webpackJsonp([0],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('Activity_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBookingS = $resource(baseUrl + 'rest/activities/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        saveTransaction: { method: 'POST', url: baseUrl + 'rest/activities/saveTransaction' }
    });
    return resourceBookingS;
}]);

angular.module('FlexyBeautyApp.services').factory('Activity', ["Activity_Resource", "ActivityData", "Period", "DayHrData", "DayData", function (Activity_Resource, ActivityData, Period, DayHrData, DayData) {

    var Activity = function Activity(activityRes, isPreviousVersion, isApplicationLoading) {
        this.id = null;
        this.label = null;
        this.period = null;

        this.dayHr = null; //if linked to dayHR; activity of a day of year
        this._dayHr = null; //tmp value for loading
        this._dayHrId = null; //tmp value for loading
        this.dayPr = null; //if linked to dayPR; activity of a day of year
        this._dayPr = null; //tmp value for loading
        this._dayPrId = null; //tmp value for loading
        this.workingPeriodDayHr = null; //if linked to workingPeriodDayHr; activity of the standard week
        this.workingPeriodDayPr = null; //if linked to workingPeriodDayPr; activity of the standard week
        this.parentActivityId = null;
        this.version = null;
        if (activityRes !== undefined && activityRes != null) this.loadObject(activityRes, isPreviousVersion, isApplicationLoading);

        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            ActivityData.add(this, isApplicationLoading);
    };
    Activity.prototype.loadObject = function (object, isPreviousVersion, isApplicationLoading) {
        if (!this.id) this.id = object.id;
        this.label = object.label;
        this.setPeriod(object.period);
        this.parentActivityId = object.parentActivityId;
        var dayHr;
        if (object.dayHrId) this._dayHrId = object.dayHrId; //preserve id for loading booking
        if (object.dayHr) this._dayHr = object.dayHr; //preserve id for loading booking
        if (object.dayPrId) this._dayPrId = object.dayPrId; //preserve id for loading booking
        if (object.dayPr) this._dayPr = object.dayPr; //preserve id for loading booking
        if (object.version) this.version = object.version;
    };

    Activity.prototype.setPeriod = function (period) {
        if (period) {
            this.period = new Period(period);
        } else this.period = null;
    };
    Activity.prototype.copyDataTo = function (object) {
        object.id = this.id;
        object.label = this.label;

        if (this.parentActivityId) object.parentActivityId = this.parentActivityId;

        if (this.period) {
            object.period = this.period.getObjectResource();
        }

        if (this.dayHr != null) if (this.dayHr.getId() == null) object.dayHr = this.dayHr.getObjectResourceCreatedByActivity(); //Inject dayHr directly in order to let the server create it
        else object.dayHrId = this.dayHr.getId();

        if (this.dayPr != null) if (this.dayPr.getId() == null) object.dayPr = this.dayPr.getObjectResourceCreatedByActivity(); //Inject dayPr directly in order to let the server create it
        else object.dayPrId = this.dayPr.getId();

        if (this.workingPeriodDayHr != null) object.workingPeriodDayHrId = this.workingPeriodDayHr.getId();

        if (this.workingPeriodDayPr != null) object.workingPeriodDayPrId = this.workingPeriodDayPr.getId();
    };

    Activity.prototype.getObjectResource = function () {
        var activityRes = new Activity_Resource();
        this.copyDataTo(activityRes);
        return activityRes;
    };

    Activity.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };
    Activity.prototype.setId = function (id) {
        this.id = id;
    };
    Activity.prototype.getId = function () {
        return this.id;
    };

    Activity.prototype.setHumanResource = function (humanResource) {
        //if (this.humanResource!=null && this.humanResource!= humanResource)
        //this.humanResource.removeActivity(this);
        this.humanResource = humanResource;
        if (this.humanResource != null) {
            //            this.humanResource.addActivity(this);
        }
    };
    Activity.prototype.getHumanResource = function () {
        return this.humanResource;
    };

    Activity.prototype.removeFromDayHr = function () //Boolean
    {
        if (this.dayHr) this.dayHr.removeActivity(this);
    };

    return Activity;
}]);

angular.module('FlexyBeautyApp.services').factory('ActivitySrv', ["$rootScope", "$log", "ServerSrv", "Activity_Resource", "UserActionData", "ActivityData", "Activity", "DayHrData", "WorkingPeriodDayHrData", "$timeout", "DayPrData", "WorkingPeriodDayPrData", function ($rootScope, $log, ServerSrv, Activity_Resource, UserActionData, ActivityData, Activity, DayHrData, WorkingPeriodDayHrData, $timeout, DayPrData, WorkingPeriodDayPrData) {
    var activitySrv = {};

    activitySrv.save = function (activity, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(activitySrv.saveSync, activity, successFunction, errorFunction);
    };
    activitySrv.saveSync = function (activity, successFunction, errorFunction) {
        if (!$rootScope.readOnly) {
            var activityRes = activity.getObjectResource();
            activityRes.$save({}, //no params
            function (activityRes) {
                try {
                    //CallBack on success
                    activity.setId(activityRes.id);
                    if (!activity.version || activityRes.version && activityRes.version > activity.version) activity.version = activityRes.version;
                    if (activity.dayHr && !activity.dayHr.id && activityRes.dayHrId) activity.dayHr.id = activityRes.dayHrId;
                    if (activity.dayPr && !activity.dayPr.id && activityRes.dayPrId) activity.dayPr.id = activityRes.dayPrId;
                    //Add user action
                    UserActionData.add(activityRes.userAction);

                    if (successFunction != undefined) successFunction(activityRes);
                } finally {
                    ServerSrv.endSavingProcess(true);
                }
            }, function (data) {
                //failure
                //error handling goes here
                $log.error("ActivitySrv.save - error");
                $log.error(data);
                try {
                    if (errorFunction != undefined) errorFunction(data);
                } finally {
                    ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
                }
            });
        }
    };

    activitySrv.saveTransaction = function (transaction, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(activitySrv.saveTransactionAsync, transaction, successFunction, errorFunction);
    };
    activitySrv.saveTransactionAsync = function (transaction, successFunction, errorFunction) {
        if (transaction && transaction.objects && transaction.objects.length > 0) {
            var transactionResource = new Activity_Resource();
            transactionResource.activities = [];
            for (var i = 0; i < transaction.objects.length; i++) {
                transactionResource.activities.push(transaction.objects[i].getObjectResource());
            }transactionResource.$saveTransaction({}, //no params
            function (data) {
                try {
                    var activity;
                    var activityRes;
                    if (data.activities && transaction.objects.length == data.activities.length) for (var i = 0; i < transaction.objects.length; i++) //Consider order must be the same
                    {
                        activity = transaction.objects[i];
                        activityRes = data.activities[i];
                        activity.setId(activityRes.id);
                        if (!activity.version || activityRes.version && activityRes.version > activity.version) activity.version = activityRes.version;
                        if (activity.dayHr && !activity.dayHr.id && activityRes.dayHrId) activity.dayHr.id = activityRes.dayHrId;
                        if (activity.dayPr && !activity.dayPr.id && activityRes.dayPrId) activity.dayPr.id = activityRes.dayPrId;
                    } else $log.error("saveTransactionAsync : returned list size incorrect !!");

                    //Add user action
                    UserActionData.add(data.userAction);
                    //CallBack on success
                    if (successFunction != undefined) successFunction(data);
                } finally {
                    ServerSrv.endSavingProcess(true);
                }
            }, function (data) {
                //failure
                //error handling goes here
                try {
                    if (errorFunction != undefined) errorFunction(data);
                } finally {
                    ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null, "Activity.saveTransactionAsync - Error on save and server call queue not empty");
                }
            });
        } else ServerSrv.endSavingProcess(true);
    };
    activitySrv.remove = function (activity, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(activitySrv.removeSync, activity, successFunction, errorFunction);
    };
    activitySrv.removeSync = function (activity, successFunction, errorFunction) {
        var activityRes = new Activity_Resource();
        activityRes.$remove({ id: activity.id }, //no params
        function (data) {
            try {
                //Add user action
                UserActionData.add(data.userAction);

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    activitySrv.updateLocally = function (id, resource) {
        var activity = ActivityData.getById(id);
        if (activity != null) {
            if (activity.version && resource.version && resource.version < activity.version) {
                return null;
            }
            activity.loadObject(resource);
            if (resource.dayHrId) {
                var dayHr = DayHrData.getById(resource.dayHrId);
                if (activity.dayHr !== dayHr) {
                    if (activity.dayHr) {
                        activity.dayHr.removeActivity(activity);
                    }
                }
                if (dayHr) {
                    dayHr.addActivity(activity);
                } else {
                    console.log("Activity.updateLocally - DayHr not found given ID in resource - DayHR ID: " + resource.dayHrId);
                }
            } else if (activity.workingPeriodDayHrId) {
                var workingPeriodDayHr = WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
                if (activity.workingPeriodDayHr !== workingPeriodDayHr) {
                    if (activity.workingPeriodDayHr) {
                        activity.workingPeriodDayHr.removeActivity(activity);
                    }
                }
                if (workingPeriodDayHr) {
                    workingPeriodDayHr.addActivity(activity);
                } else {
                    console.log("Activity.updateLocally - WorkingPeriodDayHr not found given ID in resource - WorkingPeriodDayHr ID: " + resource.workingPeriodDayHrId);
                }
            }
            if (resource.dayPrId) {
                var dayPr = DayPrData.getById(resource.dayPrId);
                if (activity.dayPr !== dayPr) {
                    if (activity.dayPr) {
                        activity.dayPr.removeActivity(activity);
                    }
                }
                if (dayPr) {
                    dayPr.addActivity(activity);
                } else {
                    console.log("Activity.updateLocally - DayPr not found given ID - DayPR ID: " + resource.dayPrId);
                }
            } else if (activity.workingPeriodDayPrId) {
                var workingPeriodDayPr = WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);
                if (activity.workingPeriodDayPr !== workingPeriodDayPr) {
                    if (activity.workingPeriodDayPr) {
                        activity.workingPeriodDayPr.removeActivity(activity);
                    }
                }
                if (workingPeriodDayPr) {
                    workingPeriodDayPr.addActivity(activity);
                } else {
                    console.log("Activity.updateLocally - WorkingPeriodDayPr not found given ID - WorkingPeriodDayPr ID: " + resource.workingPeriodDayPrId);
                }
            }
        }
        return activity;
    };

    activitySrv.removeLocally = function (id, resource) {
        var activity = ActivityData.getById(id);
        if (activity != null) {
            if (activity.version && resource.version && resource.version < activity.version) {
                return null;
            }

            if (activity.workingPeriodDayHr) {
                activity.workingPeriodDayHr.removeActivity(activity);
            }
            if (activity.dayHr) {
                activity.dayHr.removeActivity(activity);
            }
            if (activity.workingPeriodDayPr) {
                activity.workingPeriodDayPr.removeActivity(activity);
            }
            if (activity.dayPr) {
                activity.dayPr.removeActivity(activity);
            }
        } else {
            console.log("Activity.removeLocally - Model not found given ID - Activity ID: " + id);
        }
        return activity;
    };

    activitySrv.addLocally = function (id, resource) {
        var activity = ActivityData.getById(id);
        if (activity && activity.version && resource.version && resource.version < activity.version) {
            return null;
        }

        if (activity != null) {
            //check if resource already exist inside index (current action could be a 'cancel')
            activity.loadObject(resource);
            console.log("Activity.addLocally - Model already exists - Activity ID: " + id);
        } else {
            activity = new Activity(resource);
            activity.id = id; //Force set id because resource could be a previous version
        }
        if (resource.dayHrId) {
            var dayHr = DayHrData.getById(resource.dayHrId);
            if (dayHr) {
                dayHr.addActivity(activity);
            } else {
                console.log("Activity.addLocally - DayHr not found given ID - DayHR ID: " + resource.dayHrId);
            }
        } else if (activity.workingPeriodDayHrId) {
            var workingPeriodDayHr = WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
            if (workingPeriodDayHr) {
                workingPeriodDayHr.addActivity(activity);
            } else {
                console.log("Activity.addLocally - WorkingPeriodDayHr not found given ID - WorkingPeriodDayHr ID: " + resource.workingPeriodDayHrId);
            }
        }
        if (resource.dayPrId) {
            var dayPr = DayPrData.getById(resource.dayPrId);
            if (dayPr) {
                dayPr.addActivity(activity);
            } else {
                console.log("Activity.addLocally - DayPr not found given ID - DayPR ID: " + resource.dayPrId);
            }
        } else if (activity.workingPeriodDayPrId) {
            var workingPeriodDayPr = WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);
            if (workingPeriodDayPr) {
                workingPeriodDayPr.addActivity(activity);
            } else {
                console.log("Activity.addLocally - WorkingPeriodDayPr not found given ID - WorkingPeriodDayPr ID: " + resource.workingPeriodDayPrId);
            }
        }
        return activity;
    };

    activitySrv.getPreviousVersionInstance = function (resource) {
        var activity = new Activity(resource, true);
        if (resource.dayHrId) activity.dayHr = DayHrData.getById(resource.dayHrId);else if (activity.workingPeriodDayHrId) activity.workingPeriodDayHrId = WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
        if (resource.dayPrId) activity.dayPr = DayPrData.getById(resource.dayPrId);else if (activity.workingPeriodDayPrId) activity.workingPeriodDayPrId = WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);

        return activity;
    };

    return activitySrv;
}]);

angular.module('FlexyBeautyApp.services').factory('ActivityData', ["$log", "ModelDataUtil", function ($log, ModelDataUtil) {
    var activityData = {
        objActivities: {},
        indexActivities: []
    };
    activityData.getById = function (activityId, isApplicationLoading) {
        var activity = null;
        if (isApplicationLoading) {
            activity = this.objActivities[activityId];
        } else {
            for (var i = 0; i < this.indexActivities.length; i++) {
                if (this.indexActivities[i].id === activityId) {
                    activity = this.indexActivities[i];
                    break;
                }
            }
        }
        return activity;
    };
    activityData.getIndexOf = function (activity) {
        if (activity) return this.indexActivities.indexOf(activity);
        return -1;
    };
    activityData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexActivities.length) return this.indexActivities[index];else return null;
    };
    activityData.add = function (activity, isApplicationLoading) {
        if (isApplicationLoading) {
            if (activity && activity.id) {
                this.objActivities[activity.id] = activity;
            }
        } else {
            this.indexActivities.push(activity);
        }
    };

    activityData.clear = function (deleteNonRecurringOnly) {
        var recurrentActivities = deleteNonRecurringOnly ? activityData.indexActivities.filter(function (activity) {
            return activity.workingPeriodDayHr && !activity.dayHr || activity.workingPeriodDayPr && !activity.dayPr;
        }) : [];

        activityData.indexActivities = recurrentActivities;
        activityData.objActivities = {};
    };

    activityData.convertMapToArray = function (keepObject, isNewLoading) {
        if (isNewLoading) {
            this.indexActivities = ModelDataUtil.convertObjectToArray(this.objActivities, this.indexActivities);
            if (!keepObject) {
                this.objActivities = {};
            }
        } else {
            this.indexActivities = ModelDataUtil.convertMapToArray(this.objActivities, this.indexActivities);
            this.objActivities = null;
        }
    };

    return activityData;
}]);

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettings_Resource', ["$resource", "$location", function ($resource, $location) {
  var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
  return $resource(baseUrl + 'rest/company-migration-settings/:id', {}, {
    query: { method: 'GET', isArray: false },
    get: { method: 'GET' },
    displayBannerPopUp: { method: 'POST', url: baseUrl + 'rest/company-migration-settings/display-banner-pop-up' }
  });
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettings', ["CompanyMigrationSettings_Resource", function (CompanyMigrationSettings_Resource) {
  var CompanyMigrationSettings = function CompanyMigrationSettings(resource) {
    this.companyCode = null;
    this.forceMigrationDate = null;
    this.migrationInformationDate = null;
    this.displayBannerPopUp = null;
    if (resource !== undefined && resource != null) {
      this.loadObject(resource);
    }
  };

  CompanyMigrationSettings.prototype.loadObject = function (object) {
    this.companyCode = object.companyCode;
    this.forceMigrationDate = object.forceMigrationDate;
    this.displayBannerPopUp = object.displayBannerPopUp;
    this.migrationInformationDate = object.migrationInformationDate;
  };
  return CompanyMigrationSettings;
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettingsSrv', ["$log", "CompanyMigrationSettings_Resource", "CompanyMigrationSettingsData", "CompanyMigrationSettings", "ServerSrv", function ($log, CompanyMigrationSettings_Resource, CompanyMigrationSettingsData, CompanyMigrationSettings, ServerSrv) {
  var companyMigrationSettingsSrv = {};

  companyMigrationSettingsSrv.query = function (successFunction, errorFunction) {
    CompanyMigrationSettings_Resource.query({}, //params
    function (data) {
      CompanyMigrationSettingsData.companyMigrationSettings = new CompanyMigrationSettings(data);

      if (successFunction !== undefined) successFunction();
    }, function (data) {
      $log.error(data);
      if (errorFunction !== undefined) errorFunction(data);
    });
  };

  companyMigrationSettingsSrv.displayBannerPopUp = function (displayBannerPopUp, successFunction, errorFunction) {
    var companyMigrationSettingsResource = new CompanyMigrationSettings_Resource();
    companyMigrationSettingsResource.displayBannerPopUp = displayBannerPopUp;
    companyMigrationSettingsResource.$displayBannerPopUp({}, function () {
      try {
        if (successFunction != undefined) {
          successFunction();
        }
      } finally {
        ServerSrv.endSavingProcess(true);
      }
    }, function () {
      if (errorFunction != undefined) {
        errorFunction();
      }
    });
  };

  return companyMigrationSettingsSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettingsData', ["$log", function ($log) {
  var companyMigrationSettingsData = {
    companyMigrationSettings: null
  };
  companyMigrationSettingsData.getCompanyMigrationSettings = function () {
    return this.companyMigrationSettings;
  };

  return companyMigrationSettingsData;
}]);

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Day_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/days/:id', {}, {
        query: { method: 'GET', isArray: false },
        get: { method: 'GET' },
        getDays: { method: 'GET', url: baseUrl + 'rest/days/:startId/:endId', isArray: false },
        getAvailablePeriods: { method: 'GET', url: baseUrl + 'rest/days/availablePeriods/v2/:startId/:endId/:isNextWeek', isArray: false, cancellable: true },
        listDaysId: { method: 'GET', url: baseUrl + 'rest/days/listDaysId', isArray: true }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Day', ["Day_Resource", "DayHr", "DayHrData", "DayPr", "DayPrData", "Booking", "BookingData", "SaleData", "Sale", "SiteData", "HumanResourceData", "moment", "PosOp", "PosOpData", "Closure", "TypeOfSale", "Category", "Service", "RootStatCategorie", "ProductCategory", "CureCategory", "LoyaltyCardCategory", "Product", "Cure", "LoyaltyCard", "HrRootOccupationRateCategory", "PrRootOccupationRateCategory", "PhysicalResourceData", "HumanResource", "HrRootCategory", "NbCustormerCategoryStat", "TypeOfBooking", "TaxMode", "GiftItemRootCategory", "TypeOfCustomer", "VatData", "LoyaltyCustomers", "BookingService", "PhysicalResource", "GiftItemByHrRootCategory", "HumanResourceExtra", "HrOccupationDatas", "WorkingTimeRootCategory", "WorkingTimeHrIndisponibilityTime", "WorkingTimeHrUsualIndisponibilityTime", "WorkingTimeHrUnusualIndisponibilityTime", "WorkingTimeHrBookingOpenTime", "WorkingTimeHrUnoccupiedTime", "WorkingTimeHrBookingTime", "TypeOfCustomerRootCategory", "ProductStatCategorie", function (Day_Resource, DayHr, DayHrData, DayPr, DayPrData, Booking, BookingData, SaleData, Sale, SiteData, HumanResourceData, moment, PosOp, PosOpData, Closure, TypeOfSale, Category, Service, RootStatCategorie, ProductCategory, CureCategory, LoyaltyCardCategory, Product, Cure, LoyaltyCard, HrRootOccupationRateCategory, PrRootOccupationRateCategory, PhysicalResourceData, HumanResource, HrRootCategory, NbCustormerCategoryStat, TypeOfBooking, TaxMode, GiftItemRootCategory, TypeOfCustomer, VatData, LoyaltyCustomers, BookingService, PhysicalResource, GiftItemByHrRootCategory, HumanResourceExtra, HrOccupationDatas, WorkingTimeRootCategory, WorkingTimeHrIndisponibilityTime, WorkingTimeHrUsualIndisponibilityTime, WorkingTimeHrUnusualIndisponibilityTime, WorkingTimeHrBookingOpenTime, WorkingTimeHrUnoccupiedTime, WorkingTimeHrBookingTime, TypeOfCustomerRootCategory, ProductStatCategorie) {
    //Day inherit of $resource

    var Day = function Day(resource, isApplicationLoading) {
        // Call the parent constructor
        this.id = null;
        this.bookings = [];
        this.sales = [];
        this.dayHrs = [];
        this.dayPrs = [];
        this.posOps = [];
        this.closure = null;
        this.precalculatedSaleStatDatas = [];
        this.precalculatedBookingStatDatas = [];
        this.precalculatedHrOccupationDatas = [];
        this.precalculatedPrOccupationDatas = [];

        if (resource !== undefined && resource != null) {
            this.loadObject(resource, isApplicationLoading);
        }
    };
    Day.prototype.loadObject = function (object, isApplicationLoading) {
        if (!this.id) this.id = object.id;
        var booking;
        if (object.bookings) //load booking in first (will be used by DayHr to set bookingService)
            {

                this.bookings = [];
                for (var i = 0; i < object.bookings.length; i++) {
                    booking = BookingData.getById(object.bookings[i].id, isApplicationLoading);
                    if (!booking) booking = new Booking(object.bookings[i], this, true, null, isApplicationLoading);else booking.loadObject(object.bookings[i], isApplicationLoading);
                    this.bookings.push(booking);
                }
            }
        var sale;
        if (object.sales) //load sale in first (will be used by DayHr to set saleService)
            {

                this.sales = [];
                for (var i = 0; i < object.sales.length; i++) {
                    sale = SaleData.getById(object.sales[i].id, isApplicationLoading);
                    if (!sale) sale = new Sale(object.sales[i], this, true, null, isApplicationLoading);else sale.loadObject(object.sales[i], isApplicationLoading);
                    this.sales.push(sale);
                }
            }

        if (object.dayHrs) {
            this.dayHrs = [];
            var dayHr;
            for (var j = 0; j < object.dayHrs.length; j++) {
                dayHr = null;
                if (object.dayHrs[j].id) dayHr = DayHrData.getById(object.dayHrs[j].id);
                if (!dayHr) dayHr = new DayHr(object.dayHrs[j], this, null, isApplicationLoading);else dayHr.loadObject(object.dayHrs[j], isApplicationLoading);
                this.dayHrs.push(dayHr);
            }
        }
        if (object.dayPrs) {
            this.dayPrs = [];
            var dayPr;
            for (var j = 0; j < object.dayPrs.length; j++) {
                dayPr = null;
                if (object.dayPrs[j].id) dayPr = DayPrData.getById(object.dayPrs[j].id);
                if (!dayPr) dayPr = new DayPr(object.dayPrs[j], this, null, isApplicationLoading);else dayPr.loadObject(object.dayPrs[j], isApplicationLoading);
                this.dayPrs.push(dayPr);
            }
        }
        if (object.posOps) //load booking in first (will be used by DayHr to set bookingService)
            {

                this.posOps = [];
                for (var i = 0; i < object.posOps.length; i++) {
                    var posOp = PosOpData.getById(object.posOps[i].id);
                    if (!posOp) posOp = new PosOp(object.posOps[i], this);else posOp.loadObject(object.posOps[i]);
                    this.posOps.push(posOp);
                }
            }
        if (object.closure) this.closure = new Closure(object.closure, this);
    };
    Day.prototype.getBooking = function (id) {
        for (var i = 0; i < this.bookings.length; i++) {
            if (this.bookings[i].id == id) return this.bookings[i];
        }return null;
    };
    Day.prototype.getBookingByCustomerId = function (customerId) {
        for (var i = 0; i < this.bookings.length; i++) {
            if (this.bookings[i].customer && this.bookings[i].customer.id == customerId) return this.bookings[i];
        }return null;
    };
    Day.prototype.getIndexOfDayHr = function (humanResourceId) {
        if (this.dayHrs) for (var i = 0; i < this.dayHrs.length; i++) {
            if (this.dayHrs[i].humanResourceId == humanResourceId) return i;
        }return -1;
    };
    Day.prototype.getIndexOfDayPr = function (physicalResourceId, prUnitId) {
        if (this.dayHrs) for (var i = 0; i < this.dayHrs.length; i++) {
            if (this.dayHrs[i].physicalResourceId == physicalResourceId && this.dayHrs[i].prUnitId == prUnitId) return i;
        }return -1;
    };
    Day.prototype.getDayHrByHrId = function (humanResourceId) {
        if (this.dayHrs) for (var i = 0; i < this.dayHrs.length; i++) {
            if (this.dayHrs[i].humanResourceId == humanResourceId) return this.dayHrs[i];
        }return null;
    };
    Day.prototype.getDayPrByPrId = function (physicalResourceId, prUnitId) {
        if (this.dayPrs) for (var i = 0; i < this.dayPrs.length; i++) {
            if (this.dayPrs[i].physicalResourceId == physicalResourceId && this.dayPrs[i].prUnitId == prUnitId) return this.dayPrs[i];
        }return null;
    };
    Day.prototype.createAndAddDayHr = function (humanResourceId) {
        var dayHr = null;
        if (this.getIndexOfDayHr(humanResourceId) == -1) {
            dayHr = new DayHr(null, this);
            dayHr.humanResourceId = humanResourceId;
            this.dayHrs.push(dayHr);
        }
        return dayHr;
    };
    Day.prototype.addDayHr = function (dayHr) {
        if (this.dayHrs.indexOf(dayHr) == -1) {
            this.dayHrs.push(dayHr);
            dayHr.day = this;
        }
        return dayHr;
    };
    Day.prototype.removeDayHr = function (dayHr) {
        var index = this.dayHrs.indexOf(dayHr);
        if (index != -1) {
            this.dayHrs.splice(index, 1);
            dayHr.day = null;
        }
    };
    Day.prototype.createAndAddDayPr = function (physicalResourceId, prUnitId) {
        var dayPr = null;
        if (this.getIndexOfDayPr(physicalResourceId, prUnitId) == -1) {
            dayPr = new DayPr(null, this);
            dayPr.physicalResourceId = physicalResourceId;
            dayPr.prUnitId = prUnitId;
            this.dayPrs.push(dayPr);
        }
        return dayPr;
    };
    Day.prototype.addDayPr = function (dayPr) {
        if (this.dayPrs.indexOf(dayPr) == -1) {
            this.dayPrs.push(dayPr);
            dayPr.day = this;
        }
        return dayPr;
    };
    Day.prototype.removeDayPr = function (dayPr) {
        var index = this.dayPrs.indexOf(dayPr);
        if (index != -1) {
            this.dayPrs.splice(index, 1);
            dayPr.day = null;
        }
    };
    Day.prototype.getBookingServiceById = function (bsId) {
        var bs = null;
        if (this.bookings) for (var i = 0; i < this.bookings.length; i++) {
            bs = this.bookings[i].getBookingServiceById(bsId);
            if (bs) return bs;
        }
        return bs;
    };
    Day.prototype.addBooking = function (booking) {
        var index = this.bookings.indexOf(booking);
        if (index == -1) {
            this.bookings.push(booking);
            booking.day = this;
        }
    };
    Day.prototype.removeBooking = function (booking) {
        var index = this.bookings.indexOf(booking);
        if (index != -1) this.bookings.splice(index, 1);
    };
    Day.prototype.addSale = function (sale) {
        var index = this.sales.indexOf(sale);
        if (index == -1) {
            this.sales.push(sale);
            sale.day = this;
        }
    };
    Day.prototype.removeSale = function (sale) {
        var index = this.sales.indexOf(sale);
        if (index != -1) this.sales.splice(index, 1);
    };
    Day.prototype.addPosOp = function (posOp) {
        var index = this.posOps.indexOf(posOp);
        if (index == -1) {
            this.posOps.push(posOp);
            posOp.day = this;
        }
    };
    Day.prototype.removePosOp = function (posOp) {
        var index = this.posOps.indexOf(posOp);
        if (index != -1) this.posOps.splice(index, 1);
    };
    Day.prototype.getDayOfWIndex = function () {
        var date = this.getDate();
        if (date) {
            var dayOfWIndex = date.getDay() - 1; //0=Sun, 1=Mon, ..., 6=Sat
            if (dayOfWIndex == -1) dayOfWIndex = 6;
            return dayOfWIndex;
        } else return null;
    };

    Day.prototype.isOpen = function () {
        // allow to know if at least on hr is working
        var humanRessources = HumanResourceData.getActiveList();
        var isOpen = false;
        for (var i = 0; i < humanRessources.length && !isOpen; i++) {
            isOpen = humanRessources[i].hasPlanning && this.hrIsWorking(humanRessources[i].id);
        }var physicalRessources = PhysicalResourceData.getActiveList();
        for (var i = 0; i < physicalRessources.length && !isOpen; i++) {
            if (physicalRessources[i].hasPlanning) for (var u = 1; u <= physicalRessources[i].number && !isOpen; u++) {
                isOpen = this.prIsWorking(physicalRessources[i].id, u);
            }
        }return isOpen;
    };

    Day.prototype.isAStatisticDay = function (object) {
        var isAStatisticDay = this.isOpen() || this.sales.length != 0 || this.bookings.length != 0;

        if (object instanceof HumanResource) {
            isAStatisticDay = day.getHrWorkingTime() > 0;
        }
        return isAStatisticDay;
    };

    Day.prototype.hrIsWorking = function (hrId) {
        // allow to know if hr is working by hrid
        //check default site data
        var hrIsWorking = false;
        var dayHr = this.getDayHrByHrId(hrId);
        if (dayHr && dayHr.hasSpecificWpPeriods) hrIsWorking = dayHr.periods != null && dayHr.periods.length != 0 || dayHr.hasBookingActivities();else hrIsWorking = SiteData.defaultSite.hrIsWorking(this.getDayOfWIndex(), hrId);
        return hrIsWorking;
    };

    Day.prototype.prIsWorking = function (prId, prUnitId) {
        // allow to know if pr is working by prid
        //check default site data
        var prIsWorking = false,
            dayPr = this.getDayPrByPrId(prId, prUnitId);

        if (dayPr && dayPr.hasSpecificWpPeriods) prIsWorking = dayPr.periods != null && dayPr.periods.length != 0 || dayPr.hasBookingActivities();else prIsWorking = SiteData.defaultSite.prIsWorking(this.getDayOfWIndex(), prId, prUnitId);

        return prIsWorking;
    };

    Day.prototype.getHrWorkingTime = function (hrId) {
        // allow to get hr workingTime by hrid
        //check default site data if no specific period
        var hrWorkingTime = 0;
        var dayHr = this.getDayHrByHrId(hrId),
            hrWpDays = this.getHrWpDays(hrId);

        if (dayHr && dayHr.hasSpecificWpPeriods) hrWorkingTime = dayHr.getHrWorkingTime();else hrWorkingTime = SiteData.defaultSite.getHrWorkingTime(this.getDayOfWIndex(), hrId);

        if (dayHr && hrWorkingTime > 0) {
            for (var i = 0; i < dayHr.activities.length; i++) {
                if (!(dayHr.activities[i] instanceof BookingService) && dayHr.activities[i].period && dayHr.activities[i].period.duration) {
                    hrWorkingTime -= dayHr.activities[i].period.duration;
                }
            }
        }
        if (hrWpDays && hrWorkingTime > 0) {
            for (var i = 0; i < hrWpDays.length; i++) {
                if (hrWpDays[i].workingPeriodDay && hrWpDays[i].workingPeriodDay.openDay) {
                    for (var j = 0; j < hrWpDays[i].activities.length; j++) {
                        if (!(hrWpDays[i].activities[j] instanceof BookingService) && hrWpDays[i].activities[j].period && hrWpDays[i].activities[j].period.duration) {
                            hrWorkingTime -= hrWpDays[i].activities[j].period.duration;
                        }
                    }
                }
            }
        }
        return hrWorkingTime > 0 ? hrWorkingTime : 0;
    };
    Day.prototype.getHrUnusualIndisponibilityTime = function (hrId) {
        // allow to get hr workingTime by hrid
        //check default site data if no specific period
        var hrIndisponibilityTime = 0;
        var dayHr = this.getDayHrByHrId(hrId),
            hrWpDays = this.getHrWpDays(hrId);

        if (dayHr) {
            for (var i = 0; i < dayHr.activities.length; i++) {
                if (!(dayHr.activities[i] instanceof BookingService) && dayHr.activities[i].period && dayHr.activities[i].period.duration) {
                    hrIndisponibilityTime += dayHr.activities[i].period.duration;
                }
            }
        }
        return hrIndisponibilityTime;
    };

    Day.prototype.getHrUsualIndisponibilityTime = function (hrId) {
        // allow to get hr workingTime by hrid
        //check default site data if no specific period
        var hrIndisponibilityTime = 0;
        var hrWpDays = this.getHrWpDays(hrId);

        if (hrWpDays) {
            for (var i = 0; i < hrWpDays.length; i++) {
                if (hrWpDays[i].workingPeriodDay && hrWpDays[i].workingPeriodDay.openDay) {
                    for (var j = 0; j < hrWpDays[i].activities.length; j++) {
                        if (!(hrWpDays[i].activities[j] instanceof BookingService) && hrWpDays[i].activities[j].period && hrWpDays[i].activities[j].period.duration) {
                            hrIndisponibilityTime += hrWpDays[i].activities[j].period.duration;
                        }
                    }
                }
            }
        }
        return hrIndisponibilityTime;
    };

    Day.prototype.getPrWorkingTime = function (prId, prUnitId) {
        // allow to get pr workingTime by prid
        //check default site data if no specific period
        var prWorkingTime = 0;
        var dayPr = this.getDayPrByPrId(prId, prUnitId);
        if (dayPr && dayPr.hasSpecificWpPeriods) prWorkingTime = dayPr.getPrWorkingTime();else prWorkingTime = SiteData.defaultSite.getPrWorkingTime(this.getDayOfWIndex(), prId, prUnitId);

        if (dayPr) {
            for (var i = 0; i < dayPr.activities.length; i++) {
                if (!(dayPr.activities[i] instanceof BookingService) && dayPr.activities[i].period && dayPr.activities[i].period.duration) {
                    prWorkingTime -= dayPr.activities[i].period.duration;
                }
            }
        }

        return prWorkingTime;
    };
    Day.prototype.getNbWorkers = function () {
        var humanRessources = HumanResourceData.getActiveList();
        var nbWorkers = 0;
        for (var i = 0; i < humanRessources.length; i++) {
            if (this.getHrWorkingTime(humanRessources[i].id) != 0 && humanRessources[i].hasPlanning) {
                nbWorkers++;
            }
        }
        return nbWorkers;
    };
    Day.prototype.getNbWorkingHrDay = function () {
        var humanRessources = HumanResourceData.getActiveList();
        var nbJWorkingHr = 0;
        for (var i = 0; i < humanRessources.length; i++) {
            if (this.getWorkingTime() != 0) {
                nbJWorkingHr += this.getHrWorkingTime(humanRessources[i].id) / this.getWorkingTime();
            }
        }
        return nbJWorkingHr;
    };
    Day.prototype.getWorkingTime = function () {
        var timeWorking = 0;
        for (var i = 0; i < this.getWpDays().length; i++) {
            if (this.getWpDays()[i].workingPeriod && this.getWpDays()[i].workingPeriod.period && this.getWpDays()[i].workingPeriod.period.duration) {
                timeWorking += this.getWpDays()[i].workingPeriod.period.duration;
            }
        }
        return timeWorking;
    };
    Day.prototype.getWpDays = function () {
        // allow to get site.wp.wpday for hr id
        return SiteData.defaultSite.getWpDays(this.getDayOfWIndex());
    };
    Day.prototype.getHrWpDays = function (humanResourceId) {
        var wpDay = this.getWpDays(),
            hrWpDays = new Array();
        if (wpDay) {
            for (var i = 0; i < wpDay.length; i++) {
                var hrWpDay = wpDay[i].getWorkingPeriodDayHr(humanResourceId);
                if (hrWpDay) hrWpDays.push(hrWpDay);
            }
        }
        // allow to get site.wp.wpday for hr id
        return hrWpDays;
    };

    Day.prototype.getHrBookingTime = function (hrId) {
        // allow to get hr bookingTime by hrid
        var hrBookingTime = 0;
        var dayHr = this.getDayHrByHrId(hrId);
        if (dayHr) hrBookingTime = dayHr.getHrBookingTime();
        return hrBookingTime;
    };
    Day.prototype.getPrBookingTime = function (prId, prUnitId) {
        // allow to get pr bookingTime by prid
        var prBookingTime = 0;
        var dayPr = this.getDayPrByPrId(prId, prUnitId);
        if (dayPr) prBookingTime = dayPr.getPrBookingTime();
        return prBookingTime;
    };

    Day.prototype.clearPrecalculatedStatDatas = function () {
        this.precalculatedSaleStatDatas = [];
        this.precalculatedBookingStatDatas = [];
        this.precalculatedHrOccupationDatas = [];
        this.precalculatedPrOccupationDatas = [];
    };

    Day.prototype.getKeyOfSaleObjects = function (saleObjects, additionalFilters, firstDayOfPeriod, taxMode) {
        var key = "";
        for (var i = 0; i < saleObjects.length; i++) {
            key = key + (i != 0 ? ";" : "") + saleObjects[i].id;
        }
        if (key.length > 0) {
            key = key + (saleObjects.length > 0 != 0 ? ";" : "");
        }

        for (var _i = 0; _i < additionalFilters.length; _i++) {
            key = key + (_i != 0 ? ";" : "") + additionalFilters[_i].id;
        }

        if (key.length > 0) {
            key = key + (additionalFilters.length > 0 ? ";" : "");
        }

        key = key + (taxMode ? ";" + taxMode.id : "") + (firstDayOfPeriod && firstDayOfPeriod.id ? ";" + firstDayOfPeriod.id : "");
        return key;
    };

    Day.prototype.getAverageSalesCaByWorkerOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        var averageSalesCaByWorker = 0;
        if (this.getNbWorkers() !== 0) {
            averageSalesCaByWorker = this.getSalesCaOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) / this.getNbWorkers();
        }
        return averageSalesCaByWorker;
    };

    Day.prototype.getAverageNbSalesByWorkerOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        var averageNbSalesByWorker = 0;
        if (this.getNbWorkers() !== 0) {
            averageNbSalesByWorker = this.getNbSalesOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) / this.getNbWorkers();
        }
        return averageNbSalesByWorker;
    };

    Day.prototype.getAverageNbSubSalesByWorkerOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        var averageNbSalesByWorker = 0;
        if (this.getNbWorkers() !== 0) {
            averageNbSalesByWorker = this.getNbSubSalesOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) / this.getNbWorkers();
        }
        return averageNbSalesByWorker;
    };

    Day.prototype.getNbSubSalesOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSubSales;
    };

    Day.prototype.getSubSalesStepOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).subSalesStep;
    };

    Day.prototype.getSubSalesOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).subSales;
    };

    Day.prototype.getNbSalesOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSales;
    };

    Day.prototype.getNbSoldSalesOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSalesSold;
    };

    Day.prototype.getNbSalesWithServiceOrProduct = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getNbSalesOfSaleObject([TypeOfSale.ALL_WITH_PRODUCT_OR_NOT], additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode);
    };

    Day.prototype.getSalesOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).sales;
    };

    Day.prototype.getVisitsOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {

        var salesData = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
            bookings = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).bookings,
            visits = [];

        for (var i = 0; i < bookings.length; i++) {
            var minBooking = {
                date: bookings[i].day ? bookings[i].day.getDate() : "",
                isBooking: true,
                bookingTime: bookings[i].period.start.getLabel(),
                status: bookings[i].status,
                items: [],
                customer: bookings[i].customer,
                price: bookings[i].price,
                unpaid: !bookings[i].sale,
                dataType: 'VISITE'
            };

            for (var j = 0; j < bookings[i].bookingServices.length; j++) {
                minBooking.items.push({
                    type: "service",
                    label: bookings[i].bookingServices[j].label
                });
            }
            visits.push(minBooking);
        }

        for (var _i2 = 0; _i2 < salesData.salesWithBookingOutOfPeriod.length; _i2++) {
            var minSale = {
                date: salesData.salesWithBookingOutOfPeriod[_i2].day ? salesData.salesWithBookingOutOfPeriod[_i2].day.getDate() : "",
                isBooking: false,
                bookingTime: null,
                status: salesData.salesWithBookingOutOfPeriod[_i2].status,
                items: [],
                customer: salesData.salesWithBookingOutOfPeriod[_i2].customer,
                price: salesData.salesWithBookingOutOfPeriod[_i2].price,
                unpaid: false,
                dataType: 'VISITE'
            };

            for (var _j = 0; _j < salesData.salesWithBookingOutOfPeriod[_i2].saleServices.length; _j++) {
                minSale.items.push({
                    type: "service",
                    label: salesData.salesWithBookingOutOfPeriod[_i2].saleServices[_j].label
                });
            }

            for (var _j2 = 0; _j2 < salesData.salesWithBookingOutOfPeriod[_i2].saleProducts.length; _j2++) {
                minSale.items.push({
                    type: "product",
                    label: salesData.salesWithBookingOutOfPeriod[_i2].saleProducts[_j2].label
                });
            }

            for (var _j3 = 0; _j3 < salesData.salesWithBookingOutOfPeriod[_i2].saleCures.length; _j3++) {
                minSale.items.push({
                    type: "cure",
                    label: salesData.salesWithBookingOutOfPeriod[_i2].saleCures[_j3].label
                });
            }

            visits.push(minSale);
        }
        for (var _i3 = 0; _i3 < salesData.salesWithoutBooking.length; _i3++) {
            var _minSale = {
                date: salesData.salesWithoutBooking[_i3].day ? salesData.salesWithoutBooking[_i3].day.getDate() : "",
                isBooking: false,
                bookingTime: null,
                status: salesData.salesWithoutBooking[_i3].status,
                items: [],
                customer: salesData.salesWithoutBooking[_i3].customer,
                price: salesData.salesWithoutBooking[_i3].price,
                unpaid: false,
                dataType: 'VISITE'
            };

            for (var _j4 = 0; _j4 < salesData.salesWithoutBooking[_i3].saleServices.length; _j4++) {
                _minSale.items.push({
                    type: "service",
                    label: salesData.salesWithoutBooking[_i3].saleServices[_j4].label
                });
            }

            for (var _j5 = 0; _j5 < salesData.salesWithoutBooking[_i3].saleProducts.length; _j5++) {
                _minSale.items.push({
                    type: "product",
                    label: salesData.salesWithoutBooking[_i3].saleProducts[_j5].label
                });
            }

            for (var _j6 = 0; _j6 < salesData.salesWithoutBooking[_i3].saleCures.length; _j6++) {
                _minSale.items.push({
                    type: "cure",
                    label: salesData.salesWithoutBooking[_i3].saleCures[_j6].label
                });
            }

            visits.push(_minSale);
        }

        return visits;
    };

    Day.prototype.getNbSoldSalesWithoutGift = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).nbSalesWithoutGift;
    };

    Day.prototype.getNbSalesWithGift = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).nbSalesWithGift;
    };

    Day.prototype.getSalesCaOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        var price = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).price;
        price = price === null ? 0 : price;
        return price;
    };
    Day.prototype.getSalesCaTotal = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        var price = this.getSalesDatasOfSaleObject([RootStatCategorie], additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).price;
        price = price === null ? 0 : price;
        return price;
    };
    Day.prototype.getNbSalesTotal = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getNbSalesOfSaleObject([RootStatCategorie], additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode);
    };

    Day.prototype.getNbSubSalesOldCustomerOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSubSalesOldCustomer;
    };

    Day.prototype.getSubSalesOldCustomerOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).subSalesOldCustomer;
    };

    Day.prototype.getNbSubSalesNewCustomerOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSubSalesNewCustomer;
    };

    Day.prototype.getSubSalesNewCustomerOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).subSalesNewCustomer;
    };

    Day.prototype.getDurationOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).duration / 60;
    };

    Day.prototype.getSalesDatasOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        var salesDatas = null,
            keyOfSaleObjects = this.getKeyOfSaleObjects(saleObjects, additionalFilters, firstDayOfPeriod, taxMode);

        if (this.precalculatedSaleStatDatas[keyOfSaleObjects] !== undefined && moment().startOf('day').isAfter(this.getMomentDate())) {
            salesDatas = this.precalculatedSaleStatDatas[keyOfSaleObjects];
        } else {
            salesDatas = {
                price: 0,
                sales: [],
                salesWithoutBooking: [],
                salesWithBookingOutOfPeriod: [],
                qteSubSalesWithoutBooking: 0,
                subSalesWithoutBooking: [],
                subSalesWithBookingOutOfPeriod: [],
                qteSubSalesWithBookingOutOfPeriod: 0,
                subSales: [],
                subSalesStep: [],
                salesNewCustomer: [],
                salesOldCustomer: [],
                subSalesNewCustomer: [],
                subSalesOldCustomer: [],
                qteSales: 0,
                qteSalesSold: 0,
                qteSubSales: 0,
                qteSubSalesNewCustomer: 0,
                qteSubSalesOldCustomer: 0,
                duration: 0,
                customers: [],
                customersFirstVisit: [],
                customersSales: [],
                customersFirstSales: [],
                customersFirstSalesOfSaleObject: [],
                nbCustomers: 0,
                loyaltyCustormers: [],
                matchedSalesOfPassageCustomer: [],
                nbPassageCustomersOfSaleWithoutBooking: 0,
                nbPassageCustomersOfSaleWithBooking: 0,
                humanRessource: null,
                nbSalesWithoutGift: 0,
                nbSalesWithGift: 0
            };

            for (var i = 0; i < this.sales.length; i++) {
                if (this.sales[i].status === "sold" || this.sales[i].status === 'canceled' || this.sales[i].status === 'credit') {
                    for (var j = 0; j < this.sales[i].saleServices.length; j++) {
                        if (this.sales[i].saleServices[j].isPriceCalculatedBySubSaleServices()) {
                            for (var k = 0; k < this.sales[i].saleServices[j].subSaleServices.length; k++) {
                                this.sales[i].saleServices[j].subSaleServices[k].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                            }
                        } else {
                            this.sales[i].saleServices[j].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                        }
                    }
                    for (var _j7 = 0; _j7 < this.sales[i].saleProducts.length; _j7++) {
                        this.sales[i].saleProducts[_j7].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                    }

                    for (var _j8 = 0; _j8 < this.sales[i].saleCures.length; _j8++) {
                        this.sales[i].saleCures[_j8].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                    }

                    for (var _j9 = 0; _j9 < this.sales[i].loyaltyCardItems.length; _j9++) {
                        this.sales[i].loyaltyCardItems[_j9].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                    }

                    for (var _j10 = 0; _j10 < this.sales[i].giftItems.length; _j10++) {
                        this.sales[i].giftItems[_j10].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                    }

                    if ((this.sales[i].saleProducts.length > 0 || this.sales[i].saleServices.length > 0 || this.sales[i].saleCures.length > 0 || this.sales[i].loyaltyCardItems.length > 0) && this.sales[i].giftItems.length === 0) {
                        salesDatas.nbSalesWithoutGift += this.sales[i].status === 'credit' ? -1 : 1;
                    }

                    if (this.sales[i].giftItems.length !== 0) {
                        salesDatas.nbSalesWithGift += this.sales[i].status === 'credit' ? -1 : 1;
                    }
                }
            }
            for (var _i4 = 0; _i4 < salesDatas.matchedSalesOfPassageCustomer.length; _i4++) {
                if (!salesDatas.matchedSalesOfPassageCustomer[_i4].isCancelledOrCredit()) {
                    salesDatas.nbCustomers++;

                    if (salesDatas.matchedSalesOfPassageCustomer[_i4].booking) {
                        salesDatas.nbPassageCustomersOfSaleWithBooking++;
                    } else {
                        salesDatas.nbPassageCustomersOfSaleWithoutBooking++;
                    }
                }
            }
            this.precalculatedSaleStatDatas[keyOfSaleObjects] = salesDatas;
        }
        return salesDatas;
    };

    Day.prototype.getNbSubVisitsOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        var salesData = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
            subBookings = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).subBookings;

        return subBookings.length + salesData.qteSubSalesWithoutBooking + salesData.qteSubSalesWithBookingOutOfPeriod;
    };

    Day.prototype.getNbVisitsOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        var salesData = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
            bookings = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).bookings,
            nbBookings = bookings && bookings.length ? bookings.length : 0,
            nbSalesWithBookingOutOfPeriod = salesData.salesWithBookingOutOfPeriod && salesData.salesWithBookingOutOfPeriod.length ? salesData.salesWithBookingOutOfPeriod.length : 0,
            nbSalesWithoutBooking = salesData.salesWithoutBooking && salesData.salesWithoutBooking.length ? salesData.salesWithoutBooking.length : 0;

        return nbBookings + nbSalesWithBookingOutOfPeriod + nbSalesWithoutBooking;
    };

    Day.prototype.getNbFirstCustomersOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        var saleDatas = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
            bookingsDatas = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode),
            customerFomSales = saleDatas.customersFirstSalesOfSaleObject,
            customersFromBooking = bookingsDatas.customersFirstBookingsOfBookingObject,
            passageCustomersSale = saleDatas.nbPassageCustomersOfSaleWithoutBooking + saleDatas.nbPassageCustomersOfSaleWithBooking,
            passageCustomersBookingWithoutsale = bookingsDatas.nbPassageCustomersOfBookingWithoutSale,
            nbCustomers = 0,
            customers = [];

        for (var i = 0; i < customerFomSales.length; i++) {
            if (customers.indexOf(customerFomSales[i]) === -1) {
                customers.push(customerFomSales[i]);
                nbCustomers++;
            }
        }
        for (var _i5 = 0; _i5 < customersFromBooking.length; _i5++) {
            if (customers.indexOf(customersFromBooking[_i5]) === -1) {
                customers.push(customersFromBooking[_i5]);
                nbCustomers++;
            }
        }

        return nbCustomers + passageCustomersSale + passageCustomersBookingWithoutsale;
    };

    Day.prototype.getTotalFirstCustomers = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getNbFirstCustomersOfSaleObject([RootStatCategorie], additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode);
    };

    Day.prototype.getLoyaltyCustomersOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        if (saleObjects[saleObjects.length - 1] === LoyaltyCustomers) {
            saleObjects = [HrRootCategory];
        }

        var customerFomSales = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).loyaltyCustormers,
            customersFromBooking = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).loyaltyCustormers;

        for (var i = 0; i < customersFromBooking.length; i++) {
            if (customerFomSales.indexOf(customersFromBooking[i]) === -1) {
                customerFomSales.push(customersFromBooking[i]);
            }
        }

        return customerFomSales;
    };

    Day.prototype.getCustomersOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        if (saleObjects[saleObjects.length - 1] === LoyaltyCustomers) {
            saleObjects = [HrRootCategory];
        }

        var customerFomSales = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).customersSales,
            customersFromBooking = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).customersBookings;

        for (var i = 0; i < customersFromBooking.length; i++) {
            if (customerFomSales.indexOf(customersFromBooking[i]) === -1) {
                customerFomSales.push(customersFromBooking[i]);
            }
        }
        return customerFomSales;
    };

    Day.prototype.getCustomersFirstOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        if (saleObjects[saleObjects.length - 1] === LoyaltyCustomers) {
            saleObjects = [HrRootCategory];
        }

        var customerFomSales = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).customersFirstSales,
            customersFromBooking = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).customersFirstBookings;

        for (var i = 0; i < customersFromBooking.length; i++) {
            if (customerFomSales.indexOf(customersFromBooking[i]) === -1) {
                customerFomSales.push(customersFromBooking[i]);
            }
        }
        return customerFomSales;
    };

    Day.prototype.getNbPassageCustomersOfSaleObject = function (saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        if (saleObjects[saleObjects.length - 1] === LoyaltyCustomers) {
            saleObjects = [HrRootCategory];
        }

        var salesData = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
            nbPassageCustomersOfSaleWithoutBooking = salesData.nbPassageCustomersOfSaleWithoutBooking,
            nbPassageCustomersOfSaleWithBooking = salesData.nbPassageCustomersOfSaleWithBooking,
            nbPassageCustomersOfBookingWithoutSale = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).nbPassageCustomersOfBookingWithoutSale;

        return nbPassageCustomersOfSaleWithoutBooking + nbPassageCustomersOfSaleWithBooking + nbPassageCustomersOfBookingWithoutSale;
    };

    Day.prototype.getNbBookingsOfBookingObject = function (bookingObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getBookingDatasOfBookingObject(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode).bookings.length;
    };

    Day.prototype.getBookingsCAOfBookingObject = function (bookingObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getBookingDatasOfBookingObject(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode).price;
    };

    Day.prototype.getSubBookingsStepOfBookingObject = function (bookingObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getBookingDatasOfBookingObject(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode).subBookingsStep;
    };

    Day.prototype.getBookingsOfBookingObject = function (bookingObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) {
        return this.getBookingDatasOfBookingObject(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode).bookings;
    };

    Day.prototype.getBookingDatasOfBookingObject = function (bookingObjects, additionalFilters, firstDayOfPeriod, taxMode) {
        var bookingDatas = null,
            keyOfSaleObjects = this.getKeyOfSaleObjects(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode);

        if (this.precalculatedBookingStatDatas[keyOfSaleObjects] !== undefined && moment().startOf('day').isAfter(this.getMomentDate())) {
            bookingDatas = this.precalculatedBookingStatDatas[keyOfSaleObjects];
        } else {
            bookingDatas = {
                bookings: [],
                subBookings: [],
                subBookingsStep: [],
                price: 0,
                loyaltyCustormers: [],
                customers: [],
                customersFirstVisit: [],
                customersBookings: [],
                customersFirstBookings: [],
                customersFirstBookingsOfBookingObject: [],
                matchedBookingsOfPassageCustomer: [],
                nbPassageCustomersOfBookingWithoutSale: 0,
                humanRessource: null
            };

            for (var i = 0; i < this.bookings.length; i++) {
                if (this.bookings[i].bookingServices.length > 0) {
                    for (var j = 0; j < this.bookings[i].bookingServices.length; j++) {
                        if (this.bookings[i].bookingServices[j].isPackage && this.bookings[i].bookingServices[j].subBookingServices.length > 0) {
                            for (var k = 0; k < this.bookings[i].bookingServices[j].subBookingServices.length; k++) {
                                this.bookings[i].bookingServices[j].subBookingServices[k].incrementBookingDatas(bookingDatas, bookingObjects, additionalFilters, firstDayOfPeriod, taxMode, this);
                            }
                        } else {
                            this.bookings[i].bookingServices[j].incrementBookingDatas(bookingDatas, bookingObjects, additionalFilters, firstDayOfPeriod, taxMode, this);
                        }
                    }
                }
            }

            for (var _i6 = 0; _i6 < bookingDatas.matchedBookingsOfPassageCustomer.length; _i6++) {
                if (bookingDatas.matchedBookingsOfPassageCustomer && bookingDatas.matchedBookingsOfPassageCustomer[_i6]) {
                    if (!bookingDatas.matchedBookingsOfPassageCustomer[_i6].sale) {
                        bookingDatas.nbPassageCustomersOfBookingWithoutSale++;
                    }
                }
            }
            this.precalculatedBookingStatDatas[keyOfSaleObjects] = bookingDatas;
        }
        return bookingDatas;
    };

    Day.prototype.getOccupationDatasOfHrObject = function (hrObjects) {
        var lastHrObject = hrObjects[hrObjects.length - 1],
            timeOfHrObject = null,
            occupationDatas = void 0;

        for (var i = 0; i < hrObjects.length; i++) {
            if (hrObjects[i] instanceof HumanResource) {
                occupationDatas = this.getHrOccupationDatas([hrObjects[i]]);
                break;
            }
        }

        if (lastHrObject instanceof HumanResource) {
            timeOfHrObject = occupationDatas.bookingTime + occupationDatas.unoccupiedTime + occupationDatas.usualIndisponibilityTime + occupationDatas.unusualIndisponibilityTime;
        } else if (lastHrObject === WorkingTimeHrIndisponibilityTime) {
            timeOfHrObject = occupationDatas.usualIndisponibilityTime + occupationDatas.unusualIndisponibilityTime;
        } else if (lastHrObject === WorkingTimeHrUnusualIndisponibilityTime) {
            timeOfHrObject = occupationDatas.unusualIndisponibilityTime;
        } else if (lastHrObject === WorkingTimeHrUsualIndisponibilityTime) {
            timeOfHrObject = occupationDatas.usualIndisponibilityTime;
        } else if (lastHrObject === WorkingTimeHrBookingOpenTime) {
            timeOfHrObject = occupationDatas.workingTime;
        } else if (lastHrObject === WorkingTimeHrUnoccupiedTime) {
            timeOfHrObject = occupationDatas.unoccupiedTime;
        } else if (lastHrObject === WorkingTimeHrBookingTime) {
            timeOfHrObject = occupationDatas.bookingTime;
        }
        return timeOfHrObject;
    };

    Day.prototype.getBookingTimeOfHrObject = function (hrObjects) {
        return this.getHrOccupationDatas(hrObjects).bookingTime;
    };

    Day.prototype.getWorkingTimeOfHrObject = function (hrObjects) {
        return this.getHrOccupationDatas(hrObjects).workingTime;
    };

    Day.prototype.getHrOccupationPrimaryDatas = function (hrObjects) {
        var occupationDatas = this.getHrOccupationDatas(hrObjects);

        for (var i = 0; i < hrObjects.length; i++) {
            if (hrObjects[i] instanceof HumanResource) {
                occupationDatas = this.getHrOccupationDatas([hrObjects[i]]);
                break;
            }
        }

        return occupationDatas ? new HrOccupationDatas(this, occupationDatas.unoccupiedTime, occupationDatas.bookingTime, occupationDatas.unusualIndisponibilityTime, occupationDatas.usualIndisponibilityTime) : null;
    };

    Day.prototype.getHrOccupationDatas = function (hr) {
        var occupationRateData = null,
            targetHr = null,
            bookingTime = 0,
            workingTime = 0,
            unusualIndisponibilityTime = 0,
            usualIndisponibilityTime = 0;

        //in order to use this function in report, the function must accept a table in parameter
        if (hr instanceof Array) {
            targetHr = hr[hr.length - 1];
        } else {
            targetHr = hr;
        }

        var keyOfHr = targetHr.id;

        if (this.precalculatedHrOccupationDatas[keyOfHr] !== undefined && moment().startOf('day').isAfter(this.getMomentDate())) {
            occupationRateData = this.precalculatedHrOccupationDatas[keyOfHr];
        } else {
            var humanRessources = HumanResourceData.getActiveList();

            for (var j = 0; j < humanRessources.length; j++) {
                if (targetHr === HrRootOccupationRateCategory || targetHr === WorkingTimeRootCategory || targetHr === humanRessources[j]) {
                    var hrLoop = humanRessources[j];

                    if (this.hrIsWorking(hrLoop.id) && hrLoop.hasPlanning) {
                        bookingTime += this.getHrBookingTime(hrLoop.id);
                        workingTime += this.getHrWorkingTime(hrLoop.id);
                        usualIndisponibilityTime += this.getHrUsualIndisponibilityTime(hrLoop.id);
                        unusualIndisponibilityTime += this.getHrUnusualIndisponibilityTime(hrLoop.id);
                    }
                }
            }

            occupationRateData = {
                "bookingTime": bookingTime,
                "workingTime": workingTime,
                "unoccupiedTime": workingTime - bookingTime,
                "unusualIndisponibilityTime": unusualIndisponibilityTime,
                "usualIndisponibilityTime": usualIndisponibilityTime
            };

            this.precalculatedHrOccupationDatas[keyOfHr] = occupationRateData;
        }

        return occupationRateData;
    };

    Day.prototype.getBookingTimeOfPrObject = function (prObjects) {
        return this.getPrOccupationDatas(prObjects).bookingTime;
    };

    Day.prototype.getWorkingTimeOfPrObject = function (prObjects) {
        return this.getPrOccupationDatas(prObjects).workingTime;
    };

    Day.prototype.getPrOccupationDatas = function (hr) {
        var occupationRateData = null,
            targetPr = null,
            bookingTime = null,
            workingTime = null;

        //in order to use this function in report, the function must accept a table in parameter
        if (hr instanceof Array) {
            targetPr = hr[hr.length - 1];
        } else {
            targetPr = hr;
        }

        var keyOfPr = targetPr.id;

        if (this.precalculatedPrOccupationDatas[keyOfPr] !== undefined && moment().startOf('day').isAfter(this.getMomentDate())) {
            occupationRateData = this.precalculatedPrOccupationDatas[keyOfPr];
        } else {
            var physicalRessources = PhysicalResourceData.getActiveList();

            for (var j = 0; j < physicalRessources.length; j++) {
                var prLoop = physicalRessources[j];

                for (var k = 1; k <= prLoop.number; k++) {
                    if (targetPr === PrRootOccupationRateCategory || prLoop === targetPr) {
                        var _prLoop = physicalRessources[j];

                        if (this.prIsWorking(_prLoop.id, k) && _prLoop.hasPlanning) {
                            bookingTime += this.getPrBookingTime(_prLoop.id, k);
                            workingTime += this.getPrWorkingTime(_prLoop.id, k);
                        }
                    }
                }
            }
            occupationRateData = {
                "bookingTime": bookingTime,
                "workingTime": workingTime
            };

            this.precalculatedPrOccupationDatas[keyOfPr] = occupationRateData;
        }
        return occupationRateData;
    };

    Day.prototype.getSalesServicesByHrId = function (hrId) {
        var salesItems = [];
        for (var j = 0; j < this.sales.length; j++) {
            salesItems = salesItems.concat(this.sales[j].getSalesServicesByHrId(hrId));
        }
        return salesItems;
    };

    Day.prototype.getSalesProductsByHrId = function (hrId) {
        var salesItems = [];
        for (var j = 0; j < this.sales.length; j++) {
            salesItems = salesItems.concat(this.sales[j].getSalesProductsByHrId(hrId));
        }
        return salesItems;
    };

    Day.prototype.getBookingsSumPriceByHrId = function (hrId) {
        var result = { ca: 0, nbBookings: 0 };
        for (var j = 0; j < this.bookings.length; j++) {
            if (this.bookings.status != "notCame") for (var k = 0; k < this.bookings[j].bookingServices.length; k++) {
                if (this.bookings[j].bookingServices[k].dayHr && this.bookings[j].bookingServices[k].dayHr.humanResourceId === hrId) {
                    result.ca += this.bookings[j].bookingServices[k].price;
                    result.nbBookings++;
                }
            }
        }
        return result;
    };

    Day.prototype.getSalesSumPriceByHrId = function (hrId, withGift) {
        var result = { ca: 0,
            caServices: 0,
            caProducts: 0,
            caGiftItems: 0,
            caCures: 0,
            caLoyaltyCards: 0,
            nbSales: 0 };
        var saleServicesPrice, saleProductsPrice, saleGiftItemsPrice, saleCuresPrice, loyaltyCardItemsPrice;
        for (var j = 0; j < this.sales.length; j++) {
            saleServicesPrice = this.sales[j].getSaleServicesSumPriceByHrId(hrId, withGift);
            saleProductsPrice = this.sales[j].getSaleProductsSumPriceByHrId(hrId, withGift);
            saleGiftItemsPrice = this.sales[j].getSaleGiftItemsSumPriceByHrId(hrId, withGift);
            saleCuresPrice = this.sales[j].getSaleCuresSumPriceByHrId(hrId, withGift);
            loyaltyCardItemsPrice = this.sales[j].getLoyaltyCardItemsSumPriceByHrId(hrId, withGift);
            if (saleServicesPrice != 0 || saleProductsPrice != 0 || saleGiftItemsPrice != 0 || saleCuresPrice != 0 || loyaltyCardItemsPrice != 0) {
                result.caServices += saleServicesPrice;
                result.caProducts += saleProductsPrice;
                result.caGiftItems += saleGiftItemsPrice;
                result.caCures += saleCuresPrice;
                result.caLoyaltyCards += loyaltyCardItemsPrice;
                result.nbSales++;
            }
        }
        result.ca = result.caServices + result.caProducts + result.caCures + result.caLoyaltyCards; //no giftitem
        return result;
    };
    Day.prototype.getNumberOfCustomers = function (dateTime) {
        var customers = [];
        if (dateTime !== undefined) // if we want to get an average value in future
            {} else {
            var customerAlreadyListed = false;
            for (var i = 0; i < this.bookings.length; i++) {
                customerAlreadyListed = false;
                for (var j = 0; j < customers.length; j++) {
                    if (this.bookings[i].customer && customers[j].id === this.bookings[i].customer.id) {
                        customerAlreadyListed = true;
                        break;
                    }
                }if (!customerAlreadyListed && this.bookings[i].customer) {
                    customers.push(this.bookings[i].customer);
                }
            }
            for (var i = 0; i < this.sales.length; i++) {
                customerAlreadyListed = false;
                for (var j = 0; j < customers.length; j++) {
                    if (this.sales[i].customer && customers[j].id === this.sales[i].customer.id) {
                        customerAlreadyListed = true;
                        break;
                    }
                }if (!customerAlreadyListed && this.sales[i].customer) {
                    customers.push(this.sales[i].customer);
                }
            }
        }

        return customers.length;
    };

    Day.prototype.getDate = function () {
        //assume id is like
        var date = null;
        if (this.id > 0) {
            var ids = this.id.toString();
            var year = ids.substring(0, 4);
            var month = ids.substring(4, 6);
            var day = ids.substring(6);
            date = new Date(year + '/' + month + '/' + day);
        }
        return date;
    };
    Day.prototype.getMomentDate = function () {
        //assume id is like
        var date = null;
        if (this.id > 0) {
            var ids = this.id.toString();
            var year = ids.substring(0, 4);
            var month = ids.substring(4, 6);
            var day = ids.substring(6);
            // date = moment(new Date(year + '/' + month + '/' + day));
            date = moment().year(year).month(parseInt(month) - 1).date(day).startOf('day'); // for .month() need to pass an int and january is 0, not 1
        }
        return date;
    };
    Day.prototype.getWeekday = function () {
        return this.getMomentDate().weekday();
    };
    Day.prototype.hasPosOp = function (type, status) {
        for (var i = 0; i < this.posOps.length; i++) {
            if (this.posOps[i].type == type && this.posOps[i].status == status) return true;
        }return false;
    };
    Day.prototype.getCashAmount = function () {
        var cashAmount = 0;
        for (var i = 0; i < this.sales.length; i++) {
            if (this.sales[i].status == "sold" || this.sales[i].status == "credit" || this.sales[i].status == "canceled") cashAmount += this.sales[i].getCashAmount();
        }return cashAmount;
    };
    Day.prototype.getPosOpsAmount = function () {
        var amount = 0;
        for (var i = 0; i < this.posOps.length; i++) {
            if (this.posOps[i].status == "validate") amount += this.posOps[i].amount;
        }return amount;
    };
    Day.prototype.getDayName = function () {
        var dayName = "";
        switch (this.getWeekday()) {
            case 0:
                {
                    dayName = 'dimanche';
                    break;
                }
            case 1:
                {
                    dayName = 'lundi';
                    break;
                }
            case 2:
                {
                    dayName = 'mardi';
                    break;
                }
            case 3:
                {
                    dayName = 'mercredi';
                    break;
                }
            case 4:
                {
                    dayName = 'jeudi';
                    break;
                }
            case 5:
                {
                    dayName = 'vendredi';
                    break;
                }
            case 6:
                {
                    dayName = 'samedi';
                    break;
                }
            default:
                {
                    dayName = 'null';
                    break;
                }
        }
        return dayName;
    };

    Day.prototype.calculateMaxPeriod = function (period) {
        for (var k = 0; k < this.dayHrs.length; k++) {
            this.dayHrs[k].calculateMaxPeriod(period);
        }
        for (var _k = 0; _k < this.dayPrs.length; _k++) {
            this.dayPrs[_k].calculateMaxPeriod(period);
        }
    };

    return Day;
}]);

angular.module('FlexyBeautyApp.services').factory('DaySrv', ["$log", "$timeout", "Day_Resource", "Day", "DayData", "BookingSrv", "DateSrv", "Decorators", "TimeMeasures", "Constants", "moment", function ($log, $timeout, Day_Resource, Day, DayData, BookingSrv, DateSrv, Decorators, TimeMeasures, Constants, moment) {
    var daySrv = { lastReceivedDate: null, promise: null };

    daySrv.getIdFromDate = function (date) {
        //Get id from date : YYYYMMDD format
        if (date) return date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();
        return null;
    };

    daySrv.getDateFromId = function (id) {
        var date = null;
        if (id > 0) {
            var ids = id.toString();
            var year = ids.substring(0, 4);
            var month = ids.substring(4, 6);
            var _day = ids.substring(6);
            date = new Date(year + '/' + month + '/' + _day);
        }
        return date;
    };

    daySrv.get = function (dayId, successFunction, errorFunction) {
        Day_Resource.get({ id: dayId }, //params
        function (data) {
            if (successFunction !== undefined) successFunction(data);
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    daySrv.bookingLoaded = function (successFunction) {
        var allLoaded = true;
        for (var i = 0; i < DayData.indexDays.length && allLoaded; i++) {
            allLoaded = DayData.indexDays[i].bookings != null;
        }if (allLoaded && successFunction !== undefined) successFunction();
    };
    daySrv.query = function (startDayId, successFunction, errorFunction) {
        //Day_Resource.query(
        if (!startDayId) startDayId = 20000101;
        Day_Resource.getDays({ startId: startDayId, endId: 30000101 }, //get all days
        function (data) {
            //success
            var day;
            if (successFunction !== undefined) successFunction(data); //WILL CALL daySrv.loadResourceDays
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    daySrv.queryBasedDays = function (startDayId, endId) {
        if (!startDayId) startDayId = 20000101;
        return Day_Resource.getDays({ startId: startDayId, endId: endId }).$promise;
    };

    daySrv.listDaysId = function () {
        return Day_Resource.listDaysId({}).$promise;
    };

    daySrv.getFirstDateOfWeek = function (dayId) {
        var date = daySrv.getDateFromId(dayId);
        var dayOfWeek = date.getDay() - 1;
        if (dayOfWeek === -1) {
            dayOfWeek = 6;
        }

        return new Date(date.setDate(date.getDate() - dayOfWeek));
    };

    daySrv.getLastDateOfWeek = function (dayId) {
        var date = daySrv.getDateFromId(dayId);
        var lastDay = date.getDate() - date.getDay() + 7;

        return new Date(date.setDate(lastDay));
    };

    daySrv.newLoadResourceDays = Decorators.timeMeasureDecorator(function (resourceDaysMap, isApplicationLoading, startupDaysMap) {

        if (resourceDaysMap) {
            // FiXME at minimum one Day is created in order to avoid null error in views loading
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            var dayKeys = Object.keys(resourceDaysMap);

            var firstDay = resourceDaysMap[dayKeys[0]];
            var firstDate = firstDay ? daySrv.getFirstDateOfWeek(firstDay.id) : new Date();

            var lastDay = resourceDaysMap[dayKeys[dayKeys.length - 1]];
            var lastDate = lastDay ? daySrv.getLastDateOfWeek(lastDay.id) : tomorrow;

            if (startupDaysMap) {
                var startupDayKeys = Object.keys(startupDaysMap);
                var firstStartupDay = startupDaysMap[startupDayKeys[0]];
                var firstStartupDate = firstStartupDay ? daySrv.getFirstDateOfWeek(firstStartupDay.id) : new Date();

                if (lastDate.getTime() < firstStartupDate.getTime()) {
                    lastDate = firstStartupDate;
                }
            }

            var firstMoment = moment(firstDate);
            var lastMoment = moment(lastDate);

            var nbDaysToCreate = lastMoment.diff(firstMoment, 'days');

            for (var i = 0; i <= nbDaysToCreate; i++) {
                var currentDate = new Date(firstDate);
                currentDate.setDate(currentDate.getDate() + i);
                var id = daySrv.getIdFromDate(currentDate);
                var dayToLoad = resourceDaysMap[id];

                if (dayToLoad) {
                    var existingDay = DayData.getById(id, isApplicationLoading);
                    if (!existingDay) {
                        var _day2 = new Day(dayToLoad, isApplicationLoading);
                        DayData.add(_day2, isApplicationLoading);
                    } else {
                        existingDay.loadObject(dayToLoad, isApplicationLoading);
                    }
                } else {
                    var _day3 = new Day(null, isApplicationLoading);
                    _day3.id = id;
                    DayData.add(_day3, isApplicationLoading);
                }
            }
        }
    }, TimeMeasures.RESOURCE_DAYS_LOADING);

    daySrv.loadResourceDays = Decorators.timeMeasureDecorator(function (resourceDays, isApplicationLoading) {
        if (resourceDays) {
            var today = new Date();
            var diff = today.getDate() - today.getDay() + 1 - 28;
            var firstDayDate = new Date(today.setDate(diff)); //Start on monday
            var firstDayId = daySrv.getIdFromDate(firstDayDate);
            var lastDayDate = new Date(firstDayDate);
            lastDayDate.setDate(lastDayDate.getDate() + 139); //load at least 140 days (20 weeks)
            var lastDayId = daySrv.getIdFromDate(lastDayDate);
            var iDate;
            var continueAdding = true;
            var day;
            if (resourceDays.length > 0 && resourceDays[0] != undefined && resourceDays[resourceDays.length - 1] != undefined) //days exist
                {
                    if (resourceDays[0].id < firstDayId) //first day on server is older that monday of current week : use it as start
                        {
                            firstDayDate = daySrv.getDateFromId(resourceDays[0].id);
                            diff = firstDayDate.getDate() - firstDayDate.getDay() + 1 - 7;
                            firstDayDate = new Date(firstDayDate.setDate(diff)); //Start on monday
                        }
                    if (resourceDays[resourceDays.length - 1].id > lastDayId) //last day on server is more in futur than 20 weeks in future : use it
                        {
                            lastDayDate = daySrv.getDateFromId(resourceDays[resourceDays.length - 1].id);
                            diff = lastDayDate.getDate() - lastDayDate.getDay() + 7;
                            lastDayDate = new Date(lastDayDate.setDate(diff)); //end on sunday
                            lastDayId = daySrv.getIdFromDate(lastDayDate);
                        }
                }
            for (var d = 0; continueAdding && d < 10000; d++) {
                //security loop
                iDate = new Date(firstDayDate);
                iDate.setDate(iDate.getDate() + d);
                day = new Day(null, isApplicationLoading);
                day.id = this.getIdFromDate(iDate);
                DayData.add(day, isApplicationLoading);
                var found = false;
                var i;
                for (i = 0; i < resourceDays.length && !found; i++) {
                    if (resourceDays[i] != undefined && resourceDays[i].id == day.id) {
                        day.loadObject(resourceDays[i], isApplicationLoading);
                        resourceDays.splice(i, 1); //remove from resourcedays
                        found = true;
                    }
                }
                if (day.id == lastDayId) continueAdding = false;
            }
        }
    }, TimeMeasures.RESOURCE_DAYS_LOADING);
    daySrv.addDays = function (firstDate, nbdaysToLoad, insertBefore, successFunction, errorFunction) {
        var diff = firstDate.getDate() - firstDate.getDay() + 1;
        var dayOfWeekDate = new Date(firstDate.setDate(diff)); //Start on monday
        var dayId = this.getIdFromDate(dayOfWeekDate);
        var date;
        var day;
        for (var d = 0; d < nbdaysToLoad; d++) {
            day = new Day();
            date = new Date(dayOfWeekDate);
            date.setDate(date.getDate() + d);
            day.id = this.getIdFromDate(date);
            if (insertBefore) DayData.insertAt(day, d);else DayData.add(day);
        }
    };

    daySrv.getByIdAdder = function (dayId) {
        if (DayData.indexDays && DayData.indexDays.length != 0) if (DayData.indexDays[DayData.indexDays.length - 1].id < dayId) {
            var dayIndexStart = DayData.indexDays.length + DateSrv.daysBetween(daySrv.getDateFromId(DayData.indexDays[DayData.indexDays.length - 1].id), daySrv.getDateFromId(dayId));
            daySrv.addWeeks(dayIndexStart);
        } else if (DayData.indexDays[0].id > dayId) {
            var dayIndexStart = -DateSrv.daysBetween(daySrv.getDateFromId(DayData.indexDays[0].id), daySrv.getDateFromId(dayId));
            daySrv.addWeeks(dayIndexStart);
        }
        return DayData.getById(dayId);
    };
    daySrv.addWeeks = function (dayIndexStart) {
        if (DayData.indexDays.length === 0) {
            return 0;
        }

        var day, date, refDay, refDate, nbdaysToLoad;
        //add a complete week do data model days

        if (dayIndexStart < 0) //
            {
                nbdaysToLoad = Math.ceil(-dayIndexStart / 7) * 7; //round to a week
                refDay = DayData.indexDays[0];
                refDate = refDay.getDate();
                for (var d = 1; d <= nbdaysToLoad; d++) {
                    day = new Day();
                    date = new Date(refDate);
                    date.setDate(date.getDate() - d);
                    day.id = this.getIdFromDate(date);
                    DayData.insertAt(day, 0);
                    dayIndexStart++;
                }
            } else {
            nbdaysToLoad = Math.ceil(dayIndexStart / 7) * 7 + 7 - DayData.indexDays.length; //round to a week
            refDay = DayData.indexDays[DayData.indexDays.length - 1];
            refDate = refDay.getDate();
            for (var d = 1; d <= nbdaysToLoad; d++) {
                day = new Day();
                date = new Date(refDate);
                date.setDate(date.getDate() + d);
                day.id = this.getIdFromDate(date);
                DayData.add(day);
            }
        }
        return dayIndexStart;
    };
    daySrv.getDays = function (firstDate, nbdaysToLoad, insertBefore, successFunction, errorFunction) {
        daySrv.addDays(firstDate, nbdaysToLoad, insertBefore, successFunction, errorFunction);
        Day_Resource.getDays({ startId: DayData.indexDays[0].id, endId: DayData.indexDays[DayData.indexDays.length - 1].id }, //get period
        function (data) {
            daySrv.lastReceivedDate = new Date(data.queryDate);
            if (successFunction !== undefined) successFunction(data);
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    daySrv.loadExistingResourceDays = function (resourceDays) {
        var day;
        if (resourceDays) for (var i = 0; i < resourceDays.length; i++) {
            day = DayData.getById(resourceDays[i].id);
            if (day) day.loadObject(resourceDays[i]);
        }
    };

    daySrv.computeDayData = function (firstDate, nbdaysToLoad) {
        var day = firstDate.getDay();
        var dayOfWeekDiff = day === 0 ? -6 : 1;
        var diff = firstDate.getDate() - day + dayOfWeekDiff;
        var dayOfWeekDate = new Date(firstDate.setDate(diff)); //Start on monday
        var date = void 0;
        DayData.clear(); //clear days every time to be sur to have an up to date data
        for (var d = 0; d < nbdaysToLoad; d++) {
            day = new Day();
            date = new Date(dayOfWeekDate);
            date.setDate(date.getDate() + d);
            day.id = this.getIdFromDate(date);
            DayData.add(day);
        }
    };

    daySrv.getAvailablePeriods = function (firstDate, nbdaysToLoad, isNextWeek, successFunction, errorFunction) {
        this.computeDayData(firstDate, nbdaysToLoad);
        if (daySrv.availablePeriodRequest) {
            daySrv.availablePeriodRequest.$cancelRequest();
        }
        daySrv.availablePeriodRequest = Day_Resource.getAvailablePeriods({ startId: DayData.indexDays[0].id, endId: DayData.indexDays[DayData.indexDays.length - 1].id, isNextWeek: isNextWeek }, //get period
        function (data) {
            var day = void 0;
            var loadedDays = [];
            var nextDayId = data.dayAvailablePeriodsInterfaces[0] != null ? data.dayAvailablePeriodsInterfaces[0].id : DayData.indexDays[0].id;
            var nextDay = moment(nextDayId, "YYYYMMDD").toDate();
            daySrv.computeDayData(nextDay, 7, false);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = data.dayAvailablePeriodsInterfaces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var dayAvailablePeriodsInterface = _step.value;

                    day = DayData.getById(dayAvailablePeriodsInterface.id);
                    loadedDays.push(day);
                    if (day) {
                        day.loadObject(dayAvailablePeriodsInterface);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (successFunction !== undefined) {
                successFunction(loadedDays, null, nextDay, isNextWeek);
            }
            daySrv.availablePeriodRequest = null;
        }, function (data) {
            $log.error(data);

            if (errorFunction !== undefined) {
                errorFunction(data);
            }
            if (data.xhrStatus !== "abort") {
                daySrv.availablePeriodRequest = null;
            }
        });
    };

    return daySrv;
}]);

angular.module('FlexyBeautyApp.services').factory('DayData', ["$log", "ModelDataUtil", function ($log, ModelDataUtil) {
    var dayData = {
        objDays: {},
        indexDays: []
    };
    dayData.getById = function (dayId, isApplicationLoading) {
        var day = null;
        if (isApplicationLoading) {
            day = this.objDays[dayId];
        } else {
            for (var i = 0; i < this.indexDays.length; i++) {
                if (this.indexDays[i].id == dayId) {
                    day = this.indexDays[i];
                    break;
                }
            }
        }
        return day;
    };

    dayData.getIndexOf = function (day) {
        if (day) return this.indexDays.indexOf(day);
        return -1;
    };
    dayData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexDays.length) return this.indexDays[index];
        return null;
    };
    dayData.add = function (day, isApplicationLoading) {
        if (isApplicationLoading) {
            if (day && day.id) this.objDays[day.id] = day;
        } else {
            this.indexDays.push(day);
        }
    };
    dayData.insertAt = function (day, index) {
        this.indexDays.splice(index, 0, day);
        return this.indexDays.length - 1;
    };
    dayData.insert = function (day) {
        for (var i = 0; i < this.indexDays.length; i++) {
            if (this.indexDays[i].id > day.id) {
                this.indexDays.splice(i, 0, day);
                return i;
            }
        }this.indexDays.push(day);
        return this.indexDays.length - 1;
    };

    dayData.clear = function () {
        this.indexDays = [];
        this.objDays = {};
    };
    dayData.getActiveList = function () {
        return this.indexDays;
    };
    dayData.isLoaded = function () {
        return this.indexDays.length != 0;
    };
    dayData.getOpenDay = function (index) {
        for (var i = 0; i < this.indexDays.length; i++) {
            if (index != i && this.indexDays[i].closure && this.indexDays[i].closure.status == "open") return this.indexDays[i];
        }return null;
    };
    dayData.getOpenDayByLast = function () {
        for (var i = this.indexDays.length - 1; i >= 0; i--) {
            if (this.indexDays[i].closure && this.indexDays[i].closure.status == "open") return this.indexDays[i];
        }return null;
    };
    dayData.getLastClosedDay = function () {
        for (var i = this.indexDays.length - 1; i >= 0; i--) {
            if (this.indexDays[i].closure && this.indexDays[i].closure.status == "closed") return this.indexDays[i];
        }return null;
    };
    dayData.calculateMaxPeriod = function (period) {
        for (var i = 0; i < this.indexDays.length; i++) {
            this.indexDays[i].calculateMaxPeriod(period);
        }
    };

    dayData.convertMapToArray = function (keepObject, isNewLoading) {
        if (isNewLoading) {
            this.indexDays = ModelDataUtil.convertObjectToArray(this.objDays, this.indexDays);
            this.indexDays.sort(function (day1, day2) {
                return day1.id - day2.id;
            });
            if (!keepObject) {
                this.objDays = {};
            }
        } else {
            this.indexDays = ModelDataUtil.convertMapToArray(this.objDays, this.indexDays);
            this.objDays = null;
        }
    };

    return dayData;
}]);

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('DayHr_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/DayHrs/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        saveWithoutActivities: { method: 'POST', url: baseUrl + 'rest/DayHrs/withoutActivities' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('DayHr', ["DayHr_Resource", "Activity", "DayHrData", "Period", "BookingService", "$log", "HumanResourceData", function (DayHr_Resource, Activity, DayHrData, Period, BookingService, $log, HumanResourceData) {
    //WorkingPeriodDay inherit of $resource

    var DayHr = function DayHr(resource, day, isPreviousVersion, isApplicationLoading) {
        this.id = null;
        this.humanResourceId = null;
        this.day = null;
        this.hasSpecificWpPeriods = false;
        this.hasSpecificOnLineBooking = false;
        this.onLineBooking = true;
        this.activities = [];
        this.periods = []; //Periods of work for a day;
        this.availablePeriods = [];
        this.comment = null;
        this.version = null;
        if (day !== undefined && day != null) {
            this.day = day;
        }

        if (resource !== undefined && resource != null) {
            this.loadObject(resource, isApplicationLoading);
        }
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            DayHrData.add(this);
    };
    DayHr.prototype.loadObject = function (object, isApplicationLoading) {
        this.loadObjectProperties(object);
        this.loadObjectActivities(object, isApplicationLoading);
    };
    DayHr.prototype.loadObjectProperties = function (object) {
        if (!this.id) this.id = object.id;
        this.humanResourceId = object.humanResourceId;
        this.hasSpecificWpPeriods = object.hasSpecificWpPeriods;
        this.hasSpecificOnLineBooking = object.hasSpecificOnLineBooking;
        this.onLineBooking = object.onLineBooking;
        this.comment = object.comment;
        if (object.periods) {
            this.periods = [];
            for (var j = 0; j < object.periods.length; j++) {
                this.addPeriodOnHr(object.periods[j]);
            }
        }

        if (object.availablePeriods) {
            this.availablePeriods = [];
            for (var j = 0; j < object.availablePeriods.length; j++) {
                this.addAvailablePeriod(object.availablePeriods[j]);
            }
        }
        if (object.version) this.version = object.version;
    };
    DayHr.prototype.hasBookingActivities = function () {
        for (var i = 0; i < this.activities.length; i++) {
            if (this.activities[i].objectType != "Activity") return true;
        }return false;
    };
    DayHr.prototype.loadObjectActivities = function (object, isApplicationLoading) {
        if (object.activities) {

            var activitiesId = [];
            this.activities.forEach(function (activity) {
                if (!activity.booking) {
                    activitiesId.push(activity.id);
                }
            });

            for (var i = 0; i < object.activities.length; i++) {
                //Could be an simple activity or a bookingService
                if (object.activities[i].objectType == "Activity") {
                    if (activitiesId.indexOf(object.activities[i].id) === -1) {
                        var activity = new Activity(object.activities[i], null, isApplicationLoading);
                        activity.dayHr = this;
                        this.activities.push(activity);
                    }
                } else {
                    var bs = this.day.getBookingServiceById(object.activities[i].id);
                    if (bs) {
                        if (bs._dayHrId == this.id) //primary link
                            bs.dayHr = this;else bs.addSecondaryDayHr(this);

                        this.activities.push(bs);
                    }
                }
            }
        }
    };

    DayHr.prototype.addPeriodOnHr = function (period) {
        if (period) this.periods.push(new Period(period));
    };
    DayHr.prototype.addAvailablePeriod = function (period) {
        if (period) this.availablePeriods.push(new Period(period));
    };
    DayHr.prototype.getObjectResource = function () {
        var res = this.getObjectResourceWithoutActivities();
        //Add activities
        res.activities = [];
        if (this.activities) for (var i = 0; i < this.activities.length; i++) {
            res.activities.push(this.activities[i].getObjectResource());
        }return res;
    };
    DayHr.prototype.getObjectResourceWithoutActivities = function () {
        //Get only Period data
        var res = new DayHr_Resource();
        res.id = this.id;
        res.humanResourceId = this.humanResourceId;
        res.hasSpecificWpPeriods = this.hasSpecificWpPeriods;
        res.hasSpecificOnLineBooking = this.hasSpecificOnLineBooking;
        res.onLineBooking = this.onLineBooking;
        res.comment = this.comment;
        if (this.day) res.dayId = this.day.id;
        //NoActivity
        res.periods = [];
        if (this.periods) for (var i = 0; i < this.periods.length; i++) {
            res.periods.push({
                start: {
                    hour: this.periods[i].start.hour,
                    minute: this.periods[i].start.minute
                },
                end: {
                    hour: this.periods[i].end.hour,
                    minute: this.periods[i].end.minute
                }
            });
        }return res;
    };
    DayHr.prototype.getObjectResourceCreatedByActivity = function () {
        //when created by activity : hasSpecificWpPeriods = false and periods is empty
        var res = new DayHr_Resource();
        res.id = this.id;
        res.humanResourceId = this.humanResourceId;
        if (this.day) res.dayId = this.day.id;
        return res;
    };
    DayHr.prototype.setId = function (id) {
        this.id = id;
    };
    DayHr.prototype.getId = function () {
        return this.id;
    };
    DayHr.prototype.addActivity = function (activity, isPrimary) {
        if (activity) {
            var index = this.activities.indexOf(activity);
            if (index == -1) this.activities.push(activity);
            if (isPrimary === undefined || isPrimary) activity.dayHr = this;else activity.addSecondaryDayHr(this);
        }
    };
    DayHr.prototype.removeActivity = function (activity) {
        if (activity) {
            var index = this.activities.indexOf(activity);
            if (index != -1) this.activities.splice(index, 1);
        }
    };
    DayHr.prototype.isOpenWorkingPeriodForHr = function (period) {
        var isOpen = false;
        for (var i = 0; i < this.periods.length && !isOpen; i++) {
            isOpen = period.start.hour * 60 + period.start.minute < this.periods[i].end.hour * 60 + this.periods[i].end.minute && period.end.hour * 60 + period.end.minute > this.periods[i].start.hour * 60 + this.periods[i].start.minute;
        }return isOpen;
    };
    DayHr.prototype.getHrWorkingTime = function () {
        var hrWorkingTime = 0;
        for (var i = 0; i < this.periods.length; i++) {
            hrWorkingTime += this.periods[i].duration;
        }return hrWorkingTime;
    };
    DayHr.prototype.getHrBookingTime = function () {
        var hrBookingTime = 0;
        for (var i = 0; i < this.activities.length; i++) {
            if (this.activities[i] instanceof BookingService && this.activities[i].period && (this.activities[i].booking && this.activities[i].booking.status != 'notCame' || this.activities[i].pkg && this.activities[i].pkg.booking && this.activities[i].pkg.booking.status != 'notCame')) hrBookingTime += this.activities[i].period.duration;
        }return hrBookingTime;
    };
    DayHr.prototype.getActivityById = function (id) {
        for (var i = 0; i < this.activities.length; i++) {
            if (this.activities[i].id == id) return this.activities[i];
        }return null;
    };
    DayHr.prototype.calculateMaxPeriod = function (period) {
        var hr = HumanResourceData.getById(this.humanResourceId);
        if (hr && !hr.isDeleted) for (var k = 0; k < this.periods.length; k++) {
            if (this.periods[k] && this.periods[k].duration != 0) {
                if (this.periods[k].start.getTime() < period.start.getTime()) {
                    period.setStartHour(this.periods[k].start.hour);
                    period.setStartMinute(this.periods[k].start.minute);
                    console.log("Found max period on " + this.day.id + " hrid:" + this.humanResourceId);
                }
                if (this.periods[k].end.getTime() > period.end.getTime()) {
                    period.setEndHour(this.periods[k].end.hour);
                    period.setEndMinute(this.periods[k].end.minute);
                    console.log("Found max period on " + this.day.id + " hrid:" + this.humanResourceId);
                }
            }
        }
    };
    return DayHr;
}]);

angular.module('FlexyBeautyApp.services').factory('DayHrSrv', ["$log", "DayHr_Resource", "DayHrData", "DayHr", "DayData", "ServerSrv", "UserActionData", function ($log, DayHr_Resource, DayHrData, DayHr, DayData, ServerSrv, UserActionData) {
    var DayHrSrv = {};

    DayHrSrv.save = function (dayHr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(DayHrSrv.saveSync, dayHr, successFunction, errorFunction);
    };
    DayHrSrv.saveSync = function (dayHr, successFunction, errorFunction) {
        //$timeout (function () {

        var DayHrRes = dayHr.getObjectResource();
        DayHrRes.$save({}, //no params
        function (dayHrRes) {
            try {
                dayHr.setId(dayHrRes.id);
                if (!dayHr.version || dayHrRes.version && dayHrRes.version > dayHr.version) dayHr.version = dayHrRes.version;
                if (dayHrRes.activitiesId && dayHrRes.activitiesId.length == dayHr.activities.length)
                    //Assume that returned list has the same order
                    for (var i = 0; i < dayHrRes.activitiesId.length; i++) {
                        dayHr.activities[i].setId(dayHrRes.activitiesId[i]);
                    } //Add user action
                UserActionData.add(dayHrRes.userAction);

                //CallBack on success
                if (successFunction != undefined) successFunction(dayHrRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    DayHrSrv.saveWithoutActivities = function (dayHr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(DayHrSrv.saveSyncWithoutActivities, dayHr, successFunction, errorFunction);
    };
    DayHrSrv.saveSyncWithoutActivities = function (dayHr, successFunction, errorFunction) {
        //$timeout (function () {

        var DayHrRes = dayHr.getObjectResourceWithoutActivities();
        DayHrRes.$saveWithoutActivities({}, //no params
        function (dayHrRes) {
            try {
                dayHr.setId(dayHrRes.id);
                if (!dayHr.version || dayHrRes.version && dayHrRes.version > dayHr.version) dayHr.version = dayHrRes.version;
                if (dayHrRes.activitiesId && dayHrRes.activitiesId.length == dayHr.activities.length)
                    //Assume that returned list has the same order
                    for (var i = 0; i < dayHrRes.activitiesId.length; i++) {
                        dayHr.activities[i].setId(dayHrRes.activitiesId[i]);
                    } //Add user action
                UserActionData.add(dayHrRes.userAction);

                //CallBack on success
                if (successFunction != undefined) successFunction(dayHrRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    DayHrSrv.remove = function (dayHr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(DayHrSrv.removeSync, dayHr, successFunction, errorFunction);
    };
    DayHrSrv.removeSync = function (dayHr, successFunction, errorFunction) {
        //$timeout (function () {

        var DayHrRes = new DayHr_Resource();
        DayHrRes.$remove({ id: dayHr.id }, //no params
        function (dayHrRes) {
            if (!dayHr.version || dayHrRes.version && dayHrRes.version > dayHr.version) dayHr.version = dayHrRes.version;
            //Remove from server success
            // -> remove from local data
            // -> add an user action (send message)

            try {
                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(dayHrRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    DayHrSrv.updateLocally = function (id, resource) {
        var dayHr = DayHrData.getById(id);
        if (dayHr) {
            if (dayHr.version && resource.version && resource.version < dayHr.version) {
                return null;
            }
            dayHr.loadObjectProperties(resource);
        } else {
            console.log("DayHr.updateLocally - Model not found given ID - DayHr ID: " + id);
        }
        return dayHr;
    };

    DayHrSrv.removeLocally = function (id, resource) {
        var dayHr = DayHrData.getById(id);
        if (dayHr) {
            if (dayHr.version && resource.version && resource.version < dayHr.version) {
                return null;
            }

            if (dayHr.day) {
                dayHr.day.removeDayHr(dayHr);
            } else {
                console.log("DayHr.removeLocally - dayHr.day is null - DayHr ID: " + id);
            }
        } else {
            console.log("DayHr.removeLocally - Model not found given ID - DayHr ID: " + id);
        }
        return dayHr;
    };

    DayHrSrv.addLocally = function (id, resource) {
        var dayHr = DayHrData.getById(id);
        if (dayHr && dayHr.version && resource.version && resource.version < dayHr.version) {
            return null;
        }
        if (dayHr != null) {
            console.log("DayHr.addLocally - Model already exists - DayHr ID: " + id);
            dayHr.loadObjectProperties(resource);
        } else {
            var day = DayData.getById(resource.dayId);
            if (day) {
                dayHr = new DayHr(resource, day);
                dayHr.id = id;
                day.addDayHr(dayHr);
            } else {
                console.log("DayHr.addLocally - Day not found given ID - Day ID: " + resource.dayId);
            }
        }
        return dayHr;
    };

    DayHrSrv.getPreviousVersionInstance = function (resource) {
        var day = null;
        if (resource.dayId) day = DayData.getById(resource.dayId);
        var dayHr = new DayHr(resource, day, true);
        return dayHr;
    };

    return DayHrSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('DayHrData', [function () {
    var dayHrData = {
        indexDayHrs: []
    };
    dayHrData.getById = function (dayHrId) {
        for (var i = 0; i < this.indexDayHrs.length; i++) {
            if (this.indexDayHrs[i].id == dayHrId) return this.indexDayHrs[i];
        }return null;
    };
    dayHrData.getIndexOf = function (dayHr) {
        if (dayHr) return this.indexDayHrs.indexOf(dayHr);
        return -1;
    };
    dayHrData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexDayHrs.length) return this.indexDayHrs[index];
        return null;
    };
    dayHrData.add = function (dayHr) {
        this.indexDayHrs.push(dayHr);
        return this.indexDayHrs.length - 1;
    };
    dayHrData.clear = function () {
        this.indexDayHrs = [];
    };
    return dayHrData;
}]);

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('DayPr_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/DayPrs/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        saveWithoutActivities: { method: 'POST', url: baseUrl + 'rest/DayPrs/withoutActivities' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('DayPr', ["DayPr_Resource", "Activity", "DayPrData", "Period", "BookingService", function (DayPr_Resource, Activity, DayPrData, Period, BookingService) {
    //WorkingPeriodDay inherit of $resource

    var DayPr = function DayPr(resource, day, isPreviousVersion, isApplicationLoading) {
        this.id = null;
        this.prUnitId = null;
        this.physicalResourceId = null;
        this.day = null;
        this.hasSpecificWpPeriods = false;
        this.hasSpecificOnLineBooking = false;
        this.onLineBooking = true;
        this.activities = [];
        this.periods = []; //Periods of work for a day;
        this.availablePeriods = [];
        this.comment = null;
        this.version = null;
        if (day !== undefined && day != null) {
            this.day = day;
        }

        if (resource !== undefined && resource != null) {
            this.loadObject(resource, isApplicationLoading);
        }
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            DayPrData.add(this);
    };
    DayPr.prototype.loadObject = function (object, isApplicationLoading) {
        this.loadObjectProperties(object);
        this.loadObjectActivities(object, isApplicationLoading);
    };
    DayPr.prototype.loadObjectProperties = function (object) {
        if (!this.id) this.id = object.id;
        this.prUnitId = object.prUnitId;
        this.physicalResourceId = object.physicalResourceId;
        this.hasSpecificWpPeriods = object.hasSpecificWpPeriods;
        this.hasSpecificOnLineBooking = object.hasSpecificOnLineBooking;
        this.onLineBooking = object.onLineBooking;
        this.comment = object.comment;
        if (object.periods) {
            this.periods = [];
            for (var j = 0; j < object.periods.length; j++) {
                this.addPeriodOnPr(object.periods[j]);
            }
        }
        if (object.availablePeriods) {
            this.availablePeriods = [];
            for (var j = 0; j < object.availablePeriods.length; j++) {
                this.addAvailablePeriod(object.availablePeriods[j]);
            }
        }
        if (object.version) this.version = object.version;
    };

    DayPr.prototype.loadObjectActivities = function (object, isApplicationLoading) {
        if (object.activities) {
            var activitiesId = [];
            this.activities.forEach(function (activity) {
                if (!activity.booking) {
                    activitiesId.push(activity.id);
                }
            });
            for (var i = 0; i < object.activities.length; i++) {
                //Could be an simple activity or a bookingService
                if (object.activities[i].objectType == "Activity") {
                    if (activitiesId.indexOf(object.activities[i].id) === -1) {
                        var activity = new Activity(object.activities[i], null, isApplicationLoading);
                        activity.dayPr = this;
                        this.activities.push(activity);
                    }
                } else {
                    //Get BookingService Object from Booking instead
                    var bs = this.day.getBookingServiceById(object.activities[i].id);
                    if (bs) {
                        if (bs._dayPrId == this.id) {
                            bs.dayPr = this;
                        } else {
                            bs.addSecondaryDayPr(this);
                        }
                        this.activities.push(bs);
                    }
                }
            }
        }
    };

    DayPr.prototype.addPeriodOnPr = function (period) {
        if (period) this.periods.push(new Period(period));
    };
    DayPr.prototype.addAvailablePeriod = function (period) {
        if (period) this.availablePeriods.push(new Period(period));
    };
    DayPr.prototype.getObjectResource = function () {
        var res = this.getObjectResourceWithoutActivities();
        //Add activities
        res.activities = [];
        if (this.activities) for (var i = 0; i < this.activities.length; i++) {
            res.activities.push(this.activities[i].getObjectResource());
        }return res;
    };
    DayPr.prototype.getObjectResourceWithoutActivities = function () {
        //Get only Period data
        var res = new DayPr_Resource();
        res.id = this.id;
        res.prUnitId = this.prUnitId;
        res.physicalResourceId = this.physicalResourceId;
        res.hasSpecificWpPeriods = this.hasSpecificWpPeriods;
        res.hasSpecificOnLineBooking = this.hasSpecificOnLineBooking;
        res.onLineBooking = this.onLineBooking;
        res.comment = this.comment;
        if (this.day) res.dayId = this.day.id;
        //NoActivity
        res.periods = [];
        if (this.periods) for (var i = 0; i < this.periods.length; i++) {
            res.periods.push({
                start: {
                    hour: this.periods[i].start.hour,
                    minute: this.periods[i].start.minute
                },
                end: {
                    hour: this.periods[i].end.hour,
                    minute: this.periods[i].end.minute
                }
            });
        }return res;
    };
    DayPr.prototype.getObjectResourceCreatedByActivity = function () {
        //when created by activity : hasSpecificWpPeriods = false and periods is empty
        var res = new DayPr_Resource();
        res.id = this.id;
        res.prUnitId = this.prUnitId;
        res.physicalResourceId = this.physicalResourceId;
        if (this.day) res.dayId = this.day.id;
        return res;
    };
    DayPr.prototype.setId = function (id) {
        this.id = id;
    };
    DayPr.prototype.getId = function () {
        return this.id;
    };
    DayPr.prototype.addActivity = function (activity, isPrimary) {
        if (activity) {
            var index = this.activities.indexOf(activity);
            if (index == -1) this.activities.push(activity);
            if (isPrimary === undefined || isPrimary) activity.dayPr = this;else activity.addSecondaryDayPr(this);
        }
    };
    DayPr.prototype.removeActivity = function (activity) {
        if (activity) {
            var index = this.activities.indexOf(activity);
            if (index != -1) this.activities.splice(index, 1);
        }
    };
    DayPr.prototype.isOpenWorkingPeriodForPr = function (period) {
        var isOpen = false;
        for (var i = 0; i < this.periods.length && !isOpen; i++) {
            isOpen = period.start.hour * 60 + period.start.minute < this.periods[i].end.hour * 60 + this.periods[i].end.minute && period.end.hour * 60 + period.end.minute > this.periods[i].start.hour * 60 + this.periods[i].start.minute;
        }return isOpen;
    };
    DayPr.prototype.getActivityById = function (id) {
        for (var i = 0; i < this.activities.length; i++) {
            if (this.activities[i].id == id) return this.activities[i];
        }return null;
    };
    DayPr.prototype.calculateMaxPeriod = function (period) {
        for (var k = 0; k < this.periods.length; k++) {
            if (this.periods[k] && this.periods[k].duration != 0) {
                if (this.periods[k].start.getTime() < period.start.getTime()) {
                    period.setStartHour(this.periods[k].start.hour);
                    period.setStartMinute(this.periods[k].start.minute);
                    console.log("Found max period on " + this.day.id + " prid:" + this.physicalResourceId);
                }
                if (this.periods[k].end.getTime() > period.end.getTime()) {
                    period.setEndHour(this.periods[k].end.hour);
                    period.setEndMinute(this.periods[k].end.minute);
                    console.log("Found max period on " + this.day.id + " prid:" + this.physicalResourceId);
                }
            }
        }
    };
    DayPr.prototype.hasBookingActivities = function () {
        for (var i = 0; i < this.activities.length; i++) {
            if (this.activities[i].objectType != "Activity") return true;
        }return false;
    };
    DayPr.prototype.getPrWorkingTime = function () {
        var prWorkingTime = 0;
        for (var i = 0; i < this.periods.length; i++) {
            prWorkingTime += this.periods[i].duration;
        }return prWorkingTime;
    };
    DayPr.prototype.getPrBookingTime = function () {
        var prBookingTime = 0;
        for (var i = 0; i < this.activities.length; i++) {
            if (this.activities[i] instanceof BookingService && this.activities[i].period && (this.activities[i].booking && this.activities[i].booking.status != 'notCame' || this.activities[i].pkg && this.activities[i].pkg.booking && this.activities[i].pkg.booking.status != 'notCame')) prBookingTime += this.activities[i].period.duration;
        }return prBookingTime;
    };
    //        DayPr.prototype.isAvailableForPeriod= function(period)
    //        {
    //            var isAvailable = false;
    //            var i= 0;
    //            if (period)
    //                for (var u =0;u< this.dayPrUnits.length;u++)
    //                    for (i= 0; i<this.dayPrUnits[u].availablePeriods.length && !isAvailable && this.dayPrUnits[u].availablePeriods[i].start.getTime()<=period.start.getTime();i++)
    //                        isAvailable = this.dayPrUnits[u].availablePeriods[i].contains(period);
    //
    //            return isAvailable;
    //        }
    return DayPr;
}]);

angular.module('FlexyBeautyApp.services').factory('DayPrSrv', ["$log", "DayPr_Resource", "DayPrData", "DayPr", "DayData", "ServerSrv", "UserActionData", function ($log, DayPr_Resource, DayPrData, DayPr, DayData, ServerSrv, UserActionData) {
    var DayPrSrv = {};

    DayPrSrv.save = function (dayPr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(DayPrSrv.saveSync, dayPr, successFunction, errorFunction);
    };
    DayPrSrv.saveSync = function (dayPr, successFunction, errorFunction) {
        //$timeout (function () {

        var DayPrRes = dayPr.getObjectResource();
        DayPrRes.$save({}, //no params
        function (dayPrRes) {
            try {
                dayPr.setId(dayPrRes.id);
                if (!dayPr.version || dayPrRes.version && dayPrRes.version > dayPr.version) dayPr.version = dayPrRes.version;
                if (dayPrRes.activitiesId && dayPrRes.activitiesId.length == dayPr.activities.length)
                    //Assume that returned list has the same order
                    for (var i = 0; i < dayPrRes.activitiesId.length; i++) {
                        dayPr.activities[i].setId(dayPrRes.activitiesId[i]);
                    } //Add user action
                UserActionData.add(dayPrRes.userAction);

                //CallBack on success
                if (successFunction != undefined) successFunction(dayPrRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    DayPrSrv.saveWithoutActivities = function (dayPr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(DayPrSrv.saveSyncWithoutActivities, dayPr, successFunction, errorFunction);
    };
    DayPrSrv.saveSyncWithoutActivities = function (dayPr, successFunction, errorFunction) {
        //$timeout (function () {

        var DayPrRes = dayPr.getObjectResourceWithoutActivities();
        DayPrRes.$saveWithoutActivities({}, //no params
        function (dayPrRes) {
            try {
                dayPr.setId(dayPrRes.id);
                if (!dayPr.version || dayPrRes.version && dayPrRes.version > dayPr.version) dayPr.version = dayPrRes.version;
                if (dayPrRes.activitiesId && dayPrRes.activitiesId.length == dayPr.activities.length)
                    //Assume that returned list has the same order
                    for (var i = 0; i < dayPrRes.activitiesId.length; i++) {
                        dayPr.activities[i].setId(dayPrRes.activitiesId[i]);
                    } //Add user action
                UserActionData.add(dayPrRes.userAction);

                //CallBack on success
                if (successFunction != undefined) successFunction(dayPrRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    DayPrSrv.remove = function (dayPr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(DayPrSrv.removeSync, dayPr, successFunction, errorFunction);
    };
    DayPrSrv.removeSync = function (dayPr, successFunction, errorFunction) {
        //$timeout (function () {

        var DayPrRes = new DayPr_Resource();
        DayPrRes.$remove({ id: dayPr.id }, //no params
        function (dayPrRes) {
            if (!dayPr.version || dayPrRes.version && dayPrRes.version > dayPr.version) dayPr.version = dayPrRes.version;
            try {
                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(dayPrRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    DayPrSrv.updateLocally = function (id, resource) {
        var dayPr = DayPrData.getById(id);
        if (dayPr) {
            if (dayPr.version && resource.version && resource.version < dayPr.version) {
                return null;
            }
            dayPr.loadObjectProperties(resource);
        } else {
            console.log("DayPr.updateLocally - Model not found given ID - DayPr ID: " + id);
        }
        return dayPr;
    };

    DayPrSrv.removeLocally = function (id, resource) {
        var dayPr = DayPrData.getById(id);
        if (dayPr) {
            if (dayPr.version && resource.version && resource.version < dayPr.version) {
                return null;
            }

            if (dayPr.day) {
                dayPr.day.removeDayPr(dayPr);
            } else {
                console.log("DayPr.removeLocally - dayPr.day is null - DayPr ID: " + id);
            }
        } else {
            console.log("DayPr.removeLocally - Model not found given ID - DayPr ID: " + id);
        }
        return dayPr;
    };

    DayPrSrv.addLocally = function (id, resource) {
        var dayPr = DayPrData.getById(id);
        if (dayPr && dayPr.version && resource.version && resource.version < dayPr.version) {
            return null;
        }

        if (dayPr != null) {
            console.log("DayPr.addLocally - Model already exists - DayPr ID: " + id);
            dayPr.loadObjectProperties(resource);
        } else {
            var day = DayData.getById(resource.dayId);
            if (day) {
                dayPr = new DayPr(resource, day);
                dayPr.id = id;
                day.addDayPr(dayPr);
            } else {
                console.log("DayPr.addLocally - Day not found given ID - Day ID: " + resource.dayId);
            }
        }
        return dayPr;
    };

    DayPrSrv.getPreviousVersionInstance = function (resource) {
        var day = null;
        if (resource.dayId) day = DayData.getById(resource.dayId);
        var dayPr = new DayPr(resource, day, true);
        return dayPr;
    };

    return DayPrSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('DayPrData', [function () {
    var dayPrData = {
        indexDayPrs: []
    };
    dayPrData.getById = function (dayPrId) {
        for (var i = 0; i < this.indexDayPrs.length; i++) {
            if (this.indexDayPrs[i].id == dayPrId) return this.indexDayPrs[i];
        }return null;
    };
    dayPrData.getIndexOf = function (dayPr) {
        if (dayPr) return this.indexDayPrs.indexOf(dayPr);
        return -1;
    };
    dayPrData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexDayPrs.length) return this.indexDayPrs[index];
        return null;
    };
    dayPrData.add = function (dayPr) {
        this.indexDayPrs.push(dayPr);
        return this.indexDayPrs.length - 1;
    };
    dayPrData.clear = function () {
        this.indexDayPrs = [];
    };
    return dayPrData;
}]);

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

angular.module('FlexyBeautyApp.services').factory('ModelDataUtil', [function () {
    var modelDataUtil = {
        convertMapToArray: function convertMapToArray(object, array) {
            array = [];
            for (var key in object) {
                array.push(object[key]);
                delete object[key];
            }
            return array;
        },
        convertObjectToArray: function convertObjectToArray(object, indexArray) {
            var oldObject = indexArray.reduce(function (accumulatorObject, currentItem) {
                if (currentItem.id) {
                    accumulatorObject[currentItem.id] = currentItem;
                }
                return accumulatorObject;
            }, {});

            var newObject = _extends({}, object, oldObject);

            return Object.values(newObject);
        }
    };

    return modelDataUtil;
}]);

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Site_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/sites/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getFromCode: { method: 'GET', url: baseUrl + 'rest/sites/from-code' },
        saveFromCode: { method: 'POST', url: baseUrl + 'rest/sites/:companyCode' },
        addWorkingPeriod: { method: 'POST', url: baseUrl + 'rest/sites/addWorkingPeriod' },
        removeWorkingPeriod: { method: 'DELETE', url: baseUrl + 'rest/sites/removeWorkingPeriod/:siteId/:id' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Site', ["Site_Resource", "WorkingPeriod", "Period", "Countries", "HumanResourceData", function (Site_Resource, WorkingPeriod, Period, Countries, HumanResourceData) {
    //Site inherit of $resource

    var Site = function Site(resource, isApplicationLoading) {
        this.id = null;
        this.preposition = null;
        this.name = null;
        this.phone = null;
        this.emailContact = null;
        this.emailBooking = null;
        this.fax = null;
        this.address = null;
        this.postalCode = null;
        this.city = null;
        this.country = null;
        this.timeZone = null;
        this.departement = null;
        this.siret = null;
        this.rcs = null;
        this.shareCapital = null;
        this.vatNumber = null;
        this.nafCode = null;
        this.webSiteDir = null;
        this.workingPeriods = [];
        this.version = null;
        this.ownerId = null;
        this.legalName = null;
        this.legalAddress = null;
        this.legalCity = null;
        this.legalZip = null;
        this.legalCountry = null;
        this.greffeCity = null;
        this.juridicForm = null;
        if (resource !== undefined && resource != null) {
            this.loadObject(resource, isApplicationLoading);
        }
    };

    Site.prototype.isFrenchLocation = function () {
        if (this.country === Countries.FRANCE.countryCode) {
            return true;
        } else {
            return false;
        }
    };

    Site.prototype.loadObject = function (object, isApplicationLoading) {
        if (!this.id) this.id = object.id;
        this.name = object.name;
        this.preposition = object.preposition;
        this.phone = object.phone;
        this.emailContact = object.emailContact;
        this.emailBooking = object.emailBooking;
        this.fax = object.fax;
        this.address = object.address;
        this.postalCode = object.postalCode;
        this.city = object.city;
        this.country = object.country;
        this.timeZone = object.timeZone;
        this.departement = object.departement;
        this.siret = object.siret;
        this.rcs = object.rcs;
        this.shareCapital = object.shareCapital;
        this.nafCode = object.nafCode;
        this.vatNumber = object.vatNumber;
        this.webSiteDir = object.webSiteDir;
        this.ownerId = object.ownerId;
        this.legalName = object.legalName;
        this.legalAddress = object.legalAddress;
        this.legalCity = object.legalCity;
        this.legalZip = object.legalZip;
        this.legalCountry = object.legalCountry;
        this.greffeCity = object.greffeCity;
        this.juridicForm = object.juridicForm;
        if (object.workingPeriods) {
            this.workingPeriods = [];
            for (var i = 0; i < object.workingPeriods.length; i++) {
                this.workingPeriods.push(new WorkingPeriod(object.workingPeriods[i], this, isApplicationLoading));
            }
        }
        if (object.version) this.version = object.version;
    };
    Site.prototype.getObjectResource = function () {
        var rsSite = new Site_Resource();
        rsSite.id = this.id;
        rsSite.name = this.name;
        rsSite.preposition = this.preposition;
        rsSite.phone = this.phone;
        rsSite.emailContact = this.emailContact;
        rsSite.emailBooking = this.emailBooking;
        rsSite.fax = this.fax;
        rsSite.address = this.address;
        rsSite.postalCode = this.postalCode;
        rsSite.city = this.city;
        rsSite.country = this.country;
        rsSite.timeZone = this.timeZone;
        rsSite.departement = this.departement;
        rsSite.siret = this.siret;
        rsSite.nafCode = this.nafCode;
        rsSite.vatNumber = this.vatNumber;
        rsSite.webSiteDir = this.webSiteDir;
        rsSite.rcs = this.rcs;
        rsSite.shareCapital = this.shareCapital;
        rsSite.ownerId = this.ownerId;
        rsSite.legalName = this.legalName;
        rsSite.legalAddress = this.legalAddress;
        rsSite.legalCity = this.legalCity;
        rsSite.legalZip = this.legalZip;
        rsSite.legalCountry = this.legalCountry;
        rsSite.greffeCity = this.greffeCity;
        rsSite.juridicForm = this.juridicForm;

        rsSite.workingPeriods = [];

        if (this.workingPeriods) for (var i = 0; i < this.workingPeriods.length; i++) {
            rsSite.workingPeriods.push(this.workingPeriods[i].getObjectResource());
        }

        return rsSite;
    };
    Site.prototype.addWorkingPeriod = function (workingPeriod) {
        this.workingPeriods.push(workingPeriod);
        return this.workingPeriods.length - 1; //return position
    };

    Site.prototype.removeWorkingPeriod = function (workingPeriod) {
        var index = this.workingPeriods.indexOf(workingPeriod);
        if (index != -1) this.workingPeriods.splice(index, 1);
    };
    Site.prototype.isWorkingPeriod = function (dayOfWIndex, hrId, period) {
        var isWorkingPeriod = false;
        for (var i = 0; i < this.workingPeriods.length && !isWorkingPeriod; i++) {
            isWorkingPeriod = this.workingPeriods[i].isWorkingPeriod(dayOfWIndex, hrId, period);
        }return isWorkingPeriod;
    };
    Site.prototype.getMaxOpeningPeriod = function () {
        var maxPeriod = new Period();
        maxPeriod.start.hour = 24;
        var wp;
        for (var i = 0; i < this.workingPeriods.length; i++) {
            wp = this.workingPeriods[i];
            if (wp.period) {
                if (wp.period.start.getTime() < maxPeriod.start.getTime()) maxPeriod.setStart(wp.period.start);
                if (wp.period.end.getTime() > maxPeriod.end.getTime()) maxPeriod.setEnd(wp.period.end);
            }
        }
        return maxPeriod;
    };
    Site.prototype.getDefaultPeriodsOfWork = function (dayOfWIndex, hrId) {
        // return periods of work according : dayOfWIndex + Hrid
        // if period null get site opening
        var periods = [];
        var period = null;
        for (var i = 0; i < this.workingPeriods.length; i++) {
            period = this.workingPeriods[i].getDefaultPeriodOfWork(dayOfWIndex, hrId);
            if (period) {
                period.openDay = this.workingPeriods[i].workingPeriodDays[dayOfWIndex].openDay;
                period.wpIndex = i;
                periods.push(period);
            }
        }
        if (periods.length == 0 && this.workingPeriods.length != 0) //no open day : use time of first open
            periods.push(this.workingPeriods[0].period);
        return periods;
    };
    Site.prototype.getPeriodsOfWorkPr = function (dayOfWIndex, prId, prUnitId) {
        // return periods of work according : dayOfWIndex + Hrid
        var periods = [];
        var period = null;
        for (var i = 0; i < this.workingPeriods.length; i++) {
            period = this.workingPeriods[i].getPeriodOfWorkForPr(dayOfWIndex, prId, prUnitId);
            if (period) {
                period.wpIndex = i;
                periods.push(period);
            }
        }
        return periods;
    };
    Site.prototype.getPeriodsOfWork = function (dayOfWIndex, hrId) {
        // return periods of work according : dayOfWIndex + Hrid
        var periods = [];
        var period = null;
        for (var i = 0; i < this.workingPeriods.length; i++) {
            period = this.workingPeriods[i].getPeriodOfWorkForHr(dayOfWIndex, hrId);
            if (period) {
                period.wpIndex = i;
                periods.push(period);
            }
        }
        return periods;
    };
    Site.prototype.prIsWorking = function (dayOfWIndex, prId, prUnitId) {
        // allow to know if pr is working according opened period of work dayOfWIndex + prid
        var prIsWorking = false;
        var periodsOfWork = this.getPeriodsOfWorkPr(dayOfWIndex, prId, prUnitId);
        prIsWorking = periodsOfWork && periodsOfWork.length > 0;
        return prIsWorking;
    };
    Site.prototype.hrIsWorking = function (dayOfWIndex, hrId) {
        // allow to know if hr is working according opened period of work dayOfWIndex + Hrid
        var hrIsWorking = false;
        var periodsOfWork = this.getPeriodsOfWork(dayOfWIndex, hrId);
        hrIsWorking = periodsOfWork && periodsOfWork.length > 0;
        return hrIsWorking;
    };
    Site.prototype.getHrWorkingTime = function (dayOfWIndex, hrId) {
        // allow to get hr workingTime by dayOfWIndex and hrid
        //check default site data

        var hrWorkingTime = 0;
        var periodsOfWork = this.getPeriodsOfWork(dayOfWIndex, hrId);
        if (periodsOfWork) for (var i = 0; i < periodsOfWork.length; i++) {
            hrWorkingTime += periodsOfWork[i].duration;
        }return hrWorkingTime;
    };
    Site.prototype.getPrWorkingTime = function (dayOfWIndex, prId, prUnitId) {
        // allow to get hr workingTime by dayOfWIndex and hrid
        //check default site data

        var prWorkingTime = 0;
        var periodsOfWork = this.getPeriodsOfWorkPr(dayOfWIndex, prId, prUnitId);
        if (periodsOfWork) for (var i = 0; i < periodsOfWork.length; i++) {
            prWorkingTime += periodsOfWork[i].duration;
        }return prWorkingTime;
    };
    Site.prototype.getOpenWorkingPeriodIndex = function (dayOfWIndex, hrId, period) {
        // return workingPeriod index according : dayOfWIndex + Hr id who is open for an period
        for (var i = 0; i < this.workingPeriods.length; i++) {
            if (this.workingPeriods[i].isOpenWorkingPeriodForHr(dayOfWIndex, hrId, period)) return i;
        }return -1;
    };
    Site.prototype.getWorkingPeriodById = function (id) {
        for (var i = 0; i < this.workingPeriods.length; i++) {
            if (this.workingPeriods[i].id == id) return this.workingPeriods[i];
        }return null;
    };
    Site.prototype.getWpDays = function (dayOfWIndex) {
        // allow to get wpdays for dayOfW Index hrId
        //check default site data
        var wpDays = [];
        for (var i = 0; i < this.workingPeriods.length; i++) {
            wpDays.push(this.workingPeriods[i].getWpDay(dayOfWIndex));
        }return wpDays;
    };

    // statistic module
    Site.prototype.isOpenDay = function (dayOfWeekId) {
        for (var i = 0; i < this.workingPeriods.length; i++) {
            if (this.workingPeriods[i].workingPeriodDays[dayOfWeekId].openDay) return true;
        }
        return false;
    };

    Site.prototype.isWorkingPeriodDayHrOnlineBooking = function (dayOfWIndex, humanResourceId) {
        var onlineBooking = false;
        for (var i = 0; i < this.workingPeriods.length; i++) {
            var workingPeriodDay = this.workingPeriods[i].workingPeriodDays[dayOfWIndex];
            if (workingPeriodDay && workingPeriodDay.openDay) {
                var workingPeriodDayHr = workingPeriodDay.getWorkingPeriodDayHr(humanResourceId);
                if (!workingPeriodDayHr || workingPeriodDayHr.onLineBooking) {
                    onlineBooking = true;
                    break;
                }
            }
        }
        return onlineBooking;
    };

    Site.prototype.isWorkingPeriodDayPrOnlineBooking = function (dayOfWIndex, physicalResourceId, prUnitId) {
        var onlineBooking = false;
        for (var i = 0; i < this.workingPeriods.length; i++) {
            var workingPeriodDay = this.workingPeriods[i].workingPeriodDays[dayOfWIndex];
            if (workingPeriodDay && workingPeriodDay.openDay) {
                var workingPeriodDayPr = workingPeriodDay.getWorkingPeriodDayPr(physicalResourceId, prUnitId);
                if (!workingPeriodDayPr || workingPeriodDayPr.onLineBooking) {
                    onlineBooking = true;
                    break;
                }
            }
        }
        return onlineBooking;
    };

    Site.prototype.areMigrationInformationComplete = function (hasAccessToWebsite, posAppAttribute) {
        var owner = this.ownerId != null ? HumanResourceData.getById(this.ownerId) : null;
        var isValid = this.name != null && this.workingPeriods != null && this.workingPeriods.length > 0 && this.ownerId != null && this.legalName != null && this.address != null && this.city != null && this.postalCode != null && this.country != null && this.phone != null && this.siret != null && this.vatNumber != null && this.legalAddress != null && this.legalCity != null && this.legalZip != null && this.legalCountry != null && owner != null && owner.email != null && owner.phone != null;

        if (isValid && hasAccessToWebsite) {
            isValid = this.emailContact != null && this.webSiteDir != null;
        }

        if (isValid && posAppAttribute != null) {
            var isAdvanceAttr = posAppAttribute.getAppAttribute("advanceMng");
            if (isAdvanceAttr && isAdvanceAttr.value === "true") {
                isValid = this.rcs != null;
            }
        }
        return isValid;
    };

    return Site;
}]);

angular.module('FlexyBeautyApp.services').factory('SiteSrv', ["$log", "Site_Resource", "Site", "SiteData", "UserActionData", "ServerSrv", function ($log, Site_Resource, Site, SiteData, UserActionData, ServerSrv) {
    var siteSrv = {};

    siteSrv.query = function (successFunction, errorFunction, isApplicationLoading) {
        Site_Resource.query({}, //params
        function (data) {
            //success
            //Data is an Array
            SiteData.clear();

            for (var i = 0; i < data.length; i++) {
                SiteData.sites.push(new Site(data[i], isApplicationLoading));
            }if (SiteData.sites.length > 0) {
                SiteData.defaultSite = SiteData.sites[0];
            }

            if (successFunction !== undefined) successFunction(SiteData.defaultSite);
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    siteSrv.save = function (site, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(siteSrv.saveSync, site, successFunction, errorFunction);
    };
    siteSrv.saveSync = function (site, successFunction, errorFunction) {
        var siteRes = site.getObjectResource();
        siteRes.$save({}, //no params
        function (data) {
            try {
                if (!site.id) site.id = data.id;
                if (!site.version || data.version && data.version > site.version) site.version = data.version;
                /** @namespace data.workingPeriodsId */
                var wpData;var wp;
                if (data.workingPeriods && data.workingPeriods.length == site.workingPeriods.length)
                    //Assume that returned list has the same order
                    for (var i = 0; i < data.workingPeriods.length; i++) {
                        wpData = data.workingPeriods[i];
                        wp = site.workingPeriods[i];
                        wp.setId(wpData.id);
                        if (wpData.workingPeriodDaysId && wpData.workingPeriodDaysId.length == wp.workingPeriodDays.length) for (var j = 0; j < wpData.workingPeriodDaysId.length; j++) {
                            wp.workingPeriodDays[j].id = wpData.workingPeriodDaysId[j];
                        }
                    }

                //TODO UserActionData.add(data.userAction);

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    siteSrv.removeWorkingPeriod = function (site, workingPeriod, successFunction, errorFunction) {
        site.referenceWeek.removeWorkingPeriod(workingPeriod);
        ServerSrv.startSavingProcess(siteSrv.removeWorkingPeriodSync, site, workingPeriod, successFunction, errorFunction);
    };
    siteSrv.removeWorkingPeriodSync = function (site, workingPeriod, successFunction, errorFunction) {
        //$timeout (function () {

        var siteRes = new Site_Resource();
        siteRes.$removeWorkingPeriod({ siteId: site.id, id: workingPeriod.id }, function (data) {
            //Save on server success :
            // -> set id for new entity

            // -> add an user action (send message)
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    siteSrv.getSiteFromCode = function (companyCode) {
        return Site_Resource.getFromCode({ 'company-code': companyCode }).$promise;
    };
    siteSrv.saveFromCode = function (companyCode, site) {
        var siteResource = site.getObjectResource();
        return siteResource.$saveFromCode({ companyCode: companyCode }).$promise;
    };
    siteSrv.addWorkingPeriod = function (site, workingPeriod, successFunction, errorFunction) {
        site.referenceWeek.addWorkingPeriod(workingPeriod);
        ServerSrv.startSavingProcess(siteSrv.addWorkingPeriodSync, site, workingPeriod, successFunction, errorFunction);
    };
    siteSrv.addWorkingPeriodSync = function (site, workingPeriod, successFunction, errorFunction) {
        var siteRes = new Site_Resource();
        siteRes.id = site.id;
        siteRes.workingPeriod = workingPeriod.getObjectResource();
        siteRes.$addWorkingPeriod({}, //no params
        function (data) {
            try {
                workingPeriod.id = data.id;
                // -> add an user action (send message)

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    siteSrv.updateLocally = function (objectToRestore) {
        var site = SiteData.getById(objectToRestore.id);
        if (site != null) {
            site.loadObject(objectToRestore);
            return site;
        }
        return null;
    };

    return siteSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('SiteData', ["$log", function ($log) {
    var siteData = {
        sites: [],
        defaultSite: null
    };

    siteData.clear = function () {
        this.sites = [];
    };
    siteData.getById = function (siteId) {
        for (var i = 0; i < this.sites.length; i++) {
            if (this.sites[i].id == siteId) return this.sites[i];
        }return null;
    };

    return siteData;
}]);

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('WorkingPeriod_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBookingS = $resource(baseUrl + 'rest/workingPeriods/:id', {}, {});
    return resourceBookingS;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriod', ["$log", "$locale", "DateSrv", "WorkingPeriodData", "WorkingPeriod_Resource", "WorkingPeriodDay", "Period", function ($log, $locale, DateSrv, WorkingPeriodData, WorkingPeriod_Resource, WorkingPeriodDay, Period) {
    //Booking inherit of Booking_Resource

    var WorkingPeriod = function WorkingPeriod(workingPeriodRes, site, isApplicationLoading) {
        this.id = null;
        this.site = null;
        this.period = null;
        this.workingPeriodDays = []; //mondayToSunday active value

        WorkingPeriodData.add(this);

        if (site !== undefined && site != null) this.site = site;

        if (workingPeriodRes !== undefined && workingPeriodRes != null) {
            if (!this.id) this.id = workingPeriodRes.id;
            this.period = new Period(workingPeriodRes.period);
            // set the duration time
            if (workingPeriodRes.workingPeriodDays) for (var i = 0; i < workingPeriodRes.workingPeriodDays.length; i++) {
                this.workingPeriodDays.push(new WorkingPeriodDay(workingPeriodRes.workingPeriodDays[i], this, isApplicationLoading));
            }
        }
    };
    WorkingPeriod.prototype.getObjectResource = function () {
        var workingPeriodRes = new WorkingPeriod_Resource();
        workingPeriodRes.id = this.id;
        if (this.site) workingPeriodRes.siteId = this.site.id;
        workingPeriodRes.period = this.period.getObjectResource();
        workingPeriodRes.workingPeriodDays = [];
        for (var i = 0; i < this.workingPeriodDays.length; i++) {
            workingPeriodRes.workingPeriodDays.push(this.workingPeriodDays[i].getObjectResource());
        }return workingPeriodRes;
    };
    WorkingPeriod.prototype.addWorkingPeriodDay = function (workingPeriodDay) {
        this.workingPeriodDays.push(workingPeriodDay);
        workingPeriodDay.workingPeriod = this;
        return this.workingPeriodDays.length - 1;
    };
    WorkingPeriod.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };
    WorkingPeriod.prototype.setId = function (id) {
        this.id = id;
    };
    WorkingPeriod.prototype.getId = function () {
        return this.id;
    };
    WorkingPeriod.prototype.isOpenWorkingPeriodForHr = function (dayOfWIndex, hrId, period) {
        var wperiod = this.getPeriodOfWorkForHr(dayOfWIndex, hrId);
        $log.error("depracated");
        if (wperiod) {
            return period.start.hour * 60 + period.start.minute < wperiod.end.hour * 60 + wperiod.end.minute && period.end.hour * 60 + period.end.minute > wperiod.start.hour * 60 + wperiod.start.minute;
        }

        return false;
    };
    WorkingPeriod.prototype.isOpenWorkingPeriodForPr = function (dayOfWIndex, prId, prUnitId, period) {
        var wperiod = this.getPeriodOfWorkForPr(dayOfWIndex, prId, prUnitId);
        $log.error("depracated");
        if (wperiod) {
            return period.start.hour * 60 + period.start.minute < wperiod.end.hour * 60 + wperiod.end.minute && period.end.hour * 60 + period.end.minute > wperiod.start.hour * 60 + wperiod.start.minute;
        }

        return false;
    };
    WorkingPeriod.prototype.getWpDay = function (dayOfWIndex) {
        if (this.workingPeriodDays[dayOfWIndex]) return this.workingPeriodDays[dayOfWIndex];
    };

    WorkingPeriod.prototype.getPeriodOfWorkForHr = function (dayOfWIndex, hrId) {
        // return periods of work according : dayOfWIndex + Hrid
        var period = null;
        if (this.workingPeriodDays[dayOfWIndex] && this.workingPeriodDays[dayOfWIndex].openDay) {
            period = this.period;
            var wpDayHr = this.workingPeriodDays[dayOfWIndex].getWorkingPeriodDayHr(hrId);
            if (wpDayHr && wpDayHr.specificPeriod) period = wpDayHr.period;
        }
        return period;
    };
    WorkingPeriod.prototype.getPeriodOfWorkForPr = function (dayOfWIndex, prId, prUnitId) {
        // return periods of work according : dayOfWIndex + Hrid
        var period = null;
        if (this.workingPeriodDays[dayOfWIndex] && this.workingPeriodDays[dayOfWIndex].openDay) {
            period = this.period;
            var wpDayHr = this.workingPeriodDays[dayOfWIndex].getWorkingPeriodDayPr(prId, prUnitId);
            if (wpDayHr && wpDayHr.specificPeriod) period = wpDayHr.period;
        }
        return period;
    };

    WorkingPeriod.prototype.getDefaultPeriodOfWork = function (dayOfWIndex, hrId) {
        // return default periods of work according : dayOfWIndex + Hrid
        // if day closed get period of WP
        var period = null;
        if (this.workingPeriodDays[dayOfWIndex].openDay) period = this.period;
        var wpDayHr = this.workingPeriodDays[dayOfWIndex].getWorkingPeriodDayHr(hrId);
        if (wpDayHr && wpDayHr.specificPeriod && wpDayHr.period) //period cant be null
            period = wpDayHr.period;

        return period;
    };
    WorkingPeriod.prototype.setHumanResource = function (humanResource) {
        //if (this.humanResource!=null && this.humanResource!= humanResource)
        //this.humanResource.removeWorkingPeriod(this);
        this.humanResource = humanResource;
        if (this.humanResource != null) {
            //            this.humanResource.addWorkingPeriod(this);
        }
    };
    WorkingPeriod.prototype.getHumanResource = function () {
        return this.humanResource;
    };
    WorkingPeriod.prototype.setPhysicalResource = function (physicalResource) {
        //        if (this._physicalResource!=null && this._physicalResource!= physicalResource)
        //            this._physicalResource.removeWorkingPeriod(this);
        this._physicalResource = physicalResource;
        if (this._physicalResource != null) {
            this.physicalResourceId = this._physicalResource.getId();
            //            this._physicalResource.addWorkingPeriod(this);
        }
    };
    WorkingPeriod.prototype.setInherit = function (inherit) {
        this.inherit = inherit;
    };

    return WorkingPeriod;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodSrv', ["$log", "WorkingPeriod_Resource", "SiteData", "ServerSrv", function ($log, WorkingPeriod_Resource, SiteData, ServerSrv) {
    var workingPeriodSrv = {};

    workingPeriodSrv.save = function (workingPeriod, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(workingPeriodSrv.saveSync, workingPeriod, successFunction, errorFunction);
    };
    workingPeriodSrv.saveSync = function (workingPeriod, successFunction, errorFunction) {
        //$timeout (function () {

        var workingPeriodRes = workingPeriod.getObjectResource();
        workingPeriodRes.$save({}, //no params
        function (data) {
            try {
                /** @namespace data.workingPeriodDaysId */
                workingPeriod.setId(data.id);

                if (data.workingPeriodDaysId && data.workingPeriodDaysId.length == workingPeriod.workingPeriodDays.length)
                    //Assume that returned list has the same order
                    for (var i = 0; i < data.workingPeriodDaysId.length; i++) {
                        workingPeriod.workingPeriodDays[i].setId(data.workingPeriodDaysId[i]);
                    } //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    workingPeriodSrv.remove = function (workingPeriod, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(workingPeriodSrv.removeSync, workingPeriod, successFunction, errorFunction);
    };
    workingPeriodSrv.removeSync = function (workingPeriod, successFunction, errorFunction) {
        //$timeout (function () {

        var workingPeriodRes = new WorkingPeriod_Resource();
        workingPeriodRes.$remove({ id: workingPeriod.id }, //no params
        function (data) {
            SiteData.removeWorkingPeriod(workingPeriod);

            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    workingPeriodSrv.updateLocally = function (id, objectToRestore) {
        /*            var day =  DayData.get(objectToRestore.dayId)
                    if (day!=null)
                    {
                        var workingPeriod = day.getWorkingPeriod(objectToRestore.id)
                        workingPeriod.loadObject(objectToRestore);
                        workingPeriod.loadRef();
                    }*/
    };

    return workingPeriodSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodData', [function () {
    var workingPeriodData = {
        indexWorkingPeriods: []
    };
    workingPeriodData.getById = function (workingPeriodId) {
        for (var i = 0; i < this.indexWorkingPeriods.length; i++) {
            if (this.indexWorkingPeriods[i].id == workingPeriodId) return this.indexWorkingPeriods[i];
        }return null;
    };
    workingPeriodData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexWorkingPeriods.length) return this.indexWorkingPeriods[servIndex];else return null;
    };
    workingPeriodData.getIndexOf = function (workingPeriod) {
        if (workingPeriod) return this.indexWorkingPeriods.indexOf(workingPeriod);
        return -1;
    };
    workingPeriodData.add = function (workingPeriod) {
        this.indexWorkingPeriods.push(workingPeriod);
        return this.indexWorkingPeriods.length - 1;
    };
    workingPeriodData.clear = function () {
        workingPeriodData.indexWorkingPeriods = [];
    };
    return workingPeriodData;
}]);

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDay_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/workingPeriodDays/:id', {}, {});
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDay', ["WorkingPeriodDayHr", "WorkingPeriodDayPr", "WorkingPeriodDayData", "WorkingPeriodDay_Resource", function (WorkingPeriodDayHr, WorkingPeriodDayPr, WorkingPeriodDayData, WorkingPeriodDay_Resource) {
    //WorkingPeriodDay inherit of $resource

    var WorkingPeriodDay = function WorkingPeriodDay(resource, workingPeriod, isApplicationLoading) {
        this.id = null;
        this.openDay = false;
        this.workingPeriod = null;
        this.workingPeriodDayHrs = [];
        this.workingPeriodDayPrs = [];

        WorkingPeriodDayData.add(this);

        if (workingPeriod !== undefined && workingPeriod != null) this.workingPeriod = workingPeriod;

        if (resource !== undefined && resource != null) {
            this.loadObject(resource, isApplicationLoading);
        }
    };
    WorkingPeriodDay.prototype.loadObject = function (object, isApplicationLoading) {
        if (!this.id) this.id = object.id;
        this.openDay = object.openDay;
        if (object.workingPeriodDayHrs) for (var i = 0; i < object.workingPeriodDayHrs.length; i++) {
            this.workingPeriodDayHrs.push(new WorkingPeriodDayHr(object.workingPeriodDayHrs[i], this, isApplicationLoading));
        }if (object.workingPeriodDayPrs) for (var i = 0; i < object.workingPeriodDayPrs.length; i++) {
            this.workingPeriodDayPrs.push(new WorkingPeriodDayPr(object.workingPeriodDayPrs[i], this, isApplicationLoading));
        }
    };
    WorkingPeriodDay.prototype.getObjectResource = function (saveChild) {
        var wpDayRes = new WorkingPeriodDay_Resource();
        wpDayRes.id = this.id;
        wpDayRes.openDay = this.openDay;

        if (this.workingPeriod) wpDayRes.workingPeriodId = this.workingPeriod.id;
        if (saveChild !== undefined && saveChild) {
            wpDayRes.workingPeriodDayHrs = [];
            wpDayRes.workingPeriodDayPrs = [];
            if (this.workingPeriodDayHrs) for (var i = 0; i < this.workingPeriodDayHrs.length; i++) {
                wpDayRes.workingPeriodDayHrs.push(this.workingPeriodDayHrs[i].getObjectResource());
            }if (this.workingPeriodDayPrs) for (var i = 0; i < this.workingPeriodDayPrs.length; i++) {
                wpDayRes.workingPeriodDayPrs.push(this.workingPeriodDayPrs[i].getObjectResource());
            }
        }
        return wpDayRes;
    };
    WorkingPeriodDay.prototype.setId = function (id) {
        this.id = id;
    };
    WorkingPeriodDay.prototype.getId = function () {
        return this.id;
    };
    WorkingPeriodDay.prototype.indexOfWorkingPeriodDayHr = function (humanResourceId) {
        for (var i = 0; i < this.workingPeriodDayHrs.length; i++) {
            if (this.workingPeriodDayHrs[i].humanResourceId == humanResourceId) return i;
        }return -1;
    };
    WorkingPeriodDay.prototype.getWorkingPeriodDayHr = function (humanResourceId) {
        var index = this.indexOfWorkingPeriodDayHr(humanResourceId);
        if (index != -1) return this.workingPeriodDayHrs[index];
        return null;
    };
    WorkingPeriodDay.prototype.createAndAddWorkingPeriodDayHr = function (humanResourceId) {
        var wpDayHr = null;
        if (this.indexOfWorkingPeriodDayHr(humanResourceId) == -1) {
            wpDayHr = new WorkingPeriodDayHr(null, this);
            wpDayHr.humanResourceId = humanResourceId;
            this.workingPeriodDayHrs.push(wpDayHr);
        }
        return wpDayHr;
    };

    WorkingPeriodDay.prototype.removeWorkingPeriodDayHr = function (workingPeriodDayHr) {
        var index = this.workingPeriodDayHrs.indexOf(workingPeriodDayHr);
        if (index != -1) {
            this.workingPeriodDayHrs.splice(index, 1);
            //workingPeriodDayHr.workingPeriodDay = null;NOT REMOVE BECAUSE USED BY CANCEL
        }
    };
    WorkingPeriodDay.prototype.removeWorkingPeriodDayHrByHrId = function (humanResourceId) {
        var index = this.indexOfWorkingPeriodDayHr(humanResourceId);
        if (index != -1) {
            this.workingPeriodDayHrs.splice(index, 1);
        }
    };
    WorkingPeriodDay.prototype.indexOfWorkingPeriodDayPr = function (physicalResourceId, prUnitId) {
        for (var i = 0; i < this.workingPeriodDayPrs.length; i++) {
            if (this.workingPeriodDayPrs[i].physicalResourceId == physicalResourceId && this.workingPeriodDayPrs[i].prUnitId == prUnitId) return i;
        }return -1;
    };
    WorkingPeriodDay.prototype.getWorkingPeriodDayPr = function (physicalResourceId, prUnitId) {
        var index = this.indexOfWorkingPeriodDayPr(physicalResourceId, prUnitId);
        if (index != -1) return this.workingPeriodDayPrs[index];
        return null;
    };
    WorkingPeriodDay.prototype.createAndAddWorkingPeriodDayPr = function (physicalResourceId, prUnitId) {
        var wpDayPr = null;
        if (this.indexOfWorkingPeriodDayPr(physicalResourceId, prUnitId) == -1) {
            wpDayPr = new WorkingPeriodDayPr(null, this);
            wpDayPr.physicalResourceId = physicalResourceId;
            wpDayPr.prUnitId = prUnitId;
            this.workingPeriodDayPrs.push(wpDayPr);
        }
        return wpDayPr;
    };

    WorkingPeriodDay.prototype.removeWorkingPeriodDayPr = function (workingPeriodDayPr) {
        var index = this.workingPeriodDayPrs.indexOf(workingPeriodDayPr);
        if (index != -1) {
            this.workingPeriodDayPrs.splice(index, 1);
            //workingPeriodDayPr.workingPeriodDay = null;NOT REMOVE BECAUSE USED BY CANCEL
        }
    };
    WorkingPeriodDay.prototype.removeWorkingPeriodDayPrByPrId = function (humanResourceId) {
        var index = this.indexOfWorkingPeriodDayPr(humanResourceId);
        if (index != -1) {
            this.workingPeriodDayPrs.splice(index, 1);
        }
    };
    return WorkingPeriodDay;
}]);
angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDaySrv', ["$log", "ServerSrv", function ($log, ServerSrv) {
    var workingPeriodDaySrv = {};

    workingPeriodDaySrv.save = function (workingPeriodDay, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(workingPeriodDaySrv.saveSync, workingPeriodDay, successFunction, errorFunction);
    };
    workingPeriodDaySrv.saveSync = function (workingPeriodDay, successFunction, errorFunction) {
        //$timeout (function () {

        var workingPeriodDayRes = workingPeriodDay.getObjectResource();
        workingPeriodDayRes.$save({}, //no params
        function (data) {
            try {
                workingPeriodDay.setId(data.id);

                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    return workingPeriodDaySrv;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayData', [function () {
    var workingPeriodDayData = {
        indexWorkingPeriodDays: []
    };
    workingPeriodDayData.getById = function (workingPeriodDayId) {
        for (var i = 0; i < this.indexWorkingPeriodDays.length; i++) {
            if (this.indexWorkingPeriodDays[i].id == workingPeriodDayId) return this.indexWorkingPeriodDays[i];
        }return null;
    };
    workingPeriodDayData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexWorkingPeriodDays.length) return this.indexWorkingPeriodDays[servIndex];else return null;
    };
    workingPeriodDayData.getIndexOf = function (workingPeriodDay) {
        if (workingPeriodDay) return this.indexWorkingPeriodDays.indexOf(workingPeriodDay);
        return -1;
    };
    workingPeriodDayData.add = function (workingPeriodDay) {
        this.indexWorkingPeriodDays.push(workingPeriodDay);
        return this.indexWorkingPeriodDays.length - 1;
    };
    workingPeriodDayData.clear = function () {
        workingPeriodDayData.indexWorkingPeriodDays = [];
    };
    return workingPeriodDayData;
}]);

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayHr_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/workingPeriodDayHrs/:id', {}, {});
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayHr', ["WorkingPeriodDayHrData", "WorkingPeriodDayHr_Resource", "Activity", "Period", function (WorkingPeriodDayHrData, WorkingPeriodDayHr_Resource, Activity, Period) {
    //WorkingPeriodDay inherit of $resource

    var WorkingPeriodDayHr = function WorkingPeriodDayHr(resource, workingPeriodDay, isApplicationLoading) {
        this.id = null;
        this.workingPeriodDay = null;
        this.humanResourceId = null;
        this.specificPeriod = false;
        this.onLineBooking = true;
        this.period = null; //Period null means no work for resource
        this.activities = [];

        WorkingPeriodDayHrData.add(this);

        if (workingPeriodDay !== undefined) this.workingPeriodDay = workingPeriodDay;
        if (resource !== undefined && resource != null) {
            this.loadObject(resource, isApplicationLoading);
        }
    };
    WorkingPeriodDayHr.prototype.loadObject = function (object, isApplicationLoading) {
        if (!this.id) this.id = object.id;
        this.humanResourceId = object.humanResourceId;
        this.specificPeriod = object.specificPeriod;
        this.onLineBooking = object.onLineBooking;
        var activity;
        if (object.activities) for (var i = 0; i < object.activities.length; i++) {
            activity = new Activity(object.activities[i], null, isApplicationLoading);
            activity.workingPeriodDayHr = this;
            this.activities.push(activity);
        }
        this.setPeriod(object.period);
    };
    WorkingPeriodDayHr.prototype.setPeriod = function (period) {
        if (period) this.period = new Period(period);else this.period = null;
    };
    WorkingPeriodDayHr.prototype.getObjectResource = function () {
        var res = new WorkingPeriodDayHr_Resource();
        res.id = this.id;
        res.humanResourceId = this.humanResourceId;
        res.specificPeriod = this.specificPeriod;
        res.onLineBooking = this.onLineBooking;
        if (this.workingPeriodDay) res.workingPeriodDayId = this.workingPeriodDay.id;
        res.activities = [];
        if (this.activities) for (var i = 0; i < this.activities.length; i++) {
            res.activities.push(this.activities[i].getObjectResource());
        }if (this.period) {
            res.period = this.period.getObjectResource();
        }

        return res;
    };
    WorkingPeriodDayHr.prototype.setId = function (id) {
        this.id = id;
    };
    WorkingPeriodDayHr.prototype.getId = function () {
        return this.id;
    };
    WorkingPeriodDayHr.prototype.addActivity = function (activity) {
        if (activity) {
            this.activities.push(activity);
            activity.workingPeriodDayHr = this;
        }
    };
    WorkingPeriodDayHr.prototype.removeActivity = function (activity) {
        if (activity) {
            var index = this.activities.indexOf(activity);
            if (index != -1) this.activities.splice(index, 1);
        }
    };
    WorkingPeriodDayHr.prototype.getActivityById = function (id) {
        for (var i = 0; i < this.activities.length; i++) {
            if (this.activities[i].id == id) return this.activities[i];
        }return null;
    };

    return WorkingPeriodDayHr;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayHrSrv', ["$log", "WorkingPeriodDayHr_Resource", "UserActionData", "WorkingPeriodDayHrData", "ServerSrv", function ($log, WorkingPeriodDayHr_Resource, UserActionData, WorkingPeriodDayHrData, ServerSrv) {
    var workingPeriodDayHrSrv = {};

    workingPeriodDayHrSrv.save = function (workingPeriodDayHr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(workingPeriodDayHrSrv.saveSync, workingPeriodDayHr, successFunction, errorFunction);
    };

    workingPeriodDayHrSrv.saveSync = function (workingPeriodDayHr, successFunction, errorFunction) {
        var workingPeriodDayHrRes = workingPeriodDayHr.getObjectResource();
        workingPeriodDayHrRes.$save({}, //no params
        function (data) {
            try {
                workingPeriodDayHr.setId(data.id);
                UserActionData.add(data.userAction);
                if (data.activitiesId && data.activitiesId.length == workingPeriodDayHr.activities.length)
                    //Assume that returned list has the same order
                    for (var i = 0; i < data.activitiesId.length; i++) {
                        workingPeriodDayHr.activities[i].setId(data.activitiesId[i]);
                    }if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    workingPeriodDayHrSrv.remove = function (workingPeriodDayHr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(workingPeriodDayHrSrv.removeSync, workingPeriodDayHr, successFunction, errorFunction);
    };
    workingPeriodDayHrSrv.removeSync = function (workingPeriodDayHr, successFunction, errorFunction) {
        var workingPeriodDayHrRes = new WorkingPeriodDayHr_Resource();
        workingPeriodDayHrRes.$remove({ id: workingPeriodDayHr.id }, //no params
        function (data) {
            try {
                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    workingPeriodDayHrSrv.updateLocally = function (id, objectToRestore) {
        var wpDayHr = WorkingPeriodDayHrData.getById(id);
        if (wpDayHr != null) {
            wpDayHr.loadObject(objectToRestore);
        }
        return wpDayHr;
    };
    workingPeriodDayHrSrv.removeLocally = function (id, object) {
        var wpDayHr = WorkingPeriodDayHrData.getById(id);
        if (wpDayHr != null) {
            wpDayHr.workingPeriodDay.removeWorkingPeriodDayHr(wpDayHr);
        }
        return wpDayHr;
    };
    workingPeriodDayHrSrv.addLocally = function (id, objectToRestore) {
        var wpDayHr = WorkingPeriodDayHrData.getById(id);
        if (wpDayHr != null) {
            wpDayHr.loadObject(objectToRestore);
            WorkingPeriodDayHrData.add(wpDayHr);
        }
        return wpDayHr;
    };

    return workingPeriodDayHrSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayHrData', [function () {
    var workingPeriodDayHrData = {
        indexWorkingPeriodDayHrs: []
    };
    workingPeriodDayHrData.getById = function (workingPeriodDayHrId) {
        for (var i = 0; i < this.indexWorkingPeriodDayHrs.length; i++) {
            if (this.indexWorkingPeriodDayHrs[i].id == workingPeriodDayHrId) return this.indexWorkingPeriodDayHrs[i];
        }return null;
    };
    workingPeriodDayHrData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexWorkingPeriodDayHrs.length) return this.indexWorkingPeriodDayHrs[servIndex];else return null;
    };
    workingPeriodDayHrData.getIndexOf = function (workingPeriodDayHr) {
        if (workingPeriodDayHr) return this.indexWorkingPeriodDayHrs.indexOf(workingPeriodDayHr);
        return -1;
    };
    workingPeriodDayHrData.add = function (workingPeriodDayHr) {
        this.indexWorkingPeriodDayHrs.push(workingPeriodDayHr);
        return this.indexWorkingPeriodDayHrs.length - 1;
    };
    workingPeriodDayHrData.clear = function () {
        workingPeriodDayHrData.indexWorkingPeriodDayHrs = [];
    };
    return workingPeriodDayHrData;
}]);

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayPr_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/workingPeriodDayPrs/:id', {}, {});
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayPr', ["WorkingPeriodDayPrData", "WorkingPeriodDayPr_Resource", "Activity", "Period", function (WorkingPeriodDayPrData, WorkingPeriodDayPr_Resource, Activity, Period) {
    //WorkingPeriodDay inherit of $resource

    var WorkingPeriodDayPr = function WorkingPeriodDayPr(resource, workingPeriodDay, isApplicationLoading) {
        this.id = null;
        this.prUnitId = null;
        this.workingPeriodDay = null;
        this.physicalResourceId = null;
        this.specificPeriod = false;
        this.onLineBooking = true;
        this.period = null; //Period null means no work for resource
        this.activities = [];

        WorkingPeriodDayPrData.add(this);

        if (workingPeriodDay !== undefined) this.workingPeriodDay = workingPeriodDay;
        if (resource !== undefined && resource != null) {
            this.loadObject(resource, isApplicationLoading);
        }
    };
    WorkingPeriodDayPr.prototype.loadObject = function (object, isApplicationLoading) {
        if (!this.id) {
            this.id = object.id;
        }
        this.prUnitId = object.prUnitId;
        this.physicalResourceId = object.physicalResourceId;
        this.specificPeriod = object.specificPeriod;
        this.onLineBooking = object.onLineBooking;
        var activity = void 0;
        if (object.activities) for (var i = 0; i < object.activities.length; i++) {
            activity = new Activity(object.activities[i], null, isApplicationLoading);
            activity.workingPeriodDayPr = this;
            this.activities.push(activity);
        }
        this.setPeriod(object.period);
    };
    WorkingPeriodDayPr.prototype.setPeriod = function (period) {
        if (period) {
            this.period = new Period(period);
        } else {
            this.period = null;
        }
    };
    WorkingPeriodDayPr.prototype.getObjectResource = function () {
        var res = new WorkingPeriodDayPr_Resource();
        res.id = this.id;
        res.prUnitId = this.prUnitId;
        res.physicalResourceId = this.physicalResourceId;
        res.specificPeriod = this.specificPeriod;
        res.onLineBooking = this.onLineBooking;
        if (this.workingPeriodDay) res.workingPeriodDayId = this.workingPeriodDay.id;
        res.activities = [];
        if (this.activities) {
            for (var i = 0; i < this.activities.length; i++) {
                res.activities.push(this.activities[i].getObjectResource());
            }
        }
        if (this.period) {
            res.period = this.period.getObjectResource();
        }

        return res;
    };
    WorkingPeriodDayPr.prototype.setId = function (id) {
        this.id = id;
    };
    WorkingPeriodDayPr.prototype.getId = function () {
        return this.id;
    };
    WorkingPeriodDayPr.prototype.addActivity = function (activity) {
        if (activity) {
            this.activities.push(activity);
            activity.workingPeriodDayPr = this;
        }
    };
    WorkingPeriodDayPr.prototype.removeActivity = function (activity) {
        if (activity) {
            var index = this.activities.indexOf(activity);
            if (index !== -1) this.activities.splice(index, 1);
        }
    };
    WorkingPeriodDayPr.prototype.getActivityById = function (id) {
        for (var i = 0; i < this.activities.length; i++) {
            if (this.activities[i].id === id) {
                return this.activities[i];
            }
        }
        return null;
    };

    return WorkingPeriodDayPr;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayPrSrv', ["$log", "WorkingPeriodDayPr_Resource", "UserActionData", "WorkingPeriodDayPrData", "ServerSrv", function ($log, WorkingPeriodDayPr_Resource, UserActionData, WorkingPeriodDayPrData, ServerSrv) {
    var workingPeriodDayPrSrv = {};

    workingPeriodDayPrSrv.save = function (workingPeriodDayPr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(workingPeriodDayPrSrv.saveSync, workingPeriodDayPr, successFunction, errorFunction);
    };
    workingPeriodDayPrSrv.saveSync = function (workingPeriodDayPr, successFunction, errorFunction) {

        var workingPeriodDayPrRes = workingPeriodDayPr.getObjectResource();
        workingPeriodDayPrRes.$save({}, //no params
        function (data) {
            try {
                workingPeriodDayPr.setId(data.id);
                UserActionData.add(data.userAction);
                if (data.activitiesId && data.activitiesId.length === workingPeriodDayPr.activities.length)
                    //Assume that returned list has the same order
                    for (var i = 0; i < data.activitiesId.length; i++) {
                        workingPeriodDayPr.activities[i].setId(data.activitiesId[i]);
                    } //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    workingPeriodDayPrSrv.remove = function (workingPeriodDayPr, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(workingPeriodDayPrSrv.removeSync, workingPeriodDayPr, successFunction, errorFunction);
    };
    workingPeriodDayPrSrv.removeSync = function (workingPeriodDayPr, successFunction, errorFunction) {
        //$timeout (function () {

        var workingPeriodDayPrRes = new WorkingPeriodDayPr_Resource();
        workingPeriodDayPrRes.$remove({ id: workingPeriodDayPr.id }, //no params
        function (data) {
            try {
                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    workingPeriodDayPrSrv.updateLocally = function (id, objectToRestore) {
        var wpDayPr = WorkingPeriodDayPrData.getById(id);
        if (wpDayPr != null) {
            wpDayPr.loadObject(objectToRestore);
        }
        return wpDayPr;
    };
    workingPeriodDayPrSrv.removeLocally = function (id, object) {
        var wpDayPr = WorkingPeriodDayPrData.getById(id);
        if (wpDayPr != null) {
            wpDayPr.workingPeriodDay.removeWorkingPeriodDayHr(wpDayPr);
        }
        return wpDayPr;
    };
    workingPeriodDayPrSrv.addLocally = function (id, objectToRestore) {
        var wpDayPr = WorkingPeriodDayPrData.getById(id);
        if (wpDayPr != null) {
            wpDayPr.loadObject(objectToRestore);
            WorkingPeriodDayPrData.add(wpDayPr);
        }
        return wpDayPr;
    };

    return workingPeriodDayPrSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('WorkingPeriodDayPrData', [function () {
    var workingPeriodDayPrData = {
        indexWorkingPeriodDayPrs: []
    };
    workingPeriodDayPrData.getById = function (workingPeriodDayPrId) {
        for (var i = 0; i < this.indexWorkingPeriodDayPrs.length; i++) {
            if (this.indexWorkingPeriodDayPrs[i].id == workingPeriodDayPrId) return this.indexWorkingPeriodDayPrs[i];
        }return null;
    };
    workingPeriodDayPrData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexWorkingPeriodDayPrs.length) return this.indexWorkingPeriodDayPrs[servIndex];else return null;
    };
    workingPeriodDayPrData.getIndexOf = function (workingPeriodDayPr) {
        if (workingPeriodDayPr) return this.indexWorkingPeriodDayPrs.indexOf(workingPeriodDayPr);
        return -1;
    };
    workingPeriodDayPrData.add = function (workingPeriodDayPr) {
        this.indexWorkingPeriodDayPrs.push(workingPeriodDayPr);
        return this.indexWorkingPeriodDayPrs.length - 1;
    };
    workingPeriodDayPrData.clear = function () {
        workingPeriodDayPrData.indexWorkingPeriodDayPrs = [];
    };
    return workingPeriodDayPrData;
}]);

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('Image_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/images/:key', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Image', ["Image_Resource", function (Image_Resource) {

    var Image = function Image(resource) {
        this.id = null;
        this.fileName = null;
        this.type = null;
        this.label = null;
        this.keyWords = null;
        this.urlHD = null;
        this.url = null;
        this.urlPreview = null;
        this.size = null;
        this.hasHD = false;
        this.status = false;
        if (resource !== undefined && resource != null) {
            this.id = resource.id;
            this.fileName = resource.fileName;
            this.type = resource.type;
            this.label = resource.label;
            this.keyWords = resource.keyWords;
            this.status = resource.status;
            if (resource.url) this.url = resource.url.replace("http:", "");
            if (resource.urlHD) {
                this.urlHD = resource.urlHD.replace("http:", "");
                this.hasHD = true;
            } else this.urlHD = this.url;
            if (resource.urlPreview) this.urlPreview = resource.urlPreview.replace("http:", "");
            this.size = resource.size;
        }
    };

    Image.prototype.setId = function (id) {
        this.id = id;
    };

    Image.prototype.getObjectResource = function () {
        var rsImage = new Image_Resource();
        rsImage.id = this.id;
        rsImage.fileName = this.fileName;
        rsImage.type = this.type;
        rsImage.label = this.label;
        rsImage.keyWords = this.keyWords;
        rsImage.status = this.status;

        return rsImage;
    };
    return Image;
}]);
angular.module('FlexyBeautyApp.services').factory('ImageSrv', ["Image_Resource", "Image", "ImageData", "$log", "ServerSrv", function (Image_Resource, Image, ImageData, $log, ServerSrv) {
    var imageSrv = {};

    imageSrv.query = function (successFunction, errorFunction) {
        Image_Resource.query({}, //params
        function (data) {
            //success
            ImageData.clear();
            for (var i = 0; i < data.length; i++) {
                ImageData.add(new Image(data[i]));
            }if (successFunction !== undefined) successFunction(ImageData.images.sort(function (image1, image2) {
                return image1.label - image2.label;
            }));
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    imageSrv.save = function (image, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(imageSrv.saveSync, image, successFunction, errorFunction);
    };

    imageSrv.saveSync = function (image, successFunction, errorFunction) {
        var ImageRes = image.getObjectResource();
        ImageRes.$save({}, function (data) {
            try {
                image.setId(data.id);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    return imageSrv;
}]);
angular.module('FlexyBeautyApp.services').factory('ImageData', function () {
    var imageData = { images: [] };
    imageData.getById = function (imageId) {
        for (var i = 0; i < this.images.length; i++) {
            if (this.images[i].id == imageId) return this.images[i];
        }return null;
    };
    imageData.add = function (image) {
        this.images.push(image);
    };
    imageData.remove = function (image) {
        var index = this.images.indexOf(image);
        if (index != -1) this.images.splice(index, 1);
    };
    imageData.clear = function () {
        this.images = [];
    };
    imageData.getActiveList = function (type) {
        if (type === undefined) return this.images;
        var images = [];
        for (var i = 0; i < this.images.length; i++) {
            if (this.images[i].type == type || this.images[i].type == null && type == "") images.push(this.images[i]);
        }return images.sort(function (image1, image2) {
            return image1.label - image2.label;
        });
    };

    imageData.getFilteredImages = function () {
        var imagesF = [];
        if (this.getActiveList("")) {
            for (var i = 0; i < this.getActiveList("").length; i++) {
                if (this.getActiveList("")[i].status != 'NotActivated') {
                    imagesF.push(this.getActiveList("")[i]);
                }
            }
        }
        return imagesF;
    };
    return imageData;
});

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 26/01/2014
 * Time: 09:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Period', ["Time", function (Time) {

    var Period = function Period(period) {
        this.start = new Time();
        this.end = new Time();
        this.duration = 0;

        if (period != undefined && period) {
            this.start.hour = period.start.hour;
            this.start.minute = period.start.minute;
            this.end.hour = period.end.hour;
            this.end.minute = period.end.minute;
            this.updateDuration();
        }
        this.start.updateLabel();
        this.start.updateDateTime();
        this.end.updateLabel();
        this.end.updateDateTime();
    };

    Period.prototype.getObjectResource = function () {
        var periodRes = {
            start: this.start.getObjectResource(),
            end: this.end.getObjectResource()
        };
        return periodRes;
    };

    Period.prototype.equals = function (period) {
        if (!period) return false;
        return period.start.hour === this.start.hour && period.start.minute === this.start.minute && period.end.hour === this.end.hour && period.end.minute === this.end.minute;
    };

    Period.prototype.adjustEnd = function () {
        var endTime = this.start.getTime() + this.duration; //Get end time
        this.end.hour = Math.floor(endTime / 60); //Transform end time to hoor
        this.end.minute = endTime % 60;
        this.end.updateLabel();
        this.end.updateDateTime();
    };

    Period.prototype.setDuration = function (duration) {
        this.end.setTime(this.start.getTime() + duration);
        this.duration = duration;
        this.end.updateLabel();
        this.end.updateDateTime();
    };

    Period.prototype.moveToStart = function (start) {
        if (start && this.start) {
            this.start.hour = start.hour;
            this.start.minute = start.minute;
            this.start.updateLabel();
            this.start.updateDateTime();
            this.adjustEnd();
        }
    };

    Period.prototype.setStart = function (start) {
        if (start && this.start) {
            this.start.hour = start.hour;
            this.start.minute = start.minute;
            this.start.updateLabel();
            this.start.updateDateTime();
            this.updateDuration();
        }
    };

    Period.prototype.setEnd = function (end) {
        if (end && this.end) {
            this.end.hour = end.hour;
            this.end.minute = end.minute;
            this.end.updateLabel();
            this.end.updateDateTime();
            this.updateDuration();
        }
    };

    Period.prototype.setStartHour = function (hour, updateEnd) {
        if (this.start) {
            this.start.hour = hour;
            this.start.updateLabel();
            this.start.updateDateTime();
            if (updateEnd) this.adjustEnd();else this.updateDuration();
        }
    };

    Period.prototype.setStartMinute = function (minute, updateEnd) {
        if (this.start) {
            this.start.minute = minute;
            this.start.updateLabel();
            this.start.updateDateTime();
            if (updateEnd) this.adjustEnd();else this.updateDuration();
        }
    };

    Period.prototype.setEndHour = function (hour) {
        if (this.end) {
            this.end.hour = hour;
            this.end.updateLabel();
            this.end.updateDateTime();
            this.updateDuration();
        }
    };

    Period.prototype.setEndMinute = function (minute) {
        if (this.end) {
            this.end.minute = minute;
            this.end.updateLabel();
            this.end.updateDateTime();
            this.updateDuration();
        }
    };

    Period.prototype.addTime = function (time) {
        this.start.setTime(this.start.getTime() + time);
        this.end.setTime(this.end.getTime() + time);
    };

    Period.prototype.removeTime = function (time) {
        this.start.setTime(this.start.getTime() - time);
        this.end.setTime(this.end.getTime() - time);
    };

    Period.prototype.updateDuration = function () {
        this.duration = this.end.getTime() - this.start.getTime();
    };

    Period.prototype.intersect = function (period) {
        if (!period) return false;
        return period.start.getTime() < this.end.getTime() && period.end.getTime() > this.start.getTime();
    };

    Period.prototype.intersectTime = function (period) {
        if (period && period.start.getTime() < this.end.getTime() && period.end.getTime() > this.start.getTime()) return Math.min(period.end.getTime() - this.start.getTime(), this.end.getTime() - period.start.getTime());
        return 0;
    };

    Period.prototype.contains = function (period) {
        return this.start.getTime() <= period.start.getTime() && this.end.getTime() >= period.end.getTime();
    };

    Period.prototype.equals = function (period) {
        return period != null && this.start != null && this.end != null && this.start.equals(period.start) && this.end.equals(period.end);
    };

    Period.prototype.compare = function (period1, period2) {
        var comparisonValue = void 0;
        if (period1 && period2) {
            comparisonValue = Time.prototype.compare(period1.start, period2.start);
        } else if (period1) {
            comparisonValue = -1;
        } else if (period2) {
            comparisonValue = 1;
        } else {
            comparisonValue = 0;
        }
        return comparisonValue;
    };
    return Period;
}]);

angular.module('FlexyBeautyApp.services').factory('Time', ["moment", function (moment) {

    var Time = function Time() {
        this.hour = 0;
        this.minute = 0;
        this.label = "0h00";

        var momentDate = new moment();
        momentDate.hour(this.hour);
        momentDate.minute(this.minute);
        this.dateTime = momentDate.toDate();
    };
    Time.prototype.getObjectResource = function () {
        return {
            hour: this.hour,
            minute: this.minute
        };
    };
    Time.prototype.getTime = function () {
        return this.hour * 60 + this.minute;
    };
    Time.prototype.getTimeInMilli = function () {
        return (this.hour * 60 + this.minute) * 60 * 1000;
    };

    Time.prototype.setTime = function (time) {
        this.hour = Math.floor(time / 60); //Transform end time to hoor
        this.minute = time % 60;

        this.updateDateTime();
        this.updateLabel();
    };
    Time.prototype.setTimeByHm = function (h, m) {
        this.hour = h;
        this.minute = m;
        this.updateLabel();
        this.updateDateTime();
    };
    Time.prototype.equals = function (time) {
        if (!time) return false;
        return time.hour === this.hour && time.minute === this.minute;
    };
    Time.prototype.updateLabel = function () {
        this.label = this.getLabel();
    };
    Time.prototype.updateDateTime = function () {
        var momentDate = new moment();
        momentDate.hour(this.hour);
        momentDate.minute(this.minute);

        this.dateTime = momentDate.toDate();
    };
    Time.prototype.getLabel = function () {
        var timeMoment = new moment().hour(this.hour).minute(this.minute);
        return timeMoment.format("LT");
    };

    Time.prototype.updateHourMinuteFromDate = function () {
        if (this.dateTime && this.dateTime.getHours() != null && this.dateTime.getMinutes() != null) {
            this.hour = new moment(this.dateTime).hour();
            this.minute = new moment(this.dateTime).minute();
        }
    };

    Time.prototype.equals = function (time) {
        return time != null && this.hour === time.hour && this.minute === time.minute;
    };

    Time.prototype.compare = function (time1, time2) {
        var comparisonValue = void 0;
        var isValidForComparison = function isValidForComparison(time) {
            return time && !isNaN(time.getTimeInMilli());
        };

        if (isValidForComparison(time1) && isValidForComparison(time2)) {
            comparisonValue = time1.getTimeInMilli() - time2.getTimeInMilli();
        } else if (isValidForComparison(time1) && !isValidForComparison(time2)) {
            comparisonValue = -1;
        } else if (!isValidForComparison(time1) && isValidForComparison(time2)) {
            comparisonValue = 1;
        } else {
            comparisonValue = 0;
        }

        return comparisonValue;
    };

    return Time;
}]);

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* Created with JetBrains WebStorm.
* User: sebastienbeaujard
* Date: 16/01/2018
* Time: 18h01
* To change this template use File | Settings | File Templates.
*/

angular.module('FlexyBeautyApp.services').factory('CurrencyView', ["$filter", "CurrencyData", "CurrencySrv", function ($filter, CurrencyData, CurrencySrv) {

    var CurrencyView = function CurrencyView(currency, cIndex) {
        this.cIndex = cIndex;
        this.isDeleted = false;
        this.id = null;
        this.name = null;
        this.code = false;
        this.symbol = null;
        this.codeMango = null;
        this.symbol = null;
        this.typeBankAccount = null;

        this.loadDataFrom(currency);
    };
    CurrencyView.prototype.getModel = function () {
        if (this.cIndex != -1) return CurrencyData.getByIndex(this.cIndex);
        return null;
    };
    CurrencyView.prototype.loadDataFrom = function (currency) {
        if (currency !== undefined && currency) {
            this.id = currency.id;
            this.name = currency.name;
            this.code = currency.code;
            this.symbol = currency.symbol;
            this.codeMango = currency.codeMango;
            this.typeBankAccount = currency.typeBankAccount;
        }
    };
    CurrencyView.prototype.copyDataTo = function (currency) //
    {
        currency.name = this.name;
        currency.code = this.code;
        currency.symbol = this.symbol;
        currency.codeMango = this.codeMango;
        currency.typeBankAccount = this.typeBankAccount;
    };

    CurrencyView.prototype.removeModel = function () {
        var currency = this.getModel();
        if (currency != null) CurrencySrv.remove(currency);
    };
    CurrencyView.prototype.reloadModel = function () {
        var currency = this.getModel();
        if (currency != null) this.loadDataFrom(currency);
    };
    CurrencyView.prototype.updateModel = function (save, endFunction) {
        //Save by default
        var currency = this.getModel();
        if (!currency) //create it
            {
                currency = new Currency();
                this.cIndex = CurrencyData.getIndexOf(currency);
            }

        this.copyDataTo(currency);
        if (save === undefined || save) //Save by default
            CurrencySrv.save(currency, endFunction);
    };
    CurrencyView.prototype.restoreModel = function () {
        var currency = this.getModel();
        if (currency) CurrencySrv.restore(currency);
    };
    CurrencyView.prototype.canSave = function () {
        return true;
    };

    return CurrencyView;
}]);

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 17/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('TypeOfSale', ['gettextCatalog', function (gettextCatalog) {

    var prestations = gettextCatalog.getString("Prestations"),
        produits = gettextCatalog.getString("Produits"),
        cures = gettextCatalog.getString("Cures"),
        loyalties = gettextCatalog.getString("Cartes de fidélité"),
        transformedBooking = gettextCatalog.getString("Réservation transformée"),
        unTransformedBooking = gettextCatalog.getString("Réservation non transformée"),
        all = gettextCatalog.getString("Tous");

    var typeOfSale = {
        SERVICE: { id: 'SERVICE', label: prestations },
        PRODUCT: { id: 'PRODUCT', label: produits },
        CURE: { id: 'CURE', label: cures },
        LOYALTY: { id: 'LOYALTY', label: loyalties },
        SERVICE_AND_PRODUCT: { id: 'SERVICE_AND_PRODUCT', label: transformedBooking },
        SERVICE_WITHOUT_PRODUCT: { id: 'SERVICE_WITHOUT_PRODUCT', label: unTransformedBooking }
    };
    typeOfSale.ALL = {
        id: 'ALL',
        label: all,
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return [typeOfSale.SERVICE, typeOfSale.PRODUCT, typeOfSale.CURE, typeOfSale.LOYALTY];
        }
    };
    typeOfSale.ALL_WITH_PRODUCT_OR_NOT = {
        id: 'ALL_WITH_PRODUCT_OR_NOT',
        label: all,
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return [typeOfSale.SERVICE_AND_PRODUCT /*, typeOfSale.SERVICE_WITHOUT_PRODUCT*/];
        }
    };
    typeOfSale.values = function () {
        return [this.SERVICE, this.PRODUCT, this.CURE, this.LOYALTY];
    };

    return typeOfSale;
}]).factory('TypeOfGraph', ["$filter", 'gettextCatalog', function ($filter, gettextCatalog) {
    var tableau = gettextCatalog.getString("Tableau"),
        circulaire = gettextCatalog.getString("Diagramme circulaire"),
        colonne = gettextCatalog.getString("Diagramme en colonne"),
        colonnesempilees = gettextCatalog.getString("Diagramme en colonnes empilées"),
        batons = gettextCatalog.getString("Diagramme en batons"),
        batonsEmpiles = gettextCatalog.getString("Diagramme en batons empilés");
    var representations = {
        TABLE: { id: 'table', label: tableau, icon: 'fa-table' },
        PIECHART: { id: 'pie-chart', label: circulaire, icon: 'fa-pie-chart' },
        COLUMNCHART: { id: 'column-chart', label: colonne, icon: 'fa-bar-chart' },
        STACKEDCOLUMNCHART: { id: 'stacked-column-chart', label: colonnesempilees, icon: 'fa-bar-chart' },
        BARCHART: { id: 'bar-chart', label: batons, icon: 'fa-bar-chart' },
        STACKEDBARCHART: { id: 'stacked-bar-chart', label: batonsEmpiles, icon: 'fa-bar-chart' }
    };
    representations.getAll = function () {
        return [this.TABLE, this.PIECHART, this.COLUMNCHART, this.STACKEDCOLUMNCHART, this.BARCHART, this.STACKEDBARCHART];
    };
    representations.getStacked = function () {
        return [this.TABLE, this.STACKEDCOLUMNCHART, this.STACKEDBARCHART];
    };
    representations.getTypeGraphById = function (id) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.id === id;
        })[0];
    };
    return representations;
}]).factory('EltReportType', ["$filter", function ($filter) {
    var eltReportType = {
        TOTALISE: { id: 'TOTALISE' },
        COMPARE: { id: 'COMPARE' },
        ZOOM: { id: 'ZOOM' }
    };
    eltReportType.getAll = function () {
        return [this.TOTALISE, this.COMPARE, this.ZOOM];
    };
    eltReportType.getEltReportTypeById = function (id) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.id === id;
        })[0];
    };
    return eltReportType;
}]).factory('ReportTotalAgregateFunctionType', [function () {
    var reportTotalAgregateFunctionType = {
        SUM_CATEGORIES: { id: 'SUM_CATEGORIES' },
        AVERAGE_CATEGORIES: { id: 'AVERAGE_CATEGORIES' },
        NO_AGREGATION: { id: 'NO_AGREGATION' }
    };

    return reportTotalAgregateFunctionType;
}]).factory('ReportTemporalAgregateFunctionType', [function () {
    var reportTemporalAgregateFunctionType = {
        DAILY_SUM: { id: 'DAILY_SUM' },
        DAILY_AVERAGE: { id: 'DAILY_AVERAGE' }
    };

    return reportTemporalAgregateFunctionType;
}]).factory('DataType', [function () {
    var dataType = {
        NB: { id: 'NB' },
        VALUE: { id: 'VALUE' }
    };
    return dataType;
}]).factory('ColorGraph', [function () {
    var colorGraph = {
        colors: ['#bfe9ff', '#e5d1ff', '#b4ffc7', '#f6f460', '#ffe0f0', '#ffd6a6', '#ffcac7', '#ddd3ff', '#7cd9ff', '#c5ff6c']
    };
    return colorGraph;
}]).factory('PrimaryDatasType', ["SaleService", "Sale", "SaleProduct", "SaleCure", "LoyaltyCardItem", "Booking", "GiftItem", "Customer", "BookingService", "HrOccupationDatas", function (SaleService, Sale, SaleProduct, SaleCure, LoyaltyCardItem, Booking, GiftItem, Customer, BookingService, HrOccupationDatas) {
    var primaryDatasType = {
        SALESERVICE: { id: 'SALESERVICE', fileLabel: 'ventes-prestatiions' },
        SALEPRODUCT: { id: 'SALEPRODUCT', fileLabel: 'ventes-produits' },
        SALECURE: { id: 'SALECURE', fileLabel: 'ventes-cures' },
        LOYALTYCARDITEM: { id: 'LOYALTYCARDITEM', fileLabel: 'ventes-cartes-fidelite' },
        SALE: { id: 'SALE', fileLabel: 'ventes' },
        BOOKING: { id: 'BOOKING', fileLabel: 'reservations' },
        GIFTITEM: { id: 'GIFTITEM', fileLabel: 'cheques-cadeaux' },
        CUSTOMER: { id: 'CUSTOMER', fileLabel: 'clients' },
        BOOKINGSERVICE: { id: 'BOOKINGSERVICE', fileLabel: 'reservations-prestations' },
        HROCCUPATIONDATAS: { id: 'HROCCUPATIONDATAS', fileLabel: 'occupation-personnel' },
        VISITE: { id: 'VISITE', fieldLabel: 'visites' }
    };
    primaryDatasType.getType = function (objectModel) {
        if (!objectModel) return null;

        if (objectModel instanceof SaleService) {
            return this.SALESERVICE;
        } else if (objectModel instanceof SaleProduct) {
            return this.SALEPRODUCT;
        } else if (objectModel instanceof SaleCure) {
            return this.SALECURE;
        } else if (objectModel instanceof LoyaltyCardItem) {
            return this.LOYALTYCARDITEM;
        } else if (objectModel instanceof Sale) {
            return this.SALE;
        } else if (objectModel instanceof Booking) {
            return this.BOOKING;
        } else if (objectModel instanceof GiftItem) {
            return this.GIFTITEM;
        } else if (objectModel instanceof Customer) {
            return this.CUSTOMER;
        } else if (objectModel instanceof BookingService) {
            return this.BOOKINGSERVICE;
        } else if (objectModel instanceof HrOccupationDatas) {
            return this.HROCCUPATIONDATAS;
        } else if (objectModel && objectModel.dataType && objectModel.dataType == "VISITE") {
            return this.VISITE;
        }
    };

    return primaryDatasType;
}]).factory('RootStatCategorie', ["CategoryData", "ProductCategoryData", "CureCategoryData", "LoyaltyCardCategoryData", function (CategoryData, ProductCategoryData, CureCategoryData, LoyaltyCardCategoryData) {
    var rootStatCategorie = function rootStatCategorie() {
        this.id = "superCategory", this.label = "superCategory", this.getSubStatCategories = function (rootCategory) {
            return [CategoryData.categoryRoot, ProductCategoryData.categoryRoot, CureCategoryData.categoryRoot, LoyaltyCardCategoryData.categoryRoot];
        };
    };
    return new rootStatCategorie();
}]).factory('ProductStatCategorie', ["gettextCatalog", "ProductCategoryData", function (gettextCatalog, ProductCategoryData) {
    var productStatCategorie = {
        ALL: {
            id: 'PRODUCTS',
            label: "PRODUCTS",
            getSubStatCategories: function getSubStatCategories(rootCategory) {
                return [ProductCategoryData.categoryRoot];
            }
        }
    };

    return productStatCategorie;
}]).factory('HrRootOccupationRateCategory', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "HrRootOccupationRateCategory",
        label: "HrRootOccupationRateCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory, periodDays) {
            var humanResourceList = HumanResourceData.getActiveList(),
                humanResourceFinalList = humanResourceList;

            if (periodDays) {
                humanResourceFinalList = new Array();
                for (var i = 0; i < humanResourceList.length; i++) {
                    if (humanResourceList[i].statFilter(periodDays)) {
                        humanResourceFinalList.push(humanResourceList[i]);
                    }
                }
            }
            return humanResourceFinalList;
        }
    };
    return rootStatCategorie;
}]).factory('PrRootOccupationRateCategory', ['PhysicalResourceData', function (PhysicalResourceData) {
    var rootStatCategorie = {
        id: "PrRootOccupationRateCategory",
        label: "PrRootOccupationRateCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return PhysicalResourceData.getActiveList();
        }
    };
    return rootStatCategorie;
}]).factory('PeriodType', ["$filter", "gettextCatalog", function ($filter, gettextCatalog) {
    var dayly = gettextCatalog.getString("Période quotidienne"),
        weekly = gettextCatalog.getString("Période hebdomadaire"),
        monthly = gettextCatalog.getString("Période mensuelle"),
        yearly = gettextCatalog.getString("Période annuelle"),
        defined = gettextCatalog.getString("Période définie");

    var periodType = {
        DAY: { id: 'DAY', label: 'jour', selecLabel: dayly },
        WEEK: { id: 'WEEK', label: 'semaine', selecLabel: weekly },
        MONTH: { id: 'MONTH', label: 'mois', selecLabel: monthly },
        YEAR: { id: 'YEAR', label: 'annuel', selecLabel: yearly },
        CUSTOMED: { id: 'CUSTOMED', label: 'customed', selecLabel: defined }
    };
    periodType.getAll = function () {
        var tabPeriodType = new Array();
        for (var i in periodType) {
            if (periodType.hasOwnProperty(i)) {
                tabPeriodType.push(periodType[i]);
            }
        }
        return tabPeriodType;
    };
    periodType.getPeriodTypeByLabel = function (label) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.label === label;
        })[0];
    };

    periodType.getLastDayOfPeriod = function (periodTypeObject, beginDayOfPeriod, nbDay) {
        var currentMomentDay = beginDayOfPeriod.clone(),
            endMomentDay = null;

        if (periodTypeObject === this.DAY) {
            endMomentDay = currentMomentDay.clone().add(1, 'day');
        } else if (periodTypeObject === this.WEEK) {
            endMomentDay = currentMomentDay.clone().add(1, 'week');
        } else if (periodTypeObject === this.MONTH) {
            endMomentDay = currentMomentDay.clone().add(1, 'month');
        } else if (periodTypeObject === this.YEAR) {
            endMomentDay = currentMomentDay.clone().add(1, 'year');
        } else if (periodTypeObject === this.CUSTOMED) {
            endMomentDay = currentMomentDay.clone().add(nbDay, 'day');
        }
        endMomentDay.add(-1, 'day');

        return endMomentDay;
    };

    return periodType;
}]).factory('SchedulerType', ["$filter", "gettextCatalog", function ($filter, gettextCatalog) {
    var single = gettextCatalog.getString("Manuel"),
        dayly = gettextCatalog.getString("Journalier"),
        weekly = gettextCatalog.getString("Hebdomadaire"),
        monthly = gettextCatalog.getString("Mensuel"),
        yearly = gettextCatalog.getString("Annuel");

    var schedulerType = {
        SINGLE: { id: 'single', label: single },
        DAILY: { id: 'daily', label: dayly },
        WEEKLY: { id: 'weekly', label: weekly },
        MONTHLY: { id: 'monthly', label: monthly },
        YEARLY: { id: 'yearly', label: yearly }
    };
    schedulerType.getAll = function () {
        var tabShedulerType = new Array();
        for (var i in schedulerType) {
            if (schedulerType.hasOwnProperty(i)) {
                tabShedulerType.push(schedulerType[i]);
            }
        }
        return tabShedulerType;
    };
    schedulerType.getSchedulerTypeByLabel = function (label) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.label === label;
        })[0];
    };

    schedulerType.getSchedulerTypeById = function (id) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.id === id;
        })[0];
    };

    return schedulerType;
}]).factory('StatPeriodType', ["$filter", "gettextCatalog", function ($filter, gettextCatalog) {
    var present = gettextCatalog.getString("present"),
        passed = gettextCatalog.getString("passée");

    var statPeriodType = {
        CURRENT: { id: 'CURRENT', label: present },
        PAST: { id: 'PAST', label: passed }
    };
    statPeriodType.getAll = function () {
        var tabStatPeriodType = new Array();
        for (var i in statPeriodType) {
            if (statPeriodType.hasOwnProperty(i)) {
                tabStatPeriodType.push(statPeriodType[i]);
            }
        }
        return tabStatPeriodType;
    };
    statPeriodType.getPeriodTypeByLabel = function (label) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.label === label;
        })[0];
    };
    return statPeriodType;
}]).factory('LoyaltyCustomers', ['HumanResourceData', "gettextCatalog", function (HumanResourceData, gettextCatalog) {
    var customersLabel = gettextCatalog.getString("Clients venus plusieurs fois"),
        newCustomersLabel = gettextCatalog.getString("Clients venus une seule fois");
    var LoyaltyCustomers = {
        id: "LoyaltyCustomers",
        label: "LoyaltyCustomers",
        noTitle: true,
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return HumanResourceData.getActiveList();
        }
    };
    return LoyaltyCustomers;
}]).factory('HumanResourceExtra', ['CategoryData', 'ProductCategoryData', 'CureCategoryData', 'LoyaltyCardCategoryData', function (CategoryData, ProductCategoryData, CureCategoryData, LoyaltyCardCategoryData) {
    var HumanResourceExtra = {
        label: "Autre",
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            var subCategories = [CategoryData.categoryRoot, ProductCategoryData.categoryRoot, CureCategoryData.categoryRoot, LoyaltyCardCategoryData.categoryRoot];
            return subCategories;
        }
    };
    return HumanResourceExtra;
}]).factory('HrRootCategory', ['HumanResourceData', 'HumanResourceExtra', function (HumanResourceData, HumanResourceExtra) {
    var rootStatCategorie = {
        id: "hrRootCategory",
        label: "hrRootCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return HumanResourceData.getActiveList().concat([HumanResourceExtra]);
        }
    };
    return rootStatCategorie;
}]).factory('GiftItemRootCategory', ["TypeOfBooking", "gettextCatalog", function (TypeOfBooking, gettextCatalog) {
    var serviceLabel = gettextCatalog.getString("En prestation"),
        amountLabel = gettextCatalog.getString("En montant");
    var giftItemRootCategory = {
        id: "giftItemRootCategory",
        label: "giftItemRootCategory",
        subCategories: {
            SERVICE: {
                id: "giftItemServiceCategory",
                label: serviceLabel,
                getSubStatCategories: function getSubStatCategories(rootCategory) {
                    return [TypeOfBooking.CREATE_BY_CUSTORMER, TypeOfBooking.NOT_CREATE_BY_CUSTOMER];
                }
            },
            PRICE: {
                id: "giftItemPriceCategory",
                label: amountLabel,
                getSubStatCategories: function getSubStatCategories(rootCategory) {
                    return [TypeOfBooking.CREATE_BY_CUSTORMER, TypeOfBooking.NOT_CREATE_BY_CUSTOMER];
                }
            }
        },
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return [this.subCategories.SERVICE, this.subCategories.PRICE];
        }
    };

    return giftItemRootCategory;
}]).factory('GiftItemByHrRootCategory', ["HumanResourceData", function (HumanResourceData) {
    var giftItemByHrRootCategory = {
        id: "giftItemByHrRootCategory",
        label: "giftItemByHrRootCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return HumanResourceData.getActiveList();
        }
    };
    return giftItemByHrRootCategory;
}]).factory('NbCustormerCategoryStat', ["gettextCatalog", function (gettextCatalog) {
    var mens = gettextCatalog.getString("Hommes"),
        womens = gettextCatalog.getString("Femmes"),
        children = gettextCatalog.getString("Enfants"),
        unknow = gettextCatalog.getString("Non précisé"),
        walkin = gettextCatalog.getString("Clients de passage");
    var nbCustormercategoryStat = {
        id: "NbCustormerCategoryStat",
        label: "NbCustormerCategoryStat",
        subCategories: {
            MEN_VISITS: { id: 'MEN_VISITS', label: mens },
            WOMEN_VISITS: { id: 'WOMEN_VISITS', label: womens },
            CHILDREN_VISITS: { id: 'CHILDREN_VISITS', label: children },
            UNDEFINED_VISITS: { id: 'UNDEFINED_VISITS', label: unknow },
            PASSENGER_VISITS: { id: 'PASSENGER_VISITS', label: walkin }
        },
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return [this.subCategories.MEN_VISITS, this.subCategories.WOMEN_VISITS, this.subCategories.CHILDREN_VISITS, this.subCategories.UNDEFINED_VISITS, this.subCategories.PASSENGER_VISITS];
        }
    };
    return nbCustormercategoryStat;
}]).factory('TypeOfBooking', ['TypeOfCustomer', 'gettextCatalog', 'Brand', function (TypeOfCustomer, gettextCatalog, Brand) {
    var come = gettextCatalog.getString("Venus"),
        notCome = gettextCatalog.getString("Pas venus"),
        bookedInline = gettextCatalog.getString("Réservé en ligne"),
        bookedOnSite = gettextCatalog.getString("Réservé sur site"),
        comeNotCome = gettextCatalog.getString("Venus/Pas venu"),
        inlineOnSite = gettextCatalog.getString("Réservé en ligne/sur site"),
        createByRGW = gettextCatalog.getString("Réservé depuis Google"),
        createByWebSite = gettextCatalog.getString("Réservé depuis {{brandLabel}}", { brandLabel: Brand.label });

    var typeOfBooking = {
        COME: { id: 'COME', label: come },
        NOT_COME: { id: 'NOT_COME', label: notCome },
        CREATE_BY_CUSTORMER: { id: 'CREATE_BY_CUSTORMER', label: bookedInline },
        NOT_CREATE_BY_CUSTOMER: { id: 'NOT_CREATE_BY_CUSTOMER', label: bookedOnSite },
        COME_AND_NOT_COME: { id: 'COME_AND_NOT_COME', label: comeNotCome },
        CREATE_BY_CUSTORMER_AND_NOT: { id: 'CREATE_BY_CUSTORMER_AND_NOT', label: inlineOnSite },
        CREATE_BY_RWG: { id: 'CREATE_BY_RWG', label: createByRGW },
        CREATE_BY_WEBSITE: { id: 'CREATE_BY_WEBSITE', label: createByWebSite }
    };
    typeOfBooking.COME_AND_NOT_COME.getSubStatCategories = function () {
        return [typeOfBooking.COME, typeOfBooking.NOT_COME];
    };
    typeOfBooking.COME.getSubStatCategories = function () {
        return [TypeOfCustomer.OLD_CUSTOMER, TypeOfCustomer.NEW_CUSTOMER];
    };
    typeOfBooking.NOT_COME.getSubStatCategories = function () {
        return [TypeOfCustomer.OLD_CUSTOMER, TypeOfCustomer.NEW_CUSTOMER];
    };
    typeOfBooking.CREATE_BY_CUSTORMER_AND_NOT.getSubStatCategories = function () {
        return [typeOfBooking.CREATE_BY_CUSTORMER, typeOfBooking.NOT_CREATE_BY_CUSTOMER];
    };
    typeOfBooking.CREATE_BY_CUSTORMER.getSubStatCategories = function () {
        return [typeOfBooking.CREATE_BY_RWG, typeOfBooking.CREATE_BY_WEBSITE];
    };

    return typeOfBooking;
}]).factory('TypeOfCustomerRootCategory', ['TypeOfCustomer', function (TypeOfCustomer) {
    var typeOfCustomerRootCategory = {
        id: "TypeOfCustomerRootCategory",
        label: "TypeOfCustomerRootCategory",
        getSubStatCategories: function getSubStatCategories() {
            return [TypeOfCustomer.OLD_CUSTOMER, TypeOfCustomer.NEW_CUSTOMER];
        }
    };
    return typeOfCustomerRootCategory;
}]).factory('TypeOfCustomer', ['gettextCatalog', function (gettextCatalog) {
    var oldCustoms = gettextCatalog.getString("Anciens clients"),
        newCusoms = gettextCatalog.getString("Nouveaux clients");
    var typeOfCustomer = {
        OLD_CUSTOMER: { id: 'OLD_CUSTOMER', label: oldCustoms },
        NEW_CUSTOMER: { id: 'NEW_CUSTOMER', label: newCusoms }
    };
    return typeOfCustomer;
}]).factory('WorkingTimeRootCategory', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "WorkingTimeRootCategory",
        label: "WorkingTimeRootCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory, periodDays) {
            var humanResourceList = HumanResourceData.getActiveList(),
                humanResourceFinalList = humanResourceList;

            if (periodDays) {
                humanResourceFinalList = new Array();
                for (var i = 0; i < humanResourceList.length; i++) {
                    if (humanResourceList[i].statFilter(periodDays)) {
                        humanResourceFinalList.push(humanResourceList[i]);
                    }
                }
            }
            return humanResourceFinalList;
        }
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrIndisponibilityTime', ['WorkingTimeHrUsualIndisponibilityTime', 'WorkingTimeHrUnusualIndisponibilityTime', function (WorkingTimeHrUsualIndisponibilityTime, WorkingTimeHrUnusualIndisponibilityTime) {
    var rootStatCategorie = {
        id: "WorkingTimeHrIndisponibilityTime",
        label: "Période d'indisponibilité",
        getSubStatCategories: function getSubStatCategories(rootCategory, periodDays) {
            return [WorkingTimeHrUsualIndisponibilityTime, WorkingTimeHrUnusualIndisponibilityTime];
        }
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrUsualIndisponibilityTime', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "WorkingTimeHrUsualIndisponibilityTime",
        label: "Indisponibilité réccurentes"
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrUnusualIndisponibilityTime', ['HumanResourceData', function (WorkingTimeHrUnusualIndisponibilityTime) {
    var rootStatCategorie = {
        id: "WorkingTimeHrUnusualIndisponibilityTime",
        label: "Indisponibilités exceptionnelles"
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrBookingOpenTime', ['WorkingTimeHrUnoccupiedTime', 'WorkingTimeHrBookingTime', function (WorkingTimeHrUnoccupiedTime, WorkingTimeHrBookingTime) {
    var rootStatCategorie = {
        id: "WorkingTimeHrBookingOpenTime",
        label: "Période ouverte aux prestations",
        getSubStatCategories: function getSubStatCategories(rootCategory, periodDays) {
            return [WorkingTimeHrUnoccupiedTime, WorkingTimeHrBookingTime];
        }
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrUnoccupiedTime', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "WorkingTimeHrUnoccupiedTime",
        label: "Innoccupé"
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrBookingTime', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "WorkingTimeHrBookingTime",
        label: "En prestation"
    };
    return rootStatCategorie;
}]).factory('HrOccupationDatas', [function () {
    var HrOccupationDatas = function HrOccupationDatas(day, unoccupiedTime, bookingTime, unusualIndisponibilityTime, usualIndisponibilityTime) {
        this.day = day;
        this.unoccupiedTime = unoccupiedTime;
        this.bookingTime = bookingTime;
        this.unusualIndisponibilityTime = unusualIndisponibilityTime;
        this.usualIndisponibilityTime = usualIndisponibilityTime;
    };
    return HrOccupationDatas;
}]);

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 185:
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(216);
var util = __webpack_require__(218);

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERRORS = (_a = {},
    _a["no-app" /* NO_APP */] = "No Firebase App '{$name}' has been created - " +
        'call Firebase App.initializeApp()',
    _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$name}",
    _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$name}' already exists",
    _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$name}' already deleted",
    _a["duplicate-service" /* DUPLICATE_SERVICE */] = "Firebase service named '{$name}' already registered",
    _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$name}() takes either no argument or a ' +
        'Firebase App instance.',
    _a);
var appErrors = new util.ErrorFactory('app', 'Firebase', ERRORS);
function error(code, args) {
    throw appErrors.create(code, args);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ =
            config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        this.INTERNAL = {
            getUid: function () { return null; },
            getToken: function () { return Promise.resolve(null); },
            addAuthTokenListener: function (callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () { return callback(null); }, 0);
            },
            removeAuthTokenListener: function (callback) {
                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function (val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            for (var _i = 0, _a = Object.keys(_this.services_); _i < _a.length; _i++) {
                var serviceKey = _a[_i];
                for (var _b = 0, _c = Object.keys(_this.services_[serviceKey]); _b < _c.length; _b++) {
                    var instanceKey = _c[_b];
                    services.push(_this.services_[serviceKey][instanceKey]);
                }
            }
            return Promise.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        })
            .then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
                ? instanceIdentifier
                : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        util.deepExtend(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error("app-deleted" /* APP_DELETED */, { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        SDK_VERSION: '6.0.0',
        INTERNAL: {
            registerService: registerService,
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    util.patchProperty(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps[name];
        callAppHooks(app, 'delete');
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps, name)) {
            error("no-app" /* NO_APP */, { name: name });
        }
        return apps[name];
    }
    util.patchProperty(app, 'App', firebaseAppImpl);
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            error("bad-app-name" /* BAD_APP_NAME */, { name: String(name) });
        }
        if (contains(apps, name)) {
            error("duplicate-app" /* DUPLICATE_APP */, { name: name });
        }
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function (name) { return apps[name]; });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        if (allowMultipleInstances === void 0) { allowMultipleInstances = false; }
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error("duplicate-service" /* DUPLICATE_SERVICE */, { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        function serviceNamespace(appArg) {
            if (appArg === void 0) { appArg = app(); }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error("invalid-app-argument" /* INVALID_APP_ARGUMENT */, { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        }
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            util.deepExtend(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        firebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    function callAppHooks(app, eventName) {
        for (var _i = 0, _a = Object.keys(factories); _i < _a.length; _i++) {
            var serviceName = _a[_i];
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        }
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
    namespace.INTERNAL = tslib_1.__assign({}, namespace.INTERNAL, { createFirebaseNamespace: createFirebaseNamespace, extendNamespace: extendNamespace, createSubscribe: util.createSubscribe, ErrorFactory: util.ErrorFactory, deepExtend: util.deepExtend });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    return namespace;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
var isNode = false;
try {
    isNode =
        Object.prototype.toString.call(global.process) === '[object process]';
}
catch (e) { }
isNode &&
    console.warn("\nWarning: This is a browser-targeted Firebase bundle but it appears it is being\nrun in a Node environment.  If running in a Node environment, make sure you\nare using the bundle specified by the \"main\" field in package.json.\n\nIf you are using Webpack, you can specify \"main\" as the first item in\n\"resolve.mainFields\":\nhttps://webpack.js.org/configuration/resolve/#resolvemainfields\n\nIf using Rollup, use the rollup-plugin-node-resolve plugin and set \"module\"\nto false and \"main\" to true:\nhttps://github.com/rollup/rollup-plugin-node-resolve\n");
// Firebase Lite detection
if (self && 'firebase' in self) {
    console.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    var sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        console.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }
}
var firebase = createFirebaseNamespace();

exports.default = firebase;
exports.firebase = firebase;
//# sourceMappingURL=index.cjs.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var config = {
    /* List all the roles you wish to use in the app
    * You have a max of 31 before the bit shift pushes the accompanying integer out of
    * the memory footprint for an integer
    */
    roles: ['public', 'user', 'admin'],

    /*
    Build out all the access levels you want referencing the roles listed above
    You can use the "*" symbol to represent access to all roles
     */
    accessLevels: {
        'public': "*",
        'anon': ['public'],
        'user': ['user', 'admin'],
        'admin': ['admin']
    }
};

/*
    Method to build a distinct bit mask for each role
    It starts off with "1" and shifts the bit to the left for each element in the
    roles array parameter
 */

function buildRoles(roles) {
    var bitMask = "01";
    var userRoles = {};

    for (var role in roles) {
        var intCode = parseInt(bitMask, 2);
        userRoles[roles[role]] = {
            bitMask: intCode,
            title: roles[role]
        };
        bitMask = (intCode << 1).toString(2);
    }

    return userRoles;
}

/*
This method builds access level bit masks based on the accessLevelDeclaration parameter which must
contain an array for each access level containing the allowed user roles.
 */
function buildAccessLevels(accessLevelDeclarations, userRoles) {

    var accessLevels = {};
    for (var level in accessLevelDeclarations) {

        if (typeof accessLevelDeclarations[level] === 'string') {
            if (accessLevelDeclarations[level] === '*') {
                var resultBitMask = '';
                for (var role in userRoles) {
                    resultBitMask += "1";
                }
                //accessLevels[level] = parseInt(resultBitMask, 2);
                accessLevels[level] = {
                    bitMask: parseInt(resultBitMask, 2),
                    title: accessLevelDeclarations[level]
                };
            }
        } else {
            var _resultBitMask = 0;
            for (var _role in accessLevelDeclarations[level]) {
                if (userRoles.hasOwnProperty(accessLevelDeclarations[level][_role])) {
                    _resultBitMask = _resultBitMask | userRoles[accessLevelDeclarations[level][_role]].bitMask;
                }
            }

            accessLevels[level] = {
                bitMask: _resultBitMask,
                title: accessLevelDeclarations[level]
            };
        }
    }

    return accessLevels;
};

var userRoles = buildRoles(config.roles);
var accessLevels = buildAccessLevels(config.accessLevels, userRoles);

var routingConfig = {
    userRoles: userRoles,
    accessLevels: accessLevels
};

exports.routingConfig = routingConfig;

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(185);
var bytesToUuid = __webpack_require__(184);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(216);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) == 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [], pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function (input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
var getUA = function () {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
var isMobileCordova = function () {
    return (typeof window !== 'undefined' &&
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
var isReactNative = function () {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
var isNodeSdk = function () {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var FirebaseError = /** @class */ (function (_super) {
    tslib_1.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
        }
        return _this;
    }
    return FirebaseError;
}(Error));
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === void 0) { data = {}; }
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? replaceTemplate(template, data) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key.slice(-1) !== '_') {
                if (key in error) {
                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                }
                error[key] = data[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}());
function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? value.toString() : "<" + key + "?>";
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key))
        return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
var extend = function (objTo, objFrom) {
    forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
var clone = function (obj) {
    return extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
var isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
var isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
var getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
var map = function (obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
var findKey = function (obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
var findValue = function (obj, fn, opt_this) {
    var key = findKey(obj, fn, opt_this);
    return key && obj[key];
};
var getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
var getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
var querystring = function (querystringParams) {
    var params = [];
    forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
var querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function () {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(opt_offset) << 24) |
                        (buf.charCodeAt(opt_offset + 1) << 16) |
                        (buf.charCodeAt(opt_offset + 2) << 8) |
                        buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[opt_offset] << 24) |
                        (buf[opt_offset + 1] << 16) |
                        (buf[opt_offset + 2] << 8) |
                        buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}());

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace)
        return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback)
        return;
    if (typeof callback !== 'function')
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context)
        return;
    if (typeof context !== 'object' || context === null)
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.CONSTANTS = CONSTANTS;
exports.Deferred = Deferred;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.Sha1 = Sha1;
exports.assert = assert;
exports.assertionError = assertionError;
exports.async = async;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.clone = clone;
exports.contains = contains;
exports.createSubscribe = createSubscribe;
exports.decode = decode;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.errorPrefix = errorPrefix;
exports.every = every;
exports.extend = extend;
exports.findKey = findKey;
exports.findValue = findValue;
exports.forEach = forEach;
exports.getAnyKey = getAnyKey;
exports.getCount = getCount;
exports.getUA = getUA;
exports.getValues = getValues;
exports.isAdmin = isAdmin;
exports.isEmpty = isEmpty;
exports.isMobileCordova = isMobileCordova;
exports.isNodeSdk = isNodeSdk;
exports.isNonNullObject = isNonNullObject;
exports.isReactNative = isReactNative;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.issuedAtTime = issuedAtTime;
exports.jsonEval = jsonEval;
exports.map = map;
exports.patchProperty = patchProperty;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.safeGet = safeGet;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;
exports.stringify = stringify;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateNamespace = validateNamespace;
//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.libphonenumber = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){(function (){
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
var $jscomp=$jscomp||{};$jscomp.scope={};$jscomp.createTemplateTagFirstArg=function(a){return a.raw=a};$jscomp.createTemplateTagFirstArgWithRaw=function(a,b){a.raw=b;return a};$jscomp.arrayIteratorImpl=function(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}};$jscomp.arrayIterator=function(a){return{next:$jscomp.arrayIteratorImpl(a)}};$jscomp.makeIterator=function(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):$jscomp.arrayIterator(a)};
$jscomp.arrayFromIterator=function(a){for(var b,c=[];!(b=a.next()).done;)c.push(b.value);return c};$jscomp.arrayFromIterable=function(a){return a instanceof Array?a:$jscomp.arrayFromIterator($jscomp.makeIterator(a))};$jscomp.checkStringArgs=function(a,b,c){if(null==a)throw new TypeError("The 'this' value for String.prototype."+c+" must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype."+c+" must not be a regular expression");return a+""};
$jscomp.ASSUME_ES5=!1;$jscomp.ASSUME_NO_NATIVE_MAP=!1;$jscomp.ASSUME_NO_NATIVE_SET=!1;$jscomp.SIMPLE_FROUND_POLYFILL=!1;$jscomp.ISOLATE_POLYFILLS=!1;$jscomp.FORCE_POLYFILL_PROMISE=!1;$jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION=!1;$jscomp.defineProperty=$jscomp.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};
$jscomp.getGlobal=function(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");};$jscomp.global=$jscomp.getGlobal(this);$jscomp.IS_SYMBOL_NATIVE="function"===typeof Symbol&&"symbol"===typeof Symbol("x");$jscomp.TRUST_ES6_POLYFILLS=!$jscomp.ISOLATE_POLYFILLS||$jscomp.IS_SYMBOL_NATIVE;$jscomp.polyfills={};
$jscomp.propertyToPolyfillSymbol={};$jscomp.POLYFILL_PREFIX="$jscp$";var $jscomp$lookupPolyfilledValue=function(a,b){var c=$jscomp.propertyToPolyfillSymbol[b];if(null==c)return a[b];c=a[c];return void 0!==c?c:a[b]};$jscomp.polyfill=function(a,b,c,d){b&&($jscomp.ISOLATE_POLYFILLS?$jscomp.polyfillIsolated(a,b,c,d):$jscomp.polyfillUnisolated(a,b,c,d))};
$jscomp.polyfillUnisolated=function(a,b,c,d){c=$jscomp.global;a=a.split(".");for(d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))return;c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&$jscomp.defineProperty(c,a,{configurable:!0,writable:!0,value:b})};
$jscomp.polyfillIsolated=function(a,b,c,d){var e=a.split(".");a=1===e.length;d=e[0];d=!a&&d in $jscomp.polyfills?$jscomp.polyfills:$jscomp.global;for(var f=0;f<e.length-1;f++){var g=e[f];if(!(g in d))return;d=d[g]}e=e[e.length-1];c=$jscomp.IS_SYMBOL_NATIVE&&"es6"===c?d[e]:null;b=b(c);null!=b&&(a?$jscomp.defineProperty($jscomp.polyfills,e,{configurable:!0,writable:!0,value:b}):b!==c&&($jscomp.propertyToPolyfillSymbol[e]=$jscomp.IS_SYMBOL_NATIVE?$jscomp.global.Symbol(e):$jscomp.POLYFILL_PREFIX+e,e=
$jscomp.propertyToPolyfillSymbol[e],$jscomp.defineProperty(d,e,{configurable:!0,writable:!0,value:b})))};$jscomp.polyfill("String.prototype.endsWith",function(a){return a?a:function(b,c){var d=$jscomp.checkStringArgs(this,b,"endsWith");b+="";void 0===c&&(c=d.length);c=Math.max(0,Math.min(c|0,d.length));for(var e=b.length;0<e&&0<c;)if(d[--c]!=b[--e])return!1;return 0>=e}},"es6","es3");
$jscomp.findInternal=function(a,b,c){a instanceof String&&(a=String(a));for(var d=a.length,e=0;e<d;e++){var f=a[e];if(b.call(c,f,e,a))return{i:e,v:f}}return{i:-1,v:void 0}};$jscomp.polyfill("Array.prototype.find",function(a){return a?a:function(b,c){return $jscomp.findInternal(this,b,c).v}},"es6","es3");
$jscomp.polyfill("String.prototype.startsWith",function(a){return a?a:function(b,c){var d=$jscomp.checkStringArgs(this,b,"startsWith");b+="";var e=d.length,f=b.length;c=Math.max(0,Math.min(c|0,d.length));for(var g=0;g<f&&c<e;)if(d[c++]!=b[g++])return!1;return g>=f}},"es6","es3");
$jscomp.polyfill("String.prototype.repeat",function(a){return a?a:function(b){var c=$jscomp.checkStringArgs(this,null,"repeat");if(0>b||1342177279<b)throw new RangeError("Invalid count value");b|=0;for(var d="";b;)if(b&1&&(d+=c),b>>>=1)c+=c;return d}},"es6","es3");$jscomp.initSymbol=function(){};
$jscomp.polyfill("Symbol",function(a){if(a)return a;var b=function(e,f){this.$jscomp$symbol$id_=e;$jscomp.defineProperty(this,"description",{configurable:!0,writable:!0,value:f})};b.prototype.toString=function(){return this.$jscomp$symbol$id_};var c=0,d=function(e){if(this instanceof d)throw new TypeError("Symbol is not a constructor");return new b("jscomp_symbol_"+(e||"")+"_"+c++,e)};return d},"es6","es3");
$jscomp.polyfill("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=$jscomp.global[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&$jscomp.defineProperty(d.prototype,a,{configurable:!0,writable:!0,value:function(){return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this))}})}return a},"es6",
"es3");$jscomp.iteratorPrototype=function(a){a={next:a};a[Symbol.iterator]=function(){return this};return a};$jscomp.iteratorFromArray=function(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return{value:b(f,a[f]),done:!1}}d=!0;return{done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e};$jscomp.polyfill("Array.prototype.keys",function(a){return a?a:function(){return $jscomp.iteratorFromArray(this,function(b){return b})}},"es6","es3");
$jscomp.polyfill("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}},"es6","es3");$jscomp.polyfill("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var e=d.length;c=c||0;for(0>c&&(c=Math.max(c+e,0));c<e;c++){var f=d[c];if(f===b||Object.is(f,b))return!0}return!1}},"es7","es3");
$jscomp.polyfill("String.prototype.includes",function(a){return a?a:function(b,c){return-1!==$jscomp.checkStringArgs(this,b,"includes").indexOf(b,c||0)}},"es6","es3");var COMPILED=!0,goog=goog||{};goog.global=this||self;
goog.exportPath_=function(a,b,c,d){a=a.split(".");d=d||goog.global;a[0]in d||"undefined"==typeof d.execScript||d.execScript("var "+a[0]);for(var e;a.length&&(e=a.shift());)if(a.length||void 0===b)d=d[e]&&d[e]!==Object.prototype[e]?d[e]:d[e]={};else if(!c&&goog.isObject(b)&&goog.isObject(d[e]))for(var f in b)b.hasOwnProperty(f)&&(d[e][f]=b[f]);else d[e]=b};
goog.define=function(a,b){if(!COMPILED){var c=goog.global.CLOSURE_UNCOMPILED_DEFINES,d=goog.global.CLOSURE_DEFINES;c&&void 0===c.nodeType&&Object.prototype.hasOwnProperty.call(c,a)?b=c[a]:d&&void 0===d.nodeType&&Object.prototype.hasOwnProperty.call(d,a)&&(b=d[a])}return b};goog.FEATURESET_YEAR=2012;goog.DEBUG=!0;goog.LOCALE="en";goog.TRUSTED_SITE=!0;goog.DISALLOW_TEST_ONLY_CODE=COMPILED&&!goog.DEBUG;goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING=!1;
goog.provide=function(a){if(goog.isInModuleLoader_())throw Error("goog.provide cannot be used within a module.");if(!COMPILED&&goog.isProvided_(a))throw Error('Namespace "'+a+'" already declared.');goog.constructNamespace_(a)};goog.constructNamespace_=function(a,b,c){if(!COMPILED){delete goog.implicitNamespaces_[a];for(var d=a;(d=d.substring(0,d.lastIndexOf(".")))&&!goog.getObjectByName(d);)goog.implicitNamespaces_[d]=!0}goog.exportPath_(a,b,c)};
goog.getScriptNonce=function(a){if(a&&a!=goog.global)return goog.getScriptNonce_(a.document);null===goog.cspNonce_&&(goog.cspNonce_=goog.getScriptNonce_(goog.global.document));return goog.cspNonce_};goog.NONCE_PATTERN_=/^[\w+/_-]+[=]{0,2}$/;goog.cspNonce_=null;goog.getScriptNonce_=function(a){return(a=a.querySelector&&a.querySelector("script[nonce]"))&&(a=a.nonce||a.getAttribute("nonce"))&&goog.NONCE_PATTERN_.test(a)?a:""};goog.VALID_MODULE_RE_=/^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
goog.module=function(a){if("string"!==typeof a||!a||-1==a.search(goog.VALID_MODULE_RE_))throw Error("Invalid module identifier");if(!goog.isInGoogModuleLoader_())throw Error("Module "+a+" has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
if(goog.moduleLoaderState_.moduleName)throw Error("goog.module may only be called once per module.");goog.moduleLoaderState_.moduleName=a;if(!COMPILED){if(goog.isProvided_(a))throw Error('Namespace "'+a+'" already declared.');delete goog.implicitNamespaces_[a]}};goog.module.get=function(a){return goog.module.getInternal_(a)};
goog.module.getInternal_=function(a){if(!COMPILED){if(a in goog.loadedModules_)return goog.loadedModules_[a].exports;if(!goog.implicitNamespaces_[a])return a=goog.getObjectByName(a),null!=a?a:null}return null};goog.ModuleType={ES6:"es6",GOOG:"goog"};goog.moduleLoaderState_=null;goog.isInModuleLoader_=function(){return goog.isInGoogModuleLoader_()||goog.isInEs6ModuleLoader_()};goog.isInGoogModuleLoader_=function(){return!!goog.moduleLoaderState_&&goog.moduleLoaderState_.type==goog.ModuleType.GOOG};
goog.isInEs6ModuleLoader_=function(){if(goog.moduleLoaderState_&&goog.moduleLoaderState_.type==goog.ModuleType.ES6)return!0;var a=goog.global.$jscomp;return a?"function"!=typeof a.getCurrentModulePath?!1:!!a.getCurrentModulePath():!1};
goog.module.declareLegacyNamespace=function(){if(!COMPILED&&!goog.isInGoogModuleLoader_())throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");if(!COMPILED&&!goog.moduleLoaderState_.moduleName)throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");goog.moduleLoaderState_.declareLegacyNamespace=!0};
goog.declareModuleId=function(a){if(!COMPILED){if(!goog.isInEs6ModuleLoader_())throw Error("goog.declareModuleId may only be called from within an ES6 module");if(goog.moduleLoaderState_&&goog.moduleLoaderState_.moduleName)throw Error("goog.declareModuleId may only be called once per module.");if(a in goog.loadedModules_)throw Error('Module with namespace "'+a+'" already exists.');}if(goog.moduleLoaderState_)goog.moduleLoaderState_.moduleName=a;else{var b=goog.global.$jscomp;if(!b||"function"!=typeof b.getCurrentModulePath)throw Error('Module with namespace "'+
a+'" has been loaded incorrectly.');b=b.require(b.getCurrentModulePath());goog.loadedModules_[a]={exports:b,type:goog.ModuleType.ES6,moduleId:a}}};goog.setTestOnly=function(a){if(goog.DISALLOW_TEST_ONLY_CODE)throw a=a||"",Error("Importing test-only code into non-debug environment"+(a?": "+a:"."));};goog.forwardDeclare=function(a){};COMPILED||(goog.isProvided_=function(a){return a in goog.loadedModules_||!goog.implicitNamespaces_[a]&&null!=goog.getObjectByName(a)},goog.implicitNamespaces_={"goog.module":!0});
goog.getObjectByName=function(a,b){a=a.split(".");b=b||goog.global;for(var c=0;c<a.length;c++)if(b=b[a[c]],null==b)return null;return b};goog.addDependency=function(a,b,c,d){!COMPILED&&goog.DEPENDENCIES_ENABLED&&goog.debugLoader_.addDependency(a,b,c,d)};goog.ENABLE_DEBUG_LOADER=!0;goog.logToConsole_=function(a){goog.global.console&&goog.global.console.error(a)};
goog.require=function(a){if(!COMPILED){goog.ENABLE_DEBUG_LOADER&&goog.debugLoader_.requested(a);if(goog.isProvided_(a)){if(goog.isInModuleLoader_())return goog.module.getInternal_(a)}else if(goog.ENABLE_DEBUG_LOADER){var b=goog.moduleLoaderState_;goog.moduleLoaderState_=null;try{goog.debugLoader_.load_(a)}finally{goog.moduleLoaderState_=b}}return null}};goog.requireType=function(a){return{}};goog.basePath="";goog.nullFunction=function(){};
goog.abstractMethod=function(){throw Error("unimplemented abstract method");};goog.addSingletonGetter=function(a){a.instance_=void 0;a.getInstance=function(){if(a.instance_)return a.instance_;goog.DEBUG&&(goog.instantiatedSingletons_[goog.instantiatedSingletons_.length]=a);return a.instance_=new a}};goog.instantiatedSingletons_=[];goog.LOAD_MODULE_USING_EVAL=!0;goog.SEAL_MODULE_EXPORTS=goog.DEBUG;goog.loadedModules_={};goog.DEPENDENCIES_ENABLED=!COMPILED&&goog.ENABLE_DEBUG_LOADER;goog.TRANSPILE="detect";
goog.ASSUME_ES_MODULES_TRANSPILED=!1;goog.TRANSPILE_TO_LANGUAGE="";goog.TRANSPILER="transpile.js";goog.hasBadLetScoping=null;goog.useSafari10Workaround=function(){if(null==goog.hasBadLetScoping){try{var a=!eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";')}catch(b){a=!1}goog.hasBadLetScoping=a}return goog.hasBadLetScoping};goog.workaroundSafari10EvalBug=function(a){return"(function(){"+a+"\n;})();\n"};
goog.loadModule=function(a){var b=goog.moduleLoaderState_;try{goog.moduleLoaderState_={moduleName:"",declareLegacyNamespace:!1,type:goog.ModuleType.GOOG};var c={},d=c;if("function"===typeof a)d=a.call(void 0,d);else if("string"===typeof a)goog.useSafari10Workaround()&&(a=goog.workaroundSafari10EvalBug(a)),d=goog.loadModuleFromSource_.call(void 0,d,a);else throw Error("Invalid module definition");var e=goog.moduleLoaderState_.moduleName;if("string"===typeof e&&e)goog.moduleLoaderState_.declareLegacyNamespace?
goog.constructNamespace_(e,d,c!==d):goog.SEAL_MODULE_EXPORTS&&Object.seal&&"object"==typeof d&&null!=d&&Object.seal(d),goog.loadedModules_[e]={exports:d,type:goog.ModuleType.GOOG,moduleId:goog.moduleLoaderState_.moduleName};else throw Error('Invalid module name "'+e+'"');}finally{goog.moduleLoaderState_=b}};goog.loadModuleFromSource_=function(a,b){eval(b);return a};
goog.normalizePath_=function(a){a=a.split("/");for(var b=0;b<a.length;)"."==a[b]?a.splice(b,1):b&&".."==a[b]&&a[b-1]&&".."!=a[b-1]?a.splice(--b,2):b++;return a.join("/")};goog.loadFileSync_=function(a){if(goog.global.CLOSURE_LOAD_FILE_SYNC)return goog.global.CLOSURE_LOAD_FILE_SYNC(a);try{var b=new goog.global.XMLHttpRequest;b.open("get",a,!1);b.send();return 0==b.status||200==b.status?b.responseText:null}catch(c){return null}};
goog.transpile_=function(a,b,c){var d=goog.global.$jscomp;d||(goog.global.$jscomp=d={});var e=d.transpile;if(!e){var f=goog.basePath+goog.TRANSPILER,g=goog.loadFileSync_(f);if(g){(function(){(0,eval)(g+"\n//# sourceURL="+f)}).call(goog.global);if(goog.global.$gwtExport&&goog.global.$gwtExport.$jscomp&&!goog.global.$gwtExport.$jscomp.transpile)throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: '+JSON.stringify(goog.global.$gwtExport));goog.global.$jscomp.transpile=
goog.global.$gwtExport.$jscomp.transpile;d=goog.global.$jscomp;e=d.transpile}}e||(e=d.transpile=function(h,k){goog.logToConsole_(k+" requires transpilation but no transpiler was found.");return h});return e(a,b,c)};goog.typeOf=function(a){var b=typeof a;return"object"!=b?b:a?Array.isArray(a)?"array":b:"null"};goog.isArrayLike=function(a){var b=goog.typeOf(a);return"array"==b||"object"==b&&"number"==typeof a.length};goog.isDateLike=function(a){return goog.isObject(a)&&"function"==typeof a.getFullYear};
goog.isObject=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b};goog.getUid=function(a){return Object.prototype.hasOwnProperty.call(a,goog.UID_PROPERTY_)&&a[goog.UID_PROPERTY_]||(a[goog.UID_PROPERTY_]=++goog.uidCounter_)};goog.hasUid=function(a){return!!a[goog.UID_PROPERTY_]};goog.removeUid=function(a){null!==a&&"removeAttribute"in a&&a.removeAttribute(goog.UID_PROPERTY_);try{delete a[goog.UID_PROPERTY_]}catch(b){}};goog.UID_PROPERTY_="closure_uid_"+(1E9*Math.random()>>>0);
goog.uidCounter_=0;goog.cloneObject=function(a){var b=goog.typeOf(a);if("object"==b||"array"==b){if("function"===typeof a.clone)return a.clone();b="array"==b?[]:{};for(var c in a)b[c]=goog.cloneObject(a[c]);return b}return a};goog.bindNative_=function(a,b,c){return a.call.apply(a.bind,arguments)};
goog.bindJs_=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}};goog.bind=function(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?goog.bind=goog.bindNative_:goog.bind=goog.bindJs_;return goog.bind.apply(null,arguments)};
goog.partial=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}};goog.mixin=function(a,b){for(var c in b)a[c]=b[c]};goog.now=function(){return Date.now()};goog.globalEval=function(a){(0,eval)(a)};
goog.getCssName=function(a,b){if("."==String(a).charAt(0))throw Error('className passed in goog.getCssName must not start with ".". You passed: '+a);var c=function(e){return goog.cssNameMapping_[e]||e},d=function(e){e=e.split("-");for(var f=[],g=0;g<e.length;g++)f.push(c(e[g]));return f.join("-")};d=goog.cssNameMapping_?"BY_WHOLE"==goog.cssNameMappingStyle_?c:d:function(e){return e};a=b?a+"-"+d(b):d(a);return goog.global.CLOSURE_CSS_NAME_MAP_FN?goog.global.CLOSURE_CSS_NAME_MAP_FN(a):a};
goog.setCssNameMapping=function(a,b){goog.cssNameMapping_=a;goog.cssNameMappingStyle_=b};!COMPILED&&goog.global.CLOSURE_CSS_NAME_MAPPING&&(goog.cssNameMapping_=goog.global.CLOSURE_CSS_NAME_MAPPING);goog.getMsg=function(a,b,c){c&&c.html&&(a=a.replace(/</g,"&lt;"));c&&c.unescapeHtmlEntities&&(a=a.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&apos;/g,"'").replace(/&quot;/g,'"').replace(/&amp;/g,"&"));b&&(a=a.replace(/\{\$([^}]+)}/g,function(d,e){return null!=b&&e in b?b[e]:d}));return a};
goog.getMsgWithFallback=function(a,b){return a};goog.exportSymbol=function(a,b,c){goog.exportPath_(a,b,!0,c)};goog.exportProperty=function(a,b,c){a[b]=c};goog.inherits=function(a,b){function c(){}c.prototype=b.prototype;a.superClass_=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.base=function(d,e,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[e].apply(d,g)}};
goog.scope=function(a){if(goog.isInModuleLoader_())throw Error("goog.scope is not supported within a module.");a.call(goog.global)};COMPILED||(goog.global.COMPILED=COMPILED);
goog.defineClass=function(a,b){var c=b.constructor,d=b.statics;c&&c!=Object.prototype.constructor||(c=function(){throw Error("cannot instantiate an interface (no constructor defined).");});c=goog.defineClass.createSealingConstructor_(c,a);a&&goog.inherits(c,a);delete b.constructor;delete b.statics;goog.defineClass.applyProperties_(c.prototype,b);null!=d&&(d instanceof Function?d(c):goog.defineClass.applyProperties_(c,d));return c};goog.defineClass.SEAL_CLASS_INSTANCES=goog.DEBUG;
goog.defineClass.createSealingConstructor_=function(a,b){return goog.defineClass.SEAL_CLASS_INSTANCES?function(){var c=a.apply(this,arguments)||this;c[goog.UID_PROPERTY_]=c[goog.UID_PROPERTY_];return c}:a};goog.defineClass.OBJECT_PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.defineClass.applyProperties_=function(a,b){for(var c in b)Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c]);for(var d=0;d<goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length;d++)c=goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d],Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c])};
!COMPILED&&goog.DEPENDENCIES_ENABLED&&(goog.inHtmlDocument_=function(){var a=goog.global.document;return null!=a&&"write"in a},goog.isDocumentLoading_=function(){var a=goog.global.document;return a.attachEvent?"complete"!=a.readyState:"loading"==a.readyState},goog.findBasePath_=function(){if(void 0!=goog.global.CLOSURE_BASE_PATH&&"string"===typeof goog.global.CLOSURE_BASE_PATH)goog.basePath=goog.global.CLOSURE_BASE_PATH;else if(goog.inHtmlDocument_()){var a=goog.global.document,b=a.currentScript;
a=b?[b]:a.getElementsByTagName("SCRIPT");for(b=a.length-1;0<=b;--b){var c=a[b].src,d=c.lastIndexOf("?");d=-1==d?c.length:d;if("base.js"==c.substr(d-7,7)){goog.basePath=c.substr(0,d-7);break}}}},goog.findBasePath_(),goog.Transpiler=function(){this.requiresTranspilation_=null;this.transpilationTarget_=goog.TRANSPILE_TO_LANGUAGE},goog.Transpiler.prototype.createRequiresTranspilation_=function(){function a(g,h){e?d[g]=!0:h()?(c=g,d[g]=!1):e=d[g]=!0}function b(g){try{return!!eval(g)}catch(h){return!1}}
var c="es3",d={es3:!1},e=!1,f=goog.global.navigator&&goog.global.navigator.userAgent?goog.global.navigator.userAgent:"";a("es5",function(){return b("[1,].length==1")});a("es6",function(){return f.match(/Edge\/(\d+)(\.\d)*/i)?!1:b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()')});
a("es7",function(){return b("2 ** 2 == 4")});a("es8",function(){return b("async () => 1, true")});a("es9",function(){return b("({...rest} = {}), true")});a("es_next",function(){return!1});return{target:c,map:d}},goog.Transpiler.prototype.needsTranspile=function(a,b){if("always"==goog.TRANSPILE)return!0;if("never"==goog.TRANSPILE)return!1;if(!this.requiresTranspilation_){var c=this.createRequiresTranspilation_();this.requiresTranspilation_=c.map;this.transpilationTarget_=this.transpilationTarget_||
c.target}if(a in this.requiresTranspilation_)return this.requiresTranspilation_[a]?!0:!goog.inHtmlDocument_()||"es6"!=b||"noModule"in goog.global.document.createElement("script")?!1:!0;throw Error("Unknown language mode: "+a);},goog.Transpiler.prototype.transpile=function(a,b){return goog.transpile_(a,b,this.transpilationTarget_)},goog.transpiler_=new goog.Transpiler,goog.protectScriptTag_=function(a){return a.replace(/<\/(SCRIPT)/ig,"\\x3c/$1")},goog.DebugLoader_=function(){this.dependencies_={};
this.idToPath_={};this.written_={};this.loadingDeps_=[];this.depsToLoad_=[];this.paused_=!1;this.factory_=new goog.DependencyFactory(goog.transpiler_);this.deferredCallbacks_={};this.deferredQueue_=[]},goog.DebugLoader_.prototype.bootstrap=function(a,b){function c(){d&&(goog.global.setTimeout(d,0),d=null)}var d=b;if(a.length){b=[];for(var e=0;e<a.length;e++){var f=this.getPathFromDeps_(a[e]);if(!f)throw Error("Unregonized namespace: "+a[e]);b.push(this.dependencies_[f])}f=goog.require;var g=0;for(e=
0;e<a.length;e++)f(a[e]),b[e].onLoad(function(){++g==a.length&&c()})}else c()},goog.DebugLoader_.prototype.loadClosureDeps=function(){this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath+"deps.js"),"deps.js",[],[],{},!1));this.loadDeps_()},goog.DebugLoader_.prototype.requested=function(a,b){(a=this.getPathFromDeps_(a))&&(b||this.areDepsLoaded_(this.dependencies_[a].requires))&&(b=this.deferredCallbacks_[a])&&(delete this.deferredCallbacks_[a],b())},goog.DebugLoader_.prototype.setDependencyFactory=
function(a){this.factory_=a},goog.DebugLoader_.prototype.load_=function(a){if(this.getPathFromDeps_(a)){var b=this,c=[],d=function(e){var f=b.getPathFromDeps_(e);if(!f)throw Error("Bad dependency path or symbol: "+e);if(!b.written_[f]){b.written_[f]=!0;e=b.dependencies_[f];for(f=0;f<e.requires.length;f++)goog.isProvided_(e.requires[f])||d(e.requires[f]);c.push(e)}};d(a);a=!!this.depsToLoad_.length;this.depsToLoad_=this.depsToLoad_.concat(c);this.paused_||a||this.loadDeps_()}else throw a="goog.require could not find: "+
a,goog.logToConsole_(a),Error(a);},goog.DebugLoader_.prototype.loadDeps_=function(){for(var a=this,b=this.paused_;this.depsToLoad_.length&&!b;)(function(){var c=!1,d=a.depsToLoad_.shift(),e=!1;a.loading_(d);var f={pause:function(){if(c)throw Error("Cannot call pause after the call to load.");b=!0},resume:function(){c?a.resume_():b=!1},loaded:function(){if(e)throw Error("Double call to loaded.");e=!0;a.loaded_(d)},pending:function(){for(var g=[],h=0;h<a.loadingDeps_.length;h++)g.push(a.loadingDeps_[h]);
return g},setModuleState:function(g){goog.moduleLoaderState_={type:g,moduleName:"",declareLegacyNamespace:!1}},registerEs6ModuleExports:function(g,h,k){k&&(goog.loadedModules_[k]={exports:h,type:goog.ModuleType.ES6,moduleId:k||""})},registerGoogModuleExports:function(g,h){goog.loadedModules_[g]={exports:h,type:goog.ModuleType.GOOG,moduleId:g}},clearModuleState:function(){goog.moduleLoaderState_=null},defer:function(g){if(c)throw Error("Cannot register with defer after the call to load.");a.defer_(d,
g)},areDepsLoaded:function(){return a.areDepsLoaded_(d.requires)}};try{d.load(f)}finally{c=!0}})();b&&this.pause_()},goog.DebugLoader_.prototype.pause_=function(){this.paused_=!0},goog.DebugLoader_.prototype.resume_=function(){this.paused_&&(this.paused_=!1,this.loadDeps_())},goog.DebugLoader_.prototype.loading_=function(a){this.loadingDeps_.push(a)},goog.DebugLoader_.prototype.loaded_=function(a){for(var b=0;b<this.loadingDeps_.length;b++)if(this.loadingDeps_[b]==a){this.loadingDeps_.splice(b,1);
break}for(b=0;b<this.deferredQueue_.length;b++)if(this.deferredQueue_[b]==a.path){this.deferredQueue_.splice(b,1);break}if(this.loadingDeps_.length==this.deferredQueue_.length&&!this.depsToLoad_.length)for(;this.deferredQueue_.length;)this.requested(this.deferredQueue_.shift(),!0);a.loaded()},goog.DebugLoader_.prototype.areDepsLoaded_=function(a){for(var b=0;b<a.length;b++){var c=this.getPathFromDeps_(a[b]);if(!c||!(c in this.deferredCallbacks_||goog.isProvided_(a[b])))return!1}return!0},goog.DebugLoader_.prototype.getPathFromDeps_=
function(a){return a in this.idToPath_?this.idToPath_[a]:a in this.dependencies_?a:null},goog.DebugLoader_.prototype.defer_=function(a,b){this.deferredCallbacks_[a.path]=b;this.deferredQueue_.push(a.path)},goog.LoadController=function(){},goog.LoadController.prototype.pause=function(){},goog.LoadController.prototype.resume=function(){},goog.LoadController.prototype.loaded=function(){},goog.LoadController.prototype.pending=function(){},goog.LoadController.prototype.registerEs6ModuleExports=function(a,
b,c){},goog.LoadController.prototype.setModuleState=function(a){},goog.LoadController.prototype.clearModuleState=function(){},goog.LoadController.prototype.defer=function(a){},goog.LoadController.prototype.areDepsLoaded=function(){},goog.Dependency=function(a,b,c,d,e){this.path=a;this.relativePath=b;this.provides=c;this.requires=d;this.loadFlags=e;this.loaded_=!1;this.loadCallbacks_=[]},goog.Dependency.prototype.getPathName=function(){var a=this.path,b=a.indexOf("://");0<=b&&(a=a.substring(b+3),b=
a.indexOf("/"),0<=b&&(a=a.substring(b+1)));return a},goog.Dependency.prototype.onLoad=function(a){this.loaded_?a():this.loadCallbacks_.push(a)},goog.Dependency.prototype.loaded=function(){this.loaded_=!0;var a=this.loadCallbacks_;this.loadCallbacks_=[];for(var b=0;b<a.length;b++)a[b]()},goog.Dependency.defer_=!1,goog.Dependency.callbackMap_={},goog.Dependency.registerCallback_=function(a){var b=Math.random().toString(32);goog.Dependency.callbackMap_[b]=a;return b},goog.Dependency.unregisterCallback_=
function(a){delete goog.Dependency.callbackMap_[a]},goog.Dependency.callback_=function(a,b){if(a in goog.Dependency.callbackMap_){for(var c=goog.Dependency.callbackMap_[a],d=[],e=1;e<arguments.length;e++)d.push(arguments[e]);c.apply(void 0,d)}else throw Error("Callback key "+a+" does not exist (was base.js loaded more than once?).");},goog.Dependency.prototype.load=function(a){if(goog.global.CLOSURE_IMPORT_SCRIPT)goog.global.CLOSURE_IMPORT_SCRIPT(this.path)?a.loaded():a.pause();else if(goog.inHtmlDocument_()){var b=
goog.global.document;if("complete"==b.readyState&&!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING){if(/\bdeps.js$/.test(this.path)){a.loaded();return}throw Error('Cannot write "'+this.path+'" after document load');}var c=goog.getScriptNonce();if(!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING&&goog.isDocumentLoading_()){var d=function(h){h.readyState&&"complete"!=h.readyState?h.onload=d:(goog.Dependency.unregisterCallback_(e),a.loaded())};var e=goog.Dependency.registerCallback_(d);c=c?' nonce="'+c+'"':"";
var f='<script src="'+this.path+'"'+c+(goog.Dependency.defer_?" defer":"")+' id="script-'+e+'">\x3c/script>';f+="<script"+c+">";f=goog.Dependency.defer_?f+("document.getElementById('script-"+e+"').onload = function() {\n  goog.Dependency.callback_('"+e+"', this);\n};\n"):f+("goog.Dependency.callback_('"+e+"', document.getElementById('script-"+e+"'));");f+="\x3c/script>";b.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(f):f)}else{var g=b.createElement("script");g.defer=goog.Dependency.defer_;
g.async=!1;c&&(g.nonce=c);goog.DebugLoader_.IS_OLD_IE_?(a.pause(),g.onreadystatechange=function(){if("loaded"==g.readyState||"complete"==g.readyState)a.loaded(),a.resume()}):g.onload=function(){g.onload=null;a.loaded()};g.src=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path):this.path;b.head.appendChild(g)}}else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."),"deps.js"==this.relativePath?(goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."),
a.loaded()):a.pause()},goog.Es6ModuleDependency=function(a,b,c,d,e){goog.Dependency.call(this,a,b,c,d,e)},goog.inherits(goog.Es6ModuleDependency,goog.Dependency),goog.Es6ModuleDependency.prototype.load=function(a){function b(l,p){var m="",n=goog.getScriptNonce();n&&(m=' nonce="'+n+'"');l=p?'<script type="module" crossorigin'+m+">"+p+"\x3c/script>":'<script type="module" crossorigin src="'+l+'"'+m+">\x3c/script>";d.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(l):l)}function c(l,
p){var m=d.createElement("script");m.defer=!0;m.async=!1;m.type="module";m.setAttribute("crossorigin",!0);var n=goog.getScriptNonce();n&&(m.nonce=n);p?m.text=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScript(p):p:m.src=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScriptURL(l):l;d.head.appendChild(m)}if(goog.global.CLOSURE_IMPORT_SCRIPT)goog.global.CLOSURE_IMPORT_SCRIPT(this.path)?a.loaded():a.pause();else if(goog.inHtmlDocument_()){var d=goog.global.document,e=this;
if(goog.isDocumentLoading_()){var f=b;goog.Dependency.defer_=!0}else f=c;var g=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(g);a.setModuleState(goog.ModuleType.ES6)});f(void 0,'goog.Dependency.callback_("'+g+'")');f(this.path,void 0);var h=goog.Dependency.registerCallback_(function(l){goog.Dependency.unregisterCallback_(h);a.registerEs6ModuleExports(e.path,l,goog.moduleLoaderState_.moduleName)});f(void 0,'import * as m from "'+this.path+'"; goog.Dependency.callback_("'+
h+'", m)');var k=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(k);a.clearModuleState();a.loaded()});f(void 0,'goog.Dependency.callback_("'+k+'")')}else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."),a.pause()},goog.TransformedDependency=function(a,b,c,d,e){goog.Dependency.call(this,a,b,c,d,e);this.contents_=null;this.lazyFetch_=!goog.inHtmlDocument_()||!("noModule"in goog.global.document.createElement("script"))},goog.inherits(goog.TransformedDependency,
goog.Dependency),goog.TransformedDependency.prototype.load=function(a){function b(){e.contents_=goog.loadFileSync_(e.path);e.contents_&&(e.contents_=e.transform(e.contents_),e.contents_&&(e.contents_+="\n//# sourceURL="+e.path))}function c(){e.lazyFetch_&&b();if(e.contents_){f&&a.setModuleState(goog.ModuleType.ES6);try{var p=e.contents_;e.contents_=null;goog.globalEval(p);if(f)var m=goog.moduleLoaderState_.moduleName}finally{f&&a.clearModuleState()}f&&goog.global.$jscomp.require.ensure([e.getPathName()],
function(){a.registerEs6ModuleExports(e.path,goog.global.$jscomp.require(e.getPathName()),m)});a.loaded()}}function d(){var p=goog.global.document,m=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(m);c()}),n=goog.getScriptNonce();n="<script"+(n?' nonce="'+n+'"':"")+">"+goog.protectScriptTag_('goog.Dependency.callback_("'+m+'");')+"\x3c/script>";p.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(n):n)}var e=this;if(goog.global.CLOSURE_IMPORT_SCRIPT)b(),
this.contents_&&goog.global.CLOSURE_IMPORT_SCRIPT("",this.contents_)?(this.contents_=null,a.loaded()):a.pause();else{var f=this.loadFlags.module==goog.ModuleType.ES6;this.lazyFetch_||b();var g=1<a.pending().length,h=g&&goog.DebugLoader_.IS_OLD_IE_;g=goog.Dependency.defer_&&(g||goog.isDocumentLoading_());if(h||g)a.defer(function(){c()});else{var k=goog.global.document;h=goog.inHtmlDocument_()&&"ActiveXObject"in goog.global;if(f&&goog.inHtmlDocument_()&&goog.isDocumentLoading_()&&!h){goog.Dependency.defer_=
!0;a.pause();var l=k.onreadystatechange;k.onreadystatechange=function(){"interactive"==k.readyState&&(k.onreadystatechange=l,c(),a.resume());"function"===typeof l&&l.apply(void 0,arguments)}}else!goog.DebugLoader_.IS_OLD_IE_&&goog.inHtmlDocument_()&&goog.isDocumentLoading_()?d():c()}}},goog.TransformedDependency.prototype.transform=function(a){},goog.TranspiledDependency=function(a,b,c,d,e,f){goog.TransformedDependency.call(this,a,b,c,d,e);this.transpiler=f},goog.inherits(goog.TranspiledDependency,
goog.TransformedDependency),goog.TranspiledDependency.prototype.transform=function(a){return this.transpiler.transpile(a,this.getPathName())},goog.PreTranspiledEs6ModuleDependency=function(a,b,c,d,e){goog.TransformedDependency.call(this,a,b,c,d,e)},goog.inherits(goog.PreTranspiledEs6ModuleDependency,goog.TransformedDependency),goog.PreTranspiledEs6ModuleDependency.prototype.transform=function(a){return a},goog.GoogModuleDependency=function(a,b,c,d,e,f,g){goog.TransformedDependency.call(this,a,b,c,
d,e);this.needsTranspile_=f;this.transpiler_=g},goog.inherits(goog.GoogModuleDependency,goog.TransformedDependency),goog.GoogModuleDependency.prototype.transform=function(a){this.needsTranspile_&&(a=this.transpiler_.transpile(a,this.getPathName()));return goog.LOAD_MODULE_USING_EVAL&&void 0!==goog.global.JSON?"goog.loadModule("+goog.global.JSON.stringify(a+"\n//# sourceURL="+this.path+"\n")+");":'goog.loadModule(function(exports) {"use strict";'+a+"\n;return exports});\n//# sourceURL="+this.path+
"\n"},goog.DebugLoader_.IS_OLD_IE_=!(goog.global.atob||!goog.global.document||!goog.global.document.all),goog.DebugLoader_.prototype.addDependency=function(a,b,c,d){b=b||[];a=a.replace(/\\/g,"/");var e=goog.normalizePath_(goog.basePath+a);d&&"boolean"!==typeof d||(d=d?{module:goog.ModuleType.GOOG}:{});c=this.factory_.createDependency(e,a,b,c,d,goog.transpiler_.needsTranspile(d.lang||"es3",d.module));this.dependencies_[e]=c;for(c=0;c<b.length;c++)this.idToPath_[b[c]]=e;this.idToPath_[a]=e},goog.DependencyFactory=
function(a){this.transpiler=a},goog.DependencyFactory.prototype.createDependency=function(a,b,c,d,e,f){return e.module==goog.ModuleType.GOOG?new goog.GoogModuleDependency(a,b,c,d,e,f,this.transpiler):f?new goog.TranspiledDependency(a,b,c,d,e,this.transpiler):e.module==goog.ModuleType.ES6?"never"==goog.TRANSPILE&&goog.ASSUME_ES_MODULES_TRANSPILED?new goog.PreTranspiledEs6ModuleDependency(a,b,c,d,e):new goog.Es6ModuleDependency(a,b,c,d,e):new goog.Dependency(a,b,c,d,e)},goog.debugLoader_=new goog.DebugLoader_,
goog.loadClosureDeps=function(){goog.debugLoader_.loadClosureDeps()},goog.setDependencyFactory=function(a){goog.debugLoader_.setDependencyFactory(a)},goog.TRUSTED_TYPES_POLICY_=goog.TRUSTED_TYPES_POLICY_NAME?goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME+"#base"):null,goog.global.CLOSURE_NO_DEPS||goog.debugLoader_.loadClosureDeps(),goog.bootstrap=function(a,b){goog.debugLoader_.bootstrap(a,b)});goog.TRUSTED_TYPES_POLICY_NAME="goog";goog.identity_=function(a){return a};
goog.createTrustedTypesPolicy=function(a){var b=null,c=goog.global.trustedTypes;if(!c||!c.createPolicy)return b;try{b=c.createPolicy(a,{createHTML:goog.identity_,createScript:goog.identity_,createScriptURL:goog.identity_})}catch(d){goog.logToConsole_(d.message)}return b};goog.debug={};function module$contents$goog$debug$Error_DebugError(a){if(Error.captureStackTrace)Error.captureStackTrace(this,module$contents$goog$debug$Error_DebugError);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a));this.reportErrorToServer=!0}goog.inherits(module$contents$goog$debug$Error_DebugError,Error);module$contents$goog$debug$Error_DebugError.prototype.name="CustomError";goog.debug.Error=module$contents$goog$debug$Error_DebugError;goog.dom={};goog.dom.NodeType={ELEMENT:1,ATTRIBUTE:2,TEXT:3,CDATA_SECTION:4,ENTITY_REFERENCE:5,ENTITY:6,PROCESSING_INSTRUCTION:7,COMMENT:8,DOCUMENT:9,DOCUMENT_TYPE:10,DOCUMENT_FRAGMENT:11,NOTATION:12};goog.asserts={};goog.asserts.ENABLE_ASSERTS=goog.DEBUG;goog.asserts.AssertionError=function(a,b){module$contents$goog$debug$Error_DebugError.call(this,goog.asserts.subs_(a,b));this.messagePattern=a};goog.inherits(goog.asserts.AssertionError,module$contents$goog$debug$Error_DebugError);goog.asserts.AssertionError.prototype.name="AssertionError";goog.asserts.DEFAULT_ERROR_HANDLER=function(a){throw a;};goog.asserts.errorHandler_=goog.asserts.DEFAULT_ERROR_HANDLER;
goog.asserts.subs_=function(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");return c+a[d]};goog.asserts.doAssertFailure_=function(a,b,c,d){var e="Assertion failed";if(c){e+=": "+c;var f=d}else a&&(e+=": "+a,f=b);a=new goog.asserts.AssertionError(""+e,f||[]);goog.asserts.errorHandler_(a)};goog.asserts.setErrorHandler=function(a){goog.asserts.ENABLE_ASSERTS&&(goog.asserts.errorHandler_=a)};
goog.asserts.assert=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!a&&goog.asserts.doAssertFailure_("",null,b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertExists=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&null==a&&goog.asserts.doAssertFailure_("Expected to exist: %s.",[a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.fail=function(a,b){goog.asserts.ENABLE_ASSERTS&&goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1)))};goog.asserts.assertNumber=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"number"!==typeof a&&goog.asserts.doAssertFailure_("Expected number but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertString=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"string"!==typeof a&&goog.asserts.doAssertFailure_("Expected string but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertFunction=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"function"!==typeof a&&goog.asserts.doAssertFailure_("Expected function but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertObject=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isObject(a)&&goog.asserts.doAssertFailure_("Expected object but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertArray=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!Array.isArray(a)&&goog.asserts.doAssertFailure_("Expected array but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertBoolean=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"boolean"!==typeof a&&goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertElement=function(a,b,c){!goog.asserts.ENABLE_ASSERTS||goog.isObject(a)&&a.nodeType==goog.dom.NodeType.ELEMENT||goog.asserts.doAssertFailure_("Expected Element but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertInstanceof=function(a,b,c,d){!goog.asserts.ENABLE_ASSERTS||a instanceof b||goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.",[goog.asserts.getType_(b),goog.asserts.getType_(a)],c,Array.prototype.slice.call(arguments,3));return a};goog.asserts.assertFinite=function(a,b,c){!goog.asserts.ENABLE_ASSERTS||"number"==typeof a&&isFinite(a)||goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.",[a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertObjectPrototypeIsIntact=function(){for(var a in Object.prototype)goog.asserts.fail(a+" should not be enumerable in Object.prototype.")};goog.asserts.getType_=function(a){return a instanceof Function?a.displayName||a.name||"unknown type name":a instanceof Object?a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a):null===a?"null":typeof a};goog.array={};goog.NATIVE_ARRAY_PROTOTYPES=goog.TRUSTED_SITE;var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS=2012<goog.FEATURESET_YEAR;goog.array.ASSUME_NATIVE_FUNCTIONS=module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;function module$contents$goog$array_peek(a){return a[a.length-1]}goog.array.peek=module$contents$goog$array_peek;goog.array.last=module$contents$goog$array_peek;
var module$contents$goog$array_indexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.indexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.indexOf(b,c);for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1};goog.array.indexOf=module$contents$goog$array_indexOf;
var module$contents$goog$array_lastIndexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.lastIndexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.lastIndexOf.call(a,b,null==c?a.length-1:c)}:function(a,b,c){c=null==c?a.length-1:c;0>c&&(c=Math.max(0,a.length+c));if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.lastIndexOf(b,c);for(;0<=c;c--)if(c in a&&a[c]===b)return c;return-1};
goog.array.lastIndexOf=module$contents$goog$array_lastIndexOf;var module$contents$goog$array_forEach=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.forEach)?function(a,b,c){goog.asserts.assert(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};goog.array.forEach=module$contents$goog$array_forEach;
function module$contents$goog$array_forEachRight(a,b,c){var d=a.length,e="string"===typeof a?a.split(""):a;for(--d;0<=d;--d)d in e&&b.call(c,e[d],d,a)}goog.array.forEachRight=module$contents$goog$array_forEachRight;
var module$contents$goog$array_filter=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.filter)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,g="string"===typeof a?a.split(""):a,h=0;h<d;h++)if(h in g){var k=g[h];b.call(c,k,h,a)&&(e[f++]=k)}return e};goog.array.filter=module$contents$goog$array_filter;
var module$contents$goog$array_map=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.map)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f="string"===typeof a?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e};goog.array.map=module$contents$goog$array_map;
var module$contents$goog$array_reduce=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduce)?function(a,b,c,d){goog.asserts.assert(null!=a.length);d&&(b=goog.bind(b,d));return Array.prototype.reduce.call(a,b,c)}:function(a,b,c,d){var e=c;module$contents$goog$array_forEach(a,function(f,g){e=b.call(d,e,f,g,a)});return e};goog.array.reduce=module$contents$goog$array_reduce;
var module$contents$goog$array_reduceRight=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduceRight)?function(a,b,c,d){goog.asserts.assert(null!=a.length);goog.asserts.assert(null!=b);d&&(b=goog.bind(b,d));return Array.prototype.reduceRight.call(a,b,c)}:function(a,b,c,d){var e=c;module$contents$goog$array_forEachRight(a,function(f,g){e=b.call(d,e,f,g,a)});return e};goog.array.reduceRight=module$contents$goog$array_reduceRight;
var module$contents$goog$array_some=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.some)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1};goog.array.some=module$contents$goog$array_some;
var module$contents$goog$array_every=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.every)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};goog.array.every=module$contents$goog$array_every;
function module$contents$goog$array_count(a,b,c){var d=0;module$contents$goog$array_forEach(a,function(e,f,g){b.call(c,e,f,g)&&++d},c);return d}goog.array.count=module$contents$goog$array_count;function module$contents$goog$array_find(a,b,c){b=module$contents$goog$array_findIndex(a,b,c);return 0>b?null:"string"===typeof a?a.charAt(b):a[b]}goog.array.find=module$contents$goog$array_find;
function module$contents$goog$array_findIndex(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}goog.array.findIndex=module$contents$goog$array_findIndex;function module$contents$goog$array_findRight(a,b,c){b=module$contents$goog$array_findIndexRight(a,b,c);return 0>b?null:"string"===typeof a?a.charAt(b):a[b]}goog.array.findRight=module$contents$goog$array_findRight;
function module$contents$goog$array_findIndexRight(a,b,c){var d=a.length,e="string"===typeof a?a.split(""):a;for(--d;0<=d;d--)if(d in e&&b.call(c,e[d],d,a))return d;return-1}goog.array.findIndexRight=module$contents$goog$array_findIndexRight;function module$contents$goog$array_contains(a,b){return 0<=module$contents$goog$array_indexOf(a,b)}goog.array.contains=module$contents$goog$array_contains;function module$contents$goog$array_isEmpty(a){return 0==a.length}goog.array.isEmpty=module$contents$goog$array_isEmpty;
function module$contents$goog$array_clear(a){if(!Array.isArray(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0}goog.array.clear=module$contents$goog$array_clear;function module$contents$goog$array_insert(a,b){module$contents$goog$array_contains(a,b)||a.push(b)}goog.array.insert=module$contents$goog$array_insert;function module$contents$goog$array_insertAt(a,b,c){module$contents$goog$array_splice(a,c,0,b)}goog.array.insertAt=module$contents$goog$array_insertAt;
function module$contents$goog$array_insertArrayAt(a,b,c){goog.partial(module$contents$goog$array_splice,a,c,0).apply(null,b)}goog.array.insertArrayAt=module$contents$goog$array_insertArrayAt;function module$contents$goog$array_insertBefore(a,b,c){var d;2==arguments.length||0>(d=module$contents$goog$array_indexOf(a,c))?a.push(b):module$contents$goog$array_insertAt(a,b,d)}goog.array.insertBefore=module$contents$goog$array_insertBefore;
function module$contents$goog$array_remove(a,b){b=module$contents$goog$array_indexOf(a,b);var c;(c=0<=b)&&module$contents$goog$array_removeAt(a,b);return c}goog.array.remove=module$contents$goog$array_remove;function module$contents$goog$array_removeLast(a,b){b=module$contents$goog$array_lastIndexOf(a,b);return 0<=b?(module$contents$goog$array_removeAt(a,b),!0):!1}goog.array.removeLast=module$contents$goog$array_removeLast;
function module$contents$goog$array_removeAt(a,b){goog.asserts.assert(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length}goog.array.removeAt=module$contents$goog$array_removeAt;function module$contents$goog$array_removeIf(a,b,c){b=module$contents$goog$array_findIndex(a,b,c);return 0<=b?(module$contents$goog$array_removeAt(a,b),!0):!1}goog.array.removeIf=module$contents$goog$array_removeIf;
function module$contents$goog$array_removeAllIf(a,b,c){var d=0;module$contents$goog$array_forEachRight(a,function(e,f){b.call(c,e,f,a)&&module$contents$goog$array_removeAt(a,f)&&d++});return d}goog.array.removeAllIf=module$contents$goog$array_removeAllIf;function module$contents$goog$array_concat(a){return Array.prototype.concat.apply([],arguments)}goog.array.concat=module$contents$goog$array_concat;function module$contents$goog$array_join(a){return Array.prototype.concat.apply([],arguments)}
goog.array.join=module$contents$goog$array_join;function module$contents$goog$array_toArray(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}var module$contents$goog$array_clone=goog.array.toArray=module$contents$goog$array_toArray;goog.array.clone=module$contents$goog$array_clone;
function module$contents$goog$array_extend(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c];if(goog.isArrayLike(d)){var e=a.length||0,f=d.length||0;a.length=e+f;for(var g=0;g<f;g++)a[e+g]=d[g]}else a.push(d)}}goog.array.extend=module$contents$goog$array_extend;function module$contents$goog$array_splice(a,b,c,d){goog.asserts.assert(null!=a.length);return Array.prototype.splice.apply(a,module$contents$goog$array_slice(arguments,1))}goog.array.splice=module$contents$goog$array_splice;
function module$contents$goog$array_slice(a,b,c){goog.asserts.assert(null!=a.length);return 2>=arguments.length?Array.prototype.slice.call(a,b):Array.prototype.slice.call(a,b,c)}goog.array.slice=module$contents$goog$array_slice;
function module$contents$goog$array_removeDuplicates(a,b,c){b=b||a;var d=function(k){return goog.isObject(k)?"o"+goog.getUid(k):(typeof k).charAt(0)+k};c=c||d;d={};for(var e=0,f=0;f<a.length;){var g=a[f++],h=c(g);Object.prototype.hasOwnProperty.call(d,h)||(d[h]=!0,b[e++]=g)}b.length=e}goog.array.removeDuplicates=module$contents$goog$array_removeDuplicates;
function module$contents$goog$array_binarySearch(a,b,c){return module$contents$goog$array_binarySearch_(a,c||module$contents$goog$array_defaultCompare,!1,b)}goog.array.binarySearch=module$contents$goog$array_binarySearch;function module$contents$goog$array_binarySelect(a,b,c){return module$contents$goog$array_binarySearch_(a,b,!0,void 0,c)}goog.array.binarySelect=module$contents$goog$array_binarySelect;
function module$contents$goog$array_binarySearch_(a,b,c,d,e){for(var f=0,g=a.length,h;f<g;){var k=f+(g-f>>>1);var l=c?b.call(e,a[k],k,a):b(d,a[k]);0<l?f=k+1:(g=k,h=!l)}return h?f:-f-1}function module$contents$goog$array_sort(a,b){a.sort(b||module$contents$goog$array_defaultCompare)}goog.array.sort=module$contents$goog$array_sort;
function module$contents$goog$array_stableSort(a,b){for(var c=Array(a.length),d=0;d<a.length;d++)c[d]={index:d,value:a[d]};var e=b||module$contents$goog$array_defaultCompare;module$contents$goog$array_sort(c,function(f,g){return e(f.value,g.value)||f.index-g.index});for(d=0;d<a.length;d++)a[d]=c[d].value}goog.array.stableSort=module$contents$goog$array_stableSort;
function module$contents$goog$array_sortByKey(a,b,c){var d=c||module$contents$goog$array_defaultCompare;module$contents$goog$array_sort(a,function(e,f){return d(b(e),b(f))})}goog.array.sortByKey=module$contents$goog$array_sortByKey;function module$contents$goog$array_sortObjectsByKey(a,b,c){module$contents$goog$array_sortByKey(a,function(d){return d[b]},c)}goog.array.sortObjectsByKey=module$contents$goog$array_sortObjectsByKey;
function module$contents$goog$array_isSorted(a,b,c){b=b||module$contents$goog$array_defaultCompare;for(var d=1;d<a.length;d++){var e=b(a[d-1],a[d]);if(0<e||0==e&&c)return!1}return!0}goog.array.isSorted=module$contents$goog$array_isSorted;function module$contents$goog$array_equals(a,b,c){if(!goog.isArrayLike(a)||!goog.isArrayLike(b)||a.length!=b.length)return!1;var d=a.length;c=c||module$contents$goog$array_defaultCompareEquality;for(var e=0;e<d;e++)if(!c(a[e],b[e]))return!1;return!0}
goog.array.equals=module$contents$goog$array_equals;function module$contents$goog$array_compare3(a,b,c){c=c||module$contents$goog$array_defaultCompare;for(var d=Math.min(a.length,b.length),e=0;e<d;e++){var f=c(a[e],b[e]);if(0!=f)return f}return module$contents$goog$array_defaultCompare(a.length,b.length)}goog.array.compare3=module$contents$goog$array_compare3;function module$contents$goog$array_defaultCompare(a,b){return a>b?1:a<b?-1:0}goog.array.defaultCompare=module$contents$goog$array_defaultCompare;
function module$contents$goog$array_inverseDefaultCompare(a,b){return-module$contents$goog$array_defaultCompare(a,b)}goog.array.inverseDefaultCompare=module$contents$goog$array_inverseDefaultCompare;function module$contents$goog$array_defaultCompareEquality(a,b){return a===b}goog.array.defaultCompareEquality=module$contents$goog$array_defaultCompareEquality;
function module$contents$goog$array_binaryInsert(a,b,c){c=module$contents$goog$array_binarySearch(a,b,c);return 0>c?(module$contents$goog$array_insertAt(a,b,-(c+1)),!0):!1}goog.array.binaryInsert=module$contents$goog$array_binaryInsert;function module$contents$goog$array_binaryRemove(a,b,c){b=module$contents$goog$array_binarySearch(a,b,c);return 0<=b?module$contents$goog$array_removeAt(a,b):!1}goog.array.binaryRemove=module$contents$goog$array_binaryRemove;
function module$contents$goog$array_bucket(a,b,c){for(var d={},e=0;e<a.length;e++){var f=a[e],g=b.call(c,f,e,a);void 0!==g&&(d[g]||(d[g]=[])).push(f)}return d}goog.array.bucket=module$contents$goog$array_bucket;function module$contents$goog$array_toObject(a,b,c){var d={};module$contents$goog$array_forEach(a,function(e,f){d[b.call(c,e,f,a)]=e});return d}goog.array.toObject=module$contents$goog$array_toObject;
function module$contents$goog$array_range(a,b,c){var d=[],e=0,f=a;c=c||1;void 0!==b&&(e=a,f=b);if(0>c*(f-e))return[];if(0<c)for(a=e;a<f;a+=c)d.push(a);else for(a=e;a>f;a+=c)d.push(a);return d}goog.array.range=module$contents$goog$array_range;function module$contents$goog$array_repeat(a,b){for(var c=[],d=0;d<b;d++)c[d]=a;return c}goog.array.repeat=module$contents$goog$array_repeat;
function module$contents$goog$array_flatten(a){for(var b=[],c=0;c<arguments.length;c++){var d=arguments[c];if(Array.isArray(d))for(var e=0;e<d.length;e+=8192){var f=module$contents$goog$array_slice(d,e,e+8192);f=module$contents$goog$array_flatten.apply(null,f);for(var g=0;g<f.length;g++)b.push(f[g])}else b.push(d)}return b}goog.array.flatten=module$contents$goog$array_flatten;
function module$contents$goog$array_rotate(a,b){goog.asserts.assert(null!=a.length);a.length&&(b%=a.length,0<b?Array.prototype.unshift.apply(a,a.splice(-b,b)):0>b&&Array.prototype.push.apply(a,a.splice(0,-b)));return a}goog.array.rotate=module$contents$goog$array_rotate;function module$contents$goog$array_moveItem(a,b,c){goog.asserts.assert(0<=b&&b<a.length);goog.asserts.assert(0<=c&&c<a.length);b=Array.prototype.splice.call(a,b,1);Array.prototype.splice.call(a,c,0,b[0])}goog.array.moveItem=module$contents$goog$array_moveItem;
function module$contents$goog$array_zip(a){if(!arguments.length)return[];for(var b=[],c=arguments[0].length,d=1;d<arguments.length;d++)arguments[d].length<c&&(c=arguments[d].length);for(d=0;d<c;d++){for(var e=[],f=0;f<arguments.length;f++)e.push(arguments[f][d]);b.push(e)}return b}goog.array.zip=module$contents$goog$array_zip;function module$contents$goog$array_shuffle(a,b){b=b||Math.random;for(var c=a.length-1;0<c;c--){var d=Math.floor(b()*(c+1)),e=a[c];a[c]=a[d];a[d]=e}}goog.array.shuffle=module$contents$goog$array_shuffle;
function module$contents$goog$array_copyByIndex(a,b){var c=[];module$contents$goog$array_forEach(b,function(d){c.push(a[d])});return c}goog.array.copyByIndex=module$contents$goog$array_copyByIndex;function module$contents$goog$array_concatMap(a,b,c){return module$contents$goog$array_concat.apply([],module$contents$goog$array_map(a,b,c))}goog.array.concatMap=module$contents$goog$array_concatMap;goog.dom.asserts={};goog.dom.asserts.assertIsLocation=function(a){if(goog.asserts.ENABLE_ASSERTS){var b=goog.dom.asserts.getWindow_(a);b&&(!a||!(a instanceof b.Location)&&a instanceof b.Element)&&goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s",goog.dom.asserts.debugStringForType_(a))}return a};
goog.dom.asserts.assertIsElementType_=function(a,b){if(goog.asserts.ENABLE_ASSERTS){var c=goog.dom.asserts.getWindow_(a);c&&"undefined"!=typeof c[b]&&(a&&(a instanceof c[b]||!(a instanceof c.Location||a instanceof c.Element))||goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s",b,goog.dom.asserts.debugStringForType_(a)))}return a};goog.dom.asserts.assertIsHTMLAnchorElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLAnchorElement")};
goog.dom.asserts.assertIsHTMLButtonElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLButtonElement")};goog.dom.asserts.assertIsHTMLLinkElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLLinkElement")};goog.dom.asserts.assertIsHTMLImageElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLImageElement")};goog.dom.asserts.assertIsHTMLAudioElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLAudioElement")};
goog.dom.asserts.assertIsHTMLVideoElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLVideoElement")};goog.dom.asserts.assertIsHTMLInputElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLInputElement")};goog.dom.asserts.assertIsHTMLTextAreaElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLTextAreaElement")};goog.dom.asserts.assertIsHTMLCanvasElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLCanvasElement")};
goog.dom.asserts.assertIsHTMLEmbedElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLEmbedElement")};goog.dom.asserts.assertIsHTMLFormElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLFormElement")};goog.dom.asserts.assertIsHTMLFrameElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLFrameElement")};goog.dom.asserts.assertIsHTMLIFrameElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLIFrameElement")};
goog.dom.asserts.assertIsHTMLObjectElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLObjectElement")};goog.dom.asserts.assertIsHTMLScriptElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLScriptElement")};
goog.dom.asserts.debugStringForType_=function(a){if(goog.isObject(a))try{return a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a)}catch(b){return"<object could not be stringified>"}else return void 0===a?"undefined":null===a?"null":typeof a};goog.dom.asserts.getWindow_=function(a){try{var b=a&&a.ownerDocument,c=b&&(b.defaultView||b.parentWindow);c=c||goog.global;if(c.Element&&c.Location)return c}catch(d){}return null};goog.dom.HtmlElement=function(){};goog.functions={};goog.functions.constant=function(a){return function(){return a}};goog.functions.FALSE=function(){return!1};goog.functions.TRUE=function(){return!0};goog.functions.NULL=function(){return null};goog.functions.identity=function(a,b){return a};goog.functions.error=function(a){return function(){throw Error(a);}};goog.functions.fail=function(a){return function(){throw a;}};
goog.functions.lock=function(a,b){b=b||0;return function(){return a.apply(this,Array.prototype.slice.call(arguments,0,b))}};goog.functions.nth=function(a){return function(){return arguments[a]}};goog.functions.partialRight=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=this;d===goog.global&&(d=void 0);var e=Array.prototype.slice.call(arguments);e.push.apply(e,c);return a.apply(d,e)}};
goog.functions.withReturnValue=function(a,b){return goog.functions.sequence(a,goog.functions.constant(b))};goog.functions.equalTo=function(a,b){return function(c){return b?a==c:a===c}};goog.functions.compose=function(a,b){var c=arguments,d=c.length;return function(){var e;d&&(e=c[d-1].apply(this,arguments));for(var f=d-2;0<=f;f--)e=c[f].call(this,e);return e}};goog.functions.sequence=function(a){var b=arguments,c=b.length;return function(){for(var d,e=0;e<c;e++)d=b[e].apply(this,arguments);return d}};
goog.functions.and=function(a){var b=arguments,c=b.length;return function(){for(var d=0;d<c;d++)if(!b[d].apply(this,arguments))return!1;return!0}};goog.functions.or=function(a){var b=arguments,c=b.length;return function(){for(var d=0;d<c;d++)if(b[d].apply(this,arguments))return!0;return!1}};goog.functions.not=function(a){return function(){return!a.apply(this,arguments)}};
goog.functions.create=function(a,b){var c=function(){};c.prototype=a.prototype;c=new c;a.apply(c,Array.prototype.slice.call(arguments,1));return c};goog.functions.CACHE_RETURN_VALUE=!0;goog.functions.cacheReturnValue=function(a){var b=!1,c;return function(){if(!goog.functions.CACHE_RETURN_VALUE)return a();b||(c=a(),b=!0);return c}};goog.functions.once=function(a){var b=a;return function(){if(b){var c=b;b=null;c()}}};
goog.functions.debounce=function(a,b,c){var d=0;return function(e){goog.global.clearTimeout(d);var f=arguments;d=goog.global.setTimeout(function(){a.apply(c,f)},b)}};goog.functions.throttle=function(a,b,c){var d=0,e=!1,f=[],g=function(){d=0;e&&(e=!1,h())},h=function(){d=goog.global.setTimeout(g,b);a.apply(c,f)};return function(k){f=arguments;d?e=!0:h()}};goog.functions.rateLimit=function(a,b,c){var d=0,e=function(){d=0};return function(f){d||(d=goog.global.setTimeout(e,b),a.apply(c,arguments))}};
goog.functions.isFunction=function(a){return"function"===typeof a};goog.dom.TagName=function(){};goog.dom.TagName.cast=function(a,b){return a};goog.dom.TagName.prototype.toString=function(){};goog.dom.TagName.A="A";goog.dom.TagName.ABBR="ABBR";goog.dom.TagName.ACRONYM="ACRONYM";goog.dom.TagName.ADDRESS="ADDRESS";goog.dom.TagName.APPLET="APPLET";goog.dom.TagName.AREA="AREA";goog.dom.TagName.ARTICLE="ARTICLE";goog.dom.TagName.ASIDE="ASIDE";goog.dom.TagName.AUDIO="AUDIO";goog.dom.TagName.B="B";goog.dom.TagName.BASE="BASE";goog.dom.TagName.BASEFONT="BASEFONT";
goog.dom.TagName.BDI="BDI";goog.dom.TagName.BDO="BDO";goog.dom.TagName.BIG="BIG";goog.dom.TagName.BLOCKQUOTE="BLOCKQUOTE";goog.dom.TagName.BODY="BODY";goog.dom.TagName.BR="BR";goog.dom.TagName.BUTTON="BUTTON";goog.dom.TagName.CANVAS="CANVAS";goog.dom.TagName.CAPTION="CAPTION";goog.dom.TagName.CENTER="CENTER";goog.dom.TagName.CITE="CITE";goog.dom.TagName.CODE="CODE";goog.dom.TagName.COL="COL";goog.dom.TagName.COLGROUP="COLGROUP";goog.dom.TagName.COMMAND="COMMAND";goog.dom.TagName.DATA="DATA";
goog.dom.TagName.DATALIST="DATALIST";goog.dom.TagName.DD="DD";goog.dom.TagName.DEL="DEL";goog.dom.TagName.DETAILS="DETAILS";goog.dom.TagName.DFN="DFN";goog.dom.TagName.DIALOG="DIALOG";goog.dom.TagName.DIR="DIR";goog.dom.TagName.DIV="DIV";goog.dom.TagName.DL="DL";goog.dom.TagName.DT="DT";goog.dom.TagName.EM="EM";goog.dom.TagName.EMBED="EMBED";goog.dom.TagName.FIELDSET="FIELDSET";goog.dom.TagName.FIGCAPTION="FIGCAPTION";goog.dom.TagName.FIGURE="FIGURE";goog.dom.TagName.FONT="FONT";
goog.dom.TagName.FOOTER="FOOTER";goog.dom.TagName.FORM="FORM";goog.dom.TagName.FRAME="FRAME";goog.dom.TagName.FRAMESET="FRAMESET";goog.dom.TagName.H1="H1";goog.dom.TagName.H2="H2";goog.dom.TagName.H3="H3";goog.dom.TagName.H4="H4";goog.dom.TagName.H5="H5";goog.dom.TagName.H6="H6";goog.dom.TagName.HEAD="HEAD";goog.dom.TagName.HEADER="HEADER";goog.dom.TagName.HGROUP="HGROUP";goog.dom.TagName.HR="HR";goog.dom.TagName.HTML="HTML";goog.dom.TagName.I="I";goog.dom.TagName.IFRAME="IFRAME";
goog.dom.TagName.IMG="IMG";goog.dom.TagName.INPUT="INPUT";goog.dom.TagName.INS="INS";goog.dom.TagName.ISINDEX="ISINDEX";goog.dom.TagName.KBD="KBD";goog.dom.TagName.KEYGEN="KEYGEN";goog.dom.TagName.LABEL="LABEL";goog.dom.TagName.LEGEND="LEGEND";goog.dom.TagName.LI="LI";goog.dom.TagName.LINK="LINK";goog.dom.TagName.MAIN="MAIN";goog.dom.TagName.MAP="MAP";goog.dom.TagName.MARK="MARK";goog.dom.TagName.MATH="MATH";goog.dom.TagName.MENU="MENU";goog.dom.TagName.MENUITEM="MENUITEM";goog.dom.TagName.META="META";
goog.dom.TagName.METER="METER";goog.dom.TagName.NAV="NAV";goog.dom.TagName.NOFRAMES="NOFRAMES";goog.dom.TagName.NOSCRIPT="NOSCRIPT";goog.dom.TagName.OBJECT="OBJECT";goog.dom.TagName.OL="OL";goog.dom.TagName.OPTGROUP="OPTGROUP";goog.dom.TagName.OPTION="OPTION";goog.dom.TagName.OUTPUT="OUTPUT";goog.dom.TagName.P="P";goog.dom.TagName.PARAM="PARAM";goog.dom.TagName.PICTURE="PICTURE";goog.dom.TagName.PRE="PRE";goog.dom.TagName.PROGRESS="PROGRESS";goog.dom.TagName.Q="Q";goog.dom.TagName.RP="RP";
goog.dom.TagName.RT="RT";goog.dom.TagName.RTC="RTC";goog.dom.TagName.RUBY="RUBY";goog.dom.TagName.S="S";goog.dom.TagName.SAMP="SAMP";goog.dom.TagName.SCRIPT="SCRIPT";goog.dom.TagName.SECTION="SECTION";goog.dom.TagName.SELECT="SELECT";goog.dom.TagName.SMALL="SMALL";goog.dom.TagName.SOURCE="SOURCE";goog.dom.TagName.SPAN="SPAN";goog.dom.TagName.STRIKE="STRIKE";goog.dom.TagName.STRONG="STRONG";goog.dom.TagName.STYLE="STYLE";goog.dom.TagName.SUB="SUB";goog.dom.TagName.SUMMARY="SUMMARY";
goog.dom.TagName.SUP="SUP";goog.dom.TagName.SVG="SVG";goog.dom.TagName.TABLE="TABLE";goog.dom.TagName.TBODY="TBODY";goog.dom.TagName.TD="TD";goog.dom.TagName.TEMPLATE="TEMPLATE";goog.dom.TagName.TEXTAREA="TEXTAREA";goog.dom.TagName.TFOOT="TFOOT";goog.dom.TagName.TH="TH";goog.dom.TagName.THEAD="THEAD";goog.dom.TagName.TIME="TIME";goog.dom.TagName.TITLE="TITLE";goog.dom.TagName.TR="TR";goog.dom.TagName.TRACK="TRACK";goog.dom.TagName.TT="TT";goog.dom.TagName.U="U";goog.dom.TagName.UL="UL";
goog.dom.TagName.VAR="VAR";goog.dom.TagName.VIDEO="VIDEO";goog.dom.TagName.WBR="WBR";goog.object={};goog.object.forEach=function(a,b,c){for(var d in a)b.call(c,a[d],d,a)};goog.object.filter=function(a,b,c){var d={},e;for(e in a)b.call(c,a[e],e,a)&&(d[e]=a[e]);return d};goog.object.map=function(a,b,c){var d={},e;for(e in a)d[e]=b.call(c,a[e],e,a);return d};goog.object.some=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return!0;return!1};goog.object.every=function(a,b,c){for(var d in a)if(!b.call(c,a[d],d,a))return!1;return!0};
goog.object.getCount=function(a){var b=0,c;for(c in a)b++;return b};goog.object.getAnyKey=function(a){for(var b in a)return b};goog.object.getAnyValue=function(a){for(var b in a)return a[b]};goog.object.contains=function(a,b){return goog.object.containsValue(a,b)};goog.object.getValues=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b};goog.object.getKeys=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b};
goog.object.getValueByKeys=function(a,b){var c=goog.isArrayLike(b),d=c?b:arguments;for(c=c?0:1;c<d.length;c++){if(null==a)return;a=a[d[c]]}return a};goog.object.containsKey=function(a,b){return null!==a&&b in a};goog.object.containsValue=function(a,b){for(var c in a)if(a[c]==b)return!0;return!1};goog.object.findKey=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d};goog.object.findValue=function(a,b,c){return(b=goog.object.findKey(a,b,c))&&a[b]};
goog.object.isEmpty=function(a){for(var b in a)return!1;return!0};goog.object.clear=function(a){for(var b in a)delete a[b]};goog.object.remove=function(a,b){var c;(c=b in a)&&delete a[b];return c};goog.object.add=function(a,b,c){if(null!==a&&b in a)throw Error('The object already contains the key "'+b+'"');goog.object.set(a,b,c)};goog.object.get=function(a,b,c){return null!==a&&b in a?a[b]:c};goog.object.set=function(a,b,c){a[b]=c};
goog.object.setIfUndefined=function(a,b,c){return b in a?a[b]:a[b]=c};goog.object.setWithReturnValueIfNotSet=function(a,b,c){if(b in a)return a[b];c=c();return a[b]=c};goog.object.equals=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(var d in b)if(!(d in a))return!1;return!0};goog.object.clone=function(a){var b={},c;for(c in a)b[c]=a[c];return b};
goog.object.unsafeClone=function(a){if(!a||"object"!==typeof a)return a;if("function"===typeof a.clone)return a.clone();var b=Array.isArray(a)?[]:"function"!==typeof ArrayBuffer||"function"!==typeof ArrayBuffer.isView||!ArrayBuffer.isView(a)||a instanceof DataView?{}:new a.constructor(a.length),c;for(c in a)b[c]=goog.object.unsafeClone(a[c]);return b};goog.object.transpose=function(a){var b={},c;for(c in a)b[a[c]]=c;return b};goog.object.PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.object.extend=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<goog.object.PROTOTYPE_FIELDS_.length;f++)c=goog.object.PROTOTYPE_FIELDS_[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};
goog.object.create=function(a){var b=arguments.length;if(1==b&&Array.isArray(arguments[0]))return goog.object.create.apply(null,arguments[0]);if(b%2)throw Error("Uneven number of arguments");for(var c={},d=0;d<b;d+=2)c[arguments[d]]=arguments[d+1];return c};goog.object.createSet=function(a){var b=arguments.length;if(1==b&&Array.isArray(arguments[0]))return goog.object.createSet.apply(null,arguments[0]);for(var c={},d=0;d<b;d++)c[arguments[d]]=!0;return c};
goog.object.createImmutableView=function(a){var b=a;Object.isFrozen&&!Object.isFrozen(a)&&(b=Object.create(a),Object.freeze(b));return b};goog.object.isImmutableView=function(a){return!!Object.isFrozen&&Object.isFrozen(a)};
goog.object.getAllPropertyNames=function(a,b,c){if(!a)return[];if(!Object.getOwnPropertyNames||!Object.getPrototypeOf)return goog.object.getKeys(a);for(var d={};a&&(a!==Object.prototype||b)&&(a!==Function.prototype||c);){for(var e=Object.getOwnPropertyNames(a),f=0;f<e.length;f++)d[e[f]]=!0;a=Object.getPrototypeOf(a)}return goog.object.getKeys(d)};goog.object.getSuperClass=function(a){return(a=Object.getPrototypeOf(a.prototype))&&a.constructor};goog.dom.tags={};goog.dom.tags.VOID_TAGS_={area:!0,base:!0,br:!0,col:!0,command:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0};goog.dom.tags.isVoidTag=function(a){return!0===goog.dom.tags.VOID_TAGS_[a]};goog.string={};goog.string.TypedString=function(){};goog.string.Const=function(a,b){this.stringConstValueWithSecurityContract__googStringSecurityPrivate_=a===goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_&&b||"";this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_=goog.string.Const.TYPE_MARKER_};goog.string.Const.prototype.implementsGoogStringTypedString=!0;goog.string.Const.prototype.getTypedStringValue=function(){return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_};
goog.DEBUG&&(goog.string.Const.prototype.toString=function(){return"Const{"+this.stringConstValueWithSecurityContract__googStringSecurityPrivate_+"}"});goog.string.Const.unwrap=function(a){if(a instanceof goog.string.Const&&a.constructor===goog.string.Const&&a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_===goog.string.Const.TYPE_MARKER_)return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;goog.asserts.fail("expected object of type Const, got '"+a+"'");return"type_error:Const"};
goog.string.Const.from=function(a){return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_,a)};goog.string.Const.TYPE_MARKER_={};goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_={};goog.string.Const.EMPTY=goog.string.Const.from("");goog.html={};goog.html.trustedtypes={};goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse=function(){if(!goog.TRUSTED_TYPES_POLICY_NAME)return null;void 0===goog.html.trustedtypes.cachedPolicy_&&(goog.html.trustedtypes.cachedPolicy_=goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME+"#html"));return goog.html.trustedtypes.cachedPolicy_};var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE={},module$contents$goog$html$SafeScript_SafeScript=function(a,b){this.privateDoNotAccessOrElseSafeScriptWrappedValue_=b===module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE?a:"";this.implementsGoogStringTypedString=!0};module$contents$goog$html$SafeScript_SafeScript.fromConstant=function(a){a=goog.string.Const.unwrap(a);return 0===a.length?module$contents$goog$html$SafeScript_SafeScript.EMPTY:module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a)};
module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs=function(a,b){for(var c=[],d=1;d<arguments.length;d++)c.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[d]));return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("("+goog.string.Const.unwrap(a)+")("+c.join(", ")+");")};module$contents$goog$html$SafeScript_SafeScript.fromJson=function(a){return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(a))};
module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString()};module$contents$goog$html$SafeScript_SafeScript.unwrap=function(a){return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(a).toString()};
module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript=function(a){if(a instanceof module$contents$goog$html$SafeScript_SafeScript&&a.constructor===module$contents$goog$html$SafeScript_SafeScript)return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;(0,goog.asserts.fail)("expected object of type SafeScript, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeScript"};
module$contents$goog$html$SafeScript_SafeScript.stringify_=function(a){return JSON.stringify(a).replace(/</g,"\\x3c")};module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse=function(a){var b=goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();a=b?b.createScript(a):a;return new module$contents$goog$html$SafeScript_SafeScript(a,module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE)};
goog.DEBUG&&(module$contents$goog$html$SafeScript_SafeScript.prototype.toString=function(){return"SafeScript{"+this.privateDoNotAccessOrElseSafeScriptWrappedValue_+"}"});module$contents$goog$html$SafeScript_SafeScript.EMPTY=function(){return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("")}();goog.html.SafeScript=module$contents$goog$html$SafeScript_SafeScript;goog.fs={};goog.fs.url={};goog.fs.url.createObjectUrl=function(a){return goog.fs.url.getUrlObject_().createObjectURL(a)};goog.fs.url.revokeObjectUrl=function(a){goog.fs.url.getUrlObject_().revokeObjectURL(a)};goog.fs.url.UrlObject_=function(){};goog.fs.url.UrlObject_.prototype.createObjectURL=function(a){};goog.fs.url.UrlObject_.prototype.revokeObjectURL=function(a){};
goog.fs.url.getUrlObject_=function(){var a=goog.fs.url.findUrlObject_();if(null!=a)return a;throw Error("This browser doesn't seem to support blob URLs");};goog.fs.url.findUrlObject_=function(){return void 0!==goog.global.URL&&void 0!==goog.global.URL.createObjectURL?goog.global.URL:void 0!==goog.global.webkitURL&&void 0!==goog.global.webkitURL.createObjectURL?goog.global.webkitURL:void 0!==goog.global.createObjectURL?goog.global:null};
goog.fs.url.browserSupportsObjectUrls=function(){return null!=goog.fs.url.findUrlObject_()};goog.fs.blob={};goog.fs.blob.getBlob=function(a){var b=goog.global.BlobBuilder||goog.global.WebKitBlobBuilder;if(void 0!==b){b=new b;for(var c=0;c<arguments.length;c++)b.append(arguments[c]);return b.getBlob()}return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments))};
goog.fs.blob.getBlobWithProperties=function(a,b,c){var d=goog.global.BlobBuilder||goog.global.WebKitBlobBuilder;if(void 0!==d){d=new d;for(var e=0;e<a.length;e++)d.append(a[e],c);return d.getBlob(b)}if(void 0!==goog.global.Blob)return d={},b&&(d.type=b),c&&(d.endings=c),new Blob(a,d);throw Error("This browser doesn't seem to support creating Blobs");};goog.i18n={};goog.i18n.bidi={};goog.i18n.bidi.FORCE_RTL=!1;
goog.i18n.bidi.IS_RTL=goog.i18n.bidi.FORCE_RTL||("ar"==goog.LOCALE.substring(0,2).toLowerCase()||"fa"==goog.LOCALE.substring(0,2).toLowerCase()||"he"==goog.LOCALE.substring(0,2).toLowerCase()||"iw"==goog.LOCALE.substring(0,2).toLowerCase()||"ps"==goog.LOCALE.substring(0,2).toLowerCase()||"sd"==goog.LOCALE.substring(0,2).toLowerCase()||"ug"==goog.LOCALE.substring(0,2).toLowerCase()||"ur"==goog.LOCALE.substring(0,2).toLowerCase()||"yi"==goog.LOCALE.substring(0,2).toLowerCase())&&(2==goog.LOCALE.length||
"-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))||3<=goog.LOCALE.length&&"ckb"==goog.LOCALE.substring(0,3).toLowerCase()&&(3==goog.LOCALE.length||"-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4))||7<=goog.LOCALE.length&&("-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))&&("adlm"==goog.LOCALE.substring(3,7).toLowerCase()||"arab"==goog.LOCALE.substring(3,7).toLowerCase()||"hebr"==goog.LOCALE.substring(3,7).toLowerCase()||"nkoo"==goog.LOCALE.substring(3,
7).toLowerCase()||"rohg"==goog.LOCALE.substring(3,7).toLowerCase()||"thaa"==goog.LOCALE.substring(3,7).toLowerCase())||8<=goog.LOCALE.length&&("-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4))&&("adlm"==goog.LOCALE.substring(4,8).toLowerCase()||"arab"==goog.LOCALE.substring(4,8).toLowerCase()||"hebr"==goog.LOCALE.substring(4,8).toLowerCase()||"nkoo"==goog.LOCALE.substring(4,8).toLowerCase()||"rohg"==goog.LOCALE.substring(4,8).toLowerCase()||"thaa"==goog.LOCALE.substring(4,8).toLowerCase());
goog.i18n.bidi.Format={LRE:"\u202a",RLE:"\u202b",PDF:"\u202c",LRM:"\u200e",RLM:"\u200f"};goog.i18n.bidi.Dir={LTR:1,RTL:-1,NEUTRAL:0};goog.i18n.bidi.RIGHT="right";goog.i18n.bidi.LEFT="left";goog.i18n.bidi.I18N_RIGHT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.LEFT:goog.i18n.bidi.RIGHT;goog.i18n.bidi.I18N_LEFT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT;
goog.i18n.bidi.toDir=function(a,b){return"number"==typeof a?0<a?goog.i18n.bidi.Dir.LTR:0>a?goog.i18n.bidi.Dir.RTL:b?null:goog.i18n.bidi.Dir.NEUTRAL:null==a?null:a?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR};goog.i18n.bidi.ltrChars_="A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0900-\u1fff\u200e\u2c00-\ud801\ud804-\ud839\ud83c-\udbff\uf900-\ufb1c\ufe00-\ufe6f\ufefd-\uffff";goog.i18n.bidi.rtlChars_="\u0591-\u06ef\u06fa-\u08ff\u200f\ud802-\ud803\ud83a-\ud83b\ufb1d-\ufdff\ufe70-\ufefc";
goog.i18n.bidi.htmlSkipReg_=/<[^>]*>|&[^;]+;/g;goog.i18n.bidi.stripHtmlIfNeeded_=function(a,b){return b?a.replace(goog.i18n.bidi.htmlSkipReg_,""):a};goog.i18n.bidi.rtlCharReg_=new RegExp("["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.ltrCharReg_=new RegExp("["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.hasAnyRtl=function(a,b){return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.hasRtlChar=goog.i18n.bidi.hasAnyRtl;
goog.i18n.bidi.hasAnyLtr=function(a,b){return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.ltrRe_=new RegExp("^["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlRe_=new RegExp("^["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.isRtlChar=function(a){return goog.i18n.bidi.rtlRe_.test(a)};goog.i18n.bidi.isLtrChar=function(a){return goog.i18n.bidi.ltrRe_.test(a)};goog.i18n.bidi.isNeutralChar=function(a){return!goog.i18n.bidi.isLtrChar(a)&&!goog.i18n.bidi.isRtlChar(a)};
goog.i18n.bidi.ltrDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.rtlChars_+"]*["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.ltrChars_+"]*["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.startsWithRtl=function(a,b){return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isRtlText=goog.i18n.bidi.startsWithRtl;
goog.i18n.bidi.startsWithLtr=function(a,b){return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isLtrText=goog.i18n.bidi.startsWithLtr;goog.i18n.bidi.isRequiredLtrRe_=/^http:\/\/.*/;goog.i18n.bidi.isNeutralText=function(a,b){a=goog.i18n.bidi.stripHtmlIfNeeded_(a,b);return goog.i18n.bidi.isRequiredLtrRe_.test(a)||!goog.i18n.bidi.hasAnyLtr(a)&&!goog.i18n.bidi.hasAnyRtl(a)};
goog.i18n.bidi.ltrExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.ltrChars_+"][^"+goog.i18n.bidi.rtlChars_+"]*$");goog.i18n.bidi.rtlExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.rtlChars_+"][^"+goog.i18n.bidi.ltrChars_+"]*$");goog.i18n.bidi.endsWithLtr=function(a,b){return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isLtrExitText=goog.i18n.bidi.endsWithLtr;
goog.i18n.bidi.endsWithRtl=function(a,b){return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isRtlExitText=goog.i18n.bidi.endsWithRtl;goog.i18n.bidi.rtlLocalesRe_=/^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;goog.i18n.bidi.isRtlLanguage=function(a){return goog.i18n.bidi.rtlLocalesRe_.test(a)};goog.i18n.bidi.bracketGuardTextRe_=/(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
goog.i18n.bidi.guardBracketInText=function(a,b){b=(void 0===b?goog.i18n.bidi.hasAnyRtl(a):b)?goog.i18n.bidi.Format.RLM:goog.i18n.bidi.Format.LRM;return a.replace(goog.i18n.bidi.bracketGuardTextRe_,b+"$&"+b)};goog.i18n.bidi.enforceRtlInHtml=function(a){return"<"==a.charAt(0)?a.replace(/<\w+/,"$& dir=rtl"):"\n<span dir=rtl>"+a+"</span>"};goog.i18n.bidi.enforceRtlInText=function(a){return goog.i18n.bidi.Format.RLE+a+goog.i18n.bidi.Format.PDF};
goog.i18n.bidi.enforceLtrInHtml=function(a){return"<"==a.charAt(0)?a.replace(/<\w+/,"$& dir=ltr"):"\n<span dir=ltr>"+a+"</span>"};goog.i18n.bidi.enforceLtrInText=function(a){return goog.i18n.bidi.Format.LRE+a+goog.i18n.bidi.Format.PDF};goog.i18n.bidi.dimensionsRe_=/:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;goog.i18n.bidi.leftRe_=/left/gi;goog.i18n.bidi.rightRe_=/right/gi;goog.i18n.bidi.tempRe_=/%%%%/g;
goog.i18n.bidi.mirrorCSS=function(a){return a.replace(goog.i18n.bidi.dimensionsRe_,":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_,"%%%%").replace(goog.i18n.bidi.rightRe_,goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_,goog.i18n.bidi.RIGHT)};goog.i18n.bidi.doubleQuoteSubstituteRe_=/([\u0591-\u05f2])"/g;goog.i18n.bidi.singleQuoteSubstituteRe_=/([\u0591-\u05f2])'/g;
goog.i18n.bidi.normalizeHebrewQuote=function(a){return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_,"$1\u05f4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_,"$1\u05f3")};goog.i18n.bidi.wordSeparatorRe_=/\s+/;goog.i18n.bidi.hasNumeralsRe_=/[\d\u06f0-\u06f9]/;goog.i18n.bidi.rtlDetectionThreshold_=.4;
goog.i18n.bidi.estimateDirection=function(a,b){var c=0,d=0,e=!1;a=goog.i18n.bidi.stripHtmlIfNeeded_(a,b).split(goog.i18n.bidi.wordSeparatorRe_);for(b=0;b<a.length;b++){var f=a[b];goog.i18n.bidi.startsWithRtl(f)?(c++,d++):goog.i18n.bidi.isRequiredLtrRe_.test(f)?e=!0:goog.i18n.bidi.hasAnyLtr(f)?d++:goog.i18n.bidi.hasNumeralsRe_.test(f)&&(e=!0)}return 0==d?e?goog.i18n.bidi.Dir.LTR:goog.i18n.bidi.Dir.NEUTRAL:c/d>goog.i18n.bidi.rtlDetectionThreshold_?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR};
goog.i18n.bidi.detectRtlDirectionality=function(a,b){return goog.i18n.bidi.estimateDirection(a,b)==goog.i18n.bidi.Dir.RTL};goog.i18n.bidi.setElementDirAndAlign=function(a,b){a&&(b=goog.i18n.bidi.toDir(b))&&(a.style.textAlign=b==goog.i18n.bidi.Dir.RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT,a.dir=b==goog.i18n.bidi.Dir.RTL?"rtl":"ltr")};
goog.i18n.bidi.setElementDirByTextDirectionality=function(a,b){switch(goog.i18n.bidi.estimateDirection(b)){case goog.i18n.bidi.Dir.LTR:"ltr"!==a.dir&&(a.dir="ltr");break;case goog.i18n.bidi.Dir.RTL:"rtl"!==a.dir&&(a.dir="rtl");break;default:a.removeAttribute("dir")}};goog.i18n.bidi.DirectionalString=function(){};goog.html.TrustedResourceUrl=function(a,b){this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_=b===goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_?a:""};goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString=!0;goog.html.TrustedResourceUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString()};goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;
goog.html.TrustedResourceUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR};goog.html.TrustedResourceUrl.prototype.cloneWithParams=function(a,b){var c=goog.html.TrustedResourceUrl.unwrap(this);c=goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);var d=c[3]||"";return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1]+goog.html.TrustedResourceUrl.stringifyParams_("?",c[2]||"",a)+goog.html.TrustedResourceUrl.stringifyParams_("#",d,b))};
goog.DEBUG&&(goog.html.TrustedResourceUrl.prototype.toString=function(){return"TrustedResourceUrl{"+this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_+"}"});goog.html.TrustedResourceUrl.unwrap=function(a){return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString()};
goog.html.TrustedResourceUrl.unwrapTrustedScriptURL=function(a){if(a instanceof goog.html.TrustedResourceUrl&&a.constructor===goog.html.TrustedResourceUrl)return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;goog.asserts.fail("expected object of type TrustedResourceUrl, got '"+a+"' of type "+goog.typeOf(a));return"type_error:TrustedResourceUrl"};
goog.html.TrustedResourceUrl.format=function(a,b){var c=goog.string.Const.unwrap(a);if(!goog.html.TrustedResourceUrl.BASE_URL_.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof goog.string.Const?goog.string.Const.unwrap(d):
encodeURIComponent(String(d))});return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.TrustedResourceUrl.FORMAT_MARKER_=/%{(\w+)}/g;goog.html.TrustedResourceUrl.BASE_URL_=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;goog.html.TrustedResourceUrl.URL_PARAM_PARSER_=/^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
goog.html.TrustedResourceUrl.formatWithParams=function(a,b,c,d){return goog.html.TrustedResourceUrl.format(a,b).cloneWithParams(c,d)};goog.html.TrustedResourceUrl.fromConstant=function(a){return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a))};goog.html.TrustedResourceUrl.fromConstants=function(a){for(var b="",c=0;c<a.length;c++)b+=goog.string.Const.unwrap(a[c]);return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b)};
goog.html.TrustedResourceUrl.fromSafeScript=function(a){a=goog.fs.blob.getBlobWithProperties([module$contents$goog$html$SafeScript_SafeScript.unwrap(a)],"text/javascript");a=goog.fs.url.createObjectUrl(a);return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_={};
goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse=function(a){var b=goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();a=b?b.createScriptURL(a):a;return new goog.html.TrustedResourceUrl(a,goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_)};
goog.html.TrustedResourceUrl.stringifyParams_=function(a,b,c){if(null==c)return b;if("string"===typeof c)return c?a+encodeURIComponent(c):"";for(var d in c)if(Object.prototype.hasOwnProperty.call(c,d)){var e=c[d];e=Array.isArray(e)?e:[e];for(var f=0;f<e.length;f++){var g=e[f];null!=g&&(b||(b=a),b+=(b.length>a.length?"&":"")+encodeURIComponent(d)+"="+encodeURIComponent(String(g)))}}return b};goog.string.internal={};goog.string.internal.startsWith=function(a,b){return 0==a.lastIndexOf(b,0)};goog.string.internal.endsWith=function(a,b){var c=a.length-b.length;return 0<=c&&a.indexOf(b,c)==c};goog.string.internal.caseInsensitiveStartsWith=function(a,b){return 0==goog.string.internal.caseInsensitiveCompare(b,a.substr(0,b.length))};goog.string.internal.caseInsensitiveEndsWith=function(a,b){return 0==goog.string.internal.caseInsensitiveCompare(b,a.substr(a.length-b.length,b.length))};
goog.string.internal.caseInsensitiveEquals=function(a,b){return a.toLowerCase()==b.toLowerCase()};goog.string.internal.isEmptyOrWhitespace=function(a){return/^[\s\xa0]*$/.test(a)};goog.string.internal.trim=goog.TRUSTED_SITE&&String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};goog.string.internal.caseInsensitiveCompare=function(a,b){a=String(a).toLowerCase();b=String(b).toLowerCase();return a<b?-1:a==b?0:1};
goog.string.internal.newLineToBr=function(a,b){return a.replace(/(\r\n|\r|\n)/g,b?"<br />":"<br>")};
goog.string.internal.htmlEscape=function(a,b){if(b)a=a.replace(goog.string.internal.AMP_RE_,"&amp;").replace(goog.string.internal.LT_RE_,"&lt;").replace(goog.string.internal.GT_RE_,"&gt;").replace(goog.string.internal.QUOT_RE_,"&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_,"&#39;").replace(goog.string.internal.NULL_RE_,"&#0;");else{if(!goog.string.internal.ALL_RE_.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(goog.string.internal.AMP_RE_,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(goog.string.internal.LT_RE_,
"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(goog.string.internal.GT_RE_,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(goog.string.internal.QUOT_RE_,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(goog.string.internal.SINGLE_QUOTE_RE_,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(goog.string.internal.NULL_RE_,"&#0;"))}return a};goog.string.internal.AMP_RE_=/&/g;goog.string.internal.LT_RE_=/</g;goog.string.internal.GT_RE_=/>/g;goog.string.internal.QUOT_RE_=/"/g;goog.string.internal.SINGLE_QUOTE_RE_=/'/g;
goog.string.internal.NULL_RE_=/\x00/g;goog.string.internal.ALL_RE_=/[\x00&<>"']/;goog.string.internal.whitespaceEscape=function(a,b){return goog.string.internal.newLineToBr(a.replace(/  /g," &#160;"),b)};goog.string.internal.contains=function(a,b){return-1!=a.indexOf(b)};goog.string.internal.caseInsensitiveContains=function(a,b){return goog.string.internal.contains(a.toLowerCase(),b.toLowerCase())};
goog.string.internal.compareVersions=function(a,b){var c=0;a=goog.string.internal.trim(String(a)).split(".");b=goog.string.internal.trim(String(b)).split(".");for(var d=Math.max(a.length,b.length),e=0;0==c&&e<d;e++){var f=a[e]||"",g=b[e]||"";do{f=/(\d*)(\D*)(.*)/.exec(f)||["","","",""];g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];if(0==f[0].length&&0==g[0].length)break;c=0==f[1].length?0:parseInt(f[1],10);var h=0==g[1].length?0:parseInt(g[1],10);c=goog.string.internal.compareElements_(c,h)||goog.string.internal.compareElements_(0==
f[2].length,0==g[2].length)||goog.string.internal.compareElements_(f[2],g[2]);f=f[3];g=g[3]}while(0==c)}return c};goog.string.internal.compareElements_=function(a,b){return a<b?-1:a>b?1:0};goog.html.SafeUrl=function(a,b){this.privateDoNotAccessOrElseSafeUrlWrappedValue_=b===goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_?a:""};goog.html.SafeUrl.INNOCUOUS_STRING="about:invalid#zClosurez";goog.html.SafeUrl.prototype.implementsGoogStringTypedString=!0;goog.html.SafeUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString()};goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;
goog.html.SafeUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR};goog.DEBUG&&(goog.html.SafeUrl.prototype.toString=function(){return"SafeUrl{"+this.privateDoNotAccessOrElseSafeUrlWrappedValue_+"}"});goog.html.SafeUrl.unwrap=function(a){if(a instanceof goog.html.SafeUrl&&a.constructor===goog.html.SafeUrl)return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;goog.asserts.fail("expected object of type SafeUrl, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeUrl"};
goog.html.SafeUrl.fromConstant=function(a){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a))};goog.html.SAFE_MIME_TYPE_PATTERN_=/^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i;goog.html.SafeUrl.isSafeMimeType=function(a){return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a)};
goog.html.SafeUrl.fromBlob=function(a){a=goog.html.SafeUrl.isSafeMimeType(a.type)?goog.fs.url.createObjectUrl(a):goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.revokeObjectUrl=function(a){a=a.getTypedStringValue();a!==goog.html.SafeUrl.INNOCUOUS_STRING&&goog.fs.url.revokeObjectUrl(a)};
goog.html.SafeUrl.fromMediaSource=function(a){goog.asserts.assert("MediaSource"in goog.global,"No support for MediaSource");a=a instanceof MediaSource?goog.fs.url.createObjectUrl(a):goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.DATA_URL_PATTERN_=/^data:(.*);base64,[a-z0-9+\/]+=*$/i;
goog.html.SafeUrl.tryFromDataUrl=function(a){a=String(a);a=a.replace(/(%0A|%0D)/g,"");var b=a.match(goog.html.DATA_URL_PATTERN_);return b&&goog.html.SafeUrl.isSafeMimeType(b[1])?goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a):null};goog.html.SafeUrl.fromDataUrl=function(a){return goog.html.SafeUrl.tryFromDataUrl(a)||goog.html.SafeUrl.INNOCUOUS_URL};
goog.html.SafeUrl.fromTelUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"tel:")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SIP_URL_PATTERN_=/^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;goog.html.SafeUrl.fromSipUrl=function(a){goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a))||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.fromFacebookMessengerUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"fb-messenger://share")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.fromWhatsAppUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"whatsapp://send")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.fromSmsUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"sms:")&&goog.html.SafeUrl.isSmsUrlBodyValid_(a)||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.isSmsUrlBodyValid_=function(a){var b=a.indexOf("#");0<b&&(a=a.substring(0,b));b=a.match(/[?&]body=/gi);if(!b)return!0;if(1<b.length)return!1;a=a.match(/[?&]body=([^&]*)/)[1];if(!a)return!0;try{decodeURIComponent(a)}catch(c){return!1}return/^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a)};
goog.html.SafeUrl.fromSshUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"ssh://")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.sanitizeChromeExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//,a,b)};
goog.html.SafeUrl.sanitizeFirefoxExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//,a,b)};goog.html.SafeUrl.sanitizeEdgeExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//,a,b)};
goog.html.SafeUrl.sanitizeExtensionUrl_=function(a,b,c){(a=a.exec(b))?(a=a[1],-1==(c instanceof goog.string.Const?[goog.string.Const.unwrap(c)]:c.map(function(d){return goog.string.Const.unwrap(d)})).indexOf(a)&&(b=goog.html.SafeUrl.INNOCUOUS_STRING)):b=goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b)};goog.html.SafeUrl.fromTrustedResourceUrl=function(a){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a))};
goog.html.SAFE_URL_PATTERN_=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;goog.html.SafeUrl.SAFE_URL_PATTERN=goog.html.SAFE_URL_PATTERN_;goog.html.SafeUrl.trySanitize=function(a){if(a instanceof goog.html.SafeUrl)return a;a="object"==typeof a&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);return goog.html.SAFE_URL_PATTERN_.test(a)?goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a):goog.html.SafeUrl.tryFromDataUrl(a)};
goog.html.SafeUrl.sanitize=function(a){return goog.html.SafeUrl.trySanitize(a)||goog.html.SafeUrl.INNOCUOUS_URL};
goog.html.SafeUrl.sanitizeAssertUnchanged=function(a,b){if(a instanceof goog.html.SafeUrl)return a;a="object"==typeof a&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);if(b&&/^data:/i.test(a)&&(b=goog.html.SafeUrl.fromDataUrl(a),b.getTypedStringValue()==a))return b;goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a),"%s does not match the safe URL pattern",a)||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_={};goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse=function(a){return new goog.html.SafeUrl(a,goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_)};goog.html.SafeUrl.INNOCUOUS_URL=goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING);goog.html.SafeUrl.ABOUT_BLANK=goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");goog.html.SafeStyle=function(a,b){this.privateDoNotAccessOrElseSafeStyleWrappedValue_=b===goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_?a:""};goog.html.SafeStyle.prototype.implementsGoogStringTypedString=!0;
goog.html.SafeStyle.fromConstant=function(a){a=goog.string.Const.unwrap(a);if(0===a.length)return goog.html.SafeStyle.EMPTY;goog.asserts.assert(goog.string.internal.endsWith(a,";"),"Last character of style string is not ';': "+a);goog.asserts.assert(goog.string.internal.contains(a,":"),"Style string must contain at least one ':', to specify a \"name: value\" pair: "+a);return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeStyle.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleWrappedValue_};goog.DEBUG&&(goog.html.SafeStyle.prototype.toString=function(){return"SafeStyle{"+this.privateDoNotAccessOrElseSafeStyleWrappedValue_+"}"});
goog.html.SafeStyle.unwrap=function(a){if(a instanceof goog.html.SafeStyle&&a.constructor===goog.html.SafeStyle)return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;goog.asserts.fail("expected object of type SafeStyle, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeStyle"};goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_={};goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse=function(a){return new goog.html.SafeStyle(a,goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_)};
goog.html.SafeStyle.EMPTY=goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyle.INNOCUOUS_STRING="zClosurez";
goog.html.SafeStyle.create=function(a){var b="",c;for(c in a)if(Object.prototype.hasOwnProperty.call(a,c)){if(!/^[-_a-zA-Z0-9]+$/.test(c))throw Error("Name allows only [-_a-zA-Z0-9], got: "+c);var d=a[c];null!=d&&(d=Array.isArray(d)?module$contents$goog$array_map(d,goog.html.SafeStyle.sanitizePropertyValue_).join(" "):goog.html.SafeStyle.sanitizePropertyValue_(d),b+=c+":"+d+";")}return b?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b):goog.html.SafeStyle.EMPTY};
goog.html.SafeStyle.sanitizePropertyValue_=function(a){if(a instanceof goog.html.SafeUrl)return'url("'+goog.html.SafeUrl.unwrap(a).replace(/</g,"%3c").replace(/[\\"]/g,"\\$&")+'")';a=a instanceof goog.string.Const?goog.string.Const.unwrap(a):goog.html.SafeStyle.sanitizePropertyValueString_(String(a));if(/[{;}]/.test(a))throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.",[a]);return a};
goog.html.SafeStyle.sanitizePropertyValueString_=function(a){var b=a.replace(goog.html.SafeStyle.FUNCTIONS_RE_,"$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_,"$1").replace(goog.html.SafeStyle.URL_RE_,"url");if(goog.html.SafeStyle.VALUE_RE_.test(b)){if(goog.html.SafeStyle.COMMENT_RE_.test(a))return goog.asserts.fail("String value disallows comments, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING;if(!goog.html.SafeStyle.hasBalancedQuotes_(a))return goog.asserts.fail("String value requires balanced quotes, got: "+
a),goog.html.SafeStyle.INNOCUOUS_STRING;if(!goog.html.SafeStyle.hasBalancedSquareBrackets_(a))return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING}else return goog.asserts.fail("String value allows only "+goog.html.SafeStyle.VALUE_ALLOWED_CHARS_+" and simple functions, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING;return goog.html.SafeStyle.sanitizeUrl_(a)};
goog.html.SafeStyle.hasBalancedQuotes_=function(a){for(var b=!0,c=!0,d=0;d<a.length;d++){var e=a.charAt(d);"'"==e&&c?b=!b:'"'==e&&b&&(c=!c)}return b&&c};goog.html.SafeStyle.hasBalancedSquareBrackets_=function(a){for(var b=!0,c=/^[-_a-zA-Z0-9]$/,d=0;d<a.length;d++){var e=a.charAt(d);if("]"==e){if(b)return!1;b=!0}else if("["==e){if(!b)return!1;b=!1}else if(!b&&!c.test(e))return!1}return b};goog.html.SafeStyle.VALUE_ALLOWED_CHARS_="[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
goog.html.SafeStyle.VALUE_RE_=new RegExp("^"+goog.html.SafeStyle.VALUE_ALLOWED_CHARS_+"+$");goog.html.SafeStyle.URL_RE_=/\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;goog.html.SafeStyle.ALLOWED_FUNCTIONS_="calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" ");
goog.html.SafeStyle.FUNCTIONS_RE_=new RegExp("\\b("+goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|")+")\\([-+*/0-9a-z.%\\[\\], ]+\\)","g");goog.html.SafeStyle.COMMENT_RE_=/\/\*/;goog.html.SafeStyle.sanitizeUrl_=function(a){return a.replace(goog.html.SafeStyle.URL_RE_,function(b,c,d,e){var f="";d=d.replace(/^(['"])(.*)\1$/,function(g,h,k){f=h;return k});b=goog.html.SafeUrl.sanitize(d).getTypedStringValue();return c+f+b+f+e})};
goog.html.SafeStyle.concat=function(a){var b="",c=function(d){Array.isArray(d)?module$contents$goog$array_forEach(d,c):b+=goog.html.SafeStyle.unwrap(d)};module$contents$goog$array_forEach(arguments,c);return b?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b):goog.html.SafeStyle.EMPTY};var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE={},module$contents$goog$html$SafeStyleSheet_SafeStyleSheet=function(a,b){this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_=b===module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE?a:"";this.implementsGoogStringTypedString=!0};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule=function(a,b){if((0,goog.string.internal.contains)(a,"<"))throw Error("Selector does not allow '<', got: "+a);var c=a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g,"");if(!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c))throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: "+a);if(!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(c))throw Error("() and [] in selector must be balanced, got: "+
a);b instanceof goog.html.SafeStyle||(b=goog.html.SafeStyle.create(b));a=a+"{"+goog.html.SafeStyle.unwrap(b).replace(/</g,"\\3C ")+"}";return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a)};module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_=function(a){for(var b={"(":")","[":"]"},c=[],d=0;d<a.length;d++){var e=a[d];if(b[e])c.push(b[e]);else if(goog.object.contains(b,e)&&c.pop()!=e)return!1}return 0==c.length};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat=function(a){var b="",c=function(d){Array.isArray(d)?module$contents$goog$array_forEach(d,c):b+=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(d)};module$contents$goog$array_forEach(arguments,c);return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b)};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant=function(a){a=goog.string.Const.unwrap(a);if(0===a.length)return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY;(0,goog.asserts.assert)(!(0,goog.string.internal.contains)(a,"<"),"Forbidden '<' character in style sheet string: "+a);return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a)};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap=function(a){if(a instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet&&a.constructor===module$contents$goog$html$SafeStyleSheet_SafeStyleSheet)return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;(0,goog.asserts.fail)("expected object of type SafeStyleSheet, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeStyleSheet"};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse=function(a){return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(a,module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE)};goog.DEBUG&&(module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString=function(){return"SafeStyleSheet{"+this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_+"}"});
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyleSheet=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet;goog.labs={};goog.labs.userAgent={};goog.labs.userAgent.util={};goog.labs.userAgent.util.getNativeUserAgentString_=function(){var a=goog.labs.userAgent.util.getNavigator_();return a&&(a=a.userAgent)?a:""};goog.labs.userAgent.util.getNavigator_=function(){return goog.global.navigator};goog.labs.userAgent.util.userAgent_=goog.labs.userAgent.util.getNativeUserAgentString_();goog.labs.userAgent.util.setUserAgent=function(a){goog.labs.userAgent.util.userAgent_=a||goog.labs.userAgent.util.getNativeUserAgentString_()};
goog.labs.userAgent.util.getUserAgent=function(){return goog.labs.userAgent.util.userAgent_};goog.labs.userAgent.util.matchUserAgent=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.internal.contains(b,a)};goog.labs.userAgent.util.matchUserAgentIgnoreCase=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.internal.caseInsensitiveContains(b,a)};
goog.labs.userAgent.util.extractVersionTuples=function(a){for(var b=/(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g,c=[],d;d=b.exec(a);)c.push([d[1],d[2],d[3]||void 0]);return c};goog.labs.userAgent.browser={};goog.labs.userAgent.browser.matchOpera_=function(){return goog.labs.userAgent.util.matchUserAgent("Opera")};goog.labs.userAgent.browser.matchIE_=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE")};goog.labs.userAgent.browser.matchEdgeHtml_=function(){return goog.labs.userAgent.util.matchUserAgent("Edge")};goog.labs.userAgent.browser.matchEdgeChromium_=function(){return goog.labs.userAgent.util.matchUserAgent("Edg/")};
goog.labs.userAgent.browser.matchOperaChromium_=function(){return goog.labs.userAgent.util.matchUserAgent("OPR")};goog.labs.userAgent.browser.matchFirefox_=function(){return goog.labs.userAgent.util.matchUserAgent("Firefox")||goog.labs.userAgent.util.matchUserAgent("FxiOS")};
goog.labs.userAgent.browser.matchSafari_=function(){return goog.labs.userAgent.util.matchUserAgent("Safari")&&!(goog.labs.userAgent.browser.matchChrome_()||goog.labs.userAgent.browser.matchCoast_()||goog.labs.userAgent.browser.matchOpera_()||goog.labs.userAgent.browser.matchEdgeHtml_()||goog.labs.userAgent.browser.matchEdgeChromium_()||goog.labs.userAgent.browser.matchOperaChromium_()||goog.labs.userAgent.browser.matchFirefox_()||goog.labs.userAgent.browser.isSilk()||goog.labs.userAgent.util.matchUserAgent("Android"))};
goog.labs.userAgent.browser.matchCoast_=function(){return goog.labs.userAgent.util.matchUserAgent("Coast")};goog.labs.userAgent.browser.matchIosWebview_=function(){return(goog.labs.userAgent.util.matchUserAgent("iPad")||goog.labs.userAgent.util.matchUserAgent("iPhone"))&&!goog.labs.userAgent.browser.matchSafari_()&&!goog.labs.userAgent.browser.matchChrome_()&&!goog.labs.userAgent.browser.matchCoast_()&&!goog.labs.userAgent.browser.matchFirefox_()&&goog.labs.userAgent.util.matchUserAgent("AppleWebKit")};
goog.labs.userAgent.browser.matchChrome_=function(){return(goog.labs.userAgent.util.matchUserAgent("Chrome")||goog.labs.userAgent.util.matchUserAgent("CriOS"))&&!goog.labs.userAgent.browser.matchEdgeHtml_()};goog.labs.userAgent.browser.matchAndroidBrowser_=function(){return goog.labs.userAgent.util.matchUserAgent("Android")&&!(goog.labs.userAgent.browser.isChrome()||goog.labs.userAgent.browser.isFirefox()||goog.labs.userAgent.browser.isOpera()||goog.labs.userAgent.browser.isSilk())};
goog.labs.userAgent.browser.isOpera=goog.labs.userAgent.browser.matchOpera_;goog.labs.userAgent.browser.isIE=goog.labs.userAgent.browser.matchIE_;goog.labs.userAgent.browser.isEdge=goog.labs.userAgent.browser.matchEdgeHtml_;goog.labs.userAgent.browser.isEdgeChromium=goog.labs.userAgent.browser.matchEdgeChromium_;goog.labs.userAgent.browser.isOperaChromium=goog.labs.userAgent.browser.matchOperaChromium_;goog.labs.userAgent.browser.isFirefox=goog.labs.userAgent.browser.matchFirefox_;
goog.labs.userAgent.browser.isSafari=goog.labs.userAgent.browser.matchSafari_;goog.labs.userAgent.browser.isCoast=goog.labs.userAgent.browser.matchCoast_;goog.labs.userAgent.browser.isIosWebview=goog.labs.userAgent.browser.matchIosWebview_;goog.labs.userAgent.browser.isChrome=goog.labs.userAgent.browser.matchChrome_;goog.labs.userAgent.browser.isAndroidBrowser=goog.labs.userAgent.browser.matchAndroidBrowser_;goog.labs.userAgent.browser.isSilk=function(){return goog.labs.userAgent.util.matchUserAgent("Silk")};
goog.labs.userAgent.browser.getVersion=function(){function a(e){e=module$contents$goog$array_find(e,d);return c[e]||""}var b=goog.labs.userAgent.util.getUserAgent();if(goog.labs.userAgent.browser.isIE())return goog.labs.userAgent.browser.getIEVersion_(b);b=goog.labs.userAgent.util.extractVersionTuples(b);var c={};module$contents$goog$array_forEach(b,function(e){c[e[0]]=e[1]});var d=goog.partial(goog.object.containsKey,c);return goog.labs.userAgent.browser.isOpera()?a(["Version","Opera"]):goog.labs.userAgent.browser.isEdge()?
a(["Edge"]):goog.labs.userAgent.browser.isEdgeChromium()?a(["Edg"]):goog.labs.userAgent.browser.isChrome()?a(["Chrome","CriOS","HeadlessChrome"]):(b=b[2])&&b[1]||""};goog.labs.userAgent.browser.isVersionOrHigher=function(a){return 0<=goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(),a)};
goog.labs.userAgent.browser.getIEVersion_=function(a){var b=/rv: *([\d\.]*)/.exec(a);if(b&&b[1])return b[1];b="";var c=/MSIE +([\d\.]+)/.exec(a);if(c&&c[1])if(a=/Trident\/(\d.\d)/.exec(a),"7.0"==c[1])if(a&&a[1])switch(a[1]){case "4.0":b="8.0";break;case "5.0":b="9.0";break;case "6.0":b="10.0";break;case "7.0":b="11.0"}else b="7.0";else b=c[1];return b};goog.html.SafeHtml=function(a,b,c){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_=c===goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_?a:"";this.dir_=b};goog.html.SafeHtml.ENABLE_ERROR_MESSAGES=goog.DEBUG;goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE=!0;goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.SafeHtml.prototype.getDirection=function(){return this.dir_};goog.html.SafeHtml.prototype.implementsGoogStringTypedString=!0;
goog.html.SafeHtml.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString()};goog.DEBUG&&(goog.html.SafeHtml.prototype.toString=function(){return"SafeHtml{"+this.privateDoNotAccessOrElseSafeHtmlWrappedValue_+"}"});goog.html.SafeHtml.unwrap=function(a){return goog.html.SafeHtml.unwrapTrustedHTML(a).toString()};
goog.html.SafeHtml.unwrapTrustedHTML=function(a){if(a instanceof goog.html.SafeHtml&&a.constructor===goog.html.SafeHtml)return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;goog.asserts.fail("expected object of type SafeHtml, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeHtml"};
goog.html.SafeHtml.htmlEscape=function(a){if(a instanceof goog.html.SafeHtml)return a;var b="object"==typeof a,c=null;b&&a.implementsGoogI18nBidiDirectionalString&&(c=a.getDirection());a=b&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a),c)};
goog.html.SafeHtml.htmlEscapePreservingNewlines=function(a){if(a instanceof goog.html.SafeHtml)return a;a=goog.html.SafeHtml.htmlEscape(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)),a.getDirection())};
goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces=function(a){if(a instanceof goog.html.SafeHtml)return a;a=goog.html.SafeHtml.htmlEscape(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)),a.getDirection())};goog.html.SafeHtml.from=goog.html.SafeHtml.htmlEscape;
goog.html.SafeHtml.comment=function(a){return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("\x3c!--"+goog.string.internal.htmlEscape(a)+"--\x3e",null)};goog.html.SafeHtml.VALID_NAMES_IN_TAG_=/^[a-zA-Z0-9-]+$/;goog.html.SafeHtml.URL_ATTRIBUTES_={action:!0,cite:!0,data:!0,formaction:!0,href:!0,manifest:!0,poster:!0,src:!0};
goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_=goog.object.createSet(goog.dom.TagName.APPLET,goog.dom.TagName.BASE,goog.dom.TagName.EMBED,goog.dom.TagName.IFRAME,goog.dom.TagName.LINK,goog.dom.TagName.MATH,goog.dom.TagName.META,goog.dom.TagName.OBJECT,goog.dom.TagName.SCRIPT,goog.dom.TagName.STYLE,goog.dom.TagName.SVG,goog.dom.TagName.TEMPLATE);
goog.html.SafeHtml.create=function(a,b,c){goog.html.SafeHtml.verifyTagName(String(a));return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a),b,c)};
goog.html.SafeHtml.verifyTagName=function(a){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?"Invalid tag name <"+a+">.":"");if(a.toUpperCase()in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_)throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?"Tag name <"+a+"> is not allowed for SafeHtml.":"");};
goog.html.SafeHtml.createIframe=function(a,b,c,d){a&&goog.html.TrustedResourceUrl.unwrap(a);var e={};e.src=a||null;e.srcdoc=b&&goog.html.SafeHtml.unwrap(b);a=goog.html.SafeHtml.combineAttributes(e,{sandbox:""},c);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",a,d)};
goog.html.SafeHtml.createSandboxIframe=function(a,b,c,d){if(!goog.html.SafeHtml.canUseSandboxIframe())throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?"The browser does not support sandboxed iframes.":"");var e={};e.src=a?goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)):null;e.srcdoc=b||null;e.sandbox="";a=goog.html.SafeHtml.combineAttributes(e,{},c);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",a,d)};
goog.html.SafeHtml.canUseSandboxIframe=function(){return goog.global.HTMLIFrameElement&&"sandbox"in goog.global.HTMLIFrameElement.prototype};goog.html.SafeHtml.createScriptSrc=function(a,b){goog.html.TrustedResourceUrl.unwrap(a);a=goog.html.SafeHtml.combineAttributes({src:a},{},b);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",a)};
goog.html.SafeHtml.createScript=function(a,b){for(var c in b)if(Object.prototype.hasOwnProperty.call(b,c)){var d=c.toLowerCase();if("language"==d||"src"==d||"text"==d||"type"==d)throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Cannot set "'+d+'" attribute':"");}c="";a=module$contents$goog$array_concat(a);for(d=0;d<a.length;d++)c+=module$contents$goog$html$SafeScript_SafeScript.unwrap(a[d]);a=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",
b,a)};goog.html.SafeHtml.createStyle=function(a,b){b=goog.html.SafeHtml.combineAttributes({type:"text/css"},{},b);var c="";a=module$contents$goog$array_concat(a);for(var d=0;d<a.length;d++)c+=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(a[d]);a=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style",b,a)};
goog.html.SafeHtml.createMetaRefresh=function(a,b){a=goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));(goog.labs.userAgent.browser.isIE()||goog.labs.userAgent.browser.isEdge())&&goog.string.internal.contains(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'");return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta",{"http-equiv":"refresh",content:(b||0)+"; url="+a})};
goog.html.SafeHtml.getAttrNameAndValue_=function(a,b,c){if(c instanceof goog.string.Const)c=goog.string.Const.unwrap(c);else if("style"==b.toLowerCase())if(goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE)c=goog.html.SafeHtml.getStyleValue_(c);else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Attribute "style" not supported.':"");else{if(/^on/i.test(b))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Attribute "'+b+'" requires goog.string.Const value, "'+c+'" given.':"");if(b.toLowerCase()in
goog.html.SafeHtml.URL_ATTRIBUTES_)if(c instanceof goog.html.TrustedResourceUrl)c=goog.html.TrustedResourceUrl.unwrap(c);else if(c instanceof goog.html.SafeUrl)c=goog.html.SafeUrl.unwrap(c);else if("string"===typeof c)c=goog.html.SafeUrl.sanitize(c).getTypedStringValue();else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Attribute "'+b+'" on tag "'+a+'" requires goog.html.SafeUrl, goog.string.Const, or string, value "'+c+'" given.':"");}c.implementsGoogStringTypedString&&(c=c.getTypedStringValue());
goog.asserts.assert("string"===typeof c||"number"===typeof c,"String or number value expected, got "+typeof c+" with value: "+c);return b+'="'+goog.string.internal.htmlEscape(String(c))+'"'};goog.html.SafeHtml.getStyleValue_=function(a){if(!goog.isObject(a))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'The "style" attribute requires goog.html.SafeStyle or map of style properties, '+typeof a+" given: "+a:"");a instanceof goog.html.SafeStyle||(a=goog.html.SafeStyle.create(a));return goog.html.SafeStyle.unwrap(a)};
goog.html.SafeHtml.createWithDir=function(a,b,c,d){b=goog.html.SafeHtml.create(b,c,d);b.dir_=a;return b};
goog.html.SafeHtml.join=function(a,b){a=goog.html.SafeHtml.htmlEscape(a);var c=a.getDirection(),d=[],e=function(f){Array.isArray(f)?module$contents$goog$array_forEach(f,e):(f=goog.html.SafeHtml.htmlEscape(f),d.push(goog.html.SafeHtml.unwrap(f)),f=f.getDirection(),c==goog.i18n.bidi.Dir.NEUTRAL?c=f:f!=goog.i18n.bidi.Dir.NEUTRAL&&c!=f&&(c=null))};module$contents$goog$array_forEach(b,e);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)),c)};
goog.html.SafeHtml.concat=function(a){return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY,Array.prototype.slice.call(arguments))};goog.html.SafeHtml.concatWithDir=function(a,b){var c=goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments,1));c.dir_=a;return c};goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_={};
goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse=function(a,b){var c=goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();a=c?c.createHTML(a):a;return new goog.html.SafeHtml(a,b,goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_)};
goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse=function(a,b,c){var d=null;var e="<"+a+goog.html.SafeHtml.stringifyAttributes(a,b);null==c?c=[]:Array.isArray(c)||(c=[c]);goog.dom.tags.isVoidTag(a.toLowerCase())?(goog.asserts.assert(!c.length,"Void tag <"+a+"> does not allow content."),e+=">"):(d=goog.html.SafeHtml.concat(c),e+=">"+goog.html.SafeHtml.unwrap(d)+"</"+a+">",d=d.getDirection());(a=b&&b.dir)&&(d=/^(ltr|rtl|auto)$/i.test(a)?goog.i18n.bidi.Dir.NEUTRAL:null);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e,
d)};goog.html.SafeHtml.stringifyAttributes=function(a,b){var c="";if(b)for(var d in b)if(Object.prototype.hasOwnProperty.call(b,d)){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Invalid attribute name "'+d+'".':"");var e=b[d];null!=e&&(c+=" "+goog.html.SafeHtml.getAttrNameAndValue_(a,d,e))}return c};
goog.html.SafeHtml.combineAttributes=function(a,b,c){var d={},e;for(e in a)Object.prototype.hasOwnProperty.call(a,e)&&(goog.asserts.assert(e.toLowerCase()==e,"Must be lower case"),d[e]=a[e]);for(e in b)Object.prototype.hasOwnProperty.call(b,e)&&(goog.asserts.assert(e.toLowerCase()==e,"Must be lower case"),d[e]=b[e]);if(c)for(e in c)if(Object.prototype.hasOwnProperty.call(c,e)){var f=e.toLowerCase();if(f in a)throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Cannot override "'+f+'" attribute, got "'+
e+'" with value "'+c[e]+'"':"");f in b&&delete d[f];d[e]=c[e]}return d};goog.html.SafeHtml.DOCTYPE_HTML=function(){return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>",goog.i18n.bidi.Dir.NEUTRAL)}();goog.html.SafeHtml.EMPTY=new goog.html.SafeHtml(goog.global.trustedTypes&&goog.global.trustedTypes.emptyHTML||"",goog.i18n.bidi.Dir.NEUTRAL,goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
goog.html.SafeHtml.BR=function(){return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>",goog.i18n.bidi.Dir.NEUTRAL)}();goog.html.uncheckedconversions={};goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract=function(a,b,c){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b,c||null)};
goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b)};goog.dom.safe={};goog.dom.safe.InsertAdjacentHtmlPosition={AFTERBEGIN:"afterbegin",AFTEREND:"afterend",BEFOREBEGIN:"beforebegin",BEFOREEND:"beforeend"};goog.dom.safe.insertAdjacentHtml=function(a,b,c){a.insertAdjacentHTML(b,goog.html.SafeHtml.unwrapTrustedHTML(c))};goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_={MATH:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};
goog.dom.safe.isInnerHtmlCleanupRecursive_=goog.functions.cacheReturnValue(function(){if(goog.DEBUG&&"undefined"===typeof document)return!1;var a=document.createElement("div"),b=document.createElement("div");b.appendChild(document.createElement("div"));a.appendChild(b);if(goog.DEBUG&&!a.firstChild)return!1;b=a.firstChild.firstChild;a.innerHTML=goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);return!b.parentElement});
goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse=function(a,b){if(goog.dom.safe.isInnerHtmlCleanupRecursive_())for(;a.lastChild;)a.removeChild(a.lastChild);a.innerHTML=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setInnerHtml=function(a,b){if(goog.asserts.ENABLE_ASSERTS&&a.tagName){var c=a.tagName.toUpperCase();if(goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c])throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of "+a.tagName+".");}goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a,b)};
goog.dom.safe.setInnerHtmlFromConstant=function(a,b){goog.dom.safe.setInnerHtml(a,goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML to be immediatelly used."),goog.string.Const.unwrap(b)))};goog.dom.safe.setOuterHtml=function(a,b){a.outerHTML=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setFormElementAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLFormElement(a).action=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setButtonFormAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLButtonElement(a).formAction=goog.html.SafeUrl.unwrap(b)};
goog.dom.safe.setInputFormAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLInputElement(a).formAction=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setStyle=function(a,b){a.style.cssText=goog.html.SafeStyle.unwrap(b)};goog.dom.safe.documentWrite=function(a,b){a.write(goog.html.SafeHtml.unwrapTrustedHTML(b))};
goog.dom.safe.setAnchorHref=function(a,b){goog.dom.asserts.assertIsHTMLAnchorElement(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.href=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setImageSrc=function(a,b){goog.dom.asserts.assertIsHTMLImageElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:image\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrap(b)};
goog.dom.safe.setAudioSrc=function(a,b){goog.dom.asserts.assertIsHTMLAudioElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:audio\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setVideoSrc=function(a,b){goog.dom.asserts.assertIsHTMLVideoElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:video\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrap(b)};
goog.dom.safe.setEmbedSrc=function(a,b){goog.dom.asserts.assertIsHTMLEmbedElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b)};goog.dom.safe.setFrameSrc=function(a,b){goog.dom.asserts.assertIsHTMLFrameElement(a);a.src=goog.html.TrustedResourceUrl.unwrap(b)};goog.dom.safe.setIframeSrc=function(a,b){goog.dom.asserts.assertIsHTMLIFrameElement(a);a.src=goog.html.TrustedResourceUrl.unwrap(b)};
goog.dom.safe.setIframeSrcdoc=function(a,b){goog.dom.asserts.assertIsHTMLIFrameElement(a);a.srcdoc=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setLinkHrefAndRel=function(a,b,c){goog.dom.asserts.assertIsHTMLLinkElement(a);a.rel=c;goog.string.internal.caseInsensitiveContains(c,"stylesheet")?(goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl,'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'),a.href=goog.html.TrustedResourceUrl.unwrap(b)):a.href=b instanceof goog.html.TrustedResourceUrl?goog.html.TrustedResourceUrl.unwrap(b):b instanceof goog.html.SafeUrl?goog.html.SafeUrl.unwrap(b):goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(b))};
goog.dom.safe.setObjectData=function(a,b){goog.dom.asserts.assertIsHTMLObjectElement(a);a.data=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b)};goog.dom.safe.setScriptSrc=function(a,b){goog.dom.asserts.assertIsHTMLScriptElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);goog.dom.safe.setNonceForScriptElement_(a)};
goog.dom.safe.setScriptContent=function(a,b){goog.dom.asserts.assertIsHTMLScriptElement(a);a.textContent=module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(b);goog.dom.safe.setNonceForScriptElement_(a)};goog.dom.safe.setNonceForScriptElement_=function(a){var b=goog.getScriptNonce(a.ownerDocument&&a.ownerDocument.defaultView);b&&a.setAttribute("nonce",b)};
goog.dom.safe.setLocationHref=function(a,b){goog.dom.asserts.assertIsLocation(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.href=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.assignLocation=function(a,b){goog.dom.asserts.assertIsLocation(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.assign(goog.html.SafeUrl.unwrap(b))};
goog.dom.safe.replaceLocation=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.replace(goog.html.SafeUrl.unwrap(b))};goog.dom.safe.openInWindow=function(a,b,c,d,e){a=a instanceof goog.html.SafeUrl?a:goog.html.SafeUrl.sanitizeAssertUnchanged(a);b=b||goog.global;c=c instanceof goog.string.Const?goog.string.Const.unwrap(c):c||"";return b.open(goog.html.SafeUrl.unwrap(a),c,d,e)};
goog.dom.safe.parseFromStringHtml=function(a,b){return goog.dom.safe.parseFromString(a,b,"text/html")};goog.dom.safe.parseFromString=function(a,b,c){return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b),c)};
goog.dom.safe.createImageFromBlob=function(a){if(!/^image\/.*/g.test(a.type))throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");var b=goog.global.URL.createObjectURL(a);a=new goog.global.Image;a.onload=function(){goog.global.URL.revokeObjectURL(b)};goog.dom.safe.setImageSrc(a,goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."),b));return a};goog.string.DETECT_DOUBLE_ESCAPING=!1;goog.string.FORCE_NON_DOM_HTML_UNESCAPING=!1;goog.string.Unicode={NBSP:"\u00a0"};goog.string.startsWith=goog.string.internal.startsWith;goog.string.endsWith=goog.string.internal.endsWith;goog.string.caseInsensitiveStartsWith=goog.string.internal.caseInsensitiveStartsWith;goog.string.caseInsensitiveEndsWith=goog.string.internal.caseInsensitiveEndsWith;goog.string.caseInsensitiveEquals=goog.string.internal.caseInsensitiveEquals;
goog.string.subs=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")};goog.string.collapseWhitespace=function(a){return a.replace(/[\s\xa0]+/g," ").replace(/^\s+|\s+$/g,"")};goog.string.isEmptyOrWhitespace=goog.string.internal.isEmptyOrWhitespace;goog.string.isEmptyString=function(a){return 0==a.length};goog.string.isEmpty=goog.string.isEmptyOrWhitespace;goog.string.isEmptyOrWhitespaceSafe=function(a){return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a))};
goog.string.isEmptySafe=goog.string.isEmptyOrWhitespaceSafe;goog.string.isBreakingWhitespace=function(a){return!/[^\t\n\r ]/.test(a)};goog.string.isAlpha=function(a){return!/[^a-zA-Z]/.test(a)};goog.string.isNumeric=function(a){return!/[^0-9]/.test(a)};goog.string.isAlphaNumeric=function(a){return!/[^a-zA-Z0-9]/.test(a)};goog.string.isSpace=function(a){return" "==a};goog.string.isUnicodeChar=function(a){return 1==a.length&&" "<=a&&"~">=a||"\u0080"<=a&&"\ufffd">=a};
goog.string.stripNewlines=function(a){return a.replace(/(\r\n|\r|\n)+/g," ")};goog.string.canonicalizeNewlines=function(a){return a.replace(/(\r\n|\r|\n)/g,"\n")};goog.string.normalizeWhitespace=function(a){return a.replace(/\xa0|\s/g," ")};goog.string.normalizeSpaces=function(a){return a.replace(/\xa0|[ \t]+/g," ")};goog.string.collapseBreakingSpaces=function(a){return a.replace(/[\t\r\n ]+/g," ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g,"")};goog.string.trim=goog.string.internal.trim;
goog.string.trimLeft=function(a){return a.replace(/^[\s\xa0]+/,"")};goog.string.trimRight=function(a){return a.replace(/[\s\xa0]+$/,"")};goog.string.caseInsensitiveCompare=goog.string.internal.caseInsensitiveCompare;
goog.string.numberAwareCompare_=function(a,b,c){if(a==b)return 0;if(!a)return-1;if(!b)return 1;for(var d=a.toLowerCase().match(c),e=b.toLowerCase().match(c),f=Math.min(d.length,e.length),g=0;g<f;g++){c=d[g];var h=e[g];if(c!=h)return a=parseInt(c,10),!isNaN(a)&&(b=parseInt(h,10),!isNaN(b)&&a-b)?a-b:c<h?-1:1}return d.length!=e.length?d.length-e.length:a<b?-1:1};goog.string.intAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\D+/g)};
goog.string.floatAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\.\d+|\D+/g)};goog.string.numerateCompare=goog.string.floatAwareCompare;goog.string.urlEncode=function(a){return encodeURIComponent(String(a))};goog.string.urlDecode=function(a){return decodeURIComponent(a.replace(/\+/g," "))};goog.string.newLineToBr=goog.string.internal.newLineToBr;
goog.string.htmlEscape=function(a,b){a=goog.string.internal.htmlEscape(a,b);goog.string.DETECT_DOUBLE_ESCAPING&&(a=a.replace(goog.string.E_RE_,"&#101;"));return a};goog.string.E_RE_=/e/g;goog.string.unescapeEntities=function(a){return goog.string.contains(a,"&")?!goog.string.FORCE_NON_DOM_HTML_UNESCAPING&&"document"in goog.global?goog.string.unescapeEntitiesUsingDom_(a):goog.string.unescapePureXmlEntities_(a):a};
goog.string.unescapeEntitiesWithDocument=function(a,b){return goog.string.contains(a,"&")?goog.string.unescapeEntitiesUsingDom_(a,b):a};
goog.string.unescapeEntitiesUsingDom_=function(a,b){var c={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"'};var d=b?b.createElement("div"):goog.global.document.createElement("div");return a.replace(goog.string.HTML_ENTITY_PATTERN_,function(e,f){var g=c[e];if(g)return g;"#"==f.charAt(0)&&(f=Number("0"+f.substr(1)),isNaN(f)||(g=String.fromCharCode(f)));g||(goog.dom.safe.setInnerHtml(d,goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."),
e+" ")),g=d.firstChild.nodeValue.slice(0,-1));return c[e]=g})};goog.string.unescapePureXmlEntities_=function(a){return a.replace(/&([^;]+);/g,function(b,c){switch(c){case "amp":return"&";case "lt":return"<";case "gt":return">";case "quot":return'"';default:return"#"!=c.charAt(0)||(c=Number("0"+c.substr(1)),isNaN(c))?b:String.fromCharCode(c)}})};goog.string.HTML_ENTITY_PATTERN_=/&([^;\s<&]+);?/g;goog.string.whitespaceEscape=function(a,b){return goog.string.newLineToBr(a.replace(/  /g," &#160;"),b)};
goog.string.preserveSpaces=function(a){return a.replace(/(^|[\n ]) /g,"$1"+goog.string.Unicode.NBSP)};goog.string.stripQuotes=function(a,b){for(var c=b.length,d=0;d<c;d++){var e=1==c?b:b.charAt(d);if(a.charAt(0)==e&&a.charAt(a.length-1)==e)return a.substring(1,a.length-1)}return a};goog.string.truncate=function(a,b,c){c&&(a=goog.string.unescapeEntities(a));a.length>b&&(a=a.substring(0,b-3)+"...");c&&(a=goog.string.htmlEscape(a));return a};
goog.string.truncateMiddle=function(a,b,c,d){c&&(a=goog.string.unescapeEntities(a));if(d&&a.length>b){d>b&&(d=b);var e=a.length-d;a=a.substring(0,b-d)+"..."+a.substring(e)}else a.length>b&&(d=Math.floor(b/2),e=a.length-d,a=a.substring(0,d+b%2)+"..."+a.substring(e));c&&(a=goog.string.htmlEscape(a));return a};goog.string.specialEscapeChars_={"\x00":"\\0","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\x0B",'"':'\\"',"\\":"\\\\","<":"\\u003C"};goog.string.jsEscapeCache_={"'":"\\'"};
goog.string.quote=function(a){a=String(a);for(var b=['"'],c=0;c<a.length;c++){var d=a.charAt(c),e=d.charCodeAt(0);b[c+1]=goog.string.specialEscapeChars_[d]||(31<e&&127>e?d:goog.string.escapeChar(d))}b.push('"');return b.join("")};goog.string.escapeString=function(a){for(var b=[],c=0;c<a.length;c++)b[c]=goog.string.escapeChar(a.charAt(c));return b.join("")};
goog.string.escapeChar=function(a){if(a in goog.string.jsEscapeCache_)return goog.string.jsEscapeCache_[a];if(a in goog.string.specialEscapeChars_)return goog.string.jsEscapeCache_[a]=goog.string.specialEscapeChars_[a];var b=a.charCodeAt(0);if(31<b&&127>b)var c=a;else{if(256>b){if(c="\\x",16>b||256<b)c+="0"}else c="\\u",4096>b&&(c+="0");c+=b.toString(16).toUpperCase()}return goog.string.jsEscapeCache_[a]=c};goog.string.contains=goog.string.internal.contains;goog.string.caseInsensitiveContains=goog.string.internal.caseInsensitiveContains;
goog.string.countOf=function(a,b){return a&&b?a.split(b).length-1:0};goog.string.removeAt=function(a,b,c){var d=a;0<=b&&b<a.length&&0<c&&(d=a.substr(0,b)+a.substr(b+c,a.length-b-c));return d};goog.string.remove=function(a,b){return a.replace(b,"")};goog.string.removeAll=function(a,b){b=new RegExp(goog.string.regExpEscape(b),"g");return a.replace(b,"")};goog.string.replaceAll=function(a,b,c){b=new RegExp(goog.string.regExpEscape(b),"g");return a.replace(b,c.replace(/\$/g,"$$$$"))};
goog.string.regExpEscape=function(a){return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,"\\$1").replace(/\x08/g,"\\x08")};goog.string.repeat=String.prototype.repeat?function(a,b){return a.repeat(b)}:function(a,b){return Array(b+1).join(a)};goog.string.padNumber=function(a,b,c){a=void 0!==c?a.toFixed(c):String(a);c=a.indexOf(".");-1==c&&(c=a.length);return goog.string.repeat("0",Math.max(0,b-c))+a};goog.string.makeSafe=function(a){return null==a?"":String(a)};
goog.string.buildString=function(a){return Array.prototype.join.call(arguments,"")};goog.string.getRandomString=function(){return Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^goog.now()).toString(36)};goog.string.compareVersions=goog.string.internal.compareVersions;goog.string.hashCode=function(a){for(var b=0,c=0;c<a.length;++c)b=31*b+a.charCodeAt(c)>>>0;return b};goog.string.uniqueStringCounter_=2147483648*Math.random()|0;
goog.string.createUniqueString=function(){return"goog_"+goog.string.uniqueStringCounter_++};goog.string.toNumber=function(a){var b=Number(a);return 0==b&&goog.string.isEmptyOrWhitespace(a)?NaN:b};goog.string.isLowerCamelCase=function(a){return/^[a-z]+([A-Z][a-z]*)*$/.test(a)};goog.string.isUpperCamelCase=function(a){return/^([A-Z][a-z]*)+$/.test(a)};goog.string.toCamelCase=function(a){return String(a).replace(/\-([a-z])/g,function(b,c){return c.toUpperCase()})};
goog.string.toSelectorCase=function(a){return String(a).replace(/([A-Z])/g,"-$1").toLowerCase()};goog.string.toTitleCase=function(a,b){b="string"===typeof b?goog.string.regExpEscape(b):"\\s";return a.replace(new RegExp("(^"+(b?"|["+b+"]+":"")+")([a-z])","g"),function(c,d,e){return d+e.toUpperCase()})};goog.string.capitalize=function(a){return String(a.charAt(0)).toUpperCase()+String(a.substr(1)).toLowerCase()};
goog.string.parseInt=function(a){isFinite(a)&&(a=String(a));return"string"===typeof a?/^\s*-?0x/i.test(a)?parseInt(a,16):parseInt(a,10):NaN};goog.string.splitLimit=function(a,b,c){a=a.split(b);for(var d=[];0<c&&a.length;)d.push(a.shift()),c--;a.length&&d.push(a.join(b));return d};goog.string.lastComponent=function(a,b){if(b)"string"==typeof b&&(b=[b]);else return a;for(var c=-1,d=0;d<b.length;d++)if(""!=b[d]){var e=a.lastIndexOf(b[d]);e>c&&(c=e)}return-1==c?a:a.slice(c+1)};
goog.string.editDistance=function(a,b){var c=[],d=[];if(a==b)return 0;if(!a.length||!b.length)return Math.max(a.length,b.length);for(var e=0;e<b.length+1;e++)c[e]=e;for(e=0;e<a.length;e++){d[0]=e+1;for(var f=0;f<b.length;f++)d[f+1]=Math.min(d[f]+1,c[f+1]+1,c[f]+Number(a[e]!=b[f]));for(f=0;f<c.length;f++)c[f]=d[f]}return d[b.length]};goog.proto2={};goog.proto2.Descriptor=function(a,b,c){this.messageType_=a;this.name_=b.name||null;this.fullName_=b.fullName||null;this.containingType_=b.containingType;this.fields_={};for(a=0;a<c.length;a++)b=c[a],this.fields_[b.getTag()]=b};goog.proto2.Descriptor.prototype.getName=function(){return this.name_};goog.proto2.Descriptor.prototype.getFullName=function(){return this.fullName_};
goog.proto2.Descriptor.prototype.getContainingType=function(){return this.containingType_?this.containingType_.getDescriptor():null};goog.proto2.Descriptor.prototype.getFields=function(){var a=goog.object.getValues(this.fields_);module$contents$goog$array_sort(a,function(b,c){return b.getTag()-c.getTag()});return a};goog.proto2.Descriptor.prototype.getFieldsMap=function(){return this.fields_};
goog.proto2.Descriptor.prototype.findFieldByName=function(a){return goog.object.findValue(this.fields_,function(b,c,d){return b.getName()==a})||null};goog.proto2.Descriptor.prototype.findFieldByTag=function(a){goog.asserts.assert(goog.string.isNumeric(a));return this.fields_[parseInt(a,10)]||null};goog.proto2.Descriptor.prototype.createMessageInstance=function(){return new this.messageType_};goog.proto2.FieldDescriptor=function(a,b,c){this.parent_=a;goog.asserts.assert(goog.string.isNumeric(b));this.tag_=b;this.name_=c.name;this.isPacked_=!!c.packed;this.isRepeated_=!!c.repeated;this.isRequired_=!!c.required;this.fieldType_=c.fieldType;this.nativeType_=c.type;this.deserializationConversionPermitted_=!1;switch(this.fieldType_){case goog.proto2.FieldDescriptor.FieldType.INT64:case goog.proto2.FieldDescriptor.FieldType.UINT64:case goog.proto2.FieldDescriptor.FieldType.FIXED64:case goog.proto2.FieldDescriptor.FieldType.SFIXED64:case goog.proto2.FieldDescriptor.FieldType.SINT64:case goog.proto2.FieldDescriptor.FieldType.FLOAT:case goog.proto2.FieldDescriptor.FieldType.DOUBLE:this.deserializationConversionPermitted_=
!0}this.defaultValue_=c.defaultValue};goog.proto2.FieldDescriptor.FieldType={DOUBLE:1,FLOAT:2,INT64:3,UINT64:4,INT32:5,FIXED64:6,FIXED32:7,BOOL:8,STRING:9,GROUP:10,MESSAGE:11,BYTES:12,UINT32:13,ENUM:14,SFIXED32:15,SFIXED64:16,SINT32:17,SINT64:18};goog.proto2.FieldDescriptor.prototype.getTag=function(){return this.tag_};goog.proto2.FieldDescriptor.prototype.getContainingType=function(){return this.parent_.prototype.getDescriptor()};goog.proto2.FieldDescriptor.prototype.getName=function(){return this.name_};
goog.proto2.FieldDescriptor.prototype.getDefaultValue=function(){if(void 0===this.defaultValue_){var a=this.nativeType_;if(a===Boolean)this.defaultValue_=!1;else if(a===Number)this.defaultValue_=0;else if(a===String)this.defaultValue_=this.deserializationConversionPermitted_?"0":"";else return new a}return this.defaultValue_};goog.proto2.FieldDescriptor.prototype.getFieldType=function(){return this.fieldType_};goog.proto2.FieldDescriptor.prototype.getNativeType=function(){return this.nativeType_};
goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted=function(){return this.deserializationConversionPermitted_};goog.proto2.FieldDescriptor.prototype.getFieldMessageType=function(){return this.nativeType_.prototype.getDescriptor()};goog.proto2.FieldDescriptor.prototype.isCompositeType=function(){return this.fieldType_==goog.proto2.FieldDescriptor.FieldType.MESSAGE||this.fieldType_==goog.proto2.FieldDescriptor.FieldType.GROUP};goog.proto2.FieldDescriptor.prototype.isPacked=function(){return this.isPacked_};
goog.proto2.FieldDescriptor.prototype.isRepeated=function(){return this.isRepeated_};goog.proto2.FieldDescriptor.prototype.isRequired=function(){return this.isRequired_};goog.proto2.FieldDescriptor.prototype.isOptional=function(){return!this.isRepeated_&&!this.isRequired_};goog.proto2.Message=function(){this.values_={};this.fields_=this.getDescriptor().getFieldsMap();this.deserializedFields_=this.lazyDeserializer_=null};goog.proto2.Message.FieldType={DOUBLE:1,FLOAT:2,INT64:3,UINT64:4,INT32:5,FIXED64:6,FIXED32:7,BOOL:8,STRING:9,GROUP:10,MESSAGE:11,BYTES:12,UINT32:13,ENUM:14,SFIXED32:15,SFIXED64:16,SINT32:17,SINT64:18};goog.proto2.Message.prototype.initializeForLazyDeserializer=function(a,b){this.lazyDeserializer_=a;this.values_=b;this.deserializedFields_={}};
goog.proto2.Message.prototype.setUnknown=function(a,b){goog.asserts.assert(!this.fields_[a],"Field is not unknown in this message");goog.asserts.assert(1<=a,"Tag "+a+' has value "'+b+'" in descriptor '+this.getDescriptor().getName());goog.asserts.assert(null!==b,"Value cannot be null");this.values_[a]=b;this.deserializedFields_&&delete this.deserializedFields_[a]};
goog.proto2.Message.prototype.forEachUnknown=function(a,b){b=b||this;for(var c in this.values_){var d=Number(c);this.fields_[d]||a.call(b,d,this.values_[c])}};goog.proto2.Message.prototype.getDescriptor=goog.abstractMethod;goog.proto2.Message.prototype.has=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.has$Value(a.getTag())};
goog.proto2.Message.prototype.arrayOf=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.array$Values(a.getTag())};goog.proto2.Message.prototype.countOf=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.count$Values(a.getTag())};
goog.proto2.Message.prototype.get=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.get$Value(a.getTag(),b)};goog.proto2.Message.prototype.getOrDefault=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.get$ValueOrDefault(a.getTag(),b)};
goog.proto2.Message.prototype.set=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");this.set$Value(a.getTag(),b)};goog.proto2.Message.prototype.add=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");this.add$Value(a.getTag(),b)};
goog.proto2.Message.prototype.clear=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");this.clear$Field(a.getTag())};
goog.proto2.Message.prototype.equals=function(a){if(!a||this.constructor!=a.constructor)return!1;for(var b=this.getDescriptor().getFields(),c=0;c<b.length;c++){var d=b[c],e=d.getTag();if(this.has$Value(e)!=a.has$Value(e))return!1;if(this.has$Value(e)){var f=d.isCompositeType(),g=this.getValueForTag_(e);e=a.getValueForTag_(e);if(d.isRepeated()){if(g.length!=e.length)return!1;for(d=0;d<g.length;d++){var h=g[d],k=e[d];if(f?!h.equals(k):h!=k)return!1}}else if(f?!g.equals(e):g!=e)return!1}}return!0};
goog.proto2.Message.prototype.copyFrom=function(a){goog.asserts.assert(this.constructor==a.constructor,"The source message must have the same type.");this!=a&&(this.values_={},this.deserializedFields_&&(this.deserializedFields_={}),this.mergeFrom(a))};
goog.proto2.Message.prototype.mergeFrom=function(a){goog.asserts.assert(this.constructor==a.constructor,"The source message must have the same type.");for(var b=this.getDescriptor().getFields(),c=0;c<b.length;c++){var d=b[c],e=d.getTag();if(a.has$Value(e)){this.deserializedFields_&&delete this.deserializedFields_[d.getTag()];var f=d.isCompositeType();if(d.isRepeated()){d=a.array$Values(e);for(var g=0;g<d.length;g++)this.add$Value(e,f?d[g].clone():d[g])}else d=a.getValueForTag_(e),f?(f=this.getValueForTag_(e))?
f.mergeFrom(d):this.set$Value(e,d.clone()):this.set$Value(e,d)}}};goog.proto2.Message.prototype.clone=function(){var a=new this.constructor;a.copyFrom(this);return a};
goog.proto2.Message.prototype.initDefaults=function(a){for(var b=this.getDescriptor().getFields(),c=0;c<b.length;c++){var d=b[c],e=d.getTag(),f=d.isCompositeType();this.has$Value(e)||d.isRepeated()||(f?this.values_[e]=new (d.getNativeType()):a&&(this.values_[e]=d.getDefaultValue()));if(f)if(d.isRepeated())for(d=this.array$Values(e),e=0;e<d.length;e++)d[e].initDefaults(a);else this.get$Value(e).initDefaults(a)}};goog.proto2.Message.prototype.has$Value=function(a){return null!=this.values_[a]};
goog.proto2.Message.prototype.getValueForTag_=function(a){var b=this.values_[a];return null==b?null:this.lazyDeserializer_?a in this.deserializedFields_?this.deserializedFields_[a]:(b=this.lazyDeserializer_.deserializeField(this,this.fields_[a],b),this.deserializedFields_[a]=b):b};
goog.proto2.Message.prototype.get$Value=function(a,b){var c=this.getValueForTag_(a);return this.fields_[a].isRepeated()?(a=b||0,goog.asserts.assert(0<=a&&a<c.length,"Given index %s is out of bounds.  Repeated field length: %s",a,c.length),c[a]):c};goog.proto2.Message.prototype.get$ValueOrDefault=function(a,b){return this.has$Value(a)?this.get$Value(a,b):this.fields_[a].getDefaultValue()};goog.proto2.Message.prototype.array$Values=function(a){return this.getValueForTag_(a)||[]};
goog.proto2.Message.prototype.count$Values=function(a){return this.fields_[a].isRepeated()?this.has$Value(a)?this.values_[a].length:0:this.has$Value(a)?1:0};goog.proto2.Message.prototype.set$Value=function(a,b){goog.asserts.ENABLE_ASSERTS&&this.checkFieldType_(this.fields_[a],b);this.values_[a]=b;this.deserializedFields_&&(this.deserializedFields_[a]=b)};
goog.proto2.Message.prototype.add$Value=function(a,b){goog.asserts.ENABLE_ASSERTS&&this.checkFieldType_(this.fields_[a],b);this.values_[a]||(this.values_[a]=[]);this.values_[a].push(b);this.deserializedFields_&&delete this.deserializedFields_[a]};goog.proto2.Message.prototype.checkFieldType_=function(a,b){a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.ENUM?goog.asserts.assertNumber(b):goog.asserts.assert(Object(b).constructor==a.getNativeType())};
goog.proto2.Message.prototype.clear$Field=function(a){delete this.values_[a];this.deserializedFields_&&delete this.deserializedFields_[a]};goog.proto2.Message.createDescriptor=function(a,b){var c=[],d=b[0],e;for(e in b)0!=e&&c.push(new goog.proto2.FieldDescriptor(a,e,b[e]));return new goog.proto2.Descriptor(a,d,c)};goog.proto2.Serializer=function(){};goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS=!1;goog.proto2.Serializer.prototype.serialize=goog.abstractMethod;goog.proto2.Serializer.prototype.getSerializedValue=function(a,b){return a.isCompositeType()?this.serialize(b):"number"!==typeof b||isFinite(b)?b:b.toString()};goog.proto2.Serializer.prototype.deserialize=function(a,b){a=a.createMessageInstance();this.deserializeTo(a,b);goog.asserts.assert(a instanceof goog.proto2.Message);return a};
goog.proto2.Serializer.prototype.deserializeTo=goog.abstractMethod;
goog.proto2.Serializer.prototype.getDeserializedValue=function(a,b){if(a.isCompositeType())return b instanceof goog.proto2.Message?b:this.deserialize(a.getFieldMessageType(),b);if(a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.ENUM)return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS&&"string"===typeof b&&(a=a.getNativeType(),a.hasOwnProperty(b))?a[b]:"string"===typeof b&&goog.proto2.Serializer.INTEGER_REGEX.test(b)&&(a=Number(b),0<a)?a:b;if(!a.deserializationConversionPermitted())return b;
a=a.getNativeType();if(a===String){if("number"===typeof b)return String(b)}else if(a===Number&&"string"===typeof b&&("Infinity"===b||"-Infinity"===b||"NaN"===b||goog.proto2.Serializer.INTEGER_REGEX.test(b)))return Number(b);return b};goog.proto2.Serializer.INTEGER_REGEX=/^-?[0-9]+$/;goog.proto2.LazyDeserializer=function(){};goog.inherits(goog.proto2.LazyDeserializer,goog.proto2.Serializer);goog.proto2.LazyDeserializer.prototype.deserialize=function(a,b){a=a.createMessageInstance();a.initializeForLazyDeserializer(this,b);goog.asserts.assert(a instanceof goog.proto2.Message);return a};goog.proto2.LazyDeserializer.prototype.deserializeTo=function(a,b){throw Error("Unimplemented");};goog.proto2.LazyDeserializer.prototype.deserializeField=goog.abstractMethod;goog.proto2.PbLiteSerializer=function(){};goog.inherits(goog.proto2.PbLiteSerializer,goog.proto2.LazyDeserializer);goog.proto2.PbLiteSerializer.prototype.zeroIndexing_=!1;goog.proto2.PbLiteSerializer.prototype.setZeroIndexed=function(a){this.zeroIndexing_=a};
goog.proto2.PbLiteSerializer.prototype.serialize=function(a){for(var b=a.getDescriptor().getFields(),c=[],d=this.zeroIndexing_,e=0;e<b.length;e++){var f=b[e];if(a.has(f)){var g=f.getTag();g=d?g-1:g;if(f.isRepeated()){c[g]=[];for(var h=0;h<a.countOf(f);h++)c[g][h]=this.getSerializedValue(f,a.get(f,h))}else c[g]=this.getSerializedValue(f,a.get(f))}}a.forEachUnknown(function(k,l){c[d?k-1:k]=l});return c};
goog.proto2.PbLiteSerializer.prototype.deserializeField=function(a,b,c){if(null==c)return c;if(b.isRepeated()){a=[];goog.asserts.assert(Array.isArray(c),"Value must be array: %s",c);for(var d=0;d<c.length;d++)a[d]=this.getDeserializedValue(b,c[d]);return a}return this.getDeserializedValue(b,c)};
goog.proto2.PbLiteSerializer.prototype.getSerializedValue=function(a,b){return a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.BOOL?b?1:0:goog.proto2.Serializer.prototype.getSerializedValue.apply(this,arguments)};
goog.proto2.PbLiteSerializer.prototype.getDeserializedValue=function(a,b){return a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.BOOL?(goog.asserts.assert("number"===typeof b||"boolean"===typeof b,"Value is expected to be a number or boolean"),!!b):goog.proto2.Serializer.prototype.getDeserializedValue.apply(this,arguments)};
goog.proto2.PbLiteSerializer.prototype.deserialize=function(a,b){var c=b;if(this.zeroIndexing_){c=[];for(var d in b)c[parseInt(d,10)+1]=b[d]}return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this,a,c)};goog.string.StringBuffer=function(a,b){null!=a&&this.append.apply(this,arguments)};goog.string.StringBuffer.prototype.buffer_="";goog.string.StringBuffer.prototype.set=function(a){this.buffer_=""+a};goog.string.StringBuffer.prototype.append=function(a,b,c){this.buffer_+=String(a);if(null!=b)for(var d=1;d<arguments.length;d++)this.buffer_+=arguments[d];return this};goog.string.StringBuffer.prototype.clear=function(){this.buffer_=""};goog.string.StringBuffer.prototype.getLength=function(){return this.buffer_.length};
goog.string.StringBuffer.prototype.toString=function(){return this.buffer_};/*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var i18n={phonenumbers:{}};i18n.phonenumbers.NumberFormat=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.NumberFormat,goog.proto2.Message);i18n.phonenumbers.NumberFormat.descriptor_=null;i18n.phonenumbers.NumberFormat.prototype.getPattern=function(){return this.get$Value(1)};i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault=function(){return this.get$ValueOrDefault(1)};i18n.phonenumbers.NumberFormat.prototype.setPattern=function(a){this.set$Value(1,a)};
i18n.phonenumbers.NumberFormat.prototype.hasPattern=function(){return this.has$Value(1)};i18n.phonenumbers.NumberFormat.prototype.patternCount=function(){return this.count$Values(1)};i18n.phonenumbers.NumberFormat.prototype.clearPattern=function(){this.clear$Field(1)};i18n.phonenumbers.NumberFormat.prototype.getFormat=function(){return this.get$Value(2)};i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault=function(){return this.get$ValueOrDefault(2)};
i18n.phonenumbers.NumberFormat.prototype.setFormat=function(a){this.set$Value(2,a)};i18n.phonenumbers.NumberFormat.prototype.hasFormat=function(){return this.has$Value(2)};i18n.phonenumbers.NumberFormat.prototype.formatCount=function(){return this.count$Values(2)};i18n.phonenumbers.NumberFormat.prototype.clearFormat=function(){this.clear$Field(2)};i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern=function(a){return this.get$Value(3,a)};
i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault=function(a){return this.get$ValueOrDefault(3,a)};i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern=function(a){this.add$Value(3,a)};i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray=function(){return this.array$Values(3)};i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern=function(){return this.has$Value(3)};i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount=function(){return this.count$Values(3)};
i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern=function(){this.clear$Field(3)};i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule=function(){return this.get$Value(4)};i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault=function(){return this.get$ValueOrDefault(4)};i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule=function(a){this.set$Value(4,a)};
i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule=function(){return this.has$Value(4)};i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount=function(){return this.count$Values(4)};i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule=function(){this.clear$Field(4)};i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting=function(){return this.get$Value(6)};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault=function(){return this.get$ValueOrDefault(6)};i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting=function(a){this.set$Value(6,a)};i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting=function(){return this.has$Value(6)};i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount=function(){return this.count$Values(6)};
i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting=function(){this.clear$Field(6)};i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule=function(){return this.get$Value(5)};i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault=function(){return this.get$ValueOrDefault(5)};i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule=function(a){this.set$Value(5,a)};
i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule=function(){return this.has$Value(5)};i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount=function(){return this.count$Values(5)};i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule=function(){this.clear$Field(5)};i18n.phonenumbers.PhoneNumberDesc=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.PhoneNumberDesc,goog.proto2.Message);
i18n.phonenumbers.PhoneNumberDesc.descriptor_=null;i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern=function(){return this.get$Value(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault=function(){return this.get$ValueOrDefault(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern=function(a){this.set$Value(2,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern=function(){return this.has$Value(2)};
i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount=function(){return this.count$Values(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern=function(){this.clear$Field(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength=function(a){return this.get$Value(9,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault=function(a){return this.get$ValueOrDefault(9,a)};
i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength=function(a){this.add$Value(9,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray=function(){return this.array$Values(9)};i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength=function(){return this.has$Value(9)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount=function(){return this.count$Values(9)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength=function(){this.clear$Field(9)};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly=function(a){return this.get$Value(10,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault=function(a){return this.get$ValueOrDefault(10,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly=function(a){this.add$Value(10,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray=function(){return this.array$Values(10)};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly=function(){return this.has$Value(10)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount=function(){return this.count$Values(10)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly=function(){this.clear$Field(10)};i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber=function(){return this.get$Value(6)};i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault=function(){return this.get$ValueOrDefault(6)};
i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber=function(a){this.set$Value(6,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber=function(){return this.has$Value(6)};i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount=function(){return this.count$Values(6)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber=function(){this.clear$Field(6)};i18n.phonenumbers.PhoneMetadata=function(){goog.proto2.Message.call(this)};
goog.inherits(i18n.phonenumbers.PhoneMetadata,goog.proto2.Message);i18n.phonenumbers.PhoneMetadata.descriptor_=null;i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc=function(){return this.get$Value(1)};i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault=function(){return this.get$ValueOrDefault(1)};i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc=function(a){this.set$Value(1,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc=function(){return this.has$Value(1)};
i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount=function(){return this.count$Values(1)};i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc=function(){this.clear$Field(1)};i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine=function(){return this.get$Value(2)};i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault=function(){return this.get$ValueOrDefault(2)};i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine=function(a){this.set$Value(2,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine=function(){return this.has$Value(2)};i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount=function(){return this.count$Values(2)};i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine=function(){this.clear$Field(2)};i18n.phonenumbers.PhoneMetadata.prototype.getMobile=function(){return this.get$Value(3)};i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault=function(){return this.get$ValueOrDefault(3)};
i18n.phonenumbers.PhoneMetadata.prototype.setMobile=function(a){this.set$Value(3,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasMobile=function(){return this.has$Value(3)};i18n.phonenumbers.PhoneMetadata.prototype.mobileCount=function(){return this.count$Values(3)};i18n.phonenumbers.PhoneMetadata.prototype.clearMobile=function(){this.clear$Field(3)};i18n.phonenumbers.PhoneMetadata.prototype.getTollFree=function(){return this.get$Value(4)};
i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault=function(){return this.get$ValueOrDefault(4)};i18n.phonenumbers.PhoneMetadata.prototype.setTollFree=function(a){this.set$Value(4,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree=function(){return this.has$Value(4)};i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount=function(){return this.count$Values(4)};i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree=function(){this.clear$Field(4)};
i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate=function(){return this.get$Value(5)};i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault=function(){return this.get$ValueOrDefault(5)};i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate=function(a){this.set$Value(5,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate=function(){return this.has$Value(5)};i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount=function(){return this.count$Values(5)};
i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate=function(){this.clear$Field(5)};i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost=function(){return this.get$Value(6)};i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault=function(){return this.get$ValueOrDefault(6)};i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost=function(a){this.set$Value(6,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost=function(){return this.has$Value(6)};
i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount=function(){return this.count$Values(6)};i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost=function(){this.clear$Field(6)};i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber=function(){return this.get$Value(7)};i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault=function(){return this.get$ValueOrDefault(7)};i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber=function(a){this.set$Value(7,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber=function(){return this.has$Value(7)};i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount=function(){return this.count$Values(7)};i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber=function(){this.clear$Field(7)};i18n.phonenumbers.PhoneMetadata.prototype.getVoip=function(){return this.get$Value(8)};i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault=function(){return this.get$ValueOrDefault(8)};
i18n.phonenumbers.PhoneMetadata.prototype.setVoip=function(a){this.set$Value(8,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasVoip=function(){return this.has$Value(8)};i18n.phonenumbers.PhoneMetadata.prototype.voipCount=function(){return this.count$Values(8)};i18n.phonenumbers.PhoneMetadata.prototype.clearVoip=function(){this.clear$Field(8)};i18n.phonenumbers.PhoneMetadata.prototype.getPager=function(){return this.get$Value(21)};i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault=function(){return this.get$ValueOrDefault(21)};
i18n.phonenumbers.PhoneMetadata.prototype.setPager=function(a){this.set$Value(21,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPager=function(){return this.has$Value(21)};i18n.phonenumbers.PhoneMetadata.prototype.pagerCount=function(){return this.count$Values(21)};i18n.phonenumbers.PhoneMetadata.prototype.clearPager=function(){this.clear$Field(21)};i18n.phonenumbers.PhoneMetadata.prototype.getUan=function(){return this.get$Value(25)};i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault=function(){return this.get$ValueOrDefault(25)};
i18n.phonenumbers.PhoneMetadata.prototype.setUan=function(a){this.set$Value(25,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasUan=function(){return this.has$Value(25)};i18n.phonenumbers.PhoneMetadata.prototype.uanCount=function(){return this.count$Values(25)};i18n.phonenumbers.PhoneMetadata.prototype.clearUan=function(){this.clear$Field(25)};i18n.phonenumbers.PhoneMetadata.prototype.getEmergency=function(){return this.get$Value(27)};
i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault=function(){return this.get$ValueOrDefault(27)};i18n.phonenumbers.PhoneMetadata.prototype.setEmergency=function(a){this.set$Value(27,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency=function(){return this.has$Value(27)};i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount=function(){return this.count$Values(27)};i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency=function(){this.clear$Field(27)};
i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail=function(){return this.get$Value(28)};i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault=function(){return this.get$ValueOrDefault(28)};i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail=function(a){this.set$Value(28,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail=function(){return this.has$Value(28)};i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount=function(){return this.count$Values(28)};
i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail=function(){this.clear$Field(28)};i18n.phonenumbers.PhoneMetadata.prototype.getShortCode=function(){return this.get$Value(29)};i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault=function(){return this.get$ValueOrDefault(29)};i18n.phonenumbers.PhoneMetadata.prototype.setShortCode=function(a){this.set$Value(29,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode=function(){return this.has$Value(29)};
i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount=function(){return this.count$Values(29)};i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode=function(){this.clear$Field(29)};i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate=function(){return this.get$Value(30)};i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault=function(){return this.get$ValueOrDefault(30)};i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate=function(a){this.set$Value(30,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate=function(){return this.has$Value(30)};i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount=function(){return this.count$Values(30)};i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate=function(){this.clear$Field(30)};i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific=function(){return this.get$Value(31)};i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault=function(){return this.get$ValueOrDefault(31)};
i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific=function(a){this.set$Value(31,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific=function(){return this.has$Value(31)};i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount=function(){return this.count$Values(31)};i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific=function(){this.clear$Field(31)};i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices=function(){return this.get$Value(33)};
i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault=function(){return this.get$ValueOrDefault(33)};i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices=function(a){this.set$Value(33,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices=function(){return this.has$Value(33)};i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount=function(){return this.count$Values(33)};i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices=function(){this.clear$Field(33)};
i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling=function(){return this.get$Value(24)};i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault=function(){return this.get$ValueOrDefault(24)};i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling=function(a){this.set$Value(24,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling=function(){return this.has$Value(24)};
i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount=function(){return this.count$Values(24)};i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling=function(){this.clear$Field(24)};i18n.phonenumbers.PhoneMetadata.prototype.getId=function(){return this.get$Value(9)};i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault=function(){return this.get$ValueOrDefault(9)};i18n.phonenumbers.PhoneMetadata.prototype.setId=function(a){this.set$Value(9,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasId=function(){return this.has$Value(9)};i18n.phonenumbers.PhoneMetadata.prototype.idCount=function(){return this.count$Values(9)};i18n.phonenumbers.PhoneMetadata.prototype.clearId=function(){this.clear$Field(9)};i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode=function(){return this.get$Value(10)};i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault=function(){return this.get$ValueOrDefault(10)};
i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode=function(a){this.set$Value(10,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode=function(){return this.has$Value(10)};i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount=function(){return this.count$Values(10)};i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode=function(){this.clear$Field(10)};i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix=function(){return this.get$Value(11)};
i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault=function(){return this.get$ValueOrDefault(11)};i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix=function(a){this.set$Value(11,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix=function(){return this.has$Value(11)};i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount=function(){return this.count$Values(11)};i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix=function(){this.clear$Field(11)};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix=function(){return this.get$Value(17)};i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault=function(){return this.get$ValueOrDefault(17)};i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix=function(a){this.set$Value(17,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix=function(){return this.has$Value(17)};
i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount=function(){return this.count$Values(17)};i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix=function(){this.clear$Field(17)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix=function(){return this.get$Value(12)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault=function(){return this.get$ValueOrDefault(12)};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix=function(a){this.set$Value(12,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix=function(){return this.has$Value(12)};i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount=function(){return this.count$Values(12)};i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix=function(){this.clear$Field(12)};i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix=function(){return this.get$Value(13)};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault=function(){return this.get$ValueOrDefault(13)};i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix=function(a){this.set$Value(13,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix=function(){return this.has$Value(13)};i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount=function(){return this.count$Values(13)};i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix=function(){this.clear$Field(13)};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing=function(){return this.get$Value(15)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault=function(){return this.get$ValueOrDefault(15)};i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing=function(a){this.set$Value(15,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing=function(){return this.has$Value(15)};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount=function(){return this.count$Values(15)};i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing=function(){this.clear$Field(15)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule=function(){return this.get$Value(16)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault=function(){return this.get$ValueOrDefault(16)};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule=function(a){this.set$Value(16,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule=function(){return this.has$Value(16)};i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount=function(){return this.count$Values(16)};i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule=function(){this.clear$Field(16)};
i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern=function(){return this.get$Value(18)};i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault=function(){return this.get$ValueOrDefault(18)};i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern=function(a){this.set$Value(18,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern=function(){return this.has$Value(18)};
i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount=function(){return this.count$Values(18)};i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern=function(){this.clear$Field(18)};i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat=function(a){return this.get$Value(19,a)};i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault=function(a){return this.get$ValueOrDefault(19,a)};
i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat=function(a){this.add$Value(19,a)};i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray=function(){return this.array$Values(19)};i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat=function(){return this.has$Value(19)};i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount=function(){return this.count$Values(19)};i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat=function(){this.clear$Field(19)};
i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat=function(a){return this.get$Value(20,a)};i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault=function(a){return this.get$ValueOrDefault(20,a)};i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat=function(a){this.add$Value(20,a)};i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray=function(){return this.array$Values(20)};i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat=function(){return this.has$Value(20)};
i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount=function(){return this.count$Values(20)};i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat=function(){this.clear$Field(20)};i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode=function(){return this.get$Value(22)};i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault=function(){return this.get$ValueOrDefault(22)};
i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode=function(a){this.set$Value(22,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode=function(){return this.has$Value(22)};i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount=function(){return this.count$Values(22)};i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode=function(){this.clear$Field(22)};i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits=function(){return this.get$Value(23)};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault=function(){return this.get$ValueOrDefault(23)};i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits=function(a){this.set$Value(23,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits=function(){return this.has$Value(23)};i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount=function(){return this.count$Values(23)};i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits=function(){this.clear$Field(23)};
i18n.phonenumbers.PhoneMetadataCollection=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.PhoneMetadataCollection,goog.proto2.Message);i18n.phonenumbers.PhoneMetadataCollection.descriptor_=null;i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata=function(a){return this.get$Value(1,a)};i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault=function(a){return this.get$ValueOrDefault(1,a)};
i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata=function(a){this.add$Value(1,a)};i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray=function(){return this.array$Values(1)};i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata=function(){return this.has$Value(1)};i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount=function(){return this.count$Values(1)};i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata=function(){this.clear$Field(1)};
i18n.phonenumbers.NumberFormat.prototype.getDescriptor=function(){var a=i18n.phonenumbers.NumberFormat.descriptor_;a||(i18n.phonenumbers.NumberFormat.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat,{0:{name:"NumberFormat",fullName:"i18n.phonenumbers.NumberFormat"},1:{name:"pattern",required:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},2:{name:"format",required:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},3:{name:"leading_digits_pattern",
repeated:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},4:{name:"national_prefix_formatting_rule",fieldType:goog.proto2.Message.FieldType.STRING,type:String},6:{name:"national_prefix_optional_when_formatting",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean},5:{name:"domestic_carrier_code_formatting_rule",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.NumberFormat.getDescriptor=i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneNumberDesc.descriptor_;a||(i18n.phonenumbers.PhoneNumberDesc.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc,{0:{name:"PhoneNumberDesc",fullName:"i18n.phonenumbers.PhoneNumberDesc"},2:{name:"national_number_pattern",fieldType:goog.proto2.Message.FieldType.STRING,type:String},9:{name:"possible_length",repeated:!0,fieldType:goog.proto2.Message.FieldType.INT32,type:Number},
10:{name:"possible_length_local_only",repeated:!0,fieldType:goog.proto2.Message.FieldType.INT32,type:Number},6:{name:"example_number",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.PhoneNumberDesc.getDescriptor=i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneMetadata.descriptor_;a||(i18n.phonenumbers.PhoneMetadata.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata,{0:{name:"PhoneMetadata",fullName:"i18n.phonenumbers.PhoneMetadata"},1:{name:"general_desc",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},2:{name:"fixed_line",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},
3:{name:"mobile",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},4:{name:"toll_free",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},5:{name:"premium_rate",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},6:{name:"shared_cost",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},7:{name:"personal_number",fieldType:goog.proto2.Message.FieldType.MESSAGE,
type:i18n.phonenumbers.PhoneNumberDesc},8:{name:"voip",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},21:{name:"pager",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},25:{name:"uan",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},27:{name:"emergency",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},28:{name:"voicemail",fieldType:goog.proto2.Message.FieldType.MESSAGE,
type:i18n.phonenumbers.PhoneNumberDesc},29:{name:"short_code",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},30:{name:"standard_rate",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},31:{name:"carrier_specific",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},33:{name:"sms_services",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},24:{name:"no_international_dialling",
fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},9:{name:"id",required:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},10:{name:"country_code",fieldType:goog.proto2.Message.FieldType.INT32,type:Number},11:{name:"international_prefix",fieldType:goog.proto2.Message.FieldType.STRING,type:String},17:{name:"preferred_international_prefix",fieldType:goog.proto2.Message.FieldType.STRING,type:String},12:{name:"national_prefix",fieldType:goog.proto2.Message.FieldType.STRING,
type:String},13:{name:"preferred_extn_prefix",fieldType:goog.proto2.Message.FieldType.STRING,type:String},15:{name:"national_prefix_for_parsing",fieldType:goog.proto2.Message.FieldType.STRING,type:String},16:{name:"national_prefix_transform_rule",fieldType:goog.proto2.Message.FieldType.STRING,type:String},18:{name:"same_mobile_and_fixed_line_pattern",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean},19:{name:"number_format",repeated:!0,fieldType:goog.proto2.Message.FieldType.MESSAGE,
type:i18n.phonenumbers.NumberFormat},20:{name:"intl_number_format",repeated:!0,fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.NumberFormat},22:{name:"main_country_for_code",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean},23:{name:"leading_digits",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.PhoneMetadata.getDescriptor=i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneMetadataCollection.descriptor_;a||(i18n.phonenumbers.PhoneMetadataCollection.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection,{0:{name:"PhoneMetadataCollection",fullName:"i18n.phonenumbers.PhoneMetadataCollection"},1:{name:"metadata",repeated:!0,fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneMetadata}}));return a};
i18n.phonenumbers.PhoneMetadataCollection.getDescriptor=i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;i18n.phonenumbers.PhoneNumber=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.PhoneNumber,goog.proto2.Message);i18n.phonenumbers.PhoneNumber.descriptor_=null;i18n.phonenumbers.PhoneNumber.prototype.getCountryCode=function(){return this.get$Value(1)};i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault=function(){return this.get$ValueOrDefault(1)};i18n.phonenumbers.PhoneNumber.prototype.setCountryCode=function(a){this.set$Value(1,a)};
i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode=function(){return this.has$Value(1)};i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount=function(){return this.count$Values(1)};i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode=function(){this.clear$Field(1)};i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber=function(){return this.get$Value(2)};i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault=function(){return this.get$ValueOrDefault(2)};
i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber=function(a){this.set$Value(2,a)};i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber=function(){return this.has$Value(2)};i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount=function(){return this.count$Values(2)};i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber=function(){this.clear$Field(2)};i18n.phonenumbers.PhoneNumber.prototype.getExtension=function(){return this.get$Value(3)};
i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault=function(){return this.get$ValueOrDefault(3)};i18n.phonenumbers.PhoneNumber.prototype.setExtension=function(a){this.set$Value(3,a)};i18n.phonenumbers.PhoneNumber.prototype.hasExtension=function(){return this.has$Value(3)};i18n.phonenumbers.PhoneNumber.prototype.extensionCount=function(){return this.count$Values(3)};i18n.phonenumbers.PhoneNumber.prototype.clearExtension=function(){this.clear$Field(3)};
i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero=function(){return this.get$Value(4)};i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault=function(){return this.get$ValueOrDefault(4)};i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero=function(a){this.set$Value(4,a)};i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero=function(){return this.has$Value(4)};i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount=function(){return this.count$Values(4)};
i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero=function(){this.clear$Field(4)};i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros=function(){return this.get$Value(8)};i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault=function(){return this.get$ValueOrDefault(8)};i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros=function(a){this.set$Value(8,a)};i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros=function(){return this.has$Value(8)};
i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount=function(){return this.count$Values(8)};i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros=function(){this.clear$Field(8)};i18n.phonenumbers.PhoneNumber.prototype.getRawInput=function(){return this.get$Value(5)};i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault=function(){return this.get$ValueOrDefault(5)};i18n.phonenumbers.PhoneNumber.prototype.setRawInput=function(a){this.set$Value(5,a)};
i18n.phonenumbers.PhoneNumber.prototype.hasRawInput=function(){return this.has$Value(5)};i18n.phonenumbers.PhoneNumber.prototype.rawInputCount=function(){return this.count$Values(5)};i18n.phonenumbers.PhoneNumber.prototype.clearRawInput=function(){this.clear$Field(5)};i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource=function(){return this.get$Value(6)};i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault=function(){return this.get$ValueOrDefault(6)};
i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource=function(a){this.set$Value(6,a)};i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource=function(){return this.has$Value(6)};i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount=function(){return this.count$Values(6)};i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource=function(){this.clear$Field(6)};i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode=function(){return this.get$Value(7)};
i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault=function(){return this.get$ValueOrDefault(7)};i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode=function(a){this.set$Value(7,a)};i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode=function(){return this.has$Value(7)};i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount=function(){return this.count$Values(7)};
i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode=function(){this.clear$Field(7)};i18n.phonenumbers.PhoneNumber.CountryCodeSource={UNSPECIFIED:0,FROM_NUMBER_WITH_PLUS_SIGN:1,FROM_NUMBER_WITH_IDD:5,FROM_NUMBER_WITHOUT_PLUS_SIGN:10,FROM_DEFAULT_COUNTRY:20};
i18n.phonenumbers.PhoneNumber.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneNumber.descriptor_;a||(i18n.phonenumbers.PhoneNumber.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber,{0:{name:"PhoneNumber",fullName:"i18n.phonenumbers.PhoneNumber"},1:{name:"country_code",required:!0,fieldType:goog.proto2.Message.FieldType.INT32,type:Number},2:{name:"national_number",required:!0,fieldType:goog.proto2.Message.FieldType.UINT64,type:Number},3:{name:"extension",
fieldType:goog.proto2.Message.FieldType.STRING,type:String},4:{name:"italian_leading_zero",fieldType:goog.proto2.Message.FieldType.BOOL,type:Boolean},8:{name:"number_of_leading_zeros",fieldType:goog.proto2.Message.FieldType.INT32,defaultValue:1,type:Number},5:{name:"raw_input",fieldType:goog.proto2.Message.FieldType.STRING,type:String},6:{name:"country_code_source",fieldType:goog.proto2.Message.FieldType.ENUM,defaultValue:i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED,type:i18n.phonenumbers.PhoneNumber.CountryCodeSource},
7:{name:"preferred_domestic_carrier_code",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.PhoneNumber.ctor=i18n.phonenumbers.PhoneNumber;i18n.phonenumbers.PhoneNumber.ctor.getDescriptor=i18n.phonenumbers.PhoneNumber.prototype.getDescriptor;/*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.metadata={};
i18n.phonenumbers.metadata.countryCodeToRegionCodeMap={1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),7:["RU","KZ"],20:["EG"],27:["ZA"],30:["GR"],31:["NL"],32:["BE"],33:["FR"],34:["ES"],36:["HU"],39:["IT","VA"],40:["RO"],41:["CH"],43:["AT"],44:["GB","GG","IM","JE"],45:["DK"],46:["SE"],47:["NO","SJ"],48:["PL"],49:["DE"],51:["PE"],52:["MX"],53:["CU"],54:["AR"],55:["BR"],56:["CL"],57:["CO"],58:["VE"],60:["MY"],61:["AU","CC","CX"],62:["ID"],63:["PH"],64:["NZ"],
65:["SG"],66:["TH"],81:["JP"],82:["KR"],84:["VN"],86:["CN"],90:["TR"],91:["IN"],92:["PK"],93:["AF"],94:["LK"],95:["MM"],98:["IR"],211:["SS"],212:["MA","EH"],213:["DZ"],216:["TN"],218:["LY"],220:["GM"],221:["SN"],222:["MR"],223:["ML"],224:["GN"],225:["CI"],226:["BF"],227:["NE"],228:["TG"],229:["BJ"],230:["MU"],231:["LR"],232:["SL"],233:["GH"],234:["NG"],235:["TD"],236:["CF"],237:["CM"],238:["CV"],239:["ST"],240:["GQ"],241:["GA"],242:["CG"],243:["CD"],244:["AO"],245:["GW"],246:["IO"],247:["AC"],248:["SC"],
249:["SD"],250:["RW"],251:["ET"],252:["SO"],253:["DJ"],254:["KE"],255:["TZ"],256:["UG"],257:["BI"],258:["MZ"],260:["ZM"],261:["MG"],262:["RE","YT"],263:["ZW"],264:["NA"],265:["MW"],266:["LS"],267:["BW"],268:["SZ"],269:["KM"],290:["SH","TA"],291:["ER"],297:["AW"],298:["FO"],299:["GL"],350:["GI"],351:["PT"],352:["LU"],353:["IE"],354:["IS"],355:["AL"],356:["MT"],357:["CY"],358:["FI","AX"],359:["BG"],370:["LT"],371:["LV"],372:["EE"],373:["MD"],374:["AM"],375:["BY"],376:["AD"],377:["MC"],378:["SM"],380:["UA"],
381:["RS"],382:["ME"],383:["XK"],385:["HR"],386:["SI"],387:["BA"],389:["MK"],420:["CZ"],421:["SK"],423:["LI"],500:["FK"],501:["BZ"],502:["GT"],503:["SV"],504:["HN"],505:["NI"],506:["CR"],507:["PA"],508:["PM"],509:["HT"],590:["GP","BL","MF"],591:["BO"],592:["GY"],593:["EC"],594:["GF"],595:["PY"],596:["MQ"],597:["SR"],598:["UY"],599:["CW","BQ"],670:["TL"],672:["NF"],673:["BN"],674:["NR"],675:["PG"],676:["TO"],677:["SB"],678:["VU"],679:["FJ"],680:["PW"],681:["WF"],682:["CK"],683:["NU"],685:["WS"],686:["KI"],
687:["NC"],688:["TV"],689:["PF"],690:["TK"],691:["FM"],692:["MH"],800:["001"],808:["001"],850:["KP"],852:["HK"],853:["MO"],855:["KH"],856:["LA"],870:["001"],878:["001"],880:["BD"],881:["001"],882:["001"],883:["001"],886:["TW"],888:["001"],960:["MV"],961:["LB"],962:["JO"],963:["SY"],964:["IQ"],965:["KW"],966:["SA"],967:["YE"],968:["OM"],970:["PS"],971:["AE"],972:["IL"],973:["BH"],974:["QA"],975:["BT"],976:["MN"],977:["NP"],979:["001"],992:["TJ"],993:["TM"],994:["AZ"],995:["GE"],996:["KG"],998:["UZ"]};
i18n.phonenumbers.metadata.countryToMetadata={AC:[,[,,"(?:[01589]\\d|[46])\\d{4}",,,,,,,[5,6]],[,,"6[2-467]\\d{3}",,,,"62889",,,[5]],[,,"4\\d{4}",,,,"40123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AC",247,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:0[1-9]|[1589]\\d)\\d{4}",,,,"542011",,,[6]],,,[,,,,,,,,,[-1]]],AD:[,[,,"(?:1|6\\d)\\d{7}|[135-9]\\d{5}",,,,,,,[6,8,9]],[,,"[78]\\d{5}",,,,"712345",,,[6]],[,,"690\\d{6}|[356]\\d{5}",,,,"312345",
,,[6,9]],[,,"180[02]\\d{4}",,,,"18001234",,,[8]],[,,"[19]\\d{5}",,,,"912345",,,[6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AD",376,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],[,"(\\d{4})(\\d{4})","$1 $2",["1"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],,[,,,,,,,,,[-1]],,,[,,"1800\\d{4}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AE:[,[,,"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"[2-4679][2-8]\\d{6}",,,,"22345678",,,[8],[7]],
[,,"5[024-68]\\d{7}",,,,"501234567",,,[9]],[,,"400\\d{6}|800\\d{2,9}",,,,"800123456"],[,,"900[02]\\d{5}",,,,"900234567",,,[9]],[,,"700[05]\\d{5}",,,,"700012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AE",971,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],[,"(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"600[25]\\d{5}",,,,"600212345",
,,[9]],,,[,,,,,,,,,[-1]]],AF:[,[,,"[2-7]\\d{8}",,,,,,,[9],[7]],[,,"(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",,,,"234567890",,,,[7]],[,,"7\\d{8}",,,,"701234567",,,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AF",93,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
AG:[,[,,"(?:268|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",,,,"2684601234",,,,[7]],[,,"268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",,,,"2684641234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,"26848[01]\\d{4}",,,,"2684801234",,,,[7]],"AG",1,"011","1",,,"([457]\\d{6})$|1","268$1",,,,,[,,"26840[69]\\d{4}",,,,"2684061234",,,,[7]],,"268",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AI:[,[,,"(?:264|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"264(?:292|4(?:6[12]|9[78]))\\d{4}",,,,"2644612345",,,,[7]],[,,"264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",,,,"2642351234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,
,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"AI",1,"011","1",,,"([2457]\\d{6})$|1","264$1",,,,,[,,"264724\\d{4}",,,,"2647241234",,,,[7]],,"264",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AL:[,[,,"(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
,,,,,,[6,7,8,9],[5]],[,,"4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",,,,"22345678",,,[8],[5,6,7]],[,,"6(?:[78][2-9]|9\\d)\\d{6}",,,,"672123456",,,[9]],[,,"800\\d{4}",,,,"8001234",,,[7]],[,,"900[1-9]\\d\\d",,,,"900123",,,[6]],[,,"808[1-9]\\d\\d",,,,"808123",,,[6]],[,,"700[2-9]\\d{4}",,,,"70021234",,,[8]],[,,,,,,,,,[-1]],"AL",355,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AM:[,[,,"(?:[1-489]\\d|55|60|77)\\d{6}",,,,,,,[8],[5,6]],[,,"(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",,,,"10123456",,,,[5,6]],[,,"(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",,,,"77123456"],[,,"800\\d{5}",,,,"80012345"],
[,,"90[016]\\d{5}",,,,"90012345"],[,,"80[1-4]\\d{5}",,,,"80112345"],[,,,,,,,,,[-1]],[,,"60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}",,,,"60271234"],"AM",374,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],[,"(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AO:[,[,,"[29]\\d{8}",,,,,,,[9]],[,,"2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
,,,"222123456"],[,,"9[1-79]\\d{7}",,,,"923123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AO",244,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AR:[,[,,"(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",,,,,,,[10,11],[6,7,8]],[,,"3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68])))\\d{6}|(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"1123456789",,,[10],[6,7,8]],[,,"93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68]))))\\d{6}|9(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|9(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|9(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"91123456789",,,,[6,7,8]],[,,"800\\d{7,8}",,,,"8001234567"],[,,"60[04579]\\d{7}",,,,"6001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AR",54,"00","0",,,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
"9$1",,,[[,"(\\d{3})","$1",["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]],[,"(\\d{2})(\\d{4})","$1-$2",["[1-9]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[2-9]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[1-8]"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1"],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1"]],[[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"]],
[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3-$4",["91"]],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3-$4",["9"]]],[,,,,,,,,,[-1]],,,[,,"810\\d{7}",,,,,,,[10]],[,,"810\\d{7}",,,,"8101234567",,,[10]],,,[,,,,,,,,,[-1]]],AS:[,[,,"(?:[58]\\d\\d|684|900)\\d{7}",,,,,,,[10],[7]],[,,"6846(?:22|33|44|55|77|88|9[19])\\d{4}",,,,"6846221234",,,,[7]],[,,"684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}",,,,"6847331234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"AS",1,"011","1",,,"([267]\\d{6})$|1","684$1",,,,,[,,,,,,,,,[-1]],,"684",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AT:[,[,,"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
,,,,,,[4,5,6,7,8,9,10,11,12,13],[3]],[,,"1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",,,,"1234567890",,,,[3]],[,,"6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",,,,"664123456",,,[7,8,9,10,11,12,13]],[,,"800\\d{6,10}",
,,,"800123456",,,[9,10,11,12,13]],[,,"(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",,,,"900123456",,,[9,10,11,12,13]],[,,"8(?:10|2[018])\\d{6,10}|828\\d{5}",,,,"810123456",,,[8,9,10,11,12,13]],[,,,,,,,,,[-1]],[,,"5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",,,,"780123456",,,[5,6,7,8,9,10,11,12,13]],"AT",43,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["14"]],[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],
[,"(\\d{6})","$1",["[18]"]],[,"(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],[,"(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],[,"(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
"0$1"],[,"(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AU:[,[,,"1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",,,,,,,[5,6,7,8,9,10,12]],[,,"(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
,,,"212345678",,,[9],[8]],[,,"4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"AU",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"(183[12])|0",
,"0011",,[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["13"]],[,"(\\d{3})(\\d{3})","$1 $2",["19"]],[,"(\\d{3})(\\d{4})","$1 $2",["180","1802"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["19"]],[,"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]],[,"(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",
["130"]]],[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],[,,"163\\d{2,6}",,,,"1631234",,,[5,6,7,8,9]],1,,[,,"1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",,,,,,,[6,7,8,10,12]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AW:[,[,,"(?:[25-79]\\d\\d|800)\\d{4}",
,,,,,,[7]],[,,"5(?:2\\d|8[1-9])\\d{4}",,,,"5212345"],[,,"(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",,,,"5601234"],[,,"800\\d{4}",,,,"8001234"],[,,"900\\d{4}",,,,"9001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:28\\d|501)\\d{4}",,,,"5011234"],"AW",297,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AX:[,[,,"2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
,,,,,,[5,6,7,8,9,10,11,12]],[,,"18[1-8]\\d{3,6}",,,,"181234567",,,[6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,,"412345678",,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AX",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,,,[,,,,,,,,,[-1]],,"18",[,,,,,,,,,[-1]],[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
,,,"10112345"],,,[,,,,,,,,,[-1]]],AZ:[,[,,"365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",,,,,,,[9],[7]],[,,"(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",,,,"123123456",,,,[7]],[,,"36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",,,,"401234567"],[,,"88\\d{7}",,,,"881234567"],[,,"900200\\d{3}",,,,"900200123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AZ",994,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[1-9]"]],[,
"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[13-9]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BA:[,[,,"6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",,,,,,,[8,9],[6]],[,,"(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",,,,"30212345",,,[8],[6]],[,,"6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",,,,"61123456"],[,,"8[08]\\d{6}",,,,"80123456",,,[8]],[,,"9[0246]\\d{6}",,,,"90123456",,,[8]],[,,"8[12]\\d{6}",,,,"82123456",,,[8]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BA",387,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})","$1-$2",["[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]],[,,"703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",,,,"70341234",,,[8]],,,[,,,,,,,,,[-1]]],BB:[,[,,"(?:246|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",,,,"2464123456",,,,[7]],[,,"246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",,,,"2462501234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002123456"],[,,"(?:246976|900[2-9]\\d\\d)\\d{4}",,,,"9002123456",,,,[7]],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"24631\\d{5}",,,,"2463101234",,,,[7]],"BB",1,"011","1",,,"([2-9]\\d{6})$|1","246$1",,,,,[,,,,,,,,,[-1]],,"246",[,,,,,,,,,[-1]],[,,"246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
,,,"2464301234",,,,[7]],,,[,,,,,,,,,[-1]]],BD:[,[,,"[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",,,,,,,[6,7,8,9,10]],[,,"(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
,,,"27111234"],[,,"(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",,,,"1812345678",,,[10]],[,,"80[03]\\d{7}",,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}",,,,"9604123456",,,[10]],"BD",880,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
"0$1"],[,"(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|2[23]"],"0$1"],[,"(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BE:[,[,,"4\\d{8}|[1-9]\\d{7}",,,,,,,[8,9]],[,,"80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",,,,"12345678",,,[8]],[,,"4[5-9]\\d{7}",,,,"470123456",,,[9]],[,,"800[1-9]\\d{4}",,,,"80012345",,,[8]],[,,"(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}",,,,"90012345",,,[8]],[,,"7879\\d{4}",
,,,"78791234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BE",32,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}",,,,"78102345",,,[8]],,,[,,,,,,,,,[-1]]],BF:[,[,,"[025-7]\\d{7}",
,,,,,,[8]],[,,"2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",,,,"20491234"],[,,"(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}",,,,"70123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BF",226,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BG:[,[,,"00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",,,,,,,[6,7,8,9,12],[4,5]],
[,,"2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",,,,"2123456",,,[6,7,8],[4,5]],[,,"(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",,,,"43012345",,,[8,9]],[,,"(?:00800\\d\\d|800)\\d{5}",,,,"80012345",,,[8,12]],[,,"90\\d{6}",,,,"90123456",,,[8]],[,,"700\\d{5}",,,,"70012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BG",359,"00","0",,,"0",,,,[[,"(\\d{6})","$1",["1"]],[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",
["43[1-6]|70[1-9]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],
"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BH:[,[,,"[136-9]\\d{7}",,,,,,,[8]],[,,"(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
,,,"17001234"],[,,"(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}",,,,"36001234"],[,,"8[02369]\\d{6}",,,,"80123456"],[,,"(?:87|9[0-8])\\d{6}",,,,"90123456"],[,,"84\\d{6}",,,,"84123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BH",973,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BI:[,[,,"(?:[267]\\d|31)\\d{6}",,,,,,,[8]],[,,"(?:22|31)\\d{6}",,,,"22201234"],[,,"(?:29|[67][125-9])\\d{6}",
,,,"79561234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BI",257,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BJ:[,[,,"(?:01\\d|[24-689])\\d{7}",,,,,,,[8,10]],[,,"2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}",,,,"0120211234"],[,,"(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}",,,,"0195123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,,,,,,,,[-1]],[,,"857[58]\\d{4}",,,,"85751234",,,[8]],"BJ",229,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"81\\d{6}",,,,"81123456",,,[8]],,,[,,,,,,,,,[-1]]],BL:[,[,,"(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",,,,,,,[9]],[,,"590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}",,,,"590271234"],[,,"(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",
,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",,,,"976012345"],"BL",590,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BM:[,[,,"(?:441|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",,,,"4414123456",,,,[7]],[,,"441(?:[2378]\\d|5[0-39]|9[02])\\d{5}",,,,"4413701234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],
[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"BM",1,"011","1",,,"([2-9]\\d{6})$|1","441$1",,,,,[,,,,,,,,,[-1]],,"441",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BN:[,[,,"[2-578]\\d{6}",,,,,,,[7]],[,,"22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",
,,,"2345678"],[,,"(?:22[89]|[78]\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[34]\\d{5}",,,,"5345678"],"BN",673,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BO:[,[,,"8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",,,,,,,[8,9],[7]],[,,"(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
,,,"22123456",,,[8],[7]],[,,"[67]\\d{7}",,,,"71234567",,,[8]],[,,"8001[07]\\d{4}",,,,"800171234",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"50\\d{6}",,,,"50123456",,,[8],[7]],"BO",591,"00(?:1\\d)?","0",,,"0(1\\d)?",,,,[[,"(\\d)(\\d{7})","$1 $2",["[235]|4[46]"],,"0$CC $1"],[,"(\\d{8})","$1",["[67]"],,"0$CC $1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"],,"0$CC $1"]],,[,,,,,,,,,[-1]],,,[,,"8001[07]\\d{4}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BQ:[,[,,"(?:[34]1|7\\d)\\d{5}",
,,,,,,[7]],[,,"(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",,,,"7151234"],[,,"(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",,,,"3181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BQ",599,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"[347]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BR:[,[,,"(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",,,,,,,[8,9,10,11]],[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
,,,"1123456789",,,[10],[8]],[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",,,,"11961234567",,,[10,11],[8,9]],[,,"800\\d{6,7}",,,,"800123456",,,[9,10]],[,,"300\\d{6}|[59]00\\d{6,7}",,,,"300123456",,,[9,10]],[,,"(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}",,,,"40041234",,,[8,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BR",55,"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","0",,,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2",,,[[,"(\\d{3,6})","$1",["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]],
[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],[,"(\\d{4})(\\d{4})","$1-$2",["[2-57]","[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],[,"(\\d{5})(\\d{4})","$1-$2",["9"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)",
"4(?:02|37)0|[34]00"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[,,,,,,,,,[-1]],,,[,,"30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}",,,,,,,[8,9,10]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BS:[,[,,"(?:242|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
,,,"2423456789",,,,[7]],[,,"242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}",,,,"2423591234",,,,[7]],[,,"242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456",,,,[7]],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"BS",1,"011","1",,,"([3-8]\\d{6})$|1","242$1",,,,,[,,,,,,,,,[-1]],,"242",[,,,,,,,,,[-1]],[,,"242225\\d{4}",,,,"2422250123"],,,[,,,,,,,,,[-1]]],BT:[,[,,"[17]\\d{7}|[2-8]\\d{6}",,,,,,,[7,8],[6]],[,,"(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",,,,"2345678",,,[7],[6]],[,,"(?:1[67]|77)\\d{6}",,,,"17123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BT",975,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{3})",
"$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BW:[,[,,"(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
,,,"2401234",,,[7]],[,,"(?:321|7[1-8]\\d)\\d{5}",,,,"71123456",,,[8]],[,,"(?:0800|800\\d)\\d{6}",,,,"0800012345",,,[10]],[,,"90\\d{5}",,,,"9012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}",,,,"79101234",,,[8]],"BW",267,"00",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["90"]],[,"(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",
["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BY:[,[,,"(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",,,,"152450911",,,[9],[5,6,7]],[,,"(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
,,,"294911911",,,[9]],[,,"800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",,,,"8011234567"],[,,"(?:810|902)\\d{7}",,,,"9021234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"249\\d{6}",,,,"249123456",,,[9]],"BY",375,"810","8",,,"0|80?",,"8~10",,[[,"(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],[,"(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],[,"(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
"8 0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,"800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BZ:[,[,,"(?:0800\\d|[2-8])\\d{6}",,,,,,,[7,11]],[,,"(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",,,,"2221234",,,[7]],[,,"6[0-35-7]\\d{5}",
,,,"6221234",,,[7]],[,,"0800\\d{7}",,,,"08001234123",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BZ",501,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],[,"(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CA:[,[,,"[2-9]\\d{9}|3\\d{6}",,,,,,,[7,10]],[,,"(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
,,,"5062345678",,,[10],[7]],[,,"(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",,,,"5062345678",,,[10],[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456",,,[10]],[,,"900[2-9]\\d{6}",,,,"9002123456",,,[10]],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
,,,"5002345678",,,[10]],[,,"600[2-9]\\d{6}",,,,"6002012345",,,[10]],"CA",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"310\\d{4}",,,,"3101234",,,[7]],,,[,,,,,,,,,[-1]]],CC:[,[,,"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10,12]],[,,"8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",,,,"891621234",,,[9],[8]],[,,"4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CC",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"([59]\\d{7})$|0","8$1","0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CD:[,[,,"(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
,,,,,,[7,8,9,10]],[,,"(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}",,,,"1234567"],[,,"88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}",,,,"991234567",,,[7,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CD",243,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],
"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["5"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CF:[,[,,"(?:[27]\\d{3}|8776)\\d{4}",,,,,,,[8]],[,,"2[12]\\d{6}",,,,"21612345"],[,,"7[024-7]\\d{6}",,,,"70012345"],[,,,,,,,,,[-1]],[,,"8776\\d{4}",,,,"87761234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CF",236,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
CG:[,[,,"222\\d{6}|(?:0\\d|80)\\d{7}",,,,,,,[9]],[,,"222[1-589]\\d{5}",,,,"222123456"],[,,"026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",,,,"061234567"],[,,,,,,,,,[-1]],[,,"80[0-2]\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CG",242,"00",,,,,,,,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CH:[,[,,"8\\d{11}|[2-9]\\d{8}",,,
,,,,[9,12]],[,,"(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",,,,"212345678",,,[9]],[,,"(?:6[89]|7[235-9])\\d{7}",,,,"781234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"90[016]\\d{6}",,,,"900123456",,,[9]],[,,"84[0248]\\d{6}",,,,"840123456",,,[9]],[,,"878\\d{6}",,,,"878123456",,,[9]],[,,,,,,,,,[-1]],"CH",41,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4 $5",["8"],"0$1"]],,[,,"74[0248]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"5[18]\\d{7}",,,,"581234567",,,[9]],,,[,,"860\\d{9}",,,,"860123456789",,,[12]]],CI:[,[,,"[02]\\d{9}",,,,,,,[10]],[,,"2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",,,,"2123456789"],[,,"0[157]\\d{8}",,,,"0123456789"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CI",225,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",
["2"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CK:[,[,,"[2-578]\\d{4}",,,,,,,[5]],[,,"(?:2\\d|3[13-7]|4[1-5])\\d{3}",,,,"21234"],[,,"[578]\\d{4}",,,,"71234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CK",682,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CL:[,[,,"12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
,,,,,,[9,10,11]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",,,,"221234567",,,[9]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
,,,"221234567",,,[9]],[,,"(?:123|8)00\\d{6}",,,,"800123456",,,[9,11]],[,,,,,,,,,[-1]],[,,"600\\d{7,8}",,,,"6001234567",,,[10,11]],[,,,,,,,,,[-1]],[,,"44\\d{7}",,,,"441234567",,,[9]],"CL",56,"(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",,,,,,,1,[[,"(\\d{4})","$1",["1(?:[03-589]|21)|[29]0|78"]],[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],
[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",
["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[,,,,,,,,,[-1]],,,[,,"600\\d{7,8}",,,,,,,[10,11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CM:[,[,,"[26]\\d{8}|88\\d{6,7}",,,,,,,[8,9]],[,,"2(?:22|33)\\d{6}",,,,"222123456",,,[9]],[,,"(?:24[23]|6(?:[25-9]\\d|40))\\d{6}",,,,"671234567",,,[9]],[,,"88\\d{6,7}",,,,"88012345"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CM",237,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CN:[,[,,"(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",,,,,,,[7,8,9,10,11,12],[5,6]],[,,"(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
,,,"1012345678",,,[7,8,9,10,11],[5,6]],[,,"1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",,,,"13123456789",,,[11]],[,,"(?:(?:10|21)8|8)00\\d{7}",,,,"8001234567",,,[10,12]],[,,"16[08]\\d{5}",,,,"16812345",,,[8]],[,,"10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
,,,"4001234567",,,[7,8,9,10,11],[5,6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CN",86,"00|1(?:[12]\\d|79)\\d\\d00","0",,,"(1(?:[12]\\d|79)\\d\\d)|0",,"00",,[[,"(\\d{5,6})","$1",["1(?:00|2[13])|9[56]","1(?:00|2(?:1|39))|9[56]","1(?:00|2(?:1|395))|9[56]"]],[,"(\\d{5,6})","$1",["1(?:0|23)|781|[1-9]12","1(?:0|23)|7812|[1-9]123","1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"]],[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
"(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
"10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"],
"0$1","$CC $1"],[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]","1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])","1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]","1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
"1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"]],
[,"(\\d{4})(\\d{4})","$1 $2",["16[08]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],
"0$1","$CC $1"],[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]","1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]","1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
"1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]],
[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})",
"$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
"(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
"10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"],
"0$1","$CC $1"],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],
"0$1","$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})",
"$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",,,,,,,[10,11,12]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CO:[,[,,"(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",,,,,,,[8,10,11],[4,7]],[,,"601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}",
,,,"6012345678",,,[8,10],[4,7]],[,,"333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",,,,"3211234567",,,[10]],[,,"1800\\d{7}",,,,"18001234567",,,[11]],[,,"(?:19(?:0[01]|4[78])|901)\\d{7}",,,,"19001234567",,,[10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CO",57,"00(?:4(?:[14]4|56)|[579])","0",,,"0([3579]|4(?:[14]4|56))?",,,,[[,"(\\d{4})(\\d{4})","$1 $2",["46"]],[,"(\\d{3})(\\d{7})","$1 $2",["6|90"],"($1)",
"0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"],,"0$CC $1"],[,"(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1"]],[[,"(\\d{4})(\\d{4})","$1 $2",["46"]],[,"(\\d{3})(\\d{7})","$1 $2",["6|90"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"],,"0$CC $1"],[,"(\\d)(\\d{3})(\\d{7})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CR:[,[,,"(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",,,,,,,[8,10]],[,,"210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
,,,"22123456",,,[8]],[,,"(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",,,,"83123456",,,[8]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"90[059]\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:210[0-6]|4\\d{3}|5100)\\d{4}",,,,"40001234",,,[8]],"CR",506,"00",,,,"(19(?:0[0-2468]|1[09]|20|66|77|99))",,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,
,,,,[-1]],,,[,,,,,,,,,[-1]]],CU:[,[,,"(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",,,,,,,[6,7,8,10],[4,5]],[,,"(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",,,,"71234567",,,,[4,5]],[,,"(?:5\\d|6[2-4])\\d{6}",,,,"51234567",,,[8]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,"807\\d{7}",,,,"8071234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CU",53,"119","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],[,"(\\d)(\\d{6,7})",
"$1 $2",["7"],"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],[,"(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CV:[,[,,"(?:[2-59]\\d\\d|800)\\d{4}",,,,,,,[7]],[,,"2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",,,,"2211234"],[,,"(?:36|5[1-389]|9\\d)\\d{5}",,,,"9911234"],[,,"800\\d{4}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:3[3-5]|4[356])\\d{5}",,,,"3401234"],"CV",238,"0",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})",
"$1 $2 $3",["[2-589]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CW:[,[,,"(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",,,,,,,[7,8]],[,,"9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",,,,"94351234"],[,,"953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",,,,"95181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"60[0-2]\\d{4}",,,,"6001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CW",599,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",
["[3467]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],,[,,"955\\d{5}",,,,"95581234",,,[8]],1,"[69]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CX:[,[,,"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10,12]],[,,"8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",,,,"891641234",,,[9],[8]],[,,"4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CX",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"([59]\\d{7})$|0","8$1","0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CY:[,[,,"(?:[279]\\d|[58]0)\\d{6}",,,,,,
,[8]],[,,"2[2-6]\\d{6}",,,,"22345678"],[,,"9(?:10|[4-79]\\d)\\d{5}",,,,"96123456"],[,,"800\\d{5}",,,,"80001234"],[,,"90[09]\\d{5}",,,,"90012345"],[,,"80[1-9]\\d{5}",,,,"80112345"],[,,"700\\d{5}",,,,"70012345"],[,,,,,,,,,[-1]],"CY",357,"00",,,,,,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:50|77)\\d{6}",,,,"77123456"],,,[,,,,,,,,,[-1]]],CZ:[,[,,"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",,,,,,,[9,10,11,12]],[,,"(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",,,,"212345678",
,,[9]],[,,"(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[01]|[2379]\\d\\d))\\d{5}",,,,"601123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:0[05689]|76)\\d{6}",,,,"900123456",,,[9]],[,,"8[134]\\d{7}",,,,"811234567",,,[9]],[,,"70[01]\\d{6}",,,,"700123456",,,[9]],[,,"9[17]0\\d{6}",,,,"910123456",,,[9]],"CZ",420,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],
[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"9(?:5\\d|7[2-4])\\d{6}",,,,"972123456",,,[9]],,,[,,"9(?:3\\d{9}|6\\d{7,10})",,,,"93123456789"]],DE:[,[,,"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",,,,,,,[4,5,6,7,8,9,10,11,12,13,14,15],[2,3]],[,,"32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
,,,"30123456",,,[5,6,7,8,9,10,11,12,13,14,15],[2,3,4]],[,,"16[023]\\d{7,8}|1(?:5310|7[0-57-9]\\d)\\d{6}|1(?:5[0-25-9]|76)\\d{8}",,,,"15123456789",,,[10,11]],[,,"800\\d{7,12}",,,,"8001234567890",,,[10,11,12,13,14,15]],[,,"(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",,,,"9001234567",,,[10,11]],[,,"180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",,,,"18012345",,,[7,8,9,10,11,12,13,14]],[,,"700\\d{8}",,,,"70012345678",,,[11]],[,,,,,,,,,[-1]],"DE",49,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],
"0$1"],[,"(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],[,"(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],[,"(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],[,"(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],[,"(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],[,"(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],[,"(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],[,"(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],[,"(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],
[,"(\\d{5})(\\d{6})","$1 $2",["15[03568]","15(?:[0568]|31)"],"0$1"],[,"(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],,[,,"16(?:4\\d{1,10}|[89]\\d{1,11})",,,,"16412345",,,[4,5,6,7,8,9,10,11,12,13,14]],,,[,,,,,,,,,[-1]],[,,"18(?:1\\d{5,11}|[2-9]\\d{8})",,,,"18500123456",,,[8,9,10,11,12,13,14]],,,[,,"1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
,,,"177991234567",,,[12,13]]],DJ:[,[,,"(?:2\\d|77)\\d{6}",,,,,,,[8]],[,,"2(?:1[2-5]|7[45])\\d{5}",,,,"21360003"],[,,"77\\d{6}",,,,"77831001"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DJ",253,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DK:[,[,,"[2-9]\\d{7}",,,,,,,[8]],[,,"(?:(?:2\\d|9[1-46-9])\\d|3(?:[0-37]\\d|4[013]|5[0-58]|6[01347-9]|8[0-8]|9[0-79])|4(?:[0-25]\\d|[34][02-9]|6[013-579]|7[013579]|8[0-47]|9[0-27])|5(?:[0-36]\\d|4[0146-9]|5[03-57-9]|7[0568]|8[0-358]|9[0-69])|6(?:[013578]\\d|2[0-68]|4[02-8]|6[01689]|9[015689])|7(?:[0-69]\\d|7[03-9]|8[0147])|8(?:[16-9]\\d|2[0-58]))\\d{5}",
,,,"32123456"],[,,"(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",,,,"34412345"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DK",45,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DM:[,[,,"(?:[58]\\d\\d|767|900)\\d{7}",,,,,,,[10],[7]],[,,"767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",,,,"7674201234",,,,[7]],[,,"767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
,,,"7672251234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DM",1,"011","1",,,"([2-7]\\d{6})$|1","767$1",,,,,[,,,,,,,,,[-1]],,"767",[,,,,,,,,,[-1]],[,,,,,
,,,,[-1]],,,[,,,,,,,,,[-1]]],DO:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",,,,"8092345678",,,,[7]],[,,"8[024]9[2-9]\\d{6}",,,,"8092345678",
,,,[7]],[,,"8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DO",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"8001|8[024]9",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]]],DZ:[,[,,"(?:[1-4]|[5-79]\\d|80)\\d{7}",,,,,,,[8,9]],[,,"9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}",,,,"12345678"],[,,"(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",,,,"551234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"80[3-689]1\\d{5}",,,,"808123456",,,[9]],[,,"80[12]1\\d{5}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,"98[23]\\d{6}",,,,"983123456",,,[9]],"DZ",213,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EC:[,[,,"1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",,,,,,,[8,9,10,11],[7]],[,,"[2-7][2-7]\\d{6}",,,,"22123456",,,[8],[7]],[,,"964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",,,,"991234567",,,[9]],[,,"1800\\d{7}|1[78]00\\d{6}",,,,"18001234567",,,[10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,
,,,,[-1]],[,,"[2-7]890\\d{4}",,,,"28901234",,,[8]],"EC",593,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-7]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EE:[,
[,,"8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",,,,"3212345",,,[7]],[,,"(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",,,,"51234567",,,[7,8]],[,,"800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
,,,"80012345"],[,,"(?:40\\d\\d|900)\\d{4}",,,,"9001234",,,[7,8]],[,,,,,,,,,[-1]],[,,"70[0-2]\\d{5}",,,,"70012345",,,[8]],[,,,,,,,,,[-1]],"EE",372,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,
,,,,,,,,[-1]],,,[,,"800[2-9]\\d{3}",,,,,,,[7]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EG:[,[,,"[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",,,,,,,[8,9,10],[6,7]],[,,"13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",,,,"234567890",,,[8,9],[6,7]],[,,"1[0-25]\\d{8}",,,,"1001234567",,,[10]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"EG",20,"00","0",,,"0",,,,[[,"(\\d)(\\d{7,8})","$1 $2",
["[23]"],"0$1"],[,"(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EH:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"528[89]\\d{5}",,,,"528812345"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}",,,,"650123456"],[,,"80[0-7]\\d{6}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,
,,,,,,[-1]],[,,"(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",,,,"592401234"],"EH",212,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,"528[89]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ER:[,[,,"[178]\\d{6}",,,,,,,[7],[6]],[,,"(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",,,,"8370362",,,,[6]],[,,"(?:17[1-3]|7\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ER",291,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],,[,
,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ES:[,[,,"[5-9]\\d{8}",,,,,,,[9]],[,,"96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",,,,"810123456"],[,,"(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",,,,"612345678"],[,,"[89]00\\d{6}",,,,"800123456"],[,,"80[367]\\d{6}",,,,"803123456"],[,,"90[12]\\d{6}",,,,"901123456"],
[,,"70\\d{7}",,,,"701234567"],[,,,,,,,,,[-1]],"ES",34,"00",,,,,,,,[[,"(\\d{4})","$1",["905"]],[,"(\\d{6})","$1",["[79]9"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"51\\d{7}",,,,"511234567"],,,[,,,,,,,,,[-1]]],ET:[,[,,"(?:11|[2-579]\\d)\\d{7}",,,,,,,[9],[7]],[,,"11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
,,,"111112345",,,,[7]],[,,"700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}",,,,"911234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ET",251,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FI:[,[,,"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
,,,"131234567",,,[5,6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,,"412345678",,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FI",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,[[,"(\\d{5})","$1",["75[12]"],"0$1"],[,"(\\d{5})","$1",["20[2-59]"],"0$1"],[,"(\\d{6})","$1",["11"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[68])0|70[07-9]"],"0$1"],[,"(\\d{2})(\\d{4,8})",
"$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],[,"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"],[,"(\\d)(\\d{4,9})","$1 $2",["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"]],[[,"(\\d{5})","$1",["20[2-59]"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[68])0|70[07-9]"],"0$1"],[,"(\\d{2})(\\d{4,8})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],[,"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"],[,"(\\d)(\\d{4,9})","$1 $2",["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"]],[,,,,,,,,,[-1]],1,"1[03-79]|[2-9]",[,,"20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],
[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",,,,"10112345"],,,[,,,,,,,,,[-1]]],FJ:[,[,,"45\\d{5}|(?:0800\\d|[235-9])\\d{6}",,,,,,,[7,11]],[,,"603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",,,,"3212345",,,[7]],[,,"(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",,,,"7012345",,,[7]],[,,"0800\\d{7}",,,,"08001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FJ",679,"0(?:0|52)",,,,,
,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FK:[,[,,"[2-7]\\d{4}",,,,,,,[5]],[,,"[2-47]\\d{4}",,,,"31234"],[,,"[56]\\d{4}",,,,"51234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FK",500,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FM:[,[,,"(?:[39]\\d\\d|820)\\d{4}",,,,,,,[7]],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
,,,"3201234"],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",,,,"3501234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FM",691,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[389]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FO:[,[,,"[2-9]\\d{5}",,,,,,,[6]],[,,"(?:20|[34]\\d|8[19])\\d{4}",,,,"201234"],[,,"(?:[27][1-9]|5\\d|9[16])\\d{4}",,,,"211234"],[,,"80[257-9]\\d{3}",,,,"802123"],[,,"90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
,,,"901123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:6[0-36]|88)\\d{4}",,,,"601234"],"FO",298,"00",,,,"(10(?:01|[12]0|88))",,,,[[,"(\\d{6})","$1",["[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FR:[,[,,"[1-9]\\d{8}",,,,,,,[9]],[,,"(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}",,,,"123456789"],[,,"(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",,,,"612345678"],[,,"80[0-5]\\d{6}",,,,"801234567"],[,,"836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
,,,"891123456"],[,,"8(?:1[01]|2[0156]|4[024]|84)\\d{6}",,,,"884012345"],[,,,,,,,,,[-1]],[,,"9\\d{8}",,,,"912345678"],"FR",33,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["10"]],[,"(\\d{3})(\\d{3})","$1 $2",["1"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[,,,,,,,
,,[-1]],,,[,,,,,,,,,[-1]],[,,"80[6-9]\\d{6}",,,,"806123456"],,,[,,,,,,,,,[-1]]],GA:[,[,,"(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",,,,,,,[7,8]],[,,"[01]1\\d{6}",,,,"01441234",,,[8]],[,,"(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",,,,"06031234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GA",241,"00",,,,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1",,,[[,"(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["0"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GB:[,[,,"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",,,,,,,[7,9,10],[4,5,6,8]],[,,"(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
,,,"1212345678",,,[9,10],[4,5,6,7,8]],[,,"7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",,,,"7400123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",
,,[10]],"GB",44,"00","0"," x",,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])",
"[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],,[,,"76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",,,,"7640123456",,,[10]],1,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GD:[,[,,"(?:473|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
,,,"4732691234",,,,[7]],[,,"473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}",,,,"4734031234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,
[-1]],"GD",1,"011","1",,,"([2-9]\\d{6})$|1","473$1",,,,,[,,,,,,,,,[-1]],,"473",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GE:[,[,,"(?:[3-57]\\d\\d|800)\\d{6}",,,,,,,[9],[6,7]],[,,"(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",,,,"322123456",,,,[6,7]],[,,"5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
,,,"555123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70[67]\\d{6}",,,,"706123456"],"GE",995,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"70[67]\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GF:[,[,,"(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
,,,,,,[9]],[,,"594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}",,,,"594101234"],[,,"(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}",,,,"694201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}",,,,"976012345"],"GF",594,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]|9[47]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,
,[-1]],,,[,,,,,,,,,[-1]]],GG:[,[,,"(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",,,,,,,[7,9,10],[6]],[,,"1481[25-9]\\d{5}",,,,"1481256789",,,[10],[6]],[,,"7(?:(?:781|839)\\d|911[17])\\d{5}",,,,"7781123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",,,[10]],"GG",44,"00","0",,,"([25-9]\\d{5})$|0","1481$1",,
,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",,,,"7640123456",,,[10]],,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GH:[,[,,"(?:[235]\\d{3}|800)\\d{5}",,,,,,,[8,9],[7]],[,,"3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",,,,"302345678",,,[9],[7]],[,,"(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
,,,"231234567",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GH",233,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[237]|8[0-2]"]],[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"800\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GI:[,[,,"(?:[25]\\d|60)\\d{6}",
,,,,,,[8]],[,,"2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",,,,"20012345"],[,,"5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",,,,"57123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GI",350,"00",,,,,,,,[[,"(\\d{3})(\\d{5})","$1 $2",["2"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GL:[,[,,"(?:19|[2-689]\\d|70)\\d{4}",,,,,,,[6]],[,,"(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}",,,,"321000"],[,,"[245]\\d{5}",
,,,"221234"],[,,"80\\d{4}",,,,"801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3[89]\\d{4}",,,,"381234"],"GL",299,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GM:[,[,,"[2-9]\\d{6}",,,,,,,[7]],[,,"(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",,,,"5661234"],[,,"(?:[23679]\\d|4[015]|5[0-489])\\d{5}",,,,"3012345"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GM",220,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GN:[,[,,"722\\d{6}|(?:3|6\\d)\\d{7}",,,,,,,[8,9]],[,,"3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",,,,"30241234",,,[8]],[,,"6[0-356]\\d{7}",,,,"601123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"722\\d{6}",,,,"722123456",,,[9]],"GN",224,"00",,
,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GP:[,[,,"(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",,,,,,,[9]],[,,"590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}",,,,"590201234"],[,,"(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",
,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",,,,"976012345"],"GP",590,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GQ:[,[,,"222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",,,,,,,[9]],[,,"33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",,,,"333091234"],[,,"(?:222|55\\d)\\d{6}",
,,,"222123456"],[,,"80\\d[1-9]\\d{5}",,,,"800123456"],[,,"90\\d[1-9]\\d{5}",,,,"900123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GQ",240,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],[,"(\\d{3})(\\d{6})","$1 $2",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GR:[,[,,"5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",,,,,,,[10,11,12]],[,,"2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
,,,"2123456789",,,[10]],[,,"68[57-9]\\d{7}|(?:69|94)\\d{8}",,,,"6912345678",,,[10]],[,,"800\\d{7,9}",,,,"8001234567"],[,,"90[19]\\d{7}",,,,"9091234567",,,[10]],[,,"8(?:0[16]|12|[27]5|50)\\d{7}",,,,"8011234567",,,[10]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,,,,,,,,[-1]],"GR",30,"00",,,,,,,,[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],[,"(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],[,"(\\d{3})(\\d{3,4})(\\d{5})",
"$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"5005000\\d{3}",,,,"5005000123",,,[10]],,,[,,,,,,,,,[-1]]],GT:[,[,,"80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",,,,,,,[8,11]],[,,"[267][2-9]\\d{6}",,,,"22456789",,,[8]],[,,"(?:[3-5]\\d\\d|80[0-4])\\d{5}",,,,"51234567",,,[8]],[,,"18[01]\\d{8}",,,,"18001112222",,,[11]],[,,"19\\d{9}",,,,"19001112222",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GT",502,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",
["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GU:[,[,,"(?:[58]\\d\\d|671|900)\\d{7}",,,,,,,[10],[7]],[,,"671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",,,,"6713001234",,,,[7]],[,,"671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
,,,"6713001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"GU",1,"011","1",,,"([2-9]\\d{6})$|1","671$1",,1,,,[,,,,,,,,,[-1]],,"671",[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],,,[,,,,,,,,,[-1]]],GW:[,[,,"[49]\\d{8}|4\\d{6}",,,,,,,[7,9]],[,,"443\\d{6}",,,,"443201234",,,[9]],[,,"9(?:5\\d|6[569]|77)\\d{6}",,,,"955012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"40\\d{5}",,,,"4012345",,,[7]],"GW",245,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["40"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GY:[,[,,"(?:[2-8]\\d{3}|9008)\\d{3}",,,,,,,[7]],[,,"(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
,,,"2201234"],[,,"510\\d{4}|(?:6\\d|7[0-5])\\d{5}",,,,"6091234"],[,,"(?:289|8(?:00|6[28]|88|99))\\d{4}",,,,"2891234"],[,,"9008\\d{3}",,,,"9008123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"515\\d{4}",,,,"5151234"],"GY",592,"001",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HK:[,[,,"8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",,,,,,,[5,6,7,8,9,11]],[,,"(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}",
,,,"21234567",,,[8]],[,,"(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4])|7(?:4[0-2]|6[0-5]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[05])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-49]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",,,,"51234567",,,[8]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"900(?:[0-24-9]\\d{7}|3\\d{1,4})",
,,,"90012345678",,,[5,6,7,8,11]],[,,,,,,,,,[-1]],[,,"8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",,,,"81123456",,,[8]],[,,,,,,,,,[-1]],"HK",852,"00(?:30|5[09]|[126-9]?)",,,,,,"00",,[[,"(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],,[,,"7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
,,,"71123456",,,[8]],,,[,,,,,,,,,[-1]],[,,"30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",,,,"30161234",,,[8]],,,[,,,,,,,,,[-1]]],HN:[,[,,"8\\d{10}|[237-9]\\d{7}",,,,,,,[8,11]],[,,"2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",,,,"22123456",
,,[8]],[,,"[37-9]\\d{7}",,,,"91234567",,,[8]],[,,"8002\\d{7}",,,,"80021234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"HN",504,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["8"]]],[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]],[,,,,,,,,,[-1]],,,[,,"8002\\d{7}",,,,,,,[11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HR:[,[,,"(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",,,,,,,[6,7,8,9]],[,,"1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
,,,"12345678",,,[8,9],[6,7]],[,,"9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}",,,,"921234567",,,[8,9]],[,,"80\\d{5,7}",,,,"800123456",,,[7,8,9]],[,,"6[01459]\\d{6}|6[01]\\d{4,5}",,,,"611234",,,[6,7,8]],[,,,,,,,,,[-1]],[,,"7[45]\\d{6}",,,,"74123456",,,[8]],[,,,,,,,,,[-1]],"HR",385,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{4})(\\d{3})","$1 $2 $3",
["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6|7[245]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"62\\d{6,7}|72\\d{6}",,,,"62123456",,,[8,9]],,,[,,,,,,,,,[-1]]],HT:[,[,,"(?:[2-489]\\d|55)\\d{6}",,,,,,,[8]],[,,"2(?:2\\d|5[1-5]|81|9[149])\\d{5}",,,,"22453300"],[,,"(?:[34]\\d|55)\\d{6}",,,,"34101234"],[,,"8\\d{7}",,,,
"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",,,,"98901234"],"HT",509,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HU:[,[,,"[235-7]\\d{8}|[1-9]\\d{7}",,,,,,,[8,9],[6,7]],[,,"(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",,,,"12345678",,,[8],[6,7]],[,,"(?:[257]0|3[01])\\d{7}",,,,"201234567",,,[9]],[,,"(?:[48]0\\d|680[29])\\d{5}",
,,,"80123456"],[,,"9[01]\\d{6}",,,,"90123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"21\\d{7}",,,,"211234567",,,[9]],"HU",36,"00","06",,,"06",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],,[,,,,,,,,,[-1]],,,[,,"(?:[48]0\\d|680[29])\\d{5}"],[,,"38\\d{7}",,,,"381234567",,,[9]],,,[,,,,,,,,,[-1]]],ID:[,[,,"00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
,,,,,,[7,8,9,10,11,12,13,14,15,16,17],[5,6]],[,,"2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",,,,
"218350123",,,[7,8,9,10,11],[5,6]],[,,"8[1-35-9]\\d{7,10}",,,,"812345678",,,[9,10,11,12]],[,,"00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}",,,,"8001234567",,,[8,9,10,11,12,13,14,15,16,17]],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,"804\\d{7}",,,,"8041234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ID",62,"00[89]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],[,"(\\d{3})(\\d{5,8})",
"$1 $2",["[2-79]"],"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3 $4",["001"]],[,"(\\d{2})(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3 $4",["0"]]],[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",
["2[124]|[36]1"],"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],[,"(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"001803\\d{5,11}|(?:007803\\d|8071)\\d{6}",,,,,,,[10,11,12,13,14,15,16,17]],[,
,"(?:1500|8071\\d{3})\\d{3}",,,,"8071123456",,,[7,10]],,,[,,,,,,,,,[-1]]],IE:[,[,,"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",,,,,,,[7,8,9,10],[5,6]],[,,"(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",,,,"2212345",,,,[5,6]],[,,"8(?:22|[35-9]\\d)\\d{6}",,,,"850123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,"15(?:1[2-8]|[2-8]0|9[089])\\d{6}",,,,"1520123456",
,,[10]],[,,"18[59]0\\d{6}",,,,"1850123456",,,[10]],[,,"700\\d{6}",,,,"700123456",,,[9]],[,,"76\\d{7}",,,,"761234567",,,[9]],"IE",353,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],[,"(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],[,"(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],
"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],[,"(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"18[59]0\\d{6}",,,,,,,[10]],[,,"818\\d{6}",,,,"818123456",,,[9]],,,[,,"88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",,,,"8551234567",,,[10]]],IL:[,[,,"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",,,,,,,[7,8,
9,10,11,12]],[,,"153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",,,,"21234567",,,[8,11,12],[7]],[,,"55(?:410|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",,,,"502345678",,,[9]],[,,"1(?:255|80[019]\\d{3})\\d{3}",,,,"1800123456",,,[7,10]],[,,"1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}",,,,"1919123456",,,[8,10]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,"7(?:38(?:0\\d|5[0-2569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
,,,"771234567",,,[9]],"IL",972,"0(?:0|1[2-9])","0",,,"0",,,,[[,"(\\d{4})(\\d{3})","$1-$2",["125"]],[,"(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],[,"(\\d{4})(\\d{6})","$1-$2",["159"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],[,"(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],,[,,,,,,,,,[-1]],,,[,,"1700\\d{6}",
,,,,,,[10]],[,,"1599\\d{6}",,,,"1599123456",,,[10]],,,[,,"151\\d{8,9}",,,,"15112340000",,,[11,12]]],IM:[,[,,"1624\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1624(?:230|[5-8]\\d\\d)\\d{3}",,,,"1624756789",,,,[6]],[,,"76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",,,,"7924123456"],[,,"808162\\d{4}",,,,"8081624567"],[,,"8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",,,,"9016247890"],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678"],[,,"56\\d{8}",,,,"5612345678"],"IM",44,
"00","0",,,"([25-8]\\d{5})$|0","1624$1",,,,,[,,,,,,,,,[-1]],,"74576|(?:16|7[56])24",[,,,,,,,,,[-1]],[,,"3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",,,,"5512345678"],,,[,,,,,,,,,[-1]]],IN:[,[,,"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",,,,,,,[8,9,10,11,12,13],[6,7]],[,,"2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
,,,"7410410123",,,[10],[6,7,8]],[,,"(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
,,,"8123456789",,,[10]],[,,"000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",,,,"1800123456"],[,,"186[12]\\d{9}",,,,"1861123456789",,,[13]],[,,"1860\\d{7}",,,,"18603451234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IN",91,"00","0",,,"0",,,,[[,"(\\d{7})","$1",["575"]],[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",
["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
"$1 $2 $3 $4",["0"]],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],,,1]],[[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3 $4",["18"],,,1]],[,,,,,,,,,[-1]],,,[,,"1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"],[,,"140\\d{7}",,,,"1409305260",,,[10]],,,[,,,,,,,,,[-1]]],IO:[,[,,"3\\d{6}",,,,,,,[7]],[,,"37\\d{5}",,,,"3709100"],[,,"38\\d{5}",,,,"3801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IO",246,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IQ:[,[,,"(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
,,,,,,[8,9,10],[6,7]],[,,"1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",,,,"12345678",,,[8,9],[6,7]],[,,"7[3-9]\\d{8}",,,,"7912345678",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IQ",964,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IR:[,
[,,"[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",,,,,,,[4,5,6,7,10],[8]],[,,"(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}",,,,"2123456789",,,[6,7,10],[4,5,8]],[,,"9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",,,,"9123456789",,,[10]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IR",98,"00","0",,,"0",,,,[[,"(\\d{4,5})","$1",["96"],"0$1"],[,"(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",,,,,,,[4,5,10]],[,,"96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
,,,"9601",,,[4,5]],,,[,,,,,,,,,[-1]]],IS:[,[,,"(?:38\\d|[4-9])\\d{6}",,,,,,,[7,9]],[,,"(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",,,,"4101234",,,[7]],[,,"(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",,,,"6111234"],[,,"80[0-8]\\d{4}",,,,"8001234",,,[7]],[,,"90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"49[0-24-79]\\d{4}",,,,"4921234",,,[7]],"IS",354,"00|1(?:0(?:01|[12]0)|100)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"809\\d{4}",,,,"8091234",,,[7]],,,[,,"(?:689|8(?:7[18]|80)|95[48])\\d{4}",,,,"6891234",,,[7]]],IT:[,[,,"0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",,,,,,,[6,7,8,9,10,11,12]],[,,"0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
,,,"0212345678",,,[6,7,8,9,10,11]],[,,"3[2-9]\\d{7,8}|(?:31|43)\\d{8}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",,,,"800123456",,,[6,9]],[,,"(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"IT",39,"00",,,,,,,,[[,"(\\d{4,5})","$1",["1(?:0|9[246])","1(?:0|9(?:2[2-9]|[46]))"]],
[,"(\\d{6})","$1",["1(?:1|92)"]],[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]|43"]],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],
[,"(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["1(?:44|[679])|[378]|43"]],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],[,"(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[,,,,,,,,,[-1]],1,,[,,"848\\d{6}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],JE:[,[,,"1534\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1534[0-24-8]\\d{5}",,,,"1534456789",,,,[6]],[,,"7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
,,,"7797712345"],[,,"80(?:07(?:35|81)|8901)\\d{4}",,,,"8007354567"],[,,"(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",,,,"9018105678"],[,,,,,,,,,[-1]],[,,"701511\\d{4}",,,,"7015115678"],[,,"56\\d{8}",,,,"5612345678"],"JE",44,"00","0",,,"([0-24-8]\\d{5})$|0","1534$1",,,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",,,,"7640123456"],,,[,,,,,,,,,[-1]],[,,"(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
,,,"5512345678"],,,[,,,,,,,,,[-1]]],JM:[,[,,"(?:[58]\\d\\d|658|900)\\d{7}",,,,,,,[10],[7]],[,,"8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",,,,"8765230123",,,,[7]],[,,"(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
,,,"8762101234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"JM",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"658|876",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,
,,,,[-1]]],JO:[,[,,"(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",,,,,,,[8,9]],[,,"87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
,,,"62001234",,,[8]],[,,"7(?:[78][0-25-9]|9\\d)\\d{6}",,,,"790123456",,,[9]],[,,"80\\d{6}",,,,"80012345",,,[8]],[,,"9\\d{7}",,,,"90012345",,,[8]],[,,"85\\d{6}",,,,"85012345",,,[8]],[,,"70\\d{7}",,,,"700123456",,,[9]],[,,,,,,,,,[-1]],"JO",962,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],[,"(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,"74(?:66|77)\\d{5}",,,,"746612345",
,,[9]],,,[,,,,,,,,,[-1]],[,,"8(?:10|8\\d)\\d{5}",,,,"88101234",,,[8]],,,[,,,,,,,,,[-1]]],JP:[,[,,"00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",,,,,,,[8,9,10,11,12,13,14,15,16,17]],[,,"(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",,,,"312345678",,,[9]],[,,"[7-9]0[1-9]\\d{7}",
,,,"9012345678",,,[10]],[,,"00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",,,,"120123456"],[,,"990\\d{6}",,,,"990123456",,,[9]],[,,,,,,,,,[-1]],[,,"60\\d{7}",,,,"601234567",,,[9]],[,,"50[1-9]\\d{7}",,,,"5012345678",,,[10]],"JP",81,"010","0",,,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1",,,[[,"(\\d{4})(\\d{4})","$1-$2",["007","0077","00777","00777[01]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})",
"$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],
"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{3,4})","$1-$2-$3",["007","0077"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1-$2-$3",["008"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{4})(\\d{4,5})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{5})(\\d{5,6})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{6})(\\d{6,7})","$1-$2-$3",
["0"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],[,,"20\\d{8}",,,,"2012345678",,,[10]],,,[,,"00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"],[,,"570\\d{6}",,,,"570123456",,,[9]],,,[,,,,,,,,,[-1]]],KE:[,[,,"(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",,,,,,,[7,8,9,10]],[,,"(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
,,,"202012345",,,[7,8,9]],[,,"(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}",,,,"712123456",,,[9]],[,,"800[02-8]\\d{5,6}",,,,"800223456",,,[9,10]],[,,"900[02-9]\\d{5}",,,,"900223456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KE",254,"000","0",,,"0",,,,[[,"(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KG:[,[,,"8\\d{9}|[235-9]\\d{8}",
,,,,,,[9,10],[5,6]],[,,"312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",,,,"312123456",,,[9],[5,6]],[,,"312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",,,,"700123456",,,[9]],[,,"800\\d{6,7}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KG",996,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],[,"(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KH:[,[,,"1\\d{9}|[1-9]\\d{7,8}",,,,,,,[8,9,10],[6,7]],[,,"23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
,,,"23756789",,,[8,9],[6,7]],[,,"(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",,,,"91234567",,,[8,9]],[,,"1800(?:1\\d|2[019])\\d{4}",,,,"1800123456",,,[10]],[,,"1900(?:1\\d|2[09])\\d{4}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KH",855,"00[14-9]","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],
,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KI:[,[,,"(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",,,,,,,[5,8]],[,,"(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",,,,"31234"],[,,"(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
,,,"72001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",,,,"30010000",,,[8]],"KI",686,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KM:[,[,,"[3478]\\d{6}",,,,,,,[7],[4]],[,,"7[4-7]\\d{5}",,,,"7712345",,,,[4]],[,,"[34]\\d{6}",,,,"3212345"],[,,,,,,,,,[-1]],[,,"8\\d{6}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KM",269,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",
["[3478]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KN:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",,,,"8692361234",,,,[7]],[,,"869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",,,,"8697652917",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"KN",1,"011","1",,,"([2-7]\\d{6})$|1","869$1",,,,,[,,,,,,,,,[-1]],,"869",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KP:[,[,,"85\\d{6}|(?:19\\d|[2-7])\\d{7}",,,,,,,[8,10],[6,7]],[,,"(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",,,,"21234567",,,,[6,7]],[,,"19[1-3]\\d{7}",,,,"1921234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KP",850,"00|99","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],
"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KR:[,[,,"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",,,,,,,[5,6,8,9,10,11,12,13,14],[3,4,7]],[,,"(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",,,,"22123456",,,[5,6,8,9,10],
[3,4,7]],[,,"1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",,,,"1020000000",,,[9,10]],[,,"00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}",,,,"801234567",,,[9,11,12,13,14]],[,,"60[2-9]\\d{6}",,,,"602345678",,,[9]],[,,,,,,,,,[-1]],[,,"50\\d{8,9}",,,,"5012345678",,,[10,11]],[,,"70\\d{8}",,,,"7012345678",,,[10]],"KR",82,"00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","0",,,"0(8(?:[1-46-8]|5\\d\\d))?",,,,[[,"(\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"],
"0$1"],[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[36]0|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],[,"(\\d{5})(\\d{3})(\\d{3})","$1 $2 $3",["003","0030"]],[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1",
"0$CC-$1"],[,"(\\d{5})(\\d{3,4})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{5})(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["0"]]],[[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[36]0|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],
[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1","0$CC-$1"]],[,,"15\\d{7,8}",,,,"1523456789",,,[9,10]],,,[,,"00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",,,,,,,[11,12,13,14]],[,,"1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}",,,,"15441234",,,[8]],,,[,,,,,,,,,[-1]]],KW:[,[,,"18\\d{5}|(?:[2569]\\d|41)\\d{6}",,,,,,,[7,8]],[,,"2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",,,,"22345678",,,[8]],[,,"(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
,,,"50012345",,,[8]],[,,"18\\d{5}",,,,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KW",965,"00",,,,,,,,[[,"(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],[,"(\\d{3})(\\d{5})","$1 $2",["[245]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KY:[,[,,"(?:345|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",,,,"3452221234",
,,,[7]],[,,"345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",,,,"3453231234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"(?:345976|900[2-9]\\d\\d)\\d{4}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"KY",1,"011","1",,,"([2-9]\\d{6})$|1","345$1",,,,,[,,"345849\\d{4}",,,,"3458491234"],,"345",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KZ:[,[,,"(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",,,,,,,[10,14],[5,6,7]],[,,"(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
,,,"7123456789",,,[10],[5,6,7]],[,,"7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",,,,"7710009998",,,[10]],[,,"8(?:00|108\\d{3})\\d{7}",,,,"8001234567"],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,"751\\d{7}",,,,"7511234567",,,[10]],"KZ",7,"810","8",,,"8",,"8~10",,,,[,,,,,,,,,[-1]],,"33|7",[,,"751\\d{7}",,,,,,,[10]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LA:[,[,,"[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",,,,,,,[8,9,10],[6]],[,,"(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
,,,"21212862",,,[8],[6]],[,,"208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}",,,,"2023123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LA",856,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[0135-9]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"30[0135-9]\\d{6}",,,,"301234567",,,[9]],,,[,,,,,,
,,,[-1]]],LB:[,[,,"[27-9]\\d{7}|[13-9]\\d{6}",,,,,,,[7,8]],[,,"7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",,,,"1123456"],[,,"793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}",,,,"71123456"],[,,,,,,,,,[-1]],[,,"9[01]\\d{6}",,,,"90123456",,,[8]],[,,"80\\d{6}",,,,"80123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LB",961,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LC:[,[,,"(?:[58]\\d\\d|758|900)\\d{7}",,,,,,,[10],[7]],[,,"758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",,,,"7584305678",,,,[7]],[,,"758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",,,,"7582845678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],
[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"LC",1,"011","1",,,"([2-8]\\d{6})$|1","758$1",,,,,[,,,,,,,,,[-1]],,"758",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LI:[,[,,"[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",,,,,,,[7,9]],[,,"(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
,,,"2345678",,,[7]],[,,"(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",,,,"660234567"],[,,"8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",,,,"8002222"],[,,"90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",,,,"9002222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LI",423,"00","0",,,"(1001)|0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{3})(\\d{4})",
"$1 $2 $3",["69"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"870(?:28|87)\\d\\d",,,,"8702812",,,[7]],,,[,,"697(?:42|56|[78]\\d)\\d{4}",,,,"697861234",,,[9]]],LK:[,[,,"[1-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",,,,"112345678",,,,[7]],[,,"7(?:[0-25-8]\\d|4[0-4])\\d{6}",,,,"712345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,,,,,,,,[-1]],"LK",94,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"1973\\d{5}",,,,"197312345"],,,[,,,,,,,,,[-1]]],LR:[,[,,"(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",,,,,,,[7,8,9]],[,,"2\\d{7}",,,,"21234567",,,[8]],[,,"(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}",,,,"770123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"332(?:02|[34]\\d)\\d{4}",
,,,"332021234",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LR",231,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["4[67]|[56]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-578]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LS:[,[,,"(?:[256]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"2\\d{7}",,,,"22123456"],[,,"[56]\\d{7}",,,,"50123456"],[,,"800[1256]\\d{4}",,,,"80021234"],[,,,,,,,,,[-1]],[,,
,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LS",266,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2568]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LT:[,[,,"(?:[3469]\\d|52|[78]0)\\d{6}",,,,,,,[8]],[,,"(?:3[1478]|4[124-6]|52)\\d{6}",,,,"31234567"],[,,"6\\d{7}",,,,"61234567"],[,,"80[02]\\d{5}",,,,"80012345"],[,,"9(?:0[0239]|10)\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,"70[05]\\d{5}",,,,"70012345"],[,,"[89]01\\d{5}",,,,"80123456"],"LT",370,"00","0",,,"[08]",
,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(0-$1)",,1],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"0 $1",,1],[,"(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(0-$1)",,1],[,"(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(0-$1)",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"70[67]\\d{5}",,,,"70712345"],,,[,,,,,,,,,[-1]]],LU:[,[,,"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",,,,,,,[4,5,6,7,8,9,10,11]],[,,"(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
,,,"27123456"],[,,"6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",,,,"628123456",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"90[015]\\d{5}",,,,"90012345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,,,,,,,,[-1]],[,,"20(?:1\\d{5}|[2-689]\\d{1,7})",,,,"20201234",,,[4,5,6,7,8,9,10]],"LU",352,"00",,,,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",
["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LV:[,[,,"(?:[268]\\d|90)\\d{6}",,,,,,,[8]],[,,"6\\d{7}",,,,"63123456"],[,,"23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}",,,,"21234567"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,"81\\d{6}",,,,"81123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LV",371,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",
["[269]|8[01]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LY:[,[,,"[2-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",,,,"212345678",,,,[7]],[,,"9[1-6]\\d{7}",,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LY",218,"00","0",
,,"0",,,,[[,"(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MA:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",,,,"520123456"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}",,,,"650123456"],[,,"80[0-7]\\d{6}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
,,,"592401234"],"MA",212,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],[,"(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"],"0$1"],[,"(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],[,"(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MC:[,[,,"(?:[3489]|6\\d)\\d{7}",,,,,,,[8,9]],[,,"(?:870|9[2-47-9]\\d)\\d{5}",,,,"99123456",,,[8]],[,,"4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",,,,"612345678"],
[,,"(?:800|90\\d)\\d{5}",,,,"90123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MC",377,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["87"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4 $5",["6"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"8[07]0\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MD:[,[,,"(?:[235-7]\\d|[89]0)\\d{6}",,,,,,,[8]],[,,"(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",,,,"22212345"],[,,"562\\d{5}|(?:6\\d|7[16-9])\\d{6}",,,,"62112345"],[,,"800\\d{5}",,,,"80012345"],[,,"90[056]\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,,,,,,,,[-1]],[,,"3[08]\\d{6}",,,,"30123456"],"MD",373,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})",
"$1 $2 $3",["22|3"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"803\\d{5}",,,,"80312345"],,,[,,,,,,,,,[-1]]],ME:[,[,,"(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",,,,,,,[8,9],[6]],[,,"(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",,,,"30234567",,,[8],[6]],[,,"6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",,,,"67622901",,,[8]],[,,"80(?:[0-2578]|9\\d)\\d{5}",,,,"80080002"],[,,"9(?:4[1568]|5[178])\\d{5}",,,,"94515151",
,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"78[1-49]\\d{5}",,,,"78108780",,,[8]],"ME",382,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"77[1-9]\\d{5}",,,,"77273012",,,[8]],,,[,,,,,,,,,[-1]]],MF:[,[,,"(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",,,,,,,[9]],[,,"590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",,,,"590271234"],[,,"(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",
,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",,,,"976012345"],"MF",590,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MG:[,[,,"[23]\\d{8}",,,,,,,[9],[7]],[,,"2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}",,,,"202123456",,,,[7]],[,,"3[2-47-9]\\d{7}",,,,"321234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
[,,"22\\d{7}",,,,"221234567"],"MG",261,"00","0",,,"([24-9]\\d{6})$|0","20$1",,,[[,"(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MH:[,[,,"329\\d{4}|(?:[256]\\d|45)\\d{5}",,,,,,,[7]],[,,"(?:247|528|625)\\d{4}",,,,"2471234"],[,,"(?:(?:23|54)5|329|45[35-8])\\d{4}",,,,"2351234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"635\\d{4}",,,,"6351234"],"MH",692,"011","1",,,"1",,,,[[,"(\\d{3})(\\d{4})",
"$1-$2",["[2-6]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MK:[,[,,"[2-578]\\d{7}",,,,,,,[8],[6,7]],[,,"(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",,,,"22012345",,,,[6,7]],[,,"7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
,,,"72345678"],[,,"800\\d{5}",,,,"80012345"],[,,"5\\d{7}",,,,"50012345"],[,,"8(?:0[1-9]|[1-9]\\d)\\d{5}",,,,"80123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MK",389,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ML:[,[,,"[24-9]\\d{7}",,,,,,,[8]],[,,"2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
,,,"20212345"],[,,"2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}",,,,"65012345"],[,,"80\\d{6}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ML",223,"00",,,,,,,,[[,"(\\d{4})","$1",["67[057-9]|74[045]","67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[,,,,,,,,,[-1]],,,[,,"80\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MM:[,
[,,"1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",,,,,,,[6,7,8,9,10],[5]],[,,"(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
,,,"1234567",,,[6,7,8,9],[5]],[,,"(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",,,,"92123456",,,[7,8,9,10]],[,,"80080(?:0[1-9]|2\\d)\\d{3}",,,,"8008001234",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1333\\d{4}|[12]468\\d{4}",,,,"13331234",,,[8]],"MM",95,"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})",
"$1 $2 $3",["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|452|678|86","[12]|452|6788|86"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],[,"(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],[,
"(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MN:[,[,,"[12]\\d{7,9}|[5-9]\\d{7}",,,,,,,[8,9,10],[4,5,6]],[,,"[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",,,,"53123456",,,,[4,5,6]],[,,"(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}",,,,"88123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,
,"712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",,,,"75123456",,,[8]],"MN",976,"001","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MO:[,[,,"0800\\d{3}|(?:28|[68]\\d)\\d{6}",
,,,,,,[7,8]],[,,"(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",,,,"28212345",,,[8]],[,,"6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",,,,"66123456",,,[8]],[,,"0800\\d{3}",,,,"0800501",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MO",853,"00",,,,,,,,[[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{4})(\\d{4})","$1 $2",["[268]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MP:[,[,,"[58]\\d{9}|(?:67|90)0\\d{7}",
,,,,,,[10],[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",,,,"6702345678",,,,[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",,,,"6702345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MP",1,"011","1",,,"([2-9]\\d{6})$|1","670$1",,1,,,[,,,,,,,,,[-1]],,"670",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MQ:[,[,,"(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",,,,,,,[9]],[,,"(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}",,,,"596301234"],[,,"(?:69[67]\\d\\d|7091[0-3])\\d{4}",,,,"696201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,"8[129]\\d{7}",,,,"810123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
,,,"976612345"],"MQ",596,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]|8(?:0[6-9]|[36])"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MR:[,[,,"(?:[2-4]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"(?:25[08]|35\\d|45[1-7])\\d{5}",,,,"35123456"],[,,"[2-4][0-46-9]\\d{6}",,,,"22123456"],[,,"800\\d{5}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MR",
222,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MS:[,[,,"(?:[58]\\d\\d|664|900)\\d{7}",,,,,,,[10],[7]],[,,"6644(?:1[0-3]|91)\\d{4}",,,,"6644912345",,,,[7]],[,,"664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",,,,"6644923456",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MS",1,"011","1",,,"([34]\\d{6})$|1","664$1",,,,,[,,,,,,,,,[-1]],,"664",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MT:[,[,,"3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",,,,"21001234"],[,,"(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",,,,"96961234"],[,,"800(?:02|[3467]\\d)\\d{3}",,,,"80071234"],[,,"5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",,,,
"50037123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3550\\d{4}",,,,"35501234"],"MT",356,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]],,[,,"7117\\d{4}",,,,"71171234"],,,[,,,,,,,,,[-1]],[,,"501\\d{5}",,,,"50112345"],,,[,,,,,,,,,[-1]]],MU:[,[,,"(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",,,,,,,[7,8,10]],[,,"(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",,,,"54480123",,,[7,8]],[,,"5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}",
,,,"52512345",,,[8]],[,,"802\\d{7}|80[0-2]\\d{4}",,,,"8001234",,,[7,10]],[,,"30\\d{5}",,,,"3012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3(?:20|9\\d)\\d{4}",,,,"3201234",,,[7]],"MU",230,"0(?:0|[24-7]0|3[03])",,,,,,"020",,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],[,"(\\d{4})(\\d{4})","$1 $2",["[57]"]],[,"(\\d{5})(\\d{5})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MV:[,[,,"(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",,,,,,,[7,10]],[,,"(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
,,,"6701234",,,[7]],[,,"(?:46[46]|[79]\\d\\d)\\d{4}",,,,"7712345",,,[7]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MV",960,"0(?:0|19)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1-$2",["[34679]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"4(?:0[01]|50)\\d{4}",,,,"4001234",,,[7]],,,[,,,,,,,,,[-1]]],MW:[,[,,"(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",,,,,,,[7,9]],[,,"(?:1[2-9]|2[12]\\d\\d)\\d{5}",
,,,"1234567"],[,,"111\\d{6}|(?:31|77|[89][89])\\d{7}",,,,"991234567",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MW",265,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MX:[,[,,"[2-9]\\d{9}",,,,,,,[10],[7,8]],[,,"657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
,,,"2001234567",,,,[7,8]],[,,"657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",,,,"2221234567",,,,[7,8]],[,,"8(?:00|88)\\d{7}",
,,,"8001234567"],[,,"900\\d{7}",,,,"9001234567"],[,,"300\\d{7}",,,,"3001234567"],[,,"500\\d{7}",,,,"5001234567"],[,,,,,,,,,[-1]],"MX",52,"0[09]",,,,,,"00",,[[,"(\\d{5})","$1",["53"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"]]],[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MY:[,[,,"1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
,,,,,,[8,9,10],[6,7]],[,,"4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",,,,"323856789",,,[8,9],[6,7]],[,,"1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
,,,"123456789",,,[9,10]],[,,"1[378]00\\d{6}",,,,"1300123456",,,[10]],[,,"1600\\d{6}",,,,"1600123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",,,,"1546012345",,,[10]],"MY",60,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})",
"$1-$2 $3",["3"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MZ:[,[,,"(?:2|8\\d)\\d{7}",,,,,,,[8,9]],[,,"2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",,,,"21123456",,,[8]],[,,"8[2-79]\\d{7}",,,,"821234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],"MZ",258,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NA:[,[,,"[68]\\d{7,8}",,,,,,,[8,9]],[,,"64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
,,,"61221234"],[,,"(?:60|8[1245])\\d{7}",,,,"811234567",,,[9]],[,,"80\\d{7}",,,,"800123456",,,[9]],[,,"8701\\d{5}",,,,"870123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8(?:3\\d\\d|86)\\d{5}",,,,"88612345"],"NA",264,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],,,[,,,,,,,,,[-1]]],NC:[,[,,"(?:050|[2-57-9]\\d\\d)\\d{3}",,,,,,,[6]],[,,"(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",,,,"201234"],[,,"(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",,,,"751234"],[,,"050\\d{3}",,,,"050012"],[,,"36\\d{4}",,,,"366711"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NC",687,"00",,,,,,,,[[,"(\\d{3})","$1",["5[6-8]"]],[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,
,,,,,,,,[-1]]],NE:[,[,,"[027-9]\\d{7}",,,,,,,[8]],[,,"2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",,,,"20201234"],[,,"(?:23|7[0467]|[89]\\d)\\d{6}",,,,"93123456"],[,,"08\\d{6}",,,,"08123456"],[,,"09\\d{6}",,,,"09123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NE",227,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[0467]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NF:[,[,,"[13]\\d{5}",,,,,,,[6],[5]],[,,"(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",,,,"106609",,,,[5]],[,,"(?:14|3[58])\\d{4}",,,,"381234",,,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NF",672,"00",,,,"([0-258]\\d{4})$","3$1",,,[[,"(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],[,"(\\d)(\\d{5})","$1 $2",["[13]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NG:[,[,,"38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
,,,,,,[8,10,11,12,13,14],[6,7]],[,,"(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}",,,,"2033123456",,,[8,10],[6,7]],[,,"(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}",,,,"8021234567",,,[10]],[,,"800\\d{7,11}",,,,"80017591759",,,[10,11,12,13,14]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NG",234,"009","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["3"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["[7-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["20[129]"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],[,"(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"700\\d{7,11}",,,,"7001234567",,,[10,11,12,13,14]],,,[,,,,,,,,,[-1]]],NI:[,[,,"(?:1800|[25-8]\\d{3})\\d{4}",,,,,,,[8]],[,,"2\\d{7}",,,,"21234567"],[,,"(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
,,,"81234567"],[,,"1800\\d{4}",,,,"18001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NI",505,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NL:[,[,,"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",,,,,,,[5,6,7,8,9,10,11]],[,,"(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
,,,"101234567",,,[9]],[,,"(?:6[1-58]|970\\d)\\d{7}",,,,"612345678",,,[9,11]],[,,"800\\d{4,7}",,,,"8001234",,,[7,8,9,10]],[,,"90[069]\\d{4,7}",,,,"9061234",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:85|91)\\d{7}",,,,"851234567",,,[9]],"NL",31,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["1[238]|[34]"]],[,"(\\d{2})(\\d{3,4})","$1 $2",["14"]],[,"(\\d{6})","$1",["1"]],[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,
"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],[[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})",
"$1 $2 $3",["9"],"0$1"]],[,,"66\\d{7}",,,,"662345678",,,[9]],,,[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",,,,,,,[5,6]],[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",,,,"14020",,,[5,6,9]],,,[,,,,,,,,,[-1]]],NO:[,[,,"(?:0|[2-9]\\d{3})\\d{4}",,,,,,,[5,8]],[,,"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",,,,"21234567",,,[8]],[,,"(?:4[015-8]|9\\d)\\d{6}",
,,,"40612345",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"NO",47,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],,[,,,,,,,,,[-1]],1,"[02-689]|7[0-8]",[,,,,,,,,,[-1]],[,,"(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",
,,,"81212345",,,[8]]],NP:[,[,,"(?:1\\d|9)\\d{9}|[1-9]\\d{7}",,,,,,,[8,10,11],[6,7]],[,,"(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",,,,"14567890",,,[8],[6,7]],[,,"9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}",,,,"9841234567",,,[10]],[,,"1(?:66001|800\\d\\d)\\d{5}",,,,"16600101234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NP",977,"00","0",,,"0",,,,[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})",
"$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]],[,"(\\d{4})(\\d{2})(\\d{5})","$1-$2-$3",["1"]]],[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NR:[,[,,"(?:444|(?:55|8\\d)\\d|666)\\d{4}",,,,,,,[7]],[,,"444\\d{4}",,,,"4441234"],[,,"(?:55[3-9]|666|8\\d\\d)\\d{4}",,,,"5551234"],[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NR",674,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NU:[,[,,"(?:[4-7]|888\\d)\\d{3}",,,,,,,[4,7]],[,,"[47]\\d{3}",,,,"7012",,,[4]],[,,"(?:[56]|888[1-9])\\d{3}",,,,"8884012"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NU",683,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NZ:[,[,,"[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",,,,,,,[5,6,7,8,9,10]],[,,"240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",,,,"32345678",,,[8],[7]],[,,"2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",,,,"211234567",,,[8,9,10]],[,,"508\\d{6,7}|80\\d{6,8}",,,,"800123456",,,[8,9,10]],[,,"(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",,,,"900123456",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,"70\\d{7}",
,,,"701234567",,,[9]],[,,,,,,,,,[-1]],"NZ",64,"0(?:0|161)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],
,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}",,,,"83012378"],,,[,,,,,,,,,[-1]]],OM:[,[,,"(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",,,,,,,[7,8,9]],[,,"2[1-6]\\d{6}",,,,"23123456",,,[8]],[,,"(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}",,,,"92123456",,,[8]],[,,"8007\\d{4,5}|(?:500|800[05])\\d{4}",,,,"80071234"],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"OM",968,"00",,,,,,,,[[,"(\\d{3})(\\d{4,6})",
"$1 $2",["[58]"]],[,"(\\d{2})(\\d{6})","$1 $2",["2"]],[,"(\\d{4})(\\d{4})","$1 $2",["[179]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PA:[,[,,"(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",,,,,,,[7,8,10,11]],[,,"(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
,,,"2001234",,,[7]],[,,"(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",,,,"61234567",,,[7,8]],[,,"800\\d{4,5}|(?:00800|800\\d)\\d{6}",,,,"8001234"],[,,"(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",,,,"8601234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PA",507,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[68]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PE:[,[,,"(?:[14-8]|9\\d)\\d{7}",
,,,,,,[8,9],[6,7]],[,,"(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",,,,"11234567",,,[8],[6,7]],[,,"9\\d{8}",,,,"912345678",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"805\\d{5}",,,,"80512345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,"80[24]\\d{5}",,,,"80212345",,,[8]],[,,,,,,,,,[-1]],"PE",51,"00|19(?:1[124]|77|90)00","0"," Anexo ",,"0",,"00",,[[,"(\\d{3})(\\d{5})",
"$1 $2",["80"],"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PF:[,[,,"4\\d{5}(?:\\d{2})?|8\\d{7,8}",,,,,,,[6,8,9]],[,,"4(?:0[4-689]|9[4-68])\\d{5}",,,,"40412345",,,[8]],[,,"8[7-9]\\d{6}",,,,"87123456",,,[8]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"499\\d{5}",,,,"49901234",,,[8]],
"PF",689,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,,,,,,,[-1]],,,[,,"44\\d{4}",,,,,,,[6]],[,,"44\\d{4}",,,,"440123",,,[6]],,,[,,,,,,,,,[-1]]],PG:[,[,,"(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",,,,,,,[7,8]],[,,"(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",,,,"3123456",,,[7]],[,,"(?:7\\d|8[1-38])\\d{6}",,,,"70123456",,,[8]],[,
,"180\\d{4}",,,,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"2(?:0[0-57]|7[568])\\d{4}",,,,"2751234",,,[7]],"PG",675,"00|140[1-3]",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],[,"(\\d{4})(\\d{4})","$1 $2",["[78]"]]],,[,,"27[01]\\d{4}",,,,"2700123",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PH:[,[,,"(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",,,,,,,[6,8,9,10,11,12,13],[4,5,7]],[,,"(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
,,,"232345678",,,[6,8,9,10],[4,5,7]],[,,"(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",,,,"9051234567",,,[10]],[,,"1800\\d{7,9}",,,,"180012345678",,,[11,12,13]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PH",63,"00","0",,,"0",,,,[[,"(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],[,"(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
"(0$1)"],[,"(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PK:[,[,,"122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
,,,,,,[8,9,10,11,12],[5,6,7]],[,,"(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",,,,"2123456789",,,[9,10],[5,6,7,8]],[,,"3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",,,,"3012345678",,,[10]],[,,"800\\d{5}(?:\\d{3})?",,,,"80012345",,,[8,11]],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],[,,"122\\d{6}",
,,,"122044444",,,[9]],[,,,,,,,,,[-1]],"PK",92,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],[,"(\\d{4})(\\d{5})","$1 $2",["1"]],[,"(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
"(0$1)"],[,"(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],[,"(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],[,"(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
,,,"21111825888",,,[11,12]],,,[,,,,,,,,,[-1]]],PL:[,[,,"(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",,,,,,,[6,7,8,9,10]],[,,"47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",,,,"123456789",,,[7,9]],[,,"21(?:1[013-5]|2\\d|3[4-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",,,,"512345678",,,[9]],[,,"800\\d{6,7}",,,,"800123456",,,[9,10]],[,,"70[01346-8]\\d{6}",,,,"701234567",,,[9]],[,,"801\\d{6}",,
,,"801234567",,,[9]],[,,,,,,,,,[-1]],[,,"39\\d{7}",,,,"391234567",,,[9]],"PL",48,"00",,,,,,,,[[,"(\\d{5})","$1",["19"]],[,"(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]],,[,,"64\\d{4,7}",,,,"641234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]],[,,"804\\d{6}",,,,"804123456",,,[9]],,,[,,,,,,,,,[-1]]],PM:[,[,,"[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",,,,,,,[6,9]],[,,"(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}",,,,"430123"],[,,"(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}",,,,"551234"],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,"8[129]\\d{7}",,,,"810123456",
,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PM",508,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PR:[,[,,"(?:[589]\\d\\d|787)\\d{7}",,,,,,,[10],[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"PR",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,"787|939",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PS:[,[,,"[2489]2\\d{6}|(?:1\\d|5)\\d{8}",,,,,,,[8,9,10],
[7]],[,,"(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",,,,"22234567",,,[8],[7]],[,,"5[69]\\d{7}",,,,"599123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,,,,,,,,[-1]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PS",970,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
PT:[,[,,"1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",,,,,,,[9]],[,,"2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",,,,"212345678"],[,,"6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",,,,"912345678"],[,,"80[02]\\d{6}",,,,"800123456"],[,,"(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",,,,"760123456"],[,,"80(?:8\\d|9[1579])\\d{5}",,,,"808123456"],[,,"884[0-4689]\\d{5}",,,,"884123456"],[,,"30\\d{7}",,,,"301234567"],
"PT",351,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]],,[,,"6(?:222\\d|8988)\\d{4}",,,,"622212345"],,,[,,,,,,,,,[-1]],[,,"70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}",,,,"707123456"],,,[,,"600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}",,,,"600110000"]],PW:[,[,,"(?:[24-8]\\d\\d|345|900)\\d{4}",,,,,,,[7]],[,,"(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",,,,"2771234"],[,,"(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}",
,,,"6201234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PW",680,"01[12]",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PY:[,[,,"59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
,,,"212345678",,,[7,8,9],[5,6]],[,,"9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",,,,"961456789",,,[9]],[,,"9800\\d{5,7}",,,,"98000123456",,,[9,10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8700[0-4]\\d{4}",,,,"870012345",,,[9]],"PY",595,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],[,"(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],[,"(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-7])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"[2-9]0\\d{4,7}",,,,"201234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]]],QA:[,[,,"800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",,,,,,,[7,8,9,11]],[,,"4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
,,,"44123456",,,[8]],[,,"[35-7]\\d{7}",,,,"33123456",,,[8]],[,,"800\\d{4}|(?:0080[01]|800)\\d{6}",,,,"8001234",,,[7,9,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"QA",974,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],[,"(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]],,[,,"2[16]\\d{5}",,,,"2123456",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RE:[,[,,"709\\d{6}|(?:26|[689]\\d)\\d{7}",,,,,,,[9]],[,,"26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}",,,,"262161234"],[,,"(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}",
,,,"692123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89[1-37-9]\\d{6}",,,,"891123456"],[,,"8(?:1[019]|2[0156]|84|90)\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,"9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}",,,,"939901234"],"RE",262,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-9]"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RO:[,[,,"(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",,,,,,,[6,9]],[,,"[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
,,,"211234567"],[,,"(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",,,,"712034567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"90[0136]\\d{6}",,,,"900123456",,,[9]],[,,"801\\d{6}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RO",40,"00","0"," int ",,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],[,"(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3",["[236-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:37\\d|80[578])\\d{6}",,,,"372123456",,,[9]],,,[,,,,,,,,,[-1]]],RS:[,[,,"38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",,,,,,,[6,7,8,9,10,11,12],[4,5]],[,,"(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",,,,"10234567",,,[7,8,9,10,11,12],[4,5,6]],[,,"6(?:[0-689]|7\\d)\\d{6,7}",,,,"601234567",,,[8,9,10]],[,,"800\\d{3,9}",,
,,"80012345"],[,,"(?:78\\d|90[0169])\\d{3,7}",,,,"90012345",,,[6,7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RS",381,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],[,"(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7[06]\\d{4,10}",,,,"700123456"],,,[,,,,,,,,,[-1]]],RU:[,[,,"8\\d{13}|[347-9]\\d{9}",,,,,,,[10,14],[7]],[,,"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
,,,"3011234567",,,[10],[7]],[,,"9\\d{9}",,,,"9123456789",,,[10]],[,,"8(?:0[04]|108\\d{3})\\d{7}",,,,"8001234567"],[,,"80[39]\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,,,,,,,,[-1]],"RU",7,"810","8",,,"8",,"8~10",,[[,"(\\d{3})(\\d{2})(\\d{2})","$1-$2-$3",["[0-79]"]],[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],
"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],
"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],[[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],[,,,,,,,,,[-1]],1,"3[04-689]|[489]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RW:[,[,,"(?:06|[27]\\d\\d|[89]00)\\d{6}",,,,,,,[8,9]],[,,"(?:06|2[23568]\\d)\\d{6}",,,,"250123456"],[,,"7[237-9]\\d{7}",,,,"720123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,
,"900\\d{6}",,,,"900123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RW",250,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SA:[,[,,"92\\d{7}|(?:[15]|8\\d)\\d{8}",,,,,,,[9,10],[7]],[,,"1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",,,,"112345678",,,[9],[7]],[,,"579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
,,,"512345678",,,[9]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"925\\d{6}",,,,"925012345",,,[9]],[,,"920\\d{6}",,,,"920012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SA",966,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["9"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"811\\d{7}",,,,"8110123456",
,,[10]],,,[,,,,,,,,,[-1]]],SB:[,[,,"[6-9]\\d{6}|[1-6]\\d{4}",,,,,,,[5,7]],[,,"(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",,,,"40123",,,[5]],[,,"48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",,,,"7421234"],[,,"1[38]\\d{3}",,,,"18123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[12]\\d{3}",,,,"51123",,,[5]],"SB",677,"0[01]",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]],,[,,,,,,,,,
[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SC:[,[,,"(?:[2489]\\d|64)\\d{5}",,,,,,,[7]],[,,"4[2-46]\\d{5}",,,,"4217123"],[,,"2[125-8]\\d{5}",,,,"2510123"],[,,"800[08]\\d{3}",,,,"8000000"],[,,"85\\d{5}",,,,"8512345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"971\\d{4}|(?:64|95)\\d{5}",,,,"6412345"],"SC",248,"010|0[0-2]",,,,,,"00",,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SD:[,[,,"[19]\\d{8}",,,,,,,[9]],[,
,"1(?:5\\d|8[35-7])\\d{6}",,,,"153123456"],[,,"(?:1[0-2]|9[0-3569])\\d{7}",,,,"911231234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SD",249,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SE:[,[,,"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",,,,,,,[6,7,8,9,10,12]],[,,"(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
,,,"8123456",,,[7,8,9]],[,,"7[02369]\\d{7}",,,,"701234567",,,[9]],[,,"20\\d{4,7}",,,,"20123456",,,[6,7,8,9]],[,,"649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",,,,"9001234567",,,[7,8,9,10]],[,,"77[0-7]\\d{6}",,,,"771234567",,,[9]],[,,"75[1-8]\\d{6}",,,,"751234567",,,[9]],[,,,,,,,,,[-1]],"SE",46,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1"],[,"(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
"0$1"],[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1"],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})",
"$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1"]],[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1 $2 $3",["20"]],[,"(\\d{3})(\\d{4})","$1 $2",["9(?:00|39|44|9)"]],[,"(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]],[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1 $2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1 $2 $3",["9(?:00|39|44)"]],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["10|7"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["9"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]],[,,"74[02-9]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"10[1-8]\\d{6}",,,,"102345678",,,[9]],,,[,,"(?:25[245]|67[3-68])\\d{9}",,,,"254123456789",,,[12]]],SG:[,[,,"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",,,,,,,[8,10,11]],[,,"662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
,,,"61234567",,,[8]],[,,"896[0-4]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-5])|9[0-8]\\d)\\d{5}",,,,"81234567",,,[8]],[,,"(?:18|8)00\\d{7}",,,,"18001234567",,,[10,11]],[,,"1900\\d{7}",,,,"19001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:3[12]\\d|666)\\d{5}",,,,"31234567",,,[8]],"SG",65,"0[0-3]\\d",,,,,,,,[[,"(\\d{4,5})","$1",["1[013-9]|77","1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]],[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-9]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{4})(\\d{4})(\\d{3})",
"$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-9]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7000\\d{7}",,,,"70001234567",,,[11]],,,[,,,,,,,,,[-1]]],SH:[,[,,"(?:[256]\\d|8)\\d{3}",,,,,,,[4,5]],[,,"2(?:[0-57-9]\\d|6[4-9])\\d\\d",,,,"22158"],[,,"[56]\\d{4}",,,,"51234",,,[5]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"262\\d\\d",,,,"26212",,,[5]],"SH",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],1,"[256]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SI:[,[,,"[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",,,,,,,[5,6,7,8]],[,,"(?:[1-357][2-8]|4[24-8])\\d{6}",,,,"12345678",,,[8],[7]],[,,"65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",,,,"31234567",,,[8]],[,,"80\\d{4,6}",,,,"80123456",,,[6,7,8]],[,,"89[1-3]\\d{2,5}|90\\d{4,6}",,,,"90123456"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,"(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",,,,"59012345",,,[8]],"SI",386,"00|10(?:22|66|88|99)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SJ:[,[,,"0\\d{4}|(?:[489]\\d|79)\\d{6}",
,,,,,,[5,8]],[,,"79\\d{6}",,,,"79123456",,,[8]],[,,"(?:4[015-8]|9\\d)\\d{6}",,,,"41234567",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"SJ",47,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"79",[,,,,,,,,,[-1]],[,,"(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",,,,"81212345",,,[8]]],SK:[,[,,"[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
,,,,,,[6,7,9]],[,,"(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",,,,"221234567"],[,,"909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",,,,"912123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:00|[78]\\d)\\d{6}",,,,"900123456",,,[9]],[,,"8[5-9]\\d{7}",,,,"850123456",,,[9]],[,,,,,,,,,[-1]],[,,"6(?:02|5[0-4]|9[0-6])\\d{6}",,,,"690123456",,,[9]],"SK",421,"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",
["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],[,"(\\d{4})(\\d{3})","$1 $2",["909","9090"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})",
"$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[,,"9090\\d{3}",,,,"9090123",,,[7]],,,[,,"9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",,,,,,,[7,9]],[,,"96\\d{7}",,,,"961234567",,,[9]],,,[,,,,,,,,,[-1]]],SL:[,[,,"(?:[237-9]\\d|66)\\d{6}",,,,,,,[8],[6]],[,,"22[2-4][2-9]\\d{4}",,,,"22221234",,,,[6]],[,,"(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",,,,"25123456"],[,,,,,,,,,[-1]],[,,,,,
,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SL",232,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SM:[,[,,"(?:0549|[5-7]\\d)\\d{6}",,,,,,,[8,10],[6]],[,,"0549(?:8[0157-9]|9\\d)\\d{4}",,,,"0549886377",,,[10],[6]],[,,"6[16]\\d{6}",,,,"66661212",,,[8]],[,,,,,,,,,[-1]],[,,"7[178]\\d{6}",,,,"71123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[158]\\d{6}",,,,"58001110",,,[8]],"SM",378,"00",,,
,"([89]\\d{5})$","0549$1",,,[[,"(\\d{6})","$1",["[89]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SN:[,[,,"(?:[378]\\d|93)\\d{7}",,,,,,,[9]],[,,"3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",,,,"301012345"],[,,"7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[36]|[4-7]\\d|8[35]))\\d{5}",
,,,"701234567"],[,,"800\\d{6}",,,,"800123456"],[,,"88[4689]\\d{6}",,,,"884123456"],[,,"81[02468]\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,"(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",,,,"933301234"],"SN",221,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SO:[,[,,"[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",,,,,,,[6,7,8,9]],[,,
"(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",,,,"4012345",,,[6,7]],[,,"(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",,,,"71123456",,,[7,8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SO",252,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4})","$1 $2",["8[125]"]],[,"(\\d{6})","$1",["[134]"]],[,"(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],[,"(\\d)(\\d{7})","$1 $2",
["(?:2|90)4|[67]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],[,"(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|77|9[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SR:[,[,,"(?:[2-5]|68|[78]\\d)\\d{5}",,,,,,,[6,7]],[,,"(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",,,,"211234"],[,,"(?:7[124-7]|8[124-9])\\d{5}",,,,"7412345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"56\\d{4}",,,,"561234",,,[6]],"SR",597,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})",
"$1-$2-$3",["56"]],[,"(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SS:[,[,,"[19]\\d{8}",,,,,,,[9]],[,,"1[89]\\d{7}",,,,"181234567"],[,,"(?:12|9[1257-9])\\d{7}",,,,"977123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SS",211,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,
,,,,,,[-1]]],ST:[,[,,"(?:22|9\\d)\\d{5}",,,,,,,[7]],[,,"22\\d{5}",,,,"2221234"],[,,"900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",,,,"9812345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ST",239,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SV:[,[,,"[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",,,,,,,[7,8,11]],[,,"2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
,,,"21234567",,,[8]],[,,"[67]\\d{7}",,,,"70123456",,,[8]],[,,"800\\d{8}|80[01]\\d{4}",,,,"8001234",,,[7,11]],[,,"900\\d{4}(?:\\d{4})?",,,,"9001234",,,[7,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SV",503,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[89]"]],[,"(\\d{4})(\\d{4})","$1 $2",["[267]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SX:[,[,,"7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"7215(?:4[2-8]|8[239]|9[056])\\d{4}",
,,,"7215425678",,,,[7]],[,,"7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",,,,"7215205678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"SX",1,"011","1",,,"(5\\d{6})$|1",
"721$1",,,,,[,,,,,,,,,[-1]],,"721",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SY:[,[,,"[1-359]\\d{8}|[1-5]\\d{7}",,,,,,,[8,9],[6,7]],[,,"21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",,,,"112345678",,,,[6,7]],[,,"(?:50|9[1-689])\\d{7}",,,,"944567890",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SY",963,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-4]|5[1-3]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3",["[59]"],"0$1",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SZ:[,[,,"0800\\d{4}|(?:[237]\\d|900)\\d{6}",,,,,,,[8,9]],[,,"[23][2-5]\\d{6}",,,,"22171234",,,[8]],[,,"7[6-9]\\d{6}",,,,"76123456",,,[8]],[,,"0800\\d{4}",,,,"08001234",,,[8]],[,,"900\\d{6}",,,,"900012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70\\d{6}",,,,"70012345",,,[8]],"SZ",268,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[0237]"]],[,"(\\d{5})(\\d{4})","$1 $2",["9"]]],,[,,,,,,,,,[-1]],,,[,
,"0800\\d{4}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TA:[,[,,"8\\d{3}",,,,,,,[4]],[,,"8\\d{3}",,,,"8999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TA",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"8",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TC:[,[,,"(?:[58]\\d\\d|649|900)\\d{7}",,,,,,,[10],[7]],[,,"649(?:266|712|9(?:4\\d|50))\\d{4}",,,,"6497121234",,,,[7]],[,,"649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",,,,"6492311234",,,,[7]],
[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"649(?:71[01]|966)\\d{4}",,,,"6497101234",,,,[7]],"TC",1,"011","1",,,"([2-479]\\d{6})$|1","649$1",,,,,[,,,,,,,,,[-1]],,"649",[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TD:[,[,,"(?:22|[689]\\d|77)\\d{6}",,,,,,,[8]],[,,"22(?:[37-9]0|5[0-5]|6[89])\\d{4}",,,,"22501234"],[,,"(?:[69]\\d|77|8[56])\\d{6}",,,,"63012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TD",235,"00|16",,,,,,"00",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TG:[,[,,"[279]\\d{7}",,,,,,,[8]],[,,"2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
,,,"22212345"],[,,"(?:7[0-29]|9[0-36-9])\\d{6}",,,,"90112345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TG",228,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TH:[,[,,"(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",,,,,,,[8,9,10,13]],[,,"(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",,,,"21234567",,,[8]],[,,"67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
,,,"812345678",,,[9]],[,,"(?:001800\\d|1800)\\d{6}",,,,"1800123456",,,[10,13]],[,,"1900\\d{6}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"6[08]\\d{7}",,,,"601234567",,,[9]],"TH",66,"00[1-9]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TJ:[,[,,"[0-57-9]\\d{8}",,,,,,,[9],[3,5,6,7]],[,,"(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
,,,"372123456",,,,[3,5,6,7]],[,,"(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0178]|2[02]|[34]0|5[05]|7[01578]|8[078])\\d{7}",,,,"917123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TJ",992,"810",,,,,,"8~10",,[[,"(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[02-479]|[34]7"]],[,"(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3(?:[1245]|3[12])"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],,[,,
,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TK:[,[,,"[2-47]\\d{3,6}",,,,,,,[4,5,6,7]],[,,"(?:2[2-4]|[34]\\d)\\d{2,5}",,,,"3101"],[,,"7[2-4]\\d{2,5}",,,,"7290"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TK",690,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TL:[,[,,"7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",,,,,,,[7,8]],[,,"(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",,,,"2112345",,,[7]],[,,"7[2-8]\\d{6}",,,,"77212345",,,
[8]],[,,"80\\d{5}",,,,"8012345",,,[7]],[,,"90\\d{5}",,,,"9012345",,,[7]],[,,,,,,,,,[-1]],[,,"70\\d{5}",,,,"7012345",,,[7]],[,,,,,,,,,[-1]],"TL",670,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],[,"(\\d{4})(\\d{4})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TM:[,[,,"(?:[1-6]\\d|71)\\d{6}",,,,,,,[8]],[,,"(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",,,,"12345678"],[,,"(?:6\\d|71)\\d{6}",
,,,"66123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TM",993,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[67]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TN:[,[,,"[2-57-9]\\d{7}",,,,,,,[8]],[,,"81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",,,,"30010123"],[,,"3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
,,,"20123456"],[,,"8010\\d{4}",,,,"80101234"],[,,"88\\d{6}",,,,"88123456"],[,,"8[12]10\\d{4}",,,,"81101234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TN",216,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TO:[,[,,"(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",,,,,,,[5,7]],[,,"(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",,,,"20123",,,[5]],[,,"(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
,,,"7715123",,,[7]],[,,"0800\\d{3}",,,,"0800222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"55[0-37-9]\\d{4}",,,,"5510123",,,[7]],"TO",676,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TR:[,[,,"4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",,,,,,,[7,10,12,13]],[,,"(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
,,,"2123456789",,,[10]],[,,"561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",,,,"5012345678",,,[10]],[,,"8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",,,,"8001234567",,,[10,12,13]],[,,"(?:8[89]8|900)\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,"592(?:21[12]|461)\\d{4}",,,,"5922121234",,,[10]],[,,"850\\d{7}",,,,"8500123456",,,[10]],"TR",90,"00","0",,,"0",,,,[[,"(\\d{3})(\\d)(\\d{3})","$1 $2 $3",["444"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],
[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",,1]],[[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",,1]],[,,"512\\d{7}",,,,"5123456789",,,[10]],,,[,,"(?:444|811\\d{3})\\d{4}",,,,,,,[7,10]],[,,"444\\d{4}",,,,"4441444",,,[7]],,,[,,,,,,,,,[-1]]],TT:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",,,,"8682211234",,,,[7]],[,,"868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
,,,"8682911234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"TT",1,"011","1",,,"([2-46-8]\\d{6})$|1","868$1",,,,,[,,,,,,,,,[-1]],,"868",[,,,,,,,,,[-1]],[,,
,,,,,,,[-1]],,,[,,"868619\\d{4}",,,,"8686191234",,,,[7]]],TV:[,[,,"(?:2|7\\d\\d|90)\\d{4}",,,,,,,[5,6,7]],[,,"2[02-9]\\d{3}",,,,"20123",,,[5]],[,,"(?:7[01]\\d|90)\\d{4}",,,,"901234",,,[6,7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TV",688,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2"]],[,"(\\d{2})(\\d{4})","$1 $2",["90"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TW:[,[,,"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
,,,,,,[7,8,9,10,11]],[,,"(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
,,,"221234567",,,[8,9]],[,,"(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",,,,"912345678",,,[9]],[,,"80[0-79]\\d{6}|800\\d{5}",,,,"800123456",,,[8,9]],[,,"20(?:[013-9]\\d\\d|2)\\d{4}",,,,"203123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"99\\d{7}",,,,"990123456",,,[9]],[,,"7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",,,,"7012345678",,,[10,11]],"TW",886,"0(?:0[25-79]|19)","0","#",,"0",,,,[[,"(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],[,"(\\d)(\\d{3,4})(\\d{4})",
"$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"50[0-46-9]\\d{6}",,,,"500123456",,,[9]],,,[,,,,,,,,,[-1]]],TZ:[,[,,"(?:[25-8]\\d|41|90)\\d{7}",,,,,,,[9]],[,,"2[2-8]\\d{7}",,,,"222345678"],[,,"(?:6[125-9]|7[13-9])\\d{7}",,,,"621234567"],[,,"80[08]\\d{6}",,,,"800123456"],[,,"90\\d{7}",,,,"900123456"],
[,,"8(?:40|6[01])\\d{6}",,,,"840123456"],[,,,,,,,,,[-1]],[,,"41\\d{7}",,,,"412345678"],"TZ",255,"00[056]","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["5"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UA:[,[,,"[89]\\d{9}|[3-9]\\d{8}",,,,,,,[9,10],[5,6,7]],[,,"(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
,,,"311234567",,,[9],[5,6,7]],[,,"790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}",,,,"501234567",,,[9]],[,,"800[1-8]\\d{5,6}",,,,"800123456"],[,,"900[239]\\d{5,6}",,,,"900212345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"89[1-579]\\d{6}",,,,"891234567",,,[9]],"UA",380,"00","0",,,"0",,"0~0",,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],[,"(\\d{4})(\\d{5})",
"$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UG:[,[,,"800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",,,,,,,[9],[5,6,7]],[,,"20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
,,,"312345678",,,,[5,6,7]],[,,"72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-6]|9[89])\\d{6}",,,,"712345678"],[,,"800[1-3]\\d{5}",,,,"800123456"],[,,"90[1-3]\\d{6}",,,,"901123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UG",256,"00[057]","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],US:[,[,,"[2-9]\\d{9}|3\\d{6}",
,,,,,,[10],[7]],[,,"(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"305209\\d{4}",,,,"3052090123",,,,[7]],"US",1,"011","1",,,"1",,,1,[[,"(\\d{3})(\\d{4})","$1-$2",["310"],,,1],
[,"(\\d{3})(\\d{4})","$1-$2",["[24-9]|3(?:[02-9]|1[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],,,1]],[[,"(\\d{3})(\\d{4})","$1-$2",["310"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[2-9]"]]],[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UY:[,[,,"0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",,,,,,,[6,7,8,9,10,11,12,13]],[,,"(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}",,,,"21231234",,,[8],[7]],[,,"9[1-9]\\d{6}",,,,"94231234",,,[8]],[,,"0004\\d{2,9}|(?:405|80[05])\\d{4}",
,,,"8001234"],[,,"90[0-8]\\d{4}",,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UY",598,"0(?:0|1[3-9]\\d)","0"," int. ",,"0",,"00",,[[,"(\\d{3})(\\d{3,4})","$1 $2",["0"]],[,"(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[124]"]],[,"(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,
,,,,,,[-1]]],UZ:[,[,,"(?:20|33|[5-79]\\d|88)\\d{7}",,,,,,,[9]],[,,"(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}",,,,"669050123"],[,,"(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UZ",998,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VA:[,[,,"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",,,,,,,[6,7,8,9,10,11,12]],[,,"06698\\d{1,6}",,,,"0669812345",,,[6,7,8,9,10,11]],[,,"3[1-9]\\d{8}|3[2-9]\\d{7}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",
,,,"800123456",,,[6,9]],[,,"(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"VA",39,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"06698",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],VC:[,[,,"(?:[58]\\d\\d|784|900)\\d{7}",,,,,,,[10],[7]],
[,,"784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",,,,"7842661234",,,,[7]],[,,"784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",,,,"7844301234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,"78451[0-2]\\d{4}",,,,"7845101234",,,,[7]],"VC",1,"011","1",,,"([2-7]\\d{6})$|1","784$1",,,,,[,,,,,,,,,[-1]],,"784",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VE:[,[,,"[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",,,,,,,[10],[7]],[,,"(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",,,,"2121234567",,,,[7]],[,,"4(?:1[24-8]|2[46])\\d{7}",,,,"4121234567"],[,,"800\\d{7}",,,,"8001234567"],[,,"90[01]\\d{7}",,,,"9001234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
"VE",58,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1","$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"501\\d{7}",,,,"5010123456",,,,[7]],,,[,,,,,,,,,[-1]]],VG:[,[,,"(?:284|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",,,,"2842291234",,,,[7]],[,,"284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",,,,"2843001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",
,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"VG",1,"011","1",,,"([2-578]\\d{6})$|1","284$1",,,,,[,,,,,,,,,[-1]],,"284",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VI:[,[,,"[58]\\d{9}|(?:34|90)0\\d{7}",,,,,,,[10],[7]],[,,"340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
,,,"3406421234",,,,[7]],[,,"340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",,,,"3406421234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"VI",1,"011","1",,,"([2-9]\\d{6})$|1","340$1",,1,,,[,,,,,,,,,[-1]],,"340",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VN:[,[,,"[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",,,,,,,[7,8,9,10]],[,,"2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",,,,"2101234567",,,[10]],[,,"(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",,,,"912345678",,,[9]],[,,"1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
,,,"1800123456",,,[8,9,10]],[,,"1900\\d{4,6}",,,,"1900123456",,,[8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"672\\d{6}",,,,"672012345",,,[9]],"VN",84,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[17]99"],"0$1",,1],[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{3})(\\d{4,5})","$1 $2",["69"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})",
"$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"[17]99\\d{4}|69\\d{5,6}",,,,,,,[7,8]],[,,"(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
,,,"1992000",,,[7,8]],,,[,,,,,,,,,[-1]]],VU:[,[,,"[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",,,,,,,[5,7]],[,,"(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",,,,"22123",,,[5]],[,,"(?:[58]\\d|7[013-7])\\d{5}",,,,"5912345",,,[7]],[,,"81[18]\\d\\d",,,,"81123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:0[1-9]|1[01])\\d{4}",,,,"9010123",,,[7]],"VU",678,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:3[03]|900\\d)\\d{3}",,,,"30123"],,
,[,,,,,,,,,[-1]]],WF:[,[,,"(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",,,,,,,[6,9]],[,,"72\\d{4}",,,,"721234",,,[6]],[,,"(?:72|8[23])\\d{4}",,,,"821234",,,[6]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9[23]\\d{4}",,,,"921234",,,[6]],"WF",681,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[47-9]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"[48]0\\d{4}",,,,"401234",,,[6]]],WS:[,
[,,"(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",,,,,,,[5,6,7,10]],[,,"6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",,,,"22123",,,[5,6]],[,,"(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",,,,"7212345",,,[7,10]],[,,"800\\d{3}",,,,"800123",,,[6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"WS",685,"0",,,,,,,,[[,"(\\d{5})","$1",["[2-5]|6[1-9]"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],XK:[,
[,,"2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",,,,,,,[8,9,10,11,12]],[,,"38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})",,,,"28012345"],[,,"4[3-9]\\d{6}",,,,"43201234",,,[8]],[,,"800\\d{5}",,,,"80001234",,,[8]],[,,"900\\d{5}",,,,"90001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"XK",383,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2|39"],"0$1"],[,"(\\d{2})(\\d{7,10})",
"$1 $2",["3"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YE:[,[,,"(?:1|7\\d)\\d{7}|[1-7]\\d{6}",,,,,,,[7,8,9],[6]],[,,"78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",,,,"1234567",,,[7,8],[6]],[,,"7[01378]\\d{7}",,,,"712345678",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"YE",967,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YT:[,[,,"7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",,,,,,,[9]],[,,"269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}",,,,"269601234"],[,,"(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}",,,,"639012345"],[,,"80\\d{7}",,,,"801234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:39|47)8[01]|769\\d)\\d{4}",,,,"939801234"],"YT",262,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ZA:[,[,,"[1-79]\\d{8}|8\\d{4,9}",,,,,,,[5,6,7,8,9,10]],[,,"(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",,,,"101234567",,,[9]],[,,"(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
,,,"711234567",,,[5,6,7,8,9]],[,,"80\\d{7}",,,,"801234567",,,[9]],[,,"(?:86[2-9]|9[0-2]\\d)\\d{6}",,,,"862345678",,,[9]],[,,"860\\d{6}",,,,"860123456",,,[9]],[,,,,,,,,,[-1]],[,,"87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",,,,"871234567",,,[9]],"ZA",27,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})",
"$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"861\\d{6,7}",,,,"861123456",,,[9,10]],,,[,,,,,,,,,[-1]]],ZM:[,[,,"800\\d{6}|(?:21|63|[79]\\d)\\d{7}",,,,,,,[9],[6]],[,,"21[1-8]\\d{6}",,,,"211234567",,,,[6]],[,,"(?:7[5-79]|9[5-8])\\d{7}",,,,"955123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"63\\d{7}",,,,"630123456"],"ZM",260,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[1-9]"]],
[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ZW:[,[,,"2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",,,,,,,[5,6,7,8,9,10],[3,4]],[,,"(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
,,,"1312345",,,,[3,4]],[,,"7(?:[1278]\\d|3[1-9])\\d{6}",,,,"712345678",,,[9]],[,,"80(?:[01]\\d|20|8[0-8])\\d{3}",,,,"8001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",,,,"8686123456",,,[10]],"ZW",263,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],[,"(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],
[,"(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],[,"(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],800:[,[,,"(?:00|[1-9]\\d)\\d{6}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:00|[1-9]\\d)\\d{6}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",800,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["\\d"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]]],808:[,[,,"[1-9]\\d{7}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1-9]\\d{7}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",808,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],870:[,[,,"7\\d{11}|[235-7]\\d{8}",,,,,,,[9,12]],[,,,,,,,,,[-1]],[,,"(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",,,,"301234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,
"2\\d{8}",,,,"201234567",,,[9]],"001",870,,,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],878:[,[,,"10\\d{10}",,,,,,,[12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"10\\d{10}",,,,"101234567890"],"001",878,,,,,,,,1,[[,"(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],881:[,[,,"6\\d{9}|[0-36-9]\\d{8}",
,,,,,,[9,10]],[,,,,,,,,,[-1]],[,,"6\\d{9}|[0-36-9]\\d{8}",,,,"612345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",881,,,,,,,,,[[,"(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],[,"(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],882:[,[,,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",,,,,,,[7,8,9,10,11,12]],[,,,,,,,,,[-1]],[,,"342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
,,,"3421234",,,[7,8,9,10,12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}",,,,"390123456789"],"001",882,,,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["16|342"]],[,"(\\d{2})(\\d{6})","$1 $2",["49"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],[,"(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],[,"(\\d{2})(\\d{3,4})(\\d{4})",
"$1 $2 $3",["16"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],[,"(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"348[57]\\d{7}",,,,"34851234567",,,[11]]],883:[,[,,"(?:[1-4]\\d|51)\\d{6,10}",,,,,,,[8,9,10,11,12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
,,,"510012345"],"001",883,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],[,"(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],888:[,[,,"\\d{11}",,,,,,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",888,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"\\d{11}",,,,"12345678901"],,,[,,,,,,,,,[-1]]],979:[,[,,"[1359]\\d{8}",,,,,,,[9],[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1359]\\d{8}",,,,"123456789",,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",979,,,,,,,,1,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]]};/*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.PhoneNumberUtil=function(){this.regionToMetadataMap={}};goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);i18n.phonenumbers.Error={INVALID_COUNTRY_CODE:"Invalid country calling code",NOT_A_NUMBER:"The string supplied did not seem to be a phone number",TOO_SHORT_AFTER_IDD:"Phone number too short after IDD",TOO_SHORT_NSN:"The string supplied is too short to be a phone number",TOO_LONG:"The string supplied is too long to be a phone number"};
i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_=1;i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_=2;i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_=17;i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_=3;i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_=250;i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_="ZZ";i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_={54:"9"};i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_=[52,54,55];
i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN="+";i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_="*";i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_=";ext=";i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_="tel:";i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_=";phone-context=";i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_=";isub=";
i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9"};
i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","+":i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN,"*":"*","#":"#"};i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_={A:"2",B:"2",C:"2",D:"3",E:"3",F:"3",G:"4",H:"4",I:"4",J:"5",K:"5",L:"5",M:"6",N:"6",O:"6",P:"7",Q:"7",R:"7",S:"7",T:"8",U:"8",V:"8",W:"9",X:"9",Y:"9",Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9",
A:"2",B:"2",C:"2",D:"3",E:"3",F:"3",G:"4",H:"4",I:"4",J:"5",K:"5",L:"5",M:"6",N:"6",O:"6",P:"7",Q:"7",R:"7",S:"7",T:"8",U:"8",V:"8",W:"9",X:"9",Y:"9",Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",A:"A",B:"B",C:"C",D:"D",E:"E",F:"F",G:"G",H:"H",I:"I",J:"J",K:"K",L:"L",M:"M",N:"N",O:"O",P:"P",Q:"Q",R:"R",S:"S",T:"T",U:"U",V:"V",W:"W",X:"X",Y:"Y",Z:"Z",a:"A",b:"B",c:"C",d:"D",e:"E",f:"F",g:"G",h:"H",i:"I",j:"J",k:"K",l:"L",m:"M",n:"N",o:"O",p:"P",q:"Q",r:"R",s:"S",t:"T",u:"U",v:"V",w:"W",x:"X",y:"Y",z:"Z","-":"-","\uff0d":"-","\u2010":"-","\u2011":"-","\u2012":"-",
"\u2013":"-","\u2014":"-","\u2015":"-","\u2212":"-","/":"/","\uff0f":"/"," ":" ","\u3000":" ","\u2060":" ",".":".","\uff0e":"."};i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_=/[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION="-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e";i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_="0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9";
i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_="A-Za-z";i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_="+\uff0b";i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN=new RegExp("["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+"]+");i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN=new RegExp("^["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+"]+");i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_="["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]+";
i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN=new RegExp("(["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"])");i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_=new RegExp("["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]");i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_=/[\\\/] *x/;
i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_=new RegExp("[^"+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_+"#]+$");i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_=/(?:.*?[A-Za-z]){3}.*/;i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_="["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]{"+i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_+"}";
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_="["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+"]*(?:["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_+"]*["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]){3,}["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_+i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]*";
i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_=" ext. ";i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_="[\\-\\.\\(\\)]?";i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_="(["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]|"+i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_+")";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_="^\\"+i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_+"*["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]"+i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_+"*$";i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_=new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_);
i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_=i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_;i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_="["+i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_+"]+((\\-)*["+i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_+"])*";i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_="["+i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_+"]+((\\-)*["+i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_+"])*";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_="^("+i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_+"\\.)*"+i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_+"\\.?$";i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_=new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_);i18n.phonenumbers.PhoneNumberUtil.extnDigits_=function(a){return"(["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]{1,"+a+"})"};
i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_=function(){var a=i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20"),b="[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|\u0434\u043e\u0431|anexo)[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20")+"#?",c="[ \u00a0\\t,]*(?:[x\uff58#\uff03~\uff5e]|int|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9")+
"#?",d="[- ]+"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("6")+"#",e="[ \u00a0\\t]*(?:,{2}|;)[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("15")+"#?",f="[ \u00a0\\t]*(?:,)+[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9")+"#?";return a+"|"+b+"|"+c+"|"+d+"|"+e+"|"+f};i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_=new RegExp("(?:"+i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_()+")$","i");
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_=new RegExp("^"+i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_+"$|^"+i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_+"(?:"+i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_()+")?$","i");i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_=/\D+/;i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_=/(\$\d)/;i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_=/\$NP/;i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_=/\$FG/;
i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_=/\$CC/;i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_=/^\(?\$1\)?$/;i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY="001";i18n.phonenumbers.PhoneNumberFormat={E164:0,INTERNATIONAL:1,NATIONAL:2,RFC3966:3};i18n.phonenumbers.PhoneNumberType={FIXED_LINE:0,MOBILE:1,FIXED_LINE_OR_MOBILE:2,TOLL_FREE:3,PREMIUM_RATE:4,SHARED_COST:5,VOIP:6,PERSONAL_NUMBER:7,PAGER:8,UAN:9,VOICEMAIL:10,UNKNOWN:-1};
i18n.phonenumbers.PhoneNumberUtil.MatchType={NOT_A_NUMBER:0,NO_MATCH:1,SHORT_NSN_MATCH:2,NSN_MATCH:3,EXACT_MATCH:4};i18n.phonenumbers.PhoneNumberUtil.ValidationResult={IS_POSSIBLE:0,IS_POSSIBLE_LOCAL_ONLY:4,INVALID_COUNTRY_CODE:1,TOO_SHORT:2,INVALID_LENGTH:5,TOO_LONG:3};
i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber=function(a){var b=a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);0<=b?(a=a.substring(b),a=a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_,""),b=a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_),0<=b&&(a=a.substring(0,b))):a="";return a};
i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber=function(a){return a.length<i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_?!1:i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_,a)};
i18n.phonenumbers.PhoneNumberUtil.normalize=function(a){return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_,a)?i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_,!0):i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a)};i18n.phonenumbers.PhoneNumberUtil.normalizeSB_=function(a){var b=i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());a.clear();a.append(b)};
i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly=function(a){return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS,!0)};i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly=function(a){return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_,!0)};
i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber=function(a){return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_,!1)};i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode=function(a){var b=this.getMetadataForRegion(this.getRegionCodeForNumber(a));return null!=b&&(b.hasNationalPrefix()||a.hasItalianLeadingZero())&&this.isNumberGeographical(a)?this.getLengthOfNationalDestinationCode(a):0};
i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode=function(a){if(a.hasExtension()){var b=a.clone();b.clearExtension()}else b=a;b=this.format(b,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);0==b[0].length&&b.shift();return 2>=b.length?0:this.getNumberType(a)==i18n.phonenumbers.PhoneNumberType.MOBILE&&(a=i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()),""!=a)?b[2].length+
a.length:b[1].length};i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken=function(a){return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a]||""};i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions=function(){return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a){return isNaN(a)})};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes=function(){return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a){return!isNaN(a)}).map(function(a){return parseInt(a,10)})};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes=function(){var a=Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);return[].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()),$jscomp.arrayFromIterable(a.map(function(b){return parseInt(b,10)})))};i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_=function(a){return null!=a&&(1!=a.possibleLengthCount()||-1!=a.possibleLengthArray()[0])};
i18n.phonenumbers.PhoneNumberUtil.descHasData_=function(a){return null!=a&&(a.hasExampleNumber()||i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a)||a.hasNationalNumberPattern())};
i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_=function(a){var b=[];goog.object.forEach(i18n.phonenumbers.PhoneNumberType,function(c){if(c!=i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE&&c!=i18n.phonenumbers.PhoneNumberType.UNKNOWN){var d=i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a,c);i18n.phonenumbers.PhoneNumberUtil.descHasData_(d)&&b.push(c)}});return b};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion=function(a){return this.isValidRegionCode_(a)?i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)):[]};i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity=function(a){a=this.getMetadataForNonGeographicalRegion(a);return null==a?[]:i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a)};
i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_=function(a,b,c){for(var d=new goog.string.StringBuffer,e,f,g=a.length,h=0;h<g;++h)e=a.charAt(h),f=b[e.toUpperCase()],null!=f?d.append(f):c||d.append(e);return d.toString()};i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly=function(a){return 0==a.length||i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical=function(a){var b=this.getNumberType(a);return b==i18n.phonenumbers.PhoneNumberType.FIXED_LINE||b==i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE||i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(a.getCountryCodeOrDefault())&&b==i18n.phonenumbers.PhoneNumberType.MOBILE};i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_=function(a){return null!=a&&isNaN(a)&&a.toUpperCase()in i18n.phonenumbers.metadata.countryToMetadata};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_=function(a){return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap};
i18n.phonenumbers.PhoneNumberUtil.prototype.format=function(a,b){if(0==a.getNationalNumber()&&a.hasRawInput()){var c=a.getRawInputOrDefault();if(0<c.length)return c}c=a.getCountryCodeOrDefault();var d=this.getNationalSignificantNumber(a);if(b==i18n.phonenumbers.PhoneNumberFormat.E164)return this.prefixNumberWithCountryCallingCode_(c,i18n.phonenumbers.PhoneNumberFormat.E164,d,"");if(!this.hasValidCountryCallingCode_(c))return d;var e=this.getRegionCodeForCountryCode(c);e=this.getMetadataForRegionOrCallingCode_(c,
e);a=this.maybeGetFormattedExtension_(a,e,b);d=this.formatNsn_(d,e,b);return this.prefixNumberWithCountryCallingCode_(c,b,d,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern=function(a,b,c){var d=a.getCountryCodeOrDefault(),e=this.getNationalSignificantNumber(a);if(!this.hasValidCountryCallingCode_(d))return e;var f=this.getRegionCodeForCountryCode(d);f=this.getMetadataForRegionOrCallingCode_(d,f);var g=this.chooseFormattingPatternForNumber_(c,e);if(null!=g){c=g.clone();g=g.getNationalPrefixFormattingRuleOrDefault();if(0<g.length){var h=f.getNationalPrefixOrDefault();0<h.length?(g=g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_,
h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_,"$1"),c.setNationalPrefixFormattingRule(g)):c.clearNationalPrefixFormattingRule()}e=this.formatNsnUsingPattern_(e,c,b)}a=this.maybeGetFormattedExtension_(a,f,b);return this.prefixNumberWithCountryCallingCode_(d,b,e,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode=function(a,b){var c=a.getCountryCodeOrDefault(),d=this.getNationalSignificantNumber(a);if(!this.hasValidCountryCallingCode_(c))return d;var e=this.getRegionCodeForCountryCode(c);e=this.getMetadataForRegionOrCallingCode_(c,e);a=this.maybeGetFormattedExtension_(a,e,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);b=this.formatNsn_(d,e,i18n.phonenumbers.PhoneNumberFormat.NATIONAL,b);return this.prefixNumberWithCountryCallingCode_(c,
i18n.phonenumbers.PhoneNumberFormat.NATIONAL,b,a)};i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_=function(a,b){return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY==b?this.getMetadataForNonGeographicalRegion(a):this.getMetadataForRegion(b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode=function(a,b){return this.formatNationalNumberWithCarrierCode(a,0<a.getPreferredDomesticCarrierCodeOrDefault().length?a.getPreferredDomesticCarrierCodeOrDefault():b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing=function(a,b,c){var d=a.getCountryCodeOrDefault();if(!this.hasValidCountryCallingCode_(d))return a.hasRawInput()?a.getRawInputOrDefault():"";var e="";a=a.clone();a.clearExtension();var f=this.getRegionCodeForCountryCode(d),g=this.getNumberType(a),h=g!=i18n.phonenumbers.PhoneNumberType.UNKNOWN;if(b==f)e=g==i18n.phonenumbers.PhoneNumberType.FIXED_LINE||g==i18n.phonenumbers.PhoneNumberType.MOBILE||g==i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE,
"BR"==f&&e?e=0<a.getPreferredDomesticCarrierCodeOrDefault().length?this.formatNationalNumberWithPreferredCarrierCode(a,""):"":d==i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_?(b=this.getMetadataForRegion(b),e=this.canBeInternationallyDialled(a)&&this.testNumberLength_(this.getNationalSignificantNumber(a),b)!=i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT?this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL):this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL)):
e=(f==i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY||("MX"==f||"CL"==f||"UZ"==f)&&e)&&this.canBeInternationallyDialled(a)?this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL):this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);else if(h&&this.canBeInternationallyDialled(a))return c?this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL):this.format(a,i18n.phonenumbers.PhoneNumberFormat.E164);return c?e:i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber=function(a,b){if(!this.isValidRegionCode_(b))return this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);var c=a.getCountryCodeOrDefault(),d=this.getNationalSignificantNumber(a);if(!this.hasValidCountryCallingCode_(c))return d;if(c==i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_){if(this.isNANPACountry(b))return c+" "+this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL)}else if(c==this.getCountryCodeForValidRegion_(b))return this.format(a,
i18n.phonenumbers.PhoneNumberFormat.NATIONAL);var e=this.getMetadataForRegion(b),f=e.getInternationalPrefixOrDefault();b="";e.hasPreferredInternationalPrefix()?b=e.getPreferredInternationalPrefixOrDefault():i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_,f)&&(b=f);e=this.getRegionCodeForCountryCode(c);e=this.getMetadataForRegionOrCallingCode_(c,e);d=this.formatNsn_(d,e,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);a=this.maybeGetFormattedExtension_(a,
e,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);return 0<b.length?b+" "+c+" "+d+a:this.prefixNumberWithCountryCallingCode_(c,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL,d,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat=function(a,b){if(a.hasRawInput()&&!this.hasFormattingPatternForNumber_(a))return a.getRawInputOrDefault();if(!a.hasCountryCodeSource())return this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);switch(a.getCountryCodeSource()){case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:b=this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);break;case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:b=
this.formatOutOfCountryCallingNumber(a,b);break;case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:b=this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);break;default:var c=this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()),d=this.getNddPrefixForRegion(c,!0);b=this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);if(null!=d&&0!=d.length&&!this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(),d,c)&&(c=this.getMetadataForRegion(c),
d=this.getNationalSignificantNumber(a),c=this.chooseFormattingPatternForNumber_(c.numberFormatArray(),d),null!=c)){d=c.getNationalPrefixFormattingRuleOrDefault();var e=d.indexOf("$1");0>=e||(d=d.substring(0,e),d=i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d),0!=d.length&&(b=c.clone(),b.clearNationalPrefixFormattingRule(),b=this.formatByPattern(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL,[b])))}}a=a.getRawInputOrDefault();null!=b&&0<a.length&&(c=i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(b),
d=i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(a),c!=d&&(b=a));return b};i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_=function(a,b,c){a=i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);if(goog.string.startsWith(a,b))try{return this.isValidNumber(this.parse(a.substring(b.length),c))}catch(d){}return!1};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_=function(a){var b=a.getCountryCodeOrDefault(),c=this.getRegionCodeForCountryCode(b);b=this.getMetadataForRegionOrCallingCode_(b,c);if(null==b)return!1;a=this.getNationalSignificantNumber(a);return null!=this.chooseFormattingPatternForNumber_(b.numberFormatArray(),a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars=function(a,b){var c=a.getRawInputOrDefault();if(0==c.length)return this.formatOutOfCountryCallingNumber(a,b);var d=a.getCountryCodeOrDefault();if(!this.hasValidCountryCallingCode_(d))return c;c=i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c,i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_,!0);var e=this.getNationalSignificantNumber(a);if(3<e.length){var f=c.indexOf(e.substring(0,3));-1!=f&&(c=
c.substring(f))}f=this.getMetadataForRegion(b);if(d==i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_){if(this.isNANPACountry(b))return d+" "+c}else if(null!=f&&d==this.getCountryCodeForValidRegion_(b)){d=this.chooseFormattingPatternForNumber_(f.numberFormatArray(),e);if(null==d)return c;d=d.clone();d.setPattern("(\\d+)(.*)");d.setFormat("$1$2");return this.formatNsnUsingPattern_(c,d,i18n.phonenumbers.PhoneNumberFormat.NATIONAL)}b="";null!=f&&(b=f.getInternationalPrefixOrDefault(),b=i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_,
b)?b:f.getPreferredInternationalPrefixOrDefault());f=this.getRegionCodeForCountryCode(d);f=this.getMetadataForRegionOrCallingCode_(d,f);a=this.maybeGetFormattedExtension_(a,f,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);return 0<b.length?b+" "+d+" "+c+a:this.prefixNumberWithCountryCallingCode_(d,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL,c,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber=function(a){if(!a.hasNationalNumber())return"";var b=""+a.getNationalNumber();return a.hasItalianLeadingZero()&&a.getItalianLeadingZero()&&0<a.getNumberOfLeadingZerosOrDefault()?Array(a.getNumberOfLeadingZerosOrDefault()+1).join("0")+b:b};
i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_=function(a,b,c,d){switch(b){case i18n.phonenumbers.PhoneNumberFormat.E164:return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+a+c+d;case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+a+" "+c+d;case i18n.phonenumbers.PhoneNumberFormat.RFC3966:return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_+i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+a+"-"+c+d;default:return c+
d}};i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_=function(a,b,c,d){b=0==b.intlNumberFormatArray().length||c==i18n.phonenumbers.PhoneNumberFormat.NATIONAL?b.numberFormatArray():b.intlNumberFormatArray();b=this.chooseFormattingPatternForNumber_(b,a);return null==b?a:this.formatNsnUsingPattern_(a,b,c,d)};
i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_=function(a,b){for(var c,d=a.length,e=0;e<d;++e){c=a[e];var f=c.leadingDigitsPatternCount();if(0==f||0==b.search(c.getLeadingDigitsPattern(f-1)))if(f=new RegExp(c.getPattern()),i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,b))return c}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_=function(a,b,c,d){var e=b.getFormatOrDefault(),f=new RegExp(b.getPattern()),g=b.getDomesticCarrierCodeFormattingRuleOrDefault();c==i18n.phonenumbers.PhoneNumberFormat.NATIONAL&&null!=d&&0<d.length&&0<g.length?(b=g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_,d),e=e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_,b),a=a.replace(f,e)):(b=b.getNationalPrefixFormattingRuleOrDefault(),a=c==i18n.phonenumbers.PhoneNumberFormat.NATIONAL&&
null!=b&&0<b.length?a.replace(f,e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_,b)):a.replace(f,e));c==i18n.phonenumbers.PhoneNumberFormat.RFC3966&&(a=a.replace(new RegExp("^"+i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_),""),a=a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_,"g"),"-"));return a};i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber=function(a){return this.getExampleNumberForType(a,i18n.phonenumbers.PhoneNumberType.FIXED_LINE)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType=function(a,b){if(!this.isValidRegionCode_(a))return null;b=i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a),b);try{if(b.hasExampleNumber())return this.parse(b.getExampleNumber(),a)}catch(c){}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity=function(a){var b=this.getMetadataForNonGeographicalRegion(a);if(null!=b&&(b=[b.getMobile(),b.getTollFree(),b.getSharedCost(),b.getVoip(),b.getVoicemail(),b.getUan(),b.getPremiumRate()].find(function(c,d){return c.hasExampleNumber()}),void 0!==b))try{return this.parse("+"+a+b.getExampleNumber(),"ZZ")}catch(c){}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_=function(a,b,c){return a.hasExtension()&&0!=a.getExtension().length?c==i18n.phonenumbers.PhoneNumberFormat.RFC3966?i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_+a.getExtension():b.hasPreferredExtnPrefix()?b.getPreferredExtnPrefix()+a.getExtensionOrDefault():i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_+a.getExtensionOrDefault():""};
i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_=function(a,b){switch(b){case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:return a.getPremiumRate();case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:return a.getTollFree();case i18n.phonenumbers.PhoneNumberType.MOBILE:return a.getMobile();case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:return a.getFixedLine();case i18n.phonenumbers.PhoneNumberType.SHARED_COST:return a.getSharedCost();
case i18n.phonenumbers.PhoneNumberType.VOIP:return a.getVoip();case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:return a.getPersonalNumber();case i18n.phonenumbers.PhoneNumberType.PAGER:return a.getPager();case i18n.phonenumbers.PhoneNumberType.UAN:return a.getUan();case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:return a.getVoicemail();default:return a.getGeneralDesc()}};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType=function(a){var b=this.getRegionCodeForNumber(a);b=this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(),b);if(null==b)return i18n.phonenumbers.PhoneNumberType.UNKNOWN;a=this.getNationalSignificantNumber(a);return this.getNumberTypeHelper_(a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_=function(a,b){return this.isNumberMatchingDesc_(a,b.getGeneralDesc())?this.isNumberMatchingDesc_(a,b.getPremiumRate())?i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:this.isNumberMatchingDesc_(a,b.getTollFree())?i18n.phonenumbers.PhoneNumberType.TOLL_FREE:this.isNumberMatchingDesc_(a,b.getSharedCost())?i18n.phonenumbers.PhoneNumberType.SHARED_COST:this.isNumberMatchingDesc_(a,b.getVoip())?i18n.phonenumbers.PhoneNumberType.VOIP:this.isNumberMatchingDesc_(a,
b.getPersonalNumber())?i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:this.isNumberMatchingDesc_(a,b.getPager())?i18n.phonenumbers.PhoneNumberType.PAGER:this.isNumberMatchingDesc_(a,b.getUan())?i18n.phonenumbers.PhoneNumberType.UAN:this.isNumberMatchingDesc_(a,b.getVoicemail())?i18n.phonenumbers.PhoneNumberType.VOICEMAIL:this.isNumberMatchingDesc_(a,b.getFixedLine())?b.getSameMobileAndFixedLinePattern()||this.isNumberMatchingDesc_(a,b.getMobile())?i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
i18n.phonenumbers.PhoneNumberType.FIXED_LINE:!b.getSameMobileAndFixedLinePattern()&&this.isNumberMatchingDesc_(a,b.getMobile())?i18n.phonenumbers.PhoneNumberType.MOBILE:i18n.phonenumbers.PhoneNumberType.UNKNOWN:i18n.phonenumbers.PhoneNumberType.UNKNOWN};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion=function(a){if(null==a)return null;a=a.toUpperCase();var b=this.regionToMetadataMap[a];if(null==b){b=new goog.proto2.PbLiteSerializer;var c=i18n.phonenumbers.metadata.countryToMetadata[a];if(null==c)return null;b=b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(),c);this.regionToMetadataMap[a]=b}return b};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion=function(a){return this.getMetadataForRegion(""+a)};i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_=function(a,b){var c=a.length;return 0<b.possibleLengthCount()&&-1==b.possibleLengthArray().indexOf(c)?!1:i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(),a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber=function(a){var b=this.getRegionCodeForNumber(a);return this.isValidNumberForRegion(a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion=function(a,b){var c=a.getCountryCodeOrDefault(),d=this.getMetadataForRegionOrCallingCode_(c,b);if(null==d||i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY!=b&&c!=this.getCountryCodeForValidRegion_(b))return!1;a=this.getNationalSignificantNumber(a);return this.getNumberTypeHelper_(a,d)!=i18n.phonenumbers.PhoneNumberType.UNKNOWN};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber=function(a){if(null==a)return null;var b=a.getCountryCodeOrDefault();b=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];return null==b?null:1==b.length?b[0]:this.getRegionCodeForNumberFromRegionList_(a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_=function(a,b){a=this.getNationalSignificantNumber(a);for(var c,d=b.length,e=0;e<d;e++){c=b[e];var f=this.getMetadataForRegion(c);if(f.hasLeadingDigits()){if(0==a.search(f.getLeadingDigits()))return c}else if(this.getNumberTypeHelper_(a,f)!=i18n.phonenumbers.PhoneNumberType.UNKNOWN)return c}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode=function(a){a=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];return null==a?i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_:a[0]};i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode=function(a){a=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];return null==a?[]:a};
i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion=function(a){return this.isValidRegionCode_(a)?this.getCountryCodeForValidRegion_(a):0};i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_=function(a){var b=this.getMetadataForRegion(a);if(null==b)throw Error("Invalid region code: "+a);return b.getCountryCodeOrDefault()};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion=function(a,b){a=this.getMetadataForRegion(a);if(null==a)return null;a=a.getNationalPrefixOrDefault();if(0==a.length)return null;b&&(a=a.replace("~",""));return a};i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry=function(a){return null!=a&&i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(a.toUpperCase())};
i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber=function(a){if(!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a))return!1;a=new goog.string.StringBuffer(a);this.maybeStripExtension(a);return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_,a.toString())};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber=function(a){a=this.isPossibleNumberWithReason(a);return a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE||a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY};i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType=function(a,b){a=this.isPossibleNumberForTypeWithReason(a,b);return a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE||a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_=function(a,b){return this.testNumberLengthForType_(a,b,i18n.phonenumbers.PhoneNumberType.UNKNOWN)};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_=function(a,b,c){var d=i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b,c),e=0==d.possibleLengthCount()?b.getGeneralDesc().possibleLengthArray():d.possibleLengthArray();d=d.possibleLengthLocalOnlyArray();if(c==i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE)if(i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b,i18n.phonenumbers.PhoneNumberType.FIXED_LINE)))c=
i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b,i18n.phonenumbers.PhoneNumberType.MOBILE),i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c)&&(e=e.concat(0==c.possibleLengthCount()?b.getGeneralDesc().possibleLengthArray():c.possibleLengthArray()),e.sort(),0==d.length?d=c.possibleLengthLocalOnlyArray():(d=d.concat(c.possibleLengthLocalOnlyArray()),d.sort()));else return this.testNumberLengthForType_(a,b,i18n.phonenumbers.PhoneNumberType.MOBILE);if(-1==e[0])return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
a=a.length;if(-1<d.indexOf(a))return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;b=e[0];return b==a?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE:b>a?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT:e[e.length-1]<a?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG:-1<e.indexOf(a,1)?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE:i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason=function(a){return this.isPossibleNumberForTypeWithReason(a,i18n.phonenumbers.PhoneNumberType.UNKNOWN)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason=function(a,b){var c=this.getNationalSignificantNumber(a);a=a.getCountryCodeOrDefault();if(!this.hasValidCountryCallingCode_(a))return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;var d=this.getRegionCodeForCountryCode(a);a=this.getMetadataForRegionOrCallingCode_(a,d);return this.testNumberLengthForType_(c,a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString=function(a,b){try{return this.isPossibleNumber(this.parse(a,b))}catch(c){return!1}};
i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber=function(a){if(this.isValidNumber(a))return!0;var b=a.clone(),c=a.getNationalNumberOrDefault();do if(c=Math.floor(c/10),b.setNationalNumber(c),0==c||this.isPossibleNumberWithReason(b)==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT)return!1;while(!this.isValidNumber(b));a.setNationalNumber(c);return!0};
i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode=function(a,b){a=a.toString();if(0==a.length||"0"==a.charAt(0))return 0;for(var c,d=a.length,e=1;e<=i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_&&e<=d;++e)if(c=parseInt(a.substring(0,e),10),c in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap)return b.append(a.substring(e)),c;return 0};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode=function(a,b,c,d,e){if(0==a.length)return 0;a=new goog.string.StringBuffer(a);var f;null!=b&&(f=b.getInternationalPrefix());null==f&&(f="NonMatch");f=this.maybeStripInternationalPrefixAndNormalize(a,f);d&&e.setCountryCodeSource(f);if(f!=i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY){if(a.getLength()<=i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
b=this.extractCountryCode(a,c);if(0!=b)return e.setCountryCode(b),b;throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);}if(null!=b){f=b.getCountryCodeOrDefault();var g=""+f,h=a.toString();if(goog.string.startsWith(h,g)&&(g=new goog.string.StringBuffer(h.substring(g.length)),h=b.getGeneralDesc(),h=new RegExp(h.getNationalNumberPatternOrDefault()),this.maybeStripNationalPrefixAndCarrierCode(g,b,null),g=g.toString(),!i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h,a.toString())&&i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h,
g)||this.testNumberLength_(a.toString(),b)==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG))return c.append(g),d&&e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN),e.setCountryCode(f),f}e.setCountryCode(0);return 0};
i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_=function(a,b){var c=b.toString();if(0==c.search(a)){a=c.match(a)[0].length;var d=c.substring(a).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);if(d&&null!=d[1]&&0<d[1].length&&"0"==i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d[1]))return!1;b.clear();b.append(c.substring(a));return!0}return!1};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize=function(a,b){var c=a.toString();if(0==c.length)return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;if(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c))return c=c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN,""),a.clear(),a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)),i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
b=new RegExp(b);i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);return this.parsePrefixAsIdd_(b,a)?i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode=function(a,b,c){var d=a.toString(),e=d.length,f=b.getNationalPrefixForParsing();if(0==e||null==f||0==f.length)return!1;var g=new RegExp("^(?:"+f+")");if(e=g.exec(d)){f=new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());var h=i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,d),k=e.length-1;b=b.getNationalPrefixTransformRule();if(null==b||0==b.length||null==e[k]||0==e[k].length){if(h&&!i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,
d.substring(e[0].length)))return!1;null!=c&&0<k&&null!=e[k]&&c.append(e[1]);a.set(d.substring(e[0].length))}else{d=d.replace(g,b);if(h&&!i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,d))return!1;null!=c&&0<k&&c.append(e[1]);a.set(d)}return!0}return!1};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension=function(a){var b=a.toString(),c=b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);if(0<=c&&i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0,c)))for(var d=b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_),e=d.length,f=1;f<e;++f)if(null!=d[f]&&0<d[f].length)return a.clear(),a.append(b.substring(0,c)),d[f];return""};
i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_=function(a,b){return this.isValidRegionCode_(b)||null!=a&&0<a.length&&i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a)};i18n.phonenumbers.PhoneNumberUtil.prototype.parse=function(a,b){return this.parseHelper_(a,b,!1,!0)};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput=function(a,b){if(!this.isValidRegionCode_(b)&&0<a.length&&a.charAt(0)!=i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN)throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);return this.parseHelper_(a,b,!0,!0)};i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_=function(a,b){if(1<a.length&&"0"==a.charAt(0)){b.setItalianLeadingZero(!0);for(var c=1;c<a.length-1&&"0"==a.charAt(c);)c++;1!=c&&b.setNumberOfLeadingZeros(c)}};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_=function(a,b,c,d){if(null==a)throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);if(a.length>i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_)throw Error(i18n.phonenumbers.Error.TOO_LONG);var e=new goog.string.StringBuffer;this.buildNationalNumberForParsing_(a,e);if(!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString()))throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);if(d&&!this.checkRegionForParsing_(e.toString(),b))throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
d=new i18n.phonenumbers.PhoneNumber;c&&d.setRawInput(a);a=this.maybeStripExtension(e);0<a.length&&d.setExtension(a);var f=this.getMetadataForRegion(b);a=new goog.string.StringBuffer;var g=0,h=e.toString();try{g=this.maybeExtractCountryCode(h,f,a,c,d)}catch(k){if(k.message==i18n.phonenumbers.Error.INVALID_COUNTRY_CODE&&i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)){if(h=h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN,""),g=this.maybeExtractCountryCode(h,
f,a,c,d),0==g)throw k;}else throw k;}0!=g?(e=this.getRegionCodeForCountryCode(g),e!=b&&(f=this.getMetadataForRegionOrCallingCode_(g,e))):(i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e),a.append(e.toString()),null!=b?(g=f.getCountryCodeOrDefault(),d.setCountryCode(g)):c&&d.clearCountryCodeSource());if(a.getLength()<i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);null!=f&&(b=new goog.string.StringBuffer,e=new goog.string.StringBuffer(a.toString()),
this.maybeStripNationalPrefixAndCarrierCode(e,f,b),f=this.testNumberLength_(e.toString(),f),g=i18n.phonenumbers.PhoneNumberUtil.ValidationResult,f!=g.TOO_SHORT&&f!=g.IS_POSSIBLE_LOCAL_ONLY&&f!=g.INVALID_LENGTH&&(a=e,c&&0<b.toString().length&&d.setPreferredDomesticCarrierCode(b.toString())));c=a.toString();a=c.length;if(a<i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);if(a>i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_LONG);
i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c,d);d.setNationalNumber(parseInt(c,10));return d};i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_=function(a){var b=a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);if(-1===b)return null;b+=i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;if(b>=a.length)return"";var c=a.indexOf(";",b);return-1!==c?a.substring(b,c):a.substring(b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_=function(a){if(null==a)return!0;if(0===a.length)return!1;var b=i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.exec(a);a=i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_.exec(a);return null!==b||null!==a};
i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_=function(a,b){var c=i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_(a);if(!i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_(c))throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);if(null!=c){c.charAt(0)===i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN&&b.append(c);c=a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);c=0<=c?c+i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length:0;var d=
a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);b.append(a.substring(c,d))}else b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(null!=a?a:""));a=b.toString();c=a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);0<c&&(b.clear(),b.append(a.substring(0,c)))};
i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_=function(a){var b=new i18n.phonenumbers.PhoneNumber;b.setCountryCode(a.getCountryCodeOrDefault());b.setNationalNumber(a.getNationalNumberOrDefault());0<a.getExtensionOrDefault().length&&b.setExtension(a.getExtensionOrDefault());a.getItalianLeadingZero()&&(b.setItalianLeadingZero(!0),b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));return b};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch=function(a,b){if("string"==typeof a)try{var c=this.parse(a,i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_)}catch(f){if(f.message!=i18n.phonenumbers.Error.INVALID_COUNTRY_CODE)return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;if("string"!=typeof b){var d=this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());if(d!=i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_){try{c=this.parse(a,d)}catch(g){return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER}var e=
this.isNumberMatch(c,b);return e==i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH?i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH:e}}try{c=this.parseHelper_(a,null,!1,!1)}catch(g){return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER}}else c=a.clone();if("string"==typeof b)try{return e=this.parse(b,i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_),this.isNumberMatch(a,e)}catch(f){return f.message!=i18n.phonenumbers.Error.INVALID_COUNTRY_CODE?i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER:
this.isNumberMatch(b,c)}else e=b.clone();a=i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);e=i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);if(a.hasExtension()&&e.hasExtension()&&a.getExtension()!=e.getExtension())return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;b=a.getCountryCodeOrDefault();c=e.getCountryCodeOrDefault();if(0!=b&&0!=c)return a.equals(e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH:b==c&&this.isNationalNumberSuffixOfTheOther_(a,e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH:
i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;a.setCountryCode(0);e.setCountryCode(0);return a.equals(e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH:this.isNationalNumberSuffixOfTheOther_(a,e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH:i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_=function(a,b){a=""+a.getNationalNumber();b=""+b.getNationalNumber();return goog.string.endsWith(a,b)||goog.string.endsWith(b,a)};i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled=function(a){var b=this.getMetadataForRegion(this.getRegionCodeForNumber(a));if(null==b)return!0;a=this.getNationalSignificantNumber(a);return!this.isNumberMatchingDesc_(a,b.getNoInternationalDialling())};
i18n.phonenumbers.PhoneNumberUtil.matchesEntirely=function(a,b){return(a="string"==typeof a?b.match("^(?:"+a+")$"):b.match(a))&&a[0].length==b.length?!0:!1};i18n.phonenumbers.PhoneNumberUtil.matchesPrefix=function(a,b){return(a="string"==typeof a?b.match("^(?:"+a+")"):b.match(a))&&goog.string.startsWith(b,a[0])?!0:!1};i18n.phonenumbers.shortnumbermetadata={};i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap={0:"AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ")};
i18n.phonenumbers.shortnumbermetadata.countryToMetadata={AC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"AC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AD:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[0268]",,,,"110"],[,,,,,,,,,[-1]],,,,"AD",,,,,,,,,,,,,,,,,,[,,"11[0268]",,,,"110"],,[,,"11[0268]",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AE:[,[,,"[149]\\d{2,3}",,,,,,,[3,4]],,,[,,"112|99[7-9]",
,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"AE",,,,,,,,,,,,,,,,,,[,,"112|99[7-9]",,,,"112",,,[3]],,[,,"112|445[16]|99[7-9]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"445\\d",,,,"4450",,,[4]]],AF:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:0[02]|19)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"AF",,,,,,,,,,,,,,,,,,[,,"1(?:0[02]|19)",,,,"100",,,[3]],,[,,"1(?:0[02]|19)|40404",,,,"100"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],AG:[,[,,"[19]\\d\\d",,,,,,,[3]],,,
[,,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"AG",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"176|9(?:11|88|99)",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],AI:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],,,,"AI",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"176|9(?:11|88)",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],AL:[,[,,"[15]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)",,,,"112",,,[3,6]],[,,
"5\\d{4}",,,,"50000",,,[5]],,,,"AL",,,,,,,,,,,,,,,,,,[,,"1(?:12|2[7-9])",,,,"112",,,[3]],,[,,"1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])",,,,"110"],[,,,,,,,,,[-1]],[,,"123",,,,"123",,,[3]],,[,,"131|5\\d{4}",,,,"131",,,[3,5]]],AM:[,[,,"[148]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"10[1-3]",,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"AM",,,,,,,,,,,,,,,,,,[,,"10[1-3]",,,,"101",,,[3]],,[,,"(?:1|8[1-7])\\d\\d|40404",,,,"100"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,
"404\\d\\d",,,,"40400",,,[5]]],AO:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[235]",,,,"112"],[,,,,,,,,,[-1]],,,,"AO",,,,,,,,,,,,,,,,,,[,,"11[235]",,,,"112"],,[,,"11[235]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AR:[,[,,"[01389]\\d{1,4}",,,,,,,[2,3,4,5]],,,[,,"000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911",,,,"19",,,[2,3]],[,,,,,,,,,[-1]],,,,"AR",,,,,,,,,,,,,,,,,,[,,"10[017]|911",,,,"100",,,[3]],,[,,"000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911",,,,"19"],[,,,,
,,,,,[-1]],[,,"893\\d\\d",,,,"89300",,,[5]],,[,,"(?:337|893\\d)\\d",,,,"3370",,,[4,5]]],AS:[,[,,"[49]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"9(?:11|88)",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"AS",,,,,,,,,,,,,,,,,,[,,"911",,,,"911",,,[3]],,[,,"40404|9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],AT:[,[,,"[1268]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d",,,,"112"],[,,,,,,,,,[-1]],,,,"AT",,,,,,,,,,,,,,,,,
,[,,"1(?:[12]2|33|44)",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:220|61|8108[1-3])0",,,,"112"],[,,,,,,,,,[-1]],[,,"(?:220|810\\d\\d)\\d|610",,,,"610"],,[,,,,,,,,,[-1]]],AU:[,[,,"[0-27]\\d{2,7}",,,,,,,[3,4,5,6,7,8]],,,[,,"000|1(?:06|12|258885|55\\d)|733",,,,"000",,,[3,4,7]],[,,"1(?:2(?:34|456)|9\\d{4,6})",,,,"1234",,,[4,5,6,7,8]],,,,"AU",,,,,,,,,,,,,,,,,,[,,"000|1(?:06|12)",,,,"000",,,[3]],,[,,"000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)",
,,,"000"],[,,"1(?:1[09]\\d|24733)|225|767",,,,"225",,,[3,4,6]],[,,"1(?:258885|55\\d)",,,,"1550",,,[4,7]],,[,,"19\\d{4,6}",,,,"190000",,,[6,7,8]]],AW:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"100|911",,,,"100"],[,,,,,,,,,[-1]],,,,"AW",,,,,,,,,,,,,,,,,,[,,"100|911",,,,"100"],,[,,"1(?:00|18|76)|91[13]",,,,"100"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],AX:[,[,,"[17]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"112",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"AX",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,
,"112|75[12]\\d\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AZ:[,[,,"[148]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"AZ",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],,[,,"1(?:0[1-3]|12)|(?:404|880)0",,,,"101"],[,,,,,,,,,[-1]],[,,"(?:404|880)\\d",,,,"4040",,,[4]],,[,,"(?:404|880)\\d",,,,"4040",,,[4]]],BA:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:16\\d{3}|2[2-4])",,,,"122",,,[3,6]],[,,,,,,,,,[-1]],,,,"BA",,,,,,,,,,,,,,,,,,[,,"12[2-4]",
,,,"122",,,[3]],,[,,"1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?",,,,"122"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BB:[,[,,"[2-689]\\d\\d",,,,,,,[3]],,,[,,"988|[2359]11",,,,"211"],[,,,,,,,,,[-1]],,,,"BB",,,,,,,,,,,,,,,,,,[,,"[2359]11",,,,"211"],,[,,"988|[2-689]11",,,,"211"],[,,,,,,,,,[-1]],[,,"[468]11",,,,"411"],,[,,,,,,,,,[-1]]],BD:[,[,,"[1579]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"10[0-26]|[19]99",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"BD",
,,,,,,,,,,,,,,,,,[,,"10[0-2]|[19]99",,,,"100",,,[3]],,[,,"1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d",,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:11|2[13])|(?:501|959)\\d|786",,,,"111",,,[3,4]],,[,,"959\\d",,,,"9590",,,[4]]],BE:[,[,,"[1-9]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}",,,,"100"],[,,"1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d",
,,,"1204",,,[4]],,,,"BE",,,,,,,,,,,,,,,,,,[,,"1(?:0[01]|12)",,,,"100",,,[3]],,[,,"1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"[2-9]\\d{3}",,,,"2000",,,[4]]],BF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"BF",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],,[,,,,,,,,,[-1]]],BG:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"1(?:1(?:2|6\\d{3})|50|6[06])",,,,"112"],[,,,,,,,,,[-1]],,,,"BG",,,,,,,,,,,,,,,,,,[,,"1(?:12|50|6[06])",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|111))|50|6[06])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BH:[,[,,"[0189]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"(?:0[167]|81)\\d{3}|[19]99",,,,"199"],[,,"9[148]\\d{3}",,,,"91000",,,[5]],,,,"BH",,,,,,,,,,,,,,,,,,[,,"[19]99",,,,"199",,,[3]],,[,,"1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}",
,,,"100"],[,,,,,,,,,[-1]],[,,"0[67]\\d{3}|88000|98555",,,,"06000",,,[5]],,[,,"88000|98555",,,,"88000",,,[5]]],BI:[,[,,"[16-9]\\d{2,3}",,,,,,,[3,4]],,,[,,"11[237]|611",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"BI",,,,,,,,,,,,,,,,,,[,,"11[237]",,,,"112",,,[3]],,[,,"1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900",,,,"110"],[,,,,,,,,,[-1]],[,,"611|7(?:10|77)|888|900",,,,"611",,,[3]],,[,,"(?:71|90)0",,,,"710",,,[3]]],BJ:[,[,,"[17]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[246-8]|3[68]|6[06])|7[3-5]\\d\\d",
,,,"112"],[,,,,,,,,,[-1]],,,,"BJ",,,,,,,,,,,,,,,,,,[,,"11[246-8]",,,,"112",,,[3]],,[,,"1(?:05|1[24-8]|2[02-5]|3[126-8]|5[05]|6[06]|89)|7[0-5]\\d\\d",,,,"105"],[,,,,,,,,,[-1]],[,,"12[02-5]",,,,"120",,,[3]],,[,,,,,,,,,[-1]]],BL:[,[,,"1\\d",,,,,,,[2]],,,[,,"18",,,,"18"],[,,,,,,,,,[-1]],,,,"BL",,,,,,,,,,,,,,,,,,[,,"18",,,,"18"],,[,,"18",,,,"18"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BM:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],,,,"BM",,,,,,,,,,,,,,,,,,[,,"911",
,,,"911"],,[,,"176|9(?:11|88)",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],BN:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"99[135]",,,,"991"],[,,,,,,,,,[-1]],,,,"BN",,,,,,,,,,,,,,,,,,[,,"99[135]",,,,"991"],,[,,"99[135]",,,,"991"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BO:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[089]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"BO",,,,,,,,,,,,,,,,,,[,,"11[089]",,,,"110",,,[3]],,[,,"11[089]|40404",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,
"404\\d\\d",,,,"40400",,,[5]]],BQ:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],,,,"BQ",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112"],,[,,"1(?:12|76)|911",,,,"112"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],BR:[,[,,"[1-69]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911",,,,"100",,,[3,4]],[,,,,,,,,,[-1]],,,,"BR",,,,,,,,,,,,,,,,,,[,,"1(?:12|28|9[023])|911",,,,"112",,,[3]],,[,,"1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
,,,"100"],[,,"102|273\\d\\d|321",,,,"102",,,[3,5]],[,,"151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)",,,,"151",,,[3,4,5]],,[,,"285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}",,,,"321"]],BS:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:1[19]|88)",,,,"911"],[,,,,,,,,,[-1]],,,,"BS",,,,,,,,,,,,,,,,,,[,,"91[19]",,,,"911"],,[,,"9(?:1[19]|88)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BT:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[023]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"BT",
,,,,,,,,,,,,,,,,,[,,"11[023]",,,,"110",,,[3]],,[,,"11[0-6]|40404",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],BW:[,[,,"[19]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"9(?:11|9[7-9])",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"BW",,,,,,,,,,,,,,,,,,[,,"9(?:11|9[7-9])",,,,"911",,,[3]],,[,,"1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])",,,,"112"],[,,,,,,,,,[-1]],[,,"131\\d\\d",,,,"13100",,,[5]],,[,,"131\\d\\d",,,,"13100",,,[5]]],BY:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:0[1-3]|12)",,,,"101"],
[,,,,,,,,,[-1]],,,,"BY",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101"],,[,,"1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])",,,,"101"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BZ:[,[,,"9\\d\\d?",,,,,,,[2,3]],,,[,,"9(?:0|11|22|66|77|9[09])",,,,"90"],[,,,,,,,,,[-1]],,,,"BZ",,,,,,,,,,,,,,,,,,[,,"9(?:0|11|90)",,,,"90"],,[,,"9(?:0|11|22|66|77|9[09])",,,,"90"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CA:[,[,,"[1-9]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"112|988|[29]11",,,,"112",
,,[3]],[,,,,,,,,,[-1]],,,,"CA",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"[1-35-9]\\d{4,5}|112|[2-8]11|9(?:11|88)",,,,"112"],[,,,,,,,,,[-1]],[,,"[235-7]11",,,,"211",,,[3]],,[,,"[1-35-9]\\d{4,5}",,,,"10000",,,[5,6]]],CC:[,[,,"[01]\\d\\d",,,,,,,[3]],,,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],,,,"CC",,,,,,,,,,,,,,,,,,[,,"000|112",,,,"000"],,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CD:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:1[348]|77|88)",,,,"113",,,[3]],
[,,,,,,,,,[-1]],,,,"CD",,,,,,,,,,,,,,,,,,[,,"1(?:1[348]|77|88)",,,,"113",,,[3]],,[,,"1(?:1[348]|23|77|88)|40404",,,,"113"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],CF:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[78]|22\\d)",,,,"117"],[,,,,,,,,,[-1]],,,,"CF",,,,,,,,,,,,,,,,,,[,,"1(?:1[78]|220)",,,,"117"],,[,,"1(?:1[478]|220)",,,,"114"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CG:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[178]",,,,"111"],[,,,,,,,,,[-1]],,,,"CG",
,,,,,,,,,,,,,,,,,[,,"11[78]",,,,"117"],,[,,"11[126-8]",,,,"111"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CH:[,[,,"[1-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:[278]|6\\d{3})|4[47])|5200",,,,"112",,,[3,4,6]],[,,"1(?:14|8[0-2589])\\d|543|83111",,,,"543",,,[3,4,5]],,,,"CH",,,,,,,,,,,,,,,,,,[,,"1(?:1[278]|44)",,,,"112",,,[3]],,[,,"1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}",,,,"112"],[,,"1(?:4[035]|6[1-46])|1(?:41|60)\\d",
,,,"140",,,[3,4]],[,,"5(?:200|35)",,,,"535",,,[3,4]],,[,,"[2-9]\\d{2,4}",,,,"200",,,[3,4,5]]],CI:[,[,,"[14]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[01]|[78]0)",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"CI",,,,,,,,,,,,,,,,,,[,,"1(?:1[01]|[78]0)",,,,"110",,,[3]],,[,,"1(?:1[01]|[78]0)|4443",,,,"110"],[,,,,,,,,,[-1]],[,,"444\\d",,,,"4440",,,[4]],,[,,"444\\d",,,,"4440",,,[4]]],CK:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"99[689]",,,,"996"],[,,,,,,,,,[-1]],,,,"CK",,,,,,,,,,,,,,,,,,[,,"99[689]",,,,"996"],,[,,"99[689]",,,,"996"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CL:[,[,,"[1-9]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:213|3[1-3])|434\\d|911",,,,"131",,,[3,4]],[,,"1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d",,,,"1060",,,[4,5]],,,,"CL",,,,,,,,,,,,,,,,,,[,,"13[1-3]|911",,,,"131",,,[3]],,[,,"1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
,,,"100"],[,,"(?:200|333)\\d",,,,"2000",,,[4]],[,,,,,,,,,[-1]],,[,,"13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d",,,,"1060",,,[4,5]]],CM:[,[,,"[18]\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:1[37]|[37])",,,,"13",,,[2,3]],[,,,,,,,,,[-1]],,,,"CM",,,,,,,,,,,,,,,,,,[,,"1(?:1[37]|[37])",,,,"13",,,[2,3]],,[,,"1(?:1[37]|[37])|8711",
,,,"13"],[,,,,,,,,,[-1]],[,,"871\\d",,,,"8710",,,[4]],,[,,"871\\d",,,,"8710",,,[4]]],CN:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1[09]|2(?:[02]|1\\d\\d|395))",,,,"110",,,[3,5]],[,,,,,,,,,[-1]],,,,"CN",,,,,,,,,,,,,,,,,,[,,"1(?:1[09]|20)",,,,"110",,,[3]],,[,,"1(?:00|1[0249]|2395|6[08])|9[56]\\d{3,4}|12[023]|1(?:0(?:[0-26]\\d|8)|21\\d)\\d",,,,"100"],[,,"1(?:0(?:[0-26]\\d|8)\\d|1[24]|23|6[08])|9[56]\\d{3,4}|100",,,,"100"],[,,,,,,,,,[-1]],,[,,"12110",,,,"12110",,,[5]]],CO:[,[,,"[1-589]\\d\\d(?:\\d{2,3})?",
,,,,,,[3,5,6]],,,[,,"1(?:1[29]|23|32|56)",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"CO",,,,,,,,,,,,,,,,,,[,,"1(?:1[29]|23|32|56)",,,,"112",,,[3]],,[,,"1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}",,,,"106"],[,,,,,,,,,[-1]],[,,"(?:40|85)4\\d\\d",,,,"40400",,,[5]],,[,,"(?:40|85)4\\d\\d",,,,"40400",,,[5]]],CR:[,[,,"[1359]\\d{2,3}",,,,,,,[3,4]],,,[,,"112|911",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"CR",,,,,,,,,,,,,,,,,,[,,"112|911",
,,,"112",,,[3]],,[,,"1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"(?:385|5(?:0[34]|51))\\d",,,,"3850",,,[4]]],CU:[,[,,"[12]\\d\\d(?:\\d{3,4})?",,,,,,,[3,6,7]],,,[,,"10[4-7]|(?:116|204\\d)\\d{3}",,,,"104"],[,,,,,,,,,[-1]],,,,"CU",,,,,,,,,,,,,,,,,,[,,"10[4-6]",,,,"104",,,[3]],,[,,"1(?:0[4-7]|1(?:6111|8)|40)|2045252",
,,,"104"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CV:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"13[0-2]",,,,"130"],[,,,,,,,,,[-1]],,,,"CV",,,,,,,,,,,,,,,,,,[,,"13[0-2]",,,,"130"],,[,,"13[0-2]",,,,"130"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CW:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],,,,"CW",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112"],,[,,"1(?:12|76)|911",,,,"112"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],CX:[,[,,"[01]\\d\\d",,,,,,,[3]],,,[,,"000|112",
,,,"000"],[,,,,,,,,,[-1]],,,,"CX",,,,,,,,,,,,,,,,,,[,,"000|112",,,,"000"],,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CY:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"1(?:1(?:2|6\\d{3})|99)",,,,"112"],[,,,,,,,,,[-1]],,,,"CY",,,,,,,,,,,,,,,,,,[,,"1(?:12|99)",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|111))|99)",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CZ:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)",,,,"112",,,[3,6]],[,
,,,,,,,,[-1]],,,,"CZ",,,,,,,,,,,,,,,,,,[,,"1(?:12|5\\d)",,,,"112",,,[3]],,[,,"1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DE:[,[,,"[13]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:[02]|6\\d{3})",,,,"110",,,[3,6]],[,,,,,,,,,[-1]],,,,"DE",,,,,,,,,,,,,,,,,,[,,"11[02]",,,,"110",,,[3]],,[,,"11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|3311|118\\d\\d",,,,"110"],[,,,,,,,,,[-1]],[,,"331\\d",,,,"3310",,,[4]],,[,,,,,,,,,[-1]]],DJ:[,[,,"1\\d",
,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"DJ",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DK:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:[24]|6\\d{3})",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"DK",,,,,,,,,,,,,,,,,,[,,"11[24]",,,,"112",,,[3]],,[,,"1(?:1(?:[2-48]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DM:[,[,,"[39]\\d\\d",,,,,,,[3]],,,[,,"333|9(?:11|88|99)",
,,,"333"],[,,,,,,,,,[-1]],,,,"DM",,,,,,,,,,,,,,,,,,[,,"333|9(?:11|99)",,,,"333"],,[,,"333|9(?:11|88|99)",,,,"333"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DO:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|9(?:11|88)",,,,"112"],[,,,,,,,,,[-1]],,,,"DO",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112"],,[,,"112|9(?:11|88)",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DZ:[,[,,"[17]\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:12|[47]|54\\d)",,,,"14"],[,,,,,,,,,[-1]],,,,"DZ",,,,,,,,,,,,,,,,,,[,,"1(?:12|[47])",
,,,"14",,,[2,3]],,[,,"1(?:055|12|[47]|548)|730",,,,"14"],[,,,,,,,,,[-1]],[,,"730",,,,"730",,,[3]],,[,,"730",,,,"730",,,[3]]],EC:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"1(?:0[12]|12)|911",,,,"101"],[,,,,,,,,,[-1]],,,,"EC",,,,,,,,,,,,,,,,,,[,,"1(?:0[12]|12)|911",,,,"101"],,[,,"1(?:0[12]|12)|911",,,,"101"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],EE:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))",
,,,"110"],[,,"1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
,,,"123",,,[3,4,5]],,,,"EE",,,,,,,,,,,,,,,,,,[,,"11[02]",,,,"110",,,[3]],,[,,"1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
,,,"126",,,[3,4,5]]],EG:[,[,,"[13]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:2[23]|80)",,,,"122",,,[3]],[,,,,,,,,,[-1]],,,,"EG",,,,,,,,,,,,,,,,,,[,,"1(?:2[23]|80)",,,,"122",,,[3]],,[,,"1(?:2[23]|[679]\\d{3}|80)|34400",,,,"122"],[,,,,,,,,,[-1]],[,,"344\\d\\d",,,,"34400",,,[5]],,[,,"344\\d\\d",,,,"34400",,,[5]]],EH:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],,,,"EH",,,,,,,,,,,,,,,,,,[,,"1(?:[59]|77)",,,,"15"],,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,
[,,,,,,,,,[-1]]],ER:[,[,,"[12]\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"11[2-46]|(?:12[47]|20[12])\\d{3}",,,,"112"],[,,,,,,,,,[-1]],,,,"ER",,,,,,,,,,,,,,,,,,[,,"1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",,,,"112"],,[,,"1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ES:[,[,,"[0-379]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}",,,,"016",,,[3,4,6]],[,,"[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
,,,"120"],,,,"ES",,,,,,,,,,,,,,,,,,[,,"08[58]|112",,,,"085",,,[3]],,[,,"0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}",,,,"010"],[,,"0(?:[16][0-2]|80|9[12])|21\\d{4}",,,,"010",,,[3,6]],[,,"1(?:3[34]|77)|[12]2\\d{1,4}",,,,"120"],,[,,"(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d",,,,"22000",,,[5,6]]],ET:[,[,,"9\\d\\d?",,,,,
,,[2,3]],,,[,,"9(?:07|11?|2|39?|9[17])",,,,"91"],[,,,,,,,,,[-1]],,,,"ET",,,,,,,,,,,,,,,,,,[,,"9(?:11?|2|39?|9[17])",,,,"91"],,[,,"9(?:07|11?|2|39?|45|9[17])",,,,"91"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FI:[,[,,"[17]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"11(?:2|6\\d{3})",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"FI",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"11(?:2|6(?:00[06]|1(?:1[17]|23)))|(?:1[2-8]\\d|75[12])\\d\\d",,,,"112"],[,,"1[2-8]\\d{3}",,,,"12000",,,[5]],[,,,,,,,,,[-1]],
,[,,,,,,,,,[-1]]],FJ:[,[,,"[0-579]\\d(?:\\d(?:\\d{2})?)?",,,,,,,[2,3,5]],,,[,,"91[17]",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"FJ",,,,,,,,,,,,,,,,,,[,,"91[17]",,,,"911",,,[3]],,[,,"0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75",,,,"22"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],FK:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"FK",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"1\\d\\d|999",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,
,,,,,,[-1]]],FM:[,[,,"[39]\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"320\\d{3}|911",,,,"911"],[,,,,,,,,,[-1]],,,,"FM",,,,,,,,,,,,,,,,,,[,,"(?:32022|91)1",,,,"911"],,[,,"(?:32022|91)1",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FO:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[24]|81\\d)",,,,"112"],[,,,,,,,,,[-1]],,,,"FO",,,,,,,,,,,,,,,,,,[,,"11[24]",,,,"112",,,[3]],,[,,"1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FR:[,[,,"[1-8]\\d{1,5}",
,,,,,,[2,3,4,5,6]],,,[,,"1(?:1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d",,,,"15"],[,,"(?:1(?:0|18\\d)|366|[4-8]\\d\\d)\\d\\d|3[2-9]\\d\\d",,,,"1000",,,[4,5,6]],,,,"FR",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15",,,[2,3]],,[,,"1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)",,,,"15"],[,,"202\\d|6(?:1[14]|34)|70[06]",,,,"611",,,[3,4]],[,,"118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",,
,,"224",,,[3,4,5,6]],,[,,"114|[3-8]\\d{4}",,,,"114",,,[3,5]]],GA:[,[,,"1\\d(?:\\d{2})?",,,,,,,[2,4]],,,[,,"18|1(?:3\\d|73)\\d",,,,"18"],[,,,,,,,,,[-1]],,,,"GA",,,,,,,,,,,,,,,,,,[,,"1(?:3\\d\\d|730|8)",,,,"18"],,[,,"1(?:3\\d\\d|730|8)",,,,"18"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GB:[,[,,"[1-46-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999",,,,"105"],[,,,,,,,,,[-1]],,,,"GB",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901",,,,"202",,,[3,4,5]],,[,,"(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d",,,,"1250",,,[4,5]]],GD:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],,,,"GD",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"176|9(?:11|88)",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],GE:[,[,,"[014]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"0(?:11|33)|11[1-3]|[01]22",,,,"011",,,[3]],[,,,,
,,,,,[-1]],,,,"GE",,,,,,,,,,,,,,,,,,[,,"0(?:11|33)|11[1-3]|[01]22",,,,"011",,,[3]],,[,,"0(?:11|33)|11[1-3]|40404|[01]22",,,,"011"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],GF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"GF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GG:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"112|999",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"GG",,,,,,,,,
,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GH:[,[,,"[14589]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"19[1-3]|999",,,,"191",,,[3]],[,,,,,,,,,[-1]],,,,"GH",,,,,,,,,,,,,,,,,,[,,"19[1-3]|999",,,,"191",,,[3]],,[,,"19[1-3]|40404|(?:54|83)00|999",,,,"191"],[,,,,,,,,,[-1]],[,,"404\\d\\d|(?:54|83)0\\d",,,,"5400",,,[4,5]],,[,,"404\\d\\d|(?:54|83)0\\d",,,,"5400",,,[4,5]]],GI:[,[,,"[158]\\d{2,5}",
,,,,,,[3,4,5,6]],,,[,,"1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d",,,,"100",,,[3,4,6]],[,,"8[1-69]\\d\\d",,,,"8100",,,[4]],,,,"GI",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[09])",,,,"112",,,[3]],,[,,"1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])",,,,"100"],[,,"150|87\\d\\d",,,,"150",,,[3,4]],[,,"1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])",,,,"100",,,[3,5]],,[,,,,,,,,,[-1]]],GL:[,[,,"1\\d\\d",
,,,,,,[3]],,,[,,"112",,,,"112"],[,,,,,,,,,[-1]],,,,"GL",,,,,,,,,,,,,,,,,,[,,"112",,,,"112"],,[,,"1[1-8]\\d",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GM:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:1[6-8]|[6-8])",,,,"16"],[,,,,,,,,,[-1]],,,,"GM",,,,,,,,,,,,,,,,,,[,,"1(?:1[6-8]|[6-8])",,,,"16"],,[,,"1(?:1[6-8]|[6-8])",,,,"16"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GN:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,,"GN",,,,,,,,,,,,,,,,,,[,,,,,,
,,,[-1]],,[,,"12\\d|40404",,,,"120"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],GP:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"GP",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GR:[,[,,"1\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"1(?:0[089]|1(?:2|6\\d{3})|66|99)",,,,"100",,,[3,6]],[,,,,,,,,,[-1]],,,,"GR",,,,,,,,,,,,,,,,,,[,,"1(?:00|12|66|99)",,,,"100",,,[3]],,[,,"1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
,,,"100"],[,,"113\\d\\d",,,,"11300",,,[5]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GT:[,[,,"[14]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:10|2[03])",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"GT",,,,,,,,,,,,,,,,,,[,,"1(?:10|2[03])",,,,"110",,,[3]],,[,,"110|40404|1(?:2|[57]\\d)\\d",,,,"110"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],GU:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],,,,"GU",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"9(?:11|88)",,,,"911"],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GW:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[378]",,,,"113"],[,,,,,,,,,[-1]],,,,"GW",,,,,,,,,,,,,,,,,,[,,"11[378]",,,,"113"],,[,,"11[378]",,,,"113"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GY:[,[,,"[019]\\d{2,3}",,,,,,,[3,4]],,,[,,"91[1-3]",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"GY",,,,,,,,,,,,,,,,,,[,,"91[1-3]",,,,"911",,,[3]],,[,,"0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]",,,,"002"],[,,,,,,,,,[-1]],[,,"144\\d",,
,,"1440",,,[4]],,[,,"144\\d",,,,"1440",,,[4]]],HK:[,[,,"[19]\\d{2,6}",,,,,,,[3,4,5,6,7]],,,[,,"112|99[29]",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"HK",,,,,,,,,,,,,,,,,,[,,"112|99[29]",,,,"112",,,[3]],,[,,"1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]",,,,"100"],
[,,,,,,,,,[-1]],[,,"109|1(?:08|85\\d)\\d",,,,"109",,,[3,4,5]],,[,,"992",,,,"992",,,[3]]],HN:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"199",,,,"199",,,[3]],[,,,,,,,,,[-1]],,,,"HN",,,,,,,,,,,,,,,,,,[,,"199",,,,"199",,,[3]],,[,,"199|40404",,,,"199"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],HR:[,[,,"[19]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d",,,,"93",,,[2,3,5,6]],[,,"118\\d\\d",,,,"11800",,,[5]],,,,"HR",,,,,,,,,,,,,
,,,,,[,,"1(?:12|9[2-4])|9[34]",,,,"93",,,[2,3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]",,,,"93"],[,,,,,,,,,[-1]],[,,"139\\d\\d",,,,"13900",,,[5]],,[,,"139\\d\\d",,,,"13900",,,[5]]],HT:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[48]",,,,"114",,,[3]],[,,,,,,,,,[-1]],,,,"HT",,,,,,,,,,,,,,,,,,[,,"11[48]",,,,"114",,,[3]],,[,,"11[48]|40404",,,,"114"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],HU:[,[,,"1\\d{2,5}",,,,,,,
[3,4,5,6]],,,[,,"1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d",,,,"104"],[,,,,,,,,,[-1]],,,,"HU",,,,,,,,,,,,,,,,,,[,,"1(?:0[457]|12)",,,,"104",,,[3]],,[,,"1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))",,,,"104"],[,,,,,,,,,[-1]],[,,"1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d",,,,"1200",,,[4,5]],,[,,"184\\d",,,,"1840",
,,[4]]],ID:[,[,,"[178]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"11[02389]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"ID",,,,,,,,,,,,,,,,,,[,,"11[02389]",,,,"110",,,[3]],,[,,"1(?:1[02389]|40\\d\\d|50264)|71400|89887",,,,"110"],[,,,,,,,,,[-1]],[,,"(?:714|898)\\d\\d",,,,"71400",,,[5]],,[,,"714\\d\\d",,,,"71400",,,[5]]],IE:[,[,,"[159]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6\\d{3})|999",,,,"112",,,[3,6]],[,,"5[37]\\d{3}",,,,"53000",,,[5]],,,,"IE",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d",
,,,"112"],[,,"51\\d{3}",,,,"51000",,,[5]],[,,"51210",,,,"51210",,,[5]],,[,,"51210|(?:118|5[037]\\d)\\d\\d",,,,"11800",,,[5]]],IL:[,[,,"[12]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:0[0-2]|12)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"IL",,,,,,,,,,,,,,,,,,[,,"1(?:0[0-2]|12)",,,,"100",,,[3]],,[,,"1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00",,,,"100"],[,,,,,,,,,[-1]],[,,"104\\d\\d",,,,"10400",,,[5]],,[,,"104\\d\\d",,,,"10400",,,[5]]],IM:[,[,,"[189]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"999",,
,,"999",,,[3]],[,,,,,,,,,[-1]],,,,"IM",,,,,,,,,,,,,,,,,,[,,"999",,,,"999",,,[3]],,[,,"1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"8(?:64|98)\\d\\d",,,,"86400",,,[5]]],IN:[,[,,"[12578]\\d{2,8}",,,,,,,[3,4,5,6,7,8,9]],,,[,,"1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d",,,,"100",,,[3,4,5,6]],[,,"11[67]\\d{4}|56161561",,,,"1160000",,,[7,8]],
,,,"IN",,,,,,,,,,,,,,,,,,[,,"1(?:0[0-28]|12|298)|2611",,,,"100",,,[3,4]],,[,,"1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
,,,"100"],[,,"5(?:14(?:2[5-9]|[34]\\d)|757555)",,,,"51425",,,[5,7]],[,,"1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])",,,,"118",,,[3,4,5,6,7,8]],,[,,"1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)",,,,"139",,,[3,4,5,7,8]]],IQ:[,[,,"[1479]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:0[04]|15|22)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"IQ",,,,,,,,,,,,,,,,,,[,,"1(?:0[04]|15|22)",,,,"100",,,[3]],,[,,"1(?:0[04]|15|22)|4432|71117|9988",,,,"100"],[,
,,,,,,,,[-1]],[,,"(?:443|711\\d|998)\\d",,,,"4430",,,[4,5]],,[,,"(?:443|711\\d|998)\\d",,,,"4430",,,[4,5]]],IR:[,[,,"[129]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1[0-68]|2[0-59]|9[0-579])|911",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"IR",,,,,,,,,,,,,,,,,,[,,"1(?:1[025]|25)|911",,,,"110",,,[3]],,[,,"1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
,,,"110"],[,,"1(?:5[0-469]|8[0-489])\\d",,,,"1500",,,[4]],[,,"(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d",,,,"1500",,,[4,6]],,[,,"990\\d{3}",,,,"990000",,,[6]]],IS:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:12|71\\d)",,,,"112",,,[3,4]],[,,,,,,,,,[-1]],,,,"IS",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)",,,,"112"],[,,,,,,,,,[-1]],[,,"14(?:0\\d|41)",,,,"1400",,,[4]],,[,,"1(?:415|90\\d)",
,,,"1415",,,[4]]],IT:[,[,,"[14]\\d{2,6}",,,,,,,[3,4,5,6,7]],,,[,,"1(?:1(?:[2358]|6\\d{3})|87)",,,,"112",,,[3,6]],[,,"(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",,,,"1200",,,[4,5,7]],,,,"IT",,,,,,,,,,,,,,,,,,[,,"11[2358]",,,,"112",,,[3]],,[,,"1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",,,,"112"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,"4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d",,,,"43000",,,[5,7]]],JE:[,[,,"[129]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"112|999",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"JE",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],JM:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"11[029]|9(?:11|88)",,,,"110"],[,,,,,,,
,,[-1]],,,,"JM",,,,,,,,,,,,,,,,,,[,,"11[029]|911",,,,"110"],,[,,"1(?:1[029]|76)|9(?:11|88)",,,,"110"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],JO:[,[,,"[19]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:0[235]|1[2-6]|9[127])|911",,,,"102",,,[3]],[,,"9[0-4689]\\d{3}",,,,"90000",,,[5]],,,,"JO",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[127])|911",,,,"112",,,[3]],,[,,"1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911",,,,"102"],[,,,,,,,,,[-1]],[,,"9[0-4689]\\d{3}",,,,"90000",,,[5]],,[,,"9[0-4689]\\d{3}",
,,,"90000",,,[5]]],JP:[,[,,"[01]\\d\\d(?:\\d{7})?",,,,,,,[3,10]],,,[,,"11[089]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"JP",,,,,,,,,,,,,,,,,,[,,"11[09]",,,,"110",,,[3]],,[,,"000[259]\\d{6}|1(?:0[24]|1[089]|44|89)",,,,"102"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"000[259]\\d{6}",,,,"0002000000",,,[10]]],KE:[,[,,"[1-9]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999",,,,"112"],[,,"909\\d\\d",,,,"90900",,,[5]],,,,"KE",,,,,,,,,,,,,,,,,,[,,"11[24]|999",,,,"112",,,[3]],,[,,"1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988",
,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d",,,,"130"],,[,,"1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d",,,,"141"]],KG:[,[,,"[14]\\d{2,3}",,,,,,,[3,4]],,,[,,"10[1-3]",,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"KG",,,,,,,,,,,,,,,,,,[,,"10[1-3]",,,,"101",,,[3]],,[,,"10[1-3]|4040",,,,"101"],[,,,,,,,,,[-1]],[,,"404\\d",,,,"4040",,,[4]],,[,,"404\\d",,,,"4040",,
,[4]]],KH:[,[,,"[146]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[7-9]|666",,,,"117",,,[3]],[,,,,,,,,,[-1]],,,,"KH",,,,,,,,,,,,,,,,,,[,,"11[7-9]|666",,,,"117",,,[3]],,[,,"11[7-9]|40404|666",,,,"117"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],KI:[,[,,"[179]\\d{2,3}",,,,,,,[3,4]],,,[,,"19[2-5]|99[2-4]",,,,"192",,,[3]],[,,,,,,,,,[-1]],,,,"KI",,,,,,,,,,,,,,,,,,[,,"19[2-5]|99[2-4]",,,,"192",,,[3]],,[,,"1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]",,,,"100"],[,,"103",
,,,"103",,,[3]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KM:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"KM",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KN:[,[,,"[39]\\d\\d",,,,,,,[3]],,,[,,"333|9(?:11|88|99)",,,,"333"],[,,,,,,,,,[-1]],,,,"KN",,,,,,,,,,,,,,,,,,[,,"333|9(?:11|99)",,,,"333"],,[,,"333|9(?:11|88|99)",,,,"333"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KP:[,[,,"[18]\\d\\d",,,,,,,[3]],,,[,,"11[29]|819",
,,,"112"],[,,,,,,,,,[-1]],,,,"KP",,,,,,,,,,,,,,,,,,[,,"11[29]|819",,,,"112"],,[,,"11[29]|819",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KR:[,[,,"1\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:1[27-9]|28|330|82)",,,,"112",,,[3,4]],[,,,,,,,,,[-1]],,,,"KR",,,,,,,,,,,,,,,,,,[,,"11[29]",,,,"112",,,[3]],,[,,"1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])",,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d",
,,,"100",,,[3,5]],,[,,,,,,,,,[-1]]],KW:[,[,,"[18]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"112",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"KW",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"1[0-7]\\d|89887",,,,"100"],[,,,,,,,,,[-1]],[,,"898\\d\\d",,,,"89800",,,[5]],,[,,,,,,,,,[-1]]],KY:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],,,,"KY",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KZ:[,[,,"[1-4]\\d{2,4}",,,,,,,[3,4,
5]],,,[,,"1(?:0[1-3]|12)|212\\d",,,,"101",,,[3,4]],[,,,,,,,,,[-1]],,,,"KZ",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],,[,,"1(?:0[1-4]|12)|2121|(?:3040|404)0",,,,"101"],[,,,,,,,,,[-1]],[,,"(?:304\\d|404)\\d",,,,"4040",,,[4,5]],,[,,"(?:304\\d|404)\\d",,,,"4040",,,[4,5]]],LA:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"19[015]",,,,"190"],[,,,,,,,,,[-1]],,,,"LA",,,,,,,,,,,,,,,,,,[,,"19[015]",,,,"190"],,[,,"19[015]",,,,"190"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LB:[,[,,"[19]\\d\\d",,,,,,,[3]],
,,[,,"1(?:12|40|75)|999",,,,"112"],[,,,,,,,,,[-1]],,,,"LB",,,,,,,,,,,,,,,,,,[,,"1(?:12|40|75)|999",,,,"112"],,[,,"1(?:12|40|75)|999",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"LC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LI:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[278]|44)",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"LI",,,,,,,
,,,,,,,,,,,[,,"1(?:1[278]|44)",,,,"112",,,[3]],,[,,"1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LK:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"11[02689]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"LK",,,,,,,,,,,,,,,,,,[,,"11[02689]",,,,"110",,,[3]],,[,,"1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,
,,,[-1]],,[,,,,,,,,,[-1]]],LR:[,[,,"[3489]\\d{2,3}",,,,,,,[3,4]],,,[,,"355|911",,,,"355",,,[3]],[,,,,,,,,,[-1]],,,,"LR",,,,,,,,,,,,,,,,,,[,,"355|911",,,,"355",,,[3]],,[,,"355|4040|8(?:400|933)|911",,,,"355"],[,,,,,,,,,[-1]],[,,"(?:404|8(?:40|93))\\d",,,,"4040",,,[4]],,[,,"(?:404|8(?:40|93))\\d",,,,"4040",,,[4]]],LS:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[257]",,,,"112"],[,,,,,,,,,[-1]],,,,"LS",,,,,,,,,,,,,,,,,,[,,"11[257]",,,,"112"],,[,,"11[257]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],
LT:[,[,,"[01]\\d(?:\\d(?:\\d{3})?)?",,,,,,,[2,3,6]],,,[,,"0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d",,,,"01"],[,,,,,,,,,[-1]],,,,"LT",,,,,,,,,,,,,,,,,,[,,"0(?:11?|22?|33?)|1(?:0[1-3]|12)",,,,"01",,,[2,3]],,[,,"0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))",,,,"01"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LU:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:[23]|6\\d{3})",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"LU",,,,,,,,,,,,,,,,,,[,,"11[23]",,,,"112",,,[3]],
,[,,"11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LV:[,[,,"[018]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"0[1-3]|11(?:[023]|6\\d{3})",,,,"01",,,[2,3,6]],[,,"1180|821\\d\\d",,,,"1180",,,[4,5]],,,,"LV",,,,,,,,,,,,,,,,,,[,,"0[1-3]|11[023]",,,,"01",,,[2,3]],,[,,"0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4",,,,"01"],[,,"1181",,,,"1181",,,[4]],[,,"165\\d",,,,"1650",,,[4]],,[,,,,,,,,,[-1]]],LY:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,
"19[013]",,,,"190"],[,,,,,,,,,[-1]],,,,"LY",,,,,,,,,,,,,,,,,,[,,"19[013]",,,,"190"],,[,,"19[013]",,,,"190"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MA:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],,,,"MA",,,,,,,,,,,,,,,,,,[,,"1(?:[59]|77)",,,,"15"],,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MC:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],,,,"MC",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15"],,[,,"1(?:12|41|[578])",
,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MD:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"MD",,,,,,,,,,,,,,,,,,[,,"112|90[1-3]",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ME:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:12|2[2-4])",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"ME",,
,,,,,,,,,,,,,,,,[,,"1(?:12|2[2-4])",,,,"112",,,[3]],,[,,"1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"MF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MG:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:1[78]|[78])",,,,"17"],[,,,,,,,,,[-1]],,,,"MG",
,,,,,,,,,,,,,,,,,[,,"1(?:1[78]|[78])",,,,"17"],,[,,"1(?:1[78]|[78])",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MH:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"MH",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MK:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:1(?:2|6\\d{3})|9[2-4])",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"MK",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[2-4])",,,,"112",,,[3]],,[,,"1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}",
,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ML:[,[,,"[136-8]\\d{1,4}",,,,,,,[2,3,4,5]],,,[,,"1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d",,,,"15",,,[2,4,5]],[,,"(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)",,,,"1220",,,[4,5]],,,,"ML",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15",,,[2]],,[,,"1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d",,,,"15"],[,,"37(?:433|575)|7400|8001\\d",,,,"7400",
,,[4,5]],[,,"3503\\d|(?:3[67]\\d|800)\\d\\d",,,,"35030",,,[5]],,[,,"374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d",,,,"7400",,,[4,5]]],MM:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"199",,,,"199"],[,,,,,,,,,[-1]],,,,"MM",,,,,,,,,,,,,,,,,,[,,"199",,,,"199"],,[,,"199",,,,"199"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MN:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"10[0-35]",,,,"100"],[,,,,,,,,,[-1]],,,,"MN",,,,,,,,,,,,,,,,,,[,,"10[0-35]",,,,"100"],,[,,"10[0-35]",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,
,,,,[-1]]],MO:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"MO",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MP:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],,,,"MP",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MQ:[,[,,"[13]\\d(?:\\d(?:\\d(?:\\d{2})?)?)?",,,,,,,[2,3,4,6]],,,[,,"1(?:12|[578])|3[01]\\d\\d",,,,"15",,,[2,3,4]],[,
,"3[2469]\\d\\d",,,,"3200",,,[4]],,,,"MQ",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15",,,[2,3]],,[,,"1(?:12|[578])|(?:118[02-9]|3[0-2469])\\d\\d",,,,"15"],[,,"118\\d{3}",,,,"118000",,,[6]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MR:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"MR",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MS:[,[,,"[29]\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"MS",,,,,,,,,,,,,
,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"211|9(?:11|88|99)",,,,"211"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MT:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"11(?:2|6\\d{3})",,,,"112"],[,,,,,,,,,[-1]],,,,"MT",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"11(?:2|6(?:000|1(?:11|23)))",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MU:[,[,,"[189]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"11[45]|99[59]",,,,"114",,,[3]],[,,,,,,,,,[-1]],,,,"MU",,,,,,,,,,,,,,,,,,[,,"11[45]|99[59]",,,,"114",,,[3]],
,[,,"1\\d{2,4}|(?:8\\d\\d|99)\\d",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MV:[,[,,"[14]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:02|1[89])",,,,"102",,,[3]],[,,,,,,,,,[-1]],,,,"MV",,,,,,,,,,,,,,,,,,[,,"1(?:02|1[89])",,,,"102",,,[3]],,[,,"1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1",,,,"100"],[,,,,,,,,,[-1]],[,,"1[45]1",,,,"141",,,[3]],,[,,,,,,,,,[-1]]],MW:[,[,,"[189]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"199|99[7-9]",,,,"199",,,[3]],[,,,,,,,,,[-1]],,,,"MW",,,,,,,,,,,,,,,,,,[,,"199|99[7-9]",,,,
"199",,,[3]],,[,,"199|80400|99[7-9]",,,,"199"],[,,,,,,,,,[-1]],[,,"804\\d\\d",,,,"80400",,,[5]],,[,,"804\\d\\d",,,,"80400",,,[5]]],MX:[,[,,"[0579]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"0(?:6[0568]|80)|911",,,,"060",,,[3]],[,,"(?:530\\d|776)\\d",,,,"7760",,,[4,5]],,,,"MX",,,,,,,,,,,,,,,,,,[,,"0(?:6[0568]|80)|911",,,,"060",,,[3]],,[,,"0[1-9]\\d|53053|7766|911",,,,"010"],[,,,,,,,,,[-1]],[,,"0(?:[249]0|[35][01])",,,,"020",,,[3]],,[,,,,,,,,,[-1]]],MY:[,[,,"[1369]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"112|999",,,,"112",
,,[3]],[,,,,,,,,,[-1]],,,,"MY",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",,,,"100"],[,,"666\\d\\d",,,,"66600",,,[5]],[,,,,,,,,,[-1]],,[,,"(?:3[23679]\\d|666)\\d\\d",,,,"32000",,,[5]]],MZ:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[79]|9[78])",
,,,"117",,,[3]],[,,,,,,,,,[-1]],,,,"MZ",,,,,,,,,,,,,,,,,,[,,"1(?:1[79]|9[78])",,,,"117",,,[3]],,[,,"1(?:[02-5]\\d\\d|1[79]|9[78])",,,,"117"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NA:[,[,,"[19]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"10111",,,,"10111",,,[5]],[,,,,,,,,,[-1]],,,,"NA",,,,,,,,,,,,,,,,,,[,,"10111",,,,"10111",,,[5]],,[,,"(?:10|93)111|(?:1\\d|9)\\d\\d",,,,"900"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NC:[,[,,"[135]\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577",
,,,"15"],[,,,,,,,,,[-1]],,,,"NC",,,,,,,,,,,,,,,,,,[,,"1[5-8]",,,,"15",,,[2]],,[,,"1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d",,,,"15"],[,,"5(?:67|88)",,,,"567",,,[3]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NE:[,[,,"[1-3578]\\d(?:\\d(?:\\d{3})?)?",,,,,,,[2,3,6]],,,[,,"1(?:18|[578])|723\\d{3}",,,,"15"],[,,,,,,,,,[-1]],,,,"NE",,,,,,,,,,,,,,,,,,[,,"1(?:18|[578])|723141",,,,"15"],,[,,"1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888",,,,"15"],[,,,,,,,,,[-1]],
[,,"1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888",,,,"100",,,[3]],,[,,,,,,,,,[-1]]],NF:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|55|77)",,,,"911"],[,,,,,,,,,[-1]],,,,"NF",,,,,,,,,,,,,,,,,,[,,"9(?:11|55|77)",,,,"911"],,[,,"9(?:11|55|77)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NG:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"199",,,,"199",,,[3]],[,,,,,,,,,[-1]],,,,"NG",,,,,,,,,,,,,,,,,,[,,"199",,,,"199",,,[3]],,[,,"199|40700",,,,"199"],[,,,,,,,,,[-1]],[,,"407\\d\\d",,
,,"40700",,,[5]],,[,,"407\\d\\d",,,,"40700",,,[5]]],NI:[,[,,"[12467]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[58]|2[08])|737\\d",,,,"115"],[,,,,,,,,,[-1]],,,,"NI",,,,,,,,,,,,,,,,,,[,,"1(?:1[58]|2[08])",,,,"115",,,[3]],,[,,"1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00",,,,"115"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NL:[,[,,"[1349]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11(?:2|6\\d{3})|911",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"NL",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,
,[3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911",,,,"112"],[,,,,,,,,,[-1]],[,,"120\\d",,,,"1200",,,[4]],,[,,"[34]00\\d",,,,"3000",,,[4]]],NO:[,[,,"[01]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:[023]|6\\d{3})",,,,"110",,,[3,6]],[,,,,,,,,,[-1]],,,,"NO",,,,,,,,,,,,,,,,,,[,,"11[023]",,,,"110",,,[3]],,[,,"04\\d{3}|1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8[5-9]\\d|90)",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"04\\d{3}",
,,,"04000",,,[5]]],NP:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:0[0-36]|12)|1(?:09|11)\\d",,,,"100"],[,,,,,,,,,[-1]],,,,"NP",,,,,,,,,,,,,,,,,,[,,"1(?:0[0-3]|12)",,,,"100",,,[3]],,[,,"1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NR:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[0-2]",,,,"110"],[,,,,,,,,,[-1]],,,,"NR",,,,,,,,,,,,,,,,,,[,,"11[0-2]",,,,"110"],,[,,"1(?:1[0-2]|23|92)",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NU:[,[,,"[019]\\d\\d",,
,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"NU",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"01[05]|101|999",,,,"010"],[,,,,,,,,,[-1]],[,,"010",,,,"010"],,[,,,,,,,,,[-1]]],NZ:[,[,,"\\d{3,4}",,,,,,,[3,4]],,,[,,"111",,,,"111",,,[3]],[,,"018",,,,"018",,,[3]],,,,"NZ",,,,,,,,,,,,,,,,,,[,,"111",,,,"111",,,[3]],,[,,"018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",,,,"018"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}",,
,,"018"]],OM:[,[,,"[19]\\d{3}",,,,,,,[4]],,,[,,"1444|999\\d",,,,"1444"],[,,,,,,,,,[-1]],,,,"OM",,,,,,,,,,,,,,,,,,[,,"1444|9999",,,,"1444"],,[,,"1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d",,,,"1111"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PA:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"PA",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"10[2-4]|911",,,,"102"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PE:[,[,,"1\\d\\d",,,,,,,[3]],
,,[,,"1(?:05|1[67])",,,,"105"],[,,,,,,,,,[-1]],,,,"PE",,,,,,,,,,,,,,,,,,[,,"1(?:05|1[67])",,,,"105"],,[,,"1(?:05|1[67])",,,,"105"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"PF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PG:[,[,,"[01]\\d{2,6}",,,,,,,[3,4,5,6,7]],,,[,,"000|11[01]",,,,"000",,,[3]],[,,,,,,,,,[-1]],,,,"PG",,,,,,,,,,,,,,,,,,[,,"000|11[01]",,,,"000",
,,[3]],,[,,"000|1(?:1[01]|5\\d\\d|6\\d{2,5})",,,,"000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"16\\d{2,5}",,,,"1600",,,[4,5,6,7]]],PH:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"11[27]|911",,,,"112"],[,,,,,,,,,[-1]],,,,"PH",,,,,,,,,,,,,,,,,,[,,"11[27]|911",,,,"112"],,[,,"11[27]|911",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PK:[,[,,"1\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:1(?:2\\d?|5)|[56])",,,,"15"],[,,,,,,,,,[-1]],,,,"PK",,,,,,,,,,,,,,,,,,[,,"1(?:1(?:22?|5)|[56])",,,,"15"],,[,,"1(?:122|3[014]|[56])|11[2457-9]",
,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PL:[,[,,"[19]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"11(?:2|6\\d{3})|99[7-9]",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"PL",,,,,,,,,,,,,,,,,,[,,"112|99[7-9]",,,,"112",,,[3]],,[,,"1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PM:[,[,,"[13]\\d(?:\\d\\d(?:\\d{2})?)?",,,,,,,[2,4,6]],,,[,,"1[578]|3(?:0\\d|1[689])\\d",,,,"15",,,[2,4]],[,,"3[2469]\\d\\d",,,,"3200",
,,[4]],,,,"PM",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15",,,[2]],,[,,"1[578]|31(?:03|[689]\\d)|(?:118[02-9]|3[02469])\\d\\d",,,,"15"],[,,"118\\d{3}",,,,"118000",,,[6]],[,,"310\\d",,,,"3100",,,[4]],,[,,,,,,,,,[-1]]],PR:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],,,,"PR",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PS:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:0[0-2]|66)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"PS",,,,
,,,,,,,,,,,,,,[,,"10[0-2]",,,,"100",,,[3]],,[,,"1(?:0[0-2]|122|44|66|99)",,,,"100"],[,,,,,,,,,[-1]],[,,"112\\d",,,,"1120",,,[4]],,[,,,,,,,,,[-1]]],PT:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d",,,,"112"],[,,,,,,,,,[-1]],,,,"PT",,,,,,,,,,,,,,,,,,[,,"11[25]",,,,"112",,,[3]],,[,,"1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0",,,,"112"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PW:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"PW",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PY:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"128|911",,,,"128"],[,,,,,,,,,[-1]],,,,"PY",,,,,,,,,,,,,,,,,,[,,"128|911",,,,"128"],,[,,"1[1-9]\\d|911",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],QA:[,[,,"[129]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"99\\d",,,,"990",,,[3]],[,,"900",,,,"900",
,,[3]],,,,"QA",,,,,,,,,,,,,,,,,,[,,"999",,,,"999",,,[3]],,[,,"9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RE:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],,,,"RE",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15"],,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RO:[,[,,"[18]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6\\d{3})",,,,"112",,,[3,6]],[,,"(?:1(?:18[39]|[24])|8[48])\\d\\d",,,,"1200",
,,[4,6]],,,,"RO",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"(?:1[24]|8[48])\\d\\d",,,,"1200",,,[4]]],RS:[,[,,"[19]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"112|9[2-4]",,,,"92",,,[2,3]],[,,,,,,,,,[-1]],,,,"RS",,,,,,,,,,,,,,,,,,[,,"112|9[2-4]",,,,"92",,,[2,3]],,[,,"1[189]\\d{1,4}|9[2-4]",,,,"92"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,
[,,,,,,,,,[-1]]],RU:[,[,,"[01]\\d\\d?",,,,,,,[2,3]],,,[,,"112|(?:0|10)[1-3]",,,,"01"],[,,,,,,,,,[-1]],,,,"RU",,,,,,,,,,,,,,,,,,[,,"112|(?:0|10)[1-3]",,,,"01"],,[,,"112|(?:0|10)[1-4]",,,,"01"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RW:[,[,,"[14]\\d\\d",,,,,,,[3]],,,[,,"11[1245]",,,,"111"],[,,,,,,,,,[-1]],,,,"RW",,,,,,,,,,,,,,,,,,[,,"11[12]",,,,"111"],,[,,"1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SA:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,
5,6]],,,[,,"11(?:2|6\\d{3})|9(?:11|37|9[7-9])",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"SA",,,,,,,,,,,,,,,,,,[,,"112|9(?:11|9[79])",,,,"112",,,[3]],,[,,"1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])",,,,"112"],[,,"141\\d",,,,"1410",,,[4]],[,,"1(?:10|41)\\d|90[24679]",,,,"902",,,[3,4]],,[,,,,,,,,,[-1]]],SB:[,[,,"[127-9]\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SB",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SC:[,[,,"[19]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[1468]|60)|999",,,,"111",,,[3]],[,,,,,,,,,[-1]],,,,"SC",,,,,,,,,,,,,,,,,,[,,"999",,,,"999",,,[3]],,[,,"1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SD:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SD",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SE:[,[,,"[1-37-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d",,,,"112"],[,,"11811[89]|72\\d{3}",,,,"72000",,,[5,6]],,,,"SE",,,,,,,,,,,,,,,,,,[,,"112|90000",,,,"112",,,[3,5]],,[,,"11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])",,,,"112"],[,,,,,,,,,[-1]],[,,"2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
,,,"220",,,[3]],,[,,"7\\d{4}",,,,"70000",,,[5]]],SG:[,[,,"[179]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"99[359]",,,,"993",,,[3]],[,,,,,,,,,[-1]],,,,"SG",,,,,,,,,,,,,,,,,,[,,"99[359]",,,,"993",,,[3]],,[,,"1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"772\\d\\d",,,,"77200",,,[5]]],SH:[,[,,"[129]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"9(?:11|99)",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"SH",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911",,,[3]],,[,,
"1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SI:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)",,,,"112"],[,,,,,,,,,[-1]],,,,"SI",,,,,,,,,,,,,,,,,,[,,"11[23]",,,,"112",,,[3]],,[,,"1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SJ:[,[,,"[01]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[023]",,,
,"110",,,[3]],[,,,,,,,,,[-1]],,,,"SJ",,,,,,,,,,,,,,,,,,[,,"11[023]",,,,"110",,,[3]],,[,,"04\\d{3}|11[023]",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"04\\d{3}",,,,"04000",,,[5]]],SK:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:2|6\\d{3})|5[058])",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"SK",,,,,,,,,,,,,,,,,,[,,"1(?:12|5[058])",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SL:[,[,,"[069]\\d\\d(?:\\d{2})?",,
,,,,,[3,5]],,,[,,"(?:01|99)9",,,,"019",,,[3]],[,,,,,,,,,[-1]],,,,"SL",,,,,,,,,,,,,,,,,,[,,"(?:01|99)9",,,,"019",,,[3]],,[,,"(?:01|99)9|60400",,,,"019"],[,,,,,,,,,[-1]],[,,"604\\d\\d",,,,"60400",,,[5]],,[,,"604\\d\\d",,,,"60400",,,[5]]],SM:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[358]",,,,"113"],[,,,,,,,,,[-1]],,,,"SM",,,,,,,,,,,,,,,,,,[,,"11[358]",,,,"113"],,[,,"11[358]",,,,"113"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SN:[,[,,"[12]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"1(?:515|[78])|2(?:00|1)\\d{3}",
,,,"17",,,[2,4,5,6]],[,,"2(?:0[246]|[468])\\d{3}",,,,"24000",,,[5,6]],,,,"SN",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17",,,[2]],,[,,"1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]",,,,"12"],[,,"2(?:01|2)\\d{3}",,,,"22000",,,[5,6]],[,,"1[46]\\d\\d",,,,"1400",,,[4]],,[,,"2[468]\\d{3}",,,,"24000",,,[5]]],SO:[,[,,"[57-9]\\d\\d",,,,,,,[3]],,,[,,"555|888|999",,,,"555"],[,,,,,,,,,[-1]],,,,"SO",,,,,,,,,,,,,,,,,,[,,"555|888|999",,,,"555"],,[,,"555|777|888|999",,,,"555"],[,,,,,,,,,[-1]],[,,,,,,,
,,[-1]],,[,,,,,,,,,[-1]]],SR:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"115",,,,"115",,,[3]],[,,,,,,,,,[-1]],,,,"SR",,,,,,,,,,,,,,,,,,[,,"115",,,,"115",,,[3]],,[,,"1\\d{2,3}",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SS:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SS",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ST:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"112",,,,"112"],[,,,,,,,,,[-1]],,,,"ST",,,,,,,,,,,,,,,,,,[,
,"112",,,,"112"],,[,,"112",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SV:[,[,,"[149]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"116\\d{3}|911",,,,"911",,,[3,6]],[,,,,,,,,,[-1]],,,,"SV",,,,,,,,,,,,,,,,,,[,,"91[13]",,,,"911",,,[3]],,[,,"1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)",,,,"112"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],SX:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:19|88)",,,,"919"],[,,,,,,,,,[-1]],,,,"SX",,,,,,,,,,,,,,,,,,
[,,"919",,,,"919"],,[,,"9(?:19|88)",,,,"919"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SY:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[023]",,,,"110"],[,,,,,,,,,[-1]],,,,"SY",,,,,,,,,,,,,,,,,,[,,"11[023]",,,,"110"],,[,,"11[023]",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SZ:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SZ",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,
,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"TC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TD:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"TD",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TG:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[78]|7[127])",,,,"117",,,[3]],[,,,,,,,,,[-1]],,,,"TG",,,,,,,,,,,,,,,,,,[,,"1(?:1[78]|7[127])",,,,"117",
,,[3]],,[,,"1(?:011|1[078]|7[127])",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TH:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55",,,,"191"],[,,"1(?:113|2[23]\\d|5(?:09|56))",,,,"1113",,,[4]],,,,"TH",,,,,,,,,,,,,,,,,,[,,"1(?:669|9[19])",,,,"191"],,[,,"1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
,,,"100"],[,,"1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d",,,,"1103",,,[4]],[,,"114[89]",,,,"1148",,,[4]],,[,,,,,,,,,[-1]]],TJ:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:0[1-3]|12)",,,,"101"],[,,,,,,,,,[-1]],,,,"TJ",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101"],,[,,"1(?:0[1-3]|12)",,,,"101"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TL:[,[,,"1\\d\\d",
,,,,,,[3]],,,[,,"11[25]",,,,"112"],[,,,,,,,,,[-1]],,,,"TL",,,,,,,,,,,,,,,,,,[,,"11[25]",,,,"112"],,[,,"1(?:0[02]|1[25]|2[0138]|72|9[07])",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TM:[,[,,"0\\d",,,,,,,[2]],,,[,,"0[1-49]",,,,"01"],[,,,,,,,,,[-1]],,,,"TM",,,,,,,,,,,,,,,,,,[,,"0[1-3]",,,,"01"],,[,,"0[1-49]",,,,"01"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TN:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"19[078]",,,,"190"],[,,,,,,,,,[-1]],,,,"TN",,,,,,,,,,,,,,,,,,[,,"19[078]",,,,"190"],
,[,,"19[078]",,,,"190"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TO:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|22|33|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"TO",,,,,,,,,,,,,,,,,,[,,"9(?:11|22|33|99)",,,,"911"],,[,,"9(?:11|22|33|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TR:[,[,,"[1-9]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"TR",,,,,,,,,,,,,,,,,,[,,"1(?:1[02]|55)",,,,"110",,,[3]],,[,,"1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
,,,"110"],[,,"(?:285|542)0",,,,"2850",,,[4]],[,,,,,,,,,[-1]],,[,,"1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d",,,,"144",,,[3,4]]],TT:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:88|9[09])",,,,"988"],[,,,,,,,,,[-1]],,,,"TT",,,,,,,,,,,,,,,,,,[,,"99[09]",,,,"990"],,[,,"9(?:88|9[09])",
,,,"988"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TV:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"TV",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"1\\d\\d|911",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TW:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"11[0289]|1(?:81|92)\\d",,,,"110"],[,,"10[56]",,,,"105",,,[3]],,,,"TW",,,,,,,,,,,,,,,,,,[,,"11[029]",,,,"110",,,[3]],,[,,"1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",
,,,"100"],[,,"1(?:65|9(?:1\\d|50|85|98))",,,,"165"],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TZ:[,[,,"[149]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:1[0-79]|9[09])|999",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"TZ",,,,,,,,,,,,,,,,,,[,,"11[0-245]|999",,,,"110",,,[3]],,[,,"1(?:1\\d|9[09])|46400|999",,,,"110"],[,,,,,,,,,[-1]],[,,"464\\d\\d",,,,"46400",,,[5]],,[,,"464\\d\\d",,,,"46400",,,[5]]],UA:[,[,,"[189]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:0[1-3]|1(?:2|6\\d{3}))",,,,"101",,,[3,6]],[,,,,,,,,,[-1]],,,,"UA",,,,,
,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],,[,,"1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d",,,,"101"],[,,,,,,,,,[-1]],[,,"(?:118|[89]00)\\d\\d?",,,,"1180",,,[4,5]],,[,,,,,,,,,[-1]]],UG:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"UG",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],US:[,[,,"[1-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"112|611|9(?:11|33|88)",
,,,"112",,,[3]],[,,"24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7",,,,"24280",,,[5]],,,,"US",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)",,,,"112"],[,,"2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",
,,,"23333",,,[5,6]],[,,"336\\d\\d|[2-9]\\d{3}|[2356]11",,,,"211",,,[3,4,5]],,[,,"[2-9]\\d{4,5}",,,,"20000",,,[5,6]]],UY:[,[,,"[129]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"128|911",,,,"128",,,[3]],[,,,,,,,,,[-1]],,,,"UY",,,,,,,,,,,,,,,,,,[,,"128|911",,,,"128",,,[3]],,[,,"1(?:0[4-9]|1[2368]|2[0-3568]|787|997\\d?)|21997|911",,,,"104"],[,,"178\\d",,,,"1780",,,[4]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],UZ:[,[,,"[04]\\d(?:\\d(?:\\d{2})?)?",,,,,,,[2,3,5]],,,[,,"0(?:0[1-3]|[1-3]|50)",,,,"01",,,[2,3]],[,,,,,,,,,[-1]],
,,,"UZ",,,,,,,,,,,,,,,,,,[,,"0(?:0[1-3]|[1-3]|50)",,,,"01",,,[2,3]],,[,,"0(?:0[1-3]|[1-3]|50)|45400",,,,"01"],[,,,,,,,,,[-1]],[,,"454\\d\\d",,,,"45400",,,[5]],,[,,"454\\d\\d",,,,"45400",,,[5]]],VA:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[2358]",,,,"112"],[,,,,,,,,,[-1]],,,,"VA",,,,,,,,,,,,,,,,,,[,,"11[2358]",,,,"112"],,[,,"11[2358]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"VC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",
,,,"911"],,[,,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VE:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"1(?:12|71)|911",,,,"112"],[,,,,,,,,,[-1]],,,,"VE",,,,,,,,,,,,,,,,,,[,,"1(?:12|71)|911",,,,"112"],,[,,"1(?:12|71)|911",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VG:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"VG",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|88|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,
,,,,,[-1]]],VI:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],,,,"VI",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"9(?:11|88)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VN:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[3-5]",,,,"113"],[,,,,,,,,,[-1]],,,,"VN",,,,,,,,,,,,,,,,,,[,,"11[3-5]",,,,"113"],,[,,"11[3-5]",,,,"113"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VU:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"112",,,,"112"],[,,,,,,,,,[-1]],,,,"VU",,,,,,,,,,,,,,,,,,[,,"112",,,,
"112"],,[,,"112",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],WF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"WF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],WS:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"9(?:11|9[4-69])",,,,"911"],[,,,,,,,,,[-1]],,,,"WS",,,,,,,,,,,,,,,,,,[,,"9(?:11|9[4-69])",,,,"911"],,[,,"1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])",,,,"111"],[,,,,,,,,,[-1]],[,,"12[0-6]",,,,"120"],,[,,,,,,,
,,[-1]]],XK:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:12|9[2-4])",,,,"112"],[,,,,,,,,,[-1]],,,,"XK",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[2-4])",,,,"112"],,[,,"1(?:12|9[2-4])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],YE:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"19[1459]",,,,"191"],[,,,,,,,,,[-1]],,,,"YE",,,,,,,,,,,,,,,,,,[,,"19[1459]",,,,"191"],,[,,"19[1459]",,,,"191"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],YT:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|5)",,,,"15"],[,,,,,,,,,[-1]],,,,"YT",,,
,,,,,,,,,,,,,,,[,,"1(?:12|5)",,,,"15"],,[,,"1(?:12|5)",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ZA:[,[,,"[134]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:01\\d\\d|12)",,,,"112",,,[3,5]],[,,"41(?:348|851)",,,,"41348",,,[5]],,,,"ZA",,,,,,,,,,,,,,,,,,[,,"1(?:01(?:11|77)|12)",,,,"112",,,[3,5]],,[,,"1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}",,,,"107"],[,,"3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699",,,,"30782",,,[5]],[,,"111",,,,"111",,,[3]],
,[,,"[34]\\d{4}",,,,"30000",,,[5]]],ZM:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|99[139]",,,,"112"],[,,,,,,,,,[-1]],,,,"ZM",,,,,,,,,,,,,,,,,,[,,"112|99[139]",,,,"112"],,[,,"112|99[139]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ZW:[,[,,"[139]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"112|9(?:5[023]|61|9[3-59])",,,,"112",,,[3]],[,,"3[013-57-9]\\d{3}",,,,"30000",,,[5]],,,,"ZW",,,,,,,,,,,,,,,,,,[,,"112|99[3-59]",,,,"112",,,[3]],,[,,"11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])",,
,,"112"],[,,,,,,,,,[-1]],[,,"114|9(?:5[023]|6[0-25])",,,,"114",,,[3]],,[,,,,,,,,,[-1]]]};/*

 Copyright (C) 2018 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.ShortNumberInfo=function(){this.regionToMetadataMap={}};goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo);i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_=["BR","CL","NI"];i18n.phonenumbers.ShortNumberInfo.ShortNumberCost={TOLL_FREE:0,STANDARD_RATE:1,PREMIUM_RATE:2,UNKNOWN_COST:3};i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_=function(a){return(a=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a])?a:[]};
i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_=function(a,b){a=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());return null!=b&&a.includes(b)};i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;b=this.getMetadataForRegion_(b);if(!b)return!1;a=this.getNationalSignificantNumber_(a).length;return b.getGeneralDesc().possibleLengthArray().includes(a)};
i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber=function(a){var b=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());a=this.getNationalSignificantNumber_(a).length;for(var c=0;c<b.length;c++){var d=this.getMetadataForRegion_(b[c]);if(d&&d.getGeneralDesc().possibleLengthArray().includes(a))return!0}return!1};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;b=this.getMetadataForRegion_(b);if(!b)return!1;a=this.getNationalSignificantNumber_(a);var c=b.getGeneralDesc();if(!this.matchesPossibleNumberAndNationalNumber_(a,c))return!1;b=b.getShortCode();return this.matchesPossibleNumberAndNationalNumber_(a,b)};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber=function(a){var b=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault()),c=this.getRegionCodeForShortNumberFromRegionList_(a,b);return 1<b.length&&null!=c?!0:this.isValidShortNumberForRegion(a,c)};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion=function(a,b){var c=i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;if(!this.regionDialingFromMatchesNumber_(a,b))return c.UNKNOWN_COST;var d=this.getMetadataForRegion_(b);if(!d)return c.UNKNOWN_COST;a=this.getNationalSignificantNumber_(a);return d.getGeneralDesc().possibleLengthArray().includes(a.length)?this.matchesPossibleNumberAndNationalNumber_(a,d.getPremiumRate())?c.PREMIUM_RATE:this.matchesPossibleNumberAndNationalNumber_(a,
d.getStandardRate())?c.STANDARD_RATE:this.matchesPossibleNumberAndNationalNumber_(a,d.getTollFree())||this.isEmergencyNumber(a,b)?c.TOLL_FREE:c.UNKNOWN_COST:c.UNKNOWN_COST};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost=function(a){var b=i18n.phonenumbers.ShortNumberInfo.ShortNumberCost,c=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());if(0===c.length)return b.UNKNOWN_COST;if(1===c.length)return this.getExpectedCostForRegion(a,c[0]);for(var d=b.TOLL_FREE,e=0;e<c.length;e++){var f=this.getExpectedCostForRegion(a,c[e]);switch(f){case b.PREMIUM_RATE:return b.PREMIUM_RATE;case b.UNKNOWN_COST:d=b.UNKNOWN_COST;break;case b.STANDARD_RATE:d!==b.UNKNOWN_COST&&
(d=b.STANDARD_RATE);break;case b.TOLL_FREE:break;default:throw Error("Unrecognized cost for region: "+f);}}return d};i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_=function(a,b){if(0===b.length)return null;if(1===b.length)return b[0];a=this.getNationalSignificantNumber_(a);for(var c=0;c<b.length;c++){var d=b[c],e=this.getMetadataForRegion_(d);if(e&&this.matchesPossibleNumberAndNationalNumber_(a,e.getShortCode()))return d}return null};
i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions=function(){return Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(a){return isNaN(a)})};i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber=function(a){a=this.getMetadataForRegion_(a);if(!a)return"";a=a.getShortCode();return a.hasExampleNumber()?a.getExampleNumber()||"":""};
i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost=function(a,b){a=this.getMetadataForRegion_(a);if(!a)return"";var c=i18n.phonenumbers.ShortNumberInfo.ShortNumberCost,d=null;switch(b){case c.TOLL_FREE:d=a.getTollFree();break;case c.STANDARD_RATE:d=a.getStandardRate();break;case c.PREMIUM_RATE:d=a.getPremiumRate()}return d&&d.hasExampleNumber()?d.getExampleNumber()||"":""};
i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber=function(a,b){return this.matchesEmergencyNumberHelper_(a,b,!0)};i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber=function(a,b){return this.matchesEmergencyNumberHelper_(a,b,!1)};
i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_=function(a){if(!a)return null;a=a.toUpperCase();var b=this.regionToMetadataMap[a];if(null==b){b=new goog.proto2.PbLiteSerializer;var c=i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a];if(null==c)return null;b=b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(),c);this.regionToMetadataMap[a]=b}return b};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_=function(a,b,c){var d=i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a);if(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d))return!1;a=this.getMetadataForRegion_(b);if(null==a||!a.hasEmergency())return!1;d=i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d);b=c&&!i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(b);c=a.getEmergency().getNationalNumberPatternOrDefault();
return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c,d)||b&&i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c,d)};i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific=function(a){var b=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());b=this.getRegionCodeForShortNumberFromRegionList_(a,b);a=this.getNationalSignificantNumber_(a);b=this.getMetadataForRegion_(b);return!!b&&this.matchesPossibleNumberAndNationalNumber_(a,b.getCarrierSpecific())};
i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;a=this.getNationalSignificantNumber_(a);b=this.getMetadataForRegion_(b);return!!b&&this.matchesPossibleNumberAndNationalNumber_(a,b.getCarrierSpecific())};
i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;b=this.getMetadataForRegion_(b);a=this.getNationalSignificantNumber_(a);return!!b&&this.matchesPossibleNumberAndNationalNumber_(a,b.getSmsServices())};
i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_=function(a){if(!a.hasNationalNumber())return"";var b=""+a.getNationalNumber();return a.hasItalianLeadingZero()&&a.getItalianLeadingZero()&&0<a.getNumberOfLeadingZerosOrDefault()?Array(a.getNumberOfLeadingZerosOrDefault()+1).join("0")+b:b};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_=function(a,b){return 0<b.possibleLengthArray().length&&!b.possibleLengthArray().includes(a.length)?!1:i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(),a.toString())};i18n.phonenumbers.AsYouTypeFormatter=function(a){this.DIGIT_PLACEHOLDER_="\u2008";this.DIGIT_PATTERN_=new RegExp(this.DIGIT_PLACEHOLDER_);this.currentOutput_="";this.formattingTemplate_=new goog.string.StringBuffer;this.currentFormattingPattern_="";this.accruedInput_=new goog.string.StringBuffer;this.accruedInputWithoutFormatting_=new goog.string.StringBuffer;this.ableToFormat_=!0;this.isExpectingCountryCallingCode_=this.isCompleteNumber_=this.inputHasFormatting_=!1;this.phoneUtil_=i18n.phonenumbers.PhoneNumberUtil.getInstance();
this.positionToRemember_=this.originalPosition_=this.lastMatchPosition_=0;this.prefixBeforeNationalNumber_=new goog.string.StringBuffer;this.shouldAddSpaceAfterNationalPrefix_=!1;this.extractedNationalPrefix_="";this.nationalNumber_=new goog.string.StringBuffer;this.possibleFormats_=[];this.defaultCountry_=a;this.defaultMetadata_=this.currentMetadata_=this.getMetadataForRegion_(this.defaultCountry_)};i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_=" ";
i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_=new i18n.phonenumbers.PhoneMetadata;i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_=new RegExp("^["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]*\\$1["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]*(\\$\\d["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]*)*$");
i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_=/[- ]/;i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_=3;i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_=function(a){a=this.phoneUtil_.getCountryCodeForRegion(a);a=this.phoneUtil_.getRegionCodeForCountryCode(a);a=this.phoneUtil_.getMetadataForRegion(a);return null!=a?a:i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_};
i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_=function(){for(var a=this.possibleFormats_.length,b=0;b<a;++b){var c=this.possibleFormats_[b],d=c.getPatternOrDefault();if(this.currentFormattingPattern_==d)return!1;if(this.createFormattingTemplate_(c))return this.currentFormattingPattern_=d,this.shouldAddSpaceAfterNationalPrefix_=i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()),this.lastMatchPosition_=0,!0}return this.ableToFormat_=
!1};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_=function(a){for(var b=this.isCompleteNumber_&&0==this.extractedNationalPrefix_.length&&0<this.currentMetadata_.intlNumberFormatCount()?this.currentMetadata_.intlNumberFormatArray():this.currentMetadata_.numberFormatArray(),c=b.length,d=0;d<c;++d){var e=b[d];0<this.extractedNationalPrefix_.length&&this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault())&&!e.getNationalPrefixOptionalWhenFormatting()&&!e.hasDomesticCarrierCodeFormattingRule()||
(0!=this.extractedNationalPrefix_.length||this.isCompleteNumber_||this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault())||e.getNationalPrefixOptionalWhenFormatting())&&i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(e.getFormatOrDefault())&&this.possibleFormats_.push(e)}this.narrowDownPossibleFormats_(a)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_=function(a){for(var b=[],c=a.length-i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_,d=this.possibleFormats_.length,e=0;e<d;++e){var f=this.possibleFormats_[e];if(0==f.leadingDigitsPatternCount())b.push(this.possibleFormats_[e]);else{var g=Math.min(c,f.leadingDigitsPatternCount()-1);f=f.getLeadingDigitsPattern(g);0==a.search(f)&&b.push(this.possibleFormats_[e])}}this.possibleFormats_=b};
i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_=function(a){var b=a.getPatternOrDefault();this.formattingTemplate_.clear();a=this.getFormattingTemplate_(b,a.getFormatOrDefault());return 0<a.length?(this.formattingTemplate_.append(a),!0):!1};i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_=function(a,b){var c="999999999999999".match(a)[0];if(c.length<this.nationalNumber_.getLength())return"";a=c.replace(new RegExp(a,"g"),b);return a=a.replace(/9/g,this.DIGIT_PLACEHOLDER_)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.clear=function(){this.currentOutput_="";this.accruedInput_.clear();this.accruedInputWithoutFormatting_.clear();this.formattingTemplate_.clear();this.lastMatchPosition_=0;this.currentFormattingPattern_="";this.prefixBeforeNationalNumber_.clear();this.extractedNationalPrefix_="";this.nationalNumber_.clear();this.ableToFormat_=!0;this.inputHasFormatting_=!1;this.originalPosition_=this.positionToRemember_=0;this.isExpectingCountryCallingCode_=this.isCompleteNumber_=
!1;this.possibleFormats_=[];this.shouldAddSpaceAfterNationalPrefix_=!1;this.currentMetadata_!=this.defaultMetadata_&&(this.currentMetadata_=this.getMetadataForRegion_(this.defaultCountry_))};i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit=function(a){return this.currentOutput_=this.inputDigitWithOptionToRememberPosition_(a,!1)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition=function(a){return this.currentOutput_=this.inputDigitWithOptionToRememberPosition_(a,!0)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_=function(a,b){this.accruedInput_.append(a);b&&(this.originalPosition_=this.accruedInput_.getLength());this.isDigitOrLeadingPlusSign_(a)?a=this.normalizeAndAccrueDigitsAndPlusSign_(a,b):(this.ableToFormat_=!1,this.inputHasFormatting_=!0);if(!this.ableToFormat_){if(!this.inputHasFormatting_)if(this.attemptToExtractIdd_()){if(this.attemptToExtractCountryCallingCode_())return this.attemptToChoosePatternWithPrefixExtracted_()}else if(this.ableToExtractLongerNdd_())return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_),this.attemptToChoosePatternWithPrefixExtracted_();
return this.accruedInput_.toString()}switch(this.accruedInputWithoutFormatting_.getLength()){case 0:case 1:case 2:return this.accruedInput_.toString();case 3:if(this.attemptToExtractIdd_())this.isExpectingCountryCallingCode_=!0;else return this.extractedNationalPrefix_=this.removeNationalPrefixFromNationalNumber_(),this.attemptToChooseFormattingPattern_();default:if(this.isExpectingCountryCallingCode_)return this.attemptToExtractCountryCallingCode_()&&(this.isExpectingCountryCallingCode_=!1),this.prefixBeforeNationalNumber_.toString()+
this.nationalNumber_.toString();if(0<this.possibleFormats_.length){a=this.inputDigitHelper_(a);b=this.attemptToFormatAccruedDigits_();if(0<b.length)return b;this.narrowDownPossibleFormats_(this.nationalNumber_.toString());return this.maybeCreateNewTemplate_()?this.inputAccruedNationalNumber_():this.ableToFormat_?this.appendNationalNumber_(a):this.accruedInput_.toString()}return this.attemptToChooseFormattingPattern_()}};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_=function(){this.ableToFormat_=!0;this.isExpectingCountryCallingCode_=!1;this.possibleFormats_=[];this.lastMatchPosition_=0;this.formattingTemplate_.clear();this.currentFormattingPattern_="";return this.attemptToChooseFormattingPattern_()};i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_=function(){return this.extractedNationalPrefix_};
i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_=function(){if(0<this.extractedNationalPrefix_.length){var a=this.nationalNumber_.toString();this.nationalNumber_.clear();this.nationalNumber_.append(this.extractedNationalPrefix_);this.nationalNumber_.append(a);a=this.prefixBeforeNationalNumber_.toString();var b=a.lastIndexOf(this.extractedNationalPrefix_);this.prefixBeforeNationalNumber_.clear();this.prefixBeforeNationalNumber_.append(a.substring(0,b))}return this.extractedNationalPrefix_!=
this.removeNationalPrefixFromNationalNumber_()};i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_=function(a){return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a)||1==this.accruedInput_.getLength()&&i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_=function(){for(var a=this.nationalNumber_.toString(),b=this.possibleFormats_.length,c=0;c<b;++c){var d=this.possibleFormats_[c],e=d.getPatternOrDefault();if((new RegExp("^(?:"+e+")$")).test(a)&&(this.shouldAddSpaceAfterNationalPrefix_=i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()),d=a.replace(new RegExp(e,"g"),d.getFormat()),d=this.appendNationalNumber_(d),
i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d)==this.accruedInputWithoutFormatting_))return d}return""};
i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_=function(a){var b=this.prefixBeforeNationalNumber_.getLength();return this.shouldAddSpaceAfterNationalPrefix_&&0<b&&this.prefixBeforeNationalNumber_.toString().charAt(b-1)!=i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_?this.prefixBeforeNationalNumber_+i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_+a:this.prefixBeforeNationalNumber_+a};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition=function(){if(!this.ableToFormat_)return this.originalPosition_;for(var a=0,b=0,c=this.accruedInputWithoutFormatting_.toString(),d=this.currentOutput_.toString();a<this.positionToRemember_&&b<d.length;)c.charAt(a)==d.charAt(b)&&a++,b++;return b};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_=function(){var a=this.nationalNumber_.toString();return a.length>=i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_?(this.getAvailableFormats_(a),a=this.attemptToFormatAccruedDigits_(),0<a.length?a:this.maybeCreateNewTemplate_()?this.inputAccruedNationalNumber_():this.accruedInput_.toString()):this.appendNationalNumber_(a)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_=function(){var a=this.nationalNumber_.toString(),b=a.length;if(0<b){for(var c="",d=0;d<b;d++)c=this.inputDigitHelper_(a.charAt(d));return this.ableToFormat_?this.appendNationalNumber_(c):this.accruedInput_.toString()}return this.prefixBeforeNationalNumber_.toString()};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_=function(){if(1!=this.currentMetadata_.getCountryCode())return!1;var a=this.nationalNumber_.toString();return"1"==a.charAt(0)&&"0"!=a.charAt(1)&&"1"!=a.charAt(1)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_=function(){var a=this.nationalNumber_.toString(),b=0;if(this.isNanpaNumberWithNationalPrefix_())b=1,this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_),this.isCompleteNumber_=!0;else if(this.currentMetadata_.hasNationalPrefixForParsing()){var c=new RegExp("^(?:"+this.currentMetadata_.getNationalPrefixForParsing()+")");c=a.match(c);null!=c&&
null!=c[0]&&0<c[0].length&&(this.isCompleteNumber_=!0,b=c[0].length,this.prefixBeforeNationalNumber_.append(a.substring(0,b)))}this.nationalNumber_.clear();this.nationalNumber_.append(a.substring(b));return a.substring(0,b)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_=function(){var a=this.accruedInputWithoutFormatting_.toString(),b=new RegExp("^(?:\\"+i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+"|"+this.currentMetadata_.getInternationalPrefix()+")");b=a.match(b);return null!=b&&null!=b[0]&&0<b[0].length?(this.isCompleteNumber_=!0,b=b[0].length,this.nationalNumber_.clear(),this.nationalNumber_.append(a.substring(b)),this.prefixBeforeNationalNumber_.clear(),this.prefixBeforeNationalNumber_.append(a.substring(0,
b)),a.charAt(0)!=i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN&&this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_),!0):!1};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_=function(){if(0==this.nationalNumber_.getLength())return!1;var a=new goog.string.StringBuffer,b=this.phoneUtil_.extractCountryCode(this.nationalNumber_,a);if(0==b)return!1;this.nationalNumber_.clear();this.nationalNumber_.append(a.toString());a=this.phoneUtil_.getRegionCodeForCountryCode(b);i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY==a?this.currentMetadata_=this.phoneUtil_.getMetadataForNonGeographicalRegion(b):
a!=this.defaultCountry_&&(this.currentMetadata_=this.getMetadataForRegion_(a));this.prefixBeforeNationalNumber_.append(""+b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);this.extractedNationalPrefix_="";return!0};
i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_=function(a,b){if(a==i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN){var c=a;this.accruedInputWithoutFormatting_.append(a)}else c=i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a],this.accruedInputWithoutFormatting_.append(c),this.nationalNumber_.append(c);b&&(this.positionToRemember_=this.accruedInputWithoutFormatting_.getLength());return c};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_=function(a){var b=this.formattingTemplate_.toString();if(0<=b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)){var c=b.search(this.DIGIT_PATTERN_);a=b.replace(this.DIGIT_PATTERN_,a);this.formattingTemplate_.clear();this.formattingTemplate_.append(a);this.lastMatchPosition_=c;return a.substring(0,this.lastMatchPosition_+1)}1==this.possibleFormats_.length&&(this.ableToFormat_=!1);this.currentFormattingPattern_="";return this.accruedInput_.toString()};Object.defineProperty(exports,"__esModule",{value:!0});exports.default=i18n.phonenumbers;module.exports=exports["default"];

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[1])(1)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').constant('Genders', {
    MAN: { label: 'Homme' },
    WOMAN: { label: 'Femme' },
    OTHER: { label: 'Autre' }
});

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').constant('NfConstant', {
    CODE_10: { "value": "10", "label": "Accès à la piste d’audit" },
    CODE_20: { "value": "20", "label": "Archivage fiscal de période" },
    CODE_30: { "value": "30", "label": "Archivage fiscal d'exercice" },
    CODE_40: { "value": "40", "label": "Arrêt du terminal" },
    CODE_50: { "value": "50", "label": "Clôture de période" },
    CODE_60: { "value": "60", "label": "Clôture d'exercice" },
    CODE_70: { "value": "70", "label": "Début mode dégradée" },
    CODE_80: { "value": "80", "label": "Démarrage du terminal" },
    CODE_90: { "value": "90", "label": "Détection d’un défaut d’intégrité" },
    CODE_100: { "value": "100", "label": "Exécution Fonction spéciale" },
    CODE_110: { "value": "110", "label": "Export de données" },
    CODE_120: { "value": "120", "label": "Fin mode dégradée" },
    CODE_130: { "value": "130", "label": "Habilitation d’utilisateurs" },
    CODE_140: { "value": "140", "label": "Importation de données" },
    CODE_150: { "value": "150", "label": "Imprimante indisponible" },
    CODE_160: { "value": "160", "label": "La génération des écritures comptables" },
    CODE_170: { "value": "170", "label": "Le traitement de fond de caisse" },
    CODE_180: { "value": "180", "label": "Le transfert en comptabilité" },
    CODE_190: { "value": "190", "label": "Les annulations « comptables » de ticket" },
    CODE_200: { "value": "200", "label": "Purge" },
    CODE_210: { "value": "210", "label": "Reprise de données d’autres logiciels" },
    CODE_220: { "value": "220", "label": "Restauration" },
    CODE_230: { "value": "230", "label": "Sauvegarde" },
    CODE_240: { "value": "240", "label": "Suivi des interventions de maintenance" },
    CODE_250: { "value": "250", "label": "Version du logiciel" },
    CODE_260: { "value": "260", "label": "Initialisation des données" },
    CODE_300: { "value": "300", "label": "Activation de paramètre autorisé et documenté" },
    CODE_320: { "value": "320", "label": "Abandons d'opération de vente non encore enregistrée" },
    CODE_323: { "value": "323", "label": "Suppression de ligne d'opération de vente non encore enregistrée" },
    CODE_410: { "value": "410", "label": "Evolution de paramètre de conformité aux règles" },
    CODE_910: { "value": "910", "label": "Les annulations « comptables » d'acompte" },
    CODE_999: { "value": "999", "label": "Fonction éditeurs" }
});

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('AppUrlConstant', [function () {
    return {
        APP_URL: {
            PROD: {
                BACKOFFICE: "https://app.kiute.com",
                INVALID_BACKOFFICE_HOSTNAME: "app.flexybeauty.com",
                INVALID_BACKOFFICE_COMPLET_URL: "https://app.flexybeauty.com"
            },
            QA: {
                BACKOFFICE: "https://app-staging.kiute.com",
                INVALID_BACKOFFICE_HOSTNAME: "app-staging.flexybeauty.com",
                INVALID_BACKOFFICE_COMPLET_URL: "https://app-staging.flexybeauty.com"
            }
        }
    };
}]).factory('AppRedirectionFactory', ['AppUrlConstant', '$window', function (AppUrlConstant, $window) {
    return {
        needRedirectionAppUrl: function needRedirectionAppUrl(location) {
            if (location.host() === AppUrlConstant.APP_URL.PROD.INVALID_BACKOFFICE_HOSTNAME || location.host() === AppUrlConstant.APP_URL.PROD.INVALID_BACKOFFICE_COMPLET_URL) {
                $window.location.href = AppUrlConstant.APP_URL.PROD.BACKOFFICE + '/#' + location.path();
            } else if (location.host() === AppUrlConstant.APP_URL.QA.INVALID_BACKOFFICE_HOSTNAME || location.host() === AppUrlConstant.APP_URL.QA.INVALID_BACKOFFICE_COMPLET_URL) {
                $window.location.href = AppUrlConstant.APP_URL.QA.BACKOFFICE + '/#' + location.path();
            }
        }
    };
}]);

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('Brand', [function () {
    return {
        label: "Kiute Pro",
        newLabel: "Booksy",
        labelDownload: "kiutepro",
        appYear: "2020",
        billing: {
            name: "Kiute Sas",
            address: "100 rue La Fayette",
            zipcode: "75010",
            city: "Paris",
            country: "France",
            siren: "799889704",
            siret: "79988970400018",
            rcs: "Paris B 799 889 704",
            vat: "FR 92 799889704"
        },
        contact: {
            phone: "01 79 72 55 05",
            supportEmail: "support@kiute.com"
        },
        url: {
            website: "https://pro.kiute.com/fr",
            app: "https://app.kiute.com",
            sponsorship: "https://kiute.typeform.com/to/iOgFHex2",
            intercom: "https://intercom.help/KiuteProSupport",
            hubspot: "https://app.hubspot.com/meetings/flexybeauty-cs",
            unsubscribe: "https://start.flexy.co/desabonnement-flexy",
            subscribeSSO: "https://app.hubspot.com/meetings/kimberley-congre/15-minutes-pour-decouvrir-loffre-kiute-speciale-clients-flexy",
            groupUrl: "/kiute-group/",
            adminUrl: "/fxbAdmin/",
            offerPrices: "https://pro.kiute.com/fr/tarifs",
            landingPage: "https://lp.kiute.com/saas-to-marketplace",
            booksyUrl: "https://hook.eu1.make.com/hh8d1nq64fl7h6mh7d1aobxdhlkf7b6l",
            discoverBooksyUrl: "https://storage.googleapis.com/flexy-assets/migration/booksy-brand.html"
        },
        images: {
            logo: "/img/logo-booksy.svg",
            logoWhite: "/img/logo-booksy-white.svg",
            logoSingleLetter: "/img/logo-booksy.png",
            logoBooksyHeader: "/img/logo-booksy-header.png"
        },
        marketplace: {
            domain: "marketplace",
            label: "Kiute",
            url: {
                website: "www.kiute.fr",
                shortWebsite: "kiute.fr",
                proSite: "https://marketplace.kiute.fr/login"
            },
            images: {
                greyLogoUrl: "img/kiute-icon-grey.svg",
                planningLogoUrl: "img/kiute_favicon_RVB.svg"
            },
            phoneNumber: "01.84.80.04.40"
        }
    };
}]);

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('AppAttribute', [function () {
    var AppAttribute = function AppAttribute(code, value, text) {
        this.code = "";
        this.value = "";
        this.text = null;

        if (code !== undefined) this.setValues(code, value, text);
    };

    AppAttribute.prototype.setValues = function (code, value, text) {
        this.code = code;
        if (value !== undefined) this.value = value;
        if (text !== undefined) this.text = text;
    };
    AppAttribute.prototype.setValue = function (code, value) {
        this.value = value;
    };
    AppAttribute.prototype.getObjectResource = function () {
        var newAppAttribute = new AppAttribute();

        newAppAttribute.setValues(this.code, this.value);

        return newAppAttribute;
    };
    AppAttribute.prototype.getCode = function () {
        return this.code;
    };
    AppAttribute.prototype.getValue = function () {
        return this.value;
    };

    return AppAttribute;
}]);

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('AuditTrail_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/auditTrails/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }

    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('AuditTrail', ["AuditTrail_Resource", "AuditTrailData", function (AuditTrail_Resource, AuditTrailData) {
    var AuditTrail = function AuditTrail(resource) {
        this.id = null;
        this.timeCreated = null;
        this.number = null;
        this.code = null;
        this.label = null;
        this.description = null;
        this.userId = null;
        this.signature = null;
        this.pSignature = null;

        this.loadObject(resource);
        AuditTrailData.add(this);
    };
    AuditTrail.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.timeCreated = object.timeCreated;
            this.number = object.number;
            this.code = object.code;
            this.label = object.label;
            this.description = object.description;
            this.userId = object.userId;
            this.signature = object.signature;
            this.pSignature = object.pSignature;
        }
    };
    AuditTrail.prototype.getObjectResource = function () {
        var rsAuditTrail = new AuditTrail_Resource();
        rsAuditTrail.id = this.id;
        rsAuditTrail.code = this.code;
        rsAuditTrail.description = this.description;
        return rsAuditTrail;
    };

    AuditTrail.prototype.getId = function () {
        return this.id;
    };

    AuditTrail.prototype.setId = function (id) {
        this.id = id;
    };

    return AuditTrail;
}]);

angular.module('FlexyBeautyApp.services').factory('AuditTrailSrv', ["$log", "AuditTrail_Resource", "AuditTrail", "AuditTrailData", "ServerSrv", function ($log, AuditTrail_Resource, AuditTrail, AuditTrailData, ServerSrv) {
    var auditTrailSrv = {};

    auditTrailSrv.query = function (successFunction, errorFunction) {
        AuditTrail_Resource.query({}, //params
        function (data) {
            //success
            AuditTrailData.clear();
            for (var i = 0; i < data.length; i++) {
                new AuditTrail(data[i]);
            } //Auto Add to AuditTrailData
            if (successFunction !== undefined) successFunction(AuditTrailData.indexAuditTrails);
        }, function (data) {
            //failure
            $log.error("AuditTrail_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    auditTrailSrv.createAndSave = function (code, successFunction, errorFunction) {
        var auditTrail = new AuditTrail();
        auditTrail.code = code;
        ServerSrv.startSavingProcess(auditTrailSrv.saveSync, auditTrail, successFunction, errorFunction);
    };
    auditTrailSrv.save = function (auditTrail, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(auditTrailSrv.saveSync, auditTrail, successFunction, errorFunction);
    };
    auditTrailSrv.saveSync = function (auditTrail, successFunction, errorFunction) {
        //$timeout (function () {

        var AuditTrailRes = auditTrail.getObjectResource();
        AuditTrailRes.$save({}, //no params
        function (data) {
            try {
                auditTrail.setId(data.id);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    auditTrailSrv.get = function (id, successFunction, errorFunction) {
        AuditTrail_Resource.get({ id: id }, //params
        function (auditTrailResource) {
            if (successFunction != undefined) successFunction(new AuditTrail(auditTrailResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };

    return auditTrailSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('AuditTrailData', ["$filter", function ($filter) {
    var auditTrailDataSrv = {
        indexAuditTrails: []

    };
    auditTrailDataSrv.getById = function (auditTrailId) {
        for (var i = 0; i < this.indexAuditTrails.length; i++) {
            if (this.indexAuditTrails[i].getId() == auditTrailId) return this.indexAuditTrails[i];
        }return null;
    };
    auditTrailDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexAuditTrails.length) return this.indexAuditTrails[index];
        return null;
    };
    auditTrailDataSrv.getIndexOf = function (auditTrail) {
        if (auditTrail) return this.indexAuditTrails.indexOf(auditTrail);
        return -1;
    };

    auditTrailDataSrv.add = function (auditTrail) {
        var index = this.indexAuditTrails.indexOf(auditTrail);
        if (index == -1) {
            index = this.indexAuditTrails.length;
            this.indexAuditTrails.push(auditTrail);
        }
        return index;
    };
    auditTrailDataSrv.clear = function () {
        this.indexAuditTrails = [];
    };
    return auditTrailDataSrv;
}]);

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp').factory('Images', [function () {
    return {
        saleStatus: {
            advance: '/img/svg/salestatussvg/advance.svg',
            created: '/img/svg/salestatussvg/created.svg',
            paid: '/img/svg/salestatussvg/paid.svg',
            waiting: '/img/svg/salestatussvg/waiting.svg'
        }
    };
}]);

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('BillingManager_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/billing-manager', {}, {
        getBillingManager: { method: 'GET', url: baseUrl + 'rest/billing-manager' },
        computeSiteName: { method: 'GET', url: baseUrl + 'rest/billing-manager/site-name' },
        createPortalSession: { method: 'POST', url: baseUrl + 'rest/billing-manager/create-portal-session' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('BillingManagerSrv', ['BillingManager_Resource', function (BillingManager_Resource) {
    var billingManagerSrv = {};

    billingManagerSrv.getBillingManager = function () {
        return BillingManager_Resource.getBillingManager().$promise;
    };

    billingManagerSrv.computeSiteName = function () {
        return BillingManager_Resource.computeSiteName().$promise;
    };

    billingManagerSrv.createPortalSession = function () {
        return BillingManager_Resource.createPortalSession().$promise;
    };

    return billingManagerSrv;
}]);

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 16:43
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Booking_Resource', ["$resource", "$location", function ($resource, $location) {
    var resourceBooking;
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    resourceBooking = $resource(baseUrl + 'rest/bookings/:date/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getHistory: { method: 'GET', url: baseUrl + 'rest/bookings/getHistory/:id' },
        getAvailableTimes: { method: 'POST', url: baseUrl + 'rest/bookings/availableTimes' },
        saveTransaction: { method: 'POST', url: baseUrl + 'rest/bookings/saveTransaction' },
        onlineSave: { method: 'POST', url: baseUrl + 'rest/bookings/onlineSave' }
    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('Booking', ["CustomerData", "BookingService", "Booking_Resource", "Period", "BookingData", "DayData", "SaleProduct", "Payment", "Sale", "SaleData", "VatData", "TaxMode", function (CustomerData, BookingService, Booking_Resource, Period, BookingData, DayData, SaleProduct, Payment, Sale, SaleData, VatData, TaxMode) {
    //Booking inherit of Booking_Resource

    var Booking = function Booking(bookingRes, day, mustloadBookingElements, isPreviousVersion, isApplicationLoading) {
        //bookingRes : json resource
        //day : Day of booking (real oject)
        //mustloadBookingServices : boolean
        //isPreviousVersion : boolean (if the instance is a previous version -> do not add to active objects)
        this.id = null;
        this.isDeleted = false;
        this.timeCreated = null;
        this.day = null;
        this.status = "created";
        this.creator = null;
        this.comment = null;
        this.techNote = null;
        this.period = null;
        this.price = 0;
        this.discountPercent = 0;
        this.payments = [];
        this._customerId = null; //tmp for loading only
        this._customer = null; //tmp for loading only
        this.customer = null;
        this.isCreatedByCustomer = false; //Default value
        this.bookingServices = [];
        this.selectedHumanResource = null;
        this.sale = null;
        this._saleId = null;
        this.version = null;
        if (bookingRes !== undefined && bookingRes != null) {
            this.loadObjectProperties(bookingRes, null, isApplicationLoading);
            if (mustloadBookingElements) {
                this.loadObjectBookingServices(bookingRes, isPreviousVersion, isApplicationLoading);
            }
        }
        if (day !== undefined && day != null) this.day = day;

        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            BookingData.add(this, isApplicationLoading);

        this.saveTransactionOrigin = null;
    };
    Booking.prototype.loadObject = function (object, isApplicationLoading) {
        this.loadObjectProperties(object);
        this.loadObjectBookingServices(object, false, isApplicationLoading);
    };
    Booking.prototype.loadObjectProperties = function (object) {
        if (!this.id) this.id = object.id;
        if (object.timeCreated) this.timeCreated = new Date(object.timeCreated);
        if (object.timeModified) this.timeModified = new Date(object.timeModified);
        this.isDeleted = object.isDeleted;
        this.status = object.status;
        if (object.creator != null) this.creator = object.creator;
        this.comment = object.comment;
        this.techNote = object.techNote;
        this.price = object.price;
        this.discountPercent = object.discountPercent;
        this.payments = [];
        if (object.payments) for (var i = 0; i < object.payments.length; i++) {
            this.payments.push(new Payment(object.payments[i]));
        }this._saleId = object.saleId;
        this._customerId = object.customerId;
        this._customer = object.customer;
        this.isCreatedByCustomer = object.isCreatedByCustomer;
        this.setPeriod(object.period);
        if (object.version) this.version = object.version;
    };
    Booking.prototype.loadObjectBookingServices = function (object, isPreviousVersion, isApplicationLoading) {
        if (object.bookingServices) {
            this.bookingServices = []; //set to 0 and reload
            for (var i = 0; i < object.bookingServices.length; i++) {
                this.addBookingService(new BookingService(object.bookingServices[i], isPreviousVersion, isApplicationLoading));
            }
        }
    };
    Booking.prototype.loadRef = function (isPreviousVersion, isApplicationLoading) {
        if (this._customerId && (!this.customer || !isApplicationLoading)) {
            this.customer = CustomerData.getById(this._customerId, isApplicationLoading);
            if (!this.isDeleted && this.customer && (isPreviousVersion === undefined || !isPreviousVersion)) {
                this.customer.addBooking(this);
            }
        }
        if (this._saleId && (!this.sale || !isApplicationLoading)) {
            this.sale = SaleData.getById(this._saleId, isApplicationLoading);
            if (this.sale && !this.sale.booking) //patch for old errors
                this.sale.booking = this;
        }
        for (var i = 0; i < this.bookingServices.length; i++) {
            this.bookingServices[i].loadRef();
        }
    };
    Booking.prototype.removeRef = function () {
        if (this.customer) {
            this.customer.removeBooking(this);
        }
    };
    Booking.prototype.getObjectResource = function () {
        var bookingRes = new Booking_Resource();
        bookingRes.id = this.id;
        bookingRes.isDeleted = this.isDeleted;
        bookingRes.status = this.status;
        bookingRes.creator = this.creator;
        bookingRes.comment = this.comment;
        bookingRes.techNote = this.techNote;
        bookingRes.price = this.price;
        bookingRes.version = this.version;
        bookingRes.discountPercent = this.discountPercent;
        bookingRes.payments = [];
        if (this.payments) for (var i = 0; i < this.payments.length; i++) {
            bookingRes.payments.push(this.payments[i].getObjectResource());
        }if (this.sale) bookingRes.saleId = this.sale.id;
        if (this.day) bookingRes.dayId = this.day.id;

        if (this.selectedHumanResource) bookingRes.selectedHumanResourceId = this.selectedHumanResource.id;

        if (this.period) {
            bookingRes.period = this.period.getObjectResource();
        }
        bookingRes.isCreatedByCustomer = this.isCreatedByCustomer;
        if (this.customer) //always save it
            bookingRes.customer = this.customer.getObjectResource();

        bookingRes.bookingServices = [];
        for (var i = 0; i < this.bookingServices.length; i++) {
            bookingRes.bookingServices.push(this.bookingServices[i].getObjectResource());
        }
        bookingRes.saveTransactionOrigin = this.saveTransactionOrigin;
        return bookingRes;
    };
    Booking.prototype.setPeriod = function (period) {
        if (period) this.period = new Period(period);
    };
    Booking.prototype.getId = function () {
        return this.id;
    };
    Booking.prototype.setId = function (id) {
        if (this.id == null) this.id = id;
    };
    Booking.prototype.getPrice = function () {
        return this.price;
    };
    Booking.prototype.setPrice = function (price) {
        this.price = price;
    };
    Booking.prototype.getIndexOfBsFromIdInBooking = function (idInBooking) {
        if (idInBooking) {
            for (var i = 0; i < this.bookingServices.length; i++) {
                if (this.bookingServices[i].idInBooking && this.bookingServices[i].idInBooking == idInBooking) return i;
            }
        }
        return null;
    };
    Booking.prototype.getCustomer = function () {
        if (this.customer != null) return this.customer;
        return CustomerData.getById(this.customerId);
    };
    Booking.prototype.getBookingServiceById = function (id) {
        var bs = null;
        for (var i = 0; i < this.bookingServices.length && !bs; i++) {
            if (this.bookingServices[i].id == id) bs = this.bookingServices[i];else if (this.bookingServices[i].isPackage) bs = this.bookingServices[i].getSubBookingServiceById(id);
        }return bs;
    };
    Booking.prototype.addBookingService = function (bookingService) {
        var index = this.bookingServices.indexOf(bookingService);
        if (index == -1) {
            this.bookingServices.push(bookingService);
            bookingService.booking = this;
        }
    };
    Booking.prototype.removeBookingService = function (bookingService) {
        if (bookingService != null) {
            var index = this.bookingServices.indexOf(bookingService);
            if (index != -1) this.bookingServices.splice(index, 1);
            bookingService.booking = null;
        }
    };

    Booking.prototype.removeFromDay = function () {
        //remove from day and services from dayhr
        if (this.day) this.day.removeBooking(this);
        for (var i = 0; i < this.bookingServices.length; i++) {
            this.bookingServices[i].removeFromDayHr();
        }
    };
    Booking.prototype.containsGiftOnBs = function (giftItem) {
        var containsGift = false;
        if (giftItem) for (var i = 0; i < this.bookingServices.length; i++) {
            if (this.bookingServices[i].giftItem && this.bookingServices[i].giftItem.id == giftItem.id) containsGift = true;
        }return containsGift;
    };
    Booking.prototype.hrIsWorking = function (hrId) {
        var hrIsWorking = false;
        for (var i = 0; i < this.bookingServices.length; i++) {
            if (!this.bookingServices[i].isPackage) {
                if (this.bookingServices[i].dayHr && this.bookingServices[i].dayHr.humanResourceId === hrId) {
                    hrIsWorking = true;
                    break;
                }
            } else {
                for (var j = 0; j < this.bookingServices[i].subBookingServices.length; j++) {
                    if (this.bookingServices[i].subBookingServices[j].dayHr && this.bookingServices[i].subBookingServices[j].dayHr.humanResourceId === hrId) {
                        hrIsWorking = true;
                        break;
                    }
                }
            }
        }
        return hrIsWorking;
    };
    Booking.prototype.getDiscountPrice = function (taxMode) {
        var discountPrice = 0;
        if (this.sale == null) {
            var defaultVat = VatData.getDefaultVat();

            if (taxMode === TaxMode.HT) {
                discountPrice = this.price / (100 + defaultVat.tax) * 100;
            } else {
                discountPrice = this.price;
            }
        } else if (taxMode === TaxMode.HT) {
            discountPrice = this.sale.priceHT;
        } else {
            discountPrice = this.sale.price;
        }

        return discountPrice;
    };

    Booking.prototype.checkBookingCreator = function (bookingCreator) {
        var isSameCreator = false;
        if (this.creator && this.creator === bookingCreator) isSameCreator = true;
        return isSameCreator;
    };

    return Booking;
}]);

angular.module('FlexyBeautyApp.services').factory('BookingSrv', ["$rootScope", "$log", "ServerSrv", "Booking_Resource", "Booking", "HumanResourceSrv", "PhysicalResourceSrv", "DayData", "UserActionData", "BookingData", "DayHrData", "DayHr", "Customer", "gettextCatalog", "MessageSrv", function ($rootScope, $log, ServerSrv, Booking_Resource, Booking, HumanResourceSrv, PhysicalResourceSrv, DayData, UserActionData, BookingData, DayHrData, DayHr, Customer, gettextCatalog, MessageSrv) {
    var bookingSrv = {};
    bookingSrv.newLoadRef = function (isApplicationLoading, start, step) {
        return new Promise(function (resolve) {
            var bookingStart = start || 0;
            var bookingStep = step || 10000;

            var bookings = isApplicationLoading ? Object.values(BookingData.objBookings) : BookingData.indexBookings;
            var subBookings = bookings.slice(bookingStart, bookingStart + bookingStep);
            subBookings.map(function (booking) {
                booking.loadRef(null, isApplicationLoading);
            });

            if (subBookings.length === step) {
                resolve(bookingSrv.newLoadRef(isApplicationLoading, bookingStart + bookingStep, bookingStep));
            } else {
                resolve();
            }
        });
    };

    bookingSrv.loadRef = function (isApplicationLoading) {
        if (isApplicationLoading) {
            var _bookings = BookingData.objBookings;
            for (var key in _bookings) {
                _bookings[key].loadRef(null, isApplicationLoading);
            }
        } else {
            var bookings = BookingData.indexBookings;
            for (var i = 0; i < bookings.length; i++) {
                bookings[i].loadRef(null, isApplicationLoading);
            }
        }
    };
    bookingSrv.updateBookingServicesId = function (bsRes, bs) {

        bs.setId(bsRes.id);
        if (!bs.version || bsRes.version && bsRes.version > bs.version) bs.version = bsRes.version;
        bs.idInBooking = bsRes.idInBooking;
        // if dayHr created by transaction : set dayHrId
        if (bs.dayHr && !bs.dayHr.id && bsRes.dayHrId) bs.dayHr.id = bsRes.dayHrId;
        // if dayHr created by transaction : set dayHrId
        if (bs.dayPr && !bs.dayPr.id && bsRes.dayPrId) bs.dayPr.id = bsRes.dayPrId;
        for (var k = 0; k < bs.secondariesDayHrs.length; k++) {
            if (bs.secondariesDayHrs[k] && bsRes.secondariesDayHrsId[k]) bs.secondariesDayHrs[k].id = bsRes.secondariesDayHrsId[k];
        }for (var k = 0; k < bs.secondariesDayPrs.length; k++) {
            if (bs.secondariesDayPrs[k] && bsRes.secondariesDayPrsId[k]) bs.secondariesDayPrs[k].id = bsRes.secondariesDayPrsId[k];
        }
    };
    bookingSrv.save = function (booking, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bookingSrv.saveSync, booking, successFunction, errorFunction);
    };
    bookingSrv.saveSync = function (booking, successFunction, errorFunction) {
        var bookingRes = booking.getObjectResource();
        bookingRes.$save({}, //no params
        function (bookingRes) {
            /** @namespace bookingRes.salesId */
            /** @namespace bookingRes.bookingServicesId */
            try {
                booking.setId(bookingRes.id);
                if (!booking.version || bookingRes.version && bookingRes.version > booking.version) booking.version = bookingRes.version;

                if (bookingRes.timeCreated) booking.timeCreated = new Date(bookingRes.timeCreated);

                for (var j = 0; j < bookingRes.bookingServices.length; j++) {
                    bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j], booking.bookingServices[j]);
                    for (var k = 0; k < bookingRes.bookingServices[j].subBookingServices.length; k++) {
                        bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j].subBookingServices[k], booking.bookingServices[j].subBookingServices[k]);
                    }
                }

                if (bookingRes.customer && booking.customer) {
                    booking.customer.setId(bookingRes.customer.id);
                    if (!booking.customer.version || bookingRes.customer.version && bookingRes.customer.version > booking.customer.version) booking.customer.version = bookingRes.customer.version;
                }
                //Add user action
                UserActionData.add(bookingRes.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(bookingRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                var errorMessage = "Erreur inconnue lors de la sauvegarde.";
                if (data.status && data.data) {
                    if (data.status == "409") {
                        if (data.data.errorCode == "40900") errorMessage = "L'heure choisie pour la réservation n'est plus disponible.";
                        if (data.data.errorCode == "40901") errorMessage = "Impossible de valider la réservation. Veuillez recharger le site internet et essayer à nouveau.";
                    }
                }
                var transLateErrorMessage = gettextCatalog.getString(errorMessage);

                if (errorFunction != undefined) errorFunction(transLateErrorMessage);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    bookingSrv.onlineSave = function (booking, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bookingSrv.onlineSaveSync, booking, successFunction, errorFunction);
    };
    bookingSrv.onlineSaveSync = function (booking, successFunction, errorFunction) {
        var bookingRes = booking.getObjectResource();
        if (booking.sale) bookingRes.sale = booking.sale.getObjectResource();
        bookingRes.$onlineSave({}, //no params
        function (bookingRes) {
            /** @namespace bookingRes.salesId */
            /** @namespace bookingRes.bookingServicesId */

            try {
                booking.setId(bookingRes.id);
                if (!booking.version || bookingRes.version && bookingRes.version > booking.version) booking.version = bookingRes.version;

                if (booking.sale && bookingRes.sale) booking.sale = bookingRes.sale.id;
                if (bookingRes.timeCreated) booking.timeCreated = new Date(bookingRes.timeCreated);

                for (var j = 0; j < bookingRes.bookingServices.length; j++) {
                    bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j], booking.bookingServices[j]);
                    for (var k = 0; k < bookingRes.bookingServices[j].subBookingServices.length; k++) {
                        bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j].subBookingServices[k], booking.bookingServices[j].subBookingServices[k]);
                    }
                }

                if (bookingRes.customer && booking.customer) {
                    booking.customer.setId(bookingRes.customer.id);
                    if (!booking.customer.version || bookingRes.customer.version && bookingRes.customer.version > booking.customer.version) booking.customer.version = bookingRes.customer.version;
                }

                UserActionData.add(bookingRes.userAction);

                var partnerId = '10000121';
                var endpoint = 'https://www.google.com/maps/conversion/collect';

                var match = document.cookie.match(new RegExp('(?:^| )_rwgToken=([^;]+)'));
                var storedRwgToken = match ? match[1] : undefined;

                if (storedRwgToken !== undefined) {
                    fetch(endpoint, {
                        method: "POST",
                        body: JSON.stringify({
                            conversion_partner_id: partnerId,
                            rwg_token: decodeURIComponent(storedRwgToken),
                            merchant_changed: "2"
                        })
                    });
                }

                //CallBack on success
                if (successFunction != undefined) successFunction(bookingRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                var errorMessage = "La transaction a échouée. Veuillez recharger le site internet et essayer à nouveau.";
                if (data.status && data.data) {
                    if (data.status == "400") {
                        data.data.errorCode = "40000";
                        errorMessage = data.data.message;
                    }
                    if (data.status == "409") {

                        switch (data.data.errorCode) {
                            case "40900":
                                errorMessage = "L'heure choisie pour la réservation n'est plus disponible.";
                                break;
                            case "40901":
                                errorMessage = "Impossible de valider la réservation. Veuillez recharger le site internet et essayer à nouveau.";
                                break;
                            case "101101":
                            case "101102":
                            case "101103":
                            case "101104":
                            case "101111":
                            case "101112":
                            case "101113":
                            case "101115":
                            case "101116":
                            case "101119":
                            case "101199":
                                errorMessage = "Transaction refusée par la banque. Merci de vérifier vos autorisations de paiement par internet. (" + data.data.errorCode + ").";
                                break;
                            case "101105":
                                errorMessage = "La carte est expirée (" + data.data.errorCode + ").";
                                break;
                            case "101106":
                            case "101410":
                                errorMessage = "La carte n'est pas utilisable (" + data.data.errorCode + ").";
                                break;
                            case "101303":
                            case "101302":
                                errorMessage = "La carte n'est pas compatible avec la sécurité 3D Secure (" + data.data.errorCode + ").";
                                break;
                            default:
                                errorMessage = "Transaction refusée par la banque. Merci de vérifier vos autorisations de paiement par internet. (" + data.data.errorCode + ").";
                        }
                    }
                }
                if (errorFunction != undefined) {
                    var transLateErrorMessage = gettextCatalog.getString(errorMessage);
                    errorFunction(data.data.errorCode, transLateErrorMessage);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    bookingSrv.remove = function (booking, successFunction, errorFunction) {
        //Remove directly from model
        ServerSrv.startSavingProcess(bookingSrv.removeSync, booking, successFunction, errorFunction);
    };
    bookingSrv.removeSync = function (booking, successFunction, errorFunction) {
        var bookingSrv = new Booking_Resource();
        bookingSrv.$remove({ id: booking.getId() }, //params : id
        function (data) {
            try {
                UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    bookingSrv.getHistory = function (bookingId, successFunction, errorFunction) {
        Booking_Resource.getHistory({ id: bookingId }, function (bookingsRes) {
            //success
            var bookings = [];
            var booking;
            if (bookingsRes && bookingsRes.bookings) {
                for (var i = 0; i < bookingsRes.bookings.length; i++) {
                    booking = new Booking(bookingsRes.bookings[i], null, true, true);
                    booking.dayId = bookingsRes.bookings[i].dayId;
                    bookings.push(booking);
                }
            }
            //CallBack on success
            if (successFunction != undefined) successFunction(bookings);
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };
    bookingSrv.executeTransaction = function (transaction, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bookingSrv.executeTransactionAsync, transaction, successFunction, errorFunction);
    };
    bookingSrv.executeTransactionAsync = function (transaction, successFunction, errorFunction) {
        if (transaction && transaction.objects && transaction.objects.length > 0 && !$rootScope.readOnly) {
            var transactionResource = new Booking_Resource();
            transactionResource.bookings = [];
            for (var i = 0; i < transaction.objects.length; i++) {
                transactionResource.bookings.push(transaction.objects[i].getObjectResource());
            }
            transactionResource.$saveTransaction({}, //no params
            function (data) {
                try {
                    var booking;
                    var bookingRes;
                    if (data.bookings && transaction.objects.length == data.bookings.length) {
                        for (var i = 0; i < transaction.objects.length; i++) {
                            //Consider order must be the same
                            var j;
                            booking = transaction.objects[i];
                            bookingRes = data.bookings[i];

                            booking.setId(bookingRes.id);
                            if (!booking.version || bookingRes.version && bookingRes.version > booking.version) {
                                booking.version = bookingRes.version;
                            }
                            if (bookingRes.timeCreated) {
                                booking.timeCreated = new Date(bookingRes.timeCreated);
                            }
                            if (bookingRes.bookingServices && bookingRes.bookingServices.length == booking.bookingServices.length) {
                                for (j = 0; j < bookingRes.bookingServices.length; j++) {
                                    var indexOfBookingService = booking.getIndexOfBsFromIdInBooking(bookingRes.bookingServices[j].idInBooking);
                                    if (indexOfBookingService == null) {
                                        indexOfBookingService = j;
                                    }
                                    bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j], booking.bookingServices[indexOfBookingService]);
                                    for (var k = 0; k < bookingRes.bookingServices[j].subBookingServices.length; k++) {
                                        bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j].subBookingServices[k], booking.bookingServices[indexOfBookingService].subBookingServices[k]);
                                    }
                                }
                            } else {
                                $log.error("executeTransactionAsync : returned list size incorrect !!");
                            }

                            if (bookingRes.customer && booking.customer) {
                                booking.customer.setId(bookingRes.customer.id);
                                if (!booking.customer.version || bookingRes.customer.version && bookingRes.customer.version > booking.customer.version) booking.customer.version = bookingRes.customer.version;
                            }
                        }
                    } else {
                        $log.error("executeTransactionAsync : returned list size incorrect !!");
                    }

                    //Add user action
                    UserActionData.add(data.userAction);
                    //CallBack on success
                    if (successFunction) {
                        successFunction(data);
                    }
                } finally {
                    ServerSrv.endSavingProcess(true);
                }
            }, function (data) {
                //failure
                //error handling goes here
                try {
                    if (errorFunction) {
                        errorFunction(data);
                    }
                } finally {
                    ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null, "Booking.executeTransactionAsync - Error on save and server call queue not empty");
                }
            });
        } else ServerSrv.endSavingProcess(true);
    };

    bookingSrv.getAvailableTimes = function (booking) {
        var bookingSrv = booking.getObjectResource();
        bookingSrv.$getAvailableTimes({});
    };

    bookingSrv.removeLocally = function (id, resource) {
        var booking = BookingData.getById(id);
        if (booking) {
            if (booking.version && resource.version && resource.version <= booking.version) {
                return null;
            }

            if (booking.day) {
                booking.day.removeBooking(booking);
            } else {
                console.log("Booking.removeLocally - booking.day is null - booking ID: " + id);
            }
            if (booking.customer) {
                booking.customer.removeBooking(booking);
            }
        } else {
            console.log("Booking.removeLocally - Model not found given ID - booking ID: " + id);
        }
        return booking;
    };

    bookingSrv.addLocally = function (id, resource) {
        var booking = BookingData.getById(id);
        if (booking && booking.version && resource.version && resource.version <= booking.version) {
            return null;
        }

        var day = DayData.getById(resource.dayId);
        if (booking != null) {
            //check if resource already exist inside index (current action could be a 'cancel')
            console.log("Booking.addLocally - Model already exists - booking ID: " + id);
            if (booking.customer) {
                booking.customer.removeBooking(booking);
            }
            booking.loadObjectProperties(resource);
        } else {
            booking = new Booking(resource, day, false); //dont load bookingsService (will be done after)
            booking.id = id;
        }
        booking.loadRef();
        if (day) {
            day.addBooking(booking);
        } else {
            console.log("Booking.addLocally - Day not found - Day ID: " + resource.dayId);
        }

        return booking;
    };

    bookingSrv.updateLocally = function (id, resource) {
        var booking = BookingData.getById(id);
        if (!booking) {
            MessageSrv.send("error", gettextCatalog.getString("Veuillez recharger l'application afin d'actualiser les données"));
            console.log("Booking.updateLocally - Model not found given ID - Booking ID: " + id);
        } else {
            if (booking.version && resource.version && resource.version <= booking.version) {
                return null;
            }

            var newDay = DayData.getById(resource.dayId);
            if (newDay) {
                if (booking.day !== newDay) {
                    booking.day.removeBooking(booking);
                    newDay.addBooking(booking);
                }
                if (booking.customer) {
                    booking.customer.removeBooking(booking);
                }
                booking.loadObject(resource);
                booking.loadRef(); //Will add to customer
            } else {
                console.log("Booking.updateLocally - Day not found - Day ID: " + resource.dayId);
            }
        }
        return booking;
    };

    bookingSrv.getPreviousVersionInstance = function (resource) {
        var day = DayData.getById(resource.dayId);
        var booking = new Booking(resource, day, false, true);
        return booking;
    };

    return bookingSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('BookingData', ["$log", "ModelDataUtil", function ($log, ModelDataUtil) {
    var bookingData = {
        objBookings: {},
        indexBookings: []
    };
    bookingData.getById = function (bookingId, isApplicationLoading) {
        var booking = null;
        if (isApplicationLoading) {
            booking = this.objBookings[bookingId];
        } else {
            for (var i = 0; i < this.indexBookings.length; i++) {
                //Dont replace this == by a === in this method. We need implicit cast comparison
                if (this.indexBookings[i].id == bookingId) {
                    booking = this.indexBookings[i];
                    break;
                }
            }
        }
        return booking;
    };

    bookingData.getIndexOf = function (booking) {
        if (booking) return this.indexBookings.indexOf(booking);
        return -1;
    };
    bookingData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexBookings.length) return this.indexBookings[index];else return null;
    };
    bookingData.add = function (booking, isApplicationLoading) {
        if (isApplicationLoading) {
            if (booking && booking.id) this.objBookings[booking.id] = booking;
        } else {
            //to do add always sorted
            this.indexBookings.push(booking);
        }
    };

    bookingData.clear = function () {
        bookingData.indexBookings = [];
        bookingData.objBookings = {};
    };

    bookingData.convertMapToArray = function (keepObject, isNewLoading) {
        if (isNewLoading) {
            this.indexBookings = ModelDataUtil.convertObjectToArray(this.objBookings, this.indexBookings);
            if (!keepObject) {
                this.objBookings = {};
            }
        } else {
            this.indexBookings = ModelDataUtil.convertMapToArray(this.objBookings, this.indexBookings);
            this.objBookings = null;
        }
    };

    return bookingData;
}]);

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('BookingService_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBookingS = $resource(baseUrl + 'rest/bookingServices/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceBookingS;
}]);

angular.module('FlexyBeautyApp.services').factory('BookingService', ["BookingService_Resource", "HumanResourceData", "PhysicalResourceData", "CategoryData", "Activity", "ServiceData", "GiftItemData", "ActivityData", "TaxMode", "VatData", "HumanResource", "PhysicalResource", "Category", "Service", "RootStatCategorie", "HrRootOccupationRateCategory", "PrRootOccupationRateCategory", "NbCustormerCategoryStat", "TypeOfCustomerRootCategory", "TypeOfCustomer", "HrRootCategory", "TypeOfBooking", "BookingCreator", function (BookingService_Resource, HumanResourceData, PhysicalResourceData, CategoryData, Activity, ServiceData, GiftItemData, ActivityData, TaxMode, VatData, HumanResource, PhysicalResource, Category, Service, RootStatCategorie, HrRootOccupationRateCategory, PrRootOccupationRateCategory, NbCustormerCategoryStat, TypeOfCustomerRootCategory, TypeOfCustomer, HrRootCategory, TypeOfBooking, BookingCreator) {
    //BookingService inherit from Activity
    var BookingService = function BookingService(bookingServiceRes, isPreviousVersion, isApplicationLoading) {
        this.price = 0;
        this.originalPrice = 0;
        this.discountPercent = 0;
        this.idInBooking = null;
        this.hrRequest = false;
        this.isPackage = false;
        this.billPosition = 0;
        this.service = null;
        this.subBookingServices = [];
        this.booking = null;
        this.cureItemToServiceUsage = null;
        this.giftItem = null;
        this.secondariesDayPrs = [];
        this.secondariesDayHrs = [];
        this._secondariesDayPrsId = []; //tmp for loading
        this._secondariesDayHrsId = []; //tmp for loading
        this.pkg = null; //package
        Activity.call(this, bookingServiceRes, isPreviousVersion, isApplicationLoading); //call super() -> call BookingService.prototype.loadObject ->  call Activity.prototype.loadObject
    };

    BookingService.prototype = Object.create(Activity.prototype); //get all functions of super()

    BookingService.prototype.loadObject = function (object, isPreviousVersion, isApplicationLoading) {

        //Call super function
        Activity.prototype.loadObject.call(this, object);

        if (object !== undefined && object != null) {
            this.price = object.price;
            if (object.originalPrice !== undefined && object.originalPrice) this.originalPrice = object.originalPrice;else this.originalPrice = object.price;
            this.discountPercent = object.discountPercent;
            this.hrRequest = object.hrRequest;
            this.isPackage = object.isPackage;
            this._serviceId = object.serviceId;
            this._giftItemId = object.giftItemId;
            if (object.idInBooking != null) this.idInBooking = object.idInBooking;

            if (object.subBookingServices) {
                this.subBookingServices = []; //set to 0 and reload
                for (var i = 0; i < object.subBookingServices.length; i++) {
                    var subBs = ActivityData.getById(object.subBookingServices[i].id, isApplicationLoading); //can happens on propagation
                    if (subBs && (isPreviousVersion == undefined || !isPreviousVersion)) {
                        subBs.loadObject(object.subBookingServices[i], null, isApplicationLoading);
                        subBs.pkg = this;
                        subBs.booking = this.booking;
                    } else {
                        subBs = new BookingService(object.subBookingServices[i], isPreviousVersion, isApplicationLoading);
                        subBs.booking = this.booking;
                        subBs.pkg = this;
                    }
                    this.addSubBs(subBs);
                }
            }
            //no need to load  secondariesDayPrsId (will be done from dayHR or DayPr)
            // cureItemToServiceUsage is loaded by cureItemToServiceUsage
        }
    };
    BookingService.prototype.loadRef = function () {
        if (this._serviceId) this.service = ServiceData.getById(this._serviceId);

        if (this._giftItemId) this.giftItem = GiftItemData.getById(this._giftItemId);

        for (var i = 0; i < this.subBookingServices.length; i++) {
            this.subBookingServices[i].loadRef();
        }
    };
    BookingService.prototype.getSubBookingServiceById = function (id) {
        for (var i = 0; i < this.subBookingServices.length; i++) {
            if (this.subBookingServices[i].id == id) return this.subBookingServices[i];
        }return null;
    };
    BookingService.prototype.copyDataTo = function (object) {

        //Call super function
        Activity.prototype.copyDataTo.call(this, object);

        //copy specifics fields
        object.price = this.price;
        object.idInBooking = this.idInBooking;
        object.originalPrice = this.originalPrice;
        object.discountPercent = this.discountPercent;
        object.hrRequest = this.hrRequest;
        object.isPackage = this.isPackage;

        if (this.service) object.serviceId = this.service.getId();else object.serviceId = null;

        if (this.booking) object.bookingId = this.booking.getId();else object.bookingId = null;

        object.secondariesDayHrs = [];
        object.secondariesDayHrsId = [];
        for (var i = 0; i < this.secondariesDayHrs.length; i++) {
            if (this.secondariesDayHrs[i].id) object.secondariesDayHrsId.push(this.secondariesDayHrs[i].id);else object.secondariesDayHrs.push(this.secondariesDayHrs[i].getObjectResourceCreatedByActivity());
        }
        object.secondariesDayPrs = [];
        object.secondariesDayPrsId = [];
        for (var i = 0; i < this.secondariesDayPrs.length; i++) {
            if (this.secondariesDayPrs[i].id) object.secondariesDayPrsId.push(this.secondariesDayPrs[i].id);else object.secondariesDayPrs.push(this.secondariesDayPrs[i].getObjectResourceCreatedByActivity());
        }

        if (this.cureItemToServiceUsage) object.cureItemToServiceUsage = this.cureItemToServiceUsage.getObjectResource();

        if (this.giftItem) object.giftItemId = this.giftItem.id;else object.giftItemId = null;

        object.subBookingServices = [];
        for (var i = 0; i < this.subBookingServices.length; i++) {
            object.subBookingServices.push(this.subBookingServices[i].getObjectResource());
        }
    };
    // Override  from Activity.getObjectResource
    BookingService.prototype.getObjectResource = function () {
        var bookingServiceRes = new BookingService_Resource();
        this.copyDataTo(bookingServiceRes);
        return bookingServiceRes;
    };
    BookingService.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
        if (this.subBookingServices != null && object.subBookingServices != null) for (var i = 0; i < this.subBookingServices.length; i++) {
            this.subBookingServices[i].setIdUsingObject(object.subBookingServices[i]);
        }
    };
    BookingService.prototype.setId = function (id) {
        if (this.id == null) this.id = id;
    };
    BookingService.prototype.setService = function (service) {
        this.service = service;
    };
    BookingService.prototype.getService = function () {
        return this.service;
    };
    BookingService.prototype.getId = function () {
        return this.id;
    };
    BookingService.prototype.getLabel = function () {
        return this.label;
    };
    BookingService.prototype.getPrice = function () {
        return this.price;
    };
    BookingService.prototype.getIsPackage = function () {
        return this.isPackage;
    };
    BookingService.prototype.addSecondaryDayHr = function (dayHr) {
        var index = this.secondariesDayHrs.indexOf(dayHr);
        if (index == -1) this.secondariesDayHrs.push(dayHr);
    };
    BookingService.prototype.removeSecondaryDayHr = function (dayHr) {
        var index = this.secondariesDayHrs.indexOf(dayHr);
        if (index != -1) this.secondariesDayHrs.splice(index, 1);
    };
    BookingService.prototype.addSecondaryDayPr = function (dayPr) {
        var index = this.secondariesDayPrs.indexOf(dayPr);
        if (index == -1) this.secondariesDayPrs.push(dayPr);
    };
    BookingService.prototype.removeSecondaryDayPr = function (dayPr) {
        var index = this.secondariesDayPrs.indexOf(dayPr);
        if (index != -1) this.secondariesDayPrs.splice(index, 1);
    };
    BookingService.prototype.addSubBs = function (bs) {
        if (bs) {
            var index = this.subBookingServices.indexOf(bs);
            if (index == -1) {
                this.subBookingServices.push(bs);
                bs.pkg = this;
            }
        }
    };
    BookingService.prototype.getHumanResource = function () {
        var humanResource = null;
        if (this.dayHr && this.dayHr.humanResourceId) {
            humanResource = HumanResourceData.getById(this.dayHr.humanResourceId);
        }
        return humanResource;
    };
    BookingService.prototype.getPhysicalResource = function () {
        var physicalResource = null;
        if (this.dayPr && this.dayPr.physicalResourceId) {
            physicalResource = PhysicalResourceData.getById(this.dayPr.physicalResourceId);
        }
        return physicalResource;
    };
    BookingService.prototype.getDiscountPrice = function (taxMode) {
        var price = 0;

        if (this.getBooking() && (this.getBooking().sale && this.getBooking().sale.isStatusSoldOrCreditOrCanceled() || !this.getBooking().sale)) {
            if (this.subBookingServices.length > 0) {
                for (var i = 0; i < this.subBookingServices.length; i++) {
                    price += this.subBookingServices[i].price;
                }
            } else {
                price = this.price;
            }

            if (taxMode === TaxMode.HT) {
                var defaultVat = VatData.getDefaultVat();
                price = price / (100 + defaultVat.tax) * 100;
            }
        } else {
            //there is a sale attach to the booking
            price = this.getCorrespondingSaleService().getDiscountPrice(taxMode);
        }

        return price;
    };

    BookingService.prototype.getCorrespondingSaleService = function () {
        var correspondingSaleService = null;
        if (this.getBooking() && this.getBooking().sale) {
            for (var i = 0; i < this.getBooking().bookingServices.length; i++) {
                if (!this.pkg) {
                    if (this.booking.bookingServices[i] === this && this.booking.sale.saleServices[i]) {
                        correspondingSaleService = this.booking.sale.saleServices[i];
                    }
                } else {
                    for (var j = 0; j < this.getBooking().bookingServices[i].subBookingServices.length; j++) {
                        if (this.getBooking().bookingServices[i].subBookingServices[j] === this && this.getBooking().sale.saleServices[i].subSaleServices[j]) {
                            correspondingSaleService = this.getBooking().sale.saleServices[i].subSaleServices[j];
                        }
                    }
                }
            }
        }
        return correspondingSaleService;
    };

    BookingService.prototype.getBooking = function () {
        var booking = this.booking;
        if (this.pkg) {
            booking = this.pkg.booking;
        }
        return booking;
    };

    BookingService.prototype.matchAllBookingObjects = function (bookingObjects, additionalFilters, firstDayOfPeriod) {
        var matchAllBookingObject = true,
            service = this.getService();

        for (var k = 0; k < bookingObjects.length; k++) {
            var bookingObject = bookingObjects[k],
                matchBookingObject = false;

            if (bookingObject instanceof HumanResource && this.dayHr && this.dayHr.humanResourceId === bookingObject.id || bookingObject instanceof PhysicalResource && this.dayPr && this.dayPr.physicalResourceId === bookingObject.id || bookingObject instanceof Category && service && service.isDescendantOf(bookingObject) || bookingObject instanceof Service && service && (service === bookingObject || bookingObject.isPackage && bookingObject.subServices.indexOf(service) !== -1) || bookingObject === RootStatCategorie || bookingObject === HrRootCategory || bookingObject === HrRootOccupationRateCategory || bookingObject === PrRootOccupationRateCategory || bookingObject === NbCustormerCategoryStat || bookingObject === NbCustormerCategoryStat.subCategories.MEN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'M' || bookingObject === NbCustormerCategoryStat.subCategories.WOMEN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'W' || bookingObject === NbCustormerCategoryStat.subCategories.CHILDREN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'C' || bookingObject === NbCustormerCategoryStat.subCategories.UNDEFINED_VISITS && this.getBooking().customer && this.getBooking().customer.gender === null || bookingObject === NbCustormerCategoryStat.subCategories.PASSENGER_VISITS && !this.getBooking().customer || bookingObject === TypeOfCustomerRootCategory || bookingObject === TypeOfCustomer.OLD_CUSTOMER && this.getBooking().customer && (this.getBooking().customer.hasSaleBefore(firstDayOfPeriod, this.getBooking()) || this.getBooking().customer.hasBookingBefore(firstDayOfPeriod)) || bookingObject === TypeOfCustomer.NEW_CUSTOMER && (!this.getBooking().customer || !this.getBooking().customer.hasSaleBefore(firstDayOfPeriod, this.getBooking()) && !this.getBooking().customer.hasBookingBefore(firstDayOfPeriod)) || bookingObject === TypeOfBooking.COME_AND_NOT_COME || bookingObject === TypeOfBooking.COME && this.getBooking().status !== 'notCame' || bookingObject === TypeOfBooking.NOT_COME && this.getBooking().status === 'notCame' || bookingObject === TypeOfBooking.CREATE_BY_CUSTORMER_AND_NOT || bookingObject === TypeOfBooking.CREATE_BY_CUSTORMER && this.getBooking().isCreatedByCustomer || bookingObject === TypeOfBooking.NOT_CREATE_BY_CUSTOMER && !this.getBooking().isCreatedByCustomer || bookingObject === TypeOfBooking.CREATE_BY_RWG && this.getBooking().checkBookingCreator(BookingCreator.RWG.key) || bookingObject === TypeOfBooking.CREATE_BY_WEBSITE && this.getBooking().isCreatedByCustomer && !this.getBooking().checkBookingCreator(BookingCreator.RWG.key)) {
                matchBookingObject = true;
            }
            matchAllBookingObject = matchAllBookingObject && matchBookingObject;
        }

        var matchOneAdditionalFilter = false;

        for (var _k = 0; _k < additionalFilters.length; _k++) {
            var additionalFilter = additionalFilters[_k],
                matchAdditionalFilter = false;

            if (additionalFilter === NbCustormerCategoryStat.subCategories.MEN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'M' || additionalFilter === NbCustormerCategoryStat.subCategories.WOMEN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'W' || additionalFilter === NbCustormerCategoryStat.subCategories.CHILDREN_VISITS && this.getBooking().customer && this.getBooking().customer.gender === 'C' || additionalFilter instanceof HumanResource && this.humanResource === additionalFilter) {

                matchAdditionalFilter = true;
            }
            matchOneAdditionalFilter = matchOneAdditionalFilter || matchAdditionalFilter;
        }

        return matchAllBookingObject && (matchOneAdditionalFilter || additionalFilters.length === 0);
    };

    BookingService.prototype.incrementBookingDatas = function (bookingDatas, bookingObjects, additionalFilters, firstDayOfPeriod, taxMode, currentDay) {
        if (this.matchAllBookingObjects(bookingObjects, additionalFilters, firstDayOfPeriod)) {

            for (var k = 0; k < bookingObjects.length; k++) {
                var bookingObject = bookingObjects[k];

                if (bookingObject instanceof HumanResource) {
                    bookingDatas.humanResource = bookingObject;
                    break;
                }
            }
            if (this.getBooking() != null) {
                if (bookingDatas.bookings.indexOf(this.getBooking()) === -1) {
                    bookingDatas.bookings.push(this.getBooking());

                    var priceTTC = this.getBooking().price - this.getBooking().price / 100 * this.getBooking().discountPercent;

                    if (taxMode === TaxMode.HT) {
                        bookingDatas.price += priceTTC / (100 + VatData.getDefaultVat().tax) * 100;
                    } else {
                        bookingDatas.price += priceTTC;
                    }
                }

                if (this.getBooking().status !== 'notCame') {
                    if (this.pkg && bookingDatas.subBookings.indexOf(this.pkg) === -1) {
                        bookingDatas.subBookings.push(this.pkg);
                    } else if (!this.pkg) {
                        bookingDatas.subBookings.push(this);
                    }

                    bookingDatas.subBookingsStep.push(this);
                }

                if (firstDayOfPeriod) {
                    if (this.getBooking().status !== 'notCame' && this.getBooking().customer) {
                        var salesOfPeriod = this.getBooking().customer.getLoyaltySalesOfPeriod(firstDayOfPeriod, currentDay, bookingDatas.humanResource ? bookingDatas.humanResource.id : null, this.getBooking()),
                            bookingsOfPeriod = this.getBooking().customer.getLoyaltyBookingsOfPeriod(firstDayOfPeriod, currentDay, bookingDatas.humanResource ? bookingDatas.humanResource.id : null);

                        if (salesOfPeriod.length > 0 || bookingsOfPeriod.length > 0) {
                            if (bookingDatas.loyaltyCustormers.indexOf(this.getBooking().customer) === -1) {
                                bookingDatas.loyaltyCustormers.push(this.getBooking().customer);
                            }
                        } else {
                            bookingDatas.customersFirstVisit.push(this.getBooking().customer);
                        }
                    }
                }

                if (this.getBooking().status !== 'notCame' && this.getBooking().customer) {
                    if (bookingDatas.customers.indexOf(this.getBooking().customer) == -1) {
                        bookingDatas.customers.push(this.getBooking().customer);
                    }

                    if (this.getBooking().status !== 'notCame' && (!this.getBooking().sale || this.getBooking().sale && this.getBooking().sale.status !== 'canceled' && this.getBooking().sale.status !== 'credit' && this.getBooking().sale.day && this.getBooking().day && firstDayOfPeriod && (this.getBooking().sale.day.id >= this.getBooking().day.id || this.getBooking().sale.day.id < firstDayOfPeriod.id))) {
                        if (bookingDatas.customersBookings.indexOf(this.getBooking().customer) == -1) {
                            bookingDatas.customersBookings.push(this.getBooking().customer);
                            if (!this.getBooking().customer.hasSaleBetween(firstDayOfPeriod, currentDay, this.getBooking()) && !this.getBooking().customer.hasBookingBetween(firstDayOfPeriod, currentDay)) {
                                bookingDatas.customersFirstBookings.push(this.getBooking().customer);
                            }

                            if (!this.getBooking().customer.hasSaleBetween(firstDayOfPeriod, currentDay, this.getBooking(), bookingObjects, additionalFilters, currentDay) && !this.getBooking().customer.hasBookingBetween(firstDayOfPeriod, currentDay, null, bookingObjects, additionalFilters, currentDay)) {
                                bookingDatas.customersFirstBookingsOfBookingObject.push(this.getBooking().customer);
                            }
                        }
                    }
                } else {
                    if (this.getBooking().status !== 'notCame' && bookingDatas.matchedBookingsOfPassageCustomer.indexOf(this.getBooking()) === -1) {
                        bookingDatas.matchedBookingsOfPassageCustomer.push(this.getBooking());
                    }
                }
            }
        }
    };

    return BookingService;
}]);

angular.module('FlexyBeautyApp.services').factory('BookingServiceSrv', ["$log", "ServerSrv", "DayData", "ActivityData", "BookingService", "WorkingPeriodDayHrData", "WorkingPeriodDayPrData", "DayHrData", "DayPrData", "ActivitySrv", "BookingData", function ($log, ServerSrv, DayData, ActivityData, BookingService, WorkingPeriodDayHrData, WorkingPeriodDayPrData, DayHrData, DayPrData, ActivitySrv, BookingData) {
    var bsSrv = {};

    bsSrv.save = function (bookingService, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bsSrv.saveSync, bookingService, successFunction, errorFunction);
    };
    bsSrv.saveSync = function (bookingService, successFunction, errorFunction) {
        //$timeout (function () {

        var bsRes = bookingService.getObjectResource();
        bsRes.$save({}, //no params
        function (data) {
            //Save on server success :
            // -> set id for new entity and subones
            // -> add an user action (send message)

            try {
                // now we can set the id
                bookingService.setId(data.id);

                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null, "BookingService.saveSync - Error on save and server call queue not empty");
            }
        });

        //},2000)
    };

    bsSrv.updateLocallyOnDay = function (resource, bookingService) {
        if (bookingService.secondariesDayHrs) {
            for (var k = 0; k < bookingService.secondariesDayHrs.length; k++) {
                bookingService.secondariesDayHrs[k].removeActivity(bookingService);
            }
            bookingService.secondariesDayHrs = [];
        }
        if (bookingService.secondariesDayPrs) {
            for (var _k2 = 0; _k2 < bookingService.secondariesDayPrs.length; _k2++) {
                bookingService.secondariesDayPrs[_k2].removeActivity(bookingService);
            }
            bookingService.secondariesDayPrs = [];
        }
        ActivitySrv.updateLocally(resource.id, resource);
        if (resource.secondariesDayHrsId) {
            for (var _k3 = 0; _k3 < resource.secondariesDayHrsId.length; _k3++) {
                var secondaryDayHr = DayHrData.getById(resource.secondariesDayHrsId[_k3]);
                if (secondaryDayHr) {
                    secondaryDayHr.addActivity(bookingService, false);
                } else {
                    console.log("BookingService.updateLocallyOnDay - SecondaryDayHr not found given ID - SecondaryDayHr ID: " + resource.secondariesDayHrsId);
                }
            }
        }
        if (resource.secondariesDayPrsId) {
            for (var _k4 = 0; _k4 < resource.secondariesDayPrsId.length; _k4++) {
                var secondaryDayPr = DayPrData.getById(resource.secondariesDayPrsId[_k4]);
                if (secondaryDayPr) {
                    secondaryDayPr.addActivity(bookingService, false);
                } else {
                    console.log("BookingService.updateLocallyOnDay - SecondaryDayPr not found given ID - SecondaryDayPr ID: " + resource.secondariesDayPrsId);
                }
            }
        }
    };

    bsSrv.updateLocally = function (id, resource) {
        if (!resource.pkgId) {
            // subBs managed by pkg
            //not specific code to manage update/remove from booking because this link is change only for a add or delete
            // (a bookingService can't be moved to another booking)
            var bookingService = ActivityData.getById(id);
            if (bookingService != null) {
                if (bookingService.version && resource.version && resource.version <= bookingService.version) {
                    return null;
                }
                bsSrv.updateLocallyOnDay(resource, bookingService);
                for (var i = 0; i < resource.subBookingServices.length; i++) {
                    bsSrv.updateLocallyOnDay(resource.subBookingServices[i], bookingService.subBookingServices[i]); // subBs on Days
                }
            } else {
                console.log("BookingService.updateLocally - Model not found given ID - BookingService ID: " + id);
            }
            return bookingService;
        } else {
            return null;
        }
    };

    bsSrv.removeLocally = function (id, resource) {
        if (!resource.pkgId) {
            // subBs managed by pkg
            var bookingService = ActivityData.getById(id);
            if (bookingService != null) {
                if (bookingService.version && resource.version && resource.version <= bookingService.version) {
                    return null;
                }

                if (bookingService.workingPeriodDayHr) {
                    bookingService.workingPeriodDayHr.removeActivity(bookingService);
                }
                if (bookingService.dayHr) {
                    bookingService.dayHr.removeActivity(bookingService);
                }
                if (bookingService.workingPeriodDayPr) {
                    bookingService.workingPeriodDayPr.removeActivity(bookingService);
                }
                if (bookingService.dayPr) {
                    bookingService.dayPr.removeActivity(bookingService);
                }

                for (var k = 0; k < bookingService.secondariesDayHrs.length; k++) {
                    bookingService.secondariesDayHrs[k].removeActivity(bookingService);
                }
                for (var _k5 = 0; _k5 < bookingService.secondariesDayPrs.length; _k5++) {
                    bookingService.secondariesDayPrs[_k5].removeActivity(bookingService);
                }
                //remove from booking
                if (bookingService.booking) {
                    bookingService.booking.removeBookingService(bookingService);
                } else {
                    console.log("BookingService.removeLocally - bookingService.booking is null - BookingService ID: " + id);
                }
            } else {
                console.log("BookingService.removeLocally - Model not found given ID - BookingService ID: " + id);
            }
            return bookingService;
        } else {
            return null;
        }
    };

    bsSrv.addLocallyOnDay = function (resource, bookingService) {
        if (resource.dayHrId) {
            var dayHr = DayHrData.getById(resource.dayHrId);
            if (dayHr) {
                dayHr.addActivity(bookingService, true);
            } else {
                console.log("BookingService.addLocallyOnDay - DayHr not found given ID - DayHr ID: " + resource.dayHrId);
            }
        } else if (resource.workingPeriodDayHrId) {
            var workingPeriodDayHr = WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
            if (workingPeriodDayHr) {
                workingPeriodDayHr.addActivity(bookingService);
            } else {
                console.log("BookingService.addLocallyOnDay - WorkingPeriodDayHr not found given ID - WorkingPeriodDayHr ID: " + resource.workingPeriodDayHrId);
            }
        }
        if (resource.dayPrId) {
            var dayPr = DayPrData.getById(resource.dayPrId);
            if (dayPr) {
                dayPr.addActivity(bookingService, true);
            } else {
                console.log("BookingService.addLocallyOnDay - DayPr not found given ID - DayPr ID: " + resource.dayPrId);
            }
        } else if (resource.workingPeriodDayPrId) {
            var workingPeriodDayPr = WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);
            if (workingPeriodDayPr) {
                workingPeriodDayPr.addActivity(bookingService);
            } else {
                console.log("BookingService.addLocallyOnDay - WorkingPeriodDayPr not found given ID - WorkingPeriodDayPr ID: " + resource.workingPeriodDayPrId);
            }
        }
        if (resource.secondariesDayHrsId) {
            for (var k = 0; k < resource.secondariesDayHrsId.length; k++) {
                var secondaryDayHr = DayHrData.getById(resource.secondariesDayHrsId[k]);
                if (secondaryDayHr) {
                    secondaryDayHr.addActivity(bookingService, false);
                } else {
                    console.log("BookingService.addLocallyOnDay - SecondaryDayHr not found given ID - SecondaryDayHr ID: " + resource.secondariesDayHrsId[k]);
                }
            }
        }
        if (resource.secondariesDayPrsId) {
            for (var _k6 = 0; _k6 < resource.secondariesDayPrsId.length; _k6++) {
                var secondaryDayPr = DayPrData.getById(resource.secondariesDayPrsId[_k6]);
                if (secondaryDayPr) {
                    secondaryDayPr.addActivity(bookingService, false);
                } else {
                    console.log("BookingService.addLocallyOnDay - SecondaryDayPr not found given ID - SecondaryDayPr ID: " + resource.secondariesDayPrsId[_k6]);
                }
            }
        }
    };

    bsSrv.addLocally = function (id, resource) {
        if (!resource.pkgId) {
            // subBs managed by pkg
            var bookingService = ActivityData.getById(id);
            if (bookingService && bookingService.version && resource.version && resource.version <= bookingService.version) {
                return null;
            }

            if (bookingService != null) {
                //check if resource already exist inside index (current action could be a 'cancel')
                console.log("BookingService.addLocallyOnDay - Model already exists - BookingService ID: " + id);
                bookingService.loadObject(resource);
            } else {
                bookingService = new BookingService(resource);
                bookingService.id = id;
            }
            bookingService.loadRef();

            bsSrv.addLocallyOnDay(resource, bookingService);
            for (var i = 0; i < resource.subBookingServices.length; i++) {
                bsSrv.addLocallyOnDay(resource.subBookingServices[i], bookingService.subBookingServices[i]); // subBs on Days
            }
            //add to booking
            if (resource.bookingId && !resource.pkgId) {
                var booking = BookingData.getById(resource.bookingId);
                if (booking) {
                    booking.addBookingService(bookingService);
                } else {
                    console.log("BookingService.addLocallyOnDay - Booking not found given ID in resource - Booking ID: " + resource.bookingId);
                }
            }
            return bookingService;
        } else {
            return null;
        }
    };

    bsSrv.loadPreviousVersionInstanceOnPage = function (resource, bookingService) {
        if (resource.dayHrId) bookingService.dayHr = DayHrData.getById(resource.dayHrId);else if (resource.workingPeriodDayHrId) bookingService.workingPeriodDayHr = WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
        if (resource.dayPrId) bookingService.dayPr = DayPrData.getById(resource.dayPrId);else if (resource.workingPeriodDayPrId) bookingService.workingPeriodDayPr = WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);

        for (var k = 0; k < resource.secondariesDayHrsId.length; k++) {
            bookingService.addSecondaryDayHr(DayHrData.getById(resource.secondariesDayHrsId[k]));
        }for (var k = 0; k < resource.secondariesDayPrsId.length; k++) {
            bookingService.addSecondaryDayPr(DayPrData.getById(resource.secondariesDayPrsId[k]));
        }if (resource.bookingId) bookingService.booking = BookingData.getById(resource.bookingId);
    };
    bsSrv.getPreviousVersionInstance = function (resource) {
        var bookingService = new BookingService(resource, true);
        bsSrv.loadPreviousVersionInstanceOnPage(resource, bookingService);
        for (var i = 0; i < resource.subBookingServices.length; i++) {
            bsSrv.loadPreviousVersionInstanceOnPage(resource.subBookingServices[i], bookingService.subBookingServices[i]);
        } // subBs on Days
        return bookingService;
    };

    return bsSrv;
}]);

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Category_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/categories/:id', {}, {
        query: { method: 'GET', isArray: false },
        getTree: { method: 'GET', isArray: false, url: baseUrl + 'rest/categories/tree' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/categories/deleted' },
        duplicateCategory: { method: 'GET', isArray: false, url: baseUrl + 'rest/categories/duplicate/:id' },
        countCurrentServices: { method: 'GET', isArray: false, url: baseUrl + 'rest/categories/count-current-services' },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Category', ["Category_Resource", "Service", "CategoryData", "ServiceData", "ImageData", "CompanyImageData", "HrRootCategory", function (Category_Resource, Service, CategoryData, ServiceData, ImageData, CompanyImageData, HrRootCategory) {
    var Category = function Category(rsCategory, parentCategory) {
        this.id = null;
        this.isDeleted;
        this.label = "";
        this.description = "";
        this.image = null;
        this.companyImage = null;
        this.specificImage; //boolean
        this.isVisibleOnWebSite;
        this.style = "";
        this.displayType = null;

        this.services = [];
        this.categories = [];
        this.version = null;

        if (parentCategory !== undefined && parentCategory != null) this.parentCategory = parentCategory;

        if (rsCategory !== undefined && rsCategory != null) {
            var service, category;
            if (!this.id) this.id = rsCategory.id;
            this.isDeleted = rsCategory.isDeleted;
            this.label = rsCategory.label;
            this.description = rsCategory.description;
            this.imageId = rsCategory.imageId;
            this.companyImageId = rsCategory.companyImageId;
            this.specificImage = rsCategory.specificImage;
            this.isVisibleOnWebSite = rsCategory.isVisibleOnWebSite;
            this.parentCategoryId = rsCategory.parentCategoryId;
            this.style = rsCategory.style;
            if (rsCategory.displayType) this.displayType = rsCategory.displayType;
            if (rsCategory.version) this.version = rsCategory.version;
            if (rsCategory.categories) for (var i = 0; i < rsCategory.categories.length; i++) {
                category = new Category(rsCategory.categories[i], this);
                this.categories.push(category);
            }

            if (rsCategory.services) for (var j = 0; j < rsCategory.services.length; j++) {
                service = new Service(rsCategory.services[j], this);
                this.services.push(service);
            }
        }
        CategoryData.add(this);
    };

    Category.prototype.loadObject = function (object, parentCategory) {
        this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.label = object.label;
        this.description = object.description;
        this.style = object.style;
        if (object.displayType) this.displayType = object.displayType;
        this.specificImage = object.specificImage;
        this.isVisibleOnWebSite = object.isVisibleOnWebSite;
        if (object.version) this.version = object.version;
        if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }

        //load ref from ids
        if (object.servicesId) {
            var newServices = [];
            for (var i = 0; i < object.servicesId.length; i++) {
                var service = ServiceData.getById(object.servicesId[i]);
                if (service != null) newServices.push(service);
            }
            this.services = newServices;
        }
        if (object.categoriesId) {
            var newCategories = [];
            for (i = 0; i < object.categoriesId.length; i++) {
                var category = CategoryData.getById(object.categoriesId[i]);
                if (category != null) newCategories.push(category);
            }
            this.categories = newCategories;
        }
    };
    Category.prototype.getObjectResource = function () {
        var rsCategory = new Category_Resource();
        rsCategory.id = this.id;
        rsCategory.isDeleted = this.isDeleted;
        rsCategory.label = this.label;
        rsCategory.description = this.description;
        if (this.image) rsCategory.imageId = this.image.id;
        if (this.companyImage) rsCategory.companyImageId = this.companyImage.id;
        rsCategory.specificImage = this.specificImage;
        rsCategory.isVisibleOnWebSite = this.isVisibleOnWebSite;
        rsCategory.style = this.style;
        if (this.displayType) rsCategory.displayType = this.displayType;

        if (this.parentCategory) rsCategory.parentCategoryId = this.parentCategory.getId();
        rsCategory.categoriesId = [];
        for (var i = 0; i < this.categories.length; i++) {
            rsCategory.categoriesId.push(this.categories[i].getId());
        }rsCategory.servicesId = [];
        for (var i = 0; i < this.services.length; i++) {
            rsCategory.servicesId.push(this.services[i].getId());
        }return rsCategory;
    };
    Category.prototype.getId = function () {
        return this.id;
    };
    Category.prototype.setId = function (id) {
        this.id = id;
    };
    Category.prototype.getLabel = function () {
        return this.label;
    };
    Category.prototype.addService = function (service) {
        if (service) {
            var index = this.services.indexOf(service);
            if (index == -1) //Not already there
                {
                    this.services.push(service);
                    service.parentCategory = this;
                }
        }
    };
    Category.prototype.removeService = function (service) {
        var index = this.services.indexOf(service);
        if (index != -1) //Found
            {
                this.services.splice(index, 1);
            }
    };
    Category.prototype.addCategory = function (category) {
        if (category) {
            var index = this.categories.indexOf(category);
            if (index == -1) //Not already there
                {
                    this.categories.push(category);
                    category.parentCategory = this;
                }
        }
    };
    Category.prototype.removeCategory = function (category) {
        var index = this.categories.indexOf(category);
        if (index != -1) //Found
            {
                this.categories.splice(index, 1);
            }
    };
    Category.prototype.changeServicePosition = function (service, indexTarget) {
        //Change the service position
        var index = this.services.indexOf(service);
        if (indexTarget != -1 && index != -1 && indexTarget != index && this.services && indexTarget < this.services.length) {
            var cat = this.services[indexTarget];

            this.services.splice(index, 1);
            if (index < indexTarget) indexTarget--;
            this.services.splice(indexTarget, 0, service);
        }
    };
    Category.prototype.getServiceById = function (serviceId) {
        //recursive research
        var service = null;
        for (var j = 0; j < this.services.length; j++) {
            if (this.services[j].id == serviceId) return this.services[j];
        }for (var z = 0; z < this.categories.length && !service; z++) {
            service = this.categories[z].getServiceById(serviceId);
        }return service;
    };
    Category.prototype.getServiceByLabel = function (serviceLabel) {
        //recursive research, need lower case input
        var service = null;
        for (var j = 0; j < this.services.length; j++) {
            if (this.services[j].label.toLowerCase() == serviceLabel) return this.services[j];
        }for (var z = 0; z < this.categories.length && !service; z++) {
            service = this.categories[z].getServiceByLabel(serviceLabel);
        }return service;
    };
    Category.prototype.getCategoryById = function (categoryId) {
        //recursive research
        var category = null;
        for (var z = 0; z < this.categories.length && !category; z++) {
            if (this.categories[z].id == categoryId) category = this.categories[z];else category = this.categories[z].getCategoryById(categoryId);
        }return category;
    };
    Category.prototype.loadRef = function () {
        if (this.imageId) this.image = ImageData.getById(this.imageId);
        if (this.companyImageId) this.companyImage = CompanyImageData.getById(this.companyImageId);
        if (this.parentCategory == null && this.parentCategoryId) this.parentCategory = CategoryData.getById(this.parentCategoryId);
    };
    Category.prototype.getSubStatCategories = function (rootCategory) {
        return this.categories.concat(this.services);
    };

    Category.prototype.isDescendantOf = function (category) {
        var isDescendantOf = false;
        if (this.parentCategory === category) {
            isDescendantOf = true;
        } else {
            if (this.parentCategory) {
                isDescendantOf = this.parentCategory.isDescendantOf(category);
            }
        }

        return isDescendantOf;
    };

    return Category;
}]);

angular.module('FlexyBeautyApp.services').factory('CategorySrv', ["Category_Resource", "Category", "CategoryData", "UserActionData", "ServiceSrv", "$log", "ServerSrv", "Constants", function (Category_Resource, Category, CategoryData, UserActionData, ServiceSrv, $log, ServerSrv, Constants) {
    //$timeout (function () {

    var categorySrv = {};
    categorySrv.query = function (successFunction, errorFunction) {
        var treeLoaded = false;
        var deletedLoaded = false;
        Category_Resource.getTree({}, //params
        function (data) {
            //success
            CategoryData.categoryRoot = new Category(data);

            if (successFunction !== undefined && deletedLoaded) successFunction(CategoryData.categoryRoot);
            treeLoaded = true;
        }, function (data) {
            //failure
            $log.error("Category_Resource.getTree error");
            $log.error(data);
            if (errorFunction !== undefined && deletedLoaded) errorFunction(data);
            treeLoaded = true;
        });
        Category_Resource.getDeleted({}, //params
        function (data) {
            //success
            CategoryData.deletedCategories = [];
            for (var i = 0; i < data.length; i++) {
                new Category(data[i]);
            } //Auto Add to CategoryData

            if (successFunction !== undefined && treeLoaded) successFunction(CategoryData.categoryRoot);
            deletedLoaded = true;
        }, function (data) {
            //failure
            $log.error("Category_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined && treeLoaded) errorFunction(data);
            deletedLoaded = true;
        });
    };
    categorySrv.duplicateCategory = function (category, successFunction, errorFunction) {
        Category_Resource.duplicateCategory({ id: category.id }, function (data) {
            if (successFunction) {
                successFunction(data);
            }
        }, function () {
            if (errorFunction !== undefined) {
                errorFunction();
            }
        });
    };
    categorySrv.countCurrentServices = function (successFunction, errorFunction) {
        Category_Resource.countCurrentServices(function (data) {
            if (successFunction && data && data.numberOfCurrentServices < Constants.MAX_SERVICES_FOR_COMPANY) {
                successFunction();
            } else if (errorFunction) {
                errorFunction(data, MAX_SERVICES_FOR_COMPANY);
            }
        });
    };
    categorySrv.save = function (category, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(categorySrv.saveSync, category, successFunction, errorFunction);
    };
    categorySrv.saveSync = function (category, successFunction, errorFunction) {
        //$timeout (function () {

        var CategoryRes = category.getObjectResource();
        CategoryRes.$save({}, //no params
        function (data) {

            try {
                category.setId(data.id);
                //TODO  UserActionData.add(data.userAction);
                if (successFunction) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    categorySrv.remove = function (category, successFunction, errorFunction) {
        CategoryData.remove(category);
        ServerSrv.startSavingProcess(categorySrv.removeSync, category, successFunction, errorFunction);
    };
    categorySrv.removeSync = function (category, successFunction, errorFunction) {
        //$timeout (function () {

        var categoryRes = new Category_Resource();
        categoryRes.$remove({ id: category.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    categorySrv.restore = function (category, successFunction, errorFunction) {
        CategoryData.restore(category);
        ServerSrv.startSavingProcess(categorySrv.restoreSync, category, successFunction, errorFunction);
    };
    categorySrv.restoreSync = function (category, successFunction, errorFunction) {
        //$timeout (function () {

        var categoryRes = category.getObjectResource();
        categoryRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    categorySrv.getCategoryOnServer = function (scope, targetName, categoryId) {

        var category = null;
        if (CategoryData.categoryRoot.categories != null && CategoryData.categoryRoot.categories.length > 0) {
            for (var i = 0; i < CategoryData.categoryRoot.categories.length && !category; i++) {
                if (CategoryData.categoryRoot.categories[i].getId() == categoryId) category = CategoryData.categoryRoot.categories[i];else for (var j = 0; j < CategoryData.categoryRoot.categories[i].categories.length && !category; j++) {
                    if (CategoryData.categoryRoot.categories[i].categories[j].getId() == categoryId) category = CategoryData.categoryRoot.categories[i].categories[j];
                }
            }scope[targetName] = category;
        } else {

            Category_Resource.get({ id: categoryId }, function (categoryRes) {
                //success
                var bookingServices = [];

                scope[targetName] = new Category(categoryRes);
            }, function (categoryRes) {//failure
                //error handling goes here
            });
        }
    };
    categorySrv.get = function (categoryId) {
        //TODO
        return null;
    };
    categorySrv.getServiceById = function (serviceId) {
        if (CategoryData.categoryRoot != null) return CategoryData.categoryRoot.getService(serviceId);
    };
    categorySrv.loadRef = function () {
        var categories = CategoryData.indexCategories;
        for (var i = 0; i < categories.length; i++) {
            categories[i].loadRef();
        }
    };
    categorySrv.moveService = function (category, service) {
        if (category) {
            category.moveService(service);
            ServiceSrv.save(service);
        }
    };
    categorySrv.updateLocally = function (object) {
        var category = null;
        var parentCategory = null;
        if (object.parentCategoryId) //Optimization : get parent if exist
            {
                parentCategory = CategoryData.getById(object.parentCategoryId);
                if (parentCategory != null) category = parentCategory.getCategoryById(object.id);
            } else category = CategoryData.getById(object.id);
        if (category != null) category.loadObject(object, parentCategory);
    };
    categorySrv.addLocally = function (object) {
        //TODO
        /*            var category = CategoryData.getCategory(object.parentCategoryId);
                    if (category!=null)
                        category.addService(new Service(object,category));*/

    };
    categorySrv.removeLocally = function (object) {
        //TODO
        /*            var service =  null;
                    var category = CategoryData.getCategory(object.parentCategoryId);
                    if (category!=null)
                        service = category.getService(object.id)
                    if (service!=null)
                        category.removeService(service);*/
    };

    return categorySrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CategoryData', ["$log", function ($log) {
    var categoryData = {
        categoryRoot: null,
        indexCategories: [], //Used as Index
        deletedCategories: []
    };
    categoryData.getById = function (categoryId) {
        for (var i = 0; i < this.indexCategories.length; i++) {
            if (this.indexCategories[i].id == categoryId) return this.indexCategories[i];
        }return null;
    };
    categoryData.getByIndex = function (catIndex) {
        if (catIndex >= 0 && catIndex < this.indexCategories.length) return this.indexCategories[catIndex];else return null;
    };
    categoryData.getIndexOf = function (category) {
        if (category) return this.indexCategories.indexOf(category);
        return -1;
    };
    categoryData.add = function (category) {
        this.indexCategories.push(category);
        if (category.isDeleted) {
            var index = this.deletedCategories.indexOf(category);
            if (index == -1) this.deletedCategories.push(category);
        }
        return this.indexCategories.length - 1;
    };
    categoryData.remove = function (category) //Soft Remove
    {
        var index = this.deletedCategories.indexOf(category);
        if (index == -1) {
            this.deletedCategories.push(category);
            category.isDeleted = true;
        }
    };
    categoryData.restore = function (category) //Soft Remove
    {
        var index = this.deletedCategories.indexOf(category);
        if (index != -1) {
            this.deletedCategories.splice(index, 1);
            category.isDeleted = false;
        }
    };
    categoryData.clear = function () {
        categoryData.categoryRoot = null;
        categoryData.indexCategories = [];
        categoryData.deletedCategories = [];
    };
    categoryData.loaded = function () {
        return categoryData.categoryRoot != null;
    };
    categoryData.getDeletedList = function () {
        return categoryData.deletedCategories;
    };

    return categoryData;
}]);

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('CheckDeposit_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceCheckDeposits = $resource(baseUrl + 'rest/checkDeposits/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceCheckDeposits;
}]);

angular.module('FlexyBeautyApp.services').factory('CheckDeposit', ["CheckDeposit_Resource", "ProductCategoryData", "ProductData", "CheckDepositData", "HumanResourceData", function (CheckDeposit_Resource, ProductCategoryData, ProductData, CheckDepositData, HumanResourceData) {
    //CheckDeposit inherit from Activity
    var CheckDeposit = function CheckDeposit(checkDepositRes, isPreviousVersion) {
        this.id = null;
        this.cdNumber = null;
        this.bankDate = null;
        this.status = null;
        this.description = null;
        this.humanResource = null;
        this.timeCreated = new Date();
        this.salePayments = [];
        this.version = null;
        this.loadObject(checkDepositRes);
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            CheckDepositData.add(this);
    };

    CheckDeposit.prototype.loadObject = function (object) {

        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.status = object.status;
            if (object.bankDate) this.bankDate = new Date(object.bankDate);
            this.cdNumber = object.cdNumber;
            this.description = object.description;
            if (object.timeCreated) this.timeCreated = new Date(object.timeCreated);
            if (object.humanResourceId) this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.version) this.version = object.version;
        }
    };
    CheckDeposit.prototype.copyDataTo = function (object) {

        object.id = this.id;
        object.status = this.status;
        object.cdNumber = this.cdNumber;
        object.description = this.description;
        object.bankDate = this.bankDate;

        if (this.humanResource) object.humanResourceId = this.humanResource.id;
    };
    CheckDeposit.prototype.addSalePayment = function (sale, payment) {
        this.salePayments.push({ sale: sale, payment: payment });
    };

    CheckDeposit.prototype.getObjectResource = function () {
        var checkDepositRes = new CheckDeposit_Resource();
        this.copyDataTo(checkDepositRes);
        return checkDepositRes;
    };
    CheckDeposit.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };
    CheckDeposit.prototype.setId = function (id) {
        this.id = id;
    };
    CheckDeposit.prototype.getId = function () {
        return this.id;
    };
    CheckDeposit.prototype.getLabel = function () {
        return this.label;
    };

    return CheckDeposit;
}]);

angular.module('FlexyBeautyApp.services').factory('CheckDepositSrv', ["$log", "ServerSrv", "CheckDepositData", "CheckDeposit", "CheckDeposit_Resource", function ($log, ServerSrv, CheckDepositData, CheckDeposit, CheckDeposit_Resource) {
    var bpSrv = {};

    bpSrv.query = function (successFunction, errorFunction) {
        CheckDeposit_Resource.query({}, //params
        function (data) {
            //success
            CheckDepositData.clear();
            for (var i = 0; i < data.length; i++) {
                new CheckDeposit(data[i], false);
            } //Auto Add to CheckDepositData
            if (successFunction !== undefined) successFunction(CheckDepositData.getActiveList());
        }, function (data) {
            //failure
            $log.error("CheckDeposit_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    bpSrv.save = function (checkDeposit, salePaymentsToRemove, salePaymentsToAdd, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bpSrv.saveSync, checkDeposit, salePaymentsToRemove, salePaymentsToAdd, successFunction, errorFunction);
    };
    bpSrv.saveSync = function (checkDeposit, salePaymentsToRemove, salePaymentsToAdd, successFunction, errorFunction) {
        var bsRes = checkDeposit.getObjectResource();
        bsRes.salePaymentsToRemove = salePaymentsToRemove;
        bsRes.salePaymentsToAdd = salePaymentsToAdd;
        bsRes.$save({}, //no params
        function (upRes) {
            try {
                // now we can set the id
                checkDeposit.setId(upRes.id);
                if (!checkDeposit.version || upRes.version && upRes.version > checkDeposit.version) checkDeposit.version = upRes.version;
                if (upRes.timeCreated) checkDeposit.timeCreated = new Date(upRes.timeCreated);

                if (upRes.cdNumber) checkDeposit.cdNumber = upRes.cdNumber;
                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(upRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    bpSrv.updateLocally = function (id, resource) {
        var checkDeposit = CheckDepositData.getById(id);

        if (checkDeposit && checkDeposit.version && resource.version && resource.version < checkDeposit.version) return null;

        if (checkDeposit != null) checkDeposit.loadObject(resource);

        return checkDeposit;
    };
    bpSrv.removeLocally = function (id, resource) {
        return CheckDepositData.getById(id);
    };
    bpSrv.addLocally = function (id, resource) {
        var checkDeposit = CheckDepositData.getById(id);
        if (checkDeposit != null) //check if resource already exist inside index (current action could be a 'cancel')
            checkDeposit.loadObject(resource);else {
            checkDeposit = new CheckDeposit(resource);
            checkDeposit.id = id;
        }
        return checkDeposit;
    };
    bpSrv.getPreviousVersionInstance = function (resource) {
        var checkDeposit = new CheckDeposit(resource, true);
        return checkDeposit;
    };

    return bpSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CheckDepositData', ["$log", function ($log) {
    var checkDepositData = {
        indexCheckDeposits: []
    };

    checkDepositData.getById = function (checkDepositId) {
        for (var i = 0; i < this.indexCheckDeposits.length; i++) {
            if (this.indexCheckDeposits[i].id == checkDepositId) return this.indexCheckDeposits[i];
        }return null;
    };

    checkDepositData.getIndexOf = function (checkDeposit) {
        if (checkDeposit) return this.indexCheckDeposits.indexOf(checkDeposit);
        return -1;
    };

    checkDepositData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexCheckDeposits.length) return this.indexCheckDeposits[index];else return null;
    };

    checkDepositData.add = function (checkDeposit) {
        this.indexCheckDeposits.push(checkDeposit);
        return this.indexCheckDeposits.length - 1;
    };

    checkDepositData.clear = function () {
        checkDepositData.indexCheckDeposits = [];
    };

    checkDepositData.getActiveList = function () {
        return this.indexCheckDeposits;
    };

    checkDepositData.clearSalePayments = function () {
        this.indexCheckDeposits.forEach(function (checkDeposit) {
            return checkDeposit.salePayments = [];
        });
    };

    return checkDepositData;
}]);

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('Closure_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/closure/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        open: { method: 'POST', url: baseUrl + 'rest/closure/open' },
        close: { method: 'POST', url: baseUrl + 'rest/closure/close' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Closure', ["Closure_Resource", "ClosureData", function (Closure_Resource, ClosureData) {
    var Closure = function Closure(resource, day, isPreviousVersion) {
        this.id = "";
        this.isDeleted = false;
        this.timeCreated = null;
        this.number = null;
        this.type = null;
        this.price = null;
        this.absPrice = null;
        this.status = "open";
        this.day = day;
        this.version = null;
        this.vats = null;
        if (resource !== undefined && resource != null) this.loadObject(resource);

        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            ClosureData.add(this);
    };

    Closure.prototype.setId = function (id) {
        if (!this.id) this.id = id;
    };
    Closure.prototype.getId = function () {
        return this.id;
    };
    Closure.prototype.loadObject = function (object) {
        if (!this.id) this.id = object.id;
        this.number = object.number;
        this.type = object.type;
        this.status = object.status;
        this.price = object.price;
        this.absPrice = object.absPrice;
        this.timeCreated = object.timeCreated;
        this.vats = object.vats;
        if (object.version) this.version = object.version;

        if (object.archive && object.archive.fileUrl) this.archiveUrl = object.archive.fileUrl;
    };

    Closure.prototype.getObjectResource = function () {
        var newClosure = new Closure_Resource();

        newClosure.id = this.id;
        newClosure.number = this.number;
        newClosure.type = this.type;
        newClosure.status = this.status;
        newClosure.price = this.price;
        newClosure.absPrice = this.absPrice;
        newClosure.vats = this.vats;
        if (this.day) newClosure.dayId = this.day.id;
        return newClosure;
    };

    return Closure;
}]);

angular.module('FlexyBeautyApp.services').factory('ClosureSrv', ["$log", "ServerSrv", "Closure_Resource", "ClosureData", "UserActionData", "Closure", "DayData", "DaySrv", function ($log, ServerSrv, Closure_Resource, ClosureData, UserActionData, Closure, DayData, DaySrv) {
    var closureSrv = {};

    closureSrv.query = function (successFunction, errorFunction) {
        Closure_Resource.query({}, //params
        function (data) {
            ClosureData.clear();
            for (var i = 0; i < data.length; i++) {
                new Closure(data[i]);
            }

            if (successFunction !== undefined) successFunction();
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    closureSrv.open = function (closure, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(closureSrv.openSync, closure, successFunction, errorFunction);
    };

    closureSrv.openSync = function (closure, successFunction, errorFunction) {
        if (!closure.day || !closure.day.id) {
            ServerSrv.endSavingProcess(false, 412);
        }
        Closure_Resource.open({ dayId: closure.day.id.toString() }, function (data) {
            closureSrv.saveClosureSuccess(closure, data, successFunction);
        }, function (data) {
            try {
                var message = void 0;
                if (data && data.data && data.data.message) {
                    if (data.status == 400) {
                        if (errorFunction) {
                            if (data.data.message.includes("Closure already closed")) {
                                var closureDay = DayData.getById(closure.dayId);
                                if (closureDay != null) {
                                    closure.day = closureDay;
                                }
                                closure.status = "closed";
                                if (closure.day) {
                                    closure.day.closure = closure;
                                }
                                message = "La journée que vous essayez d'ouvrir a déjà été clôturée, on ne peut pas ouvrir une journée déjà clôturée";
                            } else {
                                closure.day.closure = null;
                                closure.day = null;
                                var dayInResponse = "day ";
                                var dayIdLength = 8;
                                var startOfDayIdInResponse = data.data.message.indexOf(dayInResponse) + dayInResponse.length;
                                var dayIdInResponse = data.data.message.slice(startOfDayIdInResponse, startOfDayIdInResponse + dayIdLength);
                                message = "La journée suivante est déjà ouverte : " + dayIdInResponse + ". Vous devez la fermer avant d'en ouvrir une nouvelle.";
                            }
                        }
                    } else if (data.status == 409) {
                        if (errorFunction) {
                            closure.day.closure = null;
                            closure.day = null;
                            message = data.data.message;
                        }
                    }
                    if (errorFunction && message) {
                        errorFunction(message);
                    }
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    closureSrv.close = function (closure, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(closureSrv.closeSync, closure, successFunction, errorFunction);
    };

    closureSrv.closeSync = function (closure, successFunction, errorFunction) {
        Closure_Resource.close({ id: closure.id }, function (data) {
            closureSrv.saveClosureSuccess(closure, data, successFunction);
        }, function (data) {
            try {
                if (data && data.status == 400 && data.data && data.data.message) {
                    if (errorFunction !== undefined) {
                        if (data.data.message.includes("Closure already closed")) {
                            var closureDay = DayData.getById(closure.dayId);
                            if (closureDay != null) {
                                closure.day = closureDay;
                            }
                            closure.status = "closed";
                            if (closure.day) {
                                closure.day.closure = closure;
                            }
                            errorFunction("La journée que vous essayez de fermer est déjà fermée");
                        } else {
                            closure.day.closure = null;
                            closure.day = null;
                            errorFunction("La journée que vous essayez de fermer n'a jamais été ouverte");
                        }
                    }
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    closureSrv.saveClosureSuccess = function (closure, response, successFunction) {
        try {
            closure.setId(response.id);
            var closureDay = DayData.getById(response.dayId);
            if (closureDay != null) {
                closure.day = closureDay;
            }
            closure.status = response.status;
            if (!closure.version || response.version && response.version > closure.version) {
                closure.version = response.version;
            }
            if (successFunction !== undefined) {
                successFunction(response);
            }
        } finally {
            ServerSrv.endSavingProcess(true);
        }
    };

    closureSrv.remove = function (closure, successFunction, errorFunction) {
        ClosureData.remove(closure);
        ServerSrv.startSavingProcess(closureSrv.removeSync, closure, successFunction, errorFunction);
    };
    closureSrv.removeSync = function (closure, successFunction, errorFunction) {
        //$timeout (function () {

        var closureRes = closure.getObjectResource();
        closureRes.$remove({ id: closure.getId() }, //no params
        function (data) {
            if (!closure.version || data.version && data.version > closure.version) closure.version = data.version;
            //Save on server success :
            // -> add an user action (send message)
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    closureSrv.updateLocally = function (id, resource) {
        var closure = ClosureData.getById(id);
        if (closure && closure.version && resource.version && resource.version < closure.version) return null;

        var day = DaySrv.getByIdAdder(resource.dayId);
        if (closure != null) //check if resource already exist inside index (current action could be a 'cancel')
            closure.loadObject(resource);else {
            closure = new Closure(resource, day); //dont load closuresService (will be done after)
            closure.id = id;
        }
        if (day) day.closure = closure;

        return closure;
    };
    closureSrv.removeLocally = function (id, resource) {
        var closure = ClosureData.getById(id);
        if (closure != null) {
            if (closure.day) closure.day.removeBooking(closure);
        }

        return closure;
    };
    closureSrv.addLocally = function (id, resource) {
        var closure = ClosureData.getById(id);
        if (closure && closure.version && resource.version && resource.version < closure.version) return null;

        var day = DaySrv.getByIdAdder(resource.dayId);
        if (closure != null) //check if resource already exist inside index (current action could be a 'cancel')
            closure.loadObject(resource);else {
            closure = new Closure(resource, day); //dont load closuresService (will be done after)
            closure.id = id;
        }
        if (day) day.closure = closure;

        return closure;
    };
    closureSrv.getPreviousVersionInstance = function (resource) {
        var closure = new Closure(resource, null, true);
        return closure;
    };

    return closureSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('ClosureData', [function () {
    var closureData = {
        indexClosures: [] // closure list for the entire closurelication
    };

    closureData.getById = function (closureId) {
        for (var i = 0; i < this.indexClosures.length; i++) {
            if (this.indexClosures[i].id == closureId) return this.indexClosures[i];
        }return null;
    };
    closureData.getIndexOf = function (closure) {
        if (closure) return this.indexClosures.indexOf(closure);
        return -1;
    };
    closureData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexClosures.length) return this.indexClosures[index];else return null;
    };
    closureData.add = function (closure) {
        this.indexClosures.push(closure);
        return this.indexClosures.length - 1;
    };
    closureData.clear = function () {
        closureData.indexClosures = [];
    };

    return closureData;
}]);

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('CompanyImage_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/companyImages/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        clearCache: { method: 'POST', url: baseUrl + 'rest/companyImages/clearCache' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyImage', function () {

    var CompanyImage = function CompanyImage(resource) {
        this.id = null;
        this.fileName = null;
        this.label = null;
        this.keyWords = null;
        this.urlHD = null;
        this.url = null;
        this.urlPreview = null;
        this.size = null;
        this.type = null;
        this.dim = null;
        this.filterType = null;
        if (resource !== undefined && resource != null) {
            if (!this.id) this.id = resource.id;
            this.fileName = resource.fileName;
            this.label = resource.label;
            this.keyWords = resource.keyWords;
            if (resource.url) this.url = resource.url.replace("http:", "");
            if (resource.urlHD) this.urlHD = resource.urlHD.replace("http:", "");else this.urlHD = this.url;
            if (resource.urlPreview) this.urlPreview = resource.urlPreview.replace("http:", "");
            this.size = resource.size;
            this.type = resource.type;
            if (this.type == 'customer') this.filterType = true;else this.filterType = false;
            this.dim = resource.dim;
        }
    };

    return CompanyImage;
});
angular.module('FlexyBeautyApp.services').factory('CompanyImageSrv', ["CompanyImage_Resource", "CompanyImage", "CompanyImageData", "ServerSrv", "$log", "bugsnag", "Constants", function (CompanyImage_Resource, CompanyImage, CompanyImageData, ServerSrv, $log, bugsnag, Constants) {
    var companyImageSrv = {};

    companyImageSrv.query = function (successFunction, errorFunction) {
        CompanyImage_Resource.query({}, //params
        function (data) {
            //success
            CompanyImageData.clear();
            for (var i = 0; i < data.length; i++) {
                CompanyImageData.add(new CompanyImage(data[i]));
            }if (successFunction !== undefined) successFunction(CompanyImageData.companyImages);
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
            CompanyImage_Resource.clearCache({}, function () {
                //nothing to do
            }, function (error) {
                bugsnag.notify("CompanyImage_Resource.clearCache - Error during companyImage clearCache", 'ClearCache failure. Error : ' + error.message, {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
            });
        });
    };
    companyImageSrv.remove = function (companyImage, successFunction, errorFunction) {
        CompanyImageData.remove(companyImage);
        ServerSrv.startSavingProcess(companyImageSrv.removeSync, companyImage, successFunction, errorFunction);
    };
    companyImageSrv.removeSync = function (companyImage, successFunction, errorFunction) {
        var companyImageRes = new CompanyImage_Resource();
        companyImageRes.$remove({ id: companyImage.id }, //params : id
        function (data) {
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    return companyImageSrv;
}]);
angular.module('FlexyBeautyApp.services').factory('CompanyImageData', function () {
    var companyImageData = { companyImages: [] };
    companyImageData.getById = function (companyImageId) {
        for (var i = 0; i < this.companyImages.length; i++) {
            if (this.companyImages[i].id == companyImageId) return this.companyImages[i];
        }return null;
    };
    companyImageData.add = function (companyImage) {
        this.companyImages.push(companyImage);
    };
    companyImageData.remove = function (companyImage) {
        var index = this.companyImages.indexOf(companyImage);
        if (index != -1) this.companyImages.splice(index, 1);
    };
    companyImageData.clear = function () {
        this.companyImages = [];
    };
    companyImageData.getActiveList = function (type) {
        if (type === undefined) return this.companyImages;
        var images = [];
        for (var i = 0; i < this.companyImages.length; i++) {
            if (this.companyImages[i].type == type || this.companyImages[i].type == null && type == "") {
                images.push(this.companyImages[i]);
            }
        }return images;
    };
    companyImageData.getActiveListWithoutCustomerImages = function () {
        var images = [];
        for (var i = 0; i < this.companyImages.length; i++) {
            if (this.companyImages[i].type != 'customer' || this.companyImages[i].type == null && type == "") {
                images.push(this.companyImages[i]);
            }
        }return images;
    };
    return companyImageData;
});

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Cure_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/cures/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/cures/deleted' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Cure', ["Cure_Resource", "ImageData", "CureData", "SupplierData", "CureCategoryData", "CompanyImageData", "ServiceData", "HrRootCategory", function (Cure_Resource, ImageData, CureData, SupplierData, CureCategoryData, CompanyImageData, ServiceData, HrRootCategory) {
    var Cure = function Cure(resource, parentCategory) {
        this.id = null;
        this.isDeleted;
        this.label = "";
        this.code = "";
        this.description = "";
        this.isOnHome = false;
        this.homeOrder = 0;
        this.price = null;
        this.hasInternetPrice = false;
        this.internetPrice = null;
        this.image = null;
        this.companyImage = null;
        this.specificImage = null;
        this.isVisibleOnWebSite = true; //Default;
        this.isBuyableOnWebSite = true; //Default;
        this.cureToServices = []; //{ _serviceId:2,quantity :12}
        this.serviceTab = [];
        this.version = null;
        if (resource) {
            this.loadObject(resource);
        }
        if (parentCategory) {
            this.parentCategory = parentCategory;
        }
        CureData.add(this);
    };

    Cure.prototype.loadObject = function (object, parentCategory) {
        //Assume here than the object in parameter contains only id (must load them)
        if (!this.id) {
            this.id = object.id;
        }
        this.isDeleted = object.isDeleted;
        this.parentCategoryId = object.parentCategoryId;
        this.label = object.label;
        this.code = object.code;
        this.description = object.description;
        this.price = object.price;
        this.imageId = object.imageId;
        this.companyImageId = object.companyImageId;
        this.specificImage = object.specificImage;
        this.isOnHome = object.isOnHome;
        this.homeOrder = object.homeOrder;
        this.hasInternetPrice = object.hasInternetPrice;
        this.internetPrice = object.internetPrice;
        this.isVisibleOnWebSite = object.isVisibleOnWebSite;
        this.isBuyableOnWebSite = object.isBuyableOnWebSite;
        this.cureToServices = [];
        if (object.cureToServices) {
            for (var i = 0; i < object.cureToServices.length; i++) {
                this.cureToServices.push({
                    _serviceId: object.cureToServices[i].serviceId,
                    quantity: object.cureToServices[i].quantity
                });
            }
        }
        if (parentCategory) {
            this.parentCategory = parentCategory;
        }
        if (object.version) {
            this.version = object.version;
        }
    };

    Cure.prototype.getObjectResource = function () {
        var rsCure = new Cure_Resource();
        rsCure.id = this.id;
        rsCure.isDeleted = this.isDeleted;
        rsCure.code = this.code;
        rsCure.label = this.label;
        if (this.image) rsCure.imageId = this.image.id;
        if (this.companyImage) rsCure.companyImageId = this.companyImage.id;
        rsCure.specificImage = this.specificImage;
        rsCure.description = this.description;
        rsCure.price = this.price;
        if (this.supplier != null) rsCure.supplier = this.supplier.getObjectResource(); //Always allow update
        rsCure.isOnHome = this.isOnHome;
        rsCure.homeOrder = this.homeOrder;
        rsCure.hasInternetPrice = this.hasInternetPrice;
        rsCure.internetPrice = this.internetPrice;
        rsCure.isVisibleOnWebSite = this.isVisibleOnWebSite;
        rsCure.isBuyableOnWebSite = this.isBuyableOnWebSite;

        //needPhysicalResource &&  needHumanResource MANAGED BY SERVER
        if (this.parentCategory != null) rsCure.parentCategoryId = this.parentCategory.getId();
        rsCure.cureToServices = [];
        if (this.cureToServices) for (var i = 0; i < this.cureToServices.length; i++) {
            rsCure.cureToServices.push({ serviceId: this.cureToServices[i].service.id, quantity: this.cureToServices[i].quantity });
        }return rsCure;
    };

    Cure.prototype.loadRef = function () {
        if (this.imageId) this.image = ImageData.getById(this.imageId);
        if (this.companyImageId) this.companyImage = CompanyImageData.getById(this.companyImageId);
        if (this.parentCategory == null && this.parentCategoryId) this.parentCategory = CureCategoryData.getById(this.parentCategoryId);
        for (var i = 0; i < this.cureToServices.length; i++) {
            if (this.cureToServices[i]) {
                this.cureToServices[i].service = ServiceData.getById(this.cureToServices[i]._serviceId);
                if (this.cureToServices[i].service) {
                    this.cureToServices[i].service.cures.push(this);
                    this.serviceTab.push(this.cureToServices[i].service);
                }
            }
        }
    };

    Cure.prototype.getId = function () {
        return this.id;
    };

    Cure.prototype.setId = function (id) {
        this.id = id;
    };

    Cure.prototype.getLabel = function () {
        return this.label;
    };

    Cure.prototype.reload = function (endFunction) {
        var cureSrv = this.getObjectResource();
        var cure = this;
        if (this.getId() != null) cureSrv.$get({ id: this.getId() }, //params
        function (data) {
            //success
            cure.loadObject(data);
            if (endFunction != undefined) endFunction(cure);
        }, function (data) {//failure
            //error handling goes here
            //TODO
        });
    };

    /*            Cure.prototype.isDescendantOf = function(category) {
                    var isDescendantOf = false;
                    if(category.cures) {
                        if (category.cures.indexOf(this) != -1) {
                            isDescendantOf = true;
                        }
                        else {
                            for (var i = 0; i < category.categories.length && !isDescendantOf; i++) {
                                isDescendantOf = isDescendantOf || this.isDescendantOf(category.categories[i]);
                            }
                        }
                    }
                    return isDescendantOf;
                }*/

    Cure.prototype.isDescendantOf = function (category) {
        var isDescendantOf = false;
        if (this.parentCategory === category) {
            isDescendantOf = true;
        } else {
            if (this.parentCategory) {
                isDescendantOf = this.parentCategory.isDescendantOf(category);
            }
        }

        return isDescendantOf;
    };

    return Cure;
}]);

angular.module('FlexyBeautyApp.services').factory('CureSrv', ["$log", "HumanResourceData", "HumanResourceSrv", "Cure_Resource", "Cure", "CureCategoryData", "UserActionData", "CureData", "ServerSrv", function ($log, HumanResourceData, HumanResourceSrv, Cure_Resource, Cure, CureCategoryData, UserActionData, CureData, ServerSrv) {
    var cureSrv = {};
    cureSrv.save = function (cure, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(cureSrv.saveSync, cure, successFunction, errorFunction);
    };
    cureSrv.saveSync = function (cure, successFunction, errorFunction) {
        //$timeout (function () {

        var CureRes = cure.getObjectResource();
        CureRes.$save({}, //no params
        function (data) {
            try {
                if (cure.id == null) {
                    cure.setId(data.id);
                }
                if (!cure.version || data.version && data.version > cure.version) cure.version = data.version;
                /** @namespace data.supplierId */
                if (data.supplierId && cure.supplier) cure.supplier.id = data.supplierId;

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    cureSrv.remove = function (cure, successFunction, errorFunction) {
        CureData.remove(cure);
        ServerSrv.startSavingProcess(cureSrv.removeSync, cure, successFunction, errorFunction);
    };
    cureSrv.removeSync = function (cure, successFunction, errorFunction) {
        //$timeout (function () {

        var cureRes = new Cure_Resource();
        cureRes.$remove({ id: cure.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    cureSrv.restore = function (cure, successFunction, errorFunction) {
        CureData.restore(cure);
        ServerSrv.startSavingProcess(cureSrv.restoreSync, cure, successFunction, errorFunction);
    };
    cureSrv.restoreSync = function (cure, successFunction, errorFunction) {
        //$timeout (function () {

        var cureRes = cure.getObjectResource();
        cureRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    cureSrv.query = function (successFunction, errorFunction) {
        Cure_Resource.getDeleted({}, //params
        function (data) {
            //success
            CureData.deletedCures = [];
            for (var i = 0; i < data.length; i++) {
                new Cure(data[i]);
            } //Auto Add to CureData


            if (successFunction !== undefined) successFunction(CureData.categoryRoot);
        }, function (data) {
            //failure
            $log.error("Cure_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    cureSrv.loadRef = function () {
        var cures = CureData.indexCures;
        for (var i = 0; i < cures.length; i++) {
            cures[i].loadRef();
        }
    };
    cureSrv.updateLocally = function (id, object) {
        var cure = null;
        var category = CureCategoryData.getById(object.parentCategoryId);
        if (category != null) cure = category.getCureById(id);
        if (cure != null) {
            cure.loadObject(object, category);
        }
        return cure;
    };
    cureSrv.addLocally = function (id, object) {
        var cure = null;
        var category = CureCategoryData.getById(object.parentCategoryId);
        if (category != null) {
            cure = new Cure(object, category);
            cure.id = id;
            category.addCure();
        }
        return null;
    };
    cureSrv.removeLocally = function (id, object) {
        var cure = null;
        var category = CureCategoryData.getById(object.parentCategoryId);
        if (category != null) cure = category.getCureById(id);
        if (cure != null) category.removeCure(cure);
        return cure;
    };

    return cureSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CureData', ["$log", function ($log) {
    var cureData = {
        indexCures: [], //Used as Index
        deletedCures: []
    };

    cureData.getById = function (cureId) {
        var indexCure = this.indexCures.find(function (element) {
            return element.id == cureId;
        });
        return indexCure == undefined ? null : indexCure;
    };

    cureData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexCures.length) {
            return this.indexCures[servIndex];
        }
        return null;
    };

    cureData.getIndexOf = function (cure) {
        return cure ? this.indexCures.indexOf(cure) : -1;
    };

    cureData.add = function (cure) {
        this.indexCures.push(cure);
        if (cure.isDeleted) {
            var index = this.deletedCures.indexOf(cure);
            if (index == -1) {
                this.deletedCures.push(cure);
            }
        }
        return this.indexCures.length - 1;
    };

    //Soft Remove
    cureData.remove = function (cure) {
        var index = this.deletedCures.indexOf(cure);
        if (index == -1) {
            this.deletedCures.push(cure);
            cure.isDeleted = true;
        }
    };

    //Soft Remove
    cureData.restore = function (cure) {
        var index = this.deletedCures.indexOf(cure);
        if (index != -1) {
            this.deletedCures.splice(index, 1);
            cure.isDeleted = false;
        }
    };

    cureData.clear = function () {
        cureData.indexCures = [];
        cureData.deletedCures = [];
    };

    cureData.getDeletedList = function () {
        return cureData.deletedCures;
    };

    return cureData;
}]);

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureCategory_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/cureCategories/:id', {}, {
        query: { method: 'GET', isArray: false },
        getTree: { method: 'GET', isArray: false, url: baseUrl + 'rest/cureCategories/tree' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/cureCategories/deleted' },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('CureCategory', ["CureCategory_Resource", "Cure", "CureCategoryData", "CureData", "ImageData", "CompanyImageData", function (CureCategory_Resource, Cure, CureCategoryData, CureData, ImageData, CompanyImageData) {
    var CureCategory = function CureCategory(rsCureCategory, parentCategory) {
        this.id = null;
        this.isDeleted;
        this.label = "";
        this.description = "";
        this.image = null;
        this.companyImage = null;
        this.specificImage; //boolean
        this.isVisibleOnWebSite;
        this.style = "";
        this.cures = [];
        this.categories = [];
        this.parentCategoryId = null;
        this.version = null;

        if (parentCategory !== undefined && parentCategory != null) this.parentCategory = parentCategory;

        if (rsCureCategory !== undefined && rsCureCategory != null) {
            var cure, category;
            if (!this.id) this.id = rsCureCategory.id;
            this.isDeleted = rsCureCategory.isDeleted;
            this.label = rsCureCategory.label;
            this.description = rsCureCategory.description;
            this.imageId = rsCureCategory.imageId;
            this.companyImageId = rsCureCategory.companyImageId;
            this.specificImage = rsCureCategory.specificImage;
            this.isVisibleOnWebSite = rsCureCategory.isVisibleOnWebSite;
            this.parentCategoryId = rsCureCategory.parentCategoryId;
            this.style = rsCureCategory.style;
            if (rsCureCategory.version) this.version = rsCureCategory.version;

            if (rsCureCategory.categories) for (var i = 0; i < rsCureCategory.categories.length; i++) {
                category = new CureCategory(rsCureCategory.categories[i], this);
                this.categories.push(category);
            }

            if (rsCureCategory.cures) for (var j = 0; j < rsCureCategory.cures.length; j++) {
                cure = new Cure(rsCureCategory.cures[j], this);
                this.cures.push(cure);
            }
        }
        CureCategoryData.add(this);
    };

    CureCategory.prototype.loadObject = function (object, parentCategory) {
        this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.label = object.label;
        this.description = object.description;
        this.style = object.style;
        this.specificImage = object.specificImage;
        this.isVisibleOnWebSite = object.isVisibleOnWebSite;
        if (object.version) this.version = object.version;

        if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }

        //load ref from ids
        if (object.curesId) {
            var newCures = [];
            for (var i = 0; i < object.curesId.length; i++) {
                var cure = CureData.getById(object.curesId[i]);
                if (cure != null) newCures.push(cure);
            }
            this.cures = newCures;
        }
        if (object.curesId) {
            var newCategories = [];
            for (i = 0; i < object.categoriesId.length; i++) {
                var category = CureCategoryData.getById(object.categoriesId[i]);
                if (category != null) newCategories.push(category);
            }
            this.categories = newCategories;
        }
    };
    CureCategory.prototype.getObjectResource = function () {
        var rsCureCategory = new CureCategory_Resource();
        rsCureCategory.id = this.id;
        rsCureCategory.isDeleted = this.isDeleted;
        rsCureCategory.label = this.label;
        rsCureCategory.description = this.description;
        if (this.image) rsCureCategory.imageId = this.image.id;
        if (this.companyImage) rsCureCategory.companyImageId = this.companyImage.id;
        rsCureCategory.specificImage = this.specificImage;
        rsCureCategory.isVisibleOnWebSite = this.isVisibleOnWebSite;
        rsCureCategory.style = this.style;

        if (this.parentCategory) rsCureCategory.parentCategoryId = this.parentCategory.getId();
        rsCureCategory.categoriesId = [];
        for (var i = 0; i < this.categories.length; i++) {
            rsCureCategory.categoriesId.push(this.categories[i].getId());
        }rsCureCategory.curesId = [];
        for (var i = 0; i < this.cures.length; i++) {
            rsCureCategory.curesId.push(this.cures[i].getId());
        }return rsCureCategory;
    };
    CureCategory.prototype.getId = function () {
        return this.id;
    };
    CureCategory.prototype.setId = function (id) {
        this.id = id;
    };
    CureCategory.prototype.getLabel = function () {
        return this.label;
    };
    CureCategory.prototype.addCure = function (cure) {
        var index = this.cures.indexOf(cure);
        if (index == -1) //Not already there
            {
                this.cures.push(cure);
                cure.parentCategory = this;
            }
    };
    CureCategory.prototype.removeCure = function (cure) {
        var index = this.cures.indexOf(cure);
        if (index != -1) //Found
            {
                this.cures.splice(index, 1);
            }
    };
    CureCategory.prototype.addCategory = function (category) {
        if (category) {
            var index = this.categories.indexOf(category);
            if (index == -1) //Not already there
                {
                    this.categories.push(category);
                    category.parentCategory = this;
                }
        }
    };
    CureCategory.prototype.removeCategory = function (category) {
        var index = this.categories.indexOf(category);
        if (index != -1) //Found
            {
                this.categories.splice(index, 1);
            }
    };
    CureCategory.prototype.changeCurePosition = function (cure, indexTarget) {
        //Change the cure position
        var index = this.cures.indexOf(cure);
        if (indexTarget != -1 && index != -1 && indexTarget != index && this.cures && indexTarget < this.cures.length) {
            var cat = this.cures[indexTarget];

            this.cures.splice(index, 1);
            if (index < indexTarget) indexTarget--;
            this.cures.splice(indexTarget, 0, cure);
        }
    };
    CureCategory.prototype.getCureById = function (cureId) {
        //recursive research
        var cure = null;
        for (var j = 0; j < this.cures.length; j++) {
            if (this.cures[j].id == cureId) return this.cures[j];
        }for (var z = 0; z < this.categories.length && !cure; z++) {
            cure = this.categories[z].getCureById(cureId);
        }return cure;
    };
    CureCategory.prototype.getCureByLabel = function (cureLabel) {
        //recursive research, need lower case input
        var cure = null;
        for (var j = 0; j < this.cures.length; j++) {
            if (this.cures[j].label.toLowerCase() == cureLabel) return this.cures[j];
        }for (var z = 0; z < this.categories.length && !cure; z++) {
            cure = this.categories[z].getCureByLabel(cureLabel);
        }return cure;
    };
    CureCategory.prototype.getCureCategoryById = function (categoryId) {
        //recursive research
        var category = null;
        for (var z = 0; z < this.categories.length && !category; z++) {
            if (this.categories[z].id == categoryId) category = this.categories[z];else category = this.categories[z].getCureCategoryById(categoryId);
        }return category;
    };
    CureCategory.prototype.loadRef = function () {
        if (this.imageId) this.image = ImageData.getById(this.imageId);
        if (this.companyImageId) this.companyImage = CompanyImageData.getById(this.companyImageId);
        if (this.parentCategory == null && this.parentCategoryId) this.parentCategory = CureCategoryData.getById(this.parentCategoryId);
    };

    CureCategory.prototype.getSubStatCategories = function (rootCategory) {
        return this.categories.concat(this.cures);
    };

    CureCategory.prototype.isDescendantOf = function (category) {
        var isDescendantOf = false;
        if (this.parentCategory === category) {
            isDescendantOf = true;
        } else {
            if (this.parentCategory) {
                isDescendantOf = this.parentCategory.isDescendantOf(category);
            }
        }

        return isDescendantOf;
    };

    return CureCategory;
}]);

angular.module('FlexyBeautyApp.services').factory('CureCategorySrv', ["CureCategory_Resource", "CureCategory", "CureCategoryData", "UserActionData", "CureSrv", "$log", "ServerSrv", function (CureCategory_Resource, CureCategory, CureCategoryData, UserActionData, CureSrv, $log, ServerSrv) {
    //$timeout (function () {

    var categorySrv = {};
    categorySrv.query = function (successFunction, errorFunction) {
        var treeLoaded = false;
        var deletedLoaded = false;
        CureCategory_Resource.getTree({}, //params
        function (data) {
            //success
            CureCategoryData.categoryRoot = new CureCategory(data);

            if (successFunction !== undefined && deletedLoaded) successFunction(CureCategoryData.categoryRoot);
            treeLoaded = true;
        }, function (data) {
            //failure
            $log.error("CureCategory_Resource.getTree error");
            $log.error(data);
            if (errorFunction !== undefined && deletedLoaded) errorFunction(data);
            treeLoaded = true;
        });
        CureCategory_Resource.getDeleted({}, //params
        function (data) {
            //success
            CureCategoryData.deletedCategories = [];
            for (var i = 0; i < data.length; i++) {
                new CureCategory(data[i]);
            } //Auto Add to CureCategoryData

            if (successFunction !== undefined && treeLoaded) successFunction(CureCategoryData.categoryRoot);
            deletedLoaded = true;
        }, function (data) {
            //failure
            $log.error("CureCategory_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined && treeLoaded) errorFunction(data);
            deletedLoaded = true;
        });
    };
    categorySrv.save = function (category, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(categorySrv.saveSync, category, successFunction, errorFunction);
    };
    categorySrv.saveSync = function (category, successFunction, errorFunction) {
        var CureCategoryRes = category.getObjectResource();
        CureCategoryRes.$save({}, //no params
        function (data) {
            try {
                category.setId(data.id);
                //TODO  UserActionData.add(data.userAction);
                if (successFunction) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    categorySrv.remove = function (category, successFunction, errorFunction) {
        CureCategoryData.remove(category);
        ServerSrv.startSavingProcess(categorySrv.removeSync, category, successFunction, errorFunction);
    };
    categorySrv.removeSync = function (category, successFunction, errorFunction) {
        var categoryRes = new CureCategory_Resource();
        categoryRes.$remove({ id: category.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    categorySrv.restore = function (category, successFunction, errorFunction) {
        CureCategoryData.restore(category);
        ServerSrv.startSavingProcess(categorySrv.restoreSync, category, successFunction, errorFunction);
    };
    categorySrv.restoreSync = function (category, successFunction, errorFunction) {
        //$timeout (function () {

        var categoryRes = category.getObjectResource();
        categoryRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    categorySrv.getCureCategoryOnServer = function (scope, targetName, categoryId) {

        var category = null;
        if (CureCategoryData.categoryRoot.categories != null && CureCategoryData.categoryRoot.categories.length > 0) {
            for (var i = 0; i < CureCategoryData.categoryRoot.categories.length && !category; i++) {
                if (CureCategoryData.categoryRoot.categories[i].getId() == categoryId) category = CureCategoryData.categoryRoot.categories[i];else for (var j = 0; j < CureCategoryData.categoryRoot.categories[i].categories.length && !category; j++) {
                    if (CureCategoryData.categoryRoot.categories[i].categories[j].getId() == categoryId) category = CureCategoryData.categoryRoot.categories[i].categories[j];
                }
            }scope[targetName] = category;
        } else {

            CureCategory_Resource.get({ id: categoryId }, function (categoryRes) {
                //success
                var bookingCures = [];
                scope[targetName] = new CureCategory(categoryRes);
            }, function (categoryRes) {//failure
                //error handling goes here
            });
        }
    };
    categorySrv.get = function (categoryId) {
        //TODO
        return null;
    };
    categorySrv.getCureById = function (cureId) {
        if (CureCategoryData.categoryRoot != null) return CureCategoryData.categoryRoot.getCure(cureId);
    };
    categorySrv.loadRef = function () {
        var categories = CureCategoryData.indexCategories;
        for (var i = 0; i < categories.length; i++) {
            categories[i].loadRef();
        }
    };
    categorySrv.moveCure = function (category, cure) {
        if (category) {
            category.moveCure(cure);
            CureSrv.save(cure);
        }
    };
    categorySrv.updateLocally = function (id, object) {
        var category = null;
        var parentCategory = null;
        if (object.parentCategoryId) //Optimization : get parent if exist
            {
                parentCategory = CureCategoryData.getById(object.parentCategoryId);
                if (parentCategory != null) category = parentCategory.getCureCategoryById(id);
            } else category = CureCategoryData.getById(id);
        if (category != null) category.loadObject(object, parentCategory);
    };
    categorySrv.addLocally = function (object) {
        //TODO
        /*            var category = CureCategoryData.getCureCategory(object.parentCategoryId);
                    if (category!=null)
                        category.addCure(new Cure(object,category));*/

    };
    categorySrv.removeLocally = function (object) {
        //TODO
        /*            var cure =  null;
                    var category = CureCategoryData.getCureCategory(object.parentCategoryId);
                    if (category!=null)
                        cure = category.getCure(object.id)
                    if (cure!=null)
                        category.removeCure(cure);*/
    };

    return categorySrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CureCategoryData', ["$log", function ($log) {
    var categoryData = {
        categoryRoot: null,
        indexCategories: [], //Used as Index
        deletedCategories: []
    };
    categoryData.getById = function (categoryId) {
        for (var i = 0; i < this.indexCategories.length; i++) {
            if (this.indexCategories[i].id == categoryId) return this.indexCategories[i];
        }return null;
    };
    categoryData.getByIndex = function (catIndex) {
        if (catIndex >= 0 && catIndex < this.indexCategories.length) return this.indexCategories[catIndex];else return null;
    };
    categoryData.getIndexOf = function (category) {
        if (category) return this.indexCategories.indexOf(category);
        return -1;
    };
    categoryData.add = function (category) {
        this.indexCategories.push(category);
        if (category.isDeleted) {
            var index = this.deletedCategories.indexOf(category);
            if (index == -1) this.deletedCategories.push(category);
        }
        return this.indexCategories.length - 1;
    };
    categoryData.remove = function (category) //Soft Remove
    {
        var index = this.deletedCategories.indexOf(category);
        if (index == -1) {
            this.deletedCategories.push(category);
            category.isDeleted = true;
        }
    };
    categoryData.restore = function (category) //Soft Remove
    {
        var index = this.deletedCategories.indexOf(category);
        if (index != -1) {
            this.deletedCategories.splice(index, 1);
            category.isDeleted = false;
        }
    };
    categoryData.clear = function () {
        categoryData.categoryRoot = null;
        categoryData.indexCategories = [];
        categoryData.deletedCategories = [];
    };
    categoryData.loaded = function () {
        return categoryData.categoryRoot != null;
    };
    categoryData.getDeletedList = function () {
        return categoryData.deletedCategories;
    };

    return categoryData;
}]);

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureItem_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/cureItems/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/cureItems/deleted' },
        checkCureItemServicesIsUsed: { method: 'POST', url: baseUrl + 'rest/cureItems/cureItemToService/checkCureItemServicesIsUsed' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('CureItem', ["CureItem_Resource", "CureItemData", "CureItemToService", function (CureItem_Resource, CureItemData, CureItemToService) {

    var CureItem = function CureItem(resource, saleCure, mustloadElements) {
        this.id = null;
        this.isDeleted = false;
        this.saleCure = saleCure;
        this.cureItemToServices = [];
        this.isClosed = false;
        this.cureUsed = true;
        this.version = null;
        if (resource !== undefined && resource != null) {
            this.loadObjectProperties(resource);
            if (mustloadElements) this.loadObjectCureItemToServices(resource);
        }
        CureItemData.add(this);
    };
    CureItem.prototype.loadObjectProperties = function (object) {
        //Assume here than the object in parameter contains only id (must load them)
        if (!this.id) this.id = object.id;
        if (object.version) this.version = object.version;
        this.isDeleted = object.isDeleted;
        if (object.isClosed !== undefined) //new
            this.isClosed = object.isClosed;
    };
    CureItem.prototype.loadObjectCureItemToServices = function (object) {
        this.cureItemToServices = [];
        if (object.cureItemToServices) for (var i = 0; i < object.cureItemToServices.length; i++) {
            this.cureItemToServices.push(new CureItemToService(object.cureItemToServices[i], this, true));
        }
    };
    CureItem.prototype.getObjectResource = function () {
        var rsCureItem = new CureItem_Resource();
        rsCureItem.id = this.id;
        rsCureItem.isDeleted = this.isDeleted;
        rsCureItem.isClosed = this.isClosed;
        rsCureItem.cureItemToServices = [];
        if (this.cureItemToServices) for (var i = 0; i < this.cureItemToServices.length; i++) {
            rsCureItem.cureItemToServices.push(this.cureItemToServices[i].getObjectResource());
        }return rsCureItem;
    };

    CureItem.prototype.loadRef = function () {
        //no action
    };

    CureItem.prototype.getId = function () {
        return this.id;
    };
    CureItem.prototype.setId = function (id) {
        this.id = id;
    };
    CureItem.prototype.addCureItemToService = function (cureItemToService) {
        if (cureItemToService) {
            var index = this.cureItemToServices.indexOf(cureItemToService);
            if (index == -1) this.cureItemToServices.push(cureItemToService);
            cureItemToService.cureItem = this;
        }
    };
    CureItem.prototype.removeCureItemToService = function (cureItemToService) {
        if (cureItemToService) {
            var index = this.cureItemToServices.indexOf(cureItemToService);
            if (index != -1) this.cureItemToServices.splice(index, 1);
            cureItemToService.cureItem = null;
        }
    };
    CureItem.prototype.isUsed = function () {
        var isUsed = true;
        for (var i = 0; i < this.cureItemToServices.length && isUsed; i++) {
            isUsed = isUsed && this.cureItemToServices[i].isUsed();
        }return isUsed || this.isClosed;
    };
    return CureItem;
}]);

angular.module('FlexyBeautyApp.services').factory('CureItemSrv', ["$log", "CureItem_Resource", "CureItem", "UserActionData", "CureItemData", "ServerSrv", "SaleCureData", function ($log, CureItem_Resource, CureItem, UserActionData, CureItemData, ServerSrv, SaleCureData) {
    var cureItemSrv = {};
    cureItemSrv.save = function (cureItem, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(cureItemSrv.saveSync, cureItem, successFunction, errorFunction);
    };
    cureItemSrv.saveSync = function (cureItem, successFunction, errorFunction) {
        //$timeout (function () {

        var CureItemRes = cureItem.getObjectResource();
        CureItemRes.$save({}, //no params
        function (data) {
            try {
                if (cureItem.id == null) {
                    cureItem.setId(data.id);
                }
                if (!cureItem.version || data.version && data.version > cureItem.version) cureItem.version = data.version;
                /** @namespace data.supplierId */
                if (data.supplierId && cureItem.supplier) cureItem.supplier.id = data.supplierId;

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    cureItemSrv.remove = function (cureItem, successFunction, errorFunction) {
        CureItemData.remove(cureItem);
        ServerSrv.startSavingProcess(cureItemSrv.removeSync, cureItem, successFunction, errorFunction);
    };
    cureItemSrv.removeSync = function (cureItem, successFunction, errorFunction) {
        //$timeout (function () {

        var cureItemRes = new CureItem_Resource();
        cureItemRes.$remove({ id: cureItem.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    cureItemSrv.restore = function (cureItem, successFunction, errorFunction) {
        CureItemData.restore(cureItem);
        ServerSrv.startSavingProcess(cureItemSrv.restoreSync, cureItem, successFunction, errorFunction);
    };
    cureItemSrv.restoreSync = function (cureItem, successFunction, errorFunction) {
        //$timeout (function () {

        var cureItemRes = cureItem.getObjectResource();
        cureItemRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    cureItemSrv.query = function (successFunction, errorFunction) {
        CureItem_Resource.getDeleted({}, //params
        function (data) {
            //success

            CureItemData.deletedCureItems = [];
            for (var i = 0; i < data.length; i++) {
                new CureItem(data[i]);
            } //Auto Add to CureItemData

            if (successFunction !== undefined) successFunction(CureItemData.categoryRoot);
        }, function (data) {
            //failure
            $log.error("CureItem_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    cureItemSrv.checkCureItemServiceIsUsed = function (cureItemsToService, successFunction, errorFunction) {
        var cureItemRessource = new CureItem_Resource();
        cureItemRessource.cureItemServices = cureItemsToService;
        cureItemRessource.$checkCureItemServicesIsUsed({}, function (data) {
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };

    cureItemSrv.loadRef = function () {
        var cureItems = CureItemData.indexCureItems;
        for (var i = 0; i < cureItems.length; i++) {
            cureItems[i].loadRef();
        }
    };

    cureItemSrv.updateLocally = function (id, resource) {
        var cureItem = CureItemData.getById(id);
        if (cureItem != null) {
            cureItem.loadObjectProperties(resource);
            cureItem.loadRef();
        }
        return cureItem;
    };
    cureItemSrv.addLocally = function (id, resource) {
        var cureItem = CureItemData.getById(id);
        if (cureItem != null) cureItem.loadObjectProperties(resource);else {
            cureItem = new CureItem(resource, null, false);
            cureItem.id = id;
        }
        cureItem.loadRef();
        if (resource.saleCureId) {
            var saleCure = SaleCureData.getById(resource.saleCureId);
            if (saleCure) saleCure.addCureItem(cureItem);
        }
        return cureItem;
    };
    cureItemSrv.removeLocally = function (id, resource) {
        var cureItem = CureItemData.getById(id);
        if (cureItem != null) {
            //remove from sale
            if (cureItem.saleCure) cureItem.saleCure.removeCureItem(cureItem);
        }
        return cureItem;
    };

    return cureItemSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CureItemData', ["$log", function ($log) {
    var cureItemData = {
        indexCureItems: [], //Used as Index
        deletedCureItems: []
    };
    cureItemData.getById = function (cureItemId) {
        for (var i = 0; i < this.indexCureItems.length; i++) {
            if (this.indexCureItems[i].id == cureItemId) return this.indexCureItems[i];
        }return null;
    };
    cureItemData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexCureItems.length) {
            return this.indexCureItems[servIndex];
        } else return null;
    };
    cureItemData.getIndexOf = function (cureItem) {
        if (cureItem) return this.indexCureItems.indexOf(cureItem);
        return -1;
    };
    cureItemData.add = function (cureItem) {
        this.indexCureItems.push(cureItem);
        if (cureItem.isDeleted) {
            var index = this.deletedCureItems.indexOf(cureItem);
            if (index == -1) this.deletedCureItems.push(cureItem);
        }
        return this.indexCureItems.length - 1;
    };
    cureItemData.remove = function (cureItem) //Soft Remove
    {
        var index = this.deletedCureItems.indexOf(cureItem);
        if (index == -1) {
            this.deletedCureItems.push(cureItem);
            cureItem.isDeleted = true;
        }
    };
    cureItemData.restore = function (cureItem) //Soft Remove
    {
        var index = this.deletedCureItems.indexOf(cureItem);
        if (index != -1) {
            this.deletedCureItems.splice(index, 1);
            cureItem.isDeleted = false;
        }
    };
    cureItemData.clear = function () {
        cureItemData.indexCureItems = [];
        cureItemData.deletedCureItems = [];
    };
    cureItemData.getDeletedList = function () {
        return cureItemData.deletedCureItems;
    };

    return cureItemData;
}]);

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("FlexyBeautyApp").constant("Constants", {
    "themes": {
        "pink": "theme-pink",
        "pink-original": "theme-pink",
        "pinkcontrast": "theme-pinkcontrast",
        "blue": "theme-blue",
        "night": "theme-night",
        "green": "theme-green",
        "red": "theme-red"
    },
    "defaultTheme": "blue",
    "EMAIL": "^([a-zA-Z0-9_-]+(?:\\.[a-zA-Z0-9_-]+)*)@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$",
    "ngRoutings": {
        "customer": {
            "list": "customer",
            "smsmarketing": "customer/smsmarketing",
            "notification": "customer/notification",
            "trash": "customer/trash",
            "config": "customer/config"
        }
    },
    'WEBSITE_PATH_BY_STORE_APP_CODE': {
        'cure': ['cure', 'cureCategory'],
        'loyaltyCard': ['loyaltyCardCategory', 'loyaltyCard'],
        'giftItem': ['giftItem', 'giftItems', 'giftItemsMail']
    },
    "DEFAULT_CURRENCY_CODE": "EUR",
    "DEFAULT_LOCALE_CODE": "fr-FR",
    'APP_DOMAIN': {
        "planningPos": "planningPos",
        "statistics": "statistics",
        "site": "site",
        "flexyBeauty": "flexyBeauty"

    },
    "APP_SUB_DOMAIN": {
        "pos": "pos",
        "planning": "planning",
        "flexyStore": "flexyStore",
        "paymentMode": "paymentMode"
    },
    "KIUTE_PRO_APP": {
        "local": 'http://localhost:3000',
        "staging": "https://kiute-pro-staging.kiute.com",
        "prod": "https://kiute-pro-prod.kiute.com"
    },
    "BUGSNAG_WARN_LEVEL": "warning",
    "BUGSNAG_NOTIFICATION_LEVEL": "info",
    "SMS_REMINDER_HOURS_TO_SEND": [{ hourNumber: 8, hour: '8H00' }, { hourNumber: 9, hour: '9H00' }, { hourNumber: 10, hour: '10H00' }, { hourNumber: 11, hour: '11H00' }, { hourNumber: 12, hour: '12H00' }, { hourNumber: 13, hour: '13H00' }, { hourNumber: 14, hour: '14H00' }, { hourNumber: 15, hour: '15H00' }, { hourNumber: 16, hour: '16H00' }, { hourNumber: 17, hour: '17H00' }, { hourNumber: 18, hour: '18H00' }, { hourNumber: 19, hour: '19H00' }, { hourNumber: 20, hour: '20H00' }],
    "MAX_SERVICES_FOR_COMPANY": 1000,
    "ANGULAR_TABS": {
        "LOYALTY_CARD_ITEMS": "loyaltyCardItems",
        "GIFT_ITEMS": "giftItems",
        "CURE_ITEMS": "cureItems"
    },
    "ANGULAR_EVENTS": {
        "REFRESH": "refresh",
        "MANAGER_MODE": "managerMode"
    },
    "EXPORT_FORMAT": {
        "CSV": {
            name: "CSV",
            hrefAttachment: "data:attachment/csv;charset=utf-8",
            fileExtension: "csv"
        },
        'XLSX': {
            name: 'XLSX',
            hrefAttachment: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
            fileExtension: 'xlsx'
        }
    },
    'SITE_COUNTRIES': [{
        code: 'FR',
        name: 'France',
        timezone: 'Europe/Paris'
    }, {
        code: 'GP',
        name: 'Guadeloupe',
        timezone: 'America/Guadeloupe'
    }, {
        code: 'MQ',
        name: 'Martinique',
        timezone: 'America/Martinique'
    }, {
        code: 'GF',
        name: 'Guyane',
        timezone: 'America/Cayenne'
    }, {
        code: 'RE',
        name: 'La Réunion',
        timezone: 'Indian/Reunion'
    }, {
        code: 'BE',
        name: 'Belgique',
        timezone: 'Europe/Brussels'
    }, {
        code: 'CH',
        name: 'Suisse',
        timezone: 'Europe/Zurich'
    }],
    "WEBSITE_USELESS_THEME_LABELS": ['Pastel', 'Black Bird', 'Noël étoilé'],
    "SECONDS_IN_A_DAY": 86400000,
    "NB_STARTUP_LOADED_DAYS": 7,
    "CATEGORY_LABELS": {
        "YOUR_SERVICES": "Vos prestations",
        "YOU_OTHER_SERVICES": "Vos autres prestations"
    },
    "USER_ACTION_DATE_INTERVAL_NORMAL_ACTIVITY_IN_MILLI_SECONDS": 120000,
    "USER_ACTION_DATE_INTERVAL_LOW_ACTIVITY_IN_MILLI_SECONDS": 1800000 /* 3O minutes */
    , "IDLE_TIME_START_IN_SECONDS": 1800 /* 3O minutes */
});

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureItemToService_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/cureItemToServices/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/cureItemToServices/deleted' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('CureItemToService', ["CureItemToService_Resource", "CureItemToServiceData", "ServiceData", "CureItemToServiceUsage", function (CureItemToService_Resource, CureItemToServiceData, ServiceData, CureItemToServiceUsage) {

    var CureItemToService = function CureItemToService(resource, cureItem, mustloadElements) {
        this.id = null;
        this.isDeleted;
        this.service = null;
        this.quantity = 0;
        this.cureItem = cureItem;
        this.cureItemToServiceUsages = [];
        this.version = null;
        if (resource !== undefined && resource != null) {
            this.loadObjectProperties(resource);
            if (mustloadElements) this.loadObjectCureItemToServiceUsages(resource);
        }
        CureItemToServiceData.add(this);
    };
    CureItemToService.prototype.loadObjectProperties = function (object) {
        if (!this.id) this.id = object.id;
        if (object.version) this.version = object.version;
        this.isDeleted = object.isDeleted;
        this._serviceId = object.serviceId;
        this.quantity = object.quantity;
    };
    CureItemToService.prototype.loadObjectCureItemToServiceUsages = function (object) {
        this.cureItemToServiceUsages = [];
        if (object.cureItemToServiceUsages) for (var i = 0; i < object.cureItemToServiceUsages.length; i++) {
            this.cureItemToServiceUsages.push(new CureItemToServiceUsage(object.cureItemToServiceUsages[i], this));
        }
    };
    CureItemToService.prototype.getObjectResource = function () {
        var rsCureItemToService = new CureItemToService_Resource();
        rsCureItemToService.id = this.id;
        rsCureItemToService.isDeleted = this.isDeleted;
        rsCureItemToService.quantity = this.quantity;
        if (this.service) rsCureItemToService.serviceId = this.service.id;

        //do not save  cureItemToServiceUsages on this resource

        return rsCureItemToService;
    };

    CureItemToService.prototype.loadRef = function () {
        this.service = ServiceData.getById(this._serviceId);
        if (!this.service && this.cureItem && this.cureItem.saleCure && this.cureItem.saleCure.cure && this.cureItem.saleCure.cure.cureToServices.length == 1 && this.cureItem.saleCure.cure.cureToServices[0].service) // security to avoid error
            this.service = this.cureItem.saleCure.cure.cureToServices[0].service;
        /*
                    for (var i=0;i<this.cureItemToServiceToServices.length;i++)
                        this.cureItemToServiceToServices[i].service = ServiceData.getById(this.cureItemToServiceToServices[i]._serviceId);
        */
    };
    CureItemToService.prototype.getId = function () {
        return this.id;
    };
    CureItemToService.prototype.setId = function (id) {
        this.id = id;
    };
    CureItemToService.prototype.addCureItemToServiceUsage = function (cureItemToServiceUsage) {
        if (cureItemToServiceUsage) {
            var index = this.cureItemToServiceUsages.indexOf(cureItemToServiceUsage);
            if (index == -1) this.cureItemToServiceUsages.push(cureItemToServiceUsage);
            cureItemToServiceUsage.cureItemToService = this;
        }
    };
    CureItemToService.prototype.removeCureItemToServiceUsage = function (cureItemToServiceUsage) {
        if (cureItemToServiceUsage) {
            var index = this.cureItemToServiceUsages.indexOf(cureItemToServiceUsage);
            if (index != -1) this.cureItemToServiceUsages.splice(index, 1);
            cureItemToServiceUsage.cureItemToService = null;
        }
    };
    CureItemToService.prototype.isUsed = function () {
        var usedQuantity = 0;
        for (var i = 0; i < this.cureItemToServiceUsages.length; i++) {
            usedQuantity += this.cureItemToServiceUsages[i].usedQuantity;
        }return usedQuantity >= this.quantity;
    };
    return CureItemToService;
}]);

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceSrv', ["$log", "CureItemToService_Resource", "CureItemToService", "UserActionData", "CureItemToServiceData", "ServerSrv", "CureItemData", function ($log, CureItemToService_Resource, CureItemToService, UserActionData, CureItemToServiceData, ServerSrv, CureItemData) {
    var cureItemToServiceSrv = {};
    cureItemToServiceSrv.save = function (cureItemToService, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(cureItemToServiceSrv.saveSync, cureItemToService, successFunction, errorFunction);
    };
    cureItemToServiceSrv.saveSync = function (cureItemToService, successFunction, errorFunction) {
        var CureItemToServiceRes = cureItemToService.getObjectResource();
        CureItemToServiceRes.$save({}, //no params
        function (data) {
            try {
                if (cureItemToService.id == null) {
                    cureItemToService.setId(data.id);
                }
                /** @namespace data.supplierId */
                if (data.supplierId && cureItemToService.supplier) cureItemToService.supplier.id = data.supplierId;

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    cureItemToServiceSrv.remove = function (cureItemToService, successFunction, errorFunction) {
        CureItemToServiceData.remove(cureItemToService);
        ServerSrv.startSavingProcess(cureItemToServiceSrv.removeSync, cureItemToService, successFunction, errorFunction);
    };
    cureItemToServiceSrv.removeSync = function (cureItemToService, successFunction, errorFunction) {
        var cureItemToServiceRes = new CureItemToService_Resource();
        cureItemToServiceRes.$remove({ id: cureItemToService.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    cureItemToServiceSrv.restore = function (cureItemToService, successFunction, errorFunction) {
        CureItemToServiceData.restore(cureItemToService);
        ServerSrv.startSavingProcess(cureItemToServiceSrv.restoreSync, cureItemToService, successFunction, errorFunction);
    };
    cureItemToServiceSrv.restoreSync = function (cureItemToService, successFunction, errorFunction) {
        //$timeout (function () {

        var cureItemToServiceRes = cureItemToService.getObjectResource();
        cureItemToServiceRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    cureItemToServiceSrv.query = function (successFunction, errorFunction) {
        CureItemToService_Resource.getDeleted({}, //params
        function (data) {
            //success

            CureItemToServiceData.deletedCureItemToServices = [];
            for (var i = 0; i < data.length; i++) {
                new CureItemToService(data[i]);
            } //Auto Add to CureItemToServiceData

            if (successFunction !== undefined) successFunction(CureItemToServiceData.categoryRoot);
        }, function (data) {
            //failure
            $log.error("CureItemToService_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    cureItemToServiceSrv.loadRef = function () {
        var cureItemToServices = CureItemToServiceData.indexCureItemToServices;
        for (var i = 0; i < cureItemToServices.length; i++) {
            cureItemToServices[i].loadRef();
        }
    };
    cureItemToServiceSrv.updateLocally = function (id, resource) {
        var cureItemToService = CureItemToServiceData.getById(id);
        if (cureItemToService != null) {
            cureItemToService.loadObjectProperties(resource);
            cureItemToService.loadRef();
        }
        return cureItemToService;
    };
    cureItemToServiceSrv.addLocally = function (id, resource) {
        var cureItemToService = CureItemToServiceData.getById(id);
        if (cureItemToService != null) cureItemToService.loadObjectProperties(resource);else {
            cureItemToService = new CureItemToService(resource, null, false);
            cureItemToService.id = id;
        }
        cureItemToService.loadRef();
        if (resource.cureItemId) {
            var cureItem = CureItemData.getById(resource.cureItemId);
            if (cureItem) cureItem.addCureItemToService(cureItemToService);
        }
        return cureItemToService;
    };
    cureItemToServiceSrv.removeLocally = function (id, resource) {
        var cureItemToService = CureItemToServiceData.getById(id);
        if (cureItemToService != null) {
            //remove from sale
            if (cureItemToService.cureItem) cureItemToService.cureItem.removeCureItemToService(cureItemToService);
        }
        return cureItemToService;
    };

    return cureItemToServiceSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceData', ["$log", function ($log) {
    var cureItemToServiceData = {
        indexCureItemToServices: [], //Used as Index
        deletedCureItemToServices: []
    };
    cureItemToServiceData.getById = function (cureItemToServiceId) {
        for (var i = 0; i < this.indexCureItemToServices.length; i++) {
            if (this.indexCureItemToServices[i].id == cureItemToServiceId) return this.indexCureItemToServices[i];
        }return null;
    };
    cureItemToServiceData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexCureItemToServices.length) {
            return this.indexCureItemToServices[servIndex];
        } else return null;
    };
    cureItemToServiceData.getIndexOf = function (cureItemToService) {
        if (cureItemToService) return this.indexCureItemToServices.indexOf(cureItemToService);
        return -1;
    };
    cureItemToServiceData.add = function (cureItemToService) {
        this.indexCureItemToServices.push(cureItemToService);
        if (cureItemToService.isDeleted) {
            var index = this.deletedCureItemToServices.indexOf(cureItemToService);
            if (index == -1) this.deletedCureItemToServices.push(cureItemToService);
        }
        return this.indexCureItemToServices.length - 1;
    };
    cureItemToServiceData.remove = function (cureItemToService) //Soft Remove
    {
        var index = this.deletedCureItemToServices.indexOf(cureItemToService);
        if (index == -1) {
            this.deletedCureItemToServices.push(cureItemToService);
            cureItemToService.isDeleted = true;
        }
    };
    cureItemToServiceData.restore = function (cureItemToService) //Soft Remove
    {
        var index = this.deletedCureItemToServices.indexOf(cureItemToService);
        if (index != -1) {
            this.deletedCureItemToServices.splice(index, 1);
            cureItemToService.isDeleted = false;
        }
    };
    cureItemToServiceData.clear = function () {
        cureItemToServiceData.indexCureItemToServices = [];
        cureItemToServiceData.deletedCureItemToServices = [];
    };
    cureItemToServiceData.getDeletedList = function () {
        return cureItemToServiceData.deletedCureItemToServices;
    };

    return cureItemToServiceData;
}]);

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsage_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/cureItemToServiceUsages/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/cureItemToServiceUsages/deleted' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsage', ["CureItemToServiceUsage_Resource", "CureItemToServiceUsageData", "HumanResourceData", "ActivityData", function (CureItemToServiceUsage_Resource, CureItemToServiceUsageData, HumanResourceData, ActivityData) {

    var CureItemToServiceUsage = function CureItemToServiceUsage(resource, cureItemToService) {
        this.id = null;
        this.isDeleted;
        this.cureItemToService = cureItemToService;
        this.usageTime = null;
        this.humanResource = null;
        this.bookingService = null;
        this.usedQuantity = 0;
        this.version = null;
        if (resource !== undefined && resource != null) {
            this.loadObject(resource);
        }
        CureItemToServiceUsageData.add(this);
    };
    CureItemToServiceUsage.prototype.loadObject = function (object) {
        if (!this.id) this.id = object.id;
        this.isDeleted = object.isDeleted;
        if (object.usageTime) this.usageTime = new Date(object.usageTime);
        this._humanResourceId = object.humanResourceId;
        this._bookingServiceId = object.bookingServiceId;
        this.usedQuantity = object.usedQuantity;
        if (object.version) this.version = object.version;
    };
    CureItemToServiceUsage.prototype.getObjectResource = function () {
        var rs = new CureItemToServiceUsage_Resource();
        if (this.cureItemToService) rs.cureItemToServiceId = this.cureItemToService.id;
        rs.id = this.id;
        rs.isDeleted = this.isDeleted;
        rs.usageTime = this.usageTime;
        if (this.humanResource) rs.humanResourceId = this.humanResource.id;
        if (this.bookingService) rs.bookingServiceId = this.bookingService.id;
        rs.usedQuantity = this.usedQuantity;
        return rs;
    };

    CureItemToServiceUsage.prototype.loadRef = function (isApplicationLoading) {
        this.humanResource = HumanResourceData.getById(this._humanResourceId);
        this.bookingService = ActivityData.getById(this._bookingServiceId, isApplicationLoading);
        if (this.bookingService) this.bookingService.cureItemToServiceUsage = this;
    };
    CureItemToServiceUsage.prototype.getId = function () {
        return this.id;
    };
    CureItemToServiceUsage.prototype.setId = function (id) {
        this.id = id;
    };
    return CureItemToServiceUsage;
}]);

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsageSrv', ["$log", "ServerSrv", "CureItemToServiceUsage_Resource", "CureItemToServiceUsage", "UserActionData", "CureItemToServiceUsageData", "CureItemToServiceData", function ($log, ServerSrv, CureItemToServiceUsage_Resource, CureItemToServiceUsage, UserActionData, CureItemToServiceUsageData, CureItemToServiceData) {
    var cureItemToServiceUsageSrv = {};

    cureItemToServiceUsageSrv.save = function (cureItemToServiceUsage, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(cureItemToServiceUsageSrv.saveSync, cureItemToServiceUsage, successFunction, errorFunction);
    };
    cureItemToServiceUsageSrv.saveSync = function (cureItemToServiceUsage, successFunction, errorFunction) {
        //$timeout (function () {

        var CureItemToServiceUsageRes = cureItemToServiceUsage.getObjectResource();
        CureItemToServiceUsageRes.$save({}, //no params
        function (data) {
            try {
                if (cureItemToServiceUsage.id == null) {
                    cureItemToServiceUsage.setId(data.id);
                }
                if (!cureItemToServiceUsage.version || data.version && data.version > cureItemToServiceUsage.version) cureItemToServiceUsage.version = data.version;
                /** @namespace data.supplierId */
                if (data.supplierId && cureItemToServiceUsage.supplier) cureItemToServiceUsage.supplier.id = data.supplierId;

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    cureItemToServiceUsageSrv.remove = function (cureItemToServiceUsage, successFunction, errorFunction) {
        CureItemToServiceUsageData.remove(cureItemToServiceUsage);
        ServerSrv.startSavingProcess(cureItemToServiceUsageSrv.removeSync, cureItemToServiceUsage, successFunction, errorFunction);
    };
    cureItemToServiceUsageSrv.removeSync = function (cureItemToServiceUsage, successFunction, errorFunction) {
        //$timeout (function () {

        var cureItemToServiceUsageRes = new CureItemToServiceUsage_Resource();
        cureItemToServiceUsageRes.$remove({ id: cureItemToServiceUsage.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    cureItemToServiceUsageSrv.restore = function (cureItemToServiceUsage, successFunction, errorFunction) {
        CureItemToServiceUsageData.restore(cureItemToServiceUsage);
        ServerSrv.startSavingProcess(cureItemToServiceUsageSrv.restoreSync, cureItemToServiceUsage, successFunction, errorFunction);
    };
    cureItemToServiceUsageSrv.restoreSync = function (cureItemToServiceUsage, successFunction, errorFunction) {
        var cureItemToServiceUsageRes = cureItemToServiceUsage.getObjectResource();
        cureItemToServiceUsageRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    cureItemToServiceUsageSrv.query = function (successFunction, errorFunction) {
        CureItemToServiceUsage_Resource.getDeleted({}, //params
        function (data) {
            //success

            CureItemToServiceUsageData.deletedCureItemToServiceUsages = [];
            for (var i = 0; i < data.length; i++) {
                new CureItemToServiceUsage(data[i]);
            } //Auto Add to CureItemToServiceUsageData

            if (successFunction !== undefined) successFunction(CureItemToServiceUsageData.categoryRoot);
        }, function (data) {
            //failure
            $log.error("CureItemToServiceUsage_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    cureItemToServiceUsageSrv.loadRef = function (isApplicationLoading) {
        var cureItemToServiceUsages = CureItemToServiceUsageData.indexCureItemToServiceUsages;
        for (var i = 0; i < cureItemToServiceUsages.length; i++) {
            cureItemToServiceUsages[i].loadRef(isApplicationLoading);
        }
    };
    cureItemToServiceUsageSrv.updateLocally = function (id, resource) {
        var cureItemToServiceUsage = CureItemToServiceUsageData.getById(id);
        if (cureItemToServiceUsage != null) {
            cureItemToServiceUsage.loadObject(resource);
        }
        return cureItemToServiceUsage;
    };
    cureItemToServiceUsageSrv.addLocally = function (id, resource) {
        var cureItemToServiceUsage = CureItemToServiceUsageData.getById(id);
        if (cureItemToServiceUsage != null) cureItemToServiceUsage.loadObject(resource);else {
            cureItemToServiceUsage = new CureItemToServiceUsage(resource);
            cureItemToServiceUsage.id = id;
        }
        cureItemToServiceUsage.loadRef();
        if (resource.cureItemToServiceId) {
            var cureItemToService = CureItemToServiceData.getById(resource.cureItemToServiceId);
            if (cureItemToService) cureItemToService.addCureItemToServiceUsage(cureItemToServiceUsage);
        }
        return cureItemToServiceUsage;
    };
    cureItemToServiceUsageSrv.removeLocally = function (id, resource) {
        var cureItemToServiceUsage = CureItemToServiceUsageData.getById(id);
        if (cureItemToServiceUsage != null) {
            //remove from cureItemToService
            if (cureItemToServiceUsage.cureItemToService) cureItemToServiceUsage.cureItemToService.removeCureItemToServiceUsage(cureItemToServiceUsage);
        }
        return cureItemToServiceUsage;
    };

    return cureItemToServiceUsageSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsageData', ["$log", function ($log) {
    var cureItemToServiceUsageData = {
        indexCureItemToServiceUsages: [], //Used as Index
        deletedCureItemToServiceUsages: []
    };
    cureItemToServiceUsageData.getById = function (cureItemToServiceUsageId) {
        for (var i = 0; i < this.indexCureItemToServiceUsages.length; i++) {
            if (this.indexCureItemToServiceUsages[i].id == cureItemToServiceUsageId) return this.indexCureItemToServiceUsages[i];
        }return null;
    };
    cureItemToServiceUsageData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexCureItemToServiceUsages.length) {
            return this.indexCureItemToServiceUsages[servIndex];
        } else return null;
    };
    cureItemToServiceUsageData.getIndexOf = function (cureItemToServiceUsage) {
        if (cureItemToServiceUsage) return this.indexCureItemToServiceUsages.indexOf(cureItemToServiceUsage);
        return -1;
    };
    cureItemToServiceUsageData.add = function (cureItemToServiceUsage) {
        this.indexCureItemToServiceUsages.push(cureItemToServiceUsage);
        if (cureItemToServiceUsage.isDeleted) {
            var index = this.deletedCureItemToServiceUsages.indexOf(cureItemToServiceUsage);
            if (index == -1) this.deletedCureItemToServiceUsages.push(cureItemToServiceUsage);
        }
        return this.indexCureItemToServiceUsages.length - 1;
    };
    cureItemToServiceUsageData.remove = function (cureItemToServiceUsage) //Soft Remove
    {
        var index = this.deletedCureItemToServiceUsages.indexOf(cureItemToServiceUsage);
        if (index == -1) {
            this.deletedCureItemToServiceUsages.push(cureItemToServiceUsage);
            cureItemToServiceUsage.isDeleted = true;
        }
    };
    cureItemToServiceUsageData.restore = function (cureItemToServiceUsage) //Soft Remove
    {
        var index = this.deletedCureItemToServiceUsages.indexOf(cureItemToServiceUsage);
        if (index != -1) {
            this.deletedCureItemToServiceUsages.splice(index, 1);
            cureItemToServiceUsage.isDeleted = false;
        }
    };
    cureItemToServiceUsageData.clear = function () {
        cureItemToServiceUsageData.indexCureItemToServiceUsages = [];
        cureItemToServiceUsageData.deletedCureItemToServiceUsages = [];
    };
    cureItemToServiceUsageData.getDeletedList = function () {
        return cureItemToServiceUsageData.deletedCureItemToServiceUsages;
    };

    return cureItemToServiceUsageData;
}]);

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

var PromisePool = __webpack_require__(788);

angular.module('FlexyBeautyApp.services').factory('Customer_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/customers/:id', {}, {
        query: { method: 'GET', isArray: true },
        queryByCursor: { method: 'GET', isArray: false, url: baseUrl + 'rest/customers/queryByCursor/:cursorNumber' },
        queryByCursorDeleted: { method: 'GET', isArray: false, url: baseUrl + 'rest/customers/queryByCursorDeleted/:cursorNumber' },
        nbCustomers: { method: 'GET', isArray: false, url: baseUrl + 'rest/customers/nbCustomers' },
        listFromOffset: { method: 'POST', isArray: false, url: baseUrl + 'rest/customers/listFromOffset' },
        get: { method: 'GET' },
        getById: { method: 'GET', isArray: false, url: baseUrl + 'rest/customers/byId/:id' },
        getByEmail: { method: 'GET', isArray: false, url: baseUrl + 'rest/customers/byEmail/:email' },
        getByPhone: { method: 'GET', isArray: false, url: baseUrl + 'rest/customers/byPhone/:phone' },
        getBookings: { method: 'GET', isArray: true, url: baseUrl + 'rest/customers/:id/bookings' },
        getSales: { method: 'GET', isArray: true, url: baseUrl + 'rest/customers/:id/sales' },
        getGiftItems: { method: 'GET', isArray: true, url: baseUrl + 'rest/customers/:id/giftItems' },
        getCardRegistration: { method: 'GET', isArray: false, url: baseUrl + 'rest/customers/:id/getCardRegistration' },
        login: { method: 'POST', url: baseUrl + 'rest/customers/login' },
        logout: { method: 'POST', url: baseUrl + 'rest/customers/logout' },
        register: { method: 'POST', url: baseUrl + 'rest/customers/register' },
        saveAccount: { method: 'POST', url: baseUrl + 'rest/customers/saveAccount' },
        saveOptInOut: { method: 'POST', url: baseUrl + 'rest/customers/saveOptInOut' },
        fusion: { method: 'POST', url: baseUrl + 'rest/customers/fusion' },
        forgotPwd: { method: 'POST', url: baseUrl + 'rest/customers/forgotPwd' },
        changePwd: { method: 'POST', url: baseUrl + 'rest/customers/changePwd' },
        sendSmsActivationCode: { method: 'POST', url: baseUrl + 'rest/customers/sendSmsActivationCode' },
        emptyGarbage: { method: 'POST', url: baseUrl + 'rest/customers/emptyGarbage' }
    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('Customer', ["Customer_Resource", "CustomerData", "OptInOut", "PhoneFormat", function (Customer_Resource, CustomerData, OptInOut, PhoneFormat) {
    var Customer = function Customer(resource, isApplicationLoading) {
        this.id = null;
        this.idReserveWithGoogle = null;
        this.isDeleted = false;
        this.lastName = null;
        this.firstName = null;
        this.gender = null;
        this.email = null;
        this.comment = null;
        this.isVerified = false;
        this.phone = null;
        this.password = null;
        this.address1 = null;
        this.address2 = null;
        this.city = null;
        this.postCode = null;
        this.origin = null;
        this.online = null;
        this.isBirthDate = false;
        this.birthDate = null;
        this.bookings = []; // generate a local link to booking
        this.sales = []; // generate a local link to sales
        this.giftItems = []; // generate a local link to giftItem (beneficiaries)
        this.hasWebPwd = false;
        this.hasMobileApp = false;
        this.version = null;
        this.optInOut = null;
        this.isCGVAccepted = null;
        this.customerLabelSearch = null;
        this.customerInterNationalMobileNumber = null;
        this.customerNationalMobileNumber = null;
        this.customerInterNationalLandlineNumber = null;
        this.customerNationalLandlineNumber = null;
        this.loadObject(resource);
        CustomerData.add(this, isApplicationLoading);
    };

    Customer.prototype.loadCustomerLabelSearch = function (customer) {
        this.customerLabelSearch = customer.lastName + " " + customer.firstName + " | ";
        if (customer.phone) {
            var phone = customer.phoneDisplay = PhoneFormat.formatNumberWithoutCountry(customer.phone);
            this.customerLabelSearch += phone;
        } else if (customer.landline) {
            this.customerLabelSearch += PhoneFormat.formatNumberWithoutCountry(customer.landline);
        }
    };

    Customer.prototype.createInterNationalAndNationalPhoneFormat = function () {
        this.customerNationalMobileNumber = PhoneFormat.returnNationalFormat(this.phone).replace(/\s/g, '');
        this.customerInterNationalMobileNumber = PhoneFormat.returnInternationalFormat(this.phone).replace(/\s/g, '');
        this.customerInterNationalLandlineNumber = PhoneFormat.returnInternationalFormat(this.landline).replace(/\s/g, '');
        this.customerNationalLandlineNumber = PhoneFormat.returnNationalFormat(this.landline).replace(/\s/g, '');
    };

    Customer.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.idReserveWithGoogle = object.idReserveWithGoogle;
            this.isDeleted = object.isDeleted;
            this.lastName = object.lastName;
            this.firstName = object.firstName;
            this.gender = object.gender;
            this.email = object.email;
            this.comment = object.comment;
            this.isVerified = object.isVerified;
            this.phone = object.phone;
            this.landline = object.landline;
            this.createInterNationalAndNationalPhoneFormat();
            this.loadCustomerLabelSearch(object);
            this.address1 = object.address1;
            this.address2 = object.address2;
            this.city = object.city;
            this.postCode = object.postCode;
            this.origin = object.origin;
            this.online = object.online;
            this.hasWebPwd = object.hasWebPwd;
            this.hasMobileApp = object.hasMobileApp;
            this.isCGVAccepted = object.isCGVAccepted;
            this.isBirthDate = object.isBirthDate;
            if (object.birthDate) this.birthDate = new Date(object.birthDate);
            if (object.version) this.version = object.version;
            if (object.optInOut) this.optInOut = new OptInOut(object.optInOut, this.id);
        }
    };
    Customer.prototype.getObjectResource = function () {
        var rsCustomer = new Customer_Resource();
        rsCustomer.id = this.id;
        rsCustomer.idReserveWithGoogle = this.idReserveWithGoogle;
        rsCustomer.isDeleted = this.isDeleted;
        rsCustomer.firstName = this.firstName;
        rsCustomer.lastName = this.lastName;
        rsCustomer.gender = this.gender;
        rsCustomer.email = this.email;
        rsCustomer.comment = this.comment;
        rsCustomer.isVerified = this.isVerified;
        rsCustomer.phone = this.phone;
        rsCustomer.landline = this.landline;
        rsCustomer.address1 = this.address1;
        rsCustomer.address2 = this.address2;
        rsCustomer.city = this.city;
        rsCustomer.postCode = this.postCode;
        rsCustomer.origin = this.origin;
        rsCustomer.online = this.online;
        rsCustomer.isBirthDate = this.isBirthDate;
        rsCustomer.birthDate = this.birthDate;

        return rsCustomer;
    };
    Customer.prototype.getRegisterRequest = function () {
        var rsCustomer = new Customer_Resource();
        rsCustomer.id = this.id;
        rsCustomer.idReserveWithGoogle = this.idReserveWithGoogle;
        rsCustomer.firstName = this.firstName;
        rsCustomer.lastName = this.lastName;
        rsCustomer.email = this.email;
        rsCustomer.isVerified = this.isVerified;
        rsCustomer.phone = this.phone;
        rsCustomer.landline = this.landline;
        rsCustomer.address1 = this.address1;
        rsCustomer.address2 = this.address2;
        rsCustomer.city = this.city;
        rsCustomer.postCode = this.postCode;
        rsCustomer.password = this.password;
        rsCustomer.currentPassword = this.currentPassword;
        rsCustomer.isBirthDate = this.isBirthDate;
        rsCustomer.birthDate = this.birthDate;
        rsCustomer.gender = this.gender;
        rsCustomer.isCGVAccepted = this.isCGVAccepted;
        rsCustomer.optInOut = this.optInOut;
        return rsCustomer;
    };
    Customer.prototype.getLoginRequest = function () {
        var rsCustomer = new Customer_Resource();
        rsCustomer.email = this.email;
        rsCustomer.phone = this.phone;
        rsCustomer.password = this.password;
        return rsCustomer;
    };
    Customer.prototype.getId = function () {
        return this.id;
    };
    Customer.prototype.getLabel = function () {
        return this.firstName + ' ' + this.lastName;
    };
    Customer.prototype.getPhone = function () {
        return this.phone;
    };

    Customer.prototype.getEmail = function () {
        return this.email;
    };

    Customer.prototype.setId = function (id) {
        this.id = id;
    };

    Customer.prototype.addBooking = function (booking) {
        var index = this.bookings.indexOf(booking);
        //Not already there
        if (index === -1) {
            this.bookings.push(booking);
        }
    };

    Customer.prototype.removeBooking = function (booking) {
        var index = this.bookings.indexOf(booking);
        //Found
        if (index !== -1) {
            this.bookings.splice(index, 1);
        }
    };

    Customer.prototype.addSale = function (sale) {
        var index = this.sales.indexOf(sale);
        //Not already there
        if (index === -1) {
            this.sales.push(sale);
        }
    };

    /**
     * Check if the customer has bought an item (product, service, cure, ...).
     *
     * @param itemView the itemView
     *
     * return boolean
     */
    Customer.prototype.hasBoughtItem = function (itemView) {
        if (itemView && itemView.categoryType && itemView.getModel()) {
            return this.sales.some(function (sale) {
                return sale.hasItemByIdAndType(itemView.getModel().id, itemView.categoryType) == true;
            });
        }
        return false;
    };

    Customer.prototype.removeSale = function (sale) {
        var index = this.sales.indexOf(sale);
        //Found
        if (index !== -1) {
            this.sales.splice(index, 1);
        }
    };

    Customer.prototype.addGiftItem = function (giftItem) {
        var index = this.giftItems.indexOf(giftItem);
        //Not already there
        if (index === -1) {
            this.giftItems.push(giftItem);
        }
    };

    Customer.prototype.removeGiftItem = function (giftItem) {
        var index = this.giftItems.indexOf(giftItem);
        if (index !== -1) //Found
            {
                this.giftItems.splice(index, 1);
            }
    };

    Customer.prototype.hasSaleBefore = function (day, currentBooking) {
        return this.getLoyaltySalesOfPeriod(null, day, null, currentBooking).length > 0;
    };

    Customer.prototype.hasSaleBetween = function (firstDay, endDay, currentBooking, saleObjects, additionalFilters, currentDay) {
        return this.getLoyaltySalesOfPeriod(firstDay, endDay, null, currentBooking, saleObjects, additionalFilters, currentDay).length > 0;
    };

    Customer.prototype.getLoyaltySalesOfPeriod = function (beginDay, endDay, hrId, currentBooking, saleObjects, additionalFilters, currentDay) {
        var salesOfperiod = [];
        for (var i = 0; i < this.sales.length; i++) {
            if (this.sales[i].day && (beginDay && this.sales[i].day.id >= beginDay.id || !beginDay) && (endDay && this.sales[i].day.id < endDay.id || !endDay) && (!hrId || hrId && this.sales[i].hrIsWorking(hrId)) && (!currentBooking || currentBooking && (!currentBooking.sale || currentBooking.sale !== this.sales[i])) && !this.sales[i].isCancelledOrCredit()) {
                if (!saleObjects && !additionalFilters) {
                    salesOfperiod.push(this.sales[i]);
                } else {
                    for (var j = 0; j < this.sales[i].saleServices.length; j++) {
                        if (this.sales[i].saleServices[j].subSaleServices.length === 0) {
                            if (this.sales[i].saleServices[j].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)) {
                                if (salesOfperiod.indexOf(this.sales[i]) === -1) {
                                    salesOfperiod.push(this.sales[i]);
                                }
                            }
                        } else {
                            for (var k = 0; k < this.sales[i].saleServices[j].subSaleServices.length; k++) {
                                if (this.sales[i].saleServices[j].subSaleServices[k].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)) {
                                    if (salesOfperiod.indexOf(this.sales[i]) === -1) {
                                        salesOfperiod.push(this.sales[i]);
                                    }
                                }
                            }
                        }
                    }
                    for (var _j = 0; _j < this.sales[i].saleProducts.length; _j++) {
                        if (this.sales[i].saleProducts[_j].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)) {
                            if (salesOfperiod.indexOf(this.sales[i]) === -1) {
                                salesOfperiod.push(this.sales[i]);
                            }
                        }
                    }

                    for (var _j2 = 0; _j2 < this.sales[i].saleCures.length; _j2++) {
                        if (this.sales[i].saleCures[_j2].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)) {
                            if (salesOfperiod.indexOf(this.sales[i]) === -1) {
                                salesOfperiod.push(this.sales[i]);
                            }
                        }
                    }

                    for (var _j3 = 0; _j3 < this.sales[i].loyaltyCardItems.length; _j3++) {
                        if (this.sales[i].loyaltyCardItems[_j3].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)) {
                            if (salesOfperiod.indexOf(this.sales[i]) === -1) {
                                salesOfperiod.push(this.sales[i]);
                            }
                        }
                    }

                    for (var _j4 = 0; _j4 < this.sales[i].giftItems.length; _j4++) {
                        if (this.sales[i].giftItems[_j4].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)) {
                            if (salesOfperiod.indexOf(this.sales[i]) === -1) {
                                salesOfperiod.push(this.sales[i]);
                            }
                        }
                    }
                }
            }
        }
        return salesOfperiod;
    };

    Customer.prototype.hasBookingBefore = function (day, currentSale) {
        return this.getLoyaltyBookingsOfPeriod(null, day, null, currentSale).length > 0;
    };

    Customer.prototype.hasBookingBetween = function (firstDay, endDay, currentSale, bookingObjects, additionalFilters) {
        return this.getLoyaltyBookingsOfPeriod(firstDay, endDay, null, currentSale, bookingObjects, additionalFilters).length > 0;
    };

    Customer.prototype.getLoyaltyBookingsOfPeriod = function (beginDay, endDay, hrId, currentSale, bookingObjects, additionalFilters) {
        var bookingsOfperiod = [];
        for (var i = 0; i < this.bookings.length; i++) {
            if (this.bookings[i].day && (beginDay && this.bookings[i].day.id >= beginDay.id || !beginDay) && (endDay && this.bookings[i].day.id < endDay.id || !endDay) && (!hrId || hrId && this.bookings[i].hrIsWorking(hrId)) && (!currentSale || currentSale && (!currentSale.booking || currentSale.booking != this.bookings[i])) && this.bookings[i].status !== "notCame") {

                if (!bookingObjects && !additionalFilters) {
                    bookingsOfperiod.push(this.bookings[i]);
                } else {
                    for (var j = 0; j < this.bookings[i].bookingServices.length; j++) {
                        if (this.bookings[i].bookingServices[j].isPackage && this.bookings[i].bookingServices[j].subBookingServices.length > 0) {
                            for (var k = 0; k < this.bookings[i].bookingServices[j].subBookingServices.length; k++) {
                                if (this.bookings[i].bookingServices[j].subBookingServices[k].matchAllBookingObjects(bookingObjects, additionalFilters, beginDay)) {
                                    if (bookingsOfperiod.indexOf(this.bookings[i]) === -1) {
                                        bookingsOfperiod.push(this.bookings[i]);
                                    }
                                }
                            }
                        } else {
                            if (this.bookings[i].bookingServices[j].matchAllBookingObjects(bookingObjects, additionalFilters, beginDay)) {
                                if (bookingsOfperiod.indexOf(this.bookings[i]) === -1) {
                                    bookingsOfperiod.push(this.bookings[i]);
                                }
                            }
                        }
                    }
                }
            }
        }
        return bookingsOfperiod;
    };

    return Customer;
}]);

angular.module('FlexyBeautyApp.services').factory('CustomerSrv', ["$log", "Customer_Resource", "UserActionData", "Customer", "CustomerData", "Booking", "DayData", "Day", "ServerSrv", "Sale", "GiftItem", "BookingSrv", "SaleSrv", "BookingData", "SaleData", "CureItemToServiceSrv", "GiftItemData", "gettextCatalog", "Decorators", "TimeMeasures", "Constants", "$http", function ($log, Customer_Resource, UserActionData, Customer, CustomerData, Booking, DayData, Day, ServerSrv, Sale, GiftItem, BookingSrv, SaleSrv, BookingData, SaleData, CureItemToServiceSrv, GiftItemData, gettextCatalog, Decorators, TimeMeasures, Constants, $http) {
    var _this = this;

    var customerSrv = {};

    //FIXME : not used, need to be delete
    customerSrv.query = function (successFunction, errorFunction) {
        Customer_Resource.query({}, //params
        function (data) {
            //success

            for (var i = 0; i < data.length; i++) {
                new Customer(data[i]); //Auto Add to CustomerData
            }
            if (successFunction !== undefined) {
                successFunction(CustomerData.customers);
            }
        }, function (data) {
            //failure
            $log.error("Customer_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    customerSrv.getCustomerExport = function () {
        return $http({
            method: "GET", url: 'rest/v2/customers/export?format=XLSX',
            params: { 'format': Constants.EXPORT_FORMAT.XLSX, 'timezone': 'Europe/Paris' },
            responseType: 'blob'
        });
    };
    //FIXME : not used, need to be delete
    customerSrv.queryByCursor = function (cursorNumber, successFunction, errorFunction) {
        Customer_Resource.queryByCursor({ cursorNumber: cursorNumber }, //params
        function (customerCursorInterface) {
            if (customerCursorInterface.customers) for (var i = 0; i < customerCursorInterface.customers.length; i++) {
                new Customer(customerCursorInterface.customers[i]);
            } //Auto Add to CustomerData

            if (customerCursorInterface.nextCursorNumber) customerSrv.queryByCursor(customerCursorInterface.nextCursorNumber, successFunction, errorFunction);else //finish
                if (successFunction !== undefined) successFunction(CustomerData.customers);
        }, function (data) {
            //failure
            $log.error("Customer_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    customerSrv.loadDeletedCustomersMaster = Decorators.timeMeasureDecorator(function (cursorNumber, isApplicationLoading) {
        return customerSrv.loadDeletedCustomers(cursorNumber, isApplicationLoading);
    }, TimeMeasures.DELETED_CUSTOMERS_LOADING);

    customerSrv.loadDeletedCustomers = function (cursorNumber, isApplicationLoading) {
        return Customer_Resource.queryByCursorDeleted({ cursorNumber: cursorNumber }).$promise.then(function (deletedCustomersResponse) {
            if (deletedCustomersResponse.customers) {
                for (var i = 0; i < deletedCustomersResponse.customers.length; i++) {
                    new Customer(deletedCustomersResponse.customers[i], isApplicationLoading); //Auto Add to CustomerData
                }
            }
            if (deletedCustomersResponse.nextCursorNumber) {
                return customerSrv.loadDeletedCustomers(deletedCustomersResponse.nextCursorNumber, isApplicationLoading);
            }
        }, function (data) {
            $log.error("Customer_Resource.queryByCursorDeleted error");
            $log.error(data);
        });
    };

    customerSrv.loadCustomers = Decorators.timeMeasureDecorator(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(isApplicationLoading) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return customerSrv.getNbCustomers().then(function () {
                                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
                                    return regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return customerSrv.loadFromIds(data, isApplicationLoading);

                                                case 2:
                                                    return _context.abrupt('return', _context.sent);

                                                case 3:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                }));

                                return function (_x2) {
                                    return _ref2.apply(this, arguments);
                                };
                            }());

                        case 2:
                            return _context2.abrupt('return', _context2.sent);

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }(), TimeMeasures.CUSTOMERS_LOADING);

    customerSrv.getNbCustomers = function () {
        return Customer_Resource.nbCustomers({}).$promise;
    };

    customerSrv.loadFromIds = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, isApplicationLoading) {
            var nbCustomers, size, start, end, loaders, index, promiseProducer, pool, poolPromise;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            nbCustomers = data.size;

                            if (!(nbCustomers !== 0)) {
                                _context3.next = 14;
                                break;
                            }

                            size = 1000;
                            start = 0;
                            end = size - 1;
                            loaders = [];

                            while (start < nbCustomers) {
                                if (end > nbCustomers) end = nbCustomers - 1;
                                loaders.push({ loading: true, start: start, end: end });
                                start = end + 1;
                                end += size;
                            }

                            index = -1;

                            promiseProducer = function promiseProducer() {
                                index++;
                                if (index < loaders.length) {
                                    return customerSrv.listFromOffset(loaders[index].start, loaders[index].end - loaders[index].start + 1).then(function (customerList) {
                                        if (customerList && customerList.customers) {
                                            for (var j = 0; j < customerList.customers.length; j++) {
                                                new Customer(customerList.customers[j], isApplicationLoading);
                                            }
                                        }
                                    });
                                } else {
                                    return null;
                                }
                            };

                            pool = new PromisePool(promiseProducer, 10);
                            poolPromise = pool.start();
                            return _context3.abrupt('return', poolPromise);

                        case 14:
                            return _context3.abrupt('return', Promise.resolve());

                        case 15:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        return function (_x3, _x4) {
            return _ref3.apply(this, arguments);
        };
    }();

    customerSrv.listFromOffset = function (start, size) {
        return new Promise(function (resolve, reject) {
            var rs = new Customer_Resource();
            rs.start = start;
            rs.size = size;
            rs.$listFromOffset({}, //params
            function (data) {
                resolve(data);
            }, function (data) {
                reject(data);
            });
        });
    };

    customerSrv.save = function (customer, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(customerSrv.saveSync, customer, successFunction, errorFunction);
    };

    customerSrv.saveSync = function (customer, successFunction, errorFunction) {
        var CustomerRes = customer.getObjectResource();
        CustomerRes.$save({}, //no params
        function (data) {
            try {
                customer.setId(data.id);
                if (!customer.version || data.version && data.version > customer.version) customer.version = data.version;
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    customerSrv.fusion = function (customerSource, customerTarget, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(customerSrv.fusionSync, customerSource, customerTarget, successFunction, errorFunction);
    };
    customerSrv.fusionSync = function (customerSource, customerTarget, successFunction, errorFunction) {
        //$timeout (function () {
        if (customerSource && customerTarget) {
            var rsCustomerFusion = new Customer_Resource();
            rsCustomerFusion.customerSourceId = customerSource.id;
            rsCustomerFusion.customerTargetId = customerTarget.id;
            rsCustomerFusion.$fusion({}, //no params
            function (data) {
                try {
                    if (successFunction != undefined) successFunction(data);
                } finally {
                    ServerSrv.endSavingProcess(true);
                }
            }, function (data) {
                //failure
                //error handling goes here
                try {
                    if (errorFunction != undefined) errorFunction(data);
                } finally {
                    ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
                }
            });
        }

        //},2000)
    };
    customerSrv.remove = function (customer, successFunction, errorFunction) {
        CustomerData.remove(customer);
        ServerSrv.startSavingProcess(customerSrv.removeSync, customer, successFunction, errorFunction);
    };
    customerSrv.removeSync = function (customer, successFunction, errorFunction) {
        var customerSrv = new Customer_Resource();
        customerSrv.$remove({ id: customer.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    customerSrv.emptyGarbage = function (successFunction, errorFunction) {
        ServerSrv.startSavingProcess(customerSrv.emptyGarbageSync, successFunction, errorFunction);
    };
    customerSrv.emptyGarbageSync = function (successFunction, errorFunction) {
        Customer_Resource.emptyGarbage({}, //params : id
        function (data) {
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    customerSrv.restore = function (customer, successFunction, errorFunction) {
        CustomerData.restore(customer);
        ServerSrv.startSavingProcess(customerSrv.restoreSync, customer, successFunction, errorFunction);
    };
    customerSrv.restoreSync = function (customer, successFunction, errorFunction) {
        //$timeout (function () {

        var CustomerRes = customer.getObjectResource();
        CustomerRes.$save({}, //no params
        function (data) {
            try {
                customer.setId(data.id);
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    customerSrv.get = function (id, successFunction, errorFunction) {
        Customer_Resource.get({ id: id }, //params
        function (customerResource) {
            if (successFunction != undefined) successFunction(new Customer(customerResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };
    customerSrv.getData = function (customer, successFunction, errorFunction) {
        Customer_Resource.get({ id: customer.id }, //params
        function (customerResource) {
            customer.loadObject(customerResource);
            if (successFunction != undefined) successFunction(customer);
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };
    customerSrv.loadRelatedData = function (customer, endFunction) {
        customerSrv.loader = { bookingDataLoaded: false,
            saleDataLoaded: false,
            giftItemDataLoaded: false
        };
        BookingData.clear();
        SaleData.clear();
        if (customer) {
            customer.bookings = []; // generate a local link to booking
            customer.sales = []; // generate a local link to booking
            customer.giftItems = []; // generate a local link to giftItem (beneficiaries)
            customerSrv.getBookings(customer, function () {
                customerSrv.loader.bookingDataLoaded = true;
                customerSrv.finalizeLoadRelatedData(endFunction);
            });
            customerSrv.getSales(customer, function () {
                customerSrv.loader.saleDataLoaded = true;
                customerSrv.finalizeLoadRelatedData(endFunction);
            });
            customerSrv.getGiftItems(customer, function () {
                customerSrv.loader.giftItemDataLoaded = true;
                customerSrv.finalizeLoadRelatedData(endFunction);
            });
        }
    };
    customerSrv.finalizeLoadRelatedData = function (endFunction) {
        if (customerSrv.loader.saleDataLoaded & customerSrv.loader.giftItemDataLoaded && customerSrv.loader.bookingDataLoaded) {
            BookingSrv.loadRef();
            SaleSrv.loadRef();
            CureItemToServiceSrv.loadRef();
            endFunction();
        }
    };
    customerSrv.getBookings = function (customer, endFunction) {
        if (customer && customer.id) Customer_Resource.getBookings({ id: customer.id }, //params
        function (bookingResources) {
            //success

            customer.bookings = [];
            var bookings = [];
            for (var i = 0; i < bookingResources.length; i++) {
                var day = null;
                if (bookingResources[i] !== undefined && bookingResources[i] != null && bookingResources[i].dayId) {
                    day = DayData.getById(bookingResources[i].dayId);
                    if (!day) {
                        day = new Day();
                        day.id = bookingResources[i].dayId;
                        DayData.add(day);
                    }
                }
                var booking = new Booking(bookingResources[i], day, true);
                booking.loadRef(false);
                customer.addBooking(booking);
                booking.customer = customer;
                bookings.push(booking);
            }
            if (endFunction != undefined) endFunction(bookings);
        }, function (data) {
            //failure
            console.info("Error when pulling bookings for " + customer.id);
        });
    };
    customerSrv.getSales = function (customer, endFunction) {
        if (customer && customer.id) Customer_Resource.getSales({ id: customer.id }, //params
        function (saleResources) {
            //success

            customer.sales = [];
            var sales = [];
            for (var i = 0; i < saleResources.length; i++) {
                var day = null;
                if (saleResources[i] !== undefined && saleResources[i] != null && saleResources[i].dayId) {
                    day = DayData.getById(saleResources[i].dayId);
                    if (!day) {
                        day = new Day();
                        day.id = saleResources[i].dayId;
                        DayData.add(day);
                    }
                }
                var sale = new Sale(saleResources[i], day, true);
                customer.addSale(sale);
                sales.push(sale);
            }
            for (var _i = 0; _i < sales.length; _i++) {
                sales[_i].loadRef();
            }if (endFunction != undefined) endFunction(sales);
        }, function (data) {//failure
            //error handling goes here
            //TODO
        });
    };
    customerSrv.getGiftItems = function (customer, endFunction) {
        if (customer && customer.id) Customer_Resource.getGiftItems({ id: customer.id }, //params
        function (giftItemResources) {
            //success

            var giftItems = [];
            customer.giftItems = [];
            var giftItem = void 0;
            for (var i = 0; i < giftItemResources.length; i++) {
                giftItem = GiftItemData.getById(giftItemResources[i].id);
                if (!giftItem) giftItem = new GiftItem(giftItemResources[i]);
                customer.addGiftItem(giftItem);
                giftItems.push(giftItem);
            }
            if (endFunction != undefined) endFunction(giftItems);
        }, function (data) {//failure
            //error handling goes here
            //TODO
        });
    };
    customerSrv.getCardRegistration = function (customer, successFunction, errorFunction) {
        if (customer && customer.id) Customer_Resource.getCardRegistration({ id: customer.id }, //params
        function (data) {
            if (successFunction != undefined) successFunction(data);
        }, function (errorObj) {
            var message = "Undefined error";
            if (errorObj && errorObj.data && errorObj.data.consumerMessage) message = errorObj.data.consumerMessage;

            if (errorFunction != undefined) errorFunction(message);
        });
    };

    customerSrv.getById = function (id, successFunction, errorFunction) {
        Customer_Resource.getById({ id: id }, //params
        function (customerResource) {
            if (successFunction != undefined) successFunction(new Customer(customerResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };

    customerSrv.getByEmail = function (email, successFunction, errorFunction) {
        Customer_Resource.getByEmail({ email: email }, function (customerResource) {
            if (successFunction != undefined) successFunction(new Customer(customerResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };
    customerSrv.getByPhone = function (phone, successFunction, errorFunction) {
        Customer_Resource.getByPhone({ phone: phone }, //params
        function (customerResource) {
            if (successFunction != undefined) successFunction(new Customer(customerResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };
    customerSrv.sendSmsActivationCode = function (customer, successFunction, errorFunction) {
        var customerSrv = customer.getObjectResource();

        customerSrv.$sendSmsActivationCode({}, //params
        function (data) {
            if (successFunction != undefined) successFunction(data.smsActivationCode);
        }, function (data) {
            var errorMessage = "Echec";
            var errorCode = "";
            if (data.status) {
                if (data.status == "409") errorMessage = "Un compte possédant le même numéro de téléphone existe déjà";
                errorCode = data.status;
            }
            if (errorFunction != undefined) errorFunction(errorCode, errorMessage);
        });
    };
    customerSrv.login = function (customer, successFunction, errorFunction) {
        var customerSrv = customer.getLoginRequest();
        customerSrv.$login({}, //params
        function (data) {
            //success
            customer.setId(data.userId);
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var errorCode = data.status ? data.status : "";
            var errorMessage = gettextCatalog.getString("Echec de la connexion.");
            if (data.status && data.status == "401") {
                errorMessage = gettextCatalog.getString("Email / mot de passe incorrect");
            }
            if (errorFunction != undefined) errorFunction(errorCode, errorMessage);
        });
    };
    customerSrv.register = function (customer, successFunction, errorFunction) {
        var customerSrv = customer.getRegisterRequest();
        customerSrv.$register({}, //params
        function (data) {
            customer.setId(data.userId);
            if (successFunction != undefined) {
                successFunction(data);
            }
        }, function (data) {
            var errorMessage = gettextCatalog.getString("Création du compte impossible.");

            var errorCode = "";
            if (data.status && data.data) {
                if (data.status == "409") {
                    if (data.data.errorCode == "40901") errorMessage = gettextCatalog.getString("Création du compte impossible. Cet email est déjà utilisé.");
                    if (data.data.errorCode == "40902") errorMessage = gettextCatalog.getString("Création du compte impossible. Le numéro de téléphone est déjà utilisé.");
                    errorCode = data.data.errorCode;
                }
            }
            if (errorFunction != undefined) errorFunction(errorCode, errorMessage);
        });
    };
    customerSrv.saveAccount = function (customer, successFunction, errorFunction) {
        var customerSrv = customer.getRegisterRequest();
        customerSrv.$saveAccount({}, //params
        function (data) {
            customer.password = null;
            customer.currentPassword = null;
            if (successFunction != undefined) successFunction(customer);
        }, function (data) {
            customer.password = null;
            customer.currentPassword = null;
            var errorMessage = gettextCatalog.getString("Mise à jour du compte impossible. Vérifiez le mot de passe.");
            var errorCode = "";
            if (data.status && data.data) {
                if (data.status == "409") {
                    if (data.data.errorCode == "40901") errorMessage = gettextCatalog.getString("Mise à jour du compte impossible. Cet email est déjà utilisé.");
                    if (data.data.errorCode == "40902") errorMessage = gettextCatalog.getString("Mise à jour du compte impossible. Le numéro de téléphone est déjà utilisé.");
                    errorCode = data.data.errorCode;
                }
            }
            if (errorFunction != undefined) errorFunction(errorCode, errorMessage);
        });
    };
    customerSrv.changePwd = function (customer, successFunction, errorFunction) {
        var customerSrv = customer.getRegisterRequest();
        customerSrv.$changePwd({}, //params
        function (data) {
            customer.password = null;
            customer.currentPassword = null;
            if (successFunction != undefined) successFunction(customer);
        }, function (data) {
            customer.password = null;
            customer.currentPassword = null;
            var errorMessage = gettextCatalog.getString("Mise à jour du compte impossible.");
            var errorCode = "";
            if (errorFunction != undefined) errorFunction(errorCode, errorMessage);
        });
    };
    customerSrv.forgotPwd = function (email, successFunction, errorFunction) {
        var customerSrv = new Customer_Resource();
        customerSrv.email = email;
        customerSrv.$forgotPwd({}, //params
        function (data) {
            if (successFunction != undefined) successFunction(data);
        }, function (response) {
            //failure
            var data = response.data;
            if (errorFunction != undefined) {
                var accountNotExist = gettextCatalog.getString("Ce compte n'existe pas."),
                    errorMessage = gettextCatalog.getString("Echec de l'oubli de mot de passe.");

                if (data.errorCode) {
                    if (data.errorCode.startsWith("404")) {
                        errorMessage = accountNotExist;
                    }
                }
                errorFunction(errorMessage);
            }
        });
    };
    customerSrv.logout = function (customer, successFunction, errorFunction) {
        var customerSrv = new Customer_Resource();
        customerSrv.$logout({}, //params
        function (data) {
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var errorMessage = "Echec de la déconnexion.";
            if (errorFunction != undefined) errorFunction(errorMessage);
        });
    };
    customerSrv.updateLocally = function (id, resource) {
        var customer = CustomerData.getById(id);
        if (customer != null) customer.loadObject(resource);
        return customer;
    };
    customerSrv.removeLocally = function (id) {
        var customer = CustomerData.getById(id);
        if (customer != null) CustomerData.remove(customer);
        return customer;
    };
    customerSrv.addLocally = function (id, resource) {
        var customer = CustomerData.getById(id);
        if (customer != null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                customer.loadObject(resource);
                CustomerData.add(customer);
            } else {
            customer = new Customer(resource);
            customer.id = id;
        }
        return customer;
    };

    customerSrv.restoreLocally = function (id, resource) {
        var restoreCustomer = null;
        CustomerData.deletedCustomers = CustomerData.deletedCustomers.filter(function (customer) {
            if (customer.id === id) {
                restoreCustomer = customer;
                return false;
            }
            return true;
        });

        if (restoreCustomer) {
            restoreCustomer.isDeleted = false;
            CustomerData.add(restoreCustomer);
        }

        return restoreCustomer;
    };

    return customerSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CustomerData', ["$filter", "ModelDataUtil", function ($filter, ModelDataUtil) {
    var custDataSrv = {
        objCustomers: {},
        indexCustomers: [],
        activeCustomers: [],
        deletedCustomers: []
    };
    custDataSrv.getById = function (customerId, isApplicationLoading) {
        var customer = null;
        if (isApplicationLoading) {
            customer = this.objCustomers[customerId];
        } else {
            customer = this.indexCustomers.find(function (customer) {
                return customer.id == customerId;
            }) || null;
        }
        return customer;
    };

    custDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexCustomers.length) return this.indexCustomers[index];
        return null;
    };

    custDataSrv.getIndexOf = function (customer) {
        if (customer) return this.indexCustomers.indexOf(customer);
        return -1;
    };

    custDataSrv.add = function (customer, isApplicationLoading) {
        var realIndex = undefined,
            customerArray = this.activeCustomers;
        if (customer.isDeleted) customerArray = this.deletedCustomers;

        if (isApplicationLoading) {
            var key = void 0;
            if (customer != null && customer.id) {
                key = customer.id;
            }
            if (this.objCustomers[key] != null) {
                realIndex = customerArray.indexOf(customer);
            } else {
                this.objCustomers[key] = customer;
                customerArray.push(customer);
            }
        } else {
            var index = this.indexCustomers.indexOf(customer);
            if (index !== -1) {
                realIndex = customerArray.indexOf(customer);
            } else {
                if (customer.id && this.getById(customer.id) != null) //very rare to true (just security)
                    index = this.indexCustomers.indexOf(this.getById(customer.id));else {
                    this.indexCustomers.push(customer);
                    customerArray.push(customer);
                }
            }
        }
        if (realIndex === -1) customerArray.push(customer);
    };

    custDataSrv.remove = function (customer) {
        var index = this.activeCustomers.indexOf(customer);
        if (index !== -1) {
            this.activeCustomers.splice(index, 1);
            this.deletedCustomers.push(customer);
            customer.isDeleted = true;
        }
    };

    custDataSrv.restore = function (customer) {
        var index = this.deletedCustomers.indexOf(customer);
        if (index !== -1) {
            this.deletedCustomers.splice(index, 1);
            this.activeCustomers.push(customer);
            customer.isDeleted = false;
        }
    };

    custDataSrv.clear = function () {
        this.indexCustomers = [];
        this.activeCustomers = [];
        this.deletedCustomers = [];
    };

    custDataSrv.sort = function () {
        this.activeCustomers = $filter('orderBy')(this.activeCustomers, 'lastName', false);
        this.deletedCustomers = $filter('orderBy')(this.deletedCustomers, 'lastName', false);
    };

    custDataSrv.getActiveList = function () {
        return this.activeCustomers;
    };

    custDataSrv.getDeletedList = function () {
        return this.deletedCustomers;
    };

    custDataSrv.convertMapToArray = function (keepObject, isNewLoading) {
        if (isNewLoading) {
            this.indexCustomers = ModelDataUtil.convertObjectToArray(this.objCustomers, this.indexCustomers);
            if (!keepObject) {
                this.objCustomers = {};
            }
        } else {
            this.indexCustomers = ModelDataUtil.convertMapToArray(this.objCustomers, this.indexCustomers);
            this.objCustomers = null;
        }
    };

    custDataSrv.clearBookingsAndSales = function () {
        for (var customerId in this.objCustomers) {
            this.objCustomers[customerId].bookings = [];
            this.objCustomers[customerId].sales = [];
            this.objCustomers[customerId].giftItems = [];
        }
        this.activeCustomers.forEach(function (customer) {
            customer.bookings = [];
            customer.sales = [];
            customer.giftItems = [];
        });
    };

    return custDataSrv;
}]);

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: bastienrobinot
 * Date: 16/01/2018
 * Time: 18h01
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CustomerPost_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/customerPosts/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        save: { method: 'POST', url: baseUrl + 'rest/customerPosts/' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('CustomerPost', ["CustomerPost_Resource", "CustomerPostData", function (CustomerPost_Resource, CustomerPostData) {
    var CustomerPost = function CustomerPost(resource) {
        this.id = null, this.companyImageId = null, this.customerId = null, this.customerFirstName = null, this.customerLastName = null, this.fromDeviceId = null, this.rating = null, this.customerAuthPublish = false, this.proAuthPublish = false, this.timeCreated = null, this.timePublished = null, this.text = "", this.title = "", this.isDeleted = false;

        if (resource !== undefined && resource !== null) this.loadObject(resource);

        CustomerPostData.add(this);
    };

    CustomerPost.prototype.setId = function (id) {
        this.id = id;
    };
    CustomerPost.prototype.getId = function () {
        return this.id;
    };

    CustomerPost.prototype.loadObject = function (object) {
        if (object) {
            if (!this.id) this.id = object.id;
            if (object.companyImageId) this.companyImageId = object.companyImageId;
            if (object.customerId) this.customerId = object.customerId;
            if (object.customerFirstName) this.customerFirstName = object.customerFirstName;
            if (object.customerLastName) this.customerLastName = object.customerLastName;
            if (object.fromDeviceId) this.fromDeviceId = object.fromDeviceId;
            this.rating = object.rating;
            this.customerAuthPublish = object.customerAuthPublish;
            this.proAuthPublish = object.proAuthPublish;
            this.timeCreated = object.timeCreated;
            this.timePublished = object.timePublished;
            this.text = object.text;
            this.title = object.title;
            this.isDeleted = object.isDeleted;
        }
    };

    CustomerPost.prototype.getObjectResource = function () {
        var newPost = new CustomerPost_Resource();
        newPost.id = this.id;
        newPost.rating = this.rating;
        newPost.customerAuthPublish = this.customerAuthPublish;
        newPost.proAuthPublish = this.proAuthPublish;
        newPost.timeCreated = this.timeCreated;
        newPost.timePublished = this.timePublished;
        newPost.text = this.text;
        newPost.title = this.title;
        newPost.isDeleted = this.isDeleted;
        newPost.customerId = this.customerId;
        newPost.companyImageId = this.companyImageId;
        newPost.fromDeviceId = this.fromDeviceId;
        return newPost;
    };
    return CustomerPost;
}]);

angular.module('FlexyBeautyApp.services').factory('CustomerPostSrv', ["$log", "ServerSrv", "CustomerPost_Resource", "CustomerPostData", "CustomerPost", function ($log, ServerSrv, CustomerPost_Resource, CustomerPostData, CustomerPost) {
    var customerPostSrv = {};

    customerPostSrv.query = function (successFunction, errorFunction) {
        CustomerPost_Resource.query({}, //params
        function (data) {

            CustomerPostData.clear();
            for (var i = 0; i < data.length; i++) {
                new CustomerPost(data[i]);
            }

            if (successFunction !== undefined) successFunction();
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    customerPostSrv.save = function (customerPost, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(customerPostSrv.saveSync, customerPost, successFunction, errorFunction);
    };

    customerPostSrv.saveSync = function (customerPost, successFunction, errorFunction) {
        //$timeout (function () {

        var customerPostRes = customerPost.getObjectResource();
        customerPostRes.$save({}, //no params
        function (data) {
            try {
                customerPost.setId(data.id);
                if (successFunction !== undefined && successFunction !== null) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    customerPostSrv.remove = function (customerPost, successFunction, errorFunction) {
        CustomerPostData.remove(customerPost);
        ServerSrv.startSavingProcess(customerPostSrv.removeSync, customerPost, successFunction, errorFunction);
    };

    customerPostSrv.removeSync = function (customerPost, successFunction, errorFunction) {
        var customerPostRes = customerPost.getObjectResource();
        customerPostRes.$remove({ id: customerPost.getId() }, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    return customerPostSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CustomerPostData', ["$log", function ($log) {
    var customerPostData = {
        indexCustomerPosts: [], //Used as Index
        activeCustomerPosts: [],
        deletedCustomerPosts: []
    };

    customerPostData.getPostsByCustomerId = function (customerId) {
        var posts = [];
        for (var i = 0; i < this.activeCustomerPosts.length; i++) {
            if (this.activeCustomerPosts[i].customerId === customerId) posts.push(this.activeCustomerPosts[i]);
        }return posts;
    };

    customerPostData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexCustomerPosts.length) {
            return this.indexCustomerPosts[servIndex];
        }
        return null;
    };

    customerPostData.getById = function (customerPostId) {
        for (var i = 0; i < this.indexCustomerPosts.length; i++) {
            if (this.indexCustomerPosts[i].id === customerPostId) return this.indexCustomerPosts[i];
        }return null;
    };

    customerPostData.getIndexOf = function (customerPost) {
        if (customerPost) return this.indexCustomerPosts.indexOf(customerPost);
        return -1;
    };

    customerPostData.add = function (customerPost) {
        var customerPostArray = this.activeCustomerPosts;
        if (customerPost.isDeleted) customerPostArray = this.deletedCustomerPosts;
        var index = this.indexCustomerPosts.indexOf(customerPost);
        if (index !== -1) {
            var realIndex = customerPostArray.indexOf(customerPost);
            if (realIndex === -1) customerPostArray.push(customerPost);
        } else {
            index = this.indexCustomerPosts.length;
            this.indexCustomerPosts.push(customerPost);
            customerPostArray.push(customerPost);
        }
        return index;
    };

    //Soft Remove
    customerPostData.remove = function (customerPost) {
        var index = this.activeCustomerPosts.indexOf(customerPost);
        if (index !== -1) {
            this.activeCustomerPosts.splice(index, 1);
            this.deletedCustomerPosts.push(customerPost);
            customerPost.isDeleted = true;
        }
    };

    customerPostData.getActiveList = function () {
        return this.activeCustomerPosts;
    };

    customerPostData.clear = function () {
        customerPostData.indexCustomerPosts = [];
        customerPostData.activeCustomerPosts = [];
        customerPostData.deletedCustomerPosts = [];
    };

    customerPostData.getDeletedList = function () {
        return customerPostData.deletedCustomerPosts;
    };
    return customerPostData;
}]);

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('Dashboard_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/dashboard/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        export: { method: 'POST', url: baseUrl + 'rest/dashboard/:id/export' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Dashboard', ["Dashboard_Resource", "DashboardData", "DashboardScheduler", function (Dashboard_Resource, DashboardData, DashboardScheduler) {
    var Dashboard = function Dashboard(resource) {
        this.id = "";
        this.title = null;
        this.taxMode = null;
        this.isFlexy = false;
        this.isDeleted = false;

        this.jsonDetail = "";
        this.dashboardSchedulers = [];

        this.version = null;
        if (resource !== undefined && resource !== null) this.setValues(resource);

        DashboardData.add(this);
    };

    Dashboard.prototype.setId = function (id) {
        if (!this.id) this.id = id;
    };

    Dashboard.prototype.getId = function () {
        return this.id;
    };

    Dashboard.prototype.setValues = function (resource) {
        this.id = resource.id;
        this.title = resource.title;
        this.taxMode = resource.taxMode;
        this.isFlexy = resource.flexy;
        this.isDeleted = resource.isDeleted;

        this.jsonDetail = resource.jsonDetail;
        for (var i = 0; i < resource.dashboardSchedulers.length; i++) {
            this.dashboardSchedulers.push(new DashboardScheduler(resource.dashboardSchedulers[i], this.id));
        }
        if (resource.version) this.version = resource.version;
    };

    Dashboard.prototype.getObjectResource = function () {
        var newDashboard = new Dashboard_Resource();

        newDashboard.id = this.id;
        newDashboard.title = this.title;
        newDashboard.taxMode = this.taxMode;

        newDashboard.isDeleted = this.isDeleted;
        newDashboard.jsonDetail = this.jsonDetail;
        newDashboard.dashboardSchedulers = this.dashboardSchedulers;

        return newDashboard;
    };

    Dashboard.prototype.removeDashboardScheduler = function (dashboardScheduler) {
        var index = this.dashboardSchedulers.indexOf(dashboardScheduler);
        if (index != -1) //Found
            {
                this.dashboardSchedulers.splice(index, 1);
            }
    };

    Dashboard.prototype.addDashboardScheduler = function (dashboardScheduler) {
        if (dashboardScheduler) {
            var index = this.dashboardSchedulers.indexOf(dashboardScheduler);
            if (index == -1) //Not already there
                {
                    this.dashboardSchedulers.push(dashboardScheduler);
                    dashboardScheduler.dashboardId = this.id;
                }
        }
    };

    return Dashboard;
}]);

angular.module('FlexyBeautyApp.services').factory('DashboardSrv', ["$log", "ServerSrv", "Dashboard_Resource", "DashboardData", "UserActionData", "Dashboard", function ($log, ServerSrv, Dashboard_Resource, DashboardData, UserActionData, Dashboard) {
    var dashboardSrv = {};

    dashboardSrv.query = function (successFunction, errorFunction) {
        Dashboard_Resource.query({}, function (data) {

            DashboardData.clear();
            for (var i = 0; i < data.length; i++) {
                new Dashboard(data[i]);
            }

            if (successFunction !== undefined) successFunction();
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    dashboardSrv.save = function (dashboard, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(dashboardSrv.saveSync, dashboard, successFunction, errorFunction);
    };
    dashboardSrv.saveSync = function (dashboard, successFunction, errorFunction) {
        //$timeout (function () {

        var dashboardRes = dashboard.getObjectResource();
        dashboardRes.$save({}, //no params
        function (data) {
            try {
                dashboard.setId(data.id);
                if (!dashboard.version || data.version && data.version > dashboard.version) dashboard.version = data.version;
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    dashboardSrv.remove = function (dashboard, successFunction, errorFunction) {
        DashboardData.remove(dashboard);
        ServerSrv.startSavingProcess(dashboardSrv.removeSync, dashboard, successFunction, errorFunction);
    };
    dashboardSrv.removeSync = function (dashboard, successFunction, errorFunction) {
        //$timeout (function () {

        var dashboardRes = dashboard.getObjectResource();
        dashboardRes.$remove({ id: dashboard.getId() }, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    dashboardSrv.updateLocally = function (id, object) {
        var dashboard = DashboardData.getById(id);
        if (dashboard != null) {
            dashboard.setValues(object);
        }
        return dashboard;
    };

    dashboardSrv.addLocally = function (id, object) {
        var dashboard = DashboardData.getById(id);
        if (dashboard == null) {
            var dashboard = new Dashboard(object);
            dashboard.id = id;
        }
        return dashboard;
    };

    dashboardSrv.removeLocally = function (id, object) {
        var dashboard = DashboardData.getById(id);
        if (dashboard != null) {
            DashboardData.remove(dashboard);
        }
        return dashboard;
    };

    dashboardSrv.export = function (idDashboard, object, message, beginDayId, endDayId, emailList, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(dashboardSrv.exportDashboardSync, idDashboard, object, message, beginDayId, endDayId, emailList, successFunction, errorFunction);
    };

    dashboardSrv.exportDashboardSync = function (idDashboard, object, message, beginDayId, endDayId, emailList, successFunction, errorFunction) {
        //$timeout (function () {

        var dashboardRes = new Dashboard_Resource();
        dashboardRes.object = object;
        dashboardRes.message = message;
        dashboardRes.beginDayId = beginDayId;
        dashboardRes.endDayId = endDayId;
        dashboardRes.emailList = emailList;
        dashboardRes.$export({ id: idDashboard }, // params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    return dashboardSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('DashboardData', [function () {
    var dashboardData = {
        dashboardList: [], // dashboard list for the entire application
        deletedDashboardList: [] // deleted dashboard list for the entire application
    };
    dashboardData.getById = function (dashboardId) {
        for (var i = 0; i < this.dashboardList.length; i++) {
            if (this.dashboardList[i].id == dashboardId) return this.dashboardList[i];
        }return null;
    };
    dashboardData.getByIndex = function (dashboardIndex) {
        if (dashboardIndex >= 0 && dashboardIndex < this.dashboardList.length) {
            return this.dashboardList[dashboardIndex];
        } else return null;
    };
    dashboardData.getIndexOf = function (dashboard) {
        if (dashboard) return this.dashboardList.indexOf(dashboard);
        return -1;
    };
    dashboardData.add = function (dashboard) {
        if (!dashboard.isDeleted) this.dashboardList.push(dashboard);else this.deletedDashboardList.push(dashboard);
    };
    dashboardData.remove = function (dashboard) //Soft Remove
    {
        if (!dashboard.isDeleted) {
            var indexDashboardList = this.dashboardList.indexOf(dashboard);
            if (indexDashboardList != -1) {
                this.dashboardList.splice(indexDashboardList, 1);
                this.deletedDashboardList.push(dashboard);
                dashboard.isDeleted = true;
            }
        }
    };
    dashboardData.getDashboardList = function () {
        return this.dashboardList;
    };
    dashboardData.clear = function () {
        this.dashboardList = [];
        this.deletedDashboardList = [];
    };

    return dashboardData;
}]);

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('DashboardScheduler_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/dashboardScheduler/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('DashboardScheduler', ["DashboardScheduler_Resource", "DashboardSchedulerData", function (DashboardScheduler_Resource, DashboardSchedulerData) {
    var DashboardScheduler = function DashboardScheduler(resource, dashboardId) {
        this.id = null;
        this.surname = null;
        this.type = null;
        this.object = null;
        this.message = null;
        this.sendTo = [];
        this.dashboardId = null;
        this.isDeleted = false;
        this.version = null;
        this.dashboardId = dashboardId;

        if (resource !== undefined && resource !== null) this.setValues(resource);

        DashboardSchedulerData.add(this);
    };

    DashboardScheduler.prototype.setId = function (id) {
        if (!this.id) this.id = id;
    };

    DashboardScheduler.prototype.getId = function () {
        return this.id;
    };

    DashboardScheduler.prototype.setValues = function (resource) {
        this.id = resource.id;
        this.surname = resource.surname;
        this.type = resource.type;
        this.object = resource.object;
        this.message = resource.message;
        this.sendTo = resource.sendTo;
        this.isDeleted = resource.isDeleted;
        if (resource.version) this.version = resource.version;
    };

    DashboardScheduler.prototype.getObjectResource = function () {
        var newDashboardScheduler = new DashboardScheduler_Resource();

        newDashboardScheduler.id = this.id;
        newDashboardScheduler.surname = this.surname;
        newDashboardScheduler.type = this.type;
        newDashboardScheduler.object = this.object;
        newDashboardScheduler.message = this.message;
        newDashboardScheduler.dashboardId = this.dashboardId;
        newDashboardScheduler.sendTo = this.sendTo;
        newDashboardScheduler.isDeleted = this.isDeleted;
        newDashboardScheduler.version = this.version;

        return newDashboardScheduler;
    };

    return DashboardScheduler;
}]);

angular.module('FlexyBeautyApp.services').factory('DashboardSchedulerSrv', ["$log", "ServerSrv", "DashboardScheduler_Resource", "DashboardSchedulerData", "UserActionData", "DashboardScheduler", "DashboardData", function ($log, ServerSrv, DashboardScheduler_Resource, DashboardSchedulerData, UserActionData, DashboardScheduler, DashboardData) {
    var dashboardSchedulerSrv = {};

    dashboardSchedulerSrv.save = function (dashboardScheduler, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(dashboardSchedulerSrv.saveSync, dashboardScheduler, successFunction, errorFunction);
    };
    dashboardSchedulerSrv.saveSync = function (dashboardScheduler, successFunction, errorFunction) {
        //$timeout (function () {

        var dashboardSchedulerRes = dashboardScheduler.getObjectResource();
        dashboardSchedulerRes.$save({}, //no params
        function (data) {
            try {
                dashboardScheduler.setId(data.id);
                if (!dashboardScheduler.version || data.version && data.version > dashboardScheduler.version) dashboardScheduler.version = data.version;
                if (dashboardScheduler.dashboardId) {
                    var dashboard = DashboardData.getById(dashboardScheduler.dashboardId);
                    if (dashboard.dashboardSchedulers.indexOf(dashboardScheduler) === -1) {
                        dashboard.dashboardSchedulers.push(dashboardScheduler);
                    }
                }
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    dashboardSchedulerSrv.remove = function (dashboardScheduler, successFunction, errorFunction) {
        DashboardSchedulerData.remove(dashboardScheduler);
        ServerSrv.startSavingProcess(dashboardSchedulerSrv.removeSync, dashboardScheduler, successFunction, errorFunction);
    };
    dashboardSchedulerSrv.removeSync = function (dashboardScheduler, successFunction, errorFunction) {
        //$timeout (function () {

        if (dashboardScheduler) {
            var dashboardSchedulerRes = dashboardScheduler.getObjectResource();
            dashboardSchedulerRes.$remove({ id: dashboardScheduler.getId() }, //no params
            function (data) {
                try {
                    if (dashboardScheduler.dashboardId) {
                        var dashboard = DashboardData.getById(dashboardScheduler.dashboardId);
                        if (dashboard.dashboardSchedulers.indexOf(dashboardScheduler) !== -1) {
                            dashboard.dashboardSchedulers.splice(dashboardScheduler, 1);
                        }
                    }
                    if (successFunction !== undefined) successFunction(data);
                } finally {
                    ServerSrv.endSavingProcess(true);
                }
            }, function (data) {
                //error handling goes here
                try {
                    if (errorFunction !== undefined) errorFunction(data);
                } finally {
                    ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
                }
            });
        }

        //},2000)
    };

    dashboardSchedulerSrv.updateLocally = function (id, object) {
        var dashboardScheduler = DashboardSchedulerData.getById(id);
        if (dashboardScheduler != null) {
            dashboardScheduler.setValues(object);
        }
        return dashboardScheduler;
    };

    dashboardSchedulerSrv.addLocally = function (id, object) {
        var dashboardScheduler = DashboardSchedulerData.getById(id);
        if (dashboardScheduler == null) {
            var dashboardScheduler = new DashboardScheduler(object, object.dashboardId);
            dashboardScheduler.id = id;

            var dashboard = DashboardData.getById(dashboardScheduler.dashboardId);
            if (dashboard) dashboard.addDashboardScheduler(dashboardScheduler);
        }
        return dashboardScheduler;
    };

    dashboardSchedulerSrv.removeLocally = function (id, object) {
        var dashboardScheduler = DashboardSchedulerData.getById(id);
        if (dashboardScheduler != null) {
            var dashboard = DashboardData.getById(dashboardScheduler.dashboardId);
            if (dashboard) dashboard.removeDashboardScheduler(dashboardScheduler);
            DashboardSchedulerData.remove(dashboardScheduler);
        }

        return dashboardScheduler;
    };

    return dashboardSchedulerSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('DashboardSchedulerData', [function () {
    var dashboardSchedulerData = {
        dashboardSchedulerList: [], // dashboard scheduler list for the entire application
        deletedDashboardSchedulerList: [] // deleted dashboard scheduler list for the entire application
    };
    dashboardSchedulerData.getById = function (dashboardId) {
        for (var i = 0; i < this.dashboardSchedulerList.length; i++) {
            if (this.dashboardSchedulerList[i].id == dashboardId) return this.dashboardSchedulerList[i];
        }return null;
    };
    dashboardSchedulerData.getByIndex = function (dashboardIndex) {
        if (dashboardIndex >= 0 && dashboardIndex < this.dashboardSchedulerList.length) {
            return this.dashboardSchedulerList[dashboardIndex];
        } else return null;
    };
    dashboardSchedulerData.getIndexOf = function (dashboardScheduler) {
        if (dashboardScheduler) return this.dashboardSchedulerList.indexOf(dashboardScheduler);
        return -1;
    };
    dashboardSchedulerData.add = function (dashboardScheduler) {
        if (!dashboardScheduler.isDeleted) this.dashboardSchedulerList.push(dashboardScheduler);else this.deletedDashboardSchedulerList.push(dashboardScheduler);
    };
    dashboardSchedulerData.remove = function (dashboardScheduler) //Soft Remove
    {
        if (dashboardScheduler && !dashboardScheduler.isDeleted) {
            var indexDashboardScheduler = this.dashboardSchedulerList.indexOf(dashboardScheduler);
            if (indexDashboardScheduler != -1) {
                this.dashboardSchedulerList.splice(indexDashboardScheduler, 1);
                this.deletedDashboardSchedulerList.push(dashboardScheduler);
                dashboardScheduler.isDeleted = true;
            }
        }
    };
    dashboardSchedulerData.getDashboardSchedulerList = function () {
        return this.dashboardSchedulerList;
    };
    dashboardSchedulerData.clear = function () {
        this.dashboardSchedulerList = [];
        this.deletedDashboardSchedulerList = [];
    };

    return dashboardSchedulerData;
}]);

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('GiftItem_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceSaleS = $resource(baseUrl + 'rest/giftItems/:id', {}, {
        get: { method: 'GET' },
        sendMail: {
            method: 'POST',
            url: baseUrl + 'rest/giftItems/:id/sendMail'
        }
    });
    return resourceSaleS;
}]);

angular.module('FlexyBeautyApp.services').factory('GiftItem', ["GiftItem_Resource", "GiftItemData", "HumanResourceData", "CustomerData", "ServiceData", "TaxMode", "SaleItem", "GiftItemRootCategory", "GiftItemByHrRootCategory", "TypeOfBooking", function (GiftItem_Resource, GiftItemData, HumanResourceData, CustomerData, ServiceData, TaxMode, SaleItem, GiftItemRootCategory, GiftItemByHrRootCategory, TypeOfBooking) {
    //GiftItem inherit from Activity
    var GiftItem = function GiftItem(giftItemRes, isPreviousVersion, isApplicationLoading) {
        SaleItem.call(this);

        this.id = null;
        this.code = null;
        this.service = null;
        this._serviceId = null; //tmp for loading only
        this.price = 0;
        this.vat = null;
        this.vatCode = null;
        this.originalPrice = 0;
        this.discountPercent = 0;
        this.isUsed = false;
        this.isCanceled = false;
        this.closingDate = null;
        this.sale = null;
        this.humanResource = null;
        this.validityDate = null;
        this.editionType = "";
        this.customer = null;
        this._customerId = null; //tmp for loading only
        this.barcodeData = ""; //write only
        this.messageTitle = "";
        this.message = "";
        this.imageUrl = "";
        this.comment = "";
        this.version = null;
        this.loadObject(giftItemRes);
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA  and to customer
            {
                this.loadRef(null, isApplicationLoading);
                GiftItemData.add(this);
            }
    };

    GiftItem.prototype = Object.create(SaleItem.prototype); //inherit functions from SaleItem


    GiftItem.prototype.loadObject = function (object) {

        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.code = object.code;
            this._serviceId = object.serviceId;
            this.price = object.price;
            this.vat = object.vat;
            this.vatCode = object.vatCode;
            this.isUsed = object.isUsed;
            this.isCanceled = object.isCanceled;
            if (object.closingDate) {
                this.closingDate = new Date(object.closingDate);
            }
            if (object.originalPrice !== undefined && object.originalPrice) this.originalPrice = object.originalPrice;else this.originalPrice = object.price;
            this.discountPercent = object.discountPercent;
            if (object.humanResourceId) this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.validityDate) this.validityDate = new Date(object.validityDate);
            this.editionType = object.editionType;
            this._customerId = object.customerId;
            this.barcodeData = object.barcodeData;
            this.messageTitle = object.messageTitle;
            this.message = object.message;
            this.imageUrl = object.imageUrl;
            this.comment = object.comment;
            if (object.version) this.version = object.version;
        }
    };
    GiftItem.prototype.loadRef = function (isPreviousVersion, isApplicationLoading) {
        if (this._customerId) {
            this.customer = CustomerData.getById(this._customerId, isApplicationLoading);
            if (this.customer && (isPreviousVersion === undefined || !isPreviousVersion)) {
                this.customer.addGiftItem(this);
            }
        }
        if (this._serviceId) this.service = ServiceData.getById(this._serviceId);
    };
    GiftItem.prototype.copyDataTo = function (object) {

        object.id = this.id;
        object.code = this.code;
        object.price = this.price;
        object.vat = this.vat;
        object.vatCode = this.vatCode;
        object.isUsed = this.isUsed;
        object.isCanceled = this.isCanceled;
        if (this.closingDate) {
            object.closingDate = this.closingDate;
        }
        object.originalPrice = this.originalPrice;
        object.discountPercent = this.discountPercent;
        if (this.humanResource) object.humanResourceId = this.humanResource.id;else this.humanResource = null;

        if (this.sale) object.saleId = this.sale.id;else object.saleId = null;
        if (this.service) object.serviceId = this.service.id;else object.serviceId = null;
        object.validityDate = this.validityDate;
        object.editionType = this.editionType;
        if (this.customer) //always save it
            object.customer = this.customer.getObjectResource();else object.customer = null;
        object.barcodeData = this.barcodeData;
        object.messageTitle = this.messageTitle;
        object.message = this.message;
        object.imageUrl = this.imageUrl;
        object.comment = this.comment;
    };
    GiftItem.prototype.getObjectResource = function () {
        var giftItemRes = new GiftItem_Resource();
        this.copyDataTo(giftItemRes);
        return giftItemRes;
    };
    GiftItem.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };
    GiftItem.prototype.setId = function (id) {
        this.id = id;
    };
    GiftItem.prototype.getId = function () {
        return this.id;
    };
    GiftItem.prototype.getPrice = function () {
        return this.price;
    };
    GiftItem.prototype.getDiscountPrice = function (taxMode) {
        var price = 0;

        if (this.sale.isStatusSoldOrCreditOrCanceled()) {

            price = this.price;

            //apply global discount on price
            if (this.sale.discountPercent != 0) {
                price -= this.sale.discountPercent * price / 100;
            }
            if (taxMode === TaxMode.HT) {
                var vat = this.vat ? this.vat : this.sale.vat;
                price = price / (100 + vat) * 100;
            }
        }

        return price;
    };

    GiftItem.prototype.getSale = function () {
        return this.sale;
    };

    /**
     * @override SaleItem.prototype.matchSpecificMatchingOfItem
     */
    GiftItem.prototype.matchSpecificMatchingOfItem = function (saleObject) {
        var matchSpecificMatchingOfItem = false;
        if (saleObject === GiftItemRootCategory || saleObject === GiftItemByHrRootCategory || saleObject === GiftItemRootCategory.subCategories.SERVICE && this.service !== null || saleObject === GiftItemRootCategory.subCategories.PRICE && this.service === null || saleObject === TypeOfBooking.CREATE_BY_CUSTORMER && this.getSale().isCreatedByCustomer || saleObject === TypeOfBooking.NOT_CREATE_BY_CUSTOMER && !this.getSale().isCreatedByCustomer) {
            matchSpecificMatchingOfItem = true;
        }
        return matchSpecificMatchingOfItem;
    };

    /**
     * @override SaleItem.prototype.isSaleWithTree
     */
    GiftItem.prototype.isSaleWithTree = function () {
        return false;
    };

    /**
     * @override SaleItem.prototype.incrementSalesDatas
     */
    GiftItem.prototype.incrementSalesDatas = function (salesData, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, currentDay) {
        if (this.matchAllSaleObjects(saleObjects, additionalFilters, firstDayOfPeriod, currentDay)) {
            salesData.price += this.getDiscountPrice(taxMode);
            if (salesData.sales.indexOf(this.getSale()) === -1 && !this.getSale().isCancelledOrCredit()) {
                if (!this.getSale().booking && salesData.salesWithoutBooking.indexOf(this.getSale()) === -1) {
                    salesData.salesWithoutBooking.push(this.getSale());
                }
                if (this.getSale().booking && this.getSale().booking.day && firstDayOfPeriod && lastDayOfPeriod && (this.getSale().booking.day.id < firstDayOfPeriod.id || this.getSale().booking.day.id > lastDayOfPeriod.id) && salesData.salesWithBookingOutOfPeriod.indexOf(this.getSale()) === -1) {
                    salesData.salesWithBookingOutOfPeriod.push(this.getSale());
                }
                if (salesData.customersSales.indexOf(this.getSale().customer) === -1) {
                    salesData.customersSales.push(this.getSale().customer);
                    if (salesData.customersFirstSales.indexOf(this.getSale().customer) === -1 && this.getSale().customer && !this.getSale().customer.hasSaleBetween(firstDayOfPeriod, currentDay) && !this.getSale().customer.hasBookingBetween(firstDayOfPeriod, currentDay, this.getSale())) {
                        salesData.customersFirstSales.push(this.getSale().customer);
                    }
                }
            }
            salesData.subSales.push(this);
            salesData.subSalesStep.push(this);
            salesData.qteSubSales += this.getStatQuantity();

            if (salesData.sales.indexOf(this.getSale()) === -1) {
                salesData.sales.push(this.getSale());
                salesData.qteSales += this.getStatQuantity();
            }
        }
    };

    return GiftItem;
}]);

angular.module('FlexyBeautyApp.services').factory('GiftItemSrv', ["$log", "ServerSrv", "GiftItem_Resource", "GiftItemData", "GiftItem", "SaleData", function ($log, ServerSrv, GiftItem_Resource, GiftItemData, GiftItem, SaleData) {
    var bpSrv = {};

    bpSrv.save = function (giftItem, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bpSrv.saveSync, giftItem, successFunction, errorFunction);
    };

    bpSrv.saveSync = function (giftItem, successFunction, errorFunction) {
        //$timeout (function () {

        var bsRes = giftItem.getObjectResource();
        bsRes.$save({}, //no params
        function (data) {

            try {
                // now we can set the id
                giftItem.setId(data.id);
                giftItem.code = data.code;
                if (!giftItem.version || data.version && data.version > giftItem.version) giftItem.version = data.version;
                if (data.customerId && giftItem.customer) giftItem.customer.setId(data.customerId);
                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    bpSrv.updateLocally = function (id, resource) {
        var giftItem = GiftItemData.getById(id);

        if (giftItem && giftItem.version && resource.version && resource.version < giftItem.version) return null;

        if (giftItem != null) {
            giftItem.loadObject(resource);
            giftItem.id = id;
            //remove from sale
            if (giftItem.sale) giftItem.sale.removeGiftItem(giftItem);
            if (resource.saleId) //add to sale
                {
                    var sale = SaleData.getById(resource.saleId);
                    if (sale) sale.addGiftItem(giftItem);
                }
        } else bpSrv.addLocally(id, resource);

        return giftItem;
    };
    bpSrv.removeLocally = function (id, resource) {
        var giftItem = GiftItemData.getById(id);
        if (giftItem && giftItem.version && resource.version && resource.version < giftItem.version) return null;
        if (giftItem != null) {
            //remove from sale
            if (giftItem.sale) giftItem.sale.removeGiftItem(giftItem);
        }
        return giftItem;
    };
    bpSrv.addLocally = function (id, resource) {
        var giftItem = GiftItemData.getById(id);
        if (giftItem && giftItem.version && resource.version && resource.version < giftItem.version) return null;
        if (giftItem != null) //check if resource already exist inside index (current action could be a 'cancel')
            giftItem.loadObject(resource);else giftItem = new GiftItem(resource);
        giftItem.id = id;
        //add to sale
        if (resource.saleId) {
            var sale = SaleData.getById(resource.saleId);
            if (sale) sale.addGiftItem(giftItem);
        }

        return giftItem;
    };

    bpSrv.getPreviousVersionInstance = function (resource) {
        var giftItem = new GiftItem(resource, true);
        if (resource.saleId) giftItem.sale = SaleData.getById(resource.saleId);
        return giftItem;
    };

    bpSrv.sendMail = function (giftItem) {
        GiftItem_Resource.sendMail({ id: giftItem.id }, {}).$promise.then(function (result) {
            // console.log(JSON.stringify(result));
        }).catch(function (error) {
            console.log(JSON.stringify(error));
        });
    };

    return bpSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('GiftItemData', ["$log", function ($log) {
    var giftItemData = {
        indexGiftItems: []
    };
    giftItemData.getById = function (giftItemId) {
        for (var i = 0; i < this.indexGiftItems.length; i++) {
            if (this.indexGiftItems[i].id == giftItemId) return this.indexGiftItems[i];
        }return null;
    };
    giftItemData.getIndexOf = function (giftItem) {
        if (giftItem) return this.indexGiftItems.indexOf(giftItem);
        return -1;
    };
    giftItemData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexGiftItems.length) return this.indexGiftItems[index];else return null;
    };
    giftItemData.getByCode = function (code) {
        var codeToFind = "";
        if (code) codeToFind = code.replace(/-/g, "");
        for (var i = 0; i < this.indexGiftItems.length; i++) {
            if (this.indexGiftItems[i].code == codeToFind) return this.indexGiftItems[i];
        }return null;
    };
    giftItemData.getByValidityDate = function (validityDate, isCanceled) {
        var giftItems = [];
        for (var i = 0; i < this.indexGiftItems.length; i++) {
            if (this.indexGiftItems[i].validityDate && this.indexGiftItems[i].validityDate.getFullYear() == validityDate.getFullYear() && this.indexGiftItems[i].validityDate.getMonth() == validityDate.getMonth() && this.indexGiftItems[i].validityDate.getDate() == validityDate.getDate() && this.indexGiftItems[i].isCanceled == isCanceled) giftItems.push(this.indexGiftItems[i]);
        }return giftItems;
    };

    giftItemData.getByClosingDate = function (date) {
        var giftItems = [];
        for (var i = 0; i < this.indexGiftItems.length; i++) {
            var giftItem = this.indexGiftItems[i];
            if (giftItem.isCanceled) {
                var closingDate = giftItem.closingDate;

                if (!closingDate && giftItem.validityDate) {
                    closingDate = giftItem.validityDate;
                }

                if (closingDate && closingDate.getFullYear() === date.getFullYear() && closingDate.getMonth() === date.getMonth() && closingDate.getDate() === date.getDate()) {
                    giftItems.push(giftItem);
                }
            }
        }
        return giftItems;
    };

    giftItemData.add = function (giftItem) {
        this.indexGiftItems.push(giftItem);
        return this.indexGiftItems.length - 1;
    };
    giftItemData.clear = function () {
        giftItemData.indexGiftItems = [];
    };
    giftItemData.getActiveList = function () {
        return this.indexGiftItems;
    };

    return giftItemData;
}]);

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('InternUsageProduct_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceOrderS = $resource(baseUrl + 'rest/internUsageProducts/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceOrderS;
}]);

angular.module('FlexyBeautyApp.services').factory('InternUsageProduct', ["InternUsageProduct_Resource", "ProductCategoryData", "ProductData", "InternUsageProductData", "HumanResourceData", function (InternUsageProduct_Resource, ProductCategoryData, ProductData, InternUsageProductData, HumanResourceData) {

    var InternUsageProduct = function InternUsageProduct(InternUsageProductRes, isPreviousVersion) {
        this.id = null;
        this.label = null;
        this.price = 0;
        this.originalPrice = 0;
        this.quantity = 0;
        this.product = null;
        this.usageProduct = null;
        this.version = null;
        this.humanResource = null;
        this.loadObject(InternUsageProductRes);
        this.loadRef();
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            InternUsageProductData.add(this);
    };

    InternUsageProduct.prototype.loadObject = function (object) {

        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.label = object.label;
            this.originalPrice = object.originalPrice;
            this.price = object.price;
            this.quantity = object.quantity;
            this.productId = object.productId;
            this.humanResourceId = object.humanResourceId;
            if (object.version) this.version = object.version;
        }
    };

    InternUsageProduct.prototype.loadRef = function () {
        if (this.productId) this.product = ProductData.getById(this.productId);
        if (this.humanResourceId) this.humanResource = HumanResourceData.getById(this.humanResourceId);
    };

    InternUsageProduct.prototype.copyDataTo = function (object) {

        object.id = this.id;
        object.label = this.label;
        object.originalPrice = this.originalPrice;
        object.price = this.price;
        object.quantity = this.quantity;

        if (this.product) object.productId = this.product.id;else object.productId = null;

        if (this.usageProduct) object.usageProductId = this.usageProduct.id;else object.usageProductId = null;

        if (this.humanResource) object.humanResourceId = this.humanResource.id;else object.humanResourceId = null;
    };
    InternUsageProduct.prototype.getObjectResource = function () {
        var internUsageProductRes = new InternUsageProduct_Resource();
        this.copyDataTo(internUsageProductRes);
        return internUsageProductRes;
    };
    InternUsageProduct.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };
    InternUsageProduct.prototype.setId = function (id) {
        this.id = id;
    };
    InternUsageProduct.prototype.getId = function () {
        return this.id;
    };
    InternUsageProduct.prototype.getLabel = function () {
        return this.label;
    };
    InternUsageProduct.prototype.getPrice = function () {
        return this.price;
    };

    return InternUsageProduct;
}]);

angular.module('FlexyBeautyApp.services').factory('InternUsageProductSrv', ["$log", "ServerSrv", "DayData", "InternUsageProductData", "InternUsageProduct", "ActivitySrv", "UsageProductData", function ($log, ServerSrv, DayData, InternUsageProductData, InternUsageProduct, ActivitySrv, UsageProductData) {
    var bpSrv = {};

    bpSrv.save = function (InternUsageProduct, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bpSrv.saveSync, InternUsageProduct, successFunction, errorFunction);
    };
    bpSrv.saveSync = function (InternUsageProduct, successFunction, errorFunction) {
        //$timeout (function () {

        var bsRes = InternUsageProduct.getObjectResource();
        bsRes.$save({}, //no params
        function (data) {
            try {
                InternUsageProduct.setId(data.id);
                if (!InternUsageProduct.version || data.version && data.version > InternUsageProduct.version) InternUsageProduct.version = data.version;

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    bpSrv.updateLocally = function (id, resource) {
        //not specific code to manage update/remove from InternUsageProduct because this link is change only for a add or delete
        //return ActivitySrv.updateLocally(resource);
        //TODO
    };
    bpSrv.removeLocally = function (id, resource) {
        var internUsageProduct = InternUsageProductData.getById(id);
        if (internUsageProduct != null) {
            if (internUsageProduct.usageProduct) internUsageProduct.usageProduct.removeOrderProduct(internUsageProduct);
        }
        return InternUsageProduct;
    };
    bpSrv.addLocally = function (id, resource) {
        var internUsageProduct = InternUsageProductData.getById(id);
        if (internUsageProduct != null) //check if resource already exist inside index (current action could be a 'cancel')
            internUsageProduct.loadObject(resource);else {
            internUsageProduct = new InternUsageProduct(resource);
            internUsageProduct.id = id;
        }

        if (resource.usageProductId) {
            var usageProduct = UsageProductData.getById(resource.usageProductId);
            if (usageProduct) usageProduct.addInternUsageProduct(usageProduct);
        }

        return usageProduct;
    };
    bpSrv.getPreviousVersionInstance = function (resource) {
        var internUsageProduct = new InternUsageProduct(resource, true);
        if (resource.usageProductId) internUsageProduct.usageProduct = InternUsageProductData.getById(resource.usageProductId);
        return internUsageProduct;
    };

    return bpSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('InternUsageProductData', ["$log", function ($log) {
    var internUsageProductData = {
        indexInternUsageProducts: []
    };
    internUsageProductData.getById = function (InternUsageProductId) {
        for (var i = 0; i < this.indexInternUsageProducts.length; i++) {
            if (this.indexInternUsageProducts[i].id == InternUsageProductId) return this.indexInternUsageProducts[i];
        }return null;
    };
    internUsageProductData.getIndexOf = function (internUsageProduct) {
        if (internUsageProduct) return this.indexInternUsageProducts.indexOf(internUsageProduct);
        return -1;
    };
    internUsageProductData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexInternUsageProducts.length) return this.indexInternUsageProducts[index];else return null;
    };
    internUsageProductData.add = function (internUsageProduct) {
        this.indexInternUsageProducts.push(internUsageProduct);
        return this.indexInternUsageProducts.length - 1;
    };
    internUsageProductData.clear = function () {
        internUsageProductData.indexInternUsageProducts = [];
    };

    return internUsageProductData;
}]);

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCard_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/loyaltyCards/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getSms: { method: 'GET', isArray: true, url: baseUrl + 'rest/loyaltyCards/getSms/:id' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/loyaltyCards/deleted' },
        editable: { method: 'GET', isArray: false, url: baseUrl + 'rest/loyaltyCards/:id/editable' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('LoyaltyCard', ["LoyaltyCard_Resource", "ImageData", "LoyaltyCardData", "SupplierData", "LoyaltyCardCategoryData", "CompanyImageData", "HrRootCategory", function (LoyaltyCard_Resource, ImageData, LoyaltyCardData, SupplierData, LoyaltyCardCategoryData, CompanyImageData, HrRootCategory) {

    var LoyaltyCard = function LoyaltyCard(resource, parentCategory) {
        this.id = null;
        this.isDeleted;
        this.label = "";
        this.style = "";
        this.type = null;
        this.itemType = null;
        this.monthValidity = null;
        this.alertExp = 0;
        this.description = "";
        this.price = null;
        this.image = null;
        this.companyImage = null;
        this.specificImage = null;
        this.isVisibleOnWebSite = true; //Default;
        this.isBuyableOnWebSite = false; //Default;
        this.goalPts = null;
        this.goalType = null;
        this.goalAmount = null;
        this.goalText = null;
        this.version = null;
        if (resource !== undefined && resource != null) {
            this.loadObject(resource);
        }

        if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }

        LoyaltyCardData.add(this);
    };
    LoyaltyCard.prototype.loadObject = function (object, parentCategory) {
        //Assume here than the object in parameter contains only id (must load them)
        if (!this.id) this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.parentCategoryId = object.parentCategoryId;
        this.label = object.label;
        this.style = object.style;
        this.type = object.type;
        this.itemType = object.itemType;
        this.monthValidity = object.monthValidity;
        this.alertExp = object.alertExp;
        this.description = object.description;
        this.price = object.price;
        this.imageId = object.imageId;
        this.companyImageId = object.companyImageId;
        this.specificImage = object.specificImage;
        this.isVisibleOnWebSite = object.isVisibleOnWebSite;
        this.isBuyableOnWebSite = object.isBuyableOnWebSite;
        this.goalPts = object.goalPts;
        this.goalType = object.goalType;
        this.goalAmount = object.goalAmount;
        this.goalText = object.goalText;
        if (object.version) this.version = object.version;
        if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }
    };
    LoyaltyCard.prototype.getObjectResource = function () {
        var rsLoyaltyCard = new LoyaltyCard_Resource();
        rsLoyaltyCard.id = this.id;
        rsLoyaltyCard.isDeleted = this.isDeleted;
        rsLoyaltyCard.style = this.style;
        rsLoyaltyCard.label = this.label;
        rsLoyaltyCard.type = this.type;
        rsLoyaltyCard.itemType = this.itemType;
        rsLoyaltyCard.monthValidity = this.monthValidity;
        rsLoyaltyCard.alertExp = this.alertExp;
        if (this.image) rsLoyaltyCard.imageId = this.image.id;
        if (this.companyImage) rsLoyaltyCard.companyImageId = this.companyImage.id;
        rsLoyaltyCard.specificImage = this.specificImage;
        rsLoyaltyCard.description = this.description;
        rsLoyaltyCard.price = this.price;
        rsLoyaltyCard.isVisibleOnWebSite = this.isVisibleOnWebSite;
        rsLoyaltyCard.isBuyableOnWebSite = this.isBuyableOnWebSite;
        rsLoyaltyCard.goalPts = this.goalPts;
        rsLoyaltyCard.goalType = this.goalType;
        rsLoyaltyCard.goalAmount = this.goalAmount;
        rsLoyaltyCard.goalText = this.goalText;
        if (this.parentCategory != null) rsLoyaltyCard.parentCategoryId = this.parentCategory.getId();

        return rsLoyaltyCard;
    };

    LoyaltyCard.prototype.loadRef = function () {
        if (this.imageId) this.image = ImageData.getById(this.imageId);
        if (this.companyImageId) this.companyImage = CompanyImageData.getById(this.companyImageId);
        if (this.parentCategory == null && this.parentCategoryId) this.parentCategory = LoyaltyCardCategoryData.getById(this.parentCategoryId);
    };
    LoyaltyCard.prototype.getId = function () {
        return this.id;
    };
    LoyaltyCard.prototype.setId = function (id) {
        this.id = id;
    };
    LoyaltyCard.prototype.getLabel = function () {
        return this.label;
    };
    LoyaltyCard.prototype.reload = function (endFunction) {
        var loyaltyCardSrv = this.getObjectResource();
        var loyaltyCard = this;
        if (this.getId() != null) loyaltyCardSrv.$get({ id: this.getId() }, //params
        function (data) {
            //success
            loyaltyCard.loadObject(data);
            if (endFunction != undefined) endFunction(loyaltyCard);
        }, function (data) {//failure
            //error handling goes here
            //TODO
        });
    };

    LoyaltyCard.prototype.isDescendantOf = function (category) {
        var isDescendantOf = false;
        if (this.parentCategory === category) {
            isDescendantOf = true;
        } else {
            if (this.parentCategory) {
                isDescendantOf = this.parentCategory.isDescendantOf(category);
            }
        }

        return isDescendantOf;
    };

    return LoyaltyCard;
}]);

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardSrv', ["$log", "HumanResourceData", "HumanResourceSrv", "LoyaltyCard_Resource", "LoyaltyCard", "LoyaltyCardCategoryData", "UserActionData", "LoyaltyCardData", "ServerSrv", function ($log, HumanResourceData, HumanResourceSrv, LoyaltyCard_Resource, LoyaltyCard, LoyaltyCardCategoryData, UserActionData, LoyaltyCardData, ServerSrv) {
    var loyaltyCardSrv = {};
    loyaltyCardSrv.save = function (loyaltyCard, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(loyaltyCardSrv.saveSync, loyaltyCard, successFunction, errorFunction);
    };
    loyaltyCardSrv.saveSync = function (loyaltyCard, successFunction, errorFunction) {
        //$timeout (function () {

        var LoyaltyCardRes = loyaltyCard.getObjectResource();
        LoyaltyCardRes.$save({}, //no params
        function (loyaltyCardRes) {
            try {
                if (loyaltyCard.id == null) {
                    loyaltyCard.id = loyaltyCardRes.id;
                }
                if (!loyaltyCard.version || loyaltyCardRes.version && loyaltyCardRes.version > loyaltyCard.version) loyaltyCard.version = loyaltyCardRes.version;

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    loyaltyCardSrv.remove = function (loyaltyCard, successFunction, errorFunction) {
        LoyaltyCardData.remove(loyaltyCard);
        ServerSrv.startSavingProcess(loyaltyCardSrv.removeSync, loyaltyCard, successFunction, errorFunction);
    };
    loyaltyCardSrv.removeSync = function (loyaltyCard, successFunction, errorFunction) {
        var loyaltyCardRes = new LoyaltyCard_Resource();
        loyaltyCardRes.$remove({ id: loyaltyCard.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    loyaltyCardSrv.restore = function (loyaltyCard, successFunction, errorFunction) {
        LoyaltyCardData.restore(loyaltyCard);
        ServerSrv.startSavingProcess(loyaltyCardSrv.restoreSync, loyaltyCard, successFunction, errorFunction);
    };
    loyaltyCardSrv.restoreSync = function (loyaltyCard, successFunction, errorFunction) {
        var loyaltyCardRes = loyaltyCard.getObjectResource();
        loyaltyCardRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    loyaltyCardSrv.query = function (successFunction, errorFunction) {
        LoyaltyCard_Resource.getDeleted({}, //params
        function (data) {
            //success

            LoyaltyCardData.deletedLoyaltyCards = [];
            for (var i = 0; i < data.length; i++) {
                new LoyaltyCard(data[i]);
            } //Auto Add to LoyaltyCardData

            if (successFunction !== undefined) successFunction(LoyaltyCardData.categoryRoot);
        }, function (data) {
            //failure
            $log.error("LoyaltyCard_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    loyaltyCardSrv.getSms = function (smsCampaign, successFunction, errorFunction) {
        if (smsCampaign) {
            LoyaltyCard_Resource.getSms({ id: smsCampaign.id }, //params
            function (data) {
                if (successFunction !== undefined) successFunction(data);
            }, function (data) {
                if (errorFunction !== undefined) errorFunction(data);
            });
        } else if (errorFunction !== undefined) errorFunction();
    };
    loyaltyCardSrv.loadRef = function () {
        var loyaltyCards = LoyaltyCardData.indexLoyaltyCards;
        for (var i = 0; i < loyaltyCards.length; i++) {
            loyaltyCards[i].loadRef();
        }
    };
    loyaltyCardSrv.updateLocally = function (id, object) {
        var loyaltyCard = null;
        var category = LoyaltyCardCategoryData.getById(object.parentCategoryId);
        if (category != null) loyaltyCard = category.getLoyaltyCardById(id);
        if (loyaltyCard != null) {
            loyaltyCard.loadObject(object, category);
        }
        return loyaltyCard;
    };
    loyaltyCardSrv.addLocally = function (id, object) {
        var loyaltyCard = null;
        var category = LoyaltyCardCategoryData.getById(object.parentCategoryId);
        if (category != null) {
            loyaltyCard = new LoyaltyCard(object, category);
            loyaltyCard.id = id;
            category.addLoyaltyCard();
        }
        return null;
    };
    loyaltyCardSrv.removeLocally = function (id, object) {
        var loyaltyCard = null;
        var category = LoyaltyCardCategoryData.getById(object.parentCategoryId);
        if (category != null) loyaltyCard = category.getLoyaltyCardById(id);
        if (loyaltyCard != null) category.removeLoyaltyCard(loyaltyCard);
        return loyaltyCard;
    };

    loyaltyCardSrv.editable = function (loyaltyCardId) {
        return LoyaltyCard_Resource.editable({ id: loyaltyCardId }).$promise;
    };

    return loyaltyCardSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardData', ["$log", function ($log) {
    var loyaltyCardData = {
        indexLoyaltyCards: [], //Used as Index
        deletedLoyaltyCards: []
    };
    loyaltyCardData.getById = function (loyaltyCardId) {
        for (var i = 0; i < this.indexLoyaltyCards.length; i++) {
            if (this.indexLoyaltyCards[i].id == loyaltyCardId) return this.indexLoyaltyCards[i];
        }return null;
    };
    loyaltyCardData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexLoyaltyCards.length) {
            return this.indexLoyaltyCards[servIndex];
        } else return null;
    };
    loyaltyCardData.getIndexOf = function (loyaltyCard) {
        if (loyaltyCard) return this.indexLoyaltyCards.indexOf(loyaltyCard);
        return -1;
    };
    loyaltyCardData.add = function (loyaltyCard) {
        this.indexLoyaltyCards.push(loyaltyCard);
        if (loyaltyCard.isDeleted) {
            var index = this.deletedLoyaltyCards.indexOf(loyaltyCard);
            if (index == -1) this.deletedLoyaltyCards.push(loyaltyCard);
        }
        return this.indexLoyaltyCards.length - 1;
    };
    loyaltyCardData.remove = function (loyaltyCard) //Soft Remove
    {
        var index = this.deletedLoyaltyCards.indexOf(loyaltyCard);
        if (index == -1) {
            this.deletedLoyaltyCards.push(loyaltyCard);
            loyaltyCard.isDeleted = true;
        }
    };
    loyaltyCardData.restore = function (loyaltyCard) //Soft Remove
    {
        var index = this.deletedLoyaltyCards.indexOf(loyaltyCard);
        if (index != -1) {
            this.deletedLoyaltyCards.splice(index, 1);
            loyaltyCard.isDeleted = false;
        }
    };
    loyaltyCardData.clear = function () {
        loyaltyCardData.indexLoyaltyCards = [];
        loyaltyCardData.deletedLoyaltyCards = [];
    };
    loyaltyCardData.getDeletedList = function () {
        return loyaltyCardData.deletedLoyaltyCards;
    };

    return loyaltyCardData;
}]);

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardCategory_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/loyaltyCardCategories/:id', {}, {
        query: { method: 'GET', isArray: false },
        getTree: { method: 'GET', isArray: false, url: baseUrl + 'rest/loyaltyCardCategories/tree' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/loyaltyCardCategories/deleted' },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardCategory', ["LoyaltyCardCategory_Resource", "LoyaltyCard", "LoyaltyCardCategoryData", "LoyaltyCardData", "ImageData", "CompanyImageData", function (LoyaltyCardCategory_Resource, LoyaltyCard, LoyaltyCardCategoryData, LoyaltyCardData, ImageData, CompanyImageData) {
    var LoyaltyCardCategory = function LoyaltyCardCategory(rsLoyaltyCardCategory, parentCategory) {
        this.id = null;
        this.isDeleted;
        this.label = "";
        this.description = "";
        this.image = null;
        this.companyImage = null;
        this.specificImage; //boolean
        this.isVisibleOnWebSite;
        this.style = "";
        this.loyaltyCards = [];
        this.categories = [];
        this.parentCategoryId = null;
        this.version = null;

        if (parentCategory !== undefined && parentCategory != null) this.parentCategory = parentCategory;

        if (rsLoyaltyCardCategory !== undefined && rsLoyaltyCardCategory != null) {
            var loyaltyCard, category;
            if (!this.id) this.id = rsLoyaltyCardCategory.id;
            this.isDeleted = rsLoyaltyCardCategory.isDeleted;
            this.label = rsLoyaltyCardCategory.label;
            this.description = rsLoyaltyCardCategory.description;
            this.imageId = rsLoyaltyCardCategory.imageId;
            this.companyImageId = rsLoyaltyCardCategory.companyImageId;
            this.specificImage = rsLoyaltyCardCategory.specificImage;
            this.isVisibleOnWebSite = rsLoyaltyCardCategory.isVisibleOnWebSite;
            this.parentCategoryId = rsLoyaltyCardCategory.parentCategoryId;
            this.style = rsLoyaltyCardCategory.style;

            if (rsLoyaltyCardCategory.categories) for (var i = 0; i < rsLoyaltyCardCategory.categories.length; i++) {
                category = new LoyaltyCardCategory(rsLoyaltyCardCategory.categories[i], this);
                this.categories.push(category);
            }

            if (rsLoyaltyCardCategory.loyaltyCards) for (var j = 0; j < rsLoyaltyCardCategory.loyaltyCards.length; j++) {
                loyaltyCard = new LoyaltyCard(rsLoyaltyCardCategory.loyaltyCards[j], this);
                this.loyaltyCards.push(loyaltyCard);
            }
        }
        LoyaltyCardCategoryData.add(this);
    };

    LoyaltyCardCategory.prototype.loadObject = function (object, parentCategory) {
        this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.label = object.label;
        this.description = object.description;
        this.style = object.style;
        this.specificImage = object.specificImage;
        this.isVisibleOnWebSite = object.isVisibleOnWebSite;

        if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }

        //load ref from ids
        if (object.loyaltyCardsId) {
            var newLoyaltyCards = [];
            for (var i = 0; i < object.loyaltyCardsId.length; i++) {
                var loyaltyCard = LoyaltyCardData.getById(object.loyaltyCardsId[i]);
                if (loyaltyCard != null) newLoyaltyCards.push(loyaltyCard);
            }
            this.loyaltyCards = newLoyaltyCards;
        }
        if (object.loyaltyCardsId) {
            var newCategories = [];
            for (i = 0; i < object.categoriesId.length; i++) {
                var category = LoyaltyCardCategoryData.getById(object.categoriesId[i]);
                if (category != null) newCategories.push(category);
            }
            this.categories = newCategories;
        }
    };
    LoyaltyCardCategory.prototype.getObjectResource = function () {
        var rsLoyaltyCardCategory = new LoyaltyCardCategory_Resource();
        rsLoyaltyCardCategory.id = this.id;
        rsLoyaltyCardCategory.isDeleted = this.isDeleted;
        rsLoyaltyCardCategory.label = this.label;
        rsLoyaltyCardCategory.description = this.description;
        if (this.image) rsLoyaltyCardCategory.imageId = this.image.id;
        if (this.companyImage) rsLoyaltyCardCategory.companyImageId = this.companyImage.id;
        rsLoyaltyCardCategory.specificImage = this.specificImage;
        rsLoyaltyCardCategory.isVisibleOnWebSite = this.isVisibleOnWebSite;
        rsLoyaltyCardCategory.style = this.style;

        if (this.parentCategory) rsLoyaltyCardCategory.parentCategoryId = this.parentCategory.getId();
        rsLoyaltyCardCategory.categoriesId = [];
        for (var i = 0; i < this.categories.length; i++) {
            rsLoyaltyCardCategory.categoriesId.push(this.categories[i].getId());
        }rsLoyaltyCardCategory.loyaltyCardsId = [];
        for (var i = 0; i < this.loyaltyCards.length; i++) {
            rsLoyaltyCardCategory.loyaltyCardsId.push(this.loyaltyCards[i].getId());
        }return rsLoyaltyCardCategory;
    };
    LoyaltyCardCategory.prototype.getId = function () {
        return this.id;
    };
    LoyaltyCardCategory.prototype.setId = function (id) {
        this.id = id;
    };
    LoyaltyCardCategory.prototype.getLabel = function () {
        return this.label;
    };
    LoyaltyCardCategory.prototype.addLoyaltyCard = function (loyaltyCard) {
        var index = this.loyaltyCards.indexOf(loyaltyCard);
        if (index == -1) //Not already there
            {
                this.loyaltyCards.push(loyaltyCard);
                loyaltyCard.parentCategory = this;
            }
    };
    LoyaltyCardCategory.prototype.removeLoyaltyCard = function (loyaltyCard) {
        var index = this.loyaltyCards.indexOf(loyaltyCard);
        if (index != -1) //Found
            {
                this.loyaltyCards.splice(index, 1);
            }
    };
    LoyaltyCardCategory.prototype.addCategory = function (category) {
        if (category) {
            var index = this.categories.indexOf(category);
            if (index == -1) //Not already there
                {
                    this.categories.push(category);
                    category.parentCategory = this;
                }
        }
    };
    LoyaltyCardCategory.prototype.removeCategory = function (category) {
        var index = this.categories.indexOf(category);
        if (index != -1) //Found
            {
                this.categories.splice(index, 1);
            }
    };
    LoyaltyCardCategory.prototype.changeLoyaltyCardPosition = function (loyaltyCard, indexTarget) {
        //Change the loyaltyCard position
        var index = this.loyaltyCards.indexOf(loyaltyCard);
        if (indexTarget != -1 && index != -1 && indexTarget != index && this.loyaltyCards && indexTarget < this.loyaltyCards.length) {
            var cat = this.loyaltyCards[indexTarget];

            this.loyaltyCards.splice(index, 1);
            if (index < indexTarget) indexTarget--;
            this.loyaltyCards.splice(indexTarget, 0, loyaltyCard);
        }
    };
    LoyaltyCardCategory.prototype.getLoyaltyCardById = function (loyaltyCardId) {
        //recursive research
        var loyaltyCard = null;
        for (var j = 0; j < this.loyaltyCards.length; j++) {
            if (this.loyaltyCards[j].id == loyaltyCardId) return this.loyaltyCards[j];
        }for (var z = 0; z < this.categories.length && !loyaltyCard; z++) {
            loyaltyCard = this.categories[z].getLoyaltyCardById(loyaltyCardId);
        }return loyaltyCard;
    };
    LoyaltyCardCategory.prototype.getLoyaltyCardByLabel = function (loyaltyCardLabel) {
        //recursive research, need lower case input
        var loyaltyCard = null;
        for (var j = 0; j < this.loyaltyCards.length; j++) {
            if (this.loyaltyCards[j].label.toLowerCase() == loyaltyCardLabel) return this.loyaltyCards[j];
        }for (var z = 0; z < this.categories.length && !loyaltyCard; z++) {
            loyaltyCard = this.categories[z].getLoyaltyCardByLabel(loyaltyCardLabel);
        }return loyaltyCard;
    };
    LoyaltyCardCategory.prototype.getLoyaltyCardCategoryById = function (categoryId) {
        //recursive research
        var category = null;
        for (var z = 0; z < this.categories.length && !category; z++) {
            if (this.categories[z].id == categoryId) category = this.categories[z];else category = this.categories[z].getLoyaltyCardCategoryById(categoryId);
        }return category;
    };
    LoyaltyCardCategory.prototype.loadRef = function () {
        if (this.imageId) this.image = ImageData.getById(this.imageId);
        if (this.companyImageId) this.companyImage = CompanyImageData.getById(this.companyImageId);
        if (this.parentCategory == null && this.parentCategoryId) this.parentCategory = LoyaltyCardCategoryData.getById(this.parentCategoryId);
    };

    LoyaltyCardCategory.prototype.getSubStatCategories = function (rootCategory) {
        return this.categories.concat(this.loyaltyCards);
    };

    LoyaltyCardCategory.prototype.isDescendantOf = function (category) {
        var isDescendantOf = false;
        if (this.parentCategory === category) {
            isDescendantOf = true;
        } else {
            if (this.parentCategory) {
                isDescendantOf = this.parentCategory.isDescendantOf(category);
            }
        }

        return isDescendantOf;
    };

    return LoyaltyCardCategory;
}]);

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardCategorySrv', ["LoyaltyCardCategory_Resource", "LoyaltyCardCategory", "LoyaltyCardCategoryData", "UserActionData", "LoyaltyCardSrv", "$log", "ServerSrv", function (LoyaltyCardCategory_Resource, LoyaltyCardCategory, LoyaltyCardCategoryData, UserActionData, LoyaltyCardSrv, $log, ServerSrv) {
    //$timeout (function () {

    var categorySrv = {};
    categorySrv.query = function (successFunction, errorFunction) {
        var treeLoaded = false;
        var deletedLoaded = false;
        LoyaltyCardCategory_Resource.getTree({}, //params
        function (data) {
            //success
            LoyaltyCardCategoryData.categoryRoot = new LoyaltyCardCategory(data);
            if (successFunction !== undefined && deletedLoaded) successFunction(LoyaltyCardCategoryData.categoryRoot);
            treeLoaded = true;
        }, function (data) {
            //failure
            $log.error("LoyaltyCardCategory_Resource.getTree error");
            $log.error(data);
            if (errorFunction !== undefined && deletedLoaded) errorFunction(data);
            treeLoaded = true;
        });
        LoyaltyCardCategory_Resource.getDeleted({}, //params
        function (data) {
            //success
            LoyaltyCardCategoryData.deletedCategories = [];
            for (var i = 0; i < data.length; i++) {
                new LoyaltyCardCategory(data[i]);
            } //Auto Add to LoyaltyCardCategoryData

            if (successFunction !== undefined && treeLoaded) successFunction(LoyaltyCardCategoryData.categoryRoot);
            deletedLoaded = true;
        }, function (data) {
            //failure
            $log.error("LoyaltyCardCategory_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined && treeLoaded) errorFunction(data);
            deletedLoaded = true;
        });
    };
    categorySrv.save = function (category, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(categorySrv.saveSync, category, successFunction, errorFunction);
    };
    categorySrv.saveSync = function (category, successFunction, errorFunction) {
        //$timeout (function () {

        var LoyaltyCardCategoryRes = category.getObjectResource();
        LoyaltyCardCategoryRes.$save({}, //no params
        function (data) {

            try {
                category.setId(data.id);
                //TODO  UserActionData.add(data.userAction);
                if (successFunction) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    categorySrv.remove = function (category, successFunction, errorFunction) {
        LoyaltyCardCategoryData.remove(category);
        ServerSrv.startSavingProcess(categorySrv.removeSync, category, successFunction, errorFunction);
    };
    categorySrv.removeSync = function (category, successFunction, errorFunction) {
        //$timeout (function () {

        var categoryRes = new LoyaltyCardCategory_Resource();
        categoryRes.$remove({ id: category.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    categorySrv.restore = function (category, successFunction, errorFunction) {
        LoyaltyCardCategoryData.restore(category);
        ServerSrv.startSavingProcess(categorySrv.restoreSync, category, successFunction, errorFunction);
    };
    categorySrv.restoreSync = function (category, successFunction, errorFunction) {
        //$timeout (function () {

        var categoryRes = category.getObjectResource();
        categoryRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    categorySrv.getLoyaltyCardCategoryOnServer = function (scope, targetName, categoryId) {

        var category = null;
        if (LoyaltyCardCategoryData.categoryRoot.categories != null && LoyaltyCardCategoryData.categoryRoot.categories.length > 0) {
            for (var i = 0; i < LoyaltyCardCategoryData.categoryRoot.categories.length && !category; i++) {
                if (LoyaltyCardCategoryData.categoryRoot.categories[i].getId() == categoryId) category = LoyaltyCardCategoryData.categoryRoot.categories[i];else for (var j = 0; j < LoyaltyCardCategoryData.categoryRoot.categories[i].categories.length && !category; j++) {
                    if (LoyaltyCardCategoryData.categoryRoot.categories[i].categories[j].getId() == categoryId) category = LoyaltyCardCategoryData.categoryRoot.categories[i].categories[j];
                }
            }scope[targetName] = category;
        } else {

            LoyaltyCardCategory_Resource.get({ id: categoryId }, function (categoryRes) {
                //success
                var bookingLoyaltyCards = [];
                scope[targetName] = new LoyaltyCardCategory(categoryRes);
            }, function (categoryRes) {//failure
                //error handling goes here
            });
        }
    };
    categorySrv.get = function (categoryId) {
        //TODO
        return null;
    };
    categorySrv.getLoyaltyCardById = function (loyaltyCardId) {
        if (LoyaltyCardCategoryData.categoryRoot != null) return LoyaltyCardCategoryData.categoryRoot.getLoyaltyCard(loyaltyCardId);
    };
    categorySrv.loadRef = function () {
        var categories = LoyaltyCardCategoryData.indexCategories;
        for (var i = 0; i < categories.length; i++) {
            categories[i].loadRef();
        }
    };
    categorySrv.moveLoyaltyCard = function (category, loyaltyCard) {
        if (category) {
            category.moveLoyaltyCard(loyaltyCard);
            LoyaltyCardSrv.save(loyaltyCard);
        }
    };
    categorySrv.updateLocally = function (id, object) {
        var category = null;
        var parentCategory = null;
        if (object.parentCategoryId) //Optimization : get parent if exist
            {
                parentCategory = LoyaltyCardCategoryData.getById(object.parentCategoryId);
                if (parentCategory != null) category = parentCategory.getLoyaltyCardCategoryById(id);
            } else category = LoyaltyCardCategoryData.getById(id);
        if (category != null) category.loadObject(object, parentCategory);
    };
    categorySrv.addLocally = function (id, object) {
        //TODO
        /*            var category = LoyaltyCardCategoryData.getLoyaltyCardCategory(object.parentCategoryId);
                    if (category!=null)
                        category.addLoyaltyCard(new LoyaltyCard(object,category));*/

    };
    categorySrv.removeLocally = function (id, object) {
        //TODO
        /*            var loyaltyCard =  null;
                    var category = LoyaltyCardCategoryData.getLoyaltyCardCategory(object.parentCategoryId);
                    if (category!=null)
                        loyaltyCard = category.getLoyaltyCard(object.id)
                    if (loyaltyCard!=null)
                        category.removeLoyaltyCard(loyaltyCard);*/
    };

    return categorySrv;
}]);

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardCategoryData', ["$log", function ($log) {
    var categoryData = {
        categoryRoot: null,
        indexCategories: [], //Used as Index
        deletedCategories: []
    };
    categoryData.getById = function (categoryId) {
        for (var i = 0; i < this.indexCategories.length; i++) {
            if (this.indexCategories[i].id == categoryId) return this.indexCategories[i];
        }return null;
    };
    categoryData.getByIndex = function (catIndex) {
        if (catIndex >= 0 && catIndex < this.indexCategories.length) return this.indexCategories[catIndex];else return null;
    };
    categoryData.getIndexOf = function (category) {
        if (category) return this.indexCategories.indexOf(category);
        return -1;
    };
    categoryData.add = function (category) {
        this.indexCategories.push(category);
        if (category.isDeleted) {
            var index = this.deletedCategories.indexOf(category);
            if (index == -1) this.deletedCategories.push(category);
        }
        return this.indexCategories.length - 1;
    };
    categoryData.remove = function (category) //Soft Remove
    {
        var index = this.deletedCategories.indexOf(category);
        if (index == -1) {
            this.deletedCategories.push(category);
            category.isDeleted = true;
        }
    };
    categoryData.restore = function (category) //Soft Remove
    {
        var index = this.deletedCategories.indexOf(category);
        if (index != -1) {
            this.deletedCategories.splice(index, 1);
            category.isDeleted = false;
        }
    };
    categoryData.clear = function () {
        categoryData.categoryRoot = null;
        categoryData.indexCategories = [];
        categoryData.deletedCategories = [];
    };
    categoryData.loaded = function () {
        return categoryData.categoryRoot != null;
    };
    categoryData.getDeletedList = function () {
        return categoryData.deletedCategories;
    };

    return categoryData;
}]);

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardItem_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/loyaltyCardItems/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/loyaltyCardItems/deleted' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardItem', ["LoyaltyCardItem_Resource", "LoyaltyCardItemData", "CustomerData", "LoyaltyCardData", "HumanResourceData", "SaleData", "TaxMode", "SaleItem", "LoyaltyCardCategory", "LoyaltyCard", function (LoyaltyCardItem_Resource, LoyaltyCardItemData, CustomerData, LoyaltyCardData, HumanResourceData, SaleData, TaxMode, SaleItem, LoyaltyCardCategory, LoyaltyCard) {

    var LoyaltyCardItem = function LoyaltyCardItem(resource, isSaleAdvanceLoading) {
        SaleItem.call(this);

        this.id = null;
        this.isDeleted = false;
        this.label = "";
        this.color = "";
        this.type = null;
        this.itemType = null;
        this.ptsByCa = 0;
        this.ptsBySale = 0;
        this.monthValidity = null;
        this.validityExtend = null;
        this.validityDate = null;
        this.alertExp = 0;
        this.description = "";
        this.price = null;
        this.vat = null;
        this.vatCode = null;
        this.originalPrice = null;
        this.discountPercent = null;
        this.pts = null;
        this.sale = null;
        this._saleId = null;
        this.humanResource = null;
        this._humanResourceId = null;
        this.customer = null;
        this._customerId = null;
        this.loyaltyCard = null;
        this._loyaltyCardId = null;
        this.goalPts = null;
        this.goalType = null;
        this.goalAmount = null;
        this.goalText = null;
        this.isUsed = null;
        this.version = null;
        if (resource !== undefined && resource != null) {
            this.loadObject(resource);
        }
        if (isSaleAdvanceLoading === undefined || !isSaleAdvanceLoading) {
            LoyaltyCardItemData.add(this);
        }
    };

    LoyaltyCardItem.prototype = Object.create(SaleItem.prototype); //inherit functions from SaleItem

    LoyaltyCardItem.prototype.loadObject = function (object) {
        //Assume here than the object in parameter contains only id (must load them)
        if (!this.id) this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.label = object.label;
        this.color = object.color;
        this.type = object.type;
        this.itemType = object.itemType;
        this.ptsByCa = object.ptsByCa;
        this.ptsBySale = object.ptsBySale;
        this.monthValidity = object.monthValidity;
        this.validityExtend = object.validityExtend;
        this.alertExp = object.alertExp;
        if (object.validityDate) this.validityDate = new Date(object.validityDate);
        this.description = object.description;
        this.price = object.price;
        this.vat = object.vat;
        this.vatCode = object.vatCode;
        this.originalPrice = object.originalPrice;
        this.discountPercent = object.discountPercent;
        this.pts = object.pts;
        this._saleId = object.saleId;
        this._humanResourceId = object.humanResourceId;
        this._customerId = object.customerId;
        this._loyaltyCardId = object.loyaltyCardId;
        this.goalPts = object.goalPts;
        this.goalType = object.goalType;
        this.goalAmount = object.goalAmount;
        this.goalText = object.goalText;
        this.isUsed = object.isUsed;
        if (object.version) this.version = object.version;
    };
    LoyaltyCardItem.prototype.getObjectResource = function () {
        var res = new LoyaltyCardItem_Resource();
        res.id = this.id;
        res.isDeleted = this.isDeleted;
        res.color = this.color;
        res.label = this.label;
        res.type = this.type;
        res.itemType = this.itemType;
        res.ptsByCa = this.ptsByCa;
        res.ptsBySale = this.ptsBySale;
        res.monthValidity = this.monthValidity;
        res.validityExtend = this.validityExtend;
        res.alertExp = this.alertExp;
        res.validityDate = this.validityDate;
        res.description = this.description;
        res.price = this.price;
        res.vat = this.vat;
        res.vatCode = this.vatCode;
        res.originalPrice = this.originalPrice;
        res.discountPercent = this.discountPercent;
        res.pts = this.pts;
        if (this.sale) res.saleId = this.sale.id;else res.saleId = null;
        if (this.customer) res.customerId = this.customer.id;else res.customerId = null;
        if (this.humanResource) res.humanResourceId = this.humanResource.id;else res.humanResourceId = null;
        if (this.loyaltyCard) res.loyaltyCardId = this.loyaltyCard.id;else res.loyaltyCardId = null;

        res.goalPts = this.goalPts;
        res.goalType = this.goalType;
        res.goalAmount = this.goalAmount;
        res.goalText = this.goalText;
        res.isUsed = this.isUsed;
        return res;
    };

    LoyaltyCardItem.prototype.loadRef = function (isPreviousVersion, isApplicationLoading) {
        if (this._customerId) this.customer = CustomerData.getById(this._customerId, isApplicationLoading);
        if (this._loyaltyCardId) this.loyaltyCard = LoyaltyCardData.getById(this._loyaltyCardId);
        if (this._humanResourceId) this.humanResource = HumanResourceData.getById(this._humanResourceId);
        if (this._saleId) this.sale = SaleData.getById(this._saleId, isApplicationLoading);
    };

    LoyaltyCardItem.prototype.reload = function (endFunction) {
        var loyaltyCardSrv = this.getObjectResource();
        var loyaltyCard = this;
        if (this.getId() != null) loyaltyCardSrv.$get({ id: this.getId() }, //params
        function (data) {
            //success
            loyaltyCard.loadObject(data);
            if (endFunction != undefined) endFunction(loyaltyCard);
        }, function (data) {//failure
            //error handling goes here
            //TODO
        });
    };

    LoyaltyCardItem.prototype.getLoyaltyCard = function () {
        return this.loyaltyCard;
    };

    LoyaltyCardItem.prototype.getItem = function () {
        return this.loyaltyCard;
    };

    LoyaltyCardItem.prototype.getItemCategoryType = function () {
        return LoyaltyCardCategory;
    };

    LoyaltyCardItem.prototype.getItemType = function () {
        return LoyaltyCard;
    };

    LoyaltyCardItem.prototype.getDiscountPrice = function (taxMode) {
        var price = 0;
        if (this.sale.isStatusSoldOrCreditOrCanceled()) {
            price = this.price;
            //apply global discount on price
            if (this.sale.discountPercent != 0) {
                price -= this.sale.discountPercent * price / 100;
            }

            if (taxMode === TaxMode.HT) {
                var vat = this.vat ? this.vat : this.sale.vat;
                price = price / (100 + vat) * 100;
            }
        }

        return price;
    };

    return LoyaltyCardItem;
}]);

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardItemSrv', ["$log", "LoyaltyCardItem_Resource", "LoyaltyCardItem", "UserActionData", "LoyaltyCardItemData", "ServerSrv", "SaleData", function ($log, LoyaltyCardItem_Resource, LoyaltyCardItem, UserActionData, LoyaltyCardItemData, ServerSrv, SaleData) {
    var loyaltyCardSrv = {};
    loyaltyCardSrv.save = function (loyaltyCard, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(loyaltyCardSrv.saveSync, loyaltyCard, successFunction, errorFunction);
    };
    loyaltyCardSrv.saveSync = function (loyaltyCard, successFunction, errorFunction) {
        //$timeout (function () {

        var LoyaltyCardItemRes = loyaltyCard.getObjectResource();
        LoyaltyCardItemRes.$save({}, //no params
        function (data) {
            try {
                if (loyaltyCard.id == null) {
                    loyaltyCard.id = data.id;
                }
                if (!loyaltyCard.version || data.version && data.version > loyaltyCard.version) loyaltyCard.version = data.version;
                /** @namespace data.supplierId */
                if (data.supplierId && loyaltyCard.supplier) loyaltyCard.supplier.id = data.supplierId;

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    loyaltyCardSrv.remove = function (loyaltyCard, successFunction, errorFunction) {
        LoyaltyCardItemData.remove(loyaltyCard);
        ServerSrv.startSavingProcess(loyaltyCardSrv.removeSync, loyaltyCard, successFunction, errorFunction);
    };
    loyaltyCardSrv.removeSync = function (loyaltyCard, successFunction, errorFunction) {
        //$timeout (function () {

        var loyaltyCardRes = new LoyaltyCardItem_Resource();
        loyaltyCardRes.$remove({ id: loyaltyCard.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    loyaltyCardSrv.restore = function (loyaltyCard, successFunction, errorFunction) {
        LoyaltyCardItemData.restore(loyaltyCard);
        ServerSrv.startSavingProcess(loyaltyCardSrv.restoreSync, loyaltyCard, successFunction, errorFunction);
    };
    loyaltyCardSrv.restoreSync = function (loyaltyCard, successFunction, errorFunction) {
        //$timeout (function () {

        var loyaltyCardRes = loyaltyCard.getObjectResource();
        loyaltyCardRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    loyaltyCardSrv.query = function (successFunction, errorFunction) {
        LoyaltyCardItem_Resource.getDeleted({}, //params
        function (data) {
            //success

            LoyaltyCardItemData.deletedLoyaltyCardItems = [];
            for (var i = 0; i < data.length; i++) {
                new LoyaltyCardItem(data[i]);
            } //Auto Add to LoyaltyCardItemData

            if (successFunction !== undefined) successFunction(LoyaltyCardItemData.categoryRoot);
        }, function (data) {
            //failure
            $log.error("LoyaltyCardItem_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    loyaltyCardSrv.loadRef = function (isApplicationLoading) {
        var loyaltyCards = LoyaltyCardItemData.indexLoyaltyCardItems;
        for (var i = 0; i < loyaltyCards.length; i++) {
            loyaltyCards[i].loadRef(null, isApplicationLoading);
        }
    };
    loyaltyCardSrv.updateLocally = function (id, resource) {
        var loyaltyCardItem = LoyaltyCardItemData.getById(id);
        if (loyaltyCardItem != null) {
            loyaltyCardItem.loadObject(resource);
            loyaltyCardItem.id = id;
            loyaltyCardItem.loadRef();
            //remove from sale
            if (loyaltyCardItem.sale) loyaltyCardItem.sale.removeLoyaltyCardItem(loyaltyCardItem);
            if (resource.saleId) {
                var sale = SaleData.getById(resource.saleId);
                if (sale) sale.addLoyaltyCardItem(loyaltyCardItem);
            }
        }
        return loyaltyCardItem;
    };
    loyaltyCardSrv.addLocally = function (id, resource) {
        var loyaltyCardItem = LoyaltyCardItemData.getById(id);
        if (loyaltyCardItem != null) loyaltyCardItem.loadObject(resource);else {
            loyaltyCardItem = new LoyaltyCardItem(resource, null, false);
        }
        loyaltyCardItem.id = id;
        loyaltyCardItem.loadRef();
        if (resource.saleId) {
            var sale = SaleData.getById(resource.saleId);
            if (sale) sale.addLoyaltyCardItem(loyaltyCardItem);
        }
        return loyaltyCardItem;
    };
    loyaltyCardSrv.removeLocally = function (id, resource) {
        var loyaltyCardItem = LoyaltyCardItemData.getById(id);
        if (loyaltyCardItem != null) {
            //remove from sale
            if (loyaltyCardItem.sale) loyaltyCardItem.sale.removeLoyaltyCardItem(loyaltyCardItem);
        }
        return loyaltyCardItem;
    };

    return loyaltyCardSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardItemData', ["$log", function ($log) {
    var loyaltyCardData = {
        indexLoyaltyCardItems: [], //Used as Index
        deletedLoyaltyCardItems: []
    };
    loyaltyCardData.getById = function (loyaltyCardId) {
        for (var i = 0; i < this.indexLoyaltyCardItems.length; i++) {
            if (this.indexLoyaltyCardItems[i].id == loyaltyCardId) return this.indexLoyaltyCardItems[i];
        }return null;
    };
    loyaltyCardData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexLoyaltyCardItems.length) {
            return this.indexLoyaltyCardItems[servIndex];
        } else return null;
    };
    loyaltyCardData.getIndexOf = function (loyaltyCard) {
        if (loyaltyCard) return this.indexLoyaltyCardItems.indexOf(loyaltyCard);
        return -1;
    };
    loyaltyCardData.add = function (loyaltyCard) {
        this.indexLoyaltyCardItems.push(loyaltyCard);
        if (loyaltyCard.isDeleted) {
            var index = this.deletedLoyaltyCardItems.indexOf(loyaltyCard);
            if (index == -1) this.deletedLoyaltyCardItems.push(loyaltyCard);
        }
        return this.indexLoyaltyCardItems.length - 1;
    };
    loyaltyCardData.remove = function (loyaltyCard) //Soft Remove
    {
        var index = this.deletedLoyaltyCardItems.indexOf(loyaltyCard);
        if (index == -1) {
            this.deletedLoyaltyCardItems.push(loyaltyCard);
            loyaltyCard.isDeleted = true;
        }
    };
    loyaltyCardData.restore = function (loyaltyCard) //Soft Remove
    {
        var index = this.deletedLoyaltyCardItems.indexOf(loyaltyCard);
        if (index != -1) {
            this.deletedLoyaltyCardItems.splice(index, 1);
            loyaltyCard.isDeleted = false;
        }
    };
    loyaltyCardData.clear = function () {
        loyaltyCardData.indexLoyaltyCardItems = [];
        loyaltyCardData.deletedLoyaltyCardItems = [];
    };
    loyaltyCardData.getDeletedList = function () {
        return loyaltyCardData.deletedLoyaltyCardItems;
    };

    return loyaltyCardData;
}]);

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('MobileDevice_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/mobileDevices/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        setCustomer: { method: 'POST', url: baseUrl + 'rest/mobileDevices/setCustomer' }
    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('MobileDevice', ["MobileDevice_Resource", "MobileDeviceData", function (MobileDevice_Resource, MobileDeviceData) {
    var MobileDevice = function MobileDevice(resource) {
        this.id = null;
        this.isDeleted = false;
        this.os = null;
        this.osVersion = null;
        this.token = null;
        this.customerId = null;
        this.lastAppOpening = null;
        this.loadObject(resource);
        MobileDeviceData.add(this);
    };
    MobileDevice.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.os = object.os;
            this.osVersion = object.osVersion;
            this.token = object.token;
            if (object.customerId) this.customerId = object.customerId;
            this.lastAppOpening = object.lastAppOpening;
        }
    };
    MobileDevice.prototype.getObjectResource = function () {
        var rsMobileDevice = new MobileDevice_Resource();
        rsMobileDevice.id = this.id;
        rsMobileDevice.isDeleted = this.isDeleted;
        rsMobileDevice.os = this.os;
        rsMobileDevice.osVersion = this.osVersion;
        rsMobileDevice.token = this.token;
        rsMobileDevice.customerId = this.customerId;
        rsMobileDevice.lastAppOpening = this.lastAppOpening;
        return rsMobileDevice;
    };

    MobileDevice.prototype.getId = function () {
        return this.id;
    };

    MobileDevice.prototype.setId = function (id) {
        this.id = id;
    };

    return MobileDevice;
}]);

angular.module('FlexyBeautyApp.services').factory('MobileDeviceSrv', ["$log", "MobileDevice_Resource", "ServerSrv", "MobileDeviceData", "MobileDevice", function ($log, MobileDevice_Resource, ServerSrv, MobileDeviceData, MobileDevice) {
    var mobileDeviceSrv = {};

    mobileDeviceSrv.setCustomer = function (mobileDevice, customerId, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(mobileDeviceSrv.setCustomerSync, mobileDevice, customerId, successFunction, errorFunction);
    };
    mobileDeviceSrv.setCustomerSync = function (mobileDevice, customerId, successFunction, errorFunction) {
        var mobileDeviceRes = new MobileDevice_Resource();
        mobileDeviceRes.os = mobileDevice.os;
        mobileDeviceRes.osVersion = mobileDevice.osVersion;
        mobileDeviceRes.token = mobileDevice.token;
        mobileDeviceRes.customerId = customerId;
        mobileDeviceRes.setCustomer({}, //no params
        function (data) {
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    mobileDeviceSrv.query = function (successFunction, errorFunction) {
        MobileDevice_Resource.query({}, //params
        function (data) {
            //success
            MobileDeviceData.clear();
            for (var i = 0; i < data.length; i++) {
                new MobileDevice(data[i]);
            } //Auto Add to MobileDeviceData
            if (successFunction !== undefined) successFunction(MobileDeviceData.indexMobileDevice);
        }, function (data) {
            //failure
            $log.error("MobileDevice_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    mobileDeviceSrv.get = function (id, successFunction, errorFunction) {
        MobileDevice_Resource.get({ id: id }, //params
        function (mobileDeviceResource) {
            if (successFunction != undefined) successFunction(new MobileDevice(mobileDeviceResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };
    return mobileDeviceSrv;
}]);
angular.module('FlexyBeautyApp.services').factory('MobileDeviceData', ["$filter", function ($filter) {
    var mobileDeviceDataSrv = {
        indexMobileDevice: [],
        activeMobileDevice: [],
        deletedMobileDevices: [] //deleted items
    };
    mobileDeviceDataSrv.getById = function (mobileDeviceId) {
        for (var i = 0; i < this.indexMobileDevice.length; i++) {
            if (this.indexMobileDevice[i].getId() == mobileDeviceId) return this.indexMobileDevice[i];
        }return null;
    };

    //return all mobiles for a customer. The more recent device is the first element in the tab.
    mobileDeviceDataSrv.getListByCustomerId = function (customerId) {
        var tabDevices = [];
        for (var i = 0; i < this.activeMobileDevice.length; i++) {
            if (this.activeMobileDevice[i].customerId == customerId) tabDevices.push(this.activeMobileDevice[i]);
        }
        if (tabDevices.length == 0) return null;
        tabDevices.sort(function (a, b) {
            if (a.lastAppOpening > b.lastAppOpening) return -1;
            if (a.lastAppOpening < b.lastAppOpening) return 1;
            if (a.lastAppOpening == b.lastAppOpening) return 0;
        });
        return tabDevices;
    };

    mobileDeviceDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexMobileDevice.length) return this.indexMobileDevice[index];
        return null;
    };
    mobileDeviceDataSrv.getIndexOf = function (mobileDevice) {
        if (mobileDevice) return this.indexMobileDevice.indexOf(mobileDevice);
        return -1;
    };

    mobileDeviceDataSrv.add = function (mobileDevice) {
        var mobileDeviceArray = this.activeMobileDevice;
        if (mobileDevice.isDeleted) mobileDeviceArray = this.deletedMobileDevice;
        var index = this.indexMobileDevice.indexOf(mobileDevice);
        if (index != -1) {
            var realIndex = mobileDeviceArray.indexOf(mobileDevice);
            if (realIndex == -1) mobileDeviceArray.push(mobileDevice);
        } else {
            index = this.indexMobileDevice.length;
            this.indexMobileDevice.push(mobileDevice);
            mobileDeviceArray.push(mobileDevice);
        }
        return index;
    };
    mobileDeviceDataSrv.remove = function (mobileDevice) {
        var index = this.activeMobileDevice.indexOf(mobileDevice);
        if (index != -1) {
            this.activeMobileDevice.splice(index, 1);
            this.deletedMobileDevice.push(mobileDevice);
            mobileDevice.isDeleted = true;
        }
    };
    mobileDeviceDataSrv.restore = function (mobileDevice) {
        var index = this.deletedMobileDevice.indexOf(mobileDevice);
        if (index != -1) {
            this.deletedMobileDevice.splice(index, 1);
            this.activeMobileDevice.push(mobileDevice);
            mobileDevice.isDeleted = false;
        }
    };
    mobileDeviceDataSrv.clear = function () {
        this.indexMobileDevice = [];
        this.activeMobileDevice = [];
        this.deletedMobileDevice = [];
    };

    mobileDeviceDataSrv.getActiveList = function () {
        return this.activeMobileDevice;
    };
    mobileDeviceDataSrv.getDeletedList = function () {
        return this.deletedMobileDevice;
    };
    return mobileDeviceDataSrv;
}]);

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('Monitoring_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/monitoring/', {}, {
        logHealth: { method: 'POST', url: baseUrl + 'rest/monitoring/logHealth' }
    });
}]);
angular.module('FlexyBeautyApp.services').factory('MonitoringSrv', ["Monitoring_Resource", function (Monitoring_Resource) {
    var monitoringSrv = {
        alreadySent: false
    };

    monitoringSrv.logHealth = function (applicationName, healthValue, loadingTimes) {
        if (!monitoringSrv.alreadySent) {
            monitoringSrv.alreadySent = true;
            var monitoringResource = new Monitoring_Resource();
            monitoringResource.applicationName = applicationName;
            monitoringResource.health = healthValue;
            monitoringResource.loadingTimes = loadingTimes;
            return monitoringResource.$logHealth({}).then(function () {
                console.log("MonitoringSrv.save - success");
            }, function () {
                //failure
                monitoringSrv.alreadySent = false;
                console.log("MonitoringSrv.save - failure");
            });
        }

        return Promise.resolve();
    };

    return monitoringSrv;
}]);
angular.module('FlexyBeautyApp.services').factory('MonitoringHealthState', [function (gettextCatalog) {
    return {
        OK: "OK",
        KO: "KO"
    };
}]);
angular.module('FlexyBeautyApp.services').factory('MonitoringApplication', [function (gettextCatalog) {
    return {
        PROBACKOFFICE: "PROBACKOFFICE",
        WEBSITE: "WEBSITE"
    };
}]);

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 13/11/2013
 * Time: 09:04
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Notification_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/notifications/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        countUnread: { method: 'GET', url: baseUrl + 'rest/notifications/count-unread' }

    });
}]);

angular.module('FlexyBeautyApp.services').factory('Notification', ["NotificationData", "Notification_Resource", "UserAction", function (NotificationData, Notification_Resource, UserAction) {

    var Notification = function Notification(notificationRes) {
        this.id = null;
        this.humanResourceId = null;
        this.status = null;
        this.userActionId = null;
        this.userAction = null;
        this.bookedPlatform = null;
        this.timeCreated = null;

        if (notificationRes !== undefined && notificationRes != null) {
            this.loadObject(notificationRes);
            NotificationData.add(this);
        }
    };
    Notification.prototype.loadObject = function (notificationRes) {
        if (notificationRes !== undefined && notificationRes != null) {
            if (!this.id) this.id = notificationRes.id;
            this.humanResourceId = notificationRes.humanResourceId;
            this.userActionId = notificationRes.userActionId;
            this.status = notificationRes.status;
            if (notificationRes.timeCreated) this.timeCreated = new Date(notificationRes.timeCreated);
            if (notificationRes.userAction) this.userAction = new UserAction(notificationRes.userAction, true);
            if (notificationRes.bookedPlatform) this.bookedPlatform = notificationRes.bookedPlatform;
        }
    };
    Notification.prototype.getObjectResource = function () {
        var rsNotification = new Notification_Resource();
        rsNotification.id = this.id;
        rsNotification.status = this.status;
        rsNotification.timeCreated = this.timeCreated;
        return rsNotification;
    };

    return Notification;
}]);

angular.module('FlexyBeautyApp.services').factory('NotificationSrv', ["$log", "$timeout", "Notification", "Notification_Resource", "NotificationData", "UserActionSrv", "UserActionManager", "ServerSrv", "$rootScope", "UserAction", function ($log, $timeout, Notification, Notification_Resource, NotificationData, UserActionSrv, UserActionManager, ServerSrv, $rootScope, UserAction) {
    var notificationSrv = {};

    notificationSrv.query = function (successFunction, errorFunction) {
        Notification_Resource.query({}, function (data) {
            NotificationData.clear();
            for (var i = 0; i < data.length; i++) {
                new Notification(data[i]);
            }
            NotificationData.isLoaded = true;
            if (successFunction !== undefined) {
                successFunction(NotificationData.indexNotifications);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    notificationSrv.countUnread = function () {
        var notificationResource = new Notification_Resource();
        return notificationResource.$countUnread();
    };

    notificationSrv.save = function (notification, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(notificationSrv.saveSync, notification, successFunction, errorFunction);
    };
    notificationSrv.saveSync = function (notification, successFunction, errorFunction) {
        var NotificationRes = notification.getObjectResource();
        NotificationRes.$save({}, //no params
        function (data) {
            try {
                notification.id = data.id;
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    notificationSrv.onNotificationChannel = function (notificationRes) {
        if (notificationRes && notificationRes.userActionId) {
            UserActionSrv.get(notificationRes.userActionId, function (userActionRes) {
                if (NotificationData.isLoaded) {
                    var notification = new Notification(notificationRes);
                    notification.userAction = new UserAction(userActionRes, true);
                    UserActionManager.executeUserAction(userActionRes, true);
                    $rootScope.$emit("onNotification", notification);
                } else {
                    UserActionManager.executeUserAction(userActionRes, true);
                    $rootScope.$emit("onNotification", null);
                }
            }, function () {
                //TODO
            });
        }
    };

    return notificationSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('NotificationData', ["$log", function ($log) {
    var notificationData = {
        isLoaded: false,
        indexNotifications: [],
        unreadNotifications: undefined
    };
    notificationData.getById = function (notificationId) {
        for (var i = 0; i < this.indexNotifications.length; i++) {
            if (this.indexNotifications[i].id == notificationId) return this.indexNotifications[i];
        }return null;
    };
    notificationData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexNotifications.length) return this.indexNotifications[index];
        return null;
    };
    notificationData.getIndexOf = function (notification) {
        if (notification) return this.indexNotifications.indexOf(notification);
        return -1;
    };

    notificationData.add = function (notification) {
        if (notification && !notificationData.getById(notification.id)) {
            this.indexNotifications.push(notification);
        }
    };
    notificationData.clear = function () {
        notificationData.indexNotifications = [];
    };
    return notificationData;
}]);

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('NotificationCampaign_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/notificationCampaigns/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getNotifications: { method: 'GET', isArray: true, url: baseUrl + 'rest/notificationCampaigns/getNotifications/:id' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('NotificationCampaign', ["NotificationCampaign_Resource", "NotificationCampaignData", "MobileDeviceData", function (NotificationCampaign_Resource, NotificationCampaignData, MobileDeviceData) {
    var NotificationCampaign = function NotificationCampaign(resource) {
        // Call the parent constructor
        this.id = null;
        this.isDeleted = false;
        this.label = null;
        this.subject = null;
        this.text = null;
        this.type = null;
        this.sendingDate = null;
        this.status = null;
        this.mobiles = [];
        this.filters = [];
        this.version = null;
        if (resource !== undefined && resource != null) this.loadObject(resource);

        NotificationCampaignData.add(this);
    };

    NotificationCampaign.prototype.loadObject = function (object) {
        if (!this.id) this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.label = object.label;
        this.subject = object.subject;
        this.text = object.text;
        this.type = object.type;
        if (object.sendingDate) this.sendingDate = new Date(object.sendingDate);
        this.status = object.status;
        this.mobilesId = object.mobilesId;
        if (object.filters) {
            for (var i = 0; i < object.filters.length; i++) {
                this.filters.push({
                    code: object.filters[i].code,
                    value: object.filters[i].value,
                    selectedItemViews: object.filters[i].selectedItemViews
                });
            }
        }
        if (object.version) {
            this.version = object.version;
        }
    };
    NotificationCampaign.prototype.loadRef = function () {
        if (this.mobilesId) {
            var newMobiles = [];
            for (var i = 0; i < this.mobilesId.length; i++) {
                var mobile = MobileDeviceData.getById(this.mobilesId[i]);
                if (mobile != null) newMobiles.push(mobile);
            }
            this.mobiles = newMobiles;
        }

        delete this.mobilesId;
    };

    NotificationCampaign.prototype.getObjectResource = function () {
        var rsNotificationCampaign = new NotificationCampaign_Resource();
        rsNotificationCampaign.id = this.id;
        rsNotificationCampaign.isDeleted = this.isDeleted;
        rsNotificationCampaign.label = this.label;
        rsNotificationCampaign.subject = this.subject;
        rsNotificationCampaign.text = this.text;
        rsNotificationCampaign.type = this.type;
        if (this.sendingDate) {
            rsNotificationCampaign.sendingDate = new Date(this.sendingDate);
        }
        rsNotificationCampaign.status = this.status;

        rsNotificationCampaign.mobilesId = [];

        for (var i = 0; i < this.mobiles.length; i++) {
            rsNotificationCampaign.mobilesId.push(this.mobiles[i].id);
        }
        rsNotificationCampaign.filters = [];
        if (this.filters) {
            for (var i = 0; i < this.filters.length; i++) {
                rsNotificationCampaign.filters.push({
                    code: this.filters[i].code,
                    value: this.filters[i].value,
                    selectedItemViews: this.filters[i].selectedItemViews
                });
            }
        }
        return rsNotificationCampaign;
    };

    NotificationCampaign.prototype.copyToObject = function (object) {
        object.id = this.id;
        object.label = this.label;
    };

    NotificationCampaign.prototype.getId = function () {
        return this.id;
    };

    NotificationCampaign.prototype.setId = function (id) {
        this.id = id;
    };

    return NotificationCampaign;
}]);

angular.module('FlexyBeautyApp.services').factory('NotificationCampaignSrv', ["$log", "NotificationCampaign_Resource", "NotificationCampaign", "NotificationCampaignData", "UserActionData", "ServerSrv", function ($log, NotificationCampaign_Resource, NotificationCampaign, NotificationCampaignData, UserActionData, ServerSrv) {
    var notificationCampaignSrv = {};

    notificationCampaignSrv.query = function (successFunction, errorFunction) {

        NotificationCampaign_Resource.query({}, //params
        function (data) {
            //success
            NotificationCampaignData.clear();

            for (var i = 0; i < data.length; i++) {
                new NotificationCampaign(data[i]); //auto register to DATA
            }

            if (successFunction !== undefined) successFunction(NotificationCampaignData.getActiveList());
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    notificationCampaignSrv.getNotifications = function (notificationCampaign, successFunction, errorFunction) {
        if (notificationCampaign) {
            NotificationCampaign_Resource.getNotifications({ id: notificationCampaign.id }, //params
            function (data) {
                if (successFunction !== undefined) successFunction(data);
            }, function (data) {
                $log.error(data);
                if (errorFunction !== undefined) errorFunction(data);
            });
        } else if (errorFunction !== undefined) errorFunction();
    };

    notificationCampaignSrv.restore = function (notificationCampaign, successFunction, errorFunction) {
        NotificationCampaignData.restore(notificationCampaign);
        ServerSrv.startSavingProcess(notificationCampaignSrv.restoreSync, notificationCampaign, successFunction, errorFunction);
    };
    notificationCampaignSrv.restoreSync = function (notificationCampaign, successFunction, errorFunction) {
        //$timeout (function () {

        var notificationCampaignRes = notificationCampaign.getObjectResource();
        notificationCampaignRes.$save({}, //no params
        function (data) {
            try {
                notificationCampaign.setId(data.id);
                if (!notificationCampaign.version || data.version && data.version > notificationCampaign.version) notificationCampaign.version = data.version;
                UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    notificationCampaignSrv.save = function (notificationCampaign, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(notificationCampaignSrv.saveSync, notificationCampaign, successFunction, errorFunction);
    };
    notificationCampaignSrv.saveSync = function (notificationCampaign, successFunction, errorFunction) {
        //$timeout (function () {

        var notificationCampaignRes = notificationCampaign.getObjectResource();
        notificationCampaignRes.$save({}, //no params
        function (data) {
            try {
                notificationCampaign.setId(data.id);
                UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    notificationCampaignSrv.remove = function (notificationCampaign, successFunction, errorFunction) {
        NotificationCampaignData.remove(notificationCampaign);
        ServerSrv.startSavingProcess(notificationCampaignSrv.removeSync, notificationCampaign, successFunction, errorFunction);
    };
    notificationCampaignSrv.removeSync = function (notificationCampaign, successFunction, errorFunction) {
        var notificationCampaignSrv = new NotificationCampaign_Resource();
        notificationCampaignSrv.$remove({ id: notificationCampaign.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    notificationCampaignSrv.updateLocally = function (id, objectToRestore) {
        var notificationCampaign = NotificationCampaignData.getById(id);
        if (notificationCampaign != null) {
            notificationCampaign.loadObject(objectToRestore);
            notificationCampaign.loadRef();
        }
        return notificationCampaign;
    };
    notificationCampaignSrv.removeLocally = function (id, object) {
        var notificationCampaign = NotificationCampaignData.getById(id);
        if (notificationCampaign != null) {
            NotificationCampaignData.remove(notificationCampaign);
        }
        return notificationCampaign;
    };
    notificationCampaignSrv.addLocally = function (id, objectToRestore) {
        var notificationCampaign = NotificationCampaignData.getById(id);
        if (notificationCampaign != null) {
            notificationCampaign.loadObject(objectToRestore);
            notificationCampaign.loadRef();
            NotificationCampaignData.add(notificationCampaign);
        }
        return notificationCampaign;
    };
    notificationCampaignSrv.loadRef = function () {
        var notificationCampaigns = NotificationCampaignData.getActiveList();
        for (var i = 0; i < notificationCampaigns.length; i++) {
            notificationCampaigns[i].loadRef();
        }
    };

    return notificationCampaignSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('NotificationCampaignData', ["$log", function ($log) {
    var notificationCampaignDataSrv = {
        indexNotificationCampaigns: [], //Never deleted (used as index)
        activeNotificationCampaigns: [], //active list
        deletedNotificationCampaigns: [] //deleted items
    };
    notificationCampaignDataSrv.getById = function (notificationCampaignId) {
        for (var i = 0; i < this.indexNotificationCampaigns.length; i++) {
            if (this.indexNotificationCampaigns[i].id == notificationCampaignId) return this.indexNotificationCampaigns[i];
        }return null;
    };
    notificationCampaignDataSrv.getIndexOf = function (notificationCampaign) {
        if (notificationCampaign) return this.indexNotificationCampaigns.indexOf(notificationCampaign);
        return -1;
    };
    notificationCampaignDataSrv.getByIndex = function (notificationCampaignIndex) {
        if (notificationCampaignIndex >= 0 && notificationCampaignIndex < this.indexNotificationCampaigns.length) return this.indexNotificationCampaigns[notificationCampaignIndex];else return null;
    };
    notificationCampaignDataSrv.add = function (notificationCampaign) {
        var notificationCampaignArray = this.activeNotificationCampaigns;
        if (notificationCampaign.isDeleted) notificationCampaignArray = this.deletedNotificationCampaigns;
        var index = this.indexNotificationCampaigns.indexOf(notificationCampaign);
        if (index != -1) {
            var realIndex = notificationCampaignArray.indexOf(notificationCampaign);
            if (realIndex == -1) notificationCampaignArray.push(notificationCampaign);
        } else {
            index = this.indexNotificationCampaigns.length;
            this.indexNotificationCampaigns.push(notificationCampaign);
            notificationCampaignArray.push(notificationCampaign);
        }
        return index;
    };
    notificationCampaignDataSrv.remove = function (notificationCampaign) //Soft Remove
    {
        var index = this.activeNotificationCampaigns.indexOf(notificationCampaign);
        if (index != -1) {
            this.activeNotificationCampaigns.splice(index, 1);
            this.deletedNotificationCampaigns.push(notificationCampaign);
            notificationCampaign.isDeleted = true;
        }
    };
    notificationCampaignDataSrv.restore = function (notificationCampaign) //Soft Remove
    {
        var index = this.deletedNotificationCampaigns.indexOf(notificationCampaign);
        if (index != -1) {
            this.deletedNotificationCampaigns.splice(index, 1);
            this.activeNotificationCampaigns.push(notificationCampaign);
            notificationCampaign.isDeleted = false;
        }
    };
    notificationCampaignDataSrv.clear = function () {
        this.indexNotificationCampaigns = [];
        this.activeNotificationCampaigns = [];
        this.deletedNotificationCampaigns = [];
    };
    notificationCampaignDataSrv.getActiveList = function () {
        return this.activeNotificationCampaigns;
    };
    notificationCampaignDataSrv.getDeletedList = function () {
        return this.deletedNotificationCampaigns;
    };

    return notificationCampaignDataSrv;
}]);

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('DialogCtrl', ["$scope", "$rootScope", "dialog", "dialogsModel", "$document", "LanguageManager", "Brand", function ($scope, $rootScope, dialog, dialogsModel, $document, LanguageManager, Brand) {
    var key;
    // hook the passed data to the popin scope
    for (key in dialogsModel) {
        $scope[key] = dialogsModel[key];
    }

    //Mock for Oui/Non toggle buttons
    $scope.isEnglishLanguage = function () {
        return LanguageManager.isEnglishLanguage();
    };

    $scope.dialog = dialog;
    $scope.cancel = function () {
        dialog.close(false);
    };
    $scope.action = function () {
        dialog.close(true);
    };

    $scope.confirm = function (params) {
        dialog.close(params);
    };

    $scope.brand = Brand;
}]);

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('OptInOut_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/optInOut/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('OptInOut', ["OptInOut_Resource", "OptInOutData", function (OptInOut_Resource, OptInOutData) {
    var OptInOut = function OptInOut(resource, customerId) {
        this.id = null;
        this.isSmsCampaignAllowed = null;
        this.isEmailCampaignAllowed = null;
        this.isNotificationCampaignAllowed = null;
        this.isExternalOptInOut = null;
        this.origin = null;
        this.timeModified = null;
        this.customerId = customerId;
        this.version = null;

        if (resource !== undefined && resource !== null) this.setValues(resource);

        OptInOutData.add(this);
    };

    OptInOut.prototype.setId = function (id) {
        if (!this.id) this.id = id;
    };

    OptInOut.prototype.getId = function () {
        return this.id;
    };

    OptInOut.prototype.setValues = function (resource) {
        this.id = resource.id;
        this.isSmsCampaignAllowed = resource.isSmsCampaignAllowed;
        this.isEmailCampaignAllowed = resource.isEmailCampaignAllowed;
        this.isNotificationCampaignAllowed = resource.isNotificationCampaignAllowed;
        this.isExternalOptInOut = resource.isExternalOptInOut;
        this.origin = resource.origin;
        this.timeModified = resource.timeModified;

        this.isDeleted = resource.isDeleted;
        if (resource.version) this.version = resource.version;
    };

    OptInOut.prototype.getObjectResource = function () {
        var newOptInOut = new OptInOut_Resource();

        newOptInOut.id = this.id;
        newOptInOut.isSmsCampaignAllowed = this.isSmsCampaignAllowed;
        newOptInOut.isEmailCampaignAllowed = this.isEmailCampaignAllowed;
        newOptInOut.isNotificationCampaignAllowed = this.isNotificationCampaignAllowed;
        if (!this.isExternalOptInOut) newOptInOut.isExternalOptInOut = false;else newOptInOut.isExternalOptInOut = true;
        newOptInOut.timeModified = this.timeModified;
        newOptInOut.origin = this.origin;
        newOptInOut.customerId = this.customerId;
        newOptInOut.isDeleted = this.isDeleted;

        return newOptInOut;
    };

    return OptInOut;
}]);

angular.module('FlexyBeautyApp.services').factory('OptInOutSrv', ["$log", "ServerSrv", "OptInOut_Resource", "OptInOutData", "UserActionData", "OptInOut", "CustomerData", function ($log, ServerSrv, OptInOut_Resource, OptInOutData, UserActionData, OptInOut, CustomerData) {
    var optInOutSrv = {};

    optInOutSrv.save = function (optInOut, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(optInOutSrv.saveSync, optInOut, successFunction, errorFunction);
    };

    optInOutSrv.saveSync = function (optInOut, successFunction, errorFunction) {
        var optInOutRes = optInOut.getObjectResource();
        optInOutRes.$save({}, function (data) {
            try {
                optInOut.setId(data.id);
                if (!optInOut.version || data.version && data.version > optInOut.version) optInOut.version = data.version;
                if (successFunction !== undefined && successFunction !== null) successFunction(optInOut);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    optInOutSrv.updateLocally = function (id, object) {
        var optInOut = OptInOutData.getById(id);
        if (optInOut != null) {
            optInOut.setValues(object);
        }
        return optInOut;
    };

    optInOutSrv.addLocally = function (id, object) {
        var optInOut = OptInOutData.getById(id);
        if (optInOut == null) {
            var optInOut = new OptInOut(object, object.customerId);
            optInOut.id = id;

            var customer = CustomerData.getById(optInOut.customerId);
            if (customer) customer.optInOut = optInOut;
        }
        return optInOut;
    };

    optInOutSrv.removeLocally = function (id, object) {
        var optInOut = OptInOutData.getById(id);
        if (optInOut != null) {
            var customer = CustomerData.getById(optInOut.customerId);
            if (customer) customer.removeOptInOut(optInOut);
            OptInOutData.remove(optInOut);
        }

        return optInOut;
    };

    return optInOutSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('OptInOutData', [function () {
    var optInOutData = {
        optInOutList: [], // optInOut scheduler list for the entire application
        deletedOptInOutList: [] // deleted optInOut scheduler list for the entire application
    };
    optInOutData.getById = function (optInOutId) {
        for (var i = 0; i < this.optInOutList.length; i++) {
            if (this.optInOutList[i].id == optInOutId) return this.optInOutList[i];
        }return null;
    };
    optInOutData.getByIndex = function (optInOutIndex) {
        if (optInOutIndex >= 0 && optInOutIndex < this.optInOutList.length) {
            return this.optInOutList[optInOutIndex];
        } else return null;
    };
    optInOutData.getIndexOf = function (optInOut) {
        if (optInOut) return this.optInOutList.indexOf(optInOut);
        return -1;
    };
    optInOutData.add = function (optInOut) {
        if (!optInOut.isDeleted) this.optInOutList.push(optInOut);else this.deletedOptInOutList.push(optInOut);
    };
    optInOutData.remove = function (optInOut) //Soft Remove
    {
        if (optInOut && !optInOut.isDeleted) {
            var indexOptInOut = this.optInOutList.indexOf(optInOut);
            if (indexOptInOut != -1) {
                this.optInOutList.splice(indexOptInOut, 1);
                this.deletedOptInOutList.push(optInOut);
                optInOut.isDeleted = true;
            }
        }
    };
    optInOutData.getOptInOutList = function () {
        return this.optInOutList;
    };
    optInOutData.clear = function () {
        this.optInOutList = [];
        this.deletedOptInOutList = [];
    };

    return optInOutData;
}]);

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Order_Resource', ["$resource", "$location", function ($resource, $location) {
    var resourceBooking;
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    resourceBooking = $resource(baseUrl + 'rest/orders/:date/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('Order', ["OrderData", "OrderProduct", "Order_Resource", "HumanResourceData", function (OrderData, OrderProduct, Order_Resource, HumanResourceData) {

    var Order = function Order(orderRes, mustloadElements, isPreviousVersion) {
        this.id = null;
        this.isDeleted = false;
        this.timeCreated = null;
        this.price = 0;
        this.description = null;
        this.stockDate = null;
        this.billNumber = null;
        this.status = "created"; //created
        this.humanResource = null;
        this.orderProducts = [];
        this.version = null;
        if (orderRes !== undefined && orderRes != null) {
            this.loadObjectProperties(orderRes);
            if (mustloadElements) {
                this.loadObjectOrderProducts(orderRes);
            }
        }
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            OrderData.add(this);
    };
    Order.prototype.loadObjectProperties = function (object) {
        if (object) {
            if (!this.id) this.id = object.id;
            this.orderNumber = object.orderNumber;
            if (object.timeCreated) this.timeCreated = new Date(object.timeCreated);
            this.status = object.status;
            this.price = object.price;
            this.description = object.description;
            this.billNumber = object.billNumber;
            if (object.stockDate) this.stockDate = new Date(object.stockDate);
            if (object.humanResourceId) this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.version) this.version = object.version;
        }
    };

    Order.prototype.loadObjectOrderProducts = function (object) {
        if (object.orderProducts) {
            this.orderProducts = []; //set to 0 and reload
            for (var i = 0; i < object.orderProducts.length; i++) {
                this.addOrderProduct(new OrderProduct(object.orderProducts[i]));
            }
        }
    };
    Order.prototype.loadObject = function (object) {
        this.loadObjectProperties(object);
        this.loadObjectOrderProducts(object);
    };
    Order.prototype.loadRef = function (isPreviousVersion) {
        if (this.orderProducts) for (var i = 0; i < this.orderProducts.length; i++) {
            this.orderProducts[i].loadRef();
        }
    };

    Order.prototype.getObjectResource = function () {
        var orderRes = new Order_Resource();
        //customer = booking.customer when booking is saved.
        orderRes.id = this.id;
        orderRes.orderNumber = this.orderNumber;
        orderRes.price = this.price;
        orderRes.description = this.description;
        orderRes.status = this.status;
        orderRes.billNumber = this.billNumber;
        orderRes.stockDate = this.stockDate;
        if (this.humanResource) orderRes.humanResourceId = this.humanResource.id;
        orderRes.orderProducts = [];
        for (var i = 0; i < this.orderProducts.length; i++) {
            orderRes.orderProducts.push(this.orderProducts[i].getObjectResource());
        }

        return orderRes;
    };
    Order.prototype.getOrderProductById = function (id) {
        for (var i = 0; i < this.orderProducts.length; i++) {
            if (this.orderProducts[i].id == id) return this.orderProducts[i];
        }return null;
    };
    Order.prototype.addOrderProduct = function (orderProduct) {
        var index = this.orderProducts.indexOf(orderProduct);
        if (index == -1) {
            this.orderProducts.push(orderProduct);
            orderProduct.order = this;
        }
    };
    Order.prototype.removeOrderProduct = function (orderProduct) {
        if (orderProduct != null) {
            var index = this.orderProducts.indexOf(orderProduct);
            if (index != -1) this.orderProducts.splice(index, 1);
            orderProduct.order = null;
        }
    };
    return Order;
}]);
angular.module('FlexyBeautyApp.services').factory('OrderSrv', ["$rootScope", "$log", "ServerSrv", "Order_Resource", "Order", "UserActionData", "OrderData", function ($rootScope, $log, ServerSrv, Order_Resource, Order, UserActionData, OrderData) {
    var orderSrv = {};
    orderSrv.loadRef = function () {
        var orders = OrderData.indexOrders;
        for (var i = 0; i < orders.length; i++) {
            orders[i].loadRef();
        }
    };
    orderSrv.query = function (successFunction, errorFunction) {
        Order_Resource.query({}, //params
        function (data) {
            //success
            OrderData.clear();
            for (var i = 0; i < data.length; i++) {
                new Order(data[i], true, false);
            } //Auto Add to OrderData
            if (successFunction !== undefined) successFunction(OrderData.getActiveList());
        }, function (data) {
            //failure
            $log.error("Order_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    orderSrv.save = function (order, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(orderSrv.saveSync, order, successFunction, errorFunction);
    };
    orderSrv.saveSync = function (order, successFunction, errorFunction) {
        //$timeout (function () {

        var orderRes = order.getObjectResource();
        orderRes.$save({}, //no params
        function (orderRes) {
            /** @namespace orderRes.ordersId */
            /** @namespace orderRes.orderServicesId */
            /** @namespace orderRes.orderProductsId */

            try {
                order.id = orderRes.id;
                if (!order.version || orderRes.version && orderRes.version > order.version) order.version = orderRes.version;
                if (orderRes.timeCreated) order.timeCreated = new Date(orderRes.timeCreated);

                if (orderRes.orderNumber) order.orderNumber = orderRes.orderNumber;

                for (var j = 0; j < orderRes.orderProducts.length; j++) {
                    order.orderProducts[j].setId(orderRes.orderProducts[j].id);
                } //Add user action
                UserActionData.add(orderRes.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(orderRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                var errorMessage = "Erreur inconnue lors de la sauvegarde.";
                if (data.status && data.data) {
                    if (data.status == "409") {
                        if (data.data.errorCode == "40900") errorMessage = "L'heure choisie pour la réservation n'est plus disponible.";
                    }
                }
                if (errorFunction != undefined) errorFunction(errorMessage);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    orderSrv.remove = function (order, successFunction, errorFunction) {
        //Remove directly from model
        ServerSrv.startSavingProcess(orderSrv.removeSync, order, successFunction, errorFunction);
    };
    orderSrv.removeSync = function (order, successFunction, errorFunction) {
        //$timeout (function () {

        var orderSrv = new Order_Resource();
        orderSrv.$remove({ id: order.id }, //params : id
        function (data) {
            try {
                UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    orderSrv.removeLocally = function (id, resource) {
        var order = OrderData.getById(id);
        if (order && order.version && resource.version && resource.version < order.version) return null;

        return order;
    };
    orderSrv.addLocally = function (id, resource) {
        var order = OrderData.getById(id);
        if (order && order.version && resource.version && resource.version < order.version) return null;

        if (order != null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                order.loadObjectProperties(resource);
            } else {
            order = new Order(resource, false, false); //dont load orderProduct (will be done after)
            order.id = id;
        }
        order.loadRef();

        return order;
    };
    orderSrv.updateLocally = function (id, resource) {

        var order = OrderData.getById(id);
        if (order && order.version && resource.version && resource.version < order.version) return null;

        if (order) {
            order.loadObject(resource);
            order.loadRef(); //Will add to order
        }
        return order;
    };
    orderSrv.getPreviousVersionInstance = function (resource) {
        var order = new Order(resource, false, true);
        return order;
    };

    return orderSrv;
}]);
angular.module('FlexyBeautyApp.services').factory('OrderData', ["$log", function ($log) {
    var orderData = {
        indexOrders: []
    };
    orderData.getById = function (orderId) {
        for (var i = 0; i < this.indexOrders.length; i++) {
            if (this.indexOrders[i].id == orderId) return this.indexOrders[i];
        }return null;
    };
    orderData.getIndexOf = function (order) {
        if (order) return this.indexOrders.indexOf(order);
        return -1;
    };
    orderData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexOrders.length) return this.indexOrders[index];else return null;
    };
    orderData.getActiveList = function () {
        return this.indexOrders;
    };

    orderData.add = function (order) {
        //to do add always sorted
        this.indexOrders.push(order);
    };
    orderData.clear = function () {
        orderData.indexOrders = [];
    };
    return orderData;
}]);

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('OrderProduct_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceOrderS = $resource(baseUrl + 'rest/orderProducts/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceOrderS;
}]);

angular.module('FlexyBeautyApp.services').factory('OrderProduct', ["OrderProduct_Resource", "ProductCategoryData", "ProductData", "OrderProductData", "HumanResourceData", function (OrderProduct_Resource, ProductCategoryData, ProductData, OrderProductData, HumanResourceData) {
    //OrderProduct inherit from Activity
    var OrderProduct = function OrderProduct(orderProductRes, isPreviousVersion) {
        this.id = null;
        this.label = null;
        this.price = 0;
        this.originalPrice = 0;
        this.quantity = 0;
        this.product = null;
        this.order = null;
        this.version = null;
        this.loadObject(orderProductRes);
        this.loadRef();
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            OrderProductData.add(this);
    };

    OrderProduct.prototype.loadObject = function (object) {

        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.label = object.label;
            this.originalPrice = object.originalPrice;
            this.price = object.price;
            this.quantity = object.quantity;
            this.productId = object.productId;
            if (object.version) this.version = object.version;
        }
    };
    OrderProduct.prototype.loadRef = function () {
        if (this.productId) this.product = ProductData.getById(this.productId);
    };
    OrderProduct.prototype.copyDataTo = function (object) {

        object.id = this.id;
        object.label = this.label;
        object.originalPrice = this.originalPrice;
        object.price = this.price;
        object.quantity = this.quantity;

        if (this.product) object.productId = this.product.id;else object.productId = null;

        if (this.order) object.orderId = this.order.id;else object.orderId = null;
    };
    OrderProduct.prototype.getObjectResource = function () {
        var orderProductRes = new OrderProduct_Resource();
        this.copyDataTo(orderProductRes);
        return orderProductRes;
    };
    OrderProduct.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };
    OrderProduct.prototype.setId = function (id) {
        this.id = id;
    };
    OrderProduct.prototype.getId = function () {
        return this.id;
    };
    OrderProduct.prototype.getLabel = function () {
        return this.label;
    };
    OrderProduct.prototype.getPrice = function () {
        return this.price;
    };

    return OrderProduct;
}]);

angular.module('FlexyBeautyApp.services').factory('OrderProductSrv', ["$log", "ServerSrv", "DayData", "OrderProductData", "OrderProduct", "ActivitySrv", "OrderData", function ($log, ServerSrv, DayData, OrderProductData, OrderProduct, ActivitySrv, OrderData) {
    var bpSrv = {};

    bpSrv.save = function (orderProduct, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bpSrv.saveSync, orderProduct, successFunction, errorFunction);
    };
    bpSrv.saveSync = function (orderProduct, successFunction, errorFunction) {
        var bsRes = orderProduct.getObjectResource();
        bsRes.$save({}, function (data) {
            try {
                // now we can set the id
                orderProduct.setId(data.id);
                if (!orderProduct.version || data.version && data.version > orderProduct.version) orderProduct.version = data.version;
                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    bpSrv.updateLocally = function (id, resource) {
        //not specific code to manage update/remove from order because this link is change only for a add or delete
        // (a orderProduct can't be moved to another order)
        //return ActivitySrv.updateLocally(resource);
        //TODO
    };
    bpSrv.removeLocally = function (id, resource) {
        var orderProduct = OrderProductData.getById(id);
        if (orderProduct != null) {
            //remove from order
            if (orderProduct.order) orderProduct.order.removeOrderProduct(orderProduct);
        }
        return orderProduct;
    };
    bpSrv.addLocally = function (id, resource) {
        var orderProduct = OrderProductData.getById(id);
        if (orderProduct != null) //check if resource already exist inside index (current action could be a 'cancel')
            orderProduct.loadObject(resource);else {
            orderProduct = new OrderProduct(resource);
            orderProduct.id = id;
        }
        //add to order
        if (resource.orderId) {
            var order = OrderData.getById(resource.orderId);
            if (order) order.addOrderProduct(orderProduct);
        }

        return orderProduct;
    };
    bpSrv.getPreviousVersionInstance = function (resource) {
        var orderProduct = new OrderProduct(resource, true);
        if (resource.orderId) orderProduct.order = OrderData.getById(resource.orderId);
        return orderProduct;
    };

    return bpSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('OrderProductData', ["$log", function ($log) {
    var orderProductData = {
        indexOrderProducts: []
    };
    orderProductData.getById = function (orderProductId) {
        for (var i = 0; i < this.indexOrderProducts.length; i++) {
            if (this.indexOrderProducts[i].id == orderProductId) return this.indexOrderProducts[i];
        }return null;
    };
    orderProductData.getIndexOf = function (orderProduct) {
        if (orderProduct) return this.indexOrderProducts.indexOf(orderProduct);
        return -1;
    };
    orderProductData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexOrderProducts.length) return this.indexOrderProducts[index];else return null;
    };
    orderProductData.add = function (orderProduct) {
        this.indexOrderProducts.push(orderProduct);
        return this.indexOrderProducts.length - 1;
    };
    orderProductData.clear = function () {
        orderProductData.indexOrderProducts = [];
    };

    return orderProductData;
}]);

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('OtherPaymentType_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/otherPaymentTypes/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }

    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('OtherPaymentType', ["OtherPaymentType_Resource", "OtherPaymentTypeData", function (OtherPaymentType_Resource, OtherPaymentTypeData) {
    var OtherPaymentType = function OtherPaymentType(resource) {
        this.id = null;
        this.isDeleted = false;
        this.label = null;
        this.order = null;
        this.isUsable = null;
        this.version = null;
        this.loadObject(resource);
        OtherPaymentTypeData.add(this);
    };
    OtherPaymentType.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.order = object.order;
            this.isUsable = object.isUsable;
            if (object.version) this.version = object.version;
        }
    };
    OtherPaymentType.prototype.getObjectResource = function () {
        var rsOtherPaymentType = new OtherPaymentType_Resource();
        rsOtherPaymentType.id = this.id;
        rsOtherPaymentType.isDeleted = this.isDeleted;
        rsOtherPaymentType.label = this.label;
        rsOtherPaymentType.order = this.order;
        rsOtherPaymentType.isUsable = this.isUsable;
        return rsOtherPaymentType;
    };

    OtherPaymentType.prototype.getId = function () {
        return this.id;
    };

    OtherPaymentType.prototype.setId = function (id) {
        this.id = id;
    };

    return OtherPaymentType;
}]);

angular.module('FlexyBeautyApp.services').factory('OtherPaymentTypeSrv', ["$log", "OtherPaymentType_Resource", "UserActionData", "OtherPaymentType", "OtherPaymentTypeData", "ServerSrv", function ($log, OtherPaymentType_Resource, UserActionData, OtherPaymentType, OtherPaymentTypeData, ServerSrv) {
    var optSrv = {};

    optSrv.query = function (successFunction, errorFunction) {
        OtherPaymentType_Resource.query({}, //params
        function (data) {
            //success
            OtherPaymentTypeData.clear();
            for (var i = 0; i < data.length; i++) {
                new OtherPaymentType(data[i]);
            } //Auto Add to OtherPaymentTypeData
            if (successFunction !== undefined) successFunction(OtherPaymentTypeData.indexOtherPaymentTypes);
        }, function (data) {
            //failure
            $log.error("OtherPaymentType_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    optSrv.save = function (opt, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(optSrv.saveSync, opt, successFunction, errorFunction);
    };
    optSrv.saveSync = function (opt, successFunction, errorFunction) {
        //$timeout (function () {

        var OtherPaymentTypeRes = opt.getObjectResource();
        OtherPaymentTypeRes.$save({}, //no params
        function (data) {
            try {
                opt.setId(data.id);
                if (!opt.version || data.version && data.version > opt.version) opt.version = data.version;
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    optSrv.remove = function (opt, successFunction, errorFunction) {
        OtherPaymentTypeData.remove(opt);
        ServerSrv.startSavingProcess(optSrv.removeSync, opt, successFunction, errorFunction);
    };
    optSrv.removeSync = function (opt, successFunction, errorFunction) {
        var optSrv = new OtherPaymentType_Resource();
        optSrv.$remove({ id: opt.getId() }, //params : id
        function (data) {
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    optSrv.restore = function (opt, successFunction, errorFunction) {
        OtherPaymentTypeData.restore(opt);
        ServerSrv.startSavingProcess(optSrv.restoreSync, opt, successFunction, errorFunction);
    };
    optSrv.restoreSync = function (opt, successFunction, errorFunction) {
        //$timeout (function () {

        var OtherPaymentTypeRes = opt.getObjectResource();
        OtherPaymentTypeRes.$save({}, //no params
        function (data) {
            try {
                opt.setId(data.id);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    optSrv.get = function (id, successFunction, errorFunction) {
        OtherPaymentType_Resource.get({ id: id }, //params
        function (optResource) {
            if (successFunction != undefined) successFunction(new OtherPaymentType(optResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };

    optSrv.updateLocally = function (id, resource) {
        var opt = OtherPaymentTypeData.getById(id);
        if (opt != null) opt.loadObject(resource);
        return opt;
    };
    optSrv.removeLocally = function (id, resource) {
        var opt = OtherPaymentTypeData.getById(id);
        if (opt != null) OtherPaymentTypeData.remove(opt);
        return opt;
    };
    optSrv.addLocally = function (id, resource) {
        var opt = OtherPaymentTypeData.getById(id);
        if (opt != null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                opt.loadObject(resource);
                OtherPaymentTypeData.add(opt);
            } else {
            opt = new OtherPaymentType(resource);
            opt.id = id;
        }
        return opt;
    };

    return optSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('OtherPaymentTypeData', ["$filter", function ($filter) {
    var optDataSrv = {
        indexOtherPaymentTypes: [],
        activeOtherPaymentTypes: [],
        deletedOtherPaymentTypes: [] //deleted items
    };
    optDataSrv.getById = function (optId) {
        for (var i = 0; i < this.indexOtherPaymentTypes.length; i++) {
            if (this.indexOtherPaymentTypes[i].getId() == optId) return this.indexOtherPaymentTypes[i];
        }return null;
    };
    optDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexOtherPaymentTypes.length) return this.indexOtherPaymentTypes[index];
        return null;
    };
    optDataSrv.getIndexOf = function (opt) {
        if (opt) return this.indexOtherPaymentTypes.indexOf(opt);
        return -1;
    };

    optDataSrv.add = function (opt) {
        var optArray = this.activeOtherPaymentTypes;
        if (opt.isDeleted) optArray = this.deletedOtherPaymentTypes;
        var index = this.indexOtherPaymentTypes.indexOf(opt);
        if (index != -1) {
            var realIndex = optArray.indexOf(opt);
            if (realIndex == -1) optArray.push(opt);
        } else {
            index = this.indexOtherPaymentTypes.length;
            this.indexOtherPaymentTypes.push(opt);
            optArray.push(opt);
        }
        return index;
    };
    optDataSrv.remove = function (opt) {
        var index = this.activeOtherPaymentTypes.indexOf(opt);
        if (index != -1) {
            this.activeOtherPaymentTypes.splice(index, 1);
            this.deletedOtherPaymentTypes.push(opt);
            opt.isDeleted = true;
        }
    };
    optDataSrv.restore = function (opt) {
        var index = this.deletedOtherPaymentTypes.indexOf(opt);
        if (index != -1) {
            this.deletedOtherPaymentTypes.splice(index, 1);
            this.activeOtherPaymentTypes.push(opt);
            opt.isDeleted = false;
        }
    };
    optDataSrv.clear = function () {
        this.indexOtherPaymentTypes = [];
        this.activeOtherPaymentTypes = [];
        this.deletedOtherPaymentTypes = [];
    };
    optDataSrv.sort = function () {
        this.activeOtherPaymentTypes = $filter('orderBy')(this.activeOtherPaymentTypes, 'order', false);
        this.deletedOtherPaymentTypes = $filter('orderBy')(this.deletedOtherPaymentTypes, 'order', false);
    };

    optDataSrv.getActiveList = function () {
        return this.activeOtherPaymentTypes;
    };
    optDataSrv.getDeletedList = function () {
        return this.deletedOtherPaymentTypes;
    };
    return optDataSrv;
}]);

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('Patch_Resource', ["$resource", "$location", function ($resource, $location) {
  var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
  return $resource(baseUrl + 'rest/patch-access', {}, {
    list: { method: 'GET', url: baseUrl + 'rest/patch-access' }
  });
}]);

angular.module('FlexyBeautyApp.services').factory('PatchSrv', ['Patch_Resource', function (Patch_Resource) {
  var patchSrv = {};

  patchSrv.list = function () {
    return Patch_Resource.list().$promise;
  };

  return patchSrv;
}]);

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('Payment', [function () {

    var Payment = function Payment(resource) {
        this.type = null;
        this.price = null;
        this.date = null;
        this.giftItem = null;
        this.check = false;
        this._giftItemId = null;
        this.otherPaymentType = null;
        this._otherPaymentTypeId = null;
        this.checkDeposit = null;
        this._checkDepositId = null;
        if (resource !== undefined && resource != null) {
            this.type = resource.type;
            this.price = resource.price;
            this.date = new Date(resource.date);
            this.check = resource.check;
            this._giftItemId = resource.giftItemId;
            this._otherPaymentTypeId = resource.otherPaymentTypeId;
            this._checkDepositId = resource.checkDepositId;
        }
    };
    Payment.prototype.getObjectResource = function () {
        var paymentRes = {};
        paymentRes.type = this.type;
        paymentRes.price = this.price;
        paymentRes.date = this.date;
        paymentRes.check = this.check;
        if (this.giftItem) paymentRes.giftItemId = this.giftItem.id;
        if (this.otherPaymentType) paymentRes.otherPaymentTypeId = this.otherPaymentType.id;
        if (this.checkDeposit) paymentRes.checkDepositId = this.checkDeposit.id;

        return paymentRes;
    };
    return Payment;
}]);

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('PaymentService_Resource', ['$resource', '$location', function ($resource, $location) {
  var baseUrl = $location.protocol() + '://' + $location.host() + ($location.port() && ':' + $location.port()) + '/';
  return $resource(baseUrl + 'rest/payment-service/', {}, {
    updateIban: {
      method: 'POST',
      isArray: false,
      url: baseUrl + 'rest/payment-service/update-iban'
    },
    getNeedUpdateMangopay: {
      method: 'GET',
      isArray: false,
      url: baseUrl + 'rest/payment-service/check-need-update-mangopay'
    },
    enrollUser: {
      method: 'POST',
      url: baseUrl + 'rest/payment-service/enrollUser'
    }
  });
}]);

angular.module('FlexyBeautyApp.services').factory('PaymentServiceSrv', ['$location', 'PaymentService_Resource', '$window', function ($location, PaymentService_Resource, $window) {
  var paymentServiceSrv = {};

  paymentServiceSrv.updateBankAccount = function (company, bankAccount, successFunction, errorFunction) {
    var paymentServiceResource = new PaymentService_Resource();

    paymentServiceResource.ownerName = bankAccount.ownerName;
    paymentServiceResource.ownerAddress = bankAccount.ownerAddressLine1;
    paymentServiceResource.ownerPostalCode = bankAccount.ownerPostalCode;
    paymentServiceResource.ownerCity = bankAccount.ownerCity;
    paymentServiceResource.ownerCountry = bankAccount.ownerCountry;
    paymentServiceResource.iban = bankAccount.bankAccountDetails.iban;

    paymentServiceResource.$updateIban({}, function (companyPaymentData) {
      if (companyPaymentData.scaAction.redirectUrl) {
        var currentDomain = $location.protocol() + '://' + $location.host();
        var encodedDomain = encodeURIComponent(currentDomain);
        var redirectUrl = companyPaymentData.scaAction.redirectUrl + '&returnUrl=' + encodedDomain;
        $window.location.href = redirectUrl;
      }
      if (companyPaymentData && company.companyPaymentData) {
        company.companyPaymentData.bankAccountId = companyPaymentData.bankAccountId;
        company.companyPaymentData.customerId = companyPaymentData.customerId;
      }
      if (successFunction !== undefined) {
        successFunction(companyPaymentData);
      }
    }, function (data) {
      if (errorFunction !== undefined) {
        errorFunction(data);
      }
    });
  };

  paymentServiceSrv.getNeedToUpdateMangopay = function (successFunction, errorFunction) {
    var paymentServiceResource = new PaymentService_Resource();

    paymentServiceResource.$getNeedUpdateMangopay({}, function (data) {
      if (successFunction !== undefined) {
        successFunction(data);
      }
    }, function (data) {
      if (errorFunction !== undefined) {
        errorFunction(data);
      }
    });
  };

  paymentServiceSrv.enrollUser = function () {
    var paymentServiceResource = new PaymentService_Resource();

    paymentServiceResource.$enrollUser({}, function (data) {
      if (data.redirectUrl) {
        $window.location.href = data.redirectUrl;
      }
    }, function (data) {
      console.error("Could not enroll user", data);
    });
  };

  return paymentServiceSrv;
}]);

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('PhysicalResource_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/physicalResources/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('PhysicalResource', ["PhysicalResource_Resource", "CategoryData", "ServiceData", "PhysicalResourceData", function (PhysicalResource_Resource, CategoryData, ServiceData, PhysicalResourceData) {
    //PhysicalResource inherit of $resource

    var PhysicalResource = function PhysicalResource(resource) {
        this.id = null;
        this.isDeleted = false;
        this.label = "";
        this.number = 1;
        this.services = [];
        this.hasPlanning = true;
        this.onLineBooking = true;
        this.order = null;
        this.version = null;
        if (resource !== undefined && resource != null) this.loadObject(resource);

        PhysicalResourceData.add(this);
    };

    PhysicalResource.prototype.getObjectResource = function () {
        var rsPhysicalResource = new PhysicalResource_Resource();
        rsPhysicalResource.id = this.id;
        rsPhysicalResource.isDeleted = this.isDeleted;
        rsPhysicalResource.label = this.label;
        rsPhysicalResource.number = this.number;
        rsPhysicalResource.hasPlanning = this.hasPlanning;
        rsPhysicalResource.onLineBooking = this.onLineBooking;
        rsPhysicalResource.order = this.order;

        rsPhysicalResource.servicesId = [];
        for (var i = 0; i < this.services.length; i++) {
            rsPhysicalResource.servicesId.push(this.services[i].getId());
        }

        return rsPhysicalResource;
    };

    PhysicalResource.prototype.loadObject = function (object) {
        if (!this.id) this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.label = object.label;
        this.number = object.number;
        this.hasPlanning = object.hasPlanning;
        this.onLineBooking = object.onLineBooking;
        this.order = object.order;
        this.servicesId = object.servicesId;
        if (object.version) this.version = object.version;
    };
    PhysicalResource.prototype.loadRef = function () {
        //load ref from ids
        if (this.servicesId && CategoryData.loaded()) {
            var newServices = [];
            for (var i = 0; i < this.servicesId.length; i++) {
                var service = ServiceData.getById(this.servicesId[i]);
                if (service != null) {
                    newServices.push(service);
                }
            }
            this.services = newServices;
        }

        delete this.servicesId;
    };

    PhysicalResource.prototype.getId = function () {
        return this.id;
    };
    PhysicalResource.prototype.setId = function (id) {
        this.id = id;
    };
    PhysicalResource.prototype.getLabel = function () {
        return this.label;
    };
    PhysicalResource.prototype.getId = function () {
        return this.id;
    };
    PhysicalResource.prototype.getServices = function () {
        return this.services;
    };
    PhysicalResource.prototype.hasService = function (service) {
        var has = false;
        if (this.services != null) has = this.services.indexOf(service) != -1;
        return has;
    };
    PhysicalResource.prototype.addService = function (service) {
        if (this.services.indexOf(service) == -1) this.services.push(service);
    };
    PhysicalResource.prototype.removeService = function (service) {
        var index = this.services.indexOf(service);
        if (index != -1) this.services.splice(index, 1);
    };

    PhysicalResource.prototype.statFilter = function (arrayOfDays) {
        return this.hasPlanning && this.isWorkingOnPeriod(arrayOfDays);
    };

    PhysicalResource.prototype.isWorkingOnPeriod = function (arrayOfDays) {
        var isWorkingOnPeriod = false;
        for (var i = 0; i < arrayOfDays.length; i++) {
            isWorkingOnPeriod = isWorkingOnPeriod || arrayOfDays[i].prIsWorking(this.id, this.prUnitId);

            if (isWorkingOnPeriod == true) {
                break;
            }
        }
        return isWorkingOnPeriod;
    };

    return PhysicalResource;
}]);

angular.module('FlexyBeautyApp.services').factory('PhysicalResourceSrv', ["$log", "PhysicalResource_Resource", "PhysicalResource", "PhysicalResourceData", "CategoryData", "UserActionData", "ServerSrv", function ($log, PhysicalResource_Resource, PhysicalResource, PhysicalResourceData, CategoryData, UserActionData, ServerSrv) {
    var prSrv = {};

    prSrv.query = function (successFunction, errorFunction) {
        PhysicalResource_Resource.query({}, //params
        function (data) {
            //success
            PhysicalResourceData.clear();
            for (var i = 0; i < data.length; i++) {
                new PhysicalResource(data[i]);
            } //auto register to DATA

            if (successFunction !== undefined) successFunction(PhysicalResourceData.getActiveList());
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    prSrv.reload = function (physicalResource, successFunction, errorFunction) {
        var physicalResourceSrv = new PhysicalResource_Resource();
        physicalResourceSrv.$get({ id: physicalResource.getId() }, //params : id
        function (data) {
            physicalResource.loadObject(data);
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };
    prSrv.restore = function (physicalResource, successFunction, errorFunction) {
        PhysicalResourceData.restore(physicalResource);
        ServerSrv.startSavingProcess(prSrv.restoreSync, physicalResource, successFunction, errorFunction);
    };
    prSrv.restoreSync = function (physicalResource, successFunction, errorFunction) {

        var physicalResourceRes = physicalResource.getObjectResource();
        physicalResourceRes.$save({}, //no params
        function (data) {
            try {
                physicalResource.setId(data.id);
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    prSrv.save = function (physicalResource, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(prSrv.saveSync, physicalResource, successFunction, errorFunction);
    };
    prSrv.saveSync = function (physicalResource, successFunction, errorFunction) {

        var physicalResourceRes = physicalResource.getObjectResource();
        physicalResourceRes.$save({}, //no params
        function (data) {
            try {
                physicalResource.setId(data.id);
                if (!physicalResource.version || data.version && data.version > physicalResource.version) physicalResource.version = data.version;
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    prSrv.remove = function (physicalResource, successFunction, errorFunction) {
        PhysicalResourceData.remove(physicalResource);
        ServerSrv.startSavingProcess(prSrv.removeSync, physicalResource, successFunction, errorFunction);
    };
    prSrv.removeSync = function (physicalResource, successFunction, errorFunction) {
        var physicalResourceSrv = new PhysicalResource_Resource();
        physicalResourceSrv.$remove({ id: physicalResource.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    prSrv.updateLocally = function (id, objectToRestore) {
        var physicalResource = PhysicalResourceData.getById(id);
        if (physicalResource != null) {
            physicalResource.loadObject(objectToRestore);
            physicalResource.loadRef();
        }
        return physicalResource;
    };
    prSrv.removeLocally = function (id, object) {
        var physicalResource = PhysicalResourceData.getById(id);
        if (physicalResource != null) {
            PhysicalResourceData.remove(physicalResource);
        }
        return physicalResource;
    };
    prSrv.addLocally = function (id, objectToRestore) {
        var physicalResource = PhysicalResourceData.getById(id);
        if (physicalResource != null) {
            physicalResource.loadObject(objectToRestore);
            physicalResource.id = id;
            physicalResource.loadRef();
            PhysicalResourceData.add(physicalResource);
        }
        return physicalResource;
    };
    prSrv.loadRef = function () {
        var physicalResources = PhysicalResourceData.getActiveList();
        for (var i = 0; i < physicalResources.length; i++) {
            physicalResources[i].loadRef();
        }
    };

    return prSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('PhysicalResourceData', ["$log", function ($log) {
    var prDataSrv = {
        indexPhysicalResources: [], //Never deleted (used as index)
        activePhysicalResources: [], //active list
        deletedPhysicalResources: [] //deleted items
    };
    prDataSrv.getById = function (physicalResourceId) {
        for (var i = 0; i < this.indexPhysicalResources.length; i++) {
            if (this.indexPhysicalResources[i].id == physicalResourceId) return this.indexPhysicalResources[i];
        }return null;
    };
    prDataSrv.getIndexOf = function (pr) {
        if (pr) return this.indexPhysicalResources.indexOf(pr);
        return -1;
    };
    prDataSrv.getByIndex = function (prIndex) {
        if (prIndex >= 0 && prIndex < this.indexPhysicalResources.length) return this.indexPhysicalResources[prIndex];else return null;
    };
    prDataSrv.add = function (physicalResource) {
        var prArray = this.activePhysicalResources;
        if (physicalResource.isDeleted) prArray = this.deletedPhysicalResources;
        var index = this.indexPhysicalResources.indexOf(physicalResource);
        if (index != -1) {
            var realIndex = prArray.indexOf(physicalResource);
            if (realIndex == -1) prArray.push(physicalResource);
        } else {
            index = this.indexPhysicalResources.length;
            this.indexPhysicalResources.push(physicalResource);
            prArray.push(physicalResource);
        }
        return index;
    };
    prDataSrv.remove = function (physicalResource) //Soft Remove
    {
        var index = this.activePhysicalResources.indexOf(physicalResource);
        if (index != -1) {
            this.activePhysicalResources.splice(index, 1);
            this.deletedPhysicalResources.push(physicalResource);
            physicalResource.isDeleted = true;
        }
    };
    prDataSrv.restore = function (physicalResource) //Soft Remove
    {
        var index = this.deletedPhysicalResources.indexOf(physicalResource);
        if (index != -1) {
            this.deletedPhysicalResources.splice(index, 1);
            this.activePhysicalResources.push(physicalResource);
            physicalResource.isDeleted = false;
        }
    };
    prDataSrv.clear = function () {
        this.indexPhysicalResources = [];
        this.activePhysicalResources = [];
        this.deletedPhysicalResources = [];
    };
    prDataSrv.getActiveList = function () {
        return this.activePhysicalResources;
    };
    prDataSrv.getDeletedList = function () {
        return this.deletedPhysicalResources;
    };

    return prDataSrv;
}]);

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('PosOp_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/posOps/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        export: { method: 'POST', url: baseUrl + 'rest/pos/export' }

    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('PosOp', ["PosOp_Resource", "PosOpData", "HumanResourceData", function (PosOp_Resource, PosOpData, HumanResourceData) {
    var PosOp = function PosOp(resource, day, isPreviousVersion) {
        this.id = null;
        this.isDeleted = false;
        this.type = null;
        this.desc = null;
        this.poNumber = null;
        this.status = null;
        this.amount = null;
        this.humanResource = null;
        this.day = day;
        this.timeCreated = null;
        this.version = null;
        this.loadObject(resource);
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            PosOpData.add(this);
    };
    PosOp.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.type = object.type;
            this.desc = object.desc;
            this.poNumber = object.poNumber;
            this.status = object.status;
            this.amount = object.amount;
            if (object.timeCreated) this.timeCreated = new Date(object.timeCreated);
            if (object.humanResourceId) this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.version) this.version = object.version;
        }
    };
    PosOp.prototype.getObjectResource = function () {
        var rsPosOp = new PosOp_Resource();
        rsPosOp.id = this.id;
        rsPosOp.isDeleted = this.isDeleted;
        rsPosOp.type = this.type;
        rsPosOp.desc = this.desc;
        rsPosOp.status = this.status;
        rsPosOp.amount = this.amount;
        if (this.humanResource) rsPosOp.humanResourceId = this.humanResource.id;
        if (this.day) rsPosOp.dayId = this.day.id;
        return rsPosOp;
    };

    PosOp.prototype.getId = function () {
        return this.id;
    };

    PosOp.prototype.setId = function (id) {
        this.id = id;
    };

    return PosOp;
}]);

angular.module('FlexyBeautyApp.services').factory('PosOpSrv', ["$log", "PosOp_Resource", "UserActionData", "PosOp", "PosOpData", "ServerSrv", "DayData", function ($log, PosOp_Resource, UserActionData, PosOp, PosOpData, ServerSrv, DayData) {
    var posOpSrv = {};

    posOpSrv.query = function (successFunction, errorFunction) {
        PosOp_Resource.query({}, //params
        function (data) {
            //success
            PosOpData.clear();
            for (var i = 0; i < data.length; i++) {
                new PosOp(data[i]);
            } //Auto Add to PosOpData
            if (successFunction !== undefined) successFunction(PosOpData.indexPosOps);
        }, function (data) {
            //failure
            $log.error("PosOp_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    posOpSrv.export = function (successFunction, errorFunction) {
        PosOp_Resource.export({}, //params
        function () {
            //success
            if (successFunction !== undefined) successFunction(PosOpData.indexPosOps);
        }, function (data) {
            //failure
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    posOpSrv.save = function (posOp, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(posOpSrv.saveSync, posOp, successFunction, errorFunction);
    };
    posOpSrv.saveSync = function (posOp, successFunction, errorFunction) {
        var PosOpRes = posOp.getObjectResource();
        PosOpRes.$save({}, //no params
        function (data) {
            try {
                posOp.setId(data.id);
                if (!posOp.version || data.version && data.version > posOp.version) posOp.version = data.version;
                if (!posOp.poNumber) posOp.poNumber = data.poNumber;
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    posOpSrv.remove = function (posOp, successFunction, errorFunction) {
        PosOpData.remove(posOp);
        ServerSrv.startSavingProcess(posOpSrv.removeSync, posOp, successFunction, errorFunction);
    };
    posOpSrv.removeSync = function (posOp, successFunction, errorFunction) {
        var posOpSrv = new PosOp_Resource();
        posOpSrv.$remove({ id: posOp.getId() }, //params : id
        function (data) {
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    posOpSrv.restore = function (posOp, successFunction, errorFunction) {
        PosOpData.restore(posOp);
        ServerSrv.startSavingProcess(posOpSrv.restoreSync, posOp, successFunction, errorFunction);
    };
    posOpSrv.restoreSync = function (posOp, successFunction, errorFunction) {
        var PosOpRes = posOp.getObjectResource();
        PosOpRes.$save({}, //no params
        function (data) {
            try {
                posOp.setId(data.id);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    posOpSrv.get = function (id, successFunction, errorFunction) {
        PosOp_Resource.get({ id: id }, //params
        function (posOpResource) {
            if (successFunction != undefined) successFunction(new PosOp(posOpResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };

    posOpSrv.updateLocally = function (id, resource) {
        var day = DayData.getById(resource.dayId);
        var posOp = PosOpData.getById(id);
        if (day && posOp) {
            if (posOp.day !== day) {
                posOp.day.removePosOp(posOp);
                day.addPosOp(posOp);
            }
            posOp.loadObject(resource);
        }
        return posOp;
    };
    posOpSrv.removeLocally = function (id, resource) {
        var posOp = PosOpData.getById(id);
        if (posOp != null) {
            if (posOp.day) posOp.day.removePosOp(posOp);
        }
        return posOp;
    };
    posOpSrv.addLocally = function (id, resource) {
        var posOp = PosOpData.getById(id);
        var day = DayData.getById(resource.dayId);
        if (posOp != null) //check if resource already exist inside index (current action could be a 'cancel')
            posOp.loadObject(resource);else {
            posOp = new PosOp(resource, day);
            posOp.id = id;
        }
        if (day) day.addPosOp(posOp);

        return posOp;
    };

    return posOpSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('PosOpData', ["$filter", function ($filter) {
    var posOpDataSrv = {
        indexPosOps: [],
        activePosOps: [],
        deletedPosOps: [] //deleted items
    };
    posOpDataSrv.getById = function (posOpId) {
        for (var i = 0; i < this.indexPosOps.length; i++) {
            if (this.indexPosOps[i].getId() == posOpId) return this.indexPosOps[i];
        }return null;
    };
    posOpDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexPosOps.length) return this.indexPosOps[index];
        return null;
    };
    posOpDataSrv.getIndexOf = function (posOp) {
        if (posOp) return this.indexPosOps.indexOf(posOp);
        return -1;
    };

    posOpDataSrv.add = function (posOp) {
        var posOpArray = this.activePosOps;
        if (posOp.isDeleted) posOpArray = this.deletedPosOps;
        var index = this.indexPosOps.indexOf(posOp);
        if (index != -1) {
            var realIndex = posOpArray.indexOf(posOp);
            if (realIndex == -1) posOpArray.push(posOp);
        } else {
            index = this.indexPosOps.length;
            this.indexPosOps.push(posOp);
            posOpArray.push(posOp);
        }
        return index;
    };
    posOpDataSrv.remove = function (posOp) {
        var index = this.activePosOps.indexOf(posOp);
        if (index != -1) {
            this.activePosOps.splice(index, 1);
            this.deletedPosOps.push(posOp);
            posOp.isDeleted = true;
        }
    };
    posOpDataSrv.restore = function (posOp) {
        var index = this.deletedPosOps.indexOf(posOp);
        if (index != -1) {
            this.deletedPosOps.splice(index, 1);
            this.activePosOps.push(posOp);
            posOp.isDeleted = false;
        }
    };
    posOpDataSrv.clear = function () {
        this.indexPosOps = [];
        this.activePosOps = [];
        this.deletedPosOps = [];
    };
    posOpDataSrv.sort = function () {
        this.activePosOps = $filter('orderBy')(this.activePosOps, 'type', false);
        this.deletedPosOps = $filter('orderBy')(this.deletedPosOps, 'type', false);
    };

    posOpDataSrv.getActiveList = function () {
        return this.activePosOps;
    };
    posOpDataSrv.getDeletedList = function () {
        return this.deletedPosOps;
    };
    return posOpDataSrv;
}]);

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Product_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/products/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getQuantityHistory: { method: 'GET', isArray: false, url: baseUrl + 'rest/products/getQuantityHistory/:id' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/products/deleted' },
        emptyTrash: { method: 'POST', isArray: true, url: baseUrl + 'rest/products/emptyTrash' },
        saveNoQuantity: { method: 'POST', url: baseUrl + 'rest/products/saveNoQuantity' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Product', ["Product_Resource", "ImageData", "ProductData", "SupplierData", "ProductCategoryData", "CompanyImageData", "VatData", "HrRootCategory", function (Product_Resource, ImageData, ProductData, SupplierData, ProductCategoryData, CompanyImageData, VatData, HrRootCategory) {

    var Product = function Product(resource, parentCategory) {
        this.id = null;
        this.isDeleted;
        this.label = "";
        this.code = "";
        this.reference = "";
        this.description = "";
        this.buyingPrice = null;
        this.isOnHome = false;
        this.homeOrder = 0;
        this.price = null;
        this.hasInternetPrice = false;
        this.internetPrice = null;
        this.quantity = null;
        this.hasQuantity = true;
        this.supplier = null;
        this._supplierId = null; //tmp for loading only
        this.vat = null;
        this._vatId = null; //tmp for loading only
        this.image = null;
        this.companyImage = null;
        this.specificImage = null;
        this.isVisibleOnWebSite = true; //Default;
        this.isBuyableOnWebSite = true; //Default;
        this.version = null;

        if (resource !== undefined && resource != null) {
            this.loadObject(resource);
        }

        if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }

        ProductData.add(this);
    };
    Product.prototype.loadObject = function (object, parentCategory) {
        //Assume here than the object in parameter contains only id (must load them)

        if (!this.id) this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.parentCategoryId = object.parentCategoryId;
        this.label = object.label;
        this.code = object.code;
        this.reference = object.reference;
        this.description = object.description;
        this.buyingPrice = object.buyingPrice;
        this.price = object.price;
        this.isOnHome = object.isOnHome;
        this.homeOrder = object.homeOrder;
        this.hasInternetPrice = object.hasInternetPrice;
        this.internetPrice = object.internetPrice;
        this.hasQuantity = object.hasQuantity;
        this.quantity = object.quantity;
        this._supplierId = object.supplierId;
        this._vatId = object.vatId;
        this.imageId = object.imageId;
        this.companyImageId = object.companyImageId;
        this.specificImage = object.specificImage;
        this.isVisibleOnWebSite = object.isVisibleOnWebSite;
        this.isBuyableOnWebSite = object.isBuyableOnWebSite;

        if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }
        if (object.version) this.version = object.version;
    };
    Product.prototype.getObjectResource = function () {
        var rsProduct = new Product_Resource();
        rsProduct.id = this.id;
        rsProduct.isDeleted = this.isDeleted;
        rsProduct.code = this.code;
        rsProduct.reference = this.reference;
        rsProduct.label = this.label;
        if (this.image) rsProduct.imageId = this.image.id;
        if (this.companyImage) rsProduct.companyImageId = this.companyImage.id;
        rsProduct.specificImage = this.specificImage;
        rsProduct.description = this.description;
        rsProduct.price = this.price;
        rsProduct.isOnHome = this.isOnHome;
        rsProduct.homeOrder = this.homeOrder;
        rsProduct.hasInternetPrice = this.hasInternetPrice;
        rsProduct.internetPrice = this.internetPrice;
        rsProduct.buyingPrice = this.buyingPrice;
        rsProduct.hasQuantity = this.hasQuantity;
        rsProduct.quantity = this.quantity;
        if (this.supplier != null) rsProduct.supplier = this.supplier.getObjectResource(); //Always allow update
        else rsProduct.supplier = null;
        if (this.vat != null) rsProduct.vatId = this.vat.id;else rsProduct.vatId = null;
        rsProduct.isVisibleOnWebSite = this.isVisibleOnWebSite;
        rsProduct.isBuyableOnWebSite = this.isBuyableOnWebSite;

        //needPhysicalResource &&  needHumanResource MANAGED BY SERVER
        if (this.parentCategory != null) rsProduct.parentCategoryId = this.parentCategory.getId();
        return rsProduct;
    };

    Product.prototype.loadRef = function () {
        if (this.imageId) this.image = ImageData.getById(this.imageId);
        if (this.companyImageId) this.companyImage = CompanyImageData.getById(this.companyImageId);
        if (this.parentCategory == null && this.parentCategoryId) this.parentCategory = ProductCategoryData.getById(this.parentCategoryId);
        if (this._supplierId) {
            this.supplier = SupplierData.getById(this._supplierId);
            if (this.supplier) this.supplier.addProduct(this);
        }
        if (this._vatId) this.vat = VatData.getById(this._vatId);
    };
    Product.prototype.getId = function () {
        return this.id;
    };
    Product.prototype.setId = function (id) {
        this.id = id;
    };
    Product.prototype.getLabel = function () {
        return this.label;
    };
    Product.prototype.reload = function (endFunction) {
        var productSrv = this.getObjectResource();
        var product = this;
        if (this.getId() != null) productSrv.$get({ id: this.getId() }, //params
        function (data) {
            //success
            product.loadObject(data);
            if (endFunction != undefined) endFunction(product);
        }, function (data) {//failure
            //error handling goes here
            //TODO
        });
    };

    Product.prototype.isDescendantOf = function (category) {
        var isDescendantOf = false;
        if (this.parentCategory === category) {
            isDescendantOf = true;
        } else {
            if (this.parentCategory) {
                isDescendantOf = this.parentCategory.isDescendantOf(category);
            }
        }

        return isDescendantOf;
    };

    return Product;
}]);

angular.module('FlexyBeautyApp.services').factory('ProductSrv', ["$log", "HumanResourceData", "HumanResourceSrv", "Product_Resource", "Product", "ProductCategoryData", "UserActionData", "ProductData", "ServerSrv", function ($log, HumanResourceData, HumanResourceSrv, Product_Resource, Product, ProductCategoryData, UserActionData, ProductData, ServerSrv) {
    var productSrv = {};
    productSrv.save = function (product, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(productSrv.saveSync, product, successFunction, errorFunction);
    };
    productSrv.saveSync = function (product, successFunction, errorFunction) {
        //$timeout (function () {

        var ProductRes = product.getObjectResource();
        ProductRes.$save({}, //no params
        function (data) {
            try {
                if (product.id == null) {
                    product.setId(data.id);
                }
                if (!product.version || data.version && data.version > product.version) product.version = data.version;
                /** @namespace data.supplierId */
                if (data.supplierId && product.supplier) product.supplier.id = data.supplierId;

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    productSrv.saveNoQuantity = function (product, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(productSrv.saveNoQuantitySync, product, successFunction, errorFunction);
    };
    productSrv.saveNoQuantitySync = function (product, successFunction, errorFunction) {
        //$timeout (function () {

        var ProductRes = product.getObjectResource();
        ProductRes.$saveNoQuantity({}, //no params
        function (data) {
            try {
                if (product.id == null) {
                    product.setId(data.id);
                }
                if (!product.version || data.version && data.version > product.version) product.version = data.version;
                /** @namespace data.supplierId */
                if (data.supplierId && product.supplier) product.supplier.id = data.supplierId;

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    productSrv.getQuantityHistory = function (product, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(productSrv.getQuantityHistorySync, product, successFunction, errorFunction);
    };
    productSrv.getQuantityHistorySync = function (product, successFunction, errorFunction) {
        Product_Resource.getQuantityHistory({ id: product.id }, //params
        function (productHistory) {
            //success
            try {
                //Update quantity dynamically
                if (productHistory && productHistory.productVersions && productHistory.productVersions.length != 0 && productHistory.productVersions[productHistory.productVersions.length - 1].quantity !== undefined) product.quantity = productHistory.productVersions[productHistory.productVersions.length - 1].quantity;

                if (successFunction !== undefined) successFunction(productHistory);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                $log.error("Product_Resource.getQuantityHistory error");
                $log.error(data);
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    productSrv.emptyTrash = function (successFunction, errorFunction) {
        ServerSrv.startSavingProcess(productSrv.emptyTrashSync, successFunction, errorFunction);
    };
    productSrv.emptyTrashSync = function (successFunction, errorFunction) {
        Product_Resource.emptyTrash({}, //params : id
        function (data) {
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    productSrv.remove = function (product, successFunction, errorFunction) {
        ProductData.remove(product);
        ServerSrv.startSavingProcess(productSrv.removeSync, product, successFunction, errorFunction);
    };
    productSrv.removeSync = function (product, successFunction, errorFunction) {
        //$timeout (function () {

        var productRes = new Product_Resource();
        productRes.$remove({ id: product.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    productSrv.restore = function (product, successFunction, errorFunction) {
        ProductData.restore(product);
        ServerSrv.startSavingProcess(productSrv.restoreSync, product, successFunction, errorFunction);
    };
    productSrv.restoreSync = function (product, successFunction, errorFunction) {
        //$timeout (function () {

        var productRes = product.getObjectResource();
        productRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    productSrv.query = function (successFunction, errorFunction) {
        Product_Resource.getDeleted({}, //params
        function (data) {
            //success

            ProductData.deletedProducts = [];
            for (var i = 0; i < data.length; i++) {
                new Product(data[i]);
            } //Auto Add to ProductData

            if (successFunction !== undefined) successFunction(ProductData.categoryRoot);
        }, function (data) {
            //failure
            $log.error("Product_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    productSrv.loadRef = function () {
        var products = ProductData.indexProducts;
        for (var i = 0; i < products.length; i++) {
            products[i].loadRef();
        }
    };
    productSrv.updateLocally = function (id, object) {
        var product = null;
        var category = ProductCategoryData.getById(object.parentCategoryId);
        if (category != null) product = category.getProductById(id);
        if (product != null) {
            product.loadObject(object, category);
        }
        return product;
    };
    productSrv.addLocally = function (id, object) {
        var product = null;
        var category = ProductCategoryData.getById(object.parentCategoryId);
        if (category != null) {
            product = new Product(object, category);
            product.id = id;
            category.addProduct(product);
        }
        return null;
    };
    productSrv.removeLocally = function (id, object) {
        var product = null;
        var category = ProductCategoryData.getById(object.parentCategoryId);
        if (category != null) product = category.getProductById(id);
        if (product != null) category.removeProduct(product);
        return product;
    };

    return productSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('ProductData', ["$log", function ($log) {
    var productData = {
        indexProducts: [], //Used as Index
        deletedProducts: []
    };
    productData.getById = function (productId) {
        for (var i = 0; i < this.indexProducts.length; i++) {
            if (this.indexProducts[i].id == productId) return this.indexProducts[i];
        }return null;
    };
    productData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexProducts.length) {
            return this.indexProducts[servIndex];
        } else return null;
    };
    productData.getByRef = function (reference) {
        for (var i = 0; i < this.indexProducts.length; i++) {
            if (this.indexProducts[i].reference == reference) return this.indexProducts[i];
        }return null;
    };
    productData.getIndexOf = function (product) {
        if (product) return this.indexProducts.indexOf(product);
        return -1;
    };
    productData.add = function (product) {
        this.indexProducts.push(product);
        if (product.isDeleted) {
            var index = this.deletedProducts.indexOf(product);
            if (index == -1) this.deletedProducts.push(product);
        }
        return this.indexProducts.length - 1;
    };
    productData.remove = function (product) //Soft Remove
    {
        var index = this.deletedProducts.indexOf(product);
        if (index == -1) {
            this.deletedProducts.push(product);
            product.isDeleted = true;
        }
    };
    productData.restore = function (product) //Soft Remove
    {
        var index = this.deletedProducts.indexOf(product);
        if (index != -1) {
            this.deletedProducts.splice(index, 1);
            product.isDeleted = false;
        }
    };
    productData.clear = function () {
        productData.indexProducts = [];
        productData.deletedProducts = [];
    };
    productData.getDeletedList = function () {
        return productData.deletedProducts;
    };

    productData.getActiveList = function () {
        return this.indexProducts;
    };

    return productData;
}]);

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Directives */

angular.module('FlexyBeautyApp.directives').directive('jqueryEditor', ["$sce", function ($sce) {
    return {
        restrict: 'A',
        require: '^ngModel',
        link: function link(scope, element, attrs, ngModel) {
            $(function () {
                element.jqte({
                    br: false,
                    justify: false,
                    center: false,
                    format: false,
                    indent: false,
                    outdent: false,
                    color: false,
                    link: false,
                    left: false,
                    ol: false,
                    p: false,
                    right: false,
                    rule: false,
                    source: false,
                    sup: false,
                    sub: false,
                    strike: false,
                    ul: false,
                    unlink: false,
                    fsize: true,
                    fsizes: ["40", "45", "50", "55", "60"],

                    // On change refresh the model with the textarea value
                    change: function change() {
                        if (scope.$root) {
                            var safeHtml = $sce.trustAsHtml(element.parents(".jqte").find(".jqte_editor")[0].innerHTML);
                            var phase = scope.$root.$$phase;
                            if (phase == '$apply' || phase == '$digest') ngModel.$setViewValue(safeHtml);else scope.$apply(function () {
                                ngModel.$setViewValue(safeHtml);
                            });
                        } else ngModel.$setViewValue(safeHtml);
                    }
                });
            });

            // On render refresh the textarea with the model value
            ngModel.$render = function () {
                element.parents(".jqte").find(".jqte_editor")[0].innerHTML = ngModel.$viewValue || '';
            };
        }
    };
}]).directive('colorPicker', ["$parse", function ($parse) {
    return {
        restrict: 'A',

        require: '^ngModel',
        link: function link(scope, element, attrs, ngModel) {
            var ngModelGet = $parse(attrs.ngModel);
            var defaultValue = "";
            if (ngModelGet && ngModelGet(scope)) defaultValue = ngModelGet(scope);

            $(element).spectrum({
                allowEmpty: true,
                color: defaultValue,
                showInput: true,
                containerClassName: "full-spectrum",
                showInitial: true,
                showPalette: true,
                showSelectionPalette: true,
                chooseText: "Fermer",
                cancelText: "",
                maxPaletteSize: 10,
                preferredFormat: "hex",
                move: function move(color) {
                    if (color !== undefined) {
                        if (color) ngModel.$setViewValue(color.toHexString());else ngModel.$setViewValue(null);
                        if (scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase != '$digest') // not apply running
                            scope.$apply();
                    }
                },
                show: function show() {},
                beforeShow: function beforeShow() {},
                hide: function hide(color) {},

                palette: [["rgb(0, 0, 0)", "rgb(67, 67, 67)", "rgb(102, 102, 102)", "rgb(153, 153, 153)", "rgb(183, 183, 183)", "rgb(204, 204, 204)", "rgb(217, 217, 217)", "rgb(239, 239, 239)", "rgb(243, 243, 243)", "rgb(255, 255, 255)"], ["rgb(152, 0, 0)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)", "rgb(0, 255, 255)", "rgb(74, 134, 232)", "rgb(0, 0, 255)", "rgb(153, 0, 255)", "rgb(255, 0, 255)"], ["rgb(230, 184, 175)", "rgb(244, 204, 204)", "rgb(252, 229, 205)", "rgb(255, 242, 204)", "rgb(217, 234, 211)", "rgb(208, 224, 227)", "rgb(201, 218, 248)", "rgb(207, 226, 243)", "rgb(217, 210, 233)", "rgb(234, 209, 220)", "rgb(221, 126, 107)", "rgb(234, 153, 153)", "rgb(249, 203, 156)", "rgb(255, 229, 153)", "rgb(182, 215, 168)", "rgb(162, 196, 201)", "rgb(164, 194, 244)", "rgb(159, 197, 232)", "rgb(180, 167, 214)", "rgb(213, 166, 189)", "rgb(204, 65, 37)", "rgb(224, 102, 102)", "rgb(246, 178, 107)", "rgb(255, 217, 102)", "rgb(147, 196, 125)", "rgb(118, 165, 175)", "rgb(109, 158, 235)", "rgb(111, 168, 220)", "rgb(142, 124, 195)", "rgb(194, 123, 160)", "rgb(166, 28, 0)", "rgb(204, 0, 0)", "rgb(230, 145, 56)", "rgb(241, 194, 50)", "rgb(106, 168, 79)", "rgb(69, 129, 142)", "rgb(60, 120, 216)", "rgb(61, 133, 198)", "rgb(103, 78, 167)", "rgb(166, 77, 121)", "rgb(133, 32, 12)", "rgb(153, 0, 0)", "rgb(180, 95, 6)", "rgb(191, 144, 0)", "rgb(56, 118, 29)", "rgb(19, 79, 92)", "rgb(17, 85, 204)", "rgb(11, 83, 148)", "rgb(53, 28, 117)", "rgb(116, 27, 71)", "rgb(91, 15, 0)", "rgb(102, 0, 0)", "rgb(120, 63, 4)", "rgb(127, 96, 0)", "rgb(39, 78, 19)", "rgb(12, 52, 61)", "rgb(28, 69, 135)", "rgb(7, 55, 99)", "rgb(32, 18, 77)", "rgb(76, 17, 48)"]]
            });

            scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                if (newValue != oldValue) $(element).spectrum("set", ngModelGet(scope));
            });
        }
    };
}]).directive('jqueryuiSpinner', ["$parse", function ($parse) {
    return {
        restrict: 'A',
        require: '^ngModel',
        scope: {
            jqueryuiSpinnerDisabled: '='
        },
        link: function link(scope, element, attrs, ngModel) {
            var ngModelGet = $parse(attrs.ngModel);
            var spinnerVal = attrs.jqueryuiSpinner;
            var spinnerStepAttr = attrs.jqueryuiSpinnerStep;
            var spinnerMaxAttr = attrs.jqueryuiSpinnerMax;
            var spinnerDisabledAttr = scope.jqueryuiSpinnerDisabled;
            var spinnerMinAttr = attrs.jqueryuiSpinnerMin;

            var spinnerMin = 0;
            if (spinnerMinAttr !== undefined) spinnerMin = parseInt(spinnerMinAttr);
            var spinnerDisabled = false;
            if (spinnerDisabledAttr !== undefined) spinnerDisabled = spinnerDisabledAttr;
            var spinnerStep = 5;
            if (spinnerStepAttr !== undefined) spinnerStep = parseInt(spinnerStepAttr);
            var spinnerMax = null;
            if (spinnerMaxAttr !== undefined) spinnerMax = parseInt(spinnerMaxAttr);
            var defaultValue = "";
            if (ngModelGet && ngModelGet(scope)) defaultValue = ngModelGet(scope);
            $(element).spinner({
                culture: "fr-FR",
                step: spinnerStep,
                min: spinnerMin,
                max: spinnerMax,
                numberFormat: spinnerVal,
                disabled: spinnerDisabled,
                change: function change(event, ui) {
                    var value = $(element).spinner("value");
                    ngModel.$setViewValue(value);
                    if (scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase != '$digest') // not apply running
                        scope.$apply();
                },
                spin: function spin(event, ui) {
                    ngModel.$setViewValue(ui.value);
                    if (scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase != '$digest') // not apply running
                        scope.$apply();
                }
            });
            $(element).spinner("value", defaultValue);
        }
    };
}]).directive('jqueryuiSlider', ["$parse", function ($parse) {
    return {
        restrict: 'A',
        require: '^ngModel',
        link: function link(scope, element, attrs, ngModel) {
            var ngModelGet = $parse(attrs.ngModel);
            var defaultValue = 0;
            if (ngModelGet && ngModelGet(scope) && ngModelGet(scope) !== undefined) defaultValue = ngModelGet(scope);
            var expressionHandler = null;
            if (attrs.jqueryuiSlider) expressionHandler = $parse(attrs.jqueryuiSlider);
            var sliderStepAttr = 1;
            var sliderMaxAttrGet = $parse(attrs.jqueryuiSliderMax);
            var sliderMinAttrGet = $parse(attrs.jqueryuiSliderMin);
            var sliderStepAttrGet = $parse(attrs.jqueryuiSliderStep);
            var sliderRangeAttrGet = $parse(attrs.jqueryuiSliderRange);
            var sliderMaxAttr = null;
            var sliderMinAttr = 0;
            var sliderRangeAttr = true;
            if (sliderMaxAttrGet && sliderMaxAttrGet(scope) !== undefined && sliderMaxAttrGet(scope)) sliderMaxAttr = sliderMaxAttrGet(scope);
            if (sliderMinAttrGet && sliderMinAttrGet(scope) !== undefined && sliderMinAttrGet(scope)) sliderMinAttr = sliderMinAttrGet(scope);
            if (sliderStepAttrGet && sliderStepAttrGet(scope) !== undefined && sliderStepAttrGet(scope)) sliderStepAttr = sliderStepAttrGet(scope);
            if (sliderRangeAttrGet && sliderRangeAttrGet(scope) !== undefined) sliderRangeAttr = sliderRangeAttrGet(scope);

            if (sliderRangeAttr) {
                if (defaultValue != null) $(element).slider({
                    range: true,
                    min: sliderMinAttr,
                    max: sliderMaxAttr,
                    values: defaultValue,
                    step: sliderStepAttr,
                    slide: function slide(event, ui) {
                        ngModel.$setViewValue(ui.values);
                        if (scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase != '$digest') // not apply running
                            scope.$apply();
                    },
                    stop: function stop(event, ui) {
                        if (expressionHandler && expressionHandler != undefined) scope.$apply(expressionHandler);
                    }
                });
                scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                    if (newValue != oldValue) $(element).slider("values", ngModelGet(scope));
                });
            } else {
                if (defaultValue != null) $(element).slider({
                    range: false,
                    min: sliderMinAttr,
                    max: sliderMaxAttr,
                    value: defaultValue,
                    step: sliderStepAttr,
                    slide: function slide(event, ui) {
                        ngModel.$setViewValue(ui.value);
                        if (scope.$root && scope.$root.$$phase != '$apply' && scope.$root.$$phase != '$digest') // not apply running
                            scope.$apply();
                    },
                    stop: function stop(event, ui) {
                        if (expressionHandler && expressionHandler != undefined) scope.$apply(expressionHandler);
                    }
                });
                scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                    if (newValue != oldValue) $(element).slider("value", ngModelGet(scope));
                });
            }
            //$(element).spinner("value",defaultValue);
        }
    };
}]);

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('ProductCategory_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/productCategories/:id', {}, {
        query: { method: 'GET', isArray: false },
        getTree: { method: 'GET', isArray: false, url: baseUrl + 'rest/productCategories/tree' },
        getTreeForDate: { method: 'GET', isArray: false, url: baseUrl + 'rest/productCategories/tree/:date' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/productCategories/deleted' },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('ProductCategory', ["ProductCategory_Resource", "Product", "ProductCategoryData", "ProductData", "ImageData", "CompanyImageData", function (ProductCategory_Resource, Product, ProductCategoryData, ProductData, ImageData, CompanyImageData) {
    var ProductCategory = function ProductCategory(rsProductCategory, parentCategory) {
        this.id = null;
        this.isDeleted;
        this.label = "";
        this.description = "";
        this.image = null;
        this.companyImage = null;
        this.specificImage; //boolean
        this.isVisibleOnWebSite;
        this.style = "";
        this.products = [];
        this.categories = [];
        this.parentCategoryId = null;
        this.version = null;

        if (parentCategory !== undefined && parentCategory != null) this.parentCategory = parentCategory;

        if (rsProductCategory !== undefined && rsProductCategory != null) {
            var product, category;
            this.id = rsProductCategory.id;
            this.isDeleted = rsProductCategory.isDeleted;
            this.label = rsProductCategory.label;
            this.description = rsProductCategory.description;
            this.imageId = rsProductCategory.imageId;
            this.companyImageId = rsProductCategory.companyImageId;
            this.specificImage = rsProductCategory.specificImage;
            this.isVisibleOnWebSite = rsProductCategory.isVisibleOnWebSite;
            this.parentCategoryId = rsProductCategory.parentCategoryId;
            this.style = rsProductCategory.style;

            if (rsProductCategory.categories) for (var i = 0; i < rsProductCategory.categories.length; i++) {
                category = new ProductCategory(rsProductCategory.categories[i], this);
                this.categories.push(category);
            }

            if (rsProductCategory.products) for (var j = 0; j < rsProductCategory.products.length; j++) {
                product = new Product(rsProductCategory.products[j], this);
                this.products.push(product);
            }
        }
        ProductCategoryData.add(this);
    };

    ProductCategory.prototype.loadObject = function (object, parentCategory) {
        this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.label = object.label;
        this.description = object.description;
        this.style = object.style;
        this.specificImage = object.specificImage;
        this.isVisibleOnWebSite = object.isVisibleOnWebSite;
        if (object.version) this.version = object.version;
        if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }

        //load ref from ids
        if (object.productsId) {
            var newProducts = [];
            for (var i = 0; i < object.productsId.length; i++) {
                var product = ProductData.getById(object.productsId[i]);
                if (product != null) newProducts.push(product);
            }
            this.products = newProducts;
        }
        if (object.productsId) {
            var newCategories = [];
            for (i = 0; i < object.categoriesId.length; i++) {
                var category = ProductCategoryData.getById(object.categoriesId[i]);
                if (category != null) newCategories.push(category);
            }
            this.categories = newCategories;
        }
    };
    ProductCategory.prototype.getObjectResource = function () {
        var rsProductCategory = new ProductCategory_Resource();
        rsProductCategory.id = this.id;
        rsProductCategory.isDeleted = this.isDeleted;
        rsProductCategory.label = this.label;
        rsProductCategory.description = this.description;
        if (this.image) rsProductCategory.imageId = this.image.id;
        if (this.companyImage) rsProductCategory.companyImageId = this.companyImage.id;
        rsProductCategory.specificImage = this.specificImage;
        rsProductCategory.isVisibleOnWebSite = this.isVisibleOnWebSite;
        rsProductCategory.style = this.style;

        if (this.parentCategory) rsProductCategory.parentCategoryId = this.parentCategory.getId();
        rsProductCategory.categoriesId = [];
        for (var i = 0; i < this.categories.length; i++) {
            rsProductCategory.categoriesId.push(this.categories[i].getId());
        }rsProductCategory.productsId = [];
        for (var i = 0; i < this.products.length; i++) {
            rsProductCategory.productsId.push(this.products[i].getId());
        }return rsProductCategory;
    };
    ProductCategory.prototype.getId = function () {
        return this.id;
    };
    ProductCategory.prototype.setId = function (id) {
        this.id = id;
    };
    ProductCategory.prototype.getLabel = function () {
        return this.label;
    };
    ProductCategory.prototype.addProduct = function (product) {
        if (product) {
            var index = this.products.indexOf(product);
            if (index == -1) //Not already there
                {
                    this.products.push(product);
                    product.parentCategory = this;
                }
        }
    };
    ProductCategory.prototype.removeProduct = function (product) {
        var index = this.products.indexOf(product);
        if (index != -1) //Found
            {
                this.products.splice(index, 1);
            }
    };
    ProductCategory.prototype.addCategory = function (category) {
        if (category) {
            var index = this.categories.indexOf(category);
            if (index == -1) //Not already there
                {
                    this.categories.push(category);
                    category.parentCategory = this;
                }
        }
    };
    ProductCategory.prototype.removeCategory = function (category) {
        var index = this.categories.indexOf(category);
        if (index != -1) //Found
            {
                this.categories.splice(index, 1);
            }
    };
    ProductCategory.prototype.changeProductPosition = function (product, indexTarget) {
        //Change the product position
        var index = this.products.indexOf(product);
        if (indexTarget != -1 && index != -1 && indexTarget != index && this.products && indexTarget < this.products.length) {
            var cat = this.products[indexTarget];

            this.products.splice(index, 1);
            if (index < indexTarget) indexTarget--;
            this.products.splice(indexTarget, 0, product);
        }
    };
    ProductCategory.prototype.getProductById = function (productId) {
        //recursive research
        var product = null;
        for (var j = 0; j < this.products.length; j++) {
            if (this.products[j].id == productId) return this.products[j];
        }for (var z = 0; z < this.categories.length && !product; z++) {
            product = this.categories[z].getProductById(productId);
        }return product;
    };
    ProductCategory.prototype.getProductByLabel = function (productLabel) {
        //recursive research, need lower case input
        var product = null;
        for (var j = 0; j < this.products.length; j++) {
            if (this.products[j].label.toLowerCase() == productLabel) return this.products[j];
        }for (var z = 0; z < this.categories.length && !product; z++) {
            product = this.categories[z].getProductByLabel(productLabel);
        }return product;
    };
    ProductCategory.prototype.getProductCategoryById = function (categoryId) {
        //recursive research
        var category = null;
        for (var z = 0; z < this.categories.length && !category; z++) {
            if (this.categories[z].id == categoryId) category = this.categories[z];else category = this.categories[z].getProductCategoryById(categoryId);
        }return category;
    };
    ProductCategory.prototype.loadRef = function () {
        if (this.imageId) this.image = ImageData.getById(this.imageId);
        if (this.companyImageId) this.companyImage = CompanyImageData.getById(this.companyImageId);
        if (this.parentCategory == null && this.parentCategoryId) this.parentCategory = ProductCategoryData.getById(this.parentCategoryId);
    };
    ProductCategory.prototype.getSubStatCategories = function (rootCategory) {
        return this.categories.concat(this.products);
    };

    ProductCategory.prototype.isDescendantOf = function (category) {
        var isDescendantOf = false;
        if (this.parentCategory === category) {
            isDescendantOf = true;
        } else {
            if (this.parentCategory) {
                isDescendantOf = this.parentCategory.isDescendantOf(category);
            }
        }

        return isDescendantOf;
    };

    return ProductCategory;
}]);

angular.module('FlexyBeautyApp.services').factory('ProductCategorySrv', ["ProductCategory_Resource", "ProductCategory", "ProductCategoryData", "UserActionData", "ProductSrv", "$log", "ServerSrv", "LanguageManager", function (ProductCategory_Resource, ProductCategory, ProductCategoryData, UserActionData, ProductSrv, $log, ServerSrv, LanguageManager) {
    var categorySrv = {};
    categorySrv.query = function (successFunction, errorFunction) {
        var treeLoaded = false;
        var deletedLoaded = false;
        ProductCategory_Resource.getTree({}, //params
        function (data) {
            //success
            ProductCategoryData.categoryRoot = new ProductCategory(data);

            if (successFunction !== undefined && deletedLoaded) successFunction(ProductCategoryData.categoryRoot);
            treeLoaded = true;
        }, function (data) {
            //failure
            $log.error("ProductCategory_Resource.getTree error");
            $log.error(data);
            if (errorFunction !== undefined && deletedLoaded) errorFunction(data);
            treeLoaded = true;
        });
        ProductCategory_Resource.getDeleted({}, //params
        function (data) {
            //success
            ProductCategoryData.deletedCategories = [];
            for (var i = 0; i < data.length; i++) {
                new ProductCategory(data[i]);
            } //Auto Add to ProductCategoryData

            if (successFunction !== undefined && treeLoaded) successFunction(ProductCategoryData.categoryRoot);
            deletedLoaded = true;
        }, function (data) {
            //failure
            $log.error("ProductCategory_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined && treeLoaded) errorFunction(data);
            deletedLoaded = true;
        });
    };
    categorySrv.getTreeForDate = function (date, successFunction, errorFunction) {
        var formattedDateParam = ("0" + date.getDate()).slice(-2) + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + date.getFullYear();
        ProductCategory_Resource.getTreeForDate({ date: formattedDateParam }, //params
        function (productRoot) {
            if (successFunction !== undefined) successFunction(productRoot);
        }, function (data) {
            //failure
            $log.error("ProductCategory_Resource.getTree error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    categorySrv.save = function (category, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(categorySrv.saveSync, category, successFunction, errorFunction);
    };
    categorySrv.saveSync = function (category, successFunction, errorFunction) {
        var ProductCategoryRes = category.getObjectResource();
        ProductCategoryRes.$save({}, //no params
        function (data) {
            try {
                category.setId(data.id);
                if (!category.version || data.version && data.version > category.version) category.version = data.version;
                //TODO  UserActionData.add(data.userAction);
                if (successFunction) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    categorySrv.remove = function (category, successFunction, errorFunction) {
        ProductCategoryData.remove(category);
        ServerSrv.startSavingProcess(categorySrv.removeSync, category, successFunction, errorFunction);
    };
    categorySrv.removeSync = function (category, successFunction, errorFunction) {
        var categoryRes = new ProductCategory_Resource();
        categoryRes.$remove({ id: category.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    categorySrv.restore = function (category, successFunction, errorFunction) {
        ProductCategoryData.restore(category);
        ServerSrv.startSavingProcess(categorySrv.restoreSync, category, successFunction, errorFunction);
    };
    categorySrv.restoreSync = function (category, successFunction, errorFunction) {
        var categoryRes = category.getObjectResource();
        categoryRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    categorySrv.getProductCategoryOnServer = function (scope, targetName, categoryId) {

        var category = null;
        if (ProductCategoryData.categoryRoot.categories != null && ProductCategoryData.categoryRoot.categories.length > 0) {
            for (var i = 0; i < ProductCategoryData.categoryRoot.categories.length && !category; i++) {
                if (ProductCategoryData.categoryRoot.categories[i].getId() == categoryId) category = ProductCategoryData.categoryRoot.categories[i];else for (var j = 0; j < ProductCategoryData.categoryRoot.categories[i].categories.length && !category; j++) {
                    if (ProductCategoryData.categoryRoot.categories[i].categories[j].getId() == categoryId) category = ProductCategoryData.categoryRoot.categories[i].categories[j];
                }
            }scope[targetName] = category;
        } else {
            ProductCategory_Resource.get({ id: categoryId }, function (categoryRes) {
                //success
                scope[targetName] = new ProductCategory(categoryRes);
            }, function (categoryRes) {//failure
                //error handling goes here
            });
        }
    };
    categorySrv.get = function (categoryId) {
        //TODO
        return null;
    };
    categorySrv.getProductById = function (productId) {
        if (ProductCategoryData.categoryRoot != null) return ProductCategoryData.categoryRoot.getProduct(productId);
    };
    categorySrv.loadRef = function () {
        var categories = ProductCategoryData.indexCategories;
        for (var i = 0; i < categories.length; i++) {
            categories[i].loadRef();
        }
    };
    categorySrv.moveProduct = function (category, product) {
        if (category) {
            category.moveProduct(product);
            ProductSrv.save(product);
        }
    };
    categorySrv.updateLocally = function (id, object) {
        var category = null;
        var parentCategory = null;
        if (object.parentCategoryId) //Optimization : get parent if exist
            {
                parentCategory = ProductCategoryData.getById(object.parentCategoryId);
                if (parentCategory != null) category = parentCategory.getProductCategoryById(id);
            } else category = ProductCategoryData.getById(id);
        if (category != null) category.loadObject(object, parentCategory);
    };
    categorySrv.addLocally = function (id, object) {
        //TODO
        /*            var category = ProductCategoryData.getProductCategory(object.parentCategoryId);
                    if (category!=null)
                        category.addProduct(new Product(object,category));*/

    };
    categorySrv.removeLocally = function (id, object) {
        //TODO
        /*            var product =  null;
                    var category = ProductCategoryData.getProductCategory(object.parentCategoryId);
                    if (category!=null)
                        product = category.getProduct(object.id)
                    if (product!=null)
                        category.removeProduct(product);*/
    };

    return categorySrv;
}]);

angular.module('FlexyBeautyApp.services').factory('ProductCategoryData', ["$log", function ($log) {
    var categoryData = {
        categoryRoot: null,
        indexCategories: [], //Used as Index
        deletedCategories: []
    };
    categoryData.getById = function (categoryId) {
        for (var i = 0; i < this.indexCategories.length; i++) {
            if (this.indexCategories[i].id == categoryId) return this.indexCategories[i];
        }return null;
    };
    categoryData.getByIndex = function (catIndex) {
        if (catIndex >= 0 && catIndex < this.indexCategories.length) return this.indexCategories[catIndex];else return null;
    };
    categoryData.getIndexOf = function (category) {
        if (category) return this.indexCategories.indexOf(category);
        return -1;
    };
    categoryData.add = function (category) {
        this.indexCategories.push(category);
        if (category.isDeleted) {
            var index = this.deletedCategories.indexOf(category);
            if (index == -1) this.deletedCategories.push(category);
        }
        return this.indexCategories.length - 1;
    };
    categoryData.remove = function (category) //Soft Remove
    {
        var index = this.deletedCategories.indexOf(category);
        if (index == -1) {
            this.deletedCategories.push(category);
            category.isDeleted = true;
        }
    };
    categoryData.restore = function (category) //Soft Remove
    {
        var index = this.deletedCategories.indexOf(category);
        if (index != -1) {
            this.deletedCategories.splice(index, 1);
            category.isDeleted = false;
        }
    };
    categoryData.clear = function () {
        categoryData.categoryRoot = null;
        categoryData.indexCategories = [];
        categoryData.deletedCategories = [];
    };
    categoryData.loaded = function () {
        return categoryData.categoryRoot != null;
    };
    categoryData.getDeletedList = function () {
        return categoryData.deletedCategories;
    };

    return categoryData;
}]);

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').factory('ReportModel_Resource', ["$resource", "$location", "$locale", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + '/datas/reportsList.json', {}, {
        getReports: { method: 'GET', url: baseUrl + '/datas/reportsList.json', isArray: true },
        getAdvancedReports: { method: 'GET', url: baseUrl + '/datas/advancedReportsList.json', isArray: true }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('ReportModel', ["ReportModel_Resource", "ReportModelData", function (ReportModel_Resource, ReportModelData) {

    var ReportModel = function ReportModel(resource, advanced) {
        this.id = null;
        this.title = null;
        this.descriptionTitle = null;
        this.descriptionDetail = null;
        this.index = null;
        this.indexActifEltReport = 0; //default value
        this.eltsReport = [];
        this.advanced = advanced;
        this.onTemplateOnly = false;
        this.businessPage = null;
        this.helpCenterArticles = null;

        if (resource !== undefined && resource != null) {
            this.loadObject(resource);
        }
        ReportModelData.add(this);
    };

    ReportModel.prototype.loadObject = function (object) {
        this.id = object.id;
        this.title = object.title;
        this.descriptionTitle = object.descriptionTitle;
        this.descriptionDetail = object.descriptionDetail;
        this.index = object.index;
        this.indexActifEltReport = object.indexActifEltReport; //default value
        this.typeOfData = object.typeOfData;
        this.eltsReport = object.eltsReport;
        this.onTemplateOnly = object.onTemplateOnly;
        this.businessPage = object.businessPage;
        this.helpCenterArticles = object.helpCenterArticles;
    };

    return ReportModel;
}]);

angular.module('FlexyBeautyApp.services').factory('ReportModelSrv', ["$log", "ReportModel_Resource", "ReportModel", "ReportModelData", function ($log, ReportModel_Resource, ReportModel, ReportModelData) {
    var reportModelSrv = {};

    reportModelSrv.query = function (successFunction, errorFunction) {
        ReportModel_Resource.getReports({}, //params
        function (data) {
            //success

            for (var i = 0; i < data.length; i++) {
                new ReportModel(data[i], false);
            } //Auto Add to ReportModelData

            if (successFunction !== undefined) successFunction(ReportModelData.indexReportsModel);
        }, function (data) {
            //failure
            $log.error("ReportModel_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });

        ReportModel_Resource.getAdvancedReports({}, //params
        function (data) {
            //success

            for (var i = 0; i < data.length; i++) {
                new ReportModel(data[i], true);
            } //Auto Add to ReportModelData

            if (successFunction !== undefined) successFunction(ReportModelData.indexReportsModel);
        }, function (data) {
            //failure
            $log.error("ReportModel_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    reportModelSrv.loadRef = function () {
        var reportsModel = ReportModelData.indexReportModelData;
        for (var i = 0; i < reportsModel.length; i++) {
            reportsModel[i].loadRef();
        }
    };

    return reportModelSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('ReportModelData', ["$log", function ($log) {
    var reportModelData = {
        indexReportsModel: [],
        deletedReportsModel: []
    };
    reportModelData.getById = function (reportModelId) {
        for (var i = 0; i < this.indexReportsModel.length; i++) {
            if (this.indexReportsModel[i].id == reportModelId) return this.indexReportsModel[i];
        }return null;
    };
    reportModelData.getByIndex = function (reportModelIndex) {
        if (reportModelIndex >= 0 && reportModelIndex < this.indexReportsModel.length) {
            return this.indexReportsModel[reportModelIndex];
        } else return null;
    };
    reportModelData.getIndexOf = function (reportModel) {
        if (reportModel) return this.indexReportsModel.indexOf(reportModel);
        return -1;
    };
    reportModelData.add = function (reportModel) {
        this.indexReportsModel.push(reportModel);
        if (reportModel.isDeleted) {
            var index = this.deletedReportsModel.indexOf(reportModel);
            if (index == -1) this.deletedReportsModel.push(reportModel);
        }
        return this.indexReportsModel.length - 1;
    };
    reportModelData.remove = function (reportModel) //Soft Remove
    {
        var index = this.deletedReportsModel.indexOf(reportModel);
        if (index == -1) {
            this.deletedReportsModel.push(reportModel);
            reportModel.isDeleted = true;
        }
    };
    reportModelData.restore = function (reportModel) //Soft Remove
    {
        var index = this.deletedReportsModel.indexOf(reportModel);
        if (index != -1) {
            this.deletedReportsModel.splice(index, 1);
            reportModel.isDeleted = false;
        }
    };
    reportModelData.clear = function () {
        reportModelData.indexReportsModel = [];
        reportModelData.deletedReportsModel = [];
    };
    reportModelData.getDeletedList = function () {
        return reportModelData.deletedReportsModel;
    };

    reportModelData.getActiveList = function () {
        return this.indexReportsModel;
    };

    return reportModelData;
}]);

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('Resource_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";

    return $resource(baseUrl + 'rest/resources', {}, {
        update: { method: 'PUT' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Resource', ["Resource_Resource", function (Resource_Resource) {
    var Resource = function Resource(humanResources, physicalResources, isServicePackage, editedServiceId) {
        this.humanResources = [];
        this.physicalResources = [];
        this.isServicePackage = false;
        this.editedServiceId = null;
        if (humanResources && physicalResources && isServicePackage !== null && isServicePackage !== undefined && editedServiceId) {
            this.loadObject(humanResources, physicalResources, isServicePackage, editedServiceId);
        }
    };

    Resource.prototype.getObjectResource = function () {
        var resourceResource = new Resource_Resource();
        resourceResource.serviceIdsByHumanResourceId = this.mapServicesWithIds(this.humanResources);
        resourceResource.serviceIdsByPhysicalResourceId = this.mapServicesWithIds(this.physicalResources);
        resourceResource.isServicePackage = this.isServicePackage;
        resourceResource.editedServiceId = this.editedServiceId;
        return resourceResource;
    };

    Resource.prototype.loadObject = function (humanResources, physicalResources, isServicePackage, editedServiceId) {
        this.humanResources = humanResources;
        this.physicalResources = physicalResources;
        this.isServicePackage = isServicePackage;
        this.editedServiceId = editedServiceId;
    };

    Resource.prototype.mapServicesWithIds = function (resources) {
        var servicesById = {};
        for (var i = 0; i < resources.length; i++) {
            var resource = resources[i];
            servicesById[resource.id] = [];
            for (var j = 0; j < resource.services.length; j++) {
                servicesById[resource.id].push(resource.services[j].getId());
            }
        }
        return servicesById;
    };

    return Resource;
}]);

angular.module('FlexyBeautyApp.services').factory('ResourceSrv', ["$log", "UserActionData", "ServerSrv", "HumanResourceData", "PhysicalResourceData", function ($log, UserActionData, ServerSrv, HumanResourceData, PhysicalResourceData) {
    var resourceSrv = {};

    resourceSrv.update = function (resource, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(resourceSrv.updateSync, resource, successFunction, errorFunction);
    };

    resourceSrv.updateSync = function (resource, successFunction, errorFunction) {
        var resourceSrv = resource.getObjectResource();
        resourceSrv.$update({}, //no params
        function (data) {
            try {
                if (data.humanResources) {
                    for (var i = 0; i < data.humanResources.length; i++) {
                        var humanResource = HumanResourceData.getById(data.humanResources[i].id);
                        if (!humanResource.version || data.humanResources[i].version && data.humanResources[i].version > humanResource.version) {
                            humanResource.version = data.humanResources[i].version;
                        }
                    }
                }

                if (data.physicalResources) {
                    for (var _i = 0; _i < data.physicalResources.length; _i++) {
                        var physicalResource = PhysicalResourceData.getById(data.physicalResources[_i].id);
                        if (!physicalResource.version || data.physicalResources[_i].version && data.physicalResources[_i].version > physicalResource.version) {
                            physicalResource.version = data.physicalResources[_i].version;
                        }
                    }
                }

                if (data.userAction) {
                    UserActionData.add(data.userAction);
                }

                if (successFunction) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    return resourceSrv;
}]);

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

var uuidV4 = __webpack_require__(217);

angular.module('FlexyBeautyApp.services').factory('Sale_Resource', ["$resource", "$location", function ($resource, $location) {
    var resourceBooking;
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    resourceBooking = $resource(baseUrl + 'rest/sales/:date/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        saveTransaction: { method: 'POST', url: baseUrl + 'rest/sales/saveTransaction' },
        refund: { method: 'POST', url: baseUrl + 'rest/sales/refund/:id' },
        sendMails: { method: 'POST', url: baseUrl + 'rest/sales/sendMails/:id' }
    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('Sale', ["SaleData", "Payment", "SaleService", "SaleProduct", "SaleCure", "CustomerData", "BookingData", "GiftItem", "GiftItemData", "OtherPaymentTypeData", "LoyaltyCardItem", "LoyaltyCardItemData", "CheckDepositData", "HumanResourceData", function (SaleData, Payment, SaleService, SaleProduct, SaleCure, CustomerData, BookingData, GiftItem, GiftItemData, OtherPaymentTypeData, LoyaltyCardItem, LoyaltyCardItemData, CheckDepositData, HumanResourceData) {
    var Sale = function Sale(saleRes, day, mustloadElements, isPreviousVersion, isApplicationLoading) {
        this.id = null;
        this.requestId = null;
        this.isDeleted = false;
        this.booking = null;
        this._bookingId = null;
        this.customer = null;
        this.customerLastname = null;
        this.customerFirstname = null;
        this.customerAddress = null;
        this.customerZip = null;
        this.customerCity = null;
        this.shareCapital = null;
        this.greffeCity = null;
        this.juridicForm = null;
        this._customerId = null; //tmp for loading only
        this.oriSale = null;
        this._oriSaleId = null; //tmp for loading only
        this.saleNumber = null;
        this.advanceNumber = null;
        this.estimationNumber = null;
        this.signatureCode = null;
        this.canceledSaleNumber = null;
        this.day = null;
        this.timeCreated = null;
        this.vat = 0;
        this.vatCode = null;
        this.servicesPrice = 0;
        this.productsPrice = 0;
        this.curesPrice = 0;
        this.giftItemsPrice = 0;
        this.loyaltyCardsPrice = 0;
        this.price = 0;
        this.priceHT = 0;
        this.statusType = {
            created: "created",
            waiting: "waiting",
            sold: "sold",
            canceled: "canceled",
            credit: "credit",
            advance: "advance"
        };
        this.status = this.statusType.created;
        this.delivery = null;
        this.deliveryMsg = null;
        this.techNote = null;
        this.comment = null;
        // Default value
        this.isCreatedByCustomer = false;
        this.cancelReason = "";
        // Payment type
        this.payments = [];
        this.categoryTypes = {
            product: "product",
            service: "service",
            cure: "cure",
            giftItem: "giftItem",
            loyaltyCard: "loyaltyCard"
        };
        this.saleServices = [];
        this.saleProducts = [];
        this.saleCures = [];
        this.giftItems = [];
        this.loyaltyCardItems = [];
        this.discountPercent = 0;
        // onlinePayment
        this.paymentCardId = null;
        this.loyaltyCardItem = null;
        this._loyaltyCardItemId = null;
        this.hasLoyaltyDiscount = false;
        this.nbPrint = 0;
        this.hrSeller = null;
        this.hrOp = null;
        this.loyaltyPts = 0;
        this.version = null;
        // local data
        this.realPaidPrice = 0;
        // local data
        this.caPrice = 0;
        this.sendByMail = false;
        this.sendGiftByMail = false;
        this.softV = null;
        this.deviceType = "DESKTOP";
        this.totalLoyaltyPts = 0;
        this.advancePrice = 0;
        this.site = null;

        if (saleRes !== undefined && saleRes != null) {
            this.loadObjectProperties(saleRes);
            if (mustloadElements) {
                this.loadObjectSaleServices(saleRes);
                this.loadObjectSaleProducts(saleRes);
                this.loadObjectSaleCures(saleRes);
                this.loadObjectGiftItems(saleRes, isApplicationLoading);
                this.loadObjectLoyaltyCardItems(saleRes);
            }
        } else this.requestId = uuidV4();

        if (day !== undefined && day != null) this.day = day;

        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            SaleData.add(this, isApplicationLoading);
    };

    Sale.prototype.loadObjectProperties = function (object) {
        if (object) {
            if (!this.id) this.id = object.id;
            this.requestId = object.requestId;
            this.saleNumber = object.saleNumber;
            this.advanceNumber = object.advanceNumber;
            this.estimationNumber = object.estimationNumber;
            this.signatureCode = object.signatureCode;
            this.canceledSaleNumber = object.canceledSaleNumber;
            this._customerId = object.customerId;
            this._bookingId = object.bookingId;
            this._oriSaleId = object.oriSaleId;
            if (object.timeCreated) this.timeCreated = new Date(object.timeCreated);
            this.status = object.status;
            this.delivery = object.delivery;
            this.deliveryMsg = object.deliveryMsg;
            this.techNote = object.techNote;
            this.comment = object.comment;
            this.isCreatedByCustomer = object.isCreatedByCustomer;
            this.nbPrint = object.nbPrint;
            this.cancelReason = object.cancelReason;
            this.vat = object.vat;
            this.vatCode = object.vatCode;
            this.servicesPrice = object.servicesPrice;
            this.productsPrice = object.productsPrice;
            if (object.curesPrice != undefined) this.curesPrice = object.curesPrice;
            if (object.giftItemsPrice != undefined) this.giftItemsPrice = object.giftItemsPrice;
            if (object.loyaltyCardsPrice != undefined) this.loyaltyCardsPrice = object.loyaltyCardsPrice;
            this.price = object.price;
            this.priceHT = object.priceHT;
            this.discountPercent = object.discountPercent;
            this.payments = [];
            if (object.payments) for (var i = 0; i < object.payments.length; i++) {
                this.payments.push(new Payment(object.payments[i]));
            }this.updateRealPaymentPrice();
            this.loyaltyPts = object.loyaltyPts;
            this.loyaltyDate = object.loyaltyDate;
            this._loyaltyCardItemId = object.loyaltyCardItemId;
            if (object.hrSellerId !== undefined) this.hrSeller = HumanResourceData.getById(object.hrSellerId);
            if (object.hrOpId !== undefined) this.hrOp = HumanResourceData.getById(object.hrOpId);
            if (object.version) this.version = object.version;
            this.softV = object.softV;
            this.totalLoyaltyPts = object.totalLoyaltyPts;
            this.site = object.site;
            this.hasLoyaltyDiscount = object.hasLoyaltyDiscount;
            this.advancePrice = object.advancePrice;
            if (object.deviceType) this.deviceType = object.deviceType;
            this.customerLastname = object.customerLastname;
            this.customerFirstname = object.customerFirstname;
            this.customerAddress = object.customerAddress;
            this.customerZip = object.customerZip;
            this.customerCity = object.customerCity;
            this.shareCapital = object.shareCapital;
            this.greffeCity = object.greffeCity;
            this.juridicForm = object.juridicForm;
        }
    };

    Sale.prototype.loadObjectSaleServices = function (object) {
        if (object.saleServices) {
            this.saleServices = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = object.saleServices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var oneSaleService = _step.value;

                    if (!oneSaleService.saleId || oneSaleService.saleId === this.id) {
                        this.addSaleService(new SaleService(oneSaleService));
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };

    Sale.prototype.loadObjectSaleProducts = function (object) {
        if (object.saleProducts) {
            this.saleProducts = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = object.saleProducts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var oneSaleProduct = _step2.value;

                    if (!oneSaleProduct.saleId || oneSaleProduct.saleId === this.id) {
                        this.addSaleProduct(new SaleProduct(oneSaleProduct));
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    };

    Sale.prototype.loadObjectSaleCures = function (object) {
        if (object.saleCures) {
            this.saleCures = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = object.saleCures[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var oneSaleCure = _step3.value;

                    if (!oneSaleCure.saleId || oneSaleCure.saleId === this.id) {
                        this.addSaleCure(new SaleCure(oneSaleCure, true));
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    };

    Sale.prototype.loadObjectGiftItems = function (object, isApplicationLoading) {
        if (object.giftItems) {
            this.giftItems = [];
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = object.giftItems[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var oneGiftItem = _step4.value;

                    if (!oneGiftItem.saleId || oneGiftItem.saleId === this.id) {
                        var giftItem = GiftItemData.getById(oneGiftItem.id);
                        if (!giftItem) {
                            giftItem = new GiftItem(oneGiftItem, null, isApplicationLoading);
                        }
                        this.addGiftItem(giftItem);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    };

    Sale.prototype.loadObjectLoyaltyCardItems = function (object) {
        if (object.loyaltyCardItems) {
            this.loyaltyCardItems = [];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = object.loyaltyCardItems[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var oneLoyaltyCardItem = _step5.value;

                    if (!oneLoyaltyCardItem.saleId || oneLoyaltyCardItem.saleId === this.id) {
                        this.addLoyaltyCardItem(new LoyaltyCardItem(oneLoyaltyCardItem));
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }
    };

    Sale.prototype.loadObject = function (object, isApplicationLoading) {
        this.loadObjectProperties(object);
        this.loadObjectSaleServices(object);
        this.loadObjectSaleProducts(object);
        this.loadObjectSaleCures(object);
        this.loadObjectGiftItems(object, isApplicationLoading);
        this.loadObjectLoyaltyCardItems(object);
    };

    Sale.prototype.loadRef = function (isPreviousVersion, isApplicationLoading) {
        if (this._customerId && (!this.customer || !isApplicationLoading)) {
            this.customer = CustomerData.getById(this._customerId, isApplicationLoading);
            if (this.customer && (isPreviousVersion === undefined || !isPreviousVersion)) {
                this.customer.addSale(this);
            }
        }
        if (this._oriSaleId && (!this.oriSale || !isApplicationLoading)) {
            this.oriSale = SaleData.getById(this._oriSaleId, isApplicationLoading);
        }

        if (this._bookingId && (!this.booking || !isApplicationLoading)) {
            this.booking = BookingData.getById(this._bookingId);
            if (this.booking && !this.booking.sale && (this.status == this.statusType.sold || this.status == this.statusType.waiting)) {
                this.booking.sale = this;
            }
        }

        for (var i = 0; i < this.payments.length; i++) {
            if (this.payments[i]._giftItemId) {
                this.payments[i].giftItem = GiftItemData.getById(this.payments[i]._giftItemId);
                if (this.payments[i].giftItem && this.status != this.statusType.canceled && this.status != this.statusType.credit) {
                    this.payments[i].giftItem.paymentSale = this;
                }
            }
            if (this.payments[i]._otherPaymentTypeId) {
                this.payments[i].otherPaymentType = OtherPaymentTypeData.getById(this.payments[i]._otherPaymentTypeId);
            }
            if (this.payments[i]._checkDepositId) {
                this.payments[i].checkDeposit = CheckDepositData.getById(this.payments[i]._checkDepositId);
                if (this.payments[i].checkDeposit) {
                    this.payments[i].checkDeposit.addSalePayment(this, this.payments[i]);
                }
            }
        }

        if (this.loyaltyCardItems) {
            for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                this.loyaltyCardItems[i].loadRef(null, isApplicationLoading);
            }
        }
        if (this._loyaltyCardItemId && (!this.loyaltyCardItem || !isApplicationLoading)) {
            this.loyaltyCardItem = LoyaltyCardItemData.getById(this._loyaltyCardItemId);
        }
    };

    Sale.prototype.updateRealPaymentPrice = function () {
        this.realPaidPrice = 0;
        for (var i = 0; i < this.payments.length; i++) {
            if (this.payments[i].type != "UNPAID" && this.payments[i].type != "GIFT") {
                this.realPaidPrice += this.payments[i].price;
            }
        }
    };

    Sale.prototype.getObjectResource = function () {
        var saleRes = {};
        //customer = booking.customer when booking is saved.
        saleRes.id = this.id;
        saleRes.requestId = this.requestId;
        saleRes.saleNumber = this.saleNumber;
        saleRes.advanceNumber = this.advanceNumber;
        saleRes.estimationNumber = this.estimationNumber;
        saleRes.canceledSaleNumber = this.canceledSaleNumber;
        if (this.day) saleRes.dayId = this.day.id;
        if (this.customer) //always save it
            saleRes.customer = this.customer.getObjectResource();
        if (this.booking) {
            //always save it
            saleRes.bookingId = this.booking.id;
        }
        if (this.oriSale) //always save it
            saleRes.oriSaleId = this.oriSale.id;

        saleRes.vat = this.vat;
        saleRes.vatCode = this.vatCode;
        saleRes.servicesPrice = this.servicesPrice;
        saleRes.productsPrice = this.productsPrice;
        saleRes.curesPrice = this.curesPrice;
        saleRes.giftItemsPrice = this.giftItemsPrice;
        saleRes.loyaltyCardsPrice = this.loyaltyCardsPrice;
        saleRes.price = this.price;
        saleRes.priceHT = this.priceHT;
        saleRes.status = this.status;
        saleRes.delivery = this.delivery;
        saleRes.deliveryMsg = this.deliveryMsg;
        saleRes.techNote = this.techNote;
        saleRes.comment = this.comment;
        saleRes.isCreatedByCustomer = this.isCreatedByCustomer;
        saleRes.nbPrint = this.nbPrint;
        saleRes.cancelReason = this.cancelReason;
        saleRes.discountPercent = this.discountPercent;
        saleRes.sendByMail = this.sendByMail;
        saleRes.sendGiftByMail = this.sendGiftByMail;
        saleRes.deviceType = this.deviceType;
        saleRes.totalLoyaltyPts = this.totalLoyaltyPts;
        saleRes.hasLoyaltyDiscount = this.hasLoyaltyDiscount;
        if (this.hrSeller) saleRes.hrSellerId = this.hrSeller.id;
        if (this.hrOp) saleRes.hrOpId = this.hrOp.id;

        saleRes.payments = [];
        for (var i = 0; i < this.payments.length; i++) {
            saleRes.payments.push(this.payments[i].getObjectResource());
        }saleRes.saleServices = [];
        for (var i = 0; i < this.saleServices.length; i++) {
            saleRes.saleServices.push(this.saleServices[i].getObjectResource());
        }
        saleRes.saleProducts = [];
        for (var i = 0; i < this.saleProducts.length; i++) {
            saleRes.saleProducts.push(this.saleProducts[i].getObjectResource());
        }
        saleRes.saleCures = [];
        for (var i = 0; i < this.saleCures.length; i++) {
            saleRes.saleCures.push(this.saleCures[i].getObjectResource());
        }
        saleRes.giftItems = [];
        for (var i = 0; i < this.giftItems.length; i++) {
            saleRes.giftItems.push(this.giftItems[i].getObjectResource());
        }
        saleRes.loyaltyCardItems = [];
        for (var i = 0; i < this.loyaltyCardItems.length; i++) {
            saleRes.loyaltyCardItems.push(this.loyaltyCardItems[i].getObjectResource());
        }

        saleRes.paymentCardId = this.paymentCardId;
        saleRes.loyaltyPts = this.loyaltyPts;
        saleRes.loyaltyDate = this.loyaltyDate;
        saleRes.advancePrice = this.advancePrice;
        if (this.loyaltyCardItem) saleRes.loyaltyCardItemId = this.loyaltyCardItem.id;

        saleRes.customerLastname = this.customerLastname;
        saleRes.customerFirstname = this.customerFirstname;
        saleRes.customerAddress = this.customerAddress;
        saleRes.customerZip = this.customerZip;
        saleRes.customerCity = this.customerCity;
        saleRes.shareCapital = this.shareCapital;
        saleRes.greffeCity = this.greffeCity;
        saleRes.juridicForm = this.juridicForm;

        return saleRes;
    };

    Sale.prototype.addSaleService = function (saleService) {
        var index = this.saleServices.indexOf(saleService);
        if (index == -1) {
            this.saleServices.push(saleService);
            saleService.sale = this;
        }
    };

    Sale.prototype.removeSaleService = function (saleService) {
        if (saleService != null) {
            var index = this.saleServices.indexOf(saleService);
            if (index != -1) this.saleServices.splice(index, 1);
            saleService.sale = null;
        }
    };

    Sale.prototype.getSaleProductById = function (id) {
        for (var i = 0; i < this.saleProducts.length; i++) {
            if (this.saleProducts[i].id == id) return this.saleProducts[i];
        }return null;
    };

    Sale.prototype.addSaleProduct = function (saleProduct) {
        var index = this.saleProducts.indexOf(saleProduct);
        if (index == -1) {
            this.saleProducts.push(saleProduct);
            saleProduct.sale = this;
        }
    };

    Sale.prototype.removeSaleProduct = function (saleProduct) {
        if (saleProduct != null) {
            var index = this.saleProducts.indexOf(saleProduct);
            if (index != -1) this.saleProducts.splice(index, 1);
            saleProduct.sale = null;
        }
    };

    Sale.prototype.getSaleCureById = function (id) {
        for (var i = 0; i < this.saleCures.length; i++) {
            if (this.saleCures[i].id == id) return this.saleCures[i];
        }return null;
    };

    Sale.prototype.addSaleCure = function (saleCure) {
        var index = this.saleCures.indexOf(saleCure);
        if (index == -1) {
            this.saleCures.push(saleCure);
            saleCure.sale = this;
        }
    };

    Sale.prototype.removeSaleCure = function (saleCure) {
        if (saleCure != null) {
            var index = this.saleCures.indexOf(saleCure);
            if (index != -1) this.saleCures.splice(index, 1);
            saleCure.sale = null;
        }
    };

    Sale.prototype.addGiftItem = function (giftItem) {
        var index = this.giftItems.indexOf(giftItem);
        if (index == -1) {
            this.giftItems.push(giftItem);
            giftItem.sale = this;
        }
    };

    Sale.prototype.removeGiftItem = function (giftItem) {
        if (giftItem != null) {
            var index = this.giftItems.indexOf(giftItem);
            if (index != -1) this.giftItems.splice(index, 1);
            giftItem.sale = null;
        }
    };

    Sale.prototype.addLoyaltyCardItem = function (loyaltyCardItem) {
        var index = this.loyaltyCardItems.indexOf(loyaltyCardItem);
        if (index == -1) {
            this.loyaltyCardItems.push(loyaltyCardItem);
            loyaltyCardItem.sale = this;
        }
    };

    Sale.prototype.removeLoyaltyCardItem = function (loyaltyCardItem) {
        if (loyaltyCardItem != null) {
            var index = this.loyaltyCardItems.indexOf(loyaltyCardItem);
            if (index != -1) {
                this.loyaltyCardItems.splice(index, 1);
            }
            loyaltyCardItem.sale = null;
        }
    };

    Sale.prototype.isStatusSoldOrCreditOrCanceled = function () {
        return this.status == this.statusType.sold || this.status == this.statusType.credit || this.status == this.statusType.canceled;
    };

    Sale.prototype.getSaleCuresSumPrice = function () {
        var price = 0;
        if (this.isStatusSoldOrCreditOrCanceled()) {
            for (var i = 0; i < this.saleCures.length; i++) {
                price += this.saleCures[i].getDiscountPrice();
            }
        }
        return price;
    };

    Sale.prototype.getLoyaltyCardItemsSumPrice = function () {
        var price = 0;
        if (this.isStatusSoldOrCreditOrCanceled()) {
            for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                price += this.loyaltyCardItems[i].getDiscountPrice();
            }
        }
        return price;
    };

    Sale.prototype.applyGlobalDiscountAndGift = function (price, withGift) {
        var discountPercentForItems = this.discountPercent;
        if (!withGift) //Remove gift payment from price
            {
                var originalPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
                var paymentGift = 0;
                for (var j = 0; j < this.payments.length; j++) {
                    if (this.payments[j].type == "GIFT") paymentGift += this.payments[j].price;
                }if (originalPrice > 0) discountPercentForItems = 100 - 100 * (this.price - paymentGift) / originalPrice;
            }
        //apply global discount on price
        if (discountPercentForItems == 0) return price;else return price - discountPercentForItems * price / 100;
    };

    Sale.prototype.getSaleServicesSumPriceByHrId = function (hrId, withGift) {
        var price = 0;
        if (this.isStatusSoldOrCreditOrCanceled()) {
            for (var i = 0; i < this.saleServices.length; i++) {
                if (this.saleServices[i].subSaleServices.length != 0) {
                    for (var j = 0; j < this.saleServices[i].subSaleServices.length; j++) {
                        if (this.saleServices[i].subSaleServices[j].humanResource && this.saleServices[i].subSaleServices[j].humanResource.id == hrId) {
                            price += this.saleServices[i].subSaleServices[j].price;
                        }
                    }
                } else {
                    if (this.saleServices[i].humanResource && this.saleServices[i].humanResource.id == hrId || !this.saleServices[i].humanResource && !hrId) {
                        price += this.saleServices[i].price;
                    }
                }
            }
            price = this.applyGlobalDiscountAndGift(price, withGift);
        }
        return price;
    };

    /**
     * Check if a sale exist with an item id (serviceId, productId, cureId, ...)
     * and the category type (service, product, cure, ...).
     *
     * @param itemId the itemId
     * @param categoryType the categoryType
     *
     * return boolean
     */
    Sale.prototype.hasItemByIdAndType = function (itemId, categoryType) {
        if (this.isStatusSoldOrCreditOrCanceled()) {
            switch (categoryType) {
                case this.categoryTypes.service:
                    return this.saleServices.some(function (element) {
                        return element.service && element.service.id == itemId;
                    });
                case this.categoryTypes.product:
                    return this.saleProducts.some(function (element) {
                        return element.product && element.product.id == itemId;
                    });
                case this.categoryTypes.cure:
                    return this.saleCures.some(function (element) {
                        return element.cure && element.cure.id == itemId;
                    });
                case this.categoryTypes.giftItem:
                    return this.giftItems.some(function (element) {
                        return element.id == itemId;
                    });
                case this.categoryTypes.loyaltyCard:
                    return this.loyaltyCardItems.some(function (element) {
                        return element.loyaltyCard && element.loyaltyCard.id == itemId;
                    });
                default:
                    return false;
            }
        }
        return false;
    };

    Sale.prototype.getSaleProductsSumPriceByHrId = function (hrId, withGift) {
        var price = 0;
        if (this.isStatusSoldOrCreditOrCanceled()) {
            for (var i = 0; i < this.saleProducts.length; i++) {
                if (this.saleProducts[i].humanResource && this.saleProducts[i].humanResource.id == hrId || !this.saleProducts[i].humanResource && !hrId) price += this.saleProducts[i].price;
            } //apply global discount on price
            price = this.applyGlobalDiscountAndGift(price, withGift);
        }
        return price;
    };

    Sale.prototype.getSaleGiftItemsSumPriceByHrId = function (hrId, withGift) {
        var price = 0;
        if (this.isStatusSoldOrCreditOrCanceled()) {
            for (var i = 0; i < this.giftItems.length; i++) {
                if (this.giftItems[i].humanResource && this.giftItems[i].humanResource.id == hrId || !this.giftItems[i].humanResource && !hrId) price += this.giftItems[i].price;
            } //apply global discount on price
            price = this.applyGlobalDiscountAndGift(price, withGift);
        }
        return price;
    };

    Sale.prototype.getSaleCuresSumPriceByHrId = function (hrId, withGift) {
        var price = 0;
        if (this.isStatusSoldOrCreditOrCanceled()) {
            for (var i = 0; i < this.saleCures.length; i++) {
                if (this.saleCures[i].humanResource && this.saleCures[i].humanResource.id == hrId || !this.saleCures[i].humanResource && !hrId) {
                    price += this.saleCures[i].price;
                }
            }
            //apply global discount on price
            price = this.applyGlobalDiscountAndGift(price, withGift);
        }
        return price;
    };

    Sale.prototype.getLoyaltyCardItemsSumPriceByHrId = function (hrId, withGift) {
        var price = 0;
        if (this.isStatusSoldOrCreditOrCanceled()) {
            for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                if (this.loyaltyCardItems[i].humanResource && this.loyaltyCardItems[i].humanResource.id == hrId || !this.loyaltyCardItems[i].humanResource && !hrId) {
                    price += this.loyaltyCardItems[i].price;
                }
            }
            price = this.applyGlobalDiscountAndGift(price, withGift);
        }
        return price;
    };

    Sale.prototype.getSalesServicesByHrId = function (hrId) {
        var salesItems = [];
        if (this.isStatusSoldOrCreditOrCanceled()) {
            for (var i = 0; i < this.saleServices.length; i++) {
                if (this.saleServices[i].subSaleServices.length != 0) {
                    for (var j = 0; j < this.saleServices[i].subSaleServices.length; j++) {
                        if (this.saleServices[i].subSaleServices[j].humanResource && this.saleServices[i].subSaleServices[j].humanResource.id == hrId) {
                            salesItems.push(this.saleServices[i].subSaleServices[j]);
                        }
                    }
                } else {
                    if (this.saleServices[i].humanResource && this.saleServices[i].humanResource.id == hrId) salesItems.push(this.saleServices[i]);
                }
            }
        }
        return salesItems;
    };

    Sale.prototype.getSalesProductsByHrId = function (hrId) {
        var salesItems = [];
        if (this.isStatusSoldOrCreditOrCanceled()) {
            for (var i = 0; i < this.saleProducts.length; i++) {
                if (this.saleProducts[i].humanResource && this.saleProducts[i].humanResource.id == hrId) salesItems.push(this.saleProducts[i]);
            }for (var i = 0; i < this.saleCures.length; i++) {
                if (this.saleCures[i].humanResource && this.saleCures[i].humanResource.id == hrId) salesItems.push(this.saleCures[i]);
            }for (var i = 0; i < this.giftItems.length; i++) {
                if (this.giftItems[i].humanResource && this.giftItems[i].humanResource.id == hrId) salesItems.push(this.giftItems[i]);
            }for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                if (this.loyaltyCardItems[i].humanResource && this.loyaltyCardItems[i].humanResource.id == hrId) salesItems.push(this.loyaltyCardItems[i]);
            }
        }
        return salesItems;
    };

    Sale.prototype.hasPaymentType = function (type) {
        for (var i = 0; i < this.payments.length; i++) {
            if (this.payments[i].type == type) {
                return true;
            }
        }
        return false;
    };

    Sale.prototype.hrIsWorking = function (hrId) {
        var hrIsWorking = false;
        for (var i = 0; i < this.saleServices.length; i++) {
            if (this.saleServices[i].subSaleServices.length == 0) {
                if (this.saleServices[i].humanResource && this.saleServices[i].humanResource.id === hrId) {
                    return true;
                }
            } else {
                for (var j = 0; j < this.saleServices[i].subSaleServices.length; j++) {
                    if (this.saleServices[i].subSaleServices[j].humanResource && this.saleServices[i].subSaleServices[j].humanResource.id === hrId) {
                        return true;
                    }
                }
            }
        }
        for (var i = 0; i < this.saleProducts.length; i++) {
            if (this.saleProducts[i].humanResource && this.saleProducts[i].humanResource.id === hrId) {
                return true;
            }
        }
        for (var i = 0; i < this.saleCures.length; i++) {
            if (this.saleCures[i].humanResource && this.saleCures[i].humanResource.id === hrId) {
                return true;
            }
        }
        for (var i = 0; i < this.loyaltyCardItems.length; i++) {
            if (this.loyaltyCardItems[i].humanResource && this.loyaltyCardItems[i].humanResource.id === hrId) {
                return true;
            }
        }

        return hrIsWorking;
    };

    Sale.prototype.getAllItemsPrice = function () {
        var allItemPrice = 0;
        if (this.booking && (this.status === "created" || this.status === "waiting" || this.status === "advance" || this.status === "soldProcess" || this.status === "advanceProcess")) for (var i = 0; i < this.booking.bookingServices.length; i++) {
            allItemPrice += this.booking.bookingServices[i].price;
        } else for (var _i = 0; _i < this.saleServices.length; _i++) {
            allItemPrice += this.saleServices[_i].price;
        }for (var _i2 = 0; _i2 < this.saleProducts.length; _i2++) {
            allItemPrice += this.saleProducts[_i2].price;
        }for (var _i3 = 0; _i3 < this.saleCures.length; _i3++) {
            allItemPrice += this.saleCures[_i3].price;
        }for (var _i4 = 0; _i4 < this.giftItems.length; _i4++) {
            allItemPrice += this.giftItems[_i4].price;
        }for (var _i5 = 0; _i5 < this.loyaltyCardItems.length; _i5++) {
            allItemPrice += this.loyaltyCardItems[_i5].price;
        }return allItemPrice;
    };

    Sale.prototype.isCancelledOrCredit = function () {
        return this.status === 'canceled' || this.status === 'credit';
    };

    Sale.prototype.hasReceivedPayment = function () {
        return this.status === "sold" || this.status === "advance" || this.status === "advanceKeeped";
    };

    Sale.prototype.inactiveUnusedLoyaltyCardItem = function (activeLoyaltyCard) {
        if (this.loyaltyCardItem && !this.loyaltyCardItem.isUsed && activeLoyaltyCard) {
            this.loyaltyCardItem.isUsed = true;
        }
    };

    Sale.prototype.inactiveUnusedLoyaltyCardItems = function (activeLoyaltyCard) {
        if (this.loyaltyCardItems && activeLoyaltyCard) {
            for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                var loyaltyCardItem = this.loyaltyCardItems[i];
                if (loyaltyCardItem && !loyaltyCardItem.isUsed) {
                    loyaltyCardItem.isUsed = true;
                }
            }
        }
    };

    return Sale;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleSrv', ["$rootScope", "$log", "ServerSrv", "Sale_Resource", "Sale", "HumanResourceSrv", "PhysicalResourceSrv", "DayData", "UserActionData", "SaleData", "gettextCatalog", "MessageSrv", function ($rootScope, $log, ServerSrv, Sale_Resource, Sale, HumanResourceSrv, PhysicalResourceSrv, DayData, UserActionData, SaleData, gettextCatalog, MessageSrv) {
    var saleSrv = {};
    saleSrv.newLoadRef = function (isApplicationLoading, start, step) {
        return new Promise(function (resolve) {
            var saleStart = start || 0;
            var saleStep = step || 10000;

            var sales = isApplicationLoading ? Object.values(SaleData.objSales) : SaleData.indexSales;
            var subSales = sales.slice(saleStart, saleStart + saleStep);
            subSales.map(function (sale) {
                sale.loadRef(null, isApplicationLoading);
            });

            if (subSales.length === step) {
                resolve(saleSrv.newLoadRef(isApplicationLoading, saleStart + saleStep, saleStep));
            } else {
                resolve();
            }
        });
    };

    saleSrv.loadRef = function (isApplicationLoading) {
        if (isApplicationLoading) {
            var _sales = SaleData.objSales;
            for (var key in _sales) {
                _sales[key].loadRef(null, isApplicationLoading);
            }
        } else {
            var sales = SaleData.indexSales;
            for (var i = 0; i < sales.length; i++) {
                sales[i].loadRef(null, isApplicationLoading);
            }
        }
    };
    saleSrv.save = function (sale, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(saleSrv.saveSync, sale, successFunction, errorFunction);
    };
    saleSrv.saveSync = function (sale, successFunction, errorFunction) {
        //$timeout (function () {

        var saleRes = sale.getObjectResource();
        saleRes.$save({}, //no params
        function (saleRes) {
            /** @namespace saleRes.salesId */
            /** @namespace
             *  saleRes.saleServicesId */
            /** @namespace saleRes.saleProductsId */
            try {
                if (sale.id == null) sale.id = saleRes.id;
                if (!sale.version || saleRes.version && saleRes.version > sale.version) sale.version = saleRes.version;
                if (saleRes.timeCreated) sale.timeCreated = new Date(saleRes.timeCreated);

                if (saleRes.saleNumber) sale.saleNumber = saleRes.saleNumber;

                if (saleRes.softV) sale.softV = saleRes.softV;

                if (saleRes.advanceNumber) sale.advanceNumber = saleRes.advanceNumber;

                if (saleRes.estimationNumber) sale.estimationNumber = saleRes.estimationNumber;

                if (saleRes.signatureCode) sale.signatureCode = saleRes.signatureCode;

                if (saleRes.salesId && saleRes.salesId.length == sale.sales.length) for (var i = 0; i < saleRes.salesId.length; i++) {
                    sale.sales[i].id = saleRes.salesId[i];
                }for (var j = 0; j < saleRes.saleServices.length; j++) {
                    sale.saleServices[j].setId(saleRes.saleServices[j].id);
                    if (!sale.saleServices[j].version || saleRes.saleServices[j].version && saleRes.saleServices[j].version > sale.saleServices[j].version) sale.saleServices[j].version = saleRes.saleServices[j].version;
                    // if dayHr created by transaction : set dayHrId
                }
                for (var j = 0; j < saleRes.saleProducts.length; j++) {
                    sale.saleProducts[j].setId(saleRes.saleProducts[j].id);
                    if (!sale.saleProducts[j].version || saleRes.saleProducts[j].version && saleRes.saleProducts[j].version > sale.saleProducts[j].version) sale.saleProducts[j].version = saleRes.saleProducts[j].version;
                }

                if (saleRes.saleCures) for (var j = 0; j < saleRes.saleCures.length; j++) {
                    sale.saleCures[j].setId(saleRes.saleCures[j].id);
                    if (!sale.saleCures[j].version || saleRes.saleCures[j].version && saleRes.saleCures[j].version > sale.saleCures[j].version) sale.saleCures[j].version = saleRes.saleCures[j].version;
                    if (saleRes.saleCures[j].cureItems) for (var k = 0; k < saleRes.saleCures[j].cureItems.length; k++) {
                        sale.saleCures[j].cureItems[k].setId(saleRes.saleCures[j].cureItems[k].id);
                        if (saleRes.saleCures[j].cureItems[k].cureItemToServiceIds) for (var l = 0; l < saleRes.saleCures[j].cureItems[k].cureItemToServiceIds.length; l++) {
                            sale.saleCures[j].cureItems[k].cureItemToServices[l].setId(saleRes.saleCures[j].cureItems[k].cureItemToServiceIds[l]);
                        }
                    }
                }

                if (saleRes.giftItems) for (var j = 0; j < saleRes.giftItems.length; j++) {

                    sale.giftItems[j].setId(saleRes.giftItems[j].id);
                    sale.giftItems[j].code = saleRes.giftItems[j].code;
                    if (!sale.giftItems[j].version || saleRes.giftItems[j].version && saleRes.giftItems[j].version > sale.giftItems[j].version) sale.giftItems[j].version = saleRes.giftItems[j].version;
                }
                if (saleRes.loyaltyCardItems && saleRes.loyaltyCardItems.length == sale.loyaltyCardItems.length) for (var j = 0; j < saleRes.loyaltyCardItems.length; j++) {
                    sale.loyaltyCardItems[j].id = saleRes.loyaltyCardItems[j].id;
                    if (!sale.loyaltyCardItems[j].version || saleRes.loyaltyCardItems[j].version && saleRes.loyaltyCardItems[j].version > sale.loyaltyCardItems[j].version) sale.loyaltyCardItems[j].version = saleRes.loyaltyCardItems[j].version;
                }

                if (saleRes.customer && sale.customer) {
                    sale.customer.setId(saleRes.customer.id);
                    if (!sale.customer.version || saleRes.customer.version && saleRes.customer.version > sale.customer.version) sale.customer.version = saleRes.customer.version;
                }

                sale.totalLoyaltyPts = saleRes.totalLoyaltyPts;
                sale.advancePrice = saleRes.advancePrice;
                sale.site = saleRes.site;
                sale.hasLoyaltyDiscount = saleRes.hasLoyaltyDiscount;
                UserActionData.add(saleRes.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(saleRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                var errorMessage = "Erreur inconnue lors de la sauvegarde.";
                if (data.status && data.data) {
                    if (data.status == "409") {
                        if (data.data.errorCode == "40900") errorMessage = "L'heure choisie pour la réservation n'est plus disponible.";
                    }
                }
                if (errorFunction != undefined) errorFunction(errorMessage);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    saleSrv.remove = function (sale, successFunction, errorFunction) {
        //Remove directly from model
        ServerSrv.startSavingProcess(saleSrv.removeSync, sale, successFunction, errorFunction);
    };
    saleSrv.removeSync = function (sale, successFunction, errorFunction) {
        //$timeout (function () {

        var saleSrv = new Sale_Resource();
        saleSrv.$remove({ id: sale.id }, //params : id
        function (data) {
            try {
                UserActionData.add(data.userAction);

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
        //},2000)
    };

    saleSrv.executeTransaction = function (transaction, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(saleSrv.executeTransactionAsync, transaction, successFunction, errorFunction);
    };
    saleSrv.executeTransactionAsync = function (transaction, successFunction, errorFunction) {
        if (transaction && transaction.objects && transaction.objects.length > 0) {
            var transactionResource = new Sale_Resource();
            transactionResource.sales = [];
            for (var i = 0; i < transaction.objects.length; i++) {
                transactionResource.sales.push(transaction.objects[i].getObjectResource());
            }transactionResource.$saveTransaction({}, //no params
            function (data) {
                /** @namespace data.saleServicesId */
                var success = true;
                try {
                    var sale;
                    var saleRes;
                    if (data.sales && data.sales !== undefined && transaction.objects.length == data.sales.length && data.userAction && data.userAction !== undefined) {
                        for (var i = 0; i < transaction.objects.length; i++) //Consider order must be the same
                        {
                            var j;
                            sale = transaction.objects[i];
                            saleRes = data.sales[i];
                            if (sale.id == null) sale.id = saleRes.id;
                            if (!sale.version || saleRes.version && saleRes.version > sale.version) sale.version = saleRes.version;
                            if (saleRes.timeCreated) sale.timeCreated = new Date(saleRes.timeCreated);

                            if (saleRes.saleNumber) sale.saleNumber = saleRes.saleNumber;

                            if (saleRes.softV) sale.softV = saleRes.softV;

                            if (saleRes.advanceNumber) sale.advanceNumber = saleRes.advanceNumber;

                            if (saleRes.estimationNumber) sale.estimationNumber = saleRes.estimationNumber;

                            if (saleRes.signatureCode) sale.signatureCode = saleRes.signatureCode;

                            if (sale.booking && saleRes.bookingId == sale.booking.id) {
                                sale.booking.version = saleRes.bookingVersion;
                            }

                            if (saleRes.salesId && saleRes.salesId.length == sale.sales.length) for (var i = 0; i < saleRes.salesId.length; i++) {
                                sale.sales[i].id = saleRes.salesId[i];
                            }for (var j = 0; j < saleRes.saleServices.length; j++) {
                                sale.saleServices[j].setId(saleRes.saleServices[j].id);
                                if (!sale.saleServices[j].version || saleRes.saleServices[j].version && saleRes.saleServices[j].version > sale.saleServices[j].version) sale.saleServices[j].version = saleRes.saleServices[j].version;
                            }
                            for (var j = 0; j < saleRes.saleProducts.length; j++) {
                                sale.saleProducts[j].setId(saleRes.saleProducts[j].id);
                                if (!sale.saleProducts[j].version || saleRes.saleProducts[j].version && saleRes.saleProducts[j].version > sale.saleProducts[j].version) sale.saleProducts[j].version = saleRes.saleProducts[j].version;
                            }

                            if (saleRes.saleCures) for (var j = 0; j < saleRes.saleCures.length; j++) {
                                sale.saleCures[j].setId(saleRes.saleCures[j].id);
                                if (!sale.saleCures[j].version || saleRes.saleCures[j].version && saleRes.saleCures[j].version > sale.saleCures[j].version) sale.saleCures[j].version = saleRes.saleCures[j].version;
                                if (saleRes.saleCures[j].cureItems) for (var k = 0; k < saleRes.saleCures[j].cureItems.length; k++) {
                                    sale.saleCures[j].cureItems[k].setId(saleRes.saleCures[j].cureItems[k].id);
                                    if (saleRes.saleCures[j].cureItems[k].cureItemToServiceIds) for (var l = 0; l < saleRes.saleCures[j].cureItems[k].cureItemToServiceIds.length; l++) {
                                        sale.saleCures[j].cureItems[k].cureItemToServices[l].setId(saleRes.saleCures[j].cureItems[k].cureItemToServiceIds[l]);
                                    }
                                }
                            }

                            if (saleRes.giftItems) for (var j = 0; j < saleRes.giftItems.length; j++) {

                                sale.giftItems[j].setId(saleRes.giftItems[j].id);
                                sale.giftItems[j].code = saleRes.giftItems[j].code;
                                if (!sale.giftItems[j].version || saleRes.giftItems[j].version && saleRes.giftItems[j].version > sale.giftItems[j].version) sale.giftItems[j].version = saleRes.giftItems[j].version;
                            }
                            if (saleRes.loyaltyCardItems && saleRes.loyaltyCardItems.length == sale.loyaltyCardItems.length) for (var j = 0; j < saleRes.loyaltyCardItems.length; j++) {
                                sale.loyaltyCardItems[j].id = saleRes.loyaltyCardItems[j].id;
                                if (!sale.loyaltyCardItems[j].version || saleRes.loyaltyCardItems[j].version && saleRes.loyaltyCardItems[j].version > sale.loyaltyCardItems[j].version) sale.loyaltyCardItems[j].version = saleRes.loyaltyCardItems[j].version;
                            }

                            if (saleRes.customer && sale.customer) {
                                sale.customer.setId(saleRes.customer.id);
                                if (!sale.customer.version || saleRes.customer.version && saleRes.customer.version > sale.customer.version) sale.customer.version = saleRes.customer.version;
                            }

                            sale.totalLoyaltyPts = saleRes.totalLoyaltyPts;
                            sale.site = saleRes.site;
                            sale.hasLoyaltyDiscount = saleRes.hasLoyaltyDiscount;
                            sale.advancePrice = saleRes.advancePrice;

                            sale.customerLastname = saleRes.customerLastname;
                            sale.customerFirstname = saleRes.customerFirstname;
                            sale.customerAddress = saleRes.customerAddress;
                            sale.customerZip = saleRes.customerZip;
                            sale.customerCity = saleRes.customerCity;
                            sale.shareCapital = saleRes.shareCapital;
                            sale.greffeCity = saleRes.greffeCity;
                            sale.juridicForm = saleRes.juridicForm;
                        }
                        UserActionData.add(data.userAction);
                        //CallBack on success
                        if (successFunction != undefined) successFunction(data);
                        success = true;
                    } else {
                        success = false;
                        $log.error("Sale.executeTransactionAsync : incorrect return data");
                    }
                } catch (ex) {
                    if (errorFunction != undefined) errorFunction(data);
                } finally {
                    if (success) {
                        ServerSrv.endSavingProcess(true);
                    } else {
                        ServerSrv.endSavingProcess(false, 200);
                    }
                }
            }, function (data) {
                //failure
                //error handling goes here
                try {
                    if (errorFunction != undefined) errorFunction(data);
                } finally {
                    ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
                }
            });
        } else ServerSrv.endSavingProcess(true);
    };
    saleSrv.refund = function (sale, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(saleSrv.refundAsync, sale, successFunction, errorFunction);
    };
    saleSrv.refundAsync = function (sale, successFunction, errorFunction) {
        var ress = new Sale_Resource();
        ress.$refund({ id: sale.id }, //params
        function (data) {
            //success
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure

            try {
                //error handling goes here
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    saleSrv.sendMails = function (sale, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(saleSrv.sendMailsAsync, sale, successFunction, errorFunction);
    };
    saleSrv.sendMailsAsync = function (sale, successFunction, errorFunction) {
        var ress = new Sale_Resource();
        ress.$sendMails({ id: sale.id }, //params
        function (data) {
            //success
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure

            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    saleSrv.removeLocally = function (id, resource) {
        var sale = SaleData.getById(id);
        if (sale && sale.version && resource.version && resource.version < sale.version) return null;
        if (sale != null) {
            if (sale.day) sale.day.removeSale(sale);
            if (sale.customer) sale.customer.removeSale(sale);
            sale.isDeleted = true;
        }
        return sale;
    };
    saleSrv.addLocally = function (id, resource) {
        var sale = SaleData.getById(id);
        if (sale && sale.version && resource.version && resource.version < sale.version) return null;
        var day = DayData.getById(resource.dayId);
        if (sale != null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                if (sale.customer) sale.customer.removeSale(sale);
                sale.loadObjectProperties(resource);
            } else {
            sale = new Sale(resource, day, false, null, false); //dont load salesService (will be done after)
            sale.id = id;
        }
        sale.loadRef();
        if (day) day.addSale(sale);

        return sale;
    };
    saleSrv.updateLocally = function (id, resource) {
        var sale = SaleData.getById(id);
        if (!sale) {
            MessageSrv.send("error", gettextCatalog.getString("Veuillez recharger l'application afin d'actualiser les données"));
            console.log("Sale.updateLocally error from userAction - no entity found - Sale ID: " + id);
            return null;
        }
        if (sale.version && resource.version && resource.version < sale.version) return null;

        var day = DayData.getById(resource.dayId);
        if (day && sale) {
            if (sale.day !== day) {
                sale.day.removeSale(sale);
                day.addSale(sale);
            }
            if (sale.customer) sale.customer.removeSale(sale);
            sale.loadObject(resource);
            sale.loadRef(); //Will add to customer
        }
        return sale;
    };
    saleSrv.getPreviousVersionInstance = function (resource) {
        var day = DayData.getById(resource.dayId);
        var sale = new Sale(resource, day, false, true, false);
        return sale;
    };

    return saleSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleData', ["$log", "ModelDataUtil", function ($log, ModelDataUtil) {
    var saleData = {
        objSales: {},
        indexSales: []
    };
    saleData.getById = function (saleId, isApplicationLoading) {
        var sale = null;
        if (isApplicationLoading) {
            sale = this.objSales[saleId];
        } else {
            for (var i = 0; i < this.indexSales.length; i++) {
                if (this.indexSales[i].id === saleId) {
                    sale = this.indexSales[i];
                    break;
                }
            }
        }
        return sale;
    };

    saleData.getIndexOf = function (sale) {
        if (sale) return this.indexSales.indexOf(sale);
        return -1;
    };
    saleData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexSales.length) return this.indexSales[index];else return null;
    };

    saleData.getListByDate = function (date) {
        var sales = [];
        var sale;
        var hasDate;
        var fullYear = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        if (date) for (var i = 0; i < this.indexSales.length; i++) {
            sale = this.indexSales[i];
            for (var j = 0; j < sale.payments.length; j++) {
                if (!hasDate) //deprecated
                    if (!this.indexSales[i].isDeleted && this.indexSales[i].timeCreated && this.indexSales[i].timeCreated.getFullYear() == fullYear && this.indexSales[i].timeCreated.getMonth() == month && this.indexSales[i].timeCreated.getDate() == day) sales.push(this.indexSales[i]);
            }
        }

        return sales;
    };
    saleData.getListByPaymentDate = function (date) {
        var sales = [];
        var sale;
        var hasDate;
        var fullYear = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        var match;
        var time;
        if (date) for (var i = 0; i < this.indexSales.length; i++) {
            match = false;
            hasDate = false;
            sale = this.indexSales[i];
            for (var j = 0; j < sale.payments.length && !match; j++) {
                time = sale.payments[j].date.getTime();
                if (sale.payments[j].date && time != 0 && !isNaN(time)) {
                    hasDate = true;
                    match = sale.payments[j].date.getFullYear() == fullYear && sale.payments[j].date.getMonth() == month && sale.payments[j].date.getDate() == day;
                }
                if (!match && !hasDate) //deprecated
                    match = !this.indexSales[i].isDeleted && this.indexSales[i].timeCreated && this.indexSales[i].timeCreated.getFullYear() == fullYear && this.indexSales[i].timeCreated.getMonth() == month && this.indexSales[i].timeCreated.getDate() == day;
                if (match) sales.push(this.indexSales[i]);
            }
        }

        return sales;
    };
    saleData.getListByPaymentDateAndType = function (date, type) {
        var saleAndPayments = [];
        var sale;
        var hasDate;
        var fullYear = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        var match;
        var time;
        if (date) for (var i = 0; i < this.indexSales.length; i++) {
            hasDate = false;
            sale = this.indexSales[i];
            if (sale.status == "sold" || sale.status == "advance" || sale.status == "advanceKeeped") for (var j = 0; j < sale.payments.length; j++) {
                if (sale.payments[j].type == type) {
                    match = false;
                    time = sale.payments[j].date.getTime();
                    if (sale.payments[j].date && time != 0 && !isNaN(time)) {
                        hasDate = true;
                        match = sale.payments[j].date.getFullYear() == fullYear && sale.payments[j].date.getMonth() == month && sale.payments[j].date.getDate() == day;
                    }
                    if (!match && !hasDate) //deprecated
                        match = !this.indexSales[i].isDeleted && this.indexSales[i].timeCreated && this.indexSales[i].timeCreated.getFullYear() == fullYear && this.indexSales[i].timeCreated.getMonth() == month && this.indexSales[i].timeCreated.getDate() == day;
                    if (match) saleAndPayments.push({ sale: this.indexSales[i], payment: sale.payments[j] });
                }
            }
        }

        return saleAndPayments;
    };
    saleData.getPriceByPaymentDateAndType = function (date, type) {
        var price = 0;
        var sale;
        var hasDate;
        var fullYear = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        var match;
        var time;
        if (date) for (var i = 0; i < this.indexSales.length; i++) {
            hasDate = false;
            sale = this.indexSales[i];
            if (sale.status == "sold" || sale.status == "advance" || sale.status == "advanceKeeped") for (var j = 0; j < sale.payments.length; j++) {
                if (sale.payments[j].type == type) {
                    match = false;
                    time = sale.payments[j].date.getTime();
                    if (sale.payments[j].date && time != 0 && !isNaN(time)) {
                        hasDate = true;
                        match = sale.payments[j].date.getFullYear() == fullYear && sale.payments[j].date.getMonth() == month && sale.payments[j].date.getDate() == day;
                    }
                    if (!match && !hasDate) //deprecated
                        match = !this.indexSales[i].isDeleted && this.indexSales[i].timeCreated && this.indexSales[i].timeCreated.getFullYear() == fullYear && this.indexSales[i].timeCreated.getMonth() == month && this.indexSales[i].timeCreated.getDate() == day;
                    if (match) price += sale.payments[j].price;
                }
            }
        }

        return price;
    };
    saleData.getListByPaymentType = function (type, status) {
        var sales = [];
        var found;
        if (type) for (var i = 0; i < this.indexSales.length; i++) {
            found = false;
            if (status == undefined) for (var j = 0; j < this.indexSales[i].payments.length && !found; j++) {
                if (!this.indexSales[i].isDeleted && this.indexSales[i].payments[j].type == type) {
                    sales.push(this.indexSales[i]);
                    found = true;
                }
            } else for (var j = 0; j < this.indexSales[i].payments.length && !found; j++) {
                if (this.indexSales[i].status == status && !this.indexSales[i].isDeleted && this.indexSales[i].payments[j].type == type) {
                    sales.push(this.indexSales[i]);
                    found = true;
                }
            }
        }

        return sales;
    };
    saleData.getListByDatePeriod = function (startDate, endDate) {
        var sales = [];
        if (startDate && endDate) for (var i = 0; i < this.indexSales.length; i++) {
            if (!this.indexSales[i].isDeleted && this.indexSales[i].timeCreated.getTime() >= startDate && this.indexSales[i].timeCreated.getTime() <= endDate) sales.push(this.indexSales[i]);
        }return sales;
    };
    saleData.getListByStatus = function (status) {
        var sales = [];
        if (status) for (var i = 0; i < this.indexSales.length; i++) {
            if (!this.indexSales[i].isDeleted && this.indexSales[i].status == status) sales.push(this.indexSales[i]);
        }return sales;
    };
    saleData.getOnlineListByStatus = function (status) {
        var sales = [];
        if (status) for (var i = 0; i < this.indexSales.length; i++) {
            if (!this.indexSales[i].isDeleted && this.indexSales[i].status == status && this.indexSales[i].isCreatedByCustomer) sales.push(this.indexSales[i]);
        }return sales;
    };
    saleData.getOnlineListByStatusAndDelivery = function (status, delivery) {
        var sales = [];
        if (status) for (var i = 0; i < this.indexSales.length; i++) {
            if (!this.indexSales[i].isDeleted && this.indexSales[i].delivery == delivery && this.indexSales[i].isCreatedByCustomer && this.indexSales[i].status == status) sales.push(this.indexSales[i]);
        }return sales;
    };

    saleData.add = function (sale, isApplicationLoading) {
        if (isApplicationLoading) {
            if (sale && sale.id) this.objSales[sale.id] = sale;
        } else {
            //to do add always sorted
            this.indexSales.push(sale);
        }
    };

    saleData.clear = function () {
        saleData.indexSales = [];
        saleData.objSales = {};
    };

    saleData.convertMapToArray = function (keepObject, isNewLoading) {
        if (isNewLoading) {
            this.indexSales = ModelDataUtil.convertObjectToArray(this.objSales, this.indexSales);
            if (!keepObject) {
                this.objSales = {};
            }
        } else {
            this.indexSales = ModelDataUtil.convertMapToArray(this.objSales, this.indexSales);
            this.objSales = null;
        }
    };

    return saleData;
}]);

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('SaleAdvance_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/sale-advances', {}, {
        retrieveAll: { method: 'GET', isArray: true }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('SaleAdvance', ["Payment", "Site", "CustomerData", "HumanResourceData", "DayData", "SaleService", "SaleProduct", "SaleCure", "GiftItem", "LoyaltyCardItem", "LoyaltyCardItemData", function (Payment, Site, CustomerData, HumanResourceData, DayData, SaleService, SaleProduct, SaleCure, GiftItem, LoyaltyCardItem, LoyaltyCardItemData) {
    var SaleAdvance = function SaleAdvance(saleAdvanceRes) {
        this.id = null;
        this.status = "advance";
        this.timeCreated = null;
        this.timeModified = null;
        this.customerId = null;
        this.customer = null;
        this.dayId = null;
        this.day = null;
        this.estimationNumber = null;
        this.advanceNumber = null;
        this.hrSellerId = null;
        this.hrSeller = null;
        this.hrOp = null;
        this.hrOpId = null;
        this.site = null;
        this.siteV = null;
        this.softV = null;
        this.signature = null;
        this.pSignature = null;
        this.signatureCode = null;
        this.dsignatureCode = null;
        this.vat = null;
        this.vatCode = null;
        this.servicesPrice = null;
        this.productsPrice = null;
        this.curesPrice = null;
        this.giftItemsPrice = null;
        this.loyaltyCardsPrice = null;
        this.price = null;
        this.priceHT = null;
        this.priceTurnover = null;
        this.priceTurnoverHT = null;
        this.vatPrice = null;
        this.oExt = null;
        this.discountPercent = null;
        this.isCreatedByCustomer = false;
        this.nbPrint = null;
        this.loyaltyCardItemId = null;
        this.loyaltyCardItem = null;
        this.loyaltyPts = null;
        this.totalLoyaltyPts = null;
        this.hasLoyaltyDiscount = null;
        this.loyaltyDate = null;
        this.companyName = null;
        this.payments = [];
        this.saleServices = [];
        this.saleProducts = [];
        this.saleCures = [];
        this.giftItems = [];
        this.loyaltyCardItems = [];
        this.advancePrice = 0;
        this.realPaidPrice = 0;
        this.customerLastname = null;
        this.customerFirstname = null;
        this.customerAddress = null;
        this.customerZip = null;
        this.customerCity = null;
        this.shareCapital = null;
        this.greffeCity = null;
        this.juridicForm = null;

        if (saleAdvanceRes !== undefined && saleAdvanceRes != null) {
            this.loadObjectProperties(saleAdvanceRes);
            this.loadObjectSaleServices(saleAdvanceRes);
            this.loadObjectSaleProducts(saleAdvanceRes);
            this.loadObjectSaleCures(saleAdvanceRes);
            this.loadObjectGiftItems(saleAdvanceRes);
            this.loadObjectLoyaltyCardItems(saleAdvanceRes);
        }
    };

    SaleAdvance.prototype.loadObjectProperties = function (saleAdvanceRes) {
        if (saleAdvanceRes) {
            this.id = saleAdvanceRes.id;
            this.timeCreated = saleAdvanceRes.timeCreated;
            this.timeModified = saleAdvanceRes.timeModified;
            this.customerId = saleAdvanceRes.customerId;
            if (saleAdvanceRes.customerId !== undefined) {
                this.customer = CustomerData.getById(this.customerId);
            }
            this.dayId = saleAdvanceRes.dayId;
            if (saleAdvanceRes.dayId !== undefined) {
                this.day = DayData.getById(this.dayId);
            }
            this.estimationNumber = saleAdvanceRes.estimationNumber;
            this.advanceNumber = saleAdvanceRes.advanceNumber;
            this.hrSellerId = saleAdvanceRes.hrSellerId;
            if (saleAdvanceRes.hrSellerId !== undefined) {
                this.hrSeller = HumanResourceData.getById(saleAdvanceRes.hrSellerId);
            }
            if (saleAdvanceRes.hrOpId !== undefined) {
                this.hrOp = HumanResourceData.getById(saleAdvanceRes.hrOpId);
            }
            if (saleAdvanceRes.site) {
                this.site = new Site(saleAdvanceRes.site);
            }
            this.siteV = saleAdvanceRes.siteV;
            this.softV = saleAdvanceRes.softV;
            this.signature = saleAdvanceRes.signature;
            this.pSignature = saleAdvanceRes.pSignature;
            this.signatureCode = saleAdvanceRes.signatureCode;
            this.dsignatureCode = saleAdvanceRes.dsignatureCode;
            this.vat = saleAdvanceRes.vat;
            this.vatCode = saleAdvanceRes.vatCode;
            this.servicesPrice = saleAdvanceRes.servicesPrice;
            this.productsPrice = saleAdvanceRes.productsPrice;
            this.curesPrice = saleAdvanceRes.curesPrice;
            this.giftItemsPrice = saleAdvanceRes.giftItemsPrice;
            this.loyaltyCardsPrice = saleAdvanceRes.loyaltyCardsPrice;
            this.price = saleAdvanceRes.price;
            this.priceHT = saleAdvanceRes.priceHT;
            this.priceTurnover = saleAdvanceRes.priceTurnover;
            this.priceTurnoverHT = saleAdvanceRes.priceTurnoverHT;
            this.vatPrice = saleAdvanceRes.vatPrice;
            this.advancePrice = saleAdvanceRes.advancePrice;
            this.oExt = saleAdvanceRes.oExt;
            this.discountPercent = saleAdvanceRes.discountPercent;
            this.isCreatedByCustomer = saleAdvanceRes.isCreatedByCustomer;
            this.nbPrint = saleAdvanceRes.nbPrint;
            this.loyaltyCardItemId = saleAdvanceRes.loyaltyCardItemId;
            if (saleAdvanceRes.loyaltyCardItemId !== undefined) {
                this.loyaltyCardItem = LoyaltyCardItemData.getById(saleAdvanceRes.loyaltyCardItemId);
            }
            this.loyaltyPts = saleAdvanceRes.loyaltyPts;
            this.totalLoyaltyPts = saleAdvanceRes.totalLoyaltyPts;
            this.hasLoyaltyDiscount = saleAdvanceRes.hasLoyaltyDiscount;
            this.loyaltyDate = saleAdvanceRes.loyaltyDate;
            this.companyName = saleAdvanceRes.companyName;
            this.payments = [];
            if (saleAdvanceRes.payments) {
                for (var i = 0; i < saleAdvanceRes.payments.length; i++) {
                    this.payments.push(new Payment(saleAdvanceRes.payments[i]));
                }
            }
            for (var _i = 0; _i < this.payments.length; _i++) {
                if (this.payments[_i].type !== "UNPAID" && this.payments[_i].type !== "GIFT") {
                    this.realPaidPrice += this.payments[_i].price;
                }
            }
            this.customerLastname = saleAdvanceRes.customerLastname;
            this.customerFirstname = saleAdvanceRes.customerFirstname;
            this.customerAddress = saleAdvanceRes.customerAddress;
            this.customerZip = saleAdvanceRes.customerZip;
            this.customerCity = saleAdvanceRes.customerCity;
            this.shareCapital = saleAdvanceRes.shareCapital;
            this.greffeCity = saleAdvanceRes.greffeCity;
            this.juridicForm = saleAdvanceRes.juridicForm;
        }
    };

    SaleAdvance.prototype.loadObjectSaleServices = function (object) {
        if (object.saleServices) {
            this.saleServices = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = object.saleServices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var oneSaleService = _step.value;

                    if (!oneSaleService.saleId || oneSaleService.saleId === this.id) {
                        var saleService = new SaleService(oneSaleService, true);
                        saleService.sale = this;
                        this.saleServices.push(saleService);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };

    SaleAdvance.prototype.loadObjectSaleProducts = function (object) {
        if (object.saleProducts) {
            this.saleProducts = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = object.saleProducts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var oneSaleProduct = _step2.value;

                    if (!oneSaleProduct.saleId || oneSaleProduct.saleId === this.id) {
                        var saleProduct = new SaleProduct(oneSaleProduct, true);
                        saleProduct.sale = this;
                        this.saleProducts.push(saleProduct);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    };

    SaleAdvance.prototype.loadObjectSaleCures = function (object) {
        if (object.saleCures) {
            this.saleCures = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = object.saleCures[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var oneSaleCure = _step3.value;

                    if (!oneSaleCure.saleId || oneSaleCure.saleId === this.id) {
                        var saleCure = new SaleCure(oneSaleCure, true);
                        saleCure.sale = this;
                        this.saleCures.push(saleCure);
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    };

    SaleAdvance.prototype.loadObjectGiftItems = function (object) {
        if (object.giftItems) {
            this.giftItems = [];
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = object.giftItems[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var oneGiftItem = _step4.value;

                    if (!oneGiftItem.saleId || oneGiftItem.saleId === this.id) {
                        var giftItem = new GiftItem(oneGiftItem, true);
                        giftItem.loadRef(true);
                        giftItem.sale = this;
                        this.giftItems.push(giftItem);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    };

    SaleAdvance.prototype.loadObjectLoyaltyCardItems = function (object) {
        if (object.loyaltyCardItems) {
            this.loyaltyCardItems = [];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = object.loyaltyCardItems[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var oneLoyaltyCardItem = _step5.value;

                    if (!oneLoyaltyCardItem.saleId || oneLoyaltyCardItem.saleId === this.id) {
                        var loyaltyCardItem = new LoyaltyCardItem(oneLoyaltyCardItem, true);
                        loyaltyCardItem.sale = this;
                        this.loyaltyCardItems.push(loyaltyCardItem);
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }
    };

    SaleAdvance.prototype.getAllItemsPrice = function () {
        var allItemPrice = 0;
        for (var i = 0; i < this.saleServices.length; i++) {
            allItemPrice += this.saleServices[i].price;
        }
        for (var _i2 = 0; _i2 < this.saleProducts.length; _i2++) {
            allItemPrice += this.saleProducts[_i2].price;
        }
        for (var _i3 = 0; _i3 < this.saleCures.length; _i3++) {
            allItemPrice += this.saleCures[_i3].price;
        }
        for (var _i4 = 0; _i4 < this.giftItems.length; _i4++) {
            allItemPrice += this.giftItems[_i4].price;
        }
        for (var _i5 = 0; _i5 < this.loyaltyCardItems.length; _i5++) {
            allItemPrice += this.loyaltyCardItems[_i5].price;
        }
        return allItemPrice;
    };

    return SaleAdvance;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleAdvanceSrv', ['SaleAdvance_Resource', function (SaleAdvance_Resource) {
    var saleAdvanceSrv = {};

    saleAdvanceSrv.retrieveAll = function () {
        return SaleAdvance_Resource.retrieveAll().$promise;
    };

    return saleAdvanceSrv;
}]);

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('SaleCure_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceSaleS = $resource(baseUrl + 'rest/saleCures/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceSaleS;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleCure', ["SaleCure_Resource", "CureCategoryData", "CureData", "SaleCureData", "HumanResourceData", "CureItem", "TaxMode", "SaleItem", "CureCategory", "Cure", function (SaleCure_Resource, CureCategoryData, CureData, SaleCureData, HumanResourceData, CureItem, TaxMode, SaleItem, CureCategory, Cure) {
    //SaleCure inherit from Activity
    var SaleCure = function SaleCure(saleCureRes, mustloadElements, isPreviousVersion) {
        SaleItem.call(this);

        //mustloadElements : boolean
        //isPreviousVersion : boolean (if the instance is a previous version -> do not add to active objects)
        this.id = null;
        this.label = null;
        this.price = 0;
        this.vat = null;
        this.vatCode = null;
        this.quantity = 0;
        this.originalPrice = 0;
        this.discountPercent = 0;
        this.cure = null;
        this.sale = null;
        this.humanResource;
        this.cureItems = [];
        this.version = null;

        this.loadObjectProperties(saleCureRes);
        if (mustloadElements) this.loadObjectCureItems(saleCureRes);
        this.loadRef();
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            SaleCureData.add(this);
    };

    SaleCure.prototype = Object.create(SaleItem.prototype); //inherit functions from SaleItem

    SaleCure.prototype.loadObjectProperties = function (object) {

        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.label = object.label;
            this.price = object.price;
            this.vat = object.vat;
            this.vatCode = object.vatCode;
            if (object.originalPrice !== undefined && object.originalPrice) this.originalPrice = object.originalPrice;else this.originalPrice = object.price;
            this.discountPercent = object.discountPercent;
            this.quantity = object.quantity;
            this.cureId = object.cureId;
            if (object.humanResourceId) this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.version) this.version = object.version;
        }
    };

    SaleCure.prototype.loadObjectCureItems = function (object) {

        if (object !== undefined && object != null) {
            this.cureItems = [];
            if (object.cureItems) for (var i = 0; i < object.cureItems.length; i++) {
                this.cureItems.push(new CureItem(object.cureItems[i], this, true));
            }
        }
    };

    SaleCure.prototype.loadRef = function () {
        if (this.cureId) this.cure = CureData.getById(this.cureId);
    };

    SaleCure.prototype.copyDataTo = function (object) {

        object.id = this.id;
        object.label = this.label;
        object.price = this.price;
        object.vat = this.vat;
        object.vatCode = this.vatCode;
        object.originalPrice = this.originalPrice;
        object.discountPercent = this.discountPercent;
        object.quantity = this.quantity;
        if (this.humanResource) object.humanResourceId = this.humanResource.id;

        if (this.cure) object.cureId = this.cure.id;else object.cureId = null;

        if (this.sale) object.saleId = this.sale.id;else object.saleId = null;
        object.cureItems = [];
        if (this.cureItems) for (var i = 0; i < this.cureItems.length; i++) {
            object.cureItems.push(this.cureItems[i].getObjectResource());
        }
    };

    SaleCure.prototype.getObjectResource = function () {
        var saleCureRes = new SaleCure_Resource();
        this.copyDataTo(saleCureRes);
        return saleCureRes;
    };

    SaleCure.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };

    SaleCure.prototype.setId = function (id) {
        this.id = id;
    };

    SaleCure.prototype.getId = function () {
        return this.id;
    };

    SaleCure.prototype.getLabel = function () {
        return this.label;
    };

    SaleCure.prototype.getPrice = function () {
        return this.price;
    };

    SaleCure.prototype.addCureItem = function (cureItem) {
        if (cureItem) {
            var index = this.cureItems.indexOf(cureItem);
            if (index == -1) this.cureItems.push(cureItem);
            cureItem.saleCure = this;
        }
    };

    SaleCure.prototype.removeCureItem = function (cureItem) {
        if (cureItem != null) {
            var index = this.cureItems.indexOf(cureItem);
            if (index != -1) this.cureItems.splice(index, 1);
            cureItem.saleCure = null;
        }
    };

    SaleCure.prototype.getCure = function () {
        return this.cure;
    };

    SaleCure.prototype.getItem = function () {
        return this.cure;
    };

    SaleCure.prototype.getItemCategoryType = function () {
        return CureCategory;
    };

    SaleCure.prototype.getItemType = function () {
        return Cure;
    };

    SaleCure.prototype.getDiscountPrice = function (taxMode) {
        var price = 0;
        if (this.sale.isStatusSoldOrCreditOrCanceled()) {
            price = this.price;
            //apply global discount on price
            if (this.sale.discountPercent != 0) {
                price -= this.sale.discountPercent * price / 100;
            }

            if (taxMode === TaxMode.HT) {
                var vat = this.vat ? this.vat : this.sale.vat;
                price = price / (100 + vat) * 100;
            }
        }

        return price;
    };

    /**
     * @override SaleItem.prototype.getQuantity
     */
    SaleCure.prototype.getQuantity = function () {
        return this.quantity;
    };

    return SaleCure;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleCureSrv', ["$log", "ServerSrv", "DayData", "SaleCureData", "SaleCure", "ActivitySrv", "SaleData", function ($log, ServerSrv, DayData, SaleCureData, SaleCure, ActivitySrv, SaleData) {
    var bpSrv = {};

    bpSrv.save = function (saleCure, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bpSrv.saveSync, saleCure, successFunction, errorFunction);
    };
    bpSrv.saveSync = function (saleCure, successFunction, errorFunction) {

        var bsRes = saleCure.getObjectResource();
        bsRes.$save({}, //no params
        function (data) {
            try {
                // now we can set the id
                saleCure.setId(data.id);
                if (!saleCure.version || data.version && data.version > saleCure.version) saleCure.version = data.version;
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    bpSrv.updateLocally = function (id, resource) {
        var saleCure = SaleCureData.getById(id);

        if (saleCure && saleCure.version && resource.version && resource.version < saleCure.version) return null;

        if (saleCure != null) {
            saleCure.loadObjectProperties(resource);
            saleCure.id = id;
            saleCure.loadRef();
            //remove from sale
            if (saleCure.sale) saleCure.sale.removeSaleCure(saleCure);
            if (resource.saleId) {
                var sale = SaleData.getById(resource.saleId);
                if (sale) sale.addSaleCure(saleCure);
            }
        }

        return saleCure;
    };
    bpSrv.removeLocally = function (id, resource) {
        var saleCure = SaleCureData.getById(id);
        if (saleCure && saleCure.version && resource.version && resource.version < saleCure.version) return null;
        if (saleCure != null) {
            //remove from sale
            if (saleCure.sale) saleCure.sale.removeSaleCure(saleCure);
        }
        return saleCure;
    };
    bpSrv.addLocally = function (id, resource) {
        var saleCure = SaleCureData.getById(id);
        if (saleCure && saleCure.version && resource.version && resource.version < saleCure.version) return null;
        if (saleCure != null) //check if resource already exist inside index (current action could be a 'cancel')
            saleCure.loadObjectProperties(resource);else {
            saleCure = new SaleCure(resource, null, false);
        }
        saleCure.id = id;
        //add to sale
        if (resource.saleId) {
            var sale = SaleData.getById(resource.saleId);
            if (sale) sale.addSaleCure(saleCure);
        }

        return saleCure;
    };
    bpSrv.getPreviousVersionInstance = function (resource) {
        var saleCure = new SaleCure(resource, true);
        if (resource.saleId) saleCure.sale = SaleData.getById(resource.saleId);
        return saleCure;
    };

    return bpSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleCureData', ["$log", function ($log) {
    var saleCureData = {
        indexSaleCures: []
    };
    saleCureData.getById = function (saleCureId) {
        for (var i = 0; i < this.indexSaleCures.length; i++) {
            if (this.indexSaleCures[i].id == saleCureId) return this.indexSaleCures[i];
        }return null;
    };
    saleCureData.getIndexOf = function (saleCure) {
        if (saleCure) return this.indexSaleCures.indexOf(saleCure);
        return -1;
    };
    saleCureData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexSaleCures.length) return this.indexSaleCures[index];else return null;
    };
    saleCureData.add = function (saleCure) {
        this.indexSaleCures.push(saleCure);
        return this.indexSaleCures.length - 1;
    };
    saleCureData.clear = function () {
        saleCureData.indexSaleCures = [];
    };

    return saleCureData;
}]);

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('SaleItem', ["HumanResource", "RootStatCategorie", "HrRootCategory", "NbCustormerCategoryStat", "TypeOfCustomerRootCategory", "TypeOfCustomer", "HrRootOccupationRateCategory", "HumanResourceExtra", "HumanResourceData", function (HumanResource, RootStatCategorie, HrRootCategory, NbCustormerCategoryStat, TypeOfCustomerRootCategory, TypeOfCustomer, HrRootOccupationRateCategory, HumanResourceExtra, HumanResourceData) {
    var SaleItem = function SaleItem() {};

    SaleItem.prototype.matchSpecificMatchingOfItem = function () {
        return false;
    };

    SaleItem.prototype.matchSaleItemMatching = function (saleObject, firstDayOfPeriod, currentDay) {
        var matchCommonMatching = false;
        if (saleObject instanceof HumanResource && this.humanResource === saleObject || saleObject === HumanResourceExtra && (this.humanResource === null || this.humanResource && HumanResourceData.getActiveList().indexOf(this.humanResource) === -1) || saleObject === TypeOfCustomerRootCategory || saleObject === TypeOfCustomer.OLD_CUSTOMER && this.getSale().customer && (this.getSale().customer.hasSaleBefore(firstDayOfPeriod) || this.getSale().customer.hasBookingBefore(firstDayOfPeriod, this.getSale())) || saleObject === TypeOfCustomer.NEW_CUSTOMER && (!this.getSale().customer || !this.getSale().customer.hasSaleBefore(currentDay) && !this.getSale().customer.hasBookingBefore(currentDay, this.getSale()) && (this.getSale().booking && this.getSale().booking.day.id >= firstDayOfPeriod.id || !this.getSale().booking)) || saleObject === HrRootOccupationRateCategory) {
            matchCommonMatching = true;
        }
        return matchCommonMatching;
    };

    SaleItem.prototype.getParentItem = function () {
        return null;
    };

    SaleItem.prototype.matchSaleTreeMatching = function (saleObject) {
        var matchCommonMatching = false,
            item = this.getItem(),
            parentItem = this.getParentItem();
        if (saleObject instanceof this.getItemCategoryType() && item && item.isDescendantOf(saleObject, parentItem) || saleObject instanceof this.getItemType() && item && (item === saleObject || saleObject.isPackage && saleObject.subServices && saleObject.subServices.indexOf(item) !== -1 || parentItem && parentItem === saleObject) || saleObject === RootStatCategorie || saleObject === HrRootCategory || saleObject === NbCustormerCategoryStat || saleObject === NbCustormerCategoryStat.subCategories.MEN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'M' || saleObject === NbCustormerCategoryStat.subCategories.WOMEN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'W' || saleObject === NbCustormerCategoryStat.subCategories.CHILDREN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'C' || saleObject === NbCustormerCategoryStat.subCategories.UNDEFINED_VISITS && this.getSale().customer && this.getSale().customer.gender === null || saleObject === NbCustormerCategoryStat.subCategories.PASSENGER_VISITS && !this.getSale().customer) {
            matchCommonMatching = true;
        }
        return matchCommonMatching;
    };

    SaleItem.prototype.isSaleWithTree = function () {
        return true;
    };

    SaleItem.prototype.getQuantity = function () {
        return 1;
    };

    SaleItem.prototype.getStatQuantity = function () {
        return this.getQuantity() * (this.getSale().status === 'credit' ? -1 : 1);
    };

    SaleItem.prototype.getDuration = function () {
        return 0;
    };

    SaleItem.prototype.getStatDuration = function () {
        return this.getDuration() * (this.getSale().status === 'credit' ? -1 : 1);
    };

    SaleItem.prototype.matchAllSaleObjects = function (saleObjects, additionalFilters, firstDayOfPeriod, currentDay) {
        var matchAllSaleObject = true;

        for (var k = 0; k < saleObjects.length; k++) {
            var saleObject = saleObjects[k],
                matchSaleObject = false;

            if (this.isSaleWithTree() && this.matchSaleTreeMatching(saleObject) || this.matchSaleItemMatching(saleObject, firstDayOfPeriod, currentDay) || this.matchSpecificMatchingOfItem(saleObject)) {
                matchSaleObject = true;
            }
            matchAllSaleObject = matchAllSaleObject && matchSaleObject;
        }

        var matchOneAdditionalFilter = false;

        for (var _k = 0; _k < additionalFilters.length; _k++) {
            var additionalFilter = additionalFilters[_k],
                matchAdditionalFilter = false;

            if (additionalFilter === NbCustormerCategoryStat.subCategories.MEN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'M' || additionalFilter === NbCustormerCategoryStat.subCategories.WOMEN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'W' || additionalFilter === NbCustormerCategoryStat.subCategories.CHILDREN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'C' || additionalFilter instanceof HumanResource && this.humanResource === additionalFilter) {

                matchAdditionalFilter = true;
            }
            matchOneAdditionalFilter = matchOneAdditionalFilter || matchAdditionalFilter;
        }

        return matchAllSaleObject && (matchOneAdditionalFilter || additionalFilters.length === 0);
    };

    SaleItem.prototype.getSale = function () {
        return this.sale;
    };

    SaleItem.prototype.incrementSalesDatasForSubSales = function (salesData, firstDayOfPeriod, lastDayOfPeriod) {
        salesData.subSales.push(this);
        salesData.qteSubSales += this.getStatQuantity();
        salesData.subSalesWithoutBooking.push(this);
        salesData.qteSubSalesWithoutBooking += this.getStatQuantity();
    };

    SaleItem.prototype.incrementSalesDatasForOldAndNewCustomer = function (salesData, firstDayOfPeriod) {
        if (this.getSale().customer && (this.getSale().customer.hasSaleBefore(firstDayOfPeriod) || this.getSale().customer.hasBookingBefore(firstDayOfPeriod))) {
            if (salesData.subSalesOldCustomer.indexOf(this) === -1) {
                salesData.subSalesOldCustomer.push(this);
                salesData.qteSubSalesOldCustomer += this.getStatQuantity();
            }

            if (salesData.salesOldCustomer.indexOf(this.getSale()) === -1) {
                salesData.salesOldCustomer.push(this.getSale());
            }
        } else {
            if (salesData.subSalesNewCustomer.indexOf(this) === -1) {
                salesData.subSalesNewCustomer.push(this);
                salesData.qteSubSalesNewCustomer += this.getStatQuantity();
            }

            if (salesData.salesNewCustomer.indexOf(this.getSale()) === -1) {
                salesData.salesNewCustomer.push(this.getSale());
            }
        }
    };

    SaleItem.prototype.incrementSalesDatas = function (salesData, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, currentDay) {
        if (this.matchAllSaleObjects(saleObjects, additionalFilters, firstDayOfPeriod, currentDay)) {

            for (var k = 0; k < saleObjects.length; k++) {
                var saleObject = saleObjects[k];

                if (saleObject instanceof HumanResource) {
                    salesData.humanResource = saleObject;
                    break;
                }
            }
            salesData.price += this.getDiscountPrice(taxMode);
            salesData.duration += this.getStatDuration();
            salesData.subSalesStep.push(this);

            this.incrementSalesDatasForSubSales(salesData, firstDayOfPeriod, lastDayOfPeriod);

            if (salesData.sales.indexOf(this.getSale()) === -1 && !this.getSale().isCancelledOrCredit()) {
                salesData.sales.push(this.getSale());
                salesData.qteSales += 1;
                if (this.getSale().status === "sold" && (this.getSale().saleProducts.length > 0 || this.getSale().saleServices.length > 0 || this.getSale().saleCures.length > 0 || this.getSale().loyaltyCardItems.length > 0)) {
                    salesData.qteSalesSold += 1;
                }

                if (!this.getSale().booking) {
                    salesData.salesWithoutBooking.push(this.getSale());
                }

                if (this.getSale().booking && this.getSale().booking.day && firstDayOfPeriod && lastDayOfPeriod && (this.getSale().booking.day.id < firstDayOfPeriod.id || this.getSale().booking.day.id > lastDayOfPeriod.id)) {
                    salesData.salesWithBookingOutOfPeriod.push(this.getSale());
                }
            }

            if (firstDayOfPeriod) {
                this.incrementSalesDatasForOldAndNewCustomer(salesData, firstDayOfPeriod);

                if (this.getSale().customer) {
                    var salesOfPeriod = this.getSale().customer.getLoyaltySalesOfPeriod(firstDayOfPeriod, currentDay, salesData.humanResource ? salesData.humanResource.id : null),
                        bookingsOfPeriod = this.getSale().customer.getLoyaltyBookingsOfPeriod(firstDayOfPeriod, currentDay, salesData.humanResource ? salesData.humanResource.id : null);

                    if (salesOfPeriod.length > 0 || bookingsOfPeriod.length > 0) {
                        if (salesData.loyaltyCustormers.indexOf(this.getSale().customer) === -1) {
                            salesData.loyaltyCustormers.push(this.getSale().customer);
                        }
                    } else if (salesData.customersFirstVisit.indexOf(this.getSale().customer) === -1 && !this.getSale().isCancelledOrCredit()) {
                        salesData.customersFirstVisit.push(this.getSale().customer);
                    }
                }
            }

            if (this.getSale().customer) {
                if (salesData.customers.indexOf(this.getSale().customer) === -1 && !this.getSale().isCancelledOrCredit()) {
                    salesData.customers.push(this.getSale().customer);
                    salesData.nbCustomers += 1;
                }

                //check the condition (difference beetween service and other items?)
                if (!this.getSale().isCancelledOrCredit() && (!this.getSale().booking || this.getSale().booking && this.getSale().booking.status !== 'notCame' && this.getSale().booking.day && this.getSale().day && firstDayOfPeriod && (this.getSale().booking.day.id >= this.getSale().day.id || this.getSale().booking.day.id < firstDayOfPeriod.id))) {
                    if (salesData.customersSales.indexOf(this.getSale().customer) === -1) {
                        salesData.customersSales.push(this.getSale().customer);
                    }

                    if (salesData.customersFirstSales.indexOf(this.getSale().customer) === -1 && !this.getSale().customer.hasSaleBetween(firstDayOfPeriod, currentDay) && !this.getSale().customer.hasBookingBetween(firstDayOfPeriod, currentDay, this.getSale())) {
                        salesData.customersFirstSales.push(this.getSale().customer);
                    }
                    if (salesData.customersFirstSalesOfSaleObject.indexOf(this.getSale().customer) === -1 && !this.getSale().customer.hasSaleBetween(firstDayOfPeriod, currentDay, null, saleObjects, additionalFilters, currentDay) && !this.getSale().customer.hasBookingBetween(firstDayOfPeriod, currentDay, this.getSale(), saleObjects, additionalFilters)) {
                        salesData.customersFirstSalesOfSaleObject.push(this.getSale().customer);
                    }
                }
            } else if (salesData.matchedSalesOfPassageCustomer.indexOf(this.getSale()) === -1) {
                salesData.matchedSalesOfPassageCustomer.push(this.getSale());
            }
        }
    };

    return SaleItem;
}]);

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('SaleProduct_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceSaleS = $resource(baseUrl + 'rest/saleProducts/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceSaleS;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleProduct', ["SaleProduct_Resource", "ProductCategoryData", "ProductData", "SaleProductData", "HumanResourceData", "TaxMode", "SaleItem", "ProductCategory", "Product", "TypeOfSale", "ProductStatCategorie", "ZeroPercentTvaDateCorrection", function (SaleProduct_Resource, ProductCategoryData, ProductData, SaleProductData, HumanResourceData, TaxMode, SaleItem, ProductCategory, Product, TypeOfSale, ProductStatCategorie, ZeroPercentTvaDateCorrection) {
    //SaleProduct inherit from Activity
    var SaleProduct = function SaleProduct(saleProductRes, isPreviousVersion) {
        SaleItem.call(this);

        this.id = null;
        this.label = null;
        this.price = 0;
        this.vat = null;
        this.vatCode = null;
        this.quantity = 0;
        this.originalPrice = 0;
        this.discountPercent = 0;
        this.product = null;
        this.sale = null;
        this.humanResource;
        this.version = null;
        this.loadObject(saleProductRes);
        this.loadRef();
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            SaleProductData.add(this);
    };

    SaleProduct.prototype = Object.create(SaleItem.prototype); //inherit functions from SaleItem

    SaleProduct.prototype.loadObject = function (object) {

        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.label = object.label;
            this.price = object.price;
            this.vat = object.vat;
            this.vatCode = object.vatCode;
            if (object.originalPrice !== undefined && object.originalPrice) this.originalPrice = object.originalPrice;else this.originalPrice = object.price;
            this.discountPercent = object.discountPercent;
            this.quantity = object.quantity;
            this.productId = object.productId;
            if (object.humanResourceId) this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.version) this.version = object.version;
        }
    };
    SaleProduct.prototype.loadRef = function () {
        if (this.productId) this.product = ProductData.getById(this.productId);
    };
    SaleProduct.prototype.copyDataTo = function (object) {

        object.id = this.id;
        object.label = this.label;
        object.price = this.price;
        object.vat = this.vat;
        object.vatCode = this.vatCode;
        object.originalPrice = this.originalPrice;
        object.discountPercent = this.discountPercent;
        object.quantity = this.quantity;
        if (this.humanResource) object.humanResourceId = this.humanResource.id;

        if (this.product) object.productId = this.product.id;else object.productId = null;

        if (this.sale) object.saleId = this.sale.id;else object.saleId = null;
    };
    SaleProduct.prototype.getObjectResource = function () {
        var saleProductRes = new SaleProduct_Resource();
        this.copyDataTo(saleProductRes);
        return saleProductRes;
    };
    SaleProduct.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };
    SaleProduct.prototype.setId = function (id) {
        this.id = id;
    };
    SaleProduct.prototype.getId = function () {
        return this.id;
    };
    SaleProduct.prototype.getLabel = function () {
        return this.label;
    };
    SaleProduct.prototype.getPrice = function () {
        return this.price;
    };
    SaleProduct.prototype.getProduct = function () {
        return this.product;
    };
    SaleProduct.prototype.getItem = function () {
        return this.product;
    };
    SaleProduct.prototype.getItemCategoryType = function () {
        return ProductCategory;
    };
    SaleProduct.prototype.getItemType = function () {
        return Product;
    };
    SaleProduct.prototype.getDiscountPrice = function (taxMode) {
        var price = 0;
        if (this.sale.isStatusSoldOrCreditOrCanceled()) {
            price = this.price;
            //apply global discount on price
            if (this.sale.discountPercent !== 0) {
                price -= this.sale.discountPercent * price / 100;
            }

            if (taxMode === TaxMode.HT) {
                var vat = void 0,
                    day = this.sale.day.getDate();
                //TODO the constant ZeroPercentTvaDateCorrection is deprecated, This is a temporary solution to not impact the history
                if (this.vat == null && !ZeroPercentTvaDateCorrection.isBeforeCorrection(day) || !this.vat && ZeroPercentTvaDateCorrection.isBeforeCorrection(day)) {
                    vat = this.sale.vat;
                } else {
                    vat = this.vat;
                }
                price = price / (100 + vat) * 100;
            }
        }
        return price;
    };

    /**
     * @override SaleItem.prototype.matchSpecificMatchingOfItem
     */
    SaleProduct.prototype.matchSpecificMatchingOfItem = function (saleObject) {
        var matchSpecificMatchingOfItem = false;
        if (saleObject === ProductStatCategorie || saleObject === ProductStatCategorie.ALL || saleObject === TypeOfSale.ALL_WITH_PRODUCT_OR_NOT && this.getSale().saleServices.length > 0 || saleObject === TypeOfSale.SERVICE_AND_PRODUCT && this.getSale().saleServices.length > 0) {
            matchSpecificMatchingOfItem = true;
        }
        return matchSpecificMatchingOfItem;
    };

    /**
     * @override SaleItem.prototype.getQuantity
     */
    SaleProduct.prototype.getQuantity = function () {
        return this.quantity;
    };

    return SaleProduct;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleProductSrv', ["$log", "ServerSrv", "DayData", "SaleProductData", "SaleProduct", "ActivitySrv", "SaleData", function ($log, ServerSrv, DayData, SaleProductData, SaleProduct, ActivitySrv, SaleData) {
    var bpSrv = {};

    bpSrv.save = function (saleProduct, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bpSrv.saveSync, saleProduct, successFunction, errorFunction);
    };
    bpSrv.saveSync = function (saleProduct, successFunction, errorFunction) {
        var bsRes = saleProduct.getObjectResource();
        bsRes.$save({}, //no params
        function (data) {
            try {
                // now we can set the id
                saleProduct.setId(data.id);
                if (!saleProduct.version || data.version && data.version > saleProduct.version) saleProduct.version = data.version;
                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    bpSrv.updateLocally = function (id, resource) {
        var saleProduct = SaleProductData.getById(id);

        if (saleProduct && saleProduct.version && resource.version && resource.version < saleProduct.version) return null;

        if (saleProduct != null) {
            saleProduct.loadObject(resource);
            saleProduct.id = id;
            //remove from sale
            if (saleProduct.sale) saleProduct.sale.removeSaleProduct(saleProduct);
            if (resource.saleId) {
                var sale = SaleData.getById(resource.saleId);
                if (sale) sale.addSaleProduct(saleProduct);
            }
        }

        return saleProduct;
    };
    bpSrv.removeLocally = function (id, resource) {
        var saleProduct = SaleProductData.getById(id);
        if (saleProduct && saleProduct.version && resource.version && resource.version < saleProduct.version) return null;
        if (saleProduct != null) {
            //remove from sale
            if (saleProduct.sale) saleProduct.sale.removeSaleProduct(saleProduct);
        }
        return saleProduct;
    };
    bpSrv.addLocally = function (id, resource) {
        var saleProduct = SaleProductData.getById(id);
        if (saleProduct && saleProduct.version && resource.version && resource.version < saleProduct.version) return null;

        if (saleProduct != null) //check if resource already exist inside index (current action could be a 'cancel')
            saleProduct.loadObject(resource);else {
            saleProduct = new SaleProduct(resource);
        }
        saleProduct.id = id;
        //add to sale
        if (resource.saleId) {
            var sale = SaleData.getById(resource.saleId);
            if (sale) sale.addSaleProduct(saleProduct);
        }

        return saleProduct;
    };
    bpSrv.getPreviousVersionInstance = function (resource) {
        var saleProduct = new SaleProduct(resource, true);
        if (resource.saleId) saleProduct.sale = SaleData.getById(resource.saleId);
        return saleProduct;
    };

    return bpSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleProductData', ["$log", function ($log) {
    var saleProductData = {
        indexSaleProducts: []
    };
    saleProductData.getById = function (saleProductId) {
        for (var i = 0; i < this.indexSaleProducts.length; i++) {
            if (this.indexSaleProducts[i].id == saleProductId) return this.indexSaleProducts[i];
        }return null;
    };
    saleProductData.getIndexOf = function (saleProduct) {
        if (saleProduct) return this.indexSaleProducts.indexOf(saleProduct);
        return -1;
    };
    saleProductData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexSaleProducts.length) return this.indexSaleProducts[index];else return null;
    };
    saleProductData.add = function (saleProduct) {
        this.indexSaleProducts.push(saleProduct);
        return this.indexSaleProducts.length - 1;
    };
    saleProductData.clear = function () {
        saleProductData.indexSaleProducts = [];
    };

    return saleProductData;
}]);

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('SaleService_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceSaleS = $resource(baseUrl + 'rest/saleServices/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceSaleS;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleService', ["SaleService_Resource", "CategoryData", "ServiceData", "SaleServiceData", "HumanResourceData", "TaxMode", "SaleItem", "Category", "Service", "TypeOfSale", function (SaleService_Resource, CategoryData, ServiceData, SaleServiceData, HumanResourceData, TaxMode, SaleItem, Category, Service, TypeOfSale) {
    //SaleService inherit from Activity
    var SaleService = function SaleService(saleServiceRes, isPreviousVersion, parentSaleService) {
        SaleItem.call(this);

        this.id = null;
        this.label = null;
        this.price = 0;
        this.vat = null;
        this.vatCode = null;
        this.quantity = 0;
        this.originalPrice = 0;
        this.discountPercent = 0;
        this.service = null;
        this.sale = null;
        this.humanResource = null;
        this.version = null;
        this.subSaleServices = [];
        if (parentSaleService !== undefined && parentSaleService != null) this.parentSaleService = parentSaleService;else this.parentSaleService = null;

        this.loadObject(saleServiceRes);
        this.loadRef();
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            SaleServiceData.add(this);
    };

    SaleService.prototype = Object.create(SaleItem.prototype); //inherit functions from SaleItem

    SaleService.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.label = object.label;
            this.price = object.price;
            this.vat = object.vat;
            this.vatCode = object.vatCode;
            if (object.originalPrice !== undefined && object.originalPrice) this.originalPrice = object.originalPrice;else this.originalPrice = object.price;
            this.discountPercent = object.discountPercent;
            this.quantity = object.quantity;
            this.serviceId = object.serviceId;
            if (object.humanResourceId) this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.version) this.version = object.version;

            this.subSaleServices = [];
            if (object.subSaleServices) {
                for (var j = 0; j < object.subSaleServices.length; j++) {
                    var saleService = new SaleService(object.subSaleServices[j], null, this);
                    this.subSaleServices.push(saleService);
                }
            }
        }
    };

    SaleService.prototype.loadRef = function () {
        if (this.serviceId) this.service = ServiceData.getById(this.serviceId);
        for (var i = 0; i < this.subSaleServices.length; i++) {
            this.subSaleServices[i].service = ServiceData.getById(this.subSaleServices[i].serviceId);
        }
    };

    SaleService.prototype.copyDataTo = function (object) {
        object.id = this.id;
        object.label = this.label;
        object.price = this.price;
        object.vat = this.vat;
        object.vatCode = this.vatCode;
        object.originalPrice = this.originalPrice;
        object.discountPercent = this.discountPercent;
        object.quantity = this.quantity;
        if (this.humanResource) object.humanResourceId = this.humanResource.id;

        if (this.service) object.serviceId = this.service.id;else object.serviceId = null;

        if (this.sale) object.saleId = this.sale.id;else object.saleId = null;

        object.subSaleServices = [];
        for (var i = 0; i < this.subSaleServices.length; i++) {
            object.subSaleServices.push(this.subSaleServices[i].getObjectResource(true));
        }
    };
    SaleService.prototype.getObjectResource = function () {
        var saleServiceRes = new SaleService_Resource();
        this.copyDataTo(saleServiceRes);
        return saleServiceRes;
    };
    SaleService.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };
    SaleService.prototype.setId = function (id) {
        this.id = id;
    };
    SaleService.prototype.setService = function (service) {
        this.service = service;
    };
    SaleService.prototype.getService = function () {
        return this.service;
    };
    SaleService.prototype.getItem = function () {
        return this.service;
    };
    SaleService.prototype.getItemCategoryType = function () {
        return Category;
    };
    SaleService.prototype.getItemType = function () {
        return Service;
    };

    SaleService.prototype.getParentItem = function () {
        return this.parentSaleService ? this.parentSaleService.getItem() : null;
    };

    SaleService.prototype.getId = function () {
        return this.id;
    };
    SaleService.prototype.getLabel = function () {
        return this.label;
    };
    SaleService.prototype.getPrice = function () {
        return this.price;
    };
    SaleService.prototype.getDiscountPrice = function (taxMode) {
        var price = 0;

        if (this.getSale().isStatusSoldOrCreditOrCanceled()) {
            if (this.isPriceCalculatedBySubSaleServices()) {
                for (var i = 0; i < this.subSaleServices.length; i++) {
                    price += this.subSaleServices[i].price;
                }
            } else {
                price = this.price;
            }

            //apply global discount on price
            if (this.getSale().discountPercent !== 0) {
                price -= this.getSale().discountPercent * price / 100;
            }
            if (taxMode === TaxMode.HT) {
                var vat = this.vat ? this.vat : this.getSale().vat;
                price = price / (100 + vat) * 100;
            }
        }

        return price;
    };

    /**
     * @override SaleItem.prototype.getSale
     */
    SaleService.prototype.getSale = function () {
        if (this.parentSaleService) return this.parentSaleService.getSale();else return this.sale;
    };

    SaleService.prototype.getBookingService = function () {
        var booking = this.getSale().booking,
            bookingService = null,
            bookingServiceFound = false;
        if (booking) {
            for (var i = 0; i < booking.bookingServices.length; i++) {
                if (booking.bookingServices[i].service == this.service) {
                    bookingService = booking.bookingServices[i];
                    bookingServiceFound = true;
                }
                for (var j = 0; j < booking.bookingServices[i].subBookingServices.length; j++) {
                    if (booking.bookingServices[i].subBookingServices[j].service == this.service) {
                        bookingService = booking.bookingServices[i].subBookingServices[j];
                        bookingServiceFound = true;
                        break;
                    }
                }
                if (bookingServiceFound) {
                    break;
                }
            }
        }
        return bookingService;
    };

    /**
     * @override SaleItem.prototype.getDuration
     */
    SaleService.prototype.getDuration = function () {
        var duration = 0;

        if (this.subSaleServices.length != 0) {
            for (var i = 0; i < this.subSaleServices.length; i++) {
                if (this.subSaleServices[i].humanResource) {
                    duration += this.subSaleServices[i].getDuration();
                }
            }
        } else {
            var bookingService = this.getBookingService();
            if (bookingService) {
                duration = bookingService.period.duration;
            } else {
                if (this.service) {
                    duration = this.service.duration;
                }
            }
        }
        return duration;
    };

    /**
     * @override SaleItem.prototype.matchSpecificMatchingOfItem
     */
    SaleService.prototype.matchSpecificMatchingOfItem = function (saleObject) {
        var matchSpecificMatchingOfItem = false;
        if (saleObject === TypeOfSale.ALL_WITH_PRODUCT_OR_NOT || saleObject === TypeOfSale.SERVICE_AND_PRODUCT && this.getSale().saleProducts.length > 0 || saleObject === TypeOfSale.SERVICE_WITHOUT_PRODUCT && this.getSale().saleProducts.length == 0) {
            matchSpecificMatchingOfItem = true;
        }
        return matchSpecificMatchingOfItem;
    };

    /**
     * @override SaleItem.prototype.incrementSalesDatasForSubSales
     */
    SaleService.prototype.incrementSalesDatasForSubSales = function (salesData, firstDayOfPeriod, lastDayOfPeriod) {
        if (this.parentSaleService) {
            if (salesData.subSales.indexOf(this.parentSaleService) === -1) {
                salesData.subSales.push(this.parentSaleService);
                salesData.qteSubSales += this.getStatQuantity();
            }

            if (!this.getSale().booking && salesData.subSalesWithoutBooking.indexOf(this.parentSaleService) === -1) {
                salesData.subSalesWithoutBooking.push(this.parentSaleService);
                salesData.qteSubSalesWithoutBooking += this.getStatQuantity();
            }
            if (salesData.subSalesWithBookingOutOfPeriod.indexOf(this.parentSaleService) === -1 && this.getSale().booking && this.getSale().booking.day && firstDayOfPeriod && lastDayOfPeriod && (this.getSale().booking.day.id < firstDayOfPeriod.id || this.getSale().booking.day.id > lastDayOfPeriod.id)) {
                salesData.subSalesWithBookingOutOfPeriod.push(this.parentSaleService);
                salesData.qteSubSalesWithBookingOutOfPeriod += this.getSale().status == 'credit' ? -1 : 1;
            }
        } else if (!this.parentSaleService) {
            if (salesData.subSales.indexOf(this) === -1) {
                salesData.subSales.push(this);
                salesData.qteSubSales += this.getStatQuantity();
            }
            if (!this.getSale().booking && salesData.subSalesWithoutBooking.indexOf(this) === -1) {
                salesData.subSalesWithoutBooking.push(this);
                salesData.qteSubSalesWithoutBooking += this.getStatQuantity();
            }
            if (salesData.subSalesWithBookingOutOfPeriod.indexOf(this) === -1 && this.getSale().booking && this.getSale().booking.day && firstDayOfPeriod && lastDayOfPeriod && (this.getSale().booking.day.id < firstDayOfPeriod.id || this.getSale().booking.day.id > lastDayOfPeriod.id)) {
                salesData.subSalesWithBookingOutOfPeriod.push(this);
                salesData.qteSubSalesWithBookingOutOfPeriod += this.getStatQuantity();
            }
        }
    };

    /**
     * @override SaleItem.prototype.incrementSalesDatasForOldAndNewCustomer
     */
    SaleService.prototype.incrementSalesDatasForOldAndNewCustomer = function (salesData, firstDayOfPeriod) {
        if (this.getSale().customer && (this.getSale().customer.hasSaleBefore(firstDayOfPeriod) || this.getSale().customer.hasBookingBefore(firstDayOfPeriod))) {
            if (this.parentSaleService && salesData.subSalesOldCustomer.indexOf(this.parentSaleService) === -1) {
                salesData.subSalesOldCustomer.push(this.parentSaleService);
                salesData.qteSubSalesOldCustomer += this.parentSaleService.getStatQuantity();
            } else if (!this.parentSaleService && salesData.subSalesOldCustomer.indexOf(this) === -1) {
                salesData.subSalesOldCustomer.push(this);
                salesData.qteSubSalesOldCustomer += this.getStatQuantity();
            }

            if (salesData.salesOldCustomer.indexOf(this.getSale()) === -1) {
                salesData.salesOldCustomer.push(this.getSale());
            }
        } else {
            if (this.parentSaleService && salesData.subSalesNewCustomer.indexOf(this.parentSaleService) === -1) {
                salesData.subSalesNewCustomer.push(this.parentSaleService);
                salesData.qteSubSalesNewCustomer += this.parentSaleService.getStatQuantity();
            } else if (!this.parentSaleService && salesData.subSalesNewCustomer.indexOf(this) === -1) {
                salesData.subSalesNewCustomer.push(this);
                salesData.qteSubSalesNewCustomer += this.getStatQuantity();
            }

            if (salesData.salesNewCustomer.indexOf(this.getSale()) === -1) {
                salesData.salesNewCustomer.push(this.getSale());
            }
        }
    };

    SaleService.prototype.isPriceCalculatedBySubSaleServices = function () {
        var isTurnoverFromSubSaleServices = true;
        if (this.subSaleServices == null || this.subSaleServices.length === 0) {
            isTurnoverFromSubSaleServices = false;
        } else {
            var totalPriceFromSubSaleServices = 0;
            var totalDiscountFromSubSaleServices = 0;
            for (var i = 0; i < this.subSaleServices.length; i++) {
                totalPriceFromSubSaleServices += this.subSaleServices[i].price;
                totalDiscountFromSubSaleServices += this.subSaleServices[i].originalPrice - this.subSaleServices[i].price;
            }

            var roundedPriceFromSaleService = Math.round(this.price * 100) / 100;
            var roundedDiscountFromSaleService = Math.round((this.originalPrice - this.price) * 100) / 100;
            var roundedPriceFromSubSaleServices = Math.round(totalPriceFromSubSaleServices * 100) / 100;
            var roundedDiscountFromSubSaleServices = Math.round(totalDiscountFromSubSaleServices * 100) / 100;
            var diffPrice = Math.abs(roundedPriceFromSaleService - roundedPriceFromSubSaleServices);
            var diffDiscount = Math.abs(roundedDiscountFromSaleService - roundedDiscountFromSubSaleServices);

            if (roundedPriceFromSubSaleServices === 0 && roundedPriceFromSaleService !== 0 || diffPrice > 0.01 && diffDiscount > 0.01) {
                isTurnoverFromSubSaleServices = false;
            }
        }
        return isTurnoverFromSubSaleServices;
    };

    return SaleService;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleServiceSrv', ["$log", "ServerSrv", "DayData", "SaleServiceData", "SaleService", "WorkingPeriodDayHrData", "DayHrData", "ActivitySrv", "SaleData", function ($log, ServerSrv, DayData, SaleServiceData, SaleService, WorkingPeriodDayHrData, DayHrData, ActivitySrv, SaleData) {
    var ssSrv = {};

    ssSrv.save = function (saleService, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(ssSrv.saveSync, saleService, successFunction, errorFunction);
    };
    ssSrv.saveSync = function (saleService, successFunction, errorFunction) {
        var bsRes = saleService.getObjectResource();
        bsRes.$save({}, //no params
        function (data) {
            try {
                // now we can set the id
                saleService.setId(data.id);
                if (!saleService.version || data.version && data.version > saleService.version) saleService.version = data.version;
                if (data.subSaleServicesId) for (var j = 0; j < data.subSaleServicesId.length; j++) {
                    saleService.subSaleServices[j].setId(data.subSaleServicesId[j]);
                }

                //Add user action
                //UserActionSrv.add(data.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    ssSrv.updateLocally = function (id, resource) {
        var saleService = SaleServiceData.getById(id);

        if (saleService && saleService.version && resource.version && resource.version < saleService.version) return null;

        if (saleService != null) {
            saleService.loadObject(resource);
            saleService.id = id;
            //remove from sale
            if (saleService.sale) saleService.sale.removeSaleService(saleService);

            if (resource.saleId) {
                var sale = SaleData.getById(resource.saleId);
                if (sale) sale.addSaleService(saleService);
            }
        }

        return saleService;
    };
    ssSrv.removeLocally = function (id, resource) {
        var saleService = SaleServiceData.getById(id);
        if (saleService && saleService.version && resource.version && resource.version < saleService.version) return null;
        if (saleService != null) {}
        return saleService;
    };
    ssSrv.addLocally = function (id, resource) {
        var saleService = SaleServiceData.getById(id);
        if (saleService && saleService.version && resource.version && resource.version < saleService.version) return null;
        if (saleService != null) //check if resource already exist inside index (current action could be a 'cancel')
            saleService.loadObject(resource);else {
            saleService = new SaleService(resource);
        }
        saleService.id = id;
        //add to sale
        if (resource.saleId) {
            var sale = SaleData.getById(resource.saleId);
            if (sale) sale.addSaleService(saleService);
        }

        return saleService;
    };
    ssSrv.getPreviousVersionInstance = function (resource) {
        var saleService = new SaleService(resource, true);
        if (resource.saleId) saleService.sale = SaleData.getById(resource.saleId);
        return saleService;
    };

    return ssSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('SaleServiceData', ["$log", function ($log) {
    var saleServiceData = {
        indexSaleServices: []
    };
    saleServiceData.getById = function (saleServiceId) {
        for (var i = 0; i < this.indexSaleServices.length; i++) {
            if (this.indexSaleServices[i].id == saleServiceId) return this.indexSaleServices[i];
        }return null;
    };
    saleServiceData.getIndexOf = function (saleService) {
        if (saleService) return this.indexSaleServices.indexOf(saleService);
        return -1;
    };
    saleServiceData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexSaleServices.length) return this.indexSaleServices[index];else return null;
    };
    saleServiceData.add = function (saleService) {
        this.indexSaleServices.push(saleService);
        return this.indexSaleServices.length - 1;
    };
    saleServiceData.clear = function () {
        saleServiceData.indexSaleServices = [];
    };

    return saleServiceData;
}]);

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Service_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/services/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/services/deleted' },
        getEnabledServiceSettingReserveWithGoogle: { method: 'GET', isArray: true, url: baseUrl + 'rest/services/serviceSettingReserveWithGoogle/isVisible' },
        createWithPartnerServiceSettings: { method: 'POST', url: baseUrl + 'rest/services/create-with-partner-service-settings' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Service', ["Service_Resource", "ImageData", "ServiceData", "CategoryData", "CompanyImageData", "ProductData", function (Service_Resource, ImageData, ServiceData, CategoryData, CompanyImageData, ProductData) {

    var Service = function Service(resource, parentCategory) {
        this.id = null;
        this.serviceSettingsReserveWithGoogleId = null;
        this.isDeleted;
        this.label = "";
        this.labelShort = "";
        this.description = "";
        this.isPackage = false;
        this.isOnHome = false;
        this.homeOrder = 0;
        this.price = null;
        this.hasInternetPrice = false;
        this.hasMandatoryPayment = false;
        this.internetPrice = null;
        this.duration = null;
        this.hasItnDuration = null;
        this.itnDuration = null;
        this.image = null;
        this.companyImage = null;
        this.specificImage = null;
        this.nbHrsNeeded = null;
        this.nbPrsNeeded = null;
        this.isVisibleOnWebSite = true; //Default;
        this.isBookableOnWebSite = true; //Default;
        this.subServices = [];
        this.products = [];
        this._productsId = [];
        this.images = [];
        this.cures = [];
        this.version = null;
        this.subWidgets = null;
        this.imgWidget = null;
        this.style = null;

        if (resource !== undefined && resource != null) {
            this.loadObject(resource, parentCategory);
        } else if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }

        ServiceData.add(this);
    };
    Service.prototype.loadObject = function (object, parentCategory) {
        //Assume here than the object in parameter contains only id (must load them)
        if (!this.id) this.id = object.id;
        this.serviceSettingsReserveWithGoogleId = object.serviceSettingsReserveWithGoogleId;
        this.isDeleted = object.isDeleted;
        this.parentCategoryId = object.parentCategoryId;
        this.label = object.label;
        this.labelShort = object.labelShort;
        this.description = object.description;
        this.isPackage = object.isPackage;
        this.isOnHome = object.isOnHome;
        this.homeOrder = object.homeOrder;
        this.price = object.price;
        this.hasInternetPrice = object.hasInternetPrice;
        this.hasMandatoryPayment = object.hasMandatoryPayment;
        this.internetPrice = object.internetPrice;
        this.duration = object.duration;
        this.hasItnDuration = object.hasItnDuration;
        this.itnDuration = object.itnDuration;
        this.imageId = object.imageId;
        this.companyImageId = object.companyImageId;
        this.specificImage = object.specificImage;
        this.nbHrsNeeded = object.nbHrsNeeded;
        this.nbPrsNeeded = object.nbPrsNeeded;
        this.isVisibleOnWebSite = object.isVisibleOnWebSite;
        this.isBookableOnWebSite = object.isBookableOnWebSite;
        this.nbPrsNeeded = object.nbPrsNeeded;
        this.subWidgets = object.subWidgets;
        this.imgWidget = object.imgWidget;
        this.style = object.style;

        if (parentCategory !== undefined && parentCategory != null) {
            this.parentCategory = parentCategory;
        }
        this.subServices = [];
        if (object.subServices) {

            for (var j = 0; j < object.subServices.length; j++) {
                var service = new Service(object.subServices[j], parentCategory); //not linked to not have it inside cat
                this.subServices.push(service);
            }
        }
        if (object.productsId) this._productsId = object.productsId;
        if (object.version) this.version = object.version;
    };
    Service.prototype.getObjectResource = function (isSub) {
        var rsService = new Service_Resource();
        rsService.id = this.id;
        rsService.serviceSettingsReserveWithGoogleId = this.serviceSettingsReserveWithGoogleId;
        rsService.isDeleted = this.isDeleted;
        rsService.label = this.label;
        rsService.labelShort = this.labelShort;
        if (this.image) rsService.imageId = this.image.id;
        if (this.companyImage) rsService.companyImageId = this.companyImage.id;
        rsService.specificImage = this.specificImage;
        rsService.description = this.description;
        rsService.isPackage = this.isPackage;
        rsService.isOnHome = this.isOnHome;
        rsService.homeOrder = this.homeOrder;
        rsService.price = this.price;
        rsService.hasInternetPrice = this.hasInternetPrice;
        rsService.hasMandatoryPayment = this.hasMandatoryPayment;
        rsService.internetPrice = this.internetPrice;
        rsService.duration = this.duration;
        rsService.itnDuration = this.itnDuration;
        rsService.hasItnDuration = this.hasItnDuration;
        rsService.nbHrsNeeded = this.nbHrsNeeded;
        rsService.nbPrsNeeded = this.nbPrsNeeded;
        rsService.isVisibleOnWebSite = this.isVisibleOnWebSite;
        rsService.isBookableOnWebSite = this.isBookableOnWebSite;
        rsService.subWidgets = this.subWidgets;
        rsService.imgWidget = this.imgWidget;
        rsService.style = this.style;
        //needPhysicalResource &&  needHumanResource MANAGED BY SERVER
        if ((isSub == undefined || !isSub) && this.parentCategory != null) //dont save it to not link it to server
            rsService.parentCategoryId = this.parentCategory.getId();

        rsService.subServices = [];
        for (var i = 0; i < this.subServices.length; i++) {
            rsService.subServices.push(this.subServices[i].getObjectResource(true));
        }rsService.productsId = [];
        for (var i = 0; i < this.products.length; i++) {
            rsService.productsId.push(this.products[i].getId());
        }return rsService;
    };

    Service.prototype.loadRef = function () {
        if (this.imageId) this.image = ImageData.getById(this.imageId);
        if (this.companyImageId) this.companyImage = CompanyImageData.getById(this.companyImageId);
        if (this.parentCategory == null && this.parentCategoryId) this.parentCategory = CategoryData.getById(this.parentCategoryId);
        for (var i = 0; i < this.subServices.length; i++) {
            this.subServices[i].parentCategory = this.parentCategory;
        }if (this._productsId) {
            var newProducts = [];
            for (var i = 0; i < this._productsId.length; i++) {
                var product = ProductData.getById(this._productsId[i]);
                if (product != null) newProducts.push(product);
            }
            this.products = newProducts;
        }
    };
    Service.prototype.getId = function () {
        return this.id;
    };
    Service.prototype.setId = function (id) {
        this.id = id;
    };
    Service.prototype.getLabel = function () {
        return this.label;
    };
    Service.prototype.reload = function (endFunction) {
        var serviceSrv = this.getObjectResource();
        var service = this;
        if (this.getId() != null) serviceSrv.$get({ id: this.getId() }, //params
        function (data) {
            //success
            service.loadObject(data);
            if (endFunction != undefined) endFunction(service);
        }, function (data) {//failure
            //error handling goes here
            //TODO
        });
    };

    Service.prototype.isDescendantOf = function (category, parentService) {
        var isDescendantOf = false;
        if (this.parentCategory === category) {
            isDescendantOf = true;
        } else if (this.parentCategory) {
            isDescendantOf = this.parentCategory.isDescendantOf(category);
        } else if (parentService) {
            isDescendantOf = parentService.isDescendantOf(category);
        }

        return isDescendantOf;
    };

    return Service;
}]);

angular.module('FlexyBeautyApp.services').factory('ServiceSrv', ["$log", "HumanResourceData", "HumanResourceSrv", "Service_Resource", "Service", "CategoryData", "UserActionData", "ServiceData", "ServerSrv", function ($log, HumanResourceData, HumanResourceSrv, Service_Resource, Service, CategoryData, UserActionData, ServiceData, ServerSrv) {
    var serviceSrv = {};

    serviceSrv.save = function (service, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(serviceSrv.saveSync, service, successFunction, errorFunction);
    };

    serviceSrv.saveSync = function (service, successFunction, errorFunction) {
        var ServiceRes = service.getObjectResource();
        ServiceRes.$save({}, //no params
        function (serviceRes) {
            try {
                serviceSrv.saveSuccessCallback(serviceRes, service, successFunction);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    serviceSrv.createWithPartnerServiceSettings = function (service, activationByPartnerLabel, settingsByPartnerLabel, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(serviceSrv.createWithPartnerServiceSettingsSync, service, activationByPartnerLabel, settingsByPartnerLabel, successFunction, errorFunction);
    };

    serviceSrv.createWithPartnerServiceSettingsSync = function (service, activationByPartnerLabel, settingsByPartnerLabel, successFunction, errorFunction) {
        var ServiceRes = service.getObjectResource();
        ServiceRes.activationByPartnerLabel = activationByPartnerLabel;
        ServiceRes.settingsByPartnerLabel = settingsByPartnerLabel;
        ServiceRes.$createWithPartnerServiceSettings({}, //no params
        function (serviceRes) {
            try {
                serviceSrv.saveSuccessCallback(serviceRes, service, successFunction);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    serviceSrv.saveSuccessCallback = function (serviceRes, service, successFunction) {
        if (service.id == null) {
            service.setId(serviceRes.id);
        }
        if (!service.version || serviceRes.version && serviceRes.version > service.version) {
            service.version = serviceRes.version;
        }
        if (serviceRes.subServicesId) for (var j = 0; j < serviceRes.subServicesId.length; j++) {
            service.subServices[j].setId(serviceRes.subServicesId[j]);
        }

        if (successFunction !== undefined) {
            successFunction(serviceRes);
        }
    };

    serviceSrv.remove = function (service, successFunction, errorFunction) {
        ServiceData.remove(service);
        ServerSrv.startSavingProcess(serviceSrv.removeSync, service, successFunction, errorFunction);
    };
    serviceSrv.removeSync = function (service, successFunction, errorFunction) {
        var serviceRes = new Service_Resource();
        serviceRes.$remove({ id: service.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    serviceSrv.restore = function (service, successFunction, errorFunction) {
        ServiceData.restore(service);
        ServerSrv.startSavingProcess(serviceSrv.restoreSync, service, successFunction, errorFunction);
    };
    serviceSrv.restoreSync = function (service, successFunction, errorFunction) {
        //$timeout (function () {

        var serviceRes = service.getObjectResource();
        serviceRes.$save({}, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    serviceSrv.loadEnabledServiceSettingsReserveWithGoogleViews = function (successFunction, errorFunction) {
        Service_Resource.getEnabledServiceSettingReserveWithGoogle({}, function (data) {
            if (successFunction !== undefined) successFunction(data);
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    serviceSrv.query = function (successFunction, errorFunction) {
        Service_Resource.getDeleted({}, //params
        function (data) {
            //success

            ServiceData.deletedServices = [];
            for (var i = 0; i < data.length; i++) {
                new Service(data[i]);
            } //Auto Add to ServiceData

            if (successFunction !== undefined) successFunction(ServiceData.indexServices);
        }, function (data) {
            //failure
            $log.error("Service_Resource.getDeleted error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    serviceSrv.loadRef = function () {
        var services = ServiceData.indexServices;
        for (var i = 0; i < services.length; i++) {
            services[i].loadRef();
        }
    };
    serviceSrv.updateLocally = function (id, object) {
        var service = null;
        var category = CategoryData.getById(object.parentCategoryId);
        if (category != null) service = category.getServiceById(id);
        if (service != null) {
            service.loadObject(object, category);
        }
        return service;
    };
    serviceSrv.addLocally = function (id, object) {
        var service = null;
        var category = CategoryData.getById(object.parentCategoryId);
        if (category != null) {
            service = new Service(object, category);
            service.id = id;
            category.addService();
        }
        return null;
    };
    serviceSrv.removeLocally = function (id, object) {
        var service = null;
        var category = CategoryData.getById(object.parentCategoryId);
        if (category != null) service = category.getServiceById(id);
        if (service != null) category.removeService(service);
        return service;
    };

    return serviceSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('ServiceData', ["$log", function ($log) {
    var serviceData = {
        indexServices: [], //Used as Index
        deletedServices: []
    };
    serviceData.getById = function (serviceId) {
        for (var i = 0; i < this.indexServices.length; i++) {
            if (this.indexServices[i].id == serviceId) return this.indexServices[i];
        }return null;
    };
    serviceData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexServices.length) {
            return this.indexServices[servIndex];
        } else return null;
    };
    serviceData.getIndexOf = function (service) {
        if (service) return this.indexServices.indexOf(service);
        return -1;
    };
    serviceData.add = function (service) {
        this.indexServices.push(service);
        if (service.isDeleted) {
            var index = this.deletedServices.indexOf(service);
            if (index == -1) this.deletedServices.push(service);
        }
        return this.indexServices.length - 1;
    };
    serviceData.remove = function (service) //Soft Remove
    {
        var index = this.deletedServices.indexOf(service);
        if (index == -1) {
            this.deletedServices.push(service);
            service.isDeleted = true;
        }
    };
    serviceData.restore = function (service) //Soft Remove
    {
        var index = this.deletedServices.indexOf(service);
        if (index != -1) {
            this.deletedServices.splice(index, 1);
            service.isDeleted = false;
        }
    };
    serviceData.clear = function () {
        serviceData.indexServices = [];
        serviceData.deletedServices = [];
    };
    serviceData.getDeletedList = function () {
        return serviceData.deletedServices;
    };

    return serviceData;
}]);

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Directives */

angular.module('FlexyBeautyApp.directives').directive('convertToNumber', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (val) {
                return parseInt(val, 10);
            });
            ngModel.$formatters.push(function (val) {
                return '' + val;
            });
        }
    };
}).directive('ngKeydown', function () {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            // scope.dd.view.pTView next line will convert the string
            // function name into an actual function
            var functionToCall = scope.$eval(attrs.ngKeydown);
            var thisObjectName = attrs.ngKeydown.substr(0, attrs.ngKeydown.lastIndexOf('.'));
            var thisObject = null;
            if (thisObjectName) thisObject = scope.$eval(thisObjectName);
            elem.on('keydown', function (e) {
                // on the keydown event, call my function
                // and pass it the keycode of the key
                // that was pressed
                // ex: if ENTER was pressed, e.which == 13
                if (functionToCall) functionToCall(e, thisObject);
            });
        }
    };
}).directive('uppercase', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, modelCtrl) {
            var capitalize = function capitalize(inputValue) {
                if (!inputValue) return "";
                var capitalized = inputValue.toUpperCase();
                if (capitalized !== inputValue) {
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                }
                return capitalized;
            };
            modelCtrl.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]); // capitalize initial value
        }
    };
}).directive('noSpace', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, modelCtrl) {
            var deleteSpace = function deleteSpace(inputValue) {
                if (!inputValue) return "";
                var withoutSpace = inputValue.replace(" ", "");

                return withoutSpace;
            };
            modelCtrl.$parsers.push(deleteSpace);
            deleteSpace(scope[attrs.ngModel]); // capitalize initial value
        }
    };
}).directive('lowercase', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, modelCtrl) {
            var capitalize = function capitalize(inputValue) {
                if (!inputValue) return "";
                var capitalized = inputValue.toLowerCase();
                if (capitalized !== inputValue) {
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                }
                return capitalized;
            };
            modelCtrl.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]); // capitalize initial value
        }
    };
}).directive('uppercaseFirstWord', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, modelCtrl) {
            var capitalize = function capitalize(inputValue) {
                if (!inputValue) return "";
                var index = inputValue.indexOf(" ");
                var capitalized = "";
                if (index != -1) {
                    if (index + 1 < inputValue.length) capitalized = inputValue.substring(0, index + 2).toUpperCase() + inputValue.substring(index + 2).toLowerCase(); //upper first letter of second word
                    else capitalized = inputValue.substring(0, index + 1).toUpperCase() + inputValue.substring(index + 1).toLowerCase();
                } else capitalized = inputValue.toUpperCase();
                if (capitalized !== inputValue) {
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                }
                return capitalized;
            };
            modelCtrl.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]); // capitalize initial value
        }
    };
}).directive('capitalizeWords', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, modelCtrl) {
            var el = element[0];

            function capitalize(inputValue) {
                var capitalized = inputValue.toLowerCase();
                capitalized = capitalized.replace(/(?:^|\s)\S/g, function (a) {
                    return a.toUpperCase();
                });
                return capitalized;
            }

            modelCtrl.$parsers.push(function (val) {
                var capitalizedValue = capitalize(val);

                if (capitalizedValue === val) return val;

                var start = el.selectionStart;
                var end = el.selectionEnd + capitalizedValue.length - val.length;

                modelCtrl.$setViewValue(capitalizedValue);
                modelCtrl.$render();

                el.setSelectionRange(start, end);
                return capitalizedValue;
            });
        }
    };
}).directive('capitalizeFirstLetter', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, modelCtrl) {
            var capitalize = function capitalize(inputValue) {
                if (!inputValue || inputValue.length == 0) return "";
                var capitalized = "";
                if (inputValue.length > 1) capitalized = inputValue.charAt(0).toUpperCase() + inputValue.substring(1).toLowerCase(); //upper first letter of second word
                else capitalized = inputValue.charAt(0).toUpperCase();
                if (capitalized !== inputValue) {
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                }
                return capitalized;
            };
            modelCtrl.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]); // capitalize initial value
        }
    };
}).directive('currencyFormat', ["$filter", "$locale", "CurrencyManager", "NumberSeparatorType", "$timeout", function ($filter, $locale, CurrencyManager, NumberSeparatorType, $timeout) {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, elem, attrs, modelCtrl) {
            if (!modelCtrl) return;

            //whenever the bound ngModel expression changes programmatically
            //convert the $modelValue for display in the control (change the $viewValue)
            modelCtrl.$formatters.unshift(function (a) {
                //we need to use parseFloat because "a" is a string witch contains a number
                //and the filter currencyFormatFilter has an inapropriate behavior with this type of "string-number".
                // The filter knows how to format :
                // - number, like : 1000.00
                // - number formatted string, like : 1 000,00
                //but the currencyFormatFilter filter doesn't know how to format "1000.00"
                return $filter('currencyFormatFilter')(parseFloat(a));
            });

            var timeoutCurrency = null;
            //call whenever the control updates the ngModelController with a new $viewValue from the DOM
            //convert the $viewValue (change the $modelValue)
            modelCtrl.$parsers.unshift(function (value) {
                var newValue = null;
                if (value != null && typeof value === 'string') {
                    newValue = CurrencyManager.getPriceFromPriceInput(value);
                } else {
                    newValue = value;
                }
                newValue = (newValue + '').trim() * 1;

                if (timeoutCurrency) $timeout.cancel(timeoutCurrency);

                timeoutCurrency = $timeout(function () {
                    //the user has change the viewValue but we want to add de curency sign
                    try {
                        modelCtrl.$setViewValue($filter('currencyFormatFilter')(newValue));
                    } catch (e) {
                        //when the user open quiclky the steps, there is sometimes an unknown exception in angular.
                        //the exception seems to be not "so important" and no best solution has been found
                        console.warn("Exception in AngularJs. No impact on the application is expected.");
                    }

                    modelCtrl.$render();
                }, 2000);

                return newValue;
            });
        }
    };
}]).directive('numberFormat', ["$filter", function ($filter) {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, elem, attrs, modelCtrl) {
            if (!modelCtrl) return;

            //whenever the bound ngModel expression changes programmatically
            //convert the $modelValue for display in the control (change the $viewValue)
            modelCtrl.$formatters.unshift(function (a) {
                return $filter('number')(a, 2);
            });

            var timeout = null;
            //call whenever the control updates the ngModelController with a new $viewValue from the DOM
            //convert the $viewValue (change the $modelValue)
            modelCtrl.$parsers.unshift(function (value) {
                var newValue = null;
                if (value != null && typeof value === 'string') {
                    newValue = value.replace(",", ".").replace(" ", "");
                } else {
                    newValue = value;
                }
                newValue = (newValue + '').trim() * 1;

                if (timeout) clearTimeout(timeout);

                timeout = setTimeout(function () {
                    //the user has change the viewValue but we want to format it
                    modelCtrl.$setViewValue($filter('number')(newValue));
                    modelCtrl.$render();
                }, 3000);

                return newValue;
            });
        }
    };
}]).directive('phoneInput', ["$document", "PhoneFormat", "$timeout", function ($document, PhoneFormat, $timeout) {
    return {
        restrict: 'E',
        scope: {
            phone: "=phone",
            selectedCountry: "=selectedCountry",
            displayError: "=displayError",
            errorMessage: "=errorMessage",
            holderValue: "=holderValue",
            isMobile: "=isMobile"

        },
        templateUrl: '/partials/internationalisation/internationalPhoneFormat.html',
        controller: ['$scope', function ($scope) {
            $scope.timeout = null;
            $scope.PhoneFormat = PhoneFormat;
            $scope.showFlagsList = false;
            $scope.isKeyDown = false;
            $scope.selectedTitle = "+33";
            $scope.setSelectedCountry = function (country, code) {
                $scope.selectedCountry = country;
                $scope.selectedCode = code;

                if (country == PhoneFormat.unknowFormat) {
                    $scope.selectedTitle = 'Autre Pays';
                    $scope.displayError = false;
                } else if ($scope.selectedCountry && $scope.phone && $scope.phone != "" && $scope.phone.length >= 4) {
                    $scope.selectedTitle = country.toUpperCase() + " +" + code;
                    var oldCode = '';
                    var phone = '';
                    try {
                        oldCode = PhoneFormat.getPrefixNumber($scope.phone, country);
                        phone = $scope.phone.replace("+" + oldCode, "0");
                        $scope.phone = PhoneFormat.formatNumber(phone, $scope.selectedCountry);
                        $scope.displayError = !PhoneFormat.isValidNumberForRegion($scope.phone, $scope.selectedCountry);
                    } catch (e) {
                        $scope.displayError = true;
                    }
                }
            };

            $scope.getClassCssForFlag = function () {
                var cssClass = '';
                if ($scope.selectedCountry != 'unknow' && PhoneFormat.isSupportedCountry($scope.selectedCountry)) cssClass += "iti-flag ";else cssClass += "fal fa-globe fa-lg ";
                cssClass += $scope.selectedCountry;
                return cssClass;
            };

            $scope.initField = function () {

                var country = '';
                var valueFormated = $scope.phone;
                $scope.isKeyDown = false;
                if ($scope.phone == null && !PhoneFormat.isSupportedCountry(PhoneFormat.getLocalCountry()) || $scope.phone == '' && !PhoneFormat.isSupportedCountry(PhoneFormat.getLocalCountry()) || $scope.phone && $scope.phone.length > 0 && $scope.phone.length < 4) {
                    var country = PhoneFormat.unknowFormat;
                    $scope.selectedCountry = country;
                    $scope.selectedTitle = 'Autre Pays';
                    $scope.displayError = false;
                } else if ($scope.phone && $scope.phone.length >= 4 && $scope.phone.indexOf("+") != -1) {
                    var value = $scope.phone;
                    if (value) {
                        country = PhoneFormat.getCountryFromNumber(value, $scope.isMobile);
                        if (country != PhoneFormat.unknowFormat) {
                            valueFormated = PhoneFormat.formatNumber(value, country);
                            var code = PhoneFormat.getPrefixNumber(value, country);
                            $scope.selectedCountry = country.toLowerCase();
                            $scope.selectedTitle = country.toUpperCase() + " +" + code;
                        }
                    }
                } else if ($scope.phone && $scope.phone.length >= 4 && $scope.phone.indexOf("+") == -1) {
                    valueFormated = PhoneFormat.formatNumberWithoutCountry($scope.phone, $scope.isMobile);
                    country = PhoneFormat.getCountryFromNumber(valueFormated, $scope.isMobile);
                    var code = PhoneFormat.getPrefixNumber(valueFormated, country);
                    $scope.selectedCountry = country.toLowerCase();
                    $scope.selectedTitle = country != PhoneFormat.unknowFormat ? country.toUpperCase() + " +" + code : code;
                } else {
                    var country = PhoneFormat.getLocalCountry();
                    $scope.selectedCountry = country;
                    $scope.selectedTitle = country.toUpperCase();
                }
                if (country != 'unknow') $scope.phone = valueFormated;
            };

            $scope.onInputKeyDown = function () {
                $scope.isKeyDown = true;
            };

            $scope.onInputKeyUp = function (e) {
                $scope.isKeyDown = false;
            };

            $scope.$watch('selectedCountry', function (selectedCountry) {
                if (selectedCountry && $scope.phone) $scope.setSelectedCountry(selectedCountry, PhoneFormat.getPrefixNumber($scope.phone, selectedCountry));else if (!selectedCountry && $scope.phone) {
                    var country = PhoneFormat.getCountryFromNumber($scope.phone, $scope.isMobile);
                    if (country) {
                        country = country.toLowerCase();
                        $scope.setSelectedCountry(country, PhoneFormat.getPrefixNumber($scope.phone, country));
                    }
                } else if (!selectedCountry && !$scope.phone) {
                    $scope.setSelectedCountry(PhoneFormat.getLocalCountry(), '');
                }
            });

            $scope.$watch('phone', function (phone) {
                if ($scope.selectedCountry && $scope.selectedCountry == PhoneFormat.getLocalCountry() && !PhoneFormat.isSupportedCountry(PhoneFormat.getLocalCountry())) {
                    $scope.selectedCountry = PhoneFormat.unknowFormat;
                    $scope.selectedTitle = 'Autre Pays';
                }
                if ($scope.selectedCountry == 'unknow') {
                    if (phone == null || phone == '' || PhoneFormat.isValidDigitNumber(phone)) $scope.displayError = false;else $scope.displayError = true;
                } else if (phone) {
                    var valueFormated;
                    var country = $scope.selectedCountry;
                    try {

                        if ($scope.phone && $scope.phone.length >= 4) {
                            if ($scope.timeout) $timeout.cancel($scope.timeout);
                            $scope.timeout = $timeout(function () {
                                if (!$scope.isKeyDown) {
                                    valueFormated = PhoneFormat.formatNumber($scope.phone, country);
                                    if (valueFormated != $scope.phone) $scope.phone = valueFormated;
                                }
                            }, 800);
                        }
                        if ($scope.isMobile) {
                            $scope.displayError = !PhoneFormat.isMobileNumber($scope.phone, $scope.selectedCountry);
                        } else {
                            $scope.displayError = !PhoneFormat.isValidNumberForRegion($scope.phone, $scope.selectedCountry);
                        }
                    } catch (error) {
                        $scope.displayError = true;
                    }
                } else {
                    $scope.displayError = false;
                }
            });
            $scope.initField();
        }]
    };
}]);

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('ServiceSettingsLeCiseau_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/service', {}, {
        get: { method: 'GET', url: baseUrl + 'rest/services/:serviceId/partner-service-settings/:basicAuthRole' },
        save: { method: 'PUT', url: baseUrl + 'rest/services/:serviceId/partner-service-settings/:basicAuthRole' },
        create: { method: 'POST', url: baseUrl + 'rest/services/:serviceId/partner-service-settings/:basicAuthRole' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('ServiceSettingsLeCiseau', ["ServiceSettingsLeCiseau_Resource", "ServiceSettingsLeCiseauData", function (ServiceSettingsLeCiseau_Resource, ServiceSettingsLeCiseauData) {
    var ServiceSettingsLeCiseau = function ServiceSettingsLeCiseau(resource, serviceId) {
        this.serviceId = serviceId;
        this.enabled = false; //Default;
        this.linkedServiceIds = [];
        this.settings = {
            promoEnabled: false,
            marketplaceCategoryId: null,
            marketplaceSubCategoryId: null,
            marketplaceVariantId: null
        };

        if (resource !== undefined && resource != null) {
            this.loadObject(resource);
        }
        if (serviceId) {
            ServiceSettingsLeCiseauData.add(this);
        }
    };

    ServiceSettingsLeCiseau.prototype.loadObject = function (object) {
        this.enabled = object.enabled;
        this.linkedServiceIds = object.linkedServiceIds;
        this.settings = {
            promoEnabled: object.settings.promoEnabled,
            marketplaceCategoryId: object.settings.marketplaceCategoryId,
            marketplaceSubCategoryId: object.settings.marketplaceSubCategoryId,
            marketplaceVariantId: object.settings.marketplaceVariantId
        };
    };

    ServiceSettingsLeCiseau.prototype.getObjectResource = function () {
        var serviceSettingsLeCiseauResource = new ServiceSettingsLeCiseau_Resource();
        serviceSettingsLeCiseauResource.enabled = this.enabled;
        serviceSettingsLeCiseauResource.linkedServiceIds = this.linkedServiceIds;
        serviceSettingsLeCiseauResource.settings = {
            promoEnabled: this.settings.promoEnabled,
            marketplaceCategoryId: this.settings.marketplaceCategoryId,
            marketplaceSubCategoryId: this.settings.marketplaceSubCategoryId,
            marketplaceVariantId: this.settings.marketplaceVariantId
        };
        return serviceSettingsLeCiseauResource;
    };

    return ServiceSettingsLeCiseau;
}]);

angular.module('FlexyBeautyApp.services').factory('ServiceSettingsLeCiseauSrv', ["ServiceSettingsLeCiseau_Resource", "ServiceSettingsLeCiseau", "BasicAuthRole", function (ServiceSettingsLeCiseau_Resource, ServiceSettingsLeCiseau, BasicAuthRole) {
    var ServiceSettingsLeCiseauSrv = {};
    ServiceSettingsLeCiseauSrv.get = function (serviceId, successFunction, errorFunction) {
        if (serviceId) {
            var serviceSettingsLeCiseauResource = new ServiceSettingsLeCiseau_Resource();
            var basicAuthRole = BasicAuthRole.LE_CISEAU_ROLE.role;
            serviceSettingsLeCiseauResource.$get({ serviceId: serviceId, basicAuthRole: basicAuthRole }, //params
            function (serviceSettingsLeCiseau) {
                if (successFunction) {
                    successFunction(new ServiceSettingsLeCiseau(serviceSettingsLeCiseau, serviceId));
                }
            }, function (serviceSettingsLeCiseau) {
                if (errorFunction) {
                    errorFunction();
                }
            });
        } else {
            if (errorFunction !== undefined) {
                errorFunction();
            }
        }
    };

    ServiceSettingsLeCiseauSrv.save = function (serviceSettingsLeCiseau, serviceId, successFunction, errorFunction) {
        if (serviceSettingsLeCiseau) {
            var serviceSettingsLeCiseauResource = serviceSettingsLeCiseau.getObjectResource();
            var basicAuthRole = BasicAuthRole.LE_CISEAU_ROLE.role;
            serviceSettingsLeCiseauResource.$save({ serviceId: serviceId, basicAuthRole: basicAuthRole }, //params
            function () {
                if (successFunction) {
                    successFunction();
                }
            }, function () {
                if (errorFunction) {
                    errorFunction();
                }
            });
        } else {
            if (errorFunction !== undefined) {
                errorFunction();
            }
        }
    };

    ServiceSettingsLeCiseauSrv.create = function (serviceSettingsLeCiseau, serviceId, successFunction, errorFunction) {
        if (serviceSettingsLeCiseau) {
            var serviceSettingsLeCiseauResource = serviceSettingsLeCiseau.getObjectResource();
            var basicAuthRole = BasicAuthRole.LE_CISEAU_ROLE.role;
            serviceSettingsLeCiseauResource.$create({ serviceId: serviceId, basicAuthRole: basicAuthRole }, //params
            function () {
                if (successFunction) {
                    successFunction();
                }
            }, function () {
                if (errorFunction) {
                    errorFunction();
                }
            });
        } else {
            if (errorFunction !== undefined) {
                errorFunction();
            }
        }
    };

    return ServiceSettingsLeCiseauSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('ServiceSettingsLeCiseauData', [function () {
    var serviceSettingsLeCiseauData = {
        serviceSettingsLeCiseau: []
    };

    serviceSettingsLeCiseauData.getById = function (serviceId) {
        for (var i = 0; i < this.serviceSettingsLeCiseau.length; i++) {
            if (this.serviceSettingsLeCiseau[i].serviceId === serviceId) {
                return this.serviceSettingsLeCiseau[i];
            }
        }
        return null;
    };

    serviceSettingsLeCiseauData.getIndexOf = function (serviceSettingsLeCiseau) {
        if (serviceSettingsLeCiseau) {
            return this.serviceSettingsLeCiseau.indexOf(serviceSettingsLeCiseau);
        }
        return -1;
    };

    serviceSettingsLeCiseauData.add = function (serviceSettingsLeCiseau) {
        var serviceSettings = serviceSettingsLeCiseauData.getById(serviceSettingsLeCiseau.serviceId);
        if (serviceSettings) {
            this.serviceSettingsLeCiseau.splice(serviceSettings, 1, serviceSettingsLeCiseau);
        } else {
            this.serviceSettingsLeCiseau.push(serviceSettingsLeCiseau);
        }
        return this.serviceSettingsLeCiseau[serviceSettingsLeCiseauData.getIndexOf(serviceSettingsLeCiseau)];
    };

    return serviceSettingsLeCiseauData;
}]);

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: vanessasoc
 * Date: 12/03/19
 * Time: 15:45
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('ServiceSettingsReserveWithGoogle_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/reserve-with-google/settings/services', {}, {
        get: { method: 'GET', url: baseUrl + 'rest/reserve-with-google/settings/services/:id' },
        save: { method: 'PUT', url: baseUrl + 'rest/reserve-with-google/settings/services/:id' },
        create: { method: 'POST', url: baseUrl + 'rest/reserve-with-google/settings/services/:id' }
    });
}]);
angular.module('FlexyBeautyApp.services').factory('ServiceSettingsReserveWithGoogle', ["ServiceSettingsReserveWithGoogle_Resource", "ServiceSettingsReserveWithGoogleData", function (ServiceSettingsReserveWithGoogle_Resource, ServiceSettingsReserveWithGoogleData) {
    var ServiceSettingsReserveWithGoogle = function ServiceSettingsReserveWithGoogle(resource, serviceSettingsReserveWithGoogleId) {
        this.serviceSettingsReserveWithGoogleId = serviceSettingsReserveWithGoogleId;
        this.enabled = false; //Default;
        this.priceEnabled = false; //Default;
        this.price = 0;
        this.description = "";
        if (resource !== undefined && resource != null) {
            this.loadObject(resource);
        }
        if (serviceSettingsReserveWithGoogleId) {
            ServiceSettingsReserveWithGoogleData.add(this);
        }
    };
    ServiceSettingsReserveWithGoogle.prototype.loadObject = function (object) {
        if (!this.serviceSettingsReserveWithGoogleId) this.serviceSettingsReserveWithGoogleId = object.serviceSettingsReserveWithGoogleId;
        this.enabled = object.enabled;
        this.priceEnabled = object.priceEnabled;
        this.price = object.price;
        this.description = object.description;
    };
    ServiceSettingsReserveWithGoogle.prototype.getObjectResource = function () {
        var rsServiceSettingsReserveWithGoogle = new ServiceSettingsReserveWithGoogle_Resource();
        rsServiceSettingsReserveWithGoogle.enabled = this.enabled;
        rsServiceSettingsReserveWithGoogle.priceEnabled = this.priceEnabled;
        rsServiceSettingsReserveWithGoogle.price = this.price;
        rsServiceSettingsReserveWithGoogle.description = this.description;
        return rsServiceSettingsReserveWithGoogle;
    };
    return ServiceSettingsReserveWithGoogle;
}]);
angular.module('FlexyBeautyApp.services').factory('ServiceSettingsReserveWithGoogleSrv', ["ServiceSettingsReserveWithGoogle_Resource", "ServiceSettingsReserveWithGoogle", function (ServiceSettingsReserveWithGoogle_Resource, ServiceSettingsReserveWithGoogle) {
    var ServiceSettingsReserveWithGoogleSrv = {};
    ServiceSettingsReserveWithGoogleSrv.get = function (serviceSettingsReserveWithGoogleId, successFunction, errorFunction) {
        if (serviceSettingsReserveWithGoogleId) {
            var serviceSettingReserveWithGoogleResource = new ServiceSettingsReserveWithGoogle_Resource();
            serviceSettingReserveWithGoogleResource.$get({ id: serviceSettingsReserveWithGoogleId }, //params
            function (serviceSettingsReserveWithGoogle) {
                if (successFunction) successFunction(new ServiceSettingsReserveWithGoogle(serviceSettingsReserveWithGoogle, serviceSettingsReserveWithGoogleId));
            }, function (serviceSettingsReserveWithGoogle) {
                if (errorFunction) errorFunction();
            });
        } else {
            if (errorFunction !== undefined) errorFunction();
        }
    };
    ServiceSettingsReserveWithGoogleSrv.save = function (serviceSettingsReserveWithGoogle, successFunction, errorFunction) {
        if (serviceSettingsReserveWithGoogle) {
            var serviceSettingReserveWithGoogleResource = serviceSettingsReserveWithGoogle.getObjectResource();
            serviceSettingReserveWithGoogleResource.$save({ id: serviceSettingsReserveWithGoogle.serviceSettingsReserveWithGoogleId }, //params
            function () {
                if (successFunction) successFunction();
            }, function () {
                if (errorFunction) errorFunction();
            });
        } else {
            if (errorFunction !== undefined) errorFunction();
        }
    };
    ServiceSettingsReserveWithGoogleSrv.create = function (serviceSettingsReserveWithGoogle, serviceId, successFunction, errorFunction) {
        if (serviceSettingsReserveWithGoogle) {
            var serviceSettingsReserveWithGoogleResource = serviceSettingsReserveWithGoogle.getObjectResource();
            serviceSettingsReserveWithGoogleResource.$create({ id: serviceId }, //params
            function (data) {
                if (successFunction) successFunction(data);
            }, function () {
                if (errorFunction) errorFunction();
            });
        } else {
            if (errorFunction !== undefined) errorFunction();
        }
    };
    return ServiceSettingsReserveWithGoogleSrv;
}]);
angular.module('FlexyBeautyApp.services').factory('ServiceSettingsReserveWithGoogleData', ["$log", function ($log) {
    var serviceSettingsReserveWithGoogleData = {
        serviceSettingsReserveWithGoogle: []
    };
    serviceSettingsReserveWithGoogleData.getById = function (serviceSettingsReserveWithGoogleId) {
        for (var i = 0; i < this.serviceSettingsReserveWithGoogle.length; i++) {
            if (this.serviceSettingsReserveWithGoogle[i].serviceSettingsReserveWithGoogleId == serviceSettingsReserveWithGoogleId) return this.serviceSettingsReserveWithGoogle[i];
        }return null;
    };
    serviceSettingsReserveWithGoogleData.getIndexOf = function (serviceSettingsReserveWithGoogle) {
        if (serviceSettingsReserveWithGoogle) return this.serviceSettingsReserveWithGoogle.indexOf(serviceSettingsReserveWithGoogle);
        return -1;
    };
    serviceSettingsReserveWithGoogleData.add = function (serviceSettingsReserveWithGoogle) {
        if (serviceSettingsReserveWithGoogleData.getById(serviceSettingsReserveWithGoogle.serviceSettingsReserveWithGoogleId)) {
            this.serviceSettingsReserveWithGoogle.splice(serviceSettingsReserveWithGoogleData.getById(serviceSettingsReserveWithGoogle.serviceSettingsReserveWithGoogleId), 1, serviceSettingsReserveWithGoogle);
        } else {
            this.serviceSettingsReserveWithGoogle.push(serviceSettingsReserveWithGoogle);
        }
        return this.serviceSettingsReserveWithGoogle[serviceSettingsReserveWithGoogleData.getIndexOf(serviceSettingsReserveWithGoogle)];
    };
    return serviceSettingsReserveWithGoogleData;
}]);

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('Slack_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/slack', {}, {});
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('Slack', ["Slack_Resource", function (Slack_Resource) {
    var Slack = function Slack(resource) {
        this.message = null;
    };

    Slack.prototype.getObjectResource = function () {
        var rsSlack = new Slack_Resource();
        rsSlack.message = this.message;
        return rsSlack;
    };
    return Slack;
}]);

angular.module('FlexyBeautyApp.services').factory('SlackSrv', ["$log", "Slack_Resource", "Slack", "ServerSrv", function ($log, Slack_Resource, Slack, ServerSrv) {
    var slackSrv = {};

    slackSrv.sendMessage = function (message, successFunction, errorFunction) {
        var slack = new Slack();
        slack.message = message;
        ServerSrv.startSavingProcess(slackSrv.saveSync, slack, successFunction, errorFunction);
    };
    slackSrv.save = function (slack, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(slackSrv.saveSync, slack, successFunction, errorFunction);
    };
    slackSrv.saveSync = function (slack, successFunction, errorFunction) {
        //$timeout (function () {

        var SlackRes = slack.getObjectResource();
        SlackRes.$save({}, //no params
        function (data) {
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    return slackSrv;
}]);

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('SmsCampaign_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/smsCampaigns/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getSms: { method: 'GET', isArray: true, url: baseUrl + 'rest/smsCampaigns/getSms/:id' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('SmsCampaign', ["SmsCampaign_Resource", "SmsCampaignData", "CustomerData", function (SmsCampaign_Resource, SmsCampaignData, CustomerData) {
    var SmsCampaign = function SmsCampaign(resource) {
        // Call the parent constructor
        this.id = null;
        this.isDeleted = false;
        this.label = null;
        this.subject = null;
        this.text = null;
        this.establishment = "";
        this.type = null;
        this.autoType = null;
        this.autoNb = null;
        this.sendingDate = null;
        this.status = null;
        this.customers = [];
        this.filters = [];
        this.version = null;
        if (resource !== undefined && resource != null) this.loadObject(resource);

        SmsCampaignData.add(this);
    };
    SmsCampaign.prototype.initUsingDefaults = function () {
        this.type = 'campaign';
        this.autoType = 'birthday';
        this.autoNb = 30;
        this.status = "created";
    };
    SmsCampaign.prototype.loadObject = function (object) {
        if (!this.id) this.id = object.id;
        this.isDeleted = object.isDeleted;
        this.label = object.label;
        this.subject = object.subject;
        this.text = object.text;
        this.establishment = object.establishment;
        this.type = object.type;
        this.autoType = object.autoType;
        this.autoNb = object.autoNb;
        if (object.sendingDate) this.sendingDate = new Date(object.sendingDate);
        this.status = object.status;
        this.customersId = object.customersId;
        if (object.filters) {
            for (var i = 0; i < object.filters.length; i++) {
                this.filters.push({
                    code: object.filters[i].code,
                    value: object.filters[i].value,
                    selectedItemViews: object.filters[i].selectedItemViews
                });
            }
        }
        if (object.version) {
            this.version = object.version;
        }
    };
    SmsCampaign.prototype.loadRef = function (isApplicationLoading) {
        //load ref from ids
        if (this.customersId) {
            var newCustomers = [];
            for (var i = 0; i < this.customersId.length; i++) {
                var customer = CustomerData.getById(this.customersId[i], isApplicationLoading);
                if (customer != null) newCustomers.push(customer);
            }
            this.customers = newCustomers;
        }

        delete this.customersId;
    };

    SmsCampaign.prototype.getObjectResource = function () {
        var rsSmsCampaign = new SmsCampaign_Resource();
        rsSmsCampaign.id = this.id;
        rsSmsCampaign.isDeleted = this.isDeleted;
        rsSmsCampaign.label = this.label;
        rsSmsCampaign.subject = this.subject;
        rsSmsCampaign.text = this.text;
        rsSmsCampaign.establishment = this.establishment;
        rsSmsCampaign.type = this.type;
        rsSmsCampaign.autoType = this.autoType;
        rsSmsCampaign.autoNb = this.autoNb;
        if (this.sendingDate) {
            rsSmsCampaign.sendingDate = new Date(this.sendingDate);
        }
        rsSmsCampaign.status = this.status;
        rsSmsCampaign.customersId = [];

        for (var i = 0; i < this.customers.length; i++) {
            rsSmsCampaign.customersId.push(this.customers[i].id);
        }
        rsSmsCampaign.filters = [];
        if (this.filters) {
            for (var i = 0; i < this.filters.length; i++) {
                rsSmsCampaign.filters.push({
                    code: this.filters[i].code,
                    value: this.filters[i].value,
                    selectedItemViews: this.filters[i].selectedItemViews
                });
            }
        }
        return rsSmsCampaign;
    };

    SmsCampaign.prototype.copyToObject = function (object) {
        object.id = this.id;
        object.label = this.label;
    };

    SmsCampaign.prototype.getId = function () {
        return this.id;
    };

    SmsCampaign.prototype.setId = function (id) {
        this.id = id;
    };

    return SmsCampaign;
}]);

angular.module('FlexyBeautyApp.services').factory('SmsCampaignSrv', ["$log", "SmsCampaign_Resource", "SmsCampaign", "SmsCampaignData", "UserActionData", "ServerSrv", function ($log, SmsCampaign_Resource, SmsCampaign, SmsCampaignData, UserActionData, ServerSrv) {
    var smsCampaignSrv = {};

    smsCampaignSrv.query = function (successFunction, errorFunction) {

        SmsCampaign_Resource.query({}, //params
        function (data) {
            //success
            SmsCampaignData.clear();

            for (var i = 0; i < data.length; i++) {
                new SmsCampaign(data[i]); //auto register to DATA
            }

            if (successFunction !== undefined) successFunction(SmsCampaignData.getActiveList());
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    smsCampaignSrv.getSms = function (smsCampaign, successFunction, errorFunction) {
        if (smsCampaign) {
            SmsCampaign_Resource.getSms({ id: smsCampaign.id }, //params
            function (data) {
                if (successFunction !== undefined) successFunction(data);
            }, function (data) {
                $log.error(data);
                if (errorFunction !== undefined) errorFunction(data);
            });
        } else if (errorFunction !== undefined) errorFunction();
    };

    smsCampaignSrv.restore = function (smsCampaign, successFunction, errorFunction) {
        SmsCampaignData.restore(smsCampaign);
        ServerSrv.startSavingProcess(smsCampaignSrv.restoreSync, smsCampaign, successFunction, errorFunction);
    };
    smsCampaignSrv.restoreSync = function (smsCampaign, successFunction, errorFunction) {
        //$timeout (function () {

        var smsCampaignRes = smsCampaign.getObjectResource();
        smsCampaignRes.$save({}, //no params
        function (data) {
            try {
                smsCampaign.setId(data.id);
                if (!smsCampaign.version || data.version && data.version > smsCampaign.version) smsCampaign.version = data.version;
                UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    smsCampaignSrv.save = function (smsCampaign, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(smsCampaignSrv.saveSync, smsCampaign, successFunction, errorFunction);
    };
    smsCampaignSrv.saveSync = function (smsCampaign, successFunction, errorFunction) {
        //$timeout (function () {

        var smsCampaignRes = smsCampaign.getObjectResource();
        smsCampaignRes.$save({}, //no params
        function (data) {
            try {
                smsCampaign.setId(data.id);
                UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    smsCampaignSrv.remove = function (smsCampaign, successFunction, errorFunction) {
        SmsCampaignData.remove(smsCampaign);
        ServerSrv.startSavingProcess(smsCampaignSrv.removeSync, smsCampaign, successFunction, errorFunction);
    };
    smsCampaignSrv.removeSync = function (smsCampaign, successFunction, errorFunction) {
        var smsCampaignSrv = new SmsCampaign_Resource();
        smsCampaignSrv.$remove({ id: smsCampaign.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    smsCampaignSrv.updateLocally = function (id, objectToRestore) {
        var smsCampaign = SmsCampaignData.getById(id);
        if (smsCampaign != null) {
            smsCampaign.loadObject(objectToRestore);
            smsCampaign.loadRef();
        }
        return smsCampaign;
    };
    smsCampaignSrv.removeLocally = function (id, object) {
        var smsCampaign = SmsCampaignData.getById(id);
        if (smsCampaign != null) {
            SmsCampaignData.remove(smsCampaign);
        }
        return smsCampaign;
    };
    smsCampaignSrv.addLocally = function (id, objectToRestore) {
        var smsCampaign = SmsCampaignData.getById(id);
        if (smsCampaign != null) {
            smsCampaign.loadObject(objectToRestore);
            smsCampaign.loadRef();
            SmsCampaignData.add(smsCampaign);
        }
        return smsCampaign;
    };
    smsCampaignSrv.loadRef = function (isApplicationLoading) {
        var smsCampaigns = SmsCampaignData.getActiveList();
        for (var i = 0; i < smsCampaigns.length; i++) {
            smsCampaigns[i].loadRef(isApplicationLoading);
        }
    };

    return smsCampaignSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('SmsCampaignData', ["$log", function ($log) {
    var smsCampaignDataSrv = {
        indexSmsCampaigns: [], //Never deleted (used as index)
        activeSmsCampaigns: [], //active list
        deletedSmsCampaigns: [] //deleted items
    };
    smsCampaignDataSrv.getById = function (smsCampaignId) {
        for (var i = 0; i < this.indexSmsCampaigns.length; i++) {
            if (this.indexSmsCampaigns[i].id == smsCampaignId) return this.indexSmsCampaigns[i];
        }return null;
    };
    smsCampaignDataSrv.getIndexOf = function (smsCampaign) {
        if (smsCampaign) return this.indexSmsCampaigns.indexOf(smsCampaign);
        return -1;
    };
    smsCampaignDataSrv.getByIndex = function (smsCampaignIndex) {
        if (smsCampaignIndex >= 0 && smsCampaignIndex < this.indexSmsCampaigns.length) return this.indexSmsCampaigns[smsCampaignIndex];else return null;
    };
    smsCampaignDataSrv.add = function (smsCampaign) {
        var smsCampaignArray = this.activeSmsCampaigns;
        if (smsCampaign.isDeleted) smsCampaignArray = this.deletedSmsCampaigns;
        var index = this.indexSmsCampaigns.indexOf(smsCampaign);
        if (index != -1) {
            var realIndex = smsCampaignArray.indexOf(smsCampaign);
            if (realIndex == -1) smsCampaignArray.push(smsCampaign);
        } else {
            index = this.indexSmsCampaigns.length;
            this.indexSmsCampaigns.push(smsCampaign);
            smsCampaignArray.push(smsCampaign);
        }
        return index;
    };
    smsCampaignDataSrv.remove = function (smsCampaign) //Soft Remove
    {
        var index = this.activeSmsCampaigns.indexOf(smsCampaign);
        if (index != -1) {
            this.activeSmsCampaigns.splice(index, 1);
            this.deletedSmsCampaigns.push(smsCampaign);
            smsCampaign.isDeleted = true;
        }
    };
    smsCampaignDataSrv.restore = function (smsCampaign) //Soft Remove
    {
        var index = this.deletedSmsCampaigns.indexOf(smsCampaign);
        if (index != -1) {
            this.deletedSmsCampaigns.splice(index, 1);
            this.activeSmsCampaigns.push(smsCampaign);
            smsCampaign.isDeleted = false;
        }
    };
    smsCampaignDataSrv.clear = function () {
        this.indexSmsCampaigns = [];
        this.activeSmsCampaigns = [];
        this.deletedSmsCampaigns = [];
    };
    smsCampaignDataSrv.getActiveList = function () {
        return this.activeSmsCampaigns;
    };
    smsCampaignDataSrv.getDeletedList = function () {
        return this.deletedSmsCampaigns;
    };

    return smsCampaignDataSrv;
}]);

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Supplier_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/suppliers/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }

    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('Supplier', ["Supplier_Resource", "SupplierData", function (Supplier_Resource, SupplierData) {
    var Supplier = function Supplier(resource) {
        this.id = null;
        this.isDeleted = false;
        this.label = null;
        this.lastName = null;
        this.firstName = null;
        this.email = null;
        this.isVerified = false;
        this.phone = null;
        this.password = null;
        this.address1 = null;
        this.address2 = null;
        this.city = null;
        this.postCode = null;
        this.products = []; // generate a local link to products
        this.version = null;
        this.loadObject(resource);
        SupplierData.add(this);
    };
    Supplier.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.lastName = object.lastName;
            this.firstName = object.firstName;
            this.email = object.email;
            this.isVerified = object.isVerified;
            this.phone = object.phone;
            this.landline = object.landline;
            this.address1 = object.address1;
            this.address2 = object.address2;
            this.city = object.city;
            this.postCode = object.postCode;
            if (object.version) this.version = object.version;
        }
    };
    Supplier.prototype.getObjectResource = function () {
        var rsSupplier = new Supplier_Resource();
        rsSupplier.id = this.id;
        rsSupplier.isDeleted = this.isDeleted;
        rsSupplier.label = this.label;
        rsSupplier.firstName = this.firstName;
        rsSupplier.lastName = this.lastName;
        rsSupplier.email = this.email;
        rsSupplier.isVerified = this.isVerified;
        rsSupplier.phone = this.phone;
        rsSupplier.landline = this.landline;
        rsSupplier.address1 = this.address1;
        rsSupplier.address2 = this.address2;
        rsSupplier.city = this.city;
        rsSupplier.postCode = this.postCode;

        return rsSupplier;
    };

    Supplier.prototype.getId = function () {
        return this.id;
    };
    Supplier.prototype.getLabel = function () {
        return this.firstName + ' ' + this.lastName;
    };
    Supplier.prototype.getPhone = function () {
        return this.phone;
    };
    Supplier.prototype.getEmail = function () {
        return this.email;
    };
    Supplier.prototype.setId = function (id) {
        this.id = id;
    };
    Supplier.prototype.addProduct = function (product) {
        var index = this.products.indexOf(product);
        if (index == -1) //Not already there
            {
                this.products.push(product);
            }
    };
    Supplier.prototype.removeProduct = function (product) {
        var index = this.products.indexOf(product);
        if (index != -1) //Found
            {
                this.products.splice(index, 1);
            }
    };
    return Supplier;
}]);

angular.module('FlexyBeautyApp.services').factory('SupplierSrv', ["$log", "Supplier_Resource", "UserActionData", "Supplier", "SupplierData", "ServerSrv", function ($log, Supplier_Resource, UserActionData, Supplier, SupplierData, ServerSrv) {
    var supplierSrv = {};

    supplierSrv.query = function (successFunction, errorFunction) {
        Supplier_Resource.query({}, //params
        function (data) {
            //success
            SupplierData.clear();
            for (var i = 0; i < data.length; i++) {
                new Supplier(data[i]);
            } //Auto Add to SupplierData
            if (successFunction !== undefined) successFunction(SupplierData.indexSuppliers);
        }, function (data) {
            //failure
            $log.error("Supplier_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    supplierSrv.save = function (supplier, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(supplierSrv.saveSync, supplier, successFunction, errorFunction);
    };
    supplierSrv.saveSync = function (supplier, successFunction, errorFunction) {
        //$timeout (function () {

        var SupplierRes = supplier.getObjectResource();
        SupplierRes.$save({}, //no params
        function (data) {
            try {
                supplier.setId(data.id);
                if (!supplier.version || data.version && data.version > supplier.version) supplier.version = data.version;
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    supplierSrv.remove = function (supplier, successFunction, errorFunction) {
        SupplierData.remove(supplier);
        ServerSrv.startSavingProcess(supplierSrv.removeSync, supplier, successFunction, errorFunction);
    };
    supplierSrv.removeSync = function (supplier, successFunction, errorFunction) {
        //$timeout (function () {

        var supplierSrv = new Supplier_Resource();
        supplierSrv.$remove({ id: supplier.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    supplierSrv.restore = function (supplier, successFunction, errorFunction) {
        SupplierData.restore(supplier);
        ServerSrv.startSavingProcess(supplierSrv.restoreSync, supplier, successFunction, errorFunction);
    };
    supplierSrv.restoreSync = function (supplier, successFunction, errorFunction) {
        //$timeout (function () {

        var SupplierRes = supplier.getObjectResource();
        SupplierRes.$save({}, //no params
        function (data) {
            try {
                supplier.setId(data.id);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    supplierSrv.get = function (id, successFunction, errorFunction) {
        Supplier_Resource.get({ id: id }, //params
        function (supplierResource) {
            if (successFunction != undefined) successFunction(new Supplier(supplierResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };

    supplierSrv.updateLocally = function (id, resource) {
        var supplier = SupplierData.getById(id);
        if (supplier != null) supplier.loadObject(resource);
        return supplier;
    };
    supplierSrv.removeLocally = function (id, resource) {
        var supplier = SupplierData.getById(id);
        if (supplier != null) SupplierData.remove(supplier);
        return supplier;
    };
    supplierSrv.addLocally = function (id, resource) {
        var supplier = SupplierData.getById(id);
        if (supplier != null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                supplier.loadObject(resource);
                SupplierData.add(supplier);
            } else {
            supplier = new Supplier(resource);
            supplier.id = id;
        }
        return supplier;
    };

    return supplierSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('SupplierData', ["$filter", function ($filter) {
    var custDataSrv = {
        indexSuppliers: [],
        activeSuppliers: [],
        deletedSuppliers: [] //deleted items
    };
    custDataSrv.getById = function (supplierId) {
        for (var i = 0; i < this.indexSuppliers.length; i++) {
            if (this.indexSuppliers[i].getId() == supplierId) return this.indexSuppliers[i];
        }return null;
    };
    custDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexSuppliers.length) return this.indexSuppliers[index];
        return null;
    };
    custDataSrv.getIndexOf = function (supplier) {
        if (supplier) return this.indexSuppliers.indexOf(supplier);
        return -1;
    };

    custDataSrv.add = function (supplier) {
        var supplierArray = this.activeSuppliers;
        if (supplier.isDeleted) supplierArray = this.deletedSuppliers;
        var index = this.indexSuppliers.indexOf(supplier);
        if (index != -1) {
            var realIndex = supplierArray.indexOf(supplier);
            if (realIndex == -1) supplierArray.push(supplier);
        } else {
            index = this.indexSuppliers.length;
            this.indexSuppliers.push(supplier);
            supplierArray.push(supplier);
        }
        return index;
    };
    custDataSrv.remove = function (supplier) {
        var index = this.activeSuppliers.indexOf(supplier);
        if (index != -1) {
            this.activeSuppliers.splice(index, 1);
            this.deletedSuppliers.push(supplier);
            supplier.isDeleted = true;
        }
    };
    custDataSrv.restore = function (supplier) {
        var index = this.deletedSuppliers.indexOf(supplier);
        if (index != -1) {
            this.deletedSuppliers.splice(index, 1);
            this.activeSuppliers.push(supplier);
            supplier.isDeleted = false;
        }
    };
    custDataSrv.clear = function () {
        this.indexSuppliers = [];
        this.activeSuppliers = [];
        this.deletedSuppliers = [];
    };
    custDataSrv.sort = function () {
        this.activeSuppliers = $filter('orderBy')(this.activeSuppliers, 'label', false);
        this.deletedSuppliers = $filter('orderBy')(this.deletedSuppliers, 'label', false);
    };

    custDataSrv.getActiveList = function () {
        return this.activeSuppliers;
    };
    custDataSrv.getDeletedList = function () {
        return this.deletedSuppliers;
    };
    return custDataSrv;
}]);

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('UsageProduct_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceUsageProducts = $resource(baseUrl + 'rest/usageProducts/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceUsageProducts;
}]);

angular.module('FlexyBeautyApp.services').factory('UsageProduct', ["UsageProduct_Resource", "ProductCategoryData", "ProductData", "UsageProductData", "HumanResourceData", "InternUsageProduct", function (UsageProduct_Resource, ProductCategoryData, ProductData, UsageProductData, HumanResourceData, InternUsageProduct) {
    //UsageProduct inherit from Activity
    var UsageProduct = function UsageProduct(usageProductRes, isPreviousVersion) {
        this.id = null;
        this.upNumber = null;
        this.label = null;
        this.status = null;
        this.quantity = 0;
        this.product = null;
        this.description = null;
        this.product = null;
        this.humanResource = null;
        this.price = 0;
        this.product = null;
        this.timeCreated = new Date();
        this.version = null;
        this.internUsageProducts = [];

        if (usageProductRes !== undefined && usageProductRes != null) {
            this.loadObjectProperties(usageProductRes);
            this.loadObjectInternUsageProduct(usageProductRes);
        }
        if (isPreviousVersion == undefined || !isPreviousVersion) //A previous version is not added to DATA
            UsageProductData.add(this);
    };
    UsageProduct.prototype.loadObjectProperties = function (object) {
        if (object) {
            if (!this.id) this.id = object.id;
            this.upNumber = object.upNumber;
            if (object.timeCreated) this.timeCreated = new Date(object.timeCreated);
            this.status = object.status;
            this.price = object.price;
            this.description = object.description;
            this.billNumber = object.billNumber;
            if (object.stockDate) this.stockDate = new Date(object.stockDate);
            if (object.humanResourceId) this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.version) this.version = object.version;
        }
    };

    UsageProduct.prototype.loadObject = function (object) {
        this.loadObjectProperties(object);
        this.loadObjectInternUsageProduct(object);
    };

    UsageProduct.prototype.loadRef = function (isPreviousVersion) {
        if (this.internUsageProducts) for (var i = 0; i < this.internUsageProducts.length; i++) {
            this.internUsageProducts[i].loadRef();
        }
    };

    UsageProduct.prototype.getObjectResource = function () {
        var usageProductRes = new UsageProduct_Resource();
        usageProductRes.id = this.id;
        usageProductRes.upNumber = this.upNumber;
        usageProductRes.price = this.price;
        usageProductRes.description = this.description;
        usageProductRes.status = this.status;
        usageProductRes.timeCreated = this.timeCreated;
        if (this.humanResource) usageProductRes.humanResourceId = this.humanResource.id;
        usageProductRes.internUsageProducts = [];
        for (var i = 0; i < this.internUsageProducts.length; i++) {
            usageProductRes.internUsageProducts.push(this.internUsageProducts[i].getObjectResource());
        }
        return usageProductRes;
    };

    UsageProduct.prototype.setIdUsingObject = function (object) {
        this.id = object.id;
    };

    UsageProduct.prototype.setId = function (id) {
        this.id = id;
    };

    UsageProduct.prototype.getId = function () {
        return this.id;
    };

    UsageProduct.prototype.getLabel = function () {
        return this.label;
    };

    UsageProduct.prototype.getInternUsageProductById = function (id) {
        for (var i = 0; i < this.internUsageProducts.length; i++) {
            if (this.internUsageProducts[i].id == id) return this.internUsageProducts[i];
        }return null;
    };

    UsageProduct.prototype.addInternUsageProduct = function (internUsageProduct) {
        var index = this.internUsageProducts.indexOf(internUsageProduct);
        if (index == -1) {
            this.internUsageProducts.push(internUsageProduct);
            internUsageProduct.usageProduct = this;
        }
    };

    UsageProduct.prototype.loadObjectInternUsageProduct = function (object) {
        if (object.internUsageProducts) {
            this.internUsageProducts = []; //set to 0 and reload
            for (var i = 0; i < object.internUsageProducts.length; i++) {
                this.addInternUsageProduct(new InternUsageProduct(object.internUsageProducts[i]));
            }
        }
    };

    UsageProduct.prototype.removeInternUsageProduct = function (internUsageProduct) {
        if (internUsageProduct != null) {
            var index = this.internUsageProducts.indexOf(internUsageProduct);
            if (index != -1) this.internUsageProducts.splice(index, 1);
            internUsageProduct.usageProduct = null;
        }
    };
    return UsageProduct;
}]);

angular.module('FlexyBeautyApp.services').factory('UsageProductSrv', ["$log", "ServerSrv", "UsageProductData", "UsageProduct", "UserActionData", "UsageProduct_Resource", function ($log, ServerSrv, UsageProductData, UsageProduct, UserActionData, UsageProduct_Resource) {
    var bpSrv = {};
    bpSrv.loadRef = function () {
        var usageProducts = UsageProductData.indexUsageProducts;
        for (var i = 0; i < usageProducts.length; i++) {
            usageProducts[i].loadRef();
        }
    };
    bpSrv.query = function (successFunction, errorFunction) {
        UsageProduct_Resource.query({}, //params
        function (data) {
            //success
            UsageProductData.clear();
            for (var i = 0; i < data.length; i++) {
                new UsageProduct(data[i], false);
            } //Auto Add to UsageProductData
            if (successFunction !== undefined) successFunction(UsageProductData.getActiveList());
        }, function (data) {
            //failure
            $log.error("UsageProduct_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    bpSrv.save = function (usageProduct, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(bpSrv.saveSync, usageProduct, successFunction, errorFunction);
    };
    bpSrv.saveSync = function (usageProduct, successFunction, errorFunction) {
        //$timeout (function () {

        var upRes = usageProduct.getObjectResource();
        upRes.$save({}, //no params
        function (upRes) {
            try {
                usageProduct.id = upRes.id;
                if (!usageProduct.version || upRes.version && upRes.version > usageProduct.version) usageProduct.version = upRes.version;
                if (upRes.timeCreated) usageProduct.timeCreated = new Date(upRes.timeCreated);

                if (upRes.upNumber) usageProduct.upNumber = upRes.upNumber;

                for (var j = 0; j < usageProduct.internUsageProducts.length; j++) {
                    usageProduct.internUsageProducts[j].setId(usageProduct.internUsageProducts[j].id);
                } //Add user action
                UserActionData.add(upRes.userAction);
                //CallBack on success
                if (successFunction != undefined) successFunction(upRes);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        });

        //},2000)
    };
    bpSrv.updateLocally = function (id, resource) {
        //not specific code to manage update/remove from usageProduct because this link is change only for a add or delete
        // (a usageProduct can't be moved to another usageProduct)
        //return ActivitySrv.updateLocally(resource);
        //TODO
    };
    bpSrv.removeLocally = function (id, resource) {
        return UsageProductData.getById(id);
    };
    bpSrv.addLocally = function (id, resource) {
        var usageProduct = UsageProductData.getById(id);
        if (usageProduct && usageProduct.version && resource.version && resource.version < usageProduct.version) return null;

        if (usageProduct != null) {
            usageProduct.loadObjectProperties(resource);
        } else {
            usageProduct = new UsageProduct(resource, false, false);
            usageProduct.id = id;
        }
        usageProduct.loadRef();

        return usageProduct;
    };
    bpSrv.getPreviousVersionInstance = function (resource) {
        var usageProduct = new UsageProduct(resource, true);
        return usageProduct;
    };

    return bpSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('UsageProductData', ["$log", function ($log) {
    var usageProductData = {
        indexUsageProducts: []
    };
    usageProductData.getById = function (usageProductId) {
        for (var i = 0; i < this.indexUsageProducts.length; i++) {
            if (this.indexUsageProducts[i].id == usageProductId) return this.indexUsageProducts[i];
        }return null;
    };
    usageProductData.getIndexOf = function (usageProduct) {
        if (usageProduct) return this.indexUsageProducts.indexOf(usageProduct);
        return -1;
    };
    usageProductData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexUsageProducts.length) return this.indexUsageProducts[index];else return null;
    };
    usageProductData.add = function (usageProduct) {
        this.indexUsageProducts.push(usageProduct);
        return this.indexUsageProducts.length - 1;
    };
    usageProductData.clear = function () {
        usageProductData.indexUsageProducts = [];
    };
    usageProductData.getActiveList = function () {
        return this.indexUsageProducts;
    };

    return usageProductData;
}]);

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Vat_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/vats/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }

    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('Vat', ["Vat_Resource", "VatData", function (Vat_Resource, VatData) {
    var Vat = function Vat(resource) {
        this.id = null;
        this.isDeleted = false;
        this.code = null;
        this.tax = null;
        this.isDefault = null;
        this.isUsable = null;
        this.version = null;
        this.loadObject(resource);
        VatData.add(this);
    };
    Vat.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.code = object.code;
            this.tax = object.tax;
            this.isDefault = object.isDefault;
            this.isUsable = object.isUsable;
            if (object.version) this.version = object.version;
        }
    };
    Vat.prototype.getObjectResource = function () {
        var rsVat = new Vat_Resource();
        rsVat.id = this.id;
        rsVat.isDeleted = this.isDeleted;
        rsVat.code = this.code;
        rsVat.tax = this.tax;
        rsVat.isDefault = this.isDefault;
        rsVat.isUsable = this.isUsable;
        return rsVat;
    };

    Vat.prototype.getId = function () {
        return this.id;
    };

    Vat.prototype.setId = function (id) {
        this.id = id;
    };

    return Vat;
}]);

angular.module('FlexyBeautyApp.services').factory('VatSrv', ["$log", "Vat_Resource", "UserActionData", "Vat", "VatData", "ServerSrv", function ($log, Vat_Resource, UserActionData, Vat, VatData, ServerSrv) {
    var vatSrv = {};

    vatSrv.query = function (successFunction, errorFunction) {
        Vat_Resource.query({}, //params
        function (data) {
            //success
            VatData.clear();
            for (var i = 0; i < data.length; i++) {
                new Vat(data[i]);
            } //Auto Add to VatData
            if (successFunction !== undefined) successFunction(VatData.indexVats);
        }, function (data) {
            //failure
            $log.error("Vat_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    vatSrv.save = function (vat, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(vatSrv.saveSync, vat, successFunction, errorFunction);
    };
    vatSrv.saveSync = function (vat, successFunction, errorFunction) {
        //$timeout (function () {

        var VatRes = vat.getObjectResource();
        VatRes.$save({}, //no params
        function (data) {
            try {
                vat.setId(data.id);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    vatSrv.remove = function (vat, successFunction, errorFunction) {
        VatData.remove(vat);
        ServerSrv.startSavingProcess(vatSrv.removeSync, vat, successFunction, errorFunction);
    };
    vatSrv.removeSync = function (vat, successFunction, errorFunction) {
        //$timeout (function () {

        var vatSrv = new Vat_Resource();
        vatSrv.$remove({ id: vat.getId() }, //params : id
        function (data) {
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    vatSrv.restore = function (vat, successFunction, errorFunction) {
        VatData.restore(vat);
        ServerSrv.startSavingProcess(vatSrv.restoreSync, vat, successFunction, errorFunction);
    };
    vatSrv.restoreSync = function (vat, successFunction, errorFunction) {
        //$timeout (function () {

        var VatRes = vat.getObjectResource();
        VatRes.$save({}, //no params
        function (data) {
            try {
                vat.setId(data.id);
                if (!vat.version || data.version && data.version > vat.version) vat.version = data.version;
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    vatSrv.get = function (id, successFunction, errorFunction) {
        Vat_Resource.get({ id: id }, //params
        function (vatResource) {
            if (successFunction != undefined) successFunction(new Vat(vatResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };

    vatSrv.updateLocally = function (id, resource) {
        var vat = VatData.getById(id);
        if (vat != null) vat.loadObject(resource);
        return vat;
    };
    vatSrv.removeLocally = function (id, resource) {
        var vat = VatData.getById(id);
        if (vat != null) VatData.remove(vat);
        return vat;
    };
    vatSrv.addLocally = function (id, resource) {
        var vat = VatData.getById(id);
        if (vat != null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                vat.loadObject(resource);
                VatData.add(vat);
            } else {
            vat = new Vat(resource);
            vat.id = id;
        }
        return vat;
    };

    return vatSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('VatData', ["$filter", function ($filter) {
    var vatDataSrv = {
        indexVats: [],
        activeVats: [],
        deletedVats: [] //deleted items
    };
    vatDataSrv.getById = function (vatId) {
        for (var i = 0; i < this.indexVats.length; i++) {
            if (this.indexVats[i].getId() == vatId) return this.indexVats[i];
        }return null;
    };
    vatDataSrv.getDefaultVat = function () {
        for (var i = 0; i < this.indexVats.length; i++) {
            if (this.indexVats[i].isDefault) return this.indexVats[i];
        }return null;
    };
    vatDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexVats.length) return this.indexVats[index];
        return null;
    };
    vatDataSrv.getIndexOf = function (vat) {
        if (vat) return this.indexVats.indexOf(vat);
        return -1;
    };

    vatDataSrv.add = function (vat) {
        var vatArray = this.activeVats;
        if (vat.isDeleted) vatArray = this.deletedVats;
        var index = this.indexVats.indexOf(vat);
        if (index != -1) {
            var realIndex = vatArray.indexOf(vat);
            if (realIndex == -1) vatArray.push(vat);
        } else {
            index = this.indexVats.length;
            this.indexVats.push(vat);
            vatArray.push(vat);
        }
        return index;
    };
    vatDataSrv.remove = function (vat) {
        var index = this.activeVats.indexOf(vat);
        if (index != -1) {
            this.activeVats.splice(index, 1);
            this.deletedVats.push(vat);
            vat.isDeleted = true;
        }
    };
    vatDataSrv.restore = function (vat) {
        var index = this.deletedVats.indexOf(vat);
        if (index != -1) {
            this.deletedVats.splice(index, 1);
            this.activeVats.push(vat);
            vat.isDeleted = false;
        }
    };
    vatDataSrv.clear = function () {
        this.indexVats = [];
        this.activeVats = [];
        this.deletedVats = [];
    };
    vatDataSrv.sort = function () {
        this.activeVats = $filter('orderBy')(this.activeVats, 'code', false);
        this.deletedVats = $filter('orderBy')(this.deletedVats, 'code', false);
    };

    vatDataSrv.getActiveList = function () {
        return this.activeVats;
    };
    vatDataSrv.getDeletedList = function () {
        return this.deletedVats;
    };
    return vatDataSrv;
}]);

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Style', function () {

    var Style = function Style(label) {
        this.label = label;
    };

    return Style;
});
angular.module('FlexyBeautyApp.services').factory('StyleData', ["Style", function (Style) {
    var styleData = { styles: [] };

    styleData.get = function (styleLabel) {
        for (var i = 0; i < this.styles.length; i++) {
            if (this.styles[i].label == styleLabel) return this.styles[i];
        }return null;
    };
    styleData.add = function (image) {
        this.styles.push(image);
    };
    styleData.remove = function (image) {
        var index = this.styles.indexOf(image);
        if (index != -1) this.styles.splice(index, 1);
    };
    styleData.clear = function () {
        this.styles = [];
    };

    //INIT
    styleData.add(new Style("default")); //grey
    styleData.add(new Style("white"));
    styleData.add(new Style("black"));
    styleData.add(new Style("pink"));
    styleData.add(new Style("purple"));
    styleData.add(new Style("blue"));
    styleData.add(new Style("light-blue"));
    styleData.add(new Style("green"));
    styleData.add(new Style("yellow"));
    styleData.add(new Style("brown"));
    styleData.add(new Style("orange"));
    styleData.add(new Style("red"));

    return styleData;
}]);

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Helper', ["$timeout", function ($timeout) {

    var helper = {
        displayStartWindow: "init",
        managerMode: true
    };

    return helper;
}]);

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Loader', ["$log", "$timeout", "$http", "VatSrv", "OtherPaymentTypeSrv", "SiteSrv", "HumanResourceSrv", "PhysicalResourceSrv", "CategorySrv", "ProductCategorySrv", "CureCategorySrv", "LoyaltyCardCategorySrv", "ServiceSrv", "ProductSrv", "CureSrv", "LoyaltyCardSrv", "CustomerSrv", "SupplierSrv", "ImageSrv", "Site", "HumanResource", "PhysicalResource", "Category", "ProductCategory", "CureCategory", "Image", "CompanyImageSrv", "CompanyImage", "CompanyImageData", "SaleSrv", "SaleData", "BookingSrv", "BookingData", "AppSrv", "App", "UserSrv", "StoreAppSrv", "CompanySrv", "CategoryData", "DaySrv", "DayData", "SiteData", "ImageData", "CureItemToServiceSrv", "CureItemToServiceUsageSrv", "Vat", "OrderSrv", "UsageProductSrv", "CheckDepositSrv", "ProductCategoryData", "CureCategoryData", "LoyaltyCardCategoryData", "LoyaltyCardCategory", "CustomerData", "AuditTrailSrv", "ReportModelSrv", "CurrencySrv", "CustomerPost", "CustomerPostData", "MeasureStore", "TimeMeasures", "Decorators", "CountMeasures", "ActivityData", "LanguageManager", "LaunchDarklyFeatureFlagData", "$location", "Constants", "LoaderUtil", "MonitoringSrv", "MonitoringApplication", "MonitoringHealthState", "OfferService", "DayHrData", "DayPrData", "SaleServiceData", "SaleProductData", "SaleCureData", "GiftItemData", "LoyaltyCardItemData", "CheckDepositData", "CompanyMigrationSettingsSrv", function ($log, $timeout, $http, VatSrv, OtherPaymentTypeSrv, SiteSrv, HumanResourceSrv, PhysicalResourceSrv, CategorySrv, ProductCategorySrv, CureCategorySrv, LoyaltyCardCategorySrv, ServiceSrv, ProductSrv, CureSrv, LoyaltyCardSrv, CustomerSrv, SupplierSrv, ImageSrv, Site, HumanResource, PhysicalResource, Category, ProductCategory, CureCategory, Image, CompanyImageSrv, CompanyImage, CompanyImageData, SaleSrv, SaleData, BookingSrv, BookingData, AppSrv, App, UserSrv, StoreAppSrv, CompanySrv, CategoryData, DaySrv, DayData, SiteData, ImageData, CureItemToServiceSrv, CureItemToServiceUsageSrv, Vat, OrderSrv, UsageProductSrv, CheckDepositSrv, ProductCategoryData, CureCategoryData, LoyaltyCardCategoryData, LoyaltyCardCategory, CustomerData, AuditTrailSrv, ReportModelSrv, CurrencySrv, CustomerPost, CustomerPostData, MeasureStore, TimeMeasures, Decorators, CountMeasures, ActivityData, LanguageManager, LaunchDarklyFeatureFlagData, $location, Constants, LoaderUtil, MonitoringSrv, MonitoringApplication, MonitoringHealthState, OfferService, DayHrData, DayPrData, SaleServiceData, SaleProductData, SaleCureData, GiftItemData, LoyaltyCardItemData, CheckDepositData, CompanyMigrationSettingsSrv) {

    var useHashMapForApplicationLoading = true;
    var loader = {
        loggedUserLoading: false,
        storeAppLoading: false,
        vatsLoading: false,
        optsLoading: false,
        sitesLoading: false,
        humanResourcesLoading: false,
        physicalResourcesLoading: false,
        categoriesLoading: false,
        productCategoriesLoading: false,
        productLoading: false,
        cureCategoriesLoading: false,
        cureLoading: false,
        loyaltyCardCategoriesLoading: false,
        loyaltyCardLoading: false,
        servicesLoading: false,
        customersLoading: false,
        customersDeletedLoading: false,
        ordersLoading: false,
        usageProductsLoading: false,
        checkDepositsLoading: false,
        suppliersLoading: false,
        imagesLoading: false,
        companyImagesLoading: false,
        daysLoading: false,
        resourceDays: [],
        resourceStartupDays: {},
        resourceOtherDays: {},
        loadSuccess: true,
        backOfficeRefLoading: false,
        backOfficeLoaded: false,
        loaded: false,
        appLoading: false,
        forceReload: false,
        securityError: false,
        reportsModelLoading: false,
        currencyLoading: false,
        companyMigrationSettingsLoading: false,
        newLoadingProgress: {
            customers: false,
            deletedCustomers: false,
            startupLoadedDays: false,
            allDays: false
        },
        languageManagerLoading: false,
        unauthorizedUser: false,
        offerLoading: false
    };

    loader.loadBackOfficeDependencies = Decorators.timeMeasureDecorator(function () {
        HumanResourceSrv.loadRef(CategoryData.categoryRoot);
        PhysicalResourceSrv.loadRef(CategoryData.categoryRoot);
        CategorySrv.loadRef();
        ProductCategorySrv.loadRef();
        ServiceSrv.loadRef();
        ProductSrv.loadRef();
        CureCategorySrv.loadRef();
        CureSrv.loadRef();
        LoyaltyCardCategorySrv.loadRef();
        LoyaltyCardSrv.loadRef(useHashMapForApplicationLoading);
        CompanySrv.loadRef();
        OrderSrv.loadRef();
        UsageProductSrv.loadRef();
        loader.backOfficeLoaded = true;
    }, TimeMeasures.BACKOFFICE_DEPENDENCIES_LOADING);

    loader.loadDaysDependencies = Decorators.timeMeasureDecorator(function () {
        SaleSrv.loadRef(useHashMapForApplicationLoading);
        BookingSrv.loadRef(useHashMapForApplicationLoading);
        CureItemToServiceSrv.loadRef();
        CureItemToServiceUsageSrv.loadRef(useHashMapForApplicationLoading);
    }, TimeMeasures.DAYS_DEPENDENCIES_LOADING);

    loader.isCoreLoadingFinished = function () {
        return !loader.loggedUserLoading && !loader.storeAppLoading && !loader.appLoading && !loader.currencyLoading && !loader.companyMigrationSettingsLoading && !loader.vatsLoading && !loader.optsLoading && !loader.siteLoading && !loader.humanResourcesLoading && !loader.physicalResourcesLoading && !loader.categoriesLoading && !loader.servicesLoading && !loader.productCategoriesLoading && !loader.productLoading && !loader.cureCategoriesLoading && !loader.cureLoading && !loader.loyaltyCardCategoriesLoading && !loader.loyaltyCardLoading && !loader.ordersLoading && !loader.usageProductsLoading && !loader.checkDepositsLoading && !loader.suppliersLoading && !loader.imagesLoading && !loader.companyImagesLoading && !loader.reportsModelLoading && !loader.languageManagerLoading && !loader.offerLoading;
    };

    loader.newAfterLoad = function (success, successFunction, errorFunction, doneFunction) {
        loader.loadSuccess = loader.loadSuccess && success;

        // Light day load
        if (!this.daysLoading) {
            this.daysLoading = true;
            DaySrv.newLoadResourceDays(loader.resourceStartupDays, useHashMapForApplicationLoading);
            loader.loadDaysDependencies();
            loader.convertMapsToArrays(true, true);
            loader.newLoadingProgress.startupLoadedDays = true;
        }

        if (!loader.customersDeletedLoading && !loader.newLoadingProgress.deletedCustomers) {
            loader.newLoadingProgress.deletedCustomers = true;
        }

        if (!loader.customersLoading && !loader.newLoadingProgress.customers) {
            loader.newLoadingProgress.customers = true;
        }

        if (loader.allDaysLoaded && !loader.customersDeletedLoading && !loader.customersLoading && loader.isCoreLoadingFinished()) {
            loader.clearLightDaysData();
            DaySrv.newLoadResourceDays(loader.resourceOtherDays, useHashMapForApplicationLoading, loader.resourceStartupDays);
            loader.loadDaysDependencies();

            AuditTrailSrv.createAndSave("80");

            CustomerData.convertMapToArray(false, true);

            loader.convertMapsToArrays(false, true);

            loader.newLoadingProgress.allDays = true;

            if (typeof doneFunction === "function") {
                doneFunction();
            }
        }

        if (!loader.loaded) {
            if (loader.isCoreLoadingFinished() && loader.newLoadingProgress.startupLoadedDays) {
                if (loader.loadSuccess) {
                    if (!loader.backOfficeLoaded && !loader.backOfficeRefLoading) {
                        MeasureStore.registerEnd(TimeMeasures.MODEL_LOADING);
                        loader.backOfficeRefLoading = true;
                        loader.loadBackOfficeDependencies();
                    }

                    if (loader.backOfficeLoaded) {
                        if (successFunction != undefined) successFunction();
                    }
                } else {
                    if (errorFunction != undefined) {
                        errorFunction(loader.securityError, loader.unauthorizedUser);
                    }
                }
                loader.loaded = true;
            }
        }

        if (loader.loaded && loader.allDaysLoaded && !loader.customersDeletedLoading && !loader.customersLoading) {
            MeasureStore.registerEnd(TimeMeasures.AFTER_LOADING_STARTUP_REMAINING_TIME);
            MonitoringSrv.logHealth(MonitoringApplication.PROBACKOFFICE, MonitoringHealthState.OK, JSON.stringify(MeasureStore));
        }
    };

    loader.clearLightDaysData = function () {
        DayData.clear();
        DayHrData.clear();
        DayPrData.clear();
        BookingData.clear();
        ActivityData.clear(true);
        SaleData.clear();
        SaleServiceData.clear();
        SaleProductData.clear();
        SaleCureData.clear();
        GiftItemData.clear();
        LoyaltyCardItemData.clear();
        CustomerData.clearBookingsAndSales();
        CheckDepositData.clearSalePayments();
    };

    loader.afterLoad = function (success, successFunction, errorFunction, doneFunction) {
        var canAccessNewLoading = LaunchDarklyFeatureFlagData.canAccessNewLoading;
        if (canAccessNewLoading) {
            loader.newAfterLoad(success, successFunction, errorFunction, doneFunction);
        } else {
            /*call everytime a resource is loaded : Can be called in parralel !
            scenario 1 : all backoffice loaded before start of this function for dayloaded
            scenario 2 : dayloaded before backoffice loaded at the start of the function
            scenario 3 : all backoffice loading! (loadref) when function called by dayloaded*/
            loader.loadSuccess = loader.loadSuccess && success;
            if (loader.isCoreLoadingFinished() && !loader.customersLoading && !loader.customersDeletedLoading) {

                if (loader.loadSuccess) {

                    if (!loader.backOfficeLoaded && !loader.backOfficeRefLoading) {
                        MeasureStore.registerEnd(TimeMeasures.MODEL_LOADING);
                        loader.backOfficeRefLoading = true;
                        loader.loadBackOfficeDependencies();
                    }

                    //If days loaded
                    if (!loader.daysLoading && loader.resourceDays && loader.backOfficeLoaded) {
                        DaySrv.loadResourceDays(loader.resourceDays, useHashMapForApplicationLoading);
                        loader.loadDaysDependencies();
                        AuditTrailSrv.createAndSave("80");

                        loader.convertMapsToArrays();
                        if (successFunction != undefined) successFunction();
                    }
                } else {
                    if (errorFunction != undefined) {
                        errorFunction(loader.securityError, loader.unauthorizedUser);
                    }
                }
                loader.loaded = true;
            }
        }
    };

    loader.load = function (successFunction, errorFunction, doneFunction) {
        var canAccessNewLoading = LaunchDarklyFeatureFlagData.canAccessNewLoading;

        MeasureStore.registerStart(TimeMeasures.MODEL_LOADING);
        if (loader.loaded) {
            if (successFunction != undefined) successFunction();
            return;
        }

        if (loader.loggedUserLoading || loader.storeAppLoading || loader.appLoading || loader.currencyLoading || loader.companyMigrationSettingsLoading || loader.vatsLoading || loader.optsLoading || loader.siteLoading || loader.humanResourcesLoading || loader.physicalResourcesLoading || loader.categoriesLoading || loader.servicesLoading || loader.productCategoriesLoading || loader.productLoading || loader.cureCategoriesLoading || loader.cureLoading || loader.loyaltyCardCategoriesLoading || loader.loyaltyCardLoading || loader.customersLoading || loader.customersDeletedLoading || loader.ordersLoading || loader.usageProductsLoading || loader.checkDepositsLoading || loader.suppliersLoading || loader.imagesLoading || loader.companyImagesLoading || loader.reportsModelLoading || loader.daysLoading || loader.languageManagerLoading) {
            // load already in process
            return;
        }

        loader.allDaysLoaded = false;
        loader.loggedUserLoading = true;
        loader.storeAppLoading = true;
        loader.appLoading = true;
        loader.currencyLoading = true;
        loader.companyMigrationSettingsLoading = true;
        loader.vatLoading = true;
        loader.optsLoading = true;
        loader.siteLoading = true;
        loader.humanResourcesLoading = true;
        loader.physicalResourcesLoading = true;
        loader.categoriesLoading = true;
        loader.servicesLoading = true;
        loader.productCategoriesLoading = true;
        loader.productLoading = true;
        loader.cureCategoriesLoading = true;
        loader.cureLoading = true;
        loader.loyaltyCardCategoriesLoading = true;
        loader.loyaltyCardLoading = true;
        loader.customersLoading = true;
        loader.customersDeletedLoading = true;
        loader.ordersLoading = true;
        loader.usageProductsLoading = true;
        loader.checkDepositsLoading = true;
        loader.suppliersLoading = true;
        loader.imagesLoading = true;
        loader.companyImagesLoading = true;
        loader.reportsModelLoading = true;
        loader.daysLoading = true;
        loader.languageManagerLoading = true;
        loader.offerLoading = true;

        OfferService.findAll().then(function (data) {
            OfferService.allOffers = data;
            loader.offerLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        }).catch(function (error) {
            if (error && error.status !== 200) {
                loader.securityError = true;
            }
            loader.offerLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        UserSrv.loadLoggedUser(function (user) {
            loader.loggedUserLoading = false;
            LanguageManager.initAcceptLanguage(user).then(function () {
                loader.languageManagerLoading = false;
                loader.afterLoad(true, successFunction, errorFunction, doneFunction);
            }, function () {
                loader.languageManagerLoading = false;
                loader.afterLoad(false, successFunction, errorFunction);
            });
        }, function (data) {
            if (data && data.status == 403) {
                loader.securityError = true;
            }
            if (data && data.status == 401 && data.data && data.data.message === "AUTHORIZATION_FAILURE_COMPANY_TYPE_CANCELED") {
                loader.unauthorizedUser = true;
            }
            loader.loggedUserLoading = false;
            loader.languageManagerLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        StoreAppSrv.query(function (data) {
            loader.storeAppLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        }, function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.storeAppLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        AppSrv.query(function (data) {
            loader.appLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        }, function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.appLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        CompanyMigrationSettingsSrv.query(function () {
            loader.companyMigrationSettingsLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        }, function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.companyMigrationSettingsLoading = false;
            var success = data && data.status == 404 ? true : false;
            loader.afterLoad(success, successFunction, errorFunction);
        });

        CurrencySrv.query(
        //Success function after load
        function (data) {
            loader.currencyLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.currencyLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        VatSrv.query(
        //Success function after load
        function (data) {
            loader.vatsLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.vatsLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        OtherPaymentTypeSrv.query(
        //Success function after load
        function (data) {
            loader.optsLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.optsLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        SiteSrv.query(
        //Success function after load
        function (data) {
            loader.siteLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.siteLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        }, useHashMapForApplicationLoading);

        HumanResourceSrv.query(
        //Success function after load
        function (data) {
            loader.humanResourcesLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.humanResourcesLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        PhysicalResourceSrv.query(
        //Success function after load
        function (humanResources) {
            loader.physicalResourcesLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.physicalResourcesLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        CategorySrv.query(
        //Success function after load
        function (data) {
            loader.categoriesLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.categoriesLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        ServiceSrv.query(
        //Success function after load
        function (data) {
            loader.servicesLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.servicesLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        ProductCategorySrv.query(
        //Success function after load
        function (data) {
            loader.productCategoriesLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.productCategoriesLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        ProductSrv.query(
        //Success function after load
        function (data) {
            loader.productLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.productLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        CureCategorySrv.query(
        //Success function after load
        function (data) {
            loader.cureCategoriesLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.cureCategoriesLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        CureSrv.query(
        //Success function after load
        function (data) {
            loader.cureLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.cureLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        LoyaltyCardCategorySrv.query(
        //Success function after load
        function (data) {
            loader.loyaltyCardCategoriesLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.loyaltyCardCategoriesLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        LoyaltyCardSrv.query(
        //Success function after load
        function (data) {
            loader.loyaltyCardLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.loyaltyCardLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        if (!canAccessNewLoading) {
            CustomerData.clear();
            CustomerSrv.loadCustomers(useHashMapForApplicationLoading).then(function () {
                loader.customersLoading = false;
                loader.afterLoad(true, successFunction, errorFunction);
            }, function (data) {
                if (data && data.status == 403) loader.securityError = true;
                loader.customersLoading = false;
                loader.afterLoad(false, successFunction, errorFunction);
            });

            CustomerSrv.loadDeletedCustomersMaster(null, useHashMapForApplicationLoading).then(function () {
                loader.customersDeletedLoading = false;
                loader.afterLoad(true, successFunction, errorFunction);
            }, function (data) {
                if (data && data.status == 403) loader.securityError = true;
                loader.customersDeletedLoading = false;
                loader.afterLoad(true, successFunction, errorFunction);
            });
        }

        OrderSrv.query(
        //Success function after load
        function (data) {
            loader.ordersLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.ordersLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        UsageProductSrv.query(
        //Success function after load
        function (data) {
            loader.usageProductsLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.usageProductsLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        CheckDepositSrv.query(
        //Success function after load
        function (data) {
            loader.checkDepositsLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.checkDepositsLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        SupplierSrv.query(
        //Success function after load
        function (data) {
            loader.suppliersLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.suppliersLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });
        ImageSrv.query(
        //Success function after load
        function (data) {
            loader.imagesLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.imagesLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        CompanyImageSrv.query(
        //Success function after load
        function (data) {
            loader.companyImagesLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.companyImagesLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        ReportModelSrv.query(
        //Success function after load
        function (data) {
            loader.reportsModelLoading = false;
            loader.afterLoad(true, successFunction, errorFunction, doneFunction);
        },
        //Error function after load
        function (data) {
            if (data && data.status == 403) loader.securityError = true;
            loader.reportsModelLoading = false;
            loader.afterLoad(false, successFunction, errorFunction);
        });

        if (canAccessNewLoading) {
            DaySrv.listDaysId().then(function (daysId) {
                var nbSecondsInDay = Constants.SECONDS_IN_A_DAY;
                var now = Date.now();
                var firstStartupLoadedDay = DaySrv.getIdFromDate(new Date(now - Constants.NB_STARTUP_LOADED_DAYS * nbSecondsInDay));
                var lastStartupLoadedDay = DaySrv.getIdFromDate(new Date(now + Constants.NB_STARTUP_LOADED_DAYS * nbSecondsInDay));

                var startupLoadedDayIds = [].concat(_toConsumableArray(new Set([firstStartupLoadedDay].concat(_toConsumableArray(daysId.filter(function (id) {
                    return id > firstStartupLoadedDay && id < lastStartupLoadedDay;
                })), [lastStartupLoadedDay]))));

                loader.newLoadDaysMaster(startupLoadedDayIds, function (loaders) {
                    return loader.resourceStartupDays = loader.newFinalizeDaysLoading(loaders);
                }).then(function () {
                    loader.daysLoading = false;
                    loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                }, function (error) {
                    console.log(error);
                    loader.afterLoad(false, successFunction, errorFunction);
                });

                loader.newLoadDaysMaster(daysId, function (loaders) {
                    return loader.resourceOtherDays = loader.newFinalizeDaysLoading(loaders);
                }).then(function () {
                    loader.allDaysLoaded = true;
                    loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                }, function (error) {
                    console.log(error);
                    loader.afterLoad(false, successFunction, errorFunction);
                });

                CustomerSrv.loadCustomers(useHashMapForApplicationLoading).then(function () {
                    loader.customersLoading = false;
                    loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                }, function (data) {
                    if (data && data.status === 403) {
                        loader.securityError = true;
                    }
                    loader.customersLoading = false;
                    loader.afterLoad(false, successFunction, errorFunction);
                });

                CustomerSrv.loadDeletedCustomersMaster(null, useHashMapForApplicationLoading).then(function () {
                    loader.customersDeletedLoading = false;
                    loader.afterLoad(true, successFunction, errorFunction, doneFunction);
                }, function (data) {
                    if (data && data.status === 403) {
                        loader.securityError = true;
                    }
                    loader.customersDeletedLoading = false;
                    loader.afterLoad(true, successFunction, errorFunction);
                });
            });
        } else {
            loader.loadDaysMaster().then(function () {
                loader.afterLoad(true, successFunction, errorFunction);
            }, function (error) {
                loader.afterLoad(false, successFunction, errorFunction);
            });
        }
    };

    loader.newLoadDaysMaster = function (daysId, finalizeLoadingFunction) {
        var end = void 0;
        var promises = [];
        var loaders = LoaderUtil.computeLoaders(daysId);
        for (var i = 0; i < loaders.length; i++) {
            end = loaders[i].daysId[loaders[i].daysId.length - 1];
            promises.push(loader.newLoadDays(loaders[i], loaders[i].daysId[0], end));
        }
        return Promise.all(promises).then(function () {
            if (finalizeLoadingFunction) {
                finalizeLoadingFunction(loaders);
            }
        }, function (error) {
            throw error;
        });
    };

    loader.loadDaysMaster = Decorators.timeMeasureDecorator(function () {
        return DaySrv.listDaysId().then(function (daysId) {
            var loaders = [{ loading: true, daysId: [], days: [] }];
            var j = 0;
            var size = 122; //3 by year

            for (var i = 0; i < daysId.length; i++) {
                if (!isNaN(daysId[i]) && daysId[i] > 20000000) {
                    loaders[j].daysId.push(daysId[i]);
                }

                if ((i + 1) % size === 0 && i + 1 < daysId.length) {
                    loaders.push({ loading: true, daysId: [], days: [] });
                    j++;
                }
            }

            var end = void 0;
            var promises = [];
            for (var _i = 0; _i < loaders.length; _i++) {
                if (_i === loaders.length - 1) {
                    //last query get all
                    end = 30000101;
                } else {
                    end = loaders[_i].daysId[loaders[_i].daysId.length - 1];
                }
                promises.push(loader.loadDays(loaders[_i], loaders[_i].daysId[0], end));
            }
            return Promise.all(promises).then(function () {
                loader.daysLoading = false;
                loader.finalizeLoading(loaders);
            }, function (error) {
                loader.daysLoading = false;
                throw error;
            });
        }, function (error) {
            if (error && error.status == 403) loader.securityError = true;
            loader.daysLoading = false;
        });
    }, TimeMeasures.DAYS_LOADING);

    loader.finalizeLoading = function (loaders) {
        for (var i = 0; i < loaders.length; i++) {
            loader.resourceDays = loader.resourceDays.concat(loaders[i].days);
        }
    };

    loader.newFinalizeDaysLoading = function (loaders) {
        var dayResources = [];
        for (var i = 0; i < loaders.length; i++) {
            dayResources = dayResources.concat(loaders[i].days);
        }
        dayResources = dayResources.sort(function (day1, day2) {
            return day1.id - day2.id;
        });

        var dayResourceByDayId = [];
        for (var _i2 = 0; _i2 < dayResources.length; _i2++) {
            dayResourceByDayId[dayResources[_i2].id] = dayResources[_i2];
        }

        return dayResourceByDayId;
    };

    loader.newLoadDays = function (loaderObject, startDayId, endDayId) {
        if (window.Worker) {
            return new Promise(function (resolve) {
                var token = $http.defaults.headers.common.Authorization;
                var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";

                var url = baseUrl + ('rest/days/' + startDayId + '/' + endDayId);
                try {
                    var daysWorker = new Worker('/dist/workers/days.worker.js');
                    daysWorker.postMessage([url, token]);

                    daysWorker.onmessage = function (e) {
                        var result = e.data;
                        loaderObject.days = loaderObject.days.concat(result.days);

                        daysWorker.terminate();
                        if (result.stillDayToLoad && result.days && result.days.length > 0) {
                            loaderObject.loading = true;
                            var lastDate = DaySrv.getDateFromId(result.days[result.days.length - 1].id);
                            lastDate.setDate(lastDate.getDate() + 1);
                            var newStartDayId = DaySrv.getIdFromDate(lastDate);
                            return resolve(loader.newLoadDays(loaderObject, newStartDayId, endDayId));
                        }
                        loaderObject.loading = false;
                        return resolve();
                    };
                } catch (e) {
                    if (window.bugsnag) {
                        bugsnag.notify("Loader.js - failed to create days worker", "", {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
                    }
                    return loader.loadDays(loaderObject, startDayId, endDayId);
                }
            });
        } else {
            return loader.loadDays(loaderObject, startDayId, endDayId);
        }
    };

    loader.loadDays = function (loaderObj, startDayId, endDayId) {
        return DaySrv.queryBasedDays(startDayId, endDayId).then(function (data) {
            if (data && data.stillDayToLoad && data.days && data.days.length > 0) {
                MeasureStore.registerCount(CountMeasures.NUMBER_STILL_DAY_TO_LOAD);
                loaderObj.days = loaderObj.days.concat(data.days);
                var lastDate = DaySrv.getDateFromId(data.days[data.days.length - 1].id);
                lastDate.setDate(lastDate.getDate() + 1);
                var lastId = DaySrv.getIdFromDate(lastDate);
                return loader.loadDays(loaderObj, lastId, endDayId);
            } else {
                loaderObj.days = loaderObj.days.concat(data.days);
                loaderObj.loading = false;
            }
        },
        //Error function after load
        function (error) {
            if (error && error.status == 403) loader.securityError = true;
            throw new Error("Error during days loading, startId : " + startDayId + " endId : " + endDayId);
        });
    };
    //FIXME : not used, need to be delete
    loader.loadProSiteData = function (proSiteData, successFunction, errorFunction) {
        SiteData.sites.push(new Site(proSiteData.defaultSite));
        if (SiteData.sites.length > 0) SiteData.defaultSite = SiteData.sites[0];

        if (proSiteData.humanResources) for (var i = 0; i < proSiteData.humanResources.length; i++) {
            new HumanResource(proSiteData.humanResources[i]);
        } //auto register to DATA

        if (proSiteData.physicalResources) for (var i = 0; i < proSiteData.physicalResources.length; i++) {
            new PhysicalResource(proSiteData.physicalResources[i]);
        } //auto register to DATA

        CategoryData.categoryRoot = new Category(proSiteData.categoryRoot);

        if (proSiteData.images) for (var i = 0; i < proSiteData.images.length; i++) {
            ImageData.add(new Image(proSiteData.images[i]));
        }if (proSiteData.companyImages) for (var i = 0; i < proSiteData.companyImages.length; i++) {
            CompanyImageData.add(new CompanyImage(proSiteData.companyImages[i]));
        }if (proSiteData.apps) for (var i = 0; i < proSiteData.apps.length; i++) {
            new App(proSiteData.apps[i]);
        }HumanResourceSrv.loadRef(CategoryData.categoryRoot);
        PhysicalResourceSrv.loadRef(CategoryData.categoryRoot);
        CategorySrv.loadRef();
        ServiceSrv.loadRef();
        if (proSiteData.queryDays && proSiteData.queryDays.days) DaySrv.loadResourceDays(proSiteData.queryDays.days);else DaySrv.loadResourceDays([]);
        if (successFunction != undefined) successFunction();
    };

    loader.loadWebData = function (webData, successFunction, errorFunction) {
        SiteData.sites.push(new Site(webData.defaultSite));
        if (SiteData.sites.length > 0) SiteData.defaultSite = SiteData.sites[0];

        if (webData.humanResources) for (var i = 0; i < webData.humanResources.length; i++) {
            new HumanResource(webData.humanResources[i]);
        } //auto register to DATA

        if (webData.physicalResources) for (var i = 0; i < webData.physicalResources.length; i++) {
            new PhysicalResource(webData.physicalResources[i]);
        } //auto register to DATA

        CategoryData.categoryRoot = new Category(webData.categoryRoot);
        ProductCategoryData.categoryRoot = new ProductCategory(webData.productCategoryRoot);
        CureCategoryData.categoryRoot = new CureCategory(webData.cureCategoryRoot);
        LoyaltyCardCategoryData.categoryRoot = new LoyaltyCardCategory(webData.loyaltyCardCategoryRoot);

        if (webData.customersPost) for (var i = 0; i < webData.customersPost.length; i++) {
            CustomerPostData.add(new CustomerPost(webData.customersPost[i]));
        }if (webData.images) for (var i = 0; i < webData.images.length; i++) {
            ImageData.add(new Image(webData.images[i]));
        }if (webData.companyImages) for (var i = 0; i < webData.companyImages.length; i++) {
            CompanyImageData.add(new CompanyImage(webData.companyImages[i]));
        }if (webData.apps) for (var i = 0; i < webData.apps.length; i++) {
            new App(webData.apps[i]);
        }if (webData.vats) for (var i = 0; i < webData.vats.length; i++) {
            new Vat(webData.vats[i]);
        }if (successFunction != undefined) $timeout(function () {
            HumanResourceSrv.loadRef(CategoryData.categoryRoot);
            PhysicalResourceSrv.loadRef(CategoryData.categoryRoot);
            CategorySrv.loadRef();
            ServiceSrv.loadRef();
            ProductCategorySrv.loadRef();
            CureCategorySrv.loadRef();
            LoyaltyCardCategorySrv.loadRef();
            ProductSrv.loadRef();
            CureSrv.loadRef();
            CureItemToServiceSrv.loadRef();
            LoyaltyCardSrv.loadRef();
            if (successFunction != undefined) successFunction();
        });
    };

    loader.convertMapsToArrays = function (keepObject, canAccessNewLoading) {
        if (!canAccessNewLoading) {
            CustomerData.convertMapToArray();
        }
        SaleData.convertMapToArray(keepObject, canAccessNewLoading);
        BookingData.convertMapToArray(keepObject, canAccessNewLoading);
        DayData.convertMapToArray(keepObject, canAccessNewLoading);
        ActivityData.convertMapToArray(keepObject, canAccessNewLoading);
    };

    return loader;
}]);

angular.module('FlexyBeautyApp.services').factory('LoaderUtil', [function () {
    var loaderUtil = {};
    loaderUtil.LOADER_SIZE = 122;

    loaderUtil.computeLoaders = function (daysId) {
        var loaders = [];
        if (daysId.length > 0) {
            loaders.push({ loading: true, daysId: [], days: [] });
            var j = 0;

            for (var i = 0; i < daysId.length; i++) {
                if (!isNaN(daysId[i]) && daysId[i] > 20000000) {
                    loaders[j].daysId.push(daysId[i]);
                }

                if ((i + 1) % loaderUtil.LOADER_SIZE === 0 && i + 1 < daysId.length) {
                    loaders.push({ loading: true, daysId: [], days: [] });
                    j++;
                }
            }
        }
        return loaders;
    };
    return loaderUtil;
}]);

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(789);

var Firebase = _interopRequireWildcard(_app);

__webpack_require__(790);

__webpack_require__(791);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FirebaseService = function FirebaseService(serverIdentification) {
    _classCallCheck(this, FirebaseService);

    this.firebase = Firebase;
    var config = null;
    if (serverIdentification === 'bsiflexyprod') {
        config = {
            apiKey: "AIzaSyBFZ6UcO_gYJraHA7-lxF1HtzeyHlsoo08",
            authDomain: "bsiflexyprod.firebaseapp.com",
            databaseURL: "https://bsiflexyprod.firebaseio.com",
            projectId: "bsiflexyprod",
            storageBucket: "bsiflexyprod.appspot.com",
            messagingSenderId: "154950419584"
        };
    } else if (serverIdentification === 'bsiflexyqa') {
        config = {
            apiKey: "AIzaSyC2MEsABoUubQwaMHnaYF4lsuPhUpFgmi8",
            authDomain: "bsiflexyqa.firebaseapp.com",
            databaseURL: "https://bsiflexyqa.firebaseio.com",
            projectId: "bsiflexyqa",
            storageBucket: "bsiflexyqa.appspot.com",
            messagingSenderId: "278524302071"
        };
    } else if (serverIdentification === 'bsiflexydev') {
        config = {
            apiKey: "AIzaSyDqOskUYKHe1ZOC-ty7AKjcjxqCEAjEBe0",
            authDomain: "bsiflexydev.firebaseapp.com",
            databaseURL: "https://bsiflexydev.firebaseio.com",
            projectId: "bsiflexydev",
            storageBucket: "",
            messagingSenderId: "923528606600"
        };
    }
    this.firebase.initializeApp(config);
    this.database = this.firebase.database();
    this.auth = this.firebase.auth();
};

exports.default = FirebaseService;


angular.module('FlexyBeautyApp.services').factory('FirebaseServiceFactory', ['UserData', function (UserData) {
    return {
        firebaseservice: null,

        getFireBaseService: function getFireBaseService() {
            var loggedUser = UserData.getLoggedUser();
            if (!this.firebaseservice && loggedUser && loggedUser.serverIdentification) {
                this.firebaseservice = new FirebaseService(loggedUser.serverIdentification.applicationId);
            }
            return this.firebaseservice;
        }
    };
}]);

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Filters */

angular.module('FlexyBeautyApp.filters', []).filter('currencyFormatFilter', ['$filter', 'LanguageManager', 'CurrencyManager', 'NumberSeparatorType', function ($filter, LanguageManager, CurrencyManager, NumberSeparatorType) {
    return function (text) {
        var formattedNumber = text;

        if (formattedNumber !== null) {
            if (LanguageManager.getLanguageCode() && LanguageManager.getCountryCode() && CurrencyManager.getCurrencyCodeIso()) {
                if (typeof formattedNumber === "string") {
                    formattedNumber = CurrencyManager.getPriceFromPriceInput(formattedNumber);
                    formattedNumber = parseFloat(formattedNumber);
                }
                if (!isNaN(formattedNumber)) {
                    var intlFormater = CurrencyManager.getIntlFormatter();
                    if (intlFormater) {
                        formattedNumber = intlFormater.format(formattedNumber);
                    } else {
                        formattedNumber = formattedNumber.toLocaleString(LanguageManager.getLocale(), {
                            style: 'currency',
                            currency: CurrencyManager.getCurrencyCodeIso()
                        });
                    }
                } else {
                    formattedNumber = text;
                }
            }
        }
        return formattedNumber;
    };
}]).filter('interpolate', ['version', function (version) {
    return function (text) {
        return String(text).replace(/\%VERSION\%/mg, version);
    };
}]).filter('trustHtml', ['$sce', function ($sce) {
    return function (value) {
        return $sce.trustAs('html', value);
    };
}]).filter('matchSkill', function () {
    return function (services, humainResource) {
        var filtered = [];
        angular.forEach(services, function (service) {
            if (humainResource.servicesId.indexOf(service.id) >= 0) {
                filtered.push(service);
            }
        });
        return filtered;
    };
}).filter('canPerformBookingService', function () {
    return function (resourcesView, bookingServiceView) {
        var filtered = [];
        if (bookingServiceView.bookingView && bookingServiceView.bookingView.plgDayView) angular.forEach(resourcesView, function (resourceView) {
            //TODO check open period instead open day
            var dayHrView = bookingServiceView.bookingView.plgDayView.getPlgDayHrView(resourceView);
            if (resourceView.knowsServiceView(bookingServiceView.serviceView) && dayHrView && dayHrView.isWorkingDay) filtered.push(resourceView);
        });
        return filtered;
    };
}).filter('canPerformBookingServiceOnPr', function () {
    return function (physicalResourcesUnitView, bookingServiceView) {
        var filtered = [];
        angular.forEach(physicalResourcesUnitView, function (physicalResourceUnitView) {
            if (bookingServiceView.bookingView && bookingServiceView.bookingView.plgDayView) {
                //TODO check open period instead open day
                var dayPrView = bookingServiceView.bookingView.plgDayView.getPlgDayPrView(physicalResourceUnitView.prView, physicalResourceUnitView.prUnitId);
                if (physicalResourceUnitView.prView.knowsServiceView(bookingServiceView.serviceView) && dayPrView && dayPrView.isWorkingDay) filtered.push(physicalResourceUnitView);
            }
        });
        return filtered;
    };
}).filter('labelLowerCaseFilter', function () {
    return function (objectsToFilter, filter) {
        var filtered = [];
        if (!filter || filter.length < 2) return objectsToFilter;
        var filterLowCase = filter.toLowerCase();
        angular.forEach(objectsToFilter, function (objectToFilter) {
            if (objectToFilter.labelLowerCase && objectToFilter.labelLowerCase.indexOf(filterLowCase) != -1) filtered.push(objectToFilter);
        });
        return filtered;
    };
}).filter('filterDays', function () {
    return function (days, daysToDisplay) {
        var filtered = [];
        for (var z = 0; z < days.length && z < daysToDisplay; z++) {
            filtered.push(days[z]);
        }return filtered;
    };
}).filter('numberFixedLen', function () {
    return function (n, len) {
        var num = parseInt(n, 10);
        len = parseInt(len, 10);
        if (isNaN(num) || isNaN(len)) {
            return n;
        }
        num = '' + num;
        while (num.length < len) {
            num = '0' + num;
        }
        return num;
    };
}).filter('numberDot', ["$filter", function ($filter) {
    return function (input, fractionSize) {
        if (isNaN(input)) {
            return input;
        } else {
            return $filter('number')(input, fractionSize).replace(",", ".");
        };
    };
}]).filter('smartNumber', ["$filter", function ($filter) {
    return function (input, fractionSize) {
        if (isNaN(input)) {
            return input;
        } else {
            if (input % 1 === 0) //not a float
                return input;else return $filter('number')(input, fractionSize);
        };
    };
}]).filter('searchCustomer', [function () {
    return function (customersView, inputSearch) {
        var filtered = [];
        if (!inputSearch || inputSearch === "" || inputSearch.length < 2) {
            return [];
        }

        inputSearch = inputSearch.toLowerCase();

        for (var z = 0; z < customersView.length; z++) {
            var customerView = customersView[z];
            var lastName = customerView.lastName ? customerView.lastName.toLowerCase() : customerView.lastName;
            var firstName = customerView.firstName ? customerView.firstName.toLowerCase() : customerView.firstName;
            var label = customerView.label ? customerView.label.toLowerCase() : customerView.label;
            var customerPhone = customerView.customerPhone;
            var email = customerView.email;
            var customerNationalMobileNumber = customerView.customerNationalMobileNumber;
            var customerNationalLandlineNumber = customerView.customerNationalLandlineNumber;
            var customerInterNationalMobileNumber = customerView.customerInterNationalMobileNumber;
            var customerInterNationalLandlineNumber = customerView.customerInterNationalLandlineNumber;

            if (lastName && lastName.indexOf(inputSearch) === 0 || firstName && firstName.indexOf(inputSearch) === 0 || customerPhone && customersView[z].customerPhone.indexOf(inputSearch) === 0 || label && label.indexOf(inputSearch) === 0 || email && customersView[z].email.indexOf(inputSearch) === 0 || customerNationalMobileNumber && customerNationalMobileNumber.indexOf(inputSearch.replace(/\s/g, '')) === 0 || customerInterNationalMobileNumber && customerInterNationalMobileNumber.indexOf(inputSearch.replace(/\s/g, '')) === 0 || customerNationalLandlineNumber && customerNationalLandlineNumber.indexOf(inputSearch.replace(/\s/g, '')) === 0 || customerInterNationalLandlineNumber && customerInterNationalLandlineNumber.indexOf(inputSearch.replace(/\s/g, '')) === 0) {
                filtered.push(customerView);
            }
        }

        return filtered;
    };
}]).filter('searchSupplier', [function () {
    return function (suppliersView, inputSearch) {
        var filtered = [];
        if (!inputSearch || inputSearch == "" || inputSearch.length < 2) return suppliersView;
        for (var z = 0; z < suppliersView.length; z++) {
            if (suppliersView[z].label && suppliersView[z].label.indexOf(inputSearch) == 0) filtered.push(suppliersView[z]);
        }return filtered;
    };
}]).filter('searchCompany', [function () {
    return function (companiesView, inputSearch) {
        var filtered = [];
        if (!inputSearch || inputSearch == "" || inputSearch.length < 2) return companiesView;
        for (var z = 0; z < companiesView.length; z++) {
            if (companiesView[z].name && companiesView[z].name.indexOf(inputSearch) == 0) filtered.push(companiesView[z]);
        }return filtered;
    };
}]).filter('searchLinesInvoice', [function () {
    return function (linesInvoices, inputSearch) {
        var filtered = [];
        if (!inputSearch || inputSearch == "" || inputSearch.length < 2) return linesInvoices;
        for (var z = 0; z < linesInvoices.length; z++) {
            if (linesInvoices[z] && linesInvoices[z].indexOf(inputSearch) == 0) filtered.push(linesInvoices[z]);
        }return filtered;
    };
}]).filter('reverse', function () {
    return function (items) {
        if (items) return items.slice().reverse();
    };
}).filter('minutesToTimeString', function () {
    return function (minutesIn) {
        if (!minutesIn) return "";
        var hours = Math.floor(minutesIn / 60);
        var minutes = Math.floor(minutesIn % 60);
        var timeString = '';
        if (hours > 0) {
            timeString += hours + "h";
            if (minutes < 10) timeString += "0";
        }
        if (minutes >= 0) {
            timeString += minutes;
            if (minutes > 0 && hours == 0) timeString += String.fromCharCode(8239) + "min";
        }
        return timeString;
    };
}).filter('shorterMinutesToTimeString', function () {
    return function (minutesIn) {
        if (!minutesIn) return "";
        var hours = Math.floor(minutesIn / 60);
        var minutes = Math.floor(minutesIn % 60);
        var timeString = '';
        if (hours > 0) {
            timeString += hours + "h";
            if (minutes > 0 && minutes < 10) timeString += "0";
        }
        if (minutes > 0) {
            timeString += minutes;
            if (minutes > 0 && hours == 0) timeString += String.fromCharCode(8239) + "min";
        }
        return timeString;
    };
});

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('BookingSettings', [function () {
    return {
        MOVE_BOOKING: "moveBooking",
        UPDATE_DURATION: "updateDuration",
        CREATE_SALE: "createSale",
        DELETE_BOOKING: "deleteBooking",
        UPDATE_CUSTOMER: "updateCustomer",
        DELETE_SERVICE: "deleteService",
        ADD_SERVICE: "addService",
        MOVE_HR: "moveHR",
        UPDATE_PRICE: "updatePrice",
        UPDATE_DISCOUNT: "updateDiscount",
        MOVE_PR: "movePR",
        HR_REQUEST: "hrRequest",
        DUPLICATE_BOOKING: "duplicateBooking",
        COMMENT: "comment",
        DISPLAY_SALE: "displaySale"
    };
}]).factory('BookingPartnerSettings', ['BasicAuthRole', function (BasicAuthRole) {
    var bookingPartnerSettings = {};

    bookingPartnerSettings[BasicAuthRole.LE_CISEAU_ROLE.role] = {
        moveBooking: false,
        updateDuration: false,
        createSale: true,
        deleteBooking: true,
        updateCustomer: false,
        deleteService: false,
        addService: false,
        moveHR: false,
        updatePrice: false,
        updateDiscount: false,
        movePR: false,
        hrRequest: false,
        duplicateBooking: true,
        comment: true,
        displaySale: true
    };

    bookingPartnerSettings[BasicAuthRole.GOOGLE_ROLE.role] = {
        moveBooking: true,
        updateDuration: true,
        createSale: true,
        deleteBooking: true,
        updateCustomer: false,
        deleteService: true,
        addService: true,
        moveHR: true,
        updatePrice: true,
        updateDiscount: true,
        movePR: true,
        hrRequest: true,
        duplicateBooking: true,
        comment: true,
        displaySale: true
    };

    return bookingPartnerSettings;
}]).factory('BookingPartnerSettingsAdmin', ['BasicAuthRole', function (BasicAuthRole) {
    var bookingPartnerSettingsAdmin = {};

    bookingPartnerSettingsAdmin[BasicAuthRole.LE_CISEAU_ROLE.role] = {
        moveBooking: true,
        updateDuration: false,
        createSale: false,
        deleteBooking: true,
        updateCustomer: false,
        deleteService: false,
        addService: false,
        moveHR: false,
        updatePrice: false,
        movePR: false,
        hrRequest: false,
        duplicateBooking: false,
        comment: false,
        displaySale: true
    };

    return bookingPartnerSettingsAdmin;
}]).factory('BookingPartnerSettingsFactory', ['BasicAuthRoleFactory', 'BookingPartnerSettings', 'BookingPartnerSettingsAdmin', 'BasicAuthRole', function (BasicAuthRoleFactory, BookingPartnerSettings, BookingPartnerSettingsAdmin, BasicAuthRole) {
    return {
        checkBookingPartnerSettings: function checkBookingPartnerSettings(setting, creator) {
            var checkBookingPartnerSettings = true;
            if (setting && creator) {
                var basicAuth = BasicAuthRoleFactory.getBasicAuthByBookingCreator(creator);
                if (basicAuth && BookingPartnerSettings[basicAuth.role]) {
                    checkBookingPartnerSettings = BookingPartnerSettings[basicAuth.role][setting];
                }
            }
            return checkBookingPartnerSettings;
        },
        checkBookingPartnerSettingsAdmin: function checkBookingPartnerSettingsAdmin(isAdmin, setting, creator) {
            var checkBookingPartnerSettings = false;
            if (isAdmin && setting && creator) {
                var basicAuth = BasicAuthRoleFactory.getBasicAuthByBookingCreator(creator);
                if (basicAuth && basicAuth.role === BasicAuthRole.LE_CISEAU_ROLE.role && BookingPartnerSettingsAdmin[basicAuth.role]) {
                    checkBookingPartnerSettings = BookingPartnerSettingsAdmin[basicAuth.role][setting];
                }
            }
            return checkBookingPartnerSettings;
        }
    };
}]);

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('ConstantsCustomerPosts', ['gettextCatalog', function (gettextCatalog) {
    var colorsAvailable = {
        'A': '#B71C1C',
        'B': '#880E4F',
        'C': '#4A148C',
        'D': '#311B92',
        'E': '#1A237E',
        'F': '#0D47A1',
        'G': '#01579B',
        'H': '#006064',
        'I': '#004D40',
        'J': '#1B5E20',
        'K': '#33691E',
        'L': '#827717',
        'M': '#E65100',
        'N': '#BF360C',
        'O': '#B71C1C',
        'P': '#880E4F',
        'Q': '#4A148C',
        'R': '#311B92',
        'S': '#1A237E',
        'T': '#0D47A1',
        'U': '#01579B',
        'V': '#006064',
        'W': '#4E342E',
        'X': '#1B5E20',
        'Y': '#212121',
        'Z': '#827717'
    };
    return colorsAvailable;
}]);

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('GiftItemEditionType', function () {
    return {
        DELIVERY: 'delivery',
        DELIVERED: 'delivered',
        EMAIL: 'email',
        PRINT_ON_TICKET: 'printOnTicket',
        MANUAL: 'manual'
    };
});

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('SaleDelivery', function () {
    return {
        ADDRESS: "address",
        SITE: "site",
        ADDRESS_SEND: "address-send"
    };
});

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('SaleSettings', [function () {
    return {
        UPDATE_CUSTOMER: "updateCustomer",
        DELETE_SERVICE: "deleteService",
        ADD_SERVICE: "addService",
        ADD_ITEM: "addItem",
        MOVE_HR: "moveHR",
        UPDATE_PRICE: "updatePrice",
        UPDATE_DISCOUNT: "updateDiscount",
        UPDATE_PAYMENT: "updatePayment",
        CANCEL_SALE: "cancelSale"
    };
}]).factory('SalePartnerSettingsFactory', ['BasicAuthRoleFactory', function (BasicAuthRoleFactory) {
    return {
        checkSalePartnerSettings: function checkSalePartnerSettings(setting, creator) {
            var checkSalePartnerSettings = true;
            if (setting && creator) {
                var basicAuth = BasicAuthRoleFactory.getBasicAuthByBookingCreator(creator);
                if (basicAuth && basicAuth.basicAuthRoleSaleCreationBehavior) {
                    checkSalePartnerSettings = basicAuth.basicAuthRoleSaleCreationBehavior[setting];
                }
            }
            return checkSalePartnerSettings;
        }
    };
}]);

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('TimeMeasures', function () {
    return {
        MODEL_GLOBAL_TIME: "A - MODEL_GLOBAL_TIME",
        MODEL_GLOBAL_TIME_STARTUP: "A - MODEL_GLOBAL_TIME_STARTUP",
        MODEL_LOADING: "A-1 - MODEL_LOADING",
        CUSTOMERS_LOADING: "A-1-a - CUSTOMERS_LOADING",
        DELETED_CUSTOMERS_LOADING: "A-1-b - DELETED_CUSTOMERS_LOADING",
        DAYS_LOADING: "A-1-c - DAYS_LOADING",
        BACKOFFICE_DEPENDENCIES_LOADING: "A-2-a - BACKOFFICE_DEPENDENCIES_LOADING",
        RESOURCE_DAYS_LOADING: "A-2-b - RESOURCE_DAYS_LOADING",
        DAYS_DEPENDENCIES_LOADING: "A-2-c - DAYS_DEPENDENCIES_LOADING",
        LANGUAGE_MANAGER_INITIALISATION: "A-1-e - LANGUAGE_MANAGER_INITIALISATION",
        LANGUAGE_MANAGER_SET_LOCALE: "A-1-e-1 - LANGUAGE_MANAGER_SET_LOCALE",
        LANGUAGE_MANAGER_LOAD_MOMENT: "A-1-e-2 - LANGUAGUE_MANAGER_LOAD_MOMENT",
        LANGUAGE_MANAGER__LOAD_GOOGLE_CHARTS: "A-1-e-3 - LANGUAGE_MANAGER__LOAD_GOOGLE_CHARTS",
        LANGUAGE_MANAGER_LOAD_ANGULAR: "A-1-e-4 - LANGUAGE_MANAGER_LOAD_ANGULAR",
        LANGUAGE_MANAGER_LOAD_DICTIONARY: "A-1-e-5 - LANGUAGE_MANAGER_LOAD_DICTIONARY",
        LANGUAGE_MANAGER_SET_NUMBER_FORMATTER: "A-1-e-6 - LANGUAGE_MANAGER_SET_NUMBER_FORMATTER",
        INIT_COMPANY_VIEW: "A-3-b - INIT_COMPANY_VIEW",
        EXTERNAL_SERVICES_LOADING: "A-3-c - EXTERNAL_SERVICES_LOADING",
        INIT_NOTIFICATION_VIEW: "A-3-d - INIT_NOTIFICATION_VIEW",
        PLANNING_POS_GLOBAL_TIME: "B - PLANNING_POS_GLOBAL_TIME",
        PLANNING_POS_GLOBAL_TIME_STARTUP: "B - PLANNING_POS_GLOBAL_TIME_STARTUP",
        AFTER_LOADING_STARTUP_REMAINING_TIME: "C - AFTER_LOADING_STARTUP_REMAINING_TIME",
        POS_PARAM: "B-1-a - POS_PARAM",
        CUSTOMER_PARAM: "B-1-b - CUSTOMER_PARAM",
        VATS_VIEW: "B-1-c - VATS_VIEW",
        OTHER_PAYMENT_TYPES_VIEW: "B-1-d - OTHER_PAYMENT_TYPES_VIEW",
        CATEGORY_VIEW: "B-1-e - CATEGORY_VIEW",
        SUPPLIER_VIEW: "B-1-f - SUPPLIER_VIEW",
        PRODUCT_CATEGORY_VIEW: "B-1-g - PRODUCT_CATEGORY_VIEW",
        CURE_CATEGORY_VIEW: "B-1-h - CURE_CATEGORY_VIEW",
        LOYALTY_CARD_CATEGORY_VIEW: "B-1-i - LOYALTY_CARD_CATEGORY_VIEW",
        PHYSICAL_RESOURCES_VIEW: "B-1-j - PHYSICAL_RESOURCES_VIEW",
        HUMAN_RESOURCES_VIEW: "B-1-k - HUMAN_RESOURCES_VIEW",
        CUSTOMERS_VIEW: "B-1-l - CUSTOMERS_VIEW",
        CUSTOMERS_VIEW_DISPLAYED: "B-1-m - CUSTOMERS_VIEW_DISPLAYED",
        CUSTOMERS_DELETED_VIEW: "B-1-n - CUSTOMERS_DELETED_VIEW",
        CUSTOMERS_DELETED_VIEW_DISPLAYED: "B-1-o - CUSTOMERS_DELETED_VIEW_DISPLAYED",
        SMS_CAMPAIGN_LIST_VIEWS: "B-1-p - SMS_CAMPAIGN_LIST_VIEWS",
        NOTIF_CAMPAIGN_LIST_VIEWS: "B-1-q - NOTIF_CAMPAIGN_LIST_VIEWS",
        INIT_SUB_VIEWS: "B-2-a - INIT_SUB_VIEWS",
        TIMELINE_AND_ACTIVITY_IS_PAST: "B-2-b - TIMELINE_AND_ACTIVITY_IS_PAST",
        ADD_SALE_VIEW_NOW: "B-2-c - ADD_SALE_VIEW_NOW",
        USER_ACTION_FROM_DATE: "D-1 - USER_ACTION_FROM_DATE",
        USER_ACTION_BOOKING: "D-2 - USER_ACTION_BOOKING",
        PLANNING_DAY_OPENINGS_RESPONSE_TREATMENT: "PLANNING_DAY_OPENINGS_RESPONSE_TREATMENT"
    };
}).factory('CountMeasures', ['MeasureStore', function (MeasureStore) {
    var measures = {
        NUMBER_STILL_DAY_TO_LOAD: "A-1-d - NUMBER_STILL_DAY_TO_LOAD"
    };
    for (var measure in measures) {
        MeasureStore.initCounter(measures[measure]);
    }
    return measures;
}]).factory('TimeValues', function () {
    return {
        START: "START",
        END: "END",
        DURATION: "DURATION",
        COUNT: "COUNT"
    };
}).factory('MeasureStore', ["TimeValues", "moment", function (TimeValues, moment) {
    var measureStore = {};

    measureStore.initCounter = function (measure) {
        if (!this[measure]) {
            this[measure] = {};
        }
        this[measure][TimeValues.COUNT] = 0;
        console.info("Measure : \"" + measure + "\"; New value : " + this[measure][TimeValues.COUNT] + "");
    };

    measureStore.registerCount = function (measure) {
        if (!this[measure]) {
            this[measure] = {};
        }
        this[measure][TimeValues.COUNT]++;
        console.info("Measure : \"" + measure + "\"; New value : " + this[measure][TimeValues.COUNT] + "");
    };

    measureStore.registerStart = function (measure) {
        if (!this[measure]) {
            this[measure] = {};
        }
        if (!this[measure][TimeValues.START]) {
            this[measure][TimeValues.START] = Date.now();
        }
    };

    measureStore.registerEnd = function (measure) {
        if (!this[measure]) {
            this[measure] = {};
        }
        if (!this[measure][TimeValues.END]) {
            this[measure][TimeValues.END] = Date.now();
            this[measure][TimeValues.DURATION] = this[measure][TimeValues.END] - this[measure][TimeValues.START];
            console.info("Measure : \"" + measure + "\"; duration : " + this[measure][TimeValues.DURATION] + " ms");
        }
    };
    return measureStore;
}]).factory('Decorators', ['MeasureStore', function (MeasureStore) {
    return {
        timeMeasureDecorator: function timeMeasureDecorator(fn, measureName) {
            if (typeof fn !== 'function') {
                console.warn("Invalid usage of decorator \"timeMeasureDecorator\". " + fn + " is not a function.");
                return fn;
            } else {
                var measureNameChoosen = measureName ? measureName : fn.name ? fn.name : null;

                return function () {
                    if (measureNameChoosen) {
                        MeasureStore.registerStart(measureName);
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    var result = fn.call.apply(fn, [this].concat(args));
                    if (result && typeof result.then === 'function') {
                        return result.then(function (data) {
                            if (measureNameChoosen) {
                                MeasureStore.registerEnd(measureName);
                            }
                            return data;
                        });
                    } else {
                        if (measureNameChoosen) {
                            MeasureStore.registerEnd(measureName);
                        }
                    }
                };
            }
        }
    };
}]);

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* Created with JetBrains WebStorm.
* User: bastienrobinot
* Date: 11/05/2018
* Time: 18h01
* To change this template use File | Settings | File Templates.
*/

angular.module('FlexyBeautyApp.services').factory('CustomerPostView', ["$filter", "CustomerPost", "CustomerPostData", "CustomerPostSrv", "CustomerData", "CompanyImageData", "MobileDeviceData", function ($filter, CustomerPost, CustomerPostData, CustomerPostSrv, CustomerData, CompanyImageData, MobileDeviceData) {

    var CustomerPostView = function CustomerPostView(customerPost, cpIndex) {
        this.cpIndex = cpIndex;
        this.companyImage = null, this.customer = null, this.fromDevice = null, this.rating = null, this.customerAuthPublish = false, this.proAuthPublish = false, this.timeCreated = null, this.timePublished = null, this.text = "", this.title = "", this.loadDataFrom(customerPost);
    };
    CustomerPostView.prototype.getModel = function () {
        if (this.cpIndex != -1) return CustomerPostData.getByIndex(this.cpIndex);
        return null;
    };
    CustomerPostView.prototype.loadDataFrom = function (customerPost) {
        if (customerPost !== undefined && customerPost) {
            var customer = CustomerData.getById(customerPost.customerId);
            if (customer) this.customer = customer;

            var companyImage = CompanyImageData.getById(customerPost.companyImageId);
            if (companyImage) this.companyImage = companyImage;

            var fromDevice = MobileDeviceData.getById(customerPost.fromDeviceId);
            if (fromDevice) this.fromDevice = fromDevice;

            this.rating = customerPost.rating;
            this.customerAuthPublish = customerPost.customerAuthPublish;
            this.proAuthPublish = customerPost.proAuthPublish;
            this.timeCreated = customerPost.timeCreated;
            this.timePublished = customerPost.timePublished;
            this.text = customerPost.text;
            this.title = customerPost.title;
        }
    };
    CustomerPostView.prototype.copyDataTo = function (customerPost) {

        if (this.companyImage) customerPost.companyImageId = this.companyImage.id;
        if (this.fromDevice) customerPost.fromDeviceId = this.fromDevice.getModel().id;
        if (this.customer) customerPost.customerId = this.customer.id;
        customerPost.rating = this.rating;
        customerPost.customerAuthPublish = this.customerAuthPublish;
        customerPost.proAuthPublish = this.proAuthPublish;
        customerPost.timeCreated = this.timeCreated;
        customerPost.timePublished = this.timePublished;
        customerPost.text = this.text;
        customerPost.title = this.title;
    };

    CustomerPostView.prototype.isChanged = function () {
        var customerPost = this.getModel();
        if (customerPost) return this.companyImage != customerPost.companyImage || this.customer != customerPost.customer || this.fromDevice != customerPost.fromDevice || this.rating != customerPost.rating || this.customerAuthPublish != customerPost.customerAuthPublish || this.proAuthPublish != customerPost.proAuthPublish || this.timePublished != customerPost.timePublished || this.text != customerPost.text || this.title != customerPost.title;else return true;
    };

    CustomerPostView.prototype.removeModel = function () {
        var customerPost = this.getModel();
        if (customerPost != null) CustomerPostSrv.remove(customerPost);
    };
    CustomerPostView.prototype.reloadModel = function () {
        var customerPost = this.getModel();
        if (customerPost != null) this.loadDataFrom(customerPost);
    };
    CustomerPostView.prototype.updateModel = function (endFunction) {
        //Save by default
        var customerPost = this.getModel();
        if (!customerPost) //create it
            {
                customerPost = new CustomerPost();
                this.cpIndex = CustomerPostData.getIndexOf(customerPost);
            }
        this.text = this.text.replace(new RegExp('<br/>', 'g'), '\n');
        this.copyDataTo(customerPost);
        CustomerPostSrv.save(customerPost, endFunction);
    };
    CustomerPostView.prototype.restoreModel = function () {
        var customerPost = this.getModel();
        if (customerPost) CustomerPostSrv.restore(customerPost);
    };
    CustomerPostView.prototype.canSave = function () {
        return true;
    };

    return CustomerPostView;
}]);

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('ItemCategoryView', ["$dialog", "CompanyImageFormat", "gettextCatalog", function ($dialog, CompanyImageFormat, gettextCatalog) {
    var ItemCategoryView = function ItemCategoryView() {};

    ItemCategoryView.prototype.isAllItemsImageInSquareFormat = function (items) {
        return this.isAllItemsImageInFormat(items, CompanyImageFormat.SQUARE.label);
    };

    ItemCategoryView.prototype.isAllItemsImageInPortraitFormat = function (items) {
        return this.isAllItemsImageInFormat(items, CompanyImageFormat.PORTRAIT.label);
    };

    ItemCategoryView.prototype.isAllItemsImageInRectFormat = function (items) {
        return this.isAllItemsImageInFormat(items, CompanyImageFormat.RECT.label);
    };

    ItemCategoryView.prototype.isAllItemsImageInFormat = function (items, format) {
        var isAllInFormat = true;
        for (var i = 0; i < items.length; i++) {
            if (items[i].imageDisplayed && items[i].imageDisplayed.dim && items[i].imageDisplayed.dim !== format) {
                isAllInFormat = false;
                break;
            }
        }
        return isAllInFormat;
    };

    ItemCategoryView.prototype.checkForRootSaveError = function (data) {
        if (data.data.message.includes("A root category already exists")) {
            var errorMessage = gettextCatalog.getString("Echec lors de la sauvegarde de catégorie, veuillez recharger l'application");
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/errorDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = errorMessage;
                        return tableModel;
                    }
                }
            };
            $dialog.dialog(opts).open();
        }
    };

    return ItemCategoryView;
}]);

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('MonitoringUsageData_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/monitoring/', {}, {
        logUsageData: { method: 'POST', url: baseUrl + 'rest/monitoring/logUsageData' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('MonitoringUsageDataSrv', ["MonitoringUsageData_Resource", function (MonitoringUsageData_Resource) {
    var monitoringUsageDataSrv = {};
    monitoringUsageDataSrv.logUsageData = function (data) {
        var monitoringUsageDataResource = new MonitoringUsageData_Resource();
        monitoringUsageDataResource.data = data;
        monitoringUsageDataResource.$logUsageData({});
        return Promise.resolve();
    };

    return monitoringUsageDataSrv;
}]);
angular.module('FlexyBeautyApp.services').factory('MonitoringUsageConstants', [function (gettextCatalog) {
    return {
        STATISTICS: "CLICK_COUNT_TAB_STATISTICS",
        SALES_TURNOVER: "ACCOUNTING_DATA - CLICK_COUNT_SALES_TURNOVER",
        PAYMENTS: "ACCOUNTING_DATA - CLICK_COUNT_PAYMENTS",
        GIFT_CARDS: "ACCOUNTING_DATA - CLICK_COUNT_GIFT_CARDS",
        PETTY_CASH_FUND: "ACCOUNTING_DATA - CLICK_COUNT_PETTY_CASH_FUND",
        EXPORT: "ACCOUNTING_DATA - CLICK_COUNT_EXPORT"
    };
}]);

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 18/07/2017.
 */
/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').factory('OptInOutView', ["$timeout", "$filter", "OptInOut", "OptInOutData", "OptInOutSrv", "CustomerData", function ($timeout, $filter, OptInOut, OptInOutData, OptInOutSrv, CustomerData) {
    var OptInOutView = function OptInOutView(optInOutModel, optInOutIndex) {
        this.optInOutIndex = optInOutIndex;
        this.id = null;
        this.isSmsCampaignAllowed = false;
        this.isEmailCampaignAllowed = false;
        this.isNotificationCampaignAllowed = false;
        this.isExternalOptInOut = null;
        this.origin = null;
        this.optInOutDateString = null;
        this.optInOutDatePickerOpened = false;
        this.customerId = null;
        this.timeModified = null;
        this.optInOutModel = optInOutModel;

        if (this.optInOutModel) {
            this.loadDataFrom(this.optInOutModel);
        }
    };

    OptInOutView.prototype.loadDataFrom = function (optInOutModel) {
        this.id = optInOutModel.id;
        this.isSmsCampaignAllowed = optInOutModel.isSmsCampaignAllowed ? optInOutModel.isSmsCampaignAllowed : false;
        this.isEmailCampaignAllowed = optInOutModel.isEmailCampaignAllowed ? optInOutModel.isEmailCampaignAllowed : false;
        this.isNotificationCampaignAllowed = optInOutModel.isNotificationCampaignAllowed ? optInOutModel.isNotificationCampaignAllowed : false;
        this.isExternalOptInOut = optInOutModel.isExternalOptInOut ? optInOutModel.isExternalOptInOut : false;
        this.optInOutDate = optInOutModel.optInOutDate;
        this.origin = optInOutModel.origin;
        this.customerId = optInOutModel.customerId;
        this.timeModified = optInOutModel.timeModified;
        this.updateDateString();
        this.optInOutIndex = OptInOutData.getIndexOf(optInOutModel);
    };

    OptInOutView.prototype.isChanged = function () {
        var isChanged = false;
        if (this.optInOutModel.isSmsCampaignAllowed != this.isSmsCampaignAllowed && this.optInOutModel.isEmailCampaignAllowed != this.isEmailCampaignAllowed && this.optInOutModel.isNotificationCampaignAllowed != this.isNotificationCampaignAllowed && this.optInOutModel.isExternalOptInOut != this.isExternalOptInOut) {
            isChanged = true;
        }
        return isChanged;
    };

    OptInOutView.prototype.copyDataTo = function (optInOut) {
        optInOut.isSmsCampaignAllowed = this.isSmsCampaignAllowed;
        optInOut.isEmailCampaignAllowed = this.isEmailCampaignAllowed;
        optInOut.isNotificationCampaignAllowed = this.isNotificationCampaignAllowed;
        optInOut.isExternalOptInOut = this.isExternalOptInOut;
        optInOut.timeModified = this.timeModified;
        optInOut.origin = this.origin;
        optInOut.customerId = this.customerId;
    };

    OptInOutView.prototype.getModel = function () {
        if (this.optInOutIndex != -1) {
            return OptInOutData.getByIndex(this.optInOutIndex);
        }
        return null;
    };

    OptInOutView.prototype.updateModel = function (success, failure, customerId) {
        if (customerId) this.customerId = customerId;
        var optInOut = this.getModel();
        if (optInOut == null) {
            optInOut = new OptInOut(null, customerId);
            this.optInOutIndex = OptInOutData.getIndexOf(optInOut);
            var customer = CustomerData.getById(customerId);
            if (customer) {
                customer.optInOut = optInOut;
            }
        }

        this.copyDataTo(optInOut);

        OptInOutSrv.save(optInOut, success, failure);
    };

    OptInOutView.prototype.reloadModel = function () {
        var optInOut = this.getModel();

        this.loadDataFrom(optInOut);
    };

    OptInOutView.prototype.isAgreementKnown = function () {
        var isAgreementKnown = false;
        if (this.getModel()) {
            isAgreementKnown = true;
        }
        return isAgreementKnown;
    };

    OptInOutView.prototype.onDateOptInOutStringChange = function () {
        if (this.optInOutDateString && this.optInOutDateString.length == 10) {
            var year = this.optInOutDateString.substring(6, 10);
            var month = this.optInOutDateString.substring(3, 5);
            var day = this.optInOutDateString.substring(0, 2);
            this.timeModified = new Date(year + '/' + month + '/' + day);
            if (this.timeModified) if (Object.prototype.toString.call(this.timeModified) === "[object Date]") {
                if (isNaN(this.timeModified.getTime())) this.timeModified = null;
            } else {
                this.timeModified = null;
            }
        } else this.timeModified = null;
    };
    OptInOutView.prototype.onDateOptInOutStringKeyup = function (event) //
    {
        if (this.optInOutDateString) if (!(event && (event.which == 8 || event.which == 46))) //if key delete detected : clear supplier
            {
                if ((this.optInOutDateString.length == 4 || this.optInOutDateString.length == 7) && this.optInOutDateString[this.optInOutDateString.length - 1] == '/') this.optInOutDateString = this.optInOutDateString.substr(0, this.birthDateString.length - 2);

                if (this.optInOutDateString.length == 2 || this.optInOutDateString.length == 5) this.optInOutDateString += "/";
            }
    };

    OptInOutView.prototype.displayOptInOutDatePickerF = function () {
        var optInOutView = this;
        $timeout(function () {
            optInOutView.optInOutDatePickerOpened = true;
        });
    };

    OptInOutView.prototype.updateDateString = function () {
        if (this.timeModified) this.optInOutDateString = $filter('date')(this.timeModified, 'shortDate');
    };

    OptInOutView.prototype.canSaveExternalOptInOut = function () {
        if (this.timeModified == null || this.timeModified == '' || this.origin == null || this.origin == '') return false;
        return true;
    };

    return OptInOutView;
}]);

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('App_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/app/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getByCode: { method: 'GET', url: baseUrl + 'rest/app/code/:code' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('App', ["App_Resource", "AppAttribute", "AppData", function (App_Resource, AppAttribute, AppData) {
    var App = function App(resource) {
        this.id = "";
        this.isDeleted = false;

        this.code = "";
        this.appAttributes = [];
        this.version = null;
        if (resource !== undefined && resource !== null) this.setValues(resource);

        AppData.add(this);
    };

    App.prototype.setId = function (id) {
        if (!this.id) this.id = id;
    };
    App.prototype.getId = function () {
        return this.id;
    };
    App.prototype.setCode = function (code) {
        this.code = code;
    };
    App.prototype.getCode = function () {
        return this.code;
    };
    App.prototype.setValues = function (resource) {
        this.id = resource.id;
        this.isDeleted = resource.isDeleted;

        this.code = resource.code;
        this.appAttributes = resource.appAttributes;
        if (resource.version) this.version = resource.version;
    };
    App.prototype.getObjectResource = function () {
        var newApp = new App_Resource();

        newApp.id = this.id;
        newApp.isDeleted = this.isDeleted;
        newApp.code = this.code;
        newApp.appAttributes = this.appAttributes;

        return newApp;
    };
    App.prototype.simpleAddAppAttribute = function (appAttribute) {
        var index = this.appAttributes.indexOf(appAttribute);
        if (index == -1) this.appAttributes.push(appAttribute);
    };
    App.prototype.addAppAttribute = function (appAttribute) {
        if (appAttribute.code !== undefined && appAttribute.value !== undefined && (appAttribute.code !== null && appAttribute.value !== null || appAttribute.text !== null && appAttribute.text !== null)) {
            var newAppAttribute;
            newAppAttribute = new AppAttribute(appAttribute.code, appAttribute.value, appAttribute.text);

            var index = this.appAttributes.indexOf(newAppAttribute);
            if (index !== -1) this.appAttributes[index].setValues(appAttribute.code, appAttribute.value, appAttribute.text);else this.appAttributes.push(newAppAttribute);
        }
    };
    App.prototype.removeAppAttribute = function (appAttribute) {
        var index = this.appAttributes.indexOf(appAttribute);
        if (index !== -1) this.appAttributes.splice(index, 1);
    };
    App.prototype.getAppAttribute = function (attributeCode) {
        for (var i = 0; i < this.appAttributes.length; i++) {
            if (this.appAttributes[i].code === attributeCode) return this.appAttributes[i];
        }return null;
    };
    App.prototype.setAppAttribute = function (attributeCode, newValue) {
        for (var i = 0; i < this.appAttributes.length; i++) {
            if (this.appAttributes[i].code === attributeCode) this.appAttributes[i].value = newValue;
        }
    };

    return App;
}]);

angular.module('FlexyBeautyApp.services').factory('AppSrv', ["$log", "ServerSrv", "App_Resource", "AppData", "UserActionData", "App", function ($log, ServerSrv, App_Resource, AppData, UserActionData, App) {
    var appSrv = {};

    appSrv.query = function (successFunction, errorFunction) {
        App_Resource.query({}, //params
        function (data) {
            AppData.clear();
            for (var i = 0; i < data.length; i++) {
                new App(data[i]);
            }

            if (successFunction !== undefined) successFunction();
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    appSrv.getByCode = function (code, successFunction, errorFunction) {
        App_Resource.getByCode({ code: code }, function (appRessource) {
            if (successFunction != undefined) successFunction(new App(appRessource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };
    appSrv.save = function (app, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(appSrv.saveSync, app, successFunction, errorFunction);
    };
    appSrv.saveSync = function (app, successFunction, errorFunction) {
        //$timeout (function () {

        var appRes = app.getObjectResource();
        appRes.$save({}, //no params
        function (data) {
            try {
                app.setId(data.id);
                if (!app.version || data.version && data.version > app.version) app.version = data.version;
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    appSrv.remove = function (app, successFunction, errorFunction) {
        AppData.remove(app);
        ServerSrv.startSavingProcess(appSrv.removeSync, app, successFunction, errorFunction);
    };
    appSrv.removeSync = function (app, successFunction, errorFunction) {
        //$timeout (function () {

        var appRes = app.getObjectResource();
        appRes.$remove({ id: app.getId() }, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    return appSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('AppData', [function () {
    var appData = {
        appList: [], // app list for the entire application
        deletedAppList: [] // deleted app list for the entire application
    };

    appData.add = function (app) {
        if (!app.isDeleted) this.appList.push(app);else this.deletedAppList.push(app);
    };
    appData.remove = function (app) //Soft Remove
    {
        if (!app.isDeleted) {
            var indexAppList = this.appList.indexOf(app);
            if (indexAppList != -1) {
                this.appList.splice(indexAppList, 1);
                this.deletedAppList.push(app);
                app.isDeleted = true;
            }
        }
    };
    appData.getAppList = function () {
        return this.appList;
    };
    appData.getAppByCode = function (appCode) {
        for (var i = 0; i < this.appList.length; i++) {
            if (this.appList[i].getCode() == appCode) {
                return this.appList[i];
            }
        }
        return null;
    };
    appData.clear = function () {
        this.appList = [];
        this.deletedAppList = [];
    };

    return appData;
}]);

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('TaxMode', ['gettextCatalog', function (gettextCatalog) {

    var labelHt = gettextCatalog.getString("Hors taxe"),
        labelTtc = gettextCatalog.getString("TTC"),
        shortLabelHt = gettextCatalog.getString("HT"),
        shortLabelttc = gettextCatalog.getString("TTC");
    var taxMode = {
        HT: { id: 'HT', label: labelHt, shortLabel: shortLabelHt },
        TTC: { id: 'TTC', label: labelTtc, shortLabel: shortLabelttc }
    };

    taxMode.getTaxModeById = function (id) {
        var modeToReturn = null;
        if (id === taxMode.HT.id) {
            modeToReturn = taxMode.HT;
        }
        if (id === taxMode.TTC.id) {
            modeToReturn = taxMode.TTC;
        }
        return modeToReturn;
    };
    return taxMode;
}]).factory('ZeroPercentTvaDateCorrection', function () {
    //TODO the constant ZeroPercentTvaDateCorrection is deprecated, This is a temporary solution to not impact the history
    var zeroPercentDateCorrection = {
        DATE: new Date(2019, 4, 1, 0, 0, 0),
        isBeforeCorrection: function isBeforeCorrection(date) {
            return date && date.getTime() < this.DATE.getTime();
        }
    };

    return zeroPercentDateCorrection;
}).factory('TypeOfModification', ['gettextCatalog', function (gettextCatalog) {

    var modification = gettextCatalog.getString("Modification"),
        cancellation = gettextCatalog.getString("Annulation"),
        creation = gettextCatalog.getString("Création"),
        all = gettextCatalog.getString("Toutes les modifications");

    var typeOfModification = {
        ALL: { id: 'all', label: all },
        UPDATE: { id: 'update', label: modification },
        CANCELLATION: { id: 'delete', label: cancellation },
        CREATION: { id: 'create', label: creation }
    };

    typeOfModification.values = function () {
        return [this.ALL, this.CREATION, this.CANCELLATION, this.UPDATE];
    };

    return typeOfModification;
}]);

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('Company_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/companies/:code', {}, {
        query: { method: 'GET', isArray: true },
        listCodes: { method: 'GET', isArray: true, url: baseUrl + 'rest/companies/listCodes' },
        listCodesByStatus: { method: 'GET', isArray: true, url: baseUrl + 'rest/companies/list-codes-by-status' },
        listCodesDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/companies/listCodesDeleted' },
        listFromCodes: { method: 'POST', isArray: false, url: baseUrl + 'rest/companies/listFromCodes' },
        listDeleted: { method: 'GET', isArray: true, url: baseUrl + 'rest/companies/listDeleted' },
        listRelatedData: { method: 'GET', isArray: true, url: baseUrl + 'rest/companies/listRelatedData' },
        listCardDetails: { method: 'GET', isArray: true, url: baseUrl + 'rest/companies/listCardDetails' },
        listOnlineSales: { method: 'POST', isArray: false, url: baseUrl + 'rest/companies/listOnlineSales' },
        listBrands: { method: 'POST', isArray: false, url: baseUrl + 'rest/companies/listBrands' },
        get: { method: 'GET' },
        saveSubscriptions: { method: 'POST', url: baseUrl + 'rest/companies/saveSubscriptions' },
        copyDataFromCompanySource: { method: 'POST', url: baseUrl + 'rest/companies/copyDataFromCompanySource' },
        deleteCompanyData: { method: 'POST', url: baseUrl + 'rest/companies/deleteCompanyData' },
        generateSessionToken: { method: 'POST', url: baseUrl + 'rest/companies/generateSessionToken' },
        resetDataF: { method: 'POST', url: baseUrl + 'rest/companies/resetData' },
        getCardRegistration: { method: 'POST', url: baseUrl + 'rest/companies/getCardRegistration' },
        updateCompanyType: { method: 'POST', url: baseUrl + 'rest/companies/updateCompanyType' },
        updateUserLegal: { method: 'POST', url: baseUrl + 'rest/companies/updateUserLegal' },
        updateCompanyWallet: { method: 'POST', url: baseUrl + 'rest/companies/updateCompanyWallet' },
        updateBankAccount: { method: 'POST', url: baseUrl + 'rest/companies/updateBankAccount' },
        createMandate: { method: 'POST', url: baseUrl + 'rest/companies/createMandate' },
        getWalletData: { method: 'POST', url: baseUrl + 'rest/companies/getWalletData' },
        getWalletAmount: { method: 'POST', url: baseUrl + 'rest/companies/getWalletAmount' },
        getWalletPayIns: { method: 'POST', url: baseUrl + 'rest/companies/getWalletPayIns/:page' },
        disableRwg: { method: 'PUT', url: baseUrl + 'rest/reserve-with-google/subscription/disable' },
        payOut: { method: 'POST', url: baseUrl + 'rest/companies/payOut' },
        billingManager: { method: 'GET', url: baseUrl + 'rest/companies/:companyCode/billing-manager' },
        crmInformations: { method: 'GET', url: baseUrl + 'rest/crm/:companyCode' },
        notifyAdminUpdate: { method: 'GET', url: baseUrl + 'rest/companies/notify-admin-update/:companyCode?isAdmin=:isAdmin' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Company', ["Company_Resource", "CompanyData", "User", "Subscription", "Invoice", "CompanyCommercialAction", "GroupData", "$sce", "UserData", "PartnerData", "CurrencyData", "StoreAppCode", "OfferManager", function (Company_Resource, CompanyData, User, Subscription, Invoice, CompanyCommercialAction, GroupData, $sce, UserData, PartnerData, CurrencyData, StoreAppCode, OfferManager) {
    var Company = function Company(resource, loadInvoices) {
        this.code = null; //id
        this.isDeleted = false;
        this.group = null;
        this._groupId = null;
        this.timeCreated = null;
        this.timeCanceled = null;
        this.isLive = false;
        this.hasVatOnBill = true;
        this.vat = null;
        this.name = null;
        this.vatNumber = null;
        this.type = null;
        this.country = null;
        this.comment = null;
        this.appMobile = null;
        this.appMobileSecureUrl = null;
        this.manager = null;
        this._acManagerId = null;
        this.acManager = null;
        this.discountCode = null;
        this.discountCodeIsUsed = null;
        this.startModel = null;
        this.startModelId = null;
        this.modelLocale = "";
        this.modelDefaultLocale = false;
        this.companyTypeId = "";
        this.users = [];
        this.subscriptions = [];
        this.isSubscriptionsChange = false;
        this.legalType = null;
        this.companyCommercialActions = [];
        this.estimateInvoices = {
            currentMonthInvoice: null,
            nextMonthInvoice: null
        };
        this.cardDetails = {
            creationDate: null,
            active: false,
            expirationDate: "",
            alias: "",
            cardProvider: "",
            validity: ""
        };
        this.companyPaymentData = null;
        this.invoices = [];
        this.companyLegal = null;
        this.onlineAmount = 0;
        this.level3ds = null;
        this.noCnxAlertTo = null;
        this.opinionHelpDesk = 10;
        this.opinionSolution = 10;
        this.externalSessionTokens = [];
        this.opinionSolution = 10;
        this.billingPartner = null;
        this._billingPartnerId = null;
        this.billingPartnerIdCustomer = null;
        this.billingPartnerSecretKey = null;
        this.billingPartnerAccountType = null;
        this.localeCode = null;
        this.currency = null;
        this._currencyId = null;
        this.brands = [];
        this.autoInvoice = false;
        this.kycStatus = null;
        this.activeOffer = null;

        if (resource !== undefined && resource !== null) {
            this.loadObject(resource, loadInvoices);
        }

        CompanyData.add(this);
    };

    Company.prototype.loadObject = function (object, loadInvoices) {
        if (object) {
            this.code = object.code;
            this.legalType = object.legalType;
            if (object.timeCreated) {
                this.timeCreated = new Date(object.timeCreated);
            }
            if (object.timeCanceled) {
                this.timeCanceled = new Date(object.timeCanceled);
            }
            if (object.noCnxAlertTo) {
                this.noCnxAlertTo = new Date(object.noCnxAlertTo);
            }
            this._groupId = object.groupId;
            this._acManagerId = object.acManagerId;
            this.isDeleted = object.isDeleted;
            this.isLive = object.isLive;
            this.hasVatOnBill = object.hasVatOnBill;
            if (object.vat !== undefined) {
                this.vat = object.vat;
            }
            this.name = object.name;
            this.vatNumber = object.vatNumber;
            this.type = object.type;
            this.country = object.country;
            this.localeCode = object.localeCode;
            this.modelDefaultLocale = object.modelDefaultLocale;
            this.modelLocale = object.modelLocale;
            this.companyTypeId = object.companyTypeId;
            this.comment = object.comment;
            this.appMobile = object.appMobile;
            if (this.appMobile) {
                this.appMobileSecureUrl = $sce.trustAsResourceUrl(this.appMobile);
            }
            this.manager = object.manager;
            this.startModel = object.startModel;
            this.startModelId = object.startModelId;
            this.discountCode = object.discountCode;
            this.discountCodeIsUsed = object.discountCodeIsUsed;
            this.level3ds = object.level3ds;
            this.users = [];
            var user = void 0;
            if (object.users) {
                for (var i = 0; i < object.users.length; i++) {
                    user = UserData.getById(object.users[i].id);
                    if (!user) {
                        user = new User(object.users[i]);
                    }
                    this.users.push(user);
                    user.company = this;
                }
            }
            this.subscriptions = [];
            if (object.subscriptions) {
                for (var _i = 0; _i < object.subscriptions.length; _i++) {
                    this.subscriptions.push(new Subscription(object.subscriptions[_i]));
                }
            }
            this.companyCommercialActions = [];
            if (object.companyCommercialActions) {
                for (var _i2 = 0; _i2 < object.companyCommercialActions.length; _i2++) {
                    this.companyCommercialActions.push(new CompanyCommercialAction(object.companyCommercialActions[_i2], this));
                }
            }
            if (object.estimateInvoices) {
                this.loadEstimateInvoices(object.estimateInvoices);
            }
            this.invoices = [];
            if (object.invoices && loadInvoices) {
                for (var _i3 = 0; _i3 < object.invoices.length; _i3++) {
                    this.invoices.push(new Invoice(object.invoices[_i3], this));
                }
            }
            this.onlineAmount = object.onlineAmount;
            if (object.opinionSolution !== undefined) {
                this.opinionSolution = object.opinionSolution;
            }
            if (object.opinionHelpDesk !== undefined) {
                this.opinionHelpDesk = object.opinionHelpDesk;
            }

            this.externalSessionTokens = [];
            if (object.externalSessionTokens) {
                for (var _i4 = 0; _i4 < object.externalSessionTokens.length; _i4++) {
                    this.externalSessionTokens.push(object.externalSessionTokens[_i4]);
                }
            }
            this.loadPaymentData(object);
            if (object.billingPartner) {
                this._billingPartnerId = object.billingPartner.partner.id;
                this.billingPartnerIdCustomer = object.billingPartner.partnerIdCustomer;
                this.billingPartnerSecretKey = object.billingPartner.partnerSecurityKey;
                this.billingPartnerAccountType = object.billingPartner.partnerAccountType;
            }
            this._currencyId = object.currencyId;
            if (object.brands) {
                this.brands = object.brands;
            }
            if (object.autoInvoice != null) {
                this.autoInvoice = object.autoInvoice;
            }
            this.kycStatus = object.kycStatus;
            this.activeOffer = object.activeOffer;
        }
    };

    Company.prototype.loadRelatedData = function (object) {
        if (object) {
            this.invoices = [];
            if (object.invoices) {
                for (var i = 0; i < object.invoices.length; i++) {
                    this.invoices.push(new Invoice(object.invoices[i], this));
                }
            }
        }
    };

    Company.prototype.loadPaymentData = function (object) {
        if (object.companyPaymentData) {
            this.companyPaymentData = JSON.parse(JSON.stringify(object.companyPaymentData));
        } //clone
        if (object.cardDetails) {
            this.loadObjectCardDetails(object.cardDetails);
        }
        if (object.companyLegal) {
            this.companyLegal = {
                name: object.companyLegal.name,
                email: object.companyLegal.email,
                companyNumber: object.companyLegal.companyNumber,
                headquartersAddressLine1: object.companyLegal.headquartersAddressLine1,
                headquartersPostalCode: object.companyLegal.headquartersPostalCode,
                headquartersCity: object.companyLegal.headquartersCity,
                headquartersCountry: object.companyLegal.headquartersCountry,
                legalRepresentativeFirstName: object.companyLegal.legalRepresentativeFirstName,
                legalRepresentativeLastName: object.companyLegal.legalRepresentativeLastName,
                legalRepresentativeEmail: object.companyLegal.legalRepresentativeEmail,
                legalRepresentativeBirthday: new Date(object.companyLegal.legalRepresentativeBirthday),
                legalRepresentativeCountryOfResidence: object.companyLegal.legalRepresentativeCountryOfResidence,
                legalRepresentativeNationality: object.companyLegal.legalRepresentativeNationality
            };
        }
    };

    Company.prototype.loadObjectCardDetails = function (cardDetailsObject) {
        if (this.cardDetails && cardDetailsObject) {
            if (cardDetailsObject.creationDate) {
                this.cardDetails.creationDate = new Date(cardDetailsObject.creationDate);
            }
            this.cardDetails.active = cardDetailsObject.active;
            this.cardDetails.expirationDate = cardDetailsObject.expirationDate;
            this.cardDetails.alias = cardDetailsObject.alias;
            this.cardDetails.cardProvider = cardDetailsObject.cardProvider;
            this.cardDetails.validity = cardDetailsObject.validity;
        }
    };

    Company.prototype.loadEstimateInvoices = function (estimateInvoices) {
        if (estimateInvoices.currentMonthInvoice) {
            this.estimateInvoices.currentMonthInvoice = new Invoice(estimateInvoices.currentMonthInvoice, this);
        }
        if (estimateInvoices.nextMonthInvoice) {
            this.estimateInvoices.nextMonthInvoice = new Invoice(estimateInvoices.nextMonthInvoice, this);
        }
    };

    Company.prototype.getObjectResource = function () {
        var companyRes = new Company_Resource();

        companyRes.isDeleted = this.isDeleted;
        companyRes.timeCanceled = this.timeCanceled;
        companyRes.noCnxAlertTo = this.noCnxAlertTo;
        companyRes.code = this.code;
        companyRes.name = this.name;
        companyRes.type = this.type;
        companyRes.country = this.country;
        companyRes.comment = this.comment;
        companyRes.appMobile = this.appMobile;
        companyRes.manager = this.manager;
        companyRes.isLive = this.isLive;
        companyRes.hasVatOnBill = this.hasVatOnBill;
        companyRes.vat = this.vat;
        companyRes.vatNumber = this.vatNumber;
        companyRes.discountCode = this.discountCode;
        companyRes.discountCodeIsUsed = this.discountCodeIsUsed;
        companyRes.isSubscriptionsChange = this.isSubscriptionsChange;
        companyRes.level3ds = this.level3ds;
        companyRes.modelLocale = this.modelLocale;
        companyRes.modelDefaultLocale = this.modelDefaultLocale;
        companyRes.companyTypeId = this.companyTypeId;
        if (this.autoInvoice != null) {
            companyRes.autoInvoice = this.autoInvoice;
        }
        if (this.acManager) {
            companyRes.acManagerId = this.acManager.id;
        }
        if (this.localeCode) {
            companyRes.localeCode = this.localeCode;
        }
        if (this.currency) {
            companyRes.currencyId = this.currency.id;
        }
        if (this.startModelId != null && this.startModelId !== '') {
            companyRes.startModelId = this.startModelId;
        }
        if (this.billingPartner) {
            companyRes.billingPartner = {};
            companyRes.billingPartner.partner = this.billingPartner;
            companyRes.billingPartner.partnerIdCustomer = this.billingPartnerIdCustomer;
            companyRes.billingPartner.partnerSecurityKey = this.billingPartnerSecretKey;
            companyRes.billingPartner.partnerAccountType = this.billingPartnerAccountType;
        }

        companyRes.subscriptions = [];
        if (this.subscriptions) {
            for (var i = 0; i < this.subscriptions.length; i++) {
                companyRes.subscriptions.push(this.subscriptions[i].getObjectResource());
            }
        }
        companyRes.companyCommercialActions = [];
        if (this.companyCommercialActions) {
            for (var _i5 = 0; _i5 < this.companyCommercialActions.length; _i5++) {
                companyRes.companyCommercialActions.push(this.companyCommercialActions[_i5].getObjectResource());
            }
        }
        companyRes.kycStatus = this.kycStatus;
        companyRes.activeOffer = this.activeOffer;
        return companyRes;
    };

    Company.prototype.getSubscriptionsResource = function () {
        var companyRes = new Company_Resource();

        companyRes.code = this.code;
        companyRes.isSubscriptionsChange = this.isSubscriptionsChange;
        companyRes.subscriptions = [];
        if (this.subscriptions) {
            for (var i = 0; i < this.subscriptions.length; i++) {
                companyRes.subscriptions.push(this.subscriptions[i].getObjectResource());
            }
        }
        return companyRes;
    };

    Company.prototype.getCompanyLegalResource = function () {
        var companySrv = new Company_Resource();
        if (this.companyLegal) {
            companySrv.companyCode = this.code;
            companySrv.vatNumber = this.vatNumber;
            companySrv.country = this.country;
            companySrv.name = this.companyLegal.name;
            companySrv.email = this.companyLegal.email;
            companySrv.companyNumber = this.companyLegal.companyNumber;
            companySrv.headquartersAddressLine1 = this.companyLegal.headquartersAddressLine1;
            companySrv.headquartersPostalCode = this.companyLegal.headquartersPostalCode;
            companySrv.headquartersCity = this.companyLegal.headquartersCity;
            companySrv.headquartersCountry = this.companyLegal.headquartersCountry;
            companySrv.legalRepresentativeFirstName = this.companyLegal.legalRepresentativeFirstName;
            companySrv.legalRepresentativeLastName = this.companyLegal.legalRepresentativeLastName;
            companySrv.legalRepresentativeEmail = this.companyLegal.legalRepresentativeEmail;
            companySrv.legalRepresentativeBirthday = this.companyLegal.legalRepresentativeBirthday;
            companySrv.legalRepresentativeCountryOfResidence = this.companyLegal.legalRepresentativeCountryOfResidence;
            companySrv.legalRepresentativeNationality = this.companyLegal.legalRepresentativeNationality;
        }

        return companySrv;
    };

    Company.prototype.addSubscription = function (subscription) {
        var index = this.subscriptions.indexOf(subscription);
        if (index === -1) {
            this.subscriptions.push(subscription);
        }
    };

    Company.prototype.addCompanyCommercialAction = function (companyCommercialAction) {
        var index = this.companyCommercialActions.indexOf(companyCommercialAction);
        if (index === -1) {
            this.companyCommercialActions.push(companyCommercialAction);
        }
    };

    Company.prototype.getSubscriptionPlan = function () {
        return OfferManager.computeCompanyOfferCode(this);
    };

    Company.prototype.hasSubscriptionActive = function (code) {
        for (var i = 0; i < this.subscriptions.length; i++) {
            if (this.subscriptions[i].isActive && this.subscriptions[i].storeApp && this.subscriptions[i].storeApp.code === code) {
                return true;
            }
        }
        return false;
    };

    Company.prototype.getOldSubscriptionCode = function () {
        return OfferManager.computeCompanyOfferCode(this);
    };

    Company.prototype.getActiveSubscription = function (code) {
        for (var i = 0; i < this.subscriptions.length; i++) {
            if (this.subscriptions[i].isActive && this.subscriptions[i].storeApp && this.subscriptions[i].storeApp.code === code) {
                return this.subscriptions[i];
            }
        }
        return null;
    };

    Company.prototype.loadRef = function () {
        if (this.subscriptions) {
            for (var i = 0; i < this.subscriptions.length; i++) {
                this.subscriptions[i].loadRef();
            }
        }
        if (this._groupId) {
            var group = GroupData.getById(this._groupId);
            if (group) {
                group.addCompany(this);
            }
        }
        if (this._acManagerId) {
            this.acManager = UserData.getById(this._acManagerId);
        }

        if (this._billingPartnerId) {
            this.billingPartner = PartnerData.getById(this._billingPartnerId);
        }

        if (this._currencyId) {
            this.currency = CurrencyData.getById(this._currencyId);
        }
    };

    return Company;
}]);

angular.module('FlexyBeautyApp.services').factory('CompanySrv', ["$log", "ServerSrv", "Company_Resource", "CompanyData", "Company", "OfferManager", "$http", function ($log, ServerSrv, Company_Resource, CompanyData, Company, OfferManager, $http) {
    var companySrv = {};

    companySrv.query = function (successFunction, errorFunction) {
        Company_Resource.query({}, function (data) {
            CompanyData.clear();
            for (var i = 0; i < data.length; i++) {
                new Company(data[i], true);
            }

            if (successFunction !== undefined) {
                successFunction();
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.fastQuery = function (loadInvoices, successFunction, errorFunction) {
        companySrv.listCodes(function (codes) {
            companySrv.loadFromCodes(codes, loadInvoices, successFunction, errorFunction);
        }, errorFunction);
    };

    companySrv.fastQueryByStatus = function (status, loadInvoices, successFunction, errorFunction) {
        companySrv.listCodesByStatus(status, function (codes) {
            companySrv.loadFromCodes(codes, loadInvoices, successFunction, errorFunction);
        }, errorFunction);
    };

    companySrv.fastQueryDeleted = function (successFunction, errorFunction) {
        companySrv.listCodesDeleted(function (codes) {
            companySrv.loadFromCodes(codes, false, successFunction, errorFunction);
        }, errorFunction);
    };

    companySrv.loadFromCodes = function (codes, loadInvoices, successFunction, errorFunction) {
        if (codes) {
            (function () {
                var loaders = [{ loading: true, codes: [] }];
                var j = 0;
                var size = 30;
                for (var i = 0; i < codes.length; i++) {
                    loaders[j].codes.push(codes[i]);
                    if ((i + 1) % size === 0 && i + 1 < codes.length) {
                        loaders.push({ loading: true, codes: [] });
                        j++;
                    }
                }
                for (var _i6 = 0; _i6 < loaders.length; _i6++) {
                    companySrv.listFromCodes(_i6, loaders[_i6].codes, function (index, companyList) {
                        if (companyList && companyList.companies) {
                            for (var _i7 = 0; _i7 < companyList.companies.length; _i7++) {
                                new Company(companyList.companies[_i7], loadInvoices);
                            }
                        }
                        var finish = true;
                        loaders[index].loading = false;
                        for (var k = 0; k < loaders.length && finish; k++) {
                            finish = !loaders[k].loading;
                        }
                        if (finish && successFunction !== undefined) {
                            successFunction();
                        }
                    }, errorFunction);
                }
            })();
        }
    };

    companySrv.listFromCodes = function (index, codes, successFunction, errorFunction) {
        var rs = new Company_Resource();
        rs.codes = codes;
        rs.$listFromCodes({}, //params
        function (data) {
            if (successFunction !== undefined) {
                successFunction(index, data);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.listOnlineSales = function (successFunction, errorFunction) {
        companySrv.listCodes(function (codes) {
            companySrv.loadOnlineFromCodes(codes, successFunction, errorFunction);
        }, errorFunction);
    };

    companySrv.listBrands = function (successFunction, errorFunction) {
        companySrv.listCodes(function (codes) {
            companySrv.loadBrandsFromCodes(codes, successFunction, errorFunction);
        }, errorFunction);
    };

    companySrv.loadBrandsFromCodes = function (codes, successFunction, errorFunction) {
        if (codes) {
            (function () {
                var loaders = [{ loading: true, codes: [] }];
                var j = 0;
                var size = 15;
                for (var i = 0; i < codes.length; i++) {
                    loaders[j].codes.push(codes[i]);
                    if ((i + 1) % size === 0 && i + 1 < codes.length) {
                        loaders.push({ loading: true, codes: [] });
                        j++;
                    }
                }
                for (var _i8 = 0; _i8 < loaders.length; _i8++) {
                    companySrv.listBrandsFromCodes(_i8, loaders[_i8].codes, function (index, companyList) {
                        var company = null;
                        if (companyList && companyList.companies) {
                            for (var _i9 = 0; _i9 < companyList.companies.length; _i9++) {
                                if (companyList.companies[_i9]) {
                                    company = CompanyData.getByCode(companyList.companies[_i9].code);
                                    if (company) {
                                        company.brands = companyList.companies[_i9].brands;
                                        CompanyData.addToBrandList(company);
                                    }
                                }
                            }
                        }
                        var finish = true;
                        loaders[index].loading = false;
                        for (var k = 0; k < loaders.length && finish; k++) {
                            finish = !loaders[k].loading;
                        }
                        if (finish && successFunction !== undefined) {
                            successFunction();
                        }
                    }, function (index) {
                        loaders[index].loading = false;
                        var finish = true;
                        for (var k = 0; k < loaders.length && finish; k++) {
                            finish = !loaders[k].loading;
                        }
                        if (finish && successFunction !== undefined) {
                            successFunction();
                        }
                    });
                }
            })();
        }
    };

    companySrv.loadOnlineFromCodes = function (codes, successFunction, errorFunction) {
        if (codes) {
            (function () {
                var loaders = [{ loading: true, codes: [] }];
                var j = 0;
                var size = 10;
                var company = void 0;
                for (var i = 0; i < codes.length; i++) {
                    company = CompanyData.getByCode(codes[i]);
                    if (company && (company.type === "customer" || company.type === "partner") && OfferManager.hasCompanyAccessToFeature(company, StoreAppCode.OPTION_WEBSITE)) {
                        loaders[j].codes.push(codes[i]);
                        if ((i + 1) % size === 0 && i + 1 < codes.length) {
                            loaders.push({ loading: true, codes: [] });
                            j++;
                        }
                    }
                }
                for (var _i10 = 0; _i10 < loaders.length; _i10++) {
                    companySrv.listOnlineFromCodes(_i10, loaders[_i10].codes, function (index, companyList) {
                        var company = null;
                        if (companyList && companyList.companies) {
                            for (var _i11 = 0; _i11 < companyList.companies.length; _i11++) {
                                if (companyList.companies[_i11]) {
                                    company = CompanyData.getByCode(companyList.companies[_i11].code);
                                    if (company) {
                                        company.onlineAmount = companyList.companies[_i11].onlineAmount;
                                        if (companyList.companies[_i11].bookingStats && companyList.companies[_i11].bookingStats.length === 6) {
                                            company.bookingStats = {
                                                nbOut: companyList.companies[_i11].bookingStats[0],
                                                nbIn: companyList.companies[_i11].bookingStats[1],
                                                nbOnSite: companyList.companies[_i11].bookingStats[2],
                                                priceOut: companyList.companies[_i11].bookingStats[3],
                                                priceIn: companyList.companies[_i11].bookingStats[4],
                                                priceOnSite: companyList.companies[_i11].bookingStats[5]
                                            };
                                        }
                                    }
                                }
                            }
                        }
                        var finish = true;
                        loaders[index].loading = false;
                        for (var k = 0; k < loaders.length && finish; k++) {
                            finish = !loaders[k].loading;
                        }
                        if (finish && successFunction !== undefined) {
                            successFunction();
                        }
                    }, function (index) {
                        loaders[index].loading = false;
                        var finish = true;
                        for (var k = 0; k < loaders.length && finish; k++) {
                            finish = !loaders[k].loading;
                        }
                        if (finish && successFunction !== undefined) {
                            successFunction();
                        }
                    });
                }
            })();
        }
    };

    companySrv.listBrandsFromCodes = function (index, codes, successFunction, errorFunction) {
        var rs = new Company_Resource();
        rs.codes = codes;
        rs.$listBrands({}, //params
        function (data) {
            if (successFunction !== undefined) {
                successFunction(index, data);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(index, data);
            }
        });
    };

    companySrv.listOnlineFromCodes = function (index, codes, successFunction, errorFunction) {
        var rs = new Company_Resource();
        rs.codes = codes;
        rs.$listOnlineSales({}, //params
        function (data) {
            if (successFunction !== undefined) {
                successFunction(index, data);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(index, data);
            }
        });
    };

    companySrv.listCodes = function (successFunction, errorFunction) {
        Company_Resource.listCodes({}, //params
        function (data) {
            if (successFunction !== undefined) {
                successFunction(data);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.listCodesByStatus = function (status, successFunction, errorFunction) {
        Company_Resource.listCodesByStatus({ status: status }, //params
        function (data) {
            if (successFunction !== undefined) {
                successFunction(data);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.listRelatedData = function (successFunction, errorFunction) {
        Company_Resource.listRelatedData({}, //params
        function (data) {
            var company = void 0;
            for (var i = 0; i < data.length; i++) {
                company = CompanyData.getByCode(data[i].code);
                if (company) {
                    company.loadRelatedData(data[i]);
                }
            }
            if (successFunction !== undefined) {
                successFunction();
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.listCodesDeleted = function (successFunction, errorFunction) {
        Company_Resource.listCodesDeleted({}, //params
        function (data) {
            if (successFunction !== undefined) {
                successFunction(data);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.listDeleted = function (successFunction, errorFunction) {
        Company_Resource.listDeleted({}, //params
        function (data) {

            for (var i = 0; i < data.length; i++) {
                new Company(data[i]);
            }

            if (successFunction !== undefined) {
                successFunction();
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.listCardDetails = function (successFunction, errorFunction) {
        Company_Resource.listCardDetails({}, //params
        function (data) {
            var company = void 0;
            for (var i = 0; i < data.length; i++) {
                company = CompanyData.getByCode(data[i].code);
                if (company) {
                    company.loadObjectCardDetails(data[i].cardDetails);
                }
            }

            if (successFunction !== undefined) {
                successFunction();
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.reload = function (company, isReload, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(companySrv.reloadSync, company, isReload, successFunction, errorFunction);
    };

    companySrv.reloadSync = function (company, isReload, successFunction, errorFunction) {
        Company_Resource.get({ code: company.code }, //no params
        function (data) {
            //Save on server success :
            // -> add an user action (send message)
            try {
                company.loadObject(data, isReload);
                company.loadRef();
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    companySrv.notifyAdminUpdate = function (companyCode, isAdmin) {
        Company_Resource.notifyAdminUpdate({ companyCode: companyCode, isAdmin: isAdmin });
    };

    companySrv.save = function (company, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(companySrv.saveSync, company, successFunction, errorFunction);
    };

    companySrv.saveSync = function (company, successFunction, errorFunction) {
        var companyRes = company.getObjectResource();
        companyRes.$save({}, function (data) {
            try {
                company.loadEstimateInvoices(data);
                company.isSubscriptionsChange = false;
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    companySrv.saveSubscriptions = function (company, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(companySrv.saveSubscriptionsSync, company, successFunction, errorFunction);
    };

    companySrv.saveSubscriptionsSync = function (company, successFunction, errorFunction) {
        //$timeout (function () {

        var companyRes = company.getSubscriptionsResource();
        companyRes.$saveSubscriptions({}, //no params
        function (data) {
            try {
                company.loadEstimateInvoices(data);
                company.isSubscriptionsChange = false;
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    companySrv.exportCustomerFile = function (companyCode, localeCode, format) {
        return $http({
            method: "GET", url: 'rest/v2/customers-admin/export',
            headers: { 'Accept-Language': localeCode },
            params: { 'company-code': companyCode, 'format': format },
            responseType: 'blob'
        });
    };

    companySrv.exportBookings = function (companyCode) {
        return $http({
            method: "GET", url: 'rest/bookings/export',
            params: { 'company-code': companyCode },
            responseType: 'blob'
        });
    };

    companySrv.remove = function (company, successFunction, errorFunction) {
        CompanyData.remove(company);
        ServerSrv.startSavingProcess(companySrv.removeSync, company, successFunction, errorFunction);
    };

    companySrv.removeSync = function (company, successFunction, errorFunction) {
        var companyRes = company.getObjectResource();
        companyRes.$remove({ code: company.code }, //no params
        function (data) {
            try {
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    companySrv.copyDataFromCompanySource = function (companyTarget, companySource, itemsToCopy, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(companySrv.copyDataFromCompanySourceSync, companyTarget, companySource, itemsToCopy, successFunction, errorFunction);
    };

    companySrv.copyDataFromCompanySourceSync = function (companyTarget, companySource, itemsToCopy, successFunction, errorFunction) {
        var companyRes = new Company_Resource();
        companyRes.companyTargetCode = companyTarget.code;
        companyRes.companySourceCode = companySource.code;
        companyRes.itemsToCopy = itemsToCopy;
        companyRes.$copyDataFromCompanySource({}, //no params
        function (data) {
            try {
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    companySrv.deleteCompanyData = function (company, deleteObj, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(companySrv.deleteCompanyDataSync, company, deleteObj, successFunction, errorFunction);
    };

    companySrv.deleteCompanyDataSync = function (company, deleteObj, successFunction, errorFunction) {
        var companyRes = new Company_Resource();
        companyRes.companyCode = company.code;
        companyRes.deleteCustomers = deleteObj.deleteCustomers;
        companyRes.deleteBookings = deleteObj.deleteBookings;
        companyRes.deleteProducts = deleteObj.deleteProducts;
        companyRes.deleteServices = deleteObj.deleteServices;
        companyRes.deleteSessions = deleteObj.deleteSessions;
        companyRes.$deleteCompanyData({}, //no params
        function (data) {
            company.externalSessionTokens.push({ token: data.token, timeCreated: data.timeCreated });
            //Save on server success :
            // -> add an user action (send message)
            try {
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    companySrv.generateSessionToken = function (company, external, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(companySrv.generateSessionTokenSync, company, external, successFunction, errorFunction);
    };

    companySrv.generateSessionTokenSync = function (company, external, successFunction, errorFunction) {
        var companyRes = new Company_Resource();
        companyRes.companyCode = company.code;
        companyRes.external = external;
        companyRes.$generateSessionToken({}, //no params
        function (data) {
            try {
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    companySrv.loadRef = function () {
        var companies = CompanyData.indexCompanies;
        for (var i = 0; i < companies.length; i++) {
            companies[i].loadRef();
        }
    };

    companySrv.getCardRegistration = function (company, successFunction, errorFunction) {
        if (company) {
            var _companySrv = company.getCompanyLegalResource();

            _companySrv.$getCardRegistration({}, //params
            function (data) {
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            }, function (data) {
                var errorMessage = "Error";
                if (errorFunction !== undefined) {
                    errorFunction(errorMessage);
                }
            });
        } else {
            if (errorFunction !== undefined) {
                errorFunction("companyLegal null");
            }
        }
    };

    companySrv.updateCompanyType = function (company, successFunction, errorFunction) {
        if (company) {
            var _companySrv2 = company.getObjectResource();
            _companySrv2.$updateCompanyType({}, //params
            function (data) {
                if (successFunction !== undefined) {
                    successFunction();
                }
            }, function (data) {
                var errorMessage = "";
                try {
                    if (data && data.data && data.data.consumerMessage) {
                        var errorObj = JSON.parse(data.data.consumerMessage);
                        if (errorObj && errorObj.errors) {
                            errorMessage = errorObj.errors;
                        }
                    }
                } finally {
                    if (errorFunction !== undefined) {
                        errorFunction();
                    }
                }
            });
        } else {
            if (errorFunction !== undefined) {
                errorFunction();
            }
        }
    };

    companySrv.updateUserLegal = function (company, successFunction, errorFunction) {
        if (company) {
            var _companySrv3 = company.getCompanyLegalResource();
            _companySrv3.$updateUserLegal({}, //params
            function (data) {
                if (data.userId) {
                    if (!company.companyPaymentData) {
                        company.companyPaymentData = {};
                    }
                    company.companyPaymentData.userId = data.userId;
                    company.companyPaymentData.walletId = data.walletId;
                }
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            }, function (data) {
                var errorMessage = "";
                try {
                    if (data && data.data && data.data.consumerMessage) {
                        var errorObj = JSON.parse(data.data.consumerMessage);
                        if (errorObj && errorObj.errors) {
                            errorMessage = errorObj.errors;
                        }
                    }
                } finally {
                    if (errorFunction !== undefined) {
                        errorFunction(errorMessage);
                    }
                }
            });
        } else {
            if (errorFunction !== undefined) {
                errorFunction("companyLegal null");
            }
        }
    };

    companySrv.updateCompanyWallet = function (company, successFunction, errorFunction) {
        if (company) {
            var _companySrv4 = company.getCompanyLegalResource();
            _companySrv4.$updateCompanyWallet({}, //params
            function (data) {
                if (data.userId) {
                    if (!company.companyPaymentData) {
                        company.companyPaymentData = {};
                    }
                    company.companyPaymentData.userId = data.userId;
                    company.companyPaymentData.walletId = data.walletId;
                }
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            }, function (data) {
                var errorMessage = "";
                try {
                    if (data && data.data && data.data.consumerMessage) {
                        var errorObj = JSON.parse(data.data.consumerMessage);
                        if (errorObj && errorObj.errors) {
                            errorMessage = errorObj.errors;
                        }
                    }
                } finally {
                    if (errorFunction !== undefined) {
                        errorFunction(errorMessage);
                    }
                }
            });
        } else {
            if (errorFunction !== undefined) {
                errorFunction("companyLegal null");
            }
        }
    };

    companySrv.resetDataF = function (company, resetData, successFunction, errorFunction) {
        if (company && resetData) {
            var _companySrv5 = new Company_Resource();
            _companySrv5.code = company.code;
            _companySrv5.removeBookings = resetData.removeBookings;
            _companySrv5.removeSales = resetData.removeSales;
            _companySrv5.removeCustomers = resetData.removeCustomers;
            _companySrv5.$resetDataF({}, //params
            function (data) {
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            }, function (data) {
                var errorMessage = "Error";
                if (errorFunction !== undefined) {
                    errorFunction(errorMessage);
                }
            });
        } else {
            if (errorFunction !== undefined) {
                errorFunction("company && resetData null");
            }
        }
    };

    companySrv.createMandate = function (company, successFunction, errorFunction) {
        Company_Resource.createMandate({}, //params
        function (resultMandate) {
            if (company && company.companyPaymentData) {
                company.companyPaymentData.mandateId = resultMandate.mandateId;
            }
            if (successFunction !== undefined) {
                successFunction(resultMandate);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.getWalletData = function (successFunction, errorFunction) {
        var companySrv = new Company_Resource();
        companySrv.$getWalletData({}, //params
        function (wallet) {
            if (wallet.scaAction.redirectUrl) {
                var currentDomain = $location.protocol() + '://' + $location.host();
                var encodedDomain = encodeURIComponent(currentDomain);
                var redirectUrl = data.redirectUrl + '&returnUrl=' + encodedDomain;
                $location.path(redirectUrl);
            }
            if (successFunction !== undefined) {
                successFunction(wallet);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.getWalletAmount = function (successFunction, errorFunction) {
        var companySrv = new Company_Resource();
        companySrv.$getWalletAmount({}, //params
        function (wallet) {
            if (successFunction !== undefined) {
                successFunction(wallet);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.getWalletPayIns = function (page, successFunction, errorFunction) {
        var companySrv = new Company_Resource();
        companySrv.$getWalletPayIns({ page: page }, //params
        function (wallet) {
            if (successFunction !== undefined) {
                successFunction(wallet);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.payOut = function (amount, successFunction, errorFunction) {
        var companySrv = new Company_Resource();
        companySrv.amount = amount;
        companySrv.$payOut({}, //params
        function (data) {
            if (successFunction !== undefined) {
                successFunction(data);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.restore = function (company, successFunction, errorFunction) {
        CompanyData.restore(company);
        ServerSrv.startSavingProcess(companySrv.restoreSync, company, successFunction, errorFunction);
    };

    companySrv.restoreSync = function (company, successFunction, errorFunction) {
        var CompanyRes = company.getObjectResource();
        CompanyRes.$save({}, //no params
        function (data) {
            try {
                if (successFunction !== undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    companySrv.disableRwg = function (companyCode, successFunction, errorFunction) {
        var companySrv = new Company_Resource(),
            params = {};

        if (companyCode) {
            params = {
                companyCode: companyCode
            };
        }
        companySrv.companyCode = companyCode;
        companySrv.$disableRwg(params, //params
        function () {
            if (successFunction !== undefined) {
                successFunction(wallet);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    companySrv.getBillingManager = function (companyCode) {
        return Company_Resource.billingManager({ companyCode: companyCode }).$promise;
    };

    companySrv.getCrmInformations = function (companyCode) {
        return Company_Resource.crmInformations({ companyCode: companyCode }).$promise;
    };

    return companySrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyData', ["$filter", function ($filter) {
    var companyDataSrv = {
        indexCompanies: [],
        activeCompanies: [],
        deletedCompanies: [], //deleted items,
        blockedCompanies: [],
        canceledCompanies: [],
        decleorCompanies: [],
        caritaCompanies: []
    };

    companyDataSrv.getByCode = function (companyCode) {
        for (var i = 0; i < this.indexCompanies.length; i++) {
            if (this.indexCompanies[i].code === companyCode) {
                return this.indexCompanies[i];
            }
        }
        return null;
    };

    companyDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexCompanies.length) {
            return this.indexCompanies[index];
        }
        return null;
    };

    companyDataSrv.getIndexOf = function (company) {
        if (company) {
            return this.indexCompanies.indexOf(company);
        }
        return -1;
    };

    companyDataSrv.addToBrandList = function (company) {
        for (var i = 0; i < company.brands.length; i++) {
            if (company.brands[i] === "DECLEOR") {
                if (this.decleorCompanies.indexOf(company) === -1) {
                    this.decleorCompanies.push(company);
                }
            }
            if (company.brands[i] === "CARITA") {
                if (this.caritaCompanies.indexOf(company) === -1) {
                    this.caritaCompanies.push(company);
                }
            }
        }
    };

    companyDataSrv.add = function (company) {
        var companyArray = this.activeCompanies;
        if (company.isDeleted) {
            companyArray = this.deletedCompanies;
        } else if (company.type == "blocked") {
            companyArray = this.blockedCompanies;
        } else if (company.type == "canceled") {
            companyArray = this.canceledCompanies;
        }
        var index = this.indexCompanies.indexOf(company);
        if (index !== -1) {
            var realIndex = companyArray.indexOf(company);
            if (realIndex === -1) {
                companyArray.push(company);
            }
        } else {
            index = this.indexCompanies.length;
            this.indexCompanies.push(company);
            companyArray.push(company);
        }

        this.addToBrandList(company);

        return index;
    };

    companyDataSrv.remove = function (company) {
        var index = this.activeCompanies.indexOf(company);
        if (index !== -1) {
            this.activeCompanies.splice(index, 1);
            this.deletedCompanies.push(company);
            company.isDeleted = true;
        }
    };

    companyDataSrv.restore = function (company) {
        var index = this.deletedCompanies.indexOf(company);
        if (index !== -1) {
            this.deletedCompanies.splice(index, 1);
            this.activeCompanies.push(company);
            company.isDeleted = false;
        }
    };

    companyDataSrv.clear = function () {
        this.indexCompanies = [];
        this.activeCompanies = [];
        this.deletedCompanies = [];
    };

    companyDataSrv.sort = function () {
        this.activeCompanies = $filter('orderBy')(this.activeCompanies, 'name', false);
        this.deletedCompanies = $filter('orderBy')(this.deletedCompanies, 'name', false);
    };

    companyDataSrv.getActiveList = function () {
        return this.activeCompanies;
    };

    companyDataSrv.getBlockedCompanies = function () {
        return this.blockedCompanies;
    };

    companyDataSrv.getCanceledCompanies = function () {
        return this.canceledCompanies;
    };

    companyDataSrv.getDeletedList = function () {
        return this.deletedCompanies;
    };

    return companyDataSrv;
}]);

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * CompanyCommercialAction: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CompanyCommercialAction_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/companyCommercialActions/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyCommercialAction', ["CompanyCommercialAction_Resource", "StoreAppData", "CompanyCommercialActionData", function (CompanyCommercialAction_Resource, StoreAppData, CompanyCommercialActionData) {
    //CompanyCommercialAction inherit of $resource

    var CompanyCommercialAction = function CompanyCommercialAction(resource, company) {
        // Call the parent constructor
        this.id = null;
        this.isDeleted = false;
        this.company = company;
        this.date = null;
        this.type = null;
        this.status = null;
        this.creator = null;
        this.author = null;
        this.description = null;

        if (resource !== undefined && resource != null) {
            if (resource.date) this.date = new Date(resource.date);
            if (!this.id) this.id = resource.id;
            this.isDeleted = resource.isDeleted;
            this.status = resource.status;
            this.type = resource.type;
            this.author = resource.author;
            this.creator = resource.creator;
            this.description = resource.description;
        }
        CompanyCommercialActionData.add(this);
    };
    CompanyCommercialAction.prototype.getObjectResource = function () {
        var rsSub = new CompanyCommercialAction_Resource();
        rsSub.id = this.id;
        if (this.company) rsSub.companyCode = this.company.code;
        rsSub.isDeleted = this.isDeleted;
        rsSub.date = this.date;
        rsSub.status = this.status;
        rsSub.type = this.type;
        rsSub.author = this.author;
        rsSub.creator = this.creator;
        rsSub.description = this.description;
        return rsSub;
    };

    return CompanyCommercialAction;
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyCommercialActionSrv', ["$log", "CompanyCommercialAction_Resource", "CompanyCommercialAction", "ServerSrv", "CompanyCommercialActionData", function ($log, CompanyCommercialAction_Resource, CompanyCommercialAction, ServerSrv, CompanyCommercialActionData) {
    var companyCommercialActionSrv = {};

    companyCommercialActionSrv.save = function (companyCommercialAction, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(companyCommercialActionSrv.saveSync, companyCommercialAction, successFunction, errorFunction);
    };
    companyCommercialActionSrv.saveSync = function (companyCommercialAction, successFunction, errorFunction) {
        //$timeout (function () {

        var companyCommercialActionRes = companyCommercialAction.getObjectResource();
        companyCommercialActionRes.$save({}, //no params
        function (data) {
            try {
                if (!companyCommercialAction.id) companyCommercialAction.id = data.id;
                /** @namespace data.workingPeriodsId */

                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    companyCommercialActionSrv.remove = function (companyCommercialAction, successFunction, errorFunction) {
        CompanyCommercialActionData.remove(companyCommercialAction);
        ServerSrv.startSavingProcess(companyCommercialActionSrv.removeSync, companyCommercialAction, successFunction, errorFunction);
    };
    companyCommercialActionSrv.removeSync = function (companyCommercialAction, successFunction, errorFunction) {
        var res = new CompanyCommercialAction_Resource();
        res.$remove({ id: companyCommercialAction.id }, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    return companyCommercialActionSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CompanyCommercialActionData', ["$log", function ($log) {
    var companyCommercialActionData = {
        indexCompanyCommercialActions: []
    };
    companyCommercialActionData.getById = function (companyCommercialActionId) {
        for (var i = 0; i < this.indexCompanyCommercialActions.length; i++) {
            if (this.indexCompanyCommercialActions[i].id == companyCommercialActionId) return this.indexCompanyCommercialActions[i];
        }return null;
    };
    companyCommercialActionData.getIndexOf = function (companyCommercialAction) {
        if (companyCommercialAction) return this.indexCompanyCommercialActions.indexOf(companyCommercialAction);
        return -1;
    };
    companyCommercialActionData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexCompanyCommercialActions.length) return this.indexCompanyCommercialActions[index];else return null;
    };
    companyCommercialActionData.add = function (companyCommercialAction) {
        this.indexCompanyCommercialActions.push(companyCommercialAction);
        return this.indexCompanyCommercialActions.length - 1;
    };
    companyCommercialActionData.clear = function () {
        companyCommercialActionData.indexCompanyCommercialActions = [];
    };
    companyCommercialActionData.remove = function (companyCommercialAction) {
        companyCommercialAction.isDeleted = true;
        if (companyCommercialAction.company && companyCommercialAction.company.companyCommercialActions) {
            var index = companyCommercialAction.company.companyCommercialActions.indexOf(companyCommercialAction);
            if (index != -1) {
                companyCommercialAction.company.companyCommercialActions.splice(index, 1);
            }
        }
    };

    return companyCommercialActionData;
}]);

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: bastienrobinot
 * Date: 04/01/18
 * Time: 16:50
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Currency_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/currencys/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        save: { method: 'POST', url: baseUrl + 'rest/currencys/' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Currency', ["Currency_Resource", "CurrencyData", function (Currency_Resource, CurrencyData) {
    var Currency = function Currency(resource) {
        this.id = null;
        this.code = false;
        this.name = null;
        this.symbol = null;
        this.codeMango = null;
        this.isPaymentAccepted = null;
        this.typeBankAccount = null;
        if (resource !== undefined && resource !== null) this.loadObject(resource);

        CurrencyData.add(this);
    };

    Currency.prototype.setId = function (id) {
        this.id = id;
    };
    Currency.prototype.getId = function () {
        return this.id;
    };

    Currency.prototype.loadObject = function (object) {
        if (object) {
            if (!this.id) this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.name = object.name;
            this.code = object.code;
            this.symbol = object.symbol;
            this.codeMango = object.codeMango;
            this.isPaymentAccepted = object.isPaymentAccepted;
            this.typeBankAccount = object.typeBankAccount;
        }
    };

    Currency.prototype.getObjectResource = function (object) {
        var newApp = new Currency_Resource();

        newApp.id = this.id;
        newApp.isDeleted = this.isDeleted;
        newApp.name = this.name;
        newApp.code = this.code;
        newApp.symbol = this.symbol;
        newApp.codeMango = this.codeMango;
        newApp.isPaymentAccepted = this.isPaymentAccepted;
        newApp.typeBankAccount = this.typeBankAccount;

        return newApp;
    };

    return Currency;
}]);

angular.module('FlexyBeautyApp.services').factory('CurrencySrv', ["$log", "ServerSrv", "Currency_Resource", "CurrencyData", "Currency", function ($log, ServerSrv, Currency_Resource, CurrencyData, Currency) {
    var currencySrv = {};

    currencySrv.query = function (successFunction, errorFunction) {
        Currency_Resource.query({}, //params
        function (data) {

            CurrencyData.clear();
            for (var i = 0; i < data.length; i++) {
                new Currency(data[i]);
            }

            if (successFunction !== undefined) successFunction();
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    currencySrv.restore = function (currency, successFunction, errorFunction) {
        CurrencyData.restore(currency);
        ServerSrv.startSavingProcess(currencySrv.restoreSync, currency, successFunction, errorFunction);
    };
    currencySrv.restoreSync = function (currency, successFunction, errorFunction) {
        //$timeout (function () {

        var CurrencyRes = currency.getObjectResource();
        CurrencyRes.$save({}, //no params
        function (data) {
            //Save on server success :
            // -> set id for new entity
            // -> add an user action (send message)
            try {
                currency.setId(data.id);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    currencySrv.save = function (currency, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(currencySrv.saveSync, currency, successFunction, errorFunction);
    };
    currencySrv.saveSync = function (currency, successFunction, errorFunction) {
        //$timeout (function () {

        var currencyRes = currency.getObjectResource();
        currencyRes.$save({}, //no params
        function (data) {
            try {
                currency.setId(data.id);
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    currencySrv.remove = function (currency, successFunction, errorFunction) {
        CurrencyData.remove(currency);
        ServerSrv.startSavingProcess(currencySrv.removeSync, currency, successFunction, errorFunction);
    };

    currencySrv.removeSync = function (currency, successFunction, errorFunction) {
        //$timeout (function () {

        var currencyRes = currency.getObjectResource();
        currencyRes.$remove({ id: currency.getId() }, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    return currencySrv;
}]);

angular.module('FlexyBeautyApp.services').factory('CurrencyData', ["$log", function ($log) {
    var currencyData = {
        indexCountries: [], //Used as Index
        activeCountries: [],
        deletedCountries: []
    };

    currencyData.getBycode = function (currencyCode) {
        for (var i = 0; i < this.indexCountries.length; i++) {
            if (this.indexCountries[i].code == currencyCode) return this.indexCountries[i];
        }return null;
    };

    currencyData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexCountries.length) {
            return this.indexCountries[servIndex];
        }
        return null;
    };

    currencyData.getById = function (currencyId) {
        for (var i = 0; i < this.indexCountries.length; i++) {
            if (this.indexCountries[i].id == currencyId) return this.indexCountries[i];
        }return null;
        return null;
    };

    currencyData.getIndexOf = function (currency) {
        if (currency) return this.indexCountries.indexOf(currency);
        return -1;
    };

    currencyData.add = function (currency) {
        var currencyArray = this.activeCountries;
        if (currency.isDeleted) currencyArray = this.deletedCountries;
        var index = this.indexCountries.indexOf(currency);
        if (index != -1) {
            var realIndex = currencyArray.indexOf(currency);
            if (realIndex == -1) currencyArray.push(currency);
        } else {
            index = this.indexCountries.length;
            this.indexCountries.push(currency);
            currencyArray.push(currency);
        }
        return index;
    };

    //Soft Remove
    currencyData.remove = function (currency) {
        var index = this.activeCountries.indexOf(currency);
        if (index != -1) {
            this.activeCountries.splice(index, 1);
            this.deletedCountries.push(currency);
            currency.isDeleted = true;
        }
    };

    //Soft Remove
    currencyData.restore = function (currency) {
        var index = this.deletedCountries.indexOf(currency);
        if (index != -1) {
            this.deletedCountries.splice(index, 1);
            this.activeCountries.push(currency);
            currency.isDeleted = false;
        }
    };
    currencyData.getActiveList = function () {
        return this.activeCountries;
    };

    currencyData.clear = function () {
        currencyData.indexCountries = [];
        currencyData.activeCountries = [];
        currencyData.deletedCountries = [];
    };

    currencyData.getDeletedList = function () {
        return currencyData.deletedCountries;
    };
    return currencyData;
}]);

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Group_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/groups/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
    return resourceBooking;
}]);

angular.module('FlexyBeautyApp.services').factory('Group', ["Group_Resource", "GroupData", "User", function (Group_Resource, GroupData, User) {
    var Group = function Group(resource) {
        this.id = null;
        this.isDeleted = false;
        this.timeCreated = null;
        this.name = null;
        this.comment = null;
        this.companies = [];
        this.users = [];
        this.loadObject(resource);
        GroupData.add(this);
    };
    Group.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id) this.id = object.id;
            this.isDeleted = object.isDeleted;
            if (object.timeCreated) this.timeCreated = new Date(object.timeCreated);
            this.name = object.name;
            this.comment = object.comment;
            if (object.users) for (var i = 0; i < object.users.length; i++) {
                this.users.push(new User(object.users[i]));
            }
        }
    };
    Group.prototype.getObjectResource = function () {
        var rsGroup = new Group_Resource();
        rsGroup.id = this.id;
        rsGroup.isDeleted = this.isDeleted;
        rsGroup.name = this.name;
        rsGroup.comment = this.comment;
        rsGroup.users = [];
        if (this.users) for (var i = 0; i < this.users.length; i++) {
            rsGroup.users.push(this.users[i].getObjectResourceForGroup());
        }rsGroup.companyCodes = [];
        if (this.companies) for (var i = 0; i < this.companies.length; i++) {
            rsGroup.companyCodes.push(this.companies[i].code);
        }return rsGroup;
    };
    Group.prototype.addCompany = function (company) {
        var index = this.companies.indexOf(company);
        if (index == -1) this.companies.push(company);
        company.group = this;
    };
    Group.prototype.removeCompany = function (company) {
        var index = this.companies.indexOf(company);
        if (index != -1) this.companies.splice(index, 1);
        company.group = null;
    };
    Group.prototype.getId = function () {
        return this.id;
    };

    Group.prototype.setId = function (id) {
        this.id = id;
    };
    return Group;
}]);

angular.module('FlexyBeautyApp.services').factory('GroupSrv', ["$log", "Group_Resource", "UserActionData", "Group", "GroupData", "ServerSrv", function ($log, Group_Resource, UserActionData, Group, GroupData, ServerSrv) {
    var groupSrv = {};

    groupSrv.query = function (successFunction, errorFunction) {
        Group_Resource.query({}, //params
        function (data) {
            //success
            GroupData.clear();
            for (var i = 0; i < data.length; i++) {
                new Group(data[i]);
            } //Auto Add to GroupData
            if (successFunction !== undefined) successFunction(GroupData.indexGroups);
        }, function (data) {
            //failure
            $log.error("Group_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    groupSrv.save = function (group, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(groupSrv.saveSync, group, successFunction, errorFunction);
    };
    groupSrv.saveSync = function (group, successFunction, errorFunction) {
        //$timeout (function () {

        var GroupRes = group.getObjectResource();
        GroupRes.$save({}, function (data) {
            try {
                group.setId(data.id);
                if (data.userIds) for (var i = 0; i < data.userIds.length && i < group.users.length; i++) {
                    group.users[i].id = data.userIds[i];
                }if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    groupSrv.remove = function (group, successFunction, errorFunction) {
        GroupData.remove(group);
        ServerSrv.startSavingProcess(groupSrv.removeSync, group, successFunction, errorFunction);
    };
    groupSrv.removeSync = function (group, successFunction, errorFunction) {
        //$timeout (function () {

        var groupSrv = new Group_Resource();
        groupSrv.$remove({ id: group.getId() }, //params : id
        function (data) {
            try {
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    groupSrv.restore = function (group, successFunction, errorFunction) {
        GroupData.restore(group);
        ServerSrv.startSavingProcess(groupSrv.restoreSync, group, successFunction, errorFunction);
    };
    groupSrv.restoreSync = function (group, successFunction, errorFunction) {
        //$timeout (function () {

        var GroupRes = group.getObjectResource();
        GroupRes.$save({}, //no params
        function (data) {
            try {
                group.setId(data.id);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    groupSrv.get = function (id, successFunction, errorFunction) {
        Group_Resource.get({ id: id }, //params
        function (groupResource) {
            if (successFunction != undefined) successFunction(new Group(groupResource));
        }, function (data) {
            if (errorFunction != undefined) errorFunction(data);
        });
    };

    groupSrv.updateLocally = function (id, resource) {
        var group = GroupData.getById(id);
        if (group != null) group.loadObject(resource);
        return group;
    };
    groupSrv.removeLocally = function (id, resource) {
        var group = GroupData.getById(id);
        if (group != null) GroupData.remove(group);
        return group;
    };
    groupSrv.addLocally = function (id, resource) {
        var group = GroupData.getById(id);
        if (group != null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                group.loadObject(resource);
                GroupData.add(group);
            } else {
            group = new Group(resource);
            group.id = id;
        }
        return group;
    };

    return groupSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('GroupData', ["$filter", function ($filter) {
    var custDataSrv = {
        indexGroups: [],
        activeGroups: [],
        deletedGroups: [] //deleted items
    };
    custDataSrv.getById = function (groupId) {
        for (var i = 0; i < this.indexGroups.length; i++) {
            if (this.indexGroups[i].getId() == groupId) return this.indexGroups[i];
        }return null;
    };
    custDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexGroups.length) return this.indexGroups[index];
        return null;
    };
    custDataSrv.getIndexOf = function (group) {
        if (group) return this.indexGroups.indexOf(group);
        return -1;
    };

    custDataSrv.add = function (group) {
        var groupArray = this.activeGroups;
        if (group.isDeleted) groupArray = this.deletedGroups;
        var index = this.indexGroups.indexOf(group);
        if (index != -1) {
            var realIndex = groupArray.indexOf(group);
            if (realIndex == -1) groupArray.push(group);
        } else {
            index = this.indexGroups.length;
            this.indexGroups.push(group);
            groupArray.push(group);
        }
        return index;
    };
    custDataSrv.remove = function (group) {
        var index = this.activeGroups.indexOf(group);
        if (index != -1) {
            this.activeGroups.splice(index, 1);
            this.deletedGroups.push(group);
            group.isDeleted = true;
        }
    };
    custDataSrv.restore = function (group) {
        var index = this.deletedGroups.indexOf(group);
        if (index != -1) {
            this.deletedGroups.splice(index, 1);
            this.activeGroups.push(group);
            group.isDeleted = false;
        }
    };
    custDataSrv.clear = function () {
        this.indexGroups = [];
        this.activeGroups = [];
        this.deletedGroups = [];
    };
    custDataSrv.sort = function () {
        this.activeGroups = $filter('orderBy')(this.activeGroups, 'name', false);
        this.deletedGroups = $filter('orderBy')(this.deletedGroups, 'name', false);
    };

    custDataSrv.getActiveList = function () {
        return this.activeGroups;
    };
    custDataSrv.getDeletedList = function () {
        return this.deletedGroups;
    };
    return custDataSrv;
}]);

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* Created with JetBrains WebStorm.
* User: sebastienbeaujard
* Date: 30/07/13
* Time: 10:58
* To change this template use File | Settings | File Templates.
*/

angular.module('FlexyBeautyApp.services').factory('HumanResource_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/humanResources/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
}]);
angular.module('FlexyBeautyApp.services').factory('HumanResource', ["HumanResource_Resource", "CategoryData", "ServiceData", "HumanResourceData", "HrRootOccupationRateCategory", "TypeOfSale", "HrRootCategory", "ProductCategoryData", "CureCategoryData", "LoyaltyCardCategoryData", "WorkingTimeRootCategory", "WorkingTimeHrBookingOpenTime", "WorkingTimeHrIndisponibilityTime", function (HumanResource_Resource, CategoryData, ServiceData, HumanResourceData, HrRootOccupationRateCategory, TypeOfSale, HrRootCategory, ProductCategoryData, CureCategoryData, LoyaltyCardCategoryData, WorkingTimeRootCategory, WorkingTimeHrBookingOpenTime, WorkingTimeHrIndisponibilityTime) {
    var HumanResource = function HumanResource(resource) {
        // Call the parent constructor
        this.id = null;
        this.isDeleted = false;
        this.label = "";
        this.firstName = "";
        this.lastName = "";
        this.phone = null;
        this.email = null;
        this.description = "";
        this.gender = "";
        this.color = "";
        this.photoId = null;
        this.hasPlanning = true;
        this.onLineBooking = true;
        this.order = null;
        this.services = [];
        this.version = null;
        if (resource !== undefined && resource != null) {
            this.loadObject(resource);
        } else {
            // all services are known by default then on creation init all services
            if (CategoryData.categoryRoot) {
                this.allServicesHaveToBeKnown(CategoryData.categoryRoot);
            }
        }
        HumanResourceData.add(this);
    };
    HumanResource.prototype.allServicesHaveToBeKnown = function (categoryRoot) {
        if (categoryRoot) {
            if (categoryRoot.services) {
                for (var i = 0; i < categoryRoot.services.length; i++) {
                    this.services.push(categoryRoot.services[i]);
                }
            }
            if (categoryRoot.categories) {
                for (var _i = 0; _i < categoryRoot.categories.length; _i++) {
                    if (categoryRoot.categories[_i].services) {
                        this.allServicesHaveToBeKnown(categoryRoot.categories[_i]);
                    }
                }
            }
        }
    };

    HumanResource.prototype.loadObject = function (object) {
        if (!this.id) {
            this.id = object.id;
        }
        this.isDeleted = object.isDeleted;
        this.label = object.label;
        this.firstName = object.firstName;
        this.lastName = object.lastName;
        this.phone = object.phone;
        this.email = object.email;
        this.description = object.description;
        this.gender = object.gender;
        this.color = object.color;
        this.photoId = object.photoId;
        this.hasPlanning = object.hasPlanning;
        this.onLineBooking = object.onLineBooking;
        this.servicesId = object.servicesId;
        this.order = object.order;
        if (object.version) {
            this.version = object.version;
        }
    };
    HumanResource.prototype.loadRef = function () {
        //load ref from ids
        if (this.servicesId && CategoryData.loaded()) {
            var newServices = [];
            for (var i = 0; i < this.servicesId.length; i++) {
                var service = ServiceData.getById(this.servicesId[i]);
                if (service != null) {
                    newServices.push(service);
                }
            }
            this.services = newServices;
        }
        delete this.servicesId;
    };

    HumanResource.prototype.getObjectResource = function () {
        var rsHumanResource = new HumanResource_Resource();
        rsHumanResource.id = this.id;
        rsHumanResource.isDeleted = this.isDeleted;
        rsHumanResource.label = this.label;
        rsHumanResource.firstName = this.firstName;
        rsHumanResource.lastName = this.lastName;
        rsHumanResource.phone = this.phone;
        rsHumanResource.email = this.email;
        rsHumanResource.description = this.description;
        rsHumanResource.gender = this.gender;
        rsHumanResource.color = this.color;
        rsHumanResource.photoId = this.photoId;
        rsHumanResource.hasPlanning = this.hasPlanning;
        rsHumanResource.onLineBooking = this.onLineBooking;
        rsHumanResource.order = this.order;

        rsHumanResource.servicesId = [];
        for (var i = 0; i < this.services.length; i++) {
            rsHumanResource.servicesId.push(this.services[i].getId());
        }

        return rsHumanResource;
    };

    HumanResource.prototype.copyToObject = function (object) {
        object.id = this.id;
        object.label = this.label;
        object.firstName = this.firstName;
        object.lastName = this.lastName;
        object.phone = this.phone;
        object.email = this.email;
        object.description = this.description;
        object.gender = this.gender;
        object.color = this.color;
        object.photoId = this.photoId;
        object.hasPlanning = this.hasPlanning;
        object.onLineBooking = this.onLineBooking;
        object.services = this.services;
    };
    HumanResource.prototype.getId = function () {
        return this.id;
    };
    HumanResource.prototype.setId = function (id) {
        this.id = id;
    };
    HumanResource.prototype.getLabel = function () {
        return this.label;
    };
    HumanResource.prototype.getId = function () {
        return this.id;
    };
    HumanResource.prototype.getName = function () {
        return this.firstName + " " + this.lastName;
    };
    HumanResource.prototype.getServices = function () {
        return this.services;
    };
    HumanResource.prototype.addService = function (service) {
        if (service && this.services.indexOf(service) == -1) this.services.push(service);
    };
    HumanResource.prototype.removeService = function (service) {
        var index = this.services.indexOf(service);
        if (index != -1) this.services.splice(index, 1);
    };
    HumanResource.prototype.hasService = function (service) {
        var know = false;
        if (this.services != null) know = this.services.indexOf(service) != -1;

        return know;
    };
    HumanResource.prototype.knowsCategory = function (category) {
        //Return true if HumanResource_services contains at least one item of the category.services
        if (category) if (category.services && category.services.length > 0) {
            //Sub category

            for (var i = 0; i < category.services.length; i++) {
                if (this.services.indexOf(category.services[i]) != -1) {
                    return true;
                }
            }
        } else {
            //master category
            if (category.categories && category.categories.length > 0) {
                for (var _i2 = 0; _i2 < category.categories.length; _i2++) {
                    if (this.knowsCategory(category.categories[_i2])) {
                        return true;
                    }
                }
            }
        }

        return false;
    };
    HumanResource.prototype.canPerformBookingService = function (bookingService) {
        var isFree = true;
        if (this.services.indexOf(bookingService.service) == -1) {
            //Resource do not have the service capability
            return false;
        }

        return isFree;
    };

    HumanResource.prototype.getSubStatCategories = function (rootCategory) {
        var subCategories = [];
        if (rootCategory === HrRootCategory) {
            subCategories = [CategoryData.categoryRoot, ProductCategoryData.categoryRoot, CureCategoryData.categoryRoot, LoyaltyCardCategoryData.categoryRoot];
        } else if (rootCategory === WorkingTimeRootCategory) {
            subCategories = [WorkingTimeHrBookingOpenTime, WorkingTimeHrIndisponibilityTime];
        }
        return subCategories;
    };

    HumanResource.prototype.statFilter = function (arrayOfDays) {
        return this.isWorkingOnPeriod(arrayOfDays);
    };

    HumanResource.prototype.isWorkingOnPeriod = function (arrayOfDays) {
        var isWorkingOnPeriod = false;
        for (var i = 0; i < arrayOfDays.length; i++) {
            isWorkingOnPeriod = isWorkingOnPeriod || arrayOfDays[i].hrIsWorking(this.id);
            if (isWorkingOnPeriod == true) {
                break;
            }
        }
        return isWorkingOnPeriod;
    };

    return HumanResource;
}]);

angular.module('FlexyBeautyApp.services').factory('HumanResourceSrv', ["$log", "HumanResource_Resource", "HumanResource", "HumanResourceData", "CategoryData", "UserActionData", "ServerSrv", function ($log, HumanResource_Resource, HumanResource, HumanResourceData, CategoryData, UserActionData, ServerSrv) {
    var hrSrv = {};

    hrSrv.query = function (successFunction, errorFunction) {
        HumanResource_Resource.query({}, //params
        function (data) {
            //success
            HumanResourceData.clear();

            for (var i = 0; i < data.length; i++) {
                new HumanResource(data[i]); //auto register to DATA
            }

            if (successFunction !== undefined) successFunction(HumanResourceData.getActiveList());
        }, function (data) {
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    hrSrv.reload = function (humanResource, successFunction, errorFunction) {
        var humanResourceSrv = new HumanResource_Resource();
        humanResourceSrv.$get({ id: humanResource.getId() }, //params : id
        function (data) {
            humanResource.loadObject(data);
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            //failure
            //error handling goes here
            //TODO
            if (errorFunction != undefined) errorFunction(data);
        });
    };
    hrSrv.restore = function (humanResource, successFunction, errorFunction) {
        HumanResourceData.restore(humanResource);
        ServerSrv.startSavingProcess(hrSrv.restoreSync, humanResource, successFunction, errorFunction);
    };
    hrSrv.restoreSync = function (humanResource, successFunction, errorFunction) {
        //$timeout (function () {

        var humanResourceRes = humanResource.getObjectResource();
        humanResourceRes.$save({}, //no params
        function (data) {
            try {
                humanResource.setId(data.id);
                UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    hrSrv.save = function (humanResource, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(hrSrv.saveSync, humanResource, successFunction, errorFunction);
    };
    hrSrv.saveSync = function (humanResource, successFunction, errorFunction) {
        //$timeout (function () {

        var humanResourceRes = humanResource.getObjectResource();
        humanResourceRes.$save({}, //no params
        function (data) {
            try {
                humanResource.setId(data.id);
                if (!humanResource.version || data.version && data.version > humanResource.version) humanResource.version = data.version;
                UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    hrSrv.remove = function (humanResource, successFunction, errorFunction) {
        HumanResourceData.remove(humanResource);
        ServerSrv.startSavingProcess(hrSrv.removeSync, humanResource, successFunction, errorFunction);
    };
    hrSrv.removeSync = function (humanResource, successFunction, errorFunction) {
        var humanResourceSrv = new HumanResource_Resource();
        humanResourceSrv.$remove({ id: humanResource.getId() }, //params : id
        function (data) {
            try {
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    hrSrv.updateLocally = function (id, objectToRestore) {
        var humanResource = HumanResourceData.getById(id);
        if (humanResource != null) {
            humanResource.loadObject(objectToRestore);
            humanResource.loadRef();
        }
        return humanResource;
    };
    hrSrv.removeLocally = function (id, object) {
        var humanResource = HumanResourceData.getById(id);
        if (humanResource != null) {
            HumanResourceData.remove(humanResource);
        }
        console.log(humanResource);
        return humanResource;
    };
    hrSrv.addLocally = function (id, objectToRestore) {
        var humanResource = HumanResourceData.getById(id);
        if (humanResource != null) {
            humanResource.loadObject(objectToRestore);
            humanResource.id = id;
            humanResource.loadRef();
            HumanResourceData.add(humanResource);
        }
        return humanResource;
    };
    hrSrv.loadRef = function () {
        var humanResources = HumanResourceData.getActiveList();
        for (var i = 0; i < humanResources.length; i++) {
            humanResources[i].loadRef();
        }
    };

    return hrSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('HumanResourceData', ["$log", function ($log) {
    var hrDataSrv = {
        indexHumanResources: [], //Never deleted (used as index)
        activeHumanResources: [], //active list
        deletedHumanResources: [] //deleted items
    };
    hrDataSrv.getActiveHrById = function (humanResourceId) {
        for (var i = 0; i < this.activeHumanResources.length; i++) {
            if (this.activeHumanResources[i].id == humanResourceId) return this.activeHumanResources[i];
        }return null;
    };
    hrDataSrv.getById = function (humanResourceId) {
        for (var i = 0; i < this.indexHumanResources.length; i++) {
            if (this.indexHumanResources[i].id == humanResourceId) return this.indexHumanResources[i];
        }return null;
    };
    hrDataSrv.getByEmail = function (hrMail) {
        for (var i = 0; i < this.indexHumanResources.length; i++) {
            if (this.indexHumanResources[i].email == hrMail) return this.indexHumanResources[i];
        }return null;
    };

    hrDataSrv.getIndexOf = function (hr) {
        if (hr) return this.indexHumanResources.indexOf(hr);
        return -1;
    };
    hrDataSrv.getByIndex = function (hrIndex) {
        if (hrIndex >= 0 && hrIndex < this.indexHumanResources.length) return this.indexHumanResources[hrIndex];else return null;
    };
    hrDataSrv.getFirstActive = function () {
        return this.activeHumanResources != null && this.activeHumanResources.length > 0 ? this.activeHumanResources[0] : null;
    };
    hrDataSrv.add = function (humanResource) {
        var hrArray = this.activeHumanResources;
        if (humanResource.isDeleted) hrArray = this.deletedHumanResources;
        var index = this.indexHumanResources.indexOf(humanResource);
        if (index != -1) {
            var realIndex = hrArray.indexOf(humanResource);
            if (realIndex == -1) hrArray.push(humanResource);
        } else {
            index = this.indexHumanResources.length;
            this.indexHumanResources.push(humanResource);
            hrArray.push(humanResource);
        }
        return index;
    };
    hrDataSrv.remove = function (humanResource) //Soft Remove
    {
        var index = this.activeHumanResources.indexOf(humanResource);
        if (index != -1) {
            this.activeHumanResources.splice(index, 1);
            this.deletedHumanResources.push(humanResource);
            humanResource.isDeleted = true;
        }
    };
    hrDataSrv.restore = function (humanResource) //Soft Remove
    {
        var index = this.deletedHumanResources.indexOf(humanResource);
        if (index != -1) {
            this.deletedHumanResources.splice(index, 1);
            this.activeHumanResources.push(humanResource);
            humanResource.isDeleted = false;
        }
    };
    hrDataSrv.clear = function () {
        this.indexHumanResources = [];
        this.activeHumanResources = [];
        this.deletedHumanResources = [];
    };
    hrDataSrv.getActiveList = function () {
        return this.activeHumanResources;
    };
    hrDataSrv.getDeletedList = function () {
        return this.deletedHumanResources;
    };

    return hrDataSrv;
}]);

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * Invoice: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Invoice_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/invoices/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        payIn: { method: 'POST', url: baseUrl + 'rest/invoices/payIn' },
        updateVat: { method: 'POST', url: baseUrl + 'rest/invoices/updateVat' },
        generateInvoiceOnPreviousMonth: { method: 'POST', url: baseUrl + 'rest/invoices/generate-monthly?month=:previousMonthNumber' },
        generateEstimateInvoice: { method: 'POST', url: baseUrl + 'rest/invoices/generateEstimateInvoice' },
        proceedPayment: { method: 'POST', url: baseUrl + 'rest/invoices/proceedPayment' },
        cancel: { method: 'POST', url: baseUrl + 'rest/invoices/cancel' },
        globalPayOut: { method: 'POST', url: baseUrl + 'rest/invoices/globalPayOut' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Invoice', ["Invoice_Resource", "StoreAppData", "InvoiceData", "Countries", function (Invoice_Resource, StoreAppData, InvoiceData, Countries) {
    //Invoice inherit of $resource

    var Invoice = function Invoice(resource, company) {
        // Call the parent constructor
        this.id = null;
        this.invoiceNumber = null;
        this.canNum = null;
        this.creNum = null;
        this.isDeleted = false;
        this.payInId = null;
        this.refundId = null;
        this.company = company;
        this.billingDate = null;
        this.periodStart = null;
        this.periodEnd = null;
        this.paymentDate = null;
        this.status = null;
        this.type = null;
        this.paymentType = null; //CB CHQ VIR VIRM
        this.paymentFailedMessage = null;
        this.subscriptionLines = [];
        this.subscriptionPrice = null;
        this.discountLines = [];
        this.percentDiscount = null;
        this.subscriptionPriceDiscount = null;
        this.usageBasedLines = [];
        this.usageBasedPrice = null;
        this.totalPrice = null;
        this.vat = null;
        this.vatNumber = null;
        this.totalPriceTTC = null;
        this.alreadyPayed = null;
        this.companyName = null;
        this.headquartersAddress = null;
        this.headquartersAddressLine1 = null;
        this.headquartersPostalCode = null;
        this.headquartersCity = null;
        this.headquartersCountry = null;
        this.legalRepresentativeFirstName = null;
        this.legalRepresentativeLastName = null;
        this.annualSubId = null;

        if (resource !== undefined && resource != null) this.loadObjectData(resource);

        InvoiceData.add(this);
    };
    Invoice.prototype.loadObjectData = function (resource) {
        if (resource !== undefined && resource != null) {
            if (!this.id) this.id = resource.id;
            this.invoiceNumber = resource.invoiceNumber;
            this.canNum = resource.canNum;
            this.creNum = resource.creNum;

            this.payInId = resource.payInId;
            this.refundId = resource.refundId;

            if (resource.billingDate) this.billingDate = new Date(resource.billingDate);
            if (resource.periodEnd) this.periodEnd = new Date(resource.periodEnd);
            if (resource.periodStart) {
                this.periodStart = new Date(resource.periodStart);
                // TODO fix Period end issue which is not at the end of the month but at the start of next month because timezone issue
                if (this.periodEnd && resource.annualSubId == null && this.periodEnd.getDay() == 1 && this.periodEnd.getMonth() == this.periodStart.getMonth() + 1) this.periodEnd = new Date(this.periodStart.getFullYear(), this.periodStart.getMonth() + 1, 0);
            }
            if (resource.paymentDate) this.paymentDate = new Date(resource.paymentDate);

            this.status = resource.status;
            this.type = resource.type;
            this.paymentType = resource.paymentType;
            this.paymentFailedMessage = resource.paymentFailedMessage;
            var invoiceLine;
            if (resource.subscriptionLines) for (var i = 0; i < resource.subscriptionLines.length; i++) {
                invoiceLine = {
                    label: resource.subscriptionLines[i].label,
                    priceUnit: resource.subscriptionLines[i].priceUnit,
                    unitLabel: resource.subscriptionLines[i].unitLabel,
                    price: resource.subscriptionLines[i].price,
                    quantity: resource.subscriptionLines[i].quantity,
                    percentDiscount: resource.subscriptionLines[i].percentDiscount };
                this.subscriptionLines.push(invoiceLine);
            }
            this.subscriptionPrice = resource.subscriptionPrice;
            if (resource.discountLines) for (var i = 0; i < resource.discountLines.length; i++) {
                invoiceLine = {
                    label: resource.discountLines[i].label,
                    priceUnit: resource.discountLines[i].priceUnit,
                    unitLabel: resource.discountLines[i].unitLabel,
                    price: resource.discountLines[i].price,
                    quantity: resource.discountLines[i].quantity,
                    percentDiscount: resource.discountLines[i].percentDiscount };
                this.discountLines.push(invoiceLine);
            }
            this.percentDiscount = resource.percentDiscount;;
            this.subscriptionPriceDiscount = resource.subscriptionPriceDiscount;;
            if (resource.usageBasedLines) for (var i = 0; i < resource.usageBasedLines.length; i++) {
                invoiceLine = {
                    label: resource.usageBasedLines[i].label,
                    priceUnit: resource.usageBasedLines[i].priceUnit,
                    unitLabel: resource.usageBasedLines[i].unitLabel,
                    price: resource.usageBasedLines[i].price,
                    quantity: resource.usageBasedLines[i].quantity,
                    percentDiscount: resource.usageBasedLines[i].percentDiscount };
                this.usageBasedLines.push(invoiceLine);
            }
            this.usageBasedPrice = resource.usageBasedPrice;;
            this.totalPrice = resource.totalPrice;
            this.vat = resource.vat;;
            this.vatNumber = resource.vatNumber;;
            this.totalPriceTTC = resource.totalPriceTTC;
            this.alreadyPayed = resource.alreadyPayed;
            this.companyName = resource.companyName;
            this.headquartersAddress = resource.headquartersAddress;
            this.headquartersAddressLine1 = resource.headquartersAddressLine1;
            this.headquartersPostalCode = resource.headquartersPostalCode;
            this.headquartersCity = resource.headquartersCity;
            this.headquartersCountry = resource.headquartersCountry;
            this.legalRepresentativeFirstName = resource.legalRepresentativeFirstName;
            this.legalRepresentativeLastName = resource.legalRepresentativeLastName;
            this.annualSubId = resource.annualSubId;
        }
    };
    Invoice.prototype.getObjectResource = function () {
        var invoiceRes = new Invoice_Resource();
        invoiceRes.id = this.id;
        if (this.company) invoiceRes.companyCode = this.company.code;
        invoiceRes.invoiceNumber = this.invoiceNumber;
        invoiceRes.payInId = this.payInId;
        if (this.billingDate) invoiceRes.billingDate = new Date(this.billingDate);
        if (this.periodStart) invoiceRes.periodStart = new Date(this.periodStart);
        if (this.periodEnd) invoiceRes.periodEnd = new Date(this.periodEnd);
        if (this.paymentDate) invoiceRes.paymentDate = new Date(this.paymentDate);
        invoiceRes.status = this.status;
        invoiceRes.type = this.type;
        invoiceRes.paymentType = this.paymentType;
        invoiceRes.paymentFailedMessage = this.paymentFailedMessage;
        var invoiceLine;
        invoiceRes.subscriptionLines = [];
        if (this.subscriptionLines) for (var i = 0; i < this.subscriptionLines.length; i++) {
            invoiceLine = {
                label: this.subscriptionLines[i].label,
                priceUnit: this.subscriptionLines[i].priceUnit,
                unitLabel: this.subscriptionLines[i].unitLabel,
                price: this.subscriptionLines[i].price,
                quantity: this.subscriptionLines[i].quantity,
                percentDiscount: this.subscriptionLines[i].percentDiscount };
            invoiceRes.subscriptionLines.push(invoiceLine);
        }
        invoiceRes.subscriptionPrice = this.subscriptionPrice;
        invoiceRes.discountLines = [];
        if (this.discountLines) for (var i = 0; i < this.discountLines.length; i++) {
            invoiceLine = {
                label: this.discountLines[i].label,
                priceUnit: this.discountLines[i].priceUnit,
                unitLabel: this.discountLines[i].unitLabel,
                price: this.discountLines[i].price,
                quantity: this.discountLines[i].quantity,
                percentDiscount: this.discountLines[i].percentDiscount };
            invoiceRes.discountLines.push(invoiceLine);
        }
        invoiceRes.percentDiscount = this.percentDiscount;;
        invoiceRes.subscriptionPriceDiscount = this.subscriptionPriceDiscount;;
        invoiceRes.usageBasedLines = [];
        if (this.usageBasedLines) for (var i = 0; i < this.usageBasedLines.length; i++) {
            invoiceLine = {
                label: this.usageBasedLines[i].label,
                priceUnit: this.usageBasedLines[i].priceUnit,
                unitLabel: this.usageBasedLines[i].unitLabel,
                price: this.usageBasedLines[i].price,
                quantity: this.usageBasedLines[i].quantity,
                percentDiscount: this.usageBasedLines[i].percentDiscount };
            invoiceRes.usageBasedLines.push(invoiceLine);
        }
        invoiceRes.usageBasedPrice = this.usageBasedPrice;;
        invoiceRes.totalPrice = this.totalPrice;
        invoiceRes.vat = this.vat;
        invoiceRes.vatNumber = this.vatNumber;
        invoiceRes.totalPriceTTC = this.totalPriceTTC;
        invoiceRes.alreadyPayed = this.alreadyPayed;
        invoiceRes.companyName = this.companyName;
        invoiceRes.legalRepresentativeFirstName = this.legalRepresentativeFirstName;
        invoiceRes.legalRepresentativeLastName = this.legalRepresentativeLastName;
        invoiceRes.annualSubId = this.annualSubId;
        //invoiceRes.headquartersAddress = this.headquartersAddress; //Updated by server
        return invoiceRes;
    };

    Invoice.prototype.loadRef = function () {
        this.storeApp = StoreAppData.getById(this._storeAppId);
    };
    return Invoice;
}]);

angular.module('FlexyBeautyApp.services').factory('InvoiceSrv', ["$log", "Invoice_Resource", "Invoice", "ServerSrv", "InvoiceData", function ($log, Invoice_Resource, Invoice, ServerSrv, InvoiceData) {
    var invoiceSrv = {};
    invoiceSrv.save = function (invoice, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(invoiceSrv.saveSync, invoice, successFunction, errorFunction);
    };
    invoiceSrv.saveSync = function (invoice, successFunction, errorFunction) {
        var invoiceRes = invoice.getObjectResource();
        invoiceRes.$save({}, //no params
        function (data) {
            try {
                if (data) invoice.invoiceNumber = data.invoiceNumber;
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    invoiceSrv.payIn = function (invoice, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(invoiceSrv.payInSync, invoice, successFunction, errorFunction);
    };
    invoiceSrv.payInSync = function (invoice, successFunction, errorFunction) {
        var invoiceRes = new Invoice_Resource();
        invoiceRes.id = invoice.id;
        invoiceRes.$payIn({}, //no params
        function (data) {
            if (data && data.status) {
                invoice.status = data.status;
                if (data.status == "paymentFailed" && data.paymentFailedMessage) invoice.paymentFailedMessage = data.paymentFailedMessage;
                invoice.invoiceNumber = data.invoiceNumber;
                invoice.paymentDate = data.paymentDate;
                invoice.payInId = data.payInId;
            }

            //Save on server success :
            // -> add an user action (send message)
            try {
                if (successFunction !== undefined) successFunction(invoice);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    invoiceSrv.updateVat = function (invoice, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(invoiceSrv.updateVatSync, invoice, successFunction, errorFunction);
    };
    invoiceSrv.updateVatSync = function (invoice, successFunction, errorFunction) {
        var invoiceRes = invoice.getObjectResource();

        invoiceRes.$updateVat({}, function (data) {
            invoice.vat = data.vat;
            invoice.totalPriceTTC = data.totalPriceTTC;
            try {
                if (successFunction !== undefined) successFunction(invoice);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    invoiceSrv.globalPayOut = function (successFunction, errorFunction) {
        ServerSrv.startSavingProcess(invoiceSrv.globalPayOutSync, successFunction, errorFunction);
    };
    invoiceSrv.globalPayOutSync = function (successFunction, errorFunction) {

        var invoiceRes = new Invoice_Resource();
        invoiceRes.$globalPayOut({}, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction();
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    invoiceSrv.generateInvoiceOnPreviousMonth = function (company, previousMonthNumber, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(invoiceSrv.generateInvoiceOnPreviousMonthSync, company, previousMonthNumber, successFunction, errorFunction);
    };
    invoiceSrv.generateInvoiceOnPreviousMonthSync = function (company, previousMonthNumber, successFunction, errorFunction) {

        var invoiceRes = new Invoice_Resource();
        invoiceRes.$generateInvoiceOnPreviousMonth({
            "company-code": company.code,
            previousMonthNumber: previousMonthNumber
        }, //no params
        function (data) {
            var invoice = null;
            if (data) {
                invoice = new Invoice(data, company);
                company.invoices.push(invoice);
            }

            //Save on server success :
            // -> add an user action (send message)
            try {
                if (successFunction !== undefined) successFunction(invoice);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    invoiceSrv.generateEstimateInvoice = function (company, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(invoiceSrv.generateEstimateInvoiceSync, company, successFunction, errorFunction);
    };

    invoiceSrv.generateEstimateInvoiceSync = function (company, successFunction, errorFunction) {
        var invoiceResource = new Invoice_Resource();
        invoiceResource.$generateEstimateInvoice({}, function (data) {
            try {
                company.loadEstimateInvoices(data);
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data.status);
            }
        });
    };

    invoiceSrv.proceedPayment = function (invoice, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(invoiceSrv.proceedPaymentSync, invoice, successFunction, errorFunction);
    };
    invoiceSrv.proceedPaymentSync = function (invoice, successFunction, errorFunction) {

        var invoiceRes = invoice.getObjectResource();
        invoiceRes.$proceedPayment({}, //no params
        function (data) {
            try {
                if (data.status === "paymentFailed" && errorFunction !== undefined) {
                    errorFunction(data);
                } else if (data.status !== "paymentFailed" && successFunction !== undefined) {
                    successFunction(data);
                } else {
                    $window.location.reload(true);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    invoiceSrv.remove = function (invoice, successFunction, errorFunction) {
        InvoiceData.remove(invoice);
        ServerSrv.startSavingProcess(invoiceSrv.removeSync, invoice, successFunction, errorFunction);
    };
    invoiceSrv.removeSync = function (invoice, successFunction, errorFunction) {
        var invoiceRes = new Invoice_Resource();
        invoiceRes.$remove({ id: invoice.id }, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    invoiceSrv.cancel = function (invoice, isRefundInvoice, isNewInvoice, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(invoiceSrv.cancelSync, invoice, isRefundInvoice, isNewInvoice, successFunction, errorFunction);
    };
    invoiceSrv.cancelSync = function (invoice, isRefundInvoice, isNewInvoice, successFunction, errorFunction) {

        var invoiceCancelRes = new Invoice_Resource();
        invoiceCancelRes.invoice = invoice.getObjectResource();
        invoiceCancelRes.refundInvoice = isRefundInvoice;
        invoiceCancelRes.newInvoice = isNewInvoice;

        invoiceCancelRes.$cancel({}, //no params
        function (data) {
            try {
                // generate new invoice
                var creditInvoice = null;
                if (data && data.invoice) {
                    invoice.status = data.invoice.status;
                    invoice.creNum = data.invoice.creNum;
                    invoice.refundId = data.invoice.refundId;
                }
                if (data && data.creditInvoice) creditInvoice = new Invoice(data.creditInvoice);
                var newInvoice = null;
                if (data && data.newInvoice) newInvoice = new Invoice(data.newInvoice);

                if (successFunction !== undefined) successFunction(invoice, creditInvoice, newInvoice);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    return invoiceSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('InvoiceData', ["$log", "$filter", function ($log, $filter) {
    var invoiceDataSrv = {
        indexInvoices: [],
        activeInvoices: [],
        deletedInvoices: [] //deleted items
    };
    invoiceDataSrv.getById = function (invoiceId) {
        for (var i = 0; i < this.indexInvoices.length; i++) {
            if (this.indexInvoices[i].getId() == invoiceId) return this.indexInvoices[i];
        }return null;
    };
    invoiceDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexInvoices.length) return this.indexInvoices[index];
        return null;
    };
    invoiceDataSrv.getIndexOf = function (invoice) {
        if (invoice) return this.indexInvoices.indexOf(invoice);
        return -1;
    };

    invoiceDataSrv.add = function (invoice) {
        var invoiceArray = this.activeInvoices;
        if (invoice.isDeleted) invoiceArray = this.deletedInvoices;
        var index = this.indexInvoices.indexOf(invoice);
        if (index != -1) {
            var realIndex = invoiceArray.indexOf(invoice);
            if (realIndex == -1) invoiceArray.push(invoice);
        } else {
            index = this.indexInvoices.length;
            this.indexInvoices.push(invoice);
            invoiceArray.push(invoice);
        }
        return index;
    };
    invoiceDataSrv.remove = function (invoice) {
        var index = this.activeInvoices.indexOf(invoice);
        if (index != -1) {
            this.activeInvoices.splice(index, 1);
            this.deletedInvoices.push(invoice);
            invoice.isDeleted = true;
        }
    };
    invoiceDataSrv.restore = function (invoice) {
        var index = this.deletedInvoices.indexOf(invoice);
        if (index != -1) {
            this.deletedInvoices.splice(index, 1);
            this.activeInvoices.push(invoice);
            invoice.isDeleted = false;
        }
    };
    invoiceDataSrv.clear = function () {
        this.indexInvoices = [];
        this.activeInvoices = [];
        this.deletedInvoices = [];
    };
    invoiceDataSrv.sort = function () {
        this.activeInvoices = $filter('orderBy')(this.activeInvoices, 'billingDate', false);
        this.deletedInvoices = $filter('orderBy')(this.deletedInvoices, 'billingDate', false);
    };

    invoiceDataSrv.getActiveList = function () {
        return this.activeInvoices;
    };
    invoiceDataSrv.getDeletedList = function () {
        return this.deletedInvoices;
    };
    return invoiceDataSrv;

    return invoiceDataSrv;
}]);

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: cedricGodefroy
 * Date: 28/11/18
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('LaunchDarklyFeatureFlag_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceLaunchDarklyFeature = $resource(baseUrl + 'rest/launchDarklyFeatureFlag/:flagName', {}, {
        query: { method: 'GET', isArray: true },
        loadByName: { method: 'GET', url: baseUrl + 'rest/launchDarklyFeatureFlag/:flagName' }
    });
    return resourceLaunchDarklyFeature;
}]);

angular.module('FlexyBeautyApp.services').factory('LaunchDarklyFeatureFlag', ["LaunchDarklyFeatureFlag_Resource", "LaunchDarklyFeatureFlagData", function (LaunchDarklyFeatureFlag_Resource, LaunchDarklyFeatureFlagData) {
    var LaunchDarklyFeatureFlag = function LaunchDarklyFeatureFlag(resource) {
        this.flagName = null;
        this.isActive = false;

        this.loadObject(resource);
        LaunchDarklyFeatureFlagData.add(this);
    };
    LaunchDarklyFeatureFlag.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            this.flagName = object.flagName;
            this.isActive = object.active;
        }
    };

    return LaunchDarklyFeatureFlag;
}]);

angular.module('FlexyBeautyApp.services').factory('LaunchDarklyFeatureFlagSrv', ["LaunchDarklyFeatureFlag_Resource", "LaunchDarklyFeatureFlag", "LaunchDarklyFeatureFlagData", function (LaunchDarklyFeatureFlag_Resource, LaunchDarklyFeatureFlag, LaunchDarklyFeatureFlagData) {
    var launchDarklyFeatureFlagSrv = {};

    launchDarklyFeatureFlagSrv.query = function (successFunction, errorFunction) {
        LaunchDarklyFeatureFlag_Resource.query({}, //params
        function (data) {
            //success
            LaunchDarklyFeatureFlagData.clear();
            if (data) {
                for (var i = 0; i < data.length; i++) {
                    new LaunchDarklyFeatureFlag(data[i]); //Auto Add to LaunchDarklyFeatureFlagData
                }

                LaunchDarklyFeatureFlagData.initFeatureFlags();
            }

            if (successFunction !== undefined) successFunction();
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    launchDarklyFeatureFlagSrv.loadFeatureFlag = function (flagName, successFunction, errorFunction) {
        LaunchDarklyFeatureFlag_Resource.loadByName({ flagName: flagName }, function (data) {
            if (successFunction !== undefined) successFunction(data);
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };

    return launchDarklyFeatureFlagSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('LaunchDarklyFeatureFlagData', ['LaunchDarklyFeatureFlagList', function (LaunchDarklyFeatureFlagList) {
    var launchDarklyFeatureFlagData = {
        featureFlags: [],
        canAccessNewLoading: false,
        canAccessBackofficeCustomer: false,
        canAccessBookingUserStory: false,
        canAccessDoubleTabBlocked: false
    };

    launchDarklyFeatureFlagData.getByFlagName = function (flagName) {
        for (var i = 0; i < this.featureFlags.length; i++) {
            if (this.featureFlags[i].flagName === flagName) return this.featureFlags[i];
        }return null;
    };

    launchDarklyFeatureFlagData.clear = function () {
        this.featureFlags = [];
    };

    launchDarklyFeatureFlagData.add = function (featureflag) {
        var isFeatureFlagExists = false;
        for (var i = 0; i < this.featureFlags.length; i++) {
            if (this.featureFlags.flagName === featureflag.flagName) {
                isFeatureFlagExists = true;
            }
        }
        if (!isFeatureFlagExists) {
            this.featureFlags.push(featureflag);
        }
    };

    launchDarklyFeatureFlagData.getFeatureFlagList = function () {
        return this.featureFlags;
    };

    launchDarklyFeatureFlagData.initFeatureFlags = function () {
        var newLoadingFeatureFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_3775_FEATURE_FLAG_NEW_LOADING.flagName);
        launchDarklyFeatureFlagData.canAccessNewLoading = newLoadingFeatureFlag ? newLoadingFeatureFlag.isActive : false;

        var canAccessBackofficeCustomerFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_3279_FEATURE_FLAG_BACKOFFICE_CUSTOMER.flagName);
        launchDarklyFeatureFlagData.canAccessBackofficeCustomer = canAccessBackofficeCustomerFlag ? canAccessBackofficeCustomerFlag.isActive : false;

        var canAccessBookingUserStoryFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_4365_FEATURE_FLAG_BOOKING_USER_STORY.flagName);
        launchDarklyFeatureFlagData.canAccessBookingUserStory = canAccessBookingUserStoryFlag ? canAccessBookingUserStoryFlag.isActive : false;

        var canAccessKiuteProAppFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_4424_FEATURE_FLAG_KIUTE_PRO_APP.flagName);
        launchDarklyFeatureFlagData.canAccessKiuteProApp = canAccessKiuteProAppFlag ? canAccessKiuteProAppFlag.isActive : false;

        var canAccessDoubleTabBlocked = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_287_DOUBLE_TAB_BLOCKED.flagName);
        launchDarklyFeatureFlagData.canAccessDoubleTabBlocked = canAccessDoubleTabBlocked ? canAccessDoubleTabBlocked.isActive : false;

        var forceMigrationInfosFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_311_FORCE_MIGRATION_INFOS.flagName);
        launchDarklyFeatureFlagData.forceMigrationInfos = forceMigrationInfosFlag ? forceMigrationInfosFlag.isActive : false;

        var forceMigrationDateFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_364_FORCE_MIGRATION_DATE.flagName);
        launchDarklyFeatureFlagData.forceMigrationDate = forceMigrationDateFlag ? forceMigrationDateFlag.isActive : false;
    };

    return launchDarklyFeatureFlagData;
}]);

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('Marketplace_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/marketplace', {}, {
        getMarketplaceData: { method: 'GET', url: baseUrl + 'rest/marketplace/data' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('MarketplaceSrv', ['Marketplace_Resource', function (Marketplace_Resource) {
    var marketplaceSrv = {};

    marketplaceSrv.getMarketplaceData = function () {
        return Marketplace_Resource.getMarketplaceData().$promise;
    };

    return marketplaceSrv;
}]);

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
(function() {var h,aa=aa||{},l=this;function m(a){return"string"==typeof a}function ba(a){return"boolean"==typeof a}var ca=/^[\w+/_-]+[=]{0,2}$/,ea=null;function fa(){}
function ha(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ia(a){return null===a}function ja(a){return"array"==ha(a)}function ka(a){var b=ha(a);return"array"==b||"object"==b&&"number"==typeof a.length}function q(a){return"function"==ha(a)}function r(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var la="closure_uid_"+(1E9*Math.random()>>>0),ma=0;function na(a,b,c){return a.call.apply(a.bind,arguments)}
function oa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function t(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?t=na:t=oa;return t.apply(null,arguments)}
function pa(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}var qa=Date.now||function(){return+new Date};function u(a,b){function c(){}c.prototype=b.prototype;a.pb=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.bd=function(d,e,f){for(var g=Array(arguments.length-2),k=2;k<arguments.length;k++)g[k-2]=arguments[k];return b.prototype[e].apply(d,g)}};function ra(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function v(a){if(Error.captureStackTrace)Error.captureStackTrace(this,v);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}u(v,Error);v.prototype.name="CustomError";function sa(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");v.call(this,c+a[d])}u(sa,v);sa.prototype.name="AssertionError";function ta(a,b){throw new sa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function ua(a,b){this.c=a;this.f=b;this.b=0;this.a=null}ua.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function va(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function wa(){this.b=this.a=null}var ya=new ua(function(){return new xa},function(a){a.reset()});wa.prototype.add=function(a,b){var c=ya.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function za(){var a=Aa,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function xa(){this.next=this.b=this.a=null}xa.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};xa.prototype.reset=function(){this.next=this.b=this.a=null};var Ba=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(m(a))return m(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};function Ca(a,b){for(var c=m(a)?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}
var Da=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=m(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Ea=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};
function Fa(a){a:{var b=Ga;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:m(a)?a.charAt(b):a[b]}function Ha(a,b){return 0<=Ba(a,b)}function Ia(a,b){b=Ba(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function x(a,b){var c=0;Ca(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ja(a){return Array.prototype.concat.apply([],arguments)}
function Ka(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var La=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]},Ma=/&/g,Na=/</g,Oa=/>/g,Pa=/"/g,Qa=/'/g,Ra=/\x00/g,Sa=/[\x00&<>"']/;function z(a,b){return-1!=a.indexOf(b)}function Ta(a,b){return a<b?-1:a>b?1:0};var Ua;a:{var Va=l.navigator;if(Va){var Wa=Va.userAgent;if(Wa){Ua=Wa;break a}}Ua=""}function B(a){return z(Ua,a)};function Xa(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Ya(a){for(var b in a)return!1;return!0}function Za(a){var b={},c;for(c in a)b[c]=a[c];return b}var $a="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function ab(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<$a.length;f++)c=$a[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function bb(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}function cb(a){Sa.test(a)&&(-1!=a.indexOf("&")&&(a=a.replace(Ma,"&amp;")),-1!=a.indexOf("<")&&(a=a.replace(Na,"&lt;")),-1!=a.indexOf(">")&&(a=a.replace(Oa,"&gt;")),-1!=a.indexOf('"')&&(a=a.replace(Pa,"&quot;")),-1!=a.indexOf("'")&&(a=a.replace(Qa,"&#39;")),-1!=a.indexOf("\x00")&&(a=a.replace(Ra,"&#0;")));return a};function db(a){l.setTimeout(function(){throw a;},0)}var eb;
function fb(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!B("Presto")&&(a=function(){var e=document.createElement("IFRAME");e.style.display="none";e.src="";document.documentElement.appendChild(e);var f=e.contentWindow;e=f.document;e.open();e.write("");e.close();var g="callImmediate"+Math.random(),k="file:"==f.location.protocol?"*":f.location.protocol+"//"+f.location.host;e=t(function(n){if(("*"==k||n.origin==k)&&n.data==
g)this.port1.onmessage()},this);f.addEventListener("message",e,!1);this.port1={};this.port2={postMessage:function(){f.postMessage(g,k)}}});if("undefined"!==typeof a&&!B("Trident")&&!B("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var e=c.xb;c.xb=null;e()}};return function(e){d.next={xb:e};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(e){var f=document.createElement("SCRIPT");
f.onreadystatechange=function(){f.onreadystatechange=null;f.parentNode.removeChild(f);f=null;e();e=null};document.documentElement.appendChild(f)}:function(e){l.setTimeout(e,0)}};function gb(a,b){hb||ib();jb||(hb(),jb=!0);Aa.add(a,b)}var hb;function ib(){if(l.Promise&&l.Promise.resolve){var a=l.Promise.resolve(void 0);hb=function(){a.then(kb)}}else hb=function(){var b=kb;!q(l.setImmediate)||l.Window&&l.Window.prototype&&!B("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(eb||(eb=fb()),eb(b)):l.setImmediate(b)}}var jb=!1,Aa=new wa;function kb(){for(var a;a=za();){try{a.a.call(a.b)}catch(b){db(b)}va(ya,a)}jb=!1};function C(a,b){this.a=lb;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=fa)try{var c=this;a.call(b,function(d){mb(c,nb,d)},function(d){if(!(d instanceof ob))try{if(d instanceof Error)throw d;throw Error("Promise rejected.");}catch(e){}mb(c,pb,d)})}catch(d){mb(this,pb,d)}}var lb=0,nb=2,pb=3;function qb(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}qb.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var rb=new ua(function(){return new qb},function(a){a.reset()});
function sb(a,b,c){var d=rb.get();d.g=a;d.b=b;d.f=c;return d}function D(a){if(a instanceof C)return a;var b=new C(fa);mb(b,nb,a);return b}function E(a){return new C(function(b,c){c(a)})}function tb(a,b,c){ub(a,b,c,null)||gb(pa(b,a))}function vb(a){return new C(function(b,c){var d=a.length,e=[];if(d)for(var f=function(p,y){d--;e[p]=y;0==d&&b(e)},g=function(p){c(p)},k=0,n;k<a.length;k++)n=a[k],tb(n,pa(f,k),g);else b(e)})}
function wb(a){return new C(function(b){var c=a.length,d=[];if(c)for(var e=function(k,n,p){c--;d[k]=n?{Db:!0,value:p}:{Db:!1,reason:p};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],tb(g,pa(e,f,!0),pa(e,f,!1));else b(d)})}C.prototype.then=function(a,b,c){return xb(this,q(a)?a:null,q(b)?b:null,c)};C.prototype.$goog_Thenable=!0;h=C.prototype;h.ia=function(a,b){a=sb(a,a,b);a.c=!0;yb(this,a);return this};h.s=function(a,b){return xb(this,null,a,b)};
h.cancel=function(a){this.a==lb&&gb(function(){var b=new ob(a);zb(this,b)},this)};function zb(a,b){if(a.a==lb)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==lb&&1==d?zb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Ab(c),Bb(c,e,pb,b)))}a.c=null}else mb(a,pb,b)}function yb(a,b){a.b||a.a!=nb&&a.a!=pb||Cb(a);a.f?a.f.next=b:a.b=b;a.f=b}
function xb(a,b,c,d){var e=sb(null,null,null);e.a=new C(function(f,g){e.g=b?function(k){try{var n=b.call(d,k);f(n)}catch(p){g(p)}}:f;e.b=c?function(k){try{var n=c.call(d,k);void 0===n&&k instanceof ob?g(k):f(n)}catch(p){g(p)}}:g});e.a.c=a;yb(a,e);return e.a}h.Kc=function(a){this.a=lb;mb(this,nb,a)};h.Lc=function(a){this.a=lb;mb(this,pb,a)};
function mb(a,b,c){a.a==lb&&(a===c&&(b=pb,c=new TypeError("Promise cannot resolve to itself")),a.a=1,ub(c,a.Kc,a.Lc,a)||(a.i=c,a.a=b,a.c=null,Cb(a),b!=pb||c instanceof ob||Db(a,c)))}function ub(a,b,c,d){if(a instanceof C)return yb(a,sb(b||fa,c||null,d)),!0;if(ra(a))return a.then(b,c,d),!0;if(r(a))try{var e=a.then;if(q(e))return Eb(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
function Eb(a,b,c,d,e){function f(n){k||(k=!0,d.call(e,n))}function g(n){k||(k=!0,c.call(e,n))}var k=!1;try{b.call(a,g,f)}catch(n){f(n)}}function Cb(a){a.h||(a.h=!0,gb(a.Wb,a))}function Ab(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}h.Wb=function(){for(var a;a=Ab(this);)Bb(this,a,this.a,this.i);this.h=!1};
function Bb(a,b,c,d){if(c==pb&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Fb(b,c,d);else try{b.c?b.g.call(b.f):Fb(b,c,d)}catch(e){Gb.call(null,e)}va(rb,b)}function Fb(a,b,c){b==nb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Db(a,b){a.g=!0;gb(function(){a.g&&Gb.call(null,b)})}var Gb=db;function ob(a){v.call(this,a)}u(ob,v);ob.prototype.name="cancel";function Hb(){0!=Ib&&(Jb[this[la]||(this[la]=++ma)]=this);this.qa=this.qa;this.ja=this.ja}var Ib=0,Jb={};Hb.prototype.qa=!1;function Kb(a){if(!a.qa&&(a.qa=!0,a.va(),0!=Ib)){var b=a[la]||(a[la]=++ma);if(0!=Ib&&a.ja&&0<a.ja.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Jb[b]}}Hb.prototype.va=function(){if(this.ja)for(;this.ja.length;)this.ja.shift()()};function Lb(a){Lb[" "](a);return a}Lb[" "]=fa;function Mb(a,b){var c=Nb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Ob=B("Opera"),Pb=B("Trident")||B("MSIE"),Qb=B("Edge"),Rb=Qb||Pb,Sb=B("Gecko")&&!(z(Ua.toLowerCase(),"webkit")&&!B("Edge"))&&!(B("Trident")||B("MSIE"))&&!B("Edge"),Tb=z(Ua.toLowerCase(),"webkit")&&!B("Edge");function Ub(){var a=l.document;return a?a.documentMode:void 0}var Vb;
a:{var Wb="",Xb=function(){var a=Ua;if(Sb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Qb)return/Edge\/([\d\.]+)/.exec(a);if(Pb)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Tb)return/WebKit\/(\S+)/.exec(a);if(Ob)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Xb&&(Wb=Xb?Xb[1]:"");if(Pb){var Yb=Ub();if(null!=Yb&&Yb>parseFloat(Wb)){Vb=String(Yb);break a}}Vb=Wb}var Nb={};
function Zb(a){return Mb(a,function(){for(var b=0,c=La(String(Vb)).split("."),d=La(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",k=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==g[0].length&&0==k[0].length)break;b=Ta(0==g[1].length?0:parseInt(g[1],10),0==k[1].length?0:parseInt(k[1],10))||Ta(0==g[2].length,0==k[2].length)||Ta(g[2],k[2]);g=g[3];k=k[3]}while(0==b)}return 0<=b})}var $b;var ac=l.document;
$b=ac&&Pb?Ub()||("CSS1Compat"==ac.compatMode?parseInt(Vb,10):5):void 0;var bc=Object.freeze||function(a){return a};var cc=!Pb||9<=Number($b),fc=Pb&&!Zb("9"),gc=function(){if(!l.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{l.addEventListener("test",fa,b),l.removeEventListener("test",fa,b)}catch(c){}return a}();function F(a,b){this.type=a;this.b=this.target=b;this.Jb=!0}F.prototype.preventDefault=function(){this.Jb=!1};function hc(a,b){F.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Sb){a:{try{Lb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==
c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=m(a.pointerType)?a.pointerType:ic[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}u(hc,F);var ic=bc({2:"touch",3:"pen",4:"mouse"});hc.prototype.preventDefault=function(){hc.pb.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,fc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};hc.prototype.f=function(){return this.a};var jc="closure_listenable_"+(1E6*Math.random()|0),kc=0;function lc(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.Ma=e;this.key=++kc;this.oa=this.Ia=!1}function mc(a){a.oa=!0;a.listener=null;a.proxy=null;a.src=null;a.Ma=null};function nc(a){this.src=a;this.a={};this.b=0}nc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var g=oc(a,b,d,e);-1<g?(b=a[g],c||(b.Ia=!1)):(b=new lc(b,this.src,f,!!d,e),b.Ia=c,a.push(b));return b};function pc(a,b){var c=b.type;c in a.a&&Ia(a.a[c],b)&&(mc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function oc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.oa&&f.listener==b&&f.capture==!!c&&f.Ma==d)return e}return-1};var qc="closure_lm_"+(1E6*Math.random()|0),rc={},sc=0;function tc(a,b,c,d,e){if(d&&d.once)uc(a,b,c,d,e);else if(ja(b))for(var f=0;f<b.length;f++)tc(a,b[f],c,d,e);else c=vc(c),a&&a[jc]?wc(a,b,c,r(d)?!!d.capture:!!d,e):xc(a,b,c,!1,d,e)}
function xc(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=r(e)?!!e.capture:!!e,k=yc(a);k||(a[qc]=k=new nc(a));c=k.add(b,c,d,g,f);if(!c.proxy){d=zc();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)gc||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(Ac(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");sc++}}
function zc(){var a=Bc,b=cc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function uc(a,b,c,d,e){if(ja(b))for(var f=0;f<b.length;f++)uc(a,b[f],c,d,e);else c=vc(c),a&&a[jc]?Cc(a,b,c,r(d)?!!d.capture:!!d,e):xc(a,b,c,!0,d,e)}
function G(a,b,c,d,e){if(ja(b))for(var f=0;f<b.length;f++)G(a,b[f],c,d,e);else(d=r(d)?!!d.capture:!!d,c=vc(c),a&&a[jc])?(a=a.o,b=String(b).toString(),b in a.a&&(f=a.a[b],c=oc(f,c,d,e),-1<c&&(mc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=yc(a))&&(b=a.a[b.toString()],a=-1,b&&(a=oc(b,c,d,e)),(c=-1<a?b[a]:null)&&Dc(c))}
function Dc(a){if("number"!=typeof a&&a&&!a.oa){var b=a.src;if(b&&b[jc])pc(b.o,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(Ac(c),d):b.addListener&&b.removeListener&&b.removeListener(d);sc--;(c=yc(b))?(pc(c,a),0==c.b&&(c.src=null,b[qc]=null)):mc(a)}}}function Ac(a){return a in rc?rc[a]:rc[a]="on"+a}
function Ec(a,b,c,d){var e=!0;if(a=yc(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.oa&&(f=Fc(f,d),e=e&&!1!==f)}return e}function Fc(a,b){var c=a.listener,d=a.Ma||a.src;a.Ia&&Dc(a);return c.call(d,b)}
function Bc(a,b){if(a.oa)return!0;if(!cc){if(!b)a:{b=["window","event"];for(var c=l,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new hc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=Ec(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=Ec(d[e],a,!1,b),c=c&&f}return c}return Fc(a,
new hc(b,this))}function yc(a){a=a[qc];return a instanceof nc?a:null}var Gc="__closure_events_fn_"+(1E9*Math.random()>>>0);function vc(a){if(q(a))return a;a[Gc]||(a[Gc]=function(b){return a.handleEvent(b)});return a[Gc]};function H(){Hb.call(this);this.o=new nc(this);this.Pb=this;this.Ua=null}u(H,Hb);H.prototype[jc]=!0;H.prototype.addEventListener=function(a,b,c,d){tc(this,a,b,c,d)};H.prototype.removeEventListener=function(a,b,c,d){G(this,a,b,c,d)};
H.prototype.dispatchEvent=function(a){var b,c=this.Ua;if(c)for(b=[];c;c=c.Ua)b.push(c);c=this.Pb;var d=a.type||a;if(m(a))a=new F(a,c);else if(a instanceof F)a.target=a.target||c;else{var e=a;a=new F(d,c);ab(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var g=a.b=b[f];e=Hc(g,d,!0,a)&&e}g=a.b=c;e=Hc(g,d,!0,a)&&e;e=Hc(g,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)g=a.b=b[f],e=Hc(g,d,!1,a)&&e;return e};
H.prototype.va=function(){H.pb.va.call(this);if(this.o){var a=this.o,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,mc(d[e]);delete a.a[c];a.b--}}this.Ua=null};function wc(a,b,c,d,e){a.o.add(String(b),c,!1,d,e)}function Cc(a,b,c,d,e){a.o.add(String(b),c,!0,d,e)}
function Hc(a,b,c,d){b=a.o.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.oa&&g.capture==c){var k=g.listener,n=g.Ma||g.src;g.Ia&&pc(a.o,g);e=!1!==k.call(n,d)&&e}}return e&&0!=d.Jb};function Ic(a,b,c){if(q(a))c&&(a=t(a,c));else if(a&&"function"==typeof a.handleEvent)a=t(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)}function Jc(a){var b=null;return(new C(function(c,d){b=Ic(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(c){l.clearTimeout(b);throw c;})};function Kc(a){if(a.S&&"function"==typeof a.S)return a.S();if(m(a))return a.split("");if(ka(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Lc(a){if(a.U&&"function"==typeof a.U)return a.U();if(!a.S||"function"!=typeof a.S){if(ka(a)||m(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
function Mc(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ka(a)||m(a))w(a,b,void 0);else for(var c=Lc(a),d=Kc(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Nc(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Nc)for(c=a.U(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}h=Nc.prototype;h.S=function(){Oc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};h.U=function(){Oc(this);return this.a.concat()};
h.clear=function(){this.b={};this.c=this.a.length=0};function Oc(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Pc(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Pc(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}h.get=function(a,b){return Pc(this.b,a)?this.b[a]:b};h.set=function(a,b){Pc(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
h.forEach=function(a,b){for(var c=this.U(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Pc(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Qc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Rc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Sc(a,b){this.b=this.o=this.c="";this.i=null;this.h=this.g="";this.f=!1;if(a instanceof Sc){this.f=void 0!==b?b:a.f;Tc(this,a.c);this.o=a.o;this.b=a.b;Uc(this,a.i);this.g=a.g;b=a.a;var c=new Vc;c.c=b.c;b.a&&(c.a=new Nc(b.a),c.b=b.b);Wc(this,c);this.h=a.h}else a&&(c=String(a).match(Qc))?(this.f=!!b,Tc(this,c[1]||"",!0),this.o=Xc(c[2]||""),this.b=Xc(c[3]||"",!0),Uc(this,c[4]),this.g=Xc(c[5]||"",!0),Wc(this,c[6]||"",!0),this.h=Xc(c[7]||"")):(this.f=!!b,this.a=new Vc(null,this.f))}
Sc.prototype.toString=function(){var a=[],b=this.c;b&&a.push(Yc(b,Zc,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.o)&&a.push(Yc(b,Zc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.g)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Yc(c,"/"==c.charAt(0)?$c:ad,!0));(c=this.a.toString())&&a.push("?",c);(c=this.h)&&a.push("#",Yc(c,bd));return a.join("")};
function Tc(a,b,c){a.c=c?Xc(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function Uc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function Wc(a,b,c){b instanceof Vc?(a.a=b,cd(a.a,a.f)):(c||(b=Yc(b,dd)),a.a=new Vc(b,a.f))}function I(a,b,c){a.a.set(b,c)}function ed(a,b){return a.a.get(b)}function fd(a){return a instanceof Sc?new Sc(a):new Sc(a,void 0)}function gd(a,b){var c=new Sc(null,void 0);Tc(c,"https");a&&(c.b=a);b&&(c.g=b);return c}
function Xc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Yc(a,b,c){return m(a)?(a=encodeURI(a).replace(b,hd),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function hd(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Zc=/[#\/\?@]/g,ad=/[#\?:]/g,$c=/[#\?]/g,dd=/[#\?@]/g,bd=/#/g;function Vc(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}
function id(a){a.a||(a.a=new Nc,a.b=0,a.c&&Rc(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function jd(a){var b=Lc(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Vc(null,void 0);a=Kc(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];ja(f)?kd(c,e,f):c.add(e,f)}return c}h=Vc.prototype;h.add=function(a,b){id(this);this.c=null;a=ld(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};
function md(a,b){id(a);b=ld(a,b);Pc(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Pc(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Oc(a)))}h.clear=function(){this.a=this.c=null;this.b=0};function nd(a,b){id(a);b=ld(a,b);return Pc(a.a.b,b)}h.forEach=function(a,b){id(this);this.a.forEach(function(c,d){w(c,function(e){a.call(b,e,d,this)},this)},this)};h.U=function(){id(this);for(var a=this.a.S(),b=this.a.U(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
h.S=function(a){id(this);var b=[];if(m(a))nd(this,a)&&(b=Ja(b,this.a.get(ld(this,a))));else{a=this.a.S();for(var c=0;c<a.length;c++)b=Ja(b,a[c])}return b};h.set=function(a,b){id(this);this.c=null;a=ld(this,a);nd(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};h.get=function(a,b){if(!a)return b;a=this.S(a);return 0<a.length?String(a[0]):b};function kd(a,b,c){md(a,b);0<c.length&&(a.c=null,a.a.set(ld(a,b),Ka(c)),a.b+=c.length)}
h.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.U(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.S(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};function ld(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function cd(a,b){b&&!a.f&&(id(a),a.c=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(md(this,d),kd(this,e,c))},a));a.f=b};var od=!Pb||9<=Number($b);function pd(a,b){this.a=a===qd&&b||"";this.b=rd}pd.prototype.na=!0;pd.prototype.ma=function(){return this.a};pd.prototype.toString=function(){return"Const{"+this.a+"}"};function sd(a){if(a instanceof pd&&a.constructor===pd&&a.b===rd)return a.a;ta("expected object of type Const, got '"+a+"'");return"type_error:Const"}var rd={},qd={};function td(){this.a="";this.b=ud}td.prototype.na=!0;td.prototype.ma=function(){return this.a.toString()};td.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function vd(a){if(a instanceof td&&a.constructor===td&&a.b===ud)return a.a;ta("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ha(a));return"type_error:TrustedResourceUrl"}
function wd(a,b){var c=sd(a);if(!xd.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(yd,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof pd?sd(d):encodeURIComponent(String(d))});return zd(a)}var yd=/%{(\w+)}/g,xd=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i,ud={};
function zd(a){var b=new td;b.a=a;return b};function Ad(){this.a="";this.b=Bd}Ad.prototype.na=!0;Ad.prototype.ma=function(){return this.a.toString()};Ad.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Cd(a){if(a instanceof Ad&&a.constructor===Ad&&a.b===Bd)return a.a;ta("expected object of type SafeUrl, got '"+a+"' of type "+ha(a));return"type_error:SafeUrl"}var Dd=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
function Ed(a){if(a instanceof Ad)return a;a="object"==typeof a&&a.na?a.ma():String(a);Dd.test(a)||(a="about:invalid#zClosurez");return Fd(a)}var Bd={};function Fd(a){var b=new Ad;b.a=a;return b}Fd("about:blank");function Gd(){this.a="";this.b=Hd}Gd.prototype.na=!0;Gd.prototype.ma=function(){return this.a.toString()};Gd.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Id(a){if(a instanceof Gd&&a.constructor===Gd&&a.b===Hd)return a.a;ta("expected object of type SafeHtml, got '"+a+"' of type "+ha(a));return"type_error:SafeHtml"}var Hd={};function Jd(a){var b=new Gd;b.a=a;return b}Jd("<!DOCTYPE html>");Jd("");Jd("<br>");function Kd(a,b){a.src=vd(b);if(null===ea)b:{b=l.document;if((b=b.querySelector&&b.querySelector("script[nonce]"))&&(b=b.nonce||b.getAttribute("nonce"))&&ca.test(b)){ea=b;break b}ea=""}b=ea;b&&a.setAttribute("nonce",b)};function Ld(a){var b=document;return m(a)?b.getElementById(a):a}function Md(a,b){Xa(b,function(c,d){c&&"object"==typeof c&&c.na&&(c=c.ma());"style"==d?a.style.cssText=c:"class"==d?a.className=c:"for"==d?a.htmlFor=c:Nd.hasOwnProperty(d)?a.setAttribute(Nd[d],c):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,c):a[d]=c})}
var Nd={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
function Od(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!od&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',cb(g.name),'"');if(g.type){f.push(' type="',cb(g.type),'"');var k={};ab(k,g);delete k.type;g=k}f.push(">");f=f.join("")}f=e.createElement(f);g&&(m(g)?f.className=g:ja(g)?f.className=g.join(" "):Md(f,g));2<d.length&&Pd(e,f,d);return f}
function Pd(a,b,c){function d(g){g&&b.appendChild(m(g)?a.createTextNode(g):g)}for(var e=2;e<c.length;e++){var f=c[e];!ka(f)||r(f)&&0<f.nodeType?d(f):w(Qd(f)?Ka(f):f,d)}}function Qd(a){if(a&&"number"==typeof a.length){if(r(a))return"function"==typeof a.item||"string"==typeof a.item;if(q(a))return"function"==typeof a.item}return!1};function Rd(a){var b=[];Sd(new Td,a,b);return b.join("")}function Td(){}
function Sd(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(ja(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Sd(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Ud(d,c),c.push(":"),Sd(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Ud(b,c);break;case "number":c.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Vd={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Wd=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
function Ud(a,b){b.push('"',a.replace(Wd,function(c){var d=Vd[c];d||(d="\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),Vd[c]=d);return d}),'"')};/*

 Copyright 2017 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function Xd(){var a=J();return Pb&&!!$b&&11==$b||/Edge\/\d+/.test(a)}function Yd(){return l.window&&l.window.location.href||self&&self.location&&self.location.href||""}function Zd(a,b){b=b||l.window;var c="about:blank";a&&(c=Cd(Ed(a)).toString());b.location.href=c}function $d(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<$d(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
function ae(){var a=J();a=be(a)!=ce?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!Pb||!$b||9<$b}function de(a){a=(a||J()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function ee(a){a=a||l.window;try{a.close()}catch(b){}}
function fe(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=J().toLowerCase();d&&(b.target=d,z(c,"crios/")&&(b.target="_blank"));be(J())==ge&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof Ad?c:Ed("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
for(g in a)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+a[g]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(g+"="+(a[g]?1:0))}var g=e.join(",");(B("iPhone")&&!B("iPod")&&!B("iPad")||B("iPad")||B("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c?(g=d.document.createElement("A"),b instanceof Ad||b instanceof Ad||(b="object"==typeof b&&b.na?b.ma():String(b),Dd.test(b)||(b="about:invalid#zClosurez"),b=Fd(b)),g.href=Cd(b),g.setAttribute("target",
c),a.noreferrer&&g.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),g.dispatchEvent(a),g={}):a.noreferrer?(g=d.open("",c,g),a=Cd(b).toString(),g&&(Rb&&z(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,a=Jd('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+cb(a)+'">'),g.document.write(Id(a)),g.document.close())):(g=d.open(Cd(b).toString(),c,g))&&a.noopener&&(g.opener=null);if(g)try{g.focus()}catch(k){}return g}
function he(a){return new C(function(b){function c(){Jc(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var ie=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,je=/^[^@]+@[^@]+$/;function ke(){var a=null;return(new C(function(b){"complete"==l.document.readyState?b():(a=function(){b()},uc(window,"load",a))})).s(function(b){G(window,"load",a);throw b;})}
function le(){return me(void 0)?ke().then(function(){return new C(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):E(Error("Cordova must run in an Android or iOS file scheme."))}function me(a){a=a||J();return!("file:"!==ne()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function oe(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}}
function pe(){return"undefined"!==typeof l.WorkerGlobalScope&&"function"===typeof l.importScripts}function qe(){return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("node")?"Node":pe()?"Worker":"Browser"}function re(){var a=qe();return"ReactNative"===a||"Node"===a}function se(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}
var ge="Firefox",ce="Chrome";
function be(a){var b=a.toLowerCase();if(z(b,"opera/")||z(b,"opr/")||z(b,"opios/"))return"Opera";if(z(b,"iemobile"))return"IEMobile";if(z(b,"msie")||z(b,"trident/"))return"IE";if(z(b,"edge/"))return"Edge";if(z(b,"firefox/"))return ge;if(z(b,"silk/"))return"Silk";if(z(b,"blackberry"))return"Blackberry";if(z(b,"webos"))return"Webos";if(!z(b,"safari/")||z(b,"chrome/")||z(b,"crios/")||z(b,"android"))if(!z(b,"chrome/")&&!z(b,"crios/")||z(b,"edge/")){if(z(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
2==a.length)return a[1]}else return ce;else return"Safari";return"Other"}var te={Rc:"FirebaseCore-web",Tc:"FirebaseUI-web"};function ue(a,b){b=b||[];var c=[],d={},e;for(e in te)d[te[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=qe();"Browser"===c?(d=J(),c=be(d)):"Worker"===c&&(d=J(),c=be(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function J(){return l.navigator&&l.navigator.userAgent||""}
function K(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function ve(){try{var a=l.localStorage,b=we();if(a)return a.setItem(b,"1"),a.removeItem(b),Xd()?!!l.indexedDB:!0}catch(c){return pe()&&!!l.indexedDB}return!1}function xe(){return(ye()||"chrome-extension:"===ne()||me())&&!re()&&ve()&&!pe()}function ye(){return"http:"===ne()||"https:"===ne()}function ne(){return l.location&&l.location.protocol||null}
function ze(a){a=a||J();return de(a)||be(a)==ge?!1:!0}function Ae(a){return"undefined"===typeof a?null:Rd(a)}function Be(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function Ce(a){if(null!==a)return JSON.parse(a)}function we(a){return a?a:Math.floor(1E9*Math.random()).toString()}function De(a){a=a||J();return"Safari"==be(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
function Ee(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Fe(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=J();b=qe();this.b=de(a)||"ReactNative"===b}
Fe.prototype.get=function(){var a=l.navigator;return(a&&"boolean"===typeof a.onLine&&(ye()||"chrome-extension:"===ne()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function Ge(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
function He(){var a=l.document,b=null;return Ge()||!a?D():(new C(function(c){b=function(){Ge()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Ie(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function Je(){return!(!K("fireauth.oauthhelper",l)&&!K("fireauth.iframe",l))}
function Ke(){var a=l.navigator;return a&&a.serviceWorker&&a.serviceWorker.controller||null}function Le(){var a=l.navigator;return a&&a.serviceWorker?D().then(function(){return a.serviceWorker.ready}).then(function(b){return b.active||null}).s(function(){return null}):D(null)};var Me={};function Ne(a){Me[a]||(Me[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Oe;try{var Pe={};Object.defineProperty(Pe,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Pe,"abcd",{configurable:!0,enumerable:!0,value:2});Oe=2==Pe.abcd}catch(a){Oe=!1}function L(a,b,c){Oe?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function M(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&L(a,c,b[c])}function Qe(a){var b={};M(b,a);return b}function Re(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
function Se(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function Te(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)L(b,c,Te(a[c]))}return b};function Ue(a){var b={},c=a[Ve],d=a[We];a=a[Xe];if(!a||a!=Ye&&!c)throw Error("Invalid provider user info!");b[Ze]=d||null;b[$e]=c||null;L(this,af,a);L(this,bf,Te(b))}var Ye="EMAIL_SIGNIN",Ve="email",We="newEmail",Xe="requestType",$e="email",Ze="fromEmail",bf="data",af="operation";function N(a,b){this.code=cf+a;this.message=b||df[a]||""}u(N,Error);N.prototype.w=function(){return{code:this.code,message:this.message}};N.prototype.toJSON=function(){return this.w()};function ef(a){var b=a&&a.code;return b?new N(b.substring(cf.length),a.message):null}
var cf="auth/",df={"admin-restricted-operation":"This operation is restricted to administrators only.","argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
"captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.","code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.",
"requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.",
"internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.",
"invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
"invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-dynamic-link-domain":"The provided dynamic link domain is not configured or authorized for the current project.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.",
"invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
"invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
"invalid-provider-id":"The specified provider ID is invalid.","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.",
"auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.",
"missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-or-invalid-nonce":"The OIDC ID token requires a valid unhashed nonce.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
"operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.",
"quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.","rejected-credential":"The request contains malformed or mismatching credentials.",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.",
"unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.",
"user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function ff(a){var b=a[gf];if("undefined"===typeof b)throw new N("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new N("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[hf];if(c&&"object"===typeof c){b=c[jf];var d=c[kf];c=c[lf];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new N("argument-error",kf+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
typeof c||"string"===typeof c&&!c.length))throw new N("argument-error",lf+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new N("argument-error",jf+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new N("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new N("argument-error",hf+" property must be a non null object when specified.");this.f=null;if((b=a[mf])&&"object"===
typeof b)if(b=b[nf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new N("argument-error",nf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new N("argument-error",mf+" property must be a non null object when specified.");b=a[of];if("undefined"!==typeof b&&"boolean"!==typeof b)throw new N("argument-error",of+" property must be a boolean when specified.");this.c=!!b;a=a[pf];if("undefined"!==typeof a&&("string"!==typeof a||"string"===
typeof a&&!a.length))throw new N("argument-error",pf+" property must be a non empty string when specified.");this.i=a||null}var hf="android",pf="dynamicLinkDomain",of="handleCodeInApp",mf="iOS",gf="url",kf="installApp",lf="minimumVersion",jf="packageName",nf="bundleId";
function qf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;b.dynamicLinkDomain=a.i;for(var c in b)null===b[c]&&delete b[c];return b};function rf(a){return Da(a,function(b){b=b.toString(16);return 1<b.length?b:"0"+b}).join("")};var sf=null,tf=null;function uf(a){var b="";vf(a,function(c){b+=String.fromCharCode(c)});return b}function vf(a,b){function c(n){for(;d<a.length;){var p=a.charAt(d++),y=tf[p];if(null!=y)return y;if(!/^[\s\xa0]*$/.test(p))throw Error("Unknown base64 encoding at char: "+p);}return n}wf();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),k=c(64);if(64===k&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=k&&b(g<<6&192|k))}}
function wf(){if(!sf){sf={};tf={};for(var a=0;65>a;a++)sf[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),tf[sf[a]]=a,62<=a&&(tf["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};function xf(a){this.c=a.sub;qa();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null;this.b=!!a.is_anonymous||"anonymous"==this.a}xf.prototype.f=function(){return this.b};function yf(a){return(a=zf(a))&&a.sub&&a.iss&&a.aud&&a.exp?new xf(a):null}function zf(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(uf(a))}catch(d){}return null};var Af={Xc:{$a:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",hb:"https://securetoken.googleapis.com/v1/token",id:"p"},Zc:{$a:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",hb:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},$c:{$a:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",hb:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
function Bf(a){for(var b in Af)if(Af[b].id===a)return a=Af[b],{firebaseEndpoint:a.$a,secureTokenEndpoint:a.hb};return null}var Cf;Cf=Bf("__EID__")?"__EID__":void 0;var Df="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Ef=["client_id","response_type","scope","redirect_uri","state"],Ff={Sc:{Na:"locale",Ba:500,Aa:600,Oa:"facebook.com",gb:Ef},Uc:{Na:null,Ba:500,Aa:620,Oa:"github.com",gb:Ef},Vc:{Na:"hl",Ba:515,Aa:680,Oa:"google.com",gb:Ef},ad:{Na:"lang",Ba:485,Aa:705,Oa:"twitter.com",gb:Df}};function Gf(a){for(var b in Ff)if(Ff[b].Oa==a)return Ff[b];return null};function Hf(a){var b={};b["facebook.com"]=If;b["google.com"]=Jf;b["github.com"]=Kf;b["twitter.com"]=Lf;var c=a&&a[Mf];try{if(c)return b[c]?new b[c](a):new Nf(a);if("undefined"!==typeof a[Of])return new Pf(a)}catch(d){}return null}var Of="idToken",Mf="providerId";
function Pf(a){var b=a[Mf];if(!b&&a[Of]){var c=yf(a[Of]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);L(this,"providerId",b);L(this,"isNewUser",c)}function Nf(a){Pf.call(this,a);a=Ce(a.rawUserInfo||"{}");L(this,"profile",Te(a||{}))}u(Nf,Pf);
function If(a){Nf.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}u(If,Nf);function Kf(a){Nf.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");L(this,"username",this.profile&&this.profile.login||null)}u(Kf,Nf);function Jf(a){Nf.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}u(Jf,Nf);
function Lf(a){Nf.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");L(this,"username",a.screenName||null)}u(Lf,Nf);function Qf(a){this.a=fd(a)};function Rf(a){var b=fd(a),c=ed(b,"link"),d=ed(fd(c),"link");b=ed(b,"deep_link_id");return ed(fd(b),"link")||b||d||c||a};function Sf(){}function Tf(a,b){return a.then(function(c){if(c[Uf]){var d=yf(c[Uf]);if(!d||b!=d.c)throw new N("user-mismatch");return c}throw new N("user-mismatch");}).s(function(c){throw c&&c.code&&c.code==cf+"user-not-found"?new N("user-mismatch"):c;})}function Vf(a,b){if(b)this.a=b;else throw new N("internal-error","failed to construct a credential");L(this,"providerId",a);L(this,"signInMethod",a)}Vf.prototype.la=function(a){return Wf(a,Xf(this))};
Vf.prototype.b=function(a,b){var c=Xf(this);c.idToken=b;return Yf(a,c)};Vf.prototype.f=function(a,b){return Tf(Zf(a,Xf(this)),b)};function Xf(a){return{pendingToken:a.a,requestUri:"http://localhost"}}Vf.prototype.w=function(){return{providerId:this.providerId,signInMethod:this.signInMethod,pendingToken:this.a}};function $f(a){if(a&&a.providerId&&a.signInMethod&&0==a.providerId.indexOf("saml.")&&a.pendingToken)try{return new Vf(a.providerId,a.pendingToken)}catch(b){}return null}
function ag(a,b,c){this.a=null;if(b.idToken||b.accessToken)b.idToken&&L(this,"idToken",b.idToken),b.accessToken&&L(this,"accessToken",b.accessToken),b.nonce&&!b.pendingToken&&L(this,"nonce",b.nonce),b.pendingToken&&(this.a=b.pendingToken);else if(b.oauthToken&&b.oauthTokenSecret)L(this,"accessToken",b.oauthToken),L(this,"secret",b.oauthTokenSecret);else throw new N("internal-error","failed to construct a credential");L(this,"providerId",a);L(this,"signInMethod",c)}
ag.prototype.la=function(a){return Wf(a,bg(this))};ag.prototype.b=function(a,b){var c=bg(this);c.idToken=b;return Yf(a,c)};ag.prototype.f=function(a,b){var c=bg(this);return Tf(Zf(a,c),b)};
function bg(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;a.nonce&&!a.a&&(b.nonce=a.nonce);b={postBody:jd(b).toString(),requestUri:"http://localhost"};a.a&&(delete b.postBody,b.pendingToken=a.a);return b}
ag.prototype.w=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);this.nonce&&(a.nonce=this.nonce);this.a&&(a.pendingToken=this.a);return a};
function cg(a){if(a&&a.providerId&&a.signInMethod){var b={idToken:a.oauthIdToken,accessToken:a.oauthTokenSecret?null:a.oauthAccessToken,oauthTokenSecret:a.oauthTokenSecret,oauthToken:a.oauthTokenSecret&&a.oauthAccessToken,nonce:a.nonce,pendingToken:a.pendingToken};try{return new ag(a.providerId,b,a.signInMethod)}catch(c){}}return null}function dg(a,b){this.Cc=b||[];M(this,{providerId:a,isOAuthProvider:!0});this.yb={};this.bb=(Gf(a)||{}).Na||null;this.Za=null}
dg.prototype.Da=function(a){this.yb=Za(a);return this};function eg(a){if("string"!==typeof a||0!=a.indexOf("saml."))throw new N("argument-error",'SAML provider IDs must be prefixed with "saml."');dg.call(this,a,[])}u(eg,dg);function O(a){dg.call(this,a,Ef);this.a=[]}u(O,dg);O.prototype.ua=function(a){Ha(this.a,a)||this.a.push(a);return this};O.prototype.Eb=function(){return Ka(this.a)};
O.prototype.credential=function(a,b){var c;r(a)?c={idToken:a.idToken||null,accessToken:a.accessToken||null,nonce:a.rawNonce||null}:c={idToken:a||null,accessToken:b||null};if(!c.idToken&&!c.accessToken)throw new N("argument-error","credential failed: must provide the ID token and/or the access token.");return new ag(this.providerId,c,this.providerId)};function fg(){O.call(this,"facebook.com")}u(fg,O);L(fg,"PROVIDER_ID","facebook.com");L(fg,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
function gg(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new fg).credential({accessToken:b})}function hg(){O.call(this,"github.com")}u(hg,O);L(hg,"PROVIDER_ID","github.com");L(hg,"GITHUB_SIGN_IN_METHOD","github.com");
function ig(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new hg).credential({accessToken:b})}function jg(){O.call(this,"google.com");this.ua("profile")}u(jg,O);L(jg,"PROVIDER_ID","google.com");L(jg,"GOOGLE_SIGN_IN_METHOD","google.com");function kg(a,b){var c=a;r(a)&&(c=a.idToken,b=a.accessToken);return(new jg).credential({idToken:c,accessToken:b})}function lg(){dg.call(this,"twitter.com",Df)}u(lg,dg);
L(lg,"PROVIDER_ID","twitter.com");L(lg,"TWITTER_SIGN_IN_METHOD","twitter.com");function mg(a,b){var c=a;r(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new N("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new ag("twitter.com",c,"twitter.com")}
function ng(a,b,c){this.a=a;this.c=b;L(this,"providerId","password");L(this,"signInMethod",c===og.EMAIL_LINK_SIGN_IN_METHOD?og.EMAIL_LINK_SIGN_IN_METHOD:og.EMAIL_PASSWORD_SIGN_IN_METHOD)}ng.prototype.la=function(a){return this.signInMethod==og.EMAIL_LINK_SIGN_IN_METHOD?P(a,pg,{email:this.a,oobCode:this.c}):P(a,qg,{email:this.a,password:this.c})};
ng.prototype.b=function(a,b){return this.signInMethod==og.EMAIL_LINK_SIGN_IN_METHOD?P(a,rg,{idToken:b,email:this.a,oobCode:this.c}):P(a,sg,{idToken:b,email:this.a,password:this.c})};ng.prototype.f=function(a,b){return Tf(this.la(a),b)};ng.prototype.w=function(){return{email:this.a,password:this.c,signInMethod:this.signInMethod}};function tg(a){return a&&a.email&&a.password?new ng(a.email,a.password,a.signInMethod):null}function og(){M(this,{providerId:"password",isOAuthProvider:!1})}
function ug(a,b){b=vg(b);if(!b)throw new N("argument-error","Invalid email link!");return new ng(a,b,og.EMAIL_LINK_SIGN_IN_METHOD)}function vg(a){a=Rf(a);a=new Qf(a);var b=ed(a.a,"oobCode")||null;return"signIn"===(ed(a.a,"mode")||null)&&b?b:null}M(og,{PROVIDER_ID:"password"});M(og,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});M(og,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});
function wg(a){if(!(a.Sa&&a.Ra||a.Fa&&a.$))throw new N("internal-error");this.a=a;L(this,"providerId","phone");L(this,"signInMethod","phone")}wg.prototype.la=function(a){return a.Ta(xg(this))};wg.prototype.b=function(a,b){var c=xg(this);c.idToken=b;return P(a,yg,c)};wg.prototype.f=function(a,b){var c=xg(this);c.operation="REAUTH";a=P(a,zg,c);return Tf(a,b)};
wg.prototype.w=function(){var a={providerId:"phone"};this.a.Sa&&(a.verificationId=this.a.Sa);this.a.Ra&&(a.verificationCode=this.a.Ra);this.a.Fa&&(a.temporaryProof=this.a.Fa);this.a.$&&(a.phoneNumber=this.a.$);return a};function Ag(a){if(a&&"phone"===a.providerId&&(a.verificationId&&a.verificationCode||a.temporaryProof&&a.phoneNumber)){var b={};w(["verificationId","verificationCode","temporaryProof","phoneNumber"],function(c){a[c]&&(b[c]=a[c])});return new wg(b)}return null}
function xg(a){return a.a.Fa&&a.a.$?{temporaryProof:a.a.Fa,phoneNumber:a.a.$}:{sessionInfo:a.a.Sa,code:a.a.Ra}}function Bg(a){try{this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth()}catch(b){throw new N("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}M(this,{providerId:"phone",isOAuthProvider:!1})}
Bg.prototype.Ta=function(a,b){var c=this.a.c;return D(b.verify()).then(function(d){if(!m(d))throw new N("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return Cg(c,{phoneNumber:a,recaptchaToken:d}).then(function(e){"function"===typeof b.reset&&b.reset();return e},function(e){"function"===typeof b.reset&&b.reset();throw e;});default:throw new N("argument-error",
'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function Dg(a,b){if(!a)throw new N("missing-verification-id");if(!b)throw new N("missing-verification-code");return new wg({Sa:a,Ra:b})}M(Bg,{PROVIDER_ID:"phone"});M(Bg,{PHONE_SIGN_IN_METHOD:"phone"});
function Eg(a){if(a.temporaryProof&&a.phoneNumber)return new wg({Fa:a.temporaryProof,$:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret,e=a&&a.nonce,f=a&&a.oauthIdToken,g=a&&a.pendingToken;try{switch(b){case "google.com":return kg(f,c);case "facebook.com":return gg(c);case "github.com":return ig(c);case "twitter.com":return mg(c,d);default:return c||d||f||g?g?0==b.indexOf("saml.")?new Vf(b,g):new ag(b,{pendingToken:g,idToken:a.oauthIdToken,
accessToken:a.oauthAccessToken},b):(new O(b)).credential({idToken:f,accessToken:c,rawNonce:e}):null}}catch(k){return null}}function Fg(a){if(!a.isOAuthProvider)throw new N("invalid-oauth-provider");};function Gg(a,b,c,d,e,f){this.c=a;this.b=b||null;this.g=c||null;this.f=d||null;this.h=f||null;this.a=e||null;if(this.g||this.a){if(this.g&&this.a)throw new N("invalid-auth-event");if(this.g&&!this.f)throw new N("invalid-auth-event");}else throw new N("invalid-auth-event");}Gg.prototype.getUid=function(){var a=[];a.push(this.c);this.b&&a.push(this.b);this.f&&a.push(this.f);this.i&&a.push(this.i);return a.join("-")};
Gg.prototype.w=function(){return{type:this.c,eventId:this.b,urlResponse:this.g,sessionId:this.f,postBody:this.h,error:this.a&&this.a.w()}};function Hg(a){a=a||{};return a.type?new Gg(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&ef(a.error),a.postBody):null};/*

 Copyright 2018 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function Ig(){this.b=null;this.a=[]}var Jg=null;Ig.prototype.subscribe=function(a){var b=this;this.a.push(a);this.b||(this.b=function(c){for(var d=0;d<b.a.length;d++)b.a[d](c)},a=K("universalLinks.subscribe",l),"function"===typeof a&&a(null,this.b))};Ig.prototype.unsubscribe=function(a){x(this.a,function(b){return b==a})};function Kg(a){var b="unauthorized-domain",c=void 0,d=fd(a);a=d.b;d=d.c;"chrome-extension"==d?c=bb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=bb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
N.call(this,b,c)}u(Kg,N);function Lg(a,b,c){N.call(this,a,c);a=b||{};a.zb&&L(this,"email",a.zb);a.$&&L(this,"phoneNumber",a.$);a.credential&&L(this,"credential",a.credential)}u(Lg,N);Lg.prototype.w=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.w();b&&ab(a,b);return a};Lg.prototype.toJSON=function(){return this.w()};
function Mg(a){if(a.code){var b=a.code||"";0==b.indexOf(cf)&&(b=b.substring(cf.length));var c={credential:Eg(a)};if(a.email)c.zb=a.email;else if(a.phoneNumber)c.$=a.phoneNumber;else if(!c.credential)return new N(b,a.message||void 0);return new Lg(b,c,a.message)}return null};function Ng(){}Ng.prototype.c=null;function Og(a){return a.c||(a.c=a.b())};var Pg;function Qg(){}u(Qg,Ng);Qg.prototype.a=function(){var a=Rg(this);return a?new ActiveXObject(a):new XMLHttpRequest};Qg.prototype.b=function(){var a={};Rg(this)&&(a[0]=!0,a[1]=!0);return a};
function Rg(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}Pg=new Qg;function Sg(){}u(Sg,Ng);Sg.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Tg;throw Error("Unsupported browser");};Sg.prototype.b=function(){return{}};
function Tg(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseType=this.responseText=this.response="";this.status=-1;this.statusText="";this.a.onload=t(this.cc,this);this.a.onerror=t(this.Fb,this);this.a.onprogress=t(this.dc,this);this.a.ontimeout=t(this.hc,this)}h=Tg.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
h.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};h.abort=function(){this.a.abort()};h.setRequestHeader=function(){};h.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};h.cc=function(){this.status=200;this.response=this.responseText=this.a.responseText;Ug(this,4)};h.Fb=function(){this.status=500;this.response=this.responseText="";Ug(this,4)};h.hc=function(){this.Fb()};
h.dc=function(){this.status=200;Ug(this,1)};function Ug(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}h.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function Vg(a,b,c){this.reset(a,b,c,void 0,void 0)}Vg.prototype.a=null;var Wg=0;Vg.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Wg++;d||qa();delete this.a};function Xg(a){this.f=a;this.b=this.c=this.a=null}function Yg(a,b){this.name=a;this.value=b}Yg.prototype.toString=function(){return this.name};var Zg=new Yg("SEVERE",1E3),$g=new Yg("WARNING",900),ah=new Yg("CONFIG",700),bh=new Yg("FINE",500);function ch(a){if(a.c)return a.c;if(a.a)return ch(a.a);ta("Root logger has no level set.");return null}Xg.prototype.log=function(a,b,c){if(a.value>=ch(this).value)for(q(b)&&(b=b()),a=new Vg(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var dh={},eh=null;
function fh(a){eh||(eh=new Xg(""),dh[""]=eh,eh.c=ah);var b;if(!(b=dh[a])){b=new Xg(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=fh(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;dh[a]=b}return b};function gh(a,b){a&&a.log(bh,b,void 0)};function hh(a){this.f=a}u(hh,Ng);hh.prototype.a=function(){return new ih(this.f)};hh.prototype.b=function(a){return function(){return a}}({});function ih(a){H.call(this);this.u=a;this.readyState=jh;this.status=0;this.responseType=this.responseText=this.response=this.statusText="";this.onreadystatechange=null;this.i=new Headers;this.b=null;this.m="GET";this.g="";this.a=!1;this.h=fh("goog.net.FetchXmlHttp");this.l=this.c=this.f=null}u(ih,H);var jh=0;h=ih.prototype;
h.open=function(a,b){if(this.readyState!=jh)throw this.abort(),Error("Error reopening a connection");this.m=a;this.g=b;this.readyState=1;kh(this)};h.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.i,method:this.m,credentials:void 0,cache:void 0};a&&(b.body=a);this.u.fetch(new Request(this.g,b)).then(this.gc.bind(this),this.La.bind(this))};
h.abort=function(){this.response=this.responseText="";this.i=new Headers;this.status=0;this.c&&this.c.cancel("Request was aborted.");1<=this.readyState&&this.a&&4!=this.readyState&&(this.a=!1,lh(this,!1));this.readyState=jh};
h.gc=function(a){this.a&&(this.f=a,this.b||(this.b=a.headers,this.readyState=2,kh(this)),this.a&&(this.readyState=3,kh(this),this.a&&("arraybuffer"===this.responseType?a.arrayBuffer().then(this.ec.bind(this),this.La.bind(this)):"undefined"!==typeof l.ReadableStream&&"body"in a?(this.response=this.responseText="",this.c=a.body.getReader(),this.l=new TextDecoder,mh(this)):a.text().then(this.fc.bind(this),this.La.bind(this)))))};function mh(a){a.c.read().then(a.bc.bind(a)).catch(a.La.bind(a))}
h.bc=function(a){if(this.a){var b=this.l.decode(a.value?a.value:new Uint8Array(0),{stream:!a.done});b&&(this.response=this.responseText+=b);a.done?lh(this,!0):kh(this);3==this.readyState&&mh(this)}};h.fc=function(a){this.a&&(this.response=this.responseText=a,lh(this,!0))};h.ec=function(a){this.a&&(this.response=a,lh(this,!0))};h.La=function(a){var b=this.h;b&&b.log($g,"Failed to fetch url "+this.g,a instanceof Error?a:Error(a));this.a&&lh(this,!0)};
function lh(a,b){b&&a.f&&(a.status=a.f.status,a.statusText=a.f.statusText);a.readyState=4;a.f=null;a.c=null;a.l=null;kh(a)}h.setRequestHeader=function(a,b){this.i.append(a,b)};h.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.h)&&a.log($g,"Attempting to get response header but no headers have been received for url: "+this.g,void 0),"")};
h.getAllResponseHeaders=function(){if(!this.b){var a=this.h;a&&a.log($g,"Attempting to get all response headers but no headers have been received for url: "+this.g,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function kh(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function nh(a){H.call(this);this.headers=new Nc;this.D=a||null;this.c=!1;this.A=this.a=null;this.h=this.N=this.l="";this.f=this.I=this.i=this.G=!1;this.g=0;this.u=null;this.m=oh;this.v=this.O=!1}u(nh,H);var oh="";nh.prototype.b=fh("goog.net.XhrIo");var ph=/^https?$/i,qh=["POST","PUT"];
function rh(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.N=c;a.G=!1;a.c=!0;a.a=a.D?a.D.a():Pg.a();a.A=a.D?Og(a.D):Og(Pg);a.a.onreadystatechange=t(a.Ib,a);try{gh(a.b,sh(a,"Opening Xhr")),a.I=!0,a.a.open(c,String(b),!0),a.I=!1}catch(g){gh(a.b,sh(a,"Error opening Xhr: "+g.message));th(a,g);return}b=d||"";var f=new Nc(a.headers);e&&Mc(e,function(g,k){f.set(k,g)});e=Fa(f.U());d=l.FormData&&b instanceof
l.FormData;!Ha(qh,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(g,k){this.a.setRequestHeader(k,g)},a);a.m&&(a.a.responseType=a.m);"withCredentials"in a.a&&a.a.withCredentials!==a.O&&(a.a.withCredentials=a.O);try{uh(a),0<a.g&&(a.v=vh(a.a),gh(a.b,sh(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.v)),a.v?(a.a.timeout=a.g,a.a.ontimeout=t(a.Ga,a)):a.u=Ic(a.Ga,a.g,a)),gh(a.b,sh(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(g){gh(a.b,
sh(a,"Send error: "+g.message)),th(a,g)}}function vh(a){return Pb&&Zb(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Ga(a){return"content-type"==a.toLowerCase()}h=nh.prototype;h.Ga=function(){"undefined"!=typeof aa&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",gh(this.b,sh(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function th(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;wh(a);xh(a)}
function wh(a){a.G||(a.G=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}h.abort=function(){this.a&&this.c&&(gh(this.b,sh(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),xh(this))};h.va=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),xh(this,!0));nh.pb.va.call(this)};h.Ib=function(){this.qa||(this.I||this.i||this.f?yh(this):this.vc())};h.vc=function(){yh(this)};
function yh(a){if(a.c&&"undefined"!=typeof aa)if(a.A[1]&&4==zh(a)&&2==Ah(a))gh(a.b,sh(a,"Local request error detected and ignored"));else if(a.i&&4==zh(a))Ic(a.Ib,0,a);else if(a.dispatchEvent("readystatechange"),4==zh(a)){gh(a.b,sh(a,"Request complete"));a.c=!1;try{var b=Ah(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(Qc)[1]||null;if(!f&&l.self&&l.self.location){var g=l.self.location.protocol;
f=g.substr(0,g.length-1)}e=!ph.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var k=2<zh(a)?a.a.statusText:""}catch(n){gh(a.b,"Can not get status: "+n.message),k=""}a.h=k+" ["+Ah(a)+"]";wh(a)}}finally{xh(a)}}}function xh(a,b){if(a.a){uh(a);var c=a.a,d=a.A[0]?fa:null;a.a=null;a.A=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(Zg,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
function uh(a){a.a&&a.v&&(a.a.ontimeout=null);a.u&&(l.clearTimeout(a.u),a.u=null)}function zh(a){return a.a?a.a.readyState:0}function Ah(a){try{return 2<zh(a)?a.a.status:-1}catch(b){return-1}}function Bh(a){try{return a.a?a.a.responseText:""}catch(b){return gh(a.b,"Can not get responseText: "+b.message),""}}
h.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.m){case oh:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(Zg,"Response type "+this.m+" is not supported on this browser",void 0);return null}catch(b){return gh(this.b,"Can not get response: "+b.message),null}};function sh(a,b){return b+" ["+a.N+" "+a.l+" "+Ah(a)+"]"};/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
function Ch(a){var b=Dh;this.g=[];this.v=b;this.u=a||null;this.f=this.a=!1;this.c=void 0;this.l=this.A=this.i=!1;this.h=0;this.b=null;this.o=0}Ch.prototype.cancel=function(a){if(this.a)this.c instanceof Ch&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.o--,0>=b.o&&b.cancel())}this.v?this.v.call(this.u,this):this.l=!0;this.a||(a=new Eh(this),Fh(this),Gh(this,!1,a))}};Ch.prototype.m=function(a,b){this.i=!1;Gh(this,a,b)};function Gh(a,b,c){a.a=!0;a.c=c;a.f=!b;Hh(a)}
function Fh(a){if(a.a){if(!a.l)throw new Ih(a);a.l=!1}}function Jh(a,b){Kh(a,null,b,void 0)}function Kh(a,b,c,d){a.g.push([b,c,d]);a.a&&Hh(a)}Ch.prototype.then=function(a,b,c){var d,e,f=new C(function(g,k){d=g;e=k});Kh(this,d,function(g){g instanceof Eh?f.cancel():e(g)});return f.then(a,b,c)};Ch.prototype.$goog_Thenable=!0;function Lh(a){return Ea(a.g,function(b){return q(b[1])})}
function Hh(a){if(a.h&&a.a&&Lh(a)){var b=a.h,c=Mh[b];c&&(l.clearTimeout(c.a),delete Mh[b]);a.h=0}a.b&&(a.b.o--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var k=f.call(e||a.u,b);void 0!==k&&(a.f=a.f&&(k==b||k instanceof Error),a.c=b=k);if(ra(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.i=!0}catch(n){b=n,a.f=!0,Lh(a)||(c=!0)}}a.c=b;d&&(k=t(a.m,a,!0),d=t(a.m,a,!1),b instanceof Ch?(Kh(b,k,d),b.A=!0):b.then(k,d));c&&(b=
new Nh(b),Mh[b.a]=b,a.h=b.a)}function Ih(){v.call(this)}u(Ih,v);Ih.prototype.message="Deferred has already fired";Ih.prototype.name="AlreadyCalledError";function Eh(){v.call(this)}u(Eh,v);Eh.prototype.message="Deferred was canceled";Eh.prototype.name="CanceledError";function Nh(a){this.a=l.setTimeout(t(this.c,this),0);this.b=a}Nh.prototype.c=function(){delete Mh[this.a];throw this.b;};var Mh={};function Oh(a){var b={},c=b.document||document,d=vd(a).toString(),e=document.createElement("SCRIPT"),f={Kb:e,Ga:void 0},g=new Ch(f),k=null,n=null!=b.timeout?b.timeout:5E3;0<n&&(k=window.setTimeout(function(){Ph(e,!0);var p=new Qh(Rh,"Timeout reached for loading script "+d);Fh(g);Gh(g,!1,p)},n),f.Ga=k);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Ph(e,b.cd||!1,k),Fh(g),Gh(g,!0,null))};e.onerror=function(){Ph(e,!0,k);var p=new Qh(Sh,"Error while loading script "+
d);Fh(g);Gh(g,!1,p)};f=b.attributes||{};ab(f,{type:"text/javascript",charset:"UTF-8"});Md(e,f);Kd(e,a);Th(c).appendChild(e);return g}function Th(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function Dh(){if(this&&this.Kb){var a=this.Kb;a&&"SCRIPT"==a.tagName&&Ph(a,!0,this.Ga)}}
function Ph(a,b,c){null!=c&&l.clearTimeout(c);a.onload=fa;a.onerror=fa;a.onreadystatechange=fa;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var Sh=0,Rh=1;function Qh(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);v.call(this,c);this.code=a}u(Qh,v);function Uh(a){this.f=a}u(Uh,Ng);Uh.prototype.a=function(){return new this.f};Uh.prototype.b=function(){return{}};
function Vh(a,b,c){this.b=a;a=b||{};this.i=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.o=a.secureTokenTimeout||Wh;this.f=Za(a.secureTokenHeaders||Xh);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||Yh;this.a=Za(a.firebaseHeaders||Zh);c&&(this.a["X-Client-Version"]=c,this.f["X-Client-Version"]=c);c="Node"==qe();c=l.XMLHttpRequest||c&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.XMLHttpRequest;if(!c&&
!pe())throw new N("internal-error","The XMLHttpRequest compatibility library was not found.");this.c=void 0;pe()?this.c=new hh(self):re()?this.c=new Uh(c):this.c=new Sg}var $h,Uf="idToken",Wh=new Fe(3E4,6E4),Xh={"Content-Type":"application/x-www-form-urlencoded"},Yh=new Fe(3E4,6E4),Zh={"Content-Type":"application/json"};function ai(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
function bi(a,b){b?(a.a["X-Client-Version"]=b,a.f["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.f["X-Client-Version"])}function ci(a,b,c,d,e,f,g){ae()||pe()?a=t(a.m,a):($h||($h=new C(function(k,n){di(k,n)})),a=t(a.l,a));a(b,c,d,e,f,g)}
Vh.prototype.m=function(a,b,c,d,e,f){if(pe()&&("undefined"===typeof l.fetch||"undefined"===typeof l.Headers||"undefined"===typeof l.Request))throw new N("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var g=new nh(this.c);if(f){g.g=Math.max(0,f);var k=setTimeout(function(){g.dispatchEvent("timeout")},f)}wc(g,"complete",function(){k&&clearTimeout(k);var n=null;try{n=
JSON.parse(Bh(this))||null}catch(p){n=null}b&&b(n)});Cc(g,"ready",function(){k&&clearTimeout(k);Kb(this)});Cc(g,"timeout",function(){k&&clearTimeout(k);Kb(this);b&&b(null)});rh(g,a,c,d,e)};var ei=new pd(qd,"https://apis.google.com/js/client.js?onload=%{onload}"),fi="__fcb"+Math.floor(1E6*Math.random()).toString();
function di(a,b){if(((window.gapi||{}).client||{}).request)a();else{l[fi]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=wd(ei,{onload:fi});Jh(Oh(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
Vh.prototype.l=function(a,b,c,d,e){var f=this;$h.then(function(){window.gapi.client.setApiKey(f.b);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(k){window.gapi.auth.setToken(g);b&&b(k)}})}).s(function(g){b&&b({error:{message:g&&g.message||"CORS_UNSUPPORTED"}})})};
function gi(a,b){return new C(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?ci(a,a.i+"?key="+encodeURIComponent(a.b),function(e){e?e.error?d(hi(e)):e.access_token&&e.refresh_token?c(e):d(new N("internal-error")):d(new N("network-request-failed"))},"POST",jd(b).toString(),a.f,a.o.get()):d(new N("internal-error"))})}
function ii(a,b,c,d,e,f){var g=fd(a.g+b);I(g,"key",a.b);f&&I(g,"cb",qa().toString());var k="GET"==c;if(k)for(var n in d)d.hasOwnProperty(n)&&I(g,n,d[n]);return new C(function(p,y){ci(a,g.toString(),function(A){A?A.error?y(hi(A,e||{})):p(A):y(new N("network-request-failed"))},c,k?void 0:Rd(Be(d)),a.a,a.h.get())})}function ji(a){a=a.email;if(!m(a)||!je.test(a))throw new N("invalid-email");}function ki(a){"email"in a&&ji(a)}
function li(a,b){return P(a,mi,{identifier:b,continueUri:ye()?Yd():"http://localhost"}).then(function(c){return c.signinMethods||[]})}function ni(a){return P(a,oi,{}).then(function(b){return b.authorizedDomains||[]})}function pi(a){if(!a[Uf])throw new N("internal-error");}
function qi(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new N("internal-error");}else{if(!a.sessionInfo)throw new N("missing-verification-id");if(!a.code)throw new N("missing-verification-code");}}Vh.prototype.nb=function(){return P(this,ri,{})};Vh.prototype.qb=function(a,b){return P(this,si,{idToken:a,email:b})};Vh.prototype.rb=function(a,b){return P(this,sg,{idToken:a,password:b})};var ti={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};h=Vh.prototype;
h.sb=function(a,b){var c={idToken:a},d=[];Xa(ti,function(e,f){var g=b[f];null===g?d.push(e):f in b&&(c[f]=g)});d.length&&(c.deleteAttribute=d);return P(this,si,c)};h.jb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};ab(a,b);return P(this,ui,a)};h.kb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};ab(a,b);return P(this,vi,a)};h.ib=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};ab(a,b);return P(this,wi,a)};function Cg(a,b){return P(a,xi,b)}h.Ta=function(a){return P(this,yi,a)};
function zi(a,b,c){return P(a,Ai,{idToken:b,deleteProvider:c})}function Bi(a){if(!a.requestUri||!a.sessionId&&!a.postBody&&!a.pendingToken)throw new N("internal-error");}function Ci(a,b){b.oauthIdToken&&b.providerId&&0==b.providerId.indexOf("oidc.")&&!b.pendingToken&&(a.sessionId?b.nonce=a.sessionId:a.postBody&&(a=new Vc(a.postBody),nd(a,"nonce")&&(b.nonce=a.get("nonce"))));return b}
function Di(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=Mg(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=Mg(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=Mg(a)):a.errorMessage&&(b=Ei(a.errorMessage));if(b)throw b;if(!a[Uf])throw new N("internal-error");}function Wf(a,b){b.returnIdpCredential=!0;return P(a,Fi,b)}function Yf(a,b){b.returnIdpCredential=!0;return P(a,Gi,b)}
function Zf(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return P(a,Hi,b)}function Ii(a){if(!a.oobCode)throw new N("invalid-action-code");}h.Ya=function(a,b){return P(this,Ji,{oobCode:a,newPassword:b})};h.Ja=function(a){return P(this,Ki,{oobCode:a})};h.Va=function(a){return P(this,Li,{oobCode:a})};
var Li={endpoint:"setAccountInfo",C:Ii,da:"email"},Ki={endpoint:"resetPassword",C:Ii,J:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b)throw new N("internal-error");}},Mi={endpoint:"signupNewUser",C:function(a){ji(a);if(!a.password)throw new N("weak-password");},J:pi,R:!0},mi={endpoint:"createAuthUri"},Ni={endpoint:"deleteAccount",T:["idToken"]},Ai={endpoint:"setAccountInfo",T:["idToken","deleteProvider"],C:function(a){if(!ja(a.deleteProvider))throw new N("internal-error");}},pg=
{endpoint:"emailLinkSignin",T:["email","oobCode"],C:ji,J:pi,R:!0},rg={endpoint:"emailLinkSignin",T:["idToken","email","oobCode"],C:ji,J:pi,R:!0},Oi={endpoint:"getAccountInfo"},vi={endpoint:"getOobConfirmationCode",T:["requestType"],C:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new N("internal-error");ji(a)},da:"email"},wi={endpoint:"getOobConfirmationCode",T:["idToken","requestType"],C:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new N("internal-error");},da:"email"},ui={endpoint:"getOobConfirmationCode",
T:["requestType"],C:function(a){if("PASSWORD_RESET"!=a.requestType)throw new N("internal-error");ji(a)},da:"email"},oi={vb:!0,endpoint:"getProjectConfig",Hb:"GET"},Pi={vb:!0,endpoint:"getRecaptchaParam",Hb:"GET",J:function(a){if(!a.recaptchaSiteKey)throw new N("internal-error");}},Ji={endpoint:"resetPassword",C:Ii,da:"email"},xi={endpoint:"sendVerificationCode",T:["phoneNumber","recaptchaToken"],da:"sessionInfo"},si={endpoint:"setAccountInfo",T:["idToken"],C:ki,R:!0},sg={endpoint:"setAccountInfo",
T:["idToken"],C:function(a){ki(a);if(!a.password)throw new N("weak-password");},J:pi,R:!0},ri={endpoint:"signupNewUser",J:pi,R:!0},Fi={endpoint:"verifyAssertion",C:Bi,Pa:Ci,J:Di,R:!0},Hi={endpoint:"verifyAssertion",C:Bi,Pa:Ci,J:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new N("user-not-found");if(a.errorMessage)throw Ei(a.errorMessage);if(!a[Uf])throw new N("internal-error");},R:!0},Gi={endpoint:"verifyAssertion",C:function(a){Bi(a);if(!a.idToken)throw new N("internal-error");
},Pa:Ci,J:Di,R:!0},Qi={endpoint:"verifyCustomToken",C:function(a){if(!a.token)throw new N("invalid-custom-token");},J:pi,R:!0},qg={endpoint:"verifyPassword",C:function(a){ji(a);if(!a.password)throw new N("wrong-password");},J:pi,R:!0},yi={endpoint:"verifyPhoneNumber",C:qi,J:pi},yg={endpoint:"verifyPhoneNumber",C:function(a){if(!a.idToken)throw new N("internal-error");qi(a)},J:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",Mg(a);pi(a)}},zg={Vb:{USER_NOT_FOUND:"user-not-found"},
endpoint:"verifyPhoneNumber",C:qi,J:pi};function P(a,b,c){if(!Se(c,b.T))return E(new N("internal-error"));var d=b.Hb||"POST",e;return D(c).then(b.C).then(function(){b.R&&(c.returnSecureToken=!0);return ii(a,b.endpoint,d,c,b.Vb,b.vb||!1)}).then(function(f){e=f;return b.Pa?b.Pa(c,e):e}).then(b.J).then(function(){if(!b.da)return e;if(!(b.da in e))throw new N("internal-error");return e[b.da]})}function Ei(a){return hi({error:{errors:[{message:a}],code:400,message:a}})}
function hi(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new N(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",INVALID_PENDING_TOKEN:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",MISSING_OR_INVALID_NONCE:"missing-or-invalid-nonce",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",RESET_PASSWORD_EXCEED_LIMIT:"too-many-requests",
EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",INVALID_PROVIDER_ID:"invalid-provider-id",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",
OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",
QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",REJECTED_CREDENTIAL:"rejected-credential",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_DYNAMIC_LINK_DOMAIN:"invalid-dynamic-link-domain",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash",ADMIN_ONLY_OPERATION:"admin-restricted-operation"};ab(d,
b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new N(d[e],b);!b&&a&&(b=Ae(a));return new N("internal-error",b)};function Ri(a){this.b=a;this.a=null;this.eb=Si(this)}
function Si(a){return Ti().then(function(){return new C(function(b,c){K("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:K("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Ui.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
function Vi(a,b){return a.eb.then(function(){return new C(function(c){a.a.send(b.type,b,c,K("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Wi(a,b){a.eb.then(function(){a.a.register("authEvent",b,K("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Xi=new pd(qd,"https://apis.google.com/js/api.js?onload=%{onload}"),Yi=new Fe(3E4,6E4),Ui=new Fe(5E3,15E3),Zi=null;
function Ti(){return Zi?Zi:Zi=(new C(function(a,b){function c(){Ee();K("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Ee();b(Error("Network Error"))},timeout:Yi.get()})}if(K("gapi.iframes.Iframe"))a();else if(K("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){K("gapi.load")?c():b(Error("Network Error"))};d=wd(Xi,{onload:d});D(Oh(d)).s(function(){b(Error("Network Error"))})}})).s(function(a){Zi=null;throw a;})};function $i(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=gd(this.i,"/__/auth/iframe");I(this.a,"apiKey",this.g);I(this.a,"appName",this.h);this.b=null;this.c=[]}$i.prototype.toString=function(){this.f?I(this.a,"v",this.f):md(this.a.a,"v");this.b?I(this.a,"eid",this.b):md(this.a.a,"eid");this.c.length?I(this.a,"fw",this.c.join(",")):md(this.a.a,"fw");return this.a.toString()};function aj(a,b,c,d,e){this.m=a;this.l=b;this.c=c;this.o=d;this.h=this.g=this.i=null;this.a=e;this.f=null}
aj.prototype.toString=function(){var a=gd(this.m,"/__/auth/handler");I(a,"apiKey",this.l);I(a,"appName",this.c);I(a,"authType",this.o);if(this.a.isOAuthProvider){var b=this.a;try{var c=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(this.c).auth().ea()}catch(k){c=null}b.Za=c;I(a,"providerId",this.a.providerId);b=this.a;c=Be(b.yb);for(var d in c)c[d]=c[d].toString();d=b.Cc;c=Za(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.bb&&b.Za&&!c[b.bb]&&(c[b.bb]=b.Za);Ya(c)||I(a,"customParameters",Ae(c))}"function"===typeof this.a.Eb&&
(b=this.a.Eb(),b.length&&I(a,"scopes",b.join(",")));this.i?I(a,"redirectUrl",this.i):md(a.a,"redirectUrl");this.g?I(a,"eventId",this.g):md(a.a,"eventId");this.h?I(a,"v",this.h):md(a.a,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!ed(a,g)&&I(a,g,this.b[g]);this.f?I(a,"eid",this.f):md(a.a,"eid");g=bj(this.c);g.length&&I(a,"fw",g.join(","));return a.toString()};function bj(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a).auth().ya()}catch(b){return[]}}
function cj(a,b,c,d,e){this.l=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.m=this.u=this.v=null;this.g=[];this.o=this.a=null}
function dj(a){var b=Yd();return ni(a).then(function(c){a:{var d=fd(b),e=d.c;d=d.b;for(var f=0;f<c.length;f++){var g=c[f];var k=d;var n=e;0==g.indexOf("chrome-extension://")?k=fd(g).b==k&&"chrome-extension"==n:"http"!=n&&"https"!=n?k=!1:ie.test(g)?k=k==g:(g=g.split(".").join("\\."),k=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(k));if(k){c=!0;break a}}c=!1}if(!c)throw new Kg(Yd());})}
function ej(a){if(a.o)return a.o;a.o=ke().then(function(){if(!a.u){var b=a.c,c=a.h,d=bj(a.b),e=new $i(a.l,a.f,a.b);e.f=b;e.b=c;e.c=Ka(d||[]);a.u=e.toString()}a.i=new Ri(a.u);fj(a)});return a.o}h=cj.prototype;h.Ea=function(a,b,c){var d=new N("popup-closed-by-user"),e=new N("web-storage-unsupported"),f=this,g=!1;return this.ga().then(function(){gj(f).then(function(k){k||(a&&ee(a),b(e),g=!0)})}).s(function(){}).then(function(){if(!g)return he(a)}).then(function(){if(!g)return Jc(c).then(function(){b(d)})})};
h.Lb=function(){var a=J();return!ze(a)&&!De(a)};h.Gb=function(){return!1};
h.Cb=function(a,b,c,d,e,f,g){if(!a)return E(new N("popup-blocked"));if(g&&!ze())return this.ga().s(function(n){ee(a);e(n)}),d(),D();this.a||(this.a=dj(hj(this)));var k=this;return this.a.then(function(){var n=k.ga().s(function(p){ee(a);e(p);throw p;});d();return n}).then(function(){Fg(c);if(!g){var n=ij(k.l,k.f,k.b,b,c,null,f,k.c,void 0,k.h);Zd(n,a)}}).s(function(n){"auth/network-request-failed"==n.code&&(k.a=null);throw n;})};
function hj(a){a.m||(a.v=a.c?ue(a.c,bj(a.b)):null,a.m=new Vh(a.f,Bf(a.h),a.v));return a.m}h.Ca=function(a,b,c){this.a||(this.a=dj(hj(this)));var d=this;return this.a.then(function(){Fg(b);var e=ij(d.l,d.f,d.b,a,b,Yd(),c,d.c,void 0,d.h);Zd(e)}).s(function(e){"auth/network-request-failed"==e.code&&(d.a=null);throw e;})};h.ga=function(){var a=this;return ej(this).then(function(){return a.i.eb}).s(function(){a.a=null;throw new N("network-request-failed");})};h.Ob=function(){return!0};
function ij(a,b,c,d,e,f,g,k,n,p){a=new aj(a,b,c,d,e);a.i=f;a.g=g;a.h=k;a.b=Za(n||null);a.f=p;return a.toString()}function fj(a){if(!a.i)throw Error("IfcHandler must be initialized!");Wi(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=Hg(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return D(c)}c.status="ERROR";return D(c)})}
function gj(a){var b={type:"webStorageSupport"};return ej(a).then(function(){return Vi(a.i,b)}).then(function(c){if(c&&c.length&&"undefined"!==typeof c[0].webStorageSupport)return c[0].webStorageSupport;throw Error();})}h.wa=function(a){this.g.push(a)};h.Ka=function(a){x(this.g,function(b){return b==a})};function jj(a){this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new N("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}h=jj.prototype;h.get=function(a){return D(this.a.getItem(a)).then(function(b){return b&&Ce(b)})};h.set=function(a,b){return D(this.a.setItem(a,Ae(b)))};h.P=function(a){return D(this.a.removeItem(a))};h.Y=function(){};h.ca=function(){};function kj(a){this.b=a;this.a={};this.c=t(this.f,this)}var lj=[];function mj(){var a=pe()?self:null;w(lj,function(c){c.b==a&&(b=c)});if(!b){var b=new kj(a);lj.push(b)}return b}
kj.prototype.f=function(a){var b=a.data.eventType,c=a.data.eventId,d=this.a[b];if(d&&0<d.length){a.ports[0].postMessage({status:"ack",eventId:c,eventType:b,response:null});var e=[];w(d,function(f){e.push(D().then(function(){return f(a.origin,a.data.data)}))});wb(e).then(function(f){var g=[];w(f,function(k){g.push({fulfilled:k.Db,value:k.value,reason:k.reason?k.reason.message:void 0})});w(g,function(k){for(var n in k)"undefined"===typeof k[n]&&delete k[n]});a.ports[0].postMessage({status:"done",eventId:c,
eventType:b,response:g})})}};kj.prototype.subscribe=function(a,b){Ya(this.a)&&this.b.addEventListener("message",this.c);"undefined"===typeof this.a[a]&&(this.a[a]=[]);this.a[a].push(b)};kj.prototype.unsubscribe=function(a,b){"undefined"!==typeof this.a[a]&&b?(x(this.a[a],function(c){return c==b}),0==this.a[a].length&&delete this.a[a]):b||delete this.a[a];Ya(this.a)&&this.b.removeEventListener("message",this.c)};function nj(a){this.a=a}nj.prototype.postMessage=function(a,b){this.a.postMessage(a,b)};function oj(a){this.c=a;this.b=!1;this.a=[]}
function pj(a,b,c,d){var e,f=c||{},g,k,n,p=null;if(a.b)return E(Error("connection_unavailable"));var y=d?800:50,A="undefined"!==typeof MessageChannel?new MessageChannel:null;return(new C(function(da,dc){A?(e=Math.floor(Math.random()*Math.pow(10,20)).toString(),A.port1.start(),k=setTimeout(function(){dc(Error("unsupported_event"))},y),g=function(ec){ec.data.eventId===e&&("ack"===ec.data.status?(clearTimeout(k),n=setTimeout(function(){dc(Error("timeout"))},3E3)):"done"===ec.data.status?(clearTimeout(n),
"undefined"!==typeof ec.data.response?da(ec.data.response):dc(Error("unknown_error"))):(clearTimeout(k),clearTimeout(n),dc(Error("invalid_response"))))},p={messageChannel:A,onMessage:g},a.a.push(p),A.port1.addEventListener("message",g),a.c.postMessage({eventType:b,eventId:e,data:f},[A.port2])):dc(Error("connection_unavailable"))})).then(function(da){qj(a,p);return da}).s(function(da){qj(a,p);throw da;})}
function qj(a,b){if(b){var c=b.messageChannel,d=b.onMessage;c&&(c.port1.removeEventListener("message",d),c.port1.close());x(a.a,function(e){return e==b})}}oj.prototype.close=function(){for(;0<this.a.length;)qj(this,this.a[0]);this.b=!0};function rj(){if(!sj())throw new N("web-storage-unsupported");this.c={};this.a=[];this.b=0;this.l=l.indexedDB;this.type="indexedDB";this.g=this.o=this.f=this.i=null;this.u=!1;this.h=null;var a=this;pe()&&self?(this.o=mj(),this.o.subscribe("keyChanged",function(b,c){return tj(a).then(function(d){0<d.length&&w(a.a,function(e){e(d)});return{keyProcessed:Ha(d,c.key)}})}),this.o.subscribe("ping",function(){return D(["keyChanged"])})):Le().then(function(b){if(a.h=b)a.g=new oj(new nj(b)),pj(a.g,"ping",null,
!0).then(function(c){c[0].fulfilled&&Ha(c[0].value,"keyChanged")&&(a.u=!0)}).s(function(){})})}var uj;function vj(a){return new C(function(b,c){var d=a.l.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(e){c(Error(e.target.error))}})}
function wj(a){return new C(function(b,c){var d=a.l.open("firebaseLocalStorageDb",1);d.onerror=function(e){try{e.preventDefault()}catch(f){}c(Error(e.target.error))};d.onupgradeneeded=function(e){e=e.target.result;try{e.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(e){e=e.target.result;e.objectStoreNames.contains("firebaseLocalStorage")?b(e):vj(a).then(function(){return wj(a)}).then(function(f){b(f)}).s(function(f){c(f)})}})}
function xj(a){a.m||(a.m=wj(a));return a.m}function sj(){try{return!!l.indexedDB}catch(a){return!1}}function yj(a){return a.objectStore("firebaseLocalStorage")}function zj(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function Aj(a){return new C(function(b,c){a.onsuccess=function(d){d&&d.target?b(d.target.result):b()};a.onerror=function(d){c(d.target.error)}})}h=rj.prototype;
h.set=function(a,b){var c=!1,d,e=this;return xj(this).then(function(f){d=f;f=yj(zj(d,!0));return Aj(f.get(a))}).then(function(f){var g=yj(zj(d,!0));if(f)return f.value=b,Aj(g.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return Aj(g.add(f))}).then(function(){e.c[a]=b;return Bj(e,a)}).ia(function(){c&&e.b--})};function Bj(a,b){return a.g&&a.h&&Ke()===a.h?pj(a.g,"keyChanged",{key:b},a.u).then(function(){}).s(function(){}):D()}
h.get=function(a){return xj(this).then(function(b){return Aj(yj(zj(b,!1)).get(a))}).then(function(b){return b&&b.value})};h.P=function(a){var b=!1,c=this;return xj(this).then(function(d){b=!0;c.b++;return Aj(yj(zj(d,!0))["delete"](a))}).then(function(){delete c.c[a];return Bj(c,a)}).ia(function(){b&&c.b--})};
function tj(a){return xj(a).then(function(b){var c=yj(zj(b,!1));return c.getAll?Aj(c.getAll()):new C(function(d,e){var f=[],g=c.openCursor();g.onsuccess=function(k){(k=k.target.result)?(f.push(k.value),k["continue"]()):d(f)};g.onerror=function(k){e(k.target.error)}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=$d(a.c,c);a.c=c}return d})}h.Y=function(a){0==this.a.length&&Cj(this);this.a.push(a)};
h.ca=function(a){x(this.a,function(b){return b==a});0==this.a.length&&Dj(this)};function Cj(a){function b(){a.f=setTimeout(function(){a.i=tj(a).then(function(c){0<c.length&&w(a.a,function(d){d(c)})}).then(function(){b()}).s(function(c){"STOP_EVENT"!=c.message&&b()})},800)}Dj(a);b()}function Dj(a){a.i&&a.i.cancel("STOP_EVENT");a.f&&(clearTimeout(a.f),a.f=null)};function Ej(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=D().then(function(){if(sj()){var d=we(),e="__sak"+d;uj||(uj=new rj);c=uj;return c.set(e,d).then(function(){return c.get(e)}).then(function(f){if(f!==d)throw Error("indexedDB not supported!");return c.P(e)}).then(function(){return c}).s(function(){return b.c})}return b.c}).then(function(d){b.type=d.type;d.Y(function(e){w(b.a,function(f){f(e)})});return d})}h=Ej.prototype;h.get=function(a){return this.b.then(function(b){return b.get(a)})};
h.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};h.P=function(a){return this.b.then(function(b){return b.P(a)})};h.Y=function(a){this.a.push(a)};h.ca=function(a){x(this.a,function(b){return b==a})};function Fj(){this.a={};this.type="inMemory"}h=Fj.prototype;h.get=function(a){return D(this.a[a])};h.set=function(a,b){this.a[a]=b;return D()};h.P=function(a){delete this.a[a];return D()};h.Y=function(){};h.ca=function(){};function Gj(){if(!Hj()){if("Node"==qe())throw new N("internal-error","The LocalStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.a=Ij()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;this.type="localStorage"}function Ij(){try{var a=l.localStorage,b=we();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function Hj(){var a="Node"==qe();a=Ij()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}h=Gj.prototype;h.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Ce(c)})};h.set=function(a,b){var c=this;return D().then(function(){var d=Ae(b);null===d?c.P(a):c.a.setItem(a,d)})};h.P=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};
h.Y=function(a){l.window&&tc(l.window,"storage",a)};h.ca=function(a){l.window&&G(l.window,"storage",a)};function Jj(){this.type="nullStorage"}h=Jj.prototype;h.get=function(){return D(null)};h.set=function(){return D()};h.P=function(){return D()};h.Y=function(){};h.ca=function(){};function Kj(){if(!Lj()){if("Node"==qe())throw new N("internal-error","The SessionStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.a=Mj()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function Mj(){try{var a=l.sessionStorage,b=we();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function Lj(){var a="Node"==qe();a=Mj()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}h=Kj.prototype;h.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Ce(c)})};h.set=function(a,b){var c=this;return D().then(function(){var d=Ae(b);null===d?c.P(a):c.a.setItem(a,d)})};h.P=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};h.Y=function(){};
h.ca=function(){};function Nj(){var a={};a.Browser=Oj;a.Node=Pj;a.ReactNative=Qj;a.Worker=Rj;this.a=a[qe()]}var Sj,Oj={B:Gj,Qa:Kj},Pj={B:Gj,Qa:Kj},Qj={B:jj,Qa:Jj},Rj={B:Gj,Qa:Jj};var Tj={Wc:"local",NONE:"none",Yc:"session"};function Uj(a){var b=new N("invalid-persistence-type"),c=new N("unsupported-persistence-type");a:{for(d in Tj)if(Tj[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(qe()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!ve()&&"none"!==a)throw c;}}
function Vj(){var a=!De(J())&&oe()?!0:!1,b=ze(),c=ve();this.m=a;this.h=b;this.o=c;this.a={};Sj||(Sj=new Nj);a=Sj;try{this.g=!Xd()&&Je()||!l.indexedDB?new a.a.B:new Ej(pe()?new Fj:new a.a.B)}catch(d){this.g=new Fj,this.h=!0}try{this.i=new a.a.Qa}catch(d){this.i=new Fj}this.l=new Fj;this.f=t(this.Nb,this);this.b={}}var Wj;function Xj(){Wj||(Wj=new Vj);return Wj}function Yj(a,b){switch(b){case "session":return a.i;case "none":return a.l;default:return a.g}}
function Zj(a,b){return"firebase:"+a.name+(b?":"+b:"")}function ak(a,b,c){var d=Zj(b,c),e=Yj(a,b.B);return a.get(b,c).then(function(f){var g=null;try{g=Ce(l.localStorage.getItem(d))}catch(k){}if(g&&!f)return l.localStorage.removeItem(d),a.set(b,g,c);g&&f&&"localStorage"!=e.type&&l.localStorage.removeItem(d)})}h=Vj.prototype;h.get=function(a,b){return Yj(this,a.B).get(Zj(a,b))};function bk(a,b,c){c=Zj(b,c);"local"==b.B&&(a.b[c]=null);return Yj(a,b.B).P(c)}
h.set=function(a,b,c){var d=Zj(a,c),e=this,f=Yj(this,a.B);return f.set(d,b).then(function(){return f.get(d)}).then(function(g){"local"==a.B&&(e.b[d]=g)})};h.addListener=function(a,b,c){a=Zj(a,b);this.o&&(this.b[a]=l.localStorage.getItem(a));Ya(this.a)&&(Yj(this,"local").Y(this.f),this.h||(Xd()||!Je())&&l.indexedDB||!this.o||ck(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
h.removeListener=function(a,b,c){a=Zj(a,b);this.a[a]&&(x(this.a[a],function(d){return d==c}),0==this.a[a].length&&delete this.a[a]);Ya(this.a)&&(Yj(this,"local").ca(this.f),dk(this))};function ck(a){dk(a);a.c=setInterval(function(){for(var b in a.a){var c=l.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new hc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Nb(c))}},1E3)}function dk(a){a.c&&(clearInterval(a.c),a.c=null)}
h.Nb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=l.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.Wa(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?Yj(this,"local").ca(this.f):dk(this);if(this.m)if(c=l.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?l.localStorage.setItem(b,d):l.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
typeof a.a.a||f.b[b]!==l.localStorage.getItem(b))f.b[b]=l.localStorage.getItem(b),f.Wa(b)};Pb&&$b&&10==$b&&l.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else w(a,t(this.Wa,this))};h.Wa=function(a){this.a[a]&&w(this.a[a],function(b){b()})};function ek(a){this.a=a;this.b=Xj()}var fk={name:"authEvent",B:"local"};function gk(a){return a.b.get(fk,a.a).then(function(b){return Hg(b)})};function hk(){this.a=Xj()};function ik(){this.b=-1};function jk(a,b){this.b=kk;this.f=l.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.o=l.Int32Array?new Int32Array(64):Array(64);void 0!==lk||(l.Int32Array?lk=new Int32Array(mk):lk=mk);this.reset()}var lk;u(jk,ik);for(var kk=64,nk=kk-1,ok=[],pk=0;pk<nk;pk++)ok[pk]=0;var qk=Ja(128,ok);jk.prototype.reset=function(){this.g=this.c=0;this.a=l.Int32Array?new Int32Array(this.h):Ka(this.h)};
function rk(a){for(var b=a.f,c=a.o,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var k=a.a[2]|0,n=a.a[3]|0,p=a.a[4]|0,y=a.a[5]|0,A=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var da=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&k^e&k)|0;g=p&y^~p&A;f=f+((p>>>6|p<<26)^(p>>>11|p<<21)^(p>>>25|
p<<7))|0;g=g+(lk[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=A;A=y;y=p;p=n+g|0;n=k;k=e;e=d;d=g+da|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+k|0;a.a[3]=a.a[3]+n|0;a.a[4]=a.a[4]+p|0;a.a[5]=a.a[5]+y|0;a.a[6]=a.a[6]+A|0;a.a[7]=a.a[7]+f|0}
function sk(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(m(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(rk(a),e=0);else if(ka(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(rk(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
var mk=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function tk(){jk.call(this,8,uk)}u(tk,jk);var uk=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function vk(a,b,c,d,e){this.l=a;this.i=b;this.o=c;this.m=d||null;this.u=e||null;this.h=b+":"+c;this.v=new hk;this.g=new ek(this.h);this.f=null;this.b=[];this.a=this.c=null}function wk(a){return new N("invalid-cordova-configuration",a)}h=vk.prototype;
h.ga=function(){return this.za?this.za:this.za=le().then(function(){if("function"!==typeof K("universalLinks.subscribe",l))throw wk("cordova-universal-links-plugin-fix is not installed");if("undefined"===typeof K("BuildInfo.packageName",l))throw wk("cordova-plugin-buildinfo is not installed");if("function"!==typeof K("cordova.plugins.browsertab.openUrl",l))throw wk("cordova-plugin-browsertab is not installed");if("function"!==typeof K("cordova.InAppBrowser.open",l))throw wk("cordova-plugin-inappbrowser is not installed");
},function(){throw new N("cordova-not-ready");})};function xk(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function yk(a){var b=new tk;sk(b,a);a=[];var c=8*b.g;56>b.c?sk(b,qk,56-b.c):sk(b,qk,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;rk(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return rf(a)}
h.Ea=function(a,b){b(new N("operation-not-supported-in-this-environment"));return D()};h.Cb=function(){return E(new N("operation-not-supported-in-this-environment"))};h.Ob=function(){return!1};h.Lb=function(){return!0};h.Gb=function(){return!0};
h.Ca=function(a,b,c){if(this.c)return E(new N("redirect-operation-pending"));var d=this,e=l.document,f=null,g=null,k=null,n=null;return this.c=D().then(function(){Fg(b);return zk(d)}).then(function(){return Ak(d,a,b,c)}).then(function(){return(new C(function(p,y){g=function(){var A=K("cordova.plugins.browsertab.close",l);p();"function"===typeof A&&A();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.wa(g);k=function(){f||(f=Jc(2E3).then(function(){y(new N("redirect-cancelled-by-user"))}))};
n=function(){Ge()&&k()};e.addEventListener("resume",k,!1);J().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).s(function(p){return Bk(d).then(function(){throw p;})})}).ia(function(){k&&e.removeEventListener("resume",k,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.Ka(g);d.c=null})};
function Ak(a,b,c,d){var e=xk(),f=new Gg(b,d,null,e,new N("no-auth-event")),g=K("BuildInfo.packageName",l);if("string"!==typeof g)throw new N("invalid-cordova-configuration");var k=K("BuildInfo.displayName",l),n={};if(J().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(J().toLowerCase().match(/android/))n.apn=g;else return E(new N("operation-not-supported-in-this-environment"));k&&(n.appDisplayName=k);e=yk(e);n.sessionId=e;var p=ij(a.l,a.i,a.o,b,c,null,d,a.m,n,a.u);return a.ga().then(function(){var y=
a.h;return a.v.a.set(fk,f.w(),y)}).then(function(){var y=K("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof y)throw new N("invalid-cordova-configuration");var A=null;y(function(da){if(da){A=K("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof A)throw new N("invalid-cordova-configuration");A(p)}else{A=K("cordova.InAppBrowser.open",l);if("function"!==typeof A)throw new N("invalid-cordova-configuration");da=J();a.a=A(p,da.match(/(iPad|iPhone|iPod).*OS 7_\d/i)||da.match(/(iPad|iPhone|iPod).*OS 8_\d/i)?
"_blank":"_system","location=yes")}})})}function Ck(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function zk(a){a.f||(a.f=a.ga().then(function(){return new C(function(b){function c(d){b(d);a.Ka(c);return!1}a.wa(c);Dk(a)})}));return a.f}function Bk(a){var b=null;return gk(a.g).then(function(c){b=c;c=a.g;return bk(c.b,fk,c.a)}).then(function(){return b})}
function Dk(a){function b(g){d=!0;e&&e.cancel();Bk(a).then(function(k){var n=c;if(k&&g&&g.url){var p=null;n=Rf(g.url);-1!=n.indexOf("/__/auth/callback")&&(p=fd(n),p=Ce(ed(p,"firebaseError")||null),p=(p="object"===typeof p?ef(p):null)?new Gg(k.c,k.b,null,null,p):new Gg(k.c,k.b,n,k.f));n=p||c}Ck(a,n)})}var c=new Gg("unknown",null,null,null,new N("no-auth-event")),d=!1,e=Jc(500).then(function(){return Bk(a).then(function(){d||Ck(a,c)})}),f=l.handleOpenURL;l.handleOpenURL=function(g){0==g.toLowerCase().indexOf(K("BuildInfo.packageName",
l).toLowerCase()+"://")&&b({url:g});if("function"===typeof f)try{f(g)}catch(k){console.error(k)}};Jg||(Jg=new Ig);Jg.subscribe(b)}h.wa=function(a){this.b.push(a);zk(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new Gg("unknown",null,null,null,new N("no-auth-event")),a(b))})};h.Ka=function(a){x(this.b,function(b){return b==a})};function Ek(a){this.a=a;this.b=Xj()}var Fk={name:"pendingRedirect",B:"session"};function Gk(a){return a.b.set(Fk,"pending",a.a)}function Hk(a){return bk(a.b,Fk,a.a)}function Ik(a){return a.b.get(Fk,a.a).then(function(b){return"pending"==b})};function Jk(a,b,c){this.i={};this.u=0;this.A=a;this.l=b;this.m=c;this.h=[];this.f=!1;this.o=t(this.ab,this);this.b=new Kk;this.v=new Lk;this.g=new Ek(this.l+":"+this.m);this.c={};this.c.unknown=this.b;this.c.signInViaRedirect=this.b;this.c.linkViaRedirect=this.b;this.c.reauthViaRedirect=this.b;this.c.signInViaPopup=this.v;this.c.linkViaPopup=this.v;this.c.reauthViaPopup=this.v;this.a=Mk(this.A,this.l,this.m,Cf)}
function Mk(a,b,c,d){var e=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null;return me()?new vk(a,b,c,e,d):new cj(a,b,c,e,d)}h=Jk.prototype;h.reset=function(){this.f=!1;this.a.Ka(this.o);this.a=Mk(this.A,this.l,this.m);this.i={}};h.Xa=function(){this.b.Xa()};function Nk(a){a.f||(a.f=!0,a.a.wa(a.o));var b=a.a;return a.a.ga().s(function(c){a.a==b&&a.reset();throw c;})}
function Ok(a){a.a.Lb()&&Nk(a).s(function(b){var c=new Gg("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));Pk(b)&&a.ab(c)});a.a.Gb()||Qk(a.b)}h.subscribe=function(a){Ha(this.h,a)||this.h.push(a);if(!this.f){var b=this;Ik(this.g).then(function(c){c?Hk(b.g).then(function(){Nk(b).s(function(d){var e=new Gg("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));Pk(d)&&b.ab(e)})}):Ok(b)}).s(function(){Ok(b)})}};
h.unsubscribe=function(a){x(this.h,function(b){return b==a})};h.ab=function(a){if(!a)throw new N("invalid-auth-event");6E5<=qa()-this.u&&(this.i={},this.u=0);if(a&&a.getUid()&&this.i.hasOwnProperty(a.getUid()))return!1;for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.wb(a.c,a.b)){if(b=this.c[a.c])b.h(a,d),a&&(a.f||a.b)&&(this.i[a.getUid()]=!0,this.u=qa());b=!0;break}}Qk(this.b);return b};var Rk=new Fe(2E3,1E4),Sk=new Fe(3E4,6E4);Jk.prototype.fa=function(){return this.b.fa()};
function Tk(a,b,c,d,e,f){return a.a.Cb(b,c,d,function(){a.f||(a.f=!0,a.a.wa(a.o))},function(){a.reset()},e,f)}function Pk(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}Jk.prototype.Ca=function(a,b,c){var d=this,e;return Gk(this.g).then(function(){return d.a.Ca(a,b,c).s(function(f){if(Pk(f))throw new N("operation-not-supported-in-this-environment");e=f;return Hk(d.g).then(function(){throw e;})}).then(function(){return d.a.Ob()?new C(function(){}):Hk(d.g).then(function(){return d.fa()}).then(function(){}).s(function(){})})})};
Jk.prototype.Ea=function(a,b,c,d){return this.a.Ea(c,function(e){a.ha(b,null,e,d)},Rk.get())};var Uk={};function Vk(a,b,c){var d=b+":"+c;Uk[d]||(Uk[d]=new Jk(a,b,c));return Uk[d]}function Kk(){this.b=null;this.f=[];this.c=[];this.a=null;this.i=this.g=!1}Kk.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
Kk.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.c,d=a.b,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;this.i=!(!e&&!f);"unknown"!=c||e||f?a.a?(Wk(this,!0,null,a.a),D()):b.xa(c,d)?Xk(this,a,b):E(new N("invalid-auth-event")):(Wk(this,!1,null,null),D())}else E(new N("invalid-auth-event"))};function Qk(a){a.g||(a.g=!0,Wk(a,!1,null,null))}Kk.prototype.Xa=function(){this.g&&!this.i&&Wk(this,!1,null,null)};
function Xk(a,b,c){c=c.xa(b.c,b.b);var d=b.g,e=b.f,f=b.h,g=!!b.c.match(/Redirect$/);c(d,e,f).then(function(k){Wk(a,g,k,null)}).s(function(k){Wk(a,g,null,k)})}function Yk(a,b){a.b=function(){return E(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function Zk(a,b){a.b=function(){return D(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function Wk(a,b,c,d){b?d?Yk(a,d):Zk(a,c):Zk(a,{user:null});a.f=[];a.c=[]}
Kk.prototype.fa=function(){var a=this;return new C(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),$k(a))})};function $k(a){var b=new N("timeout");a.a&&a.a.cancel();a.a=Jc(Sk.get()).then(function(){a.b||(a.g=!0,Wk(a,!0,null,b))})}function Lk(){}Lk.prototype.h=function(a,b){if(a){var c=a.c,d=a.b;a.a?(b.ha(a.c,null,a.a,a.b),D()):b.xa(c,d)?al(a,b):E(new N("invalid-auth-event"))}else E(new N("invalid-auth-event"))};
function al(a,b){var c=a.b,d=a.c;b.xa(d,c)(a.g,a.f,a.h).then(function(e){b.ha(d,e,null,c)}).s(function(e){b.ha(d,null,e,c)})};function bl(){this.tb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.tb},set:function(a){this.tb=a},enumerable:!1})};function cl(a,b){this.a=b;L(this,"verificationId",a)}cl.prototype.confirm=function(a){a=Dg(this.verificationId,a);return this.a(a)};function dl(a,b,c,d){return(new Bg(a)).Ta(b,c).then(function(e){return new cl(e,d)})};function el(a){var b=zf(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new N("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");M(this,{token:a,expirationTime:Ie(1E3*b.exp),authTime:Ie(1E3*b.auth_time),issuedAtTime:Ie(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,claims:b})};function fl(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}fl.prototype.start=function(){this.a=this.c;gl(this,!0)};function hl(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function gl(a,b){a.stop();a.b=Jc(hl(a,b)).then(function(){return He()}).then(function(){return a.h()}).then(function(){gl(a,!0)}).s(function(c){a.i(c)&&gl(a,!1)})}
fl.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function il(a){this.f=a;this.b=this.a=null;this.c=0}il.prototype.w=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function jl(a,b){var c=b[Uf],d=b.refreshToken;b=kl(b.expiresIn);a.b=c;a.c=b;a.a=d}function ll(a,b){a.b=b.b;a.a=b.a;a.c=b.c}function kl(a){return qa()+1E3*parseInt(a,10)}
function ml(a,b){return gi(a.f,b).then(function(c){a.b=c.access_token;a.c=kl(c.expires_in);a.a=c.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(c){"auth/user-token-expired"==c.code&&(a.a=null);throw c;})}il.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?E(new N("user-token-expired")):a||!this.b||qa()>this.c-3E4?this.a?ml(this,{grant_type:"refresh_token",refresh_token:this.a}):D(null):D({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function nl(a,b){this.a=a||null;this.b=b||null;M(this,{lastSignInTime:Ie(b||null),creationTime:Ie(a||null)})}function ol(a){return new nl(a.a,a.b)}nl.prototype.w=function(){return{lastLoginAt:this.b,createdAt:this.a}};function pl(a,b,c,d,e,f){M(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function ql(a,b){F.call(this,a);for(var c in b)this[c]=b[c]}u(ql,F);
function Q(a,b,c){this.G=[];this.l=a.apiKey;this.m=a.appName;this.u=a.authDomain||null;a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?ue(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null;this.c=new Vh(this.l,Bf(Cf),a);this.h=new il(this.c);rl(this,b[Uf]);jl(this.h,b);L(this,"refreshToken",this.h.a);sl(this,c||{});H.call(this);this.I=!1;this.u&&xe()&&(this.a=Vk(this.u,this.l,this.m));this.N=[];this.i=null;this.A=tl(this);this.V=t(this.Ha,this);var d=this;this.ka=null;this.ta=function(e){d.pa(e.g)};this.X=null;this.O=[];this.sa=function(e){ul(d,
e.c)};this.W=null}u(Q,H);Q.prototype.pa=function(a){this.ka=a;ai(this.c,a)};Q.prototype.ea=function(){return this.ka};function vl(a,b){a.X&&G(a.X,"languageCodeChanged",a.ta);(a.X=b)&&tc(b,"languageCodeChanged",a.ta)}function ul(a,b){a.O=b;bi(a.c,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?ue(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,a.O):null)}Q.prototype.ya=function(){return Ka(this.O)};function wl(a,b){a.W&&G(a.W,"frameworkChanged",a.sa);(a.W=b)&&tc(b,"frameworkChanged",a.sa)}Q.prototype.Ha=function(){this.A.b&&(this.A.stop(),this.A.start())};
function xl(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a.m).auth()}catch(b){throw new N("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.m+"'!");}}function tl(a){return new fl(function(){return a.F(!0)},function(b){return b&&"auth/network-request-failed"==b.code?!0:!1},function(){var b=a.h.c-qa()-3E5;return 0<b?b:0})}function yl(a){a.D||a.A.b||(a.A.start(),G(a,"tokenChanged",a.V),tc(a,"tokenChanged",a.V))}function zl(a){G(a,"tokenChanged",a.V);a.A.stop()}
function rl(a,b){a.ra=b;L(a,"_lat",b)}function Al(a,b){x(a.N,function(c){return c==b})}function Bl(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return wb(b).then(function(){return a})}function Cl(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
function sl(a,b){M(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new nl(b.createdAt,b.lastLoginAt),providerData:[]})}L(Q.prototype,"providerId","firebase");function Dl(){}function El(a){return D().then(function(){if(a.D)throw new N("app-deleted");})}function Fl(a){return Da(a.providerData,function(b){return b.providerId})}
function Gl(a,b){b&&(Hl(a,b.providerId),a.providerData.push(b))}function Hl(a,b){x(a.providerData,function(c){return c.providerId==b})}function Il(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&L(a,b,c)}
function Jl(a,b){a!=b&&(M(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?L(a,"metadata",ol(b.metadata)):L(a,"metadata",new nl),w(b.providerData,function(c){Gl(a,c)}),ll(a.h,b.h),L(a,"refreshToken",a.h.a))}h=Q.prototype;h.reload=function(){var a=this;return R(this,El(this).then(function(){return Kl(a).then(function(){return Bl(a)}).then(Dl)}))};
function Kl(a){return a.F().then(function(b){var c=a.isAnonymous;return Ll(a,b).then(function(){c||Il(a,"isAnonymous",!1);return b})})}h.ac=function(a){return this.F(a).then(function(b){return new el(b)})};h.F=function(a){var b=this;return R(this,El(this).then(function(){return b.h.getToken(a)}).then(function(c){if(!c)throw new N("internal-error");c.accessToken!=b.ra&&(rl(b,c.accessToken),b.dispatchEvent(new ql("tokenChanged")));Il(b,"refreshToken",c.refreshToken);return c.accessToken}))};
function Ml(a,b){b[Uf]&&a.ra!=b[Uf]&&(jl(a.h,b),a.dispatchEvent(new ql("tokenChanged")),rl(a,b[Uf]),Il(a,"refreshToken",a.h.a))}function Ll(a,b){return P(a.c,Oi,{idToken:b}).then(t(a.wc,a))}
h.wc=function(a){a=a.users;if(!a||!a.length)throw new N("internal-error");a=a[0];sl(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=Nl(a),c=0;c<b.length;c++)Gl(this,b[c]);Il(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
function Nl(a){return(a=a.providerUserInfo)&&a.length?Da(a,function(b){return new pl(b.rawId,b.providerId,b.email,b.displayName,b.photoUrl,b.phoneNumber)}):[]}h.xc=function(a){Ne("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.fb(a)};
h.fb=function(a){var b=this,c=null;return R(this,a.f(this.c,this.uid).then(function(d){Ml(b,d);c=Ol(b,d,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};function Pl(a,b){return Kl(a).then(function(){if(Ha(Fl(a),b))return Bl(a).then(function(){throw new N("provider-already-linked");})})}h.oc=function(a){Ne("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.cb(a)};
h.cb=function(a){var b=this,c=null;return R(this,Pl(this,a.providerId).then(function(){return b.F()}).then(function(d){return a.b(b.c,d)}).then(function(d){c=Ol(b,d,"link");return Ql(b,d)}).then(function(){return c}))};h.pc=function(a,b){var c=this;return R(this,Pl(this,"phone").then(function(){return dl(xl(c),a,b,t(c.cb,c))}))};h.yc=function(a,b){var c=this;return R(this,D().then(function(){return dl(xl(c),a,b,t(c.fb,c))}),!0)};
function Ol(a,b,c){var d=Eg(b);b=Hf(b);return Qe({user:a,credential:d,additionalUserInfo:b,operationType:c})}function Ql(a,b){Ml(a,b);return a.reload().then(function(){return a})}h.qb=function(a){var b=this;return R(this,this.F().then(function(c){return b.c.qb(c,a)}).then(function(c){Ml(b,c);return b.reload()}))};h.Oc=function(a){var b=this;return R(this,this.F().then(function(c){return a.b(b.c,c)}).then(function(c){Ml(b,c);return b.reload()}))};
h.rb=function(a){var b=this;return R(this,this.F().then(function(c){return b.c.rb(c,a)}).then(function(c){Ml(b,c);return b.reload()}))};
h.sb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return El(this);var b=this;return R(this,this.F().then(function(c){return b.c.sb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(c){Ml(b,c);Il(b,"displayName",c.displayName||null);Il(b,"photoURL",c.photoUrl||null);w(b.providerData,function(d){"password"===d.providerId&&(L(d,"displayName",b.displayName),L(d,"photoURL",b.photoURL))});return Bl(b)}).then(Dl))};
h.Mc=function(a){var b=this;return R(this,Kl(this).then(function(c){return Ha(Fl(b),a)?zi(b.c,c,[a]).then(function(d){var e={};w(d.providerUserInfo||[],function(f){e[f.providerId]=!0});w(Fl(b),function(f){e[f]||Hl(b,f)});e[Bg.PROVIDER_ID]||L(b,"phoneNumber",null);return Bl(b)}):Bl(b).then(function(){throw new N("no-such-provider");})}))};
h.delete=function(){var a=this;return R(this,this.F().then(function(b){return P(a.c,Ni,{idToken:b})}).then(function(){a.dispatchEvent(new ql("userDeleted"))})).then(function(){for(var b=0;b<a.G.length;b++)a.G[b].cancel("app-deleted");vl(a,null);wl(a,null);a.G=[];a.D=!0;zl(a);L(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
h.wb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.aa||null)==b||"reauthViaRedirect"==a&&(this.aa||null)==b?!0:!1};h.ha=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};
h.xa=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?t(this.Ab,this):"reauthViaPopup"==a&&b==(this.g||null)?t(this.Bb,this):"linkViaRedirect"==a&&(this.aa||null)==b?t(this.Ab,this):"reauthViaRedirect"==a&&(this.aa||null)==b?t(this.Bb,this):null};h.qc=function(a){var b=this;return Rl(this,"linkViaPopup",a,function(){return Pl(b,a.providerId).then(function(){return Bl(b)})},!1)};h.zc=function(a){return Rl(this,"reauthViaPopup",a,function(){return D()},!0)};
function Rl(a,b,c,d,e){if(!xe())return E(new N("operation-not-supported-in-this-environment"));if(a.i&&!e)return E(a.i);var f=Gf(c.providerId),g=we(a.uid+":::"),k=null;(!ze()||oe())&&a.u&&c.isOAuthProvider&&(k=ij(a.u,a.l,a.m,b,c,null,g,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null));var n=fe(k,f&&f.Ba,f&&f.Aa);d=d().then(function(){Sl(a);if(!e)return a.F().then(function(){})}).then(function(){return Tk(a.a,n,b,c,g,!!k)}).then(function(){return new C(function(p,y){a.ha(b,null,new N("cancelled-popup-request"),a.g||null);
a.f=p;a.v=y;a.g=g;a.b=a.a.Ea(a,b,n,g)})}).then(function(p){n&&ee(n);return p?Qe(p):null}).s(function(p){n&&ee(n);throw p;});return R(a,d,e)}h.rc=function(a){var b=this;return Tl(this,"linkViaRedirect",a,function(){return Pl(b,a.providerId)},!1)};h.Ac=function(a){return Tl(this,"reauthViaRedirect",a,function(){return D()},!0)};
function Tl(a,b,c,d,e){if(!xe())return E(new N("operation-not-supported-in-this-environment"));if(a.i&&!e)return E(a.i);var f=null,g=we(a.uid+":::");d=d().then(function(){Sl(a);if(!e)return a.F().then(function(){})}).then(function(){a.aa=g;return Bl(a)}).then(function(k){a.ba&&(k=a.ba,k=k.b.set(Ul,a.w(),k.a));return k}).then(function(){return a.a.Ca(b,c,g)}).s(function(k){f=k;if(a.ba)return Vl(a.ba);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
function Sl(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new N("internal-error");throw new N("auth-domain-config-required");}}h.Ab=function(a,b,c){var d=this;this.b&&(this.b.cancel(),this.b=null);var e=null,f=this.F().then(function(g){return Yf(d.c,{requestUri:a,postBody:c,sessionId:b,idToken:g})}).then(function(g){e=Ol(d,g,"link");return Ql(d,g)}).then(function(){return e});return R(this,f)};
h.Bb=function(a,b,c){var d=this;this.b&&(this.b.cancel(),this.b=null);var e=null,f=D().then(function(){return Tf(Zf(d.c,{requestUri:a,sessionId:b,postBody:c}),d.uid)}).then(function(g){e=Ol(d,g,"reauthenticate");Ml(d,g);d.i=null;return d.reload()}).then(function(){return e});return R(this,f,!0)};h.ib=function(a){var b=this,c=null;return R(this,this.F().then(function(d){c=d;return"undefined"===typeof a||Ya(a)?{}:qf(new ff(a))}).then(function(d){return b.c.ib(c,d)}).then(function(d){if(b.email!=d)return b.reload()}).then(function(){}))};
function R(a,b,c){var d=Wl(a,b,c);a.G.push(d);d.ia(function(){Ia(a.G,d)});return d}function Wl(a,b,c){return a.i&&!c?(b.cancel(),E(a.i)):b.s(function(d){!d||"auth/user-disabled"!=d.code&&"auth/user-token-expired"!=d.code||(a.i||a.dispatchEvent(new ql("userInvalidated")),a.i=d);throw d;})}h.toJSON=function(){return this.w()};
h.w=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.l,appName:this.m,authDomain:this.u,stsTokenManager:this.h.w(),redirectEventId:this.aa||null};this.metadata&&ab(a,this.metadata.w());w(this.providerData,function(b){a.providerData.push(Re(b))});return a};
function Xl(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[Uf]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-qa())/1E3;else return null;var d=new Q(b,c,a);a.providerData&&w(a.providerData,function(e){e&&Gl(d,Qe(e))});a.redirectEventId&&(d.aa=a.redirectEventId);return d}
function Yl(a,b,c,d){var e=new Q(a,b);c&&(e.ba=c);d&&ul(e,d);return e.reload().then(function(){return e})}function Zl(a,b,c,d){b=b||{apiKey:a.l,authDomain:a.u,appName:a.m};var e=a.h,f={};f[Uf]=e.b;f.refreshToken=e.a;f.expiresIn=(e.c-qa())/1E3;b=new Q(b,f);c&&(b.ba=c);d&&ul(b,d);Jl(b,a);return b};function $l(a){this.a=a;this.b=Xj()}var Ul={name:"redirectUser",B:"session"};function Vl(a){return bk(a.b,Ul,a.a)}function am(a,b){return a.b.get(Ul,a.a).then(function(c){c&&b&&(c.authDomain=b);return Xl(c||{})})};function bm(a){this.a=a;this.b=Xj();this.c=null;this.f=cm(this);this.b.addListener(dm("local"),this.a,t(this.g,this))}bm.prototype.g=function(){var a=this,b=dm("local");em(this,function(){return D().then(function(){return a.c&&"local"!=a.c.B?a.b.get(b,a.a):null}).then(function(c){if(c)return fm(a,"local").then(function(){a.c=b})})})};function fm(a,b){var c=[],d;for(d in Tj)Tj[d]!==b&&c.push(bk(a.b,dm(Tj[d]),a.a));c.push(bk(a.b,gm,a.a));return vb(c)}
function cm(a){var b=dm("local"),c=dm("session"),d=dm("none");return ak(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(f){return f?d:a.b.get(b,a.a).then(function(g){return g?b:a.b.get(gm,a.a).then(function(k){return k?dm(k):b})})})}).then(function(e){a.c=e;return fm(a,e.B)}).s(function(){a.c||(a.c=b)})}var gm={name:"persistence",B:"session"};function dm(a){return{name:"authUser",B:a}}
bm.prototype.lb=function(a){var b=null,c=this;Uj(a);return em(this,function(){return a!=c.c.B?c.b.get(c.c,c.a).then(function(d){b=d;return fm(c,a)}).then(function(){c.c=dm(a);if(b)return c.b.set(c.c,b,c.a)}):D()})};function hm(a){return em(a,function(){return a.b.set(gm,a.c.B,a.a)})}function im(a,b){return em(a,function(){return a.b.set(a.c,b.w(),a.a)})}function jm(a){return em(a,function(){return bk(a.b,a.c,a.a)})}
function km(a,b){return em(a,function(){return a.b.get(a.c,a.a).then(function(c){c&&b&&(c.authDomain=b);return Xl(c||{})})})}function em(a,b){a.f=a.f.then(b,b);return a.f};function lm(a){this.l=!1;L(this,"settings",new bl);L(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?ue(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null,this.c=new Vh(S(this).options&&S(this).options.apiKey,Bf(Cf),a);else throw new N("invalid-api-key");this.N=[];this.m=[];this.I=[];this.Rb=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(t(this.kc,this));this.O=void 0;this.Sb=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(t(this.mc,this));mm(this,null);this.h=new bm(S(this).options.apiKey+":"+S(this).name);this.A=
new $l(S(this).options.apiKey+":"+S(this).name);this.V=T(this,nm(this));this.i=T(this,om(this));this.X=!1;this.ka=t(this.Jc,this);this.Ha=t(this.Z,this);this.ra=t(this.Zb,this);this.sa=t(this.ic,this);this.ta=t(this.jc,this);pm(this);this.INTERNAL={};this.INTERNAL["delete"]=t(this.delete,this);this.INTERNAL.logFramework=t(this.sc,this);this.u=0;H.call(this);qm(this);this.G=[]}u(lm,H);function rm(a){F.call(this,"languageCodeChanged");this.g=a}u(rm,F);
function sm(a){F.call(this,"frameworkChanged");this.c=a}u(sm,F);h=lm.prototype;h.lb=function(a){a=this.h.lb(a);return T(this,a)};h.pa=function(a){this.W===a||this.l||(this.W=a,ai(this.c,this.W),this.dispatchEvent(new rm(this.ea())))};h.ea=function(){return this.W};h.Pc=function(){var a=l.navigator;this.pa(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};h.sc=function(a){this.G.push(a);bi(this.c,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?ue(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,this.G):null);this.dispatchEvent(new sm(this.G))};
h.ya=function(){return Ka(this.G)};function qm(a){Object.defineProperty(a,"lc",{get:function(){return this.ea()},set:function(b){this.pa(b)},enumerable:!1});a.W=null}h.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).w()}};function tm(a){return a.Qb||E(new N("auth-domain-config-required"))}
function pm(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&xe()&&(a.Qb=a.V.then(function(){if(!a.l){a.a=Vk(b,c,S(a).name);a.a.subscribe(a);U(a)&&Cl(U(a));if(a.D){Cl(a.D);var d=a.D;d.pa(a.ea());vl(d,a);d=a.D;ul(d,a.G);wl(d,a);a.D=null}return a.a}}))}h.wb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
h.ha=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};h.xa=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?t(this.Yb,this):null};
h.Yb=function(a,b,c){var d=this;a={requestUri:a,postBody:c,sessionId:b};this.b&&(this.b.cancel(),this.b=null);var e=null,f=null,g=Wf(d.c,a).then(function(k){e=Eg(k);f=Hf(k);return k});a=d.V.then(function(){return g}).then(function(k){return um(d,k)}).then(function(){return Qe({user:U(d),credential:e,additionalUserInfo:f,operationType:"signIn"})});return T(this,a)};
h.Hc=function(a){if(!xe())return E(new N("operation-not-supported-in-this-environment"));var b=this,c=Gf(a.providerId),d=we(),e=null;(!ze()||oe())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=ij(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null));var f=fe(e,c&&c.Ba,c&&c.Aa);c=tm(this).then(function(g){return Tk(g,f,"signInViaPopup",a,d,!!e)}).then(function(){return new C(function(g,k){b.ha("signInViaPopup",null,new N("cancelled-popup-request"),
b.g);b.f=g;b.v=k;b.g=d;b.b=b.a.Ea(b,"signInViaPopup",f,d)})}).then(function(g){f&&ee(f);return g?Qe(g):null}).s(function(g){f&&ee(f);throw g;});return T(this,c)};h.Ic=function(a){if(!xe())return E(new N("operation-not-supported-in-this-environment"));var b=this,c=tm(this).then(function(){return hm(b.h)}).then(function(){return b.a.Ca("signInViaRedirect",a)});return T(this,c)};
h.fa=function(){if(!xe())return E(new N("operation-not-supported-in-this-environment"));var a=this,b=tm(this).then(function(){return a.a.fa()}).then(function(c){return c?Qe(c):null});return T(this,b)};
h.Nc=function(a){if(!a)return E(new N("null-user"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=Zl(a,c,b.A,b.ya());return T(this,this.i.then(function(){if(S(b).options.apiKey!=a.l)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return Jl(U(b),a),b.Z(a);mm(b,d);Cl(d);return b.Z(d)}).then(function(){vm(b)}))};
function um(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.V.then(function(){return Yl(c,b,a.A,a.ya())}).then(function(d){if(U(a)&&d.uid==U(a).uid)return Jl(U(a),d),a.Z(d);mm(a,d);Cl(d);return a.Z(d)}).then(function(){vm(a)})}
function mm(a,b){U(a)&&(Al(U(a),a.Ha),G(U(a),"tokenChanged",a.ra),G(U(a),"userDeleted",a.sa),G(U(a),"userInvalidated",a.ta),zl(U(a)));b&&(b.N.push(a.Ha),tc(b,"tokenChanged",a.ra),tc(b,"userDeleted",a.sa),tc(b,"userInvalidated",a.ta),0<a.u&&yl(b));L(a,"currentUser",b);b&&(b.pa(a.ea()),vl(b,a),ul(b,a.G),wl(b,a))}h.ob=function(){var a=this,b=this.i.then(function(){if(!U(a))return D();mm(a,null);return jm(a.h).then(function(){vm(a)})});return T(this,b)};
function wm(a){var b=am(a.A,S(a).options.authDomain).then(function(c){if(a.D=c)c.ba=a.A;return Vl(a.A)});return T(a,b)}function nm(a){var b=S(a).options.authDomain,c=wm(a).then(function(){return km(a.h,b)}).then(function(d){return d?(d.ba=a.A,a.D&&(a.D.aa||null)==(d.aa||null)?d:d.reload().then(function(){return im(a.h,d).then(function(){return d})}).s(function(e){return"auth/network-request-failed"==e.code?d:jm(a.h)})):null}).then(function(d){mm(a,d||null)});return T(a,c)}
function om(a){return a.V.then(function(){return a.fa()}).s(function(){}).then(function(){if(!a.l)return a.ka()}).s(function(){}).then(function(){if(!a.l){a.X=!0;var b=a.h;b.b.addListener(dm("local"),b.a,a.ka)}})}
h.Jc=function(){var a=this;return km(this.h,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return Jl(U(a),b),U(a).F();if(U(a)||b)mm(a,b),b&&(Cl(b),b.ba=a.A),a.a&&a.a.subscribe(a),vm(a)}})};h.Z=function(a){return im(this.h,a)};h.Zb=function(){vm(this);this.Z(U(this))};h.ic=function(){this.ob()};h.jc=function(){this.ob()};
function xm(a,b){var c=null,d=null;return T(a,b.then(function(e){c=Eg(e);d=Hf(e);return um(a,e)}).then(function(){return Qe({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}h.kc=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};h.mc=function(a){var b=this;ym(this,function(){a.next(U(b))})};h.uc=function(a,b,c){var d=this;this.X&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.Promise.resolve().then(function(){q(a)?a(U(d)):q(a.next)&&a.next(U(d))});return this.Rb(a,b,c)};
h.tc=function(a,b,c){var d=this;this.X&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.Promise.resolve().then(function(){d.O=d.getUid();q(a)?a(U(d)):q(a.next)&&a.next(U(d))});return this.Sb(a,b,c)};h.$b=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).F(a).then(function(d){return{accessToken:d}}):null});return T(this,c)};h.Dc=function(a){var b=this;return this.i.then(function(){return xm(b,P(b.c,Qi,{token:a}))}).then(function(c){var d=c.user;Il(d,"isAnonymous",!1);b.Z(d);return c})};
h.Ec=function(a,b){var c=this;return this.i.then(function(){return xm(c,P(c.c,qg,{email:a,password:b}))})};h.Ub=function(a,b){var c=this;return this.i.then(function(){return xm(c,P(c.c,Mi,{email:a,password:b}))})};h.Mb=function(a){var b=this;return this.i.then(function(){return xm(b,a.la(b.c))})};h.mb=function(a){Ne("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");return this.Mb(a)};
h.nb=function(){var a=this;return this.i.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=Qe({providerId:null,isNewUser:!1});return Qe({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return xm(a,a.c.nb()).then(function(d){var e=d.user;Il(e,"isAnonymous",!0);a.Z(e);return d})})};function S(a){return a.app}function U(a){return a.currentUser}h.getUid=function(){return U(this)&&U(this).uid||null};function zm(a){return U(a)&&U(a)._lat||null}
function vm(a){if(a.X){for(var b=0;b<a.m.length;b++)if(a.m[b])a.m[b](zm(a));if(a.O!==a.getUid()&&a.I.length)for(a.O=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](zm(a))}}h.Tb=function(a){this.addAuthTokenListener(a);this.u++;0<this.u&&U(this)&&yl(U(this))};h.Bc=function(a){var b=this;w(this.m,function(c){c==a&&b.u--});0>this.u&&(this.u=0);0==this.u&&U(this)&&zl(U(this));this.removeAuthTokenListener(a)};
h.addAuthTokenListener=function(a){var b=this;this.m.push(a);T(this,this.i.then(function(){b.l||Ha(b.m,a)&&a(zm(b))}))};h.removeAuthTokenListener=function(a){x(this.m,function(b){return b==a})};function ym(a,b){a.I.push(b);T(a,a.i.then(function(){!a.l&&Ha(a.I,b)&&a.O!==a.getUid()&&(a.O=a.getUid(),b(zm(a)))}))}
h.delete=function(){this.l=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,a.b.removeListener(dm("local"),a.a,this.ka));this.a&&(this.a.unsubscribe(this),this.a.Xa());return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.Promise.resolve()};function T(a,b){a.N.push(b);b.ia(function(){Ia(a.N,b)});return b}h.Xb=function(a){return T(this,li(this.c,a))};h.nc=function(a){return!!vg(a)};
h.kb=function(a,b){var c=this;return T(this,D().then(function(){var d=new ff(b);if(!d.c)throw new N("argument-error",of+" must be true when sending sign in link to email");return qf(d)}).then(function(d){return c.c.kb(a,d)}).then(function(){}))};h.Qc=function(a){return this.Ja(a).then(function(b){return b.data.email})};h.Ya=function(a,b){return T(this,this.c.Ya(a,b).then(function(){}))};h.Ja=function(a){return T(this,this.c.Ja(a).then(function(b){return new Ue(b)}))};
h.Va=function(a){return T(this,this.c.Va(a).then(function(){}))};h.jb=function(a,b){var c=this;return T(this,D().then(function(){return"undefined"===typeof b||Ya(b)?{}:qf(new ff(b))}).then(function(d){return c.c.jb(a,d)}).then(function(){}))};h.Gc=function(a,b){return T(this,dl(this,a,b,t(this.mb,this)))};h.Fc=function(a,b){var c=this;return T(this,D().then(function(){var d=ug(a,b||Yd());return c.mb(d)}))};function Am(){}Am.prototype.render=function(){};Am.prototype.reset=function(){};Am.prototype.getResponse=function(){};Am.prototype.execute=function(){};function Bm(){this.a={};this.b=1E12}var Cm=null;Bm.prototype.render=function(a,b){this.a[this.b.toString()]=new Dm(a,b);return this.b++};Bm.prototype.reset=function(a){var b=Em(this,a);a=Fm(a);b&&a&&(b.delete(),delete this.a[a])};Bm.prototype.getResponse=function(a){return(a=Em(this,a))?a.getResponse():null};Bm.prototype.execute=function(a){(a=Em(this,a))&&a.execute()};function Em(a,b){return(b=Fm(b))?a.a[b]||null:null}function Fm(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
function Dm(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=Ld(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():tc(this.f,"click",this.i)}Dm.prototype.getResponse=function(){Gm(this);return this.b};
Dm.prototype.execute=function(){Gm(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=se();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};Dm.prototype.delete=function(){Gm(this);this.g=!0;clearTimeout(this.a);this.a=null;G(this.f,"click",this.i)};function Gm(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function Hm(){}Hm.prototype.g=function(){Cm||(Cm=new Bm);return D(Cm)};Hm.prototype.c=function(){};var Im=null;function Jm(){this.b=l.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var Km=new pd(qd,"https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),Lm=new Fe(3E4,6E4);
Jm.prototype.g=function(a){var b=this;return new C(function(c,d){var e=setTimeout(function(){d(new N("network-request-failed"))},Lm.get());if(!l.grecaptcha||a!==b.f&&!b.b){l[b.a]=function(){if(l.grecaptcha){b.f=a;var g=l.grecaptcha.render;l.grecaptcha.render=function(k,n){k=g(k,n);b.b++;return k};clearTimeout(e);c(l.grecaptcha)}else clearTimeout(e),d(new N("internal-error"));delete l[b.a]};var f=wd(Km,{onload:b.a,hl:a||""});D(Oh(f)).s(function(){clearTimeout(e);d(new N("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
c(l.grecaptcha)})};Jm.prototype.c=function(){this.b--};var Mm=null;function Nm(a,b,c,d,e,f,g){L(this,"type","recaptcha");this.c=this.f=null;this.D=!1;this.l=b;this.g=null;g?(Im||(Im=new Hm),g=Im):(Mm||(Mm=new Jm),g=Mm);this.m=g;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[Om])throw new N("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[Pm];if(!l.document)throw new N("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
if(!Ld(b)||!this.i&&Ld(b).hasChildNodes())throw new N("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new Vh(a,f||null,e||null);this.v=d||function(){return null};var k=this;this.o=[];var n=this.a[Qm];this.a[Qm]=function(y){Rm(k,y);if("function"===typeof n)n(y);else if("string"===typeof n){var A=K(n,l);"function"===typeof A&&A(y)}};var p=this.a[Sm];this.a[Sm]=function(){Rm(k,null);if("function"===typeof p)p();else if("string"===typeof p){var y=
K(p,l);"function"===typeof y&&y()}}}var Qm="callback",Sm="expired-callback",Om="sitekey",Pm="size";function Rm(a,b){for(var c=0;c<a.o.length;c++)try{a.o[c](b)}catch(d){}}function Tm(a,b){x(a.o,function(c){return c==b})}function Um(a,b){a.h.push(b);b.ia(function(){Ia(a.h,b)});return b}h=Nm.prototype;
h.za=function(){var a=this;return this.f?this.f:this.f=Um(this,D().then(function(){if(ye()&&!pe())return ke();throw new N("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.m.g(a.v())}).then(function(b){a.g=b;return P(a.u,Pi,{})}).then(function(b){a.a[Om]=b.recaptchaSiteKey}).s(function(b){a.f=null;throw b;}))};
h.render=function(){Vm(this);var a=this;return Um(this,this.za().then(function(){if(null===a.c){var b=a.l;if(!a.i){var c=Ld(b);b=Od("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};h.verify=function(){Vm(this);var a=this;return Um(this,this.render().then(function(b){return new C(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(f){f&&(Tm(a,e),c(f))};a.o.push(e);a.i&&a.g.execute(a.c)}})}))};h.reset=function(){Vm(this);null!==this.c&&this.g.reset(this.c)};
function Vm(a){if(a.D)throw new N("internal-error","RecaptchaVerifier instance has been destroyed.");}h.clear=function(){Vm(this);this.D=!0;this.m.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=Ld(this.l);for(var b;b=a.firstChild;)a.removeChild(b)}};
function Wm(a,b,c){var d=!1;try{this.b=c||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app()}catch(g){throw new N("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new N("invalid-api-key");var e=this,f=null;try{f=this.b.auth().ya()}catch(g){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(g){}f=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?ue(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,f):null;Nm.call(this,c,a,b,function(){try{var g=e.b.auth().ea()}catch(k){g=
null}return g},f,Bf(Cf),d)}u(Wm,Nm);function Xm(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new N("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=Ym.length)throw new N("internal-error",
"Argument validator received an unsupported number of arguments.");c=Ym[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new N("argument-error",a+" failed: "+d);}var Ym="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:m}}function Zm(a,b){return{name:a||"",K:"a boolean",optional:!!b,M:ba}}
function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:r}}function $m(a,b){return{name:a||"",K:"a function",optional:!!b,M:q}}function an(a,b){return{name:a||"",K:"null",optional:!!b,M:ia}}function bn(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function cn(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof lm)}}}
function dn(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app.App)}}}function en(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.la||!c)}}}
function fn(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function gn(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&m(a.type)&&q(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(e){return a.M(e)||b.M(e)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=hn(d,a[c],b[c].j)}}function jn(a,b){for(var c in b){var d=b[c].name;d!==c&&Object.defineProperty(a,d,{get:pa(function(e){return this[e]},c),set:pa(function(e,f,g,k){Xm(e,[g],[k],!0);this[f]=k},d,c,b[c].ub),enumerable:!0})}}function Z(a,b,c,d){a[b]=hn(b,c,d)}
function hn(a,b,c){function d(){var g=Array.prototype.slice.call(arguments);Xm(e,c,g);return b.apply(this,g)}if(!c)return b;var e=kn(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function kn(a){a=a.split(".");return a[a.length-1]};Y(lm.prototype,{Va:{name:"applyActionCode",j:[V("code")]},Ja:{name:"checkActionCode",j:[V("code")]},Ya:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},Ub:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},Xb:{name:"fetchSignInMethodsForEmail",j:[V("email")]},fa:{name:"getRedirectResult",j:[]},nc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},tc:{name:"onAuthStateChanged",j:[X(W(),$m(),"nextOrObserver"),$m("opt_error",!0),$m("opt_completed",!0)]},uc:{name:"onIdTokenChanged",
j:[X(W(),$m(),"nextOrObserver"),$m("opt_error",!0),$m("opt_completed",!0)]},jb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),an(null,!0),"opt_actionCodeSettings",!0)]},kb:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},lb:{name:"setPersistence",j:[V("persistence")]},mb:{name:"signInAndRetrieveDataWithCredential",j:[en()]},nb:{name:"signInAnonymously",j:[]},Mb:{name:"signInWithCredential",j:[en()]},Dc:{name:"signInWithCustomToken",j:[V("token")]},
Ec:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Fc:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Gc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),gn()]},Hc:{name:"signInWithPopup",j:[fn()]},Ic:{name:"signInWithRedirect",j:[fn()]},Nc:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",K:"an instance of Firebase User",optional:!!a,M:function(b){return!!(b&&b instanceof Q)}}}(),an(),"user")]},ob:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},
Pc:{name:"useDeviceLanguage",j:[]},Qc:{name:"verifyPasswordResetCode",j:[V("code")]}});jn(lm.prototype,{lc:{name:"languageCode",ub:X(V(),an(),"languageCode")}});lm.Persistence=Tj;lm.Persistence.LOCAL="local";lm.Persistence.SESSION="session";lm.Persistence.NONE="none";
Y(Q.prototype,{"delete":{name:"delete",j:[]},ac:{name:"getIdTokenResult",j:[Zm("opt_forceRefresh",!0)]},F:{name:"getIdToken",j:[Zm("opt_forceRefresh",!0)]},oc:{name:"linkAndRetrieveDataWithCredential",j:[en()]},cb:{name:"linkWithCredential",j:[en()]},pc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),gn()]},qc:{name:"linkWithPopup",j:[fn()]},rc:{name:"linkWithRedirect",j:[fn()]},xc:{name:"reauthenticateAndRetrieveDataWithCredential",j:[en()]},fb:{name:"reauthenticateWithCredential",j:[en()]},yc:{name:"reauthenticateWithPhoneNumber",
j:[V("phoneNumber"),gn()]},zc:{name:"reauthenticateWithPopup",j:[fn()]},Ac:{name:"reauthenticateWithRedirect",j:[fn()]},reload:{name:"reload",j:[]},ib:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),an(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Mc:{name:"unlink",j:[V("provider")]},qb:{name:"updateEmail",j:[V("email")]},rb:{name:"updatePassword",j:[V("password")]},Oc:{name:"updatePhoneNumber",j:[en("phone")]},sb:{name:"updateProfile",j:[W("profile")]}});
Y(Bm.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(Am.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(C.prototype,{ia:{name:"finally"},s:{name:"catch"},then:{name:"then"}});jn(bl.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",ub:Zm("appVerificationDisabledForTesting")}});Y(cl.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});
Z(Sf,"fromJSON",function(a){a=m(a)?JSON.parse(a):a;for(var b,c=[cg,tg,Ag,$f],d=0;d<c.length;d++)if(b=c[d](a))return b;return null},[X(V(),W(),"json")]);Z(og,"credential",function(a,b){return new ng(a,b)},[V("email"),V("password")]);Y(ng.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Y(fg.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(fg,"credential",gg,[X(V(),W(),"token")]);Z(og,"credentialWithLink",ug,[V("email"),V("emailLink")]);
Y(hg.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(hg,"credential",ig,[X(V(),W(),"token")]);Y(jg.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(jg,"credential",kg,[X(V(),X(W(),an()),"idToken"),X(V(),an(),"accessToken",!0)]);Y(lg.prototype,{Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(lg,"credential",mg,[X(V(),W(),"token"),V("secret",!0)]);
Y(O.prototype,{ua:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),X(W(),an()),"optionsOrIdToken"),X(V(),an(),"accessToken",!0)]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Y(ag.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Y(Vf.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Z(Bg,"credential",Dg,[V("verificationId"),V("verificationCode")]);Y(Bg.prototype,{Ta:{name:"verifyPhoneNumber",j:[V("phoneNumber"),gn()]}});
Y(wg.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Y(N.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Lg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Kg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Wm.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});
(function(){if("undefined"!==typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService){var a={Auth:lm,AuthCredential:Sf,Error:N};Z(a,"EmailAuthProvider",og,[]);Z(a,"FacebookAuthProvider",fg,[]);Z(a,"GithubAuthProvider",hg,[]);Z(a,"GoogleAuthProvider",jg,[]);Z(a,"TwitterAuthProvider",lg,[]);Z(a,"OAuthProvider",O,[V("providerId")]);Z(a,"SAMLAuthProvider",eg,[V("providerId")]);Z(a,"PhoneAuthProvider",Bg,[cn()]);Z(a,"RecaptchaVerifier",Wm,[X(V(),bn(),"recaptchaContainer"),W("recaptchaParameters",
!0),dn()]);__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService("auth",function(b,c){b=new lm(b);c({INTERNAL:{getUid:t(b.getUid,b),getToken:t(b.$b,b),addAuthTokenListener:t(b.Tb,b),removeAuthTokenListener:t(b.Bc,b)}});return b},a,function(b,c){if("create"===b)try{c.auth()}catch(d){}});__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.extendNamespace({User:Q})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

//# sourceMappingURL=auth.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(35)))

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(186));
var tslib_1 = __webpack_require__(216);
var util = __webpack_require__(218);
var logger$1 = __webpack_require__(580);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */ (function () {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */
    function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */
    DOMStorageWrapper.prototype.set = function (key, value) {
        if (value == null) {
            this.domStorage_.removeItem(this.prefixedName_(key));
        }
        else {
            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
        }
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */
    DOMStorageWrapper.prototype.get = function (key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) {
            return null;
        }
        else {
            return util.jsonEval(storedVal);
        }
    };
    /**
     * @param {string} key
     */
    DOMStorageWrapper.prototype.remove = function (key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */
    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function () {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function (key, value) {
        if (value == null) {
            delete this.cache_[key];
        }
        else {
            this.cache_[key] = value;
        }
    };
    MemoryStorage.prototype.get = function (key) {
        if (util.contains(this.cache_, key)) {
            return this.cache_[key];
        }
        return null;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */
var createStoragefor = function (domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' &&
            typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new DOMStorageWrapper(domStorage);
        }
    }
    catch (e) { }
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new MemoryStorage();
};
/** A storage object that lasts across sessions */
var PersistentStorage = createStoragefor('localStorage');
/** A storage object that only lasts one session */
var SessionStorage = createStoragefor('sessionStorage');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger$1.Logger('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */
var LUIDGenerator = (function () {
    var id = 1;
    return function () {
        return id++;
    };
})();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */
var sha1 = function (str) {
    var utf8Bytes = util.stringToByteArray(str);
    var sha1 = new util.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return util.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} var_args
 * @return {string}
 * @private
 */
var buildLogMessage_ = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = '';
    for (var i = 0; i < var_args.length; i++) {
        if (Array.isArray(var_args[i]) ||
            (var_args[i] &&
                typeof var_args[i] === 'object' &&
                typeof var_args[i].length === 'number')) {
            message += buildLogMessage_.apply(null, var_args[i]);
        }
        else if (typeof var_args[i] === 'object') {
            message += util.stringify(var_args[i]);
        }
        else {
            message += var_args[i];
        }
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */
var logger = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */
var firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */
var enableLogging = function (logger_, persistent) {
    util.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        logClient.logLevel = logger$1.LogLevel.VERBOSE;
        logger = logClient.log.bind(logClient);
        if (persistent)
            SessionStorage.set('logging_enabled', true);
    }
    else if (typeof logger_ === 'function') {
        logger = logger_;
    }
    else {
        logger = null;
        SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} var_args
 */
var log = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (firstLog_ === true) {
        firstLog_ = false;
        if (logger === null && SessionStorage.get('logging_enabled') === true)
            enableLogging(true);
    }
    if (logger) {
        var message = buildLogMessage_.apply(null, var_args);
        logger(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */
var logWrapper = function (prefix) {
    return function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
};
/**
 * @param {...string} var_args
 */
var error = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
};
/**
 * @param {...string} var_args
 */
var fatal = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
    throw new Error(message);
};
/**
 * @param {...*} var_args
 */
var warn = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */
var warnIfPageIsSecure = function () {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' &&
        window.location &&
        window.location.protocol &&
        window.location.protocol.indexOf('https:') !== -1) {
        warn('Insecure Firebase access from a secure page. ' +
            'Please use https in calls to new Firebase().');
    }
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */
var isInvalidJSONNumber = function (data) {
    return (typeof data === 'number' &&
        (data != data || // NaN
            data == Number.POSITIVE_INFINITY ||
            data == Number.NEGATIVE_INFINITY));
};
/**
 * @param {function()} fn
 */
var executeWhenDOMReady = function (fn) {
    if (util.isNodeSdk() || document.readyState === 'complete') {
        fn();
    }
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function () {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
        }
        else if (document.attachEvent) {
            // IE.
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete')
                    wrappedFn_1();
            });
            // fallback to onload.
            window.attachEvent('onload', wrappedFn_1);
            // jQuery has an extra hack for IE that we could employ (based on
            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
            // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */
var MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */
var MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */
var nameCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === MIN_NAME || b === MAX_NAME) {
        return -1;
    }
    else if (b === MIN_NAME || a === MAX_NAME) {
        return 1;
    }
    else {
        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) {
                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
            }
            else {
                return -1;
            }
        }
        else if (bAsInt !== null) {
            return 1;
        }
        else {
            return a < b ? -1 : 1;
        }
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */
var stringCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 1;
    }
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */
var requireKey = function (key, obj) {
    if (obj && key in obj) {
        return obj[key];
    }
    else {
        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
    }
};
/**
 * @param {*} obj
 * @return {string}
 */
var ObjectToUniqueKey = function (obj) {
    if (typeof obj !== 'object' || obj === null)
        return util.stringify(obj);
    var keys = [];
    for (var k in obj) {
        keys.push(k);
    }
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for (var i = 0; i < keys.length; i++) {
        if (i !== 0)
            key += ',';
        key += util.stringify(keys[i]);
        key += ':';
        key += ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */
var splitStringBySize = function (str, segsize) {
    var len = str.length;
    if (len <= segsize) {
        return [str];
    }
    var dataSegs = [];
    for (var c = 0; c < len; c += segsize) {
        if (c + segsize > len) {
            dataSegs.push(str.substring(c, len));
        }
        else {
            dataSegs.push(str.substring(c, c + segsize));
        }
    }
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param {!(Object|Array)} obj The object or array to iterate over
 * @param {function(?, ?)} fn The function to apply
 */
var each = function (obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; ++i) {
            fn(i, obj[i]);
        }
    }
    else {
        /**
         * in the conversion of code we removed the goog.object.forEach
         * function which did a value,key callback. We standardized on
         * a single impl that does a key, value callback. So we invert
         * to not have to touch the `each` code points
         */
        util.forEach(obj, function (key, val) { return fn(val, key); });
    }
};
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */
var doubleToIEEE754String = function (v) {
    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    }
    else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        }
        else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    bits = [];
    for (i = fbits; i; i -= 1) {
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for (i = ebits; i; i -= 1) {
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for (i = 0; i < 64; i += 8) {
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1)
            hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */
var isChromeExtensionContentScript = function () {
    return !!(typeof window === 'object' &&
        window['chrome'] &&
        window['chrome']['extension'] &&
        !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */
var isWindowsStoreApp = function () {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */
var errorForServerCode = function (code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') {
        reason =
            'The data requested exceeds the maximum size ' +
                'that can be accessed with a single request.';
    }
    else if (code == 'permission_denied') {
        reason = "Client doesn't have permission to access the desired data.";
    }
    else if (code == 'unavailable') {
        reason = 'The service is unavailable';
    }
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */
var INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */
var tryParseInt = function (str) {
    if (INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) {
            return intVal;
        }
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */
var exceptionGuard = function (fn) {
    try {
        fn();
    }
    catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function () {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */
var beingCrawled = function () {
    var userAgent = (typeof window === 'object' &&
        window['navigator'] &&
        window['navigator']['userAgent']) ||
        '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */
var setTimeoutNonBlocking = function (fn, time) {
    var timeout = setTimeout(fn, time);
    if (typeof timeout === 'object' && timeout['unref']) {
        timeout['unref']();
    }
    return timeout;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */
var Path = /** @class */ (function () {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */
    function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for (var i = 0; i < this.pieces_.length; i++) {
                if (this.pieces_[i].length > 0) {
                    this.pieces_[copyTo] = this.pieces_[i];
                    copyTo++;
                }
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        }
        else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */
        get: function () {
            return new Path('');
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.getFront = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */
    Path.prototype.getLength = function () {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */
    Path.prototype.popFront = function () {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) {
            pieceNum++;
        }
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */
    Path.prototype.getBack = function () {
        if (this.pieceNum_ < this.pieces_.length)
            return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + this.pieces_[i];
        }
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
        }
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */
    Path.prototype.slice = function (begin) {
        if (begin === void 0) { begin = 0; }
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */
    Path.prototype.parent = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
            pieces.push(this.pieces_[i]);
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */
    Path.prototype.child = function (childPathObj) {
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
            pieces.push(this.pieces_[i]);
        if (childPathObj instanceof Path) {
            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
                pieces.push(childPathObj.pieces_[i]);
            }
        }
        else {
            var childPieces = childPathObj.split('/');
            for (var i = 0; i < childPieces.length; i++) {
                if (childPieces[i].length > 0)
                    pieces.push(childPieces[i]);
            }
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */
    Path.prototype.isEmpty = function () {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */
    Path.relativePath = function (outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) {
            return innerPath;
        }
        else if (outer === inner) {
            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        }
        else {
            throw new Error('INTERNAL ERROR: innerPath (' +
                innerPath +
                ') is not within ' +
                'outerPath (' +
                outerPath +
                ')');
        }
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */
    Path.comparePaths = function (left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0)
                return cmp;
        }
        if (leftKeys.length === rightKeys.length)
            return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */
    Path.prototype.equals = function (other) {
        if (this.getLength() !== other.getLength()) {
            return false;
        }
        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */
    Path.prototype.contains = function (other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) {
            return false;
        }
        while (i < this.pieces_.length) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}()); // end Path
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */
var ValidationPath = /** @class */ (function () {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */
    function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */
        this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */
        this.byteLength_ = Math.max(1, this.parts_.length);
        for (var i = 0; i < this.parts_.length; i++) {
            this.byteLength_ += util.stringLength(this.parts_[i]);
        }
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */
        get: function () {
            return 32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
        get: function () {
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    /** @param {string} child */
    ValidationPath.prototype.push = function (child) {
        // Count the needed '/'
        if (this.parts_.length > 0) {
            this.byteLength_ += 1;
        }
        this.parts_.push(child);
        this.byteLength_ += util.stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function () {
        var last = this.parts_.pop();
        this.byteLength_ -= util.stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) {
            this.byteLength_ -= 1;
        }
    };
    ValidationPath.prototype.checkValid_ = function () {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
            throw new Error(this.errorPrefix_ +
                'has a key path longer than ' +
                ValidationPath.MAX_PATH_LENGTH_BYTES +
                ' bytes (' +
                this.byteLength_ +
                ').');
        }
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
            throw new Error(this.errorPrefix_ +
                'path specified exceeds the maximum depth that can be written (' +
                ValidationPath.MAX_PATH_DEPTH +
                ') or object contains a cycle ' +
                this.toErrorString());
        }
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */
    ValidationPath.prototype.toErrorString = function () {
        if (this.parts_.length == 0) {
            return '';
        }
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PROTOCOL_VERSION = '5';
var VERSION_PARAM = 'v';
var TRANSPORT_SESSION_PARAM = 's';
var REFERER_PARAM = 'r';
var FORGE_REF = 'f';
var FORGE_DOMAIN = 'firebaseio.com';
var LAST_SESSION_PARAM = 'ls';
var WEBSOCKET = 'websocket';
var LONG_POLLING = 'long_polling';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */ (function () {
    /**
     * @param {string} host Hostname portion of the url for the repo
     * @param {boolean} secure Whether or not this repo is accessed over ssl
     * @param {string} namespace The namespace represented by the repo
     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param {string=} persistenceKey Override the default session persistence storage key
     */
    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
        if (persistenceKey === void 0) { persistenceKey = ''; }
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.persistenceKey = persistenceKey;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost = PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function () {
        return this.host !== this.internalHost || this.isCustomHost();
    };
    RepoInfo.prototype.isCacheableHost = function () {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function () {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function () {
        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
    };
    RepoInfo.prototype.updateHost = function (newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) {
                PersistentStorage.set('host:' + this.host, this.internalHost);
            }
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */
    RepoInfo.prototype.connectionURL = function (type, params) {
        util.assert(typeof type === 'string', 'typeof type must == string');
        util.assert(typeof params === 'object', 'typeof params must == object');
        var connURL;
        if (type === WEBSOCKET) {
            connURL =
                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        }
        else if (type === LONG_POLLING) {
            connURL =
                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        }
        else {
            throw new Error('Unknown connection type: ' + type);
        }
        if (this.needsQueryParam()) {
            params['ns'] = this.namespace;
        }
        var pairs = [];
        util.forEach(params, function (key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */
    RepoInfo.prototype.toString = function () {
        var str = this.toURLString();
        if (this.persistenceKey) {
            str += '<' + this.persistenceKey + '>';
        }
        return str;
    };
    /** @return {string} */
    RepoInfo.prototype.toURLString = function () {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!string} pathString
 * @return {string}
 */
function decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for (var i = 0; i < pieces.length; i++) {
        if (pieces[i].length > 0) {
            var piece = pieces[i];
            try {
                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
            }
            catch (e) { }
            pathStringDecoded += '/' + piece;
        }
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */
function decodeQuery(queryString) {
    var results = {};
    if (queryString.charAt(0) === '?') {
        queryString = queryString.substring(1);
    }
    for (var _i = 0, _a = queryString.split('&'); _i < _a.length; _i++) {
        var segment = _a[_i];
        if (segment.length === 0) {
            continue;
        }
        var kv = segment.split('=');
        if (kv.length === 2) {
            results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        }
        else {
            warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
        }
    }
    return results;
}
/**
 *
 * @param {!string} dataURL
 * @return {{repoInfo: !RepoInfo, path: !Path}}
 */
var parseRepoInfo = function (dataURL) {
    var parsedUrl = parseURL(dataURL), namespace = parsedUrl.subdomain;
    if (parsedUrl.domain === 'firebase') {
        fatal(parsedUrl.host +
            ' is no longer supported. ' +
            'Please use <YOUR FIREBASE>.firebaseio.com instead');
    }
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace == 'undefined') &&
        parsedUrl.domain !== 'localhost') {
        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    }
    if (!parsedUrl.secure) {
        warnIfPageIsSecure();
    }
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
        path: new Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
 */
var parseURL = function (dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '', domain = '', subdomain = '', pathString = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) {
            slashInd = dataURL.length;
        }
        var questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) {
            questionMarkInd = dataURL.length;
        }
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) {
            // For pathString, questionMarkInd will always come after slashInd
            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
        }
        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        }
        else {
            colonInd = dataURL.length;
        }
        var parts = host.split('.');
        if (parts.length === 3) {
            // Normalize namespaces to lowercase to share storage / connection.
            domain = parts[1];
            subdomain = parts[0].toLowerCase();
        }
        else if (parts.length === 2) {
            domain = parts[0];
        }
        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
            domain = 'localhost';
        }
        // Support `ns` query param if subdomain not already set
        if (subdomain === '' && 'ns' in queryParams) {
            subdomain = queryParams['ns'];
        }
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString
    };
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */
var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */
var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */
var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
/**
 * @param {*} key
 * @return {boolean}
 */
var isValidKey = function (key) {
    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidPathString = function (pathString) {
    return (typeof pathString === 'string' &&
        pathString.length !== 0 &&
        !INVALID_PATH_REGEX_.test(pathString));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidRootPathString = function (pathString) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    return isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */
var isValidPriority = function (priority) {
    return (priority === null ||
        typeof priority === 'string' ||
        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
        (priority && typeof priority === 'object' && util.contains(priority, '.sv')));
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */
var validateFirebaseData = function (errorPrefix, data, path_) {
    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) {
        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    }
    if (typeof data === 'function') {
        throw new Error(errorPrefix +
            'contains a function ' +
            path.toErrorString() +
            ' with contents = ' +
            data.toString());
    }
    if (isInvalidJSONNumber(data)) {
        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    }
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' &&
        data.length > MAX_LEAF_SIZE_ / 3 &&
        util.stringLength(data) > MAX_LEAF_SIZE_) {
        throw new Error(errorPrefix +
            'contains a string greater than ' +
            MAX_LEAF_SIZE_ +
            ' utf8 bytes ' +
            path.toErrorString() +
            " ('" +
            data.substring(0, 50) +
            "...')");
    }
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        var hasDotValue_1 = false, hasActualChild_1 = false;
        util.forEach(data, function (key, value) {
            if (key === '.value') {
                hasDotValue_1 = true;
            }
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!isValidKey(key)) {
                    throw new Error(errorPrefix +
                        ' contains an invalid key (' +
                        key +
                        ') ' +
                        path.toErrorString() +
                        '.  Keys must be non-empty strings ' +
                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
                }
            }
            path.push(key);
            validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) {
            throw new Error(errorPrefix +
                ' contains ".value" child ' +
                path.toErrorString() +
                ' in addition to actual children.');
        }
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */
var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
    var i, curPath;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!isValidKey(keys[j])) {
                throw new Error(errorPrefix +
                    'contains an invalid key (' +
                    keys[j] +
                    ') in path ' +
                    curPath.toString() +
                    '. Keys must be non-empty strings ' +
                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort(Path.comparePaths);
    var prevPath = null;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) {
            throw new Error(errorPrefix +
                'contains a path ' +
                prevPath.toString() +
                ' that is ancestor of another path ' +
                curPath.toString());
        }
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === 'object') || Array.isArray(data)) {
        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
    }
    var mergePaths = [];
    util.forEach(data, function (key, value) {
        var curPath = new Path(key);
        validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!isValidPriority(value)) {
                throw new Error(errorPrefix +
                    "contains an invalid value for '" +
                    curPath.toString() +
                    "', which must be a valid " +
                    'Firebase priority (a string, finite number, server value, or null).');
            }
        }
        mergePaths.push(curPath);
    });
    validateFirebaseMergePaths(errorPrefix, mergePaths);
};
var validatePriority = function (fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined)
        return;
    if (isInvalidJSONNumber(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'is ' +
            priority.toString() +
            ', but must be a valid Firebase priority (a string, finite number, ' +
            'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!isValidPriority(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid Firebase priority ' +
            '(a string, finite number, server value, or null).');
};
var validateEventType = function (fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined)
        return;
    switch (eventType) {
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
                'must be a valid event type = "value", "child_added", "child_removed", ' +
                '"child_changed", or "child_moved".');
    }
};
var validateKey = function (fnName, argumentNumber, key, optional) {
    if (optional && key === undefined)
        return;
    if (!isValidKey(key))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid key = "' +
            key +
            '".  Firebase keys must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var validatePathString = function (fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined)
        return;
    if (!isValidPathString(pathString))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid path = "' +
            pathString +
            '". Paths must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "[", or "]"');
};
var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    validatePathString(fnName, argumentNumber, pathString, optional);
};
var validateWritablePath = function (fnName, path) {
    if (path.getFront() === '.info') {
        throw new Error(fnName + " failed = Can't modify data under /.info/");
    }
};
var validateUrl = function (fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
        parsedUrl.repoInfo.host.length === 0 ||
        (!isValidKey(parsedUrl.repoInfo.namespace) &&
            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
            'must be a valid firebase URL and ' +
            'the path can\'t contain ".", "#", "$", "[", or "]".');
    }
};
var validateBoolean = function (fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined)
        return;
    if (typeof bool !== 'boolean')
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var OnDisconnect = /** @class */ (function () {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */
    function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.cancel = function (onComplete) {
        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.remove = function (onComplete) {
        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
        validateWritablePath('OnDisconnect.remove', this.path_);
        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.set = function (value, onComplete) {
        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.set', this.path_);
        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
        }
        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransactionResult = /** @class */ (function () {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */
    function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function () {
        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
    };
    return TransactionResult;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */
var nextPushId = (function () {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function (now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        util.assert(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        }
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
})();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */
var NamedNode = /** @class */ (function () {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */
    NamedNode.Wrap = function (name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @constructor
 */
var Index = /** @class */ (function () {
    function Index() {
    }
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */
    Index.prototype.getCompare = function () {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */
    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
        var newWrapped = new NamedNode(MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */
    Index.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    return Index;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __EMPTY_NODE;
var KeyIndex = /** @class */ (function (_super) {
    tslib_1.__extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function () {
            return __EMPTY_NODE;
        },
        set: function (val) {
            __EMPTY_NODE = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.compare = function (a, b) {
        return nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.isDefinedOn = function (node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.maxPost = function () {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new NamedNode(MAX_NAME, __EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    KeyIndex.prototype.makePost = function (indexValue, name) {
        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new NamedNode(indexValue, __EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    KeyIndex.prototype.toString = function () {
        return '.key';
    };
    return KeyIndex;
}(Index));
var KEY_INDEX = new KeyIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_NODE;
function setMaxNode(val) {
    MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */
var priorityHashText = function (priority) {
    if (typeof priority === 'number')
        return 'number:' + doubleToIEEE754String(priority);
    else
        return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */
var validatePriorityNode = function (priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        util.assert(typeof val === 'string' ||
            typeof val === 'number' ||
            (typeof val === 'object' && util.contains(val, '.sv')), 'Priority must be a string or number.');
    }
    else {
        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    }
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */
var LeafNode = /** @class */ (function () {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */
    function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function () {
            return __childrenNodeConstructor;
        },
        set: function (val) {
            __childrenNodeConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    LeafNode.prototype.isLeafNode = function () {
        return true;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPriority = function () {
        return this.priorityNode_;
    };
    /** @inheritDoc */
    LeafNode.prototype.updatePriority = function (newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */
    LeafNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.getChild = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else if (path.getFront() === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.hasChild = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
        return null;
    };
    /** @inheritDoc */
    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else if (newChildNode.isEmpty() && childName !== '.priority') {
            return this;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else if (newChildNode.isEmpty() && front !== '.priority') {
            return this;
        }
        else {
            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.isEmpty = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.numChildren = function () {
        return 0;
    };
    /** @inheritDoc */
    LeafNode.prototype.forEachChild = function (index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.val = function (exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty())
            return {
                '.value': this.getValue(),
                '.priority': this.getPriority().val()
            };
        else
            return this.getValue();
    };
    /** @inheritDoc */
    LeafNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty())
                toHash +=
                    'priority:' +
                        priorityHashText(this.priorityNode_.val()) +
                        ':';
            var type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') {
                toHash += doubleToIEEE754String(this.value_);
            }
            else {
                toHash += this.value_;
            }
            this.lazyHash_ = sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */
    LeafNode.prototype.getValue = function () {
        return this.value_;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.compareTo = function (other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
            return 1;
        }
        else if (other instanceof LeafNode.__childrenNodeConstructor) {
            return -1;
        }
        else {
            util.assert(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */
    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') {
                // Deferred value nodes are all equal, but we should also never get to this point...
                return 0;
            }
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) {
                    return -1;
                }
                else if (this.value_ === otherLeaf.value_) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
        }
        else {
            return thisIndex - otherIndex;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.withIndex = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.isIndexed = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.equals = function (other) {
        /**
         * @inheritDoc
         */
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return (this.value_ === otherLeaf.value_ &&
                this.priorityNode_.equals(otherLeaf.priorityNode_));
        }
        else {
            return false;
        }
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */
    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
    return LeafNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var nodeFromJSON;
var MAX_NODE$1;
function setNodeFromJSON(val) {
    nodeFromJSON = val;
}
function setMaxNode$1(val) {
    MAX_NODE$1 = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var PriorityIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.compare = function (a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.isDefinedOn = function (node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.maxPost = function () {
        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    PriorityIndex.prototype.makePost = function (indexValue, name) {
        var priorityNode = nodeFromJSON(indexValue);
        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    PriorityIndex.prototype.toString = function () {
        return '.priority';
    };
    return PriorityIndex;
}(Index));
var PRIORITY_INDEX = new PriorityIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An iterator over an LLRBNode.
 */
var SortedMapIterator = /** @class */ (function () {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */
    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */
        this.nodeStack_ = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            node = node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_)
            result = this.resultGenerator_(node.key, node.value);
        else
            result = { key: node.key, value: node.value };
        if (this.isReverse_) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) {
            return this.resultGenerator_(node.key, node.value);
        }
        else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}());
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */
var LLRBNode = /** @class */ (function () {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left =
            left != null ? left : SortedMap.EMPTY_NODE;
        this.right =
            right != null ? right : SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBNode.prototype.count = function () {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */
    LLRBNode.prototype.min_ = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min_();
        }
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.minKey = function () {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var cmp, n;
        n = this;
        cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */
    LLRBNode.prototype.removeMin_ = function () {
        if (this.left.isEmpty()) {
            return SortedMap.EMPTY_NODE;
        }
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_())
            n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */
    LLRBNode.prototype.remove = function (key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
                n = n.moveRedLeft_();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed_())
                n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
                n = n.moveRedRight_();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return SortedMap.EMPTY_NODE;
                }
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */
    LLRBNode.prototype.isRed_ = function () {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */
    LLRBNode.prototype.fixUp_ = function () {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_())
            n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_())
            n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_())
            n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */
    LLRBNode.prototype.moveRedLeft_ = function () {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */
    LLRBNode.prototype.moveRedRight_ = function () {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */
    LLRBNode.prototype.rotateLeft_ = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */
    LLRBNode.prototype.rotateRight_ = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */
    LLRBNode.prototype.colorFlip_ = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */
    LLRBNode.prototype.checkMaxDepth_ = function () {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBNode.prototype.check_ = function () {
        var blackDepth;
        if (this.isRed_() && this.left.isRed_()) {
            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed_()) {
            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) {
            throw new Error('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed_() ? 0 : 1);
        }
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}());
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
    }
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBEmptyNode.prototype.count = function () {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBEmptyNode.prototype.check_ = function () {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */
    LLRBEmptyNode.prototype.isRed_ = function () {
        return false;
    };
    return LLRBEmptyNode;
}());
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */
var SortedMap = /** @class */ (function () {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */
    function SortedMap(comparator_, root_) {
        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator_, this.root_
            .insert(key, value, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator_, this.root_
            .remove(key, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */
    SortedMap.prototype.get = function (key) {
        var cmp;
        var node = this.root_;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */
    SortedMap.prototype.getPredecessorKey = function (key) {
        var cmp, node = this.root_, rightParent = null;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty())
                        node = node.right;
                    return node.key;
                }
                else if (rightParent) {
                    return rightParent.key;
                }
                else {
                    return null; // first item.
                }
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */
    SortedMap.prototype.isEmpty = function () {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */
    SortedMap.prototype.count = function () {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */
    SortedMap.prototype.minKey = function () {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */
    SortedMap.prototype.maxKey = function () {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */
    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
    return SortedMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_2 = Math.log(2);
/**
 * @constructor
 */
var Base12Num = /** @class */ (function () {
    /**
     * @param {number} length
     */
    function Base12Num(length) {
        var logBase2 = function (num) {
            return parseInt((Math.log(num) / LOG_2), 10);
        };
        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = (length + 1) & mask;
    }
    /**
     * @return {boolean}
     */
    Base12Num.prototype.nextBitIsOne = function () {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & (0x1 << this.current_));
        this.current_--;
        return result;
    };
    return Base12Num;
}());
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */
var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function (low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length == 0) {
            return null;
        }
        else if (length == 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
        }
        else {
            var middle = parseInt((length / 2), 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function (base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function (chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function (pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            }
            else {
                root = pennant;
                node = pennant;
            }
        };
        for (var i = 0; i < base12.count; ++i) {
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) {
                buildPennant(chunkSize, LLRBNode.BLACK);
            }
            else {
                // current == 2
                buildPennant(chunkSize, LLRBNode.BLACK);
                buildPennant(chunkSize, LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    return new SortedMap(mapSortFn || cmp, root);
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _defaultIndexMap;
var fallbackObject = {};
/**
 *
 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
 * @param {Object.<string, Index>} indexSet
 * @constructor
 */
var IndexMap = /** @class */ (function () {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         * @type {!IndexMap}
         * @const
         */
        get: function () {
            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            _defaultIndexMap =
                _defaultIndexMap ||
                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
            return _defaultIndexMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param {!string} indexKey
     * @return {?SortedMap.<NamedNode, Node>}
     */
    IndexMap.prototype.get = function (indexKey) {
        var sortedMap = util.safeGet(this.indexes_, indexKey);
        if (!sortedMap)
            throw new Error('No index defined for ' + indexKey);
        if (sortedMap === fallbackObject) {
            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
            // regular child map
            return null;
        }
        else {
            return sortedMap;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {boolean}
     */
    IndexMap.prototype.hasIndex = function (indexDefinition) {
        return util.contains(this.indexSet_, indexDefinition.toString());
    };
    /**
     * @param {!Index} indexDefinition
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator(NamedNode.Wrap);
        var next = iter.getNext();
        while (next) {
            sawIndexedValue =
                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) {
            newIndex = buildChildSet(childList, indexDefinition.getCompare());
        }
        else {
            newIndex = fallbackObject;
        }
        var indexName = indexDefinition.toString();
        var newIndexSet = util.clone(this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = util.clone(this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
        var _this = this;
        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
            var index = util.safeGet(_this.indexSet_, indexName);
            util.assert(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator(NamedNode.Wrap);
                    var next = iter.getNext();
                    while (next) {
                        if (next.name != namedNode.name) {
                            childList.push(next);
                        }
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return buildChildSet(childList, index.getCompare());
                }
                else {
                    // No change, this remains a fallback
                    return fallbackObject;
                }
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) {
                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
            if (indexedChildren === fallbackObject) {
                // This is the fallback. Just return it, nothing to do in this case
                return indexedChildren;
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) {
                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                else {
                    // No record of this child
                    return indexedChildren;
                }
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NAME_ONLY_COMPARATOR(left, right) {
    return nameCompare(left.name, right.name);
}
function NAME_COMPARATOR(left, right) {
    return nameCompare(left, right);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: For memory savings, don't store priorityNode_ if it's empty.
var EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */
var ChildrenNode = /** @class */ (function () {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */
    function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */
        if (this.priorityNode_) {
            validatePriorityNode(this.priorityNode_);
        }
        if (this.children_.isEmpty()) {
            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
        }
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function () {
            return (EMPTY_NODE ||
                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    ChildrenNode.prototype.isLeafNode = function () {
        return false;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPriority = function () {
        return this.priorityNode_ || EMPTY_NODE;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
        if (this.children_.isEmpty()) {
            // Don't allow priorities on empty nodes
            return this;
        }
        else {
            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.getPriority();
        }
        else {
            var child = this.children_.get(childName);
            return child === null ? EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getChild = function (path) {
        var front = path.getFront();
        if (front === null)
            return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hasChild = function (childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        util.assert(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else {
            var namedNode = new NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            }
            else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else {
            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.isEmpty = function () {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.numChildren = function () {
        return this.children_.count();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.val = function (exportFormat) {
        if (this.isEmpty())
            return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
                maxKey = Math.max(maxKey, Number(key));
            }
            else {
                allIntegerKeys = false;
            }
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            for (var key in obj)
                array[key] = obj[key];
            return array;
        }
        else {
            if (exportFormat && !this.getPriority().isEmpty()) {
                obj['.priority'] = this.getPriority().val();
            }
            return obj;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty())
                toHash_1 +=
                    'priority:' +
                        priorityHashText(this.getPriority().val()) +
                        ':';
            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '')
                    toHash_1 += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        }
        else {
            return this.children_.getPredecessorKey(childName);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        }
        else {
            return this.children_.minKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) {
            return new NamedNode(minKey, this.children_.get(minKey));
        }
        else {
            return null;
        }
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        }
        else {
            return this.children_.maxKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) {
            return new NamedNode(maxKey, this.children_.get(maxKey));
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.forEachChild = function (index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            return idx.inorderTraversal(function (wrappedNode) {
                return action(wrappedNode.name, wrappedNode.node);
            });
        }
        else {
            return this.children_.inorderTraversal(action);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */
    ChildrenNode.prototype.getIterator = function (indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getIteratorFrom(startPost, function (key) { return key; });
        }
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, startPost) < 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getReverseIteratorFrom(endPost, function (key) {
                return key;
            });
        }
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, endPost) > 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.compareTo = function (other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) {
                return 0;
            }
            else {
                return -1;
            }
        }
        else if (other.isLeafNode() || other.isEmpty()) {
            return 1;
        }
        else if (other === MAX_NODE$2) {
            return -1;
        }
        else {
            // Must be another node with children.
            return 0;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.withIndex = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX ||
            this.indexMap_.hasIndex(indexDefinition)) {
            return this;
        }
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.isIndexed = function (index) {
        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.equals = function (other) {
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            return false;
        }
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
                return false;
            }
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator(PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while (thisCurrent && otherCurrent) {
                    if (thisCurrent.name !== otherCurrent.name ||
                        !thisCurrent.node.equals(otherCurrent.node)) {
                        return false;
                    }
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            }
            else {
                return false;
            }
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */
    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX) {
            return null;
        }
        else {
            return this.indexMap_.get(indexDefinition.toString());
        }
    };
    /**
     * @private
     * @type {RegExp}
     */
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}());
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */
var MaxNode = /** @class */ (function (_super) {
    tslib_1.__extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function (other) {
        if (other === this) {
            return 0;
        }
        else {
            return 1;
        }
    };
    MaxNode.prototype.equals = function (other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function () {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function (childName) {
        return ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function () {
        return false;
    };
    return MaxNode;
}(ChildrenNode));
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */
var MAX_NODE$2 = new MaxNode();
Object.defineProperties(NamedNode, {
    MIN: {
        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new NamedNode(MAX_NAME, MAX_NODE$2)
    }
});
/**
 * Reference Extensions
 */
KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
LeafNode.__childrenNodeConstructor = ChildrenNode;
setMaxNode(MAX_NODE$2);
setMaxNode$1(MAX_NODE$2);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */
function nodeFromJSON$1(json, priority) {
    if (priority === void 0) { priority = null; }
    if (json === null) {
        return ChildrenNode.EMPTY_NODE;
    }
    if (typeof json === 'object' && '.priority' in json) {
        priority = json['.priority'];
    }
    util.assert(priority === null ||
        typeof priority === 'string' ||
        typeof priority === 'number' ||
        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
        json = json['.value'];
    }
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
    }
    if (!(json instanceof Array) && USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj_1 = json;
        util.forEach(hinzeJsonObj_1, function (key, child) {
            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = nodeFromJSON$1(hinzeJsonObj_1[key]);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 =
                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length == 0) {
            return ChildrenNode.EMPTY_NODE;
        }
        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
        }
        else {
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
        }
    }
    else {
        var node_1 = ChildrenNode.EMPTY_NODE;
        var jsonObj_1 = json;
        util.forEach(jsonObj_1, function (key, childData) {
            if (util.contains(jsonObj_1, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = nodeFromJSON$1(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty())
                        node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority(nodeFromJSON$1(priority));
    }
}
setNodeFromJSON(nodeFromJSON$1);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var ValueIndex = /** @class */ (function (_super) {
    tslib_1.__extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.compare = function (a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.isDefinedOn = function (node) {
        return true;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.maxPost = function () {
        return NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    ValueIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        return new NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    ValueIndex.prototype.toString = function () {
        return '.value';
    };
    return ValueIndex;
}(Index));
var VALUE_INDEX = new ValueIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */
var PathIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */
    PathIndex.prototype.extractChild = function (snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.isDefinedOn = function (node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.compare = function (a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.maxPost = function () {
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
        return new NamedNode(MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.toString = function () {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}(Index));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */
var DataSnapshot = /** @class */ (function () {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */
    function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.val = function () {
        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.exportVal = function () {
        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function () {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */
    DataSnapshot.prototype.exists = function () {
        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */
    DataSnapshot.prototype.child = function (childPathString) {
        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        validatePathString('DataSnapshot.child', 1, childPathString, false);
        var childPath = new Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */
    DataSnapshot.prototype.hasChild = function (childPathString) {
        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */
    DataSnapshot.prototype.getPriority = function () {
        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */
    DataSnapshot.prototype.forEach = function (action) {
        var _this = this;
        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
        util.validateCallback('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode())
            return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function (key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */
    DataSnapshot.prototype.hasChildren = function () {
        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode())
            return false;
        else
            return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function () {
            return this.ref_.getKey();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */
    DataSnapshot.prototype.numChildren = function () {
        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */
    DataSnapshot.prototype.getRef = function () {
        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return DataSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */
    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getPath = function () {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') {
            return ref.path;
        }
        else {
            return ref.getParent().path;
        }
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventType = function () {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.toString = function () {
        return (this.getPath().toString() +
            ':' +
            this.eventType +
            ':' +
            util.stringify(this.snapshot.exportVal()));
    };
    return DataEvent;
}());
var CancelEvent = /** @class */ (function () {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getPath = function () {
        return this.path;
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventType = function () {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.toString = function () {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents registration for 'value' events.
 */
var ValueEventRegistration = /** @class */ (function () {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */
    function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.respondsTo = function (eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createEvent = function (change, query) {
        var index = query.getQueryParams().getIndex();
        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        }
        else {
            var cb_1 = this.callback_;
            return function () {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.matches = function (other) {
        if (!(other instanceof ValueEventRegistration)) {
            return false;
        }
        else if (!other.callback_ || !this.callback_) {
            // If no callback specified, we consider it to match any callback.
            return true;
        }
        else {
            return (other.callback_ === this.callback_ && other.context_ === this.context_);
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.hasAnyCallback = function () {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}());
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */
var ChildEventRegistration = /** @class */ (function () {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */
    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.respondsTo = function (eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck =
            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return util.contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createEvent = function (change, query) {
        util.assert(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child(/** @type {!string} */ (change.childName));
        var index = query.getQueryParams().getIndex();
        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        }
        else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function () {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.matches = function (other) {
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) {
                return true;
            }
            else if (this.context_ === other.context_) {
                var otherCount = util.getCount(other.callbacks_);
                var thisCount = util.getCount(this.callbacks_);
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    //  If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey /** @type {!string} */ = util.getAnyKey(other.callbacks_);
                        var thisKey /** @type {!string} */ = util.getAnyKey(this.callbacks_);
                        return (thisKey === otherKey &&
                            (!other.callbacks_[otherKey] ||
                                !this.callbacks_[thisKey] ||
                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
                    }
                    else {
                        // Exact match on each key.
                        return util.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
                    }
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.hasAnyCallback = function () {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */
var Query = /** @class */ (function () {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function (val) {
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */
    Query.validateQueryEndpoints_ = function (params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) {
            startNode = params.getIndexStartValue();
        }
        if (params.hasEnd()) {
            endNode = params.getIndexEndValue();
        }
        if (params.getIndex() === KEY_INDEX) {
            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
                'startAt(), endAt(), or equalTo().';
            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
                'or equalTo() must be a string.';
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName != MIN_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof startNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName != MAX_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof endNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
        }
        else if (params.getIndex() === PRIORITY_INDEX) {
            if ((startNode != null && !isValidPriority(startNode)) ||
                (endNode != null && !isValidPriority(endNode))) {
                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
            }
        }
        else {
            util.assert(params.getIndex() instanceof PathIndex ||
                params.getIndex() === VALUE_INDEX, 'unknown index type.');
            if ((startNode != null && typeof startNode === 'object') ||
                (endNode != null && typeof endNode === 'object')) {
                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
                    'an object.');
            }
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */
    Query.validateLimit_ = function (params) {
        if (params.hasStart() &&
            params.hasEnd() &&
            params.hasLimit() &&
            !params.hasAnchoredLimit()) {
            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */
    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
        if (this.orderByCalled_ === true) {
            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
        }
    };
    /**
     * @return {!QueryParams}
     */
    Query.prototype.getQueryParams = function () {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */
    Query.prototype.getRef = function () {
        util.validateArgCount('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */
    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
        util.validateArgCount('Query.on', 2, 4, arguments.length);
        validateEventType('Query.on', 1, eventType, false);
        util.validateCallback('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') {
            this.onValueEvent(callback, ret.cancel, ret.context);
        }
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */
    Query.prototype.off = function (eventType, callback, context) {
        util.validateArgCount('Query.off', 0, 3, arguments.length);
        validateEventType('Query.off', 1, eventType, true);
        util.validateCallback('Query.off', 2, callback, true);
        util.validateContextObject('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new ValueEventRegistration(valueCallback, null, context || null);
        }
        else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param failureCallbackOrContext
     * @param context
     * @return {!firebase.Promise}
     */
    Query.prototype.once = function (eventType, userCallback, failureCallbackOrContext, context) {
        var _this = this;
        util.validateArgCount('Query.once', 1, 4, arguments.length);
        validateEventType('Query.once', 1, eventType, false);
        util.validateCallback('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new util.Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function () { });
        var onceCallback = function (snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) {
                    userCallback.bind(ret.context)(snapshot);
                }
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, 
        /*cancel=*/ function (err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel)
                ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToFirst = function (limit) {
        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToLast = function (limit) {
        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToLast: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */
    Query.prototype.orderByChild = function (path) {
        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') {
            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        }
        else if (path === '$priority') {
            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        }
        else if (path === '$value') {
            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        }
        validatePathString('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new Path(path);
        if (parsedPath.isEmpty()) {
            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        }
        var index = new PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */
    Query.prototype.orderByKey = function () {
        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy(KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */
    Query.prototype.orderByPriority = function () {
        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */
    Query.prototype.orderByValue = function () {
        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.startAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
        validateKey('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
                'or equalTo).');
        }
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.endAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
        validateKey('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */
    Query.prototype.equalTo = function (value, name) {
        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
        validateKey('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
                'equalTo).');
        }
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */
    Query.prototype.toString = function () {
        util.validateArgCount('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function () {
        // An optional spacer argument is unnecessary for a string.
        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */
    Query.prototype.queryObject = function () {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */
    Query.prototype.queryIdentifier = function () {
        var obj = this.queryObject();
        var id = ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */
    Query.prototype.isEqual = function (other) {
        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */
    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
        var ret = { cancel: null, context: null };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            util.validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            util.validateContextObject(fnName, 4, ret.context, true);
        }
        else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
                // it's a context!
                ret.context = cancelOrContext;
            }
            else if (typeof cancelOrContext === 'function') {
                ret.cancel = cancelOrContext;
            }
            else {
                throw new Error(util.errorPrefix(fnName, 3, true) +
                    ' must either be a cancel callback or a context object.');
            }
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements a set with a count of elements.
 *
 * @template K, V
 */
var CountedSet = /** @class */ (function () {
    function CountedSet() {
        this.set = {};
    }
    /**
     * @param {!K} item
     * @param {V} val
     */
    CountedSet.prototype.add = function (item, val) {
        this.set[item] = val !== null ? val : true;
    };
    /**
     * @param {!K} key
     * @return {boolean}
     */
    CountedSet.prototype.contains = function (key) {
        return util.contains(this.set, key);
    };
    /**
     * @param {!K} item
     * @return {V}
     */
    CountedSet.prototype.get = function (item) {
        return this.contains(item) ? this.set[item] : undefined;
    };
    /**
     * @param {!K} item
     */
    CountedSet.prototype.remove = function (item) {
        delete this.set[item];
    };
    /**
     * Deletes everything in the set
     */
    CountedSet.prototype.clear = function () {
        this.set = {};
    };
    /**
     * True if there's nothing in the set
     * @return {boolean}
     */
    CountedSet.prototype.isEmpty = function () {
        return util.isEmpty(this.set);
    };
    /**
     * @return {number} The number of items in the set
     */
    CountedSet.prototype.count = function () {
        return util.getCount(this.set);
    };
    /**
     * Run a function on each k,v pair in the set
     * @param {function(K, V)} fn
     */
    CountedSet.prototype.each = function (fn) {
        util.forEach(this.set, function (k, v) { return fn(k, v); });
    };
    /**
     * Mostly for debugging
     * @return {Array.<K>} The keys present in this CountedSet
     */
    CountedSet.prototype.keys = function () {
        var keys = [];
        util.forEach(this.set, function (k) {
            keys.push(k);
        });
        return keys;
    };
    return CountedSet;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper class to store a sparse set of snapshots.
 *
 * @constructor
 */
var SparseSnapshotTree = /** @class */ (function () {
    function SparseSnapshotTree() {
        /**
         * @private
         * @type {Node}
         */
        this.value_ = null;
        /**
         * @private
         * @type {CountedSet}
         */
        this.children_ = null;
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {?Node} The retrieved node, or null.
     */
    SparseSnapshotTree.prototype.find = function (path) {
        if (this.value_ != null) {
            return this.value_.getChild(path);
        }
        else if (!path.isEmpty() && this.children_ != null) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children_.contains(childKey)) {
                var childTree = this.children_.get(childKey);
                return childTree.find(path);
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @param {!Node} data The new data, or null.
     */
    SparseSnapshotTree.prototype.remember = function (path, data) {
        if (path.isEmpty()) {
            this.value_ = data;
            this.children_ = null;
        }
        else if (this.value_ !== null) {
            this.value_ = this.value_.updateChild(path, data);
        }
        else {
            if (this.children_ == null) {
                this.children_ = new CountedSet();
            }
            var childKey = path.getFront();
            if (!this.children_.contains(childKey)) {
                this.children_.add(childKey, new SparseSnapshotTree());
            }
            var child = this.children_.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {boolean} True if this node should now be removed.
     */
    SparseSnapshotTree.prototype.forget = function (path) {
        if (path.isEmpty()) {
            this.value_ = null;
            this.children_ = null;
            return true;
        }
        else {
            if (this.value_ !== null) {
                if (this.value_.isLeafNode()) {
                    // We're trying to forget a node that doesn't exist
                    return false;
                }
                else {
                    var value = this.value_;
                    this.value_ = null;
                    var self_1 = this;
                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
                        self_1.remember(new Path(key), tree);
                    });
                    return this.forget(path);
                }
            }
            else if (this.children_ !== null) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children_.contains(childKey)) {
                    var safeToRemove = this.children_.get(childKey).forget(path);
                    if (safeToRemove) {
                        this.children_.remove(childKey);
                    }
                }
                if (this.children_.isEmpty()) {
                    this.children_ = null;
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param {!Path} prefixPath Path to look up node for.
     * @param {!Function} func The function to invoke for each tree.
     */
    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
        if (this.value_ !== null) {
            func(prefixPath, this.value_);
        }
        else {
            this.forEachChild(function (key, tree) {
                var path = new Path(prefixPath.toString() + '/' + key);
                tree.forEachTree(path, func);
            });
        }
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param {!Function} func The function to invoke for each child.
     */
    SparseSnapshotTree.prototype.forEachChild = function (func) {
        if (this.children_ !== null) {
            this.children_.each(function (key, tree) {
                func(key, tree);
            });
        }
    };
    return SparseSnapshotTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */
var generateWithValues = function (values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */
var resolveDeferredValue = function (value, serverValues) {
    if (!value || typeof value !== 'object') {
        return value;
    }
    else {
        util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
        return serverValues[value['.sv']];
    }
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!SparseSnapshotTree} tree
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */
var resolveDeferredValueTree = function (tree, serverValues) {
    var resolvedTree = new SparseSnapshotTree();
    tree.forEachTree(new Path(''), function (path, node) {
        resolvedTree.remember(path, resolveDeferredValueSnapshot(node, serverValues));
    });
    return resolvedTree;
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */
var resolveDeferredValueSnapshot = function (node, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = resolveDeferredValue(rawPri, serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = resolveDeferredValue(leafNode.getValue(), serverValues);
        if (value !== leafNode.getValue() ||
            priority !== leafNode.getPriority().val()) {
            return new LeafNode(value, nodeFromJSON$1(priority));
        }
        else {
            return node;
        }
    }
    else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) {
            newNode = newNode.updatePriority(new LeafNode(priority));
        }
        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
            var newChildNode = resolveDeferredValueSnapshot(childNode, serverValues);
            if (newChildNode !== childNode) {
                newNode = newNode.updateImmediateChild(childName, newChildNode);
            }
        });
        return newNode;
    }
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @enum
 */
var OperationType;
(function (OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType || (OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */
var OperationSource = /** @class */ (function () {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
    }
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.User = new OperationSource(
    /*fromUser=*/ true, false, null, 
    /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.Server = new OperationSource(false, 
    /*fromServer=*/ true, null, 
    /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */
    OperationSource.forServerTaggedQuery = function (queryId) {
        return new OperationSource(false, 
        /*fromServer=*/ true, queryId, 
        /*tagged=*/ true);
    };
    return OperationSource;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AckUserWrite = /** @class */ (function () {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */
    function AckUserWrite(
    /**@inheritDoc */ path, 
    /**@inheritDoc */ affectedTree, 
    /**@inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */
        this.type = OperationType.ACK_USER_WRITE;
        /** @inheritDoc */
        this.source = OperationSource.User;
    }
    /**
     * @inheritDoc
     */
    AckUserWrite.prototype.operationForChild = function (childName) {
        if (!this.path.isEmpty()) {
            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        }
        else if (this.affectedTree.value != null) {
            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        }
        else {
            var childTree = this.affectedTree.subtree(new Path(childName));
            return new AckUserWrite(Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */
var EmptyChildren = function () {
    if (!emptyChildrenSingleton) {
        emptyChildrenSingleton = new SortedMap(stringCompare);
    }
    return emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */
var ImmutableTree = /** @class */ (function () {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */
    function ImmutableTree(value, children) {
        if (children === void 0) { children = EmptyChildren(); }
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */
    ImmutableTree.fromObject = function (obj) {
        var tree = ImmutableTree.Empty;
        util.forEach(obj, function (childPath, childSnap) {
            tree = tree.set(new Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */
    ImmutableTree.prototype.isEmpty = function () {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */
    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
        if (this.value != null && predicate(this.value)) {
            return { path: Path.Empty, value: this.value };
        }
        else {
            if (relativePath.isEmpty()) {
                return null;
            }
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
                        return { path: fullPath, value: childExistingPathAndValue.value };
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */
    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */
    ImmutableTree.prototype.subtree = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this;
        }
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) {
                return childTree.subtree(relativePath.popFront());
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.set = function (relativePath, toSet) {
        if (relativePath.isEmpty()) {
            return new ImmutableTree(toSet, this.children);
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.remove = function (relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) {
                return ImmutableTree.Empty;
            }
            else {
                return new ImmutableTree(null, this.children);
            }
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) {
                    newChildren = this.children.remove(front);
                }
                else {
                    newChildren = this.children.insert(front, newChild);
                }
                if (this.value === null && newChildren.isEmpty()) {
                    return ImmutableTree.Empty;
                }
                else {
                    return new ImmutableTree(this.value, newChildren);
                }
            }
            else {
                return this;
            }
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */
    ImmutableTree.prototype.get = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this.value;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                return child.get(relativePath.popFront());
            }
            else {
                return null;
            }
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */
    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
        if (relativePath.isEmpty()) {
            return newTree;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) {
                newChildren = this.children.remove(front);
            }
            else {
                newChildren = this.children.insert(front, newChild);
            }
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */
    ImmutableTree.prototype.fold = function (fn) {
        return this.fold_(Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */
    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function (childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */
    ImmutableTree.prototype.findOnPath = function (path, f) {
        return this.findOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) {
            return result;
        }
        else {
            if (pathToFollow.isEmpty()) {
                return null;
            }
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) {
                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */
    ImmutableTree.prototype.foreachOnPath = function (path, f) {
        return this.foreachOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) {
            return this;
        }
        else {
            if (this.value) {
                f(currentRelativePath, this.value);
            }
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) {
                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */
    ImmutableTree.prototype.foreach = function (f) {
        this.foreach_(Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
        this.children.inorderTraversal(function (childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) {
            f(currentRelativePath, this.value);
        }
    };
    /**
     *
     * @param {function(string, !T)} f
     */
    ImmutableTree.prototype.foreachChild = function (f) {
        this.children.inorderTraversal(function (childName, childTree) {
            if (childTree.value) {
                f(childName, childTree.value);
            }
        });
    };
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
var ListenComplete = /** @class */ (function () {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */
        this.type = OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new ListenComplete(this.source, Path.Empty);
        }
        else {
            return new ListenComplete(this.source, this.path.popFront());
        }
    };
    return ListenComplete;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
var Overwrite = /** @class */ (function () {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */
        this.type = OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
        }
        else {
            return new Overwrite(this.source, this.path.popFront(), this.snap);
        }
    };
    return Overwrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
    function Merge(
    /**@inheritDoc */ source, 
    /**@inheritDoc */ path, 
    /**@inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */
        this.type = OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */
    Merge.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new Path(childName));
            if (childTree.isEmpty()) {
                // This child is unaffected
                return null;
            }
            else if (childTree.value) {
                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
                return new Overwrite(this.source, Path.Empty, childTree.value);
            }
            else {
                // This is a merge at a deeper level
                return new Merge(this.source, Path.Empty, childTree);
            }
        }
        else {
            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */
    Merge.prototype.toString = function () {
        return ('Operation(' +
            this.path +
            ': ' +
            this.source.toString() +
            ' merge: ' +
            this.children.toString() +
            ')');
    };
    return Merge;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */
var CacheNode = /** @class */ (function () {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */
    function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */
    CacheNode.prototype.isFullyInitialized = function () {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */
    CacheNode.prototype.isFiltered = function () {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForPath = function (path) {
        if (path.isEmpty()) {
            return this.isFullyInitialized() && !this.filtered_;
        }
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForChild = function (key) {
        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
    };
    /**
     * @return {!Node}
     */
    CacheNode.prototype.getNode = function () {
        return this.node_;
    };
    return CacheNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */
var ViewCache = /** @class */ (function () {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */
    function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getEventCache = function () {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteEventSnap = function () {
        return this.eventCache_.isFullyInitialized()
            ? this.eventCache_.getNode()
            : null;
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getServerCache = function () {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteServerSnap = function () {
        return this.serverCache_.isFullyInitialized()
            ? this.serverCache_.getNode()
            : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */
    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false));
    return ViewCache;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */
var Change = /** @class */ (function () {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.valueChange = function (snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childAddedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childRemovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */
    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childMovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */
    Change.CHILD_ADDED = 'child_added';
    /** Event type for a child removed */
    Change.CHILD_REMOVED = 'child_removed';
    /** Event type for a child changed */
    Change.CHILD_CHANGED = 'child_changed';
    /** Event type for a child moved */
    Change.CHILD_MOVED = 'child_moved';
    /** Event type for a value change */
    Change.VALUE = 'value';
    return Change;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */
var IndexedFilter = /** @class */ (function () {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() == newChild.isEmpty()) {
                // Nothing changed.
                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
                return snap;
            }
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) {
                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
                }
                else {
                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
                }
            }
            else if (oldChild.isEmpty()) {
                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
            }
            else {
                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
            }
        }
        if (snap.isLeafNode() && newChild.isEmpty()) {
            return snap;
        }
        else {
            // Make sure the node is indexed
            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) {
                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (!newSnap.hasChild(key)) {
                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
                    }
                });
            }
            if (!newSnap.isLeafNode()) {
                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (oldSnap.hasChild(key)) {
                        var oldChild = oldSnap.getImmediateChild(key);
                        if (!oldChild.equals(childNode)) {
                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
                        }
                    }
                    else {
                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
                    }
                });
            }
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        if (oldSnap.isEmpty()) {
            return ChildrenNode.EMPTY_NODE;
        }
        else {
            return oldSnap.updatePriority(newPriority);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.filtersNodes = function () {
        return false;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndexedFilter = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    return IndexedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var ChildChangeAccumulator = /** @class */ (function () {
    function ChildChangeAccumulator() {
        this.changeMap_ = {};
    }
    /**
     * @param {!Change} change
     */
    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
        var type = change.type;
        var childKey /** @type {!string} */ = change.childName;
        util.assert(type == Change.CHILD_ADDED ||
            type == Change.CHILD_CHANGED ||
            type == Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = util.safeGet(this.changeMap_, childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type == Change.CHILD_ADDED && oldType == Change.CHILD_REMOVED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_ADDED) {
                delete this.changeMap_[childKey];
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childRemovedChange(childKey, oldChange.oldSnap);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_ADDED) {
                this.changeMap_[childKey] = Change.childAddedChange(childKey, change.snapshotNode);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
            }
            else {
                throw util.assertionError('Illegal combination of changes: ' +
                    change +
                    ' occurred after ' +
                    oldChange);
            }
        }
        else {
            this.changeMap_[childKey] = change;
        }
    };
    /**
     * @return {!Array.<!Change>}
     */
    ChildChangeAccumulator.prototype.getChanges = function () {
        return util.getValues(this.changeMap_);
    };
    return ChildChangeAccumulator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */ (function () {
    function NoCompleteChildSource_() {
    }
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}());
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) {
            return node.getNode().getImmediateChild(childKey);
        }
        else {
            var serverNode = this.optCompleteServerCache_ != null
                ? new CacheNode(this.optCompleteServerCache_, true, false)
                : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null
            ? this.optCompleteServerCache_
            : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) {
            return null;
        }
        else {
            return nodes[0];
        }
    };
    return WriteTreeCompleteChildSource;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */ (function () {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */
    function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}());
/**
 * @constructor
 */
var ViewProcessor = /** @class */ (function () {
    /**
     * @param {!NodeFilter} filter_
     */
    function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */
    ViewProcessor.prototype.assertIndexed = function (viewCache) {
        util.assert(viewCache
            .getEventCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        util.assert(viewCache
            .getServerCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */
    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) {
                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode =
                    overwrite.source.tagged ||
                        (oldViewCache.getServerCache().isFiltered() &&
                            !overwrite.path.isEmpty());
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) {
                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode =
                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) {
                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            }
            else {
                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
            }
        }
        else if (operation.type === OperationType.LISTEN_COMPLETE) {
            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        }
        else {
            throw util.assertionError('Unknown operation type: ' + operation.type);
        }
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */
    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 ||
                !oldViewCache.getEventCache().isFullyInitialized() ||
                (isLeafOrEmpty &&
                    !eventSnap
                        .getNode()
                        .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
                !eventSnap
                    .getNode()
                    .getPriority()
                    .equals(oldCompleteSnap.getPriority())) {
                accumulator.push(Change.valueChange(
                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
            }
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) {
            // we have a shadowing write, ignore changes
            return viewCache;
        }
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof ChildrenNode
                        ? serverCache
                        : ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                }
                else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            }
            else {
                var childKey = changePath.getFront();
                if (childKey == '.priority') {
                    util.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) {
                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    }
                    else {
                        // priority didn't change, keep old node
                        newEventCache = oldEventSnap.getNode();
                    }
                }
                else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) {
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey)
                                .updateChild(childChangePath, eventChildUpdate);
                        }
                        else {
                            // Nothing changed, just keep the old child
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey);
                        }
                    }
                    else {
                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    }
                    if (newEventChild != null) {
                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    }
                    else {
                        // no complete child available or no change
                        newEventCache = oldEventSnap.getNode();
                    }
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode
            ? this.filter_
            : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) {
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        }
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap
                .getNode()
                .updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        }
        else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) &&
                changePath.getLength() > 1) {
                // We don't update incomplete nodes with updates intended for other listeners
                return oldViewCache;
            }
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey == '.priority') {
                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            }
            else {
                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
            }
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        }
        else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            }
            else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) {
                    // Child overwrite, we can replace the child
                    newChild = changedSnap;
                }
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' &&
                            childNode.getChild(childChangePath.parent()).isEmpty()) {
                            // This is a priority update on an empty node. If this node exists on the server, the
                            // server will send down the priority in the update, so ignore for now
                            newChild = childNode;
                        }
                        else {
                            newChild = childNode.updateChild(childChangePath, changedSnap);
                        }
                    }
                    else {
                        // There is no complete child node available
                        newChild = ChildrenNode.EMPTY_NODE;
                    }
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                }
                else {
                    newViewCache = oldViewCache;
                }
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */
    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */
    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
        merge.foreach(function (relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache
            .getServerCache()
            .getNode()
            .isEmpty() &&
            !viewCache.getServerCache().isFullyInitialized()) {
            return viewCache;
        }
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) {
            viewMergeTree = changedChildren;
        }
        else {
            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
        }
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
                childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) {
            return viewCache;
        }
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
                serverCache.isCompleteForPath(ackPath)) {
                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            }
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = ImmutableTree.Empty;
                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            }
            else {
                return viewCache;
            }
        }
        else {
            // This is a merge.
            var changedChildren_2 = ImmutableTree.Empty;
            affectedTree.foreach(function (mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) {
                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
                }
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) {
            return viewCache;
        }
        else {
            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) {
                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                }
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode = newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            }
            else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null &&
                    viewCache.getServerCache().isCompleteForChild(childKey)) {
                    newChild = oldEventCache.getImmediateChild(childKey);
                }
                if (newChild != null) {
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                }
                else if (viewCache
                    .getEventCache()
                    .getNode()
                    .hasChild(childKey)) {
                    // No complete child available, delete the existing one, if any
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                }
                else {
                    newEventCache = oldEventCache;
                }
                if (newEventCache.isEmpty() &&
                    viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) {
                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                    }
                }
            }
            complete =
                viewCache.getServerCache().isFullyInitialized() ||
                    writesCache.shadowingWrite(Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     */
    function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */
        this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */
    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function (change) {
            if (change.type === Change.CHILD_CHANGED &&
                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
            }
        });
        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */
    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function (change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function (registration) {
                if (registration.respondsTo(change.type)) {
                    events.push(registration.createEvent(materializedChange, _this.query_));
                }
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */
    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') {
            return change;
        }
        else {
            change.prevName = eventCache.getPredecessorChildName(
            /** @type {!string} */
            change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */
    EventGenerator.prototype.compareChanges_ = function (a, b) {
        if (a.childName == null || b.childName == null) {
            throw util.assertionError('Should only compare child_ events.');
        }
        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */
var View = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */
        this.processor_ = new ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */
        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */
        this.eventGenerator_ = new EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */
    View.prototype.getQuery = function () {
        return this.query_;
    };
    /**
     * @return {?Node}
     */
    View.prototype.getServerCache = function () {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */
    View.prototype.getCompleteServerCache = function (path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() ||
                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
                return cache.getChild(path);
            }
        }
        return null;
    };
    /**
     * @return {boolean}
     */
    View.prototype.isEmpty = function () {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */
    View.prototype.addEventRegistration = function (eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function (registration) {
                cancelError /** @type {!Error} */ = cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) {
                    cancelEvents.push(maybeEvent);
                }
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) {
                    remaining.push(existing);
                }
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        }
        else {
            this.eventRegistrations_ = [];
        }
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */
    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
        if (operation.type === OperationType.MERGE &&
            operation.source.queryId !== null) {
            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */
    View.prototype.getInitialEvents = function (registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                initialChanges.push(Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) {
            initialChanges.push(Change.valueChange(eventSnap.getNode()));
        }
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */
    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
        var registrations = eventRegistration
            ? [eventRegistration]
            : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */
var SyncPoint = /** @class */ (function () {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         *
         * @type {!Object.<!string, !View>}
         * @private
         */
        this.views_ = {};
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
            return __referenceConstructor$1;
        },
        set: function (val) {
            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
            __referenceConstructor$1 = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.isEmpty = function () {
        return util.isEmpty(this.views_);
    };
    /**
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} optCompleteServerCache
     * @return {!Array.<!Event>}
     */
    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = util.safeGet(this.views_, queryId);
            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        }
        else {
            var events_1 = [];
            util.forEach(this.views_, function (key, view) {
                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
            });
            return events_1;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = util.safeGet(this.views_, queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) {
                eventCacheComplete = true;
            }
            else if (serverCache instanceof ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            }
            else {
                eventCache = ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new ViewCache(new CacheNode(
            /** @type {!Node} */ (eventCache), eventCacheComplete, false), new CacheNode(
            /** @type {!Node} */ (serverCache), serverCacheComplete, false));
            view = new View(query, viewCache);
            this.views_[queryId] = view;
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */
    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') {
            // When you do ref.off(...), we search all views for the registration to remove.
            var self_1 = this;
            util.forEach(this.views_, function (viewQueryId, view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete self_1.views_[viewQueryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            });
        }
        else {
            // remove the callback from the specific view.
            var view = util.safeGet(this.views_, queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete this.views_[queryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) {
            // We removed our last complete view.
            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        }
        return { removed: removed, events: cancelEvents };
    };
    /**
     * @return {!Array.<!View>}
     */
    SyncPoint.prototype.getQueryViews = function () {
        var _this = this;
        var values = Object.keys(this.views_).map(function (key) { return _this.views_[key]; });
        return values.filter(function (view) {
            return !view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
    };
    /**
     *
     * @param {!Path} path The path to the desired complete snapshot
     * @return {?Node} A complete cache, if it exists
     */
    SyncPoint.prototype.getCompleteServerCache = function (path) {
        var serverCache = null;
        util.forEach(this.views_, function (key, view) {
            serverCache = serverCache || view.getCompleteServerCache(path);
        });
        return serverCache;
    };
    /**
     * @param {!Query} query
     * @return {?View}
     */
    SyncPoint.prototype.viewForQuery = function (query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) {
            return this.getCompleteView();
        }
        else {
            var queryId = query.queryIdentifier();
            return util.safeGet(this.views_, queryId);
        }
    };
    /**
     * @param {!Query} query
     * @return {boolean}
     */
    SyncPoint.prototype.viewExistsForQuery = function (query) {
        return this.viewForQuery(query) != null;
    };
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.hasCompleteView = function () {
        return this.getCompleteView() != null;
    };
    /**
     * @return {?View}
     */
    SyncPoint.prototype.getCompleteView = function () {
        var completeView = util.findValue(this.views_, function (view) {
            return view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
        return completeView || null;
    };
    return SyncPoint;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 *
 * @constructor
 * @param {!ImmutableTree.<!Node>} writeTree
 */
var CompoundWrite = /** @class */ (function () {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    /**
     * @param {!Path} path
     * @param {!Node} node
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrite = function (path, node) {
        if (path.isEmpty()) {
            return new CompoundWrite(new ImmutableTree(node));
        }
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            }
            else {
                var subtree = new ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    /**
     * @param {!Path} path
     * @param {!Object.<string, !Node>} updates
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrites = function (path, updates) {
        var newWrite = this;
        util.forEach(updates, function (childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param {!Path} path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */
    CompoundWrite.prototype.removeWrite = function (path) {
        if (path.isEmpty()) {
            return CompoundWrite.Empty;
        }
        else {
            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param {!Path} path The path to check for
     * @return {boolean} Whether there is a complete write at that path
     */
    CompoundWrite.prototype.hasCompleteWrite = function (path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param {!Path} path The path to get a complete write
     * @return {?Node} The node if complete at that path, or null otherwise.
     */
    CompoundWrite.prototype.getCompleteNode = function (path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            return this.writeTree_
                .get(rootmost.path)
                .getChild(Path.relativePath(rootmost.path, path));
        }
        else {
            return null;
        }
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return {!Array.<NamedNode>} A list of all complete children.
     */
    CompoundWrite.prototype.getCompleteChildren = function () {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) {
            // If it's a leaf node, it has no children; so nothing to do.
            if (!node.isLeafNode()) {
                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                    children.push(new NamedNode(childName, childNode));
                });
            }
        }
        else {
            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
                if (childTree.value != null) {
                    children.push(new NamedNode(childName, childTree.value));
                }
            });
        }
        return children;
    };
    /**
     * @param {!Path} path
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.childCompoundWrite = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) {
                return new CompoundWrite(new ImmutableTree(shadowingNode));
            }
            else {
                return new CompoundWrite(this.writeTree_.subtree(path));
            }
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return {boolean} Whether this CompoundWrite is empty
     */
    CompoundWrite.prototype.isEmpty = function () {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param {!Node} node The node to apply this CompoundWrite to
     * @return {!Node} The node with all writes applied
     */
    CompoundWrite.prototype.apply = function (node) {
        return CompoundWrite.applySubtreeWrite_(Path.Empty, this.writeTree_, node);
    };
    /**
     * @type {!CompoundWrite}
     */
    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
    /**
     * @param {!Path} relativePath
     * @param {!ImmutableTree.<!Node>} writeTree
     * @param {!Node} node
     * @return {!Node}
     * @private
     */
    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
        if (writeTree.value != null) {
            // Since there a write is always a leaf, we're done here
            return node.updateChild(relativePath, writeTree.value);
        }
        else {
            var priorityWrite_1 = null;
            writeTree.children.inorderTraversal(function (childKey, childTree) {
                if (childKey === '.priority') {
                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                    // to apply priorities to empty nodes that are later filled
                    util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
                    priorityWrite_1 = childTree.value;
                }
                else {
                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
                }
            });
            // If there was a priority write, we only apply it if the node is not empty
            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
            }
            return node;
        }
    };
    return CompoundWrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
var WriteTree = /** @class */ (function () {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */
        this.visibleWrites_ = CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */
        this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */
    WriteTree.prototype.childWrites = function (path) {
        return new WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */
    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) {
            visible = true;
        }
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) {
            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        }
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */
    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */
    WriteTree.prototype.getWrite = function (writeId) {
        for (var i = 0; i < this.allWrites_.length; i++) {
            var record = this.allWrites_[i];
            if (record.writeId === writeId) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */
    WriteTree.prototype.removeWrite = function (writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function (s) {
            return s.writeId === writeId;
        });
        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while (removedWriteWasVisible && i >= 0) {
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx &&
                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
                    // The removed write was completely shadowed by a subsequent write.
                    removedWriteWasVisible = false;
                }
                else if (writeToRemove.path.contains(currentWrite.path)) {
                    // Either we're covering some writes or they're covering part of us (depending on which came first).
                    removedWriteOverlapsWithOtherWrites = true;
                }
            }
            i--;
        }
        if (!removedWriteWasVisible) {
            return false;
        }
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        }
        else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) {
                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            }
            else {
                var children = writeToRemove.children;
                util.forEach(children, function (childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.getCompleteWriteData = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) {
                return shadowingNode;
            }
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) {
                    return completeServerCache;
                }
                else if (completeServerCache == null &&
                    !subMerge.hasCompleteWrite(Path.Empty)) {
                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                    return null;
                }
                else {
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        }
        else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) {
                return completeServerCache;
            }
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites &&
                    completeServerCache == null &&
                    !merge.hasCompleteWrite(Path.Empty)) {
                    return null;
                }
                else {
                    var filter = function (write) {
                        return ((write.visible || includeHiddenWrites) &&
                            (!writeIdsToExclude ||
                                !~writeIdsToExclude.indexOf(write.writeId)) &&
                            (write.path.contains(treePath) || treePath.contains(write.path)));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
        var completeChildren = ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) {
                // we're shadowing everything. Return the children.
                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
                });
            }
            return completeChildren;
        }
        else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                var node = merge_1
                    .childCompoundWrite(new Path(childName))
                    .apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
        else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) {
            // At this point we can probably guarantee that we're in case 2, meaning no events
            // May need to check visibility while doing the findRootMostValueAndPath call
            return null;
        }
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) {
                // We're not shadowing at all. Case 1
                return existingServerSnap.getChild(childPath);
            }
            else {
                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
                // However this is tricky to find out, since user updates don't necessary change the server
                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
                // only check if the updates change the serverNode.
                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
                return childMerge.apply(existingServerSnap.getChild(childPath));
            }
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) {
            return shadowingNode;
        }
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            }
            else {
                return null;
            }
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.shadowingWrite = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode(Path.Empty);
        if (shadowingNode != null) {
            toIterate = shadowingNode;
        }
        else if (completeServerData != null) {
            toIterate = merge.apply(completeServerData);
        }
        else {
            // no children to iterate on
            return [];
        }
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse
                ? toIterate.getReverseIteratorFrom(startPost, index)
                : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while (next && nodes.length < count) {
                if (cmp(next, startPost) !== 0) {
                    nodes.push(next);
                }
                next = iter.getNext();
            }
            return nodes;
        }
        else {
            return [];
        }
    };
    /**
     * @param {!WriteRecord} writeRecord
     * @param {!Path} path
     * @return {boolean}
     * @private
     */
    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
        if (writeRecord.snap) {
            return writeRecord.path.contains(path);
        }
        else {
            // findKey can return undefined, so use !! to coerce to boolean
            return !!util.findKey(writeRecord.children, function (childSnap, childName) {
                return writeRecord.path.child(childName).contains(path);
            });
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     * @private
     */
    WriteTree.prototype.resetTree_ = function () {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
        if (this.allWrites_.length > 0) {
            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        }
        else {
            this.lastWriteId_ = -1;
        }
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     *
     * @param {!WriteRecord} write
     * @return {boolean}
     * @private
     */
    WriteTree.DefaultFilter_ = function (write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     *
     * @param {!Array.<!WriteRecord>} writes
     * @param {!function(!WriteRecord):boolean} filter
     * @param {!Path} treeRoot
     * @return {!CompoundWrite}
     * @private
     */
    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
        var compoundWrite = CompoundWrite.Empty;
        for (var i = 0; i < writes.length; ++i) {
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
                    }
                }
                else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) {
                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
                        }
                        else {
                            var child = util.safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
                            }
                        }
                    }
                }
                else {
                    throw util.assertionError('WriteRecord should have .snap or .children');
                }
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}());
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */
var WriteTreeRef = /** @class */ (function () {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */
    function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTreeRef.prototype.shadowingWrite = function (path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */
    WriteTreeRef.prototype.child = function (childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */ (function () {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */
    function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         * @type {!ImmutableTree.<!SyncPoint>}
         * @private
         */
        this.syncPointTree_ = ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         * @type {!WriteTree}
         * @private
         */
        this.pendingWriteTree_ = new WriteTree();
        this.tagToQueryMap_ = {};
        this.queryToTagMap_ = {};
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @param {number} writeId
     * @param {boolean=} visible
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) {
            return [];
        }
        else {
            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
        }
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param {!number} writeId
     * @param {boolean=} revert True if the given write failed and needs to be reverted
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
        if (revert === void 0) { revert = false; }
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) {
            return [];
        }
        else {
            var affectedTree_1 = ImmutableTree.Empty;
            if (write.snap != null) {
                // overwrite
                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
            }
            else {
                util.forEach(write.children, function (pathString, node) {
                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
                });
            }
            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @param {!Path} path
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyListenComplete = function (path) {
        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // Query must have been removed already
            return [];
        }
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var changeTree = ImmutableTree.fromObject(changedChildren);
            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @param {!Path} path
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
            var relativePath = Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView =
                foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        }
        else {
            foundAncestorDefaultView =
                foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) {
            serverCacheComplete = true;
        }
        else {
            serverCacheComplete = false;
            serverCache = ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function (childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
                if (completeCache) {
                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
                }
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            util.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap_[queryKey] = tag;
            // Coerce to string to avoid sparse arrays.
            this.tagToQueryMap_['_' + tag] = queryKey;
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */ = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint &&
            (query.queryIdentifier() === 'default' ||
                maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */
            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) {
                this.syncPointTree_ = this.syncPointTree_.remove(path);
            }
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !==
                removed.findIndex(function (query) {
                    return query.getQueryParams().loadsAllData();
                });
            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for (var i = 0; i < newViews.length; ++i) {
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                }
                else {
                    removed.forEach(function (queryToRemove) {
                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                    });
                }
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
     * it, but as this is only used by transaction code, that should always be the case anyways.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     * @param {!Path} path The path to the data we want
     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
     * @return {?Node}
     */
    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
            var relativePath = Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) {
                return serverCache;
            }
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     *
     * @param {!ImmutableTree.<!SyncPoint>} subtree
     * @return {!Array.<!View>}
     * @private
     */
    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [completeView];
            }
            else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) {
                    views_1 = maybeChildSyncPoint.getQueryViews();
                }
                util.forEach(childMap, function (key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    /**
     * @param {!Array.<!Query>} queries
     * @private
     */
    SyncTree.prototype.removeTags_ = function (queries) {
        for (var j = 0; j < queries.length; ++j) {
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
                delete this.queryToTagMap_[removedQueryKey];
                delete this.tagToQueryMap_['_' + removedQueryTag];
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     * @param {!Query} query
     * @return {!Query} The normalized query
     * @private
     */
    SyncTree.queryForListening_ = function (query) {
        if (query.getQueryParams().loadsAllData() &&
            !query.getQueryParams().isDefault()) {
            // We treat queries that load all data as default queries
            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
            // from Query
            return /** @type {!Query} */ query.getRef();
        }
        else {
            return query;
        }
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @param {!Query} query
     * @param {!View} view
     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
     * @private
     */
    SyncTree.prototype.setupListener_ = function (query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) {
            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        }
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() &&
                    maybeChildSyncPoint &&
                    maybeChildSyncPoint.hasCompleteView()) {
                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
                }
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) {
                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
                    }
                    util.forEach(childMap, function (key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for (var i = 0; i < queriesToStop.length; ++i) {
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    /**
     *
     * @param {!View} view
     * @return {{hashFn: function(), onComplete: function(!string, *)}}
     * @private
     */
    SyncTree.prototype.createListenerForView_ = function (view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function () {
                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function (status) {
                if (status === 'ok') {
                    if (tag) {
                        return _this.applyTaggedListenComplete(query.path, tag);
                    }
                    else {
                        return _this.applyListenComplete(query.path);
                    }
                }
                else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error = errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, 
                    /*eventRegistration*/ null, error);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     * @private
     * @param {!Query} query
     * @return {string}
     */
    SyncTree.makeQueryKey_ = function (query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     * @private
     * @param {!string} queryKey
     * @return {{queryId: !string, path: !Path}}
     */
    SyncTree.parseQueryKey_ = function (queryKey) {
        var splitIndex = queryKey.indexOf('$');
        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     * @param {!number} tag
     * @return {?string}
     * @private
     */
    SyncTree.prototype.queryKeyForTag_ = function (tag) {
        return this.tagToQueryMap_['_' + tag];
    };
    /**
     * Return the tag associated with the given query.
     * @param {!Query} query
     * @return {?number}
     * @private
     */
    SyncTree.prototype.tagForQuery_ = function (query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return util.safeGet(this.queryToTagMap_, queryKey);
    };
    /**
     * Static accessor for query tags.
     * @return {number}
     * @private
     */
    SyncTree.getNextQueryTag_ = function () {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     *
     * @param {!Path} queryPath
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, 
        /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
  
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
  
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     *
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, 
        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) {
            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        }
        else {
            var syncPoint = syncPointTree.get(Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) {
                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
            }
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache
                    ? serverCache.getImmediateChild(childName)
                    : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) {
                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            }
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get(Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) {
            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
        }
        var events = [];
        syncPointTree.children.inorderTraversal(function (childName, childTree) {
            var childServerCache = serverCache
                ? serverCache.getImmediateChild(childName)
                : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) {
                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
        });
        if (syncPoint) {
            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        }
        return events;
    };
    /**
     * Static tracker for next query tag.
     * @type {number}
     * @private
     */
    SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
    function SnapshotHolder() {
        this.rootNode_ = ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function (path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var AuthTokenProvider = /** @class */ (function () {
    /**
     * @param {!FirebaseApp} app_
     */
    function AuthTokenProvider(app_) {
        this.app_ = app_;
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */
    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
        // .catch
        function (error) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            }
            else {
                return Promise.reject(error);
            }
        });
    };
    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        this.app_['INTERNAL']['addAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
        var errorMessage = 'Provided authentication credentials for the app named "' +
            this.app_.name +
            '" are invalid. This usually indicates your app was not ' +
            'initialized correctly. ';
        if ('credential' in this.app_.options) {
            errorMessage +=
                'Make sure the "credential" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else if ('serviceAccount' in this.app_.options) {
            errorMessage +=
                'Make sure the "serviceAccount" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else {
            errorMessage +=
                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
                    'initializeApp() match the values provided for your app at ' +
                    'https://console.firebase.google.com/.';
        }
        warn(errorMessage);
    };
    return AuthTokenProvider;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
var StatsCollection = /** @class */ (function () {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function (name, amount) {
        if (amount === void 0) { amount = 1; }
        if (!util.contains(this.counters_, name))
            this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function () {
        return util.deepCopy(this.counters_);
    };
    return StatsCollection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsManager = /** @class */ (function () {
    function StatsManager() {
    }
    StatsManager.getCollection = function (repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) {
            this.collections_[hashString] = new StatsCollection();
        }
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) {
            this.reporters_[hashString] = creatorFunction();
        }
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */ (function () {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function () {
        var newStats = this.collection_.get();
        var delta = util.clone(newStats);
        if (this.last_) {
            util.forEach(this.last_, function (stat, value) {
                delta[stat] = delta[stat] - value;
            });
        }
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
    /**
     * @param collection
     * @param server_
     */
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new StatsListener(collection);
        var timeout = FIRST_STATS_MIN_TIME +
            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function (stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function () {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        util.forEach(stats, function (stat, value) {
            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) {
            this.server_.reportStats(reportedStats);
        }
        // queue our next run.
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */
        this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */
    EventQueue.prototype.queueEvents = function (eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for (var i = 0; i < eventDataList.length; i++) {
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) {
                currList = new EventList(eventPath);
            }
            currList.add(eventData);
        }
        if (currList) {
            this.eventLists_.push(currList);
        }
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */
    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */
    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */
    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for (var i = 0; i < this.eventLists_.length; i++) {
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                }
                else {
                    sentAll = false;
                }
            }
        }
        if (sentAll) {
            this.eventLists_ = [];
        }
        this.recursionDepth_--;
    };
    return EventQueue;
}());
/**
 * @param {!Path} path
 * @constructor
 */
var EventList = /** @class */ (function () {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */
        this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */
    EventList.prototype.add = function (eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */
    EventList.prototype.raise = function () {
        for (var i = 0; i < this.events_.length; i++) {
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if (logger) {
                    log('event: ' + eventData.toString());
                }
                exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */
    EventList.prototype.getPath = function () {
        return this.path_;
    };
    return EventList;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */
var EventEmitter = /** @class */ (function () {
    /**
     * @param {!Array.<string>} allowedEvents_
     */
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} var_args
     */
    EventEmitter.prototype.trigger = function (eventType) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = this.listeners_[eventType].slice();
            for (var i = 0; i < listeners.length; i++) {
                listeners[i].callback.apply(listeners[i].context, var_args);
            }
        }
    };
    EventEmitter.prototype.on = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({ callback: callback, context: context });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) {
            callback.apply(context, eventData);
        }
    };
    EventEmitter.prototype.off = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].callback === callback &&
                (!context || context === listeners[i].context)) {
                listeners.splice(i, 1);
                return;
            }
        }
    };
    EventEmitter.prototype.validateEventType_ = function (eventType) {
        util.assert(this.allowedEvents_.find(function (et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, ['visible']) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' &&
            typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            }
            else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            }
            else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            }
            else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) {
            document.addEventListener(visibilityChange, function () {
                var visible = !document[hidden];
                if (visible !== _this.visible_) {
                    _this.visible_ = visible;
                    _this.trigger('visible', visible);
                }
            }, false);
        }
        return _this;
    }
    VisibilityMonitor.getInstance = function () {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [this.visible_];
    };
    return VisibilityMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, ['online']) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' &&
            typeof window.addEventListener !== 'undefined' &&
            !util.isMobileCordova()) {
            window.addEventListener('online', function () {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function () {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function () {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
        return [this.online_];
    };
    /**
     * @return {boolean}
     */
    OnlineMonitor.prototype.currentlyOnline = function () {
        return this.online_;
    };
    return OnlineMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */ (function () {
    /**
     * @param onMessage_
     */
    function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */
    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function () {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function (i) {
                if (toProcess[i]) {
                    exceptionGuard(function () {
                        _this.onMessage_(toProcess[i]);
                    });
                }
            };
            for (var i = 0; i < toProcess.length; ++i) {
                _loop_2(i);
            }
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while (this.pendingResponses[this.currentResponseNum]) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
    };
    return PacketReceiver;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// URL query parameters associated with longpolling
var FIREBASE_LONGPOLL_START_PARAM = 'start';
var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
var FIREBASE_LONGPOLL_ID_PARAM = 'id';
var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
var FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */
var KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */
var LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */
var BrowserPollConnection = /** @class */ (function () {
    /**
     * @param {string} connId An identifier for this connection, used for logging
     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */
    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = logWrapper(connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.urlFn = function (params) {
            return repoInfo.connectionURL(LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */
    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function () {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        }, Math.floor(LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        executeWhenDOMReady(function () {
            if (_this.isClosed_)
                return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var command = args[0], arg1 = args[1], arg2 = args[2];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder)
                    return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command == FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                }
                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function () {
                            _this.onClosed_();
                        });
                    }
                    else {
                        _this.onClosed_();
                    }
                }
                else {
                    throw new Error('Unrecognized command received: ' + command);
                }
            }, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var pN = args[0], data = args[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function () {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
            if (_this.transportSessionId) {
                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            }
            if (_this.lastSessionId) {
                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
            }
            if (!util.isNodeSdk() &&
                typeof location !== 'undefined' &&
                location.href &&
                location.href.indexOf(FORGE_DOMAIN) !== -1) {
                urlParams[REFERER_PARAM] = FORGE_REF;
            }
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function () {
                /* do nothing */
            });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */
    BrowserPollConnection.prototype.start = function () {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */
    BrowserPollConnection.forceAllow = function () {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */
    BrowserPollConnection.forceDisallow = function () {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function () {
        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return (BrowserPollConnection.forceAllow_ ||
            (!BrowserPollConnection.forceDisallow_ &&
                typeof document !== 'undefined' &&
                document.createElement != null &&
                !isChromeExtensionContentScript() &&
                !isWindowsStoreApp() &&
                !util.isNodeSdk()));
    };
    /**
     * No-op for polling
     */
    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
    /**
     * Stops polling and cleans up the iframe
     * @private
     */
    BrowserPollConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */
    BrowserPollConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */
    BrowserPollConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */
    BrowserPollConnection.prototype.send = function (data) {
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = util.base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for (var i = 0; i < dataSegs.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */
    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
        if (util.isNodeSdk())
            return;
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */
    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = util.stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}());
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/
var FirebaseIFrameScriptHolder = /** @class */ (function () {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */
    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        /**
         * @type {CountedSet.<number, number>}
         */
        this.outstandingRequests = new CountedSet();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!util.isNodeSdk()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = LUIDGenerator();
            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src &&
                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            }
            catch (e) {
                log('frame writing exception');
                if (e.stack) {
                    log(e.stack);
                }
                log(e);
            }
        }
        else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */
    FirebaseIFrameScriptHolder.createIFrame_ = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) {
                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                    log('No IE domain setting required');
                }
            }
            catch (e) {
                var domain = document.domain;
                iframe.src =
                    "javascript:void((function(){document.open();document.domain='" +
                        domain +
                        "';document.close();})())";
            }
        }
        else {
            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
            // never gets hit.
            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        }
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) {
            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        }
        else if (iframe.contentWindow) {
            iframe.doc = iframe.contentWindow.document; // Internet Explorer
        }
        else if (iframe.document) {
            iframe.doc = iframe.document; //others?
        }
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */
    FirebaseIFrameScriptHolder.prototype.close = function () {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function () {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        if (util.isNodeSdk() && this.myID) {
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            var theURL = this.urlFn(urlParams);
            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */
    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while (this.newRequest_()) { }
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */
    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive &&
            this.sendNewPolls &&
            this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while (this.pendingSegs.length > 0) {
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
                    MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString =
                        curDataString +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
                            i +
                            '=' +
                            theSeg.seg +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
                            i +
                            '=' +
                            theSeg.ts +
                            '&' +
                            FIREBASE_LONGPOLL_DATA_PARAM +
                            i +
                            '=' +
                            theSeg.d;
                    i++;
                }
                else {
                    break;
                }
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */
    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) {
            this.newRequest_();
        }
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */
    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial, 1);
        var doNewRequest = function () {
            _this.outstandingRequests.remove(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function () {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */
    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
        var _this = this;
        if (util.isNodeSdk()) {
            this.doNodeLongPoll(url, loadCB);
        }
        else {
            setTimeout(function () {
                try {
                    // if we're already closed, don't add this poll
                    if (!_this.sendNewPolls)
                        return;
                    var newScript_1 = _this.myIFrame.doc.createElement('script');
                    newScript_1.type = 'text/javascript';
                    newScript_1.async = true;
                    newScript_1.src = url;
                    newScript_1.onload = newScript_1.onreadystatechange = function () {
                        var rstate = newScript_1.readyState;
                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                            newScript_1.onload = newScript_1.onreadystatechange = null;
                            if (newScript_1.parentNode) {
                                newScript_1.parentNode.removeChild(newScript_1);
                            }
                            loadCB();
                        }
                    };
                    newScript_1.onerror = function () {
                        log('Long-poll script failed to load: ' + url);
                        _this.sendNewPolls = false;
                        _this.close();
                    };
                    _this.myIFrame.doc.body.appendChild(newScript_1);
                }
                catch (e) {
                    // TODO: we should make this error visible somehow
                }
            }, Math.floor(1));
        }
    };
    return FirebaseIFrameScriptHolder;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
    WebSocketImpl = MozWebSocket;
}
else if (typeof WebSocket !== 'undefined') {
    WebSocketImpl = WebSocket;
}
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */ (function () {
    /**
     * @param {string} connId identifier for this transport
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     */
    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = logWrapper(this.connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */
    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
        if (!util.isNodeSdk() &&
            typeof location !== 'undefined' &&
            location.href &&
            location.href.indexOf(FORGE_DOMAIN) !== -1) {
            urlParams[REFERER_PARAM] = FORGE_REF;
        }
        if (transportSessionId) {
            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
        }
        if (lastSessionId) {
            urlParams[LAST_SESSION_PARAM] = lastSessionId;
        }
        return repoInfo.connectionURL(WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */
    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        PersistentStorage.set('previous_websocket_failure', true);
        try {
            if (util.isNodeSdk()) {
                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + firebase.SDK_VERSION + "/" + process.platform + "/" + device
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = process['env'];
                var proxy = this.connURL.indexOf('wss://') == 0
                    ? env['HTTPS_PROXY'] || env['https_proxy']
                    : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) {
                    options['proxy'] = { origin: proxy };
                }
                this.mySock = new WebSocketImpl(this.connURL, [], options);
            }
            else {
                this.mySock = new WebSocketImpl(this.connURL);
            }
        }
        catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error = e.message || e.data;
            if (error) {
                this.log_(error);
            }
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function () {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function () {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function (m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function (e) {
            _this.log_('WebSocket error.  Closing connection.');
            var error = e.message || e.data;
            if (error) {
                _this.log_(error);
            }
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */
    WebSocketConnection.prototype.start = function () { };
    WebSocketConnection.forceDisallow = function () {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function () {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
                    isOldAndroid = true;
                }
            }
        }
        return (!isOldAndroid &&
            WebSocketImpl !== null &&
            !WebSocketConnection.forceDisallow_);
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */
    WebSocketConnection.previouslyFailed = function () {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return (PersistentStorage.isInMemoryStorage ||
            PersistentStorage.get('previous_websocket_failure') === true);
    };
    WebSocketConnection.prototype.markConnectionHealthy = function () {
        PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function (data) {
        this.frames.push(data);
        if (this.frames.length == this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = util.jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */
    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */
    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
        util.assert(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */
    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
        if (this.mySock === null)
            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) {
            // we're buffering
            this.appendFrame_(data);
        }
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) {
                this.appendFrame_(remainingData);
            }
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */
    WebSocketConnection.prototype.send = function (data) {
        this.resetKeepAlive();
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) {
            this.sendString_(String(dataSegs.length));
        }
        //Send the actual data in segments.
        for (var i = 0; i < dataSegs.length; i++) {
            this.sendString_(dataSegs[i]);
        }
    };
    WebSocketConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */
    WebSocketConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */
    WebSocketConnection.prototype.resetKeepAlive = function () {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function () {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) {
                _this.sendString_('0');
            }
            _this.resetKeepAlive();
        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */
    WebSocketConnection.prototype.sendString_ = function (str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        }
        catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */
    WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */
    WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */
    function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */
        get: function () {
            return [BrowserPollConnection, WebSocketConnection];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */
    TransportManager.prototype.initTransports_ = function (repoInfo) {
        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable)
                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) {
            this.transports_ = [WebSocketConnection];
        }
        else {
            var transports_1 = (this.transports_ = []);
            each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
                if (transport && transport['isAvailable']()) {
                    transports_1.push(transport);
                }
            });
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */
    TransportManager.prototype.initialTransport = function () {
        if (this.transports_.length > 0) {
            return this.transports_[0];
        }
        else {
            throw new Error('No transports available');
        }
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */
    TransportManager.prototype.upgradeTransport = function () {
        if (this.transports_.length > 1) {
            return this.transports_[1];
        }
        else {
            return null;
        }
    };
    return TransportManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Abort upgrade attempt if it takes longer than 60s.
var UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = 't';
var MESSAGE_DATA = 'd';
var CONTROL_SHUTDOWN = 's';
var CONTROL_RESET = 'r';
var CONTROL_ERROR = 'e';
var CONTROL_PONG = 'o';
var SWITCH_ACK = 'a';
var END_TRANSMISSION = 'n';
var PING = 'p';
var SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */
var Connection = /** @class */ (function () {
    /**
     * @param {!string} id - an id for this connection
     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */
    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */;
        this.log_ = logWrapper('c:' + this.id + ':');
        this.transportManager_ = new TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */
    Connection.prototype.start_ = function () {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */
        setTimeout(function () {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
        if (healthyTimeout_ms > 0) {
            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
                _this.healthyTimeout_ = null;
                if (!_this.isHealthy_) {
                    if (_this.conn_ &&
                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has received ' +
                            _this.conn_.bytesReceived +
                            ' bytes.  Marking connection healthy.');
                        _this.isHealthy_ = true;
                        _this.conn_.markConnectionHealthy();
                    }
                    else if (_this.conn_ &&
                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has sent ' +
                            _this.conn_.bytesSent +
                            ' bytes.  Leaving connection alive.');
                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
                        // the server.
                    }
                    else {
                        _this.log_('Closing unhealthy connection after timeout.');
                        _this.close();
                    }
                }
            }, Math.floor(healthyTimeout_ms));
        }
    };
    /**
     * @return {!string}
     * @private
     */
    Connection.prototype.nextTransportId_ = function () {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function (conn) {
        var _this = this;
        return function (everConnected) {
            if (conn === _this.conn_) {
                _this.onConnectionLost_(everConnected);
            }
            else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            }
            else {
                _this.log_('closing an old connection');
            }
        };
    };
    Connection.prototype.connReceiver_ = function (conn) {
        var _this = this;
        return function (message) {
            if (_this.state_ != 2 /* DISCONNECTED */) {
                if (conn === _this.rx_) {
                    _this.onPrimaryMessageReceived_(message);
                }
                else if (conn === _this.secondaryConn_) {
                    _this.onSecondaryMessageReceived_(message);
                }
                else {
                    _this.log_('message on old connection');
                }
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */
    Connection.prototype.sendRequest = function (dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = { t: 'd', d: dataMsg };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function () {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
            // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function (controlData) {
        if (MESSAGE_TYPE in controlData) {
            var cmd = controlData[MESSAGE_TYPE];
            if (cmd === SWITCH_ACK) {
                this.upgradeIfSecondaryHealthy_();
            }
            else if (cmd === CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ ||
                    this.rx_ === this.secondaryConn_) {
                    this.close();
                }
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onSecondaryControl_(data);
        }
        else if (layer == 'd') {
            // got a data message, but we're still second connection. Need to buffer it up
            this.pendingDataMessages.push(data);
        }
        else {
            throw new Error('Unknown protocol layer: ' + layer);
        }
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        }
        else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function () {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onControl_(data);
        }
        else if (layer == 'd') {
            this.onDataMessage_(data);
        }
    };
    Connection.prototype.onDataMessage_ = function (message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function () {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function (controlData) {
        var cmd = requireKey(MESSAGE_TYPE, controlData);
        if (MESSAGE_DATA in controlData) {
            var payload = controlData[MESSAGE_DATA];
            if (cmd === SERVER_HELLO) {
                this.onHandshake_(payload);
            }
            else if (cmd === END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
                    this.onDataMessage_(this.pendingDataMessages[i]);
                }
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            }
            else if (cmd === CONTROL_SHUTDOWN) {
                // This was previously the 'onKill' callback passed to the lower-level connection
                // payload in this case is the reason for the shutdown. Generally a human-readable error
                this.onConnectionShutdown_(payload);
            }
            else if (cmd === CONTROL_RESET) {
                // payload in this case is the host we should contact
                this.onReset_(payload);
            }
            else if (cmd === CONTROL_ERROR) {
                error('Server Error: ' + payload);
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            }
            else {
                error('Unknown control packet command: ' + cmd);
            }
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */
    Connection.prototype.onHandshake_ = function (handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ == 0 /* CONNECTING */) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if (PROTOCOL_VERSION !== version) {
                warn('Protocol version mismatch detected');
            }
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function () {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) {
            this.startUpgrade_(conn);
        }
    };
    Connection.prototype.startUpgrade_ = function (conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ =
            conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        setTimeoutNonBlocking(function () {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor(UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function (host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */) {
            this.close();
        }
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        }
        else {
            setTimeoutNonBlocking(function () {
                _this.sendPingOnPrimaryIfNecessary_();
            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
        }
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
            this.log_('sending ping on primary.');
            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function () {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) {
            // we are relying on this connection already in some capacity. Therefore, a failure is real
            this.close();
        }
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */
    Connection.prototype.onConnectionLost_ = function (everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        }
        else if (this.state_ === 1 /* CONNECTED */) {
            this.log_('Realtime connection lost.');
        }
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */
    Connection.prototype.onConnectionShutdown_ = function (reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function (data) {
        if (this.state_ !== 1 /* CONNECTED */) {
            throw 'Connection is not connected';
        }
        else {
            this.tx_.send(data);
        }
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */
    Connection.prototype.close = function () {
        if (this.state_ !== 2 /* DISCONNECTED */) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* DISCONNECTED */;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */
    Connection.prototype.closeConnections_ = function () {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */ (function () {
    function ServerActions() {
    }
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */
    ServerActions.prototype.refreshAuthToken = function (token) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
    /**
     * @param {Object.<string, *>} stats
     */
    ServerActions.prototype.reportStats = function (stats) { };
    return ServerActions;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RECONNECT_MIN_DELAY = 1000;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */
var PersistentConnection = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param onConnectStatus_
     * @param onServerInfoUpdate_
     * @param authTokenProvider_
     * @param authOverride_
     */
    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = logWrapper('p:' + _this.id + ':');
        /** @private {Object} */
        _this.interruptReasons_ = {};
        _this.listens_ = {};
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        /** @private {number|null} */
        _this.establishConnectionTimer_ = null;
        /** @private {boolean} */
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        /** @private {?{
         *   sendRequest(Object),
         *   close()
         * }} */
        _this.realtime_ = null;
        /** @private {string|null} */
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !util.isNodeSdk()) {
            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        }
        _this.scheduleConnect_(0);
        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) {
            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        }
        return _this;
    }
    /**
     * @param {!string} action
     * @param {*} body
     * @param {function(*)=} onResponse
     * @protected
     */
    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = { r: curReqNum, a: action, b: body };
        this.log_(util.stringify(msg));
        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) {
            this.requestCBHash_[curReqNum] = onResponse;
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        this.listens_[pathString] = this.listens_[pathString] || {};
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        util.assert(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens_[pathString][queryId] = listenSpec;
        if (this.connected_) {
            this.sendListen_(listenSpec);
        }
    };
    /**
     * @param {!{onComplete(),
     *           hashFn():!string,
     *           query: !Query,
     *           tag: ?number}} listenSpec
     * @private
     */
    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req[ /*hash*/'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function (message) {
            var payload = message[ /*data*/'d'];
            var status = message[ /*status*/'s'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') {
                    _this.removeListen_(pathString, queryId);
                }
                if (listenSpec.onComplete) {
                    listenSpec.onComplete(status, payload);
                }
            }
        });
    };
    /**
     * @param {*} payload
     * @param {!Query} query
     * @private
     */
    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
            var warnings = util.safeGet(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' +
                    query
                        .getQueryParams()
                        .getIndex()
                        .toString() +
                    '"';
                var indexPath = query.path.toString();
                warn("Using an unspecified index. Your data will be downloaded and " +
                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
                    (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.refreshAuthToken = function (token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) {
            this.tryAuth();
        }
        else {
            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
            //the credential so we dont become authenticated next time we connect.
            if (this.connected_) {
                this.sendRequest('unauth', {}, function () { });
            }
        }
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    /**
     * @param {!string} credential
     * @private
     */
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || util.isAdmin(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */
    PersistentConnection.prototype.tryAuth = function () {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
            var requestData = { cred: token_1 };
            if (this.authOverride_ === null) {
                requestData['noauth'] = true;
            }
            else if (typeof this.authOverride_ === 'object') {
                requestData['authvar'] = this.authOverride_;
            }
            this.sendRequest(authMethod, requestData, function (res) {
                var status = res[ /*status*/'s'];
                var data = res[ /*data*/'d'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') {
                        _this.invalidAuthTokenCount_ = 0;
                    }
                    else {
                        // Triggers reconnect and force refresh for auth token
                        _this.onAuthRevoked_(status, data);
                    }
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.unlisten = function (query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) {
            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
        }
    };
    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('o', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'o',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('om', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'om',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('oc', pathString, null, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'oc',
                data: null,
                onComplete: onComplete
            });
        }
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
        var request = { /*path*/ p: pathString, /*data*/ d: data };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function (response) {
            if (onComplete) {
                setTimeout(function () {
                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
                }, Math.floor(0));
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined)
            request[ /*hash*/'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) {
            this.sendPut_(index);
        }
        else {
            this.log_('Buffering put: ' + pathString);
        }
    };
    PersistentConnection.prototype.sendPut_ = function (index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function (message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) {
                _this.outstandingPuts_ = [];
            }
            if (onComplete)
                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.reportStats = function (stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = { /*counters*/ c: stats };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, function (result) {
                var status = result[ /*status*/'s'];
                if (status !== 'ok') {
                    var errorReason = result[ /* data */'d'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    /**
     * @param {*} message
     * @private
     */
    PersistentConnection.prototype.onDataMessage_ = function (message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + util.stringify(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[ /*body*/'b']);
            }
        }
        else if ('error' in message) {
            throw 'A server-side error has occurred: ' + message['error'];
        }
        else if ('a' in message) {
            // a and b are action and body, respectively
            this.onDataPush_(message['a'], message['b']);
        }
    };
    PersistentConnection.prototype.onDataPush_ = function (action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge*/ false, body['t']);
        else if (action === 'm')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge=*/ true, body['t']);
        else if (action === 'c')
            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
        else if (action === 'ac')
            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
        else if (action === 'sd')
            this.onSecurityDebugPacket_(body);
        else
            error('Unrecognized action received from server: ' +
                util.stringify(action) +
                '\nAre you using the latest client?');
    };
    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) {
            this.sendConnectStats_();
        }
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
        var _this = this;
        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) {
            clearTimeout(this.establishConnectionTimer_);
        }
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function () {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        }, Math.floor(timeout));
    };
    /**
     * @param {boolean} visible
     * @private
     */
    PersistentConnection.prototype.onVisible_ = function (visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible &&
            !this.visible_ &&
            this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function (online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) {
                this.realtime_.close();
            }
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            }
            else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function () {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function () {
                if (connection_1) {
                    connection_1.close();
                }
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function (msg) {
                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_
                .getToken(forceRefresh)
                .then(function (result) {
                if (!canceled_1) {
                    log('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
                    /* onKill= */ function (reason) {
                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                }
                else {
                    log('getToken() completed but was canceled');
                }
            })
                .then(null, function (error) {
                self_1.log_('Failed to get token: ' + error);
                if (!canceled_1) {
                    if (util.CONSTANTS.NODE_ADMIN) {
                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
                        // But getToken() may also just have temporarily failed, so we still want to
                        // continue retrying.
                        warn(error);
                    }
                    closeFn_1();
                }
            });
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.interrupt = function (reason) {
        log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) {
            this.realtime_.close();
        }
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) {
                this.onRealtimeDisconnect_();
            }
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.resume = function (reason) {
        log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if (util.isEmpty(this.interruptReasons_)) {
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({ serverTimeOffset: delta });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function () {
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete)
                    put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0)
            this.outstandingPuts_ = [];
    };
    /**
     * @param {!string} pathString
     * @param {Array.<*>=} query
     * @private
     */
    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) {
            queryId = 'default';
        }
        else {
            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
        }
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete)
            listen.onComplete('permission_denied');
    };
    /**
     * @param {!string} pathString
     * @param {!string} queryId
     * @return {{queries:Array.<Query>, onComplete:function(string)}}
     * @private
     */
    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
        var normalizedPathString = new Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens_[normalizedPathString] !== undefined) {
            listen = this.listens_[normalizedPathString][queryId];
            delete this.listens_[normalizedPathString][queryId];
            if (util.getCount(this.listens_[normalizedPathString]) === 0) {
                delete this.listens_[normalizedPathString];
            }
        }
        else {
            // all listens for this path has already been removed
            listen = undefined;
        }
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
        log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
        if (this.securityDebugCallback_) {
            this.securityDebugCallback_(body);
        }
        else {
            if ('msg' in body) {
                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
            }
        }
    };
    PersistentConnection.prototype.restoreState_ = function () {
        var _this = this;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        util.forEach(this.listens_, function (pathString, queries) {
            util.forEach(queries, function (key, listenSpec) {
                _this.sendListen_(listenSpec);
            });
        });
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            if (this.outstandingPuts_[i])
                this.sendPut_(i);
        }
        while (this.onDisconnectRequestQueue_.length) {
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     * @private
     */
    PersistentConnection.prototype.sendConnectStats_ = function () {
        var stats = {};
        var clientName = 'js';
        if (util.CONSTANTS.NODE_ADMIN) {
            clientName = 'admin_node';
        }
        else if (util.CONSTANTS.NODE_CLIENT) {
            clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + firebase.SDK_VERSION.replace(/\./g, '-')] = 1;
        if (util.isMobileCordova()) {
            stats['framework.cordova'] = 1;
        }
        else if (util.isReactNative()) {
            stats['framework.reactnative'] = 1;
        }
        this.reportStats(stats);
    };
    /**
     * @return {boolean}
     * @private
     */
    PersistentConnection.prototype.shouldReconnect_ = function () {
        var online = OnlineMonitor.getInstance().currentlyOnline();
        return util.isEmpty(this.interruptReasons_) && online;
    };
    /**
     * @private
     */
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     * @type {number}
     * @private
     */
    PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
    tslib_1.__extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */
    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */
        _this.log_ = logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */
        _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function (stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */
    ReadonlyRestClient.getListenId_ = function (query, tag) {
        if (tag !== undefined) {
            return 'tag$' + tag;
        }
        else {
            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParameters = query
            .getQueryParams()
            .toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParameters, function (error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            }
            if (util.safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error) {
                    status_1 = 'ok';
                }
                else if (error == 401) {
                    status_1 = 'permission_denied';
                }
                else {
                    status_1 = 'rest_error:' + error;
                }
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
        // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */
    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_
            .getToken(/*forceRefresh=*/ false)
            .then(function (authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) {
                queryStringParameters['auth'] = authToken;
            }
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
                _this.repoInfo_.host +
                pathString +
                '?' +
                'ns=' +
                _this.repoInfo_.namespace +
                util.querystring(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = util.jsonEval(xhr.responseText);
                        }
                        catch (e) {
                            warn('Failed to parse JSON response for ' +
                                url +
                                ': ' +
                                xhr.responseText);
                        }
                        callback(null, res);
                    }
                    else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) {
                            warn('Got unsuccessful REST response for ' +
                                url +
                                ' Status: ' +
                                xhr.status);
                        }
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */
var Repo = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo_
     * @param {boolean} forceRestClient
     * @param {!FirebaseApp} app
     */
    function Repo(repoInfo_, forceRestClient, app) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        // A list of data pieces and paths to be set when this client disconnects.
        this.onDisconnect_ = new SparseSnapshotTree();
        /**
         * TODO: This should be @private but it's used by test_access.js and internal.js
         * @type {?PersistentConnection}
         */
        this.persistentConnection_ = null;
        /** @type {!AuthTokenProvider} */
        var authTokenProvider = new AuthTokenProvider(app);
        this.stats_ = StatsManager.getCollection(repoInfo_);
        if (forceRestClient || beingCrawled()) {
            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        }
        else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if (typeof authOverride !== 'object') {
                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                }
                try {
                    util.stringify(authOverride);
                }
                catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function (token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
        this.transactions_init_();
        // Used for .info.
        this.infoData_ = new SnapshotHolder();
        this.infoSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function () {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function () { }
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function (query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return {string}  The URL corresponding to the root of this Firebase.
     */
    Repo.prototype.toString = function () {
        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
    };
    /**
     * @return {!string} The namespace represented by the repo.
     */
    Repo.prototype.name = function () {
        return this.repoInfo_.namespace;
    };
    /**
     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
     */
    Repo.prototype.serverTime = function () {
        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     * @return {!Object}
     */
    Repo.prototype.generateServerValues = function () {
        return generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     *
     * @private
     * @param {string} pathString
     * @param {*} data
     * @param {boolean} isMerge
     * @param {?number} tag
     */
    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new Path(pathString);
        data = this.interceptServerDataCallback_
            ? this.interceptServerDataCallback_(pathString, data)
            : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = util.map(data, function (raw) {
                    return nodeFromJSON$1(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            }
            else {
                var taggedSnap = nodeFromJSON$1(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        }
        else if (isMerge) {
            var changedChildren = util.map(data, function (raw) {
                return nodeFromJSON$1(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        }
        else {
            var snap = nodeFromJSON$1(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) {
            // Since we have a listener outstanding for each transaction, receiving any events
            // is a proxy for some change having occurred.
            affectedPath = this.rerunTransactions_(path);
        }
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    /**
     * TODO: This should be @private but it's used by test_access.js and internal.js
     * @param {?function(!string, *):*} callback
     * @private
     */
    Repo.prototype.interceptServerData_ = function (callback) {
        this.interceptServerDataCallback_ = callback;
    };
    /**
     * @param {!boolean} connectStatus
     * @private
     */
    Repo.prototype.onConnectStatus_ = function (connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) {
            this.runOnDisconnectEvents_();
        }
    };
    /**
     * @param {!Object} updates
     * @private
     */
    Repo.prototype.onServerInfoUpdate_ = function (updates) {
        var _this = this;
        each(updates, function (value, key) {
            _this.updateInfo_(key, value);
        });
    };
    /**
     *
     * @param {!string} pathString
     * @param {*} value
     * @private
     */
    Repo.prototype.updateInfo_ = function (pathString, value) {
        var path = new Path('/.info/' + pathString);
        var newNode = nodeFromJSON$1(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    /**
     * @return {!number}
     * @private
     */
    Repo.prototype.getNextWriteId_ = function () {
        return this.nextWriteId_++;
    };
    /**
     * @param {!Path} path
     * @param {*} newVal
     * @param {number|string|null} newPriority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
            var success = status === 'ok';
            if (!success) {
                warn('set at ' + path + ' failed: ' + status);
            }
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    /**
     * @param {!Path} path
     * @param {!Object} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', { path: path.toString(), value: childrenToMerge });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        util.forEach(childrenToMerge, function (changedKey, changedValue) {
            empty = false;
            var newNodeUnresolved = nodeFromJSON$1(changedValue);
            changedChildren[changedKey] = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
                var success = status === 'ok';
                if (!success) {
                    warn('update at ' + path + ' failed: ' + status);
                }
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            util.forEach(childrenToMerge, function (changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        }
        else {
            log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     * @private
     */
    Repo.prototype.runOnDisconnectEvents_ = function () {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = resolveDeferredValueTree(this.onDisconnect_, serverValues);
        var events = [];
        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
    };
    /**
     * @param {!Path} path
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.forget(path);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {*} priority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
        var _this = this;
        if (util.isEmpty(childrenToMerge)) {
            log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
            if (status === 'ok') {
                util.forEach(childrenToMerge, function (childName, childNode) {
                    var newChildNode = nodeFromJSON$1(childNode);
                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
                });
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     */
    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    /**
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration
     */
    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.interrupt(INTERRUPT_REASON);
        }
    };
    Repo.prototype.resume = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.resume(INTERRUPT_REASON);
        }
    };
    Repo.prototype.stats = function (showDelta) {
        if (showDelta === void 0) { showDelta = false; }
        if (typeof console === 'undefined')
            return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_)
                this.statsListener_ = new StatsListener(this.stats_);
            stats = this.statsListener_.get();
        }
        else {
            stats = this.stats_.get();
        }
        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        util.forEach(stats, function (stat, value) {
            // pad stat names to be the same length (plus 2 extra spaces).
            for (var i = stat.length; i < longestName + 2; i++)
                stat += ' ';
            console.log(stat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function (metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    /**
     * @param {...*} var_args
     * @private
     */
    Repo.prototype.log_ = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        var prefix = '';
        if (this.persistentConnection_) {
            prefix = this.persistentConnection_.id + ':';
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
    /**
     * @param {?function(?Error, *=)} callback
     * @param {!string} status
     * @param {?string=} errorReason
     */
    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
        if (callback) {
            exceptionGuard(function () {
                if (status == 'ok') {
                    callback(null);
                }
                else {
                    var code = (status || 'error').toUpperCase();
                    var message = code;
                    if (errorReason)
                        message += ': ' + errorReason;
                    var error = new Error(message);
                    error.code = code;
                    callback(error);
                }
            });
        }
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function () {
            return this.__database || (this.__database = new Database(this));
        },
        enumerable: true,
        configurable: true
    });
    return Repo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
var RangedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function RangedFilter(params) {
        this.indexedFilter_ = new IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getStartPost = function () {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getEndPost = function () {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */
    RangedFilter.prototype.matches = function (node) {
        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
            this.index_.compare(node, this.getEndPost()) <= 0);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            newSnap = ChildrenNode.EMPTY_NODE;
        }
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            if (!self.matches(new NamedNode(key, childNode))) {
                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
            }
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndexedFilter = function () {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getStartPost_ = function (params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        }
        else {
            return params.getIndex().minPost();
        }
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getEndPost_ = function (params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        }
        else {
            return params.getIndex().maxPost();
        }
    };
    return RangedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function LimitedFilter(params) {
        this.rangedFilter_ = new RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        if (snap.getImmediateChild(key).equals(newChild)) {
            // No change
            return snap;
        }
        else if (snap.numChildren() < this.limit_) {
            return this.rangedFilter_
                .getIndexedFilter()
                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        }
        else {
            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
        }
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        }
        else {
            if (this.limit_ * 2 < newSnap.numChildren() &&
                newSnap.isIndexed(this.index_)) {
                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
                // anchor to the startPost, endPost, or last element as appropriate
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
                }
                else {
                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
                }
                var count = 0;
                while (iterator.hasNext() && count < this.limit_) {
                    var next = iterator.getNext();
                    var inRange = void 0;
                    if (this.reverse_) {
                        inRange =
                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                    }
                    else {
                        inRange =
                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                    }
                    if (inRange) {
                        filtered = filtered.updateImmediateChild(next.name, next.node);
                        count++;
                    }
                    else {
                        // if we have reached the end post, we cannot keep adding elemments
                        break;
                    }
                }
            }
            else {
                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
                filtered = newSnap.withIndex(this.index_);
                // Don't support priorities on queries
                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
                var startPost = void 0;
                var endPost = void 0;
                var cmp = void 0;
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = filtered.getReverseIterator(this.index_);
                    startPost = this.rangedFilter_.getEndPost();
                    endPost = this.rangedFilter_.getStartPost();
                    var indexCompare_1 = this.index_.getCompare();
                    cmp = function (a, b) { return indexCompare_1(b, a); };
                }
                else {
                    iterator = filtered.getIterator(this.index_);
                    startPost = this.rangedFilter_.getStartPost();
                    endPost = this.rangedFilter_.getEndPost();
                    cmp = this.index_.getCompare();
                }
                var count = 0;
                var foundStartPost = false;
                while (iterator.hasNext()) {
                    var next = iterator.getNext();
                    if (!foundStartPost && cmp(startPost, next) <= 0) {
                        // start adding
                        foundStartPost = true;
                    }
                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                    if (inRange) {
                        count++;
                    }
                    else {
                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
                    }
                }
            }
        }
        return this.rangedFilter_
            .getIndexedFilter()
            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndexedFilter = function () {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */
    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function (a, b) { return indexCmp_1(b, a); };
        }
        else {
            cmp = this.index_.getCompare();
        }
        var oldEventCache = snap;
        util.assert(oldEventCache.numChildren() == this.limit_, '');
        var newChildNamedNode = new NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_
            ? oldEventCache.getFirstChild(this.index_)
            : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while (nextChild != null &&
                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
                // been applied to the limited filter yet. Ignore this next child which will be updated later in
                // the limited filter...
                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            }
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            }
            else {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
                }
                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) {
                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
                    }
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                }
                else {
                    return newEventCache;
                }
            }
        }
        else if (childSnap.isEmpty()) {
            // we're deleting a node, but it was not in the window, so ignore it
            return snap;
        }
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache
                    .updateImmediateChild(childKey, childSnap)
                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
            }
            else {
                return snap;
            }
        }
        else {
            return snap;
        }
    };
    return LimitedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
var QueryParams = /** @class */ (function () {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasStart = function () {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */
    QueryParams.prototype.isViewFromLeft = function () {
        if (this.viewFrom_ === '') {
            // limit(), rather than limitToFirst or limitToLast was called.
            // This means that only one of startSet_ and endSet_ is true. Use them
            // to calculate which side of the view to anchor to. If neither is set,
            // anchor to the end.
            return this.startSet_;
        }
        else {
            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
        }
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */
    QueryParams.prototype.getIndexStartValue = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexStartName = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) {
            return this.indexStartName_;
        }
        else {
            return MIN_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasEnd = function () {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */
    QueryParams.prototype.getIndexEndValue = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexEndName = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) {
            return this.indexEndName_;
        }
        else {
            return MAX_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasLimit = function () {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */
    QueryParams.prototype.hasAnchoredLimit = function () {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */
    QueryParams.prototype.getLimit = function () {
        util.assert(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */
    QueryParams.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */
    QueryParams.prototype.copy_ = function () {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limit = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToFirst = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToLast = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.startAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (indexValue === undefined) {
            indexValue = null;
        }
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        }
        else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.endAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (indexValue === undefined) {
            indexValue = null;
        }
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        }
        else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */
    QueryParams.prototype.orderBy = function (index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */
    QueryParams.prototype.getQueryObject = function () {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
            }
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
            }
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                }
                else {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
                }
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== PRIORITY_INDEX) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        }
        return obj;
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.loadsAllData = function () {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.isDefault = function () {
        return this.loadsAllData() && this.index_ == PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */
    QueryParams.prototype.getNodeFilter = function () {
        if (this.loadsAllData()) {
            return new IndexedFilter(this.getIndex());
        }
        else if (this.hasLimit()) {
            return new LimitedFilter(this);
        }
        else {
            return new RangedFilter(this);
        }
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */
    QueryParams.prototype.toRestQueryStringParameters = function () {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) {
            return qs;
        }
        var orderBy;
        if (this.index_ === PRIORITY_INDEX) {
            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        }
        else if (this.index_ === VALUE_INDEX) {
            orderBy = REST_CONSTANTS.VALUE_INDEX;
        }
        else if (this.index_ === KEY_INDEX) {
            orderBy = REST_CONSTANTS.KEY_INDEX;
        }
        else {
            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
            if (this.startNameSet_) {
                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
            }
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
            if (this.endNameSet_) {
                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
            }
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) {
                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            }
            else {
                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
            }
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */
    QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Reference = /** @class */ (function (_super) {
    tslib_1.__extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */
    function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof Repo)) {
            throw new Error('new Reference() no longer supported - use app.database().');
        }
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */
    Reference.prototype.getKey = function () {
        util.validateArgCount('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty())
            return null;
        else
            return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */
    Reference.prototype.child = function (pathString) {
        util.validateArgCount('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') {
            pathString = String(pathString);
        }
        else if (!(pathString instanceof Path)) {
            if (this.path.getFront() === null)
                validateRootPathString('Reference.child', 1, pathString, false);
            else
                validatePathString('Reference.child', 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */
    Reference.prototype.getParent = function () {
        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */
    Reference.prototype.getRoot = function () {
        util.validateArgCount('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while (ref.getParent() !== null) {
            ref = ref.getParent();
        }
        return ref;
    };
    /** @return {!Database} */
    Reference.prototype.databaseProp = function () {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.set = function (newVal, onComplete) {
        util.validateArgCount('Reference.set', 1, 2, arguments.length);
        validateWritablePath('Reference.set', this.path);
        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
        util.validateCallback('Reference.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, 
        /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('Reference.update', 1, 2, arguments.length);
        validateWritablePath('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to Firebase.update() is deprecated. ' +
                'Use set() if you want to overwrite the existing data, or ' +
                'an Object with integer keys if you really do want to ' +
                'only update some of the children.');
        }
        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
        util.validateCallback('Reference.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('Reference.setWithPriority', this.path);
        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
        validatePriority('Reference.setWithPriority', 2, newPriority, false);
        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.setWithPriority failed: ' +
                this.getKey() +
                ' is a read-only object.';
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.remove = function (onComplete) {
        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
        validateWritablePath('Reference.remove', this.path);
        util.validateCallback('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */
    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
        validateWritablePath('Reference.transaction', this.path);
        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
        util.validateCallback('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        validateBoolean('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.transaction failed: ' +
                this.getKey() +
                ' is a read-only object.';
        if (applyLocally === undefined)
            applyLocally = true;
        var deferred = new util.Deferred();
        if (typeof onComplete === 'function') {
            deferred.promise.catch(function () { });
        }
        var promiseComplete = function (error, committed, snapshot) {
            if (error) {
                deferred.reject(error);
            }
            else {
                deferred.resolve(new TransactionResult(committed, snapshot));
            }
            if (typeof onComplete === 'function') {
                onComplete(error, committed, snapshot);
            }
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setPriority = function (priority, onComplete) {
        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
        validateWritablePath('Reference.setPriority', this.path);
        validatePriority('Reference.setPriority', 1, priority, false);
        util.validateCallback('Reference.setPriority', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */
    Reference.prototype.push = function (value, onComplete) {
        util.validateArgCount('Reference.push', 0, 2, arguments.length);
        validateWritablePath('Reference.push', this.path);
        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
        util.validateCallback('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) {
            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
        }
        else {
            promise = Promise.resolve(pushRef);
        }
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') {
            promise.catch(function () { });
        }
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */
    Reference.prototype.onDisconnect = function () {
        validateWritablePath('Reference.onDisconnect', this.path);
        return new OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function () {
            return this.databaseProp();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function () {
            return this.getKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function () {
            return this.getParent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function () {
            return this.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    return Reference;
}(Query));
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */
Query.__referenceConstructor = Reference;
SyncPoint.__referenceConstructor = Reference;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Node in a Tree.
 */
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}());
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */
var Tree = /** @class */ (function () {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */
    function Tree(name_, parent_, node_) {
        if (name_ === void 0) { name_ = ''; }
        if (parent_ === void 0) { parent_ = null; }
        if (node_ === void 0) { node_ = new TreeNode(); }
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */
    Tree.prototype.subTree = function (pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
        var child = this, next;
        while ((next = path.getFront()) !== null) {
            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */
    Tree.prototype.getValue = function () {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */
    Tree.prototype.setValue = function (value) {
        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */
    Tree.prototype.clear = function () {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */
    Tree.prototype.hasChildren = function () {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */
    Tree.prototype.isEmpty = function () {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachChild = function (action) {
        var _this = this;
        util.forEach(this.node_.children, function (child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */
    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst)
            action(this);
        this.forEachChild(function (child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst)
            action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */
    Tree.prototype.forEachAncestor = function (action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while (node !== null) {
            if (action(node)) {
                return true;
            }
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
        this.forEachChild(function (child) {
            if (child.getValue() !== null)
                action(child);
            else
                child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */
    Tree.prototype.path = function () {
        return new Path(this.parent_ === null
            ? this.name_
            : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */
    Tree.prototype.name = function () {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */
    Tree.prototype.parent = function () {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */
    Tree.prototype.updateParents_ = function () {
        if (this.parent_ !== null)
            this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */
    Tree.prototype.updateChild_ = function (childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = util.contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        }
        else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus;
(function (TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
Repo.prototype.transactions_init_ = function () {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */
    this.transactionQueueTree_ = new Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function () { };
    var watchRef = new Reference(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function () {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    }
    else {
        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === 'object' &&
            newVal !== null &&
            util.contains(newVal, '.priority')) {
            priorityForNode = util.safeGet(newVal, '.priority');
            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
                'Priority must be a valid string, finite number, server value, or null.');
        }
        else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
                ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode /** @type {null|number|string} */ = priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
Repo.prototype.getLatestState_ = function (path, excludeSets) {
    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
        ChildrenNode.EMPTY_NODE);
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */
Repo.prototype.sendReadyTransactions_ = function (node) {
    var _this = this;
    if (node === void 0) { node = this.transactionQueueTree_; }
    // Before recursing, make sure any completed transactions are removed.
    if (!node) {
        this.pruneCompletedTransactionsBelowNode_(node);
    }
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        util.assert(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) {
            this.sendTransactionQueue_(node.path(), queue);
        }
    }
    else if (node.hasChildren()) {
        node.forEachChild(function (childNode) {
            _this.sendReadyTransactions_(childNode);
        });
    }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */
Repo.prototype.sendTransactionQueue_ = function (path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function (txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for (var i = 0; i < queue.length; i++) {
        var txn = queue[i];
        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for (var i = 0; i < queue.length; i++) {
                queue[i].status = TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new Reference(_this, queue[i].path);
                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for (var i = 0; i < callbacks.length; i++) {
                exceptionGuard(callbacks[i]);
            }
        }
        else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for (var i = 0; i < queue.length; i++) {
                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
                        queue[i].status = TransactionStatus.NEEDS_ABORT;
                    else
                        queue[i].status = TransactionStatus.RUN;
                }
            }
            else {
                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for (var i = 0; i < queue.length; i++) {
                    queue[i].status = TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
Repo.prototype.rerunTransactions_ = function (changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
    if (queue.length === 0) {
        return; // Nothing to do!
    }
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function (q) {
        return q.status === TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function (q) {
        return q.currentWriteId;
    });
    for (var i = 0; i < queue.length; i++) {
        var transaction = queue[i];
        var relativePath = Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        }
        else if (transaction.status === TransactionStatus.RUN) {
            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            }
            else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = nodeFromJSON$1(newData);
                    var hasExplicitPriority = typeof newData === 'object' &&
                        newData != null &&
                        util.contains(newData, '.priority');
                    if (!hasExplicitPriority) {
                        // Keep the old priority if there wasn't a priority explicitly specified.
                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    }
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                }
                else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function (unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                }
                else {
                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
                }
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for (var i = 0; i < callbacks.length; i++) {
        exceptionGuard(callbacks[i]);
    }
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */
Repo.prototype.getAncestorTransactionNode_ = function (path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    while ((front = path.getFront()) !== null &&
        transactionNode.getValue() === null) {
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */
Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function (a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */
Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) {
        for (var i = 0; i < nodeQueue.length; i++) {
            queue.push(nodeQueue[i]);
        }
    }
    node.forEachChild(function (child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */
Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for (var from = 0; from < queue.length; from++) {
            if (queue[from].status !== TransactionStatus.COMPLETED) {
                queue[to] = queue[from];
                to++;
            }
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function (childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
Repo.prototype.abortTransactions_ = function (path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */
Repo.prototype.abortTransactionsOnNode_ = function (node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) ;
            else if (queue[i].status === TransactionStatus.SENT) {
                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            }
            else {
                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) {
            // We're not waiting for any sent transactions.  We can clear the queue.
            node.setValue(null);
        }
        else {
            // Remove the transactions we aborted.
            queue.length = lastSent + 1;
        }
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for (var i = 0; i < callbacks.length; i++) {
            exceptionGuard(callbacks[i]);
        }
    }
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** @const {string} */
var DATABASE_URL_OPTION = 'databaseURL';
var _staticInstance;
/**
 * Creates and caches Repo instances.
 */
var RepoManager = /** @class */ (function () {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */
        this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */
        this.useRestClient_ = false;
    }
    RepoManager.getInstance = function () {
        if (!_staticInstance) {
            _staticInstance = new RepoManager();
        }
        return _staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].interrupt();
            }
        }
    };
    RepoManager.prototype.resume = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].resume();
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */
    RepoManager.prototype.databaseFromApp = function (app, url) {
        var dbUrl = url || app.options[DATABASE_URL_OPTION];
        if (dbUrl === undefined) {
            fatal("Can't determine Firebase Database URL.  Be sure to include " +
                DATABASE_URL_OPTION +
                ' option when calling firebase.initializeApp().');
        }
        var parsedUrl = parseRepoInfo(dbUrl);
        var repoInfo = parsedUrl.repoInfo;
        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) {
            fatal('Database URL must point to the root of a Firebase Database ' +
                '(not including a child path).');
        }
        var repo = this.createRepo(repoInfo, app);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */
    RepoManager.prototype.deleteRepo = function (repo) {
        var appRepos = util.safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        }
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */
    RepoManager.prototype.createRepo = function (repoInfo, app) {
        var appRepos = util.safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = util.safeGet(appRepos, repoInfo.toURLString());
        if (repo) {
            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        }
        repo = new Repo(repoInfo, this.useRestClient_, app);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */
    RepoManager.prototype.forceRestClient = function (forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */
var Database = /** @class */ (function () {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */
    function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof Repo)) {
            fatal("Don't call new Database() directly - please use firebase.database().");
        }
        /** @type {Reference} */
        this.root_ = new Reference(repo_, Path.Empty);
        this.INTERNAL = new DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function () {
            return this.repo_.app;
        },
        enumerable: true,
        configurable: true
    });
    Database.prototype.ref = function (path) {
        this.checkDeleted_('ref');
        util.validateArgCount('database.ref', 0, 1, arguments.length);
        if (path instanceof Reference) {
            return this.refFromURL(path.toString());
        }
        return path !== undefined ? this.root_.child(path) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.refFromURL = function (url) {
        /** @const {string} */
        var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        util.validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = parseRepoInfo(url);
        validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) {
            fatal(apiName +
                ': Host name does not match the current database: ' +
                '(found ' +
                repoInfo.host +
                ' but expected ' +
                this.repo_.repoInfo_.host +
                ')');
        }
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */
    Database.prototype.checkDeleted_ = function (apiName) {
        if (this.repo_ === null) {
            fatal('Cannot call ' + apiName + ' on a deleted database.');
        }
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function () {
        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function () {
        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        }
    };
    return Database;
}());
var DatabaseInternals = /** @class */ (function () {
    /** @param {!Database} database */
    function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */
    DatabaseInternals.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.database.checkDeleted_('delete');
                RepoManager.getInstance().deleteRepo(this.database.repo_);
                this.database.repo_ = null;
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [2 /*return*/];
            });
        });
    };
    return DatabaseInternals;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
var forceLongPolling = function () {
    WebSocketConnection.forceDisallow();
    BrowserPollConnection.forceAllow();
};
var forceWebSockets = function () {
    BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
var isWebSocketsAvailable = function () {
    return WebSocketConnection['isAvailable']();
};
var setSecurityDebugCallback = function (ref, callback) {
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var stats = function (ref, showDelta) {
    ref.repo.stats(showDelta);
};
var statsIncrementCounter = function (ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var dataUpdateCount = function (ref) {
    return ref.repo.dataUpdateCount;
};
var interceptServerData = function (ref, callback) {
    return ref.repo.interceptServerData_(callback);
};

var INTERNAL = /*#__PURE__*/Object.freeze({
  forceLongPolling: forceLongPolling,
  forceWebSockets: forceWebSockets,
  isWebSocketsAvailable: isWebSocketsAvailable,
  setSecurityDebugCallback: setSecurityDebugCallback,
  stats: stats,
  statsIncrementCounter: statsIncrementCounter,
  dataUpdateCount: dataUpdateCount,
  interceptServerData: interceptServerData
});

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataConnection = PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
    this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
PersistentConnection.prototype.echo = function (data, onEcho) {
    this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var RealTimeConnection = Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
var hijackHash = function (newHash) {
    var oldPut = PersistentConnection.prototype.put;
    PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
        if (opt_hash !== undefined) {
            opt_hash = newHash();
        }
        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
    };
    return function () {
        PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
var ConnectionTarget = RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
var queryIdentifier = function (query) {
    return query.queryIdentifier();
};
/**
 * @param {!Query} firebaseRef
 * @return {!Object}
 */
var listens = function (firebaseRef) {
    return firebaseRef.repo.persistentConnection_.listens_;
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
var forceRestClient = function (forceRestClient) {
    RepoManager.getInstance().forceRestClient(forceRestClient);
};

var TEST_ACCESS = /*#__PURE__*/Object.freeze({
  DataConnection: DataConnection,
  RealTimeConnection: RealTimeConnection,
  hijackHash: hijackHash,
  ConnectionTarget: ConnectionTarget,
  queryIdentifier: queryIdentifier,
  listens: listens,
  forceRestClient: forceRestClient
});

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ServerValue = Database.ServerValue;
function registerDatabase(instance) {
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager.getInstance().databaseFromApp(app, url); }, 
    // firebase.database namespace properties
    {
        Reference: Reference,
        Query: Query,
        Database: Database,
        DataSnapshot: DataSnapshot,
        enableLogging: enableLogging,
        INTERNAL: INTERNAL,
        ServerValue: ServerValue,
        TEST_ACCESS: TEST_ACCESS
    }, null, true);
    if (util.isNodeSdk()) {
        module.exports = namespace;
    }
}
registerDatabase(firebase);

exports.DataSnapshot = DataSnapshot;
exports.Database = Database;
exports.OnDisconnect = OnDisconnect;
exports.Query = Query;
exports.Reference = Reference;
exports.ServerValue = ServerValue;
exports.enableLogging = enableLogging;
exports.registerDatabase = registerDatabase;
//# sourceMappingURL=index.cjs.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(794)))

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('OfferResource', ["$resource", function ($resource) {
    var baseUrl = location.origin;
    return $resource(baseUrl + '/rest/offers', {}, {
        listCompanyOfferUsages: { method: 'GET', isArray: false, url: baseUrl + '/rest/offers/usage-history-per-offer' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('OfferService', ["OfferResource", function (OfferResource) {
    return {
        allOffers: [],
        findAll: function findAll() {
            return OfferResource.query().$promise;
        },
        computeUsageHistoryPerOffer: function computeUsageHistoryPerOffer(companyCode) {
            return OfferResource.listCompanyOfferUsages({ companyCode: companyCode }).$promise;
        }
    };
}]);

angular.module('FlexyBeautyApp.services').factory('Offer', [function () {
    return {
        code: '',
        label: '',
        storeAppCodes: [],
        price: 0.0,
        position: 0,
        timeCreated: 0,
        timeModified: 0
    };
}]);

/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel)
        return;
    var now = new Date().toISOString();
    switch (logType) {
        /**
         * By default, `console.debug` is not displayed in the developer console (in
         * chrome). To avoid forcing users to have to opt-in to these logs twice
         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
         * logs to the `console.log` function.
         */
        case LogLevel.DEBUG:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.VERBOSE:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.INFO:
            console.info.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.WARN:
            console.warn.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.ERROR:
            console.error.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        default:
            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The log handler for the Logger instance.
         */
        this._logHandler = defaultLogHandler;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError('Invalid value assigned to `logLevel`');
            }
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
    };
    return Logger;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.logLevel = level;
    });
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('Partner_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/partners/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        generateSessionToken: { method: 'POST', url: baseUrl + 'rest/partners/generateSessionToken' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Partner', ["Partner_Resource", "PartnerData", function (Partner_Resource, PartnerData) {
    var Partner = function Partner(resource) {
        this.id = null;
        this.isDeleted = false;
        this.name = null;
        this.token = null;

        if (resource !== undefined && resource !== null) this.loadObject(resource);

        PartnerData.add(this);
    };

    Partner.prototype.setId = function (id) {
        this.id = id;
    };
    Partner.prototype.getId = function () {
        return this.id;
    };

    Partner.prototype.loadObject = function (object) {
        if (object) {
            if (!this.id) this.id = object.id;
            /*if (object.timeCreated)
                this.timeCreated = new Date(object.timeCreated);*/
            this.isDeleted = object.isDeleted;
            this.name = object.name;
            this.token = object.token;
        }
    };

    Partner.prototype.getObjectResource = function (object) {
        var newApp = new Partner_Resource();

        newApp.id = this.id;
        newApp.isDeleted = this.isDeleted;
        newApp.name = this.name;
        newApp.token = this.token;

        return newApp;
    };

    return Partner;
}]);

angular.module('FlexyBeautyApp.services').factory('PartnerSrv', ["$log", "ServerSrv", "Partner_Resource", "PartnerData", "Partner", function ($log, ServerSrv, Partner_Resource, PartnerData, Partner) {
    var partnerSrv = {};

    partnerSrv.query = function (successFunction, errorFunction) {
        Partner_Resource.query({}, function (data) {
            PartnerData.clear();
            for (var i = 0; i < data.length; i++) {
                new Partner(data[i]);
            }

            if (successFunction !== undefined) successFunction();
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    partnerSrv.restore = function (partner, successFunction, errorFunction) {
        PartnerData.restore(partner);
        ServerSrv.startSavingProcess(partnerSrv.restoreSync, partner, successFunction, errorFunction);
    };
    partnerSrv.restoreSync = function (partner, successFunction, errorFunction) {
        //$timeout (function () {

        var PartnerRes = partner.getObjectResource();
        PartnerRes.$save({}, function (data) {
            try {
                partner.setId(data.id);
                //TODO UserActionData.add(data.userAction);
                if (successFunction != undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    partnerSrv.save = function (partner, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(partnerSrv.saveSync, partner, successFunction, errorFunction);
    };
    partnerSrv.saveSync = function (partner, successFunction, errorFunction) {
        var partnerRes = partner.getObjectResource();
        partnerRes.$save({}, function (data) {
            try {
                partner.setId(data.id);
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    partnerSrv.remove = function (partner, successFunction, errorFunction) {
        PartnerData.remove(partner);
        ServerSrv.startSavingProcess(partnerSrv.removeSync, partner, successFunction, errorFunction);
    };
    partnerSrv.generateSessionToken = function (partner, external, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(partnerSrv.generateSessionTokenSync, partner, external, successFunction, errorFunction);
    };
    partnerSrv.generateSessionTokenSync = function (partner, external, successFunction, errorFunction) {
        var partnerRes = new Partner_Resource();
        partnerRes.idPartner = partner.id;
        partnerRes.external = external;
        partnerRes.$generateSessionToken({}, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    partnerSrv.removeSync = function (partner, successFunction, errorFunction) {
        var partnerRes = partner.getObjectResource();
        partnerRes.$remove({ id: partner.getId() }, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    return partnerSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('PartnerData', ["$filter", function ($filter) {
    var partnerDataSrv = {
        indexPartners: [],
        activePartners: [],
        deletedPartners: [] //deleted items
    };
    partnerDataSrv.getById = function (partnerId) {
        for (var i = 0; i < this.indexPartners.length; i++) {
            if (this.indexPartners[i].id == partnerId) return this.indexPartners[i];
        }return null;
    };
    partnerDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexPartners.length) return this.indexPartners[index];
        return null;
    };
    partnerDataSrv.getIndexOf = function (partner) {
        if (partner) return this.indexPartners.indexOf(partner);
        return -1;
    };

    partnerDataSrv.add = function (partner) {
        var partnerArray = this.activePartners;
        if (partner.isDeleted) partnerArray = this.deletedPartners;
        var index = this.indexPartners.indexOf(partner);
        if (index != -1) {
            var realIndex = partnerArray.indexOf(partner);
            if (realIndex == -1) partnerArray.push(partner);
        } else {
            index = this.indexPartners.length;
            this.indexPartners.push(partner);
            partnerArray.push(partner);
        }
        return index;
    };
    partnerDataSrv.remove = function (partner) {
        var index = this.activePartners.indexOf(partner);
        if (index != -1) {
            this.activePartners.splice(index, 1);
            this.deletedPartners.push(partner);
            partner.isDeleted = true;
        }
    };
    partnerDataSrv.restore = function (partner) {
        var index = this.deletedPartners.indexOf(partner);
        if (index != -1) {
            this.deletedPartners.splice(index, 1);
            this.activePartners.push(partner);
            partner.isDeleted = false;
        }
    };
    partnerDataSrv.clear = function () {
        this.indexPartners = [];
        this.activePartners = [];
        this.deletedPartners = [];
    };
    partnerDataSrv.sort = function () {
        this.activePartners = $filter('orderBy')(this.activePartners, 'label', false);
        this.deletedPartners = $filter('orderBy')(this.deletedPartners, 'label', false);
    };

    partnerDataSrv.getActiveList = function () {
        return this.activePartners;
    };
    partnerDataSrv.getDeletedList = function () {
        return this.deletedPartners;
    };
    return partnerDataSrv;
}]);

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('StoreApp_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/storeApps/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('StoreApp', ["StoreApp_Resource", "StoreAppData", function (StoreApp_Resource, StoreAppData) {
    var StoreApp = function StoreApp(resource) {
        this.id = null;
        this.isDeleted = false;
        this.code = null;
        this.order = null;
        this.label = null;
        this.isActiveByDefault = true;
        this.isChangeable = true;
        this.type = null; //subscription,usageBased,discount
        this.status = null; //released / beta / future
        this.usageLabel = null;
        this.isVisibleForCustomers = true;
        this.mandatoryBases = "";
        this.description = null;
        this.videoUrl = null;
        this.price = null;
        this.percentDiscount = null;
        this.trialTime = null;
        this.propagateStoreAppSettings = false;
        this.isMain = false;

        if (resource !== undefined && resource !== null) this.loadObject(resource);

        StoreAppData.add(this);
    };

    StoreApp.prototype.setId = function (id) {
        this.id = id;
    };
    StoreApp.prototype.getId = function () {
        return this.id;
    };

    StoreApp.prototype.loadObject = function (object) {
        if (object) {
            if (!this.id) this.id = object.id;
            if (object.timeCreated) this.timeCreated = new Date(object.timeCreated);
            this.isDeleted = object.isDeleted;
            this.code = object.code;
            this.label = object.label;
            this.order = object.order;
            this.isActiveByDefault = object.isActiveByDefault;
            this.isChangeable = object.isChangeable;
            this.type = object.type;
            this.status = object.status;
            this.usageLabel = object.usageLabel;
            this.isVisibleForCustomers = object.isVisibleForCustomers;
            this.mandatoryBases = object.mandatoryBases;
            this.description = object.description;
            this.videoUrl = object.videoUrl;
            this.price = object.price;
            this.percentDiscount = object.percentDiscount;
            this.trialTime = object.trialTime;
            this.isMain = object.isMain;
        }
    };

    StoreApp.prototype.getObjectResource = function (object) {
        var newApp = new StoreApp_Resource();

        newApp.id = this.id;
        newApp.isDeleted = this.isDeleted;
        newApp.code = this.code;
        newApp.label = this.label;
        newApp.order = this.order;
        newApp.isActiveByDefault = this.isActiveByDefault;
        newApp.isChangeable = this.isChangeable;
        newApp.type = this.type;
        newApp.status = this.status;
        newApp.usageLabel = this.usageLabel;
        newApp.isVisibleForCustomers = this.isVisibleForCustomers;
        newApp.mandatoryBases = this.mandatoryBases;
        newApp.description = this.description;
        newApp.videoUrl = this.videoUrl;
        newApp.price = this.price;
        newApp.percentDiscount = this.percentDiscount;
        newApp.trialTime = this.trialTime;
        newApp.propagateStoreAppSettings = this.propagateStoreAppSettings; //one time only
        this.propagateStoreAppSettings = false;
        newApp.isMain = this.isMain;
        return newApp;
    };

    return StoreApp;
}]);

angular.module('FlexyBeautyApp.services').factory('StoreAppSrv', ["$log", "ServerSrv", "StoreApp_Resource", "StoreAppData", "StoreApp", function ($log, ServerSrv, StoreApp_Resource, StoreAppData, StoreApp) {
    var storeAppSrv = {};

    storeAppSrv.query = function (successFunction, errorFunction) {
        StoreApp_Resource.query({}, //params
        function (data) {
            StoreAppData.clear();
            for (var i = 0; i < data.length; i++) {
                new StoreApp(data[i]);
            }

            if (successFunction !== undefined) successFunction();
        }, function (data) {
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    storeAppSrv.save = function (storeApp, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(storeAppSrv.saveSync, storeApp, successFunction, errorFunction);
    };
    storeAppSrv.saveSync = function (storeApp, successFunction, errorFunction) {
        var storeAppRes = storeApp.getObjectResource();
        storeAppRes.$save({}, //no params
        function (data) {
            try {
                storeApp.setId(data.id);
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    storeAppSrv.remove = function (storeApp, successFunction, errorFunction) {
        StoreAppData.remove(storeApp);
        ServerSrv.startSavingProcess(storeAppSrv.removeSync, storeApp, successFunction, errorFunction);
    };
    storeAppSrv.removeSync = function (storeApp, successFunction, errorFunction) {
        //$timeout (function () {

        var storeAppRes = storeApp.getObjectResource();
        storeAppRes.$remove({ id: storeApp.getId() }, //no params
        function (data) {
            try {
                if (successFunction !== undefined) successFunction(data);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //error handling goes here
            try {
                if (errorFunction !== undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };

    return storeAppSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('StoreAppData', ["$filter", function ($filter) {
    var storeAppDataSrv = {
        indexStoreApps: [],
        activeStoreApps: [],
        deletedStoreApps: [] //deleted items
    };
    storeAppDataSrv.getById = function (storeAppId) {
        for (var i = 0; i < this.indexStoreApps.length; i++) {
            if (this.indexStoreApps[i].id == storeAppId) return this.indexStoreApps[i];
        }return null;
    };
    storeAppDataSrv.getByCode = function (storeAppCode) {
        for (var i = 0; i < this.indexStoreApps.length; i++) {
            if (this.indexStoreApps[i].code == storeAppCode) return this.indexStoreApps[i];
        }return null;
    };
    storeAppDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexStoreApps.length) return this.indexStoreApps[index];
        return null;
    };
    storeAppDataSrv.getIndexOf = function (storeApp) {
        if (storeApp) return this.indexStoreApps.indexOf(storeApp);
        return -1;
    };

    storeAppDataSrv.add = function (storeApp) {
        var storeAppArray = this.activeStoreApps;
        if (storeApp.isDeleted) storeAppArray = this.deletedStoreApps;
        var index = this.indexStoreApps.indexOf(storeApp);
        if (index != -1) {
            var realIndex = storeAppArray.indexOf(storeApp);
            if (realIndex == -1) storeAppArray.push(storeApp);
        } else {
            index = this.indexStoreApps.length;
            this.indexStoreApps.push(storeApp);
            storeAppArray.push(storeApp);
        }
        return index;
    };
    storeAppDataSrv.remove = function (storeApp) {
        var index = this.activeStoreApps.indexOf(storeApp);
        if (index != -1) {
            this.activeStoreApps.splice(index, 1);
            this.deletedStoreApps.push(storeApp);
            storeApp.isDeleted = true;
        }
    };
    storeAppDataSrv.restore = function (storeApp) {
        var index = this.deletedStoreApps.indexOf(storeApp);
        if (index != -1) {
            this.deletedStoreApps.splice(index, 1);
            this.activeStoreApps.push(storeApp);
            storeApp.isDeleted = false;
        }
    };
    storeAppDataSrv.clear = function () {
        this.indexStoreApps = [];
        this.activeStoreApps = [];
        this.deletedStoreApps = [];
    };
    storeAppDataSrv.sort = function () {
        this.activeStoreApps = $filter('orderBy')(this.activeStoreApps, 'label', false);
        this.deletedStoreApps = $filter('orderBy')(this.deletedStoreApps, 'label', false);
    };

    storeAppDataSrv.getActiveList = function () {
        return this.activeStoreApps;
    };
    storeAppDataSrv.getDeletedList = function () {
        return this.deletedStoreApps;
    };
    return storeAppDataSrv;
}]);

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * Subscription: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Subscription_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/subscriptions/:id', {}, {
        query: { method: 'GET', isArray: true },
        update: { method: 'POST', url: 'rest/subscription/store-app/:storeAppCode' },
        create: { method: 'PUT', url: 'rest/subscription/store-app/:storeAppCode' },
        get: { method: 'GET' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Subscription', ["Subscription_Resource", "StoreAppData", "SubscriptionData", function (Subscription_Resource, StoreAppData, SubscriptionData) {
    //Subscription inherit of $resource

    var Subscription = function Subscription(resource, company) {
        // Call the parent constructor
        this.id = null;
        this.timeCreated = null;
        this.isDeleted = false;
        this.company = company;
        this.storeApp = null;
        this._storeAppId = null;
        this.isActive = null;
        this.price = null;
        this.trialTime = null;
        this.percentDiscount = 0;
        this.historyUsages = [];
        this.annualInvoiceNumber = null;
        if (resource !== undefined && resource != null) {
            if (resource.timeCreated) {
                this.timeCreated = new Date(resource.timeCreated);
            }
            if (!this.id) {
                this.id = resource.id;
            }
            this._storeAppId = resource.storeAppId;
            this.isActive = resource.isActive;
            this.price = resource.price;
            this.percentDiscount = resource.percentDiscount;
            this.trialTime = resource.trialTime;
            this.annualInvoiceNumber = resource.annualInvoiceNumber;
            var usage = void 0;
            if (resource.historyUsages) {
                for (var i = 0; i < resource.historyUsages.length; i++) {
                    usage = { startDate: null, endDate: null };
                    if (resource.historyUsages[i].startDate) {
                        usage.startDate = new Date(resource.historyUsages[i].startDate);
                    }
                    if (resource.historyUsages[i].endDate) {
                        usage.endDate = new Date(resource.historyUsages[i].endDate);
                    }
                    this.historyUsages.push(usage);
                }
            }
        }
        SubscriptionData.add(this);
    };

    Subscription.prototype.getObjectResource = function () {
        var rsSub = new Subscription_Resource();
        rsSub.id = this.id;
        if (this.storeApp) rsSub.storeAppId = this.storeApp.id;

        if (this.company) rsSub.companyCode = this.company.code;
        rsSub.isActive = this.isActive;
        rsSub.price = this.price;
        rsSub.percentDiscount = this.percentDiscount;
        rsSub.trialTime = this.trialTime;
        rsSub.annualInvoiceNumber = this.annualInvoiceNumber;
        return rsSub;
    };

    Subscription.prototype.getSavingObjectResource = function () {
        var rsSub = new Subscription_Resource();
        if (this.storeApp) {
            rsSub.storeAppId = this.storeApp.id;
        }
        rsSub.isActive = this.isActive;
        rsSub.price = this.price;
        return rsSub;
    };

    Subscription.prototype.loadRef = function () {
        this.storeApp = StoreAppData.getById(this._storeAppId);
    };
    return Subscription;
}]);

angular.module('FlexyBeautyApp.services').factory('SubscriptionSrv', ["$log", "Subscription_Resource", "Subscription", "ServerSrv", "InvoiceSrv", function ($log, Subscription_Resource, Subscription, ServerSrv, InvoiceSrv) {
    var subscriptionSrv = {};

    subscriptionSrv.create = function (subscription, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(subscriptionSrv.createSync, subscription, successFunction, errorFunction);
    };

    subscriptionSrv.createSync = function (subscription, successFunction, errorFunction) {
        var subscriptionRes = subscription.getSavingObjectResource();
        subscriptionRes.$create({ storeAppCode: subscription.storeApp.code }, function (data) {
            try {
                if (subscription.company) {
                    InvoiceSrv.generateEstimateInvoice(subscription.company);
                }
                subscription.id = data.id;
                if (successFunction != undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction != undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };

    subscriptionSrv.update = function (subscription, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(subscriptionSrv.updateSync, subscription, successFunction, errorFunction);
    };

    subscriptionSrv.updateSync = function (subscription, successFunction, errorFunction) {
        var subscriptionRes = subscription.getSavingObjectResource();
        subscriptionRes.$update({ storeAppCode: subscription.storeApp.code }, function (data) {
            try {
                if (subscription.company) {
                    InvoiceSrv.generateEstimateInvoice(subscription.company);
                }
                if (successFunction != undefined) {
                    successFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            try {
                if (errorFunction != undefined) {
                    errorFunction(data);
                }
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });
    };
    return subscriptionSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('SubscriptionData', ["$log", function ($log) {
    var subscriptionData = {
        indexActivities: []
    };
    subscriptionData.getById = function (subscriptionId) {
        for (var i = 0; i < this.indexActivities.length; i++) {
            if (this.indexActivities[i].id == subscriptionId) return this.indexActivities[i];
        }return null;
    };
    subscriptionData.getByCode = function (subscriptionCode) {
        for (var i = 0; i < this.indexActivities.length; i++) {
            if (this.indexActivities[i].code == subscriptionCode) return this.indexActivities[i];
        }return null;
    };
    subscriptionData.getIndexOf = function (subscription) {
        if (subscription) return this.indexActivities.indexOf(subscription);
        return -1;
    };
    subscriptionData.getByIndex = function (index) {
        if (index >= 0 && index < this.indexActivities.length) return this.indexActivities[index];else return null;
    };
    subscriptionData.add = function (subscription) {
        this.indexActivities.push(subscription);
        return this.indexActivities.length - 1;
    };
    subscriptionData.clear = function () {
        subscriptionData.indexActivities = [];
    };

    return subscriptionData;
}]);

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('User_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/users/:id', {}, {
        query: { method: 'GET', isArray: true },
        listAdmin: { method: 'GET', url: baseUrl + 'rest/users/listAdmin', isArray: true },
        get: { method: 'GET' },
        login: { method: 'POST', url: baseUrl + 'rest/users/login' },
        loginAnonymous: { method: 'POST', url: baseUrl + 'rest/users/loginAnonymous' },
        loginAsAdmin: { method: 'POST', url: baseUrl + 'rest/users/loginAsAdmin' },
        loginAsGroup: { method: 'POST', url: baseUrl + 'rest/users/loginAsGroup' },
        logout: { method: 'POST', url: baseUrl + 'rest/users/logout' },
        createChannel: { method: 'POST', url: baseUrl + 'rest/users/createChannel' },
        register: { method: 'POST', url: baseUrl + 'rest/users/register' },
        registerAsAdmin: { method: 'POST', url: baseUrl + 'rest/users/registerAsAdmin' },
        forgotPwd: { method: 'POST', url: baseUrl + 'rest/users/forgotPwd' },
        getLoggedUser: { method: 'GET', url: baseUrl + 'rest/users/getLoggedUser' },
        getLoggedUserPayment: { method: 'GET', url: baseUrl + 'rest/users/getLoggedUserPayment' },
        registerManagerMode: { method: 'POST', url: baseUrl + 'rest/users/registerManagerMode' },
        ssoConnexion: { method: 'GET', url: baseUrl + 'rest/users/sso-connexion' },
        notifyMarketPlace: { method: 'POST', url: baseUrl + 'rest/users/:id/notify-marketplace' },
        loginManagerMode: { method: 'POST', url: baseUrl + 'rest/users/loginManagerMode' },
        resetPassword: { method: 'POST', url: baseUrl + 'rest/users/resetPassword/:companyCode' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('User', ["User_Resource", "Subscription", "UserData", function (User_Resource, Subscription, UserData) {
    //User inherit of $resource

    var User = function User(resource) {
        // Call the parent constructor
        this.id = null;
        this.firstName = "";
        this.lastName = "";
        this.phone = "";
        this.landline = "";
        this.email = "";
        this.password = "";
        this.adminPassword = "";
        this.companyCode = "";
        this.companyName = ""; //creation account only
        this.companyLocaleCode = ""; //creation account only
        this.companyCountryCode = ""; //creation account only
        this.companyCurrencyCode = ""; //creation account only
        this.companyDiscountCode = ""; //creation account only
        this.companyTypeId = "";
        this.company = null;
        this.role = null;
        this.lastConnexionDate = null;
        this.lastUserAgent = null;
        this.serverIdentification = null;
        this.walletAmount = null;
        this.hasManagerPassword = false;
        this.isAutoManager = false;
        this.isManager = false;
        this.isSuperAdmin = false;
        this.legalType = true;
        this.isModel = false;
        this.userLocale = "fr-FR";

        if (resource !== undefined && resource != null) {
            if (!this.id) this.id = resource.id;
            this.firstName = resource.firstName;
            this.lastName = resource.lastName;
            this.phone = resource.phone;
            this.landline = resource.landline;
            this.email = resource.email;
            this.password = resource.password;
            this.adminPassword = resource.adminPassword;
            this.companyCode = resource.companyCode;
            this.offer = resource.offer; //creation account only
            this.companyName = resource.companyName; //creation account only
            this.companyManager = resource.companyManager; //creation account only
            this.companyDiscountCode = resource.companyDiscountCode;
            this.role = resource.role;
            this.isAutoManager = resource.isAutoManager;
            this.isManager = resource.isManager;
            this.isSuperAdmin = resource.isSuperAdmin;
            this.walletAmount = resource.walletAmount;
            this.hasManagerPassword = resource.hasManagerPassword;
            this.lastUserAgent = resource.lastUserAgent;
            this.legalType = resource.legalType;
            this.companyTypeId = resource.companyTypeId;
            this.isModel = resource.isModel;
            this.userLocale = resource.userLocale;
            if (resource.currencyCode) this.companyCurrencyCode = resource.currencyCode;
            if (resource.countryCode) this.companyCountryCode = resource.countryCode;
            if (resource.localeCode) this.companyLocaleCode = resource.localeCode;
            if (resource.lastConnexionDate) this.lastConnexionDate = new Date(resource.lastConnexionDate);
            if (resource.serverIdentification) this.serverIdentification = {
                applicationId: resource.serverIdentification.applicationId,
                version: resource.serverIdentification.version,
                currentDate: resource.serverIdentification.currentDate ? new Date(resource.serverIdentification.currentDate) : null
            };
        }
        UserData.add(this);
    };
    User.prototype.getObjectResource = function () {
        var rsUser = new User_Resource();
        rsUser.id = this.id;
        rsUser.firstName = this.firstName;
        rsUser.lastName = this.lastName;
        rsUser.phone = this.phone;
        rsUser.landline = this.landline;
        rsUser.email = this.email;
        rsUser.password = this.password;
        rsUser.companyCode = this.companyCode;
        rsUser.isAutoManager = this.isAutoManager;
        rsUser.isManager = this.isManager;
        rsUser.isSuperAdmin = this.isSuperAdmin;
        rsUser.userLocale = this.userLocale;
        return rsUser;
    };

    User.prototype.getObjectResourceForGroup = function () {
        var rsUser = new User_Resource();
        rsUser.id = this.id;
        rsUser.firstName = this.firstName;
        rsUser.lastName = this.lastName;
        rsUser.phone = this.phone;
        rsUser.landline = this.landline;
        rsUser.email = this.email;
        rsUser.password = this.password;
        return rsUser;
    };
    User.prototype.getLoginRequest = function () {
        var rsUser = new User_Resource();
        rsUser.email = this.email;
        rsUser.password = this.password;
        return rsUser;
    };
    User.prototype.getRegisterRequest = function () {
        var rsUser = new User_Resource();
        rsUser.firstName = this.firstName;
        rsUser.lastName = this.lastName;
        rsUser.phone = this.phone;
        rsUser.landline = this.landline;
        rsUser.email = this.email;
        rsUser.password = this.password;
        rsUser.adminPassword = this.adminPassword;
        rsUser.offer = this.offer;
        rsUser.companyName = this.companyName;
        rsUser.companyManager = this.companyManager;
        rsUser.companyDiscountCode = this.companyDiscountCode;
        rsUser.currencyCode = this.companyCurrencyCode;
        rsUser.localeCode = this.companyLocaleCode;
        rsUser.countryCode = this.companyCountryCode;
        rsUser.legalType = this.legalType;
        rsUser.companyTypeId = this.companyTypeId;
        rsUser.isModel = this.isModel;
        rsUser.userLocale = this.userLocale;
        return rsUser;
    };
    User.prototype.getId = function () {
        return this.id;
    };
    User.prototype.setId = function (id) {
        this.id = id;
    };
    User.prototype.setCompanyCode = function (companyCode) {
        this.companyCode = companyCode;
    };
    User.prototype.getEmail = function () {
        return this.email;
    };
    User.prototype.isLoggedToProduction = function () {
        return this.serverIdentification && this.serverIdentification.applicationId == "bsiflexyprod";
    };
    User.prototype.getLastName = function () {
        return this.lastName;
    };
    User.prototype.getFirstName = function () {
        return this.firstName;
    };

    return User;
}]);

angular.module('FlexyBeautyApp.services').factory('UserSrv', ["$log", "User_Resource", "ServerSrv", "User", "UserData", "Company", "gettextCatalog", "BasicAuthRole", function ($log, User_Resource, ServerSrv, User, UserData, Company, gettextCatalog, BasicAuthRole) {
    var userSrv = {};
    userSrv.query = function (successFunction, errorFunction) {
        User_Resource.query({}, //params
        function (data) {
            //success
            UserData.clear();
            for (var i = 0; i < data.length; i++) {
                new User(data[i]);
            } //Auto Add to CustomerData
            if (successFunction !== undefined) successFunction(UserData.users);
        }, function (data) {
            //failure
            $log.error("User_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    userSrv.listAdmin = function (successFunction, errorFunction) {
        User_Resource.listAdmin({}, //params
        function (data) {
            //success
            for (var i = 0; i < data.length; i++) {
                new User(data[i]);
            } //Auto Add to CustomerData
            if (successFunction !== undefined) successFunction(UserData.users);
        }, function (data) {
            //failure
            $log.error("User_Resource.query error");
            $log.error(data);
            if (errorFunction !== undefined) errorFunction(data);
        });
    };
    userSrv.save = function (user, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(userSrv.saveSync, user, successFunction, errorFunction);
    };
    userSrv.saveSync = function (user, successFunction, errorFunction) {
        //$timeout (function () {

        var userSrv = user.getObjectResource();
        userSrv.$save({}, //params
        function (data) {
            //success
            try {
                user.setId(userSrv.id);
                if (successFunction != undefined) successFunction(user);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    userSrv.remove = function (user, successFunction, errorFunction) {
        ServerSrv.startSavingProcess(userSrv.removeSync, user, successFunction, errorFunction);
    };
    userSrv.removeSync = function (user, successFunction, errorFunction) {
        //$timeout (function () {

        var userSrv = user.getObjectResource();
        userSrv.$remove({ id: user.id }, //params
        function (data) {
            try {
                if (successFunction != undefined) successFunction(user);
            } finally {
                ServerSrv.endSavingProcess(true);
            }
        }, function (data) {
            //failure
            //error handling goes here
            try {
                if (errorFunction != undefined) errorFunction(data);
            } finally {
                ServerSrv.endSavingProcess(false, data ? data.status : null, data && data.data ? data.data.errorCode : null);
            }
        });

        //},2000)
    };
    userSrv.login = function (user, successFunction, errorFunction) {
        var userSrv = user.getLoginRequest();
        userSrv.$login({}, //params
        function (data) {
            //success
            user.setId(data.userId);
            user.setCompanyCode(data.companyCode);
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var errorMessage = gettextCatalog.getString("Echec de la connexion.");
            if (data.status && data.status == "401") {
                errorMessage = gettextCatalog.getString("Email / mot de passe incorrect");
            }
            if (errorFunction !== undefined) errorFunction(errorMessage);
        });
    };

    userSrv.loginOnForgetPwd = function (user, token, successFunction, errorFunction) {
        var userSrv = user.getLoginRequest();
        userSrv.forgetPwdToken = token;
        userSrv.$login({}, //params
        function (data) {
            //success
            user.setId(data.userId);
            user.setCompanyCode(data.companyCode);
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var errorMessage = gettextCatalog.getString("Echec de la connexion.");
            if (data.status && data.status == "401") {
                errorMessage = gettextCatalog.getString("Email / mot de passe incorrect");
            }
            if (errorFunction !== undefined) errorFunction(errorMessage);
        });
    };
    userSrv.loginAnonymous = function (companyCode, successFunction, errorFunction) {
        var userSrv = new User_Resource();
        userSrv.companyCode = companyCode;
        userSrv.$loginAnonymous({}, //params
        function (data) {
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var errorMessage = "Echec de la connexion.";
            if (errorFunction != undefined) errorFunction(errorMessage);
        });
    };
    userSrv.loginAsAdmin = function (user, successFunction, errorFunction) {
        var userSrv = user.getLoginRequest();
        userSrv.$loginAsAdmin({}, //params
        function (data) {
            //success
            user.setId(data.userId);
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var errorMessage = "Echec de la connexion.";
            if (data.status && data.status == "401") {
                errorMessage = "Email / mot de passe incorrect";
            }
            if (errorFunction !== undefined) errorFunction(errorMessage);
        });
    };
    userSrv.loginAsGroup = function (user, successFunction, errorFunction) {
        var userSrv = user.getLoginRequest();
        userSrv.$loginAsGroup({}, //params
        function (data) {
            user.setId(data.userId);
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var errorMessage = gettextCatalog.getString("Echec de la connexion.");
            if (data.status && data.status == "401") {
                errorMessage = gettextCatalog.getString("Email / mot de passe incorrect");
            }
            if (errorFunction !== undefined) errorFunction(errorMessage);
        });
    };
    userSrv.logout = function (user, successFunction, errorFunction) {
        var userSrv = new User_Resource();
        userSrv.$logout({}, //params
        function (data) {
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var errorMessage = "Echec de la déconnexion.";
            if (data.status) {
                if (data.status == "404") errorMessage = "Ce compte n'existe pas.";
            }
            if (errorFunction != undefined) errorFunction(errorMessage);
        });
    };

    userSrv.loadLoggedUser = function (successFunction, errorFunction) {
        var userSrv = new User_Resource();

        userSrv.$getLoggedUser({}, //params
        function (data) {
            var user = new User(data);
            var company = new Company();
            user.company = company;
            company.users.push(user);
            if (data.company) {
                company.loadObject(data.company, true);
            }
            UserData.setLoggedUser(user);
            if (successFunction != undefined) successFunction(user);
        }, function (data) {
            //Preserve access to FlexyBeauty.
            var user = new User();
            var company = new Company();
            user.company = company;
            company.users.push(user);
            UserData.setLoggedUser(user);
            if (errorFunction != undefined) errorFunction(data);
        });
    };

    userSrv.loadLoggedUserPayment = function (user, successFunction, errorFunction) {
        var userSrv = new User_Resource();
        userSrv.$getLoggedUserPayment({}, //params
        function (data) {
            if (user.company) {
                user.company.loadPaymentData(data);
            }
            if (successFunction !== undefined) {
                successFunction(data);
            }
        }, function (data) {
            if (errorFunction !== undefined) {
                errorFunction(data);
            }
        });
    };

    userSrv.ssoConnexion = function (successFunction, errorFunction) {
        var userSrv = new User_Resource();
        userSrv.$ssoConnexion({}, function (data) {
            if (successFunction !== undefined) {
                successFunction(data);
            }
        }, function () {
            if (errorFunction !== undefined) {
                errorFunction(BasicAuthRole.LE_CISEAU_ROLE.proSite);
            }
        });
    };

    userSrv.notifyMarketPlace = function (userId) {
        var userResource = new User_Resource();
        return userResource.$notifyMarketPlace({ id: userId });
    };

    userSrv.forgotPwd = function (user, successFunction, errorFunction) {
        var userSrv = new User_Resource();
        userSrv.email = user.email;
        userSrv.$forgotPwd({}, //params
        function (data) {
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var forgotPasswordFailure = gettextCatalog.getString("Echec de l'oubli de mot de passe.");

            var errorMessage = forgotPasswordFailure;
            if (errorFunction != undefined) errorFunction(errorMessage);
        });
    };
    userSrv.registerManagerMode = function (user, password, managerPassword, successFunction, errorFunction) {
        var userSrv = new User_Resource();
        userSrv.password = password;
        userSrv.managerPassword = managerPassword;
        userSrv.$registerManagerMode({}, //params
        function (data) {
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var connexionFailure = gettextCatalog.getString("Echec de la connexion."),
                passwordIncorrect = gettextCatalog.getString("Le mot de passe est incorrect."),
                accountNotExist = gettextCatalog.getString("Ce compte n'existe pas."),
                errorMessage = connexionFailure;

            if (data.status) {
                if (data.status == "401") {
                    errorMessage = passwordIncorrect;
                }
                if (data.status == "404") errorMessage = accountNotExist;
            }
            if (errorFunction != undefined) errorFunction(errorMessage);
        });
    };
    userSrv.loginManagerMode = function (user, managerPassword, successFunction, errorFunction) {
        var userSrv = new User_Resource();
        userSrv.managerPassword = managerPassword;
        userSrv.$loginManagerMode({}, //params
        function (data) {
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var connexionFailure = gettextCatalog.getString("Echec de la connexion."),
                passwordIncorrect = gettextCatalog.getString("Le mot de passe est incorrect."),
                accountNotExist = gettextCatalog.getString("Ce compte n'existe pas."),
                errorMessage = connexionFailure;

            if (data.status) {
                if (data.status == "401") errorMessage = passwordIncorrect;
                if (data.status == "404") errorMessage = accountNotExist;
            }
            if (errorFunction != undefined) errorFunction(errorMessage);
        });
    };
    userSrv.createChannel = function () {
        return User_Resource.createChannel({}).$promise;
    };
    userSrv.register = function (user, successFunction, errorFunction) {
        var userSrv = user.getRegisterRequest();
        userSrv.$register({}, //params
        function (data) {
            //success
            user.setId(data.userId);
            if (data.companyCode) user.setCompanyCode(data.companyCode);
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var accountCreationImpossible = gettextCatalog.getString("Création du compte impossible."),
                emailEverUse = gettextCatalog.getString("Cet email est déjà utilisé."),
                companyNameEverUsed = gettextCatalog.getString("Le nom de l'entreprise est déjà utilisé."),
                notAurizedCaracterInCompanyName = gettextCatalog.getString("Le nom de l'entreprise contient des caratères non autorisés."),
                unknownPromoCode = gettextCatalog.getString("Le code promo n'est pas reconnu."),
                errorMessage = accountCreationImpossible;

            if (data.status && data.data) {
                if (data.status == "409") {
                    if (data.data.errorCode == "40901") errorMessage = accountCreationImpossible + "\n" + emailEverUse;
                    if (data.data.errorCode == "40902") errorMessage = accountCreationImpossible + "\n" + companyNameEverUsed;
                    if (data.data.errorCode == "40903") errorMessage = accountCreationImpossible + "\n" + notAurizedCaracterInCompanyName;
                    if (data.data.errorCode == "40904") errorMessage = accountCreationImpossible + "\n" + unknownPromoCode;
                }
            }
            if (errorFunction != undefined) errorFunction(errorMessage);
        });
    };
    userSrv.registerAsAdmin = function (user, successFunction, errorFunction) {
        var userSrv = user.getRegisterRequest();
        userSrv.$registerAsAdmin({}, //params
        function (data) {
            //success
            user.setId(data.userId);
            if (successFunction != undefined) successFunction(data);
        }, function (data) {
            var accountCreationImpossible = "Création du compte impossible.",
                emailEverUse = "Cet email est déjà utilisé.",
                errorMessage = accountCreationImpossible;
            if (data.status && data.data) {
                if (data.status == "409") {
                    if (data.data.errorCode == "40901") errorMessage = accountCreationImpossible + "\n" + emailEverUse;
                }
            }
            if (errorFunction != undefined) errorFunction(errorMessage);
        });
    };

    userSrv.resetPassword = function (companyCode, successFunction, errorFunction) {
        User_Resource.resetPassword({ companyCode: companyCode }, {}).$promise.then(function (response) {
            if (successFunction != null) {
                successFunction(response);
            }
        }, function (response) {
            if (errorFunction != null) {
                errorFunction(response);
            }
        });
    };

    return userSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('UserData', ["$filter", function ($filter) {
    var userDataSrv = {
        loggedUser: null,
        indexUsers: [],
        activeUsers: [],
        deletedUsers: [] //deleted items
    };
    userDataSrv.getById = function (userId) {
        for (var i = 0; i < this.indexUsers.length; i++) {
            if (this.indexUsers[i].getId() == userId) return this.indexUsers[i];
        }return null;
    };
    userDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexUsers.length) return this.indexUsers[index];
        return null;
    };
    userDataSrv.getIndexOf = function (user) {
        if (user) return this.indexUsers.indexOf(user);
        return -1;
    };

    userDataSrv.add = function (user) {
        var userArray = this.activeUsers;
        if (user.isDeleted) userArray = this.deletedUsers;
        var userExist = this.getById(user.id);
        var index = -1;
        if (userExist) index = userArray.indexOf(userExist);else {
            index = this.indexUsers.length;
            this.indexUsers.push(user);
            userArray.push(user);
        }
        return index;
    };
    userDataSrv.remove = function (user) {
        var index = this.activeUsers.indexOf(user);
        if (index != -1) {
            this.activeUsers.splice(index, 1);
            this.deletedUsers.push(user);
            user.isDeleted = true;
        }
    };
    userDataSrv.restore = function (user) {
        var index = this.deletedUsers.indexOf(user);
        if (index != -1) {
            this.deletedUsers.splice(index, 1);
            this.activeUsers.push(user);
            user.isDeleted = false;
        }
    };
    userDataSrv.clear = function () {
        this.indexUsers = [];
        this.activeUsers = [];
        this.deletedUsers = [];
    };
    userDataSrv.sort = function () {
        this.activeUsers = $filter('orderBy')(this.activeUsers, 'lastName', false);
        this.deletedUsers = $filter('orderBy')(this.deletedUsers, 'lastName', false);
    };

    userDataSrv.getActiveList = function () {
        return this.activeUsers;
    };
    userDataSrv.getDeletedList = function () {
        return this.deletedUsers;
    };

    userDataSrv.getLoggedUser = function () {
        return userDataSrv.loggedUser;
    };
    userDataSrv.setLoggedUser = function (user) {
        userDataSrv.loggedUser = user;
    };

    return userDataSrv;
}]);

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 13/11/2013
 * Time: 09:04
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('UserAction_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/userActions/:id', {}, {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET' },
        getUserActionFromDate: { method: 'POST', isArray: false, url: baseUrl + 'rest/userActions/date' },
        getUserActionBooking: { method: 'POST', isArray: false, url: baseUrl + 'rest/userActions/booking' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('UserAction', ["UserAction_Resource", "HumanResourceData", "ObjectModification", "gettextCatalog", function (UserAction_Resource, HumanResourceData, ObjectModification, gettextCatalog) {

    var userAction = function userAction(userActionRes, loadObjectModifications) {
        this.id = null;
        this.author = null; //humanResource (generate after global Load)
        this.authorId = null; //humanResourceId
        this.actionDate = null;
        this.globalType = null;
        this.globalObjectType = null;
        this.cancelable = true;
        this.description = "";
        this.objectModifications = [];

        if (userActionRes !== undefined && userActionRes != null) {
            var msg = gettextCatalog.getString("Annuler la"),
                msgCreate = gettextCatalog.getString("création"),
                msgDelete = gettextCatalog.getString("suppression"),
                msgUpdate = gettextCatalog.getString("modification"),
                msgCustomer = gettextCatalog.getString("du client"),
                msgDay = gettextCatalog.getString("de la journée"),
                msgBooking = gettextCatalog.getString("de la réservation"),
                msgUnavailable = gettextCatalog.getString("de l'indisponibilité");
            !this.id;
            this.id = userActionRes.id;
            this.cancelable = userActionRes.cancelable;
            if (userActionRes.actionDate) this.actionDate = new Date(userActionRes.actionDate);
            this.authorId = userActionRes.authorId;
            this.globalType = userActionRes.globalType;
            this.globalObjectType = userActionRes.globalObjectType;
            this.author = HumanResourceData.getById(userActionRes.authorId);
            this.description = msg + " ";
            switch (this.globalType) {
                case "delete":
                    this.description += msgDelete;
                    break;
                case "update":
                    this.description += msgUpdate;
                    break;
                case "create":
                    this.description += msgCreate;
                    break;
            }
            switch (this.globalObjectType) {
                case "Customer":
                    this.description += " " + msgCustomer;
                    break;
                case "Booking":
                    this.description += " " + msgBooking;
                    break;
                case "BookingService":
                    this.description += " " + msgBooking;
                    break;
                case "Activity":
                    this.description += " " + msgUnavailable;
                    break;
                default:
                    this.description = null;
                    break;
            }
            if (this.description) this.description += " ?";

            if (loadObjectModifications !== undefined && loadObjectModifications) {
                this.objectModifications = [];
                for (var i = 0; i < userActionRes.objectModifications.length; i++) {
                    var objModification = new ObjectModification(userActionRes.objectModifications[i]);
                    objModification.currentVersion = userActionRes.objectModifications[i].currentVersion;
                    objModification.previousVersion = userActionRes.objectModifications[i].previousVersion;
                    this.objectModifications.push(objModification);
                }
            }
        }
        userAction.prototype.getCancelRequest = function () {
            var rsUserAction = new UserAction_Resource();
            rsUserAction.id = this.id;
            return rsUserAction;
        };
    };
    return userAction;
}]);

angular.module('FlexyBeautyApp.services').factory('ObjectModification', [function () {
    return function (object) {
        this.type = object.type; //create / update / delete
        this.objectId = object.objectId;
        this.currentVersion = null;
        this.previousVersion = null;
    };
}]);

angular.module('FlexyBeautyApp.services').factory('UserActionSrv', ["$log", "$timeout", "UserAction_Resource", "Decorators", "TimeMeasures", function ($log, $timeout, UserAction_Resource, Decorators, TimeMeasures) {
    var userActionSrv = {
        autoUpdatePromise: null
    };

    userActionSrv.get = function (id, successFunction, errorFunction) {
        UserAction_Resource.get({ id: id }, //params
        function (userActionResource) {
            if (successFunction) {
                successFunction(userActionResource);
            }
        }, function (data) {
            if (errorFunction) {
                errorFunction(data);
            }
        });
    };

    userActionSrv.getUserActionFromDate = Decorators.timeMeasureDecorator(function (fromDate) {
        var actionRes = new UserAction_Resource();
        actionRes.fromDate = fromDate;
        return actionRes.$getUserActionFromDate({});
    }, TimeMeasures.USER_ACTION_FROM_DATE);

    userActionSrv.getUserActionBooking = Decorators.timeMeasureDecorator(function (fromDate) {
        var actionRes = new UserAction_Resource();
        actionRes.fromDate = fromDate;
        return actionRes.$getUserActionBooking({});
    }, TimeMeasures.USER_ACTION_BOOKING);

    return userActionSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('UserActionManager', ["$log", "$rootScope", "$timeout", "ServerSrv", "MessageSrv", "UserActionData", "HumanResourceSrv", "CategorySrv", "ServiceSrv", "BookingSrv", "BookingServiceSrv", "SaleSrv", "SaleServiceSrv", "SaleProductSrv", "SaleCureSrv", "SiteSrv", "WorkingPeriodDayHrSrv", "WorkingPeriodDayPrSrv", "ActivitySrv", "ObjectModification", "DayHrSrv", "DayPrSrv", "CustomerSrv", "Activity", "BookingService", "DayHr", "DayPr", "GiftItemSrv", "CureItemSrv", "CureItemToServiceSrv", "CureItemToServiceUsageSrv", "LoyaltyCardItemSrv", "PosOpSrv", "OrderSrv", "OrderProductSrv", "CheckDepositSrv", "UsageProductSrv", "ProductSrv", "UserActionSrv", "ClosureSrv", "DashboardSrv", "DashboardSchedulerSrv", "OptInOutSrv", "Constants", "$interval", function ($log, $rootScope, $timeout, ServerSrv, MessageSrv, UserActionData, HumanResourceSrv, CategorySrv, ServiceSrv, BookingSrv, BookingServiceSrv, SaleSrv, SaleServiceSrv, SaleProductSrv, SaleCureSrv, SiteSrv, WorkingPeriodDayHrSrv, WorkingPeriodDayPrSrv, ActivitySrv, ObjectModification, DayHrSrv, DayPrSrv, CustomerSrv, Activity, BookingService, DayHr, DayPr, GiftItemSrv, CureItemSrv, CureItemToServiceSrv, CureItemToServiceUsageSrv, LoyaltyCardItemSrv, PosOpSrv, OrderSrv, OrderProductSrv, CheckDepositSrv, UsageProductSrv, ProductSrv, UserActionSrv, ClosureSrv, DashboardSrv, DashboardSchedulerSrv, OptInOutSrv, Constants, $interval) {

    var userActionSrv = {
        currentPopDate: null,
        nextPopDate: null,
        popInterval: undefined
    };

    userActionSrv.stopPopInterval = function () {
        console.info("Cancellation of userAction pop interval");
        if (angular.isDefined(userActionSrv.popInterval)) {
            $interval.cancel(userActionSrv.popInterval);
            userActionSrv.popInterval = undefined;
        }
    };

    userActionSrv.executeUserActionPop = function (onAuthenticationLost) {
        userActionSrv.nextPopDate = new Date();
        console.info("Current time : " + new Date() + "; Asking userAction/date with popDate " + userActionSrv.currentPopDate);
        UserActionSrv.getUserActionFromDate(userActionSrv.currentPopDate).then(function (data) {
            var userActionsRes = data ? data.userActions : {};
            if (userActionsRes) {
                for (var i = 0; i < userActionsRes.length; i++) {
                    if (!UserActionData.getExternal(userActionsRes[i].id) && !UserActionData.get(userActionsRes[i].id) && !UserActionData.getCanceled(userActionsRes[i].id)) //not already processed
                        userActionSrv.executeUserAction(userActionsRes[i], true);
                }
            }
            userActionSrv.currentPopDate = userActionSrv.nextPopDate;
        }, function (data) {
            if (data && data.status && data.status === 401) {
                onAuthenticationLost();
            }
        });
    };

    userActionSrv.startUserActionPop = function (onAuthenticationLost, intervalInMillisecond) {
        console.info("Creation of userAction pop interval");
        userActionSrv.popInterval = $interval(userActionSrv.executeUserActionPop, intervalInMillisecond, null, null, onAuthenticationLost);
        return userActionSrv.popInterval;
    };

    userActionSrv.orderByModelHierarchy = function (objectModifications) {
        // Order objects modification in order to manage in first leaves of model hierarchy
        var orderedObjModifs = [];
        var objectModificationsCopy = objectModifications.slice();
        var modelHierarchy = ["User", "Customer", "HumanResource", "PhysicalResource", "Service", "Product", "Cure", "LoyaltyCard", "Supplier", "Category", "ProductCategory", "CureCategory", "LoyaltyCardCategory", "Site", "WorkingPeriod", "WorkingPeriodDay", "WorkingPeriodDayHr", "WorkingPeriodDayPr", "Day", "DayHr", "DayPr", "Sale", "SaleProduct", "SaleService", "SaleCure", "GiftItem", "LoyaltyCardItem", "Booking", "BookingService", "Activity", "CureItem", "CureItemToService", "CureItemToServiceUsage", "PosOp", "Order", "OrderProduct", "CheckDeposit", "UsageProduct", "Vat", "OtherPaymentType", "App", "Closure", "Dashboard", "DashboardScheduler", "OptInOut"];

        //first adding or update  : add dayHr before activity
        var i, j;
        for (i = 0; i < modelHierarchy.length && objectModificationsCopy.length > 0; i++) {
            for (j = 0; j < objectModificationsCopy.length;) {
                if (objectModificationsCopy[j].type !== "delete" && objectModificationsCopy[j].currentVersion.objectType === modelHierarchy[i]) {
                    orderedObjModifs.push(objectModificationsCopy[j]);
                    objectModificationsCopy.splice(j, 1);
                } else j++;
            }
        }
        //now remove : inverse order hierarchy : remove activity before day hre
        for (i = modelHierarchy.length; i >= 0 && objectModificationsCopy.length > 0; i--) {
            for (var j = 0; j < objectModificationsCopy.length;) {
                if (objectModificationsCopy[j].type === "delete" && objectModificationsCopy[j].currentVersion.objectType === modelHierarchy[i]) {
                    orderedObjModifs.push(objectModificationsCopy[j]);
                    objectModificationsCopy.splice(j, 1);
                } else j++;
            }
        }
        if (objectModificationsCopy.length > 0) $log.error("objectModificationsCopy not empty. Check " + objectModificationsCopy[0].currentVersion.objectType);
        return orderedObjModifs;
    };

    userActionSrv.getObjectService = function (resourceCurrentVersion, resourcePreviousVersion) {
        var srv = null;
        if (resourceCurrentVersion.objectType) {
            switch (resourceCurrentVersion.objectType) {
                case "Product":
                    srv = ProductSrv;
                    break;
                case "Customer":
                    srv = CustomerSrv;
                    break;
                case "Booking":
                    srv = BookingSrv;
                    break;
                case "BookingService":
                    srv = BookingServiceSrv;
                    break;
                case "Sale":
                    srv = SaleSrv;
                    break;
                case "SaleProduct":
                    srv = SaleProductSrv;
                    break;
                case "SaleCure":
                    srv = SaleCureSrv;
                    break;
                case "SaleService":
                    srv = SaleServiceSrv;
                    break;
                case "GiftItem":
                    srv = GiftItemSrv;
                    break;
                case "LoyaltyCardItem":
                    srv = LoyaltyCardItemSrv;
                    break;
                case "DayPr":
                    srv = DayPrSrv;
                    break;
                case "DayHr":
                    srv = DayHrSrv;
                    break;
                case "CureItem":
                    srv = CureItemSrv;
                    break;
                case "CureItemToService":
                    srv = CureItemToServiceSrv;
                    break;
                case "CureItemToServiceUsage":
                    srv = CureItemToServiceUsageSrv;
                    break;
                case "PosOp":
                    srv = PosOpSrv;
                    break;
                case "Order":
                    srv = OrderSrv;
                    break;
                case "OrderProduct":
                    srv = OrderProductSrv;
                    break;
                case "CheckDeposit":
                    srv = CheckDepositSrv;
                    break;
                case "UsageProduct":
                    srv = UsageProductSrv;
                    break;
                case "Closure":
                    srv = ClosureSrv;
                    break;
                case "Activity":
                    if (!(resourceCurrentVersion && resourceCurrentVersion.workingPeriodDayHr || resourcePreviousVersion && resourcePreviousVersion.workingPeriodDayHr || resourceCurrentVersion && resourceCurrentVersion.workingPeriodDayPr || resourcePreviousVersion && resourcePreviousVersion.workingPeriodDayPr)) srv = ActivitySrv;
                    break;
                case "Dashboard":
                    srv = DashboardSrv;
                    break;
                case "DashboardScheduler":
                    srv = DashboardSchedulerSrv;
                    break;
                case "OptInOut":
                    srv = OptInOutSrv;
                    break;

            }
        }
        return srv;
    };
    userActionSrv.executeUserAction = function (userActionRes, isNotFromAngularEvent) {
        /** @namespace data.objectModifications */
        /** @namespace data.userAction */
        //must manage "objectsModifications"
        //return userAction
        if (userActionRes.objectModifications && UserActionData.getExternal(userActionRes.id) == null) //not already executed
            {
                UserActionData.addExternal(userActionRes);
                var orderedObjModifs = userActionSrv.orderByModelHierarchy(userActionRes.objectModifications);
                var actionsToEmitToViews = [];
                var allowUpdate = true;
                for (var i = 0; i < orderedObjModifs.length && allowUpdate; i++) {
                    var srv = null;
                    var objModification = new ObjectModification(orderedObjModifs[i]);
                    var resourceCurrentVersion = orderedObjModifs[i].currentVersion;
                    var resourcePreviousVersion = orderedObjModifs[i].previousVersion;
                    srv = userActionSrv.getObjectService(resourceCurrentVersion, resourcePreviousVersion);
                    if (srv) {
                        switch (orderedObjModifs[i].type) {
                            case "create":
                                if (srv.addLocally !== undefined) objModification.currentVersion = srv.addLocally(orderedObjModifs[i].objectId, resourceCurrentVersion);
                                break;
                            case "update":
                                if (srv.updateLocally !== undefined) objModification.currentVersion = srv.updateLocally(orderedObjModifs[i].objectId, resourceCurrentVersion);
                                break;
                            case "delete":
                                if (srv.removeLocally !== undefined) objModification.currentVersion = srv.removeLocally(orderedObjModifs[i].objectId, resourceCurrentVersion);
                                break;

                            case "restore":
                                if (typeof srv.restoreLocally === "function") {
                                    objModification.currentVersion = srv.restoreLocally(orderedObjModifs[i].objectId, resourceCurrentVersion);
                                }
                                break;
                        }
                        if (objModification.currentVersion) {
                            if (resourcePreviousVersion && srv.getPreviousVersionInstance !== undefined) //Defined only for classes that can change of owner //TODO do it for all classes
                                objModification.previousVersion = srv.getPreviousVersionInstance(resourcePreviousVersion);
                            actionsToEmitToViews.push(objModification);
                        } else //version is null (maybe because it's not the last version)
                            if (resourceCurrentVersion.objectType === "Booking" || resourceCurrentVersion.objectType === "Sale") //not the last version of booking refuse other update of bs
                                allowUpdate = false;
                    } else //Action on objects not managed
                        {
                            if (resourceCurrentVersion.objectType !== "App") MessageSrv.send("warning", "Des données de l'établissement ont été modifiées par un autre utilisateur<br/>Vous devez recharger l'application", isNotFromAngularEvent);
                        }
                }
            }
        //Manage internal reference inside previousVersion
        if (allowUpdate) {
            for (var j = 0; j < actionsToEmitToViews.length; j++) {
                if (actionsToEmitToViews[j].previousVersion instanceof Activity || actionsToEmitToViews[j].previousVersion instanceof BookingService) {
                    var previousActivity = actionsToEmitToViews[j].previousVersion;
                    //check for intance of dayHr inside actionsToEmitToViews
                    if (previousActivity.dayHr) for (var k = 0; k < actionsToEmitToViews.length; k++) {
                        if (actionsToEmitToViews[k].currentVersion instanceof DayHr && actionsToEmitToViews[k].currentVersion.id === previousActivity.dayHr.id) {
                            actionsToEmitToViews[k].previousVersion.id = actionsToEmitToViews[k].currentVersion.id; //set real object id (to allow research)
                            previousActivity.dayHr = actionsToEmitToViews[k].previousVersion;
                        }
                    }if (previousActivity.dayPr) for (var _k = 0; _k < actionsToEmitToViews.length; _k++) {
                        if (actionsToEmitToViews[_k].currentVersion instanceof DayPr && actionsToEmitToViews[_k].currentVersion.id === previousActivity.dayPr.id) {
                            actionsToEmitToViews[_k].previousVersion.id = actionsToEmitToViews[_k].currentVersion.id; //set real object id (to allow research)
                            previousActivity.dayPr = actionsToEmitToViews[_k].previousVersion;
                        }
                    }
                }
            }
            for (var _j = 0; _j < actionsToEmitToViews.length; _j++) {
                $rootScope.$emit("onExternalModelChanged", actionsToEmitToViews[_j], isNotFromAngularEvent);
                console.log(actionsToEmitToViews[_j]);
                //Emit to view ctrl
            }
        }
    };

    return userActionSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('UserActionData', ["$log", "UserAction", "MessageSrv", "$rootScope", function ($log, UserAction, MessageSrv, $rootScope) {
    var userActionData = {
        userActions: [], //actions done by logged user
        userActionsCanceled: [], //actions canceled by logged user
        externalUserActions: [] //actions receive by channel communication
    };

    userActionData.get = function (userActionId) {
        for (var i = 0; i < this.userActions.length; i++) {
            if (this.userActions[i].id === userActionId) return this.userActions[i];
        }return null;
    };

    userActionData.getExternal = function (userActionId) {
        if (userActionId === undefined || userActionId === null) {
            return null;
        }

        for (var i = 0; i < this.externalUserActions.length; i++) {
            if (this.externalUserActions[i].id === userActionId) {
                return this.externalUserActions[i];
            }
        }

        return null;
    };

    userActionData.getCanceled = function (userActionId) {
        for (var i = 0; i < this.userActionsCanceled.length; i++) {
            if (this.userActionsCanceled[i].id === userActionId) return this.userActionsCanceled[i];
        }return null;
    };

    userActionData.getLastUserAction = function () {
        if (this.userActions.length > 0) return this.userActions[this.userActions.length - 1];
        return null;
    };

    userActionData.getLastUserActionCanceled = function () {
        if (this.userActionsCanceled.length > 0) {
            return this.userActionsCanceled[this.userActionsCanceled.length - 1];
        }
        return null;
    };

    userActionData.add = function (userActionRes) {
        if (userActionRes && !userActionData.get(userActionRes.id)) {
            var userAction = new UserAction(userActionRes);
            this.userActions.push(userAction);
            this.userActionsCanceled = []; //When a new action occurs redo is reset
            if (userAction.globalObjectType !== "Sale") {
                //sales actions can't be canceled
                $rootScope.$emit("onChangeUserActionToCancel", userAction);
            }
        }
    };

    userActionData.addExternal = function (userActionRes) {
        var userAction = null;
        if (userActionRes && !userActionData.getExternal(userActionRes.id)) {
            userAction = new UserAction(userActionRes);
            this.externalUserActions.push(userAction);
        }
        return userAction;
    };

    userActionData.addCanceled = function (userActionRes) {
        var userAction = new UserAction(userActionRes);
        this.userActionsCanceled.push(userAction);
        $rootScope.$emit("onChangeUserActionToRedo", userAction);
    };

    userActionData.remove = function (userAction) {
        var index = this.userActions.indexOf(userAction);
        if (index !== -1) this.userActions.splice(index, 1);
    };
    userActionData.removeCanceled = function (userAction) {
        var index = this.userActionsCanceled.indexOf(userAction);
        if (index !== -1) this.userActionsCanceled.splice(index, 1);
    };
    userActionData.clear = function () {
        userActionData.userActions = [];
    };
    return userActionData;
}]);

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _authorizationConfig = __webpack_require__(19);

angular.module('FlexyBeautyApp.services').factory('Auth', ["$log", "$http", "$window", "$location", "User", "UserSrv", "CustomerSrv", "FirebaseServiceFactory", "CookieFactory", "bugsnag", "NotificationSrv", "UserActionManager", "UserData", "OptInOutSrv", "Constants", "Brand", "OfferManager", "StoreAppCode", function ($log, $http, $window, $location, User, UserSrv, CustomerSrv, FirebaseServiceFactory, CookieFactory, bugsnag, NotificationSrv, UserActionManager, UserData, OptInOutSrv, Constants, Brand, OfferManager, StoreAppCode) {
    // initialisation (refresh page by example)
    var accessLevels = void 0;
    var userRoles = void 0;
    var CHILD_ADDED_EVENT = "child_added";

    if (_authorizationConfig.routingConfig !== undefined && _authorizationConfig.routingConfig) {
        accessLevels = _authorizationConfig.routingConfig.accessLevels;
        userRoles = _authorizationConfig.routingConfig.userRoles;
    }
    var currentUser = null;

    /* For Angular App & React app: setup $window['kiuteProUser'] from backoffice or admin */
    function initKiuteProUser(specialUser, companyCode, isAdminUser) {
        var loggedUser = UserData.getLoggedUser();
        var currencyCode = Constants.DEFAULT_CURRENCY_CODE;
        var localeCode = Constants.DEFAULT_LOCALE_CODE;
        var companyName = '';
        var managerMode = false;
        var serverIdentification = {};
        var clientFullAccess = false;
        var onlineReservationAccess = false;
        var country = 'FR';
        if (loggedUser && loggedUser.company) {
            if (loggedUser.company.currency) {
                currencyCode = loggedUser.company.currency.codeMango;
            }
            if (loggedUser.company.localeCode) {
                localeCode = loggedUser.company.localeCode;
            }
            companyName = loggedUser.company.name;
            managerMode = !loggedUser.hasManagerPassword || loggedUser.isManager || isAdminUser;
            serverIdentification = loggedUser.serverIdentification;
            clientFullAccess = OfferManager.hasCompanyAccessToFeature(loggedUser.company, StoreAppCode.OPTION_CLIENT_FULL);
            onlineReservationAccess = OfferManager.hasCompanyAccessToOnlineReservation(loggedUser.company);
            if (loggedUser.company.country) {
                country = loggedUser.company.country;
            }
        }
        var kiuteProUser = Object.assign({
            currencyCode: currencyCode,
            companyCode: companyCode,
            companyName: companyName,
            localeCode: localeCode,
            serverIdentification: serverIdentification,
            managerMode: managerMode,
            clientFullAccess: clientFullAccess,
            onlineReservationAccess: onlineReservationAccess,
            country: country,
            isAdminUser: isAdminUser
        }, specialUser);

        $window['kiuteProUser'] = kiuteProUser;

        return kiuteProUser;
    }

    function changeUser(user, companyCode, token, channelId, isProSite, firebaseToken, firebaseEncodedCompanyCode) {
        var absUrl = $location.absUrl();
        if (!absUrl || absUrl.indexOf(Brand.url.adminUrl) === -1 && absUrl.indexOf(Brand.url.groupUrl) === -1) {
            manageUserConnection(absUrl, user, companyCode, token, channelId, firebaseToken, isProSite, firebaseEncodedCompanyCode);
            $http.defaults.headers.common.Authorization = token;
        } else {
            currentUser.channelId = channelId;
            if (isProSite && firebaseToken) {
                manageFirebaseEvent(companyCode, channelId, firebaseToken, firebaseEncodedCompanyCode);
            }
        }
        if (absUrl.indexOf(Brand.url.adminUrl) !== -1) {
            var adminUser = CookieFactory.getCookie('flexyBeauty-admin-user');
            if (adminUser) {
                initKiuteProUser(adminUser, companyCode, true);
            }
        } else if (absUrl.indexOf(Brand.url.groupUrl) !== -1) {
            var groupUser = CookieFactory.getCookie('flexyBeauty-group-user');
            if (groupUser) {
                initKiuteProUser(groupUser, companyCode, true);
            }
        }
        return currentUser;
    }

    function redirectOnLoginPage() {
        var absUrl = $location.absUrl();
        if (absUrl.indexOf("/connect/") !== -1) {
            $window.open("/connect", "_self");
        } else {
            $window.open("/", "_self");
        }
        $location.path('/login');
    }

    function manageUserConnection(absUrl, user, companyCode, token, channelId, firebaseToken, isProSite, firebaseEncodedCompanyCode) {
        if (user) {
            connectUser(absUrl, user, companyCode, token, channelId, firebaseToken, isProSite, firebaseEncodedCompanyCode);
        } else {
            disconnectUser(absUrl, isProSite, companyCode);
        }
    }

    function connectUser(absUrl, user, companyCode, token, channelId, firebaseToken, isProSite, firebaseEncodedCompanyCode) {
        currentUser = createCurrentUser(user, token);
        if (isProSite && firebaseToken) {
            console.info("connectUser - channelId " + channelId);
            manageFirebaseEvent(companyCode, channelId, firebaseToken, firebaseEncodedCompanyCode);
        }
        createCookie(absUrl, isProSite, user, currentUser, companyCode, channelId);
    }

    function manageFirebaseEvent(companyCode, channelId, firebaseToken, encodedFirebaseCompanyCode) {
        var firebaseService = FirebaseServiceFactory.getFireBaseService();
        if (firebaseService && firebaseToken) {
            console.info("Firebase : sign-in with channelId " + channelId + " and firebaseToken " + firebaseToken);
            firebaseService.auth.signInWithCustomToken(firebaseToken).catch(function (error) {
                console.log("errorCode = " + error.code + ", errorMessage = " + error.message);
            });
            firebaseService.auth.onAuthStateChanged(function (user) {
                if (user && user.uid === channelId) {
                    onFirebaseMessageAdded(companyCode, channelId, encodedFirebaseCompanyCode);
                }
            });
        }
    }

    function onFirebaseMessageAdded(companyCode, channelId, encodedFirebaseCompanyCode) {
        var nodePath = "company/" + (encodedFirebaseCompanyCode ? encodedFirebaseCompanyCode : companyCode) + "/channel/" + channelId + "/message";
        console.info("Firebase : add observer on " + CHILD_ADDED_EVENT + " for firebase user " + firebaseUserUid() + " on node \"" + nodePath + "\"");
        var firebaseService = FirebaseServiceFactory.getFireBaseService();
        if (firebaseService) {
            var messageRef = firebaseService.database.ref(nodePath);
            messageRef.on(CHILD_ADDED_EVENT, function (child) {
                var message = child.val();
                console.log("Firebase : new message reception");
                console.log(message);
                if (message && message.data && message.sourceChannelId !== channelId && message.targetChannelId === channelId) {
                    console.log("Firebase : new message treated : " + JSON.stringify(message));
                    var userAction = JSON.parse(message.data);
                    if (userAction && userAction.objectType === "Notification") {
                        NotificationSrv.onNotificationChannel(userAction);
                    } else {
                        UserActionManager.executeUserAction(userAction, true);
                    }
                } else if (message && message.sourceChannelId === channelId) {
                    console.log("Firebase : new message not treated because modificatiion message was emitted by the current channelId");
                } else if (message && message.targetChannelId !== channelId) {
                    console.log("Firebase : new message not treated because current channelId (" + channelId + ") not in targetted (targetChannelId : " + message.targetChannelId + ")");
                } else {
                    console.log("Firebase : new message not treated");
                }
            });
        }
    }

    function firebaseUserUid() {
        var userUid = "/Not connected to firebase/";
        var firebaseService = FirebaseServiceFactory.getFireBaseService();
        if (firebaseService) {
            userUid = firebaseService.auth && firebaseService.auth.currentUser ? firebaseService.auth.currentUser.uid : userUid;
        }
        return userUid;
    }

    function disconnectUser(absUrl, isProSite, companyCode) {
        currentUser = deleteCurrentUser();
        deleteCookie(absUrl, isProSite, companyCode);
    }

    function createCurrentUser(user, token) {
        return {
            id: user.id,
            email: user.email,
            phone: user.phone,
            role: user.role,
            companyCode: user.companyCode,
            companyName: user.companyName,
            token: token //token for rest security
        };
    }

    function deleteCurrentUser() {
        return {
            id: null,
            email: '',
            phone: '',
            role: userRoles.public,
            companyCode: null,
            companyName: null,
            token: null
        };
    }

    function createCookie(absUrl, isProSite, user, cookieUser, companyCode, channelId) {
        var kiuteProUser = initKiuteProUser(cookieUser, companyCode, false);
        var currentUserCookie = Object.assign(kiuteProUser, {
            channelId: channelId
        });

        if (absUrl.indexOf("/connect#") !== -1 && isProSite) {
            CookieFactory.setCookieRoot('flexyBeauty-connect-user-' + user.companyCode, currentUserCookie);
        } else {
            if (isProSite) {
                CookieFactory.setCookie('flexyBeauty-pro-user', currentUserCookie);
            } else {
                CookieFactory.setCookie('flexyBeauty-web-user-' + companyCode, currentUserCookie);
                bugsnag.user = {
                    id: companyCode,
                    email: user.email
                };
            }
        }
    }

    function deleteCookie(absUrl, isProSite, companyCode) {
        if (absUrl.indexOf("/connect/") !== -1 && isProSite) {
            var index = absUrl.indexOf("connect/");
            var connectCompanyCode = absUrl.substr(index + 8);
            var index2 = connectCompanyCode.indexOf("#");
            if (index2 !== -1) {
                connectCompanyCode = connectCompanyCode.substr(0, index2);
            }
            CookieFactory.removeCookieRoot('flexyBeauty-connect-user-' + connectCompanyCode);
        } else {
            if (isProSite) {
                CookieFactory.removeCookie('flexyBeauty-pro-user');
            } else {
                CookieFactory.removeCookie('flexyBeauty-web-user-' + companyCode);
                bugsnag.user = {
                    id: companyCode,
                    email: ""
                };
            }
        }
    }

    function afterLogout(companyCode, success, successParam) {
        changeUser(null, companyCode, null, null, true);
        if (success !== undefined) {
            success(successParam);
        }
        redirectOnLoginPage();
    }

    function isAdmin(absUrl) {
        return absUrl && absUrl.indexOf(Brand.url.adminUrl) !== -1;
    }

    function isGroup(absUrl) {
        return absUrl && absUrl.indexOf(Brand.url.groupUrl) !== -1;
    }

    return {
        init: function init(isProSite, companyCode) {
            var absUrl = $location.absUrl();
            if (isAdmin(absUrl)) {
                //Admin mode
                var adminUrlPattern = Brand.url.adminUrl;
                var index = absUrl.indexOf(adminUrlPattern);
                var currentCompanyCode = absUrl.substr(index + adminUrlPattern.length);
                var index2 = currentCompanyCode.indexOf("#");
                if (index2 !== -1) {
                    currentCompanyCode = currentCompanyCode.substr(0, index2);
                }
                currentUser = CookieFactory.getCookie('flexyBeauty-admin-user');
                if (currentUser) {
                    currentUser.companyCode = currentCompanyCode;
                    currentUser.role = userRoles.admin;
                    $http.defaults.headers.common.Authorization = currentUser.token + '&' + currentCompanyCode;
                }
            } else if (isGroup(absUrl)) {
                var groupUrlPattern = Brand.url.groupUrl;
                var _index = absUrl.indexOf(groupUrlPattern);
                var _currentCompanyCode = absUrl.substr(_index + groupUrlPattern.length);
                var _index2 = _currentCompanyCode.indexOf("#");
                if (_index2 !== -1) {
                    _currentCompanyCode = _currentCompanyCode.substr(0, _index2);
                }
                currentUser = CookieFactory.getCookie('flexyBeauty-group-user');
                if (currentUser) {
                    currentUser.companyCode = _currentCompanyCode;
                    currentUser.role = userRoles.admin;
                    $http.defaults.headers.common.Authorization = currentUser.token + '&' + _currentCompanyCode;
                }
            } else if (absUrl && absUrl.indexOf("/connect", absUrl.length - 8) !== -1 || absUrl.indexOf("/connect/") !== -1 || absUrl.indexOf("/connect#") !== -1) {
                //Multi mode
                var _index3 = absUrl.indexOf("connect/");
                if (_index3 !== -1) {
                    var _currentCompanyCode2 = absUrl.substr(_index3 + 8);
                    var _index4 = _currentCompanyCode2.indexOf("#");
                    if (_index4 !== -1) {
                        _currentCompanyCode2 = _currentCompanyCode2.substr(0, _index4);
                    }
                    currentUser = CookieFactory.getCookie('flexyBeauty-connect-user-' + _currentCompanyCode2);
                    if (currentUser) {
                        $http.defaults.headers.common.Authorization = currentUser.token;
                    }
                }
            } else if (!currentUser) {
                if (isProSite) {
                    // connection to connect site
                    currentUser = CookieFactory.getCookie('flexyBeauty-pro-user');
                } else {
                    // connection to web site
                    currentUser = CookieFactory.getCookie('flexyBeauty-web-user-' + companyCode);
                    if (!currentUser) {
                        //for old compatibility
                        currentUser = CookieFactory.getCookie('flexyBeauty-web-user');
                        CookieFactory.setCookie('flexyBeauty-web-user-' + companyCode, currentUser);
                        CookieFactory.removeCookie('flexyBeauty-web-user');
                    }
                }
                if (currentUser) {
                    $http.defaults.headers.common.Authorization = currentUser.token;
                }
            }
        },
        authorize: function authorize(accessLevel, role) {
            if (role === undefined && currentUser) {
                role = currentUser.role;
            } else {
                role = userRoles.public;
            }
            if (accessLevel) {
                return accessLevel.bitMask & role.bitMask;
            } else {
                return null;
            }
        },
        isAdmin: function isAdmin() {
            if (currentUser) {
                return currentUser.role === userRoles.admin;
            }
        },
        isAdminNotGroup: function isAdminNotGroup() {
            return isAdmin($location.absUrl()) && !isGroup($location.absUrl());
        },
        isLoggedIn: function isLoggedIn(user) {
            if (user === undefined) {
                user = currentUser;
            }
            if (user) {
                return user.role.title === userRoles.user.title || user.role.title === userRoles.admin.title;
            } else {
                return false;
            }
        },
        clearWebSiteUser: function clearWebSiteUser(companyCode) {
            changeUser(null, companyCode, null, false);
        },
        getCompanyCode: function getCompanyCode() {
            if (currentUser) {
                return currentUser.companyCode;
            }
            return '';
        },
        getCompanyName: function getCompanyName() {
            if (currentUser) {
                return currentUser.companyName;
            }
            return '';
        },
        getCurrentUser: function getCurrentUser() {
            return currentUser;
        },
        getToken: function getToken() {
            if (currentUser) {
                return currentUser.token;
            }
            return '';
        },
        registerToProSite: function registerToProSite(user, success, error) {
            UserSrv.register(user, function (res) {
                changeUser(user, user.companyCode, res.token, res.channelId, true);
                if (success !== undefined) {
                    success(res);
                }
            }, error);
        },
        loginToProSite: function loginToProSite(user, success, error) {
            UserSrv.login(user, function (res) {
                $http.defaults.headers.common.Authorization = res.token;
                currentUser = createCurrentUser(user, res.token);
                createCookie($location.absUrl(), true, user, currentUser, user.companyCode);
                if (success !== undefined) {
                    success(res);
                }
            }, error);
        },
        loginToProSiteOnForgetPwd: function loginToProSiteOnForgetPwd(user, token, success, error) {
            UserSrv.loginOnForgetPwd(user, token, function (res) {
                changeUser(user, user.companyCode, res.token, res.channelId, true);
                if (success !== undefined) {
                    success(res);
                }
            }, error);
        },
        loginToWebSite: function loginToWebSite(companyCode, customer, success, error) {
            if (customer) {
                CustomerSrv.login(customer, function (res) {
                    changeUser(customer, companyCode, res.token, null, false);
                    if (success !== undefined) {
                        success(customer);
                    }
                }, error);
            } else {
                UserSrv.loginAnonymous(companyCode, function (res) {
                    // Set token in memory but store no cookies
                    changeUser(null, companyCode, res.token, null, false);
                    if (success !== undefined) {
                        success(customer);
                    }
                }, error);
            }
        },
        loginToWebSiteByToken: function loginToWebSiteByToken(email, companyCode, token) {
            changeUser({ email: email }, companyCode, token, null, false);
        },
        createChannel: function createChannel(user) {
            return UserSrv.createChannel().then(function (data) {
                $http.defaults.headers.common["Channel-Id"] = data.channelId;
                sessionStorage.setItem('channelId', data.channelId);
                return changeUser(user, user.companyCode, user.token, data.channelId, true, data.firebaseToken, data.firebaseEncodedCompanyCode);
            }).catch(); // This empty catch is used to throw an exception to the calling method
        },
        changeUserFromWebSite: function changeUserFromWebSite(customer, companyCode, token) {
            changeUser(customer, companyCode, token, null, false);
        },
        registerToWebSite: function registerToWebSite(customer, companyCode, success, error) {
            CustomerSrv.register(customer, function (res) {
                changeUser(customer, companyCode, res.token, null, false);
                customer.optInOut.customerId = res.userId;
                OptInOutSrv.save(customer.optInOut, function () {
                    if (success !== undefined) {
                        success(customer);
                    }
                }, error);
            }, error);
        },
        logout: function logout(success, error) {
            var absUrl = $location.absUrl();
            if (currentUser && (!absUrl || absUrl.indexOf(Brand.url.adminUrl) === -1 && absUrl.indexOf(Brand.url.groupUrl) === -1)) {
                var user = new User(currentUser);
                UserSrv.logout(user, function (res) {
                    afterLogout(user.companyCode, success, res);
                }, function (res) {
                    //Force logout and clear token of cookie
                    changeUser(null, user.companyCode, null, null, true);
                    if (error !== undefined) {
                        error(res);
                    }
                    redirectOnLoginPage();
                });
            }
        },
        logoutFromWeb: function logoutFromWeb(customer, companyCode, success, error) {
            if (currentUser) {
                if (customer) {
                    CustomerSrv.logout(customer, function (res) {
                        changeUser(null, companyCode, null, null, false);
                        if (success !== undefined) {
                            success(res);
                        }
                    }, function (res) {
                        //Force logout and clear token of cookie
                        changeUser(null, companyCode, null, null, false);
                        if (error !== undefined) {
                            error(res);
                        }
                    });
                } else {
                    changeUser(null, currentUser.companyCode, null, null, false);
                    if (success !== undefined) {
                        success();
                    }
                }
            }
        },
        afterLogout: afterLogout,
        accessLevels: accessLevels,
        userRoles: userRoles,
        user: currentUser
    };
}]);

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp').factory('CookieFactory', ["ipCookie", function (ipCookie) {

    return {
        getCookie: function getCookie(name) {
            return ipCookie(name);
        },

        getAllCookies: function getAllCookies() {
            return ipCookie();
        },

        setCookie: function setCookie(name, value) {
            return ipCookie(name, value, { expires: 100 });
        },

        removeCookie: function removeCookie(name) {
            return ipCookie(name, null);
        },
        setCookieRoot: function setCookieRoot(name, value) {
            return ipCookie(name, value, { expires: 100, path: '/' });
        },

        removeCookieRoot: function removeCookieRoot(name) {
            return ipCookie(name, null, { path: '/' });
        }
    };
}]);

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Created by cedricgodefroy on 27/10/2017.
 */
angular.module('FlexyBeautyApp.services').factory('NumberSeparatorType', [function () {
    return {
        DECIMAL: { id: 'decimal' },
        GROUP: { id: 'group' }
    };
}]);
angular.module('FlexyBeautyApp.services').factory('CurrencyManager', ["CurrencyData", "LanguageManager", "NumberSeparatorType", function (CurrencyData, LanguageManager, NumberSeparatorType) {
    var CurrencyManager = {
        symbol: null,
        code: null,
        codeIso: null,
        intlFormatter: null
    };

    CurrencyManager.setByCurrency = function (currency) {
        if (currency !== null) {
            this.set(currency.symbol, currency.code, currency.codeMango);
        } else {
            this.setDefaultCurency();
        }
        this.setIntlFormatter();
    };

    CurrencyManager.set = function (symbol, code, codeIso) {
        if (symbol && code && codeIso) {
            this.symbol = symbol;
            this.code = code;
            this.codeIso = codeIso;
        } else {
            this.setDefaultCurency();
        }
        this.setIntlFormatter();
    };

    CurrencyManager.setDefaultCurency = function () {
        this.symbol = "€";
        this.code = "eu";
        this.codeIso = "EUR";
    };

    CurrencyManager.getCurrencyCode = function () {
        return this.code;
    };

    CurrencyManager.getCurrencySymbol = function () {
        return this.symbol;
    };

    CurrencyManager.getCurrencyCodeIso = function () {
        return this.codeIso;
    };

    CurrencyManager.isEuroCurrency = function () {
        return this.codeIso === "EUR";
    };

    CurrencyManager.getSeparator = function (separatorType) {
        var numberWithGroupAndDecimalSeparator = 1000.1;
        var separator = void 0,
            intlFormater = LanguageManager.getIntlNumberFormatter();

        if (intlFormater) {
            separator = intlFormater.formatToParts(numberWithGroupAndDecimalSeparator).find(function (part) {
                return part.type === separatorType.id;
            }).value;
        } else {
            if (separatorType === NumberSeparatorType.GROUP) {
                separator = numberWithGroupAndDecimalSeparator.toLocaleString(LanguageManager.getLocale()).substring(1, 2);
            } else if (separatorType === NumberSeparatorType.DECIMAL) {
                separator = numberWithGroupAndDecimalSeparator.toLocaleString(LanguageManager.getLocale()).substring(5, 6);
            }
        }
        return separator;
    };

    CurrencyManager.setIntlFormatter = function () {
        try {
            if (Intl && (typeof Intl === 'undefined' ? 'undefined' : _typeof(Intl)) === 'object' && Intl && Intl.NumberFormat && typeof Intl.NumberFormat === 'function' && Intl.NumberFormat.prototype.hasOwnProperty("formatToParts") && Intl.NumberFormat.prototype.hasOwnProperty("format")) {
                this.intlFormatter = new Intl.NumberFormat(LanguageManager.getLocale(), {
                    style: 'currency',
                    currency: this.getCurrencyCodeIso(),
                    minimumFractionDigits: 2
                    // the default value for minimumFractionDigits depends on the currency
                    // and is usually already 2
                });
            }
        } catch (e) {
            //sometimes some browsers (mobile safari) throw an exception " ReferenceError · Can't find variable: Intl" despite of the test above
            //if it occurs an exception with Intl, we force the intlNumberFormatter to null in order to format the number with the "old method"
            this.intlFormatter = null;
        }
    };

    CurrencyManager.getIntlFormatter = function () {
        return this.intlFormatter;
    };

    CurrencyManager.getPriceFromPriceInput = function (priceInput) {
        return priceInput.replace(/\s/g, '').replace(this.getCurrencySymbol(), "")
        //systematical echapment of all group separator
        //In the world there are only 4 group separators : , .’˙ (http://www.statisticalconsultants.co.nz/blog/how-the-world-separates-its-digits.html)
        //this action is usefull and possible because of two reasons :
        //1) the . character have a particular role in a Regexp expression so we have to escape it
        //2) the expression with the other group separator and the escape character (\, \’ and \˙) have no particular role in Regexp (not like \d or other \s) so that the escape character is transparent and not radically change the meaning of the Regexp
        .replace(new RegExp("\\" + this.getSeparator(NumberSeparatorType.GROUP), "g"), "").replace(this.getSeparator(NumberSeparatorType.DECIMAL), ".");
    };

    return CurrencyManager;
}]);

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('ErrorCode', [function () {

    var errorCode = {
        SESSION_TOKEN_INVALID: { code: '40103' },
        CHANNEL_INVALID: { code: '40104' },
        CHANNEL_EXPIRED: { code: '40105' },
        BOOKING_CONFLICT: { code: '40930' },
        SALE_CONFLICT: { code: '40940' },
        COMPANY_EMAIL_CONFLICT: { code: '40950' }
    };

    return errorCode;
}]);

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by sebastienbeaujard on 26/04/2014.
 * Transaction server manager + retry feature
 */
angular.module('FlexyBeautyApp.services').factory('GlobalVariable', ["$log", "AppData", function ($log, AppData) {
    var globalVariable = {
        vat: 20, //TVA used by application (can be overrided)
        defaultVat: 20
    };

    globalVariable.loadVat = function () {

        var posApp = AppData.getAppByCode("pos");
        if (posApp != null) {
            var vatAttr = posApp.getAppAttribute("vat");
            if (vatAttr && vatAttr.value) globalVariable.vat = parseFloat(vatAttr.value);else globalVariable.vat = globalVariable.defaultVat;
        } else {
            globalVariable.vat = globalVariable.defaultVat;
        }
    };
    return globalVariable;
}]);

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Created by cedricgodefroy on 27/10/2017.
 */

angular.module('FlexyBeautyApp.services').factory('LanguageManager_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/lokalise/', {}, {
        getJsonFile: { method: 'POST', url: baseUrl + 'rest/lokalise/getJsonFile' }
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Countries', ["gettextCatalog", function (gettextCatalog) {

    var countries = {};

    countries.FRANCE = { countryCode: "FR", countryName: gettextCatalog.getString("France"), isSupported: false, onlinePaymentLink: "https://www.infogreffe.fr", shareholderDeclarationLink: "https://www.mangopay.com/terms/shareholder-declaration/Shareholder_Declaration-FR.pdf" };
    countries.BELGIUM = { countryCode: "BE", countryName: gettextCatalog.getString("Belgique"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SWITZERLAND = { countryCode: "CH", countryName: gettextCatalog.getString("Suisse"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.LUXEMBOURG = { countryCode: "LU", countryName: gettextCatalog.getString("Luxembourg"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.AFGHANISTAN = { countryCode: "AF", countryName: gettextCatalog.getString("Afghanistan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SOUTHAFRICA = { countryCode: "ZA", countryName: gettextCatalog.getString("Afrique du sud"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ALAND = { countryCode: "AX", countryName: gettextCatalog.getString("Åland, îles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ALBANIA = { countryCode: "AL", countryName: gettextCatalog.getString("Albanie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ALGERIA = { countryCode: "DZ", countryName: gettextCatalog.getString("Algérie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GERMANY = { countryCode: "DE", countryName: gettextCatalog.getString("Allemagne"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ANDORRA = { countryCode: "AD", countryName: gettextCatalog.getString("Andorre"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ANGOLA = { countryCode: "AO", countryName: gettextCatalog.getString("Angola"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ANGUILLA = { countryCode: "AI", countryName: gettextCatalog.getString("Anguilla"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ANTARCTICA = { countryCode: "AQ", countryName: gettextCatalog.getString("Antarctique"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ANTIGUAANDBARBUDA = { countryCode: "AG", countryName: gettextCatalog.getString("Antigua et barbuda"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SAUDIARABIA = { countryCode: "SA", countryName: gettextCatalog.getString("Arabie saoudite"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ARGENTINA = { countryCode: "AR", countryName: gettextCatalog.getString("Argentine"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ARMENIA = { countryCode: "AM", countryName: gettextCatalog.getString("Arménie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ARUBA = { countryCode: "AW", countryName: gettextCatalog.getString("Aruba"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.AUSTRALIA = { countryCode: "AU", countryName: gettextCatalog.getString("Australie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.AUSTRIA = { countryCode: "AT", countryName: gettextCatalog.getString("Autriche"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.AZERBAIJAN = { countryCode: "AZ", countryName: gettextCatalog.getString("Azerbaïdjan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BAHAMAS = { countryCode: "BS", countryName: gettextCatalog.getString("Bahamas"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BAHRAIN = { countryCode: "BH", countryName: gettextCatalog.getString("Bahreïn"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BANGLADECH = { countryCode: "BD", countryName: gettextCatalog.getString("Bangladesh"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BARBADOS = { countryCode: "BB", countryName: gettextCatalog.getString("Barbade"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BELARUS = { countryCode: "BY", countryName: gettextCatalog.getString("Bélarus"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BELIZE = { countryCode: "BZ", countryName: gettextCatalog.getString("Belize"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BENIN = { countryCode: "BJ", countryName: gettextCatalog.getString("Bénin"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BERMUDA = { countryCode: "BM", countryName: gettextCatalog.getString("Bermudes"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BHUTAN = { countryCode: "BT", countryName: gettextCatalog.getString("Bhoutan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BOLIVIA = { countryCode: "BO", countryName: gettextCatalog.getString("Bolivie, l'état plurinational de"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BONAIRE = { countryCode: "BQ", countryName: gettextCatalog.getString("Bonaire, saint eustache et saba"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BOSNIAANDHERZEGOVINA = { countryCode: "BA", countryName: gettextCatalog.getString("Bosnie herzégovine"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BOTSWANA = { countryCode: "BW", countryName: gettextCatalog.getString("Botswana"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null }, countries.BOUVET = { countryCode: "BV", countryName: gettextCatalog.getString("Bouvet, île"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BRAZIL = { countryCode: "BR", countryName: gettextCatalog.getString("Brésil"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BRUNEIDARUSSALAM = { countryCode: "BN", countryName: gettextCatalog.getString("Brunei darussalam"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BULGARIA = { countryCode: "BG", countryName: gettextCatalog.getString("Bulgarie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BURKINAFASO = { countryCode: "BF", countryName: gettextCatalog.getString("Burkina faso"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BURUNDI = { countryCode: "BI", countryName: gettextCatalog.getString("Burundi"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CAYMAN = { countryCode: "KY", countryName: gettextCatalog.getString("Caïmans, îles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CAMBODIA = { countryCode: "KH", countryName: gettextCatalog.getString("Cambodge"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CAMEROUN = { countryCode: "CM", countryName: gettextCatalog.getString("Cameroun"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CANADA = { countryCode: "CA", countryName: gettextCatalog.getString("Canada"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CAPEVERDE = { countryCode: "CV", countryName: gettextCatalog.getString("Cap vert"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CENTRALAFRICANREPUBLIC = { countryCode: "CF", countryName: gettextCatalog.getString("Centrafricaine, république"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CHILI = { countryCode: "CL", countryName: gettextCatalog.getString("Chili"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CHINA = { countryCode: "CN", countryName: gettextCatalog.getString("Chine"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CHRISTMASISLAND = { countryCode: "CX", countryName: gettextCatalog.getString("Christmas, île"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CYPRUS = { countryCode: "CY", countryName: gettextCatalog.getString("Chypre"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.COCOSISLANDS = { countryCode: "CC", countryName: gettextCatalog.getString("Cocos (keeling), îles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.COLOMBIA = { countryCode: "CO", countryName: gettextCatalog.getString("Colombie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.COMOROS = { countryCode: "KM", countryName: gettextCatalog.getString("Comores"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CONGO = { countryCode: "CG", countryName: gettextCatalog.getString("Congo"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.DEMOCRATICREPUBLICOFTHECONGO = { countryCode: "CD", countryName: gettextCatalog.getString("Congo, la république démocratique du"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.COOKISLANDS = { countryCode: "CK", countryName: gettextCatalog.getString("Cook, îles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SOUTHKOREA = { countryCode: "KR", countryName: gettextCatalog.getString("Corée, république de"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NORTHKOREA = { countryCode: "KP", countryName: gettextCatalog.getString("Corée, république populaire démocratique de"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.COSTARICA = { countryCode: "CR", countryName: gettextCatalog.getString("Costa rica"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.IVORYCOAST = { countryCode: "CI", countryName: gettextCatalog.getString("Côte d'ivoire"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CROATIA = { countryCode: "HR", countryName: gettextCatalog.getString("Croatie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CUBA = { countryCode: "CU", countryName: gettextCatalog.getString("Cuba"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CUARCAO = { countryCode: "CW", countryName: gettextCatalog.getString("Curaçao"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.DENMARK = { countryCode: "DK", countryName: gettextCatalog.getString("Danemark"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.DJIBOUTI = { countryCode: "DJ", countryName: gettextCatalog.getString("Djibouti"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.DOMINICANREPUBLIC = { countryCode: "DO", countryName: gettextCatalog.getString("Dominicaine, république"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.DOMINICA = { countryCode: "DM", countryName: gettextCatalog.getString("Dominique"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.EGYPT = { countryCode: "EG", countryName: gettextCatalog.getString("Égypte"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ELSALVADOR = { countryCode: "SV", countryName: gettextCatalog.getString("El salvador"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.UNITEDARABEMIRATES = { countryCode: "AE", countryName: gettextCatalog.getString("Émirats arabes unis"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ECUADOR = { countryCode: "EC", countryName: gettextCatalog.getString("Équateur"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ERITREA = { countryCode: "ER", countryName: gettextCatalog.getString("Érythrée"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SPAIN = { countryCode: "ES", countryName: gettextCatalog.getString("Espagne"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ESTONIA = { countryCode: "EE", countryName: gettextCatalog.getString("Estonie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.UNITEDSTATESOFAMERICA = { countryCode: "US", countryName: gettextCatalog.getString("États unis"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ETHIOPIA = { countryCode: "ET", countryName: gettextCatalog.getString("Éthiopie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.FALKLANDISLANDS = { countryCode: "FK", countryName: gettextCatalog.getString("Falkland, îles (malvinas)"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.FAROEISLANDS = { countryCode: "FO", countryName: gettextCatalog.getString("Féroé, îles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.FIJI = { countryCode: "FJ", countryName: gettextCatalog.getString("Fidji"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.FINLAND = { countryCode: "FI", countryName: gettextCatalog.getString("Finlande"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GABON = { countryCode: "GA", countryName: gettextCatalog.getString("Gabon"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GAMBIA = { countryCode: "GM", countryName: gettextCatalog.getString("Gambie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GEORGIA = { countryCode: "GE", countryName: gettextCatalog.getString("Géorgie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SOUTHGEORGIA = { countryCode: "GS", countryName: gettextCatalog.getString("Géorgie du sud et les îles sandwich du sud"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GHANA = { countryCode: "GH", countryName: gettextCatalog.getString("Ghana"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GIBRALTAR = { countryCode: "GI", countryName: gettextCatalog.getString("Gibraltar"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GREECE = { countryCode: "GR", countryName: gettextCatalog.getString("Grèce"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GRENADA = { countryCode: "GD", countryName: gettextCatalog.getString("Grenade"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GREENLAND = { countryCode: "GL", countryName: gettextCatalog.getString("Groenland"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GUADELOUPE = { countryCode: "GP", countryName: gettextCatalog.getString("Guadeloupe"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GUAM = { countryCode: "GU", countryName: gettextCatalog.getString("Guam"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GUATEMALA = { countryCode: "GT", countryName: gettextCatalog.getString("Guatemala"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GUERNSEY = { countryCode: "GG", countryName: gettextCatalog.getString("Guernesey"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GUINEA = { countryCode: "GN", countryName: gettextCatalog.getString("Guinée"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GUINEABISSAU = { countryCode: "GW", countryName: gettextCatalog.getString("Guinée bissau"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.EQUATORIALGUINEA = { countryCode: "GQ", countryName: gettextCatalog.getString("Guinée équatoriale"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.GUYANA = { countryCode: "GY", countryName: gettextCatalog.getString("Guyana"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.FRENCHGUIANA = { countryCode: "GF", countryName: gettextCatalog.getString("Guyane française"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.HAITI = { countryCode: "HT", countryName: gettextCatalog.getString("Haïti"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.HEARDISLANDANDMCDONALDISLANDS = { countryCode: "HM", countryName: gettextCatalog.getString("Heard et îles macdonald, île"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.HONDOURAS = { countryCode: "HN", countryName: gettextCatalog.getString("Honduras"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.HONGKONG = { countryCode: "HK", countryName: gettextCatalog.getString("Hong kong"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.HUNGARY = { countryCode: "HU", countryName: gettextCatalog.getString("Hongrie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ISLEOFMAN = { countryCode: "IM", countryName: gettextCatalog.getString("Île de man"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MINOROUTLYINGISLANDSUNITEDSTATES = { countryCode: "UM", countryName: gettextCatalog.getString("Îles mineures éloignées des états unis"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BRITISHVIRGINISLANDS = { countryCode: "VG", countryName: gettextCatalog.getString("Îles vierges britanniques"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.USAVIRGINISLANDS = { countryCode: "VI", countryName: gettextCatalog.getString("Îles vierges des états unis"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.INDIA = { countryCode: "IN", countryName: gettextCatalog.getString("Inde"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.INDONESIA = { countryCode: "ID", countryName: gettextCatalog.getString("Indonésie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.IRAN = { countryCode: "IR", countryName: gettextCatalog.getString("Iran, république islamique d'"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.IRAQ = { countryCode: "IQ", countryName: gettextCatalog.getString("Iraq"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.IRELAND = { countryCode: "IE", countryName: gettextCatalog.getString("Irlande"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ICELAND = { countryCode: "IS", countryName: gettextCatalog.getString("Islande"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ISRAEL = { countryCode: "IL", countryName: gettextCatalog.getString("Israël"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ITALIA = { countryCode: "IT", countryName: gettextCatalog.getString("Italie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.JAMAICA = { countryCode: "JM", countryName: gettextCatalog.getString("Jamaïque"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.JAPAN = { countryCode: "JP", countryName: gettextCatalog.getString("Japon"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.JERSEY = { countryCode: "JE", countryName: gettextCatalog.getString("Jersey"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.JORDAN = { countryCode: "JO", countryName: gettextCatalog.getString("Jordanie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.KAZAKHSTAN = { countryCode: "KZ", countryName: gettextCatalog.getString("Kazakhstan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.KENYA = { countryCode: "KE", countryName: gettextCatalog.getString("Kenya"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.KYRGYZSTAN = { countryCode: "KG", countryName: gettextCatalog.getString("Kirghizistan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.KIRIBATI = { countryCode: "KI", countryName: gettextCatalog.getString("Kiribati"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.KUWAIT = { countryCode: "KW", countryName: gettextCatalog.getString("Koweït"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.LAO = { countryCode: "LA", countryName: gettextCatalog.getString("Lao, république démocratique populaire"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.LESOTHO = { countryCode: "LS", countryName: gettextCatalog.getString("Lesotho"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.LATVIA = { countryCode: "LV", countryName: gettextCatalog.getString("Lettonie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.LEBANON = { countryCode: "LB", countryName: gettextCatalog.getString("Liban"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.LIBERIA = { countryCode: "LR", countryName: gettextCatalog.getString("Libéria"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.LIBYA = { countryCode: "LY", countryName: gettextCatalog.getString("Libye"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.LIECHTENSTEIN = { countryCode: "LI", countryName: gettextCatalog.getString("Liechtenstein"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.LITHUANIA = { countryCode: "LT", countryName: gettextCatalog.getString("Lituanie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MACAU = { countryCode: "MO", countryName: gettextCatalog.getString("Macao"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MACEDONIA = { countryCode: "MK", countryName: gettextCatalog.getString("Macédoine, l'ex république yougoslave de"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MADAGASCAR = { countryCode: "MG", countryName: gettextCatalog.getString("Madagascar"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MALISIA = { countryCode: "MY", countryName: gettextCatalog.getString("Malaisie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MALAWI = { countryCode: "MW", countryName: gettextCatalog.getString("Malawi"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MALDIVES = { countryCode: "MV", countryName: gettextCatalog.getString("Maldives"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MALI = { countryCode: "ML", countryName: gettextCatalog.getString("Mali"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MALTA = { countryCode: "MT", countryName: gettextCatalog.getString("Malte"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NORTHERNMARIANAISLANDS = { countryCode: "MP", countryName: gettextCatalog.getString("Mariannes du nord, îles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MAROCO = { countryCode: "MA", countryName: gettextCatalog.getString("Maroc"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MARSHALL = { countryCode: "MH", countryName: gettextCatalog.getString("Marshall, îles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MARTINIQUE = { countryCode: "MQ", countryName: gettextCatalog.getString("Martinique"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MAURITIUS = { countryCode: "MU", countryName: gettextCatalog.getString("Maurice"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MAURITANIA = { countryCode: "MR", countryName: gettextCatalog.getString("Mauritanie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MAYOTTE = { countryCode: "YT", countryName: gettextCatalog.getString("Mayotte"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MEXICO = { countryCode: "MX", countryName: gettextCatalog.getString("Mexique"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MICRONESIAFEDERALSTATESOF = { countryCode: "FM", countryName: gettextCatalog.getString("Micronésie, états fédérés de"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MOLDOVA = { countryCode: "MD", countryName: gettextCatalog.getString("Moldova, république de"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MONACO = { countryCode: "MC", countryName: gettextCatalog.getString("Monaco"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MONGOLIA = { countryCode: "MN", countryName: gettextCatalog.getString("Mongolie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MONTENEGRO = { countryCode: "ME", countryName: gettextCatalog.getString("Monténégro"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MONTSERRAT = { countryCode: "MS", countryName: gettextCatalog.getString("Montserrat"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MOZAMBIQUE = { countryCode: "MZ", countryName: gettextCatalog.getString("Mozambique"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.MYNAMAR = { countryCode: "MM", countryName: gettextCatalog.getString("Myanmar"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NAMIBIA = { countryCode: "NA", countryName: gettextCatalog.getString("Namibie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NAURU = { countryCode: "NR", countryName: gettextCatalog.getString("Nauru"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NEPAL = { countryCode: "NP", countryName: gettextCatalog.getString("Népal"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NICARAGUA = { countryCode: "NI", countryName: gettextCatalog.getString("Nicaragua"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NIGER = { countryCode: "NE", countryName: gettextCatalog.getString("Niger"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NIGERIA = { countryCode: "NG", countryName: gettextCatalog.getString("Nigéria"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NIUE = { countryCode: "NU", countryName: gettextCatalog.getString("Niué"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NOFOLKISLAND = { countryCode: "NF", countryName: gettextCatalog.getString("Norfolk, île"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NORWAY = { countryCode: "NO", countryName: gettextCatalog.getString("Norvège"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NEWCALEDONIA = { countryCode: "NC", countryName: gettextCatalog.getString("Nouvelle calédonie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NEWZEALAND = { countryCode: "NZ", countryName: gettextCatalog.getString("Nouvelle zélande"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BRITISHINDIANOCEANTERRITORY = { countryCode: "IO", countryName: gettextCatalog.getString("Océan indien, territoire britannique de l'"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.OMAN = { countryCode: "OM", countryName: gettextCatalog.getString("Oman"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.UGANDA = { countryCode: "UG", countryName: gettextCatalog.getString("Ouganda"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.UZBEKISTAN = { countryCode: "UZ", countryName: gettextCatalog.getString("Ouzbékistan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PAKISTAN = { countryCode: "PK", countryName: gettextCatalog.getString("Pakistan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PALAU = { countryCode: "PW", countryName: gettextCatalog.getString("Palaos"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PALESTINIANTERRITORIES = { countryCode: "PS", countryName: gettextCatalog.getString("Palestinien occupé, territoire"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PANAMA = { countryCode: "PA", countryName: gettextCatalog.getString("Panama"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PAPUANEWGUINEA = { countryCode: "PG", countryName: gettextCatalog.getString("Papouasie nouvelle guinée"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PARAGUAY = { countryCode: "PY", countryName: gettextCatalog.getString("Paraguay"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.NETHERLANDS = { countryCode: "NL", countryName: gettextCatalog.getString("Pays bas"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PERU = { countryCode: "PE", countryName: gettextCatalog.getString("Pérou"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PHILIPPINES = { countryCode: "PH", countryName: gettextCatalog.getString("Philippines"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PITCAIRNISLAND = { countryCode: "PN", countryName: gettextCatalog.getString("Pitcairn"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.POLAND = { countryCode: "PL", countryName: gettextCatalog.getString("Pologne"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.FRENCHPOLYNESIA = { countryCode: "PF", countryName: gettextCatalog.getString("Polynésie française"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PORTORICO = { countryCode: "PR", countryName: gettextCatalog.getString("Porto rico"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.PORTUGAL = { countryCode: "PT", countryName: gettextCatalog.getString("Portugal"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.QATAR = { countryCode: "QA", countryName: gettextCatalog.getString("Qatar"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.REUNIONISLAND = { countryCode: "RE", countryName: gettextCatalog.getString("Réunion"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ROMANIA = { countryCode: "RO", countryName: gettextCatalog.getString("Roumanie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.UNITEDKINGDOM = { countryCode: "GB", countryName: gettextCatalog.getString("Royaume uni"), isSupported: false, onlinePaymentLink: "https://beta.companieshouse.gov.uk/", shareholderDeclarationLink: null };
    countries.RUSSIA = { countryCode: "RU", countryName: gettextCatalog.getString("Russie, fédération de"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.RWANDA = { countryCode: "RW", countryName: gettextCatalog.getString("Rwanda"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.WESTERNSAHARA = { countryCode: "EH", countryName: gettextCatalog.getString("Sahara occidental"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.STBARTHOLOMEW = { countryCode: "BL", countryName: gettextCatalog.getString("Saint barthélemy"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SAINTHELENA = { countryCode: "SH", countryName: gettextCatalog.getString("Sainte hélène, ascension et tristan da cunha"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.STLUCIA = { countryCode: "LC", countryName: gettextCatalog.getString("Sainte lucie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.STKITTS = { countryCode: "KN", countryName: gettextCatalog.getString("Saint kitts et nevis"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.STMARINO = { countryCode: "SM", countryName: gettextCatalog.getString("Saint marin"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.STMARINOFRENCHPART = { countryCode: "MF", countryName: gettextCatalog.getString("Saint martin(partie française)"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.STMARINODUTCHPART = { countryCode: "SX", countryName: gettextCatalog.getString("Saint martin (partie néerlandaise)"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SAINTPIERREANDMIQUELON = { countryCode: "PM", countryName: gettextCatalog.getString("Saint pierre et miquelon"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.HOLYSEESTATEOFTHECITYOFVATICAN = { countryCode: "VA", countryName: gettextCatalog.getString("Saint siège (état de la cité du vatican)"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SAINTVINCENTANDTHEGRENADINES = { countryCode: "VC", countryName: gettextCatalog.getString("Saint vincent et les grenadines"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SOLOMONISLANDS = { countryCode: "SB", countryName: gettextCatalog.getString("Salomon, îles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SAMOA = { countryCode: "WS", countryName: gettextCatalog.getString("Samoa"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.AMERICANSAMOA = { countryCode: "AS", countryName: gettextCatalog.getString("Samoa américaines"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SAOTOMEANDPRINCIPE = { countryCode: "ST", countryName: gettextCatalog.getString("Sao tomé et principe"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SENEGAL = { countryCode: "SN", countryName: gettextCatalog.getString("Sénégal"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SERBIA = { countryCode: "RS", countryName: gettextCatalog.getString("Serbie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SEYCHELLES = { countryCode: "SC", countryName: gettextCatalog.getString("Seychelles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SIERRALEONE = { countryCode: "SL", countryName: gettextCatalog.getString("Sierra leone"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SINGAPORE = { countryCode: "SG", countryName: gettextCatalog.getString("Singapour"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SLOVAKIA = { countryCode: "SK", countryName: gettextCatalog.getString("Slovaquie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SLOVENIA = { countryCode: "SI", countryName: gettextCatalog.getString("Slovénie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SOMALIA = { countryCode: "SO", countryName: gettextCatalog.getString("Somalie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SUDAN = { countryCode: "SD", countryName: gettextCatalog.getString("Soudan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SOUTHSUDAN = { countryCode: "SS", countryName: gettextCatalog.getString("Soudan du sud"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SRILANKA = { countryCode: "LK", countryName: gettextCatalog.getString("Sri lanka"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SWEDEN = { countryCode: "SE", countryName: gettextCatalog.getString("Suède"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SURINAME = { countryCode: "SR", countryName: gettextCatalog.getString("Suriname"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SVALBARDANDJANMAYEN = { countryCode: "SJ", countryName: gettextCatalog.getString("Svalbard et île jan mayen"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SWAZILAND = { countryCode: "SZ", countryName: gettextCatalog.getString("Swaziland"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.SYRIA = { countryCode: "SY", countryName: gettextCatalog.getString("Syrienne, république arabe"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TAJIKISTAN = { countryCode: "TJ", countryName: gettextCatalog.getString("Tadjikistan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TAIWAN = { countryCode: "TW", countryName: gettextCatalog.getString("Taïwan, province de chine"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TANZANIA = { countryCode: "TZ", countryName: gettextCatalog.getString("Tanzanie, république unie de"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.CHAD = { countryCode: "TD", countryName: gettextCatalog.getString("Tchad"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.BELIZE = { CZECHREPUBLIC: "CZ", countryName: gettextCatalog.getString("Tchèque, république"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.FRENCHSOUTHERNTERRITORIES = { countryCode: "TF", countryName: gettextCatalog.getString("Terres australes françaises"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.THAILAND = { countryCode: "TH", countryName: gettextCatalog.getString("Thaïlande"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TIMORLESTE = { countryCode: "TL", countryName: gettextCatalog.getString("Timor leste"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TOGO = { countryCode: "TG", countryName: gettextCatalog.getString("Togo"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TOKELAU = { countryCode: "TK", countryName: gettextCatalog.getString("Tokelau"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TONGA = { countryCode: "TO", countryName: gettextCatalog.getString("Tonga"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TRINIDADANDTOBAGO = { countryCode: "TT", countryName: gettextCatalog.getString("Trinité et tobago"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TUNISIA = { countryCode: "TN", countryName: gettextCatalog.getString("Tunisie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TURKMENISTAN = { countryCode: "TM", countryName: gettextCatalog.getString("Turkménistan"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TURKSANDCAICOSISLANDS = { countryCode: "TC", countryName: gettextCatalog.getString("Turks et caïcos, îles"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TURKEY = { countryCode: "TR", countryName: gettextCatalog.getString("Turquie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.TUVALU = { countryCode: "TV", countryName: gettextCatalog.getString("Tuvalu"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.UKRAINE = { countryCode: "UA", countryName: gettextCatalog.getString("Ukraine"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.URUGUAY = { countryCode: "UY", countryName: gettextCatalog.getString("Uruguay"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.VANUATU = { countryCode: "VU", countryName: gettextCatalog.getString("Vanuatu"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.VENEZUELA = { countryCode: "VE", countryName: gettextCatalog.getString("Venezuela, république bolivarienne du"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.VIETNAM = { countryCode: "VN", countryName: gettextCatalog.getString("Viet nam"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.WALLISANDFUTUNAISLANDS = { countryCode: "WF", countryName: gettextCatalog.getString("Wallis et futuna"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.YEMEN = { countryCode: "YE", countryName: gettextCatalog.getString("Yémen"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ZAMBIA = { countryCode: "ZM", countryName: gettextCatalog.getString("Zambie"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };
    countries.ZIMBABWE = { countryCode: "ZW", countryName: gettextCatalog.getString("Zimbabwe​​​​​"), isSupported: false, onlinePaymentLink: null, shareholderDeclarationLink: null };

    countries.map = [];
    countries.map[countries.FRANCE.countryCode] = countries.FRANCE;
    countries.map[countries.BELGIUM.countryCode] = countries.BELGIUM;
    countries.map[countries.SWITZERLAND.countryCode] = countries.SWITZERLAND;
    countries.map[countries.LUXEMBOURG.countryCode] = countries.LUXEMBOURG;
    countries.map[countries.AFGHANISTAN.countryCode] = countries.AFGHANISTAN;
    countries.map[countries.SOUTHAFRICA.countryCode] = countries.SOUTHAFRICA;
    countries.map[countries.ALAND.countryCode] = countries.ALAND;
    countries.map[countries.ALBANIA.countryCode] = countries.ALBANIA;
    countries.map[countries.ALGERIA.countryCode] = countries.ALGERIA;
    countries.map[countries.GERMANY.countryCode] = countries.GERMANY;
    countries.map[countries.ANDORRA.countryCode] = countries.ANDORRA;
    countries.map[countries.ANGOLA.countryCode] = countries.ANGOLA;
    countries.map[countries.ANGUILLA.countryCode] = countries.ANGUILLA;
    countries.map[countries.ANTARCTICA.countryCode] = countries.ANTARCTICA;
    countries.map[countries.ANTIGUAANDBARBUDA.countryCode] = countries.ANTIGUAANDBARBUDA;
    countries.map[countries.SAUDIARABIA.countryCode] = countries.SAUDIARABIA;
    countries.map[countries.ARGENTINA.countryCode] = countries.ARGENTINA;
    countries.map[countries.ARMENIA.countryCode] = countries.ARMENIA;
    countries.map[countries.ARUBA.countryCode] = countries.ARUBA;
    countries.map[countries.AUSTRALIA.countryCode] = countries.AUSTRALIA;
    countries.map[countries.AUSTRIA.countryCode] = countries.AUSTRIA;
    countries.map[countries.AZERBAIJAN.countryCode] = countries.AZERBAIJAN;
    countries.map[countries.BAHAMAS.countryCode] = countries.BAHAMAS;
    countries.map[countries.BAHRAIN.countryCode] = countries.BAHRAIN;
    countries.map[countries.BANGLADECH.countryCode] = countries.BANGLADECH;
    countries.map[countries.BARBADOS.countryCode] = countries.BARBADOS;
    countries.map[countries.BELARUS.countryCode] = countries.BELARUS;
    countries.map[countries.BELIZE.countryCode] = countries.BELIZE;
    countries.map[countries.BENIN.countryCode] = countries.BENIN;
    countries.map[countries.BERMUDA.countryCode] = countries.BERMUDA;
    countries.map[countries.BHUTAN.countryCode] = countries.BHUTAN;
    countries.map[countries.BOLIVIA.countryCode] = countries.BOLIVIA;
    countries.map[countries.BONAIRE.countryCode] = countries.BONAIRE;
    countries.map[countries.BOSNIAANDHERZEGOVINA.countryCode] = countries.BOSNIAANDHERZEGOVINA;
    countries.map[countries.BOTSWANA.countryCode] = countries.BOTSWANA;
    countries.map[countries.BOUVET.countryCode] = countries.BOUVET;
    countries.map[countries.BRAZIL.countryCode] = countries.BRAZIL;
    countries.map[countries.BRUNEIDARUSSALAM.countryCode] = countries.BRUNEIDARUSSALAM;
    countries.map[countries.BULGARIA.countryCode] = countries.BULGARIA;
    countries.map[countries.BURKINAFASO.countryCode] = countries.BURKINAFASO;
    countries.map[countries.BURUNDI.countryCode] = countries.BURUNDI;
    countries.map[countries.CAYMAN.countryCode] = countries.CAYMAN;
    countries.map[countries.CAMBODIA.countryCode] = countries.CAMBODIA;
    countries.map[countries.CAMEROUN.countryCode] = countries.CAMEROUN;
    countries.map[countries.CANADA.countryCode] = countries.CANADA;
    countries.map[countries.CAPEVERDE.countryCode] = countries.CAPEVERDE;
    countries.map[countries.CENTRALAFRICANREPUBLIC.countryCode] = countries.CENTRALAFRICANREPUBLIC;
    countries.map[countries.CHILI.countryCode] = countries.CHILI;
    countries.map[countries.CHINA.countryCode] = countries.CHINA;
    countries.map[countries.CHRISTMASISLAND.countryCode] = countries.CHRISTMASISLAND;
    countries.map[countries.CYPRUS.countryCode] = countries.CYPRUS;
    countries.map[countries.COCOSISLANDS.countryCode] = countries.COCOSISLANDS;
    countries.map[countries.COLOMBIA.countryCode] = countries.COLOMBIA;
    countries.map[countries.COMOROS.countryCode] = countries.COMOROS;
    countries.map[countries.CONGO.countryCode] = countries.CONGO;
    countries.map[countries.DEMOCRATICREPUBLICOFTHECONGO.countryCode] = countries.DEMOCRATICREPUBLICOFTHECONGO;
    countries.map[countries.COOKISLANDS.countryCode] = countries.COOKISLANDS;
    countries.map[countries.SOUTHKOREA.countryCode] = countries.SOUTHKOREA;
    countries.map[countries.NORTHKOREA.countryCode] = countries.NORTHKOREA;
    countries.map[countries.COSTARICA.countryCode] = countries.COSTARICA;
    countries.map[countries.IVORYCOAST.countryCode] = countries.IVORYCOAST;
    countries.map[countries.CROATIA.countryCode] = countries.CROATIA;
    countries.map[countries.CUBA.countryCode] = countries.CUBA;
    countries.map[countries.CUARCAO.countryCode] = countries.CUARCAO;
    countries.map[countries.DENMARK.countryCode] = countries.DENMARK;
    countries.map[countries.DJIBOUTI.countryCode] = countries.DJIBOUTI;
    countries.map[countries.DOMINICANREPUBLIC.countryCode] = countries.DOMINICANREPUBLIC;
    countries.map[countries.DOMINICA.countryCode] = countries.DOMINICA;
    countries.map[countries.EGYPT.countryCode] = countries.EGYPT;
    countries.map[countries.ELSALVADOR.countryCode] = countries.ELSALVADOR;
    countries.map[countries.UNITEDARABEMIRATES.countryCode] = countries.UNITEDARABEMIRATES;
    countries.map[countries.ECUADOR.countryCode] = countries.ECUADOR;
    countries.map[countries.ERITREA.countryCode] = countries.ERITREA;
    countries.map[countries.SPAIN.countryCode] = countries.SPAIN;
    countries.map[countries.ESTONIA.countryCode] = countries.ESTONIA;
    countries.map[countries.UNITEDSTATESOFAMERICA.countryCode] = countries.UNITEDSTATESOFAMERICA;
    countries.map[countries.ETHIOPIA.countryCode] = countries.ETHIOPIA;
    countries.map[countries.FALKLANDISLANDS.countryCode] = countries.FALKLANDISLANDS;
    countries.map[countries.FAROEISLANDS.countryCode] = countries.FAROEISLANDS;
    countries.map[countries.FIJI.countryCode] = countries.FIJI;
    countries.map[countries.FINLAND.countryCode] = countries.FINLAND;
    countries.map[countries.GABON.countryCode] = countries.GABON;
    countries.map[countries.GAMBIA.countryCode] = countries.GAMBIA;
    countries.map[countries.GEORGIA.countryCode] = countries.GEORGIA;
    countries.map[countries.SOUTHGEORGIA.countryCode] = countries.SOUTHGEORGIA;
    countries.map[countries.GHANA.countryCode] = countries.GHANA;
    countries.map[countries.GIBRALTAR.countryCode] = countries.GIBRALTAR;
    countries.map[countries.GREECE.countryCode] = countries.GREECE;
    countries.map[countries.GRENADA.countryCode] = countries.GRENADA;
    countries.map[countries.GREENLAND.countryCode] = countries.GREENLAND;
    countries.map[countries.GUADELOUPE.countryCode] = countries.GUADELOUPE;
    countries.map[countries.GUAM.countryCode] = countries.GUAM;
    countries.map[countries.GUATEMALA.countryCode] = countries.GUATEMALA;
    countries.map[countries.GUERNSEY.countryCode] = countries.GUERNSEY;
    countries.map[countries.GUINEA.countryCode] = countries.GUINEA;
    countries.map[countries.GUINEABISSAU.countryCode] = countries.GUINEABISSAU;
    countries.map[countries.EQUATORIALGUINEA.countryCode] = countries.EQUATORIALGUINEA;
    countries.map[countries.GUYANA.countryCode] = countries.GUYANA;
    countries.map[countries.FRENCHGUIANA.countryCode] = countries.FRENCHGUIANA;
    countries.map[countries.HAITI.countryCode] = countries.HAITI;
    countries.map[countries.HEARDISLANDANDMCDONALDISLANDS.countryCode] = countries.HEARDISLANDANDMCDONALDISLANDS;
    countries.map[countries.HONDOURAS.countryCode] = countries.HONDOURAS;
    countries.map[countries.HONGKONG.countryCode] = countries.HONGKONG;
    countries.map[countries.HUNGARY.countryCode] = countries.HUNGARY;
    countries.map[countries.ISLEOFMAN.countryCode] = countries.ISLEOFMAN;
    countries.map[countries.MINOROUTLYINGISLANDSUNITEDSTATES.countryCode] = countries.MINOROUTLYINGISLANDSUNITEDSTATES;
    countries.map[countries.BRITISHVIRGINISLANDS.countryCode] = countries.BRITISHVIRGINISLANDS;
    countries.map[countries.USAVIRGINISLANDS.countryCode] = countries.USAVIRGINISLANDS;
    countries.map[countries.INDIA.countryCode] = countries.INDIA;
    countries.map[countries.INDONESIA.countryCode] = countries.INDONESIA;
    countries.map[countries.IRAN.countryCode] = countries.IRAN;
    countries.map[countries.IRAQ.countryCode] = countries.IRAQ;
    countries.map[countries.IRELAND.countryCode] = countries.IRELAND;
    countries.map[countries.ICELAND.countryCode] = countries.ICELAND;
    countries.map[countries.ISRAEL.countryCode] = countries.ISRAEL;
    countries.map[countries.ITALIA.countryCode] = countries.ITALIA;
    countries.map[countries.JAMAICA.countryCode] = countries.JAMAICA;
    countries.map[countries.JAPAN.countryCode] = countries.JAPAN;
    countries.map[countries.JERSEY.countryCode] = countries.JERSEY;
    countries.map[countries.JORDAN.countryCode] = countries.JORDAN;
    countries.map[countries.KAZAKHSTAN.countryCode] = countries.KAZAKHSTAN;
    countries.map[countries.KENYA.countryCode] = countries.KENYA;
    countries.map[countries.KYRGYZSTAN.countryCode] = countries.KYRGYZSTAN;
    countries.map[countries.KIRIBATI.countryCode] = countries.KIRIBATI;
    countries.map[countries.KUWAIT.countryCode] = countries.KUWAIT;
    countries.map[countries.LAO.countryCode] = countries.LAO;
    countries.map[countries.LESOTHO.countryCode] = countries.LESOTHO;
    countries.map[countries.LATVIA.countryCode] = countries.LATVIA;
    countries.map[countries.LEBANON.countryCode] = countries.LEBANON;
    countries.map[countries.LIBERIA.countryCode] = countries.LIBERIA;
    countries.map[countries.LIBYA.countryCode] = countries.LIBYA;
    countries.map[countries.LIECHTENSTEIN.countryCode] = countries.LIECHTENSTEIN;
    countries.map[countries.LITHUANIA.countryCode] = countries.LITHUANIA;
    countries.map[countries.MACAU.countryCode] = countries.MACAU;
    countries.map[countries.MACEDONIA.countryCode] = countries.MACEDONIA;
    countries.map[countries.MADAGASCAR.countryCode] = countries.MADAGASCAR;
    countries.map[countries.MALISIA.countryCode] = countries.MALISIA;
    countries.map[countries.MALAWI.countryCode] = countries.MALAWI;
    countries.map[countries.MALDIVES.countryCode] = countries.MALDIVES;
    countries.map[countries.MALI.countryCode] = countries.MALI;
    countries.map[countries.MALTA.countryCode] = countries.MALTA;
    countries.map[countries.NORTHERNMARIANAISLANDS.countryCode] = countries.NORTHERNMARIANAISLANDS;
    countries.map[countries.MAROCO.countryCode] = countries.MAROCO;
    countries.map[countries.MARSHALL.countryCode] = countries.MARSHALL;
    countries.map[countries.MARTINIQUE.countryCode] = countries.MARTINIQUE;
    countries.map[countries.MAURITIUS.countryCode] = countries.MAURITIUS;
    countries.map[countries.MAURITANIA.countryCode] = countries.MAURITANIA;
    countries.map[countries.MAYOTTE.countryCode] = countries.MAYOTTE;
    countries.map[countries.MEXICO.countryCode] = countries.MEXICO;
    countries.map[countries.MICRONESIAFEDERALSTATESOF.countryCode] = countries.MICRONESIAFEDERALSTATESOF;
    countries.map[countries.MOLDOVA.countryCode] = countries.MOLDOVA;
    countries.map[countries.MONACO.countryCode] = countries.MONACO;
    countries.map[countries.MONGOLIA.countryCode] = countries.MONGOLIA;
    countries.map[countries.MONTENEGRO.countryCode] = countries.MONTENEGRO;
    countries.map[countries.MONTSERRAT.countryCode] = countries.MONTSERRAT;
    countries.map[countries.MOZAMBIQUE.countryCode] = countries.MOZAMBIQUE;
    countries.map[countries.MYNAMAR.countryCode] = countries.MYNAMAR;
    countries.map[countries.NAMIBIA.countryCode] = countries.NAMIBIA;
    countries.map[countries.NAURU.countryCode] = countries.NAURU.countryCode;
    countries.map[countries.NEPAL.countryCode] = countries.NEPAL;
    countries.map[countries.NICARAGUA.countryCode] = countries.NICARAGUA;
    countries.map[countries.NIGER.countryCode] = countries.NIGER;
    countries.map[countries.NIGERIA.countryCode] = countries.NIGERIA;
    countries.map[countries.NIUE.countryCode] = countries.NIUE;
    countries.map[countries.NOFOLKISLAND.countryCode] = countries.NOFOLKISLAND;
    countries.map[countries.NORWAY.countryCode] = countries.NORWAY;
    countries.map[countries.NEWCALEDONIA.countryCode] = countries.NEWCALEDONIA;
    countries.map[countries.NEWZEALAND.countryCode] = countries.NEWZEALAND;
    countries.map[countries.BRITISHINDIANOCEANTERRITORY.countryCode] = countries.BRITISHINDIANOCEANTERRITORY;
    countries.map[countries.OMAN.countryCode] = countries.OMAN;
    countries.map[countries.UGANDA.countryCode] = countries.UGANDA;
    countries.map[countries.UZBEKISTAN.countryCode] = countries.UZBEKISTAN;
    countries.map[countries.PAKISTAN.countryCode] = countries.PAKISTAN;
    countries.map[countries.PALAU.countryCode] = countries.PALAU;
    countries.map[countries.PALESTINIANTERRITORIES.countryCode] = countries.PALESTINIANTERRITORIES;
    countries.map[countries.PANAMA.countryCode] = countries.PANAMA;
    countries.map[countries.PAPUANEWGUINEA.countryCode] = countries.PAPUANEWGUINEA;
    countries.map[countries.PARAGUAY.countryCode] = countries.PARAGUAY;
    countries.map[countries.NETHERLANDS.countryCode] = countries.NETHERLANDS;
    countries.map[countries.PERU.countryCode] = countries.PERU;
    countries.map[countries.PHILIPPINES.countryCode] = countries.PHILIPPINES;
    countries.map[countries.PITCAIRNISLAND.countryCode] = countries.PITCAIRNISLAND;
    countries.map[countries.POLAND.countryCode] = countries.POLAND;
    countries.map[countries.FRENCHPOLYNESIA.countryCode] = countries.FRENCHPOLYNESIA;
    countries.map[countries.PORTORICO.countryCode] = countries.PORTORICO;
    countries.map[countries.PORTUGAL.countryCode] = countries.PORTUGAL;
    countries.map[countries.QATAR.countryCode] = countries.QATAR;
    countries.map[countries.REUNIONISLAND.countryCode] = countries.REUNIONISLAND;
    countries.map[countries.ROMANIA.countryCode] = countries.ROMANIA;
    countries.map[countries.UNITEDKINGDOM.countryCode] = countries.UNITEDKINGDOM;
    countries.map[countries.RUSSIA.countryCode] = countries.RUSSIA;
    countries.map[countries.RWANDA.countryCode] = countries.RWANDA;
    countries.map[countries.WESTERNSAHARA.countryCode] = countries.WESTERNSAHARA;
    countries.map[countries.STBARTHOLOMEW.countryCode] = countries.STBARTHOLOMEW;
    countries.map[countries.SAINTHELENA.countryCode] = countries.SAINTHELENA;
    countries.map[countries.STLUCIA.countryCode] = countries.STLUCIA;
    countries.map[countries.STKITTS.countryCode] = countries.STKITTS;
    countries.map[countries.STMARINO.countryCode] = countries.STMARINO;
    countries.map[countries.STMARINOFRENCHPART.countryCode] = countries.STMARINOFRENCHPART;
    countries.map[countries.STMARINODUTCHPART.countryCode] = countries.STMARINODUTCHPART;
    countries.map[countries.SAINTPIERREANDMIQUELON.countryCode] = countries.SAINTPIERREANDMIQUELON;
    countries.map[countries.HOLYSEESTATEOFTHECITYOFVATICAN.countryCode] = countries.HOLYSEESTATEOFTHECITYOFVATICAN;
    countries.map[countries.SAINTVINCENTANDTHEGRENADINES.countryCode] = countries.SAINTVINCENTANDTHEGRENADINES;
    countries.map[countries.SOLOMONISLANDS.countryCode] = countries.SOLOMONISLANDS;
    countries.map[countries.SAMOA.countryCode] = countries.SAMOA;
    countries.map[countries.AMERICANSAMOA.countryCode] = countries.AMERICANSAMOA;
    countries.map[countries.SAOTOMEANDPRINCIPE.countryCode] = countries.SAOTOMEANDPRINCIPE;
    countries.map[countries.SENEGAL.countryCode] = countries.SENEGAL;
    countries.map[countries.SERBIA.countryCode] = countries.SERBIA;
    countries.map[countries.SEYCHELLES.countryCode] = countries.SEYCHELLES;
    countries.map[countries.SIERRALEONE.countryCode] = countries.SIERRALEONE;
    countries.map[countries.SINGAPORE.countryCode] = countries.SINGAPORE;
    countries.map[countries.SLOVAKIA.countryCode] = countries.SLOVAKIA;
    countries.map[countries.SLOVENIA.countryCode] = countries.SLOVENIA;
    countries.map[countries.SOMALIA.countryCode] = countries.SOMALIA;
    countries.map[countries.SUDAN.countryCode] = countries.SUDAN;
    countries.map[countries.SOUTHSUDAN.countryCode] = countries.SOUTHSUDAN;
    countries.map[countries.SRILANKA.countryCode] = countries.SRILANKA;
    countries.map[countries.SWEDEN.countryCode] = countries.SWEDEN;
    countries.map[countries.SURINAME.countryCode] = countries.SURINAME;
    countries.map[countries.SVALBARDANDJANMAYEN.countryCode] = countries.SVALBARDANDJANMAYEN;
    countries.map[countries.SWAZILAND.countryCode] = countries.SWAZILAND;
    countries.map[countries.SYRIA.countryCode] = countries.SYRIA;
    countries.map[countries.TAJIKISTAN.countryCode] = countries.TAJIKISTAN;
    countries.map[countries.TAIWAN.countryCode] = countries.TAIWAN;
    countries.map[countries.TANZANIA.countryCode] = countries.TANZANIA, countries.map[countries.CHAD.countryCode] = countries.CHAD;
    countries.map[countries.BELIZE.countryCode] = countries.BELIZE;
    countries.map[countries.FRENCHSOUTHERNTERRITORIES.countryCode] = countries.FRENCHSOUTHERNTERRITORIES;
    countries.map[countries.THAILAND.countryCode] = countries.THAILAND;
    countries.map[countries.TIMORLESTE.countryCode] = countries.TIMORLESTE;
    countries.map[countries.TOGO.countryCode] = countries.TOGO;
    countries.map[countries.TOKELAU.countryCode] = countries.TOKELAU;
    countries.map[countries.TONGA.countryCode] = countries.TONGA;
    countries.map[countries.TRINIDADANDTOBAGO.countryCode] = countries.TRINIDADANDTOBAGO;
    countries.map[countries.TUNISIA.countryCode] = countries.TUNISIA;
    countries.map[countries.TURKMENISTAN.countryCode] = countries.TURKMENISTAN;
    countries.map[countries.TURKSANDCAICOSISLANDS.countryCode] = countries.TURKSANDCAICOSISLANDS;
    countries.map[countries.TURKEY.countryCode] = countries.TURKEY;
    countries.map[countries.TUVALU.countryCode] = countries.TUVALU;
    countries.map[countries.UKRAINE.countryCode] = countries.UKRAINE;
    countries.map[countries.URUGUAY.countryCode] = countries.URUGUAY;
    countries.map[countries.VANUATU.countryCode] = countries.VANUATU;
    countries.map[countries.VENEZUELA.countryCode] = countries.VENEZUELA;
    countries.map[countries.VIETNAM.countryCode] = countries.VIETNAM;
    countries.map[countries.WALLISANDFUTUNAISLANDS.countryCode] = countries.WALLISANDFUTUNAISLANDS;
    countries.map[countries.YEMEN.countryCode] = countries.YEMEN;
    countries.map[countries.ZAMBIA.countryCode] = countries.ZAMBIA;
    countries.map[countries.ZIMBABWE.countryCode] = countries.ZIMBABWE;

    countries.list = [];
    for (var countryCode in countries.map) {
        countries.list.push(countries.map[countryCode]);
    }
    return countries;
}]);
angular.module('FlexyBeautyApp.services').factory('LocaleList', [function () {
    var localeList = [{ languageName: "Albanais", languageCode: "sq", countryName: "Albanie", countryCode: "AL", localeCode: "sq-AL", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Algérie", countryCode: "DZ", localeCode: "ar-DZ", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Bahreïn", countryCode: "BH", localeCode: "ar-BH", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Egypte", countryCode: "EG", localeCode: "ar-EG", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Irak", countryCode: "QI", localeCode: "ar-QI", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Jordan", countryCode: "JO", localeCode: "ar-JO", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Koweït", countryCode: "KW", localeCode: "ar-KW", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Liban", countryCode: "LB", localeCode: "ar-LB", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Libye", countryCode: "LY", localeCode: "ar-LY", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Maroc", countryCode: "MA", localeCode: "ar-MA", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Oman", countryCode: "OM", localeCode: "ar-OM", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Qatar", countryCode: "QA", localeCode: "ar-QA", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Arabie Saoudite", countryCode: "SA", localeCode: "ar-SA", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Soudan", countryCode: "SD", localeCode: "ar-SD", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Syrie", countryCode: "SY", localeCode: "ar-SY", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Tunisie", countryCode: "TN", localeCode: "ar-TN", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Emirats Arabes Unis", countryCode: "AE", localeCode: "ar-AE", isSupported: false }, { languageName: "Arabe", languageCode: "ar", countryName: "Yémen", countryCode: "YE", localeCode: "ar-YE", isSupported: false }, { languageName: "Biélorusse", languageCode: "be", countryName: "Biélorussie", countryCode: "BY", localeCode: "be-BY", isSupported: false }, { languageName: "Bulgare", languageCode: "bg", countryName: "Bulgarie", countryCode: "BG", localeCode: "bg-bg", isSupported: false }, { languageName: "Catalan", languageCode: "ca", countryName: "Espagne", countryCode: "ES", localeCode: "ca-ES", isSupported: false }, { languageName: "Chinois", languageCode: "zh", countryName: "Chine", countryCode: "CN", localeCode: "zh-CN", isSupported: false }, { languageName: "Chinois", languageCode: "zh", countryName: "Singapour", countryCode: "SG", localeCode: "zh-SG", isSupported: false }, { languageName: "Chinois", languageCode: "zh", countryName: "Hong Kong", countryCode: "HK", localeCode: "zh-HK", isSupported: false }, { languageName: "Chinois", languageCode: "zh", countryName: "Taiwan", countryCode: "TW", localeCode: "zh-TW", isSupported: false }, { languageName: "Croate", languageCode: "hr", countryName: "Croatie", countryCode: "HR", localeCode: "HR-HR", isSupported: false }, { languageName: "Tchèque", languageCode: "cs", countryName: "République tchèque", countryCode: "CZ", localeCode: "cs-cz", isSupported: false }, { languageName: "Danois", languageCode: "da", countryName: "Danemark", countryCode: "DK", localeCode: "da-DK", isSupported: false }, { languageName: "Néerlandais", languageCode: "nl", countryName: "Belgique", countryCode: "BE", localeCode: "nl-BE", isSupported: true }, { languageName: "Néerlandais", languageCode: "nl", countryName: "Pays-Bas", countryCode: "NL", localeCode: "NL-NL", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Australie", countryCode: "AU", localeCode: "en-AU", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Canada", countryCode: "CA", localeCode: "en-CA", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Inde", countryCode: "IN", localeCode: "en-IN", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Irlande", countryCode: "IE", localeCode: "en-IE", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Malte", countryCode: "MT", localeCode: "en-MT", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Nouvelle Zélande", countryCode: "NZ", localeCode: "en-NZ", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Philippines", countryCode: "PH", localeCode: "en-PH", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Singapour", countryCode: "SG", localeCode: "en-SG", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Afrique du Sud", countryCode: "ZA", localeCode: "en-ZA", isSupported: false }, { languageName: "Anglais", languageCode: "en", countryName: "Royaume-Uni", countryCode: "GB", localeCode: "en-GB", isSupported: true }, { languageName: "Anglais", languageCode: "en", countryName: "États-Unis", countryCode: "US", localeCode: "en-US", isSupported: false }, { languageName: "Estonien", languageCode: "et", countryName: "Estonie", countryCode: "EE", localeCode: "et-EE", isSupported: false }, { languageName: "Finlandais", languageCode: "fi", countryName: "Finlande", countryCode: "FI", localeCode: "fi-FI", isSupported: false }, { languageName: "Français", countryName: "Belgique", countryCode: "BE", localeCode: "fr-BE", isSupported: false }, { languageName: "Français", countryName: "Canada", countryCode: "CA", localeCode: "fr-CA", isSupported: false }, { languageName: "Français", countryName: "France", countryCode: "FR", localeCode: "fr-FR", isSupported: true }, { languageName: "Français", countryName: "Luxembourg", countryCode: "LU", localeCode: "fr-LU", isSupported: false }, { languageName: "Français", countryName: "Suisse", countryCode: "CH", localeCode: "fr-CH", isSupported: true }, { languageName: "Allemand", languageCode: "de", countryName: "Autriche", countryCode: "AT", localeCode: "de-AT", isSupported: false }, { languageName: "Allemand", languageCode: "de", countryName: "Allemagne", countryCode: "DE", localeCode: "de-DE", isSupported: false }, { languageName: "Allemand", languageCode: "de", countryName: "Luxembourg", countryCode: "LU", localeCode: "de-LU", isSupported: false }, { languageName: "Allemand", languageCode: "de", countryName: "Suisse", countryCode: "CH", localeCode: "de-CH", isSupported: false }, { languageName: "Grec", languageCode: "el", countryName: "Chypre", countryCode: "CY", localeCode: "el-CY", isSupported: false }, { languageName: "Grec", languageCode: "el", countryName: "Grèce", countryCode: "GR", localeCode: "el-GR", isSupported: false }, { languageName: "Hébreu", languageCode: "iw", countryName: "Israël", countryCode: "IL", localeCode: "iw-IL", isSupported: false }, { languageName: "Hindi", languageCode: "salut", countryName: "Inde", countryCode: "IN", localeCode: "Salut dans", isSupported: false }, { languageName: "Hongrois", languageCode: "hu", countryName: "Hongrie", countryCode: "HU", localeCode: "hu-HU", isSupported: false }, { languageName: "Islandais", languageCode: "est", countryName: "Islande", countryCode: "IS", localeCode: "is-is", isSupported: false }, { languageName: "Indonésien", languageCode: "en", countryName: "Indonésie", countryCode: "ID", localeCode: "in-ID", isSupported: false }, { languageName: "Irlandais", languageCode: "ga", countryName: "Irlande", countryCode: "IE", localeCode: "ga-IE", isSupported: false }, { languageName: "Italien", languageCode: "le", countryName: "Italie", countryCode: "IT", localeCode: "ça ça", isSupported: false }, { languageName: "Italien", languageCode: "le", countryName: "Suisse", countryCode: "CH", localeCode: "démanger", isSupported: false }, { languageName: "Japonais", languageCode: "ja", countryName: "Japon", countryCode: "JP", localeCode: "ja-JP", isSupported: false }, { languageName: "Japonais", languageCode: "ja", countryName: "Japon", countryCode: "JP", localeCode: "ja-JP-u-ca-japanese", isSupported: false }, { languageName: "Japonais", languageCode: "ja", countryName: "Japon", countryCode: "JP", localeCode: "ja-JP-x-lvariant-JP", isSupported: false }, { languageName: "Coréen", languageCode: "ko", countryName: "Corée du Sud", countryCode: "KR", localeCode: "ko-kr", isSupported: false }, { languageName: "Letton", languageCode: "lv", countryName: "Lettonie", countryCode: "LV", localeCode: "LV-LV", isSupported: false }, { languageName: "Lituanien", languageCode: "lt", countryName: "Lituanie", countryCode: "LT", localeCode: "LT-LT", isSupported: false }, { languageName: "Macédonien", languageCode: "mk", countryName: "Macédoine", countryCode: "MK", localeCode: "MK-MK", isSupported: false }, { languageName: "Malais", languageCode: "ms", countryName: "Malaisie", countryCode: "MY", localeCode: "ms-MY", isSupported: false }, { languageName: "Maltais", languageCode: "mt", countryName: "Malte", countryCode: "MT", localeCode: "mt-MT", isSupported: false }, { languageName: "Norvégien", languageCode: "non", countryName: "Norvège", countryCode: "NO", localeCode: "non non", isSupported: false }, { languageName: "Norvégien bokmål", countryName: "Norvège", countryCode: "NO", localeCode: "nb-NO", isSupported: false }, { languageName: "Nynorsk norvégien", languageCode: "nn", countryName: "Norvège", countryCode: "NO", localeCode: "nn-NO", isSupported: false }, { languageName: "Norvégien", languageCode: "non", countryName: "Norvège", countryCode: "NO", localeCode: "no-NO-x-lvariant-NY", isSupported: false }, { languageName: "Polonais", languageCode: "pl", countryName: "Pologne", countryCode: "PL", localeCode: "pl-PL", isSupported: false }, { languageName: "Portugais", languageCode: "pt", countryName: "Brésil", countryCode: "BR", localeCode: "pt-BR", isSupported: false }, { languageName: "Portugais", languageCode: "pt", countryName: "Portugal", countryCode: "PT", localeCode: "pt-PT", isSupported: false }, { languageName: "Roumain", languageCode: "ro", countryName: "Roumanie", countryCode: "RO", localeCode: "ro-ro", isSupported: false }, { languageName: "Russe", languageCode: "ru", countryName: "Russie", countryCode: "RU", localeCode: "ru-RU", isSupported: false }, { languageName: "Serbe", languageCode: "sr", countryName: "Bosnie-Herzégovine", countryCode: "BA", localeCode: "sr-BA", isSupported: false }, { languageName: "Serbe", languageCode: "sr", countryName: "Monténégro", countryCode: "ME", localeCode: "sr-me", isSupported: false }, { languageName: "Serbe", languageCode: "sr", countryName: "Serbie", countryCode: "RS", localeCode: "sr-RS", isSupported: false }, { languageName: "Serbe", languageCode: "sr", countryName: "Bosnie-Herzégovine", countryCode: "BA", localeCode: "sr-Latn-BA", isSupported: false }, { languageName: "Serbe", languageCode: "sr", countryName: "Monténégro", countryCode: "ME", localeCode: "sr-Latn-ME", isSupported: false }, { languageName: "Serbe", languageCode: "sr", countryName: "Serbie", countryCode: "RS", localeCode: "Sr-Latn-RS", isSupported: false }, { languageName: "Slovaque", languageCode: "sk", countryName: "Slovaquie", countryCode: "SK", localeCode: "sk-SK", isSupported: false }, { languageName: "Slovène", languageCode: "sl", countryName: "Slovénie", countryCode: "SI", localeCode: "sl-SI", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Argentine", countryCode: "AR", localeCode: "es-AR", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Bolivie", countryCode: "BO", localeCode: "es-BO", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Chili", countryCode: "CL", localeCode: "es-CL", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Colombie", countryCode: "CO", localeCode: "es-CO", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Costa Rica", countryCode: "CR", localeCode: "es-CR", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "République dominicaine", countryCode: "DO", localeCode: "es-DO", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Équateur", countryCode: "CE", localeCode: "es-EC", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Salvador", countryCode: "SV", localeCode: "es-SV", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Guatemala", countryCode: "GT", localeCode: "es-GT", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Honduras", countryCode: "HN", localeCode: "es-HN", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Mexique", countryCode: "MX", localeCode: "es-MX", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Nicaragua", countryCode: "NL", localeCode: "es-NI", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Panama", countryCode: "PA", localeCode: "es-PA", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Paraguay", countryCode: "PY", localeCode: "es-PY", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Pérou", countryCode: "PE", localeCode: "es-PE", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Porto Rico", countryCode: "PR", localeCode: "es-PR", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Espagne", countryCode: "ES", localeCode: "es-ES", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "États-Unis", countryCode: "US", localeCode: "es-US", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Uruguay", countryCode: "UY", localeCode: "es-UY", isSupported: false }, { languageName: "Espagnol", languageCode: "es", countryName: "Venezuela", countryCode: "VE", localeCode: "es-VE", isSupported: false }, { languageName: "Suédois", languageCode: "sv", countryName: "Suède", countryCode: "SE", localeCode: "sv-SE", isSupported: false }, { languageName: "Thaï", languageCode: "th", countryName: "Thaïlande", countryCode: "TH", localeCode: "th-TH", isSupported: false }, { languageName: "Thaï", languageCode: "th", countryName: "Thaïlande", countryCode: "TH", localeCode: "th-th-u-ca-bouddhiste", isSupported: false }, { languageName: "Thaï", languageCode: "th", countryName: "Thaïlande", countryCode: "TH", localeCode: "th-TH-u-ca-bouddhiste-nu-thai", isSupported: false }, { languageName: "Thaï", languageCode: "th", countryName: "Thaïlande", countryCode: "TH", localeCode: "th-TH-x-lvariant-TH", isSupported: false }, { languageName: "Turc", languageCode: "tr", countryName: "Turquie", countryCode: "TR", localeCode: "tr-TR", isSupported: false }, { languageName: "Ukrainien", countryName: "Ukraine", countryCode: "UA", localeCode: "uk-UA", isSupported: false }, { languageName: "Vietnamien", languageCode: "vi", countryName: "Vietnam", countryCode: "VN", localeCode: "vi-VN" }];
    return localeList;
}]);
angular.module('FlexyBeautyApp.services').factory('LanguageApplicationList', [function () {
    var languageApplicationList = [{ languageName: "Anglais", countryName: "Royaume-Uni", localeCode: "en-GB" }, { languageName: "Français", countryName: "France", localeCode: "fr-FR" }];
    return languageApplicationList;
}]);
angular.module('FlexyBeautyApp.services').factory('LanguageManagerSrv', ["LanguageManager_Resource", function (LanguageManager_Resource) {
    var languageManagerSrv = {};

    languageManagerSrv.getJsonFile = function (languageCode, countryCode) {
        return LanguageManager_Resource.getJsonFile({
            languageCode: languageCode,
            countryCode: countryCode
        }).$promise;
    };
    return languageManagerSrv;
}]);
angular.module('FlexyBeautyApp.services').factory('SupportedLocales', [function () {
    var supportedLocales = [];

    supportedLocales["fr"] = [];
    supportedLocales["fr"]["FR"] = {
        languageCode: 'fr',
        countryCode: 'FR',
        facebookLocale: "fr_fr",
        angularLocale: "fr",
        momentLocale: "fr",
        gettextLocale: "fr",
        googleChartLocale: "fr"
    };

    supportedLocales["fr"]["CH"] = {
        languageCode: 'fr',
        countryCode: 'CH',
        facebookLocale: "fr_fr",
        angularLocale: "fr-ch",
        momentLocale: "fr-ch",
        gettextLocale: "fr",
        googleChartLocale: "fr"
    };

    supportedLocales["en"] = [];

    supportedLocales["en"]["US"] = {
        languageCode: 'en',
        countryCode: 'US',
        facebookLocale: "en_US",
        angularLocale: "en-us",
        momentLocale: "en",
        gettextLocale: "en_US",
        googleChartLocale: "en"
    };

    supportedLocales["en"]["GB"] = {
        languageCode: 'en',
        countryCode: 'GB',
        facebookLocale: "en",
        angularLocale: "en-gb",
        momentLocale: "en-gb",
        gettextLocale: "en_GB",
        googleChartLocale: "en"
    };

    supportedLocales["de"] = [];
    supportedLocales["de"]["DE"] = {
        languageCode: 'de',
        countryCode: 'DE',
        facebookLocale: "de",
        angularLocale: "de",
        momentLocale: "de",
        gettextLocale: "de",
        googleChartLocale: "de"
    };

    supportedLocales["es"] = [];
    supportedLocales["es"]["ES"] = {
        languageCode: 'es',
        countryCode: 'ES',
        facebookLocale: "es_LA",
        angularLocale: "es",
        momentLocale: "es",
        gettextLocale: "es",
        googleChartLocale: "es"
    };

    supportedLocales["nl"] = [];
    supportedLocales["nl"]["BE"] = {
        languageCode: 'nl',
        countryCode: 'BE',
        facebookLocale: "nl_BE",
        angularLocale: "nl-be",
        momentLocale: "nl-be",
        gettextLocale: "nl",
        googleChartLocale: "nl"
    };

    return supportedLocales;
}]);
angular.module('FlexyBeautyApp.services').factory('LanguageManager', ['$cookies', 'gettextCatalog', '$locale', '$http', 'tmhDynamicLocale', 'LanguageManagerSrv', 'SupportedLocales', '$location', 'LaunchDarklyFeatureFlagData', 'LaunchDarklyFeatureFlagList', 'Decorators', 'TimeMeasures', 'moment', 'PhoneFormat', function ($cookies, gettextCatalog, $locale, $http, tmhDynamicLocale, LanguageManagerSrv, SupportedLocales, $location, LaunchDarklyFeatureFlagData, LaunchDarklyFeatureFlagList, Decorators, TimeMeasures, moment, PhoneFormat) {
    var languageManager = {
        locale: null,
        intlNumberFormatter: null,
        LOCALE_SEPARATOR: "-"
    };

    languageManager.getLanguageCode = function () {
        return this.locale ? this.locale.languageCode : null;
    };

    languageManager.getCountryCode = function () {
        return this.locale ? this.locale.countryCode : null;
    };

    languageManager.initAcceptLanguage = function (user) {
        var _this = this;

        return new Promise(function (resolve, reject) {
            if (user && user.company && user.company.localeCode) {
                $http.defaults.headers.common["Accept-Language"] = user.company.localeCode;
                PhoneFormat.setLocalCountry(user.company.country);
                _this.initLanguageManager(user.company.localeCode).then(resolve, reject);
            } else {
                resolve();
            }
        });
    };

    languageManager.setLocale = Decorators.timeMeasureDecorator(function (localeCode) {
        var languageCode = void 0,
            countryCode = void 0;

        if (localeCode) {
            var localeSplit = localeCode.split(this.LOCALE_SEPARATOR);
            var languageIndex = 0,
                countryIndex = 1;
            languageCode = localeSplit[languageIndex];
            countryCode = localeSplit[countryIndex];
        }
        //loading of the correct language
        if (languageCode && countryCode && SupportedLocales[languageCode][countryCode]) {
            this.locale = SupportedLocales[languageCode][countryCode];
        } else {
            this.locale = SupportedLocales["fr"]["FR"];
        }
    }, TimeMeasures.LANGUAGE_MANAGER_SET_LOCALE);

    languageManager.loadMomentWithCorrectLocale = Decorators.timeMeasureDecorator(function () {
        moment.locale(this.locale.momentLocale);
    }, TimeMeasures.LANGUAGE_MANAGER_LOAD_MOMENT);

    languageManager.loadGoogleChartsWithCorrectLocale = Decorators.timeMeasureDecorator(function () {
        var _this2 = this;

        return new Promise(function (resolve) {
            try {
                google.charts.load('48', {
                    packages: ['corechart', 'table', 'gauge'],
                    language: _this2.locale.googleChartLocale,
                    callback: resolve
                });
            } catch (e) {
                console.warn("Failed to Google Charts ");
            }
        });
    }, TimeMeasures.LANGUAGE_MANAGER__LOAD_GOOGLE_CHARTS);

    languageManager.loadAngularDynamicLocaleWithCorrectLocale = Decorators.timeMeasureDecorator(function () {
        return tmhDynamicLocale.set(this.locale.angularLocale);
    }, TimeMeasures.LANGUAGE_MANAGER_LOAD_ANGULAR);

    languageManager.loadDictionaryWithCorrectLocale = Decorators.timeMeasureDecorator(function () {
        var loadDictionarySuccess = function loadDictionarySuccess(data) {
            if (data && data.json) {
                var jsonData = JSON.parse(data.json);
                gettextCatalog.setStrings(data.language, jsonData);
                gettextCatalog.setCurrentLanguage(data.language);
                console.info("Current language " + gettextCatalog.getCurrentLanguage());
            }
        };

        return LanguageManagerSrv.getJsonFile(this.locale.languageCode, this.locale.countryCode).then(loadDictionarySuccess);
    }, TimeMeasures.LANGUAGE_MANAGER_LOAD_DICTIONARY);

    languageManager.initLanguageManager = Decorators.timeMeasureDecorator(function (localeCode) {
        this.setLocale(localeCode);

        this.setIntlNumberFormatter();

        this.loadMomentWithCorrectLocale();

        var promises = [];

        promises.push(this.loadGoogleChartsWithCorrectLocale());

        promises.push(this.loadAngularDynamicLocaleWithCorrectLocale());

        promises.push(this.loadDictionaryWithCorrectLocale());

        return Promise.all(promises);
    }, TimeMeasures.LANGUAGE_MANAGER_INITIALISATION);

    languageManager.getGetTextLocale = function () {
        return this.locale.gettextLocale;
    };

    languageManager.getLocale = function () {
        return this.getLanguageCode() + this.LOCALE_SEPARATOR + this.getCountryCode();
    };

    //Mock for Oui/Non toggle buttons
    languageManager.isEnglishLanguage = function () {
        return this.getLanguageCode() && this.getLanguageCode().indexOf("en") !== -1;
    };

    languageManager.isFrenchLanguage = function () {
        return this.getLanguageCode() && this.getLanguageCode().indexOf("fr") !== -1;
    };

    languageManager.isDutchLanguage = function () {
        return this.getLanguageCode() && this.getLanguageCode().indexOf("nl") !== -1;
    };

    languageManager.canAccessLiveEdit = function () {
        var displayLiveEdit = false,
            absUrl = $location.absUrl(); //don't work on website in appPro but top.document.location.href don't work on all website

        if (absUrl.indexOf("/fxbAdmin/") !== -1 && !this.isFrenchLanguage()) {
            displayLiveEdit = true;
        }

        return displayLiveEdit;
    };

    languageManager.setIntlNumberFormatter = Decorators.timeMeasureDecorator(function () {
        try {
            if (Intl && (typeof Intl === 'undefined' ? 'undefined' : _typeof(Intl)) === 'object' && Intl.NumberFormat && typeof Intl.NumberFormat === 'function' && Intl.NumberFormat.prototype.hasOwnProperty("formatToParts") && Intl.NumberFormat.prototype.hasOwnProperty("format")) {
                this.intlNumberFormatter = Intl.NumberFormat(this.getLocale());
            }
        } catch (e) {
            //sometimes some browsers (mobile safari) throw an exception " ReferenceError · Can't find variable: Intl" despite of the test above
            //if it occurs an exception with Intl, we force the intlNumberFormatter to null in order to format the number with the "old method"
            this.intlNumberFormatter = null;
        }
    }, TimeMeasures.LANGUAGE_MANAGER_SET_NUMBER_FORMATTER);

    languageManager.getIntlNumberFormatter = function () {
        return this.intlNumberFormatter;
    };

    return languageManager;
}]);

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("FlexyBeautyApp.services").factory("LaunchDarklyFeatureFlagList", [function () {
    return {
        FLEX_3279_FEATURE_FLAG_BACKOFFICE_CUSTOMER: {
            flagName: "flex-3279-backoffice-customer"
        },
        FLEX_3534_FEATURE_FLAG_LE_CISEAU_SERVICE_SETTINGS: {
            flagName: "flex-3534-le-ciseau-service-settings"
        },
        FLEX_3477_FEATURE_FLAG_DRAG_DROP: {
            flagName: "flex-3477-drag-drop"
        },
        FLEX_3775_FEATURE_FLAG_NEW_LOADING: {
            flagName: "flex-3775-new-loading"
        },
        FLEX_4365_FEATURE_FLAG_BOOKING_USER_STORY: {
            flagName: "flex-4365-booking-user-story"
        },
        FLEX_4424_FEATURE_FLAG_KIUTE_PRO_APP: {
            flagName: 'flex-4424-kiute-pro-app'
        },
        FLEX_311_FORCE_MIGRATION_INFOS: {
            flagName: 'flex-311-force-migration-infos'
        },
        FLEX_364_FORCE_MIGRATION_DATE: {
            flagName: 'flex-364-force-migration-date'
        },
        FLEX_287_DOUBLE_TAB_BLOCKED: {
            flagName: 'flex-287-double-tab-blocked'
        }
    };
}]);

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('OfferManager', ['StoreAppCode', 'Offers', "$sce", "OfferService", function (StoreAppCode, Offers, $sce, OfferService) {
    return {

        companyActiveOfferSubscription: null,
        companyActiveOfferSubscriptionView: null,

        computeCompanyOfferCode: function computeCompanyOfferCode(company) {
            return company && company.activeOffer ? company.activeOffer.offerCode : null;
        },

        computeCompanyViewOfferCode: function computeCompanyViewOfferCode(companyView) {
            return companyView && companyView.activeOffer ? companyView.activeOffer.offerCode : null;
        },

        computeCompanyOfferLabel: function computeCompanyOfferLabel(company) {
            if (company) {
                var currentOfferCode = this.computeCompanyOfferCode(company);
                var currentOffer = OfferService.allOffers.find(function (offer) {
                    return offer.code === currentOfferCode;
                });
                return currentOffer && currentOffer.label;
            }
            return null;
        },

        computeCompanyNextOfferLabel: function computeCompanyNextOfferLabel(company) {
            if (company) {
                var currentOfferCode = this.computeCompanyOfferCode(company);
                return this.computeNextOfferLabel(currentOfferCode);
            }
            return null;
        },

        computeNextOfferLabel: function computeNextOfferLabel(currentOfferCode) {
            switch (currentOfferCode) {
                case Offers.ATTRACT.code:
                    return Offers.MANAGE.label;
                case Offers.MANAGE.code:
                    return Offers.BOOST.label;
                case Offers.START.code:
                    return Offers.PLUS.label;
                case Offers.PLUS.code:
                    return Offers.BOOST.label;
                default:
                    return null;
            }
        },

        hasCompanyAccessToFeature: function hasCompanyAccessToFeature(company, storeAppCode) {
            return !!company && !!company.activeOffer && !!company.subscriptions && !!company.subscriptions.find && company.subscriptions.find(function (subscription) {
                return !!subscription.storeApp && subscription.storeApp.code === storeAppCode && subscription.isActive;
            }) !== undefined;
        },

        hasCompanyAccessToOnlineReservation: function hasCompanyAccessToOnlineReservation(company) {
            return this.hasCompanyAccessToFeature(company, StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE) || this.hasCompanyAccessToFeature(company, StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE) || this.hasCompanyAccessToFeature(company, StoreAppCode.OPTION_WEBSITE);
        },

        computeDashboardVideoUrl: function computeDashboardVideoUrl() {
            return $sce.trustAsResourceUrl("https://www.youtube.com/embed/j28sk8oRT_c");
        },

        checkWithoutTillAndPosSubscription: function checkWithoutTillAndPosSubscription(companyView, editedSubscriptionView) {
            var withoutTillSubscription = companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE);
            var posSubscription = companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_POS_APP_CODE);
            if (editedSubscriptionView === withoutTillSubscription) {
                posSubscription.isActive = !withoutTillSubscription.isActive;
            } else if (editedSubscriptionView === posSubscription) {
                withoutTillSubscription.isActive = !posSubscription.isActive;
            }
        },

        computeMandatoryBased: function computeMandatoryBased(companyView, editedSubscriptionView) {
            var mandatoryBasedSubscriptionViews = companyView.subscriptionsView.filter(function (subscriptionView) {
                return subscriptionView !== editedSubscriptionView && subscriptionView.storeAppView.mandatoryBases === editedSubscriptionView.storeAppView.code;
            });
            mandatoryBasedSubscriptionViews.forEach(function (subscriptionView) {
                return subscriptionView.isActive = editedSubscriptionView.isActive;
            });
            return mandatoryBasedSubscriptionViews;
        },

        isWithoutTillCompatibleWithActiveOffer: function isWithoutTillCompatibleWithActiveOffer(companyView) {
            return this.computeCompanyViewOfferCode(companyView) === Offers.PLUS.code;
        },

        hasAccessToCreativeMode: function hasAccessToCreativeMode(activeOfferCode) {
            return activeOfferCode === Offers.PRESTIGE.code;
        },

        hasAccessToFeature: function hasAccessToFeature(subscriptions, storeAppCode) {
            return !!subscriptions && subscriptions.find && subscriptions.find(function (subscription) {
                return subscription.storeAppCode === storeAppCode && subscription.isActive;
            }) !== undefined;
        },

        computeWebsiteCustomizationTutorialVideoUrl: function computeWebsiteCustomizationTutorialVideoUrl(subscriptions) {
            if (this.hasAccessToFeature(subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                return "https://www.youtube.com/watch?v=Fazski8a3KE";
            }
            if (this.hasAccessToFeature(subscriptions, StoreAppCode.OPTION_WEBSITE)) {
                return "https://www.youtube.com/watch?v=xcGoDxvLVwo";
            }
            return "";
        },

        computeDefaultRegisterOfferCode: function computeDefaultRegisterOfferCode() {
            return Offers.BOOST.code;
        },

        hasOfferAccessToStoreApp: function hasOfferAccessToStoreApp(activeOfferCode, storeAppView) {
            var activeOffer = OfferService.allOffers.find(function (offer) {
                return offer.code === activeOfferCode;
            });
            return !!storeAppView && !!activeOffer && !!activeOffer.storeAppCodes && activeOffer.storeAppCodes.find(function (storeAppCode) {
                return storeAppCode === storeAppView.code;
            }) !== undefined;
        }
    };
}]).constant('Offers', {
    ATTRACT: { code: 'attract', label: 'Free' },
    MANAGE: { code: 'manage', label: 'Smart' },
    BOOST: { code: 'boost', label: 'Business' },
    START: { code: 'start', label: 'Start' },
    PLUS: { code: 'plus', label: 'Plus' },
    PRESTIGE: { code: 'prestige', label: 'Prestige' }
});

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 27/10/2017.
 */

// Require `PhoneNumberFormat`.
var phoneNumberFormat = __webpack_require__(25).PhoneNumberFormat;
var phoneUtil = __webpack_require__(25).PhoneNumberUtil.getInstance();
var phoneNumberType = __webpack_require__(25).PhoneNumberType;

angular.module('FlexyBeautyApp.services').factory('PhoneFormat', [function () {
    var phoneFormat = {
        defaultFormat: 'fr',
        unknowFormat: 'unknow',
        supportedCountries: ['fr', 'be', 'gb', 'ch', 'us'],
        companyCountry: 'fr',
        INTERNATIONAL_PREFIX: '+',
        EMPTY_NUMBER: ''
    };

    phoneFormat.setLocalCountry = function (companyCountry) {
        phoneFormat.companyCountry = companyCountry ? companyCountry.toLowerCase() : phoneFormat.defaultFormat;
    };

    phoneFormat.getLocalCountry = function () {
        return phoneFormat.companyCountry;
    };

    phoneFormat.isSupportedCountry = function (region) {
        return phoneFormat.supportedCountries.indexOf(region) !== -1;
    };

    phoneFormat.isValidDigitNumber = function (number) {
        var regexp = new RegExp('^([0-9]|\\+)([0-9\\s])*$');
        return regexp.test(number);
    };

    phoneFormat.formatNumberWithoutCountry = function (number, isMobile) {
        var code = '';
        if (!number) {
            return '';
        } else if (number && number.indexOf(phoneFormat.INTERNATIONAL_PREFIX) === -1) {
            if (isMobile && phoneFormat.isMobileNumber(number, phoneFormat.getLocalCountry())) {
                code = phoneFormat.getLocalCountry();
            } else if (!isMobile && phoneFormat.isValidNumberForRegion(number, phoneFormat.getLocalCountry())) {
                code = phoneFormat.getLocalCountry();
            } else {
                code = phoneFormat.unknowFormat;
            }
        }

        try {
            if (code !== phoneFormat.unknowFormat) {
                var phoneNumber = phoneUtil.parse(number, code);
                code = phoneUtil.getRegionCodeForNumber(phoneNumber);
                if (phoneNumber != null && code != null && phoneFormat.isSupportedCountry(code.toLowerCase())) {
                    if (code === phoneFormat.getLocalCountry().toUpperCase()) {
                        number = phoneUtil.format(phoneNumber, phoneNumberFormat.NATIONAL);
                    } else {
                        number = phoneUtil.format(phoneNumber, phoneNumberFormat.INTERNATIONAL);
                    }
                }
            }
        } catch (error) {}

        return number;
    };

    phoneFormat.returnInternationalFormat = function (number) {
        if (!number) {
            return phoneFormat.EMPTY_NUMBER;
        }

        var code = void 0;
        if (number.indexOf(phoneFormat.INTERNATIONAL_PREFIX) === -1) {
            code = phoneFormat.getLocalCountry();
            if (code == null) {
                code = phoneFormat.defaultFormat;
            }
        }

        if (phoneFormat.isValid(number, code)) {
            try {
                var phoneNumber = phoneUtil.parse(number, code);
                if (phoneNumber != null) {
                    number = phoneUtil.format(phoneNumber, phoneNumberFormat.INTERNATIONAL);
                }
            } catch (error) {}
        }

        return number;
    };

    phoneFormat.isValid = function (phoneNumber, regionCode) {
        var isValid = false;

        try {
            var number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode);
            isValid = phoneUtil.isValidNumber(number);
        } catch (e) {}

        return isValid;
    };

    phoneFormat.returnNationalFormat = function (number) {
        if (!number) {
            return phoneFormat.EMPTY_NUMBER;
        }

        if (number.indexOf(phoneFormat.INTERNATIONAL_PREFIX) === 0) {
            try {
                var phoneNumber = phoneUtil.parse(number);
                if (phoneNumber != null) {
                    number = phoneUtil.format(phoneNumber, phoneNumberFormat.NATIONAL);
                }
            } catch (error) {}
        }

        return number;
    };

    phoneFormat.isMobileNumber = function (number, region) {
        try {
            var phoneNumber = phoneUtil.parse(number, region);
            if (phoneNumber != null) {
                if (phoneUtil.isValidNumberForRegion(phoneNumber, region) && (phoneUtil.getNumberType(phoneNumber) === phoneNumberType.MOBILE || phoneUtil.getNumberType(phoneNumber) === phoneNumberType.FIXED_LINE_OR_MOBILE)) {
                    return true;
                }
            }
        } catch (error) {}
        return false;
    };

    phoneFormat.formatNumberWithInternationalFormat = function (number, region) {
        try {
            if (region !== 'unknow') {
                var phoneNumber = phoneUtil.parse(number, region);
                if (phoneNumber != null) {
                    return phoneUtil.format(phoneNumber, phoneNumberFormat.INTERNATIONAL);
                }
            }
        } catch (error) {}
        return number;
    };

    phoneFormat.formatNumber = function (number, region) {
        try {
            if (region !== 'unknow') {
                var phoneNumber = phoneUtil.parse(number, region);
                if (phoneNumber !== null) {
                    if (region === phoneFormat.getLocalCountry()) {
                        var nationalPhone = phoneUtil.format(phoneNumber, phoneNumberFormat.NATIONAL);
                        if (nationalPhone && nationalPhone[0] !== "+" && nationalPhone[0] !== "0") {
                            return "0" + nationalPhone;
                        } else {
                            return nationalPhone;
                        }
                    }
                    return phoneUtil.format(phoneNumber, phoneNumberFormat.INTERNATIONAL);
                }
            }
        } catch (error) {}
        return number;
    };

    phoneFormat.isValidNumberForRegion = function (number, region) {
        var isValideNumberForRegion = false;
        try {
            if (region === 'unknow') {
                isValideNumberForRegion = true;
            } else {
                var phoneNumber = phoneUtil.parse(number, region);
                if (phoneNumber != null) {
                    if (phoneUtil.isValidNumberForRegion(phoneNumber, region)) {
                        isValideNumberForRegion = true;
                    }
                }
            }
        } catch (error) {}
        return isValideNumberForRegion;
    };

    phoneFormat.getPrefixNumber = function (number, region) {
        var countryCode = '';
        if (region !== phoneFormat.unknowFormat) {
            try {
                var phoneNumber = phoneUtil.parseAndKeepRawInput(number, region);
                countryCode = phoneNumber.getCountryCode();
            } catch (e) {}
        }
        return countryCode;
    };

    phoneFormat.getCountryFromNumber = function (number, isMobile) {
        var code = '';
        if (!number) {
            code = phoneFormat.isSupportedCountry(phoneFormat.getLocalCountry()) ? phoneFormat.getLocalCountry() : phoneFormat.unknowFormat;
            return code;
        }

        if (number && number.indexOf(phoneFormat.INTERNATIONAL_PREFIX) === -1) {
            if (isMobile && phoneFormat.isMobileNumber(number, phoneFormat.getLocalCountry())) {
                code = phoneFormat.getLocalCountry();
            } else if (!isMobile && phoneFormat.isValidNumberForRegion(number, phoneFormat.getLocalCountry())) {
                code = phoneFormat.getLocalCountry();
            } else {
                code = phoneFormat.unknowFormat;
            }
        }

        try {
            if (code !== phoneFormat.unknowFormat) {
                var phoneNumber = phoneUtil.parse(number, code);
                if (phoneNumber !== null) {
                    var region = phoneUtil.getRegionCodeForNumber(phoneNumber);
                    if (region && phoneFormat.isSupportedCountry(region.toLowerCase()) && phoneUtil.isValidNumberForRegion(phoneNumber, region)) {
                        code = region;
                    } else {
                        code = phoneFormat.unknowFormat;
                    }
                }
            }
        } catch (error) {
            code = phoneFormat.unknowFormat;
        }

        return code;
    };

    return phoneFormat;
}]);

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by sebastienbeaujard on 26/04/2014.
 * Transaction server manager + retry feature
 */

angular.module('FlexyBeautyApp.services').factory('ServerSrv', ["$log", "$timeout", "MessageSrv", "gettextCatalog", "bugsnag", "Constants", "ErrorCode", "$rootScope", function ($log, $timeout, MessageSrv, gettextCatalog, bugsnag, Constants, ErrorCode, $rootScope) {

    var serverSrv = {
        nextSavesStack: [],
        delay: 5000,
        promise: null,
        needToCleanMessage: false
    };
    serverSrv.addFunction = function (functionToCall) {
        //Save function and parameters in order to be able to call it after current process
        var argumentsArray = Array.prototype.slice.apply(arguments);
        argumentsArray.splice(0, 1);
        serverSrv.nextSavesStack.push({
            functionToCall: functionToCall,
            arguments: argumentsArray
        });
    };
    serverSrv.executeNextFunctionWithDelay = function () {
        if (!serverSrv.promise) {
            serverSrv.promise = $timeout(serverSrv.executeNextFunction, serverSrv.delay);
            serverSrv.delay = serverSrv.delay * 2;
            if (serverSrv.delay > 60000) serverSrv.delay = 60000;
        }
    };
    serverSrv.executeNextFunction = function () {
        if (serverSrv.promise) serverSrv.promise = null;
        if (serverSrv.nextSavesStack.length != 0) {
            console.log(new Date() + " executeNextFunction. Still " + serverSrv.nextSavesStack.length);
            var saveFunction = serverSrv.nextSavesStack[0]; //remove and assign value removed to saveFunction
            saveFunction.functionToCall.apply(this, saveFunction.arguments);
        }
    };
    serverSrv.startSavingProcess = function (functionToCall) {
        //Save function and parameters in order to be able to call it after current process
        var argumentsArray = Array.prototype.slice.apply(arguments);
        argumentsArray.splice(0, 1);
        serverSrv.nextSavesStack.push({
            functionToCall: functionToCall,
            arguments: argumentsArray
        });
        if (serverSrv.nextSavesStack.length == 1) serverSrv.executeNextFunction();
    };
    serverSrv.endSavingProcess = function (isSuccess, httpStatus, errorCode, bugsnagErrorNotification) {
        var mustRetry = false;
        if (isSuccess) {
            if (serverSrv.needToCleanMessage) {
                serverSrv.needToCleanMessage = false;
                MessageSrv.cleanMessage();
            }
            serverSrv.delay = 5000;
        } else {
            switch (httpStatus) {
                case -1:
                    MessageSrv.send("alert", "<span>" + gettextCatalog.getString("Connexion internet inactive") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Nouvelle tentative dans ") + serverSrv.delay / 1000 + "s");
                    mustRetry = true;
                    break;
                case 200:
                    serverSrv.needToCleanMessage = true;
                    MessageSrv.send("error", "<span>" + gettextCatalog.getString("Votre sauvegarde a échoué à cause d'une erreur non identifiée.") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Il est conseillé de recharger.") + "</span>");
                    break;
                case 401:
                    switch (errorCode) {
                        case ErrorCode.SESSION_TOKEN_INVALID.code:
                            $rootScope.$emit("fxbInvalidToken");
                            break;
                        case ErrorCode.CHANNEL_INVALID.code:
                        case ErrorCode.CHANNEL_EXPIRED.code:
                            $rootScope.$emit("fxbInvalidChannel");
                            break;
                        default:
                            serverSrv.needToCleanMessage = true;
                            MessageSrv.send("error", "<span>" + gettextCatalog.getString("Accès non autorisé") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Veuillez recharger ou vous reconnecter") + "</span>");
                            break;
                    }
                    break;
                case 403:
                    serverSrv.needToCleanMessage = true;
                    MessageSrv.send("error", "<span>" + gettextCatalog.getString("Accès non autorisé") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Veuillez vous reconnecter") + "</span>");
                    break;
                case 409:
                    switch (errorCode) {
                        case ErrorCode.BOOKING_CONFLICT.code:
                            serverSrv.needToCleanMessage = true;
                            MessageSrv.send("error", "<span>" + gettextCatalog.getString("La réservation a été modifié par un autre utilisateur!") + "<br/>" + "<span>" + gettextCatalog.getString("Recharger pour mettre à jour") + "</span>");
                            break;
                        case ErrorCode.SALE_CONFLICT.code:
                            serverSrv.needToCleanMessage = true;
                            MessageSrv.send("error", "<span>" + gettextCatalog.getString("Ce ticket a déjà été encaissé") + "<br/>" + "<span>" + gettextCatalog.getString("Recharger pour mettre à jour") + "</span>");
                            break;
                        case ErrorCode.COMPANY_EMAIL_CONFLICT.code:
                            serverSrv.needToCleanMessage = true;
                            MessageSrv.send("error", "<span>" + gettextCatalog.getString("L'email fournit est déjà utilisé pour un autre compte ! L'email affiché n'est pas correct !") + "<br/>" + "<span>" + gettextCatalog.getString("Recharger l'admin pour éviter les erreurs !") + "</span>");
                            break;
                        default:
                            break;
                    }
                    break;
                case 404:
                case 412:
                case 500:
                    serverSrv.needToCleanMessage = true;
                    MessageSrv.send("error", "<span>" + gettextCatalog.getString("Echec de la sauvegarde !") + "</span>" + "<br/>" + "<span>" + gettextCatalog.getString("Veuillez recharger la solution et essayer à nouveau.") + "</span>");
                    break;
                default:
                    serverSrv.needToCleanMessage = true;
                    MessageSrv.send("error", "<span>" + gettextCatalog.getString("Erreur dans la sauvegarde code n°") + "</span>" + httpStatus + "<br/>" + "<span>" + gettextCatalog.getString("Veuillez recharger la solution et essayer à nouveau.") + "</span>");
                    break;
            }
            try {
                if (bugsnagErrorNotification && serverSrv.nextSavesStack && serverSrv.nextSavesStack.length > 1) {
                    bugsnag.notify(bugsnagErrorNotification, "", {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
                }
            } catch (e) {
                //nothing to do
            }
        }
        if (mustRetry) {
            serverSrv.executeNextFunctionWithDelay();
        } else {
            serverSrv.nextSavesStack.splice(0, 1);
            serverSrv.executeNextFunction();
        }
    };

    return serverSrv;
}]);

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by sebastienbeaujard on 26/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('Transaction', ["$timeout", function ($timeout) {

    var Transaction = function Transaction() {
        this.objects = [];
    };
    Transaction.prototype.addObject = function (object) {
        var index = this.objects.indexOf(object);
        if (index == -1) //Not already there
            this.objects.push(object);
    };
    return Transaction;
}]);

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 13/11/2013
 * Time: 13:17
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Message', function () {

    var message = function message(type, text) {
        this.type = type;
        this.text = text;
    };

    return message;
});
angular.module('FlexyBeautyApp.services').factory('MessageSrv', ["$rootScope", "$timeout", "$log", "Message", "MessageData", function ($rootScope, $timeout, $log, Message, MessageData) {
    var messageSrv = {};

    messageSrv.cleanMessage = function () {
        if (MessageData.messages.length > 0) {
            MessageData.cleanMessage();
            $rootScope.$emit("fxbMessage", null);
        }
    };
    messageSrv.send = function (type, text, isNotFromAngularEvent) {
        //Currently manage only one message (but many in future dev)
        var message = new Message(type, text);
        MessageData.add(message);
        //emit To directive fxbMessage ('messageUserAction', function()
        $rootScope.$emit("fxbMessage", message, isNotFromAngularEvent);
    };
    return messageSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('MessageData', ["$rootScope", "$timeout", "$log", "Message", function ($rootScope, $timeout, $log, Message) {
    var messageData = { reset: null, messages: [] };

    messageData.cleanMessage = function () {
        messageData.messages = [];
    };

    messageData.add = function (message) {
        this.messages.push(message);
    };
    messageData.clear = function () {
        messageData.messages = [];
    };
    return messageData;
}]);

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 07/12/2013
 * Time: 12:41
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('DateSrv', ["$locale", function ($locale) {
    var dateSrv = {
        daysOfWeekLabel: [$locale.DATETIME_FORMATS.DAY[1], $locale.DATETIME_FORMATS.DAY[2], $locale.DATETIME_FORMATS.DAY[3], $locale.DATETIME_FORMATS.DAY[4], $locale.DATETIME_FORMATS.DAY[5], $locale.DATETIME_FORMATS.DAY[6], $locale.DATETIME_FORMATS.DAY[0]],
        DEFAULT_BIRTHDAY_YEAR: new Date().getFullYear() - 20
    };

    dateSrv.daysOfWeekLabelC = [];
    for (var i = 0; i < dateSrv.daysOfWeekLabel.length; i++) {
        dateSrv.daysOfWeekLabelC.push(dateSrv.daysOfWeekLabel[i].charAt(0).toUpperCase() + dateSrv.daysOfWeekLabel[i].slice(1));
    }

    dateSrv.daysBetween = function (date1, date2) {
        if (!date1 || !date2) {
            return 0;
        }

        // The number of milliseconds in one day
        var ONE_DAY = 1000 * 60 * 60 * 24;

        // Convert both dates to milliseconds
        var date1_ms = date1.getTime();
        var date2_ms = date2.getTime();

        // Calculate the difference in milliseconds
        var difference_ms = Math.abs(date1_ms - date2_ms);

        // Convert back to days and return
        return Math.round(difference_ms / ONE_DAY);
    };

    dateSrv.doReload = function () {
        dateSrv.daysOfWeekLabel = [$locale.DATETIME_FORMATS.DAY[1], $locale.DATETIME_FORMATS.DAY[2], $locale.DATETIME_FORMATS.DAY[3], $locale.DATETIME_FORMATS.DAY[4], $locale.DATETIME_FORMATS.DAY[5], $locale.DATETIME_FORMATS.DAY[6], $locale.DATETIME_FORMATS.DAY[0]];

        dateSrv.daysOfWeekLabelC = [];
        for (var _i = 0; _i < dateSrv.daysOfWeekLabel.length; _i++) {
            dateSrv.daysOfWeekLabelC.push(dateSrv.daysOfWeekLabel[_i].charAt(0).toUpperCase() + dateSrv.daysOfWeekLabel[_i].slice(1));
        }
        return dateSrv;
    };

    return dateSrv;
}]);

angular.module('FlexyBeautyApp.services').factory('Format', [function () {
    var format = {};

    format.formatNumber = function (input) {
        var output = void 0;

        if (input != undefined && input != "") {
            if (input[0] == "+") {
                output = input;
            } else {
                var withoutSpace = input.replace(/\s/g, '');
                withoutSpace = withoutSpace.replace(/\./g, ''); //Remove also dot
                //remove space
                var ret = [];
                //create a array every 2 chars
                for (var i = 0, len = withoutSpace.length; i < len; i += 2) {
                    ret.push(withoutSpace.substr(i, 2));
                }
                output = ret.join(' '); //join array as string inserting a space
            }

            return output;
        }
        return input;
    };

    return format;
}]);

angular.module('FlexyBeautyApp.services').factory('DateFormator', ["moment", function (moment) {
    var dateFormator = {};
    var DAY_ID_FORMAT = "YYYYMMDD";

    dateFormator.format = function (idOfDay) {
        var id = idOfDay + "";
        return id.substring(6, 8) + "/" + id.substring(4, 6) + "/" + id.substring(0, 4); // returns "dd/mm/yyyy"
    };

    /**
     * @return "yyyymmdd"
     */
    dateFormator.dateToDayId = function (date) {
        return date ? moment(date).format(DAY_ID_FORMAT) : date;
    };

    dateFormator.dayIdToDate = function (stringDate) {
        var yyyy = stringDate.substring(0, 4);
        var mm = stringDate.substring(4, 6);
        var dd = stringDate.substring(6, 8);
        return new Date(yyyy + '/' + mm + '/' + dd);
    };

    return dateFormator;
}]);

angular.module('FlexyBeautyApp.services').factory('StyleColor', [function () {
    var styleColor = {};

    styleColor.getContrastYIQ = function (hexcolor) {
        var r = parseInt(hexcolor.substr(1, 2), 16);
        var g = parseInt(hexcolor.substr(3, 2), 16);
        var b = parseInt(hexcolor.substr(5, 2), 16);
        var yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq >= 128 ? 'black' : 'white';
    };

    return styleColor;
}]);

angular.module('FlexyBeautyApp.services').factory('Theme', [function () {
    var theme = {};

    var themeCollection = new Array();

    themeCollection["blue"] = {
        name: "blue",
        file: "./dist/css/blue-theme.css"
    };
    themeCollection["pink"] = {
        name: "pink",
        file: "./dist/css/pink-theme.css"
    };
    themeCollection["green"] = {
        name: "green",
        file: "./dist/css/green-theme.css"
    };
    themeCollection["pink-original"] = {
        name: "pink-original",
        file: "./dist/css/pink-original-theme.css"
    };

    theme.getThemeByName = function (name) {
        return themeCollection[name] ? themeCollection[name] : themeCollection["pink-original"];
    };

    return theme;
}]);

angular.module('FlexyBeautyApp.services').factory('Timers', ["$timeout", "$interval", function ($timeout, $interval) {
    return {
        cancel: function cancel(timers, intervals) {
            if (timers && timers.length) {
                timers.forEach(function (timer) {
                    if (timer) {
                        $timeout.cancel(timer);
                    }
                });
            }
            if (intervals && intervals.length) {
                intervals.forEach(function (interval) {
                    if (interval) {
                        $interval.cancel(interval);
                    }
                });
            }
        }
    };
}]);

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('BasicAuthRoleSaleCreationBehavior', ['SaleStatus', 'SalePaymentType', function (SaleStatus, SalePaymentType) {
    return {
        getLeCiseauSaleCreationBehavior: function getLeCiseauSaleCreationBehavior() {
            return {
                updateCustomer: false,
                deleteService: false,
                addService: false,
                addItem: false,
                moveHR: false,
                updatePrice: false,
                updatePayment: false,
                updateDiscount: false,
                cancelSale: function cancelSale(saleStatus, payments) {
                    return saleStatus !== SaleStatus.SOLD || !(payments.length === 1 && payments[0].type === SalePaymentType.LECISEAU.type);
                }
            };
        },
        getReserveWithGoogleSaleCreationBehavior: function getReserveWithGoogleSaleCreationBehavior() {
            return {
                updateCustomer: false,
                deleteService: true,
                addService: true,
                addItem: true,
                moveHR: true,
                updatePrice: true,
                updatePayment: true,
                updateDiscount: true,
                cancelSale: function cancelSale() {
                    return true;
                }
            };
        }
    };
}]);

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('CompanyTypes', ['gettextCatalog', function () {

    var companyTypes = {

        MIGRATION: { value: "migration" },
        NEW_ACCOUNT: { value: "newAccount" },
        CUSTOMER: { value: "customer" },
        BILLINGISSUE: { value: "billingIssue" },
        BILLINGBLOCKED: { value: "billingBlocked" },
        BLOCKED: { value: "blocked" },
        CANCELED: { value: "canceled" },
        MODEL: { value: "model" },
        PARTNER: { value: "partner" },
        INTERNALTEST: { value: "internalTest" }

    };
    return companyTypes;
}]);

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  /* istanbul ignore next */
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    module.exports = factory()
  } else {
    root.PromisePool = factory()
    // Legacy API
    root.promisePool = root.PromisePool
  }
})(this, function () {
  'use strict'

  var EventTarget = function () {
    this._listeners = {}
  }

  EventTarget.prototype.addEventListener = function (type, listener) {
    this._listeners[type] = this._listeners[type] || []
    if (this._listeners[type].indexOf(listener) < 0) {
      this._listeners[type].push(listener)
    }
  }

  EventTarget.prototype.removeEventListener = function (type, listener) {
    if (this._listeners[type]) {
      var p = this._listeners[type].indexOf(listener)
      if (p >= 0) {
        this._listeners[type].splice(p, 1)
      }
    }
  }

  EventTarget.prototype.dispatchEvent = function (evt) {
    if (this._listeners[evt.type] && this._listeners[evt.type].length) {
      var listeners = this._listeners[evt.type].slice()
      for (var i = 0, l = listeners.length; i < l; ++i) {
        listeners[i].call(this, evt)
      }
    }
  }

  var isGenerator = function (func) {
    return (typeof func.constructor === 'function' &&
      func.constructor.name === 'GeneratorFunction')
  }

  var functionToIterator = function (func) {
    return {
      next: function () {
        var promise = func()
        return promise ? {value: promise} : {done: true}
      }
    }
  }

  var promiseToIterator = function (promise) {
    var called = false
    return {
      next: function () {
        if (called) {
          return {done: true}
        }
        called = true
        return {value: promise}
      }
    }
  }

  var toIterator = function (obj, Promise) {
    var type = typeof obj
    if (type === 'object') {
      if (typeof obj.next === 'function') {
        return obj
      }
      /* istanbul ignore else */
      if (typeof obj.then === 'function') {
        return promiseToIterator(obj)
      }
    }
    if (type === 'function') {
      return isGenerator(obj) ? obj() : functionToIterator(obj)
    }
    return promiseToIterator(Promise.resolve(obj))
  }

  var PromisePoolEvent = function (target, type, data) {
    this.target = target
    this.type = type
    this.data = data
  }

  var PromisePool = function (source, concurrency, options) {
    EventTarget.call(this)
    if (typeof concurrency !== 'number' ||
        Math.floor(concurrency) !== concurrency ||
        concurrency < 1) {
      throw new Error('Invalid concurrency')
    }
    this._concurrency = concurrency
    this._options = options || {}
    this._options.promise = this._options.promise || Promise
    this._iterator = toIterator(source, this._options.promise)
    this._done = false
    this._size = 0
    this._promise = null
    this._callbacks = null
  }
  PromisePool.prototype = new EventTarget()
  PromisePool.prototype.constructor = PromisePool

  PromisePool.prototype.concurrency = function (value) {
    if (typeof value !== 'undefined') {
      this._concurrency = value
      if (this.active()) {
        this._proceed()
      }
    }
    return this._concurrency
  }

  PromisePool.prototype.size = function () {
    return this._size
  }

  PromisePool.prototype.active = function () {
    return !!this._promise
  }

  PromisePool.prototype.promise = function () {
    return this._promise
  }

  PromisePool.prototype.start = function () {
    var that = this
    var Promise = this._options.promise
    this._promise = new Promise(function (resolve, reject) {
      that._callbacks = {
        reject: reject,
        resolve: resolve
      }
      that._proceed()
    })
    return this._promise
  }

  PromisePool.prototype._fireEvent = function (type, data) {
    this.dispatchEvent(new PromisePoolEvent(this, type, data))
  }

  PromisePool.prototype._settle = function (error) {
    if (error) {
      this._callbacks.reject(error)
    } else {
      this._callbacks.resolve()
    }
    this._promise = null
    this._callbacks = null
  }

  PromisePool.prototype._onPooledPromiseFulfilled = function (promise, result) {
    this._size--
    if (this.active()) {
      this._fireEvent('fulfilled', {
        promise: promise,
        result: result
      })
      this._proceed()
    }
  }

  PromisePool.prototype._onPooledPromiseRejected = function (promise, error) {
    this._size--
    if (this.active()) {
      this._fireEvent('rejected', {
        promise: promise,
        error: error
      })
      this._settle(error || new Error('Unknown error'))
    }
  }

  PromisePool.prototype._trackPromise = function (promise) {
    var that = this
    promise
      .then(function (result) {
        that._onPooledPromiseFulfilled(promise, result)
      }, function (error) {
        that._onPooledPromiseRejected(promise, error)
      })['catch'](function (err) {
        that._settle(new Error('Promise processing failed: ' + err))
      })
  }

  PromisePool.prototype._proceed = function () {
    if (!this._done) {
      var result = { done: false }
      while (this._size < this._concurrency &&
          !(result = this._iterator.next()).done) {
        this._size++
        this._trackPromise(result.value)
      }
      this._done = (result === null || !!result.done)
    }
    if (this._done && this._size === 0) {
      this._settle()
    }
  }

  PromisePool.PromisePoolEvent = PromisePoolEvent
  // Legacy API
  PromisePool.PromisePool = PromisePool

  return PromisePool
})


/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(186));

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = firebase;
//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('BasicAuthRole', ['gettextCatalog', 'StoreAppCode', 'BookingCreator', 'BasicAuthRoleSaleCreationBehavior', 'SaleStatus', 'CompanyType', "Brand", "Countries", "CompanyTypes", function (gettextCatalog, StoreAppCode, BookingCreator, BasicAuthRoleSaleCreationBehavior, SaleStatus, CompanyType, Brand, Countries, CompanyTypes) {
    return {
        GOOGLE_ROLE: {
            role: 'GoogleRole',
            storeAppCode: StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE,
            bookingCreator: BookingCreator.RWG.key,
            label: gettextCatalog.getString('Réserver avec Google'),
            webSite: "#",
            proSite: '#',
            basicAuthRoleSaleCreationBehavior: BasicAuthRoleSaleCreationBehavior.getReserveWithGoogleSaleCreationBehavior(),
            displaySaleAlert: function displaySaleAlert() {
                return false;
            },
            canPartnerUpdatePayment: function canPartnerUpdatePayment() {
                return true;
            },
            phoneNumber: '',
            isCompanyTypeCompliant: function isCompanyTypeCompliant(companyView) {
                return companyView.companyTypeId === CompanyType.HAIRDRESSING_SALON.id || companyView.companyTypeId === CompanyType.LOREAL_HAIR_SALON.id || companyView.companyTypeId === CompanyType.BEAUTY_INSTITUTE.id || companyView.companyTypeId === CompanyType.SPA.id;
            }
        },
        LE_CISEAU_ROLE: {
            role: 'leCiseauRole',
            storeAppCode: StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE,
            bookingCreator: BookingCreator.LE_CISEAU.key,
            label: Brand.marketplace.label,
            webSite: Brand.marketplace.url.website,
            proSite: Brand.marketplace.url.proSite,

            basicAuthRoleSaleCreationBehavior: BasicAuthRoleSaleCreationBehavior.getLeCiseauSaleCreationBehavior(),
            displaySaleAlert: function displaySaleAlert(saleStatus) {
                return saleStatus === SaleStatus.CREATED || saleStatus === SaleStatus.ADVANCE || saleStatus === SaleStatus.WAITING;
            },
            canPartnerUpdatePayment: function canPartnerUpdatePayment(saleStatus, saleSetting) {
                return saleStatus !== SaleStatus.SOLD || saleStatus === SaleStatus.SOLD && saleSetting;
            },
            isCompanyTypeCompliant: function isCompanyTypeCompliant(companyView) {
                return companyView.companyTypeId !== CompanyType.OTHER.id;
            },
            isCountryCompliant: function isCountryCompliant(companyView) {
                var compliantCountries = [Countries.FRANCE.countryCode, Countries.GUADELOUPE.countryCode, Countries.MARTINIQUE.countryCode, Countries.REUNIONISLAND.countryCode];
                return compliantCountries.includes(companyView.country);
            },
            isAccountTypeCompliant: function isAccountTypeCompliant(companyView) {
                var compliantAccountTypes = [CompanyTypes.PARTNER, CompanyTypes.CUSTOMER, CompanyTypes.BILLINGISSUE, CompanyTypes.NEW_ACCOUNT];
                return compliantAccountTypes.find(function (accountType) {
                    return accountType.value === companyView.type;
                }) != null;
            }
        }
    };
}]).factory('BasicAuthRoleFactory', ['BasicAuthRole', function (BasicAuthRole) {
    return {
        getBasicAuthByBookingCreator: function getBasicAuthByBookingCreator(creator) {
            for (var basicAuthRole in BasicAuthRole) {
                if (BasicAuthRole.hasOwnProperty(basicAuthRole) && BasicAuthRole[basicAuthRole].bookingCreator === creator) {
                    return BasicAuthRole[basicAuthRole];
                }
            }
        }
    };
}]);

/***/ }),

/***/ 790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_auth__ = __webpack_require__(578);


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_database__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_database__);


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 794:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('BookingCreator', ['gettextCatalog', 'Brand', function (gettextCatalog, Brand) {
    var labelTreatwell = gettextCatalog.getString("par treatwell"),
        labelGoogle = gettextCatalog.getString("par google"),
        labelWeb = gettextCatalog.getString("par internet"),
        labelAppMobile = gettextCatalog.getString("par l'application mobile"),
        labelBackOffice = gettextCatalog.getString("par l'agenda"),
        labelMarketplace = gettextCatalog.getString("par " + Brand.marketplace.label),
        labelBackOfficeKiutePro = gettextCatalog.getString("par l'application mobile android");

    return {
        WEBSITE: {
            key: "WEBSITE",
            code: "internet",
            label: labelWeb
        },
        RWG: {
            key: "RWG",
            code: "google",
            label: labelGoogle
        },
        TREATWELL: {
            key: "TREATWELL",
            code: "treatwell",
            label: labelTreatwell
        },
        BACKOFFICE: {
            key: "BACKOFFICE",
            code: "backoffice",
            label: labelBackOffice
        },
        APPMOBILE_PRO: {
            key: "APPMOBILE_PRO",
            code: "appmobilePro",
            label: labelAppMobile
        },
        APPMOBILE_CLI: {
            key: "APPMOBILE_CLI",
            code: "appmobileCli",
            label: labelAppMobile
        },
        LE_CISEAU: {
            key: "LE_CISEAU",
            code: "leCiseau",
            label: labelMarketplace
        },
        BACKOFFICE_KIUTE_PRO: {
            key: "BACKOFFICE_KIUTE_PRO",
            code: "backofficeKiutePro",
            label: labelBackOfficeKiutePro
        }
    };
}]);

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39);
__webpack_require__(287);
__webpack_require__(122);
__webpack_require__(48);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(49);
__webpack_require__(50);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(124);
__webpack_require__(392);
__webpack_require__(387);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(388);
__webpack_require__(125);
__webpack_require__(126);
__webpack_require__(127);
__webpack_require__(398);
__webpack_require__(53);
__webpack_require__(422);
__webpack_require__(54);
__webpack_require__(403);
__webpack_require__(405);
__webpack_require__(404);
__webpack_require__(406);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(413);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(399);
__webpack_require__(59);
__webpack_require__(414);
__webpack_require__(418);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(420);
__webpack_require__(419);
__webpack_require__(60);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(425);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(431);
__webpack_require__(129);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(435);
__webpack_require__(61);
__webpack_require__(62);
__webpack_require__(63);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(421);
__webpack_require__(130);
__webpack_require__(131);
__webpack_require__(132);
__webpack_require__(133);
__webpack_require__(52);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(393);
__webpack_require__(128);
__webpack_require__(135);
__webpack_require__(134);
__webpack_require__(441);
__webpack_require__(64);
__webpack_require__(75);
__webpack_require__(65);
__webpack_require__(446);
__webpack_require__(73);
__webpack_require__(76);
__webpack_require__(74);
__webpack_require__(445);
__webpack_require__(68);
__webpack_require__(449);
__webpack_require__(69);
__webpack_require__(66);
__webpack_require__(72);
__webpack_require__(41);
__webpack_require__(45);
__webpack_require__(43);
__webpack_require__(42);
__webpack_require__(166);
__webpack_require__(486);
__webpack_require__(51);
__webpack_require__(142);
__webpack_require__(410);
__webpack_require__(472);
__webpack_require__(89);
__webpack_require__(464);
__webpack_require__(460);
__webpack_require__(456);
__webpack_require__(83);
__webpack_require__(78);
__webpack_require__(55);
__webpack_require__(70);
__webpack_require__(407);
__webpack_require__(80);
__webpack_require__(85);
__webpack_require__(86);
__webpack_require__(46);
__webpack_require__(47);
__webpack_require__(458);
__webpack_require__(457);
__webpack_require__(81);
__webpack_require__(67);
__webpack_require__(430);
__webpack_require__(79);
__webpack_require__(88);
__webpack_require__(455);
__webpack_require__(459);
__webpack_require__(77);
__webpack_require__(57);
__webpack_require__(71);
__webpack_require__(37);
__webpack_require__(82);
__webpack_require__(84);
__webpack_require__(289);
__webpack_require__(380);
__webpack_require__(58);
__webpack_require__(38);
module.exports = __webpack_require__(288);


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('BookingSaveTransactionOrigin', function () {

    return {
        WAITING_SALE: "WaitingSale",
        ADVANCE_SALE: "AdvanceSale",
        SOLD_SALE: "SoldSale",
        CANCELED_SALE: "CanceledSale",
        BOOKING_SERVICE_RESIZE: "BookingServiceResize",
        DRAG_DROP_DIFF_DAY_MULTIPLE: "DragDropDiffDayMultiple",
        DRAG_DROP_DIFF_DAY_SINGLE: "DragDropDiffDaySingle",
        DRAG_DROP_SAME_DAY: "DragDropSameDay",
        SAVE_BUTTON: "SaveButton",
        TOGGLE_STATUS: "ToggleStatus",
        DIRECTIVES_PRO: "DirectivesPro"
    };
});

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('BookingStatus', function () {
    var bookingStatus = {
        WAITING_FOR_CONFIRM: "waitingForConfirm",
        CREATED: "created",
        PLANNED: "planned",
        NOT_CAME: "notCame",
        CAME: "came",
        PAYED: "payed",
        PREPAID: "prepaid"
    };
    return bookingStatus;
});

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('CompanyType', ['gettextCatalog', function (gettextCatalog) {
    var labelSc = gettextCatalog.getString("Salon de coiffure"),
        labelIb = gettextCatalog.getString("Institut de beauté"),
        labelSpa = gettextCatalog.getString("SPA"),
        labelAutre = gettextCatalog.getString("Autre"),
        labelLoreal = gettextCatalog.getString("Salon de coiffure l'Oréal");

    return {
        HAIRDRESSING_SALON: { id: '1', label: labelSc },
        BEAUTY_INSTITUTE: { id: '2', label: labelIb },
        SPA: { id: '3', label: labelSpa },
        OTHER: { id: '4', label: labelAutre },
        LOREAL_HAIR_SALON: { id: '5', label: labelLoreal }
    };
}]);

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('CureStatus', function () {
    return {
        ACTIVE: "active",
        USED: "used",
        CLOSED: "closed"
    };
});

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('SalePaymentType', ['gettextCatalog', 'Brand', function (gettextCatalog, Brand) {
    return {
        CASH: {
            type: "CASH",
            label: gettextCatalog.getString("Espèces"),
            labelChartPayment: gettextCatalog.getString("Espèces"),
            keyPrice: "cashPrice",
            keyNumber: "cashNb"
        },
        CB: {
            type: "CB",
            label: gettextCatalog.getString("Carte bancaire"),
            labelChartPayment: gettextCatalog.getString("CB"),
            keyPrice: "cbPrice",
            keyNumber: "cbNb"
        },
        CBONLINE: {
            type: "CBONLINE",
            label: gettextCatalog.getString("Carte bancaire"),
            labelChartPayment: gettextCatalog.getString("CB Online"),
            keyPrice: "cbOnlinePrice",
            keyNumber: "cbOnlineNb"
        },
        CHECK: {
            type: "CHECK",
            label: gettextCatalog.getString("Chèque"),
            labelChartPayment: gettextCatalog.getString("Chèques"),
            keyPrice: "checkPrice",
            keyNumber: "checkNb"
        },
        GIFT: {
            type: "GIFT",
            label: gettextCatalog.getString("Bon cadeau"),
            labelChartPayment: gettextCatalog.getString("Chq cadeaux"),
            keyPrice: "giftPrice",
            keyNumber: "giftNb"
        },
        OTHER: {
            type: "OTHER",
            label: gettextCatalog.getString("Autre"),
            labelChartPayment: gettextCatalog.getString("Autres"),
            keyPrice: "otherPrice",
            keyNumber: "otherNb"
        },
        UNPAID: {
            type: "UNPAID",
            label: gettextCatalog.getString("Reste à payer"),
            labelChartPayment: "",
            keyPrice: "unpaidPrice",
            keyNumber: "unpaidNb"
        },
        IZETTLE: {
            type: "IZETTLE",
            label: gettextCatalog.getString("Carte bancaire"),
            labelChartPayment: gettextCatalog.getString("CB iZettle"),
            keyPrice: "iZettlePrice",
            keyNumber: "iZettleNb"
        },
        LECISEAU: {
            type: "LECISEAU",
            label: Brand.marketplace.url.shortWebsite,
            labelChartPayment: Brand.marketplace.url.shortWebsite,
            keyPrice: "leCiseauPrice",
            keyNumber: "leCiseauNb"
        }
    };
}]).factory('SalePaymentTypeFactory', ['SalePaymentType', function (SalePaymentType) {
    return {
        from: function from(type) {
            for (var salePaymentType in SalePaymentType) {
                if (SalePaymentType.hasOwnProperty(salePaymentType) && SalePaymentType[salePaymentType].type === type) {
                    return SalePaymentType[salePaymentType];
                }
            }
        }
    };
}]);

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('SaleStatus', function () {
    var saleStatus = {
        CREATED: "created",
        ESTIMATION: "estimation",
        WAITING: "waiting",
        ADVANCE: "advance",
        ADVANCE_PROCESS: "advanceProcess",
        ADVANCE_KEEPED: "advanceKeeped",
        SOLD_PROCESS: "soldProcess",
        CANCELED: "canceled",
        CREDIT: "credit",
        SOLD: "sold"
    };
    return saleStatus;
});

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('FlexyBeautyApp.services').factory('StoreAppCode', [function () {
    return {
        OPTION_START_APP_CODE: "start",
        OPTION_PLUS_APP_CODE: "plus",
        OPTION_BOOST_APP_CODE: "boost",
        OPTION_PRESTIGE_APP_CODE: "prestige",
        OPTION_ANNUAL_APP_CODE: "annual",
        OPTION_ONLINE_SHOP_APP_CODE: "onlineShop",
        OPTION_SOLO_APP_CODE: "solo",
        OPTION_GIFT_ITEM_APP_CODE: "giftItem",
        OPTION_LOYALTY_CARD_APP_CODE: "loyaltyCard",
        OPTION_ONLINE_BOOKING_APP_CODE: "onlineBooking",
        OPTION_POS_APP_CODE: "pos",
        OPTION_ICAL_APP_CODE: "ical",
        OPTION_CURE_APP_CODE: "cure",
        OPTION_NATIVE_APP_APP_CODE: "nativeApp",
        OPTION_BOOKING_SMS_SECURITY_APP_CODE: "bookingSmsSecurity",
        OPTION_SMS_REMINDER_APP_CODE: "smsReminder",
        OPTION_SMS_CAMPAIGN_APP_CODE: "smsCampaign",
        OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE: "optionReserveWithGoogle",
        OPTION_LE_CISEAU_STORE_APP_CODE: "optionLeCiseau",
        OPTION_LE_CISEAU_LIGHT_STORE_APP_CODE: "optionLeCiseauLight",
        OPTION_WITHOUT_TILL_STORE_APP_CODE: "withoutTill",
        OPTION_WEBSITE: "website",
        OPTION_WEBSITE_PAYMENT: "websitePayment",
        OPTION_CLIENT_FULL: "clientFull",
        OPTION_STATISTICS: "statistics",
        OPTION_STATISTICS_FULL: "statisticsFull",
        OPTION_BOOKSY_BUTTON: "booksyMigration"
    };
}]).factory('StoreAppObject', ['StoreAppCode', function () {
    var StoreAppObject = function StoreAppObject(storeAppCode) {
        this.code = storeAppCode;
    };
    StoreAppObject.prototype.onSubscriptionChange = function () {
        return Promise.resolve(true);
    };
    StoreAppObject.prototype.computeSubscriptionChangeDescriptionMessage = function () {
        return null;
    };
    StoreAppObject.prototype.afterSubscriptionChange = function (subscriptionView) {
        //by default nothing to do
    };
    StoreAppObject.prototype.displaySubscription = function (companyView, subscriptionView) {
        return true;
    };
    StoreAppObject.prototype.disableSubscription = function (offerCode) {
        return false;
    };

    return StoreAppObject;
}]).factory('StoreAppCodeFactory', ['StoreAppCode', 'StoreAppObject', 'gettextCatalog', 'AppData', '$dialog', 'CompanySrv', 'AppCode', 'BasicAuthRole', 'Countries', 'OfferManager', 'CompanyType', "UserSrv", "Brand", "Offers", function (StoreAppCode, StoreAppObject, gettextCatalog, AppData, $dialog, CompanySrv, AppCode, BasicAuthRole, Countries, OfferManager, CompanyType, UserSrv, Brand, Offers) {
    var storeAppCodeFactory = void 0;
    var storeAppCodeObjects = {};

    for (var storeAppCode in StoreAppCode) {
        if (StoreAppCode.hasOwnProperty(storeAppCode)) {
            storeAppCodeObjects[StoreAppCode[storeAppCode]] = new StoreAppObject(StoreAppCode[storeAppCode]);
        }
    }
    var onIcalSubscriptionChange = function onIcalSubscriptionChange(subscriptionView) {
        var question = gettextCatalog.getString("Êtes-vous sûr de vouloir désactiver l’option {{optionName}} ? (L’option ne pourra pas être réactivée.)", { optionName: subscriptionView.storeAppView.label });
        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/generalConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["question"] = question;
                    return tableModel;
                }
            }
        };

        var d = $dialog.dialog(opts);

        return d.open();
    };

    var onPartnerSubscriptionChange = function onPartnerSubscriptionChange(subscriptionView) {
        var question = void 0;
        var description = void 0;

        if (!subscriptionView.isActive) {
            question = gettextCatalog.getString("Êtes-vous sûr de vouloir désactiver l’option {{optionName}} ? (L’option pourra être réactivée. Attention cette réactivation peut prendre jusqu'à 24h).", { optionName: subscriptionView.storeAppView.label });
        } else {
            question = gettextCatalog.getString("Êtes-vous sûr de vouloir activer l’option {{optionName}} ? (L'activation peut prendre jusqu'à 24h).", { optionName: subscriptionView.storeAppView.label });
            description = this.computeSubscriptionChangeDescriptionMessage();
        }

        var opts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: '/partials/global/generalConfirm.html',
            controller: 'DialogCtrl',
            resolve: {
                dialogsModel: function dialogsModel() {
                    var tableModel = [];
                    tableModel["question"] = question;
                    tableModel["description"] = description;
                    return tableModel;
                }
            }
        };

        var d = $dialog.dialog(opts);

        return d.open();
    };

    var onMarketPlaceSubscriptionChange = function onMarketPlaceSubscriptionChange(subscriptionView, companyView, user) {
        return new Promise(function (resolve, reject) {
            if (!subscriptionView.isActive) {
                return resolve(true);
            }
            var marketPlaceLabel = BasicAuthRole.LE_CISEAU_ROLE.label;
            var opts = {
                backdrop: true,
                keyboard: false,
                backdropClick: false,
                templateUrl: '/partials/global/marketPlaceContactDialog.html',
                dialogClass: "modal modal-sm",
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["marketPlaceLabel"] = marketPlaceLabel;
                        tableModel["buttonLabel"] = gettextCatalog.getString("Activer la synchronisation avec {{marketPlaceLabel}}", { marketPlaceLabel: marketPlaceLabel });
                        return tableModel;
                    }
                }
            };
            var dialog = $dialog.dialog(opts);
            dialog.open().then(function (result) {
                if (!result) {
                    return reject();
                } else {
                    UserSrv.notifyMarketPlace(user.id);
                    companyView.openLinkInFrame(Brand.url.subscribeSSO, user.email);
                    return resolve(true);
                }
            });
        });
    };
    storeAppCodeObjects[StoreAppCode.OPTION_ICAL_APP_CODE].onSubscriptionChange = onIcalSubscriptionChange;
    storeAppCodeObjects[StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE].onSubscriptionChange = onPartnerSubscriptionChange;
    storeAppCodeObjects[StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE].onSubscriptionChange = onMarketPlaceSubscriptionChange;
    storeAppCodeObjects[StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE].afterSubscriptionChange = function (subscriptionView) {
        if (!subscriptionView.isActive) {
            CompanySrv.disableRwg();
        }
    };

    storeAppCodeObjects[StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE].computeSubscriptionChangeDescriptionMessage = function () {
        var app = AppData.getAppByCode(AppCode.WEBSITE_APP);
        var allowChooseHrAppAttribute = app.getAppAttribute(AppCode.WEBSITE_ATTRIBUTE_ALLOW_CHOOSE_HR);
        if (allowChooseHrAppAttribute && allowChooseHrAppAttribute.value === "false") {
            return gettextCatalog.getString("Pour information lors d'une réservation sur {{partnerName}} votre client pourra choisir son professionnel, contrairement à ce que vous avez paramétré sur votre site internet {{brandLabel}}.", { partnerName: BasicAuthRole.LE_CISEAU_ROLE.label, brandLabel: Brand.label });
        }
    };

    storeAppCodeObjects[StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE].displaySubscription = function (companyView, subscriptionView) {
        return companyView.country === Countries.FRANCE.countryCode && BasicAuthRole.LE_CISEAU_ROLE.isCompanyTypeCompliant(companyView);
    };

    storeAppCodeObjects[StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE].displaySubscription = function (companyView, subscriptionView) {
        return OfferManager.isWithoutTillCompatibleWithActiveOffer(companyView);
    };

    storeAppCodeObjects[StoreAppCode.OPTION_ICAL_APP_CODE].displaySubscription = function (companyView, subscriptionView) {
        return subscriptionView && subscriptionView.isActive;
    };

    storeAppCodeObjects[StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE].disableSubscription = function (offerCode) {
        return offerCode === Offers.ATTRACT.code;
    };

    storeAppCodeFactory = {
        storeAppCodeObjects: storeAppCodeObjects,
        from: function from(storeAppCode) {
            for (var storeAppCodeObject in this.storeAppCodeObjects) {
                if (storeAppCodeObjects.hasOwnProperty(storeAppCodeObject) && storeAppCode === storeAppCodeObjects[storeAppCodeObject].code) {
                    return storeAppCodeObjects[storeAppCodeObject];
                }
            }
            return null;
        }
    };
    return storeAppCodeFactory;
}]);

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 17/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('CompanyImageFormat', [function () {
    var companyImageFormat = {
        SQUARE: { id: 'SQUARE', label: 'square' },
        RECT: { id: 'RECT', label: 'rect' },
        PORTRAIT: { id: 'PORTRAIT', label: 'portrait' }
    };

    return companyImageFormat;
}]).factory('IOSDevice', [function () {
    var iosDevices = {
        IPAD: { label: 'iPod' },
        IPOD: { label: 'iPad' },
        IPHONE: { label: 'iPhone' }
    };
    iosDevices.isIOSDevice = function () {
        if (navigator && navigator.platform && (navigator.platform.indexOf(this.IPAD.label) !== -1 || navigator.platform.indexOf(this.IPOD.label) !== -1 || navigator.platform.indexOf(this.IPHONE.label) !== -1)) return true;
        return false;
    };
    return iosDevices;
}]).factory('TreeMovementDirection', ["gettextCatalog", function (gettextCatalog) {
    var treeMovementDirection = {

        UP: { id: 'UP', action: gettextCatalog.getString("Remonter") },
        DOWN: { id: 'DOWN', action: gettextCatalog.getString("Descendre") }
    };

    return treeMovementDirection;
}]).factory('AppCode', [function () {
    return {
        SMS_APP: "sms",
        SMS_ATTRIBUTE_HOUR_TO_SEND: "hourToSend",
        SMS_ATTRIBUTE_ENDING_TEXT: "endingText",
        SMS_ATTRIBUTE_FIRST_NAME: "firstName",
        POS_APP: "pos",
        POS_ATTRIBUTE_IZETTLE_PAYMENT: "iZettlePayment",
        WEBSITE_APP: "webSite",
        WEBSITE_ATTRIBUTE_ALLOW_CHOOSE_HR: "allowChooseHr"
    };
}]);

/***/ })

},[802]);


// WEBPACK FOOTER //
// shared.bundle.min.beef4959440565507367.js